
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4e11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4e11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, "key")) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
            });
            var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = jsx;
    $587db01302e19550$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.3.1";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("3y30c", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2956e04298bc31b1$export$ae55be85d98224ed, (v) => $2956e04298bc31b1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2956e04298bc31b1$export$882461b6382ed46c, (v) => $2956e04298bc31b1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2956e04298bc31b1$export$466bfc07425424d5, (v) => $2956e04298bc31b1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2956e04298bc31b1$export$fa8d919ba61d84db, (v) => $2956e04298bc31b1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2956e04298bc31b1$export$757ceba2d55c277e, (v) => $2956e04298bc31b1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2956e04298bc31b1$export$b3890eb0ae9dca99, (v) => $2956e04298bc31b1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2956e04298bc31b1$export$502457920280e6be, (v) => $2956e04298bc31b1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2956e04298bc31b1$export$dc54d992c10e8a18, (v) => $2956e04298bc31b1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$ae55be85d98224ed;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$882461b6382ed46c;
var $2956e04298bc31b1$export$466bfc07425424d5;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$fa8d919ba61d84db;
var $2956e04298bc31b1$export$757ceba2d55c277e;
var $2956e04298bc31b1$export$b3890eb0ae9dca99;
var $2956e04298bc31b1$export$502457920280e6be;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$dc54d992c10e8a18;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var Scheduler = (parcelRequire("fO90s"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === "function" && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || "Unknown";
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.3.1";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $2956e04298bc31b1$export$ae55be85d98224ed = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = createPortal$1;
    $2956e04298bc31b1$export$882461b6382ed46c = createRoot$1;
    $2956e04298bc31b1$export$466bfc07425424d5 = findDOMNode;
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = flushSync$1;
    $2956e04298bc31b1$export$fa8d919ba61d84db = hydrate;
    $2956e04298bc31b1$export$757ceba2d55c277e = hydrateRoot$1;
    $2956e04298bc31b1$export$b3890eb0ae9dca99 = render;
    $2956e04298bc31b1$export$502457920280e6be = unmountComponentAtNode;
    $2956e04298bc31b1$export$c78a37762a8d58e1 = batchedUpdates$1;
    $2956e04298bc31b1$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $2956e04298bc31b1$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $553b3f9a1c62156e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = forceFrameRate;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("bhLLf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7lMqe = parcelRequire("7lMqe");

var $d5Tjt = parcelRequire("d5Tjt");

var $57D9P = parcelRequire("57D9P");

var $3Fk1A = parcelRequire("3Fk1A");
var $8376549264707561$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $57D9P.RawSha256();
        if (secret) {
            this.outer = new $57D9P.RawSha256();
            var inner = $8376549264707561$var$bufferFromSecret(secret);
            var outer = new Uint8Array($d5Tjt.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $d5Tjt.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ($8376549264707561$var$isEmptyData(toHash) || this.error) return;
        try {
            this.hash.update($8376549264707561$var$convertToBuffer(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $7lMqe.__awaiter(this, void 0, void 0, function() {
            return $7lMqe.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $8376549264707561$var$Sha256;
function $8376549264707561$var$bufferFromSecret(secret) {
    var input = $8376549264707561$var$convertToBuffer(secret);
    if (input.byteLength > $d5Tjt.BLOCK_SIZE) {
        var bufferHash = new $57D9P.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($d5Tjt.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function $8376549264707561$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $8376549264707561$var$convertToBuffer(data) {
    if (typeof data === "string") return $3Fk1A.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("7lMqe", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $55a00e36a5eb4e35$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $55a00e36a5eb4e35$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $55a00e36a5eb4e35$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $55a00e36a5eb4e35$var$extendStatics = function(d, b) {
    $55a00e36a5eb4e35$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $55a00e36a5eb4e35$var$extendStatics(d, b);
};
function $55a00e36a5eb4e35$export$a8ba968b8961cb8a(d, b) {
    $55a00e36a5eb4e35$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $55a00e36a5eb4e35$export$18ce0697a983be9b = function() {
    $55a00e36a5eb4e35$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $55a00e36a5eb4e35$export$18ce0697a983be9b.apply(this, arguments);
};
function $55a00e36a5eb4e35$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $55a00e36a5eb4e35$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $55a00e36a5eb4e35$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $55a00e36a5eb4e35$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $55a00e36a5eb4e35$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $55a00e36a5eb4e35$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $55a00e36a5eb4e35$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $55a00e36a5eb4e35$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $55a00e36a5eb4e35$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $55a00e36a5eb4e35$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $55a00e36a5eb4e35$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($55a00e36a5eb4e35$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $55a00e36a5eb4e35$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $55a00e36a5eb4e35$export$10c90e4f7922046c(v) {
    return this instanceof $55a00e36a5eb4e35$export$10c90e4f7922046c ? (this.v = v, this) : new $55a00e36a5eb4e35$export$10c90e4f7922046c(v);
}
function $55a00e36a5eb4e35$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $55a00e36a5eb4e35$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $55a00e36a5eb4e35$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $55a00e36a5eb4e35$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $55a00e36a5eb4e35$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $55a00e36a5eb4e35$export$19a8beecd37a4c45 === "function" ? $55a00e36a5eb4e35$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $55a00e36a5eb4e35$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $55a00e36a5eb4e35$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $55a00e36a5eb4e35$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $55a00e36a5eb4e35$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $55a00e36a5eb4e35$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("d5Tjt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("57D9P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d5Tjt = parcelRequire("d5Tjt");
/**
 * @internal
 */ var $3babfb12b473c764$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($d5Tjt.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $d5Tjt.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $d5Tjt.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $d5Tjt.BLOCK_SIZE >= $d5Tjt.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $d5Tjt.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $d5Tjt.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($d5Tjt.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($d5Tjt.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($d5Tjt.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $d5Tjt.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($d5Tjt.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $3babfb12b473c764$var$RawSha256;

});

parcelRegister("3Fk1A", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $2ab4bbea62ab01fb$export$c7c5cef950a4d2fc);

var $fxeOV = parcelRequire("fxeOV");

var $hRLFI = parcelRequire("hRLFI");
var $2ab4bbea62ab01fb$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $hRLFI.fromUtf8)(input) : (0, $fxeOV.fromUtf8)(input);
};
var $2ab4bbea62ab01fb$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $hRLFI.toUtf8)(input) : (0, $fxeOV.toUtf8)(input);
};

});
parcelRegister("fxeOV", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $b4f56f1ef6f1d759$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $b4f56f1ef6f1d759$export$b4b216764bb846eb);
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $b4f56f1ef6f1d759$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $b4f56f1ef6f1d759$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("hRLFI", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $d01c5d89ca25d518$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $d01c5d89ca25d518$export$b4b216764bb846eb);
function $d01c5d89ca25d518$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $d01c5d89ca25d518$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("biuEp", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $dBHwk = parcelRequire("dBHwk");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $2rasJ = parcelRequire("2rasJ");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2rasJ.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $dBHwk.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2rasJ.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $2rasJ.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("dBHwk", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});




parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof $parcel$global !== "undefined" && obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $iBfJ5.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $8ec5fc0fdc198ba4$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});



parcelRegister("dZNvx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $jLgwE = parcelRequire("jLgwE");

var $iS0p3 = parcelRequire("iS0p3");

var $43ZGj = parcelRequire("43ZGj");

var $ev7Sh = parcelRequire("ev7Sh");

var $5J2Ch = parcelRequire("5J2Ch");

var $b3AtY = parcelRequire("b3AtY");
var $a30760100f159708$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $ev7Sh.supportsWebCrypto)((0, $b3AtY.locateWindow)())) this.hash = new $iS0p3.Sha256(secret);
        else if ((0, $5J2Ch.isMsWindow)((0, $b3AtY.locateWindow)())) this.hash = new $jLgwE.Sha256(secret);
        else this.hash = new $43ZGj.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
module.exports.Sha256 = $a30760100f159708$var$Sha256;

});
parcelRegister("jLgwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $5W33V = parcelRequire("5W33V");

var $HuE2p = parcelRequire("HuE2p");

var $7JkZg = parcelRequire("7JkZg");

var $b3AtY = parcelRequire("b3AtY");
var $e62f39bfe4c4c07c$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = $e62f39bfe4c4c07c$var$getKeyPromise(secret).then(function(keyData) {
                return (0, $b3AtY.locateWindow)().msCrypto.subtle.sign($HuE2p.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $b3AtY.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $5W33V.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($e62f39bfe4c4c07c$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $e62f39bfe4c4c07c$var$Sha256;
function $e62f39bfe4c4c07c$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $b3AtY.locateWindow)().msCrypto.subtle.importKey("raw", $e62f39bfe4c4c07c$var$toArrayBufferView(secret), $HuE2p.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $e62f39bfe4c4c07c$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $7JkZg.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("5W33V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $4524bea7fa1c3c18$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $4524bea7fa1c3c18$var$isEmptyData;

});

parcelRegister("HuE2p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("7JkZg", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $5a0d03f47ba3a19c$export$c7c5cef950a4d2fc);

var $3FGx9 = parcelRequire("3FGx9");

var $1FDTF = parcelRequire("1FDTF");
const $5a0d03f47ba3a19c$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $1FDTF.fromUtf8)(input) : (0, $3FGx9.fromUtf8)(input);
const $5a0d03f47ba3a19c$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $1FDTF.toUtf8)(input) : (0, $3FGx9.toUtf8)(input);

});
parcelRegister("3FGx9", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $2ac631c22079bb70$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $2ac631c22079bb70$export$b4b216764bb846eb);
const $2ac631c22079bb70$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $2ac631c22079bb70$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("1FDTF", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $13789176cdd2435b$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $13789176cdd2435b$export$b4b216764bb846eb);
function $13789176cdd2435b$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $13789176cdd2435b$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});


parcelRegister("b3AtY", function(module, exports) {

$parcel$export(module.exports, "locateWindow", () => $80cc462e9f5bf099$export$2a77db4d0e0dd1ff);
const $80cc462e9f5bf099$var$fallbackWindow = {};
function $80cc462e9f5bf099$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $80cc462e9f5bf099$var$fallbackWindow;
}

});


parcelRegister("iS0p3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hjaGm = parcelRequire("hjaGm");

var $HuE2p = parcelRequire("HuE2p");

var $b3AtY = parcelRequire("b3AtY");
var $dbcd95333c2a53f2$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $b3AtY.locateWindow)().crypto.subtle.importKey("raw", (0, $hjaGm.convertToBuffer)(secret), $HuE2p.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, $hjaGm.isEmptyData)(data)) return;
        var update = (0, $hjaGm.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $b3AtY.locateWindow)().crypto.subtle.sign($HuE2p.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $hjaGm.isEmptyData)(this.toHash)) return Promise.resolve($HuE2p.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $b3AtY.locateWindow)().crypto.subtle.digest($HuE2p.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $dbcd95333c2a53f2$var$Sha256;

});
parcelRegister("hjaGm", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $8fgGH = parcelRequire("8fgGH");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $8fgGH.convertToBuffer;
    }
});

var $8jSOE = parcelRequire("8jSOE");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $8jSOE.isEmptyData;
    }
});

var $gio1K = parcelRequire("gio1K");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $gio1K.numToUint8;
    }
});

var $6T6C2 = parcelRequire("6T6C2");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $6T6C2.uint32ArrayFrom;
    }
});

});
parcelRegister("8fgGH", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $600cab417a06e7ac$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $7JkZg = parcelRequire("7JkZg");
// Quick polyfill
var $600cab417a06e7ac$var$fromUtf8 = typeof $600cab417a06e7ac$require$Buffer !== "undefined" && $600cab417a06e7ac$require$Buffer.from ? function(input) {
    return $600cab417a06e7ac$require$Buffer.from(input, "utf8");
} : $7JkZg.fromUtf8;
function $600cab417a06e7ac$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $600cab417a06e7ac$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $600cab417a06e7ac$var$convertToBuffer;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("8jSOE", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $60ea9e669120404c$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $60ea9e669120404c$var$isEmptyData;

});

parcelRegister("gio1K", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $bdd0f70f69a63efb$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $bdd0f70f69a63efb$var$numToUint8;

});

parcelRegister("6T6C2", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $503d023ca5269342$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $503d023ca5269342$var$uint32ArrayFrom;

});



parcelRegister("43ZGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fo9tD = parcelRequire("fo9tD");

(0, $fo9tD.__exportStar)((parcelRequire("ap24y")), module.exports);

});
parcelRegister("fo9tD", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $b34072d902a04152$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $b34072d902a04152$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $b34072d902a04152$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b34072d902a04152$var$extendStatics = function(d, b) {
    $b34072d902a04152$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b34072d902a04152$var$extendStatics(d, b);
};
function $b34072d902a04152$export$a8ba968b8961cb8a(d, b) {
    $b34072d902a04152$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b34072d902a04152$export$18ce0697a983be9b = function() {
    $b34072d902a04152$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b34072d902a04152$export$18ce0697a983be9b.apply(this, arguments);
};
function $b34072d902a04152$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b34072d902a04152$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b34072d902a04152$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b34072d902a04152$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b34072d902a04152$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b34072d902a04152$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b34072d902a04152$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b34072d902a04152$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b34072d902a04152$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b34072d902a04152$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b34072d902a04152$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b34072d902a04152$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b34072d902a04152$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b34072d902a04152$export$10c90e4f7922046c(v) {
    return this instanceof $b34072d902a04152$export$10c90e4f7922046c ? (this.v = v, this) : new $b34072d902a04152$export$10c90e4f7922046c(v);
}
function $b34072d902a04152$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b34072d902a04152$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b34072d902a04152$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b34072d902a04152$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b34072d902a04152$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b34072d902a04152$export$19a8beecd37a4c45 === "function" ? $b34072d902a04152$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b34072d902a04152$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b34072d902a04152$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b34072d902a04152$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b34072d902a04152$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b34072d902a04152$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("ap24y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $fo9tD = parcelRequire("fo9tD");

var $gHUYh = parcelRequire("gHUYh");

var $slA5K = parcelRequire("slA5K");

var $hjaGm = parcelRequire("hjaGm");
var $792dd8bc0c72ea08$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $slA5K.RawSha256();
        if (secret) {
            this.outer = new $slA5K.RawSha256();
            var inner = $792dd8bc0c72ea08$var$bufferFromSecret(secret);
            var outer = new Uint8Array($gHUYh.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $gHUYh.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $hjaGm.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $hjaGm.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $fo9tD.__awaiter)(this, void 0, void 0, function() {
            return (0, $fo9tD.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $792dd8bc0c72ea08$var$Sha256;
function $792dd8bc0c72ea08$var$bufferFromSecret(secret) {
    var input = (0, $hjaGm.convertToBuffer)(secret);
    if (input.byteLength > $gHUYh.BLOCK_SIZE) {
        var bufferHash = new $slA5K.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($gHUYh.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("gHUYh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("slA5K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $gHUYh = parcelRequire("gHUYh");
/**
 * @internal
 */ var $05535b3398184e5b$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($gHUYh.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $gHUYh.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $gHUYh.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $gHUYh.BLOCK_SIZE >= $gHUYh.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $gHUYh.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $gHUYh.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($gHUYh.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($gHUYh.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($gHUYh.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $gHUYh.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($gHUYh.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $05535b3398184e5b$var$RawSha256;

});



parcelRegister("ev7Sh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kzTHY = parcelRequire("kzTHY");

$kzTHY.__exportStar((parcelRequire("kxobH")), module.exports);

});
parcelRegister("kzTHY", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $efb24a0743932879$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $efb24a0743932879$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $efb24a0743932879$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $efb24a0743932879$var$extendStatics = function(d, b) {
    $efb24a0743932879$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $efb24a0743932879$var$extendStatics(d, b);
};
function $efb24a0743932879$export$a8ba968b8961cb8a(d, b) {
    $efb24a0743932879$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $efb24a0743932879$export$18ce0697a983be9b = function() {
    $efb24a0743932879$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $efb24a0743932879$export$18ce0697a983be9b.apply(this, arguments);
};
function $efb24a0743932879$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $efb24a0743932879$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $efb24a0743932879$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $efb24a0743932879$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $efb24a0743932879$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $efb24a0743932879$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $efb24a0743932879$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $efb24a0743932879$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $efb24a0743932879$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $efb24a0743932879$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $efb24a0743932879$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($efb24a0743932879$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $efb24a0743932879$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $efb24a0743932879$export$10c90e4f7922046c(v) {
    return this instanceof $efb24a0743932879$export$10c90e4f7922046c ? (this.v = v, this) : new $efb24a0743932879$export$10c90e4f7922046c(v);
}
function $efb24a0743932879$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $efb24a0743932879$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $efb24a0743932879$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $efb24a0743932879$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $efb24a0743932879$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $efb24a0743932879$export$19a8beecd37a4c45 === "function" ? $efb24a0743932879$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $efb24a0743932879$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $efb24a0743932879$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $efb24a0743932879$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $efb24a0743932879$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $efb24a0743932879$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("kxobH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $kzTHY = parcelRequire("kzTHY");
var $ef39a6e4a29d7d1f$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $ef39a6e4a29d7d1f$var$supportsWebCrypto(window) {
    if ($ef39a6e4a29d7d1f$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $ef39a6e4a29d7d1f$var$supportsWebCrypto;
function $ef39a6e4a29d7d1f$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $ef39a6e4a29d7d1f$var$supportsSecureRandom;
function $ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle) {
    return subtle && $ef39a6e4a29d7d1f$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $ef39a6e4a29d7d1f$var$supportsSubtleCrypto;
function $ef39a6e4a29d7d1f$var$supportsZeroByteGCM(subtle) {
    return $kzTHY.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $kzTHY.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $ef39a6e4a29d7d1f$var$supportsZeroByteGCM;

});


parcelRegister("5J2Ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eQfwo = parcelRequire("eQfwo");

$eQfwo.__exportStar((parcelRequire("eMy2l")), module.exports);

$eQfwo.__exportStar((parcelRequire("inKXX")), module.exports);

$eQfwo.__exportStar((parcelRequire("cNnlx")), module.exports);

$eQfwo.__exportStar((parcelRequire("8ShfB")), module.exports);

$eQfwo.__exportStar((parcelRequire("5zgQn")), module.exports);

});
parcelRegister("eQfwo", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $ace1f64193e2e0e6$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ace1f64193e2e0e6$var$extendStatics = function(d, b) {
    $ace1f64193e2e0e6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ace1f64193e2e0e6$var$extendStatics(d, b);
};
function $ace1f64193e2e0e6$export$a8ba968b8961cb8a(d, b) {
    $ace1f64193e2e0e6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ace1f64193e2e0e6$export$18ce0697a983be9b = function() {
    $ace1f64193e2e0e6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ace1f64193e2e0e6$export$18ce0697a983be9b.apply(this, arguments);
};
function $ace1f64193e2e0e6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ace1f64193e2e0e6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ace1f64193e2e0e6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ace1f64193e2e0e6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ace1f64193e2e0e6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ace1f64193e2e0e6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ace1f64193e2e0e6$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ace1f64193e2e0e6$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ace1f64193e2e0e6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ace1f64193e2e0e6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ace1f64193e2e0e6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ace1f64193e2e0e6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ace1f64193e2e0e6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ace1f64193e2e0e6$export$10c90e4f7922046c(v) {
    return this instanceof $ace1f64193e2e0e6$export$10c90e4f7922046c ? (this.v = v, this) : new $ace1f64193e2e0e6$export$10c90e4f7922046c(v);
}
function $ace1f64193e2e0e6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ace1f64193e2e0e6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ace1f64193e2e0e6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ace1f64193e2e0e6$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ace1f64193e2e0e6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ace1f64193e2e0e6$export$19a8beecd37a4c45 === "function" ? $ace1f64193e2e0e6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ace1f64193e2e0e6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ace1f64193e2e0e6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ace1f64193e2e0e6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ace1f64193e2e0e6$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ace1f64193e2e0e6$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("eMy2l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("inKXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cNnlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8ShfB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5zgQn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $40dd49703035fb84$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $40dd49703035fb84$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $40dd49703035fb84$var$isMsWindow(window) {
    if ($40dd49703035fb84$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $40dd49703035fb84$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $40dd49703035fb84$var$isMsWindow;

});



parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("dOqqi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("WS9F7", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("laOt8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6a1ae3267718cab$export$2e2bcd8739ae039);
function $f6a1ae3267718cab$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("9CiNR", function(module, exports) {

$parcel$export(module.exports, "convert2nimn", () => $70063f94e6c64de4$export$fa981bbccf843781, (v) => $70063f94e6c64de4$export$fa981bbccf843781 = v);
var $70063f94e6c64de4$export$fa981bbccf843781;
"use strict";
const $70063f94e6c64de4$var$char = function(a) {
    return String.fromCharCode(a);
};
const $70063f94e6c64de4$var$chars = {
    nilChar: $70063f94e6c64de4$var$char(176),
    missingChar: $70063f94e6c64de4$var$char(201),
    nilPremitive: $70063f94e6c64de4$var$char(175),
    missingPremitive: $70063f94e6c64de4$var$char(200),
    emptyChar: $70063f94e6c64de4$var$char(178),
    emptyValue: $70063f94e6c64de4$var$char(177),
    boundryChar: $70063f94e6c64de4$var$char(179),
    objStart: $70063f94e6c64de4$var$char(198),
    arrStart: $70063f94e6c64de4$var$char(204),
    arrayEnd: $70063f94e6c64de4$var$char(185)
};
const $70063f94e6c64de4$var$charsArr = [
    $70063f94e6c64de4$var$chars.nilChar,
    $70063f94e6c64de4$var$chars.nilPremitive,
    $70063f94e6c64de4$var$chars.missingChar,
    $70063f94e6c64de4$var$chars.missingPremitive,
    $70063f94e6c64de4$var$chars.boundryChar,
    $70063f94e6c64de4$var$chars.emptyChar,
    $70063f94e6c64de4$var$chars.emptyValue,
    $70063f94e6c64de4$var$chars.arrayEnd,
    $70063f94e6c64de4$var$chars.objStart,
    $70063f94e6c64de4$var$chars.arrStart
];
const $70063f94e6c64de4$var$_e = function(node, e_schema, options) {
    if (typeof e_schema === "string") {
        //premitive
        if (node && node[0] && node[0].val !== undefined) return $70063f94e6c64de4$var$getValue(node[0].val, e_schema);
        else return $70063f94e6c64de4$var$getValue(node, e_schema);
    } else {
        const hasValidData = $70063f94e6c64de4$var$hasData(node);
        if (hasValidData === true) {
            let str = "";
            if (Array.isArray(e_schema)) {
                //attributes can't be repeated. hence check in children tags only
                str += $70063f94e6c64de4$var$chars.arrStart;
                const itemSchema = e_schema[0];
                //const itemSchemaType = itemSchema;
                const arr_len = node.length;
                if (typeof itemSchema === "string") for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $70063f94e6c64de4$var$getValue(node[arr_i].val, itemSchema);
                    str = $70063f94e6c64de4$var$processValue(str, r);
                }
                else for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $70063f94e6c64de4$var$_e(node[arr_i], itemSchema, options);
                    str = $70063f94e6c64de4$var$processValue(str, r);
                }
                str += $70063f94e6c64de4$var$chars.arrayEnd; //indicates that next item is not array item
            } else {
                //object
                str += $70063f94e6c64de4$var$chars.objStart;
                const keys = Object.keys(e_schema);
                if (Array.isArray(node)) node = node[0];
                for(let i in keys){
                    const key = keys[i];
                    //a property defined in schema can be present either in attrsMap or children tags
                    //options.textNodeName will not present in both maps, take it's value from val
                    //options.attrNodeName will be present in attrsMap
                    let r;
                    if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) r = $70063f94e6c64de4$var$_e(node.attrsMap[key], e_schema[key], options);
                    else if (key === options.textNodeName) r = $70063f94e6c64de4$var$_e(node.val, e_schema[key], options);
                    else r = $70063f94e6c64de4$var$_e(node.child[key], e_schema[key], options);
                    str = $70063f94e6c64de4$var$processValue(str, r);
                }
            }
            return str;
        } else return hasValidData;
    }
};
const $70063f94e6c64de4$var$getValue = function(a /*, type*/ ) {
    switch(a){
        case undefined:
            return $70063f94e6c64de4$var$chars.missingPremitive;
        case null:
            return $70063f94e6c64de4$var$chars.nilPremitive;
        case "":
            return $70063f94e6c64de4$var$chars.emptyValue;
        default:
            return a;
    }
};
const $70063f94e6c64de4$var$processValue = function(str, r) {
    if (!$70063f94e6c64de4$var$isAppChar(r[0]) && !$70063f94e6c64de4$var$isAppChar(str[str.length - 1])) str += $70063f94e6c64de4$var$chars.boundryChar;
    return str + r;
};
const $70063f94e6c64de4$var$isAppChar = function(ch) {
    return $70063f94e6c64de4$var$charsArr.indexOf(ch) !== -1;
};
function $70063f94e6c64de4$var$hasData(jObj) {
    if (jObj === undefined) return $70063f94e6c64de4$var$chars.missingChar;
    else if (jObj === null) return $70063f94e6c64de4$var$chars.nilChar;
    else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) return $70063f94e6c64de4$var$chars.emptyChar;
    else return true;
}

var $21YsA = parcelRequire("21YsA");

var $l8rQG = parcelRequire("l8rQG");
var $70063f94e6c64de4$require$buildOptions = $l8rQG.buildOptions;
const $70063f94e6c64de4$var$convert2nimn = function(node, e_schema, options) {
    options = $70063f94e6c64de4$require$buildOptions(options, $21YsA.defaultOptions, $21YsA.props);
    return $70063f94e6c64de4$var$_e(node, e_schema, options);
};
$70063f94e6c64de4$export$fa981bbccf843781 = $70063f94e6c64de4$var$convert2nimn;

});
parcelRegister("21YsA", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", () => $17aa92e58750223a$export$ba43bf67f3d48107, (v) => $17aa92e58750223a$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "props", () => $17aa92e58750223a$export$8128bb6492cf3de7, (v) => $17aa92e58750223a$export$8128bb6492cf3de7 = v);
$parcel$export(module.exports, "getTraversalObj", () => $17aa92e58750223a$export$2ca3eb0a2f8a693a, (v) => $17aa92e58750223a$export$2ca3eb0a2f8a693a = v);
var $17aa92e58750223a$export$ba43bf67f3d48107;
var $17aa92e58750223a$export$8128bb6492cf3de7;
var $17aa92e58750223a$export$2ca3eb0a2f8a693a;
"use strict";

var $l8rQG = parcelRequire("l8rQG");

var $l8rQG = parcelRequire("l8rQG");
var $17aa92e58750223a$require$buildOptions = $l8rQG.buildOptions;

var $ji8Zv = parcelRequire("ji8Zv");

var $fLtYL = parcelRequire("fLtYL");
const $17aa92e58750223a$var$regx = "<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, $l8rQG.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $17aa92e58750223a$var$defaultOptions = {
    attributeNamePrefix: "@_",
    attrNodeName: false,
    textNodeName: "#text",
    ignoreAttributes: true,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseNodeValue: true,
    parseAttributeValue: false,
    arrayMode: false,
    trimValues: true,
    cdataTagName: false,
    cdataPositionChar: "\\c",
    numParseOptions: {
        hex: true,
        leadingZeros: true
    },
    tagValueProcessor: function(a, tagName) {
        return a;
    },
    attrValueProcessor: function(a, attrName) {
        return a;
    },
    stopNodes: [],
    alwaysCreateTextNode: false
};
$17aa92e58750223a$export$ba43bf67f3d48107 = $17aa92e58750223a$var$defaultOptions;
const $17aa92e58750223a$var$props = [
    "attributeNamePrefix",
    "attrNodeName",
    "textNodeName",
    "ignoreAttributes",
    "ignoreNameSpace",
    "allowBooleanAttributes",
    "parseNodeValue",
    "parseAttributeValue",
    "arrayMode",
    "trimValues",
    "cdataTagName",
    "cdataPositionChar",
    "tagValueProcessor",
    "attrValueProcessor",
    "parseTrueNumberOnly",
    "numParseOptions",
    "stopNodes",
    "alwaysCreateTextNode"
];
$17aa92e58750223a$export$8128bb6492cf3de7 = $17aa92e58750223a$var$props;
/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */ function $17aa92e58750223a$var$processTagValue(tagName, val, options) {
    if (val) {
        if (options.trimValues) val = val.trim();
        val = options.tagValueProcessor(val, tagName);
        val = $17aa92e58750223a$var$parseValue(val, options.parseNodeValue, options.numParseOptions);
    }
    return val;
}
function $17aa92e58750223a$var$resolveNameSpace(tagname, options) {
    if (options.ignoreNameSpace) {
        const tags = tagname.split(":");
        const prefix = tagname.charAt(0) === "/" ? "/" : "";
        if (tags[0] === "xmlns") return "";
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
function $17aa92e58750223a$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === "string") {
        //console.log(options)
        const newval = val.trim();
        if (newval === "true") return true;
        else if (newval === "false") return false;
        else return $fLtYL(val, options);
    } else {
        if ($l8rQG.isExist(val)) return val;
        else return "";
    }
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $17aa92e58750223a$var$attrsRegx = new RegExp("([^\\s=]+)\\s*(=\\s*(['\"])(.*?)\\3)?", "g");
function $17aa92e58750223a$var$buildAttributesMap(attrStr, options) {
    if (!options.ignoreAttributes && typeof attrStr === "string") {
        attrStr = attrStr.replace(/\r?\n/g, " ");
        //attrStr = attrStr || attrStr.trim();
        const matches = $l8rQG.getAllMatches(attrStr, $17aa92e58750223a$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = $17aa92e58750223a$var$resolveNameSpace(matches[i][1], options);
            if (attrName.length) {
                if (matches[i][4] !== undefined) {
                    if (options.trimValues) matches[i][4] = matches[i][4].trim();
                    matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                    attrs[options.attributeNamePrefix + attrName] = $17aa92e58750223a$var$parseValue(matches[i][4], options.parseAttributeValue, options.numParseOptions);
                } else if (options.allowBooleanAttributes) attrs[options.attributeNamePrefix + attrName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (options.attrNodeName) {
            const attrCollection = {};
            attrCollection[options.attrNodeName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $17aa92e58750223a$var$getTraversalObj = function(xmlData, options) {
    xmlData = xmlData.replace(/\r\n?/g, "\n");
    options = $17aa92e58750223a$require$buildOptions(options, $17aa92e58750223a$var$defaultOptions, $17aa92e58750223a$var$props);
    const xmlObj = new $ji8Zv("!xml");
    let currentNode = xmlObj;
    let textData = "";
    //function match(xmlData){
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === "<") {
            if (xmlData[i + 1] === "/") {
                const closeIndex = $17aa92e58750223a$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */ if (currentNode) {
                    if (currentNode.val) currentNode.val = $l8rQG.getValue(currentNode.val) + "" + $17aa92e58750223a$var$processTagValue(tagName, textData, options);
                    else currentNode.val = $17aa92e58750223a$var$processTagValue(tagName, textData, options);
                }
                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                    currentNode.child = [];
                    if (currentNode.attrsMap == undefined) currentNode.attrsMap = {};
                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
                }
                currentNode = currentNode.parent;
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === "?") i = $17aa92e58750223a$var$findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
            else if (xmlData.substr(i + 1, 3) === "!--") i = $17aa92e58750223a$var$findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
            else if (xmlData.substr(i + 1, 2) === "!D") {
                const closeIndex = $17aa92e58750223a$var$findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
                const tagExp = xmlData.substring(i, closeIndex);
                if (tagExp.indexOf("[") >= 0) i = xmlData.indexOf("]>", i) + 1;
                else i = closeIndex;
            } else if (xmlData.substr(i + 1, 2) === "![") {
                const closeIndex = $17aa92e58750223a$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                //considerations
                //1. CDATA will always have parent node
                //2. A tag with CDATA is not a leaf node so it's value would be string type.
                if (textData) {
                    currentNode.val = $l8rQG.getValue(currentNode.val) + "" + $17aa92e58750223a$var$processTagValue(currentNode.tagname, textData, options);
                    textData = "";
                }
                if (options.cdataTagName) {
                    //add cdata node
                    const childNode = new $ji8Zv(options.cdataTagName, currentNode, tagExp);
                    currentNode.addChild(childNode);
                    //for backtracking
                    currentNode.val = $l8rQG.getValue(currentNode.val) + options.cdataPositionChar;
                    //add rest value to parent node
                    if (tagExp) childNode.val = tagExp;
                } else currentNode.val = (currentNode.val || "") + (tagExp || "");
                i = closeIndex + 2;
            } else {
                const result = $17aa92e58750223a$var$closingIndexForOpeningTag(xmlData, i + 1);
                let tagExp = result.data;
                const closeIndex = result.index;
                const separatorIndex = tagExp.indexOf(" ");
                let tagName = tagExp;
                let shouldBuildAttributesMap = true;
                if (separatorIndex !== -1) {
                    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, "");
                    tagExp = tagExp.substr(separatorIndex + 1);
                }
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) {
                        tagName = tagName.substr(colonIndex + 1);
                        shouldBuildAttributesMap = tagName !== result.data.substr(colonIndex + 1);
                    }
                }
                //save text to parent node
                if (currentNode && textData) {
                    if (currentNode.tagname !== "!xml") currentNode.val = $l8rQG.getValue(currentNode.val) + "" + $17aa92e58750223a$var$processTagValue(currentNode.tagname, textData, options);
                }
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    const childNode = new $ji8Zv(tagName, currentNode, "");
                    if (tagName !== tagExp) childNode.attrsMap = $17aa92e58750223a$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                } else {
                    const childNode = new $ji8Zv(tagName, currentNode);
                    if (options.stopNodes.length && options.stopNodes.includes(childNode.tagname)) childNode.startIndex = closeIndex;
                    if (tagName !== tagExp && shouldBuildAttributesMap) childNode.attrsMap = $17aa92e58750223a$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                    currentNode = childNode;
                }
                textData = "";
                i = closeIndex;
            }
        } else textData += xmlData[i];
    }
    return xmlObj;
};
function $17aa92e58750223a$var$closingIndexForOpeningTag(data, i) {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < data.length; index++){
        let ch = data[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === ">") return {
            data: tagExp,
            index: index
        };
        else if (ch === "	") ch = " ";
        tagExp += ch;
    }
}
function $17aa92e58750223a$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
$17aa92e58750223a$export$2ca3eb0a2f8a693a = $17aa92e58750223a$var$getTraversalObj;

});
parcelRegister("l8rQG", function(module, exports) {

$parcel$export(module.exports, "isExist", () => $f62ff286a4f745fa$export$a5edf3f35b6dd392, (v) => $f62ff286a4f745fa$export$a5edf3f35b6dd392 = v);
$parcel$export(module.exports, "isEmptyObject", () => $f62ff286a4f745fa$export$83b788b1a3698c03, (v) => $f62ff286a4f745fa$export$83b788b1a3698c03 = v);
$parcel$export(module.exports, "merge", () => $f62ff286a4f745fa$export$4950aa0f605343fb, (v) => $f62ff286a4f745fa$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "getValue", () => $f62ff286a4f745fa$export$bf7199a9ebcb84a9, (v) => $f62ff286a4f745fa$export$bf7199a9ebcb84a9 = v);
$parcel$export(module.exports, "buildOptions", () => $f62ff286a4f745fa$export$ecbd7d678ac4909b, (v) => $f62ff286a4f745fa$export$ecbd7d678ac4909b = v);
$parcel$export(module.exports, "isTagNameInArrayMode", () => $f62ff286a4f745fa$export$fd3b6180ca5b0284, (v) => $f62ff286a4f745fa$export$fd3b6180ca5b0284 = v);
$parcel$export(module.exports, "isName", () => $f62ff286a4f745fa$export$998d7ff9801e90bb, (v) => $f62ff286a4f745fa$export$998d7ff9801e90bb = v);
$parcel$export(module.exports, "getAllMatches", () => $f62ff286a4f745fa$export$aaa9734c55cb7a19, (v) => $f62ff286a4f745fa$export$aaa9734c55cb7a19 = v);
$parcel$export(module.exports, "nameRegexp", () => $f62ff286a4f745fa$export$e8f2644f7085b4b1, (v) => $f62ff286a4f745fa$export$e8f2644f7085b4b1 = v);
var $f62ff286a4f745fa$export$a5edf3f35b6dd392;
var $f62ff286a4f745fa$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $f62ff286a4f745fa$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $f62ff286a4f745fa$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $f62ff286a4f745fa$export$ecbd7d678ac4909b;
/**
 * Check if a tag name should be treated as array
 *
 * @param tagName the node tagname
 * @param arrayMode the array mode option
 * @param parentTagName the parent tag name
 * @returns {boolean} true if node should be parsed as array
 */ var $f62ff286a4f745fa$export$fd3b6180ca5b0284;
var $f62ff286a4f745fa$export$998d7ff9801e90bb;
var $f62ff286a4f745fa$export$aaa9734c55cb7a19;
var $f62ff286a4f745fa$export$e8f2644f7085b4b1;
"use strict";
const $f62ff286a4f745fa$var$nameStartChar = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
const $f62ff286a4f745fa$var$nameChar = $f62ff286a4f745fa$var$nameStartChar + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
const $f62ff286a4f745fa$var$nameRegexp = "[" + $f62ff286a4f745fa$var$nameStartChar + "][" + $f62ff286a4f745fa$var$nameChar + "]*";
const $f62ff286a4f745fa$var$regexName = new RegExp("^" + $f62ff286a4f745fa$var$nameRegexp + "$");
const $f62ff286a4f745fa$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $f62ff286a4f745fa$var$isName = function(string) {
    const match = $f62ff286a4f745fa$var$regexName.exec(string);
    return !(match === null || typeof match === "undefined");
};
$f62ff286a4f745fa$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== "undefined";
};
$f62ff286a4f745fa$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$f62ff286a4f745fa$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === "strict") target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$f62ff286a4f745fa$export$bf7199a9ebcb84a9 = function(v) {
    if ($f62ff286a4f745fa$export$a5edf3f35b6dd392(v)) return v;
    else return "";
};
$f62ff286a4f745fa$export$ecbd7d678ac4909b = function(options, defaultOptions, props) {
    let newOptions = {};
    if (!options) return defaultOptions; //if there are not options
    for(let i = 0; i < props.length; i++)if (options[props[i]] !== undefined) newOptions[props[i]] = options[props[i]];
    else newOptions[props[i]] = defaultOptions[props[i]];
    return newOptions;
};
$f62ff286a4f745fa$export$fd3b6180ca5b0284 = function(tagName, arrayMode, parentTagName) {
    if (arrayMode === false) return false;
    else if (arrayMode instanceof RegExp) return arrayMode.test(tagName);
    else if (typeof arrayMode === "function") return !!arrayMode(tagName, parentTagName);
    return arrayMode === "strict";
};
$f62ff286a4f745fa$export$998d7ff9801e90bb = $f62ff286a4f745fa$var$isName;
$f62ff286a4f745fa$export$aaa9734c55cb7a19 = $f62ff286a4f745fa$var$getAllMatches;
$f62ff286a4f745fa$export$e8f2644f7085b4b1 = $f62ff286a4f745fa$var$nameRegexp;

});

parcelRegister("ji8Zv", function(module, exports) {
"use strict";
module.exports = function(tagname, parent, val) {
    this.tagname = tagname;
    this.parent = parent;
    this.child = {}; //child tags
    this.attrsMap = {}; //attributes map
    this.val = val; //text only
    this.addChild = function(child) {
        if (Array.isArray(this.child[child.tagname])) //already presents
        this.child[child.tagname].push(child);
        else this.child[child.tagname] = [
            child
        ];
    };
};

});

parcelRegister("fLtYL", function(module, exports) {
const $b7a28001cd116d9a$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $b7a28001cd116d9a$var$numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $b7a28001cd116d9a$var$consider = {
    hex: true,
    leadingZeros: true,
    decimalPoint: ".",
    eNotation: true
};
function $b7a28001cd116d9a$var$toNumber(str, options = {}) {
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }
    options = Object.assign({}, $b7a28001cd116d9a$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && $b7a28001cd116d9a$var$hexRegex.test(trimmedStr)) return Number.parseInt(trimmedStr, 16);
    else {
        //separate negative sign, leading zeros, and rest number
        const match = $b7a28001cd116d9a$var$numRegex.exec(trimmedStr);
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $b7a28001cd116d9a$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            const eNotation = match[4] || match[6];
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (eNotation) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) {
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if (numTrimmedByZeros === numStr) return num;
                    else if (sign + numTrimmedByZeros === numStr) return num;
                    else return str;
                }
                if (trimmedStr === numStr) return num;
                else if (trimmedStr === sign + numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);
                // }
                return str;
            }
        // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $b7a28001cd116d9a$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
module.exports = $b7a28001cd116d9a$var$toNumber;

});



parcelRegister("ajMmB", function(module, exports) {

$parcel$export(module.exports, "convertToJsonString", () => $783131c068b59ec2$export$54ffaacfc0931fb0, (v) => $783131c068b59ec2$export$54ffaacfc0931fb0 = v);
var $783131c068b59ec2$export$54ffaacfc0931fb0;
"use strict";

var $l8rQG = parcelRequire("l8rQG");

var $l8rQG = parcelRequire("l8rQG");
var $783131c068b59ec2$require$buildOptions = $l8rQG.buildOptions;

var $21YsA = parcelRequire("21YsA");
//TODO: do it later
const $783131c068b59ec2$var$convertToJsonString = function(node, options) {
    options = $783131c068b59ec2$require$buildOptions(options, $21YsA.defaultOptions, $21YsA.props);
    options.indentBy = options.indentBy || "";
    return $783131c068b59ec2$var$_cToJsonStr(node, options, 0);
};
const $783131c068b59ec2$var$_cToJsonStr = function(node, options, level) {
    let jObj = "{";
    //traver through all the children
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj += '"' + tagname + '" : [ ';
            for(let tag in node.child[tagname])jObj += $783131c068b59ec2$var$_cToJsonStr(node.child[tagname][tag], options) + " , ";
            jObj = jObj.substr(0, jObj.length - 1) + " ] "; //remove extra comma in last
        } else jObj += '"' + tagname + '" : ' + $783131c068b59ec2$var$_cToJsonStr(node.child[tagname][0], options) + " ,";
    }
    $l8rQG.merge(jObj, node.attrsMap);
    //add attrsMap as new children
    if ($l8rQG.isEmptyObject(jObj)) return $l8rQG.isExist(node.val) ? node.val : "";
    else {
        if ($l8rQG.isExist(node.val)) {
            if (!(typeof node.val === "string" && (node.val === "" || node.val === options.cdataPositionChar))) jObj += '"' + options.textNodeName + '" : ' + $783131c068b59ec2$var$stringval(node.val);
        }
    }
    //add value
    if (jObj[jObj.length - 1] === ",") jObj = jObj.substr(0, jObj.length - 2);
    return jObj + "}";
};
function $783131c068b59ec2$var$stringval(v) {
    if (v === true || v === false || !isNaN(v)) return v;
    else return '"' + v + '"';
}
function $783131c068b59ec2$var$indentate(options, level) {
    return options.indentBy.repeat(level);
}
$783131c068b59ec2$export$54ffaacfc0931fb0 = $783131c068b59ec2$var$convertToJsonString;

});

parcelRegister("gnljR", function(module, exports) {
"use strict";

var $l8rQG = parcelRequire("l8rQG");
var $bebf54e7096383a5$require$buildOptions = $l8rQG.buildOptions;
const $bebf54e7096383a5$var$defaultOptions = {
    attributeNamePrefix: "@_",
    attrNodeName: false,
    textNodeName: "#text",
    ignoreAttributes: true,
    cdataTagName: false,
    cdataPositionChar: "\\c",
    format: false,
    indentBy: "  ",
    supressEmptyNode: false,
    tagValueProcessor: function(a) {
        return a;
    },
    attrValueProcessor: function(a) {
        return a;
    }
};
const $bebf54e7096383a5$var$props = [
    "attributeNamePrefix",
    "attrNodeName",
    "textNodeName",
    "ignoreAttributes",
    "cdataTagName",
    "cdataPositionChar",
    "format",
    "indentBy",
    "supressEmptyNode",
    "tagValueProcessor",
    "attrValueProcessor",
    "rootNodeName"
];
function $bebf54e7096383a5$var$Parser(options) {
    this.options = $bebf54e7096383a5$require$buildOptions(options, $bebf54e7096383a5$var$defaultOptions, $bebf54e7096383a5$var$props);
    if (this.options.ignoreAttributes || this.options.attrNodeName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $bebf54e7096383a5$var$isAttribute;
    }
    if (this.options.cdataTagName) this.isCDATA = $bebf54e7096383a5$var$isCDATA;
    else this.isCDATA = function() {
        return false;
    };
    this.replaceCDATAstr = $bebf54e7096383a5$var$replaceCDATAstr;
    this.replaceCDATAarr = $bebf54e7096383a5$var$replaceCDATAarr;
    this.processTextOrObjNode = $bebf54e7096383a5$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $bebf54e7096383a5$var$indentate;
        this.tagEndChar = ">\n";
        this.newLine = "\n";
    } else {
        this.indentate = function() {
            return "";
        };
        this.tagEndChar = ">";
        this.newLine = "";
    }
    if (this.options.supressEmptyNode) {
        this.buildTextNode = $bebf54e7096383a5$var$buildEmptyTextNode;
        this.buildObjNode = $bebf54e7096383a5$var$buildEmptyObjNode;
    } else {
        this.buildTextNode = $bebf54e7096383a5$var$buildTextValNode;
        this.buildObjNode = $bebf54e7096383a5$var$buildObjectNode;
    }
    this.buildTextValNode = $bebf54e7096383a5$var$buildTextValNode;
    this.buildObjectNode = $bebf54e7096383a5$var$buildObjectNode;
}
$bebf54e7096383a5$var$Parser.prototype.parse = function(jObj) {
    if (Array.isArray(jObj) && this.options.rootNodeName && this.options.rootNodeName.length > 1) jObj = {
        [this.options.rootNodeName]: jObj
    };
    return this.j2x(jObj, 0).val;
};
$bebf54e7096383a5$var$Parser.prototype.j2x = function(jObj, level) {
    let attrStr = "";
    let val = "";
    for(let key in jObj){
        if (typeof jObj[key] === "undefined") ;
        else if (jObj[key] === null) val += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
        else if (jObj[key] instanceof Date) val += this.buildTextNode(jObj[key], key, "", level);
        else if (typeof jObj[key] !== "object") {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += " " + attr + '="' + this.options.attrValueProcessor("" + jObj[key]) + '"';
            else if (this.isCDATA(key)) {
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAstr("", jObj[key]);
            } else //tag value
            if (key === this.options.textNodeName) {
                if (jObj[this.options.cdataTagName]) ;
                else val += this.options.tagValueProcessor("" + jObj[key]);
            } else val += this.buildTextNode(jObj[key], key, "", level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            if (this.isCDATA(key)) {
                val += this.indentate(level);
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAarr("", jObj[key]);
            } else {
                //nested nodes
                const arrLen = jObj[key].length;
                for(let j = 0; j < arrLen; j++){
                    const item = jObj[key][j];
                    if (typeof item === "undefined") ;
                    else if (item === null) val += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
                    else if (typeof item === "object") val += this.processTextOrObjNode(item, key, level);
                    else val += this.buildTextNode(item, key, "", level);
                }
            }
        } else //nested node
        if (this.options.attrNodeName && key === this.options.attrNodeName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += " " + Ks[j] + '="' + this.options.attrValueProcessor("" + jObj[key][Ks[j]]) + '"';
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
function $bebf54e7096383a5$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextNode(result.val, key, result.attrStr, level);
    else return this.buildObjNode(result.val, key, result.attrStr, level);
}
function $bebf54e7096383a5$var$replaceCDATAstr(str, cdata) {
    str = this.options.tagValueProcessor("" + str);
    if (this.options.cdataPositionChar === "" || str === "") return str + "<![CDATA[" + cdata + "]]" + this.tagEndChar;
    else return str.replace(this.options.cdataPositionChar, "<![CDATA[" + cdata + "]]" + this.tagEndChar);
}
function $bebf54e7096383a5$var$replaceCDATAarr(str, cdata) {
    str = this.options.tagValueProcessor("" + str);
    if (this.options.cdataPositionChar === "" || str === "") return str + "<![CDATA[" + cdata.join("]]><![CDATA[") + "]]" + this.tagEndChar;
    else {
        for(let v in cdata)str = str.replace(this.options.cdataPositionChar, "<![CDATA[" + cdata[v] + "]]>");
        return str + this.newLine;
    }
}
function $bebf54e7096383a5$var$buildObjectNode(val, key, attrStr, level) {
    if (attrStr && val.indexOf("<") === -1) return this.indentate(level) + "<" + key + attrStr + ">" + val + //+ this.newLine
    // + this.indentate(level)
    "</" + key + this.tagEndChar;
    else return this.indentate(level) + "<" + key + attrStr + this.tagEndChar + val + //+ this.newLine
    this.indentate(level) + "</" + key + this.tagEndChar;
}
function $bebf54e7096383a5$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== "") return this.buildObjectNode(val, key, attrStr, level);
    else return this.indentate(level) + "<" + key + attrStr + "/" + this.tagEndChar;
}
function $bebf54e7096383a5$var$buildTextValNode(val, key, attrStr, level) {
    return this.indentate(level) + "<" + key + attrStr + ">" + this.options.tagValueProcessor(val) + "</" + key + this.tagEndChar;
}
function $bebf54e7096383a5$var$buildEmptyTextNode(val, key, attrStr, level) {
    if (val !== "") return this.buildTextValNode(val, key, attrStr, level);
    else return this.indentate(level) + "<" + key + attrStr + "/" + this.tagEndChar;
}
function $bebf54e7096383a5$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $bebf54e7096383a5$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
function $bebf54e7096383a5$var$isCDATA(name) {
    return name === this.options.cdataTagName;
}
//formatting
//indentation
//\n after each closing or self closing tag
module.exports = $bebf54e7096383a5$var$Parser;

});

parcelRegister("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance($lk5EI(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));

$57966c7e0affc4cb$var$axios.VERSION = (parcelRequire("35BUy")).version;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $4Tkeq("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $lJY4v;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("lJY4v", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $8v8A7 = parcelRequire("8v8A7");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $fd3c65eeb28abd71$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $fd3c65eeb28abd71$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json");
                return $fd3c65eeb28abd71$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $fd3c65eeb28abd71$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $8v8A7(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");

var $lJY4v = parcelRequire("lJY4v");

var $4Tkeq = parcelRequire("4Tkeq");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $lJY4v.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $4Tkeq("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});


parcelRegister("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});




parcelRegister("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $gKvUL.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $gKvUL.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("bv3QM", function(module, exports) {
"use strict";

var $35BUy = parcelRequire("35BUy");
var $85f59389941e7907$require$VERSION = $35BUy.version;
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $85f59389941e7907$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {
module.exports = {
    "version": "0.26.0"
};

});



parcelRegister("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $gKvUL.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("4at3P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_VIDEO_DURATION = module.exports.MAX_VIDEO_SIZE = module.exports.MAX_FILE_SIZE = module.exports.BACKGROUND_COLOR = module.exports.FONT = module.exports.DATA_UNIT_CONVERSION = module.exports.STORE_KEY_THEME = module.exports.STORE_KEY_FONT_FAMILY = module.exports.COLORS_V2_ALPHA = module.exports.COLORS_V2 = module.exports.COLORS = void 0;

var $6dtri = parcelRequire("6dtri");
module.exports.COLORS = {
    BLACK: "rgb(0, 0, 0)",
    BACKGROUND_DARK: "rgb(167, 179, 189)",
    BLACK_DISABLED: "rgb(145, 160, 173)",
    BLACK_HIGH_EMPHASIS: "rgb(48, 50, 55)",
    BLACK_INACTIVE: "rgb(209, 217, 222)",
    BLACK_MEDIUM_EMPHASIS: "rgb(63, 72, 83)",
    BLACK_SHADOW: "rgba(0, 0, 0, 0.25)",
    CREATIVE_TITLE: "rgb(47, 47, 47)",
    ERROR_DARK: "rgb(255, 48, 55)",
    ERROR_LIGHT: "rgb(255, 234, 235)",
    GRAY_10: "rgb(43, 49, 58)",
    GRAY_3: "rgb(222, 226, 230)",
    GRAY_CHIP_MEDIUM: "rgb(224, 224, 224)",
    GRAY_DARK: "rgb(101, 108, 117)",
    GRAY_DARK_2: "rgb(112, 112, 112)",
    GRAY_DARK_3: "rgb(139, 139, 139)",
    GRAY_DARK_4: "rgb(155, 155, 155)",
    GRAY_DARK_5: "rgb(66, 66, 66)",
    GRAY_DIVIDER: "rgb(167, 179, 189)",
    GRAY_LIGHT: "rgb(238, 240, 242)",
    GRAY_LIGHT_1: "rgb(223, 220, 220)",
    GRAY_LIGHT_2: "rgb(236, 236, 236)",
    GRAY_LIGHT_3: "rgb(196, 196, 196)",
    GRAY_LIGHT_4: "rgb(229, 229, 229)",
    GRAY_LIGHT_5: "rgb(199, 199, 199)",
    GRAY_LINK_INACTIVE: "rgb(128, 131, 137)",
    GRAY_PREVIEW_TEXT: "rgb(199, 207, 213)",
    GRAY_SPONSOR_TEXT: "rgb(142, 148, 160)",
    GRAY_BORDER: "rgb(167, 179, 189)",
    GREEN_LOADER: "rgb(0, 199, 177)",
    PREVIEW_HEADER_TEXT: "rgb(60, 60, 60)",
    PRIMARY_10: "rgb(219, 237, 251)",
    PRIMARY_100: "rgb(179, 233, 246)",
    PRIMARY_400: "rgb(51, 196, 232)",
    PRIMARY_50: "rgb(230, 248, 252)",
    PRIMARY_500_ACCENT: "rgb(0, 181, 226)",
    PRIMARY_900: "rgb(0, 79, 124)",
    PRIMARY_DARK_TEXT: "rgb(0, 72, 128)",
    SUCCESS_DARK: "rgb(0, 148, 126)",
    SUCCESS_LIGHT: "rgb(230, 249, 247)",
    SURFACE_SNACKBAR: "rgb(32, 32, 32)",
    WARNING_BASE: "rgb(255, 205, 0)",
    WARNING_DARK: "rgb(255, 174, 0)",
    WARNING_LIGHT: "rgb(255, 250, 230)",
    WHITE: "rgb(255, 255, 255)",
    WHITE_MEDIUM_EMPHASIS: "rgba(255, 255, 255, 0.7)",
    LOADER_BORDER: "rgb(0, 199, 177)",
    FACEBOOK_BANNER_DIVIDER: "rgb(197, 195, 195)",
    LOADER_LIGHT_BLUE: "rgb(79, 180, 221)",
    LOADER_GREEN: "rgb(88, 196, 178)",
    GRAY_HELPER: "rgb(129, 129, 129)"
};
module.exports.COLORS_V2 = {
    PRIMARY_50: "rgb(229, 235, 255)",
    PRIMARY_100: "rgb(204, 214, 255)",
    PRIMARY_200: "rgb(165, 183, 255)",
    PRIMARY_300: "rgb(123, 150, 255)",
    PRIMARY_400: "rgb(91, 124, 255)",
    PRIMARY_500: "rgb(60, 97, 243)",
    PRIMARY_600: "rgb(37, 80, 250)",
    PRIMARY_700: "rgb(0, 51, 255)",
    PRIMARY_800: "rgb(1, 33, 160)",
    PRIMARY_900: "rgb(8, 8, 48)",
    NEUTRAL_BLACK: "rgb(0, 0, 0)",
    NEUTRAL_DARK: "rgb(145, 160, 173)",
    NEUTRAL_INACTIVE: "rgb(209, 217, 222)",
    NEUTRAL_MEDIUM: "rgb(229, 234, 239)",
    NEUTRAL_LIGHT: "rgb(238, 243, 246)",
    NEUTRAL_WHITE: "rgb(255, 255, 255)",
    SUCCESS_DARK: "rgb(0, 148, 126)",
    SUCCESS_LIGHT: "rgb(0, 199, 177)",
    SUCCESS_LIGHTEST: "rgb(230, 246, 243)",
    WARNING_DARK: "rgb(255, 174, 0)",
    WARNING_LIGHT: "rgb(255, 205, 0)",
    WARNING_LIGHTEST: "rgb(255, 246, 212)",
    ERROR_DARK: "rgb(255, 48, 55)",
    ERROR_LIGHT: "rgb(255, 131, 135)",
    ERROR_LIGHTEST: "rgb(255, 234, 235)"
};
module.exports.COLORS_V2_ALPHA = {
    NEUTRAL_BLACK_SHADOW: module.exports.COLORS_V2.NEUTRAL_BLACK.replace(")", ", 0.25)"),
    NEUTRAL_BLACK_SCRIM: module.exports.COLORS_V2.NEUTRAL_BLACK.replace(")", ", 0.4)"),
    NEUTRAL_WHITE_FADE: module.exports.COLORS_V2.NEUTRAL_WHITE.replace(")", ", 0.54)")
};
module.exports.STORE_KEY_FONT_FAMILY = "demo_font_family";
module.exports.STORE_KEY_THEME = "demo_theme";
module.exports.DATA_UNIT_CONVERSION = 1024;
module.exports.FONT = {
    WEIGHT: {
        // Light
        THIN: 100,
        EXTRA_LIGHT: 200,
        LIGHT: 300,
        // Regular
        NORMAL: 400,
        MEDIUM: 500,
        // Bold
        SEMI_BOLD: 600,
        BOLD: 700,
        EXTRA_BOLD: 800
    },
    SIZE: {
        // Regular Text
        SMALL: "0.625em",
        REGULAR: "0.6875em",
        MEDIUM: "0.75em",
        SEMI_LARGE: "0.8125em",
        LARGE: "0.875em",
        EXTRA_LARGE: "1em",
        // Set default
        BASE: "16px",
        // Titles
        H2: "1.125em",
        H1: "2.25em"
    },
    FAMILY: {
        COLFAX: $6dtri.FONT_FAMILY_ENUM.colfax,
        POPPINS: $6dtri.FONT_FAMILY_ENUM.poppins,
        VERDANA: "Verdana, sans-serif",
        HELVETICA: "Helvetica, sans-serif"
    }
};
module.exports.BACKGROUND_COLOR = {
    [$6dtri.BACKGROUND_ENUM.black]: module.exports.COLORS_V2.NEUTRAL_BLACK,
    [$6dtri.BACKGROUND_ENUM.white]: module.exports.COLORS_V2.NEUTRAL_WHITE,
    [$6dtri.BACKGROUND_ENUM.blue]: module.exports.COLORS_V2.PRIMARY_700
};
module.exports.MAX_FILE_SIZE = 4;
module.exports.MAX_VIDEO_SIZE = 20;
module.exports.MAX_VIDEO_DURATION = 65;

});
parcelRegister("6dtri", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FILE_TYPE_ENUM = module.exports.ADVANCED_CREATIVE_SIZES_ENUM = module.exports.BACKGROUND_ENUM = module.exports.DATA_UNIT_ENUM = module.exports.TARGET_ENUM = module.exports.CSS_POS_ENUM = module.exports.INPUT_VARIANT_ENUM = module.exports.PROJECT_ENUM = module.exports.FONT_FAMILY_ENUM = module.exports.THEME_ENUM = module.exports.CREATIVE_SOCIAL_TYPE_ENUM = module.exports.CREATIVE_DESTINATION_ENUM = module.exports.CREATIVE_FORMAT_IFRAME_ENUM = module.exports.CREATIVE_FORMAT_ENUM = module.exports.CREATIVE_EDITOR_ENUM = void 0;
var $486acb05e5482e6a$var$CREATIVE_EDITOR_ENUM;
(function(CREATIVE_EDITOR_ENUM) {
    CREATIVE_EDITOR_ENUM["lite"] = "lite";
    CREATIVE_EDITOR_ENUM["advanced"] = "advanced";
})($486acb05e5482e6a$var$CREATIVE_EDITOR_ENUM || (module.exports.CREATIVE_EDITOR_ENUM = $486acb05e5482e6a$var$CREATIVE_EDITOR_ENUM = {}));
var $486acb05e5482e6a$var$CREATIVE_FORMAT_ENUM;
(function(CREATIVE_FORMAT_ENUM) {
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardBanner"] = 1] = "StandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["LogoEnhancedBanner"] = 2] = "LogoEnhancedBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["ScrollReactiveBanner"] = 3] = "ScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["AdhesiveBottomBanner"] = 4] = "AdhesiveBottomBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["AdhesiveSideBanner"] = 5] = "AdhesiveSideBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardVideo"] = 6] = "StandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["ScrollReactiveVideo"] = 7] = "ScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGStandardBanner"] = 8] = "IGStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGStandardVideo"] = 9] = "IGStandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGScrollReactiveBanner"] = 10] = "IGScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGScrollReactiveVideo"] = 11] = "IGScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBStandardBanner"] = 12] = "FBStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBStandardVideo"] = 13] = "FBStandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBScrollReactiveBanner"] = 14] = "FBScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBScrollReactiveVideo"] = 15] = "FBScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["TiktokVideo"] = 16] = "TiktokVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["InstagramReelsVideo"] = 17] = "InstagramReelsVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGCarousel"] = 18] = "IGCarousel";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["MiddleBanner"] = 19] = "MiddleBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBCarousel"] = 20] = "FBCarousel";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["DynamicScrollReactiveBanner"] = 21] = "DynamicScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Venti"] = 22] = "Venti";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Breakaway"] = 23] = "Breakaway";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Runway"] = 24] = "Runway";
/* Uncomment for A/B testing */ // StandardBannerIframe = 101,
// StandardVideoIframe = 102,
})($486acb05e5482e6a$var$CREATIVE_FORMAT_ENUM || (module.exports.CREATIVE_FORMAT_ENUM = $486acb05e5482e6a$var$CREATIVE_FORMAT_ENUM = {}));
var $486acb05e5482e6a$var$CREATIVE_FORMAT_IFRAME_ENUM;
(function(CREATIVE_FORMAT_IFRAME_ENUM) {
    CREATIVE_FORMAT_IFRAME_ENUM[CREATIVE_FORMAT_IFRAME_ENUM["StandardBannerIframe"] = 101] = "StandardBannerIframe";
    CREATIVE_FORMAT_IFRAME_ENUM[CREATIVE_FORMAT_IFRAME_ENUM["StandardVideoIframe"] = 102] = "StandardVideoIframe";
})($486acb05e5482e6a$var$CREATIVE_FORMAT_IFRAME_ENUM || (module.exports.CREATIVE_FORMAT_IFRAME_ENUM = $486acb05e5482e6a$var$CREATIVE_FORMAT_IFRAME_ENUM = {}));
var $486acb05e5482e6a$var$CREATIVE_DESTINATION_ENUM;
(function(CREATIVE_DESTINATION_ENUM) {
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["EntireCreative"] = 1] = "EntireCreative";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["MainAsset"] = 2] = "MainAsset";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["Description"] = 3] = "Description";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["Cta"] = 4] = "Cta";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["SocialLogo"] = 5] = "SocialLogo";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["WatchOnSocial"] = 6] = "WatchOnSocial";
})($486acb05e5482e6a$var$CREATIVE_DESTINATION_ENUM || (module.exports.CREATIVE_DESTINATION_ENUM = $486acb05e5482e6a$var$CREATIVE_DESTINATION_ENUM = {}));
var $486acb05e5482e6a$var$CREATIVE_SOCIAL_TYPE_ENUM;
(function(CREATIVE_SOCIAL_TYPE_ENUM) {
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Standard"] = 1] = "Standard";
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Social"] = 2] = "Social";
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Dynamic"] = 3] = "Dynamic";
})($486acb05e5482e6a$var$CREATIVE_SOCIAL_TYPE_ENUM || (module.exports.CREATIVE_SOCIAL_TYPE_ENUM = $486acb05e5482e6a$var$CREATIVE_SOCIAL_TYPE_ENUM = {}));
var $486acb05e5482e6a$var$THEME_ENUM;
(function(THEME_ENUM) {
    THEME_ENUM["v1"] = "v1";
    THEME_ENUM["v2"] = "v2";
})($486acb05e5482e6a$var$THEME_ENUM || (module.exports.THEME_ENUM = $486acb05e5482e6a$var$THEME_ENUM = {}));
var $486acb05e5482e6a$var$FONT_FAMILY_ENUM;
(function(FONT_FAMILY_ENUM) {
    FONT_FAMILY_ENUM["colfax"] = "Colfax";
    FONT_FAMILY_ENUM["poppins"] = "Poppins";
})($486acb05e5482e6a$var$FONT_FAMILY_ENUM || (module.exports.FONT_FAMILY_ENUM = $486acb05e5482e6a$var$FONT_FAMILY_ENUM = {}));
var $486acb05e5482e6a$var$PROJECT_ENUM;
(function(PROJECT_ENUM) {
    PROJECT_ENUM["composer"] = "composer";
    PROJECT_ENUM["pegasus"] = "pegasus";
})($486acb05e5482e6a$var$PROJECT_ENUM || (module.exports.PROJECT_ENUM = $486acb05e5482e6a$var$PROJECT_ENUM = {}));
var $486acb05e5482e6a$var$INPUT_VARIANT_ENUM;
(function(INPUT_VARIANT_ENUM) {
    INPUT_VARIANT_ENUM["standard"] = "standard";
    INPUT_VARIANT_ENUM["outlined"] = "outlined";
})($486acb05e5482e6a$var$INPUT_VARIANT_ENUM || (module.exports.INPUT_VARIANT_ENUM = $486acb05e5482e6a$var$INPUT_VARIANT_ENUM = {}));
var $486acb05e5482e6a$var$CSS_POS_ENUM;
(function(CSS_POS_ENUM) {
    CSS_POS_ENUM["fixed"] = "fixed";
    CSS_POS_ENUM["absolute"] = "absolute";
    CSS_POS_ENUM["relative"] = "relative";
    CSS_POS_ENUM["static"] = "static";
    CSS_POS_ENUM["sticky"] = "sticky";
})($486acb05e5482e6a$var$CSS_POS_ENUM || (module.exports.CSS_POS_ENUM = $486acb05e5482e6a$var$CSS_POS_ENUM = {}));
var $486acb05e5482e6a$var$TARGET_ENUM;
(function(TARGET_ENUM) {
    TARGET_ENUM["blank"] = "_blank";
    TARGET_ENUM["self"] = "_self";
})($486acb05e5482e6a$var$TARGET_ENUM || (module.exports.TARGET_ENUM = $486acb05e5482e6a$var$TARGET_ENUM = {}));
var $486acb05e5482e6a$var$DATA_UNIT_ENUM;
(function(DATA_UNIT_ENUM) {
    DATA_UNIT_ENUM["B"] = "B";
    DATA_UNIT_ENUM["KB"] = "KB";
    DATA_UNIT_ENUM["MB"] = "MB";
    DATA_UNIT_ENUM["GB"] = "GB";
    DATA_UNIT_ENUM["TB"] = "TB";
    DATA_UNIT_ENUM["PB"] = "PB";
})($486acb05e5482e6a$var$DATA_UNIT_ENUM || (module.exports.DATA_UNIT_ENUM = $486acb05e5482e6a$var$DATA_UNIT_ENUM = {}));
var $486acb05e5482e6a$var$BACKGROUND_ENUM;
(function(BACKGROUND_ENUM) {
    BACKGROUND_ENUM["white"] = "white";
    BACKGROUND_ENUM["black"] = "black";
    BACKGROUND_ENUM["blue"] = "blue";
})($486acb05e5482e6a$var$BACKGROUND_ENUM || (module.exports.BACKGROUND_ENUM = $486acb05e5482e6a$var$BACKGROUND_ENUM = {}));
var $486acb05e5482e6a$var$ADVANCED_CREATIVE_SIZES_ENUM;
(function(ADVANCED_CREATIVE_SIZES_ENUM) {
    // Middle Banner
    ADVANCED_CREATIVE_SIZES_ENUM["_320x250"] = "320x250";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x250"] = "390x250";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x250"] = "428x250";
    // Venti
    ADVANCED_CREATIVE_SIZES_ENUM["_320x460"] = "320x460";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x460"] = "390x460";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x460"] = "428x460";
    // Breakaway Initial and Runway
    ADVANCED_CREATIVE_SIZES_ENUM["_320x150"] = "320x150";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x150"] = "390x150";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x150"] = "428x150";
    // Breakaway Collapsed
    ADVANCED_CREATIVE_SIZES_ENUM["_130x150"] = "130x150";
})($486acb05e5482e6a$var$ADVANCED_CREATIVE_SIZES_ENUM || (module.exports.ADVANCED_CREATIVE_SIZES_ENUM = $486acb05e5482e6a$var$ADVANCED_CREATIVE_SIZES_ENUM = {}));
var $486acb05e5482e6a$var$FILE_TYPE_ENUM;
(function(FILE_TYPE_ENUM) {
    FILE_TYPE_ENUM["image"] = "image";
    FILE_TYPE_ENUM["video"] = "video";
    FILE_TYPE_ENUM["logo"] = "logo";
})($486acb05e5482e6a$var$FILE_TYPE_ENUM || (module.exports.FILE_TYPE_ENUM = $486acb05e5482e6a$var$FILE_TYPE_ENUM = {}));

});


parcelRegister("eYYk9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gu4OS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("58LUk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CREATIVE_FORMAT_BY_CREATIVE_EDITOR = module.exports.CREATIVE_CONFIG_BY_FORMAT = void 0;

var $6dtri = parcelRequire("6dtri");
// Deprecating CREATIVE_FORMATS v2.0.33,
module.exports.CREATIVE_CONFIG_BY_FORMAT = Object.freeze({
    [$6dtri.CREATIVE_FORMAT_ENUM.StandardBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.StandardBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-banner",
        title: "Standard Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-display-1",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.StandardVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.StandardVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-video",
        title: "Standard Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-video-1",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "logo-enhanced-banner",
        title: "Logo Enhanced Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-display-3",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "scroll-reactive-banner",
        title: "Scroll Reactive Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-display-2",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "scroll-reactive-video",
        title: "Scroll Reactive Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-video-2",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "adhesive-bottom-banner",
        title: "Adhesive Bottom Banner",
        resolution: "",
        cpc: true,
        viewability: true,
        engagement: false,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-adhesion-display-1",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "adhesive-side-banner",
        title: "Adhesive Side Banner",
        resolution: "",
        cpc: true,
        viewability: true,
        engagement: false,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-adhesion-display-2",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.IGStandardBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.IGStandardBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-standard-banner",
        title: "Instagram Standard Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-2",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.IGStandardVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.IGStandardVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-standard-video",
        title: "Instagram Standard Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-2",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-scroll-reactive-banner",
        title: "Instagram Scroll Reactive Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-1",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.IGCarousel]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.IGCarousel,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-carousel",
        title: "Instagram Carousel",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-carousel-1",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.FBCarousel]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.FBCarousel,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-carousel",
        title: "Facebook Carousel",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-carousel-2",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-scroll-reactive-video",
        title: "Instagram Scroll Reactive Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-1",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.FBStandardBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.FBStandardBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-standard-banner",
        title: "Facebook Standard Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-3",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.FBStandardVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.FBStandardVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-standard-video",
        title: "Facebook Standard Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-3",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-scroll-reactive-banner",
        title: "Facebook Scroll Reactive Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-4",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-scroll-reactive-video",
        title: "Facebook Scroll Reactive Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-4",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.TiktokVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.TiktokVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "tiktok-video",
        title: "Tiktok Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo,
            $6dtri.CREATIVE_DESTINATION_ENUM.WatchOnSocial
        ],
        templateId: "social-video-5",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.InstagramReelsVideo]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.InstagramReelsVideo,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "reels-video",
        title: "Reels Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.MainAsset,
            $6dtri.CREATIVE_DESTINATION_ENUM.Description,
            $6dtri.CREATIVE_DESTINATION_ENUM.Cta,
            $6dtri.CREATIVE_DESTINATION_ENUM.SocialLogo,
            $6dtri.CREATIVE_DESTINATION_ENUM.WatchOnSocial
        ],
        templateId: "social-video-5",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.MiddleBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.MiddleBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "middle-banner",
        title: "Middle Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [],
        templateId: "middle-banner-animated",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._320x250,
                width: 320,
                height: 250
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._390x250,
                width: 390,
                height: 250
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._428x250,
                width: 428,
                height: 250
            }
        ]
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Dynamic,
        id: "dynamic-scroll-reactive-banner",
        title: "Scroll Reactive Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "dynamic-scroll-reactive-banner",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.lite
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.Breakaway]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.Breakaway,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "breakaway",
        title: "Breakaway",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "breakaway",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._320x150,
                width: 320,
                height: 150
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._390x150,
                width: 390,
                height: 150
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._428x150,
                width: 428,
                height: 150
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._130x150,
                width: 130,
                height: 150,
                isCollapsed: true
            }
        ]
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.Runway]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.Runway,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "runway",
        title: "Runway",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [
            $6dtri.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "runway",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._320x150,
                width: 320,
                height: 150
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._390x150,
                width: 390,
                height: 150
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._428x150,
                width: 428,
                height: 150
            }
        ]
    },
    [$6dtri.CREATIVE_FORMAT_ENUM.Venti]: {
        type: $6dtri.CREATIVE_FORMAT_ENUM.Venti,
        socialType: $6dtri.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "venti",
        title: "Venti",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [],
        templateId: "venti-animated",
        creativeEditor: $6dtri.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._320x460,
                width: 320,
                height: 460
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._390x460,
                width: 390,
                height: 460
            },
            {
                label: $6dtri.ADVANCED_CREATIVE_SIZES_ENUM._428x460,
                width: 428,
                height: 460
            }
        ]
    }
});
module.exports.CREATIVE_FORMAT_BY_CREATIVE_EDITOR = {
    [$6dtri.CREATIVE_EDITOR_ENUM.lite]: [
        $6dtri.CREATIVE_FORMAT_ENUM.StandardBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.StandardVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.IGStandardBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.IGStandardVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.FBStandardBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.FBStandardVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.TiktokVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.InstagramReelsVideo,
        $6dtri.CREATIVE_FORMAT_ENUM.IGCarousel,
        $6dtri.CREATIVE_FORMAT_ENUM.FBCarousel,
        $6dtri.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner
    ],
    [$6dtri.CREATIVE_EDITOR_ENUM.advanced]: [
        $6dtri.CREATIVE_FORMAT_ENUM.MiddleBanner,
        $6dtri.CREATIVE_FORMAT_ENUM.Venti,
        $6dtri.CREATIVE_FORMAT_ENUM.Breakaway,
        $6dtri.CREATIVE_FORMAT_ENUM.Runway
    ]
};

});

parcelRegister("2mtV0", function(module, exports) {
"use strict";
var $1b84d8055b26a988$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1b84d8055b26a988$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compressImages = void 0;

const $1b84d8055b26a988$var$browser_image_compression_1 = $1b84d8055b26a988$var$__importDefault((parcelRequire("kcyGx")));

var $6dtri = parcelRequire("6dtri");
const $1b84d8055b26a988$var$compressImages = (files)=>$1b84d8055b26a988$var$__awaiter(void 0, void 0, void 0, function*() {
        if (files.every((file)=>file.type.includes($6dtri.FILE_TYPE_ENUM.video))) return files;
        const compressionPromises = [];
        const compressionOptions = {
            maxSizeMB: 0.2929,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        };
        try {
            const validBlobs = files.filter((file)=>file.type.includes($6dtri.FILE_TYPE_ENUM.image) && file instanceof Blob);
            if (validBlobs.length < 1) throw new Error("File(s) format unsupported!");
            validBlobs.forEach((blob)=>compressionPromises.push((0, $1b84d8055b26a988$var$browser_image_compression_1.default)(blob, compressionOptions)));
            const compressedBlobs = yield Promise.all(compressionPromises);
            return compressedBlobs;
        } catch (err) {
            console.log(err);
            return files;
        }
    });
module.exports.compressImages = $1b84d8055b26a988$var$compressImages;

});
parcelRegister("kcyGx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8225ba78123222c8$export$2e2bcd8739ae039);
/**
 * Browser Image Compression
 * v2.0.2
 * by Donald <donaldcwl@gmail.com>
 * https://github.com/Donaldcwl/browser-image-compression
 */ function $8225ba78123222c8$var$_mergeNamespaces(e, t1) {
    return t1.forEach(function(t1) {
        t1 && "string" != typeof t1 && !Array.isArray(t1) && Object.keys(t1).forEach(function(r) {
            if ("default" !== r && !(r in e)) {
                var i = Object.getOwnPropertyDescriptor(t1, r);
                Object.defineProperty(e, r, i.get ? i : {
                    enumerable: !0,
                    get: function() {
                        return t1[r];
                    }
                });
            }
        });
    }), Object.freeze(e);
}
function $8225ba78123222c8$var$copyExifWithoutOrientation(e, t1) {
    return new Promise(function(r, i) {
        let o;
        return $8225ba78123222c8$var$getApp1Segment(e).then(function(e) {
            try {
                return o = e, r(new Blob([
                    t1.slice(0, 2),
                    o,
                    t1.slice(2)
                ], {
                    type: "image/jpeg"
                }));
            } catch (e) {
                return i(e);
            }
        }, i);
    });
}
const $8225ba78123222c8$var$getApp1Segment = (e)=>new Promise((t1, r)=>{
        const i = new FileReader;
        i.addEventListener("load", ({ target: { result: e } })=>{
            const i = new DataView(e);
            let o = 0;
            if (65496 !== i.getUint16(o)) return r("not a valid JPEG");
            for(o += 2;;){
                const a = i.getUint16(o);
                if (65498 === a) break;
                const s = i.getUint16(o + 2);
                if (65505 === a && 1165519206 === i.getUint32(o + 4)) {
                    const a = o + 10;
                    let f;
                    switch(i.getUint16(a)){
                        case 18761:
                            f = !0;
                            break;
                        case 19789:
                            f = !1;
                            break;
                        default:
                            return r("TIFF header contains invalid endian");
                    }
                    if (42 !== i.getUint16(a + 2, f)) return r("TIFF header contains invalid version");
                    const l = i.getUint32(a + 4, f), c = a + l + 2 + 12 * i.getUint16(a + l, f);
                    for(let e = a + l + 2; e < c; e += 12)if (274 == i.getUint16(e, f)) {
                        if (3 !== i.getUint16(e + 2, f)) return r("Orientation data type is invalid");
                        if (1 !== i.getUint32(e + 4, f)) return r("Orientation data count is invalid");
                        i.setUint16(e + 8, 1, f);
                        break;
                    }
                    return t1(e.slice(o, o + 2 + s));
                }
                o += 2 + s;
            }
            return t1(new Blob);
        }), i.readAsArrayBuffer(e);
    });
var $8225ba78123222c8$var$e = {}, $8225ba78123222c8$var$t1 = {
    get exports () {
        return $8225ba78123222c8$var$e;
    },
    set exports (t){
        $8225ba78123222c8$var$e = t;
    }
};
!function(e) {
    var r, i, UZIP = {};
    $8225ba78123222c8$var$t1.exports = UZIP, UZIP.parse = function(e, t1) {
        for(var r = UZIP.bin.readUshort, i = UZIP.bin.readUint, o = 0, a = {}, s = new Uint8Array(e), f = s.length - 4; 101010256 != i(s, f);)f--;
        o = f;
        o += 4;
        var l = r(s, o += 4);
        r(s, o += 2);
        var c = i(s, o += 2), u = i(s, o += 4);
        o += 4, o = u;
        for(var h = 0; h < l; h++){
            i(s, o), o += 4, o += 4, o += 4, i(s, o += 4);
            c = i(s, o += 4);
            var d = i(s, o += 4), A = r(s, o += 4), g = r(s, o + 2), p = r(s, o + 4);
            o += 6;
            var m = i(s, o += 8);
            o += 4, o += A + g + p, UZIP._readLocal(s, m, a, c, d, t1);
        }
        return a;
    }, UZIP._readLocal = function(e, t1, r, i, o, a) {
        var s = UZIP.bin.readUshort, f = UZIP.bin.readUint;
        f(e, t1), s(e, t1 += 4), s(e, t1 += 2);
        var l = s(e, t1 += 2);
        f(e, t1 += 2), f(e, t1 += 4), t1 += 4;
        var c = s(e, t1 += 8), u = s(e, t1 += 2);
        t1 += 2;
        var h = UZIP.bin.readUTF8(e, t1, c);
        if (t1 += c, t1 += u, a) r[h] = {
            size: o,
            csize: i
        };
        else {
            var d = new Uint8Array(e.buffer, t1);
            if (0 == l) r[h] = new Uint8Array(d.buffer.slice(t1, t1 + i));
            else {
                if (8 != l) throw "unknown compression method: " + l;
                var A = new Uint8Array(o);
                UZIP.inflateRaw(d, A), r[h] = A;
            }
        }
    }, UZIP.inflateRaw = function(e, t1) {
        return UZIP.F.inflate(e, t1);
    }, UZIP.inflate = function(e, t1) {
        return e[0], e[1], UZIP.inflateRaw(new Uint8Array(e.buffer, e.byteOffset + 2, e.length - 6), t1);
    }, UZIP.deflate = function(e, t1) {
        null == t1 && (t1 = {
            level: 6
        });
        var r = 0, i = new Uint8Array(50 + Math.floor(1.1 * e.length));
        i[r] = 120, i[r + 1] = 156, r += 2, r = UZIP.F.deflateRaw(e, i, r, t1.level);
        var o = UZIP.adler(e, 0, e.length);
        return i[r + 0] = o >>> 24 & 255, i[r + 1] = o >>> 16 & 255, i[r + 2] = o >>> 8 & 255, i[r + 3] = o >>> 0 & 255, new Uint8Array(i.buffer, 0, r + 4);
    }, UZIP.deflateRaw = function(e, t1) {
        null == t1 && (t1 = {
            level: 6
        });
        var r = new Uint8Array(50 + Math.floor(1.1 * e.length)), i = UZIP.F.deflateRaw(e, r, i, t1.level);
        return new Uint8Array(r.buffer, 0, i);
    }, UZIP.encode = function(e, t1) {
        null == t1 && (t1 = !1);
        var r = 0, i = UZIP.bin.writeUint, o = UZIP.bin.writeUshort, a = {};
        for(var s in e){
            var f = !UZIP._noNeed(s) && !t1, l = e[s], c = UZIP.crc.crc(l, 0, l.length);
            a[s] = {
                cpr: f,
                usize: l.length,
                crc: c,
                file: f ? UZIP.deflateRaw(l) : l
            };
        }
        for(var s in a)r += a[s].file.length + 30 + 46 + 2 * UZIP.bin.sizeUTF8(s);
        r += 22;
        var u = new Uint8Array(r), h = 0, d = [];
        for(var s in a){
            var A = a[s];
            d.push(h), h = UZIP._writeHeader(u, h, s, A, 0);
        }
        var g = 0, p = h;
        for(var s in a){
            A = a[s];
            d.push(h), h = UZIP._writeHeader(u, h, s, A, 1, d[g++]);
        }
        var m = h - p;
        return i(u, h, 101010256), h += 4, o(u, h += 4, g), o(u, h += 2, g), i(u, h += 2, m), i(u, h += 4, p), h += 4, h += 2, u.buffer;
    }, UZIP._noNeed = function(e) {
        var t1 = e.split(".").pop().toLowerCase();
        return -1 != "png,jpg,jpeg,zip".indexOf(t1);
    }, UZIP._writeHeader = function(e, t1, r, i, o, a) {
        var s = UZIP.bin.writeUint, f = UZIP.bin.writeUshort, l = i.file;
        return s(e, t1, 0 == o ? 67324752 : 33639248), t1 += 4, 1 == o && (t1 += 2), f(e, t1, 20), f(e, t1 += 2, 0), f(e, t1 += 2, i.cpr ? 8 : 0), s(e, t1 += 2, 0), s(e, t1 += 4, i.crc), s(e, t1 += 4, l.length), s(e, t1 += 4, i.usize), f(e, t1 += 4, UZIP.bin.sizeUTF8(r)), f(e, t1 += 2, 0), t1 += 2, 1 == o && (t1 += 2, t1 += 2, s(e, t1 += 6, a), t1 += 4), t1 += UZIP.bin.writeUTF8(e, t1, r), 0 == o && (e.set(l, t1), t1 += l.length), t1;
    }, UZIP.crc = {
        table: function() {
            for(var e = new Uint32Array(256), t1 = 0; t1 < 256; t1++){
                for(var r = t1, i = 0; i < 8; i++)1 & r ? r = 3988292384 ^ r >>> 1 : r >>>= 1;
                e[t1] = r;
            }
            return e;
        }(),
        update: function(e, t1, r, i) {
            for(var o = 0; o < i; o++)e = UZIP.crc.table[255 & (e ^ t1[r + o])] ^ e >>> 8;
            return e;
        },
        crc: function(e, t1, r) {
            return 4294967295 ^ UZIP.crc.update(4294967295, e, t1, r);
        }
    }, UZIP.adler = function(e, t1, r) {
        for(var i = 1, o = 0, a = t1, s = t1 + r; a < s;){
            for(var f = Math.min(a + 5552, s); a < f;)o += i += e[a++];
            i %= 65521, o %= 65521;
        }
        return o << 16 | i;
    }, UZIP.bin = {
        readUshort: function(e, t1) {
            return e[t1] | e[t1 + 1] << 8;
        },
        writeUshort: function(e, t1, r) {
            e[t1] = 255 & r, e[t1 + 1] = r >> 8 & 255;
        },
        readUint: function(e, t1) {
            return 16777216 * e[t1 + 3] + (e[t1 + 2] << 16 | e[t1 + 1] << 8 | e[t1]);
        },
        writeUint: function(e, t1, r) {
            e[t1] = 255 & r, e[t1 + 1] = r >> 8 & 255, e[t1 + 2] = r >> 16 & 255, e[t1 + 3] = r >> 24 & 255;
        },
        readASCII: function(e, t1, r) {
            for(var i = "", o = 0; o < r; o++)i += String.fromCharCode(e[t1 + o]);
            return i;
        },
        writeASCII: function(e, t1, r) {
            for(var i = 0; i < r.length; i++)e[t1 + i] = r.charCodeAt(i);
        },
        pad: function(e) {
            return e.length < 2 ? "0" + e : e;
        },
        readUTF8: function(e, t1, r) {
            for(var i, o = "", a = 0; a < r; a++)o += "%" + UZIP.bin.pad(e[t1 + a].toString(16));
            try {
                i = decodeURIComponent(o);
            } catch (i) {
                return UZIP.bin.readASCII(e, t1, r);
            }
            return i;
        },
        writeUTF8: function(e, t1, r) {
            for(var i = r.length, o = 0, a = 0; a < i; a++){
                var s = r.charCodeAt(a);
                if (0 == (4294967168 & s)) e[t1 + o] = s, o++;
                else if (0 == (4294965248 & s)) e[t1 + o] = 192 | s >> 6, e[t1 + o + 1] = 128 | s >> 0 & 63, o += 2;
                else if (0 == (4294901760 & s)) e[t1 + o] = 224 | s >> 12, e[t1 + o + 1] = 128 | s >> 6 & 63, e[t1 + o + 2] = 128 | s >> 0 & 63, o += 3;
                else {
                    if (0 != (4292870144 & s)) throw "e";
                    e[t1 + o] = 240 | s >> 18, e[t1 + o + 1] = 128 | s >> 12 & 63, e[t1 + o + 2] = 128 | s >> 6 & 63, e[t1 + o + 3] = 128 | s >> 0 & 63, o += 4;
                }
            }
            return o;
        },
        sizeUTF8: function(e) {
            for(var t1 = e.length, r = 0, i = 0; i < t1; i++){
                var o = e.charCodeAt(i);
                if (0 == (4294967168 & o)) r++;
                else if (0 == (4294965248 & o)) r += 2;
                else if (0 == (4294901760 & o)) r += 3;
                else {
                    if (0 != (4292870144 & o)) throw "e";
                    r += 4;
                }
            }
            return r;
        }
    }, UZIP.F = {}, UZIP.F.deflateRaw = function(e, t1, r, i) {
        var o = [
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                4,
                4,
                8,
                4,
                0
            ],
            [
                4,
                5,
                16,
                8,
                0
            ],
            [
                4,
                6,
                16,
                16,
                0
            ],
            [
                4,
                10,
                16,
                32,
                0
            ],
            [
                8,
                16,
                32,
                32,
                0
            ],
            [
                8,
                16,
                128,
                128,
                0
            ],
            [
                8,
                32,
                128,
                256,
                0
            ],
            [
                32,
                128,
                258,
                1024,
                1
            ],
            [
                32,
                258,
                258,
                4096,
                1
            ]
        ][i], a = UZIP.F.U, s = UZIP.F._goodIndex;
        UZIP.F._hash;
        var f = UZIP.F._putsE, l = 0, c = r << 3, u = 0, h = e.length;
        if (0 == i) {
            for(; l < h;)f(t1, c, l + (_ = Math.min(65535, h - l)) == h ? 1 : 0), c = UZIP.F._copyExact(e, l, _, t1, c + 8), l += _;
            return c >>> 3;
        }
        var d = a.lits, A = a.strt, g = a.prev, p = 0, m = 0, w = 0, v = 0, b = 0, y = 0;
        for(h > 2 && (A[y = UZIP.F._hash(e, 0)] = 0), l = 0; l < h; l++){
            if (b = y, l + 1 < h - 2) {
                y = UZIP.F._hash(e, l + 1);
                var E = l + 1 & 32767;
                g[E] = A[y], A[y] = E;
            }
            if (u <= l) {
                (p > 14e3 || m > 26697) && h - l > 100 && (u < l && (d[p] = l - u, p += 2, u = l), c = UZIP.F._writeBlock(l == h - 1 || u == h ? 1 : 0, d, p, v, e, w, l - w, t1, c), p = m = v = 0, w = l);
                var F = 0;
                l < h - 2 && (F = UZIP.F._bestMatch(e, l, g, b, Math.min(o[2], h - l), o[3]));
                var _ = F >>> 16, B = 65535 & F;
                if (0 != F) {
                    B = 65535 & F;
                    var U = s(_ = F >>> 16, a.of0);
                    a.lhst[257 + U]++;
                    var C = s(B, a.df0);
                    a.dhst[C]++, v += a.exb[U] + a.dxb[C], d[p] = _ << 23 | l - u, d[p + 1] = B << 16 | U << 8 | C, p += 2, u = l + _;
                } else a.lhst[e[l]]++;
                m++;
            }
        }
        for(w == l && 0 != e.length || (u < l && (d[p] = l - u, p += 2, u = l), c = UZIP.F._writeBlock(1, d, p, v, e, w, l - w, t1, c), p = 0, m = 0, p = m = v = 0, w = l); 0 != (7 & c);)c++;
        return c >>> 3;
    }, UZIP.F._bestMatch = function(e, t1, r, i, o, a) {
        var s = 32767 & t1, f = r[s], l = s - f + 32768 & 32767;
        if (f == s || i != UZIP.F._hash(e, t1 - l)) return 0;
        for(var c = 0, u = 0, h = Math.min(32767, t1); l <= h && 0 != --a && f != s;){
            if (0 == c || e[t1 + c] == e[t1 + c - l]) {
                var d = UZIP.F._howLong(e, t1, l);
                if (d > c) {
                    if (u = l, (c = d) >= o) break;
                    l + 2 < d && (d = l + 2);
                    for(var A = 0, g = 0; g < d - 2; g++){
                        var p = t1 - l + g + 32768 & 32767, m = p - r[p] + 32768 & 32767;
                        m > A && (A = m, f = p);
                    }
                }
            }
            l += (s = f) - (f = r[s]) + 32768 & 32767;
        }
        return c << 16 | u;
    }, UZIP.F._howLong = function(e, t1, r) {
        if (e[t1] != e[t1 - r] || e[t1 + 1] != e[t1 + 1 - r] || e[t1 + 2] != e[t1 + 2 - r]) return 0;
        var i = t1, o = Math.min(e.length, t1 + 258);
        for(t1 += 3; t1 < o && e[t1] == e[t1 - r];)t1++;
        return t1 - i;
    }, UZIP.F._hash = function(e, t1) {
        return (e[t1] << 8 | e[t1 + 1]) + (e[t1 + 2] << 4) & 65535;
    }, UZIP.saved = 0, UZIP.F._writeBlock = function(e, t1, r, i, o, a, s, f, l) {
        var c, u, h, d, A, g, p, m, w, v = UZIP.F.U, b = UZIP.F._putsF, y = UZIP.F._putsE;
        v.lhst[256]++, u = (c = UZIP.F.getTrees())[0], h = c[1], d = c[2], A = c[3], g = c[4], p = c[5], m = c[6], w = c[7];
        var E = 32 + (0 == (l + 3 & 7) ? 0 : 8 - (l + 3 & 7)) + (s << 3), F = i + UZIP.F.contSize(v.fltree, v.lhst) + UZIP.F.contSize(v.fdtree, v.dhst), _ = i + UZIP.F.contSize(v.ltree, v.lhst) + UZIP.F.contSize(v.dtree, v.dhst);
        _ += 14 + 3 * p + UZIP.F.contSize(v.itree, v.ihst) + (2 * v.ihst[16] + 3 * v.ihst[17] + 7 * v.ihst[18]);
        for(var B = 0; B < 286; B++)v.lhst[B] = 0;
        for(B = 0; B < 30; B++)v.dhst[B] = 0;
        for(B = 0; B < 19; B++)v.ihst[B] = 0;
        var U = E < F && E < _ ? 0 : F < _ ? 1 : 2;
        if (b(f, l, e), b(f, l + 1, U), l += 3, 0 == U) {
            for(; 0 != (7 & l);)l++;
            l = UZIP.F._copyExact(o, a, s, f, l);
        } else {
            var C, I;
            if (1 == U && (C = v.fltree, I = v.fdtree), 2 == U) {
                UZIP.F.makeCodes(v.ltree, u), UZIP.F.revCodes(v.ltree, u), UZIP.F.makeCodes(v.dtree, h), UZIP.F.revCodes(v.dtree, h), UZIP.F.makeCodes(v.itree, d), UZIP.F.revCodes(v.itree, d), C = v.ltree, I = v.dtree, y(f, l, A - 257), y(f, l += 5, g - 1), y(f, l += 5, p - 4), l += 4;
                for(var Q = 0; Q < p; Q++)y(f, l + 3 * Q, v.itree[1 + (v.ordr[Q] << 1)]);
                l += 3 * p, l = UZIP.F._codeTiny(m, v.itree, f, l), l = UZIP.F._codeTiny(w, v.itree, f, l);
            }
            for(var M = a, x = 0; x < r; x += 2){
                for(var S = t1[x], R = S >>> 23, T = M + (8388607 & S); M < T;)l = UZIP.F._writeLit(o[M++], C, f, l);
                if (0 != R) {
                    var O = t1[x + 1], P = O >> 16, H = O >> 8 & 255, L = 255 & O;
                    y(f, l = UZIP.F._writeLit(257 + H, C, f, l), R - v.of0[H]), l += v.exb[H], b(f, l = UZIP.F._writeLit(L, I, f, l), P - v.df0[L]), l += v.dxb[L], M += R;
                }
            }
            l = UZIP.F._writeLit(256, C, f, l);
        }
        return l;
    }, UZIP.F._copyExact = function(e, t1, r, i, o) {
        var a = o >>> 3;
        return i[a] = r, i[a + 1] = r >>> 8, i[a + 2] = 255 - i[a], i[a + 3] = 255 - i[a + 1], a += 4, i.set(new Uint8Array(e.buffer, t1, r), a), o + (r + 4 << 3);
    }, UZIP.F.getTrees = function() {
        for(var e = UZIP.F.U, t1 = UZIP.F._hufTree(e.lhst, e.ltree, 15), r = UZIP.F._hufTree(e.dhst, e.dtree, 15), i = [], o = UZIP.F._lenCodes(e.ltree, i), a = [], s = UZIP.F._lenCodes(e.dtree, a), f = 0; f < i.length; f += 2)e.ihst[i[f]]++;
        for(f = 0; f < a.length; f += 2)e.ihst[a[f]]++;
        for(var l = UZIP.F._hufTree(e.ihst, e.itree, 7), c = 19; c > 4 && 0 == e.itree[1 + (e.ordr[c - 1] << 1)];)c--;
        return [
            t1,
            r,
            l,
            o,
            s,
            c,
            i,
            a
        ];
    }, UZIP.F.getSecond = function(e) {
        for(var t1 = [], r = 0; r < e.length; r += 2)t1.push(e[r + 1]);
        return t1;
    }, UZIP.F.nonZero = function(e) {
        for(var t1 = "", r = 0; r < e.length; r += 2)0 != e[r + 1] && (t1 += (r >> 1) + ",");
        return t1;
    }, UZIP.F.contSize = function(e, t1) {
        for(var r = 0, i = 0; i < t1.length; i++)r += t1[i] * e[1 + (i << 1)];
        return r;
    }, UZIP.F._codeTiny = function(e, t1, r, i) {
        for(var o = 0; o < e.length; o += 2){
            var a = e[o], s = e[o + 1];
            i = UZIP.F._writeLit(a, t1, r, i);
            var f = 16 == a ? 2 : 17 == a ? 3 : 7;
            a > 15 && (UZIP.F._putsE(r, i, s, f), i += f);
        }
        return i;
    }, UZIP.F._lenCodes = function(e, t1) {
        for(var r = e.length; 2 != r && 0 == e[r - 1];)r -= 2;
        for(var i = 0; i < r; i += 2){
            var o = e[i + 1], a = i + 3 < r ? e[i + 3] : -1, s = i + 5 < r ? e[i + 5] : -1, f = 0 == i ? -1 : e[i - 1];
            if (0 == o && a == o && s == o) {
                for(var l = i + 5; l + 2 < r && e[l + 2] == o;)l += 2;
                (c = Math.min(l + 1 - i >>> 1, 138)) < 11 ? t1.push(17, c - 3) : t1.push(18, c - 11), i += 2 * c - 2;
            } else if (o == f && a == o && s == o) {
                for(l = i + 5; l + 2 < r && e[l + 2] == o;)l += 2;
                var c = Math.min(l + 1 - i >>> 1, 6);
                t1.push(16, c - 3), i += 2 * c - 2;
            } else t1.push(o, 0);
        }
        return r >>> 1;
    }, UZIP.F._hufTree = function(e, t1, r) {
        var i = [], o = e.length, a = t1.length, s = 0;
        for(s = 0; s < a; s += 2)t1[s] = 0, t1[s + 1] = 0;
        for(s = 0; s < o; s++)0 != e[s] && i.push({
            lit: s,
            f: e[s]
        });
        var f = i.length, l = i.slice(0);
        if (0 == f) return 0;
        if (1 == f) {
            var c = i[0].lit;
            l = 0 == c ? 1 : 0;
            return t1[1 + (c << 1)] = 1, t1[1 + (l << 1)] = 1, 1;
        }
        i.sort(function(e, t1) {
            return e.f - t1.f;
        });
        var u = i[0], h = i[1], d = 0, A = 1, g = 2;
        for(i[0] = {
            lit: -1,
            f: u.f + h.f,
            l: u,
            r: h,
            d: 0
        }; A != f - 1;)u = d != A && (g == f || i[d].f < i[g].f) ? i[d++] : i[g++], h = d != A && (g == f || i[d].f < i[g].f) ? i[d++] : i[g++], i[A++] = {
            lit: -1,
            f: u.f + h.f,
            l: u,
            r: h
        };
        var p = UZIP.F.setDepth(i[A - 1], 0);
        for(p > r && (UZIP.F.restrictDepth(l, r, p), p = r), s = 0; s < f; s++)t1[1 + (l[s].lit << 1)] = l[s].d;
        return p;
    }, UZIP.F.setDepth = function(e, t1) {
        return -1 != e.lit ? (e.d = t1, t1) : Math.max(UZIP.F.setDepth(e.l, t1 + 1), UZIP.F.setDepth(e.r, t1 + 1));
    }, UZIP.F.restrictDepth = function(e, t1, r) {
        var i = 0, o = 1 << r - t1, a = 0;
        for(e.sort(function(e, t1) {
            return t1.d == e.d ? e.f - t1.f : t1.d - e.d;
        }), i = 0; i < e.length && e[i].d > t1; i++){
            var s = e[i].d;
            e[i].d = t1, a += o - (1 << r - s);
        }
        for(a >>>= r - t1; a > 0;)(s = e[i].d) < t1 ? (e[i].d++, a -= 1 << t1 - s - 1) : i++;
        for(; i >= 0; i--)e[i].d == t1 && a < 0 && (e[i].d--, a++);
        0 != a && console.log("debt left");
    }, UZIP.F._goodIndex = function(e, t1) {
        var r = 0;
        return t1[16 | r] <= e && (r |= 16), t1[8 | r] <= e && (r |= 8), t1[4 | r] <= e && (r |= 4), t1[2 | r] <= e && (r |= 2), t1[1 | r] <= e && (r |= 1), r;
    }, UZIP.F._writeLit = function(e, t1, r, i) {
        return UZIP.F._putsF(r, i, t1[e << 1]), i + t1[1 + (e << 1)];
    }, UZIP.F.inflate = function(e, t1) {
        var r = Uint8Array;
        if (3 == e[0] && 0 == e[1]) return t1 || new r(0);
        var i = UZIP.F, o = i._bitsF, a = i._bitsE, s = i._decodeTiny, f = i.makeCodes, l = i.codes2map, c = i._get17, u = i.U, h = null == t1;
        h && (t1 = new r(e.length >>> 2 << 3));
        for(var d, A, g = 0, p = 0, m = 0, w = 0, v = 0, b = 0, y = 0, E = 0, F = 0; 0 == g;)if (g = o(e, F, 1), p = o(e, F + 1, 2), F += 3, 0 != p) {
            if (h && (t1 = UZIP.F._check(t1, E + 131072)), 1 == p && (d = u.flmap, A = u.fdmap, b = 511, y = 31), 2 == p) {
                m = a(e, F, 5) + 257, w = a(e, F + 5, 5) + 1, v = a(e, F + 10, 4) + 4, F += 14;
                for(var _ = 0; _ < 38; _ += 2)u.itree[_] = 0, u.itree[_ + 1] = 0;
                var B = 1;
                for(_ = 0; _ < v; _++){
                    var U = a(e, F + 3 * _, 3);
                    u.itree[1 + (u.ordr[_] << 1)] = U, U > B && (B = U);
                }
                F += 3 * v, f(u.itree, B), l(u.itree, B, u.imap), d = u.lmap, A = u.dmap, F = s(u.imap, (1 << B) - 1, m + w, e, F, u.ttree);
                var C = i._copyOut(u.ttree, 0, m, u.ltree);
                b = (1 << C) - 1;
                var I = i._copyOut(u.ttree, m, w, u.dtree);
                y = (1 << I) - 1, f(u.ltree, C), l(u.ltree, C, d), f(u.dtree, I), l(u.dtree, I, A);
            }
            for(;;){
                var Q = d[c(e, F) & b];
                F += 15 & Q;
                var M = Q >>> 4;
                if (M >>> 8 == 0) t1[E++] = M;
                else {
                    if (256 == M) break;
                    var x = E + M - 254;
                    if (M > 264) {
                        var S = u.ldef[M - 257];
                        x = E + (S >>> 3) + a(e, F, 7 & S), F += 7 & S;
                    }
                    var R = A[c(e, F) & y];
                    F += 15 & R;
                    var T = R >>> 4, O = u.ddef[T], P = (O >>> 4) + o(e, F, 15 & O);
                    for(F += 15 & O, h && (t1 = UZIP.F._check(t1, E + 131072)); E < x;)t1[E] = t1[E++ - P], t1[E] = t1[E++ - P], t1[E] = t1[E++ - P], t1[E] = t1[E++ - P];
                    E = x;
                }
            }
        } else {
            0 != (7 & F) && (F += 8 - (7 & F));
            var H = 4 + (F >>> 3), L = e[H - 4] | e[H - 3] << 8;
            h && (t1 = UZIP.F._check(t1, E + L)), t1.set(new r(e.buffer, e.byteOffset + H, L), E), F = H + L << 3, E += L;
        }
        return t1.length == E ? t1 : t1.slice(0, E);
    }, UZIP.F._check = function(e, t1) {
        var r = e.length;
        if (t1 <= r) return e;
        var i = new Uint8Array(Math.max(r << 1, t1));
        return i.set(e, 0), i;
    }, UZIP.F._decodeTiny = function(e, t1, r, i, o, a) {
        for(var s = UZIP.F._bitsE, f = UZIP.F._get17, l = 0; l < r;){
            var c = e[f(i, o) & t1];
            o += 15 & c;
            var u = c >>> 4;
            if (u <= 15) a[l] = u, l++;
            else {
                var h = 0, d = 0;
                16 == u ? (d = 3 + s(i, o, 2), o += 2, h = a[l - 1]) : 17 == u ? (d = 3 + s(i, o, 3), o += 3) : 18 == u && (d = 11 + s(i, o, 7), o += 7);
                for(var A = l + d; l < A;)a[l] = h, l++;
            }
        }
        return o;
    }, UZIP.F._copyOut = function(e, t1, r, i) {
        for(var o = 0, a = 0, s = i.length >>> 1; a < r;){
            var f = e[a + t1];
            i[a << 1] = 0, i[1 + (a << 1)] = f, f > o && (o = f), a++;
        }
        for(; a < s;)i[a << 1] = 0, i[1 + (a << 1)] = 0, a++;
        return o;
    }, UZIP.F.makeCodes = function(e, t1) {
        for(var r, i, o, a, s = UZIP.F.U, f = e.length, l = s.bl_count, c = 0; c <= t1; c++)l[c] = 0;
        for(c = 1; c < f; c += 2)l[e[c]]++;
        var u = s.next_code;
        for(r = 0, l[0] = 0, i = 1; i <= t1; i++)r = r + l[i - 1] << 1, u[i] = r;
        for(o = 0; o < f; o += 2)0 != (a = e[o + 1]) && (e[o] = u[a], u[a]++);
    }, UZIP.F.codes2map = function(e, t1, r) {
        for(var i = e.length, o = UZIP.F.U.rev15, a = 0; a < i; a += 2)if (0 != e[a + 1]) for(var s = a >> 1, f = e[a + 1], l = s << 4 | f, c = t1 - f, u = e[a] << c, h = u + (1 << c); u != h;)r[o[u] >>> 15 - t1] = l, u++;
    }, UZIP.F.revCodes = function(e, t1) {
        for(var r = UZIP.F.U.rev15, i = 15 - t1, o = 0; o < e.length; o += 2){
            var a = e[o] << t1 - e[o + 1];
            e[o] = r[a] >>> i;
        }
    }, UZIP.F._putsE = function(e, t1, r) {
        r <<= 7 & t1;
        var i = t1 >>> 3;
        e[i] |= r, e[i + 1] |= r >>> 8;
    }, UZIP.F._putsF = function(e, t1, r) {
        r <<= 7 & t1;
        var i = t1 >>> 3;
        e[i] |= r, e[i + 1] |= r >>> 8, e[i + 2] |= r >>> 16;
    }, UZIP.F._bitsE = function(e, t1, r) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8) >>> (7 & t1) & (1 << r) - 1;
    }, UZIP.F._bitsF = function(e, t1, r) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1) & (1 << r) - 1;
    }, UZIP.F._get17 = function(e, t1) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1);
    }, UZIP.F._get25 = function(e, t1) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16 | e[3 + (t1 >>> 3)] << 24) >>> (7 & t1);
    }, UZIP.F.U = (r = Uint16Array, i = Uint32Array, {
        next_code: new r(16),
        bl_count: new r(16),
        ordr: [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ],
        of0: [
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            13,
            15,
            17,
            19,
            23,
            27,
            31,
            35,
            43,
            51,
            59,
            67,
            83,
            99,
            115,
            131,
            163,
            195,
            227,
            258,
            999,
            999,
            999
        ],
        exb: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ],
        ldef: new r(32),
        df0: [
            1,
            2,
            3,
            4,
            5,
            7,
            9,
            13,
            17,
            25,
            33,
            49,
            65,
            97,
            129,
            193,
            257,
            385,
            513,
            769,
            1025,
            1537,
            2049,
            3073,
            4097,
            6145,
            8193,
            12289,
            16385,
            24577,
            65535,
            65535
        ],
        dxb: [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ],
        ddef: new i(32),
        flmap: new r(512),
        fltree: [],
        fdmap: new r(32),
        fdtree: [],
        lmap: new r(32768),
        ltree: [],
        ttree: [],
        dmap: new r(32768),
        dtree: [],
        imap: new r(512),
        itree: [],
        rev15: new r(32768),
        lhst: new i(286),
        dhst: new i(30),
        ihst: new i(19),
        lits: new i(15e3),
        strt: new r(65536),
        prev: new r(32768)
    }), function() {
        for(var e = UZIP.F.U, t1 = 0; t1 < 32768; t1++){
            var r = t1;
            r = (4278255360 & (r = (4042322160 & (r = (3435973836 & (r = (2863311530 & r) >>> 1 | (1431655765 & r) << 1)) >>> 2 | (858993459 & r) << 2)) >>> 4 | (252645135 & r) << 4)) >>> 8 | (16711935 & r) << 8, e.rev15[t1] = (r >>> 16 | r << 16) >>> 17;
        }
        function pushV(e, t1, r) {
            for(; 0 != t1--;)e.push(0, r);
        }
        for(t1 = 0; t1 < 32; t1++)e.ldef[t1] = e.of0[t1] << 3 | e.exb[t1], e.ddef[t1] = e.df0[t1] << 4 | e.dxb[t1];
        pushV(e.fltree, 144, 8), pushV(e.fltree, 112, 9), pushV(e.fltree, 24, 7), pushV(e.fltree, 8, 8), UZIP.F.makeCodes(e.fltree, 9), UZIP.F.codes2map(e.fltree, 9, e.flmap), UZIP.F.revCodes(e.fltree, 9), pushV(e.fdtree, 32, 5), UZIP.F.makeCodes(e.fdtree, 5), UZIP.F.codes2map(e.fdtree, 5, e.fdmap), UZIP.F.revCodes(e.fdtree, 5), pushV(e.itree, 19, 0), pushV(e.ltree, 286, 0), pushV(e.dtree, 30, 0), pushV(e.ttree, 320, 0);
    }();
}();
var $8225ba78123222c8$var$UZIP = $8225ba78123222c8$var$_mergeNamespaces({
    __proto__: null,
    default: $8225ba78123222c8$var$e
}, [
    $8225ba78123222c8$var$e
]);
const $8225ba78123222c8$var$UPNG = function() {
    var e = {
        nextZero (e, t1) {
            for(; 0 != e[t1];)t1++;
            return t1;
        },
        readUshort: (e, t1)=>e[t1] << 8 | e[t1 + 1],
        writeUshort (e, t1, r) {
            e[t1] = r >> 8 & 255, e[t1 + 1] = 255 & r;
        },
        readUint: (e, t1)=>16777216 * e[t1] + (e[t1 + 1] << 16 | e[t1 + 2] << 8 | e[t1 + 3]),
        writeUint (e, t1, r) {
            e[t1] = r >> 24 & 255, e[t1 + 1] = r >> 16 & 255, e[t1 + 2] = r >> 8 & 255, e[t1 + 3] = 255 & r;
        },
        readASCII (e, t1, r) {
            let i = "";
            for(let o = 0; o < r; o++)i += String.fromCharCode(e[t1 + o]);
            return i;
        },
        writeASCII (e, t1, r) {
            for(let i = 0; i < r.length; i++)e[t1 + i] = r.charCodeAt(i);
        },
        readBytes (e, t1, r) {
            const i = [];
            for(let o = 0; o < r; o++)i.push(e[t1 + o]);
            return i;
        },
        pad: (e)=>e.length < 2 ? `0${e}` : e,
        readUTF8 (t1, r, i) {
            let o, a = "";
            for(let o = 0; o < i; o++)a += `%${e.pad(t1[r + o].toString(16))}`;
            try {
                o = decodeURIComponent(a);
            } catch (o) {
                return e.readASCII(t1, r, i);
            }
            return o;
        }
    };
    function decodeImage(t1, r, i, o) {
        const a = r * i, s = _getBPP(o), f = Math.ceil(r * s / 8), l = new Uint8Array(4 * a), c = new Uint32Array(l.buffer), { ctype: u } = o, { depth: h } = o, d = e.readUshort;
        if (6 == u) {
            const e = a << 2;
            if (8 == h) for(var A = 0; A < e; A += 4)l[A] = t1[A], l[A + 1] = t1[A + 1], l[A + 2] = t1[A + 2], l[A + 3] = t1[A + 3];
            if (16 == h) for(A = 0; A < e; A++)l[A] = t1[A << 1];
        } else if (2 == u) {
            const e = o.tabs.tRNS;
            if (null == e) {
                if (8 == h) for(A = 0; A < a; A++){
                    var g = 3 * A;
                    c[A] = -16777216 | t1[g + 2] << 16 | t1[g + 1] << 8 | t1[g];
                }
                if (16 == h) for(A = 0; A < a; A++){
                    g = 6 * A;
                    c[A] = -16777216 | t1[g + 4] << 16 | t1[g + 2] << 8 | t1[g];
                }
            } else {
                var p = e[0];
                const r = e[1], i = e[2];
                if (8 == h) for(A = 0; A < a; A++){
                    var m = A << 2;
                    g = 3 * A;
                    c[A] = -16777216 | t1[g + 2] << 16 | t1[g + 1] << 8 | t1[g], t1[g] == p && t1[g + 1] == r && t1[g + 2] == i && (l[m + 3] = 0);
                }
                if (16 == h) for(A = 0; A < a; A++){
                    m = A << 2, g = 6 * A;
                    c[A] = -16777216 | t1[g + 4] << 16 | t1[g + 2] << 8 | t1[g], d(t1, g) == p && d(t1, g + 2) == r && d(t1, g + 4) == i && (l[m + 3] = 0);
                }
            }
        } else if (3 == u) {
            const e = o.tabs.PLTE, s = o.tabs.tRNS, c = s ? s.length : 0;
            if (1 == h) for(var w = 0; w < i; w++){
                var v = w * f, b = w * r;
                for(A = 0; A < r; A++){
                    m = b + A << 2;
                    var y = 3 * (E = t1[v + (A >> 3)] >> 7 - ((7 & A) << 0) & 1);
                    l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
                }
            }
            if (2 == h) for(w = 0; w < i; w++)for(v = w * f, b = w * r, A = 0; A < r; A++){
                m = b + A << 2, y = 3 * (E = t1[v + (A >> 2)] >> 6 - ((3 & A) << 1) & 3);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
            if (4 == h) for(w = 0; w < i; w++)for(v = w * f, b = w * r, A = 0; A < r; A++){
                m = b + A << 2, y = 3 * (E = t1[v + (A >> 1)] >> 4 - ((1 & A) << 2) & 15);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
            if (8 == h) for(A = 0; A < a; A++){
                var E;
                m = A << 2, y = 3 * (E = t1[A]);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
        } else if (4 == u) {
            if (8 == h) for(A = 0; A < a; A++){
                m = A << 2;
                var F = t1[_ = A << 1];
                l[m] = F, l[m + 1] = F, l[m + 2] = F, l[m + 3] = t1[_ + 1];
            }
            if (16 == h) for(A = 0; A < a; A++){
                var _;
                m = A << 2, F = t1[_ = A << 2];
                l[m] = F, l[m + 1] = F, l[m + 2] = F, l[m + 3] = t1[_ + 2];
            }
        } else if (0 == u) for(p = o.tabs.tRNS ? o.tabs.tRNS : -1, w = 0; w < i; w++){
            const e = w * f, i = w * r;
            if (1 == h) for(var B = 0; B < r; B++){
                var U = (F = 255 * (t1[e + (B >>> 3)] >>> 7 - (7 & B) & 1)) == 255 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (2 == h) for(B = 0; B < r; B++){
                U = (F = 85 * (t1[e + (B >>> 2)] >>> 6 - ((3 & B) << 1) & 3)) == 85 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (4 == h) for(B = 0; B < r; B++){
                U = (F = 17 * (t1[e + (B >>> 1)] >>> 4 - ((1 & B) << 2) & 15)) == 17 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (8 == h) for(B = 0; B < r; B++){
                U = (F = t1[e + B]) == p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (16 == h) for(B = 0; B < r; B++){
                F = t1[e + (B << 1)], U = d(t1, e + (B << 1)) == p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
        }
        return l;
    }
    function _decompress(e, r, i, o) {
        const a = _getBPP(e), s = Math.ceil(i * a / 8), f = new Uint8Array((s + 1 + e.interlace) * o);
        return r = e.tabs.CgBI ? t1(r, f) : _inflate(r, f), 0 == e.interlace ? r = _filterZero(r, e, 0, i, o) : 1 == e.interlace && (r = function _readInterlace(e, t1) {
            const r = t1.width, i = t1.height, o = _getBPP(t1), a = o >> 3, s = Math.ceil(r * o / 8), f = new Uint8Array(i * s);
            let l = 0;
            const c = [
                0,
                0,
                4,
                0,
                2,
                0,
                1
            ], u = [
                0,
                4,
                0,
                2,
                0,
                1,
                0
            ], h = [
                8,
                8,
                8,
                4,
                4,
                2,
                2
            ], d = [
                8,
                8,
                4,
                4,
                2,
                2,
                1
            ];
            let A = 0;
            for(; A < 7;){
                const p = h[A], m = d[A];
                let w = 0, v = 0, b = c[A];
                for(; b < i;)b += p, v++;
                let y = u[A];
                for(; y < r;)y += m, w++;
                const E = Math.ceil(w * o / 8);
                _filterZero(e, t1, l, w, v);
                let F = 0, _ = c[A];
                for(; _ < i;){
                    let t1 = u[A], i = l + F * E << 3;
                    for(; t1 < r;){
                        var g;
                        if (1 == o) g = (g = e[i >> 3]) >> 7 - (7 & i) & 1, f[_ * s + (t1 >> 3)] |= g << 7 - ((7 & t1) << 0);
                        if (2 == o) g = (g = e[i >> 3]) >> 6 - (7 & i) & 3, f[_ * s + (t1 >> 2)] |= g << 6 - ((3 & t1) << 1);
                        if (4 == o) g = (g = e[i >> 3]) >> 4 - (7 & i) & 15, f[_ * s + (t1 >> 1)] |= g << 4 - ((1 & t1) << 2);
                        if (o >= 8) {
                            const r = _ * s + t1 * a;
                            for(let t1 = 0; t1 < a; t1++)f[r + t1] = e[(i >> 3) + t1];
                        }
                        i += o, t1 += m;
                    }
                    F++, _ += p;
                }
                w * v != 0 && (l += v * (1 + E)), A += 1;
            }
            return f;
        }(r, e)), r;
    }
    function _inflate(e, r) {
        return t1(new Uint8Array(e.buffer, 2, e.length - 6), r);
    }
    var t1 = function() {
        const e = {
            H: {}
        };
        return e.H.N = function(t1, r) {
            const i = Uint8Array;
            let o, a, s = 0, f = 0, l = 0, c = 0, u = 0, h = 0, d = 0, A = 0, g = 0;
            if (3 == t1[0] && 0 == t1[1]) return r || new i(0);
            const p = e.H, m = p.b, w = p.e, v = p.R, b = p.n, y = p.A, E = p.Z, F = p.m, _ = null == r;
            for(_ && (r = new i(t1.length >>> 2 << 5)); 0 == s;)if (s = m(t1, g, 1), f = m(t1, g + 1, 2), g += 3, 0 != f) {
                if (_ && (r = e.H.W(r, A + 131072)), 1 == f && (o = F.J, a = F.h, h = 511, d = 31), 2 == f) {
                    l = w(t1, g, 5) + 257, c = w(t1, g + 5, 5) + 1, u = w(t1, g + 10, 4) + 4, g += 14;
                    let e = 1;
                    for(var B = 0; B < 38; B += 2)F.Q[B] = 0, F.Q[B + 1] = 0;
                    for(B = 0; B < u; B++){
                        const r = w(t1, g + 3 * B, 3);
                        F.Q[1 + (F.X[B] << 1)] = r, r > e && (e = r);
                    }
                    g += 3 * u, b(F.Q, e), y(F.Q, e, F.u), o = F.w, a = F.d, g = v(F.u, (1 << e) - 1, l + c, t1, g, F.v);
                    const r = p.V(F.v, 0, l, F.C);
                    h = (1 << r) - 1;
                    const i = p.V(F.v, l, c, F.D);
                    d = (1 << i) - 1, b(F.C, r), y(F.C, r, o), b(F.D, i), y(F.D, i, a);
                }
                for(;;){
                    const e = o[E(t1, g) & h];
                    g += 15 & e;
                    const i = e >>> 4;
                    if (i >>> 8 == 0) r[A++] = i;
                    else {
                        if (256 == i) break;
                        {
                            let e = A + i - 254;
                            if (i > 264) {
                                const r = F.q[i - 257];
                                e = A + (r >>> 3) + w(t1, g, 7 & r), g += 7 & r;
                            }
                            const o = a[E(t1, g) & d];
                            g += 15 & o;
                            const s = o >>> 4, f = F.c[s], l = (f >>> 4) + m(t1, g, 15 & f);
                            for(g += 15 & f; A < e;)r[A] = r[A++ - l], r[A] = r[A++ - l], r[A] = r[A++ - l], r[A] = r[A++ - l];
                            A = e;
                        }
                    }
                }
            } else {
                0 != (7 & g) && (g += 8 - (7 & g));
                const o = 4 + (g >>> 3), a = t1[o - 4] | t1[o - 3] << 8;
                _ && (r = e.H.W(r, A + a)), r.set(new i(t1.buffer, t1.byteOffset + o, a), A), g = o + a << 3, A += a;
            }
            return r.length == A ? r : r.slice(0, A);
        }, e.H.W = function(e, t1) {
            const r = e.length;
            if (t1 <= r) return e;
            const i = new Uint8Array(r << 1);
            return i.set(e, 0), i;
        }, e.H.R = function(t1, r, i, o, a, s) {
            const f = e.H.e, l = e.H.Z;
            let c = 0;
            for(; c < i;){
                const e = t1[l(o, a) & r];
                a += 15 & e;
                const i = e >>> 4;
                if (i <= 15) s[c] = i, c++;
                else {
                    let e = 0, t1 = 0;
                    16 == i ? (t1 = 3 + f(o, a, 2), a += 2, e = s[c - 1]) : 17 == i ? (t1 = 3 + f(o, a, 3), a += 3) : 18 == i && (t1 = 11 + f(o, a, 7), a += 7);
                    const r = c + t1;
                    for(; c < r;)s[c] = e, c++;
                }
            }
            return a;
        }, e.H.V = function(e, t1, r, i) {
            let o = 0, a = 0;
            const s = i.length >>> 1;
            for(; a < r;){
                const r = e[a + t1];
                i[a << 1] = 0, i[1 + (a << 1)] = r, r > o && (o = r), a++;
            }
            for(; a < s;)i[a << 1] = 0, i[1 + (a << 1)] = 0, a++;
            return o;
        }, e.H.n = function(t1, r) {
            const i = e.H.m, o = t1.length;
            let a, s, f;
            let l;
            const c = i.j;
            for(var u = 0; u <= r; u++)c[u] = 0;
            for(u = 1; u < o; u += 2)c[t1[u]]++;
            const h = i.K;
            for(a = 0, c[0] = 0, s = 1; s <= r; s++)a = a + c[s - 1] << 1, h[s] = a;
            for(f = 0; f < o; f += 2)l = t1[f + 1], 0 != l && (t1[f] = h[l], h[l]++);
        }, e.H.A = function(t1, r, i) {
            const o = t1.length, a = e.H.m.r;
            for(let e = 0; e < o; e += 2)if (0 != t1[e + 1]) {
                const o = e >> 1, s = t1[e + 1], f = o << 4 | s, l = r - s;
                let c = t1[e] << l;
                const u = c + (1 << l);
                for(; c != u;)i[a[c] >>> 15 - r] = f, c++;
            }
        }, e.H.l = function(t1, r) {
            const i = e.H.m.r, o = 15 - r;
            for(let e = 0; e < t1.length; e += 2){
                const a = t1[e] << r - t1[e + 1];
                t1[e] = i[a] >>> o;
            }
        }, e.H.M = function(e, t1, r) {
            r <<= 7 & t1;
            const i = t1 >>> 3;
            e[i] |= r, e[i + 1] |= r >>> 8;
        }, e.H.I = function(e, t1, r) {
            r <<= 7 & t1;
            const i = t1 >>> 3;
            e[i] |= r, e[i + 1] |= r >>> 8, e[i + 2] |= r >>> 16;
        }, e.H.e = function(e, t1, r) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8) >>> (7 & t1) & (1 << r) - 1;
        }, e.H.b = function(e, t1, r) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1) & (1 << r) - 1;
        }, e.H.Z = function(e, t1) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1);
        }, e.H.i = function(e, t1) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16 | e[3 + (t1 >>> 3)] << 24) >>> (7 & t1);
        }, e.H.m = function() {
            const e = Uint16Array, t1 = Uint32Array;
            return {
                K: new e(16),
                j: new e(16),
                X: [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ],
                S: [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    999,
                    999,
                    999
                ],
                T: [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0,
                    0,
                    0,
                    0
                ],
                q: new e(32),
                p: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    65535,
                    65535
                ],
                z: [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13,
                    0,
                    0
                ],
                c: new t1(32),
                J: new e(512),
                _: [],
                h: new e(32),
                $: [],
                w: new e(32768),
                C: [],
                v: [],
                d: new e(32768),
                D: [],
                u: new e(512),
                Q: [],
                r: new e(32768),
                s: new t1(286),
                Y: new t1(30),
                a: new t1(19),
                t: new t1(15e3),
                k: new e(65536),
                g: new e(32768)
            };
        }(), function() {
            const t1 = e.H.m;
            for(var r = 0; r < 32768; r++){
                let e = r;
                e = (2863311530 & e) >>> 1 | (1431655765 & e) << 1, e = (3435973836 & e) >>> 2 | (858993459 & e) << 2, e = (4042322160 & e) >>> 4 | (252645135 & e) << 4, e = (4278255360 & e) >>> 8 | (16711935 & e) << 8, t1.r[r] = (e >>> 16 | e << 16) >>> 17;
            }
            function n(e, t1, r) {
                for(; 0 != t1--;)e.push(0, r);
            }
            for(r = 0; r < 32; r++)t1.q[r] = t1.S[r] << 3 | t1.T[r], t1.c[r] = t1.p[r] << 4 | t1.z[r];
            n(t1._, 144, 8), n(t1._, 112, 9), n(t1._, 24, 7), n(t1._, 8, 8), e.H.n(t1._, 9), e.H.A(t1._, 9, t1.J), e.H.l(t1._, 9), n(t1.$, 32, 5), e.H.n(t1.$, 5), e.H.A(t1.$, 5, t1.h), e.H.l(t1.$, 5), n(t1.Q, 19, 0), n(t1.C, 286, 0), n(t1.D, 30, 0), n(t1.v, 320, 0);
        }(), e.H.N;
    }();
    function _getBPP(e) {
        return [
            1,
            null,
            3,
            1,
            2,
            null,
            4
        ][e.ctype] * e.depth;
    }
    function _filterZero(e, t1, r, i, o) {
        let a = _getBPP(t1);
        const s = Math.ceil(i * a / 8);
        let f, l;
        a = Math.ceil(a / 8);
        let c = e[r], u = 0;
        if (c > 1 && (e[r] = [
            0,
            0,
            1
        ][c - 2]), 3 == c) for(u = a; u < s; u++)e[u + 1] = e[u + 1] + (e[u + 1 - a] >>> 1) & 255;
        for(let t1 = 0; t1 < o; t1++)if (f = r + t1 * s, l = f + t1 + 1, c = e[l - 1], u = 0, 0 == c) for(; u < s; u++)e[f + u] = e[l + u];
        else if (1 == c) {
            for(; u < a; u++)e[f + u] = e[l + u];
            for(; u < s; u++)e[f + u] = e[l + u] + e[f + u - a];
        } else if (2 == c) for(; u < s; u++)e[f + u] = e[l + u] + e[f + u - s];
        else if (3 == c) {
            for(; u < a; u++)e[f + u] = e[l + u] + (e[f + u - s] >>> 1);
            for(; u < s; u++)e[f + u] = e[l + u] + (e[f + u - s] + e[f + u - a] >>> 1);
        } else {
            for(; u < a; u++)e[f + u] = e[l + u] + _paeth(0, e[f + u - s], 0);
            for(; u < s; u++)e[f + u] = e[l + u] + _paeth(e[f + u - a], e[f + u - s], e[f + u - a - s]);
        }
        return e;
    }
    function _paeth(e, t1, r) {
        const i = e + t1 - r, o = i - e, a = i - t1, s = i - r;
        return o * o <= a * a && o * o <= s * s ? e : a * a <= s * s ? t1 : r;
    }
    function _IHDR(t1, r, i) {
        i.width = e.readUint(t1, r), r += 4, i.height = e.readUint(t1, r), r += 4, i.depth = t1[r], r++, i.ctype = t1[r], r++, i.compress = t1[r], r++, i.filter = t1[r], r++, i.interlace = t1[r], r++;
    }
    function _copyTile(e, t1, r, i, o, a, s, f, l) {
        const c = Math.min(t1, o), u = Math.min(r, a);
        let h = 0, d = 0;
        for(let r = 0; r < u; r++)for(let a = 0; a < c; a++)if (s >= 0 && f >= 0 ? (h = r * t1 + a << 2, d = (f + r) * o + s + a << 2) : (h = (-f + r) * t1 - s + a << 2, d = r * o + a << 2), 0 == l) i[d] = e[h], i[d + 1] = e[h + 1], i[d + 2] = e[h + 2], i[d + 3] = e[h + 3];
        else if (1 == l) {
            var A = e[h + 3] * (1 / 255), g = e[h] * A, p = e[h + 1] * A, m = e[h + 2] * A, w = i[d + 3] * (1 / 255), v = i[d] * w, b = i[d + 1] * w, y = i[d + 2] * w;
            const t1 = 1 - A, r = A + w * t1, o = 0 == r ? 0 : 1 / r;
            i[d + 3] = 255 * r, i[d + 0] = (g + v * t1) * o, i[d + 1] = (p + b * t1) * o, i[d + 2] = (m + y * t1) * o;
        } else if (2 == l) {
            A = e[h + 3], g = e[h], p = e[h + 1], m = e[h + 2], w = i[d + 3], v = i[d], b = i[d + 1], y = i[d + 2];
            A == w && g == v && p == b && m == y ? (i[d] = 0, i[d + 1] = 0, i[d + 2] = 0, i[d + 3] = 0) : (i[d] = g, i[d + 1] = p, i[d + 2] = m, i[d + 3] = A);
        } else if (3 == l) {
            A = e[h + 3], g = e[h], p = e[h + 1], m = e[h + 2], w = i[d + 3], v = i[d], b = i[d + 1], y = i[d + 2];
            if (A == w && g == v && p == b && m == y) continue;
            if (A < 220 && w > 20) return !1;
        }
        return !0;
    }
    return {
        decode: function decode(r) {
            const i = new Uint8Array(r);
            let o = 8;
            const a = e, s = a.readUshort, f = a.readUint, l = {
                tabs: {},
                frames: []
            }, c = new Uint8Array(i.length);
            let u, h = 0, d = 0;
            const A = [
                137,
                80,
                78,
                71,
                13,
                10,
                26,
                10
            ];
            for(var g = 0; g < 8; g++)if (i[g] != A[g]) throw "The input is not a PNG file!";
            for(; o < i.length;){
                const e = a.readUint(i, o);
                o += 4;
                const r = a.readASCII(i, o, 4);
                if (o += 4, "IHDR" == r) _IHDR(i, o, l);
                else if ("iCCP" == r) {
                    for(var p = o; 0 != i[p];)p++;
                    a.readASCII(i, o, p - o), i[p + 1];
                    const s = i.slice(p + 2, o + e);
                    let f = null;
                    try {
                        f = _inflate(s);
                    } catch (e) {
                        f = t1(s);
                    }
                    l.tabs[r] = f;
                } else if ("CgBI" == r) l.tabs[r] = i.slice(o, o + 4);
                else if ("IDAT" == r) {
                    for(g = 0; g < e; g++)c[h + g] = i[o + g];
                    h += e;
                } else if ("acTL" == r) l.tabs[r] = {
                    num_frames: f(i, o),
                    num_plays: f(i, o + 4)
                }, u = new Uint8Array(i.length);
                else if ("fcTL" == r) {
                    if (0 != d) (E = l.frames[l.frames.length - 1]).data = _decompress(l, u.slice(0, d), E.rect.width, E.rect.height), d = 0;
                    const e = {
                        x: f(i, o + 12),
                        y: f(i, o + 16),
                        width: f(i, o + 4),
                        height: f(i, o + 8)
                    };
                    let t1 = s(i, o + 22);
                    t1 = s(i, o + 20) / (0 == t1 ? 100 : t1);
                    const r = {
                        rect: e,
                        delay: Math.round(1e3 * t1),
                        dispose: i[o + 24],
                        blend: i[o + 25]
                    };
                    l.frames.push(r);
                } else if ("fdAT" == r) {
                    for(g = 0; g < e - 4; g++)u[d + g] = i[o + g + 4];
                    d += e - 4;
                } else if ("pHYs" == r) l.tabs[r] = [
                    a.readUint(i, o),
                    a.readUint(i, o + 4),
                    i[o + 8]
                ];
                else if ("cHRM" == r) {
                    l.tabs[r] = [];
                    for(g = 0; g < 8; g++)l.tabs[r].push(a.readUint(i, o + 4 * g));
                } else if ("tEXt" == r || "zTXt" == r) {
                    null == l.tabs[r] && (l.tabs[r] = {});
                    var m = a.nextZero(i, o), w = a.readASCII(i, o, m - o), v = o + e - m - 1;
                    if ("tEXt" == r) y = a.readASCII(i, m + 1, v);
                    else {
                        var b = _inflate(i.slice(m + 2, m + 2 + v));
                        y = a.readUTF8(b, 0, b.length);
                    }
                    l.tabs[r][w] = y;
                } else if ("iTXt" == r) {
                    null == l.tabs[r] && (l.tabs[r] = {});
                    m = 0, p = o;
                    m = a.nextZero(i, p);
                    w = a.readASCII(i, p, m - p);
                    const t1 = i[p = m + 1];
                    var y;
                    i[p + 1], p += 2, m = a.nextZero(i, p), a.readASCII(i, p, m - p), p = m + 1, m = a.nextZero(i, p), a.readUTF8(i, p, m - p);
                    v = e - ((p = m + 1) - o);
                    if (0 == t1) y = a.readUTF8(i, p, v);
                    else {
                        b = _inflate(i.slice(p, p + v));
                        y = a.readUTF8(b, 0, b.length);
                    }
                    l.tabs[r][w] = y;
                } else if ("PLTE" == r) l.tabs[r] = a.readBytes(i, o, e);
                else if ("hIST" == r) {
                    const e = l.tabs.PLTE.length / 3;
                    l.tabs[r] = [];
                    for(g = 0; g < e; g++)l.tabs[r].push(s(i, o + 2 * g));
                } else if ("tRNS" == r) 3 == l.ctype ? l.tabs[r] = a.readBytes(i, o, e) : 0 == l.ctype ? l.tabs[r] = s(i, o) : 2 == l.ctype && (l.tabs[r] = [
                    s(i, o),
                    s(i, o + 2),
                    s(i, o + 4)
                ]);
                else if ("gAMA" == r) l.tabs[r] = a.readUint(i, o) / 1e5;
                else if ("sRGB" == r) l.tabs[r] = i[o];
                else if ("bKGD" == r) 0 == l.ctype || 4 == l.ctype ? l.tabs[r] = [
                    s(i, o)
                ] : 2 == l.ctype || 6 == l.ctype ? l.tabs[r] = [
                    s(i, o),
                    s(i, o + 2),
                    s(i, o + 4)
                ] : 3 == l.ctype && (l.tabs[r] = i[o]);
                else if ("IEND" == r) break;
                o += e, a.readUint(i, o), o += 4;
            }
            var E;
            return 0 != d && ((E = l.frames[l.frames.length - 1]).data = _decompress(l, u.slice(0, d), E.rect.width, E.rect.height)), l.data = _decompress(l, c, l.width, l.height), delete l.compress, delete l.interlace, delete l.filter, l;
        },
        toRGBA8: function toRGBA8(e) {
            const t1 = e.width, r = e.height;
            if (null == e.tabs.acTL) return [
                decodeImage(e.data, t1, r, e).buffer
            ];
            const i = [];
            null == e.frames[0].data && (e.frames[0].data = e.data);
            const o = t1 * r * 4, a = new Uint8Array(o), s = new Uint8Array(o), f = new Uint8Array(o);
            for(let c = 0; c < e.frames.length; c++){
                const u = e.frames[c], h = u.rect.x, d = u.rect.y, A = u.rect.width, g = u.rect.height, p = decodeImage(u.data, A, g, e);
                if (0 != c) for(var l = 0; l < o; l++)f[l] = a[l];
                if (0 == u.blend ? _copyTile(p, A, g, a, t1, r, h, d, 0) : 1 == u.blend && _copyTile(p, A, g, a, t1, r, h, d, 1), i.push(a.buffer.slice(0)), 0 == u.dispose) ;
                else if (1 == u.dispose) _copyTile(s, A, g, a, t1, r, h, d, 0);
                else if (2 == u.dispose) for(l = 0; l < o; l++)a[l] = f[l];
            }
            return i;
        },
        _paeth: _paeth,
        _copyTile: _copyTile,
        _bin: e
    };
}();
!function() {
    const { _copyTile: e } = $8225ba78123222c8$var$UPNG, { _bin: t1 } = $8225ba78123222c8$var$UPNG, r = $8225ba78123222c8$var$UPNG._paeth;
    var i = {
        table: function() {
            const e = new Uint32Array(256);
            for(let t1 = 0; t1 < 256; t1++){
                let r = t1;
                for(let e = 0; e < 8; e++)1 & r ? r = 3988292384 ^ r >>> 1 : r >>>= 1;
                e[t1] = r;
            }
            return e;
        }(),
        update (e, t1, r, o) {
            for(let a = 0; a < o; a++)e = i.table[255 & (e ^ t1[r + a])] ^ e >>> 8;
            return e;
        },
        crc: (e, t1, r)=>4294967295 ^ i.update(4294967295, e, t1, r)
    };
    function addErr(e, t1, r, i) {
        t1[r] += e[0] * i >> 4, t1[r + 1] += e[1] * i >> 4, t1[r + 2] += e[2] * i >> 4, t1[r + 3] += e[3] * i >> 4;
    }
    function N(e) {
        return Math.max(0, Math.min(255, e));
    }
    function D(e, t1) {
        const r = e[0] - t1[0], i = e[1] - t1[1], o = e[2] - t1[2], a = e[3] - t1[3];
        return r * r + i * i + o * o + a * a;
    }
    function dither(e, t1, r, i, o, a, s) {
        null == s && (s = 1);
        const f = i.length, l = [];
        for(var c = 0; c < f; c++){
            const e = i[c];
            l.push([
                e >>> 0 & 255,
                e >>> 8 & 255,
                e >>> 16 & 255,
                e >>> 24 & 255
            ]);
        }
        for(c = 0; c < f; c++){
            let e = 4294967295;
            for(var u = 0, h = 0; h < f; h++){
                var d = D(l[c], l[h]);
                h != c && d < e && (e = d, u = h);
            }
        }
        const A = new Uint32Array(o.buffer), g = new Int16Array(t1 * r * 4), p = [
            0,
            8,
            2,
            10,
            12,
            4,
            14,
            6,
            3,
            11,
            1,
            9,
            15,
            7,
            13,
            5
        ];
        for(c = 0; c < p.length; c++)p[c] = 255 * ((p[c] + .5) / 16 - .5);
        for(let o = 0; o < r; o++)for(let w = 0; w < t1; w++){
            var m;
            c = 4 * (o * t1 + w);
            if (2 != s) m = [
                N(e[c] + g[c]),
                N(e[c + 1] + g[c + 1]),
                N(e[c + 2] + g[c + 2]),
                N(e[c + 3] + g[c + 3])
            ];
            else {
                d = p[4 * (3 & o) + (3 & w)];
                m = [
                    N(e[c] + d),
                    N(e[c + 1] + d),
                    N(e[c + 2] + d),
                    N(e[c + 3] + d)
                ];
            }
            u = 0;
            let v = 16777215;
            for(h = 0; h < f; h++){
                const e = D(m, l[h]);
                e < v && (v = e, u = h);
            }
            const b = l[u], y = [
                m[0] - b[0],
                m[1] - b[1],
                m[2] - b[2],
                m[3] - b[3]
            ];
            1 == s && (w != t1 - 1 && addErr(y, g, c + 4, 7), o != r - 1 && (0 != w && addErr(y, g, c + 4 * t1 - 4, 3), addErr(y, g, c + 4 * t1, 5), w != t1 - 1 && addErr(y, g, c + 4 * t1 + 4, 1))), a[c >> 2] = u, A[c >> 2] = i[u];
        }
    }
    function _main(e, r, o, a, s) {
        null == s && (s = {});
        const { crc: f } = i, l = t1.writeUint, c = t1.writeUshort, u = t1.writeASCII;
        let h = 8;
        const d = e.frames.length > 1;
        let A, g = !1, p = 33 + (d ? 20 : 0);
        if (null != s.sRGB && (p += 13), null != s.pHYs && (p += 21), null != s.iCCP && (A = pako.deflate(s.iCCP), p += 21 + A.length + 4), 3 == e.ctype) {
            for(var m = e.plte.length, w = 0; w < m; w++)e.plte[w] >>> 24 != 255 && (g = !0);
            p += 8 + 3 * m + 4 + (g ? 8 + 1 * m + 4 : 0);
        }
        for(var v = 0; v < e.frames.length; v++)d && (p += 38), p += (F = e.frames[v]).cimg.length + 12, 0 != v && (p += 4);
        p += 12;
        const b = new Uint8Array(p), y = [
            137,
            80,
            78,
            71,
            13,
            10,
            26,
            10
        ];
        for(w = 0; w < 8; w++)b[w] = y[w];
        if (l(b, h, 13), h += 4, u(b, h, "IHDR"), h += 4, l(b, h, r), h += 4, l(b, h, o), h += 4, b[h] = e.depth, h++, b[h] = e.ctype, h++, b[h] = 0, h++, b[h] = 0, h++, b[h] = 0, h++, l(b, h, f(b, h - 17, 17)), h += 4, null != s.sRGB && (l(b, h, 1), h += 4, u(b, h, "sRGB"), h += 4, b[h] = s.sRGB, h++, l(b, h, f(b, h - 5, 5)), h += 4), null != s.iCCP) {
            const e = 13 + A.length;
            l(b, h, e), h += 4, u(b, h, "iCCP"), h += 4, u(b, h, "ICC profile"), h += 11, h += 2, b.set(A, h), h += A.length, l(b, h, f(b, h - (e + 4), e + 4)), h += 4;
        }
        if (null != s.pHYs && (l(b, h, 9), h += 4, u(b, h, "pHYs"), h += 4, l(b, h, s.pHYs[0]), h += 4, l(b, h, s.pHYs[1]), h += 4, b[h] = s.pHYs[2], h++, l(b, h, f(b, h - 13, 13)), h += 4), d && (l(b, h, 8), h += 4, u(b, h, "acTL"), h += 4, l(b, h, e.frames.length), h += 4, l(b, h, null != s.loop ? s.loop : 0), h += 4, l(b, h, f(b, h - 12, 12)), h += 4), 3 == e.ctype) {
            l(b, h, 3 * (m = e.plte.length)), h += 4, u(b, h, "PLTE"), h += 4;
            for(w = 0; w < m; w++){
                const t1 = 3 * w, r = e.plte[w], i = 255 & r, o = r >>> 8 & 255, a = r >>> 16 & 255;
                b[h + t1 + 0] = i, b[h + t1 + 1] = o, b[h + t1 + 2] = a;
            }
            if (h += 3 * m, l(b, h, f(b, h - 3 * m - 4, 3 * m + 4)), h += 4, g) {
                l(b, h, m), h += 4, u(b, h, "tRNS"), h += 4;
                for(w = 0; w < m; w++)b[h + w] = e.plte[w] >>> 24 & 255;
                h += m, l(b, h, f(b, h - m - 4, m + 4)), h += 4;
            }
        }
        let E = 0;
        for(v = 0; v < e.frames.length; v++){
            var F = e.frames[v];
            d && (l(b, h, 26), h += 4, u(b, h, "fcTL"), h += 4, l(b, h, E++), h += 4, l(b, h, F.rect.width), h += 4, l(b, h, F.rect.height), h += 4, l(b, h, F.rect.x), h += 4, l(b, h, F.rect.y), h += 4, c(b, h, a[v]), h += 2, c(b, h, 1e3), h += 2, b[h] = F.dispose, h++, b[h] = F.blend, h++, l(b, h, f(b, h - 30, 30)), h += 4);
            const t1 = F.cimg;
            l(b, h, (m = t1.length) + (0 == v ? 0 : 4)), h += 4;
            const r = h;
            u(b, h, 0 == v ? "IDAT" : "fdAT"), h += 4, 0 != v && (l(b, h, E++), h += 4), b.set(t1, h), h += m, l(b, h, f(b, r, h - r)), h += 4;
        }
        return l(b, h, 0), h += 4, u(b, h, "IEND"), h += 4, l(b, h, f(b, h - 4, 4)), h += 4, b.buffer;
    }
    function compressPNG(e, t1, r) {
        for(let i = 0; i < e.frames.length; i++){
            const o = e.frames[i];
            o.rect.width;
            const a = o.rect.height, s = new Uint8Array(a * o.bpl + a);
            o.cimg = _filterZero(o.img, a, o.bpp, o.bpl, s, t1, r);
        }
    }
    function compress(t1, r, i, o, a) {
        const s = a[0], f = a[1], l = a[2], c = a[3], u = a[4], h = a[5];
        let d = 6, A = 8, g = 255;
        for(var p = 0; p < t1.length; p++){
            const e = new Uint8Array(t1[p]);
            for(var m = e.length, w = 0; w < m; w += 4)g &= e[w + 3];
        }
        const v = 255 != g, b = function framize(t1, r, i, o, a, s) {
            const f = [];
            for(var l = 0; l < t1.length; l++){
                const h = new Uint8Array(t1[l]), A = new Uint32Array(h.buffer);
                var c;
                let g = 0, p = 0, m = r, w = i, v = o ? 1 : 0;
                if (0 != l) {
                    const b = s || o || 1 == l || 0 != f[l - 2].dispose ? 1 : 2;
                    let y = 0, E = 1e9;
                    for(let e = 0; e < b; e++){
                        var u = new Uint8Array(t1[l - 1 - e]);
                        const o = new Uint32Array(t1[l - 1 - e]);
                        let s = r, f = i, c = -1, h = -1;
                        for(let e = 0; e < i; e++)for(let t1 = 0; t1 < r; t1++)A[d = e * r + t1] != o[d] && (t1 < s && (s = t1), t1 > c && (c = t1), e < f && (f = e), e > h && (h = e));
                        -1 == c && (s = f = c = h = 0), a && (1 == (1 & s) && s--, 1 == (1 & f) && f--);
                        const v = (c - s + 1) * (h - f + 1);
                        v < E && (E = v, y = e, g = s, p = f, m = c - s + 1, w = h - f + 1);
                    }
                    u = new Uint8Array(t1[l - 1 - y]);
                    1 == y && (f[l - 1].dispose = 2), c = new Uint8Array(m * w * 4), e(u, r, i, c, m, w, -g, -p, 0), v = e(h, r, i, c, m, w, -g, -p, 3) ? 1 : 0, 1 == v ? _prepareDiff(h, r, i, c, {
                        x: g,
                        y: p,
                        width: m,
                        height: w
                    }) : e(h, r, i, c, m, w, -g, -p, 0);
                } else c = h.slice(0);
                f.push({
                    rect: {
                        x: g,
                        y: p,
                        width: m,
                        height: w
                    },
                    img: c,
                    blend: v,
                    dispose: 0
                });
            }
            if (o) for(l = 0; l < f.length; l++){
                if (1 == (A = f[l]).blend) continue;
                const e = A.rect, o = f[l - 1].rect, s = Math.min(e.x, o.x), c = Math.min(e.y, o.y), u = {
                    x: s,
                    y: c,
                    width: Math.max(e.x + e.width, o.x + o.width) - s,
                    height: Math.max(e.y + e.height, o.y + o.height) - c
                };
                f[l - 1].dispose = 1, l - 1 != 0 && _updateFrame(t1, r, i, f, l - 1, u, a), _updateFrame(t1, r, i, f, l, u, a);
            }
            let h = 0;
            if (1 != t1.length) for(var d = 0; d < f.length; d++){
                var A;
                h += (A = f[d]).rect.width * A.rect.height;
            }
            return f;
        }(t1, r, i, s, f, l), y = {}, E = [], F = [];
        if (0 != o) {
            const e = [];
            for(w = 0; w < b.length; w++)e.push(b[w].img.buffer);
            const t1 = function concatRGBA(e) {
                let t1 = 0;
                for(var r = 0; r < e.length; r++)t1 += e[r].byteLength;
                const i = new Uint8Array(t1);
                let o = 0;
                for(r = 0; r < e.length; r++){
                    const t1 = new Uint8Array(e[r]), a = t1.length;
                    for(let e = 0; e < a; e += 4){
                        let r = t1[e], a = t1[e + 1], s = t1[e + 2];
                        const f = t1[e + 3];
                        0 == f && (r = a = s = 0), i[o + e] = r, i[o + e + 1] = a, i[o + e + 2] = s, i[o + e + 3] = f;
                    }
                    o += a;
                }
                return i.buffer;
            }(e), r = quantize(t1, o);
            for(w = 0; w < r.plte.length; w++)E.push(r.plte[w].est.rgba);
            let i = 0;
            for(w = 0; w < b.length; w++){
                const e = (B = b[w]).img.length;
                var _ = new Uint8Array(r.inds.buffer, i >> 2, e >> 2);
                F.push(_);
                const t1 = new Uint8Array(r.abuf, i, e);
                h && dither(B.img, B.rect.width, B.rect.height, E, t1, _), B.img.set(t1), i += e;
            }
        } else for(p = 0; p < b.length; p++){
            var B = b[p];
            const e = new Uint32Array(B.img.buffer);
            var U = B.rect.width;
            m = e.length, _ = new Uint8Array(m);
            F.push(_);
            for(w = 0; w < m; w++){
                const t1 = e[w];
                if (0 != w && t1 == e[w - 1]) _[w] = _[w - 1];
                else if (w > U && t1 == e[w - U]) _[w] = _[w - U];
                else {
                    let e = y[t1];
                    if (null == e && (y[t1] = e = E.length, E.push(t1), E.length >= 300)) break;
                    _[w] = e;
                }
            }
        }
        const C = E.length;
        C <= 256 && 0 == u && (A = C <= 2 ? 1 : C <= 4 ? 2 : C <= 16 ? 4 : 8, A = Math.max(A, c));
        for(p = 0; p < b.length; p++){
            (B = b[p]).rect.x, B.rect.y;
            U = B.rect.width;
            const e = B.rect.height;
            let t1 = B.img;
            new Uint32Array(t1.buffer);
            let r = 4 * U, i = 4;
            if (C <= 256 && 0 == u) {
                r = Math.ceil(A * U / 8);
                var I = new Uint8Array(r * e);
                const o = F[p];
                for(let t1 = 0; t1 < e; t1++){
                    w = t1 * r;
                    const e = t1 * U;
                    if (8 == A) for(var Q = 0; Q < U; Q++)I[w + Q] = o[e + Q];
                    else if (4 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 1)] |= o[e + Q] << 4 - 4 * (1 & Q);
                    else if (2 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 2)] |= o[e + Q] << 6 - 2 * (3 & Q);
                    else if (1 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 3)] |= o[e + Q] << 7 - 1 * (7 & Q);
                }
                t1 = I, d = 3, i = 1;
            } else if (0 == v && 1 == b.length) {
                I = new Uint8Array(U * e * 3);
                const o = U * e;
                for(w = 0; w < o; w++){
                    const e = 3 * w, r = 4 * w;
                    I[e] = t1[r], I[e + 1] = t1[r + 1], I[e + 2] = t1[r + 2];
                }
                t1 = I, d = 2, i = 3, r = 3 * U;
            }
            B.img = t1, B.bpl = r, B.bpp = i;
        }
        return {
            ctype: d,
            depth: A,
            plte: E,
            frames: b
        };
    }
    function _updateFrame(t1, r, i, o, a, s, f) {
        const l = Uint8Array, c = Uint32Array, u = new l(t1[a - 1]), h = new c(t1[a - 1]), d = a + 1 < t1.length ? new l(t1[a + 1]) : null, A = new l(t1[a]), g = new c(A.buffer);
        let p = r, m = i, w = -1, v = -1;
        for(let e = 0; e < s.height; e++)for(let t1 = 0; t1 < s.width; t1++){
            const i = s.x + t1, f = s.y + e, l = f * r + i, c = g[l];
            0 == c || 0 == o[a - 1].dispose && h[l] == c && (null == d || 0 != d[4 * l + 3]) || (i < p && (p = i), i > w && (w = i), f < m && (m = f), f > v && (v = f));
        }
        -1 == w && (p = m = w = v = 0), f && (1 == (1 & p) && p--, 1 == (1 & m) && m--), s = {
            x: p,
            y: m,
            width: w - p + 1,
            height: v - m + 1
        };
        const b = o[a];
        b.rect = s, b.blend = 1, b.img = new Uint8Array(s.width * s.height * 4), 0 == o[a - 1].dispose ? (e(u, r, i, b.img, s.width, s.height, -s.x, -s.y, 0), _prepareDiff(A, r, i, b.img, s)) : e(A, r, i, b.img, s.width, s.height, -s.x, -s.y, 0);
    }
    function _prepareDiff(t1, r, i, o, a) {
        e(t1, r, i, o, a.width, a.height, -a.x, -a.y, 2);
    }
    function _filterZero(e, t1, r, i, o, a, s) {
        const f = [];
        let l, c = [
            0,
            1,
            2,
            3,
            4
        ];
        -1 != a ? c = [
            a
        ] : (t1 * i > 5e5 || 1 == r) && (c = [
            0
        ]), s && (l = {
            level: 0
        });
        const u = $8225ba78123222c8$var$UZIP;
        for(var h = 0; h < c.length; h++){
            for(let a = 0; a < t1; a++)_filterLine(o, e, a, i, r, c[h]);
            f.push(u.deflate(o, l));
        }
        let d, A = 1e9;
        for(h = 0; h < f.length; h++)f[h].length < A && (d = h, A = f[h].length);
        return f[d];
    }
    function _filterLine(e, t1, i, o, a, s) {
        const f = i * o;
        let l = f + i;
        if (e[l] = s, l++, 0 == s) {
            if (o < 500) for(var c = 0; c < o; c++)e[l + c] = t1[f + c];
            else e.set(new Uint8Array(t1.buffer, f, o), l);
        } else if (1 == s) {
            for(c = 0; c < a; c++)e[l + c] = t1[f + c];
            for(c = a; c < o; c++)e[l + c] = t1[f + c] - t1[f + c - a] + 256 & 255;
        } else if (0 == i) {
            for(c = 0; c < a; c++)e[l + c] = t1[f + c];
            if (2 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c];
            if (3 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c] - (t1[f + c - a] >> 1) + 256 & 255;
            if (4 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c] - r(t1[f + c - a], 0, 0) + 256 & 255;
        } else {
            if (2 == s) for(c = 0; c < o; c++)e[l + c] = t1[f + c] + 256 - t1[f + c - o] & 255;
            if (3 == s) {
                for(c = 0; c < a; c++)e[l + c] = t1[f + c] + 256 - (t1[f + c - o] >> 1) & 255;
                for(c = a; c < o; c++)e[l + c] = t1[f + c] + 256 - (t1[f + c - o] + t1[f + c - a] >> 1) & 255;
            }
            if (4 == s) {
                for(c = 0; c < a; c++)e[l + c] = t1[f + c] + 256 - r(0, t1[f + c - o], 0) & 255;
                for(c = a; c < o; c++)e[l + c] = t1[f + c] + 256 - r(t1[f + c - a], t1[f + c - o], t1[f + c - a - o]) & 255;
            }
        }
    }
    function quantize(e, t1) {
        const r = new Uint8Array(e), i = r.slice(0), o = new Uint32Array(i.buffer), a = getKDtree(i, t1), s = a[0], f = a[1], l = r.length, c = new Uint8Array(l >> 2);
        let u;
        if (r.length < 2e7) for(var h = 0; h < l; h += 4)u = getNearest(s, d = r[h] * (1 / 255), A = r[h + 1] * (1 / 255), g = r[h + 2] * (1 / 255), p = r[h + 3] * (1 / 255)), c[h >> 2] = u.ind, o[h >> 2] = u.est.rgba;
        else for(h = 0; h < l; h += 4){
            var d = r[h] * (1 / 255), A = r[h + 1] * (1 / 255), g = r[h + 2] * (1 / 255), p = r[h + 3] * (1 / 255);
            for(u = s; u.left;)u = planeDst(u.est, d, A, g, p) <= 0 ? u.left : u.right;
            c[h >> 2] = u.ind, o[h >> 2] = u.est.rgba;
        }
        return {
            abuf: i.buffer,
            inds: c,
            plte: f
        };
    }
    function getKDtree(e, t1, r) {
        null == r && (r = 1e-4);
        const i = new Uint32Array(e.buffer), o = {
            i0: 0,
            i1: e.length,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        o.bst = stats(e, o.i0, o.i1), o.est = estats(o.bst);
        const a = [
            o
        ];
        for(; a.length < t1;){
            let t1 = 0, o = 0;
            for(var s = 0; s < a.length; s++)a[s].est.L > t1 && (t1 = a[s].est.L, o = s);
            if (t1 < r) break;
            const f = a[o], l = splitPixels(e, i, f.i0, f.i1, f.est.e, f.est.eMq255);
            if (f.i0 >= l || f.i1 <= l) {
                f.est.L = 0;
                continue;
            }
            const c = {
                i0: f.i0,
                i1: l,
                bst: null,
                est: null,
                tdst: 0,
                left: null,
                right: null
            };
            c.bst = stats(e, c.i0, c.i1), c.est = estats(c.bst);
            const u = {
                i0: l,
                i1: f.i1,
                bst: null,
                est: null,
                tdst: 0,
                left: null,
                right: null
            };
            u.bst = {
                R: [],
                m: [],
                N: f.bst.N - c.bst.N
            };
            for(s = 0; s < 16; s++)u.bst.R[s] = f.bst.R[s] - c.bst.R[s];
            for(s = 0; s < 4; s++)u.bst.m[s] = f.bst.m[s] - c.bst.m[s];
            u.est = estats(u.bst), f.left = c, f.right = u, a[o] = c, a.push(u);
        }
        a.sort((e, t1)=>t1.bst.N - e.bst.N);
        for(s = 0; s < a.length; s++)a[s].ind = s;
        return [
            o,
            a
        ];
    }
    function getNearest(e, t1, r, i, o) {
        if (null == e.left) return e.tdst = function dist(e, t1, r, i, o) {
            const a = t1 - e[0], s = r - e[1], f = i - e[2], l = o - e[3];
            return a * a + s * s + f * f + l * l;
        }(e.est.q, t1, r, i, o), e;
        const a = planeDst(e.est, t1, r, i, o);
        let s = e.left, f = e.right;
        a > 0 && (s = e.right, f = e.left);
        const l = getNearest(s, t1, r, i, o);
        if (l.tdst <= a * a) return l;
        const c = getNearest(f, t1, r, i, o);
        return c.tdst < l.tdst ? c : l;
    }
    function planeDst(e, t1, r, i, o) {
        const { e: a } = e;
        return a[0] * t1 + a[1] * r + a[2] * i + a[3] * o - e.eMq;
    }
    function splitPixels(e, t1, r, i, o, a) {
        for(i -= 4; r < i;){
            for(; vecDot(e, r, o) <= a;)r += 4;
            for(; vecDot(e, i, o) > a;)i -= 4;
            if (r >= i) break;
            const s = t1[r >> 2];
            t1[r >> 2] = t1[i >> 2], t1[i >> 2] = s, r += 4, i -= 4;
        }
        for(; vecDot(e, r, o) > a;)r -= 4;
        return r + 4;
    }
    function vecDot(e, t1, r) {
        return e[t1] * r[0] + e[t1 + 1] * r[1] + e[t1 + 2] * r[2] + e[t1 + 3] * r[3];
    }
    function stats(e, t1, r) {
        const i = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], o = [
            0,
            0,
            0,
            0
        ], a = r - t1 >> 2;
        for(let a = t1; a < r; a += 4){
            const t1 = e[a] * (1 / 255), r = e[a + 1] * (1 / 255), s = e[a + 2] * (1 / 255), f = e[a + 3] * (1 / 255);
            o[0] += t1, o[1] += r, o[2] += s, o[3] += f, i[0] += t1 * t1, i[1] += t1 * r, i[2] += t1 * s, i[3] += t1 * f, i[5] += r * r, i[6] += r * s, i[7] += r * f, i[10] += s * s, i[11] += s * f, i[15] += f * f;
        }
        return i[4] = i[1], i[8] = i[2], i[9] = i[6], i[12] = i[3], i[13] = i[7], i[14] = i[11], {
            R: i,
            m: o,
            N: a
        };
    }
    function estats(e) {
        const { R: t1 } = e, { m: r } = e, { N: i } = e, a = r[0], s = r[1], f = r[2], l = r[3], c = 0 == i ? 0 : 1 / i, u = [
            t1[0] - a * a * c,
            t1[1] - a * s * c,
            t1[2] - a * f * c,
            t1[3] - a * l * c,
            t1[4] - s * a * c,
            t1[5] - s * s * c,
            t1[6] - s * f * c,
            t1[7] - s * l * c,
            t1[8] - f * a * c,
            t1[9] - f * s * c,
            t1[10] - f * f * c,
            t1[11] - f * l * c,
            t1[12] - l * a * c,
            t1[13] - l * s * c,
            t1[14] - l * f * c,
            t1[15] - l * l * c
        ], h = u, d = o;
        let A = [
            Math.random(),
            Math.random(),
            Math.random(),
            Math.random()
        ], g = 0, p = 0;
        if (0 != i) for(let e = 0; e < 16 && (A = d.multVec(h, A), p = Math.sqrt(d.dot(A, A)), A = d.sml(1 / p, A), !(0 != e && Math.abs(p - g) < 1e-9)); e++)g = p;
        const m = [
            a * c,
            s * c,
            f * c,
            l * c
        ];
        return {
            Cov: u,
            q: m,
            e: A,
            L: g,
            eMq255: d.dot(d.sml(255, m), A),
            eMq: d.dot(A, m),
            rgba: (Math.round(255 * m[3]) << 24 | Math.round(255 * m[2]) << 16 | Math.round(255 * m[1]) << 8 | Math.round(255 * m[0]) << 0) >>> 0
        };
    }
    var o = {
        multVec: (e, t1)=>[
                e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2] + e[3] * t1[3],
                e[4] * t1[0] + e[5] * t1[1] + e[6] * t1[2] + e[7] * t1[3],
                e[8] * t1[0] + e[9] * t1[1] + e[10] * t1[2] + e[11] * t1[3],
                e[12] * t1[0] + e[13] * t1[1] + e[14] * t1[2] + e[15] * t1[3]
            ],
        dot: (e, t1)=>e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2] + e[3] * t1[3],
        sml: (e, t1)=>[
                e * t1[0],
                e * t1[1],
                e * t1[2],
                e * t1[3]
            ]
    };
    $8225ba78123222c8$var$UPNG.encode = function encode(e, t1, r, i, o, a, s) {
        null == i && (i = 0), null == s && (s = !1);
        const f = compress(e, t1, r, i, [
            !1,
            !1,
            !1,
            0,
            s,
            !1
        ]);
        return compressPNG(f, -1), _main(f, t1, r, o, a);
    }, $8225ba78123222c8$var$UPNG.encodeLL = function encodeLL(e, t1, r, i, o, a, s, f) {
        const l = {
            ctype: 0 + (1 == i ? 0 : 2) + (0 == o ? 0 : 4),
            depth: a,
            frames: []
        }, c = (i + o) * a, u = c * t1;
        for(let i = 0; i < e.length; i++)l.frames.push({
            rect: {
                x: 0,
                y: 0,
                width: t1,
                height: r
            },
            img: new Uint8Array(e[i]),
            blend: 0,
            dispose: 1,
            bpp: Math.ceil(c / 8),
            bpl: Math.ceil(u / 8)
        });
        return compressPNG(l, 0, !0), _main(l, t1, r, s, f);
    }, $8225ba78123222c8$var$UPNG.encode.compress = compress, $8225ba78123222c8$var$UPNG.encode.dither = dither, $8225ba78123222c8$var$UPNG.quantize = quantize, $8225ba78123222c8$var$UPNG.quantize.getKDtree = getKDtree, $8225ba78123222c8$var$UPNG.quantize.getNearest = getNearest;
}();
const $8225ba78123222c8$var$r = {
    toArrayBuffer (e, t1) {
        const i = e.width, o = e.height, a = i << 2, s = e.getContext("2d").getImageData(0, 0, i, o), f = new Uint32Array(s.data.buffer), l = (32 * i + 31) / 32 << 2, c = l * o, u = 122 + c, h = new ArrayBuffer(u), d = new DataView(h), A = 1048576;
        let g, p, m, w, v = A, b = 0, y = 0, E = 0;
        function set16(e) {
            d.setUint16(y, e, !0), y += 2;
        }
        function set32(e) {
            d.setUint32(y, e, !0), y += 4;
        }
        function seek(e) {
            y += e;
        }
        set16(19778), set32(u), seek(4), set32(122), set32(108), set32(i), set32(-o >>> 0), set16(1), set16(32), set32(3), set32(c), set32(2835), set32(2835), seek(8), set32(16711680), set32(65280), set32(255), set32(4278190080), set32(1466527264), function convert() {
            for(; b < o && v > 0;){
                for(w = 122 + b * l, g = 0; g < a;)v--, p = f[E++], m = p >>> 24, d.setUint32(w + g, p << 8 | m), g += 4;
                b++;
            }
            E < f.length ? (v = A, setTimeout(convert, $8225ba78123222c8$var$r._dly)) : t1(h);
        }();
    },
    toBlob (e, t1) {
        this.toArrayBuffer(e, (e)=>{
            t1(new Blob([
                e
            ], {
                type: "image/bmp"
            }));
        });
    },
    _dly: 9
};
var $8225ba78123222c8$var$i = {
    CHROME: "CHROME",
    FIREFOX: "FIREFOX",
    DESKTOP_SAFARI: "DESKTOP_SAFARI",
    IE: "IE",
    IOS: "IOS",
    ETC: "ETC"
}, $8225ba78123222c8$var$o = {
    [$8225ba78123222c8$var$i.CHROME]: 16384,
    [$8225ba78123222c8$var$i.FIREFOX]: 11180,
    [$8225ba78123222c8$var$i.DESKTOP_SAFARI]: 16384,
    [$8225ba78123222c8$var$i.IE]: 8192,
    [$8225ba78123222c8$var$i.IOS]: 4096,
    [$8225ba78123222c8$var$i.ETC]: 8192
};
const $8225ba78123222c8$var$a = "undefined" != typeof window, $8225ba78123222c8$var$s = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, $8225ba78123222c8$var$f = $8225ba78123222c8$var$a && window.cordova && window.cordova.require && window.cordova.require("cordova/modulemapper"), $8225ba78123222c8$var$CustomFile = ($8225ba78123222c8$var$a || $8225ba78123222c8$var$s) && ($8225ba78123222c8$var$f && $8225ba78123222c8$var$f.getOriginalSymbol(window, "File") || "undefined" != typeof File && File), $8225ba78123222c8$var$CustomFileReader = ($8225ba78123222c8$var$a || $8225ba78123222c8$var$s) && ($8225ba78123222c8$var$f && $8225ba78123222c8$var$f.getOriginalSymbol(window, "FileReader") || "undefined" != typeof FileReader && FileReader);
function $8225ba78123222c8$var$getFilefromDataUrl(e, t1, r = Date.now()) {
    return new Promise((i)=>{
        const o = e.split(","), a = o[0].match(/:(.*?);/)[1], s = globalThis.atob(o[1]);
        let f = s.length;
        const l = new Uint8Array(f);
        for(; f--;)l[f] = s.charCodeAt(f);
        const c = new Blob([
            l
        ], {
            type: a
        });
        c.name = t1, c.lastModified = r, i(c);
    });
}
function $8225ba78123222c8$var$getDataUrlFromFile(e) {
    return new Promise((t1, r)=>{
        const i = new $8225ba78123222c8$var$CustomFileReader;
        i.onload = ()=>t1(i.result), i.onerror = (e)=>r(e), i.readAsDataURL(e);
    });
}
function $8225ba78123222c8$var$loadImage(e) {
    return new Promise((t1, r)=>{
        const i = new Image;
        i.onload = ()=>t1(i), i.onerror = (e)=>r(e), i.src = e;
    });
}
function $8225ba78123222c8$var$getBrowserName() {
    if (void 0 !== $8225ba78123222c8$var$getBrowserName.cachedResult) return $8225ba78123222c8$var$getBrowserName.cachedResult;
    let e = $8225ba78123222c8$var$i.ETC;
    const { userAgent: t1 } = navigator;
    return /Chrom(e|ium)/i.test(t1) ? e = $8225ba78123222c8$var$i.CHROME : /iP(ad|od|hone)/i.test(t1) && /WebKit/i.test(t1) ? e = $8225ba78123222c8$var$i.IOS : /Safari/i.test(t1) ? e = $8225ba78123222c8$var$i.DESKTOP_SAFARI : /Firefox/i.test(t1) ? e = $8225ba78123222c8$var$i.FIREFOX : (/MSIE/i.test(t1) || !0 == !!document.documentMode) && (e = $8225ba78123222c8$var$i.IE), $8225ba78123222c8$var$getBrowserName.cachedResult = e, $8225ba78123222c8$var$getBrowserName.cachedResult;
}
function $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser(e, t1) {
    const r = $8225ba78123222c8$var$getBrowserName(), i = $8225ba78123222c8$var$o[r];
    let a = e, s = t1, f = a * s;
    const l = a > s ? s / a : a / s;
    for(; f > i * i;){
        const e = (i + a) / 2, t1 = (i + s) / 2;
        e < t1 ? (s = t1, a = t1 * l) : (s = e * l, a = e), f = a * s;
    }
    return {
        width: a,
        height: s
    };
}
function $8225ba78123222c8$var$getNewCanvasAndCtx(e, t1) {
    let r, i;
    try {
        if (r = new OffscreenCanvas(e, t1), i = r.getContext("2d"), null === i) throw new Error("getContext of OffscreenCanvas returns null");
    } catch (e) {
        r = document.createElement("canvas"), i = r.getContext("2d");
    }
    return r.width = e, r.height = t1, [
        r,
        i
    ];
}
function $8225ba78123222c8$var$drawImageInCanvas(e, t1) {
    const { width: r, height: i } = $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser(e.width, e.height), [o, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i);
    return t1 && /jpe?g/.test(t1) && (a.fillStyle = "white", a.fillRect(0, 0, o.width, o.height)), a.drawImage(e, 0, 0, o.width, o.height), o;
}
function $8225ba78123222c8$var$isIOS() {
    return void 0 !== $8225ba78123222c8$var$isIOS.cachedResult || ($8225ba78123222c8$var$isIOS.cachedResult = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "undefined" != typeof document && "ontouchend" in document), $8225ba78123222c8$var$isIOS.cachedResult;
}
function $8225ba78123222c8$var$drawFileInCanvas(e, t1 = {}) {
    return new Promise(function(r, o) {
        let a, s;
        var $Try_2_Post = function() {
            try {
                return s = $8225ba78123222c8$var$drawImageInCanvas(a, t1.fileType || e.type), r([
                    a,
                    s
                ]);
            } catch (e) {
                return o(e);
            }
        }, $Try_2_Catch = function(t1) {
            try {
                var $Try_3_Catch = function(e) {
                    try {
                        throw e;
                    } catch (e) {
                        return o(e);
                    }
                };
                try {
                    let t1;
                    return $8225ba78123222c8$var$getDataUrlFromFile(e).then(function(e) {
                        try {
                            return t1 = e, $8225ba78123222c8$var$loadImage(t1).then(function(e) {
                                try {
                                    return a = e, function() {
                                        try {
                                            return $Try_2_Post();
                                        } catch (e) {
                                            return o(e);
                                        }
                                    }();
                                } catch (e) {
                                    return $Try_3_Catch(e);
                                }
                            }, $Try_3_Catch);
                        } catch (e) {
                            return $Try_3_Catch(e);
                        }
                    }, $Try_3_Catch);
                } catch (e) {
                    $Try_3_Catch(e);
                }
            } catch (e) {
                return o(e);
            }
        };
        try {
            if ($8225ba78123222c8$var$isIOS() || [
                $8225ba78123222c8$var$i.DESKTOP_SAFARI,
                $8225ba78123222c8$var$i.MOBILE_SAFARI
            ].includes($8225ba78123222c8$var$getBrowserName())) throw new Error("Skip createImageBitmap on IOS and Safari");
            return createImageBitmap(e).then(function(e) {
                try {
                    return a = e, $Try_2_Post();
                } catch (e) {
                    return $Try_2_Catch();
                }
            }, $Try_2_Catch);
        } catch (e) {
            $Try_2_Catch();
        }
    });
}
function $8225ba78123222c8$var$canvasToFile(e, t1, i, o, a = 1) {
    return new Promise(function(s, f) {
        let l;
        if ("image/png" === t1) {
            let c, u, h;
            return c = e.getContext("2d"), { data: u } = c.getImageData(0, 0, e.width, e.height), h = $8225ba78123222c8$var$UPNG.encode([
                u.buffer
            ], e.width, e.height, 4096 * a), l = new Blob([
                h
            ], {
                type: t1
            }), l.name = i, l.lastModified = o, $If_4.call(this);
        }
        {
            if ("image/bmp" === t1) return new Promise((t1)=>$8225ba78123222c8$var$r.toBlob(e, t1)).then((function(e) {
                try {
                    return l = e, l.name = i, l.lastModified = o, $If_5.call(this);
                } catch (e) {
                    return f(e);
                }
            }).bind(this), f);
            {
                if ("function" == typeof OffscreenCanvas && e instanceof OffscreenCanvas) return e.convertToBlob({
                    type: t1,
                    quality: a
                }).then((function(e) {
                    try {
                        return l = e, l.name = i, l.lastModified = o, $If_6.call(this);
                    } catch (e) {
                        return f(e);
                    }
                }).bind(this), f);
                {
                    let d;
                    return d = e.toDataURL(t1, a), $8225ba78123222c8$var$getFilefromDataUrl(d, i, o).then((function(e) {
                        try {
                            return l = e, $If_6.call(this);
                        } catch (e) {
                            return f(e);
                        }
                    }).bind(this), f);
                }
                function $If_6() {
                    return $If_5.call(this);
                }
            }
            function $If_5() {
                return $If_4.call(this);
            }
        }
        function $If_4() {
            return s(l);
        }
    });
}
function $8225ba78123222c8$var$cleanupCanvasMemory(e) {
    e.width = 0, e.height = 0;
}
function $8225ba78123222c8$var$isAutoOrientationInBrowser() {
    return new Promise(function(e, t1) {
        let r, i, o, a, s;
        return void 0 !== $8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult ? e($8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult) : (r = "data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", $8225ba78123222c8$var$getFilefromDataUrl("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", "test.jpg", Date.now()).then(function(r) {
            try {
                return i = r, $8225ba78123222c8$var$drawFileInCanvas(i).then(function(r) {
                    try {
                        return o = r[1], $8225ba78123222c8$var$canvasToFile(o, i.type, i.name, i.lastModified).then(function(r) {
                            try {
                                return a = r, $8225ba78123222c8$var$cleanupCanvasMemory(o), $8225ba78123222c8$var$drawFileInCanvas(a).then(function(r) {
                                    try {
                                        return s = r[0], $8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult = 1 === s.width && 2 === s.height, e($8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult);
                                    } catch (e) {
                                        return t1(e);
                                    }
                                }, t1);
                            } catch (e) {
                                return t1(e);
                            }
                        }, t1);
                    } catch (e) {
                        return t1(e);
                    }
                }, t1);
            } catch (e) {
                return t1(e);
            }
        }, t1));
    });
}
function $8225ba78123222c8$var$getExifOrientation(e) {
    return new Promise((t1, r)=>{
        const i = new $8225ba78123222c8$var$CustomFileReader;
        i.onload = (e)=>{
            const r = new DataView(e.target.result);
            if (65496 != r.getUint16(0, !1)) return t1(-2);
            const i = r.byteLength;
            let o = 2;
            for(; o < i;){
                if (r.getUint16(o + 2, !1) <= 8) return t1(-1);
                const e = r.getUint16(o, !1);
                if (o += 2, 65505 == e) {
                    if (1165519206 != r.getUint32(o += 2, !1)) return t1(-1);
                    const e = 18761 == r.getUint16(o += 6, !1);
                    o += r.getUint32(o + 4, e);
                    const i = r.getUint16(o, e);
                    o += 2;
                    for(let a = 0; a < i; a++)if (274 == r.getUint16(o + 12 * a, e)) return t1(r.getUint16(o + 12 * a + 8, e));
                } else {
                    if (65280 != (65280 & e)) break;
                    o += r.getUint16(o, !1);
                }
            }
            return t1(-1);
        }, i.onerror = (e)=>r(e), i.readAsArrayBuffer(e);
    });
}
function $8225ba78123222c8$var$handleMaxWidthOrHeight(e, t1) {
    const { width: r } = e, { height: i } = e, { maxWidthOrHeight: o } = t1;
    let a, s = e;
    return isFinite(o) && (r > o || i > o) && ([s, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i), r > i ? (s.width = o, s.height = i / r * o) : (s.width = r / i * o, s.height = o), a.drawImage(e, 0, 0, s.width, s.height), $8225ba78123222c8$var$cleanupCanvasMemory(e)), s;
}
function $8225ba78123222c8$var$followExifOrientation(e, t1) {
    const { width: r } = e, { height: i } = e, [o, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i);
    switch(t1 > 4 && t1 < 9 ? (o.width = i, o.height = r) : (o.width = r, o.height = i), t1){
        case 2:
            a.transform(-1, 0, 0, 1, r, 0);
            break;
        case 3:
            a.transform(-1, 0, 0, -1, r, i);
            break;
        case 4:
            a.transform(1, 0, 0, -1, 0, i);
            break;
        case 5:
            a.transform(0, 1, 1, 0, 0, 0);
            break;
        case 6:
            a.transform(0, 1, -1, 0, i, 0);
            break;
        case 7:
            a.transform(0, -1, -1, 0, i, r);
            break;
        case 8:
            a.transform(0, -1, 1, 0, 0, r);
    }
    return a.drawImage(e, 0, 0, r, i), $8225ba78123222c8$var$cleanupCanvasMemory(e), o;
}
function $8225ba78123222c8$var$compress(e, t1, r = 0) {
    return new Promise(function(i, o) {
        let a, s, f, l, c, u, h, d, A, g, p, m, w, v, b, y, E, F, _, B;
        function incProgress(e = 5) {
            if (t1.signal && t1.signal.aborted) throw t1.signal.reason;
            a += e, t1.onProgress(Math.min(a, 100));
        }
        function setProgress(e) {
            if (t1.signal && t1.signal.aborted) throw t1.signal.reason;
            a = Math.min(Math.max(e, a), 100), t1.onProgress(a);
        }
        return a = r, s = t1.maxIteration || 10, f = 1024 * t1.maxSizeMB * 1024, incProgress(), $8225ba78123222c8$var$drawFileInCanvas(e, t1).then((function(r) {
            try {
                return [, l] = r, incProgress(), c = $8225ba78123222c8$var$handleMaxWidthOrHeight(l, t1), incProgress(), new Promise(function(r, i) {
                    var o;
                    if (!(o = t1.exifOrientation)) return $8225ba78123222c8$var$getExifOrientation(e).then((function(e) {
                        try {
                            return o = e, $If_2.call(this);
                        } catch (e) {
                            return i(e);
                        }
                    }).bind(this), i);
                    function $If_2() {
                        return r(o);
                    }
                    return $If_2.call(this);
                }).then((function(r) {
                    try {
                        return u = r, incProgress(), $8225ba78123222c8$var$isAutoOrientationInBrowser().then((function(r) {
                            try {
                                return h = r ? c : $8225ba78123222c8$var$followExifOrientation(c, u), incProgress(), d = t1.initialQuality || 1, A = t1.fileType || e.type, $8225ba78123222c8$var$canvasToFile(h, A, e.name, e.lastModified, d).then((function(r) {
                                    try {
                                        {
                                            if (g = r, incProgress(), p = g.size > f, m = g.size > e.size, !p && !m) return setProgress(100), i(g);
                                            var a;
                                            function $Loop_3() {
                                                if (s-- && (b > f || b > w)) {
                                                    let t1, r;
                                                    return t1 = B ? .95 * _.width : _.width, r = B ? .95 * _.height : _.height, [E, F] = $8225ba78123222c8$var$getNewCanvasAndCtx(t1, r), F.drawImage(_, 0, 0, t1, r), d *= "image/png" === A ? .85 : .95, $8225ba78123222c8$var$canvasToFile(E, A, e.name, e.lastModified, d).then(function(e) {
                                                        try {
                                                            return y = e, $8225ba78123222c8$var$cleanupCanvasMemory(_), _ = E, b = y.size, setProgress(Math.min(99, Math.floor((v - b) / (v - f) * 100))), $Loop_3;
                                                        } catch (e) {
                                                            return o(e);
                                                        }
                                                    }, o);
                                                }
                                                return [
                                                    1
                                                ];
                                            }
                                            return w = e.size, v = g.size, b = v, _ = h, B = !t1.alwaysKeepResolution && p, (a = (function(e) {
                                                for(; e;){
                                                    if (e.then) return void e.then(a, o);
                                                    try {
                                                        if (e.pop) {
                                                            if (e.length) return e.pop() ? $Loop_3_exit.call(this) : e;
                                                            e = $Loop_3;
                                                        } else e = e.call(this);
                                                    } catch (e) {
                                                        return o(e);
                                                    }
                                                }
                                            }).bind(this))($Loop_3);
                                            function $Loop_3_exit() {
                                                return $8225ba78123222c8$var$cleanupCanvasMemory(_), $8225ba78123222c8$var$cleanupCanvasMemory(E), $8225ba78123222c8$var$cleanupCanvasMemory(c), $8225ba78123222c8$var$cleanupCanvasMemory(h), $8225ba78123222c8$var$cleanupCanvasMemory(l), setProgress(100), i(y);
                                            }
                                        }
                                    } catch (u) {
                                        return o(u);
                                    }
                                }).bind(this), o);
                            } catch (e) {
                                return o(e);
                            }
                        }).bind(this), o);
                    } catch (e) {
                        return o(e);
                    }
                }).bind(this), o);
            } catch (e) {
                return o(e);
            }
        }).bind(this), o);
    });
}
const $8225ba78123222c8$var$l = "\nlet scriptImported = false\nself.addEventListener('message', async (e) => {\n  const { file, id, imageCompressionLibUrl, options } = e.data\n  options.onProgress = (progress) => self.postMessage({ progress, id })\n  try {\n    if (!scriptImported) {\n      // console.log('[worker] importScripts', imageCompressionLibUrl)\n      self.importScripts(imageCompressionLibUrl)\n      scriptImported = true\n    }\n    // console.log('[worker] self', self)\n    const compressedFile = await imageCompression(file, options)\n    self.postMessage({ file: compressedFile, id })\n  } catch (e) {\n    // console.error('[worker] error', e)\n    self.postMessage({ error: e.message + '\\n' + e.stack, id })\n  }\n})\n";
let $8225ba78123222c8$var$c;
function $8225ba78123222c8$var$compressOnWebWorker(e, t1) {
    return new Promise((r, i)=>{
        $8225ba78123222c8$var$c || ($8225ba78123222c8$var$c = function createWorkerScriptURL(e) {
            const t1 = [];
            return "function" == typeof e ? t1.push(`(${e})()`) : t1.push(e), URL.createObjectURL(new Blob(t1));
        }($8225ba78123222c8$var$l));
        const o = new Worker($8225ba78123222c8$var$c);
        o.addEventListener("message", function handler(e) {
            if (t1.signal && t1.signal.aborted) o.terminate();
            else if (void 0 === e.data.progress) {
                if (e.data.error) return i(new Error(e.data.error)), void o.terminate();
                r(e.data.file), o.terminate();
            } else t1.onProgress(e.data.progress);
        }), o.addEventListener("error", i), t1.signal && t1.signal.addEventListener("abort", ()=>{
            i(t1.signal.reason), o.terminate();
        }), o.postMessage({
            file: e,
            imageCompressionLibUrl: t1.libURL,
            options: {
                ...t1,
                onProgress: void 0,
                signal: void 0
            }
        });
    });
}
function $8225ba78123222c8$export$2e2bcd8739ae039(e, t1) {
    return new Promise(function(r, i) {
        let o, a, s, f, l, c;
        if (o = {
            ...t1
        }, s = 0, { onProgress: f } = o, o.maxSizeMB = o.maxSizeMB || Number.POSITIVE_INFINITY, l = "boolean" != typeof o.useWebWorker || o.useWebWorker, delete o.useWebWorker, o.onProgress = (e)=>{
            s = e, "function" == typeof f && f(s);
        }, !(e instanceof Blob || e instanceof $8225ba78123222c8$var$CustomFile)) return i(new Error("The file given is not an instance of Blob or File"));
        if (!/^image/.test(e.type)) return i(new Error("The file given is not an image"));
        if (c = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, !l || "function" != typeof Worker || c) return $8225ba78123222c8$var$compress(e, o).then((function(e) {
            try {
                return a = e, $If_4.call(this);
            } catch (e) {
                return i(e);
            }
        }).bind(this), i);
        var u = (function() {
            try {
                return $If_4.call(this);
            } catch (e) {
                return i(e);
            }
        }).bind(this), $Try_1_Catch = function(t1) {
            try {
                return $8225ba78123222c8$var$compress(e, o).then(function(e) {
                    try {
                        return a = e, u();
                    } catch (e) {
                        return i(e);
                    }
                }, i);
            } catch (e) {
                return i(e);
            }
        };
        try {
            return o.libURL = o.libURL || "https://cdn.jsdelivr.net/npm/browser-image-compression@2.0.2/dist/browser-image-compression.js", $8225ba78123222c8$var$compressOnWebWorker(e, o).then(function(e) {
                try {
                    return a = e, u();
                } catch (e) {
                    return $Try_1_Catch();
                }
            }, $Try_1_Catch);
        } catch (e) {
            $Try_1_Catch();
        }
        function $If_4() {
            try {
                a.name = e.name, a.lastModified = e.lastModified;
            } catch (e) {}
            try {
                o.preserveExif && "image/jpeg" === e.type && (!o.fileType || o.fileType && o.fileType === e.type) && (a = $8225ba78123222c8$var$copyExifWithoutOrientation(e, a));
            } catch (e) {}
            return r(a);
        }
    });
}
$8225ba78123222c8$export$2e2bcd8739ae039.getDataUrlFromFile = $8225ba78123222c8$var$getDataUrlFromFile, $8225ba78123222c8$export$2e2bcd8739ae039.getFilefromDataUrl = $8225ba78123222c8$var$getFilefromDataUrl, $8225ba78123222c8$export$2e2bcd8739ae039.loadImage = $8225ba78123222c8$var$loadImage, $8225ba78123222c8$export$2e2bcd8739ae039.drawImageInCanvas = $8225ba78123222c8$var$drawImageInCanvas, $8225ba78123222c8$export$2e2bcd8739ae039.drawFileInCanvas = $8225ba78123222c8$var$drawFileInCanvas, $8225ba78123222c8$export$2e2bcd8739ae039.canvasToFile = $8225ba78123222c8$var$canvasToFile, $8225ba78123222c8$export$2e2bcd8739ae039.getExifOrientation = $8225ba78123222c8$var$getExifOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.handleMaxWidthOrHeight = $8225ba78123222c8$var$handleMaxWidthOrHeight, $8225ba78123222c8$export$2e2bcd8739ae039.followExifOrientation = $8225ba78123222c8$var$followExifOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.cleanupCanvasMemory = $8225ba78123222c8$var$cleanupCanvasMemory, $8225ba78123222c8$export$2e2bcd8739ae039.isAutoOrientationInBrowser = $8225ba78123222c8$var$isAutoOrientationInBrowser, $8225ba78123222c8$export$2e2bcd8739ae039.approximateBelowMaximumCanvasSizeOfBrowser = $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser, $8225ba78123222c8$export$2e2bcd8739ae039.copyExifWithoutOrientation = $8225ba78123222c8$var$copyExifWithoutOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.getBrowserName = $8225ba78123222c8$var$getBrowserName, $8225ba78123222c8$export$2e2bcd8739ae039.version = "2.0.2";

});


parcelRegister("4YG7V", function(module, exports) {
"use strict";
var $39fd71891747cd45$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOutsideClick = void 0;

const $39fd71891747cd45$var$react_1 = $39fd71891747cd45$var$__importDefault((parcelRequire("acw62")));
const $39fd71891747cd45$var$useOutsideClick = (ref, callback)=>{
    $39fd71891747cd45$var$react_1.default.useEffect(()=>{
        /**
         * Alert if clicked on outside of element
         */ const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) callback();
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
};
module.exports.useOutsideClick = $39fd71891747cd45$var$useOutsideClick;

});

parcelRegister("ardto", function(module, exports) {
"use strict";
var $7996e07a5cdc6aeb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7996e07a5cdc6aeb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7996e07a5cdc6aeb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7996e07a5cdc6aeb$var$__createBinding(result, mod, k);
    }
    $7996e07a5cdc6aeb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInterval = void 0;

const $7996e07a5cdc6aeb$var$react_1 = $7996e07a5cdc6aeb$var$__importStar((parcelRequire("acw62")));
const $7996e07a5cdc6aeb$var$useInterval = (callback, delay)=>{
    const intervalId = $7996e07a5cdc6aeb$var$react_1.default.useRef(null);
    const savedCallback = $7996e07a5cdc6aeb$var$react_1.default.useRef(callback);
    (0, $7996e07a5cdc6aeb$var$react_1.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, $7996e07a5cdc6aeb$var$react_1.useEffect)(()=>{
        const tick = ()=>savedCallback.current();
        intervalId.current = window.setInterval(tick, delay);
        return ()=>window.clearInterval(intervalId.current);
    }, [
        delay
    ]);
    return intervalId.current;
};
module.exports.useInterval = $7996e07a5cdc6aeb$var$useInterval;

});

parcelRegister("iA21T", function(module, exports) {
"use strict";
var $d86d29d28942ec73$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePlayVideo = void 0;

const $d86d29d28942ec73$var$react_1 = $d86d29d28942ec73$var$__importDefault((parcelRequire("acw62")));
const $d86d29d28942ec73$var$usePlayVideo = (onVideoEnd, video, videoRef, interval)=>{
    $d86d29d28942ec73$var$react_1.default.useEffect(()=>{
        var _a;
        if (!!video && videoRef.current) {
            onVideoEnd();
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            (_a = videoRef.current) === null || _a === void 0 || _a.play().catch(()=>videoRef.current ? videoRef.current.pause() : null);
        }
        return ()=>{
            if (interval) // eslint-disable-next-line react-hooks/exhaustive-deps
            clearInterval(interval.current);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        video
    ]);
};
module.exports.usePlayVideo = $d86d29d28942ec73$var$usePlayVideo;

});

parcelRegister("1yxbR", function(module, exports) {
"use strict";
var $1222b64ef4432189$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDeletePressed = void 0;

const $1222b64ef4432189$var$react_1 = $1222b64ef4432189$var$__importDefault((parcelRequire("acw62")));
const $1222b64ef4432189$var$useDeletePressed = (ref, callback)=>{
    $1222b64ef4432189$var$react_1.default.useEffect(()=>{
        /**
         * Alert if delete pressed
         */ const handleDeletePressed = (event)=>{
            const isDeleteKey = event.key === "Delete" || event.key === "Backspace";
            if (isDeleteKey && ref.current && (ref.current === event.target || ref.current.contains(event.target))) callback();
        };
        // Bind the event listener
        document.addEventListener("keydown", handleDeletePressed);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener("keydown", handleDeletePressed);
        };
    });
};
module.exports.useDeletePressed = $1222b64ef4432189$var$useDeletePressed;

});

parcelRegister("a4ib3", function(module, exports) {
"use strict";
var $754860b9801397c4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgProvider = void 0;

const $754860b9801397c4$var$krg_provider_react_1 = $754860b9801397c4$var$__importDefault((parcelRequire("kDyjg")));
module.exports.KrgProvider = $754860b9801397c4$var$krg_provider_react_1.default;

});
parcelRegister("kDyjg", function(module, exports) {
"use strict";
var $f0621061e641fd74$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0621061e641fd74$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f0621061e641fd74$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f0621061e641fd74$var$__createBinding(result, mod, k);
    }
    $f0621061e641fd74$var$__setModuleDefault(result, mod);
    return result;
};
var $f0621061e641fd74$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f0621061e641fd74$var$react_1 = $f0621061e641fd74$var$__importStar((parcelRequire("acw62")));

var $2BuCw = parcelRequire("2BuCw");
var $gRp5N = parcelRequire("gRp5N");

const $f0621061e641fd74$var$krg_provider_style_1 = $f0621061e641fd74$var$__importDefault((parcelRequire("2qk1E")));

var $4at3P = parcelRequire("4at3P");

var $6dtri = parcelRequire("6dtri");

const $f0621061e641fd74$var$KrgProvider = ({ children: children, theme: theme })=>{
    const demoFontFamily = localStorage.getItem($4at3P.STORE_KEY_FONT_FAMILY) || $6dtri.FONT_FAMILY_ENUM.colfax;
    const [fontFamily, setFontFamily] = (0, $f0621061e641fd74$var$react_1.useState)(demoFontFamily);
    const storageCallback = (e)=>{
        setFontFamily(localStorage.getItem($4at3P.STORE_KEY_FONT_FAMILY) || $6dtri.FONT_FAMILY_ENUM.colfax);
    };
    (0, $f0621061e641fd74$var$react_1.useEffect)(()=>{
        if (demoFontFamily) window.addEventListener("storage", storageCallback);
        return ()=>{
            if (demoFontFamily) window.removeEventListener("storage", storageCallback);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return $f0621061e641fd74$var$react_1.default.createElement($2BuCw.default, {
        injectFirst: true
    }, $f0621061e641fd74$var$react_1.default.createElement($gRp5N.default, {
        theme: theme ? theme : (0, $f0621061e641fd74$var$krg_provider_style_1.default)(fontFamily)
    }, children));
};
module.exports.default = $f0621061e641fd74$var$KrgProvider;

});
parcelRegister("2BuCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e56ca0825dc344f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $l7wW1 = parcelRequire("l7wW1");

var $a9M6v = parcelRequire("a9M6v");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
let $1e56ca0825dc344f$var$cache;
if (typeof document === "object") $1e56ca0825dc344f$var$cache = (0, $a9M6v.default)({
    key: "css",
    prepend: true
});
function $1e56ca0825dc344f$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $1e56ca0825dc344f$var$cache ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l7wW1.C), {
        value: $1e56ca0825dc344f$var$cache,
        children: children
    }) : children;
}
$1e56ca0825dc344f$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */ injectFirst: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $k8nJx = parcelRequire("k8nJx");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $8da5bfbbed271cd7$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("eGxWZ"))($k8nJx.isElement, $8da5bfbbed271cd7$var$throwOnDirectAccess);

});
parcelRegister("k8nJx", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9XjZK"));

});
parcelRegister("9XjZK", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $73f922543d406108$export$2b8d127b894957b9, (v) => $73f922543d406108$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $73f922543d406108$export$cea3a54a6425200c, (v) => $73f922543d406108$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $73f922543d406108$export$a7c73072b1a182ae, (v) => $73f922543d406108$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $73f922543d406108$export$9f27bc3417b4524d, (v) => $73f922543d406108$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $73f922543d406108$export$db77ccec0bb4ccac, (v) => $73f922543d406108$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $73f922543d406108$export$8392c0c9d3dcbd35, (v) => $73f922543d406108$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $73f922543d406108$export$ffb0004e005737fa, (v) => $73f922543d406108$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $73f922543d406108$export$b624eff549462981, (v) => $73f922543d406108$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $73f922543d406108$export$7897aa7841a5380c, (v) => $73f922543d406108$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $73f922543d406108$export$602eac185826482c, (v) => $73f922543d406108$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $73f922543d406108$export$e2c29f18771995cb, (v) => $73f922543d406108$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $73f922543d406108$export$5f8d39834fd61797, (v) => $73f922543d406108$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $73f922543d406108$export$74bf444e3cd11ea5, (v) => $73f922543d406108$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $73f922543d406108$export$92387174baf9b227, (v) => $73f922543d406108$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $73f922543d406108$export$ec112efeb987d9c6, (v) => $73f922543d406108$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $73f922543d406108$export$b706b080d889d2c9, (v) => $73f922543d406108$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $73f922543d406108$export$5be5a87408f70ddc, (v) => $73f922543d406108$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $73f922543d406108$export$45a5e7f76e0caa8d, (v) => $73f922543d406108$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $73f922543d406108$export$455c2e768291efa6, (v) => $73f922543d406108$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $73f922543d406108$export$9522e17588c12572, (v) => $73f922543d406108$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $73f922543d406108$export$2110ac352bb060b9, (v) => $73f922543d406108$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $73f922543d406108$export$56885ab8b9c456ab, (v) => $73f922543d406108$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $73f922543d406108$export$d927fcb6adf8f9de, (v) => $73f922543d406108$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $73f922543d406108$export$b82d16f27459e05a, (v) => $73f922543d406108$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $73f922543d406108$export$522c17b4f5e123e8, (v) => $73f922543d406108$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $73f922543d406108$export$1aabd8a0274ecfd6, (v) => $73f922543d406108$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $73f922543d406108$export$9b621391a187a31a, (v) => $73f922543d406108$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $73f922543d406108$export$f5bbd400c2f4426f, (v) => $73f922543d406108$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73f922543d406108$export$2b8d127b894957b9;
var $73f922543d406108$export$cea3a54a6425200c;
var $73f922543d406108$export$a7c73072b1a182ae;
var $73f922543d406108$export$9f27bc3417b4524d;
var $73f922543d406108$export$db77ccec0bb4ccac;
var $73f922543d406108$export$8392c0c9d3dcbd35;
var $73f922543d406108$export$ffb0004e005737fa;
var $73f922543d406108$export$b624eff549462981;
var $73f922543d406108$export$7897aa7841a5380c;
var $73f922543d406108$export$602eac185826482c;
var $73f922543d406108$export$e2c29f18771995cb;
var $73f922543d406108$export$5f8d39834fd61797;
var $73f922543d406108$export$74bf444e3cd11ea5;
var $73f922543d406108$export$92387174baf9b227;
var $73f922543d406108$export$ec112efeb987d9c6;
var $73f922543d406108$export$b706b080d889d2c9;
var $73f922543d406108$export$5be5a87408f70ddc;
var $73f922543d406108$export$45a5e7f76e0caa8d;
var $73f922543d406108$export$455c2e768291efa6;
var $73f922543d406108$export$9522e17588c12572;
var $73f922543d406108$export$2110ac352bb060b9;
var $73f922543d406108$export$56885ab8b9c456ab;
var $73f922543d406108$export$d927fcb6adf8f9de;
var $73f922543d406108$export$b82d16f27459e05a;
var $73f922543d406108$export$522c17b4f5e123e8;
var $73f922543d406108$export$1aabd8a0274ecfd6;
var $73f922543d406108$export$9b621391a187a31a;
var $73f922543d406108$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $73f922543d406108$export$2b8d127b894957b9 = AsyncMode;
    $73f922543d406108$export$cea3a54a6425200c = ConcurrentMode;
    $73f922543d406108$export$a7c73072b1a182ae = ContextConsumer;
    $73f922543d406108$export$9f27bc3417b4524d = ContextProvider;
    $73f922543d406108$export$db77ccec0bb4ccac = Element;
    $73f922543d406108$export$8392c0c9d3dcbd35 = ForwardRef;
    $73f922543d406108$export$ffb0004e005737fa = Fragment;
    $73f922543d406108$export$b624eff549462981 = Lazy;
    $73f922543d406108$export$7897aa7841a5380c = Memo;
    $73f922543d406108$export$602eac185826482c = Portal;
    $73f922543d406108$export$e2c29f18771995cb = Profiler;
    $73f922543d406108$export$5f8d39834fd61797 = StrictMode;
    $73f922543d406108$export$74bf444e3cd11ea5 = Suspense;
    $73f922543d406108$export$92387174baf9b227 = isAsyncMode;
    $73f922543d406108$export$ec112efeb987d9c6 = isConcurrentMode;
    $73f922543d406108$export$b706b080d889d2c9 = isContextConsumer;
    $73f922543d406108$export$5be5a87408f70ddc = isContextProvider;
    $73f922543d406108$export$45a5e7f76e0caa8d = isElement;
    $73f922543d406108$export$455c2e768291efa6 = isForwardRef;
    $73f922543d406108$export$9522e17588c12572 = isFragment;
    $73f922543d406108$export$2110ac352bb060b9 = isLazy;
    $73f922543d406108$export$56885ab8b9c456ab = isMemo;
    $73f922543d406108$export$d927fcb6adf8f9de = isPortal;
    $73f922543d406108$export$b82d16f27459e05a = isProfiler;
    $73f922543d406108$export$522c17b4f5e123e8 = isStrictMode;
    $73f922543d406108$export$1aabd8a0274ecfd6 = isSuspense;
    $73f922543d406108$export$9b621391a187a31a = isValidElementType;
    $73f922543d406108$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("eGxWZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $k8nJx = parcelRequire("k8nJx");

var $8coUR = parcelRequire("8coUR");

var $kZO5c = parcelRequire("kZO5c");

var $fQsEq = parcelRequire("fQsEq");

var $gwROR = parcelRequire("gwROR");
var $ab0f52c9db6f842e$var$printWarning = function() {};
$ab0f52c9db6f842e$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $kZO5c) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $ab0f52c9db6f842e$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$k8nJx.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $ab0f52c9db6f842e$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($fQsEq(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $kZO5c);
                if (checkerResult == null) return null;
                if (checkerResult.data && $fQsEq(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $8coUR({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($fQsEq(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $gwROR;
    ReactPropTypes.resetWarningCache = $gwROR.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});

parcelRegister("fQsEq", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("gwROR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c08961ea4c03f601$var$printWarning = function() {};

var $kZO5c = parcelRequire("kZO5c");
var $c08961ea4c03f601$var$loggedTypeFailures = {};

var $fQsEq = parcelRequire("fQsEq");
$c08961ea4c03f601$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $c08961ea4c03f601$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($fQsEq(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $kZO5c);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $c08961ea4c03f601$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $c08961ea4c03f601$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $c08961ea4c03f601$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $c08961ea4c03f601$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $c08961ea4c03f601$var$checkPropTypes.resetWarningCache = function() {
    $c08961ea4c03f601$var$loggedTypeFailures = {};
};
module.exports = $c08961ea4c03f601$var$checkPropTypes;

});



parcelRegister("l7wW1", function(module, exports) {

$parcel$export(module.exports, "a", () => $f603cc9427f570ab$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $f603cc9427f570ab$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $f603cc9427f570ab$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $f603cc9427f570ab$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $f603cc9427f570ab$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $f603cc9427f570ab$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $f603cc9427f570ab$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $f603cc9427f570ab$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $f603cc9427f570ab$export$407448d2b89b1813 = false;
var $f603cc9427f570ab$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $f603cc9427f570ab$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: "css"
}) : null);
var $f603cc9427f570ab$export$e7094788287c5e9b = $f603cc9427f570ab$var$EmotionCacheContext.Provider;
var $f603cc9427f570ab$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $acw62.useContext)($f603cc9427f570ab$var$EmotionCacheContext);
};
var $f603cc9427f570ab$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($f603cc9427f570ab$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$f603cc9427f570ab$export$23f2a1d2818174ef) $f603cc9427f570ab$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $acw62.useContext)($f603cc9427f570ab$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($f603cc9427f570ab$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $f603cc9427f570ab$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $f603cc9427f570ab$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7);
};
var $f603cc9427f570ab$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $f603cc9427f570ab$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $f603cc9427f570ab$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $f603cc9427f570ab$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $f603cc9427f570ab$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($f603cc9427f570ab$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $f603cc9427f570ab$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $f603cc9427f570ab$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $f603cc9427f570ab$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $f603cc9427f570ab$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($f603cc9427f570ab$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$f603cc9427f570ab$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $f603cc9427f570ab$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f603cc9427f570ab$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f603cc9427f570ab$var$Emotion = /* #__PURE__ */ $f603cc9427f570ab$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$f603cc9427f570ab$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($f603cc9427f570ab$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $f603cc9427f570ab$var$typePropName && !$f603cc9427f570ab$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($f603cc9427f570ab$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $f603cc9427f570ab$export$a9c23c6ac3fc3eca = $f603cc9427f570ab$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== "undefined";
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if ($76500f1a9bc57c92$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8Hm9c"));

});
parcelRegister("8Hm9c", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $655384e8331727f6$export$2b8d127b894957b9, (v) => $655384e8331727f6$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $655384e8331727f6$export$cea3a54a6425200c, (v) => $655384e8331727f6$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $655384e8331727f6$export$a7c73072b1a182ae, (v) => $655384e8331727f6$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $655384e8331727f6$export$9f27bc3417b4524d, (v) => $655384e8331727f6$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $655384e8331727f6$export$db77ccec0bb4ccac, (v) => $655384e8331727f6$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $655384e8331727f6$export$8392c0c9d3dcbd35, (v) => $655384e8331727f6$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $655384e8331727f6$export$ffb0004e005737fa, (v) => $655384e8331727f6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $655384e8331727f6$export$b624eff549462981, (v) => $655384e8331727f6$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $655384e8331727f6$export$7897aa7841a5380c, (v) => $655384e8331727f6$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $655384e8331727f6$export$602eac185826482c, (v) => $655384e8331727f6$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $655384e8331727f6$export$e2c29f18771995cb, (v) => $655384e8331727f6$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $655384e8331727f6$export$5f8d39834fd61797, (v) => $655384e8331727f6$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $655384e8331727f6$export$74bf444e3cd11ea5, (v) => $655384e8331727f6$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $655384e8331727f6$export$92387174baf9b227, (v) => $655384e8331727f6$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $655384e8331727f6$export$ec112efeb987d9c6, (v) => $655384e8331727f6$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $655384e8331727f6$export$b706b080d889d2c9, (v) => $655384e8331727f6$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $655384e8331727f6$export$5be5a87408f70ddc, (v) => $655384e8331727f6$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $655384e8331727f6$export$45a5e7f76e0caa8d, (v) => $655384e8331727f6$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $655384e8331727f6$export$455c2e768291efa6, (v) => $655384e8331727f6$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $655384e8331727f6$export$9522e17588c12572, (v) => $655384e8331727f6$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $655384e8331727f6$export$2110ac352bb060b9, (v) => $655384e8331727f6$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $655384e8331727f6$export$56885ab8b9c456ab, (v) => $655384e8331727f6$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $655384e8331727f6$export$d927fcb6adf8f9de, (v) => $655384e8331727f6$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $655384e8331727f6$export$b82d16f27459e05a, (v) => $655384e8331727f6$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $655384e8331727f6$export$522c17b4f5e123e8, (v) => $655384e8331727f6$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $655384e8331727f6$export$1aabd8a0274ecfd6, (v) => $655384e8331727f6$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $655384e8331727f6$export$9b621391a187a31a, (v) => $655384e8331727f6$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $655384e8331727f6$export$f5bbd400c2f4426f, (v) => $655384e8331727f6$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $655384e8331727f6$export$2b8d127b894957b9;
var $655384e8331727f6$export$cea3a54a6425200c;
var $655384e8331727f6$export$a7c73072b1a182ae;
var $655384e8331727f6$export$9f27bc3417b4524d;
var $655384e8331727f6$export$db77ccec0bb4ccac;
var $655384e8331727f6$export$8392c0c9d3dcbd35;
var $655384e8331727f6$export$ffb0004e005737fa;
var $655384e8331727f6$export$b624eff549462981;
var $655384e8331727f6$export$7897aa7841a5380c;
var $655384e8331727f6$export$602eac185826482c;
var $655384e8331727f6$export$e2c29f18771995cb;
var $655384e8331727f6$export$5f8d39834fd61797;
var $655384e8331727f6$export$74bf444e3cd11ea5;
var $655384e8331727f6$export$92387174baf9b227;
var $655384e8331727f6$export$ec112efeb987d9c6;
var $655384e8331727f6$export$b706b080d889d2c9;
var $655384e8331727f6$export$5be5a87408f70ddc;
var $655384e8331727f6$export$45a5e7f76e0caa8d;
var $655384e8331727f6$export$455c2e768291efa6;
var $655384e8331727f6$export$9522e17588c12572;
var $655384e8331727f6$export$2110ac352bb060b9;
var $655384e8331727f6$export$56885ab8b9c456ab;
var $655384e8331727f6$export$d927fcb6adf8f9de;
var $655384e8331727f6$export$b82d16f27459e05a;
var $655384e8331727f6$export$522c17b4f5e123e8;
var $655384e8331727f6$export$1aabd8a0274ecfd6;
var $655384e8331727f6$export$9b621391a187a31a;
var $655384e8331727f6$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $655384e8331727f6$export$2b8d127b894957b9 = AsyncMode;
    $655384e8331727f6$export$cea3a54a6425200c = ConcurrentMode;
    $655384e8331727f6$export$a7c73072b1a182ae = ContextConsumer;
    $655384e8331727f6$export$9f27bc3417b4524d = ContextProvider;
    $655384e8331727f6$export$db77ccec0bb4ccac = Element;
    $655384e8331727f6$export$8392c0c9d3dcbd35 = ForwardRef;
    $655384e8331727f6$export$ffb0004e005737fa = Fragment;
    $655384e8331727f6$export$b624eff549462981 = Lazy;
    $655384e8331727f6$export$7897aa7841a5380c = Memo;
    $655384e8331727f6$export$602eac185826482c = Portal;
    $655384e8331727f6$export$e2c29f18771995cb = Profiler;
    $655384e8331727f6$export$5f8d39834fd61797 = StrictMode;
    $655384e8331727f6$export$74bf444e3cd11ea5 = Suspense;
    $655384e8331727f6$export$92387174baf9b227 = isAsyncMode;
    $655384e8331727f6$export$ec112efeb987d9c6 = isConcurrentMode;
    $655384e8331727f6$export$b706b080d889d2c9 = isContextConsumer;
    $655384e8331727f6$export$5be5a87408f70ddc = isContextProvider;
    $655384e8331727f6$export$45a5e7f76e0caa8d = isElement;
    $655384e8331727f6$export$455c2e768291efa6 = isForwardRef;
    $655384e8331727f6$export$9522e17588c12572 = isFragment;
    $655384e8331727f6$export$2110ac352bb060b9 = isLazy;
    $655384e8331727f6$export$56885ab8b9c456ab = isMemo;
    $655384e8331727f6$export$d927fcb6adf8f9de = isPortal;
    $655384e8331727f6$export$b82d16f27459e05a = isProfiler;
    $655384e8331727f6$export$522c17b4f5e123e8 = isStrictMode;
    $655384e8331727f6$export$1aabd8a0274ecfd6 = isSuspense;
    $655384e8331727f6$export$9b621391a187a31a = isValidElementType;
    $655384e8331727f6$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== "undefined";
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, "-$&").toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== "undefined";
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7B2bR"));

});


parcelRegister("gRp5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4650f6dac4940cb$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $6WOpW = parcelRequire("6WOpW");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c4650f6dac4940cb$var$_excluded = [
    "theme"
];
function $c4650f6dac4940cb$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $1En50.default)(_ref, $c4650f6dac4940cb$var$_excluded);
    const scopedTheme = themeInput[0, $4jPsi.default];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6WOpW.default), (0, $8nd05.default)({}, props, {
        themeId: scopedTheme ? (0, $4jPsi.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}
$c4650f6dac4940cb$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]).isRequired
};

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("6WOpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ef44b883b4d7f9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $lT1cX = parcelRequire("lT1cX");
var $lYrbz = parcelRequire("lYrbz");

var $8mDZX = parcelRequire("8mDZX");
parcelRequire("jjlaj");
var $l7wW1 = parcelRequire("l7wW1");

var $2HliV = parcelRequire("2HliV");

var $58lXc = parcelRequire("58lXc");

var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $8nd05.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $8nd05.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $8nd05.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2HliV.default)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $lT1cX.default)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    if (upperTheme === null && typeof localTheme === "function" || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === "function") console.error([
        "MUI: You are providing a theme function prop to the ThemeProvider component:",
        "<ThemeProvider theme={outerTheme => outerTheme} />",
        "",
        "However, no outer theme is present.",
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join("\n"));
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lYrbz.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l7wW1.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58lXc.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
$50ef44b883b4d7f9$var$ThemeProvider.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]).isRequired,
    /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */ themeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
$50ef44b883b4d7f9$var$ThemeProvider.propTypes = (0, $8mDZX.default)($50ef44b883b4d7f9$var$ThemeProvider.propTypes);
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;

});
parcelRegister("lT1cX", function(module, exports) {

$parcel$export(module.exports, "default", () => $feefabedf550ce3f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fHPaR = parcelRequire("fHPaR");
function $feefabedf550ce3f$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $fHPaR.default));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useDebugValue(theme);
    return theme;
}

});
parcelRegister("fHPaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f2914bcc222460$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
$b6f2914bcc222460$var$ThemeContext.displayName = "ThemeContext";
var $b6f2914bcc222460$export$2e2bcd8739ae039 = $b6f2914bcc222460$var$ThemeContext;

});


parcelRegister("lYrbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff44a152eb20ab0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8mDZX = parcelRequire("8mDZX");

var $fHPaR = parcelRequire("fHPaR");

var $lT1cX = parcelRequire("lT1cX");

var $2NPLA = parcelRequire("2NPLA");

var $ayMG0 = parcelRequire("ayMG0");
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        if (!mergedTheme) console.error([
            "MUI: You should return an object from your theme function, i.e.",
            "<ThemeProvider theme={() => ({})} />"
        ].join("\n"));
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $lT1cX.default)();
    if (outerTheme === null && typeof localTheme === "function") console.error([
        "MUI: You are providing a theme function prop to the ThemeProvider component:",
        "<ThemeProvider theme={outerTheme => outerTheme} />",
        "",
        "However, no outer theme is present.",
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join("\n"));
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $2NPLA.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fHPaR.default).Provider, {
        value: theme,
        children: children
    });
}
$fff44a152eb20ab0$var$ThemeProvider.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]).isRequired
};
$fff44a152eb20ab0$var$ThemeProvider.propTypes = (0, $8mDZX.default)($fff44a152eb20ab0$var$ThemeProvider.propTypes);
var $fff44a152eb20ab0$export$2e2bcd8739ae039 = $fff44a152eb20ab0$var$ThemeProvider;

});
parcelRegister("8mDZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $616f679ce54fb161$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $616f679ce54fb161$var$specialProperty = "exact-prop: \u200B";
function $616f679ce54fb161$export$2e2bcd8739ae039(propTypes) {
    return (0, $8nd05.default)({}, propTypes, {
        [$616f679ce54fb161$var$specialProperty]: (props)=>{
            const unsupportedProps = Object.keys(props).filter((prop)=>!propTypes.hasOwnProperty(prop));
            if (unsupportedProps.length > 0) return new Error(`The following props are not supported: ${unsupportedProps.map((prop)=>`\`${prop}\``).join(", ")}. Please remove them.`);
            return null;
        }
    });
}

});

parcelRegister("2NPLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a8501e6e2f4912$export$2e2bcd8739ae039);
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $20a8501e6e2f4912$export$2e2bcd8739ae039 = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("l7wW1")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("l7wW1")).w);

var $l7wW1 = parcelRequire("l7wW1");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $l7wW1.h).call(props, "css")) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $l7wW1.E);
    createElementArgArray[1] = (0, $l7wW1.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $l7wW1.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $l7wW1.T)));
    if (!(0, $l7wW1.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $e0f035ab0866fe47$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $e0f035ab0866fe47$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $e0f035ab0866fe47$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $l7wW1.i) && res !== undefined) rules += res;
        }
        if (!(0, $l7wW1.i)) return rules;
    });
    if (!(0, $l7wW1.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $l7wW1.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $l7wW1.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $l7wW1.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $l7wW1.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2HliV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f701f7d1726bc9a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $l7wW1 = parcelRequire("l7wW1");
"use client";
function $1f701f7d1726bc9a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1f701f7d1726bc9a$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $l7wW1.T));
    return !contextTheme || $1f701f7d1726bc9a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1f701f7d1726bc9a$export$2e2bcd8739ae039 = $1f701f7d1726bc9a$var$useTheme;

});

parcelRegister("58lXc", function(module, exports) {

$parcel$export(module.exports, "useRtl", () => $3bcebab40d8ce666$export$b2dd014b6c321cb);
$parcel$export(module.exports, "default", () => $3bcebab40d8ce666$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");
const $3bcebab40d8ce666$var$_excluded = [
    "value"
];
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $1En50.default)(_ref, $3bcebab40d8ce666$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, (0, $8nd05.default)({
        value: value != null ? value : true
    }, props));
}
$3bcebab40d8ce666$var$RtlProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value != null ? value : false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;

});

parcelRegister("aMyfV", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $7d98f590ab80e73c$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $7d98f590ab80e73c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
$7d98f590ab80e73c$var$DefaultPropsProvider.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $8nd05.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $8nd05.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $8nd05.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("2qk1E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ijOKP = parcelRequire("ijOKP");
const $1c3d8b251f745758$var$defaultTheme = (selectedFontFamily)=>{
    let typography;
    if (selectedFontFamily) typography = {
        fontFamily: [
            selectedFontFamily,
            "Arial",
            "sans-serif"
        ].join(",")
    };
    return (0, $ijOKP.default)({
        typography: typography,
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920
            }
        }
    });
};
module.exports.default = $1c3d8b251f745758$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


var $3z1Ay = parcelRequire("3z1Ay");

var $kOOck = parcelRequire("kOOck");
var $9dZwz = parcelRequire("9dZwz");

var $6o2lr = parcelRequire("6o2lr");

var $4Cod0 = parcelRequire("4Cod0");

var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");
const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    if (options.vars) throw new Error(`MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.`);
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $6o2lr.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $lhXgK.default))
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    {
        // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
        const stateClasses = [
            "active",
            "checked",
            "completed",
            "disabled",
            "error",
            "expanded",
            "focused",
            "focusVisible",
            "required",
            "selected"
        ];
        const traverse = (node, component)=>{
            let key;
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for(key in node){
                const child = node[key];
                if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
                    {
                        const stateClass = (0, $4Cod0.default)("", key);
                        console.error([
                            `MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`,
                            "You can not override it like this: ",
                            JSON.stringify(node, null, 2),
                            "",
                            `Instead, you need to use the '&.${stateClass}' syntax:`,
                            JSON.stringify({
                                root: {
                                    [`&.${stateClass}`]: child
                                }
                            }, null, 2),
                            "",
                            "https://mui.com/r/state-classes-guide"
                        ].join("\n"));
                    }
                    // Remove the style to prevent global conflicts.
                    node[key] = {};
                }
            }
        };
        Object.keys(muiTheme.components).forEach((component)=>{
            const styleOverrides = muiTheme.components[component].styleOverrides;
            if (styleOverrides && component.indexOf("Mui") === 0) traverse(styleOverrides, component);
        });
    }
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    if (!$d5615f18e5cd04fc$var$warnedOnce) {
        $d5615f18e5cd04fc$var$warnedOnce = true;
        console.error([
            "MUI: the createMuiTheme function was renamed to createTheme.",
            "",
            "You should use `import { createTheme } from '@mui/material/styles'`"
        ].join("\n"));
    }
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;

});
parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (!$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("kOOck", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27f6a6c429b3415$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");

var $jxD4j = parcelRequire("jxD4j");

var $nZvud = parcelRequire("nZvud");

var $8ru1G = parcelRequire("8ru1G");

var $imjyU = parcelRequire("imjyU");
const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $jxD4j.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $jxD4j.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $jxD4j.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $jxD4j.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $jxD4j.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $jxD4j.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $jxD4j.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $8ru1G.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $8ru1G.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $8ru1G.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $cKRCq.padding)
    },
    pt: {
        style: (0, $cKRCq.padding)
    },
    pr: {
        style: (0, $cKRCq.padding)
    },
    pb: {
        style: (0, $cKRCq.padding)
    },
    pl: {
        style: (0, $cKRCq.padding)
    },
    px: {
        style: (0, $cKRCq.padding)
    },
    py: {
        style: (0, $cKRCq.padding)
    },
    padding: {
        style: (0, $cKRCq.padding)
    },
    paddingTop: {
        style: (0, $cKRCq.padding)
    },
    paddingRight: {
        style: (0, $cKRCq.padding)
    },
    paddingBottom: {
        style: (0, $cKRCq.padding)
    },
    paddingLeft: {
        style: (0, $cKRCq.padding)
    },
    paddingX: {
        style: (0, $cKRCq.padding)
    },
    paddingY: {
        style: (0, $cKRCq.padding)
    },
    paddingInline: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineStart: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineEnd: {
        style: (0, $cKRCq.padding)
    },
    paddingBlock: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockStart: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockEnd: {
        style: (0, $cKRCq.padding)
    },
    m: {
        style: (0, $cKRCq.margin)
    },
    mt: {
        style: (0, $cKRCq.margin)
    },
    mr: {
        style: (0, $cKRCq.margin)
    },
    mb: {
        style: (0, $cKRCq.margin)
    },
    ml: {
        style: (0, $cKRCq.margin)
    },
    mx: {
        style: (0, $cKRCq.margin)
    },
    my: {
        style: (0, $cKRCq.margin)
    },
    margin: {
        style: (0, $cKRCq.margin)
    },
    marginTop: {
        style: (0, $cKRCq.margin)
    },
    marginRight: {
        style: (0, $cKRCq.margin)
    },
    marginBottom: {
        style: (0, $cKRCq.margin)
    },
    marginLeft: {
        style: (0, $cKRCq.margin)
    },
    marginX: {
        style: (0, $cKRCq.margin)
    },
    marginY: {
        style: (0, $cKRCq.margin)
    },
    marginInline: {
        style: (0, $cKRCq.margin)
    },
    marginInlineStart: {
        style: (0, $cKRCq.margin)
    },
    marginInlineEnd: {
        style: (0, $cKRCq.margin)
    },
    marginBlock: {
        style: (0, $cKRCq.margin)
    },
    marginBlockStart: {
        style: (0, $cKRCq.margin)
    },
    marginBlockEnd: {
        style: (0, $cKRCq.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $nZvud.gap)
    },
    rowGap: {
        style: (0, $nZvud.rowGap)
    },
    columnGap: {
        style: (0, $nZvud.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxWidth: {
        style: (0, $imjyU.maxWidth)
    },
    minWidth: {
        transform: (0, $imjyU.sizingTransform)
    },
    height: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    minHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;

});
parcelRegister("cKRCq", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $94935f79a2c44a85$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $94935f79a2c44a85$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $94935f79a2c44a85$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $94935f79a2c44a85$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $94935f79a2c44a85$export$6f98e8eaf0be1996);

var $4eUVS = parcelRequire("4eUVS");

var $3OJTQ = parcelRequire("3OJTQ");

var $k0igC = parcelRequire("k0igC");

var $aFh0N = parcelRequire("aFh0N");

var $hsAPr = parcelRequire("hsAPr");
const $94935f79a2c44a85$var$properties = {
    m: "margin",
    p: "padding"
};
const $94935f79a2c44a85$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $94935f79a2c44a85$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $94935f79a2c44a85$var$getCssProperties = (0, $hsAPr.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($94935f79a2c44a85$var$aliases[prop]) prop = $94935f79a2c44a85$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $94935f79a2c44a85$var$properties[a];
    const direction = $94935f79a2c44a85$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $94935f79a2c44a85$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $94935f79a2c44a85$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $94935f79a2c44a85$var$spacingKeys = [
    ...$94935f79a2c44a85$export$aab52a0dde05ad8a,
    ...$94935f79a2c44a85$export$f8397d44f03ab6ad
];
function $94935f79a2c44a85$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $k0igC.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        if (typeof abs !== "number") console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        if (!Number.isInteger(abs)) console.error([
            `MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`
        ].join("\n"));
        else if (abs > themeSpacing.length - 1) console.error([
            `MUI: The value provided (${abs}) overflows.`,
            `The supported values are: ${JSON.stringify(themeSpacing)}.`,
            `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`
        ].join("\n"));
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    console.error([
        `MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`,
        "It should be a number, an array or a function."
    ].join("\n"));
    return ()=>undefined;
}
function $94935f79a2c44a85$export$1def6f833384e3d1(theme) {
    return $94935f79a2c44a85$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $94935f79a2c44a85$var$getCssProperties(prop);
    const styleFromPropValue = $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $94935f79a2c44a85$var$style(props, keys) {
    const transformer = $94935f79a2c44a85$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aFh0N.default), {});
}
function $94935f79a2c44a85$export$7ede87f9b603dd3c(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$aab52a0dde05ad8a);
}
$94935f79a2c44a85$export$7ede87f9b603dd3c.propTypes = $94935f79a2c44a85$export$aab52a0dde05ad8a.reduce((obj, key)=>{
    obj[key] = (0, $4eUVS.default);
    return obj;
}, {});
$94935f79a2c44a85$export$7ede87f9b603dd3c.filterProps = $94935f79a2c44a85$export$aab52a0dde05ad8a;
function $94935f79a2c44a85$export$6f98e8eaf0be1996(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$f8397d44f03ab6ad);
}
$94935f79a2c44a85$export$6f98e8eaf0be1996.propTypes = $94935f79a2c44a85$export$f8397d44f03ab6ad.reduce((obj, key)=>{
    obj[key] = (0, $4eUVS.default);
    return obj;
}, {});
$94935f79a2c44a85$export$6f98e8eaf0be1996.filterProps = $94935f79a2c44a85$export$f8397d44f03ab6ad;
function $94935f79a2c44a85$var$spacing(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$spacingKeys);
}
$94935f79a2c44a85$var$spacing.propTypes = $94935f79a2c44a85$var$spacingKeys.reduce((obj, key)=>{
    obj[key] = (0, $4eUVS.default);
    return obj;
}, {});
$94935f79a2c44a85$var$spacing.filterProps = $94935f79a2c44a85$var$spacingKeys;
var $94935f79a2c44a85$export$2e2bcd8739ae039 = $94935f79a2c44a85$var$spacing;

});
parcelRegister("4eUVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $3164a1db6d2c6969$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");
const $3164a1db6d2c6969$var$responsivePropType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
]);
var $3164a1db6d2c6969$export$2e2bcd8739ae039 = $3164a1db6d2c6969$var$responsivePropType;

});

parcelRegister("3OJTQ", function(module, exports) {

$parcel$export(module.exports, "values", () => $2c79a5510dec9b08$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $2c79a5510dec9b08$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $2c79a5510dec9b08$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $2c79a5510dec9b08$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $2c79a5510dec9b08$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $2c79a5510dec9b08$export$980e6a259d807490);

var $8nd05 = parcelRequire("8nd05");

var $c9Z8w = parcelRequire("c9Z8w");

var $3z1Ay = parcelRequire("3z1Ay");

var $aFh0N = parcelRequire("aFh0N");
const $2c79a5510dec9b08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2c79a5510dec9b08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$2c79a5510dec9b08$export$68c286be0e7e55b7[key]}px)`
};
function $2c79a5510dec9b08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2c79a5510dec9b08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2c79a5510dec9b08$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aFh0N.default)(base, extended);
    };
    newStyleFunction.propTypes = (0, $8nd05.default)({}, styleFunction.propTypes, {
        xs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        sm: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        md: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        lg: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        xl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    });
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2c79a5510dec9b08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2c79a5510dec9b08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $2c79a5510dec9b08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2c79a5510dec9b08$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2c79a5510dec9b08$export$2e2bcd8739ae039 = $2c79a5510dec9b08$var$breakpoints;

});
parcelRegister("aFh0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3aede628aa278f$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $7c3aede628aa278f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7c3aede628aa278f$export$2e2bcd8739ae039 = $7c3aede628aa278f$var$merge;

});


parcelRegister("k0igC", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $e901fa2f27580273$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $e901fa2f27580273$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $e901fa2f27580273$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $4eUVS = parcelRequire("4eUVS");

var $3OJTQ = parcelRequire("3OJTQ");
function $e901fa2f27580273$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e901fa2f27580273$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $e901fa2f27580273$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e901fa2f27580273$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {
        [prop]: (0, $4eUVS.default)
    };
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e901fa2f27580273$export$2e2bcd8739ae039 = $e901fa2f27580273$var$style;

});
parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error(`MUI: \`capitalize(string)\` expects a string argument.`);
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("hsAPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb619e97db430627$export$2e2bcd8739ae039);
function $cb619e97db430627$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jxD4j", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $e39f6794db8cf9ac$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $e39f6794db8cf9ac$export$7a57f79000377ca2);

var $4eUVS = parcelRequire("4eUVS");

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");
function $e39f6794db8cf9ac$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $e39f6794db8cf9ac$var$createBorderStyle(prop, transform) {
    return (0, $k0igC.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $e39f6794db8cf9ac$export$1edee58a52776cd9 = $e39f6794db8cf9ac$var$createBorderStyle("border", $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$f9a7b6bd24892946 = $e39f6794db8cf9ac$var$createBorderStyle("borderTop", $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$5abca33e6be905d2 = $e39f6794db8cf9ac$var$createBorderStyle("borderRight", $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e2ce9f12a980a822 = $e39f6794db8cf9ac$var$createBorderStyle("borderBottom", $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$47658cca1a909427 = $e39f6794db8cf9ac$var$createBorderStyle("borderLeft", $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e7fb0694ba2404fc = $e39f6794db8cf9ac$var$createBorderStyle("borderColor");
const $e39f6794db8cf9ac$export$126a92c968acdb85 = $e39f6794db8cf9ac$var$createBorderStyle("borderTopColor");
const $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e = $e39f6794db8cf9ac$var$createBorderStyle("borderRightColor");
const $e39f6794db8cf9ac$export$340b0327727f6d1a = $e39f6794db8cf9ac$var$createBorderStyle("borderBottomColor");
const $e39f6794db8cf9ac$export$60beef91a985b4bf = $e39f6794db8cf9ac$var$createBorderStyle("borderLeftColor");
const $e39f6794db8cf9ac$export$f9258c55612cbed7 = $e39f6794db8cf9ac$var$createBorderStyle("outline", $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$621fe586efeb64b9 = $e39f6794db8cf9ac$var$createBorderStyle("outlineColor");
const $e39f6794db8cf9ac$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.propTypes = {
    borderRadius: (0, $4eUVS.default)
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $e39f6794db8cf9ac$var$borders = (0, $gojsU.default)($e39f6794db8cf9ac$export$1edee58a52776cd9, $e39f6794db8cf9ac$export$f9a7b6bd24892946, $e39f6794db8cf9ac$export$5abca33e6be905d2, $e39f6794db8cf9ac$export$e2ce9f12a980a822, $e39f6794db8cf9ac$export$47658cca1a909427, $e39f6794db8cf9ac$export$e7fb0694ba2404fc, $e39f6794db8cf9ac$export$126a92c968acdb85, $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e, $e39f6794db8cf9ac$export$340b0327727f6d1a, $e39f6794db8cf9ac$export$60beef91a985b4bf, $e39f6794db8cf9ac$export$7a57f79000377ca2, $e39f6794db8cf9ac$export$f9258c55612cbed7, $e39f6794db8cf9ac$export$621fe586efeb64b9);
var $e39f6794db8cf9ac$export$2e2bcd8739ae039 = $e39f6794db8cf9ac$var$borders;

});
parcelRegister("gojsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $beedfc9d7e65f133$export$2e2bcd8739ae039);

var $aFh0N = parcelRequire("aFh0N");
function $beedfc9d7e65f133$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aFh0N.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = styles.reduce((acc, style)=>Object.assign(acc, style.propTypes), {});
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $beedfc9d7e65f133$export$2e2bcd8739ae039 = $beedfc9d7e65f133$var$compose;

});


parcelRegister("nZvud", function(module, exports) {

$parcel$export(module.exports, "gap", () => $0481dc1348188242$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $0481dc1348188242$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $0481dc1348188242$export$8a833ffa5f5dbeda);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");

var $4eUVS = parcelRequire("4eUVS");
const $0481dc1348188242$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$5df9adcb0db95e1e.propTypes = {
    gap: (0, $4eUVS.default)
};
$0481dc1348188242$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $0481dc1348188242$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$ec60d70ff941a580.propTypes = {
    columnGap: (0, $4eUVS.default)
};
$0481dc1348188242$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $0481dc1348188242$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$8a833ffa5f5dbeda.propTypes = {
    rowGap: (0, $4eUVS.default)
};
$0481dc1348188242$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $0481dc1348188242$export$baf44164ca3a34e8 = (0, $k0igC.default)({
    prop: "gridColumn"
});
const $0481dc1348188242$export$8f7213a1cd01e832 = (0, $k0igC.default)({
    prop: "gridRow"
});
const $0481dc1348188242$export$b0e0abbc49ba668 = (0, $k0igC.default)({
    prop: "gridAutoFlow"
});
const $0481dc1348188242$export$bcd8b929d4b4142 = (0, $k0igC.default)({
    prop: "gridAutoColumns"
});
const $0481dc1348188242$export$e5039a674e14c828 = (0, $k0igC.default)({
    prop: "gridAutoRows"
});
const $0481dc1348188242$export$42bd9088661ffb03 = (0, $k0igC.default)({
    prop: "gridTemplateColumns"
});
const $0481dc1348188242$export$920682ae05b999bc = (0, $k0igC.default)({
    prop: "gridTemplateRows"
});
const $0481dc1348188242$export$1b88fbdd482fd33a = (0, $k0igC.default)({
    prop: "gridTemplateAreas"
});
const $0481dc1348188242$export$bdb486e40d52d26f = (0, $k0igC.default)({
    prop: "gridArea"
});
const $0481dc1348188242$var$grid = (0, $gojsU.default)($0481dc1348188242$export$5df9adcb0db95e1e, $0481dc1348188242$export$ec60d70ff941a580, $0481dc1348188242$export$8a833ffa5f5dbeda, $0481dc1348188242$export$baf44164ca3a34e8, $0481dc1348188242$export$8f7213a1cd01e832, $0481dc1348188242$export$b0e0abbc49ba668, $0481dc1348188242$export$bcd8b929d4b4142, $0481dc1348188242$export$e5039a674e14c828, $0481dc1348188242$export$42bd9088661ffb03, $0481dc1348188242$export$920682ae05b999bc, $0481dc1348188242$export$1b88fbdd482fd33a, $0481dc1348188242$export$bdb486e40d52d26f);
var $0481dc1348188242$export$2e2bcd8739ae039 = $0481dc1348188242$var$grid;

});

parcelRegister("8ru1G", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $625822e5d7cce21a$export$dbaffd4420ea0ac6);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
function $625822e5d7cce21a$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $625822e5d7cce21a$export$35e9368ef982300f = (0, $k0igC.default)({
    prop: "color",
    themeKey: "palette",
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$2506f56c10355b33 = (0, $k0igC.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$8c5a050822fd698c = (0, $k0igC.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$var$palette = (0, $gojsU.default)($625822e5d7cce21a$export$35e9368ef982300f, $625822e5d7cce21a$export$2506f56c10355b33, $625822e5d7cce21a$export$8c5a050822fd698c);
var $625822e5d7cce21a$export$2e2bcd8739ae039 = $625822e5d7cce21a$var$palette;

});

parcelRegister("imjyU", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $d5d974b5976c38ad$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $d5d974b5976c38ad$export$488fda99655ff65a);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $3OJTQ = parcelRequire("3OJTQ");
function $d5d974b5976c38ad$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $d5d974b5976c38ad$export$7e3df82ee760448c = (0, $k0igC.default)({
    prop: "width",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $3OJTQ.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $d5d974b5976c38ad$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$d5d974b5976c38ad$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $d5d974b5976c38ad$export$ee148fbbe8357dd2 = (0, $k0igC.default)({
    prop: "minWidth",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ac607276a8fe9f0a = (0, $k0igC.default)({
    prop: "height",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$dc0d8bd0b94f8570 = (0, $k0igC.default)({
    prop: "maxHeight",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$a43cf604e12f3b17 = (0, $k0igC.default)({
    prop: "minHeight",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ffed9f14fb65e276 = (0, $k0igC.default)({
    prop: "size",
    cssProperty: "width",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$905076ed6620e671 = (0, $k0igC.default)({
    prop: "size",
    cssProperty: "height",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$6ccc93f785106a58 = (0, $k0igC.default)({
    prop: "boxSizing"
});
const $d5d974b5976c38ad$var$sizing = (0, $gojsU.default)($d5d974b5976c38ad$export$7e3df82ee760448c, $d5d974b5976c38ad$export$488fda99655ff65a, $d5d974b5976c38ad$export$ee148fbbe8357dd2, $d5d974b5976c38ad$export$ac607276a8fe9f0a, $d5d974b5976c38ad$export$dc0d8bd0b94f8570, $d5d974b5976c38ad$export$a43cf604e12f3b17, $d5d974b5976c38ad$export$6ccc93f785106a58);
var $d5d974b5976c38ad$export$2e2bcd8739ae039 = $d5d974b5976c38ad$var$sizing;

});


parcelRegister("9dZwz", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $6b750d631801d296$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $aFh0N = parcelRequire("aFh0N");

var $k0igC = parcelRequire("k0igC");

var $3OJTQ = parcelRequire("3OJTQ");

var $kOOck = parcelRequire("kOOck");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $k0igC.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $k0igC.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $k0igC.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $kOOck.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3OJTQ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $3OJTQ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $aFh0N.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $3OJTQ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    "sx"
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});

parcelRegister("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $dLM8u = parcelRequire("dLM8u");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");

var $9dZwz = parcelRequire("9dZwz");

var $kOOck = parcelRequire("kOOck");

var $2UDLz = parcelRequire("2UDLz");
const $4a66cd95e497efc7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $4a66cd95e497efc7$var$_excluded);
    const breakpoints = (0, $dLM8u.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $bVuw0.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2UDLz.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRegister("dLM8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06500f70819ed69$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $a06500f70819ed69$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a06500f70819ed69$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $a06500f70819ed69$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $a06500f70819ed69$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $a06500f70819ed69$var$_excluded);
    const sortedValues = $a06500f70819ed69$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRegister("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $cKRCq.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        if (!(argsInput.length <= 4)) console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("2UDLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21efa8802134c535$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});


parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


var $3z1Ay = parcelRequire("3z1Ay");

var $kSnzZ = parcelRequire("kSnzZ");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dzxhF.default).white,
        default: (0, $dzxhF.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dzxhF.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $dzxhF.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $kSnzZ.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $kSnzZ.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kSnzZ.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        {
            const contrast = (0, $kSnzZ.getContrastRatio)(background, contrastText);
            if (contrast < 3) console.error([
                `MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`,
                "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.",
                "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"
            ].join("\n"));
        }
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error(`MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.`);
        if (typeof color.main !== "string") throw new Error(`MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`);
        $368aaef25f6a2997$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    if (!modes[mode]) console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    const paletteOutput = (0, $3z1Ay.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $8nd05.default)({}, (0, $dzxhF.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kSnzZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f32b24353f12f45a$var$alpha;
module.exports.blend = $f32b24353f12f45a$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f32b24353f12f45a$var$darken;
module.exports.decomposeColor = $f32b24353f12f45a$var$decomposeColor;
module.exports.emphasize = $f32b24353f12f45a$var$emphasize;
module.exports.getContrastRatio = $f32b24353f12f45a$var$getContrastRatio;
module.exports.getLuminance = $f32b24353f12f45a$var$getLuminance;
module.exports.hexToRgb = $f32b24353f12f45a$var$hexToRgb;
module.exports.hslToRgb = $f32b24353f12f45a$var$hslToRgb;
module.exports.lighten = $f32b24353f12f45a$var$lighten;
module.exports.private_safeAlpha = $f32b24353f12f45a$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f32b24353f12f45a$var$private_safeDarken;
module.exports.private_safeEmphasize = $f32b24353f12f45a$var$private_safeEmphasize;
module.exports.private_safeLighten = $f32b24353f12f45a$var$private_safeLighten;
module.exports.recomposeColor = $f32b24353f12f45a$var$recomposeColor;
module.exports.rgbToHex = $f32b24353f12f45a$var$rgbToHex;

var $f32b24353f12f45a$var$_formatMuiErrorMessage2 = $1jnue((parcelRequire("dsPLe")));

var $f32b24353f12f45a$var$_clamp = $1jnue((parcelRequire("lYE9x")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f32b24353f12f45a$var$clampWrapper(value, min = 0, max = 1) {
    if (value < min || value > max) console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    return (0, $f32b24353f12f45a$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f32b24353f12f45a$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $f32b24353f12f45a$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f32b24353f12f45a$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error(`MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`);
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error(`MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`);
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f32b24353f12f45a$var$colorChannel = (color)=>{
    const decomposedColor = $f32b24353f12f45a$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $f32b24353f12f45a$var$colorChannel;
const $f32b24353f12f45a$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f32b24353f12f45a$var$colorChannel(color);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f32b24353f12f45a$var$private_safeColorChannel;
function $f32b24353f12f45a$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f32b24353f12f45a$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $f32b24353f12f45a$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f32b24353f12f45a$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f32b24353f12f45a$var$hslToRgb(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $f32b24353f12f45a$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f32b24353f12f45a$var$getLuminance(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f32b24353f12f45a$var$getContrastRatio(foreground, background) {
    const lumA = $f32b24353f12f45a$var$getLuminance(foreground);
    const lumB = $f32b24353f12f45a$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$alpha(color, value) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    value = $f32b24353f12f45a$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeAlpha(color, value, warning) {
    try {
        return $f32b24353f12f45a$var$alpha(color, value);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$darken(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$darken(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$lighten(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$lighten(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$emphasize(color, coefficient = 0.15) {
    return $f32b24353f12f45a$var$getLuminance(color) > 0.5 ? $f32b24353f12f45a$var$darken(color, coefficient) : $f32b24353f12f45a$var$lighten(color, coefficient);
}
function $f32b24353f12f45a$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$emphasize(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f32b24353f12f45a$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f32b24353f12f45a$var$decomposeColor(background);
    const overlayColor = $f32b24353f12f45a$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f32b24353f12f45a$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dsPLe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cpmCj")).default);

var $cpmCj = parcelRequire("cpmCj");

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});


parcelRegister("lYE9x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1jJMI")).default);

var $1jJMI = parcelRequire("1jJMI");

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});



parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: "#000",
    white: "#fff"
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    if (typeof fontSize !== "number") console.error("MUI: `fontSize` is required to be a number.");
    if (typeof htmlFontSize !== "number") console.error("MUI: `htmlFontSize` is required to be a number.");
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $3z1Ay.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    "none",
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "duration", () => $845514f3678d3888$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        {
            const isString = (value)=>typeof value === "string";
            // IE11 support, replace with Number.isNaN
            // eslint-disable-next-line no-restricted-globals
            const isNumber = (value)=>!isNaN(parseFloat(value));
            if (!isString(props) && !Array.isArray(props)) console.error('MUI: Argument "props" must be a string or Array.');
            if (!isNumber(durationOption) && !isString(durationOption)) console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
            if (!isString(easingOption)) console.error('MUI: Argument "easing" must be a string.');
            if (!isNumber(delay) && !isString(delay)) console.error('MUI: Argument "delay" must be a number or a string.');
            if (typeof options !== "object") console.error([
                "MUI: Secong argument of transition.create must be an object.",
                "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"
            ].join("\n"));
            if (Object.keys(other).length !== 0) console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(",")}].`);
        }
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(",");
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});





parcelRegister("gGasv", function(module, exports) {
"use strict";
var $c248ae7dac8165cc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgFontSelector = void 0;

const $c248ae7dac8165cc$var$krg_font_selector_react_1 = $c248ae7dac8165cc$var$__importDefault((parcelRequire("fi7rP")));
module.exports.KrgFontSelector = $c248ae7dac8165cc$var$krg_font_selector_react_1.default;

});
parcelRegister("fi7rP", function(module, exports) {
"use strict";
var $b21e50756b07e2d1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b21e50756b07e2d1$var$react_1 = $b21e50756b07e2d1$var$__importDefault((parcelRequire("acw62")));

var $i4KPV = parcelRequire("i4KPV");

var $6dtri = parcelRequire("6dtri");

var $4at3P = parcelRequire("4at3P");
const $b21e50756b07e2d1$var$KrgFontSelector = ({ setFontFamily: setFontFamily })=>{
    return $b21e50756b07e2d1$var$react_1.default.createElement($i4KPV.KrgStyleSelector, {
        label: "Select Font",
        options: [
            $6dtri.FONT_FAMILY_ENUM.colfax,
            $6dtri.FONT_FAMILY_ENUM.poppins
        ],
        storageKey: $4at3P.STORE_KEY_FONT_FAMILY,
        onChange: setFontFamily
    });
};
module.exports.default = $b21e50756b07e2d1$var$KrgFontSelector;

});
parcelRegister("i4KPV", function(module, exports) {
"use strict";
var $d28cee79069e03b6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d28cee79069e03b6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d28cee79069e03b6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d28cee79069e03b6$var$__exportStar((parcelRequire("4at3P")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("6dtri")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("eYYk9")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("gu4OS")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("58LUk")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("2mtV0")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("4YG7V")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("ardto")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("iA21T")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("1yxbR")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("a4ib3")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("gGasv")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("aPnuy")), module.exports);

$d28cee79069e03b6$var$__exportStar((parcelRequire("ebXhF")), module.exports);

});
parcelRegister("aPnuy", function(module, exports) {
"use strict";
var $7e20e3c360b83aa3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgThemeSelector = void 0;

const $7e20e3c360b83aa3$var$krg_theme_selector_react_1 = $7e20e3c360b83aa3$var$__importDefault((parcelRequire("hxlI1")));
module.exports.KrgThemeSelector = $7e20e3c360b83aa3$var$krg_theme_selector_react_1.default;

});
parcelRegister("hxlI1", function(module, exports) {
"use strict";
var $cc465bb2c40b6e57$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $cc465bb2c40b6e57$var$react_1 = $cc465bb2c40b6e57$var$__importDefault((parcelRequire("acw62")));

var $i4KPV = parcelRequire("i4KPV");

var $6dtri = parcelRequire("6dtri");

var $4at3P = parcelRequire("4at3P");
const $cc465bb2c40b6e57$var$KrgThemeSelector = ({ setTheme: setTheme })=>{
    return $cc465bb2c40b6e57$var$react_1.default.createElement($i4KPV.KrgStyleSelector, {
        label: "Select Theme",
        options: [
            $6dtri.THEME_ENUM.v1,
            $6dtri.THEME_ENUM.v2
        ],
        storageKey: $4at3P.STORE_KEY_THEME,
        onChange: setTheme
    });
};
module.exports.default = $cc465bb2c40b6e57$var$KrgThemeSelector;

});


parcelRegister("ebXhF", function(module, exports) {
"use strict";
var $a55014515cfe1f8c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgStyleSelector = void 0;

const $a55014515cfe1f8c$var$krg_style_selector_react_1 = $a55014515cfe1f8c$var$__importDefault((parcelRequire("2WIk7")));
module.exports.KrgStyleSelector = $a55014515cfe1f8c$var$krg_style_selector_react_1.default;

});
parcelRegister("2WIk7", function(module, exports) {
"use strict";
var $22536148ca59f4dc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $22536148ca59f4dc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $22536148ca59f4dc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $22536148ca59f4dc$var$__createBinding(result, mod, k);
    }
    $22536148ca59f4dc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $22536148ca59f4dc$var$react_1 = $22536148ca59f4dc$var$__importStar((parcelRequire("acw62")));

var $cX7V2 = parcelRequire("cX7V2");
var $2iAqv = parcelRequire("2iAqv");
const $22536148ca59f4dc$var$KrgStyleSelector = ({ label: label, options: options, storageKey: storageKey, onChange: onChange })=>{
    const [selectedValue, setSelectedValue] = (0, $22536148ca59f4dc$var$react_1.useState)(storageKey ? localStorage.getItem(storageKey) || options[0] : options[0]);
    (0, $22536148ca59f4dc$var$react_1.useEffect)(()=>{
        onChange(selectedValue);
        if (storageKey) {
            localStorage.setItem(storageKey, selectedValue);
            window.dispatchEvent(new Event("storage"));
        }
    }, [
        selectedValue,
        storageKey,
        onChange
    ]);
    return $22536148ca59f4dc$var$react_1.default.createElement("div", {
        style: {
            padding: "1em 1em 1em 0",
            display: "inline-block"
        }
    }, $22536148ca59f4dc$var$react_1.default.createElement($cX7V2.default, {
        name: label,
        value: selectedValue,
        style: {
            width: "200px",
            height: "36px",
            borderRadius: 0
        },
        onChange: ({ target: target })=>setSelectedValue(target.value)
    }, options.map((item)=>$22536148ca59f4dc$var$react_1.default.createElement($2iAqv.default, {
            key: item,
            value: item
        }, item))));
};
module.exports.default = $22536148ca59f4dc$var$KrgStyleSelector;

});
parcelRegister("cX7V2", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e1233e8d06bb2d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $c0lH6 = parcelRequire("c0lH6");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $7LRfY = parcelRequire("7LRfY");

var $ab7Se = parcelRequire("ab7Se");

var $iOErJ = parcelRequire("iOErJ");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");
parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");
var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $96e1233e8d06bb2d$var$_excluded2 = [
    "root"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== "variant",
    slot: "Root"
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $ab7Se.default), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $imehR.default), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $g4sO2.default), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7LRfY.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $iOErJ.default) : (0, $c0lH6.default);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $1En50.default)(classes, $96e1233e8d06bb2d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $9Rgf1.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $8nd05.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $8nd05.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$96e1233e8d06bb2d$var$Select.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   * @default {}
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */ input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */ native: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            ""
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "filled",
        "outlined",
        "standard"
    ])
};
$96e1233e8d06bb2d$var$Select.muiName = "Select";
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("c0lH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd650259be885cb$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $i582X = parcelRequire("i582X");

var $gzyUk = parcelRequire("gzyUk");

var $jTnBY = parcelRequire("jTnBY");

var $4F5tJ = parcelRequire("4F5tJ");

var $iOErJ = parcelRequire("iOErJ");

var $2BbKU = parcelRequire("2BbKU");

var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $bmfPX.default).select}`]: styles.select
            },
            {
                [`&.${(0, $bmfPX.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $bmfPX.default).error}`]: styles.error
            },
            {
                [`&.${(0, $bmfPX.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $iOErJ.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $bmfPX.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $iOErJ.nativeSelectIconStyles));
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)("input", {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $jTnBY.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bmfPX.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $9Rgf1.default)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $gzyUk.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2BbKU.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Select component doesn't accept a Fragment as a child.",
            "Consider providing an array instead."
        ].join("\n"));
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error(`MUI: The \`value\` prop must be an array when using the \`Select\` component with \`multiple\`.`);
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useEffect(()=>{
        if (!foundMatch && !multiple && value !== "") {
            const values = childrenArray.map((child)=>child.props.value);
            console.warn([
                `MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ""}component.`,
                "Consider providing a value that matches one of the available options or ''.",
                `The available values are ${values.filter((x)=>x != null).map((x)=>`\`${x}\``).join(", ") || '""'}.`
            ].join("\n"));
        }
    }, [
        foundMatch,
        childrenArray,
        multiple,
        name,
        value
    ]);
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = (0, $8nd05.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $auC0X.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), (0, $8nd05.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $8nd05.default)({}, MenuProps.slotProps, {
                    paper: (0, $8nd05.default)({}, paperProps, {
                        style: (0, $8nd05.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
$8bd650259be885cb$var$SelectInput.propTypes = {
    /**
   * @ignore
   */ "aria-describedby": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * If `true`, the select is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the selected item is displayed even if its value is empty.
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */ inputRef: (0, $i582X.default),
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "standard",
        "outlined",
        "filled"
    ])
};
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hkVY4"));

});
parcelRegister("hkVY4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $c9f145267881427c$export$a7c73072b1a182ae, (v) => $c9f145267881427c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c9f145267881427c$export$9f27bc3417b4524d, (v) => $c9f145267881427c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c9f145267881427c$export$db77ccec0bb4ccac, (v) => $c9f145267881427c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c9f145267881427c$export$8392c0c9d3dcbd35, (v) => $c9f145267881427c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c9f145267881427c$export$ffb0004e005737fa, (v) => $c9f145267881427c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c9f145267881427c$export$b624eff549462981, (v) => $c9f145267881427c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c9f145267881427c$export$7897aa7841a5380c, (v) => $c9f145267881427c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c9f145267881427c$export$602eac185826482c, (v) => $c9f145267881427c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c9f145267881427c$export$e2c29f18771995cb, (v) => $c9f145267881427c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c9f145267881427c$export$5f8d39834fd61797, (v) => $c9f145267881427c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c9f145267881427c$export$74bf444e3cd11ea5, (v) => $c9f145267881427c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $c9f145267881427c$export$998bcd577473dd93, (v) => $c9f145267881427c$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $c9f145267881427c$export$92387174baf9b227, (v) => $c9f145267881427c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $c9f145267881427c$export$ec112efeb987d9c6, (v) => $c9f145267881427c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c9f145267881427c$export$b706b080d889d2c9, (v) => $c9f145267881427c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c9f145267881427c$export$5be5a87408f70ddc, (v) => $c9f145267881427c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c9f145267881427c$export$45a5e7f76e0caa8d, (v) => $c9f145267881427c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c9f145267881427c$export$455c2e768291efa6, (v) => $c9f145267881427c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c9f145267881427c$export$9522e17588c12572, (v) => $c9f145267881427c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c9f145267881427c$export$2110ac352bb060b9, (v) => $c9f145267881427c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c9f145267881427c$export$56885ab8b9c456ab, (v) => $c9f145267881427c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c9f145267881427c$export$d927fcb6adf8f9de, (v) => $c9f145267881427c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c9f145267881427c$export$b82d16f27459e05a, (v) => $c9f145267881427c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c9f145267881427c$export$522c17b4f5e123e8, (v) => $c9f145267881427c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c9f145267881427c$export$1aabd8a0274ecfd6, (v) => $c9f145267881427c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $c9f145267881427c$export$3d6c20d97e46b957, (v) => $c9f145267881427c$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $c9f145267881427c$export$9b621391a187a31a, (v) => $c9f145267881427c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c9f145267881427c$export$f5bbd400c2f4426f, (v) => $c9f145267881427c$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9f145267881427c$export$a7c73072b1a182ae;
var $c9f145267881427c$export$9f27bc3417b4524d;
var $c9f145267881427c$export$db77ccec0bb4ccac;
var $c9f145267881427c$export$8392c0c9d3dcbd35;
var $c9f145267881427c$export$ffb0004e005737fa;
var $c9f145267881427c$export$b624eff549462981;
var $c9f145267881427c$export$7897aa7841a5380c;
var $c9f145267881427c$export$602eac185826482c;
var $c9f145267881427c$export$e2c29f18771995cb;
var $c9f145267881427c$export$5f8d39834fd61797;
var $c9f145267881427c$export$74bf444e3cd11ea5;
var $c9f145267881427c$export$998bcd577473dd93;
var $c9f145267881427c$export$92387174baf9b227;
var $c9f145267881427c$export$ec112efeb987d9c6;
var $c9f145267881427c$export$b706b080d889d2c9;
var $c9f145267881427c$export$5be5a87408f70ddc;
var $c9f145267881427c$export$45a5e7f76e0caa8d;
var $c9f145267881427c$export$455c2e768291efa6;
var $c9f145267881427c$export$9522e17588c12572;
var $c9f145267881427c$export$2110ac352bb060b9;
var $c9f145267881427c$export$56885ab8b9c456ab;
var $c9f145267881427c$export$d927fcb6adf8f9de;
var $c9f145267881427c$export$b82d16f27459e05a;
var $c9f145267881427c$export$522c17b4f5e123e8;
var $c9f145267881427c$export$1aabd8a0274ecfd6;
var $c9f145267881427c$export$3d6c20d97e46b957;
var $c9f145267881427c$export$9b621391a187a31a;
var $c9f145267881427c$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $c9f145267881427c$export$a7c73072b1a182ae = ContextConsumer;
    $c9f145267881427c$export$9f27bc3417b4524d = ContextProvider;
    $c9f145267881427c$export$db77ccec0bb4ccac = Element;
    $c9f145267881427c$export$8392c0c9d3dcbd35 = ForwardRef;
    $c9f145267881427c$export$ffb0004e005737fa = Fragment;
    $c9f145267881427c$export$b624eff549462981 = Lazy;
    $c9f145267881427c$export$7897aa7841a5380c = Memo;
    $c9f145267881427c$export$602eac185826482c = Portal;
    $c9f145267881427c$export$e2c29f18771995cb = Profiler;
    $c9f145267881427c$export$5f8d39834fd61797 = StrictMode;
    $c9f145267881427c$export$74bf444e3cd11ea5 = Suspense;
    $c9f145267881427c$export$998bcd577473dd93 = SuspenseList;
    $c9f145267881427c$export$92387174baf9b227 = isAsyncMode;
    $c9f145267881427c$export$ec112efeb987d9c6 = isConcurrentMode;
    $c9f145267881427c$export$b706b080d889d2c9 = isContextConsumer;
    $c9f145267881427c$export$5be5a87408f70ddc = isContextProvider;
    $c9f145267881427c$export$45a5e7f76e0caa8d = isElement;
    $c9f145267881427c$export$455c2e768291efa6 = isForwardRef;
    $c9f145267881427c$export$9522e17588c12572 = isFragment;
    $c9f145267881427c$export$2110ac352bb060b9 = isLazy;
    $c9f145267881427c$export$56885ab8b9c456ab = isMemo;
    $c9f145267881427c$export$d927fcb6adf8f9de = isPortal;
    $c9f145267881427c$export$b82d16f27459e05a = isProfiler;
    $c9f145267881427c$export$522c17b4f5e123e8 = isStrictMode;
    $c9f145267881427c$export$1aabd8a0274ecfd6 = isSuspense;
    $c9f145267881427c$export$3d6c20d97e46b957 = isSuspenseList;
    $c9f145267881427c$export$9b621391a187a31a = isValidElementType;
    $c9f145267881427c$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("auC0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3a319e7e555608$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
let $7a3a319e7e555608$var$globalId = 0;
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $7a3a319e7e555608$var$maybeReactUseId = $acw62["useId".toString()];
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}

});

parcelRegister("i582X", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29eef8283105e84$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");
const $d29eef8283105e84$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
]);
var $d29eef8283105e84$export$2e2bcd8739ae039 = $d29eef8283105e84$var$refType;

});

parcelRegister("gzyUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10afe25107351d9$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $6zeBo.default);

});
parcelRegister("6zeBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8156a231c9130b$export$2e2bcd8739ae039);
function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("4F5tJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $364f3db28d8d2e79$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $Nd5tw = parcelRequire("Nd5tw");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $lBOb7 = parcelRequire("lBOb7");

var $6el2W = parcelRequire("6el2W");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $lyHsQ = parcelRequire("lyHsQ");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lyHsQ.getMenuUtilityClass), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $6el2W.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $6el2W.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $lBOb7.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            "Consider providing an array instead."
        ].join("\n"));
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $364f3db28d8d2e79$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $eD6Co.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $eD6Co.default)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $9QePP.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
$364f3db28d8d2e79$var$Menu.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */ anchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Menu contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */ disableAutoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */ MenuListProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * @ignore
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */ PopoverClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "menu",
        "selectedMenu"
    ])
};
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;

});
parcelRegister("Nd5tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $093eba95afdcc9bd$export$2e2bcd8739ae039);
function $093eba95afdcc9bd$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null) return null;
    if (propValue && propValue.nodeType !== 1) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
    return null;
}

});

parcelRegister("eD6Co", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa69d7725f45330b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $1ESci = parcelRequire("1ESci");

var $8bslU = parcelRequire("8bslU");
"use client";
const $aa69d7725f45330b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $1En50.default)(parameters, $aa69d7725f45330b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $8bslU.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $1ESci.default)((0, $8nd05.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $gEUd4.default)(elementType, (0, $8nd05.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;

});
parcelRegister("3qSdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $27fddc0219860a83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hervl = parcelRequire("hervl");
"use client";
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $hervl.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("hervl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b9145416f64bb2$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("gEUd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20bfbd9e98e2eff$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $awhpc = parcelRequire("awhpc");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $awhpc.default)(elementType)) return otherProps;
    return (0, $8nd05.default)({}, otherProps, {
        ownerState: (0, $8nd05.default)({}, otherProps.ownerState, ownerState)
    });
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;

});
parcelRegister("awhpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8a64e8a5211ee5$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === "string";
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;

});


parcelRegister("1ESci", function(module, exports) {

$parcel$export(module.exports, "default", () => $135391549c807611$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9QePP = parcelRequire("9QePP");

var $f56pe = parcelRequire("f56pe");

var $5nUQA = parcelRequire("5nUQA");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $8nd05.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $8nd05.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f56pe.default)((0, $8nd05.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $5nUQA.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $5nUQA.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $8nd05.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $8nd05.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;

});
parcelRegister("f56pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $afac4abdaa8d83ea$export$2e2bcd8739ae039);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;

});

parcelRegister("5nUQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebb326a10a78a15$export$2e2bcd8739ae039);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;

});


parcelRegister("8bslU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5557fdc8e8d8fa$export$2e2bcd8739ae039);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;

});


parcelRegister("lBOb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb3fa0cdc277971$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $c9Z8w = parcelRequire("c9Z8w");

var $gzyUk = parcelRequire("gzyUk");

var $8AyZl = parcelRequire("8AyZl");

var $19SuQ = parcelRequire("19SuQ");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $khjmj.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $19SuQ.default)((0, $gzyUk.default)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $gzyUk.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $9Rgf1.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            "Consider providing an array instead."
        ].join("\n"));
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
$fbb3fa0cdc277971$var$MenuList.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */ autoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * MenuList contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */ disabledItemsFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */ disableListWrap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "menu",
        "selectedMenu"
    ])
};
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;

});
parcelRegister("8AyZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $640cd381f5e8b3ea$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $eUMjp = parcelRequire("eUMjp");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eUMjp.getListUtilityClass), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
$640cd381f5e8b3ea$var$List.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */ disablePadding: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The content of the subheader, normally `ListSubheader`.
   */ subheader: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;

});
parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("8Uq77")).default);

var $bpUvK = parcelRequire("bpUvK");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

var $PJRTc = parcelRequire("PJRTc");
"use client";
const $0277c5e26ff0d56c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($bpUvK)))({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("bpUvK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84fddd6da8624ed6$var$createStyled;
module.exports.shouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $84fddd6da8624ed6$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2 = $1jnue((parcelRequire("c05no")));

var $84fddd6da8624ed6$var$_styledEngine = $84fddd6da8624ed6$var$_interopRequireWildcard((parcelRequire("bOOlK")));

var $3z1Ay = parcelRequire("3z1Ay");

var $84fddd6da8624ed6$var$_capitalize = $1jnue((parcelRequire("2A1GY")));

var $84fddd6da8624ed6$var$_getDisplayName = $1jnue((parcelRequire("eQufN")));

var $84fddd6da8624ed6$var$_createTheme = $1jnue((parcelRequire("5QV4f")));

var $84fddd6da8624ed6$var$_styleFunctionSx = $1jnue((parcelRequire("2bwhi")));
const $84fddd6da8624ed6$var$_excluded = [
    "ownerState"
], $84fddd6da8624ed6$var$_excluded2 = [
    "variants"
], $84fddd6da8624ed6$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $84fddd6da8624ed6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($84fddd6da8624ed6$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $84fddd6da8624ed6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $84fddd6da8624ed6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $84fddd6da8624ed6$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $84fddd6da8624ed6$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $84fddd6da8624ed6$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $84fddd6da8624ed6$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $84fddd6da8624ed6$var$_createTheme.default)();
const $84fddd6da8624ed6$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $84fddd6da8624ed6$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $84fddd6da8624ed6$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $84fddd6da8624ed6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $84fddd6da8624ed6$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(_ref, $84fddd6da8624ed6$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $84fddd6da8624ed6$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$84fddd6da8624ed6$var$processStyleArg(resolvedStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $84fddd6da8624ed6$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $84fddd6da8624ed6$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $84fddd6da8624ed6$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $84fddd6da8624ed6$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $84fddd6da8624ed6$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $84fddd6da8624ed6$var$_styleFunctionSx.default)((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
            theme: $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $84fddd6da8624ed6$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $84fddd6da8624ed6$var$defaultOverridesResolver($84fddd6da8624ed6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $84fddd6da8624ed6$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        if (componentName) // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${$84fddd6da8624ed6$var$lowercaseFirstLetter(componentSlot || "Root")}`;
        let shouldForwardPropOption = $84fddd6da8624ed6$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($84fddd6da8624ed6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $84fddd6da8624ed6$var$_styledEngine.default)(tag, (0, $84fddd6da8624ed6$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$84fddd6da8624ed6$var$processStyleArg(stylesArg, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: $84fddd6da8624ed6$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $84fddd6da8624ed6$var$processStyleArg(slotStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $84fddd6da8624ed6$var$processStyleArg({
                    variants: themeVariants
                }, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            {
                let displayName;
                if (componentName) displayName = `${componentName}${(0, $84fddd6da8624ed6$var$_capitalize.default)(componentSlot || "")}`;
                if (displayName === undefined) displayName = `Styled(${(0, $84fddd6da8624ed6$var$_getDisplayName.default)(tag)})`;
                Component.displayName = displayName;
            }
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bOOlK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $89ab6b9e702438b4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $89ab6b9e702438b4$export$e00380445f2b9e0c);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("l7wW1")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("2BuCw")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("bBbjn")).default);
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5rflj = parcelRequire("5rflj");
parcelRequire("jjlaj");
var $l7wW1 = parcelRequire("l7wW1");
var $jjlaj = parcelRequire("jjlaj");

var $2BuCw = parcelRequire("2BuCw");

var $bBbjn = parcelRequire("bBbjn");
"use client";
function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    return (...styles)=>{
        const component = typeof tag === "string" ? `"${tag}"` : "component";
        if (styles.length === 0) console.error([
            `MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`,
            'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'
        ].join("\n"));
        else if (styles.some((style)=>style === undefined)) console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
        return stylesFactory(...styles);
    };
}
const $89ab6b9e702438b4$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("5rflj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");
parcelRequire("acw62");
parcelRequire("gd942");

parcelRequire("8ajhZ");
parcelRequire("8rteH");
parcelRequire("2lACw");
var $3f5b60245567d758$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind();
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
parcelRequire("jjlaj");
var $l7wW1 = parcelRequire("l7wW1");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== "undefined";
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $l7wW1.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $l7wW1.T));
            }
            if (typeof props.className === "string") className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("bBbjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $871beca1e2477cf0$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}
$871beca1e2477cf0$export$2e2bcd8739ae039.propTypes = {
    defaultTheme: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
};

});


parcelRegister("2A1GY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gxvzd")).default);

var $gxvzd = parcelRequire("gxvzd");

});

parcelRegister("eQufN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eWm0o")).default);

var $eWm0o = parcelRequire("eWm0o");
$parcel$exportWildcard(module.exports, $eWm0o);

});
parcelRegister("eWm0o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $ae078d4716220a63$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ae078d4716220a63$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ae078d4716220a63$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ae078d4716220a63$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $ae078d4716220a63$export$aad197c7121a6651(Component) || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $ae078d4716220a63$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $4jPKB.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("5QV4f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6o2lr")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("dLM8u")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("2UDLz")).default);

var $6o2lr = parcelRequire("6o2lr");

var $dLM8u = parcelRequire("dLM8u");

var $2UDLz = parcelRequire("2UDLz");

});

parcelRegister("2bwhi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9dZwz")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("9dZwz")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("hcz0Q")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("kOOck")).default);

var $9dZwz = parcelRequire("9dZwz");

var $hcz0Q = parcelRequire("hcz0Q");

var $kOOck = parcelRequire("kOOck");

});
parcelRegister("hcz0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85eb76b78f8a14c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $kOOck = parcelRequire("kOOck");
const $c85eb76b78f8a14c$var$_excluded = [
    "sx"
];
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $kOOck.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $c85eb76b78f8a14c$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
"use client";
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});

parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== "classes";
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), (0, $8nd05.default)({}, props));
}
$0f2e94b8fca67639$var$DefaultPropsProvider.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
};
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $aMyfV.useDefaultProps)(params);
}

});

parcelRegister("3W6ht", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddba918a398c481$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
$2ddba918a398c481$var$ListContext.displayName = "ListContext";
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;

});

parcelRegister("eUMjp", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", () => $adbbc5717e0d0350$export$c6bd6795ed6e3203);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)("MuiList", slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});



parcelRegister("19SuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d80e79907b6bdbc$export$2e2bcd8739ae039);

var $aF4kJ = parcelRequire("aF4kJ");
var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $aF4kJ.default);

});
parcelRegister("aF4kJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0200cab69b9251c8$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});


parcelRegister("9Rgf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d5a979b2ad8bc9$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");
"use client";
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $3qSdM.default);

});

parcelRegister("khjmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec346974df496fc5$export$2e2bcd8739ae039);

var $eEJPp = parcelRequire("eEJPp");
"use client";
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $eEJPp.default);

});
parcelRegister("eEJPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab859a020ad749e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;

});



parcelRegister("6el2W", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", () => $012baef8dc9ae9d0$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $012baef8dc9ae9d0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $Nd5tw = parcelRequire("Nd5tw");

var $i582X = parcelRequire("i582X");

var $5qZhP = parcelRequire("5qZhP");

var $iuSDM = parcelRequire("iuSDM");

var $fEVav = parcelRequire("fEVav");

var $eD6Co = parcelRequire("eD6Co");

var $awhpc = parcelRequire("awhpc");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1iGrQ = parcelRequire("1iGrQ");

var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $9Rgf1 = parcelRequire("9Rgf1");

var $iscuz = parcelRequire("iscuz");

var $118QM = parcelRequire("118QM");

var $7Frhn = parcelRequire("7Frhn");

var $k6uEG = parcelRequire("k6uEG");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $012baef8dc9ae9d0$var$_excluded3 = [
    "slotProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $k6uEG.getPopoverUtilityClass), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $118QM.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $iscuz.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $9Rgf1.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === "anchorPosition") {
            if (!anchorPosition) console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.');
            return anchorPosition;
        }
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $gzyUk.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        {
            const box = anchorElement.getBoundingClientRect();
            if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                "MUI: The `anchorEl` prop provided to the component is invalid.",
                "The anchor element should be part of the document layout.",
                "Make sure the element is present in the document or that it's not display none."
            ].join("\n"));
        }
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9Evvr.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) console.error([
            "MUI: The popover component is too tall.",
            `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`,
            "Please consider adding a `max-height` to improve the user-experience."
        ].join("\n"));
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $1iGrQ.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9Evvr.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $gzyUk.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $012baef8dc9ae9d0$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $012baef8dc9ae9d0$export$821346c38a2d9390;
    const paperProps = (0, $eD6Co.default)({
        elementType: PaperSlot,
        externalSlotProps: (0, $8nd05.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $8nd05.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $1En50.default)(_useSlotProps, $012baef8dc9ae9d0$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, (0, $8nd05.default)({}, rootProps, !(0, $awhpc.default)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, (0, $8nd05.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
$012baef8dc9ae9d0$var$Popover.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */ action: (0, $i582X.default),
    /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */ anchorEl: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]), (props)=>{
        if (props.open && (!props.anchorReference || props.anchorReference === "anchorEl")) {
            const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
                const box = resolvedAnchorEl.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    "MUI: The `anchorEl` prop provided to the component is invalid.",
                    "The anchor element should be part of the document layout.",
                    "Make sure the element is present in the document or that it's not display none."
                ].join("\n"));
            } else return new Error([
                "MUI: The `anchorEl` prop provided to the component is invalid.",
                `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`
            ].join("\n"));
        }
        return null;
    }),
    /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                "center",
                "left",
                "right"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                "bottom",
                "center",
                "top"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        ]).isRequired
    }),
    /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */ anchorPosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        left: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
        top: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
    }),
    /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */ anchorReference: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "anchorEl",
        "anchorPosition",
        "none"
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The elevation of the popover.
   * @default 8
   */ elevation: (0, $iuSDM.default),
    /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */ marginThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).shape({
        component: (0, $5qZhP.default)
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                "center",
                "left",
                "right"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                "bottom",
                "center",
                "top"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        ]).isRequired
    }),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;

});
parcelRegister("5qZhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f4eebb5f6e262f1$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $fEVav = parcelRequire("fEVav");
function $3f4eebb5f6e262f1$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $3f4eebb5f6e262f1$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === "undefined") return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === "function" && !$3f4eebb5f6e262f1$var$isClassComponent(propValue)) warningHint = "Did you accidentally provide a plain function component instead?";
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + "For more information see https://mui.com/r/caveat-with-refs-guide");
    return null;
}
var $3f4eebb5f6e262f1$export$2e2bcd8739ae039 = (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType, $3f4eebb5f6e262f1$var$elementTypeAcceptingRef);

});
parcelRegister("fEVav", function(module, exports) {

$parcel$export(module.exports, "default", () => $b666efe8669b09a1$export$2e2bcd8739ae039);
function $b666efe8669b09a1$export$2e2bcd8739ae039(propType1, propType2) {
    return function validate(...args) {
        return propType1(...args) || propType2(...args);
    };
}

});


parcelRegister("iuSDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d77569d5c33a697b$export$2e2bcd8739ae039);
function $d77569d5c33a697b$export$9fd44dd81470cadd(value) {
    const valueType = typeof value;
    switch(valueType){
        case "number":
            if (Number.isNaN(value)) return "NaN";
            if (!Number.isFinite(value)) return "Infinity";
            if (value !== Math.floor(value)) return "float";
            return "number";
        case "object":
            if (value === null) return "null";
            return value.constructor.name;
        default:
            return valueType;
    }
}
// IE 11 support
function $d77569d5c33a697b$var$ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === "number" && isFinite(x) && Math.floor(x) === x;
}
const $d77569d5c33a697b$var$isInteger = Number.isInteger || $d77569d5c33a697b$var$ponyfillIsInteger;
function $d77569d5c33a697b$var$requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !$d77569d5c33a697b$var$isInteger(propValue)) {
        const propType = $d77569d5c33a697b$export$9fd44dd81470cadd(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function $d77569d5c33a697b$var$validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return $d77569d5c33a697b$var$requiredInteger(props, propName, ...other);
}
function $d77569d5c33a697b$var$validatorNoop() {
    return null;
}
$d77569d5c33a697b$var$validator.isRequired = $d77569d5c33a697b$var$requiredInteger;
$d77569d5c33a697b$var$validatorNoop.isRequired = $d77569d5c33a697b$var$validatorNoop;
var $d77569d5c33a697b$export$2e2bcd8739ae039 = $d77569d5c33a697b$var$validator;

});

parcelRegister("1iGrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2866359d6621f3$export$2e2bcd8739ae039);

var $aJ8G8 = parcelRequire("aJ8G8");
var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $aJ8G8.default);

});
parcelRegister("aJ8G8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf4d6c2077a48de$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("9Evvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $707049eb9639aeac$export$2e2bcd8739ae039);

var $9KvVX = parcelRequire("9KvVX");
var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $9KvVX.default);

});
parcelRegister("9KvVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $71912e551e227707$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $6zeBo.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("iscuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f4882a3b1c59f2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $lHOu3 = parcelRequire("lHOu3");

var $72gTS = parcelRequire("72gTS");

var $1mPeS = parcelRequire("1mPeS");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default) } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = (0, $lHOu3.default)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $14H9o.default)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A single child content element.
   */ children: (0, $72gTS.default).isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ])
};
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;

});
parcelRegister("lHOu3", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $fcd4c6205d65c7df$export$786b4da70f00938b);
$parcel$export(module.exports, "default", () => $fcd4c6205d65c7df$export$2e2bcd8739ae039);

var $iYIN2 = parcelRequire("iYIN2");

var $dOphX = parcelRequire("dOphX");
"use client";
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $iYIN2.default)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $dOphX.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("iYIN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1092ee97d527c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("dOphX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e38fa988f617e0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("72gTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f5d45b693d85f2$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $fEVav = parcelRequire("fEVav");
function $51f5d45b693d85f2$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $51f5d45b693d85f2$var$acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === "undefined") return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === "function" && !$51f5d45b693d85f2$var$isClassComponent(elementType)) warningHint = "Did you accidentally use a plain function component for an element instead?";
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + "For more information see https://mui.com/r/caveat-with-refs-guide");
    return null;
}
const $51f5d45b693d85f2$var$elementAcceptingRef = (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element, $51f5d45b693d85f2$var$acceptingRef);
$51f5d45b693d85f2$var$elementAcceptingRef.isRequired = (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element.isRequired, $51f5d45b693d85f2$var$acceptingRef);
var $51f5d45b693d85f2$export$2e2bcd8739ae039 = $51f5d45b693d85f2$var$elementAcceptingRef;

});

parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");

var $bRYJd = parcelRequire("bRYJd");

var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: typeof Element === "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $bRYJd.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

module.exports = (parcelRequire("3y30c"));

});

parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("bRYJd", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", () => $8a43c04fdfd3c437$export$3458ee1082941f5e);

var $c9Z8w = parcelRequire("c9Z8w");
var $8a43c04fdfd3c437$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    }).isRequired
]);
var $8a43c04fdfd3c437$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })
]);

});

parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("14H9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c87a2f38cd49c7a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7HKeb = parcelRequire("7HKeb");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
"use client";
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $7HKeb.default)((0, $jR9F1.default));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useDebugValue(theme);
    return theme[0, $4jPsi.default] || theme;
}

});
parcelRegister("7HKeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c0686cf27fa016$export$2e2bcd8739ae039);

var $6o2lr = parcelRequire("6o2lr");

var $2HliV = parcelRequire("2HliV");
"use client";
const $59c0686cf27fa016$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $59c0686cf27fa016$var$useTheme(defaultTheme = $59c0686cf27fa016$export$35e57303dbd8a66) {
    return (0, $2HliV.default)(defaultTheme);
}
var $59c0686cf27fa016$export$2e2bcd8739ae039 = $59c0686cf27fa016$var$useTheme;

});


parcelRegister("hweuE", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $cc10aae84e3e4b9c$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $cc10aae84e3e4b9c$export$8cb1e9b404609ae9);
const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});


parcelRegister("118QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdcbfecdf3275a2$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $Nd5tw = parcelRequire("Nd5tw");

var $72gTS = parcelRequire("72gTS");

var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $kRwxQ = parcelRequire("kRwxQ");

var $2Q995 = parcelRequire("2Q995");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6cr7d = parcelRequire("6cr7d");

var $lkowv = parcelRequire("lkowv");

var $16KGQ = parcelRequire("16KGQ");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $16KGQ.getModalUtilityClass), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $6cr7d.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $1iOpW.useDefaultProps)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const propsWithDefaults = (0, $8nd05.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $lkowv.default)((0, $8nd05.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $8nd05.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0bdcbfecdf3275a2$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $eD6Co.default)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $8nd05.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $9QePP.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, (0, $8nd05.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kRwxQ.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
$0bdcbfecdf3275a2$var$Modal.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * A single child content element.
   */ children: (0, $72gTS.default).isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */ closeAfterTransition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */ hideBackdrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * A function called when a transition enters.
   */ onTransitionEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * A function called when a transition has exited.
   */ onTransitionExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * The props used for each slot inside the Modal.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;

});
parcelRegister("kRwxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f30200a1e85b3f20$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $72gTS = parcelRequire("72gTS");
var $8mDZX = parcelRequire("8mDZX");
var $6zeBo = parcelRequire("6zeBo");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $3qSdM.default)(children.ref, rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) {
                console.error([
                    "MUI: The modal content node does not accept focus.",
                    'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'
                ].join("\n"));
                rootRef.current.setAttribute("tabIndex", "-1");
            }
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
$f30200a1e85b3f20$var$FocusTrap.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A single child content element.
   */ children: (0, $72gTS.default),
    /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */ getTabbable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */ isEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, focus is locked.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
// eslint-disable-next-line
$f30200a1e85b3f20$var$FocusTrap["propTypes"] = (0, $8mDZX.default)($f30200a1e85b3f20$var$FocusTrap.propTypes);
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;

});

parcelRegister("2Q995", function(module, exports) {

$parcel$export(module.exports, "default", () => $2117883cc21a32b2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $c9Z8w = parcelRequire("c9Z8w");

var $8mDZX = parcelRequire("8mDZX");
var $Nd5tw = parcelRequire("Nd5tw");
var $hervl = parcelRequire("hervl");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $3qSdM.default)(/*#__PURE__*/ $acw62.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $eEJPp.default)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $eEJPp.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $hervl.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $hervl.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode
    });
});
$2117883cc21a32b2$var$Portal.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The children to render into the `container`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
// eslint-disable-next-line
$2117883cc21a32b2$var$Portal["propTypes"] = (0, $8mDZX.default)($2117883cc21a32b2$var$Portal.propTypes);
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;

});

parcelRegister("6cr7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $4838e5a14e330013$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $86f4a = parcelRequire("86f4a");

var $7ViEK = parcelRequire("7ViEK");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4838e5a14e330013$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7ViEK.getBackdropUtilityClass), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $86f4a.default), transitionDuration: transitionDuration } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4838e5a14e330013$var$BackdropRoot, (0, $8nd05.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $9QePP.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
$4838e5a14e330013$var$Backdrop.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */ invisible: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ])
};
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;

});
parcelRegister("86f4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5a92158e7d9bd4$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $1mPeS = parcelRequire("1mPeS");

var $72gTS = parcelRequire("72gTS");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $14H9o.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default) } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$5e5a92158e7d9bd4$var$Fade.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A single child content element.
   */ children: (0, $72gTS.default).isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ])
};
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;

});

parcelRegister("7ViEK", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $5c4c540114ae85ab$export$9927a91fd93152bd);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)("MuiBackdrop", slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;

});


parcelRegister("lkowv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86e7d122c1fa324$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3qSdM = parcelRequire("3qSdM");
var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $hPGQj = parcelRequire("hPGQj");

var $f56pe = parcelRequire("f56pe");

var $75CP6 = parcelRequire("75CP6");
"use client";
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$defaultManager = new (0, $75CP6.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $f86e7d122c1fa324$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $6zeBo.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $13KXh.default)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $13KXh.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $75CP6.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f56pe.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $8nd05.default)({}, propsEventHandlers, otherHandlers);
        return (0, $8nd05.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $8nd05.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $hPGQj.default)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $hPGQj.default)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;

});
parcelRegister("13KXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5a7e8ccbc07697$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $eEJPp.default)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;

});

parcelRegister("hPGQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("75CP6", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $52971d86e2bcd483$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $52971d86e2bcd483$export$ce11c4ecd08cea67);

var $6zeBo = parcelRequire("6zeBo");
var $9KvVX = parcelRequire("9KvVX");
var $aF4kJ = parcelRequire("aF4kJ");
// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $6zeBo.default)(container);
    if (doc.body === container) return (0, $9KvVX.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $9KvVX.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $aF4kJ.default)((0, $6zeBo.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $6zeBo.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $6zeBo.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $9KvVX.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});


parcelRegister("16KGQ", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $0cea91a79e26c98a$export$67960e22b12a638d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)("MuiModal", slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;

});


parcelRegister("7Frhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $595185d0d7275c3b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $iuSDM = parcelRequire("iuSDM");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $35vyj = parcelRequire("35vyj");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");

var $6LfkK = parcelRequire("6LfkK");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6LfkK.getPaperUtilityClass), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $8nd05.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $8nd05.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $kSnzZ.alpha)("#fff", (0, $35vyj.default)(ownerState.elevation))}, ${(0, $kSnzZ.alpha)("#fff", (0, $35vyj.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const theme = (0, $14H9o.default)();
        if (theme.shadows[elevation] === undefined) console.error([
            `MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`,
            `Please make sure that \`theme.shadows[${elevation}]\` is defined.`
        ].join("\n"));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other));
});
$595185d0d7275c3b$var$Paper.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */ elevation: (0, $fEVav.default)((0, $iuSDM.default), (props)=>{
        const { elevation: elevation, variant: variant } = props;
        if (elevation > 0 && variant === "outlined") return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
        return null;
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   * @default 'elevation'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "elevation",
            "outlined"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;

});
parcelRegister("35vyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $23fa506264c010ed$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $23fa506264c010ed$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $23fa506264c010ed$export$2e2bcd8739ae039 = $23fa506264c010ed$var$getOverlayAlpha;

});

parcelRegister("6LfkK", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", () => $4ec306d48089c2c9$export$29cdb466b9b6f20b);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)("MuiPaper", slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;

});


parcelRegister("k6uEG", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", () => $ea2c25a800e729b1$export$88f455dd56c95edb);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)("MuiPopover", slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)("MuiPopover", [
    "root",
    "paper"
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;

});


parcelRegister("lyHsQ", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", () => $fb1e7d0ac8fac824$export$2cf86a63a84fe23d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)("MuiMenu", slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;

});


parcelRegister("iOErJ", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", () => $db2c454fb2e8bc3c$export$c1eccd1617458c87);
$parcel$export(module.exports, "nativeSelectIconStyles", () => $db2c454fb2e8bc3c$export$e7a817afd12a40d0);
$parcel$export(module.exports, "default", () => $db2c454fb2e8bc3c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $6jVRo = parcelRequire("6jVRo");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $jTnBY.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6jVRo.getNativeSelectUtilityClasses), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $8nd05.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $6jVRo.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $6jVRo.default).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $6jVRo.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
$db2c454fb2e8bc3c$var$NativeSelectInput.propTypes = {
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the select is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */ inputRef: (0, $i582X.default),
    /**
   * @ignore
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "standard",
        "outlined",
        "filled"
    ])
};
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;

});
parcelRegister("6jVRo", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $49a1663d7631a8fa$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $49a1663d7631a8fa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)("MuiNativeSelect", slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;

});


parcelRegister("2BbKU", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $1e4827e2a850b1f0$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $1e4827e2a850b1f0$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("3yddg", function(module, exports) {

$parcel$export(module.exports, "default", () => $295ecbe78b5bad73$export$2e2bcd8739ae039);

var $agZ85 = parcelRequire("agZ85");
"use client";
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $agZ85.default);

});
parcelRegister("agZ85", function(module, exports) {

$parcel$export(module.exports, "default", () => $77aad105771eb889$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    {
        $acw62.useEffect(()=>{
            if (isControlled !== (controlled !== undefined)) console.error([
                `MUI: A component is changing the ${isControlled ? "" : "un"}controlled ${state} state of ${name} to be ${isControlled ? "un" : ""}controlled.`,
                "Elements should not switch from uncontrolled to controlled (or vice versa).",
                `Decide between using a controlled or uncontrolled ${name} ` + "element for the lifetime of the component.",
                "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
                "More info: https://fb.me/react-controlled-components"
            ].join("\n"));
        }, [
            state,
            name,
            controlled
        ]);
        const { current: defaultValue } = $acw62.useRef(defaultProp);
        $acw62.useEffect(()=>{
            if (!isControlled && !Object.is(defaultValue, defaultProp)) console.error([
                `MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`
            ].join("\n"));
        }, [
            JSON.stringify(defaultProp)
        ]);
    }
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("bmfPX", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $844e08aea9053c4b$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $844e08aea9053c4b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)("MuiSelect", slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;

});


parcelRegister("aaphR", function(module, exports) {

$parcel$export(module.exports, "default", () => $766e740713576b8d$export$2e2bcd8739ae039);
function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("cJQfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $946238fa82894619$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $blr6C = parcelRequire("blr6C");
"use client";
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $blr6C.default));
}

});
parcelRegister("blr6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8426ae8303951a73$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
$8426ae8303951a73$var$FormControlContext.displayName = "FormControlContext";
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;

});


parcelRegister("7LRfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a863bd9b12ca76b$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Node passed into the SVG element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "inherit",
            "action",
            "disabled",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */ fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "inherit",
            "large",
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Applies a color attribute to the SVG element.
   */ htmlColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */ inheritViewBox: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */ shapeRendering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */ titleAccess: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */ viewBox: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
$2a8a963e5702921b$var$SvgIcon.muiName = "SvgIcon";
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)("MuiSvgIcon", slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});




parcelRegister("ab7Se", function(module, exports) {

$parcel$export(module.exports, "default", () => $76910a07fd4ac4fe$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");

var $i582X = parcelRequire("i582X");

var $95gUw = parcelRequire("95gUw");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $b3ugU = parcelRequire("b3ugU");

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b3ugU.getInputUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $8nd05.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $b3ugU.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $b3ugU.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b3ugU.default).disabled}, .${(0, $b3ugU.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $b3ugU.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $95gUw.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense",
        "none"
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
$76910a07fd4ac4fe$var$Input.muiName = "Input";
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;

});
parcelRegister("95gUw", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $69d1b2c99a8dc649$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $69d1b2c99a8dc649$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $69d1b2c99a8dc649$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseComponent", () => $69d1b2c99a8dc649$export$a1ad29c901026019);
$parcel$export(module.exports, "default", () => $69d1b2c99a8dc649$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $5qZhP = parcelRequire("5qZhP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $awhpc = parcelRequire("awhpc");

var $gSRTE = parcelRequire("gSRTE");

var $aaphR = parcelRequire("aaphR");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $ldx2z = parcelRequire("ldx2z");

var $2BbKU = parcelRequire("2BbKU");

var $dmljZ = parcelRequire("dmljZ");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $jTnBY.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dmljZ.getInputBaseUtilityClass), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $dmljZ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $d8seH.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $8nd05.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $dmljZ.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $dmljZ.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldx2z.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{
        if (instance && instance.nodeName !== "INPUT" && !instance.focus) console.error([
            "MUI: You have provided a `inputComponent` to the input component",
            "that does not correctly handle the `ref` prop.",
            "Make sure the `ref` prop is called with a HTMLInputElement."
        ].join("\n"));
    }, []);
    const handleInputRef = (0, $9Rgf1.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $cJQfW.default)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useEffect(()=>{
        if (muiFormControl) return muiFormControl.registerEffect();
        return undefined;
    }, [
        muiFormControl
    ]);
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $2BbKU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $khjmj.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error(`MUI: Expected valid input target. Did you use a custom \`inputComponent\` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.`);
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) {
            if (minRows || maxRows) console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.");
            inputProps = (0, $8nd05.default)({
                type: undefined,
                minRows: rows,
                maxRows: rows
            }, inputProps);
        } else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $gSRTE.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $awhpc.default)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $awhpc.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
$69d1b2c99a8dc649$var$InputBase.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ "aria-describedby": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */ disableInjectingGlobalStyles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, $5qZhP.default),
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense",
        "none"
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */ onInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ renderSuffix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The size of the component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;

});
parcelRegister("gSRTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $032c0e7078a9cb7d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3qSdM = parcelRequire("3qSdM");
var $9KvVX = parcelRequire("9KvVX");
var $eEJPp = parcelRequire("eEJPp");
var $aJ8G8 = parcelRequire("aJ8G8");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $032c0e7078a9cb7d$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1En50.default)(props, $032c0e7078a9cb7d$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(forwardedRef, inputRef);
    const heightRef = $acw62.useRef(null);
    const shadowRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $9KvVX.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $acw62.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $eEJPp.default)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $aJ8G8.default)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $9KvVX.default)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $eEJPp.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $032c0e7078a9cb7d$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
$032c0e7078a9cb7d$var$TextareaAutosize.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Maximum number of rows to display.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Minimum number of rows to display.
   * @default 1
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;

});

parcelRegister("ldx2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $03fc756f7adfd498$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $92iK7 = parcelRequire("92iK7");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92iK7.default), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    }));
}
$03fc756f7adfd498$var$GlobalStyles.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The styles you want to apply globally.
   */ styles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ])
};
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;

});
parcelRegister("92iK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6942d6ec85232a9d$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $bBbjn = parcelRequire("bBbjn");

var $7HKeb = parcelRequire("7HKeb");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $7HKeb.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
        styles: globalStyles
    });
}
$6942d6ec85232a9d$var$GlobalStyles.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ defaultTheme: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ styles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * @ignore
   */ themeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;

});


parcelRegister("dmljZ", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $9b9dde6aa920e08c$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $9b9dde6aa920e08c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)("MuiInputBase", slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;

});


parcelRegister("b3ugU", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $80c774dd7f29b734$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $80c774dd7f29b734$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)("MuiInput", slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $dmljZ.default), (0, $beCSm.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;

});


parcelRegister("g4sO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb335d5457c07f5b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");

var $i582X = parcelRequire("i582X");

var $c9Z8w = parcelRequire("c9Z8w");

var $8Indx = parcelRequire("8Indx");

var $95gUw = parcelRequire("95gUw");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $faAxf = parcelRequire("faAxf");

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $faAxf.getFilledInputUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $8nd05.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $faAxf.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $faAxf.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $faAxf.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $faAxf.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $faAxf.default).disabled}, .${(0, $faAxf.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $faAxf.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the input will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense",
        "none"
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
$bb335d5457c07f5b$var$FilledInput.muiName = "Input";
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;

});
parcelRegister("faAxf", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $b0b42157daacd8b1$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $b0b42157daacd8b1$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)("MuiFilledInput", slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $dmljZ.default), (0, $beCSm.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;

});


parcelRegister("imehR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d55d2dd82639e9$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $9ZwEw = parcelRequire("9ZwEw");

var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $96QZi = parcelRequire("96QZi");

var $95gUw = parcelRequire("95gUw");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $96QZi.getOutlinedInputUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $95gUw.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $8nd05.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $96QZi.default).focused} .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $96QZi.default).error} .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $96QZi.default).disabled} .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $9ZwEw.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5d55d2dd82639e9$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense",
        "none"
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
$d5d55d2dd82639e9$var$OutlinedInput.muiName = "Input";
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;

});
parcelRegister("9ZwEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $746323a953600e78$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)("fieldset", {
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)("legend", {
    shouldForwardProp: (0, $8Uq77.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}
$746323a953600e78$export$2e2bcd8739ae039.propTypes = {
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The label.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};

});

parcelRegister("96QZi", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $6a1dc6d1d7e1816a$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $6a1dc6d1d7e1816a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)("MuiOutlinedInput", slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $dmljZ.default), (0, $beCSm.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;

});



parcelRegister("2iAqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ac984bce84b2164$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $6n0Ko = parcelRequire("6n0Ko");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $cbVYE = parcelRequire("cbVYE");

var $doXfV = parcelRequire("doXfV");

var $guz4p = parcelRequire("guz4p");

var $eWb0W = parcelRequire("eWb0W");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $1ac984bce84b2164$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $eWb0W.getMenuItemUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $eWb0W.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $eWb0W.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $eWb0W.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $cbVYE.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $cbVYE.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $guz4p.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $guz4p.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $doXfV.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $8nd05.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $doXfV.default).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $1En50.default)(props, $1ac984bce84b2164$var$_excluded);
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
            else console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered.");
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $9Rgf1.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, (0, $8nd05.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
$1ac984bce84b2164$var$MenuItem.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * If `true`, the component is selected.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * @default 0
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
};
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;

});
parcelRegister("6n0Ko", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a35786d89db9dda$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $5qZhP = parcelRequire("5qZhP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");

var $4o7uD = parcelRequire("4o7uD");

var $cllwi = parcelRequire("cllwi");

var $brF9L = parcelRequire("brF9L");

var $5JO1P = parcelRequire("5JO1P");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4a35786d89db9dda$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5JO1P.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $5JO1P.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1En50.default)(props, $4a35786d89db9dda$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $9Rgf1.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $cllwi.default)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $4o7uD.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4o7uD.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $4o7uD.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4o7uD.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $9Rgf1.default)(ref, focusVisibleRef, buttonRef);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useEffect(()=>{
        if (enableTouchRipple && !rippleRef.current) console.error([
            "MUI: The `component` prop provided to ButtonBase is invalid.",
            "Please make sure the children prop is rendered in this custom component."
        ].join("\n"));
    }, [
        enableTouchRipple
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, (0, $8nd05.default)({
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $brF9L.default), (0, $8nd05.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
$4a35786d89db9dda$var$ButtonBase.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */ action: (0, $i582X.default),
    /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */ centerRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $5qZhP.default),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */ disableTouchRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */ focusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).any,
    /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */ LinkComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onContextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */ onFocusVisible: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onTouchEnd: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onTouchMove: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onTouchStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * @default 0
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Props applied to the `TouchRipple` element.
   */ TouchRippleProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * A ref that points to the `TouchRipple` element.
   */ touchRippleRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
                start: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
                stop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
            })
        })
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "button",
            "reset",
            "submit"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;

});
parcelRegister("4o7uD", function(module, exports) {

$parcel$export(module.exports, "default", () => $331f3746e6346411$export$2e2bcd8739ae039);

var $13KXh = parcelRequire("13KXh");
"use client";
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $13KXh.default);

});

parcelRegister("cllwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc8239a3939454e$export$2e2bcd8739ae039);

var $1SuLX = parcelRequire("1SuLX");
"use client";
var $8fc8239a3939454e$export$2e2bcd8739ae039 = (0, $1SuLX.default);

});
parcelRegister("1SuLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e2b45accdb3531$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $lHOu3 = parcelRequire("lHOu3");
"use client";
let $15e2b45accdb3531$var$hadKeyboardEvent = true;
let $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
const $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout = new (0, $lHOu3.Timeout)();
const $15e2b45accdb3531$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $15e2b45accdb3531$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $15e2b45accdb3531$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $15e2b45accdb3531$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $15e2b45accdb3531$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $15e2b45accdb3531$var$handlePointerDown() {
    $15e2b45accdb3531$var$hadKeyboardEvent = false;
}
function $15e2b45accdb3531$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($15e2b45accdb3531$var$hadFocusVisibleRecently) $15e2b45accdb3531$var$hadKeyboardEvent = true;
    }
}
function $15e2b45accdb3531$var$prepare(doc) {
    doc.addEventListener("keydown", $15e2b45accdb3531$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $15e2b45accdb3531$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $15e2b45accdb3531$var$hadKeyboardEvent || $15e2b45accdb3531$var$focusTriggersKeyboardModality(target);
}
function $15e2b45accdb3531$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $15e2b45accdb3531$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $15e2b45accdb3531$var$hadFocusVisibleRecently = true;
            $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($15e2b45accdb3531$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});


parcelRegister("brF9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $855224273a002a0f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $jEvxL = parcelRequire("jEvxL");

var $9QePP = parcelRequire("9QePP");

var $jjlaj = parcelRequire("jjlaj");

var $lHOu3 = parcelRequire("lHOu3");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $hruNq = parcelRequire("hruNq");

var $a4Mf7 = parcelRequire("a4Mf7");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $855224273a002a0f$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $855224273a002a0f$var$_ = (t)=>t, $855224273a002a0f$var$_t, $855224273a002a0f$var$_t2, $855224273a002a0f$var$_t3, $855224273a002a0f$var$_t4;
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t || ($855224273a002a0f$var$_t = $855224273a002a0f$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $855224273a002a0f$var$exitKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t2 || ($855224273a002a0f$var$_t2 = $855224273a002a0f$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $855224273a002a0f$var$pulsateKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t3 || ($855224273a002a0f$var$_t3 = $855224273a002a0f$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $hruNq.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($855224273a002a0f$var$_t4 || ($855224273a002a0f$var$_t4 = $855224273a002a0f$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $a4Mf7.default).rippleVisible, $855224273a002a0f$var$enterKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a4Mf7.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $a4Mf7.default).child, (0, $a4Mf7.default).childLeaving, $855224273a002a0f$var$exitKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a4Mf7.default).childPulsate, $855224273a002a0f$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1En50.default)(props, $855224273a002a0f$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $lHOu3.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $a4Mf7.default).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $a4Mf7.default).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $a4Mf7.default).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $a4Mf7.default).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $a4Mf7.default).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $a4Mf7.default).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, (0, $8nd05.default)({
        className: (0, $9QePP.default)((0, $a4Mf7.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEvxL.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
$855224273a002a0f$var$TouchRipple.propTypes = {
    /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */ center: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;

});
parcelRegister("jEvxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ea38a8b431e8fc$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $6xlZQ = parcelRequire("6xlZQ");

var $n2pn1 = parcelRequire("n2pn1");
var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hDpcU.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $n2pn1.getInitialChildMapping)(nextProps, handleExited) : (0, $n2pn1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $n2pn1.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("n2pn1", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $04540450bf60efa1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $04540450bf60efa1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $04540450bf60efa1$export$36fd1af28d383ec0);

var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, "appear", props),
            enter: $04540450bf60efa1$var$getProp(child, "enter", props),
            exit: $04540450bf60efa1$var$getProp(child, "exit", props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("hruNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2cd8c78d72bd92$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
$cb2cd8c78d72bd92$var$Ripple.propTypes = {
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore - injected from TransitionGroup
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore - injected from TransitionGroup
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */ pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Diameter of the ripple.
   */ rippleSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Horizontal position of the ripple center.
   */ rippleX: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Vertical position of the ripple center.
   */ rippleY: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * exit delay
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
};
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;

});

parcelRegister("a4Mf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $755fb323846f60d4$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)("MuiTouchRipple", slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;

});


parcelRegister("5JO1P", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $42d7f65840078ec1$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $42d7f65840078ec1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)("MuiButtonBase", slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;

});


parcelRegister("cbVYE", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", () => $024a60f892d3fa61$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $024a60f892d3fa61$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)("MuiDivider", slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;

});

parcelRegister("doXfV", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $9c1b7b40cd19f5fe$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $9c1b7b40cd19f5fe$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)("MuiListItemIcon", slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;

});

parcelRegister("guz4p", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $c01aa6ddbe5e68bd$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $c01aa6ddbe5e68bd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)("MuiListItemText", slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;

});

parcelRegister("eWb0W", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $adff06ac3b11e066$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $adff06ac3b11e066$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)("MuiMenuItem", slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;

});







parcelRegister("5WRsZ", function(module, exports) {
"use strict";
var $454bd7dbb53d2b4e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $454bd7dbb53d2b4e$var$react_1 = $454bd7dbb53d2b4e$var$__importDefault((parcelRequire("acw62")));

var $kybK6 = parcelRequire("kybK6");
var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");

const $454bd7dbb53d2b4e$var$Close_1 = $454bd7dbb53d2b4e$var$__importDefault((parcelRequire("dqlTG")));

var $i4KPV = parcelRequire("i4KPV");

var $3xrB1 = parcelRequire("3xrB1");

const $454bd7dbb53d2b4e$var$base_style_1 = $454bd7dbb53d2b4e$var$__importDefault((parcelRequire("3x1AH")));

const $454bd7dbb53d2b4e$var$style_v1_1 = $454bd7dbb53d2b4e$var$__importDefault((parcelRequire("0LEOn")));

const $454bd7dbb53d2b4e$var$style_v2_1 = $454bd7dbb53d2b4e$var$__importDefault((parcelRequire("kK7wF")));
const $454bd7dbb53d2b4e$var$KrgSnackbar = ({ id: id, className: className = "", style: style, type: type = $3xrB1.TYPE_ENUM.white, position: position = {
    horizontal: "center",
    vertical: "bottom"
}, title: title, text: text, isOpen: isOpen, autoHideDuration: autoHideDuration, icon: icon, button: button, theme: theme = $i4KPV.THEME_ENUM.v1, onClose: onClose, onClick: onClick, onFocus: onFocus, onBlur: onBlur })=>{
    const props = {
        type: type
    };
    const baseClasses = (0, $454bd7dbb53d2b4e$var$base_style_1.default)(props);
    const classesV1 = (0, $454bd7dbb53d2b4e$var$style_v1_1.default)(props);
    const classesV2 = (0, $454bd7dbb53d2b4e$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const handleClose = (e, reason)=>{
        if (reason === "clickaway") return;
        onClose === null || onClose === void 0 || onClose(e);
    };
    const handleButtonClick = (e)=>{
        if (!button) return;
        if (button.onClick) button.onClick(e);
        else onClose === null || onClose === void 0 || onClose(e);
    };
    return $454bd7dbb53d2b4e$var$react_1.default.createElement($kybK6.default, {
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        id: id,
        className: `${baseClasses.root} ${className}`,
        style: style,
        autoHideDuration: autoHideDuration === "infinity" ? undefined : autoHideDuration,
        open: isOpen,
        onClose: handleClose,
        anchorOrigin: position
    }, $454bd7dbb53d2b4e$var$react_1.default.createElement("div", {
        className: `${baseClasses.alert} ${classes.alert}`
    }, icon && $454bd7dbb53d2b4e$var$react_1.default.createElement("div", {
        className: `${baseClasses.icon} ${classes.icon}`
    }, icon), $454bd7dbb53d2b4e$var$react_1.default.createElement("div", {
        className: `${baseClasses.textContainer} ${classes.textContainer}`
    }, title && $454bd7dbb53d2b4e$var$react_1.default.createElement("span", {
        className: classes.title
    }, title), $454bd7dbb53d2b4e$var$react_1.default.createElement("span", {
        className: `${baseClasses.text} ${classes.text}`
    }, text)), button ? button.text ? $454bd7dbb53d2b4e$var$react_1.default.createElement($6lXkL.default, {
        className: `${baseClasses.button} ${classes.button}`,
        onClick: handleButtonClick
    }, button.text) : $454bd7dbb53d2b4e$var$react_1.default.createElement($9Lykx.default, {
        className: classes.closeIcon,
        onClick: handleButtonClick
    }, $454bd7dbb53d2b4e$var$react_1.default.createElement($454bd7dbb53d2b4e$var$Close_1.default, null)) : null));
};
$454bd7dbb53d2b4e$var$KrgSnackbar.TYPE_ENUM = $3xrB1.TYPE_ENUM;
$454bd7dbb53d2b4e$var$KrgSnackbar.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $454bd7dbb53d2b4e$var$KrgSnackbar;

});
parcelRegister("kybK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef601776ba11bb1e$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $3S0qO = parcelRequire("3S0qO");

var $kGwBF = parcelRequire("kGwBF");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $iscuz = parcelRequire("iscuz");

var $iSsbN = parcelRequire("iSsbN");

var $kVqBB = parcelRequire("kVqBB");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $ef601776ba11bb1e$var$_excluded = [
    "onEnter",
    "onExited"
], $ef601776ba11bb1e$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kVqBB.getSnackbarUtilityClass), classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $d8seH.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $8nd05.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $14H9o.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $iscuz.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $ef601776ba11bb1e$var$_excluded), other = (0, $1En50.default)(props, $ef601776ba11bb1e$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $3S0qO.default)((0, $8nd05.default)({}, ownerState));
    const [exited, setExited] = $acw62.useState(true);
    const rootProps = (0, $eD6Co.default)({
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), (0, $8nd05.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef601776ba11bb1e$var$SnackbarRoot, (0, $8nd05.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSsbN.default), (0, $8nd05.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
$ef601776ba11bb1e$var$Snackbar.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */ action: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */ anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "center",
            "left",
            "right"
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "bottom",
            "top"
        ]).isRequired
    }),
    /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */ autoHideDuration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Replace the `SnackbarContent` component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Props applied to the `ClickAwayListener` element.
   */ ClickAwayListenerProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Props applied to the [`SnackbarContent`](/material-ui/api/snackbar-content/) element.
   */ ContentProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */ disableWindowBlurListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */ key: ()=>null,
    /**
   * The message to display.
   */ message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */ resumeHideDuration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $ef601776ba11bb1e$export$2e2bcd8739ae039 = $ef601776ba11bb1e$var$Snackbar;

});
parcelRegister("3S0qO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d16bff1157c299f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $lHOu3 = parcelRequire("lHOu3");
var $13KXh = parcelRequire("13KXh");

var $f56pe = parcelRequire("f56pe");
"use client";
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $lHOu3.default)();
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $13KXh.default)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $13KXh.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, "timeout");
        });
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $8nd05.default)({}, (0, $f56pe.default)(parameters), (0, $f56pe.default)(externalProps));
        return (0, $8nd05.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$export$2e2bcd8739ae039 = $2d16bff1157c299f$var$useSnackbar;

});

parcelRegister("kGwBF", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", () => $f0f105dbd8c07c9e$export$58385c17fee43f89);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $72gTS = parcelRequire("72gTS");
var $8mDZX = parcelRequire("8mDZX");
var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $3qSdM.default)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $13KXh.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $6zeBo.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, childrenProps)
    });
}
$f0f105dbd8c07c9e$export$58385c17fee43f89.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The wrapped element.
   */ children: (0, $72gTS.default).isRequired,
    /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */ disableReactTree: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */ mouseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "onClick",
        "onMouseDown",
        "onMouseUp",
        "onPointerDown",
        "onPointerUp",
        false
    ]),
    /**
   * Callback fired when a "click away" event is detected.
   */ onClickAway: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */ touchEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "onTouchEnd",
        "onTouchStart",
        false
    ])
};
// eslint-disable-next-line
$f0f105dbd8c07c9e$export$58385c17fee43f89["propTypes"] = (0, $8mDZX.default)($f0f105dbd8c07c9e$export$58385c17fee43f89.propTypes);

});

parcelRegister("iSsbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbe322effc7340b4$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Frhn = parcelRequire("7Frhn");

var $6CRBu = parcelRequire("6CRBu");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $dbe322effc7340b4$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6CRBu.getSnackbarContentUtilityClass), classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $kSnzZ.emphasize)(theme.palette.background.default, emphasis);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $d8seH.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $d8seH.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $1En50.default)(props, $dbe322effc7340b4$var$_excluded);
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
$dbe322effc7340b4$var$SnackbarContent.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */ action: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The message to display.
   */ message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $dbe322effc7340b4$export$2e2bcd8739ae039 = $dbe322effc7340b4$var$SnackbarContent;

});
parcelRegister("6CRBu", function(module, exports) {

$parcel$export(module.exports, "getSnackbarContentUtilityClass", () => $4d2fdf4430378182$export$def81488db1a3216);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4d2fdf4430378182$export$def81488db1a3216(slot) {
    return (0, $4Cod0.default)("MuiSnackbarContent", slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $beCSm.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $4d2fdf4430378182$export$2e2bcd8739ae039 = $4d2fdf4430378182$var$snackbarContentClasses;

});


parcelRegister("kVqBB", function(module, exports) {

$parcel$export(module.exports, "getSnackbarUtilityClass", () => $f3bdc4d25b715a88$export$6cb096457f5926f4);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3bdc4d25b715a88$export$6cb096457f5926f4(slot) {
    return (0, $4Cod0.default)("MuiSnackbar", slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $beCSm.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $f3bdc4d25b715a88$export$2e2bcd8739ae039 = $f3bdc4d25b715a88$var$snackbarClasses;

});


parcelRegister("6lXkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a02bab8c70a697b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $1xAC3 = parcelRequire("1xAC3");

var $bwtSM = parcelRequire("bwtSM");

var $3eDio = parcelRequire("3eDio");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4a02bab8c70a697b$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $1xAC3.getButtonUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $4a02bab8c70a697b$var$commonIconStyles = (ownerState)=>(0, $8nd05.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $8nd05.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $8nd05.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $8nd05.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $1xAC3.default).focusVisible}`]: (0, $8nd05.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $1xAC3.default).disabled}`]: (0, $8nd05.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $1xAC3.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $1xAC3.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $bwtSM.default));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $3eDio.default));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $1En50.default)(props, $4a02bab8c70a697b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
$4a02bab8c70a697b$var$Button.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "inherit",
            "primary",
            "secondary",
            "success",
            "error",
            "info",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, no elevation is used.
   * @default false
   */ disableElevation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Element placed after the children.
   */ endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "small",
            "medium",
            "large"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Element placed before the children.
   */ startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "button",
            "reset",
            "submit"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "contained",
            "outlined",
            "text"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;

});
parcelRegister("1xAC3", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", () => $11f546081ba06ace$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $11f546081ba06ace$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)("MuiButton", slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;

});

parcelRegister("bwtSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8639dcef822d5d4c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
$8639dcef822d5d4c$var$ButtonGroupContext.displayName = "ButtonGroupContext";
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;

});

parcelRegister("3eDio", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b1293270900846$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
$25b1293270900846$var$ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext";
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;

});


parcelRegister("9Lykx", function(module, exports) {

$parcel$export(module.exports, "default", () => $71c322247f7fbf93$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $jzUw6 = parcelRequire("jzUw6");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $71c322247f7fbf93$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jzUw6.getIconButtonUtilityClass), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $8nd05.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $8nd05.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $8nd05.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $jzUw6.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $1En50.default)(props, $71c322247f7fbf93$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
$71c322247f7fbf93$var$IconButton.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The icon to display.
   */ children: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node, (props)=>{
        const found = $acw62.Children.toArray(props.children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.props.onClick);
        if (found) return new Error([
            "MUI: You are providing an onClick event listener to a child of a button element.",
            "Prefer applying it to the IconButton directly.",
            "This guarantees that the whole <button> will be responsive to click events."
        ].join("\n"));
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "inherit",
            "default",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "end",
        "start",
        false
    ]),
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "small",
            "medium",
            "large"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;

});
parcelRegister("jzUw6", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", () => $e40d2047b7c1e09d$export$5e8702d71474f093);
$parcel$export(module.exports, "default", () => $e40d2047b7c1e09d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)("MuiIconButton", slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;

});


parcelRegister("dqlTG", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = module.exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});
parcelRegister("7Ekty", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});


parcelRegister("3xrB1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TYPE_ENUM = void 0;
var $2939dc29426d9e51$var$TYPE_ENUM;
(function(TYPE_ENUM) {
    TYPE_ENUM["white"] = "white";
    TYPE_ENUM["dark"] = "dark";
    TYPE_ENUM["accent"] = "accent";
    TYPE_ENUM["warning"] = "warning";
    TYPE_ENUM["error"] = "error";
    TYPE_ENUM["success"] = "success";
    TYPE_ENUM["gray"] = "gray";
})($2939dc29426d9e51$var$TYPE_ENUM || (module.exports.TYPE_ENUM = $2939dc29426d9e51$var$TYPE_ENUM = {}));

});

parcelRegister("3x1AH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $2925b014339d8daf$var$useBaseStyles = (0, $1GFtd.default)({
    root: {
        fontSize: $i4KPV.FONT.SIZE.BASE
    },
    alert: {
        alignItems: "center",
        borderRadius: "0.25em",
        boxShadow: "0em 0.1875em 0.3125em rgba(0, 0, 0, 0.2), 0em 0.0625em 1.125em rgba(0, 0, 0, 0.12), 0em 0.375em 0.625em rgba(0, 0, 0, 0.14)",
        display: "flex",
        minHeight: "3em",
        minWidth: "16em",
        padding: "0.5em 1em"
    },
    textContainer: {
        display: "flex",
        flexFlow: "column"
    },
    text: {
        fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
        lineHeight: 1.2,
        marginRight: "0.625em"
    },
    icon: {
        display: "flex",
        marginRight: "0.625em"
    },
    button: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        marginLeft: "auto",
        minWidth: "unset"
    }
});
module.exports.default = $2925b014339d8daf$var$useBaseStyles;

});
parcelRegister("1GFtd", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a9e1ccd58618d1$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $f88hq = parcelRequire("f88hq");

var $3ZPKo = parcelRequire("3ZPKo");

var $bNC8T = parcelRequire("bNC8T");

var $7dXaW = parcelRequire("7dXaW");

var $8P1M4 = parcelRequire("8P1M4");

var $9p8NW = parcelRequire("9p8NW");

var $f5fvw = parcelRequire("f5fvw");

var $5EhBI = parcelRequire("5EhBI");
const $13a9e1ccd58618d1$var$_excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function $13a9e1ccd58618d1$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $3ZPKo.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $13a9e1ccd58618d1$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $bNC8T.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $bNC8T.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $8nd05.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $bNC8T.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $8nd05.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $bNC8T.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $f88hq.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $8nd05.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $3ZPKo.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $13a9e1ccd58618d1$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $13a9e1ccd58618d1$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $bNC8T.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $bNC8T.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $13a9e1ccd58618d1$var$useSynchronousEffect(func, values) {
    const key = $acw62.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    const currentKey = $acw62.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $acw62.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $13a9e1ccd58618d1$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $5EhBI.default) } = options, stylesOptions2 = (0, $1En50.default)(options, $13a9e1ccd58618d1$var$_excluded);
    const stylesCreator = (0, $f5fvw.default)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $9p8NW.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $7dXaW.default)() || defaultTheme;
        const stylesOptions = (0, $8nd05.default)({}, $acw62.useContext((0, $8P1M4.StylesContext)), stylesOptions2);
        const instance = $acw62.useRef();
        const shouldUpdate = $acw62.useRef();
        $13a9e1ccd58618d1$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $13a9e1ccd58618d1$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $13a9e1ccd58618d1$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $acw62.useEffect(()=>{
            if (shouldUpdate.current) $13a9e1ccd58618d1$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $13a9e1ccd58618d1$var$getClasses(instance.current, props.classes, Component);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useDebugValue(classes);
        {
            const supportedComponents = [
                "MuiAvatar",
                "MuiBadge",
                "MuiButton",
                "MuiButtonGroup",
                "MuiChip",
                "MuiDivider",
                "MuiFab",
                "MuiPaper",
                "MuiToolbar",
                "MuiTypography",
                "MuiAlert",
                "MuiPagination",
                "MuiPaginationItem",
                "MuiSkeleton",
                "MuiTimelineDot"
            ];
            if (name && supportedComponents.indexOf(name) >= 0 && props.variant && !classes[props.variant]) console.error([
                `MUI: You are using a variant value \`${props.variant}\` for which you didn't define styles.`,
                `Please create a new variant matcher in your theme for this variant. To learn more about matchers visit https://mui.com/r/custom-component-variants.`
            ].join("\n"));
        }
        return classes;
    };
    return useStyles;
}

});
parcelRegister("f88hq", function(module, exports) {

$parcel$export(module.exports, "createRule", () => createRule);
$parcel$export(module.exports, "toCssValue", () => toCssValue);
$parcel$export(module.exports, "RuleList", () => RuleList);
$parcel$export(module.exports, "create", () => createJss);
$parcel$export(module.exports, "hasCSSTOMSupport", () => hasCSSTOMSupport);
$parcel$export(module.exports, "getDynamicStyles", () => getDynamicStyles);

var $8nd05 = parcelRequire("8nd05");

var $ja49S = parcelRequire("ja49S");

var $9RYKL = parcelRequire("9RYKL");

var $cHPF9 = parcelRequire("cHPF9");

var $g7ajw = parcelRequire("g7ajw");

var $hDpcU = parcelRequire("hDpcU");

var $1En50 = parcelRequire("1En50");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    if (name[0] === "@") (0, $9RYKL.default)(false, "[JSS] Unknown rule " + name);
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        if (sheet && sheet.attached) (0, $9RYKL.default)(false, '[JSS] Rule is not linked. Missing sheet option "link: true".');
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $g7ajw.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $hDpcU.default)((0, $hDpcU.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8nd05.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $cHPF9.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else {
            this.name = "noname";
            (0, $9RYKL.default)(false, "[JSS] Bad keyframes name " + key);
        }
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $8nd05.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        (0, $9RYKL.default)(false, '[JSS] Referenced keyframes rule "' + name + '" is not defined.');
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $g7ajw.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8nd05.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $8nd05.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $8nd05.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $8nd05.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            else (0, $9RYKL.default)(false, '[JSS] Unknown hook "' + name + '".');
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $1En50.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $cHPF9.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        if (ruleCounter > maxRules) (0, $9RYKL.default)(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".");
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {
        (0, $9RYKL.default)(false, '[JSS] DOMException "' + err.message + '" was thrown. Tried to remove property "' + prop + '".');
    }
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
        // bad specificity issues may appear.
        (0, $9RYKL.default)(false, '[JSS] Insertion point "' + insertionPoint + '" not found.');
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        else (0, $9RYKL.default)(false, "[JSS] Insertion point is not in the DOM.");
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        (0, $9RYKL.default)(false, "[JSS] " + err.message);
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $ja49S.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $8nd05.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $8nd05.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $8nd05.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $9RYKL.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $9RYKL.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $cHPF9.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $b03e06a37d110f0d$export$2e2bcd8739ae039 = index;

});
parcelRegister("ja49S", function(module, exports) {

$parcel$export(module.exports, "default", () => $df322d3da36c941f$export$2e2bcd8739ae039);
var $df322d3da36c941f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $df322d3da36c941f$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(document)) === "object" && document.nodeType === 9;
var $df322d3da36c941f$export$2e2bcd8739ae039 = $df322d3da36c941f$export$4e09c449d6c407f7;

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = false;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZreY.default)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("3ZPKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e8f358add423b98$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $eWm0o = parcelRequire("eWm0o");
function $2e8f358add423b98$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $8nd05.default)({}, baseClasses);
    if (typeof newClasses === "string") {
        console.error([
            `MUI: The value \`${newClasses}\` ` + `provided to the classes prop of ${(0, $eWm0o.default)(Component)} is incorrect.`,
            "You might want to use the className prop instead."
        ].join("\n"));
        return baseClasses;
    }
    Object.keys(newClasses).forEach((key)=>{
        if (!baseClasses[key] && newClasses[key]) console.error([
            `MUI: The key \`${key}\` ` + `provided to the classes prop is not implemented in ${(0, $eWm0o.default)(Component)}.`,
            `You can only override one of the following: ${Object.keys(baseClasses).join(",")}.`
        ].join("\n"));
        if (newClasses[key] && typeof newClasses[key] !== "string") console.error([
            `MUI: The key \`${key}\` ` + `provided to the classes prop is not valid for ${(0, $eWm0o.default)(Component)}.`,
            `You need to provide a non empty string instead of: ${newClasses[key]}.`
        ].join("\n"));
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}

});

parcelRegister("bNC8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $8971db9eb9bb20fc$export$2e2bcd8739ae039);
// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $8971db9eb9bb20fc$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $8971db9eb9bb20fc$export$2e2bcd8739ae039 = $8971db9eb9bb20fc$var$multiKeyStore;

});

parcelRegister("7dXaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5427a657c32785a2$export$2e2bcd8739ae039);

var $lT1cX = parcelRequire("lT1cX");
function $5427a657c32785a2$export$2e2bcd8739ae039() {
    var _privateTheme$$$mater;
    const privateTheme = (0, $lT1cX.default)();
    return (_privateTheme$$$mater = privateTheme == null ? void 0 : privateTheme.$$material) != null ? _privateTheme$$$mater : privateTheme;
}

});

parcelRegister("8P1M4", function(module, exports) {

$parcel$export(module.exports, "StylesContext", () => $66c47682defefc53$export$f4de434b269fe487);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8mDZX = parcelRequire("8mDZX");

var $f88hq = parcelRequire("f88hq");

var $hpAJe = parcelRequire("hpAJe");

var $JEeE3 = parcelRequire("JEeE3");

var $ayMG0 = parcelRequire("ayMG0");
const $66c47682defefc53$var$_excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const $66c47682defefc53$var$defaultJSS = (0, $f88hq.create)((0, $JEeE3.default)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $66c47682defefc53$var$defaultGenerateClassName = (0, $hpAJe.default)();
const $66c47682defefc53$export$70a8aea9ff58d1cd = new Map();
const $66c47682defefc53$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $66c47682defefc53$var$defaultGenerateClassName,
    jss: $66c47682defefc53$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $66c47682defefc53$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $66c47682defefc53$export$f4de434b269fe487 = /*#__PURE__*/ $acw62.createContext($66c47682defefc53$var$defaultOptions);
$66c47682defefc53$export$f4de434b269fe487.displayName = "StylesContext";
let $66c47682defefc53$var$injectFirstNode;
function $66c47682defefc53$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false } = props, localOptions = (0, $1En50.default)(props, $66c47682defefc53$var$_excluded);
    const outerOptions = $acw62.useContext($66c47682defefc53$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = (0, $8nd05.default)({}, outerOptions, localOptions);
    if (injectFirst && localOptions.jss) console.error("MUI: You cannot use the jss and injectFirst props at the same time.");
    const value = $acw62.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (typeof window === "undefined" && !context.sheetsManager) console.error("MUI: You need to use the ServerStyleSheets API when rendering on the server.");
        if (context.jss.options.insertionPoint && injectFirst) console.error("MUI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.");
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
            if (!$66c47682defefc53$var$injectFirstNode) {
                const head = document.head;
                $66c47682defefc53$var$injectFirstNode = document.createComment("mui-inject-first");
                head.insertBefore($66c47682defefc53$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $f88hq.create)({
                plugins: (0, $JEeE3.default)().plugins,
                insertionPoint: $66c47682defefc53$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($66c47682defefc53$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}
$66c47682defefc53$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */ disableGeneration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * JSS's class name generator.
   */ generateClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */ injectFirst: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * JSS's instance.
   */ jss: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ serverGenerateClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */ sheetsCache: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */ sheetsManager: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   *
   * Collect the sheets.
   */ sheetsRegistry: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
$66c47682defefc53$export$2e2bcd8739ae039.propTypes = (0, $8mDZX.default)($66c47682defefc53$export$2e2bcd8739ae039.propTypes);

});
parcelRegister("hpAJe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad142f86b77d6d8$export$2e2bcd8739ae039);

var $2NPLA = parcelRequire("2NPLA");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $cad142f86b77d6d8$var$stateClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
];
function $cad142f86b77d6d8$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = "jss", seed: seed = "" } = options;
    const seedPrefix = seed === "" ? "" : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        if (ruleCounter >= 1e10) console.warn([
            "MUI: You might have a memory leak.",
            "The ruleCounter is not supposed to grow that much."
        ].join(""));
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($cad142f86b77d6d8$var$stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $2NPLA.default] || seed !== "") return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        const suffix = `${rule.key}-${getNextCounterId()}`;
        // Help with debuggability.
        if (styleSheet.options.classNamePrefix) return `${seedPrefix}${styleSheet.options.classNamePrefix}-${suffix}`;
        return `${seedPrefix}${suffix}`;
    };
}

});

parcelRegister("JEeE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369f56021741c$export$2e2bcd8739ae039);

var $f6oht = parcelRequire("f6oht");

var $29zp1 = parcelRequire("29zp1");

var $dj0fa = parcelRequire("dj0fa");

var $87e0Y = parcelRequire("87e0Y");

var $75add = parcelRequire("75add");

var $81Rrl = parcelRequire("81Rrl");

var $3TmXG = parcelRequire("3TmXG");
function $089369f56021741c$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $f6oht.default)(),
            (0, $29zp1.default)(),
            (0, $dj0fa.default)(),
            (0, $87e0Y.default)(),
            (0, $75add.default)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $81Rrl.default)(),
            (0, $3TmXG.default)()
        ]
    };
}

});
parcelRegister("f6oht", function(module, exports) {

$parcel$export(module.exports, "default", () => $afea4036e4b96092$export$2e2bcd8739ae039);


var $f88hq = parcelRequire("f88hq");
var $afea4036e4b96092$var$now = Date.now();
var $afea4036e4b96092$var$fnValuesNs = "fnValues" + $afea4036e4b96092$var$now;
var $afea4036e4b96092$var$fnRuleNs = "fnStyle" + ++$afea4036e4b96092$var$now;
var $afea4036e4b96092$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $f88hq.createRule)(name, {}, options);
            rule[$afea4036e4b96092$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($afea4036e4b96092$var$fnValuesNs in rule || $afea4036e4b96092$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$afea4036e4b96092$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$afea4036e4b96092$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$afea4036e4b96092$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $afea4036e4b96092$export$2e2bcd8739ae039 = $afea4036e4b96092$var$functionPlugin;

});

parcelRegister("29zp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1917e24186a6046e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $f88hq = parcelRequire("f88hq");
var $1917e24186a6046e$var$at = "@global";
var $1917e24186a6046e$var$atPrefix = "@global ";
var $1917e24186a6046e$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $f88hq.RuleList)((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $1917e24186a6046e$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($1917e24186a6046e$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $8nd05.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $1917e24186a6046e$var$separatorRegExp = /\s*,\s*/g;
function $1917e24186a6046e$var$addScope(selector, scope) {
    var parts = selector.split($1917e24186a6046e$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$1917e24186a6046e$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $8nd05.default)({}, options, {
        selector: $1917e24186a6046e$var$addScope(name, rule.selector)
    }));
    delete style[$1917e24186a6046e$var$at];
}
function $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $1917e24186a6046e$var$at.length) !== $1917e24186a6046e$var$at) continue;
        var selector = $1917e24186a6046e$var$addScope(prop.substr($1917e24186a6046e$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $8nd05.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1917e24186a6046e$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $1917e24186a6046e$var$at) return new $1917e24186a6046e$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $1917e24186a6046e$var$atPrefix.length) === $1917e24186a6046e$var$atPrefix) return new $1917e24186a6046e$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet);
        $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $1917e24186a6046e$export$2e2bcd8739ae039 = $1917e24186a6046e$var$jssGlobal;

});

parcelRegister("dj0fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afd3d12d6cbc635$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9RYKL = parcelRequire("9RYKL");
var $9afd3d12d6cbc635$var$separatorRegExp = /\s*,\s*/g;
var $9afd3d12d6cbc635$var$parentRegExp = /&/g;
var $9afd3d12d6cbc635$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $9afd3d12d6cbc635$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            (0, $9RYKL.default)(false, '[JSS] Could not find the referenced rule "' + key + '" in "' + (container.options.meta || container.toString()) + '".');
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($9afd3d12d6cbc635$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $8nd05.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $8nd05.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($9afd3d12d6cbc635$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $8nd05.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $8nd05.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $9afd3d12d6cbc635$export$2e2bcd8739ae039 = $9afd3d12d6cbc635$var$jssNested;

});

parcelRegister("87e0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e89d92f45e570c6$export$2e2bcd8739ae039);

var $hrHWs = parcelRequire("hrHWs");
/**
 * Convert camel cased property names to dash separated.
 */ function $5e89d92f45e570c6$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $hrHWs.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($5e89d92f45e570c6$var$convertCase);
        else converted.fallbacks = $5e89d92f45e570c6$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $5e89d92f45e570c6$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $5e89d92f45e570c6$var$convertCase(style[index]);
            return style;
        }
        return $5e89d92f45e570c6$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $hrHWs.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5e89d92f45e570c6$export$2e2bcd8739ae039 = $5e89d92f45e570c6$var$camelCase;

});
parcelRegister("hrHWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb370b3f4a9491f5$export$2e2bcd8739ae039);
/* eslint-disable no-var, prefer-template */ var $cb370b3f4a9491f5$var$uppercasePattern = /[A-Z]/g;
var $cb370b3f4a9491f5$var$msPattern = /^ms-/;
var $cb370b3f4a9491f5$var$cache = {};
function $cb370b3f4a9491f5$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $cb370b3f4a9491f5$var$hyphenateStyleName(name) {
    if ($cb370b3f4a9491f5$var$cache.hasOwnProperty(name)) return $cb370b3f4a9491f5$var$cache[name];
    var hName = name.replace($cb370b3f4a9491f5$var$uppercasePattern, $cb370b3f4a9491f5$var$toHyphenLower);
    return $cb370b3f4a9491f5$var$cache[name] = $cb370b3f4a9491f5$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $cb370b3f4a9491f5$export$2e2bcd8739ae039 = $cb370b3f4a9491f5$var$hyphenateStyleName;

});


parcelRegister("75add", function(module, exports) {

$parcel$export(module.exports, "default", () => $5280ebef38a3c5c6$export$2e2bcd8739ae039);

var $f88hq = parcelRequire("f88hq");
var $5280ebef38a3c5c6$var$px = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $5280ebef38a3c5c6$var$ms = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $5280ebef38a3c5c6$var$percent = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $5280ebef38a3c5c6$var$defaultUnits = {
    // Animation properties
    "animation-delay": $5280ebef38a3c5c6$var$ms,
    "animation-duration": $5280ebef38a3c5c6$var$ms,
    // Background properties
    "background-position": $5280ebef38a3c5c6$var$px,
    "background-position-x": $5280ebef38a3c5c6$var$px,
    "background-position-y": $5280ebef38a3c5c6$var$px,
    "background-size": $5280ebef38a3c5c6$var$px,
    // Border Properties
    border: $5280ebef38a3c5c6$var$px,
    "border-bottom": $5280ebef38a3c5c6$var$px,
    "border-bottom-left-radius": $5280ebef38a3c5c6$var$px,
    "border-bottom-right-radius": $5280ebef38a3c5c6$var$px,
    "border-bottom-width": $5280ebef38a3c5c6$var$px,
    "border-left": $5280ebef38a3c5c6$var$px,
    "border-left-width": $5280ebef38a3c5c6$var$px,
    "border-radius": $5280ebef38a3c5c6$var$px,
    "border-right": $5280ebef38a3c5c6$var$px,
    "border-right-width": $5280ebef38a3c5c6$var$px,
    "border-top": $5280ebef38a3c5c6$var$px,
    "border-top-left-radius": $5280ebef38a3c5c6$var$px,
    "border-top-right-radius": $5280ebef38a3c5c6$var$px,
    "border-top-width": $5280ebef38a3c5c6$var$px,
    "border-width": $5280ebef38a3c5c6$var$px,
    "border-block": $5280ebef38a3c5c6$var$px,
    "border-block-end": $5280ebef38a3c5c6$var$px,
    "border-block-end-width": $5280ebef38a3c5c6$var$px,
    "border-block-start": $5280ebef38a3c5c6$var$px,
    "border-block-start-width": $5280ebef38a3c5c6$var$px,
    "border-block-width": $5280ebef38a3c5c6$var$px,
    "border-inline": $5280ebef38a3c5c6$var$px,
    "border-inline-end": $5280ebef38a3c5c6$var$px,
    "border-inline-end-width": $5280ebef38a3c5c6$var$px,
    "border-inline-start": $5280ebef38a3c5c6$var$px,
    "border-inline-start-width": $5280ebef38a3c5c6$var$px,
    "border-inline-width": $5280ebef38a3c5c6$var$px,
    "border-start-start-radius": $5280ebef38a3c5c6$var$px,
    "border-start-end-radius": $5280ebef38a3c5c6$var$px,
    "border-end-start-radius": $5280ebef38a3c5c6$var$px,
    "border-end-end-radius": $5280ebef38a3c5c6$var$px,
    // Margin properties
    margin: $5280ebef38a3c5c6$var$px,
    "margin-bottom": $5280ebef38a3c5c6$var$px,
    "margin-left": $5280ebef38a3c5c6$var$px,
    "margin-right": $5280ebef38a3c5c6$var$px,
    "margin-top": $5280ebef38a3c5c6$var$px,
    "margin-block": $5280ebef38a3c5c6$var$px,
    "margin-block-end": $5280ebef38a3c5c6$var$px,
    "margin-block-start": $5280ebef38a3c5c6$var$px,
    "margin-inline": $5280ebef38a3c5c6$var$px,
    "margin-inline-end": $5280ebef38a3c5c6$var$px,
    "margin-inline-start": $5280ebef38a3c5c6$var$px,
    // Padding properties
    padding: $5280ebef38a3c5c6$var$px,
    "padding-bottom": $5280ebef38a3c5c6$var$px,
    "padding-left": $5280ebef38a3c5c6$var$px,
    "padding-right": $5280ebef38a3c5c6$var$px,
    "padding-top": $5280ebef38a3c5c6$var$px,
    "padding-block": $5280ebef38a3c5c6$var$px,
    "padding-block-end": $5280ebef38a3c5c6$var$px,
    "padding-block-start": $5280ebef38a3c5c6$var$px,
    "padding-inline": $5280ebef38a3c5c6$var$px,
    "padding-inline-end": $5280ebef38a3c5c6$var$px,
    "padding-inline-start": $5280ebef38a3c5c6$var$px,
    // Mask properties
    "mask-position-x": $5280ebef38a3c5c6$var$px,
    "mask-position-y": $5280ebef38a3c5c6$var$px,
    "mask-size": $5280ebef38a3c5c6$var$px,
    // Width and height properties
    height: $5280ebef38a3c5c6$var$px,
    width: $5280ebef38a3c5c6$var$px,
    "min-height": $5280ebef38a3c5c6$var$px,
    "max-height": $5280ebef38a3c5c6$var$px,
    "min-width": $5280ebef38a3c5c6$var$px,
    "max-width": $5280ebef38a3c5c6$var$px,
    // Position properties
    bottom: $5280ebef38a3c5c6$var$px,
    left: $5280ebef38a3c5c6$var$px,
    top: $5280ebef38a3c5c6$var$px,
    right: $5280ebef38a3c5c6$var$px,
    inset: $5280ebef38a3c5c6$var$px,
    "inset-block": $5280ebef38a3c5c6$var$px,
    "inset-block-end": $5280ebef38a3c5c6$var$px,
    "inset-block-start": $5280ebef38a3c5c6$var$px,
    "inset-inline": $5280ebef38a3c5c6$var$px,
    "inset-inline-end": $5280ebef38a3c5c6$var$px,
    "inset-inline-start": $5280ebef38a3c5c6$var$px,
    // Shadow properties
    "box-shadow": $5280ebef38a3c5c6$var$px,
    "text-shadow": $5280ebef38a3c5c6$var$px,
    // Column properties
    "column-gap": $5280ebef38a3c5c6$var$px,
    "column-rule": $5280ebef38a3c5c6$var$px,
    "column-rule-width": $5280ebef38a3c5c6$var$px,
    "column-width": $5280ebef38a3c5c6$var$px,
    // Font and text properties
    "font-size": $5280ebef38a3c5c6$var$px,
    "font-size-delta": $5280ebef38a3c5c6$var$px,
    "letter-spacing": $5280ebef38a3c5c6$var$px,
    "text-decoration-thickness": $5280ebef38a3c5c6$var$px,
    "text-indent": $5280ebef38a3c5c6$var$px,
    "text-stroke": $5280ebef38a3c5c6$var$px,
    "text-stroke-width": $5280ebef38a3c5c6$var$px,
    "word-spacing": $5280ebef38a3c5c6$var$px,
    // Motion properties
    motion: $5280ebef38a3c5c6$var$px,
    "motion-offset": $5280ebef38a3c5c6$var$px,
    // Outline properties
    outline: $5280ebef38a3c5c6$var$px,
    "outline-offset": $5280ebef38a3c5c6$var$px,
    "outline-width": $5280ebef38a3c5c6$var$px,
    // Perspective properties
    perspective: $5280ebef38a3c5c6$var$px,
    "perspective-origin-x": $5280ebef38a3c5c6$var$percent,
    "perspective-origin-y": $5280ebef38a3c5c6$var$percent,
    // Transform properties
    "transform-origin": $5280ebef38a3c5c6$var$percent,
    "transform-origin-x": $5280ebef38a3c5c6$var$percent,
    "transform-origin-y": $5280ebef38a3c5c6$var$percent,
    "transform-origin-z": $5280ebef38a3c5c6$var$percent,
    // Transition properties
    "transition-delay": $5280ebef38a3c5c6$var$ms,
    "transition-duration": $5280ebef38a3c5c6$var$ms,
    // Alignment properties
    "vertical-align": $5280ebef38a3c5c6$var$px,
    "flex-basis": $5280ebef38a3c5c6$var$px,
    // Some random properties
    "shape-margin": $5280ebef38a3c5c6$var$px,
    size: $5280ebef38a3c5c6$var$px,
    gap: $5280ebef38a3c5c6$var$px,
    // Grid properties
    grid: $5280ebef38a3c5c6$var$px,
    "grid-gap": $5280ebef38a3c5c6$var$px,
    "row-gap": $5280ebef38a3c5c6$var$px,
    "grid-row-gap": $5280ebef38a3c5c6$var$px,
    "grid-column-gap": $5280ebef38a3c5c6$var$px,
    "grid-template-rows": $5280ebef38a3c5c6$var$px,
    "grid-template-columns": $5280ebef38a3c5c6$var$px,
    "grid-auto-rows": $5280ebef38a3c5c6$var$px,
    "grid-auto-columns": $5280ebef38a3c5c6$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $5280ebef38a3c5c6$var$px,
    "box-shadow-y": $5280ebef38a3c5c6$var$px,
    "box-shadow-blur": $5280ebef38a3c5c6$var$px,
    "box-shadow-spread": $5280ebef38a3c5c6$var$px,
    "font-line-height": $5280ebef38a3c5c6$var$px,
    "text-shadow-x": $5280ebef38a3c5c6$var$px,
    "text-shadow-y": $5280ebef38a3c5c6$var$px,
    "text-shadow-blur": $5280ebef38a3c5c6$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $5280ebef38a3c5c6$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $5280ebef38a3c5c6$var$units = $5280ebef38a3c5c6$var$addCamelCasedVersion($5280ebef38a3c5c6$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $5280ebef38a3c5c6$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $5280ebef38a3c5c6$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $5280ebef38a3c5c6$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $5280ebef38a3c5c6$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $5280ebef38a3c5c6$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $5280ebef38a3c5c6$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $5280ebef38a3c5c6$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $5280ebef38a3c5c6$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $5280ebef38a3c5c6$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $5280ebef38a3c5c6$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5280ebef38a3c5c6$export$2e2bcd8739ae039 = $5280ebef38a3c5c6$var$defaultUnit;

});

parcelRegister("81Rrl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d87dec9ac2db100$export$2e2bcd8739ae039);

var $WZ5By = parcelRequire("WZ5By");

var $f88hq = parcelRequire("f88hq");
/**
 * Add vendor prefix to a property name when needed.
 */ function $5d87dec9ac2db100$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $WZ5By.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $WZ5By.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $WZ5By.supportedValue)(supportedProp, (0, $f88hq.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $WZ5By.supportedValue)(prop, (0, $f88hq.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5d87dec9ac2db100$export$2e2bcd8739ae039 = $5d87dec9ac2db100$var$jssVendorPrefixer;

});
parcelRegister("WZ5By", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", () => $0b14cdf9ea25e36f$export$b6aa0648d950180a);
$parcel$export(module.exports, "supportedProperty", () => $0b14cdf9ea25e36f$export$ce097f82c2e4551a);
$parcel$export(module.exports, "supportedValue", () => $0b14cdf9ea25e36f$export$511766124059c277);

var $ja49S = parcelRequire("ja49S");

var $kbxxf = parcelRequire("kbxxf");
// Export javascript style and css style vendor prefixes.
var $0b14cdf9ea25e36f$var$js = "";
var $0b14cdf9ea25e36f$var$css = "";
var $0b14cdf9ea25e36f$var$vendor = "";
var $0b14cdf9ea25e36f$var$browser = "";
var $0b14cdf9ea25e36f$var$isTouch = (0, $ja49S.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $ja49S.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $0b14cdf9ea25e36f$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $0b14cdf9ea25e36f$var$_document$createEleme = document.createElement("p"), $0b14cdf9ea25e36f$var$style = $0b14cdf9ea25e36f$var$_document$createEleme.style;
    var $0b14cdf9ea25e36f$var$testProp = "Transform";
    for(var $0b14cdf9ea25e36f$var$key in $0b14cdf9ea25e36f$var$jsCssMap)if ($0b14cdf9ea25e36f$var$key + $0b14cdf9ea25e36f$var$testProp in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = $0b14cdf9ea25e36f$var$key;
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap[$0b14cdf9ea25e36f$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($0b14cdf9ea25e36f$var$js === "Webkit" && "msHyphens" in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = "ms";
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap.ms;
        $0b14cdf9ea25e36f$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($0b14cdf9ea25e36f$var$js === "Webkit" && "-apple-trailing-word" in $0b14cdf9ea25e36f$var$style) $0b14cdf9ea25e36f$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $0b14cdf9ea25e36f$export$82e9f45cca5ba907 = {
    js: $0b14cdf9ea25e36f$var$js,
    css: $0b14cdf9ea25e36f$var$css,
    vendor: $0b14cdf9ea25e36f$var$vendor,
    browser: $0b14cdf9ea25e36f$var$browser,
    isTouch: $0b14cdf9ea25e36f$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $0b14cdf9ea25e36f$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $0b14cdf9ea25e36f$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $0b14cdf9ea25e36f$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$camelize(str) {
    return str.replace($0b14cdf9ea25e36f$var$regExp, $0b14cdf9ea25e36f$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$pascalize(str) {
    return $0b14cdf9ea25e36f$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $0b14cdf9ea25e36f$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($0b14cdf9ea25e36f$var$camelize(longhand) in style) return prop;
            if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(longhand) in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $0b14cdf9ea25e36f$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === "apple" && !$0b14cdf9ea25e36f$export$82e9f45cca5ba907.isTouch) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $0b14cdf9ea25e36f$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $0b14cdf9ea25e36f$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $0b14cdf9ea25e36f$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms" && $0b14cdf9ea25e36f$export$82e9f45cca5ba907.browser !== "edge") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $0b14cdf9ea25e36f$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === "apple") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $0b14cdf9ea25e36f$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return jsProp in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $0b14cdf9ea25e36f$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $0b14cdf9ea25e36f$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $0b14cdf9ea25e36f$var$camelize(prop) in style ? prop : false;
    }
};
var $0b14cdf9ea25e36f$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $0b14cdf9ea25e36f$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + pascalized in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $0b14cdf9ea25e36f$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return "" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $0b14cdf9ea25e36f$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $0b14cdf9ea25e36f$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $0b14cdf9ea25e36f$var$propMap[prop];
        if (!newProp) return false;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $0b14cdf9ea25e36f$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $0b14cdf9ea25e36f$var$propKeys = Object.keys($0b14cdf9ea25e36f$var$propMap$1);
var $0b14cdf9ea25e36f$var$prefixCss = function prefixCss(p) {
    return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $0b14cdf9ea25e36f$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($0b14cdf9ea25e36f$var$propKeys.indexOf(prop) > -1) {
            var newProp = $0b14cdf9ea25e36f$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($0b14cdf9ea25e36f$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $0b14cdf9ea25e36f$var$plugins = [
    $0b14cdf9ea25e36f$var$appearence,
    $0b14cdf9ea25e36f$var$colorAdjust,
    $0b14cdf9ea25e36f$var$mask,
    $0b14cdf9ea25e36f$var$textOrientation,
    $0b14cdf9ea25e36f$var$transform,
    $0b14cdf9ea25e36f$var$transition,
    $0b14cdf9ea25e36f$var$writingMode,
    $0b14cdf9ea25e36f$var$userSelect,
    $0b14cdf9ea25e36f$var$breakPropsOld,
    $0b14cdf9ea25e36f$var$inlineLogicalOld,
    $0b14cdf9ea25e36f$var$unprefixed,
    $0b14cdf9ea25e36f$var$prefixed,
    $0b14cdf9ea25e36f$var$scrollSnap,
    $0b14cdf9ea25e36f$var$overscrollBehavior,
    $0b14cdf9ea25e36f$var$flex2012,
    $0b14cdf9ea25e36f$var$flex2009
];
var $0b14cdf9ea25e36f$var$propertyDetectors = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $0b14cdf9ea25e36f$var$noPrefill = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $kbxxf.default)(p.noPrefill));
    return a;
}, []);
var $0b14cdf9ea25e36f$var$el;
var $0b14cdf9ea25e36f$var$cache = {};
if (0, $ja49S.default) {
    $0b14cdf9ea25e36f$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $0b14cdf9ea25e36f$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $0b14cdf9ea25e36f$var$key$1 in $0b14cdf9ea25e36f$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($0b14cdf9ea25e36f$var$key$1)) $0b14cdf9ea25e36f$var$cache[$0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1]] = $0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $0b14cdf9ea25e36f$var$noPrefill.forEach(function(x) {
        return delete $0b14cdf9ea25e36f$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$0b14cdf9ea25e36f$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($0b14cdf9ea25e36f$var$cache[prop] != null) return $0b14cdf9ea25e36f$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $0b14cdf9ea25e36f$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $0b14cdf9ea25e36f$var$propertyDetectors.length; i++){
        $0b14cdf9ea25e36f$var$cache[prop] = $0b14cdf9ea25e36f$var$propertyDetectors[i](prop, $0b14cdf9ea25e36f$var$el.style, options); // Break loop, if value found.
        if ($0b14cdf9ea25e36f$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $0b14cdf9ea25e36f$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $0b14cdf9ea25e36f$var$cache[prop];
}
var $0b14cdf9ea25e36f$var$cache$1 = {};
var $0b14cdf9ea25e36f$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $0b14cdf9ea25e36f$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $0b14cdf9ea25e36f$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p1) : ", " + $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $ja49S.default) $0b14cdf9ea25e36f$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$0b14cdf9ea25e36f$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($0b14cdf9ea25e36f$var$cache$1[cacheKey] != null) return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($0b14cdf9ea25e36f$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($0b14cdf9ea25e36f$var$transPropsRegExp, $0b14cdf9ea25e36f$var$prefixTransitionCallback);
    else if ($0b14cdf9ea25e36f$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $0b14cdf9ea25e36f$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($0b14cdf9ea25e36f$var$el$1.style[property] === "") {
            $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $0b14cdf9ea25e36f$var$el$1.style[property] = ""; // Write current value to cache.
    $0b14cdf9ea25e36f$var$cache$1[cacheKey] = prefixedValue;
    return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
}

});
parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $cN7Ua.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7K8zV.default)(r);
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7K8zV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7K8zV.default)(r, a) : void 0;
    }
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("3TmXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d5851d4b913d01d$export$2e2bcd8739ae039);
/**
 * Sort props by length.
 */ function $2d5851d4b913d01d$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $2d5851d4b913d01d$export$2e2bcd8739ae039 = $2d5851d4b913d01d$var$jssPropsSort;

});



parcelRegister("9p8NW", function(module, exports) {

$parcel$export(module.exports, "increment", () => $6d8d47425bc40907$export$a2647aa13413c947);
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $6d8d47425bc40907$var$indexCounter = -1000000000;
function $6d8d47425bc40907$export$a2647aa13413c947() {
    $6d8d47425bc40907$var$indexCounter += 1;
    if ($6d8d47425bc40907$var$indexCounter >= 0) console.warn([
        "MUI: You might have a memory leak.",
        "The indexCounter is not supposed to grow that much."
    ].join("\n"));
    return $6d8d47425bc40907$var$indexCounter;
}

});

parcelRegister("f5fvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb35a18e8b17e0a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $3z1Ay = parcelRequire("3z1Ay");

var $l3DCH = parcelRequire("l3DCH");

var $5EhBI = parcelRequire("5EhBI");
function $afb35a18e8b17e0a$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === "function";
    if (typeof stylesOrCreator !== "object" && !themingEnabled) console.error([
        "MUI: The `styles` argument provided is invalid.",
        "You need to provide a function generating the styles or a styles object."
    ].join("\n"));
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                if (themingEnabled === true && theme === (0, $5EhBI.default)) // TODO: prepend error message/name instead
                console.error([
                    "MUI: The `styles` argument provided is invalid.",
                    "You are providing a function without a theme in the context.",
                    "One of the parent elements needs to use a ThemeProvider."
                ].join("\n"));
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $8nd05.default)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                if (!stylesWithOverrides[key]) console.warn([
                    "MUI: You are trying to override a style that does not exist.",
                    `Fix the \`${key}\` key of \`theme.components.${name}.styleOverrides\`.`,
                    "",
                    `If you intentionally wanted to add a new key, please use the theme.components[${name}].variants option.`
                ].join("\n"));
                stylesWithOverrides[key] = (0, $3z1Ay.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $l3DCH.default)(definition.props);
                stylesWithOverrides[classKey] = (0, $3z1Ay.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("l3DCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5489d1d50f78a43$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $gxvzd = parcelRequire("gxvzd");
const $f5489d1d50f78a43$var$_excluded = [
    "variant"
];
function $f5489d1d50f78a43$var$isEmpty(string) {
    return string.length === 0;
}
function $f5489d1d50f78a43$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $1En50.default)(props, $f5489d1d50f78a43$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $f5489d1d50f78a43$var$isEmpty(classKey) ? props[key] : (0, $gxvzd.default)(props[key]);
        else classKey += `${$f5489d1d50f78a43$var$isEmpty(classKey) ? key : (0, $gxvzd.default)(key)}${(0, $gxvzd.default)(props[key].toString())}`;
    });
    return classKey;
}

});

parcelRegister("5EhBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $41ce589cb6180c8f$export$2e2bcd8739ae039);
// We use the same empty object to ref count the styles that don't need a theme object.
const $41ce589cb6180c8f$var$noopTheme = {};
var $41ce589cb6180c8f$export$2e2bcd8739ae039 = $41ce589cb6180c8f$var$noopTheme;

});




parcelRegister("0LEOn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $3xrB1 = parcelRequire("3xrB1");
const $0024f7f064d4a103$var$useStylesV1 = (0, $1GFtd.default)({
    root: {
        fontSize: $i4KPV.FONT.SIZE.BASE
    },
    alert: {
        backgroundColor: ({ type: type })=>type === $3xrB1.TYPE_ENUM.white ? $i4KPV.COLORS.WHITE : type === $3xrB1.TYPE_ENUM.dark ? $i4KPV.COLORS.SURFACE_SNACKBAR : type === $3xrB1.TYPE_ENUM.accent ? $i4KPV.COLORS.PRIMARY_50 : type === $3xrB1.TYPE_ENUM.warning ? $i4KPV.COLORS.WARNING_LIGHT : type === $3xrB1.TYPE_ENUM.error ? $i4KPV.COLORS.ERROR_LIGHT : type === $3xrB1.TYPE_ENUM.success ? $i4KPV.COLORS.SUCCESS_LIGHT : $i4KPV.COLORS.GRAY_CHIP_MEDIUM
    },
    textContainer: {},
    title: {},
    text: {
        color: ({ type: type })=>type === $3xrB1.TYPE_ENUM.white ? $i4KPV.COLORS.BLACK_HIGH_EMPHASIS : type === $3xrB1.TYPE_ENUM.dark ? $i4KPV.COLORS.WHITE : type === $3xrB1.TYPE_ENUM.accent ? $i4KPV.COLORS.PRIMARY_400 : type === $3xrB1.TYPE_ENUM.warning ? $i4KPV.COLORS.WARNING_DARK : type === $3xrB1.TYPE_ENUM.error ? $i4KPV.COLORS.ERROR_DARK : type === $3xrB1.TYPE_ENUM.success ? $i4KPV.COLORS.SUCCESS_DARK : $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS,
        fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
        lineHeight: 1.2,
        marginRight: "0.625em"
    },
    icon: {
        color: ({ type: type })=>type === $3xrB1.TYPE_ENUM.white ? $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS : type === $3xrB1.TYPE_ENUM.dark ? $i4KPV.COLORS.WHITE_MEDIUM_EMPHASIS : type === $3xrB1.TYPE_ENUM.accent ? $i4KPV.COLORS.PRIMARY_500_ACCENT : type === $3xrB1.TYPE_ENUM.warning ? $i4KPV.COLORS.WARNING_BASE : type === $3xrB1.TYPE_ENUM.error ? $i4KPV.COLORS.ERROR_DARK : type === $3xrB1.TYPE_ENUM.success ? $i4KPV.COLORS.SUCCESS_DARK : $i4KPV.COLORS.BLACK_DISABLED
    },
    button: {
        color: ({ type: type })=>type === $3xrB1.TYPE_ENUM.white ? $i4KPV.COLORS.PRIMARY_500_ACCENT : type === $3xrB1.TYPE_ENUM.dark ? $i4KPV.COLORS.PRIMARY_500_ACCENT : type === $3xrB1.TYPE_ENUM.accent ? $i4KPV.COLORS.PRIMARY_500_ACCENT : type === $3xrB1.TYPE_ENUM.warning ? $i4KPV.COLORS.WARNING_DARK : type === $3xrB1.TYPE_ENUM.error ? $i4KPV.COLORS.ERROR_DARK : type === $3xrB1.TYPE_ENUM.success ? $i4KPV.COLORS.SUCCESS_DARK : $i4KPV.COLORS.BLACK_DISABLED,
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        marginLeft: "auto",
        minWidth: "unset"
    },
    closeIcon: {}
});
module.exports.default = $0024f7f064d4a103$var$useStylesV1;

});

parcelRegister("kK7wF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $3xrB1 = parcelRequire("3xrB1");
const $f19df0fdf63625e5$var$useStylesV2 = (0, $1GFtd.default)({
    alert: {
        minWidth: "auto",
        minHeight: "4em",
        padding: "0.625em 0.625em 0.625em 1em",
        borderRadius: "0.625em",
        boxShadow: `0 0.25em 0.25em ${$i4KPV.COLORS_V2_ALPHA.NEUTRAL_BLACK_SHADOW}`,
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_BLACK.replace(")", ", 0.75)")
    },
    icon: {
        height: "2em",
        margin: "0 0.4375em 0 0.125em",
        color: ({ type: type })=>type === $3xrB1.TYPE_ENUM.dark ? $i4KPV.COLORS_V2.NEUTRAL_WHITE : type === $3xrB1.TYPE_ENUM.success ? $i4KPV.COLORS_V2.SUCCESS_LIGHT : type === $3xrB1.TYPE_ENUM.warning ? $i4KPV.COLORS_V2.WARNING_DARK : type === $3xrB1.TYPE_ENUM.error ? $i4KPV.COLORS_V2.ERROR_DARK : $i4KPV.COLORS_V2.NEUTRAL_DARK,
        background: ({ type: type })=>type === $3xrB1.TYPE_ENUM.dark ? "unset" : `radial-gradient(circle at center, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 0, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 50%, transparent 51%, transparent 100%)`,
        "& > .MuiSvgIcon-root": {
            fontSize: "2.1em"
        }
    },
    textContainer: {
        color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        marginRight: "1em",
        minWidth: "8em",
        lineHeight: "1.125em"
    },
    title: {
        fontSize: $i4KPV.FONT.SIZE.LARGE,
        fontWeight: $i4KPV.FONT.WEIGHT.BOLD,
        lineHeight: "inherit",
        marginBottom: "0.1875em",
        marginRight: 0
    },
    text: {
        fontSize: $i4KPV.FONT.SIZE.LARGE,
        fontWeight: $i4KPV.FONT.WEIGHT.NORMAL,
        lineHeight: "inherit",
        marginRight: 0
    },
    button: {
        fontSize: $i4KPV.FONT.SIZE.LARGE,
        fontWeight: $i4KPV.FONT.WEIGHT.SEMI_BOLD,
        textTransform: "uppercase",
        borderRadius: "1em",
        margin: 0,
        padding: "0.25em 0.714287em",
        color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        height: "2.1428571em",
        "&:hover": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_BLACK
        }
    },
    closeIcon: {
        color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        padding: 0,
        margin: "0 0.416667em 0 0",
        "&:hover": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_DARK
        }
    }
});
module.exports.default = $f19df0fdf63625e5$var$useStylesV2;

});


parcelRegister("bJGq5", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $88b4cd5a21664005$export$2b8d127b894957b9, (v) => $88b4cd5a21664005$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $88b4cd5a21664005$export$cea3a54a6425200c, (v) => $88b4cd5a21664005$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $88b4cd5a21664005$export$a7c73072b1a182ae, (v) => $88b4cd5a21664005$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $88b4cd5a21664005$export$9f27bc3417b4524d, (v) => $88b4cd5a21664005$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $88b4cd5a21664005$export$db77ccec0bb4ccac, (v) => $88b4cd5a21664005$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $88b4cd5a21664005$export$8392c0c9d3dcbd35, (v) => $88b4cd5a21664005$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $88b4cd5a21664005$export$ffb0004e005737fa, (v) => $88b4cd5a21664005$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $88b4cd5a21664005$export$b624eff549462981, (v) => $88b4cd5a21664005$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $88b4cd5a21664005$export$7897aa7841a5380c, (v) => $88b4cd5a21664005$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $88b4cd5a21664005$export$602eac185826482c, (v) => $88b4cd5a21664005$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $88b4cd5a21664005$export$e2c29f18771995cb, (v) => $88b4cd5a21664005$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $88b4cd5a21664005$export$5f8d39834fd61797, (v) => $88b4cd5a21664005$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $88b4cd5a21664005$export$74bf444e3cd11ea5, (v) => $88b4cd5a21664005$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $88b4cd5a21664005$export$92387174baf9b227, (v) => $88b4cd5a21664005$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $88b4cd5a21664005$export$ec112efeb987d9c6, (v) => $88b4cd5a21664005$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $88b4cd5a21664005$export$b706b080d889d2c9, (v) => $88b4cd5a21664005$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $88b4cd5a21664005$export$5be5a87408f70ddc, (v) => $88b4cd5a21664005$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $88b4cd5a21664005$export$45a5e7f76e0caa8d, (v) => $88b4cd5a21664005$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $88b4cd5a21664005$export$455c2e768291efa6, (v) => $88b4cd5a21664005$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $88b4cd5a21664005$export$9522e17588c12572, (v) => $88b4cd5a21664005$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $88b4cd5a21664005$export$2110ac352bb060b9, (v) => $88b4cd5a21664005$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $88b4cd5a21664005$export$56885ab8b9c456ab, (v) => $88b4cd5a21664005$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $88b4cd5a21664005$export$d927fcb6adf8f9de, (v) => $88b4cd5a21664005$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $88b4cd5a21664005$export$b82d16f27459e05a, (v) => $88b4cd5a21664005$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $88b4cd5a21664005$export$522c17b4f5e123e8, (v) => $88b4cd5a21664005$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $88b4cd5a21664005$export$1aabd8a0274ecfd6, (v) => $88b4cd5a21664005$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $88b4cd5a21664005$export$9b621391a187a31a, (v) => $88b4cd5a21664005$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $88b4cd5a21664005$export$f5bbd400c2f4426f, (v) => $88b4cd5a21664005$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $88b4cd5a21664005$export$2b8d127b894957b9;
var $88b4cd5a21664005$export$cea3a54a6425200c;
var $88b4cd5a21664005$export$a7c73072b1a182ae;
var $88b4cd5a21664005$export$9f27bc3417b4524d;
var $88b4cd5a21664005$export$db77ccec0bb4ccac;
var $88b4cd5a21664005$export$8392c0c9d3dcbd35;
var $88b4cd5a21664005$export$ffb0004e005737fa;
var $88b4cd5a21664005$export$b624eff549462981;
var $88b4cd5a21664005$export$7897aa7841a5380c;
var $88b4cd5a21664005$export$602eac185826482c;
var $88b4cd5a21664005$export$e2c29f18771995cb;
var $88b4cd5a21664005$export$5f8d39834fd61797;
var $88b4cd5a21664005$export$74bf444e3cd11ea5;
var $88b4cd5a21664005$export$92387174baf9b227;
var $88b4cd5a21664005$export$ec112efeb987d9c6;
var $88b4cd5a21664005$export$b706b080d889d2c9;
var $88b4cd5a21664005$export$5be5a87408f70ddc;
var $88b4cd5a21664005$export$45a5e7f76e0caa8d;
var $88b4cd5a21664005$export$455c2e768291efa6;
var $88b4cd5a21664005$export$9522e17588c12572;
var $88b4cd5a21664005$export$2110ac352bb060b9;
var $88b4cd5a21664005$export$56885ab8b9c456ab;
var $88b4cd5a21664005$export$d927fcb6adf8f9de;
var $88b4cd5a21664005$export$b82d16f27459e05a;
var $88b4cd5a21664005$export$522c17b4f5e123e8;
var $88b4cd5a21664005$export$1aabd8a0274ecfd6;
var $88b4cd5a21664005$export$9b621391a187a31a;
var $88b4cd5a21664005$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $88b4cd5a21664005$export$2b8d127b894957b9 = AsyncMode;
    $88b4cd5a21664005$export$cea3a54a6425200c = ConcurrentMode;
    $88b4cd5a21664005$export$a7c73072b1a182ae = ContextConsumer;
    $88b4cd5a21664005$export$9f27bc3417b4524d = ContextProvider;
    $88b4cd5a21664005$export$db77ccec0bb4ccac = Element;
    $88b4cd5a21664005$export$8392c0c9d3dcbd35 = ForwardRef;
    $88b4cd5a21664005$export$ffb0004e005737fa = Fragment;
    $88b4cd5a21664005$export$b624eff549462981 = Lazy;
    $88b4cd5a21664005$export$7897aa7841a5380c = Memo;
    $88b4cd5a21664005$export$602eac185826482c = Portal;
    $88b4cd5a21664005$export$e2c29f18771995cb = Profiler;
    $88b4cd5a21664005$export$5f8d39834fd61797 = StrictMode;
    $88b4cd5a21664005$export$74bf444e3cd11ea5 = Suspense;
    $88b4cd5a21664005$export$92387174baf9b227 = isAsyncMode;
    $88b4cd5a21664005$export$ec112efeb987d9c6 = isConcurrentMode;
    $88b4cd5a21664005$export$b706b080d889d2c9 = isContextConsumer;
    $88b4cd5a21664005$export$5be5a87408f70ddc = isContextProvider;
    $88b4cd5a21664005$export$45a5e7f76e0caa8d = isElement;
    $88b4cd5a21664005$export$455c2e768291efa6 = isForwardRef;
    $88b4cd5a21664005$export$9522e17588c12572 = isFragment;
    $88b4cd5a21664005$export$2110ac352bb060b9 = isLazy;
    $88b4cd5a21664005$export$56885ab8b9c456ab = isMemo;
    $88b4cd5a21664005$export$d927fcb6adf8f9de = isPortal;
    $88b4cd5a21664005$export$b82d16f27459e05a = isProfiler;
    $88b4cd5a21664005$export$522c17b4f5e123e8 = isStrictMode;
    $88b4cd5a21664005$export$1aabd8a0274ecfd6 = isSuspense;
    $88b4cd5a21664005$export$9b621391a187a31a = isValidElementType;
    $88b4cd5a21664005$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("1SJGG", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $o8HxT = parcelRequire("o8HxT");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $15ee4628980e0994$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $15ee4628980e0994$var$isString(value) {
    return typeof value == "string" || !$o8HxT(value) && $8l89S(value) && $eq6CV(value) == $15ee4628980e0994$var$stringTag;
}
module.exports = $15ee4628980e0994$var$isString;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});

parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});


parcelRegister("jZ8n5", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $e8ca352f25b37def$export$bf730a2d8bf68b42, (v) => $e8ca352f25b37def$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8ca352f25b37def$export$bf730a2d8bf68b42;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var shim = (parcelRequire("hfliI"));
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var useSyncExternalStore = shim.useSyncExternalStore;
    // for CommonJS interop.
    var useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.
    function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        // Use this to track the rendered snapshot.
        var instRef = useRef(null);
        var inst;
        if (instRef.current === null) {
            inst = {
                hasValue: false,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        var _useMemo = useMemo(function() {
            // Track the memoized state using closure variables that are local to this
            // memoized instance of a getSnapshot function. Intentionally not using a
            // useRef hook, because that state would be shared across all concurrent
            // copies of the hook/component.
            var hasMemo = false;
            var memoizedSnapshot;
            var memoizedSelection;
            var memoizedSelector = function(nextSnapshot) {
                if (!hasMemo) {
                    // The first time the hook is called, there is no memoized result.
                    hasMemo = true;
                    memoizedSnapshot = nextSnapshot;
                    var _nextSelection = selector(nextSnapshot);
                    if (isEqual !== undefined) // Even if the selector has changed, the currently rendered selection
                    // may be equal to the new selection. We should attempt to reuse the
                    // current value if possible, to preserve downstream memoizations.
                    {
                        if (inst.hasValue) {
                            var currentSelection = inst.value;
                            if (isEqual(currentSelection, _nextSelection)) {
                                memoizedSelection = currentSelection;
                                return currentSelection;
                            }
                        }
                    }
                    memoizedSelection = _nextSelection;
                    return _nextSelection;
                } // We may be able to reuse the previous invocation's result.
                // We may be able to reuse the previous invocation's result.
                var prevSnapshot = memoizedSnapshot;
                var prevSelection = memoizedSelection;
                if (objectIs(prevSnapshot, nextSnapshot)) // The snapshot is the same as last time. Reuse the previous selection.
                return prevSelection;
                 // The snapshot has changed, so we need to compute a new selection.
                // The snapshot has changed, so we need to compute a new selection.
                var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
                // has changed. If it hasn't, return the previous selection. That signals
                // to React that the selections are conceptually equal, and we can bail
                // out of rendering.
                // If a custom isEqual function is provided, use that to check if the data
                // has changed. If it hasn't, return the previous selection. That signals
                // to React that the selections are conceptually equal, and we can bail
                // out of rendering.
                if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) return prevSelection;
                memoizedSnapshot = nextSnapshot;
                memoizedSelection = nextSelection;
                return nextSelection;
            }; // Assigning this to a constant so that Flow knows it can't change.
            // Assigning this to a constant so that Flow knows it can't change.
            var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;
            var getSnapshotWithSelector = function() {
                return memoizedSelector(getSnapshot());
            };
            var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            };
            return [
                getSnapshotWithSelector,
                getServerSnapshotWithSelector
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]), getSelection = _useMemo[0], getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect(function() {
            inst.hasValue = true;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    }
    $e8ca352f25b37def$export$bf730a2d8bf68b42 = useSyncExternalStoreWithSelector;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6KR8i"));

});
parcelRegister("6KR8i", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $4eb0410bd318fafe$export$306c0aa65ff9ec16, (v) => $4eb0410bd318fafe$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4eb0410bd318fafe$export$306c0aa65ff9ec16;
"use strict";

(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    // dispatch for CommonJS interop named imports.
    var useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
    var didWarnOld18Alpha = false;
    var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
    // because of a very particular set of implementation details and assumptions
    // -- change any one of them and it will break. The most important assumption
    // is that updates are always synchronous, because concurrent rendering is
    // only available in versions of React that also have a built-in
    // useSyncExternalStore API. And we only use this shim when the built-in API
    // does not exist.
    //
    // Do not assume that the clever hacks used by this hook also work in general.
    // The point of this shim is to replace the need for hacks by other libraries.
    function useSyncExternalStore(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    getServerSnapshot) {
        if (!didWarnOld18Alpha) {
            if (React.startTransition !== undefined) {
                didWarnOld18Alpha = true;
                error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
        }
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.
        var _useState = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        }), inst = _useState[0].inst, forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
            // commit phase if there was an interleaved mutation. In concurrent mode
            // this can happen all the time, but even in synchronous mode, an earlier
            // effect may have mutated the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            // Check for changes right before subscribing. Subsequent changes will be
            // detected in the subscription handler.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
            var handleStoreChange = function() {
                // TODO: Because there is no cross-renderer API for batching updates, it's
                // up to the consumer of this library to wrap their subscription event
                // with unstable_batchedUpdates. Should we try to detect when this isn't
                // the case and print a warning in development?
                // The store changed. Check if the snapshot changed since the last time we
                // read from the store.
                if (checkIfSnapshotChanged(inst)) // Force a re-render.
                forceUpdate({
                    inst: inst
                });
            }; // Subscribe to the store and return a clean-up function.
            return subscribe(handleStoreChange);
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        // Note: The shim does not use getServerSnapshot, because pre-18 versions of
        // React do not expose a way to check if we're hydrating. So users of the shim
        // will need to track that themselves and return the correct value
        // from `getSnapshot`.
        return getSnapshot();
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var isServerEnvironment = !canUseDOM;
    var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
    var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;
    $4eb0410bd318fafe$export$306c0aa65ff9ec16 = useSyncExternalStore$2;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("iqpWY", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
var $hPtJY = parcelRequire("hPtJY");

exports = module.exports = (parcelRequire("1p2Hm"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    "lightseagreen",
    "forestgreen",
    "goldenrod",
    "dodgerblue",
    "darkorchid",
    "crimson"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && window.process.type === "renderer") return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return "[UnexpectedJSONParseError]: " + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? "%c" : "") + this.namespace + (useColors ? " %c" : " ") + args[0] + (useColors ? "%c " : " ") + "+" + exports.humanize(this.diff);
    if (!useColors) return;
    var c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ("%%" === match) return;
        index++;
        if ("%c" === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem("debug");
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $hPtJY !== "undefined" && "env" in $hPtJY) r = undefined;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("1p2Hm", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug["default"] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("e9TqR"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ("string" !== typeof args[0]) // anything else let's inspect with %O
        args.unshift("%O");
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === "%%") return match;
            index++;
            var formatter = exports.formatters[format];
            if ("function" === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ("function" === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, ".*?");
        if (namespaces[0] === "-") exports.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
        else exports.names.push(new RegExp("^" + namespaces + "$"));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable("");
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("e9TqR", function(module, exports) {
/**
 * Helpers.
 */ var $a4ece7a21cd42d5c$var$s = 1000;
var $a4ece7a21cd42d5c$var$m = $a4ece7a21cd42d5c$var$s * 60;
var $a4ece7a21cd42d5c$var$h = $a4ece7a21cd42d5c$var$m * 60;
var $a4ece7a21cd42d5c$var$d = $a4ece7a21cd42d5c$var$h * 24;
var $a4ece7a21cd42d5c$var$y = $a4ece7a21cd42d5c$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $a4ece7a21cd42d5c$var$parse(val);
    else if (type === "number" && isNaN(val) === false) return options.long ? $a4ece7a21cd42d5c$var$fmtLong(val) : $a4ece7a21cd42d5c$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $a4ece7a21cd42d5c$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $a4ece7a21cd42d5c$var$y;
        case "days":
        case "day":
        case "d":
            return n * $a4ece7a21cd42d5c$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $a4ece7a21cd42d5c$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $a4ece7a21cd42d5c$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $a4ece7a21cd42d5c$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $a4ece7a21cd42d5c$var$fmtShort(ms) {
    if (ms >= $a4ece7a21cd42d5c$var$d) return Math.round(ms / $a4ece7a21cd42d5c$var$d) + "d";
    if (ms >= $a4ece7a21cd42d5c$var$h) return Math.round(ms / $a4ece7a21cd42d5c$var$h) + "h";
    if (ms >= $a4ece7a21cd42d5c$var$m) return Math.round(ms / $a4ece7a21cd42d5c$var$m) + "m";
    if (ms >= $a4ece7a21cd42d5c$var$s) return Math.round(ms / $a4ece7a21cd42d5c$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $a4ece7a21cd42d5c$var$fmtLong(ms) {
    return $a4ece7a21cd42d5c$var$plural(ms, $a4ece7a21cd42d5c$var$d, "day") || $a4ece7a21cd42d5c$var$plural(ms, $a4ece7a21cd42d5c$var$h, "hour") || $a4ece7a21cd42d5c$var$plural(ms, $a4ece7a21cd42d5c$var$m, "minute") || $a4ece7a21cd42d5c$var$plural(ms, $a4ece7a21cd42d5c$var$s, "second") || ms + " ms";
}
/**
 * Pluralization helper.
 */ function $a4ece7a21cd42d5c$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + " " + name;
    return Math.ceil(ms / n) + " " + name + "s";
}

});



parcelRegister("lcSRC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === "object" || type === "function");
    }
    function isFunction(x) {
        return typeof x === "function";
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== "undefined" ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === "undefined" && typeof $hPtJY !== "undefined" && ({}).toString.call($hPtJY) === "[object process]";
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $hPtJY.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== "undefined") return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode("");
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function("return this")().require("vertx");
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.");
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, "Settle: " + (promise._label || " unknown promise"));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error("Array Methods must be provided an Array");
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== "function") {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError("You must pass an array to race."));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== "function" && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== "undefined") local = $parcel$global;
        else if (typeof self !== "undefined") local = self;
        else try {
            local = Function("return this")();
        } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === "[object Promise]" && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});

parcelRegister("c5tG7", function(module, exports) {
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7WlvX", function(module, exports) {
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ataIx", function(module, exports) {
"use strict";
var $79f4ed133ea8848d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $79f4ed133ea8848d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $79f4ed133ea8848d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $79f4ed133ea8848d$var$__createBinding(result, mod, k);
    }
    $79f4ed133ea8848d$var$__setModuleDefault(result, mod);
    return result;
};
var $79f4ed133ea8848d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $79f4ed133ea8848d$var$react_1 = $79f4ed133ea8848d$var$__importStar((parcelRequire("acw62")));

var $4fGPb = parcelRequire("4fGPb");

var $f1q41 = parcelRequire("f1q41");

var $9Lykx = parcelRequire("9Lykx");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");

var $i4KPV = parcelRequire("i4KPV");

const $79f4ed133ea8848d$var$shared_components_krg_vertical_navigation_1 = $79f4ed133ea8848d$var$__importDefault((parcelRequire("dtVYq")));

const $79f4ed133ea8848d$var$krg_header_menu_button_style_1 = $79f4ed133ea8848d$var$__importDefault((parcelRequire("hH27q")));
const $79f4ed133ea8848d$var$KrgHeaderMenuButton = ({ className: className = "", menuClassName: menuClassName = "", style: style, anchorOrigin: anchorOrigin = {
    vertical: "bottom",
    horizontal: "right"
}, transformOrigin: transformOrigin = {
    vertical: "top",
    horizontal: "right"
}, menuItems: menuItems, icon: icon, header: header = {
    title: ""
}, isOpen: isOpen = false, theme: theme = $i4KPV.THEME_ENUM.v1, onVisibilityChange: onVisibilityChange, onClick: onClick, onBlur: onBlur, onFocus: onFocus })=>{
    const isV2Theme = theme === $i4KPV.THEME_ENUM.v2;
    const classes = (0, $79f4ed133ea8848d$var$krg_header_menu_button_style_1.default)();
    const [anchorEl, setAnchorEl] = (0, $79f4ed133ea8848d$var$react_1.useState)(null);
    const [isMenuOpen, setIsMenuOpen] = (0, $79f4ed133ea8848d$var$react_1.useState)(isOpen);
    (0, $79f4ed133ea8848d$var$react_1.useEffect)(()=>setIsMenuOpen(isOpen), [
        isOpen
    ]);
    const ref = $79f4ed133ea8848d$var$react_1.default.useRef(null);
    (0, $i4KPV.useOutsideClick)(ref, ()=>handleClose());
    const handleOpen = (e)=>{
        onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(true);
        setIsMenuOpen(true);
        const innerElement = e.currentTarget.childNodes[0];
        setAnchorEl(innerElement);
    };
    const handleClose = ()=>{
        onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(false);
        setIsMenuOpen(false);
        setAnchorEl(null);
    };
    const handleClick = (item)=>{
        var _a;
        (_a = item.handleClick) === null || _a === void 0 || _a.call(item);
        handleClose();
    };
    return $79f4ed133ea8848d$var$react_1.default.createElement($79f4ed133ea8848d$var$react_1.default.Fragment, null, $79f4ed133ea8848d$var$react_1.default.createElement($9Lykx.default, {
        className: `${className} ${classes.button}`,
        TouchRippleProps: {
            className: classes.buttonRippleClass
        },
        style: style,
        onClick: (e)=>{
            onClick === null || onClick === void 0 || onClick(e);
            isMenuOpen ? handleClose() : handleOpen(e);
        },
        onFocus: onFocus,
        onBlur: onBlur
    }, icon), $79f4ed133ea8848d$var$react_1.default.createElement($4F5tJ.default, {
        classes: {
            paper: `${classes.menuPaper} ${menuClassName}`,
            list: classes.menuList
        },
        elevation: 1,
        anchorEl: anchorEl,
        anchorOrigin: anchorOrigin,
        transformOrigin: transformOrigin,
        open: isMenuOpen,
        onClose: handleClose,
        ref: ref,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick
    }, (0, $f1q41.isArray)(menuItems) ? isV2Theme ? $79f4ed133ea8848d$var$react_1.default.createElement($4fGPb.BrowserRouter, null, $79f4ed133ea8848d$var$react_1.default.createElement($79f4ed133ea8848d$var$shared_components_krg_vertical_navigation_1.default, {
        header: header,
        navigationList: [
            {
                items: menuItems
            }
        ],
        selectedItem: "",
        isCollapsable: true,
        theme: theme,
        onSelect: handleClose,
        onClose: handleClose
    })) : menuItems.map((item, index)=>$79f4ed133ea8848d$var$react_1.default.createElement($2iAqv.default, {
            key: index,
            className: classes.menuItem,
            onClick: ()=>handleClick(item)
        }, item.text)) : menuItems));
};
module.exports.default = $79f4ed133ea8848d$var$KrgHeaderMenuButton;
$79f4ed133ea8848d$var$KrgHeaderMenuButton.THEME_ENUM = $i4KPV.THEME_ENUM;

});
parcelRegister("4fGPb", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $3189c83282a9a1c6$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $3189c83282a9a1c6$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "matchPath", () => (parcelRequire("kfZjc")).matchPath);

var $kfZjc = parcelRequire("kfZjc");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $3np4r = parcelRequire("3np4r");

var $c9Z8w = parcelRequire("c9Z8w");

var $9RYKL = parcelRequire("9RYKL");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bv4qN = parcelRequire("bv4qN");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$3189c83282a9a1c6$export$9ba4e89fdfa1fc54.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    forceRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
};
$3189c83282a9a1c6$export$9ba4e89fdfa1fc54.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
};
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$3189c83282a9a1c6$export$7221d69dcfc8e36b.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hashType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "hashbang",
        "noslash",
        "slash"
    ])
};
$3189c83282a9a1c6$export$7221d69dcfc8e36b.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
};
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $3np4r.createLocation)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1En50.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $8nd05.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
$3189c83282a9a1c6$var$LinkAnchor.displayName = "LinkAnchor";
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1En50.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <Link> outside a <Router>");
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $8nd05.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $3np4r.createPath)(context.location) === (0, $3np4r.createPath)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
]);
var $3189c83282a9a1c6$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
    })
]);
$3189c83282a9a1c6$export$a6c7ac8248d6e38a.displayName = "Link";
$3189c83282a9a1c6$export$a6c7ac8248d6e38a.propTypes = {
    innerRef: $3189c83282a9a1c6$var$refType,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    to: $3189c83282a9a1c6$var$toType.isRequired
};
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1En50.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <NavLink> outside a <Router>");
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $kfZjc.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $8nd05.default)({}, style, activeStyle);
        }
        var props = (0, $8nd05.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
$3189c83282a9a1c6$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $3189c83282a9a1c6$var$ariaCurrentType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
    "page",
    "step",
    "location",
    "date",
    "time",
    "true",
    "false"
]);
$3189c83282a9a1c6$export$b0d92dbee9b5b60d.propTypes = (0, $8nd05.default)({}, $3189c83282a9a1c6$export$a6c7ac8248d6e38a.propTypes, {
    "aria-current": $3189c83282a9a1c6$var$ariaCurrentType,
    activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    activeStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
});

});
parcelRegister("kfZjc", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", () => $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07);
$parcel$export(module.exports, "Router", () => $ebf4c3fe5600f7ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "generatePath", () => $ebf4c3fe5600f7ed$export$82476f982757e71e);
$parcel$export(module.exports, "Redirect", () => $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "matchPath", () => $ebf4c3fe5600f7ed$export$81336c211d5ff295);
$parcel$export(module.exports, "Route", () => $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Switch", () => $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262);
$parcel$export(module.exports, "useHistory", () => $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c);
$parcel$export(module.exports, "useLocation", () => $ebf4c3fe5600f7ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useParams", () => $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3np4r = parcelRequire("3np4r");

var $9RYKL = parcelRequire("9RYKL");

var $bv4qN = parcelRequire("bv4qN");

var $8nd05 = parcelRequire("8nd05");

var $1w1uY = parcelRequire("1w1uY");

var $dtksX = parcelRequire("dtksX");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");
var $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ebf4c3fe5600f7ed$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $ebf4c3fe5600f7ed$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ebf4c3fe5600f7ed$var$commonjsGlobal[key] = ($ebf4c3fe5600f7ed$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ebf4c3fe5600f7ed$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $ebf4c3fe5600f7ed$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ebf4c3fe5600f7ed$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ebf4c3fe5600f7ed$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ebf4c3fe5600f7ed$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $g7ajw.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $ebf4c3fe5600f7ed$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ebf4c3fe5600f7ed$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT;
                    (0, $9RYKL.default)((changedBits & $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT) === changedBits, "calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: " + changedBits);
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $g7ajw.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ebf4c3fe5600f7ed$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $ebf4c3fe5600f7ed$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $ebf4c3fe5600f7ed$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = $ebf4c3fe5600f7ed$var$createContext();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$55185c17a0fcbe46.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    history: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
$ebf4c3fe5600f7ed$export$55185c17a0fcbe46.prototype.componentDidUpdate = function(prevProps) {
    (0, $9RYKL.default)(prevProps.history === this.props.history, "You cannot change <Router history>");
};
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$ae46f04cfaffe093.propTypes = {
    initialEntries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    initialIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
$ebf4c3fe5600f7ed$export$ae46f04cfaffe093.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { MemoryRouter as Router }`.");
};
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <Prompt> outside a <Router>");
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
]);
$ebf4c3fe5600f7ed$export$83716a4aa1642908.propTypes = {
    when: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    message: $ebf4c3fe5600f7ed$var$messageType.isRequired
};
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($1w1uY))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <Redirect> outside a <Router>");
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $3np4r.createLocation)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $8nd05.default)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $3np4r.createLocation)(prevProps.to);
                if (!(0, $3np4r.locationsAreEqual)(prevLocation, (0, $8nd05.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
$ebf4c3fe5600f7ed$export$2d8d895a0a0f636e.propTypes = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]).isRequired
};
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($1w1uY)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    (0, $9RYKL.default)(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? ' path="' + path + '"' : "") + ">, but you ") + "should have returned a React element or `null`");
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $bv4qN.default)(false, "You should not use <Route> outside a <Router>");
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $8nd05.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, _this.props.path) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, _this.props.path) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$e7b0ac011bb776c6.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    component: function component(props, propName) {
        if (props[propName] && !(0, $dtksX.isValidElementType)(props[propName])) return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
    },
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    render: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
$ebf4c3fe5600f7ed$export$e7b0ac011bb776c6.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!(this.props.children && !$ebf4c3fe5600f7ed$var$isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored");
    (0, $9RYKL.default)(!(this.props.children && !$ebf4c3fe5600f7ed$var$isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored");
    (0, $9RYKL.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
};
$ebf4c3fe5600f7ed$export$e7b0ac011bb776c6.prototype.componentDidUpdate = function(prevProps) {
    (0, $9RYKL.default)(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    (0, $9RYKL.default)(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
};
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $3np4r.createPath)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $bv4qN.default)(false, "You cannot %s with <StaticRouter>", methodName);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $3np4r.createLocation)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1En50.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $3np4r.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $8nd05.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$cac06da4d76d935b.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    context: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
$ebf4c3fe5600f7ed$export$cac06da4d76d935b.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { StaticRouter as Router }`.");
};
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false, "You should not use <Switch> outside a <Router>");
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $8nd05.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$b5d5cf8927ab7262.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
$ebf4c3fe5600f7ed$export$b5d5cf8927ab7262.prototype.componentDidUpdate = function(prevProps) {
    (0, $9RYKL.default)(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    (0, $9RYKL.default)(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
};
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1En50.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false, "You should not use <" + displayName + " /> outside a <Router>");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useHistory()");
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useLocation()");
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useParams()");
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useRouteMatch()");
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
if (typeof window !== "undefined") {
    var $ebf4c3fe5600f7ed$var$global$1 = window;
    var $ebf4c3fe5600f7ed$var$key = "__react_router_build__";
    var $ebf4c3fe5600f7ed$var$buildNames = {
        cjs: "CommonJS",
        esm: "ES modules",
        umd: "UMD"
    };
    if ($ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key] && $ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key] !== "esm") {
        var $ebf4c3fe5600f7ed$var$initialBuildName = $ebf4c3fe5600f7ed$var$buildNames[$ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key]];
        var $ebf4c3fe5600f7ed$var$secondaryBuildName = $ebf4c3fe5600f7ed$var$buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
        // loading 2 different builds.
        throw new Error("You are loading the " + $ebf4c3fe5600f7ed$var$secondaryBuildName + " build of React Router " + ("on a page that is already running the " + $ebf4c3fe5600f7ed$var$initialBuildName + " ") + "build, so things won't work right.");
    }
    $ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key] = "esm";
}

});
parcelRegister("3np4r", function(module, exports) {

$parcel$export(module.exports, "createPath", () => $2756f79476f0245f$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $2756f79476f0245f$export$90c043f1c57770b8);
$parcel$export(module.exports, "locationsAreEqual", () => $2756f79476f0245f$export$c3e8bb440bd55b18);
$parcel$export(module.exports, "createBrowserHistory", () => $2756f79476f0245f$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $2756f79476f0245f$export$b71fdd3798280242);
$parcel$export(module.exports, "createMemoryHistory", () => $2756f79476f0245f$export$2b76ad033c6e6d08);

var $8nd05 = parcelRequire("8nd05");

var $WYl7Q = parcelRequire("WYl7Q");

var $9t72y = parcelRequire("9t72y");

var $9RYKL = parcelRequire("9RYKL");

var $bv4qN = parcelRequire("bv4qN");
function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $8nd05.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $WYl7Q.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9t72y.default)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        (0, $9RYKL.default)(prompt == null, "A history supports only one prompt at a time");
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else {
                    (0, $9RYKL.default)(false, "A history needs a getUserConfirmation function in order to use a prompt message");
                    callback(true);
                }
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $2756f79476f0245f$var$PopStateEvent = "popstate";
var $2756f79476f0245f$var$HashChangeEvent = "hashchange";
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false, "Browser history needs a DOM");
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, $9RYKL.default)(!basename || $2756f79476f0245f$var$hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $9RYKL.default)(state === undefined, "Browser history cannot push state in browsers that do not support HTML5 history");
                window.location.href = href;
            }
        });
    }
    function replace(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $9RYKL.default)(state === undefined, "Browser history cannot replace state in browsers that do not support HTML5 history");
                window.location.replace(href);
            }
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = "hashchange";
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + "#" + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false, "Hash history needs a DOM");
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        (0, $9RYKL.default)(!basename || $2756f79476f0245f$var$hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        (0, $9RYKL.default)(state === undefined, "Hash history cannot push state; it is ignored");
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else {
                (0, $9RYKL.default)(false, "Hash history cannot PUSH the same path; a new entry will not be added to the history stack");
                setState();
            }
        });
    }
    function replace(path, state) {
        (0, $9RYKL.default)(state === undefined, "Hash history cannot replace state; it is ignored");
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        (0, $9RYKL.default)(canGoWithoutReload, "Hash history go(n) causes a full page reload in this browser");
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("WYl7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b14391bdc5d7d11$export$2e2bcd8739ae039);
function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;

});

parcelRegister("9t72y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e4c488965e5c6e8$export$2e2bcd8739ae039);
function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;

});

parcelRegister("bv4qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = false;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});


parcelRegister("1w1uY", function(module, exports) {

var $fR7uw = parcelRequire("fR7uw");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $11a9f12f8ef9d3ee$var$pathToRegexp;
module.exports.parse = $11a9f12f8ef9d3ee$var$parse;
module.exports.compile = $11a9f12f8ef9d3ee$var$compile;
module.exports.tokensToFunction = $11a9f12f8ef9d3ee$var$tokensToFunction;
module.exports.tokensToRegExp = $11a9f12f8ef9d3ee$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $11a9f12f8ef9d3ee$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $11a9f12f8ef9d3ee$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $11a9f12f8ef9d3ee$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $11a9f12f8ef9d3ee$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $11a9f12f8ef9d3ee$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $11a9f12f8ef9d3ee$var$compile(str, options) {
    return $11a9f12f8ef9d3ee$var$tokensToFunction($11a9f12f8ef9d3ee$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $11a9f12f8ef9d3ee$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $11a9f12f8ef9d3ee$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $11a9f12f8ef9d3ee$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $11a9f12f8ef9d3ee$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $11a9f12f8ef9d3ee$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($fR7uw(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $11a9f12f8ef9d3ee$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $11a9f12f8ef9d3ee$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $11a9f12f8ef9d3ee$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $11a9f12f8ef9d3ee$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $11a9f12f8ef9d3ee$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $11a9f12f8ef9d3ee$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $11a9f12f8ef9d3ee$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $11a9f12f8ef9d3ee$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($11a9f12f8ef9d3ee$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $11a9f12f8ef9d3ee$var$flags(options));
    return $11a9f12f8ef9d3ee$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $11a9f12f8ef9d3ee$var$stringToRegexp(path, keys, options) {
    return $11a9f12f8ef9d3ee$var$tokensToRegExp($11a9f12f8ef9d3ee$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $11a9f12f8ef9d3ee$var$tokensToRegExp(tokens, keys, options) {
    if (!$fR7uw(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $11a9f12f8ef9d3ee$var$escapeString(token);
        else {
            var prefix = $11a9f12f8ef9d3ee$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $11a9f12f8ef9d3ee$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $11a9f12f8ef9d3ee$var$attachKeys(new RegExp("^" + route, $11a9f12f8ef9d3ee$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $11a9f12f8ef9d3ee$var$pathToRegexp(path, keys, options) {
    if (!$fR7uw(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $11a9f12f8ef9d3ee$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($fR7uw(path)) return $11a9f12f8ef9d3ee$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $11a9f12f8ef9d3ee$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("fR7uw", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

});


parcelRegister("dtksX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bJGq5"));

});



parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("dtVYq", function(module, exports) {
"use strict";
var $9d0af42b37418c96$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9d0af42b37418c96$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9d0af42b37418c96$var$__createBinding(exports1, m, p);
};
var $9d0af42b37418c96$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TARGET_ENUM = module.exports.THEME_ENUM = void 0;

const $9d0af42b37418c96$var$krg_vertical_navigation_react_1 = $9d0af42b37418c96$var$__importDefault((parcelRequire("57DfS")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});
Object.defineProperty(module.exports, "TARGET_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.TARGET_ENUM;
    }
});

$9d0af42b37418c96$var$__exportStar((parcelRequire("7cXEc")), module.exports);

$9d0af42b37418c96$var$__exportStar((parcelRequire("lpTh7")), module.exports);
module.exports.default = $9d0af42b37418c96$var$krg_vertical_navigation_react_1.default;

});
parcelRegister("57DfS", function(module, exports) {
"use strict";
var $3bac0e72e6258426$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3bac0e72e6258426$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3bac0e72e6258426$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3bac0e72e6258426$var$__createBinding(result, mod, k);
    }
    $3bac0e72e6258426$var$__setModuleDefault(result, mod);
    return result;
};
var $3bac0e72e6258426$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3bac0e72e6258426$var$react_1 = $3bac0e72e6258426$var$__importStar((parcelRequire("acw62")));

var $4fGPb = parcelRequire("4fGPb");

var $26QC4 = parcelRequire("26QC4");
var $3bYfT = parcelRequire("3bYfT");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $bjZRT = parcelRequire("bjZRT");
var $19ocJ = parcelRequire("19ocJ");
var $lkxXU = parcelRequire("lkxXU");
var $5WjaY = parcelRequire("5WjaY");

var $eJaQo = parcelRequire("eJaQo");
var $2LuXZ = parcelRequire("2LuXZ");
var $5DHtS = parcelRequire("5DHtS");

var $i4KPV = parcelRequire("i4KPV");

var $7cXEc = parcelRequire("7cXEc");

const $3bac0e72e6258426$var$base_style_1 = $3bac0e72e6258426$var$__importDefault((parcelRequire("b57eu")));

const $3bac0e72e6258426$var$style_v1_1 = $3bac0e72e6258426$var$__importDefault((parcelRequire("gATWx")));

const $3bac0e72e6258426$var$style_v2_1 = $3bac0e72e6258426$var$__importDefault((parcelRequire("lFCqQ")));
const $3bac0e72e6258426$var$KrgVerticalNavigation = ({ className: className = "", headerClassName: headerClassName = "", sectionClassName: sectionClassName = "", style: style, header: header, variant: variant = $7cXEc.VARIANT_ENUM.none, borderStyle: borderStyle = $7cXEc.BORDER_STYLE_ENUM.right, navigationList: navigationList, selectedItem: selectedItem, isFullWidth: isFullWidth = false, isSelectable: isSelectable = false, isCollapsable: isCollapsable = false, theme: theme = $i4KPV.THEME_ENUM.v1, onSelect: onSelect, onClose: onClose, onClick: onClick, onFocus: onFocus, onBlur: onBlur })=>{
    const props = {
        variant: variant,
        borderStyle: borderStyle,
        isFullWidth: isFullWidth
    };
    const baseClasses = (0, $3bac0e72e6258426$var$base_style_1.default)(props);
    const classesV1 = (0, $3bac0e72e6258426$var$style_v1_1.default)(props);
    const classesV2 = (0, $3bac0e72e6258426$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const [isSectionCollapsed, setIsSectionCollapsed] = (0, $3bac0e72e6258426$var$react_1.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $3bac0e72e6258426$var$react_1.useEffect)(()=>setIsSectionCollapsed(false), [
        isCollapsable
    ]);
    const navigationHeader = $3bac0e72e6258426$var$react_1.default.createElement("div", {
        className: `${classes.headerContainer} ${headerClassName}`
    }, onClose && $3bac0e72e6258426$var$react_1.default.createElement($eJaQo.default, {
        onClick: onClose,
        className: baseClasses.closeIcon
    }), $3bac0e72e6258426$var$react_1.default.createElement("div", {
        className: classes.headerAvatar
    }, header.avatar && $3bac0e72e6258426$var$react_1.default.createElement($3bac0e72e6258426$var$react_1.default.Fragment, null, typeof header.avatar === "string" ? $3bac0e72e6258426$var$react_1.default.createElement($26QC4.default, {
        src: header.avatar
    }) : header.avatar)), $3bac0e72e6258426$var$react_1.default.createElement("div", {
        className: `${baseClasses.headerText} ${classes.headerText}`
    }, $3bac0e72e6258426$var$react_1.default.createElement("div", {
        className: `${baseClasses.headerTitle} ${classes.headerTitle}`
    }, $3bac0e72e6258426$var$react_1.default.createElement($3bYfT.default, {
        variant: "h6"
    }, header.title)), header.subtitle && $3bac0e72e6258426$var$react_1.default.createElement("div", {
        className: `${baseClasses.headerSubtitle} ${classes.headerSubtitle}`
    }, $3bac0e72e6258426$var$react_1.default.createElement($3bYfT.default, null, header.subtitle)), isCollapsable && $3bac0e72e6258426$var$react_1.default.createElement("span", {
        className: baseClasses.headerIcon
    }, isSectionCollapsed ? $3bac0e72e6258426$var$react_1.default.createElement($2LuXZ.default, {
        onClick: ()=>setIsSectionCollapsed(false)
    }) : $3bac0e72e6258426$var$react_1.default.createElement($5DHtS.default, {
        onClick: ()=>setIsSectionCollapsed(true)
    }))));
    const list = navigationList && navigationList.map((navigationListItem, index)=>$3bac0e72e6258426$var$react_1.default.createElement("div", {
            key: index,
            className: `${baseClasses.section} ${sectionClassName} ` + `${index === 0 && isSectionCollapsed ? baseClasses.sectionCollapsed : ""}`
        }, $3bac0e72e6258426$var$react_1.default.createElement($8AyZl.default, {
            component: "nav",
            className: `${navigationListItem.items.length > 1 || navigationListItem.title ? classes.listContainer : classes.listContainerSmall}`
        }, navigationListItem.title && $3bac0e72e6258426$var$react_1.default.createElement("div", {
            className: `${baseClasses.listHeader} ${classes.listHeader}`
        }, $3bac0e72e6258426$var$react_1.default.createElement($3bYfT.default, null, navigationListItem.title)), navigationListItem.items && navigationListItem.items.filter((item)=>!item.isHidden).map((item)=>$3bac0e72e6258426$var$react_1.default.createElement($4fGPb.Link, {
                key: item.text,
                className: baseClasses.listItemLink,
                to: {
                    pathname: item.link || window.location.pathname
                },
                target: item.target || $i4KPV.TARGET_ENUM.self,
                onClick: item.isEnabled !== false ? ()=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(item.text || "") : undefined
            }, $3bac0e72e6258426$var$react_1.default.createElement($lofVM.default, {
                button: true,
                TouchRippleProps: {
                    className: baseClasses.listItemRipple
                },
                className: `${baseClasses.listItem} ` + `${classes.listItem} ` + `${item.isEnabled === false ? `${baseClasses.listItemDisabled} ${classes.listItemDisabled}` : ""} ` + `${isSelectable && selectedItem === item.text ? classes.listItemSelected : ""}`,
                onClick: ()=>{
                    var _a;
                    return (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
                }
            }, $3bac0e72e6258426$var$react_1.default.createElement($bjZRT.default, {
                className: `${baseClasses.listItemIcon} ${classes.listItemIcon}`
            }, item.icon), $3bac0e72e6258426$var$react_1.default.createElement($19ocJ.default, {
                className: `${baseClasses.listItemText} ${classes.listItemText}`
            }, $3bac0e72e6258426$var$react_1.default.createElement("p", null, item.text)))))), index < navigationList.length - 1 && $3bac0e72e6258426$var$react_1.default.createElement($lkxXU.default, {
            className: classes.divider
        })));
    return $3bac0e72e6258426$var$react_1.default.createElement($5WjaY.default, {
        className: `${baseClasses.root} ${classes.root} ${className}`,
        style: style,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick
    }, navigationHeader, (header.avatar || header.title || header.subtitle) && $3bac0e72e6258426$var$react_1.default.createElement($lkxXU.default, {
        className: classes.divider
    }), list);
};
$3bac0e72e6258426$var$KrgVerticalNavigation.BORDER_STYLE_ENUM = $7cXEc.BORDER_STYLE_ENUM;
$3bac0e72e6258426$var$KrgVerticalNavigation.VARIANT_ENUM = $7cXEc.VARIANT_ENUM;
$3bac0e72e6258426$var$KrgVerticalNavigation.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $3bac0e72e6258426$var$KrgVerticalNavigation;

});
parcelRegister("26QC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1894f4268467302e$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $df4uV = parcelRequire("df4uV");

var $68Vfr = parcelRequire("68Vfr");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $1894f4268467302e$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $68Vfr.getAvatarUtilityClass), classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $d8seH.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none",
        variants: [
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: "square"
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $8nd05.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $8nd05.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles("dark", {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $1894f4268467302e$var$AvatarImg = (0, $d8seH.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $d8seH.default)((0, $df4uV.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $1En50.default)(props, $1894f4268467302e$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded((0, $8nd05.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $8nd05.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $6lpak.default)("img", {
        className: classes.img,
        elementType: $1894f4268467302e$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $8nd05.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)(ImgSlot, (0, $8nd05.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
$1894f4268467302e$var$Avatar.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */ alt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ imgProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The `sizes` attribute for the `img` element.
   */ sizes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        img: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        img: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The `src` attribute for the `img` element.
   */ src: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */ srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The shape of the avatar.
   * @default 'circular'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "circular",
            "rounded",
            "square"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $1894f4268467302e$export$2e2bcd8739ae039 = $1894f4268467302e$var$Avatar;

});
parcelRegister("df4uV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a402a389bd8b499$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $9a402a389bd8b499$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRegister("68Vfr", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", () => $478fe5b437ab8d6f$export$ffd560f22c0ecf04);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $478fe5b437ab8d6f$export$ffd560f22c0ecf04(slot) {
    return (0, $4Cod0.default)("MuiAvatar", slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $beCSm.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $478fe5b437ab8d6f$export$2e2bcd8739ae039 = $478fe5b437ab8d6f$var$avatarClasses;

});

parcelRegister("6lpak", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e8399bd2388464$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $8bslU = parcelRequire("8bslU");

var $1ESci = parcelRequire("1ESci");
"use client";
const $49e8399bd2388464$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $49e8399bd2388464$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $49e8399bd2388464$var$_excluded3 = [
    "component"
];
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $1En50.default)(parameters, $49e8399bd2388464$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $1En50.default)(externalForwardedProps, $49e8399bd2388464$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $8bslU.default)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $1ESci.default)((0, $8nd05.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $1En50.default)(_mergeSlotProps.props, $49e8399bd2388464$var$_excluded3);
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $8nd05.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $gEUd4.default)(elementType, (0, $8nd05.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}

});


parcelRegister("3bYfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2531239e3a525689$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $bhKtZ = parcelRequire("bhKtZ");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bhKtZ.getTypographyUtilityClass), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $hcz0Q.default)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || "span";
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
$2531239e3a525689$var$Typography.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the component.
   * @default 'inherit'
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "center",
        "inherit",
        "justify",
        "left",
        "right"
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */ gutterBottom: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */ noWrap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */ paragraph: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'body1'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "body1",
            "body2",
            "button",
            "caption",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "inherit",
            "overline",
            "subtitle1",
            "subtitle2"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */ variantMapping: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).object
};
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;

});
parcelRegister("bhKtZ", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", () => $837556bdf75d281f$export$24c1f8f60cbac79e);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)("MuiTypography", slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;

});


parcelRegister("lofVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92832698674c928$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $5qZhP = parcelRequire("5qZhP");

var $fEVav = parcelRequire("fEVav");

var $kSnzZ = parcelRequire("kSnzZ");

var $awhpc = parcelRequire("awhpc");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $cpXNi = parcelRequire("cpXNi");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3W6ht = parcelRequire("3W6ht");

var $fiKZz = parcelRequire("fiKZz");

var $dUgGz = parcelRequire("dUgGz");

var $d9alg = parcelRequire("d9alg");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $f92832698674c928$var$_excluded = [
    "className"
], $f92832698674c928$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fiKZz.getListItemUtilityClass), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $8nd05.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $dUgGz.default).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $fiKZz.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $fiKZz.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $fiKZz.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $fiKZz.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $fiKZz.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $1En50.default)(props.ContainerProps, $f92832698674c928$var$_excluded), other = (0, $1En50.default)(props, $f92832698674c928$var$_excluded2);
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
            else console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered.");
        }
    }, [
        autoFocus
    ]);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $cpXNi.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $9Rgf1.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $9QePP.default)((0, $fiKZz.default).focusVisible, focusVisibleClassName);
        Component = (0, $6n0Ko.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, (0, $8nd05.default)({
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, !(0, $awhpc.default)(Root) && {
                        as: Component,
                        ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $awhpc.default)(Root) && {
            ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9alg.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
$f92832698674c928$var$ListItem.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Defines the `align-items` style property.
   * @default 'center'
   */ alignItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "center",
        "flex-start"
    ]),
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ button: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */ children: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node, (props)=>{
        const children = $acw62.Children.toArray(props.children);
        // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
        let secondaryActionIndex = -1;
        for(let i = children.length - 1; i >= 0; i -= 1){
            const child = children[i];
            if ((0, $cpXNi.default)(child, [
                "ListItemSecondaryAction"
            ])) {
                secondaryActionIndex = i;
                break;
            }
        }
        //  is ListItemSecondaryAction the last child of ListItem
        if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) return new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.");
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */ ContainerComponent: (0, $5qZhP.default),
    /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */ ContainerProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, all padding is removed.
   * @default false
   */ disablePadding: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The element to display at the end of ListItem.
   */ secondaryAction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;

});
parcelRegister("cpXNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a633ad7a979daa$export$2e2bcd8739ae039);

var $4NpFa = parcelRequire("4NpFa");
var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $4NpFa.default);

});
parcelRegister("4NpFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $37dfa52af4926933$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

});


parcelRegister("fiKZz", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", () => $b23cfd2067550897$export$5682c366c0c669d9);
$parcel$export(module.exports, "default", () => $b23cfd2067550897$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)("MuiListItem", slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;

});

parcelRegister("dUgGz", function(module, exports) {

$parcel$export(module.exports, "getListItemButtonUtilityClass", () => $a1fd72c2634274a8$export$c09531d8563c67a5);
$parcel$export(module.exports, "default", () => $a1fd72c2634274a8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)("MuiListItemButton", slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;

});

parcelRegister("d9alg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9924235485c5a222$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $7lon8 = parcelRequire("7lon8");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $9924235485c5a222$var$_excluded = [
    "className"
];
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7lon8.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $9924235485c5a222$var$_excluded);
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = (0, $8nd05.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$9924235485c5a222$var$ListItemSecondaryAction.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `IconButton` or selection control.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
$9924235485c5a222$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;

});
parcelRegister("7lon8", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", () => $558d665a4b71ad4c$export$ccdb26aeba48a86e);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)("MuiListItemSecondaryAction", slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;

});



parcelRegister("bjZRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $83e175cb7e49d325$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $doXfV = parcelRequire("doXfV");

var $3W6ht = parcelRequire("3W6ht");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $83e175cb7e49d325$var$_excluded = [
    "className"
];
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $doXfV.getListItemIconUtilityClass), classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $d8seH.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $83e175cb7e49d325$var$_excluded);
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$83e175cb7e49d325$var$ListItemIcon.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $83e175cb7e49d325$export$2e2bcd8739ae039 = $83e175cb7e49d325$var$ListItemIcon;

});

parcelRegister("19ocJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d696835f9b43a35$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $3bYfT = parcelRequire("3bYfT");

var $3W6ht = parcelRequire("3W6ht");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $guz4p = parcelRequire("guz4p");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $0d696835f9b43a35$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $guz4p.getListItemTextUtilityClass), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $guz4p.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $guz4p.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $1En50.default)(props, $0d696835f9b43a35$var$_excluded);
    const { dense: dense } = $acw62.useContext((0, $3W6ht.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $3bYfT.default) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), (0, $8nd05.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $3bYfT.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d696835f9b43a35$var$ListItemTextRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
$0d696835f9b43a35$var$ListItemText.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Alias for the `primary` prop.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */ inset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The main content element.
   */ primary: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */ primaryTypographyProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The secondary content element.
   */ secondary: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */ secondaryTypographyProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;

});

parcelRegister("lkxXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f875d00b2138afe4$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $cbVYE = parcelRequire("cbVYE");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $f875d00b2138afe4$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cbVYE.getDividerUtilityClass), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kSnzZ.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        borderTopStyle: "solid",
        borderLeftStyle: "solid",
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: "inherit"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: "inherit"
        }
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $1En50.default)(props, $f875d00b2138afe4$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
$f875d00b2138afe4$var$Divider.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Absolutely position the element.
   * @default false
   */ absolute: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */ flexItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */ light: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The component orientation.
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "horizontal",
        "vertical"
    ]),
    /**
   * @ignore
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The text alignment.
   * @default 'center'
   */ textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "center",
        "left",
        "right"
    ]),
    /**
   * The variant to use.
   * @default 'fullWidth'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "fullWidth",
            "inset",
            "middle"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;

});

parcelRegister("5WjaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $45313e7d506ce734$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Frhn = parcelRequire("7Frhn");

var $bOBRq = parcelRequire("bOBRq");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $45313e7d506ce734$var$_excluded = [
    "className",
    "raised"
];
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bOBRq.getCardUtilityClass), classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $1En50.default)(props, $45313e7d506ce734$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        raised: raised
    });
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
$45313e7d506ce734$var$Card.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the card will use raised styling.
   * @default false
   */ raised: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool, (props)=>{
        if (props.raised && props.variant === "outlined") return new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.');
        return null;
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $45313e7d506ce734$export$2e2bcd8739ae039 = $45313e7d506ce734$var$Card;

});
parcelRegister("bOBRq", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", () => $89a1bb9709695920$export$f3b76d2cce458caa);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $89a1bb9709695920$export$f3b76d2cce458caa(slot) {
    return (0, $4Cod0.default)("MuiCard", slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $beCSm.default)("MuiCard", [
    "root"
]);
var $89a1bb9709695920$export$2e2bcd8739ae039 = $89a1bb9709695920$var$cardClasses;

});


parcelRegister("eJaQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8dae130526a9ed$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ab8dae130526a9ed$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});

parcelRegister("2LuXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2037fde3f2b67600$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2037fde3f2b67600$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), "KeyboardArrowDown");

});

parcelRegister("5DHtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b252a7376cfacd$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $41b252a7376cfacd$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), "KeyboardArrowUp");

});

parcelRegister("7cXEc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BORDER_STYLE_ENUM = module.exports.VARIANT_ENUM = void 0;
var $53f7ec235f8aa44f$var$VARIANT_ENUM;
(function(VARIANT_ENUM) {
    VARIANT_ENUM["elevation"] = "elevation";
    VARIANT_ENUM["outlined"] = "outlined";
    VARIANT_ENUM["none"] = "none";
})($53f7ec235f8aa44f$var$VARIANT_ENUM || (module.exports.VARIANT_ENUM = $53f7ec235f8aa44f$var$VARIANT_ENUM = {}));
var $53f7ec235f8aa44f$var$BORDER_STYLE_ENUM;
(function(BORDER_STYLE_ENUM) {
    BORDER_STYLE_ENUM["left"] = "left";
    BORDER_STYLE_ENUM["right"] = "right";
})($53f7ec235f8aa44f$var$BORDER_STYLE_ENUM || (module.exports.BORDER_STYLE_ENUM = $53f7ec235f8aa44f$var$BORDER_STYLE_ENUM = {}));

});

parcelRegister("b57eu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $8115c5a03d56ed39$var$useBaseStyles = (0, $1GFtd.default)({
    root: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        height: "auto",
        width: "100%"
    },
    headerText: {
        position: "relative",
        marginRight: "0.25em"
    },
    headerTitle: {
        display: "flex",
        alignItems: "center",
        height: "1.625em",
        marginBottom: "0.25em",
        "& h6": {
            fontSize: "1.25em",
            lineHight: "1.625em",
            letterSpacing: "0.009375em"
        }
    },
    headerSubtitle: {
        display: "flex",
        alignItems: "center",
        height: "1.3125em",
        "& p": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
            lineHeight: "1.25em",
            letterSpacing: "0.015625em"
        }
    },
    headerIcon: {
        position: "absolute",
        bottom: "-0.125em",
        right: 0,
        cursor: "pointer"
    },
    listItemLink: {
        textDecoration: "none"
    },
    listItem: {
        borderRadius: "0.25em",
        cursor: "pointer",
        height: "2.5em",
        margin: "0.0625em 0"
    },
    listItemDisabled: {
        pointerEvents: "none"
    },
    listItemRipple: {
        opacity: 0.3
    },
    listItemText: {
        display: "flex",
        alignItems: "center",
        height: "1.125em",
        "& p": {
            lineHeight: "1.25em",
            letterSpacing: "0.00625em",
            fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM
        }
    },
    listItemIcon: {
        minWidth: "auto"
    },
    listHeader: {
        display: "flex",
        alignItems: "center",
        padding: "0.75em 1em",
        "& p": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE
        }
    },
    closeIcon: {
        float: "right",
        cursor: "pointer"
    },
    section: {
        overflow: "hidden",
        display: "block"
    },
    sectionCollapsed: {
        display: "none"
    }
});
module.exports.default = $8115c5a03d56ed39$var$useBaseStyles;

});

parcelRegister("gATWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $7cXEc = parcelRequire("7cXEc");
const $c14b674bea93f342$var$useStyles = (0, $1GFtd.default)({
    root: {
        maxWidth: ({ isFullWidth: isFullWidth })=>isFullWidth ? "100%" : "16em",
        boxShadow: ({ variant: variant })=>variant === $7cXEc.VARIANT_ENUM.elevation ? "0 0.375em 0.3125em rgba(0, 0, 0, 0.24), 0 0.5625em 1.125em rgba(0, 0, 0, 0.18)" : "none",
        borderRight: ({ variant: variant, borderStyle: borderStyle })=>variant === $7cXEc.VARIANT_ENUM.outlined && borderStyle === $7cXEc.BORDER_STYLE_ENUM.right ? `0.0625em solid ${$i4KPV.COLORS.GRAY_DIVIDER}` : "none",
        borderLeft: ({ variant: variant, borderStyle: borderStyle })=>variant === $7cXEc.VARIANT_ENUM.outlined && borderStyle === $7cXEc.BORDER_STYLE_ENUM.left ? `0.0625em solid ${$i4KPV.COLORS.GRAY_DIVIDER}` : "none"
    },
    headerContainer: {
        padding: "1em"
    },
    headerAvatar: {
        margin: "1.5em 0"
    },
    headerText: {},
    headerTitle: {
        "& h6": {
            color: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS
        }
    },
    headerSubtitle: {
        "& p": {
            color: $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS
        }
    },
    listContainer: {
        padding: "0.5em"
    },
    listContainerSmall: {
        padding: "0.25em"
    },
    listHeader: {
        height: "1.25em",
        "& p": {
            color: $i4KPV.COLORS.BLACK_DISABLED,
            lineHeight: "1.25em",
            letterSpacing: "0.015625em"
        }
    },
    listItem: {
        color: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)"
        }
    },
    listItemIcon: {
        marginRight: "0.875em",
        "& svg": {
            color: $i4KPV.COLORS.BLACK_INACTIVE
        }
    },
    listItemText: {
        "& p": {
            fontSize: $i4KPV.FONT.SIZE.MEDIUM
        }
    },
    listItemDisabled: {
        color: $i4KPV.COLORS.BLACK_INACTIVE
    },
    listItemSelected: {
        color: $i4KPV.COLORS.PRIMARY_500_ACCENT,
        backgroundColor: $i4KPV.COLORS.PRIMARY_50,
        "& svg": {
            color: $i4KPV.COLORS.PRIMARY_500_ACCENT
        }
    },
    divider: {
        backgroundColor: $i4KPV.COLORS.GRAY_DIVIDER
    }
});
module.exports.default = $c14b674bea93f342$var$useStyles;

});

parcelRegister("lFCqQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $7cXEc = parcelRequire("7cXEc");
const $fc6b3d190594e814$var$useStyles = (0, $1GFtd.default)({
    root: {
        width: ({ isFullWidth: isFullWidth })=>isFullWidth ? "100%" : "16em",
        boxShadow: ({ variant: variant })=>variant === $7cXEc.VARIANT_ENUM.elevation ? `0 0.25em 0.25em 0 ${$i4KPV.COLORS_V2_ALPHA.NEUTRAL_BLACK_SHADOW}` : "none",
        borderRight: ({ variant: variant, borderStyle: borderStyle })=>variant === $7cXEc.VARIANT_ENUM.outlined && borderStyle === $7cXEc.BORDER_STYLE_ENUM.right ? `0.0625em solid ${$i4KPV.COLORS_V2.NEUTRAL_DARK}` : "none",
        borderLeft: ({ variant: variant, borderStyle: borderStyle })=>variant === $7cXEc.VARIANT_ENUM.outlined && borderStyle === $7cXEc.BORDER_STYLE_ENUM.left ? `0.0625em solid ${$i4KPV.COLORS_V2.NEUTRAL_DARK}` : "none"
    },
    headerContainer: {
        padding: "0.625em 0.5em 1em 1em"
    },
    headerAvatar: {
        margin: "1.5em 0 0 0",
        display: "flex",
        "& > div": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_DARK
        }
    },
    headerText: {
        marginTop: "1.125em"
    },
    headerTitle: {
        "& h6": {
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM
        }
    },
    headerSubtitle: {
        "& p": {
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM
        }
    },
    listContainer: {
        padding: "1em 0"
    },
    listContainerSmall: {
        padding: "0.5em 0"
    },
    listHeader: {
        height: "2em",
        marginBottom: "0.5em",
        "& p": {
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            textTransform: "uppercase"
        }
    },
    listItem: {
        margin: 0,
        color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        "&:hover": {
            background: $i4KPV.COLORS_V2.PRIMARY_700,
            color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            "& div > svg": {
                color: $i4KPV.COLORS_V2.NEUTRAL_WHITE
            }
        }
    },
    listItemIcon: {
        marginRight: "0.75em",
        "& svg": {
            color: $i4KPV.COLORS_V2.NEUTRAL_MEDIUM
        }
    },
    listItemText: {
        "& p": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE
        }
    },
    listItemDisabled: {
        color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
        "& svg": {
            color: $i4KPV.COLORS_V2.NEUTRAL_LIGHT
        }
    },
    listItemSelected: {
        color: $i4KPV.COLORS_V2.PRIMARY_700,
        backgroundColor: $i4KPV.COLORS_V2.PRIMARY_50,
        "& div > svg": {
            color: $i4KPV.COLORS_V2.PRIMARY_700
        }
    },
    divider: {
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_DARK
    }
});
module.exports.default = $fc6b3d190594e814$var$useStyles;

});


parcelRegister("lpTh7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("hH27q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $ce18188a1e24abaa$var$useStyles = (0, $1GFtd.default)({
    /*
      Button
     */ button: {
        color: $i4KPV.COLORS.WHITE,
        fontSize: $i4KPV.FONT.SIZE.BASE,
        padding: 0,
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    buttonIcon: {
        fontSize: "1.6em"
    },
    buttonRippleClass: {
        opacity: 0
    },
    /*
      Menu
     */ menuPaper: {
        borderRadius: 0,
        marginTop: "0.2em"
    },
    menuList: {
        padding: 0
    },
    menuItem: {
        color: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
        whiteSpace: "normal",
        fontSize: "0.9em",
        lineHeight: 1.2,
        minWidth: "8em",
        maxWidth: "25em",
        padding: "0.6em 0.8em",
        "&:hover": {
            backgroundColor: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
            color: $i4KPV.COLORS.WHITE
        }
    }
});
module.exports.default = $ce18188a1e24abaa$var$useStyles;

});


parcelRegister("4YKhJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("0zGhM", function(module, exports) {
"use strict";
var $001badb5ed4429f5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $001badb5ed4429f5$var$react_1 = $001badb5ed4429f5$var$__importDefault((parcelRequire("acw62")));

var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");

var $eJaQo = parcelRequire("eJaQo");

var $i4KPV = parcelRequire("i4KPV");

var $dgtCa = parcelRequire("dgtCa");

const $001badb5ed4429f5$var$submit_1 = $001badb5ed4429f5$var$__importDefault((parcelRequire("82rHB")));

const $001badb5ed4429f5$var$save_continue_1 = $001badb5ed4429f5$var$__importDefault((parcelRequire("19Buq")));

var $fE9Ck = parcelRequire("fE9Ck");

var $3IONI = parcelRequire("3IONI");
const $001badb5ed4429f5$var$KrgModal = ({ className: className = "", paperClassName: paperClassName = "", style: style, type: type = $fE9Ck.TYPE_ENUM.info, inputContainer: inputContainer, submitButtonText: submitButtonText = "", cancelButtonText: cancelButtonText = "", buttonConfig: buttonConfig, scrim: scrim = $fE9Ck.SCRIM_ENUM.light, headerIconType: headerIconType, header: header, title: title, body: body = "", links: links = [], maxWidth: maxWidth, isOpen: isOpen = false, isCancelButtonEnabled: isCancelButtonEnabled = true, isSubmitButtonEnabled: isSubmitButtonEnabled = true, isCloseIconDismissible: isCloseIconDismissible = true, isBackDropDismissible: isBackDropDismissible = true, isEscKeyDismissible: isEscKeyDismissible = true, theme: theme = $i4KPV.THEME_ENUM.v1, onSubmitClick: onSubmitClick, onClose: onClose, onBlur: onBlur, onFocus: onFocus })=>{
    const props = {
        scrim: scrim,
        headerIconType: headerIconType
    };
    const baseClasses = (0, $3IONI.useBaseStyles)(props);
    const classesV1 = (0, $3IONI.useStylesV1)(props);
    const classesV2 = (0, $3IONI.useStylesV2)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const onDialogClose = (evt)=>{
        if (evt.type === "click" && isBackDropDismissible || evt.type === "keydown" && isEscKeyDismissible) onClose(evt);
    };
    return $001badb5ed4429f5$var$react_1.default.createElement($6MV2p.default, {
        style: style,
        open: isOpen,
        classes: {
            root: `${baseClasses.dialogContainer} ${className}`
        },
        BackdropProps: {
            classes: {
                root: classes.backdrop
            }
        },
        PaperProps: {
            classes: {
                root: `${baseClasses.dialogPaper} ${classes.dialogPaper} ${paperClassName}`
            }
        },
        maxWidth: maxWidth,
        disableScrollLock: true,
        disableEscapeKeyDown: !isEscKeyDismissible,
        onFocus: onFocus,
        onBlur: onBlur,
        onClose: onDialogClose
    }, $001badb5ed4429f5$var$react_1.default.createElement($2MUlQ.default, {
        className: classes.closeActionContainer
    }, isCloseIconDismissible ? $001badb5ed4429f5$var$react_1.default.createElement($eJaQo.default, {
        className: baseClasses.closeActionButton,
        onClick: onClose
    }) : null), type === $fE9Ck.TYPE_ENUM.submit ? $001badb5ed4429f5$var$react_1.default.createElement($001badb5ed4429f5$var$submit_1.default, {
        title: title,
        inputContainer: inputContainer,
        submitButtonText: submitButtonText,
        cancelButtonText: cancelButtonText,
        buttonConfig: buttonConfig,
        maxWidth: maxWidth,
        isCancelButtonEnabled: isCancelButtonEnabled,
        isSubmitButtonEnabled: isSubmitButtonEnabled,
        theme: theme,
        onClick: onSubmitClick,
        onClose: onClose
    }) : $001badb5ed4429f5$var$react_1.default.createElement($001badb5ed4429f5$var$save_continue_1.default, {
        type: type,
        header: header,
        title: title,
        body: body,
        links: links,
        submitButtonText: submitButtonText,
        cancelButtonText: cancelButtonText,
        buttonConfig: buttonConfig,
        maxWidth: maxWidth,
        inputContainer: inputContainer,
        headerIconType: headerIconType,
        isCancelButtonEnabled: isCancelButtonEnabled,
        isSubmitButtonEnabled: isSubmitButtonEnabled,
        theme: theme,
        onSubmitClick: onSubmitClick,
        onClose: onClose
    }));
};
$001badb5ed4429f5$var$KrgModal.BUTTON_VARIANT_ENUM = $dgtCa.VARIANT_ENUM;
$001badb5ed4429f5$var$KrgModal.SIZE_ENUM = $fE9Ck.SIZE_ENUM;
$001badb5ed4429f5$var$KrgModal.STATUS_ENUM = $fE9Ck.STATUS_ENUM;
$001badb5ed4429f5$var$KrgModal.SCRIM_ENUM = $fE9Ck.SCRIM_ENUM;
$001badb5ed4429f5$var$KrgModal.TYPE_ENUM = $fE9Ck.TYPE_ENUM;
$001badb5ed4429f5$var$KrgModal.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $001badb5ed4429f5$var$KrgModal;

});
parcelRegister("6MV2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f13784bd714c44e$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $jTnBY = parcelRequire("jTnBY");

var $118QM = parcelRequire("118QM");

var $86f4a = parcelRequire("86f4a");

var $7Frhn = parcelRequire("7Frhn");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $gX5bM = parcelRequire("gX5bM");

var $8W68d = parcelRequire("8W68d");

var $6cr7d = parcelRequire("6cr7d");

var $14H9o = parcelRequire("14H9o");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4f13784bd714c44e$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $6cr7d.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $gX5bM.getDialogUtilityClass), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $118QM.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $14H9o.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $7Frhn.default), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $86f4a.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $4f13784bd714c44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $auC0X.default)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $4f13784bd714c44e$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $8nd05.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogContainer, {
                className: (0, $9QePP.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogPaper, (0, $8nd05.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $9QePP.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8W68d.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
$4f13784bd714c44e$var$Dialog.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The id(s) of the element(s) that describe the dialog.
   */ "aria-describedby": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The id(s) of the element(s) that label the dialog.
   */ "aria-labelledby": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * @ignore
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Dialog children, usually the included sub-components.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the dialog is full-screen.
   * @default false
   */ fullScreen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */ maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "xs",
            "sm",
            "md",
            "lg",
            "xl",
            false
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * The component used to render the body of the dialog.
   * @default Paper
   */ PaperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */ scroll: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "body",
        "paper"
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;

});
parcelRegister("gX5bM", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", () => $c5762e789acf7dcc$export$2177af0aa15c34c2);
$parcel$export(module.exports, "default", () => $c5762e789acf7dcc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)("MuiDialog", slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $beCSm.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;

});

parcelRegister("8W68d", function(module, exports) {

$parcel$export(module.exports, "default", () => $68187f174395cd28$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
$68187f174395cd28$var$DialogContext.displayName = "DialogContext";
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;

});


parcelRegister("2MUlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $207bc6ab7c60f4b2$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $4ZLz5 = parcelRequire("4ZLz5");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $207bc6ab7c60f4b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ZLz5.getDialogActionsUtilityClass), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1En50.default)(props, $207bc6ab7c60f4b2$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$207bc6ab7c60f4b2$var$DialogActions.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */ disableSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;

});
parcelRegister("4ZLz5", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", () => $3a31c1516a2c01e5$export$5e57a444791c63be);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)("MuiDialogActions", slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $beCSm.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;

});


parcelRegister("dgtCa", function(module, exports) {
"use strict";
var $9a83bdce3f800815$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9a83bdce3f800815$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9a83bdce3f800815$var$__createBinding(exports1, m, p);
};
var $9a83bdce3f800815$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = module.exports.BACKGROUND_ENUM = void 0;

const $9a83bdce3f800815$var$krg_button_react_1 = $9a83bdce3f800815$var$__importDefault((parcelRequire("enRtQ")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "BACKGROUND_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.BACKGROUND_ENUM;
    }
});
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$9a83bdce3f800815$var$__exportStar((parcelRequire("1jQBw")), module.exports);
module.exports.default = $9a83bdce3f800815$var$krg_button_react_1.default;

});
parcelRegister("enRtQ", function(module, exports) {
"use strict";
var $a78cb2c593e209ad$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a78cb2c593e209ad$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a78cb2c593e209ad$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a78cb2c593e209ad$var$__createBinding(result, mod, k);
    }
    $a78cb2c593e209ad$var$__setModuleDefault(result, mod);
    return result;
};
var $a78cb2c593e209ad$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = module.exports.BACKGROUND_ENUM = module.exports.VARIANT_ENUM = module.exports.SIZE_ENUM = module.exports.HORIZONTAL_POS_ENUM = void 0;

const $a78cb2c593e209ad$var$react_1 = $a78cb2c593e209ad$var$__importStar((parcelRequire("acw62")));

var $6lXkL = parcelRequire("6lXkL");

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "BACKGROUND_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.BACKGROUND_ENUM;
    }
});
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

var $1jQBw = parcelRequire("1jQBw");
Object.defineProperty(module.exports, "SIZE_ENUM", {
    enumerable: true,
    get: function() {
        return $1jQBw.SIZE_ENUM;
    }
});
Object.defineProperty(module.exports, "HORIZONTAL_POS_ENUM", {
    enumerable: true,
    get: function() {
        return $1jQBw.HORIZONTAL_POS_ENUM;
    }
});
Object.defineProperty(module.exports, "VARIANT_ENUM", {
    enumerable: true,
    get: function() {
        return $1jQBw.VARIANT_ENUM;
    }
});

const $a78cb2c593e209ad$var$base_style_1 = $a78cb2c593e209ad$var$__importDefault((parcelRequire("7MMpq")));

const $a78cb2c593e209ad$var$style_v1_1 = $a78cb2c593e209ad$var$__importDefault((parcelRequire("hoVd6")));

const $a78cb2c593e209ad$var$style_v2_1 = $a78cb2c593e209ad$var$__importDefault((parcelRequire("d9BHA")));
const $a78cb2c593e209ad$var$KrgButton = (0, $a78cb2c593e209ad$var$react_1.forwardRef)(({ id: id, className: className = "", textContainerClassName: textContainerClassName = "", text: text, size: size = $1jQBw.SIZE_ENUM.medium, variant: variant = $1jQBw.VARIANT_ENUM.outlined, background: background = $i4KPV.BACKGROUND_ENUM.white, startIcon: startIcon, endIcon: endIcon, iconFontSize: iconFontSize, style: style, buttonTextPosition: buttonTextPosition = $1jQBw.HORIZONTAL_POS_ENUM.center, hasIconBackground: hasIconBackground = false, isEnabled: isEnabled = true, isSquaredBorder: isSquaredBorder = false, isFullWidth: isFullWidth = false, theme: theme = $i4KPV.THEME_ENUM.v1, onBlur: onBlur, onClick: onClick, onFocus: onFocus }, ref)=>{
    const isIconButton = !!startIcon && !text;
    const props = {
        variant: variant,
        background: background,
        buttonTextPosition: buttonTextPosition,
        iconFontSize: iconFontSize,
        hasIconBackground: hasIconBackground,
        isEnabled: isEnabled,
        isIconButton: isIconButton,
        isFullWidth: isFullWidth,
        isSquaredBorder: isSquaredBorder,
        hasIcon: !!startIcon
    };
    const baseClasses = (0, $a78cb2c593e209ad$var$base_style_1.default)(props);
    const classesV1 = (0, $a78cb2c593e209ad$var$style_v1_1.default)(props);
    const classesV2 = (0, $a78cb2c593e209ad$var$style_v2_1.default)(props)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const buttonSizeClass = classes[`${size}Button`];
    const buttonVariantClass = classes[`${variant}${background !== $i4KPV.BACKGROUND_ENUM.white ? "Knockout" : ""}Button`];
    const textSizeContainerClass = classes[`${size}TextContainer`];
    const buttonRippleVariantClass = $1jQBw.VARIANT_ENUM.outlined ? classes.buttonRipple : "";
    return $a78cb2c593e209ad$var$react_1.default.createElement($6lXkL.default, {
        ref: ref,
        id: id,
        className: `${baseClasses.button} ${classes.button} ${buttonVariantClass} ${buttonSizeClass} ${className}`,
        TouchRippleProps: {
            className: buttonRippleVariantClass
        },
        variant: variant,
        disabled: !isEnabled,
        fullWidth: isFullWidth,
        style: style,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }, $a78cb2c593e209ad$var$react_1.default.createElement("div", {
        className: baseClasses.innerContainer
    }, startIcon, $a78cb2c593e209ad$var$react_1.default.createElement("div", {
        className: `${baseClasses.textContainer} ${classes.textContainer} ${textSizeContainerClass} ${textContainerClassName}`
    }, text), endIcon));
});
module.exports.default = $a78cb2c593e209ad$var$KrgButton;

});
parcelRegister("1jQBw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HORIZONTAL_POS_ENUM = module.exports.SIZE_ENUM = module.exports.VARIANT_ENUM = void 0;
var $0f605eea486bcf87$var$VARIANT_ENUM;
(function(VARIANT_ENUM) {
    VARIANT_ENUM["text"] = "text";
    VARIANT_ENUM["outlined"] = "outlined";
    VARIANT_ENUM["contained"] = "contained";
})($0f605eea486bcf87$var$VARIANT_ENUM || (module.exports.VARIANT_ENUM = $0f605eea486bcf87$var$VARIANT_ENUM = {}));
var $0f605eea486bcf87$var$SIZE_ENUM;
(function(SIZE_ENUM) {
    SIZE_ENUM["small"] = "small";
    SIZE_ENUM["medium"] = "medium";
    SIZE_ENUM["large"] = "large";
    SIZE_ENUM["xlarge"] = "xlarge";
})($0f605eea486bcf87$var$SIZE_ENUM || (module.exports.SIZE_ENUM = $0f605eea486bcf87$var$SIZE_ENUM = {}));
var $0f605eea486bcf87$var$HORIZONTAL_POS_ENUM;
(function(HORIZONTAL_POS_ENUM) {
    HORIZONTAL_POS_ENUM["left"] = "left";
    HORIZONTAL_POS_ENUM["center"] = "center";
    HORIZONTAL_POS_ENUM["right"] = "right";
})($0f605eea486bcf87$var$HORIZONTAL_POS_ENUM || (module.exports.HORIZONTAL_POS_ENUM = $0f605eea486bcf87$var$HORIZONTAL_POS_ENUM = {}));

});

parcelRegister("7MMpq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $5ab2912245d8101f$var$useBaseStyles = (0, $1GFtd.default)({
    /*
      Icon and text wrapper
    */ innerContainer: {
        alignItems: "center",
        display: "flex",
        width: "100%"
    },
    /*
      Text container and its sizes
    */ textContainer: {
        display: ({ isIconButton: isIconButton })=>isIconButton ? "none" : "block",
        width: "100%",
        textAlign: ({ buttonTextPosition: buttonTextPosition })=>buttonTextPosition
    },
    /*
      Default button style
    */ button: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        lineHeight: 1.2,
        boxShadow: "none",
        minWidth: ({ isIconButton: isIconButton })=>isIconButton ? "0" : "4em",
        "&:active": {
            boxShadow: "none"
        },
        "&:hover": {
            boxShadow: "none"
        },
        "& .MuiButton-startIcon": {
            marginRight: "0"
        }
    }
});
module.exports.default = $5ab2912245d8101f$var$useBaseStyles;

});

parcelRegister("hoVd6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $cab10e5d5b3473f5$var$useStylesV1 = (0, $1GFtd.default)({
    /*
      Default button style
    */ button: {
        borderRadius: 0
    },
    textContainer: {},
    /*
      Text button style
    */ textButton: {
        backgroundColor: $i4KPV.COLORS.WHITE,
        color: $i4KPV.COLORS.PRIMARY_500_ACCENT,
        "&:hover": {
            backgroundColor: $i4KPV.COLORS.PRIMARY_50
        },
        "&:disabled": {
            color: $i4KPV.COLORS.BLACK_DISABLED
        }
    },
    /*
      Outlined button style
    */ outlinedButton: {
        backgroundColor: $i4KPV.COLORS.WHITE,
        borderColor: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
        color: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
        "&:hover": {
            backgroundColor: $i4KPV.COLORS.WHITE,
            borderColor: $i4KPV.COLORS.PRIMARY_500_ACCENT,
            color: $i4KPV.COLORS.PRIMARY_500_ACCENT
        },
        "&:disabled": {
            borderColor: $i4KPV.COLORS.GRAY_DIVIDER,
            color: $i4KPV.COLORS.GRAY_DIVIDER
        }
    },
    /*
      Knockout button style
    */ outlinedKnockoutButton: {
        borderColor: $i4KPV.COLORS.WHITE,
        color: $i4KPV.COLORS.WHITE,
        "&:hover": {
            borderColor: $i4KPV.COLORS.PRIMARY_500_ACCENT,
            color: $i4KPV.COLORS.PRIMARY_500_ACCENT
        },
        "&:disabled": {
            borderColor: $i4KPV.COLORS.GRAY_DIVIDER,
            color: $i4KPV.COLORS.GRAY_DIVIDER
        }
    },
    containedKnockoutButton: {},
    textKnockoutButton: {},
    /*
      Contained button style
    */ containedButton: {
        backgroundColor: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
        color: $i4KPV.COLORS.WHITE,
        "&:hover": {
            backgroundColor: $i4KPV.COLORS.PRIMARY_500_ACCENT
        },
        "&:disabled": {
            backgroundColor: $i4KPV.COLORS.BLACK_INACTIVE,
            color: $i4KPV.COLORS.BLACK_DISABLED
        }
    },
    /*
      Button Size
    */ smallButton: {
        minHeight: "1.5em",
        padding: "0.2em 1em",
        // Start icon style
        "& .MuiSvgIcon-root": {
            fontSize: ({ iconFontSize: iconFontSize })=>iconFontSize || "0.8em"
        }
    },
    mediumButton: {
        minHeight: "2.25em",
        padding: "0.5em 1em",
        // Start icon style
        "& .MuiSvgIcon-root": {
            fontSize: ({ iconFontSize: iconFontSize })=>iconFontSize || "1em"
        }
    },
    largeButton: {
        minHeight: "3em",
        padding: "0.8em 1em",
        width: ({ isFullWidth: isFullWidth, isIconButton: isIconButton })=>isFullWidth ? "100%" : isIconButton ? "auto" : "17.5em",
        // Start icon style
        "& .MuiSvgIcon-root": {
            fontSize: ({ iconFontSize: iconFontSize })=>iconFontSize || "1.2em"
        }
    },
    xlargeButton: {
        minHeight: "3.75em",
        padding: "1.1em 1em",
        width: ({ isFullWidth: isFullWidth, isIconButton: isIconButton })=>isFullWidth ? "100%" : isIconButton ? "auto" : "17.5em",
        // Start icon style
        "& .MuiSvgIcon-root": {
            fontSize: ({ iconFontSize: iconFontSize })=>iconFontSize || "1.3em"
        }
    },
    /*
      Text container and its sizes
    */ smallTextContainer: {
        fontSize: "0.8em",
        padding: ({ hasIcon: hasIcon })=>hasIcon ? "0.09375em 0.625em 0 0.8125em" : "0.0625em 0 0",
        lineHeight: "0.8em"
    },
    mediumTextContainer: {
        fontSize: "0.8em",
        padding: "0.125em 1.5625em 0"
    },
    largeTextContainer: {
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
        lineHeight: "1em",
        padding: "0.125em 1.5625em 0"
    },
    xlargeTextContainer: {
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
        lineHeight: "1em",
        padding: "0.125em 1.5625em 0"
    },
    /* Ripple effect */ buttonRipple: {
        opacity: 0.5
    }
});
module.exports.default = $cab10e5d5b3473f5$var$useStylesV1;

});

parcelRegister("d9BHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $1jQBw = parcelRequire("1jQBw");
const $99395c75ddcd15d8$var$useStylesV2 = ({ hasIconBackground: hasIconBackground, isEnabled: isEnabled, isSquaredBorder: isSquaredBorder })=>(0, $1GFtd.default)({
        /*
      Default button style
    */ button: {
            borderRadius: isSquaredBorder ? 0 : "3.125em",
            fontWeight: $i4KPV.FONT.WEIGHT.SEMI_BOLD,
            // Icon background style
            "& .MuiSvgIcon-root": hasIconBackground ? {
                background: isEnabled ? $i4KPV.COLORS_V2.NEUTRAL_BLACK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
                borderRadius: "50%",
                color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
                fontSize: `${$i4KPV.FONT.SIZE.MEDIUM} !important`,
                padding: "0.3125em",
                overflow: "visible"
            } : null,
            // Icon background style on button hover
            "&:hover .MuiSvgIcon-root": hasIconBackground ? {
                backgroundColor: $i4KPV.COLORS_V2.PRIMARY_700
            } : null
        },
        textContainer: {
            textTransform: "capitalize",
            padding: ({ hasIcon: hasIcon, variant: variant })=>hasIcon ? `0 0 0 ${variant === $1jQBw.VARIANT_ENUM.text ? "0.8em" : "1.2em"}` : undefined
        },
        /*
    /* SIZE */ /* Small size */ smallButton: {
            height: "1.9375em",
            padding: isSquaredBorder ? "0 0.5em" : "0 1.9375em",
            // Start icon style
            "& .MuiSvgIcon-root": {
                fontSize: ({ iconFontSize: iconFontSize })=>iconFontSize || "1.1em"
            }
        },
        /* Medium size */ mediumButton: {
            height: "2.3125em",
            padding: isSquaredBorder ? "0 1em" : "0 2.3125em",
            // Start icon style
            "& .MuiSvgIcon-root": {
                fontSize: ({ iconFontSize: iconFontSize })=>iconFontSize || "1.2em"
            }
        },
        /* Large size */ largeButton: {
            height: "2.8125em",
            padding: isSquaredBorder ? "0 1.5em" : "0 2.8125em",
            width: ({ isFullWidth: isFullWidth })=>isFullWidth ? "100%" : "auto",
            // Start icon style
            "& .MuiSvgIcon-root": {
                fontSize: ({ iconFontSize: iconFontSize })=>iconFontSize || "1.2em"
            }
        },
        /* xLarge size */ xlargeButton: {},
        /*
    /* VARIANTS */ /* Text variant */ textButton: {
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            padding: 0,
            "&:hover": {
                backgroundColor: "transparent",
                color: $i4KPV.COLORS_V2.PRIMARY_700
            },
            "&:disabled": {
                color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            },
            "& .MuiTouchRipple-child": {
                backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE
            }
        },
        /* Outlined variant */ outlinedButton: {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            borderColor: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            "&:hover": {
                backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
                borderColor: $i4KPV.COLORS_V2.PRIMARY_700,
                color: $i4KPV.COLORS_V2.PRIMARY_700
            },
            "&:disabled": {
                borderColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
                color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        /* Contained variant */ containedButton: {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            "&:hover": {
                backgroundColor: $i4KPV.COLORS_V2.PRIMARY_700
            },
            "&:disabled": {
                backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
                color: $i4KPV.COLORS_V2.NEUTRAL_WHITE
            },
            "& .MuiTouchRipple-child": {
                backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE
            }
        },
        /*
    /* KNOCKOUT (background not white) */ /* Text variant */ textKnockoutButton: {
            color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            "&:hover": {
                backgroundColor: "transparent",
                color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_BLACK
            },
            "&:disabled": {
                color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.PRIMARY_400
            },
            "& .MuiTouchRipple-child": {
                backgroundColor: "transparent"
            }
        },
        /* Outlined variant */ outlinedKnockoutButton: {
            borderColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            "&:hover": {
                backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
                borderColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
                color: $i4KPV.COLORS_V2.PRIMARY_700
            },
            "&:disabled": {
                borderColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.PRIMARY_400,
                color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.PRIMARY_400
            },
            "& .MuiTouchRipple-child": {
                backgroundColor: $i4KPV.COLORS_V2.PRIMARY_400
            }
        },
        /* Contained variant */ containedKnockoutButton: {
            backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.NEUTRAL_WHITE : $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            "&:hover": {
                backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.NEUTRAL_WHITE : $i4KPV.COLORS_V2.NEUTRAL_BLACK,
                color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_WHITE
            },
            "&:disabled": {
                backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
                color: $i4KPV.COLORS_V2.NEUTRAL_DARK
            },
            "& .MuiTouchRipple-child": {
                backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.black ? $i4KPV.COLORS_V2.PRIMARY_400 : $i4KPV.COLORS_V2.NEUTRAL_WHITE
            }
        },
        /* TEXT by SIZE */ /* Small size */ smallTextContainer: {
            fontSize: $i4KPV.FONT.SIZE.REGULAR,
            lineHeight: $i4KPV.FONT.SIZE.REGULAR
        },
        /* Medium size */ mediumTextContainer: {
            fontSize: $i4KPV.FONT.SIZE.REGULAR,
            lineHeight: $i4KPV.FONT.SIZE.REGULAR
        },
        /* Large size */ largeTextContainer: {
            fontSize: $i4KPV.FONT.SIZE.LARGE,
            lineHeight: $i4KPV.FONT.SIZE.LARGE
        },
        /* xLarge size */ xlargeTextContainer: {},
        /* Ripple effect */ buttonRipple: {}
    });
module.exports.default = $99395c75ddcd15d8$var$useStylesV2;

});



parcelRegister("82rHB", function(module, exports) {
"use strict";
var $5da3ffb48721c419$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $5da3ffb48721c419$var$submit_modal_react_1 = $5da3ffb48721c419$var$__importDefault((parcelRequire("2EZ1i")));
module.exports.default = $5da3ffb48721c419$var$submit_modal_react_1.default;

});
parcelRegister("2EZ1i", function(module, exports) {
"use strict";
var $1efea6765fe94f2f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1efea6765fe94f2f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1efea6765fe94f2f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1efea6765fe94f2f$var$__createBinding(result, mod, k);
    }
    $1efea6765fe94f2f$var$__setModuleDefault(result, mod);
    return result;
};
var $1efea6765fe94f2f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $1efea6765fe94f2f$var$react_1 = $1efea6765fe94f2f$var$__importDefault((parcelRequire("acw62")));

var $6Q1H5 = parcelRequire("6Q1H5");
var $2MUlQ = parcelRequire("2MUlQ");

const $1efea6765fe94f2f$var$shared_components_krg_button_1 = $1efea6765fe94f2f$var$__importStar((parcelRequire("dgtCa")));

var $i4KPV = parcelRequire("i4KPV");

var $lPVW7 = parcelRequire("lPVW7");

var $1aIR6 = parcelRequire("1aIR6");
const $1efea6765fe94f2f$var$SubmitModal = ({ title: title = "", inputContainer: inputContainer, maxWidth: maxWidth, submitButtonText: submitButtonText, cancelButtonText: cancelButtonText, buttonConfig: buttonConfig, isCancelButtonEnabled: isCancelButtonEnabled, isSubmitButtonEnabled: isSubmitButtonEnabled, theme: theme = $i4KPV.THEME_ENUM.v1, onClick: onClick, onClose: onClose })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const props = {
        maxWidth: maxWidth
    };
    const isV1Theme = theme === $i4KPV.THEME_ENUM.v1;
    const baseClasses = (0, $lPVW7.useBaseStyles)(props);
    const classesV1 = (0, $lPVW7.useStylesV1)(props);
    const classesV2 = (0, $lPVW7.useStylesV2)(props);
    const classes = isV1Theme ? classesV1 : classesV2;
    const hasInputContainer = !!inputContainer;
    return $1efea6765fe94f2f$var$react_1.default.createElement($1efea6765fe94f2f$var$react_1.default.Fragment, null, title && $1efea6765fe94f2f$var$react_1.default.createElement($1aIR6.TitleSection, {
        classes: classes,
        title: title,
        hasInputContainer: hasInputContainer,
        isSubmit: true
    }), inputContainer && $1efea6765fe94f2f$var$react_1.default.createElement($1aIR6.InputSection, {
        baseClasses: baseClasses,
        classes: classes,
        inputContainer: inputContainer
    }), $1efea6765fe94f2f$var$react_1.default.createElement($6Q1H5.default, {
        className: `${baseClasses.buttons} ${classes.buttons}`
    }, cancelButtonText && $1efea6765fe94f2f$var$react_1.default.createElement($2MUlQ.default, {
        className: classes.button
    }, $1efea6765fe94f2f$var$react_1.default.createElement($1efea6765fe94f2f$var$shared_components_krg_button_1.default, {
        text: cancelButtonText,
        size: isV1Theme ? undefined : $1efea6765fe94f2f$var$shared_components_krg_button_1.SIZE_ENUM.large,
        style: {
            width: (_a = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _a === void 0 ? void 0 : _a.width
        },
        variant: ((_b = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _b === void 0 ? void 0 : _b.variant) || isV1Theme ? $1efea6765fe94f2f$var$shared_components_krg_button_1.VARIANT_ENUM.contained : $1efea6765fe94f2f$var$shared_components_krg_button_1.VARIANT_ENUM.outlined,
        startIcon: (_c = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _c === void 0 ? void 0 : _c.startIcon,
        endIcon: (_d = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _d === void 0 ? void 0 : _d.endIcon,
        isEnabled: isCancelButtonEnabled,
        theme: theme,
        onClick: onClose
    })), submitButtonText && $1efea6765fe94f2f$var$react_1.default.createElement($2MUlQ.default, {
        className: classes.button
    }, $1efea6765fe94f2f$var$react_1.default.createElement($1efea6765fe94f2f$var$shared_components_krg_button_1.default, {
        text: submitButtonText,
        size: isV1Theme ? undefined : $1efea6765fe94f2f$var$shared_components_krg_button_1.SIZE_ENUM.large,
        style: {
            width: (_e = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _e === void 0 ? void 0 : _e.width
        },
        variant: ((_f = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _f === void 0 ? void 0 : _f.variant) || $1efea6765fe94f2f$var$shared_components_krg_button_1.VARIANT_ENUM.contained,
        startIcon: (_g = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _g === void 0 ? void 0 : _g.startIcon,
        endIcon: (_h = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _h === void 0 ? void 0 : _h.endIcon,
        isEnabled: isSubmitButtonEnabled,
        theme: theme,
        onClick: onClick
    }))));
};
module.exports.default = $1efea6765fe94f2f$var$SubmitModal;

});
parcelRegister("6Q1H5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa8e9c420cdee0a$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $hd5xz = parcelRequire("hd5xz");

var $kQXVi = parcelRequire("kQXVi");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4fa8e9c420cdee0a$var$_excluded = [
    "className",
    "dividers"
];
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hd5xz.getDialogContentUtilityClass), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $kQXVi.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1En50.default)(props, $4fa8e9c420cdee0a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        dividers: dividers
    });
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$4fa8e9c420cdee0a$var$DialogContent.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Display the top and bottom dividers.
   * @default false
   */ dividers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;

});
parcelRegister("hd5xz", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", () => $c877f2cebcabf5cb$export$61b0ee1f05fb344e);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)("MuiDialogContent", slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $beCSm.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;

});

parcelRegister("kQXVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e7257b2514744a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)("MuiDialogTitle", slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $beCSm.default)("MuiDialogTitle", [
    "root"
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;

});


parcelRegister("lPVW7", function(module, exports) {
"use strict";
var $fe5b4d5d0b559e5a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useStylesV2 = module.exports.useStylesV1 = module.exports.useBaseStyles = void 0;

const $fe5b4d5d0b559e5a$var$base_style_1 = $fe5b4d5d0b559e5a$var$__importDefault((parcelRequire("ef0C9")));
module.exports.useBaseStyles = $fe5b4d5d0b559e5a$var$base_style_1.default;

const $fe5b4d5d0b559e5a$var$style_v1_1 = $fe5b4d5d0b559e5a$var$__importDefault((parcelRequire("1Oq3p")));
module.exports.useStylesV1 = $fe5b4d5d0b559e5a$var$style_v1_1.default;

const $fe5b4d5d0b559e5a$var$style_v2_1 = $fe5b4d5d0b559e5a$var$__importDefault((parcelRequire("cuN9x")));
module.exports.useStylesV2 = $fe5b4d5d0b559e5a$var$style_v2_1.default;

});
parcelRegister("ef0C9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $a5e2f1644520d8d9$var$useBaseStyles = (0, $1GFtd.default)({
    /* Dialog Header */ header: {
        display: "flex",
        alignItems: "center"
    },
    /* Content input */ input: {
        "& > div": {
            height: "auto"
        }
    },
    /* Buttons container */ buttons: {
        display: "flex",
        justifyContent: "flex-end",
        "@media (max-width: 499.95px)": {
            flexDirection: "column",
            alignItems: "flex-end"
        }
    }
});
module.exports.default = $a5e2f1644520d8d9$var$useBaseStyles;

});

parcelRegister("1Oq3p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $fE9Ck = parcelRequire("fE9Ck");
const $151eabbddda2abea$var$useStylesV1 = (0, $1GFtd.default)({
    /* Dialog Header */ header: {
        padding: "1.25em 3em",
        /* Header Icon */ "& > .MuiSvgIcon-root": {
            marginRight: "0.45em",
            color: ({ headerIconType: headerIconType })=>headerIconType === $fE9Ck.STATUS_ENUM.confirmation ? $i4KPV.COLORS.SUCCESS_DARK : headerIconType === $fE9Ck.STATUS_ENUM.warning ? $i4KPV.COLORS.WARNING_DARK : headerIconType === $fE9Ck.STATUS_ENUM.error && $i4KPV.COLORS.ERROR_DARK
        },
        /* Header Text */ "& > .MuiTypography-root": {
            position: "relative",
            top: "0.05em",
            color: ({ headerIconType: headerIconType })=>headerIconType === $fE9Ck.STATUS_ENUM.confirmation ? $i4KPV.COLORS.SUCCESS_DARK : headerIconType === $fE9Ck.STATUS_ENUM.warning ? $i4KPV.COLORS.WARNING_DARK : headerIconType === $fE9Ck.STATUS_ENUM.error && $i4KPV.COLORS.ERROR_DARK
        }
    },
    /* Content body */ body: {},
    /* Content title */ title: {
        padding: "1.5em 3em 1.25em 3em"
    },
    /* Spacer with no content, only for layout spacing */ spacer: {
        height: ({ type: type })=>type === $fE9Ck.TYPE_ENUM.info ? "2.6875em" : "1.4375em"
    },
    /* Content title modifier for V1 Submit*/ titleSubmit: {
        padding: "0 1em 2.4375em 1em",
        margin: "0"
    },
    /* Content input */ input: {
        padding: ({ type: type })=>type === $fE9Ck.TYPE_ENUM.info ? "0.5em 1em 3.9375em 1em" : "0.5em 1em 2.6875em 1em"
    },
    /* Content link */ linksWrapper: {},
    linkContainer: {},
    linkWrapper: {},
    linkLabel: {},
    link: {},
    linkCopyText: {},
    tooltip: {},
    divider: {},
    /* Buttons container */ buttons: {
        padding: "0 .75em .75em .75em"
    },
    /* Button */ button: {
        padding: "1.25em 1em 0.75em"
    }
});
module.exports.default = $151eabbddda2abea$var$useStylesV1;

});
parcelRegister("fE9Ck", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SIZE_ENUM = module.exports.STATUS_ENUM = module.exports.SCRIM_ENUM = module.exports.TYPE_ENUM = void 0;
var $b6420d33dbc4a3c0$var$TYPE_ENUM;
(function(TYPE_ENUM) {
    TYPE_ENUM["info"] = "info";
    TYPE_ENUM["submit"] = "submit";
    TYPE_ENUM["continue"] = "continue";
    TYPE_ENUM["confirmation"] = "confirmation";
})($b6420d33dbc4a3c0$var$TYPE_ENUM || (module.exports.TYPE_ENUM = $b6420d33dbc4a3c0$var$TYPE_ENUM = {}));
var $b6420d33dbc4a3c0$var$SCRIM_ENUM;
(function(SCRIM_ENUM) {
    SCRIM_ENUM["light"] = "light";
    SCRIM_ENUM["dark"] = "dark";
})($b6420d33dbc4a3c0$var$SCRIM_ENUM || (module.exports.SCRIM_ENUM = $b6420d33dbc4a3c0$var$SCRIM_ENUM = {}));
var $b6420d33dbc4a3c0$var$STATUS_ENUM;
(function(STATUS_ENUM) {
    STATUS_ENUM["confirmation"] = "confirmation";
    STATUS_ENUM["warning"] = "warning";
    STATUS_ENUM["error"] = "error";
})($b6420d33dbc4a3c0$var$STATUS_ENUM || (module.exports.STATUS_ENUM = $b6420d33dbc4a3c0$var$STATUS_ENUM = {}));
var $b6420d33dbc4a3c0$var$SIZE_ENUM;
(function(SIZE_ENUM) {
    SIZE_ENUM["xs"] = "xs";
    SIZE_ENUM["sm"] = "sm";
    SIZE_ENUM["md"] = "md";
    SIZE_ENUM["lg"] = "lg";
    SIZE_ENUM["xl"] = "xl";
})($b6420d33dbc4a3c0$var$SIZE_ENUM || (module.exports.SIZE_ENUM = $b6420d33dbc4a3c0$var$SIZE_ENUM = {}));

});


parcelRegister("cuN9x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $fE9Ck = parcelRequire("fE9Ck");
const $918e6a1756c0e5f8$var$MARGIN_DEFAULT = "1.875em";
const $918e6a1756c0e5f8$var$MARGIN_WITH_ICON = "6.3em";
const $918e6a1756c0e5f8$var$MARGIN_WITH_ICON_HEADER = "5.6em";
const $918e6a1756c0e5f8$var$useStylesV2 = (0, $1GFtd.default)({
    /* Dialog Header */ header: {
        alignItems: "flex-start",
        padding: 0,
        marginBottom: $918e6a1756c0e5f8$var$MARGIN_DEFAULT,
        minHeight: ({ headerIconType: headerIconType })=>headerIconType ? "4.25em" : "auto",
        "& > .MuiSvgIcon-root": {
            position: "absolute",
            fontSize: "5.2em",
            marginLeft: "-0.08em",
            marginTop: "0.035em",
            color: ({ headerIconType: headerIconType })=>headerIconType === $fE9Ck.STATUS_ENUM.confirmation ? $i4KPV.COLORS_V2.SUCCESS_LIGHT : headerIconType === $fE9Ck.STATUS_ENUM.warning ? $i4KPV.COLORS_V2.WARNING_DARK : headerIconType === $fE9Ck.STATUS_ENUM.error ? $i4KPV.COLORS_V2.ERROR_DARK : $i4KPV.COLORS_V2.NEUTRAL_BLACK
        },
        "& > .MuiTypography-root": {
            fontSize: $i4KPV.FONT.SIZE.H2,
            fontWeight: $i4KPV.FONT.WEIGHT.NORMAL,
            lineHeight: $918e6a1756c0e5f8$var$MARGIN_DEFAULT,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            marginLeft: ({ headerIconType: headerIconType })=>headerIconType ? $918e6a1756c0e5f8$var$MARGIN_WITH_ICON_HEADER : 0
        }
    },
    /* Content body */ body: {
        padding: 0,
        marginBottom: $918e6a1756c0e5f8$var$MARGIN_DEFAULT,
        marginLeft: ({ headerIconType: headerIconType })=>headerIconType ? $918e6a1756c0e5f8$var$MARGIN_WITH_ICON : 0,
        "& > .MuiTypography-root": {
            fontSize: $i4KPV.FONT.SIZE.MEDIUM
        }
    },
    /* Content title */ title: {
        padding: 0,
        marginBottom: $918e6a1756c0e5f8$var$MARGIN_DEFAULT,
        marginLeft: ({ headerIconType: headerIconType })=>headerIconType ? $918e6a1756c0e5f8$var$MARGIN_WITH_ICON : 0,
        overflow: "revert",
        "& > .MuiTypography-root": {
            fontWeight: $i4KPV.FONT.WEIGHT.NORMAL,
            fontSize: $i4KPV.FONT.SIZE.H2,
            lineHeight: $918e6a1756c0e5f8$var$MARGIN_DEFAULT,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK
        }
    },
    /* Spacer with no content, only used in V1 layout spacing */ spacer: {
        display: "none"
    },
    /* Content title modifier for Submit*/ titleSubmit: {},
    /* Content input */ input: {
        padding: "0.5em 0 0.1em 0",
        marginBottom: $918e6a1756c0e5f8$var$MARGIN_DEFAULT,
        marginLeft: ({ headerIconType: headerIconType })=>headerIconType ? $918e6a1756c0e5f8$var$MARGIN_WITH_ICON : 0
    },
    /* Content link */ linksWrapper: {
        border: `0.03125em solid ${$i4KPV.COLORS_V2.NEUTRAL_INACTIVE}`,
        borderRadius: "0.3125em",
        padding: "0.4375em 1.5em 0 0.6875em ",
        marginLeft: ({ headerIconType: headerIconType })=>headerIconType ? $918e6a1756c0e5f8$var$MARGIN_WITH_ICON : 0,
        marginBottom: "1em",
        maxHeight: "19em",
        overflowY: "auto"
    },
    linkContainer: {
        display: "flex",
        padding: "0 1em",
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_LIGHT,
        borderRadius: "0.3em",
        border: `0.03125em solid ${$i4KPV.COLORS_V2.NEUTRAL_INACTIVE}`,
        marginBottom: "0.5em",
        flexFlow: ({ maxWidth: maxWidth })=>maxWidth === $fE9Ck.SIZE_ENUM.xs ? "column" : "row",
        "& > .MuiDivider-root": {
            height: "inherit",
            margin: "0.4em 1em"
        }
    },
    linkWrapper: {
        flex: "1",
        overflow: "hidden"
    },
    linkLabel: {
        marginLeft: "1.5em",
        lineHeight: "2em",
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM
    },
    link: {
        color: `${$i4KPV.COLORS_V2.PRIMARY_700} !important`,
        "& div": {
            fontSize: "0.75rem",
            fontWeight: $i4KPV.FONT.WEIGHT.NORMAL,
            textTransform: "none"
        },
        "&:hover": {
            color: `${$i4KPV.COLORS_V2.NEUTRAL_BLACK} !important`
        }
    },
    linkCopyText: {
        fontSize: "0.85714em",
        marginTop: "0.25em"
    },
    divider: {
        border: `0.025em solid ${$i4KPV.COLORS_V2.NEUTRAL_DARK}`
    },
    tooltip: {
        '.MuiTooltip-popper[data-popper-placement*="bottom"] > &': {
            marginTop: "-0.25em"
        }
    },
    /* Buttons container */ buttons: {
        marginTop: $918e6a1756c0e5f8$var$MARGIN_DEFAULT,
        padding: 0,
        flexWrap: "wrap",
        overflow: "revert"
    },
    /* Button */ button: {
        padding: 0,
        marginLeft: "1em",
        marginBottom: $918e6a1756c0e5f8$var$MARGIN_DEFAULT
    }
});
module.exports.default = $918e6a1756c0e5f8$var$useStylesV2;

});


parcelRegister("1aIR6", function(module, exports) {
"use strict";
var $0da985006649e3c5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0da985006649e3c5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0da985006649e3c5$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0da985006649e3c5$var$__createBinding(result, mod, k);
    }
    $0da985006649e3c5$var$__setModuleDefault(result, mod);
    return result;
};
var $0da985006649e3c5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkSection = module.exports.LinksSection = module.exports.InputSection = module.exports.BodySection = module.exports.TitleSection = module.exports.HeaderSection = void 0;

const $0da985006649e3c5$var$react_1 = $0da985006649e3c5$var$__importDefault((parcelRequire("acw62")));

var $6Q1H5 = parcelRequire("6Q1H5");
var $3bYfT = parcelRequire("3bYfT");
var $lkxXU = parcelRequire("lkxXU");

var $bNGtB = parcelRequire("bNGtB");
var $5WoTm = parcelRequire("5WoTm");
var $JlKem = parcelRequire("JlKem");
var $6XS0u = parcelRequire("6XS0u");
var $2SJYg = parcelRequire("2SJYg");
var $gqvXj = parcelRequire("gqvXj");

const $0da985006649e3c5$var$shared_components_krg_button_1 = $0da985006649e3c5$var$__importStar((parcelRequire("dgtCa")));

const $0da985006649e3c5$var$shared_components_krg_tooltip_1 = $0da985006649e3c5$var$__importDefault((parcelRequire("AfP12")));

var $fE9Ck = parcelRequire("fE9Ck");
const $0da985006649e3c5$var$HeaderSection = ({ baseClasses: baseClasses, classes: classes, isV2Theme: isV2Theme, header: header, headerIconType: headerIconType })=>$0da985006649e3c5$var$react_1.default.createElement($6Q1H5.default, {
        className: `${baseClasses.header} ${classes.header}`
    }, headerIconType === $fE9Ck.STATUS_ENUM.confirmation ? $0da985006649e3c5$var$react_1.default.createElement($bNGtB.default, null) : headerIconType === $fE9Ck.STATUS_ENUM.warning ? isV2Theme ? $0da985006649e3c5$var$react_1.default.createElement($5WoTm.default, null) : $0da985006649e3c5$var$react_1.default.createElement($JlKem.default, null) : headerIconType === $fE9Ck.STATUS_ENUM.error ? isV2Theme ? $0da985006649e3c5$var$react_1.default.createElement($6XS0u.default, null) : $0da985006649e3c5$var$react_1.default.createElement($5WoTm.default, null) : null, $0da985006649e3c5$var$react_1.default.createElement($3bYfT.default, {
        variant: "h6"
    }, header));
module.exports.HeaderSection = $0da985006649e3c5$var$HeaderSection;
const $0da985006649e3c5$var$TitleSection = ({ classes: classes, title: title, hasInputContainer: hasInputContainer, isSubmit: isSubmit })=>$0da985006649e3c5$var$react_1.default.createElement($6Q1H5.default, {
        className: `${classes.title} ${isSubmit ? classes.titleSubmit : ""} ${hasInputContainer}`
    }, $0da985006649e3c5$var$react_1.default.createElement($3bYfT.default, {
        dangerouslySetInnerHTML: {
            __html: title
        }
    }));
module.exports.TitleSection = $0da985006649e3c5$var$TitleSection;
const $0da985006649e3c5$var$BodySection = ({ classes: classes, body: body })=>$0da985006649e3c5$var$react_1.default.createElement($6Q1H5.default, {
        className: classes.body
    }, $0da985006649e3c5$var$react_1.default.createElement($3bYfT.default, {
        dangerouslySetInnerHTML: {
            __html: body
        }
    }));
module.exports.BodySection = $0da985006649e3c5$var$BodySection;
const $0da985006649e3c5$var$InputSection = ({ baseClasses: baseClasses, classes: classes, inputContainer: inputContainer })=>$0da985006649e3c5$var$react_1.default.createElement($6Q1H5.default, {
        className: `${baseClasses.input} ${classes.input}`
    }, inputContainer);
module.exports.InputSection = $0da985006649e3c5$var$InputSection;
const $0da985006649e3c5$var$LinksSection = ({ classes: classes, theme: theme, links: links, maxWidth: maxWidth })=>{
    return $0da985006649e3c5$var$react_1.default.createElement("div", {
        className: classes.linksWrapper
    }, links.map(({ url: url, label: label, copyText: copyText }, i)=>$0da985006649e3c5$var$react_1.default.createElement("div", {
            key: `link-${i}`
        }, $0da985006649e3c5$var$react_1.default.createElement(module.exports.LinkSection, {
            classes: classes,
            theme: theme,
            maxWidth: maxWidth,
            url: url,
            label: label,
            copyText: copyText
        }))));
};
module.exports.LinksSection = $0da985006649e3c5$var$LinksSection;
const $0da985006649e3c5$var$LinkSection = ({ classes: classes, theme: theme, maxWidth: maxWidth, url: url, label: label, copyText: copyText })=>{
    const [isOpen, setIsOpen] = $0da985006649e3c5$var$react_1.default.useState(false);
    const onCopyClick = ()=>{
        navigator.clipboard.writeText(url);
        setIsOpen(true);
        setTimeout(()=>setIsOpen(false), 2000);
    };
    return $0da985006649e3c5$var$react_1.default.createElement("div", null, $0da985006649e3c5$var$react_1.default.createElement($3bYfT.default, {
        className: classes.linkLabel
    }, label), $0da985006649e3c5$var$react_1.default.createElement($6Q1H5.default, {
        className: classes.linkContainer
    }, $0da985006649e3c5$var$react_1.default.createElement("span", {
        className: classes.linkWrapper
    }, $0da985006649e3c5$var$react_1.default.createElement($0da985006649e3c5$var$shared_components_krg_button_1.default, {
        className: classes.link,
        variant: $0da985006649e3c5$var$shared_components_krg_button_1.VARIANT_ENUM.text,
        startIcon: $0da985006649e3c5$var$react_1.default.createElement($2SJYg.default, null),
        text: url,
        theme: theme,
        size: $0da985006649e3c5$var$shared_components_krg_button_1.SIZE_ENUM.large,
        onClick: ()=>window.open(url, "_blank")
    })), $0da985006649e3c5$var$react_1.default.createElement($lkxXU.default, {
        className: classes.divider,
        orientation: maxWidth === $fE9Ck.SIZE_ENUM.xs ? "horizontal" : "vertical"
    }), $0da985006649e3c5$var$react_1.default.createElement($0da985006649e3c5$var$shared_components_krg_tooltip_1.default, {
        classNames: {
            tooltip: classes.tooltip
        },
        tooltip: "Copied",
        tooltipProps: {
            PopperProps: {
                disablePortal: true
            },
            disableFocusListener: true,
            disableHoverListener: true,
            disableTouchListener: true
        },
        position: $0da985006649e3c5$var$shared_components_krg_tooltip_1.default.POSITION_ENUM.top,
        hasArrow: false,
        isOpen: isOpen,
        theme: theme
    }, $0da985006649e3c5$var$react_1.default.createElement("span", null, $0da985006649e3c5$var$react_1.default.createElement($0da985006649e3c5$var$shared_components_krg_button_1.default, {
        className: classes.linkCopyText,
        variant: $0da985006649e3c5$var$shared_components_krg_button_1.VARIANT_ENUM.text,
        startIcon: $0da985006649e3c5$var$react_1.default.createElement($gqvXj.default, null),
        text: copyText || "Copy Link",
        theme: theme,
        size: $0da985006649e3c5$var$shared_components_krg_button_1.SIZE_ENUM.large,
        onClick: onCopyClick
    })))));
};
module.exports.LinkSection = $0da985006649e3c5$var$LinkSection;

});
parcelRegister("bNGtB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8975383ad1dea524$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8975383ad1dea524$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle");

});

parcelRegister("5WoTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4535ad880493f316$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $4535ad880493f316$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error");

});

parcelRegister("JlKem", function(module, exports) {

$parcel$export(module.exports, "default", () => $0885121e8393a5b8$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0885121e8393a5b8$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "Warning");

});

parcelRegister("6XS0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $512225694c05769e$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $512225694c05769e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), "RemoveCircleOutlined");

});

parcelRegister("2SJYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $219448ca2dce677c$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $219448ca2dce677c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew");

});

parcelRegister("gqvXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf57dccd1789595f$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bf57dccd1789595f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy");

});

parcelRegister("AfP12", function(module, exports) {
"use strict";
var $06cfa2cb5df76838$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $06cfa2cb5df76838$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $06cfa2cb5df76838$var$__createBinding(exports1, m, p);
};
var $06cfa2cb5df76838$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = void 0;

const $06cfa2cb5df76838$var$krg_tooltip_react_1 = $06cfa2cb5df76838$var$__importDefault((parcelRequire("eOjtY")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$06cfa2cb5df76838$var$__exportStar((parcelRequire("8cUge")), module.exports);

$06cfa2cb5df76838$var$__exportStar((parcelRequire("9XUXW")), module.exports);
module.exports.default = $06cfa2cb5df76838$var$krg_tooltip_react_1.default;

});
parcelRegister("eOjtY", function(module, exports) {
"use strict";
var $ac84d8fbc8865071$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ac84d8fbc8865071$var$react_1 = $ac84d8fbc8865071$var$__importDefault((parcelRequire("acw62")));

var $cVXaD = parcelRequire("cVXaD");

var $i4KPV = parcelRequire("i4KPV");

var $8cUge = parcelRequire("8cUge");

const $ac84d8fbc8865071$var$base_style_1 = $ac84d8fbc8865071$var$__importDefault((parcelRequire("lW1g5")));

const $ac84d8fbc8865071$var$style_v1_1 = $ac84d8fbc8865071$var$__importDefault((parcelRequire("kwazK")));

const $ac84d8fbc8865071$var$style_v2_1 = $ac84d8fbc8865071$var$__importDefault((parcelRequire("BqOrl")));
const $ac84d8fbc8865071$var$KrgTooltip = ({ classNames: classNames, style: style, children: children, text: text = "", tooltip: tooltip, tooltipProps: tooltipProps, position: position = $8cUge.POSITION_ENUM.bottom, type: type = $8cUge.TYPE_ENUM.default, hasArrow: hasArrow = true, isOpen: isOpen, onClick: onClick, theme: theme = $i4KPV.THEME_ENUM.v1 })=>{
    const props = {
        type: type,
        isTextTooltip: typeof tooltip === "string"
    };
    const baseClasses = (0, $ac84d8fbc8865071$var$base_style_1.default)(props);
    const classesV1 = (0, $ac84d8fbc8865071$var$style_v1_1.default)(props);
    const classesV2 = (0, $ac84d8fbc8865071$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    return $ac84d8fbc8865071$var$react_1.default.createElement($cVXaD.default, Object.assign({}, tooltipProps, {
        classes: {
            arrow: `${classes.arrow} ${classNames === null || classNames === void 0 ? void 0 : classNames.arrow}`,
            popper: `${baseClasses.popper} ${classNames === null || classNames === void 0 ? void 0 : classNames.popper}`,
            tooltip: `${baseClasses.tooltip} ${classes.tooltip} ${classNames === null || classNames === void 0 ? void 0 : classNames.tooltip}`,
            // only extrernal class configuration
            popperInteractive: classNames === null || classNames === void 0 ? void 0 : classNames.popperInteractive,
            popperArrow: classNames === null || classNames === void 0 ? void 0 : classNames.popperArrow,
            popperClose: classNames === null || classNames === void 0 ? void 0 : classNames.popperClose,
            tooltipArrow: classNames === null || classNames === void 0 ? void 0 : classNames.tooltipArrow,
            touch: classNames === null || classNames === void 0 ? void 0 : classNames.touch,
            tooltipPlacementLeft: classNames === null || classNames === void 0 ? void 0 : classNames.tooltipPlacementLeft,
            tooltipPlacementRight: classNames === null || classNames === void 0 ? void 0 : classNames.tooltipPlacementRight,
            tooltipPlacementTop: classNames === null || classNames === void 0 ? void 0 : classNames.tooltipPlacementTop,
            tooltipPlacementBottom: classNames === null || classNames === void 0 ? void 0 : classNames.tooltipPlacementBottom
        },
        open: isOpen,
        sx: style,
        title: tooltip,
        placement: position,
        arrow: hasArrow,
        onClick: onClick
    }), $ac84d8fbc8865071$var$react_1.default.createElement("span", null, children || text));
};
$ac84d8fbc8865071$var$KrgTooltip.POSITION_ENUM = $8cUge.POSITION_ENUM;
$ac84d8fbc8865071$var$KrgTooltip.TYPE_ENUM = $8cUge.TYPE_ENUM;
$ac84d8fbc8865071$var$KrgTooltip.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $ac84d8fbc8865071$var$KrgTooltip;

});
parcelRegister("cVXaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a8b4f445fd9172$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $lHOu3 = parcelRequire("lHOu3");

var $72gTS = parcelRequire("72gTS");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $58lXc = parcelRequire("58lXc");

var $gEUd4 = parcelRequire("gEUd4");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $iscuz = parcelRequire("iscuz");

var $e76iu = parcelRequire("e76iu");

var $4o7uD = parcelRequire("4o7uD");

var $9Rgf1 = parcelRequire("9Rgf1");

var $5A6d3 = parcelRequire("5A6d3");

var $cllwi = parcelRequire("cllwi");

var $3yddg = parcelRequire("3yddg");

var $eVjpW = parcelRequire("eVjpW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $96a8b4f445fd9172$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $jTnBY.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eVjpW.getTooltipUtilityClass), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $eVjpW.default).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $eVjpW.default).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: (0, $8nd05.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $8nd05.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: (0, $8nd05.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $8nd05.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="top"] &`]: (0, $8nd05.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="bottom"] &`]: (0, $8nd05.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $lHOu3.Timeout)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $iscuz.default), TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $96a8b4f445fd9172$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $lHOu3.default)();
    const enterTimer = (0, $lHOu3.default)();
    const leaveTimer = (0, $lHOu3.default)();
    const touchTimer = (0, $lHOu3.default)();
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { current: isControlled } = $acw62.useRef(openProp !== undefined);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useEffect(()=>{
            if (childNode && childNode.disabled && !isControlled && title !== "" && childNode.tagName.toLowerCase() === "button") console.error([
                "MUI: You are providing a disabled `button` child to the Tooltip component.",
                "A disabled element does not fire events.",
                "Tooltip needs to listen to the child element's events to display the title.",
                "",
                "Add a simple wrapper element, such as a `span`."
            ].join("\n"));
        }, [
            title,
            childNode,
            isControlled
        ]);
    }
    const id = (0, $5A6d3.default)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $4o7uD.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $4o7uD.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $cllwi.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $9Rgf1.default)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $8nd05.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    childrenProps["data-mui-internal-clone-element"] = true;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useEffect(()=>{
        if (childNode && !childNode.getAttribute("data-mui-internal-clone-element")) console.error([
            "MUI: The `children` component of the Tooltip is not forwarding its props correctly.",
            "Please make sure that props are spread on the same element that the ref is applied to."
        ].join("\n"));
    }, [
        childNode
    ]);
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    if (children.props.title) console.error([
        "MUI: You have provided a `title` prop to the child of <Tooltip />.",
        `Remove this title prop \`${children.props.title}\` or the Tooltip component.`
    ].join("\n"));
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $8nd05.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $96a8b4f445fd9172$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $iscuz.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $96a8b4f445fd9172$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $96a8b4f445fd9172$var$TooltipArrow;
    const popperProps = (0, $gEUd4.default)(PopperComponent, (0, $8nd05.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $9QePP.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $gEUd4.default)(TransitionComponent, (0, $8nd05.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $gEUd4.default)(TooltipComponent, (0, $8nd05.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $9QePP.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $gEUd4.default)(ArrowComponent, (0, $8nd05.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $9QePP.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $8nd05.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $e76iu.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $8nd05.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $8nd05.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
$96a8b4f445fd9172$var$Tooltip.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */ arrow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Tooltip reference element.
   */ children: (0, $72gTS.default).isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Arrow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Popper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        Transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        arrow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */ describeChild: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Do not respond to focus-visible events.
   * @default false
   */ disableFocusListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Do not respond to hover events.
   * @default false
   */ disableHoverListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */ disableInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Do not respond to long press touch events.
   * @default false
   */ disableTouchListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */ enterDelay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */ enterNextDelay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */ enterTouchDelay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */ followCursor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */ leaveDelay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */ leaveTouchDelay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Tooltip placement.
   * @default 'bottom'
   */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "bottom-end",
        "bottom-start",
        "bottom",
        "left-end",
        "left-start",
        "left",
        "right-end",
        "right-start",
        "right",
        "top-end",
        "top-start",
        "top"
    ]),
    /**
   * The component used for the popper.
   * @default Popper
   */ PopperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */ PopperProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        arrow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        arrow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;

});
parcelRegister("e76iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4669aa090d445bd$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $5AoD1 = parcelRequire("5AoD1");

var $i582X = parcelRequire("i582X");

var $Nd5tw = parcelRequire("Nd5tw");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $7JHF2 = parcelRequire("7JHF2");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $a4669aa090d445bd$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $7JHF2.default), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($5AoD1)))();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $a4669aa090d445bd$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $8nd05.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, (0, $8nd05.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
$a4669aa090d445bd$var$Popper.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */ anchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * Popper render function or node.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */ modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        effect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        enabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        fn: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        phase: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "afterMain",
            "afterRead",
            "afterWrite",
            "beforeMain",
            "beforeRead",
            "beforeWrite",
            "main",
            "read",
            "write"
        ]),
        requires: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        requiresIfExists: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    })),
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * Popper placement.
   * @default 'bottom'
   */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "auto-end",
        "auto-start",
        "auto",
        "bottom-end",
        "bottom-start",
        "bottom",
        "left-end",
        "left-start",
        "left",
        "right-end",
        "right-start",
        "right",
        "top-end",
        "top-start",
        "top"
    ]),
    /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */ popperOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        onFirstUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto-end",
            "auto-start",
            "auto",
            "bottom-end",
            "bottom-start",
            "bottom",
            "left-end",
            "left-start",
            "left",
            "right-end",
            "right-start",
            "right",
            "top-end",
            "top-start",
            "top"
        ]),
        strategy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "absolute",
            "fixed"
        ])
    }),
    /**
   * A ref that points to the used popper instance.
   */ popperRef: (0, $i582X.default),
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */ transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;

});
parcelRegister("5AoD1", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41136b35f34e8eee$var$React = $41136b35f34e8eee$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jjlaj");
var $l7wW1 = parcelRequire("l7wW1");
function $41136b35f34e8eee$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($41136b35f34e8eee$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $41136b35f34e8eee$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $41136b35f34e8eee$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $41136b35f34e8eee$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $41136b35f34e8eee$var$useTheme(defaultTheme = null) {
    const contextTheme = $41136b35f34e8eee$var$React.useContext($l7wW1.T);
    return !contextTheme || $41136b35f34e8eee$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $41136b35f34e8eee$var$_default = module.exports.default = $41136b35f34e8eee$var$useTheme;

});

parcelRegister("7JHF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1e9a841ed0d0fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $fEVav = parcelRequire("fEVav");
var $Nd5tw = parcelRequire("Nd5tw");
var $i582X = parcelRequire("i582X");
var $6zeBo = parcelRequire("6zeBo");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $3tUi5 = parcelRequire("3tUi5");

var $c9Z8w = parcelRequire("c9Z8w");

var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $2Q995 = parcelRequire("2Q995");

var $g3XLf = parcelRequire("g3XLf");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5a1e9a841ed0d0fc$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $5a1e9a841ed0d0fc$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $g3XLf.getPopperUtilityClass), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $3qSdM.default)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $3qSdM.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $eEJPp.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $eEJPp.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        if (resolvedAnchorElement && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
            const box = resolvedAnchorElement.getBoundingClientRect();
            if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                "MUI: The `anchorEl` prop provided to the component is invalid.",
                "The anchor element should be part of the document layout.",
                "Make sure the element is present in the document or that it's not display none."
            ].join("\n"));
        }
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $3tUi5.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $8nd05.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $eD6Co.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $6zeBo.default)(resolvedAnchorEl).body : (0, $6zeBo.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, (0, $8nd05.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $8nd05.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
$5a1e9a841ed0d0fc$var$Popper.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */ anchorEl: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]), (props)=>{
        if (props.open) {
            const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
                const box = resolvedAnchorEl.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    "MUI: The `anchorEl` prop provided to the component is invalid.",
                    "The anchor element should be part of the document layout.",
                    "Make sure the element is present in the document or that it's not display none."
                ].join("\n"));
            } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== "function" || $5a1e9a841ed0d0fc$var$isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) return new Error([
                "MUI: The `anchorEl` prop provided to the component is invalid.",
                "It should be an HTML element instance or a virtualElement ",
                "(https://popper.js.org/docs/v2/virtual-elements/)."
            ].join("\n"));
        }
        return null;
    }),
    /**
   * Popper render function or node.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $Nd5tw.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * Direction of the text.
   * @default 'ltr'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "ltr",
        "rtl"
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */ modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        effect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        enabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        fn: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        phase: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "afterMain",
            "afterRead",
            "afterWrite",
            "beforeMain",
            "beforeRead",
            "beforeWrite",
            "main",
            "read",
            "write"
        ]),
        requires: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        requiresIfExists: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    })),
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * Popper placement.
   * @default 'bottom'
   */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "auto-end",
        "auto-start",
        "auto",
        "bottom-end",
        "bottom-start",
        "bottom",
        "left-end",
        "left-start",
        "left",
        "right-end",
        "right-start",
        "right",
        "top-end",
        "top-start",
        "top"
    ]),
    /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */ popperOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        onFirstUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto-end",
            "auto-start",
            "auto",
            "bottom-end",
            "bottom-start",
            "bottom",
            "left-end",
            "left-start",
            "left",
            "right-end",
            "right-start",
            "right",
            "top-end",
            "top-start",
            "top"
        ]),
        strategy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "absolute",
            "fixed"
        ])
    }),
    /**
   * A ref that points to the used popper instance.
   */ popperRef: (0, $i582X.default),
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */ transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === "html" || (0, $oKPBf.default)(offsetParent) === "body" && (0, $huVQQ.default)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === "rtl") x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === "x" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("g3XLf", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", () => $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)("MuiPopper", slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)("MuiPopper", [
    "root"
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;

});



parcelRegister("5A6d3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4105219ee6538ed1$export$2e2bcd8739ae039);

var $auC0X = parcelRequire("auC0X");
"use client";
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $auC0X.default);

});

parcelRegister("eVjpW", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $add5737403c6a16a$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $add5737403c6a16a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)("MuiTooltip", slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;

});


parcelRegister("8cUge", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TYPE_ENUM = module.exports.POSITION_ENUM = void 0;
var $5f9b15f76c1197fe$var$POSITION_ENUM;
(function(POSITION_ENUM) {
    POSITION_ENUM["topStart"] = "top-start";
    POSITION_ENUM["top"] = "top";
    POSITION_ENUM["topEnd"] = "top-end";
    POSITION_ENUM["rightEnd"] = "right-end";
    POSITION_ENUM["right"] = "right";
    POSITION_ENUM["rightStart"] = "right-start";
    POSITION_ENUM["bottomEnd"] = "bottom-end";
    POSITION_ENUM["bottom"] = "bottom";
    POSITION_ENUM["bottomStart"] = "bottom-start";
    POSITION_ENUM["leftStart"] = "left-start";
    POSITION_ENUM["left"] = "left";
    POSITION_ENUM["leftEnd"] = "left-end";
})($5f9b15f76c1197fe$var$POSITION_ENUM || (module.exports.POSITION_ENUM = $5f9b15f76c1197fe$var$POSITION_ENUM = {}));
var $5f9b15f76c1197fe$var$TYPE_ENUM;
(function(TYPE_ENUM) {
    TYPE_ENUM["default"] = "default";
    TYPE_ENUM["warning"] = "warning";
    TYPE_ENUM["error"] = "error";
    TYPE_ENUM["success"] = "success";
    TYPE_ENUM["neutral"] = "neutral";
})($5f9b15f76c1197fe$var$TYPE_ENUM || (module.exports.TYPE_ENUM = $5f9b15f76c1197fe$var$TYPE_ENUM = {}));

});

parcelRegister("lW1g5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $ff7ffdaa999b3883$var$useBaseStyles = (0, $1GFtd.default)({
    popper: {
        fontSize: $i4KPV.FONT.SIZE.BASE
    },
    tooltip: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        "&:not(.MuiTooltip-tooltipArrow).MuiTooltip-tooltipPlacement": {
            "&Top": {
                marginBottom: "0.7272727em"
            },
            "&Right": {
                marginLeft: "0.7272727em"
            },
            "&Bottom": {
                marginTop: "0.7272727em"
            },
            "&Left": {
                marginRight: "0.7272727em"
            }
        }
    }
});
module.exports.default = $ff7ffdaa999b3883$var$useBaseStyles;

});

parcelRegister("kwazK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $eefeffe2d60eb324$var$useStylesV1 = (0, $1GFtd.default)({
    tooltip: {},
    arrow: {}
});
module.exports.default = $eefeffe2d60eb324$var$useStylesV1;

});

parcelRegister("BqOrl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $8cUge = parcelRequire("8cUge");
const $0708413ad1bc9814$var$getColorByType = (type)=>type === $8cUge.TYPE_ENUM.default ? $i4KPV.COLORS_V2.NEUTRAL_BLACK.replace(")", ", 0.75)") // Add opacity
     : type === $8cUge.TYPE_ENUM.success ? $i4KPV.COLORS_V2.SUCCESS_LIGHTEST : type === $8cUge.TYPE_ENUM.warning ? $i4KPV.COLORS_V2.WARNING_LIGHTEST : type === $8cUge.TYPE_ENUM.error ? $i4KPV.COLORS_V2.ERROR_LIGHTEST : type === $8cUge.TYPE_ENUM.neutral ? $i4KPV.COLORS_V2.NEUTRAL_WHITE : $i4KPV.COLORS_V2.NEUTRAL_BLACK;
const $0708413ad1bc9814$var$useStylesV2 = (0, $1GFtd.default)({
    tooltip: {
        padding: ({ type: type })=>type === $8cUge.TYPE_ENUM.neutral ? "0" : "1.363637em",
        maxWidth: ({ isTextTooltip: isTextTooltip })=>isTextTooltip ? "20em" : "auto",
        backgroundColor: ({ type: type })=>$0708413ad1bc9814$var$getColorByType(type),
        color: ({ type: type })=>type === $8cUge.TYPE_ENUM.default ? $i4KPV.COLORS_V2.NEUTRAL_WHITE : $i4KPV.COLORS_V2.NEUTRAL_BLACK
    },
    arrow: {
        color: ({ type: type })=>$0708413ad1bc9814$var$getColorByType(type)
    }
});
module.exports.default = $0708413ad1bc9814$var$useStylesV2;

});


parcelRegister("9XUXW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});





parcelRegister("19Buq", function(module, exports) {
"use strict";
var $0d73b663609c5973$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0d73b663609c5973$var$save_continue_modal_react_1 = $0d73b663609c5973$var$__importDefault((parcelRequire("iAmcm")));
module.exports.default = $0d73b663609c5973$var$save_continue_modal_react_1.default;

});
parcelRegister("iAmcm", function(module, exports) {
"use strict";
var $d87cceec6d99ef46$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d87cceec6d99ef46$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d87cceec6d99ef46$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d87cceec6d99ef46$var$__createBinding(result, mod, k);
    }
    $d87cceec6d99ef46$var$__setModuleDefault(result, mod);
    return result;
};
var $d87cceec6d99ef46$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d87cceec6d99ef46$var$react_1 = $d87cceec6d99ef46$var$__importDefault((parcelRequire("acw62")));

var $6Q1H5 = parcelRequire("6Q1H5");
var $2MUlQ = parcelRequire("2MUlQ");

const $d87cceec6d99ef46$var$shared_components_krg_button_1 = $d87cceec6d99ef46$var$__importStar((parcelRequire("dgtCa")));

var $i4KPV = parcelRequire("i4KPV");

var $fE9Ck = parcelRequire("fE9Ck");

var $lPVW7 = parcelRequire("lPVW7");

var $1aIR6 = parcelRequire("1aIR6");
const $d87cceec6d99ef46$var$SaveContinueModal = ({ type: type, headerIconType: headerIconType, header: header = "", title: title = "", body: body = "", links: links = [], inputContainer: inputContainer, submitButtonText: submitButtonText, cancelButtonText: cancelButtonText, buttonConfig: buttonConfig, maxWidth: maxWidth, isCancelButtonEnabled: isCancelButtonEnabled, isSubmitButtonEnabled: isSubmitButtonEnabled, theme: theme = $i4KPV.THEME_ENUM.v1, onSubmitClick: onSubmitClick, onClose: onClose })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const props = {
        headerIconType: headerIconType,
        maxWidth: maxWidth,
        type: type
    };
    const isV2Theme = theme === $i4KPV.THEME_ENUM.v2;
    const baseClasses = (0, $lPVW7.useBaseStyles)(props);
    const classesV1 = (0, $lPVW7.useStylesV1)(props);
    const classesV2 = (0, $lPVW7.useStylesV2)(props);
    const classes = isV2Theme ? classesV2 : classesV1;
    const hasInputContainer = !!inputContainer;
    return $d87cceec6d99ef46$var$react_1.default.createElement($d87cceec6d99ef46$var$react_1.default.Fragment, null, header && $d87cceec6d99ef46$var$react_1.default.createElement($1aIR6.HeaderSection, {
        baseClasses: baseClasses,
        classes: classes,
        isV2Theme: isV2Theme,
        header: header,
        headerIconType: headerIconType
    }), (links === null || links === void 0 ? void 0 : links.length) > 0 && isV2Theme && $d87cceec6d99ef46$var$react_1.default.createElement($1aIR6.LinksSection, {
        classes: classes,
        theme: theme,
        links: links,
        maxWidth: maxWidth
    }), body && isV2Theme && $d87cceec6d99ef46$var$react_1.default.createElement($1aIR6.BodySection, {
        classes: classes,
        body: body
    }), title && $d87cceec6d99ef46$var$react_1.default.createElement($1aIR6.TitleSection, {
        classes: classes,
        title: title,
        hasInputContainer: hasInputContainer,
        isSubmit: false
    }), inputContainer && $d87cceec6d99ef46$var$react_1.default.createElement($1aIR6.InputSection, {
        baseClasses: baseClasses,
        classes: classes,
        inputContainer: inputContainer
    }), !inputContainer && $d87cceec6d99ef46$var$react_1.default.createElement("div", {
        className: classes.spacer
    }), type !== $fE9Ck.TYPE_ENUM.info && $d87cceec6d99ef46$var$react_1.default.createElement($6Q1H5.default, {
        className: `${baseClasses.buttons} ${classes.buttons}`
    }, type === $fE9Ck.TYPE_ENUM.confirmation && cancelButtonText && $d87cceec6d99ef46$var$react_1.default.createElement($2MUlQ.default, {
        className: classes.button
    }, $d87cceec6d99ef46$var$react_1.default.createElement($d87cceec6d99ef46$var$shared_components_krg_button_1.default, {
        text: cancelButtonText,
        size: isV2Theme ? $d87cceec6d99ef46$var$shared_components_krg_button_1.SIZE_ENUM.large : undefined,
        style: {
            width: (_a = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _a === void 0 ? void 0 : _a.width
        },
        variant: ((_b = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _b === void 0 ? void 0 : _b.variant) || $d87cceec6d99ef46$var$shared_components_krg_button_1.VARIANT_ENUM.outlined,
        startIcon: (_c = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _c === void 0 ? void 0 : _c.startIcon,
        endIcon: (_d = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.cancelButton) === null || _d === void 0 ? void 0 : _d.endIcon,
        isEnabled: isCancelButtonEnabled,
        theme: theme,
        onClick: onClose
    })), submitButtonText && $d87cceec6d99ef46$var$react_1.default.createElement($2MUlQ.default, {
        className: classes.button
    }, $d87cceec6d99ef46$var$react_1.default.createElement($d87cceec6d99ef46$var$shared_components_krg_button_1.default, {
        text: submitButtonText,
        size: isV2Theme ? $d87cceec6d99ef46$var$shared_components_krg_button_1.SIZE_ENUM.large : undefined,
        style: {
            width: (_e = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _e === void 0 ? void 0 : _e.width
        },
        variant: ((_f = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _f === void 0 ? void 0 : _f.variant) || $d87cceec6d99ef46$var$shared_components_krg_button_1.VARIANT_ENUM.contained,
        startIcon: (_g = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _g === void 0 ? void 0 : _g.startIcon,
        endIcon: (_h = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.submitButton) === null || _h === void 0 ? void 0 : _h.endIcon,
        isEnabled: isSubmitButtonEnabled,
        theme: theme,
        onClick: onSubmitClick
    }))));
};
module.exports.default = $d87cceec6d99ef46$var$SaveContinueModal;

});


parcelRegister("3IONI", function(module, exports) {
"use strict";
var $2b5ce32915493339$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useStylesV2 = module.exports.useStylesV1 = module.exports.useBaseStyles = void 0;

const $2b5ce32915493339$var$base_style_1 = $2b5ce32915493339$var$__importDefault((parcelRequire("lenBv")));
module.exports.useBaseStyles = $2b5ce32915493339$var$base_style_1.default;

const $2b5ce32915493339$var$style_v1_1 = $2b5ce32915493339$var$__importDefault((parcelRequire("j13Sz")));
module.exports.useStylesV1 = $2b5ce32915493339$var$style_v1_1.default;

const $2b5ce32915493339$var$style_v2_1 = $2b5ce32915493339$var$__importDefault((parcelRequire("kqwVu")));
module.exports.useStylesV2 = $2b5ce32915493339$var$style_v2_1.default;

});
parcelRegister("lenBv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $f74d370b9717ed09$var$useBaseStyles = (0, $1GFtd.default)({
    dialogContainer: {
        fontSize: $i4KPV.FONT.SIZE.BASE
    },
    dialogPaper: {
        minWidth: "25.5em",
        borderRadius: "0.125em"
    },
    closeActionButton: {
        cursor: "pointer"
    }
});
module.exports.default = $f74d370b9717ed09$var$useBaseStyles;

});

parcelRegister("j13Sz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $fE9Ck = parcelRequire("fE9Ck");
const $dd811ea93c35d06a$var$useStylesV1 = (0, $1GFtd.default)({
    backdrop: {
        backgroundColor: ({ scrim: scrim })=>`rgba(0, 0, 0, ${scrim === $fE9Ck.SCRIM_ENUM.light ? 0.38 : 0.54})`
    },
    dialogPaper: {},
    closeActionContainer: {}
});
module.exports.default = $dd811ea93c35d06a$var$useStylesV1;

});

parcelRegister("kqwVu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $edefc6d03bcfea9b$var$useStylesV2 = (0, $1GFtd.default)({
    backdrop: {
        backgroundColor: $i4KPV.COLORS_V2_ALPHA.NEUTRAL_BLACK_SCRIM
    },
    dialogPaper: {
        padding: "3.2em 3.75em 1.875em 3.75em",
        boxShadow: `0 0.025em 0.025em ${$i4KPV.COLORS_V2_ALPHA.NEUTRAL_BLACK_SHADOW}`,
        color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        minHeight: ({ headerIconType: headerIconType })=>headerIconType ? "12.5em" : "unset"
    },
    closeActionContainer: {
        position: "absolute",
        top: 0,
        right: 0,
        padding: "1.5em",
        "& > svg": {
            fontSize: "2em",
            color: $i4KPV.COLORS_V2.NEUTRAL_DARK,
            "&:hover": {
                color: $i4KPV.COLORS_V2.PRIMARY_700
            }
        }
    }
});
module.exports.default = $edefc6d03bcfea9b$var$useStylesV2;

});



parcelRegister("bcwoj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iDAOR", function(module, exports) {
"use strict";
var $d9186e0b6107e42d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VARIANT_ENUM = module.exports.THEME_ENUM = void 0;

const $d9186e0b6107e42d$var$krg_text_input_react_1 = $d9186e0b6107e42d$var$__importDefault((parcelRequire("lJFSG")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});
Object.defineProperty(module.exports, "VARIANT_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.INPUT_VARIANT_ENUM;
    }
});
module.exports.default = $d9186e0b6107e42d$var$krg_text_input_react_1.default;

});
parcelRegister("lJFSG", function(module, exports) {
"use strict";
var $04156448d956fa9f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $04156448d956fa9f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $04156448d956fa9f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $04156448d956fa9f$var$__createBinding(result, mod, k);
    }
    $04156448d956fa9f$var$__setModuleDefault(result, mod);
    return result;
};
var $04156448d956fa9f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $04156448d956fa9f$var$react_1 = $04156448d956fa9f$var$__importStar((parcelRequire("acw62")));

var $jTnBY = parcelRequire("jTnBY");
var $iAtns = parcelRequire("iAtns");

const $04156448d956fa9f$var$Error_1 = $04156448d956fa9f$var$__importDefault((parcelRequire("g3Qa3")));

var $i4KPV = parcelRequire("i4KPV");

const $04156448d956fa9f$var$base_style_1 = $04156448d956fa9f$var$__importDefault((parcelRequire("lmaQJ")));

const $04156448d956fa9f$var$style_v1_1 = $04156448d956fa9f$var$__importDefault((parcelRequire("5EhkY")));

const $04156448d956fa9f$var$style_v2_1 = $04156448d956fa9f$var$__importDefault((parcelRequire("5QLlK")));
const $04156448d956fa9f$var$KrgTextInput = ({ id: id = "", className: className = "", style: style, label: label, placeholder: placeholder, debounceTime: debounceTime = 300, errorMessage: errorMessage = "", variant: variant = $i4KPV.INPUT_VARIANT_ENUM.outlined, startAdornment: startAdornment, endAdornment: endAdornment, text: text, textColor: textColor, labelColor: labelColor, placeholderColor: placeholderColor, iconColor: iconColor, borderColor: borderColor, inputRef: inputRef, inputType: inputType, maxCharacter: maxCharacter, maxCharacterOnly: maxCharacterOnly, min: min, max: max, validations: validations, mediaLabel: mediaLabel, hasErrorIcon: hasErrorIcon, hasCaret: hasCaret = true, hasAutoFocus: hasAutoFocus = false, hasAutoComplete: hasAutoComplete = false, isFullWidth: isFullWidth = false, isAutoHeight: isAutoHeight = false, isReadOnly: isReadOnly = false, isHiddenStartAdornmentOnFocus: isHiddenStartAdornmentOnFocus = false, isHiddenStartAdornmentWithPlaceholderOnFocus: isHiddenStartAdornmentWithPlaceholderOnFocus = false, isPillShaped: isPillShaped = false, isEnabled: isEnabled = true, theme: theme = $i4KPV.THEME_ENUM.v1, onTextChange: onTextChange, onDebounceEnd: onDebounceEnd, onDebounceRestart: onDebounceRestart, onKeyDown: onKeyDown, onClick: onClick, onFocus: onFocus, onBlur: onBlur })=>{
    const [innerText, setInnerText] = (0, $04156448d956fa9f$var$react_1.useState)("");
    const [focused, setFocused] = (0, $04156448d956fa9f$var$react_1.useState)(false);
    const timer = (0, $04156448d956fa9f$var$react_1.useRef)(null);
    const isControlled = text !== undefined;
    const inputValue = isControlled ? text : innerText;
    const hideStartAdornment = isHiddenStartAdornmentOnFocus && (focused || text) || isHiddenStartAdornmentWithPlaceholderOnFocus;
    const [errorMsg, setErrorMsg] = (0, $04156448d956fa9f$var$react_1.useState)("");
    const mediaLabelCap = (0, $jTnBY.default)(mediaLabel || "");
    const errorMessageCap = (0, $jTnBY.default)(errorMessage);
    const labelCap = (0, $jTnBY.default)(label || "");
    const placeholderCap = (0, $jTnBY.default)(placeholder || "");
    const props = {
        textColor: textColor,
        labelColor: labelColor,
        placeholderColor: placeholderColor,
        iconColor: iconColor,
        borderColor: borderColor,
        mediaLabel: mediaLabel,
        hasCaret: hasCaret,
        isAutoHeight: isAutoHeight,
        isPillShaped: isPillShaped,
        hasStartAdornment: !!startAdornment && !hideStartAdornment,
        hasEndAdornment: !!endAdornment
    };
    const baseClasses = (0, $04156448d956fa9f$var$base_style_1.default)(props);
    const classesV1 = (0, $04156448d956fa9f$var$style_v1_1.default)(props);
    const classesV2 = (0, $04156448d956fa9f$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    (0, $04156448d956fa9f$var$react_1.useEffect)(()=>setErrorMsg(errorMessageCap), [
        errorMessageCap
    ]);
    (0, $04156448d956fa9f$var$react_1.useEffect)(()=>{
        // Max character only checks character length, is not concerned with validating url
        if (handleMaxCharacterOnly()) setErrorMsg(`Max character limit of ${maxCharacterOnly} was exceeded`);
        else if (validations === null || validations === void 0 ? void 0 : validations.url) {
            if (!handleUrlValidation()) setErrorMsg('This is not a valid URL. Only URLs beginning with "https" are valid.');
            else setErrorMsg("");
        } else setErrorMsg("");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        inputValue
    ]);
    const handleUrlValidation = ()=>{
        // validate url imp trackers
        const trackerUrl = inputValue.trim();
        // eslint-disable-next-line
        const match = inputValue.match(/^https:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+\|,;=.%\{\}]+$/) !== null;
        return match || trackerUrl === "";
    };
    const handleMaxCharacterOnly = ()=>{
        return maxCharacterOnly && inputValue.length > maxCharacterOnly;
    };
    const onTextValueChange = (e)=>{
        const value = e.target.value;
        if (isControlled) {
            if (onTextChange) onTextChange(value);
            if (onDebounceEnd) handleDebounce(value);
        } else {
            setInnerText(value);
            if (onDebounceEnd) handleDebounce(value);
        }
    };
    const handleDebounce = (value)=>{
        if (timer && timer.current) clearTimeout(timer.current);
        if (onDebounceRestart) onDebounceRestart();
        timer.current = setTimeout(()=>{
            if (onDebounceEnd) onDebounceEnd(value);
        }, debounceTime);
    };
    const hasMaxError = ()=>{
        return typeof max === "number" && inputValue > max;
    };
    const hasMinError = ()=>{
        return typeof min === "number" && inputValue < min;
    };
    const getHelperText = ()=>{
        if (maxCharacter) {
            const remainingLength = maxCharacter - inputValue.length;
            if (remainingLength > -1) return `${remainingLength} characters remaining`;
            return `${Math.abs(remainingLength)} characters over`;
        } else if (hasMaxError() || hasMinError()) return `Only values between "${min}" and "${max}" are allowed`;
        return errorMsg;
    };
    const hasError = ()=>{
        if (maxCharacter) return maxCharacter - inputValue.length < 0;
        else if (hasMaxError() || hasMinError()) return true;
        return errorMsg !== "";
    };
    const textFieldVariantClass = variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? baseClasses.textFieldOutlined : `${baseClasses.textFieldStandard} ${classes.textFieldStandard}`;
    const textFieldDisabledClass = isEnabled ? hasError() ? `${baseClasses.textFieldError} ${classes.textFieldError}` : classes.textFieldEnabled : `${baseClasses.textFieldDisabled} ${classes.textFieldDisabled}`;
    const textFieldFilledClass = isEnabled && !hasError() ? inputValue === "" ? classes.textFieldEmpty : classes.textFieldFilled : "";
    return $04156448d956fa9f$var$react_1.default.createElement($iAtns.default, {
        className: `${baseClasses.textField}` + ` ${classes.textField}` + ` ${textFieldVariantClass}` + ` ${textFieldDisabledClass}` + ` ${textFieldFilledClass}` + ` ${className}`,
        size: "small",
        style: style,
        InputProps: {
            id: id,
            endAdornment: hasErrorIcon && hasError() ? $04156448d956fa9f$var$react_1.default.createElement($04156448d956fa9f$var$Error_1.default, {
                className: baseClasses.errorIcon
            }) : endAdornment,
            startAdornment: mediaLabel ? $04156448d956fa9f$var$react_1.default.createElement("div", {
                className: baseClasses.startAdornmentWrapper
            }, $04156448d956fa9f$var$react_1.default.createElement("div", {
                className: baseClasses.startAdormentSvgWrapper
            }, startAdornment), $04156448d956fa9f$var$react_1.default.createElement("span", {
                className: baseClasses.mediaLabelWrapper
            }, mediaLabelCap)) : startAdornment,
            inputProps: {
                min: min,
                max: max
            },
            className: `${baseClasses.inputContainer} ${classes.inputContainer}`,
            type: inputType,
            readOnly: isReadOnly,
            onFocus: (e)=>{
                setFocused(true);
                onFocus === null || onFocus === void 0 || onFocus(e);
            },
            onBlur: (e)=>{
                setFocused(false);
                onBlur === null || onBlur === void 0 || onBlur(e);
            }
        },
        variant: variant,
        value: inputValue,
        label: mediaLabelCap ? "" : labelCap,
        placeholder: placeholderCap,
        fullWidth: isFullWidth,
        disabled: !isEnabled,
        error: hasError(),
        helperText: getHelperText(),
        inputRef: inputRef,
        autoFocus: hasAutoFocus,
        autoComplete: hasAutoComplete ? "on" : "off",
        onWheel: (event)=>{
            var _a;
            return (_a = event.target) === null || _a === void 0 ? void 0 : _a.blur();
        } /* any is required */ ,
        onChange: onTextValueChange,
        onClick: onClick,
        onKeyDown: onKeyDown
    });
};
$04156448d956fa9f$var$KrgTextInput.VARIANT_ENUM = $i4KPV.INPUT_VARIANT_ENUM;
$04156448d956fa9f$var$KrgTextInput.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $04156448d956fa9f$var$KrgTextInput;

});
parcelRegister("iAtns", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8826083c5af4ea7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $i582X = parcelRequire("i582X");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ab7Se = parcelRequire("ab7Se");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $OEVqP = parcelRequire("OEVqP");

var $gd5y7 = parcelRequire("gd5y7");

var $i32L9 = parcelRequire("i32L9");

var $cX7V2 = parcelRequire("cX7V2");

var $3epOE = parcelRequire("3epOE");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $d8826083c5af4ea7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $ab7Se.default),
    filled: (0, $g4sO2.default),
    outlined: (0, $imehR.default)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3epOE.getTextFieldUtilityClass), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $gd5y7.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $1En50.default)(props, $d8826083c5af4ea7$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    if (select && !children) console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $auC0X.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8826083c5af4ea7$var$TextFieldRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cX7V2.default), (0, $8nd05.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
$d8826083c5af4ea7$var$TextField.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */ FormHelperTextProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The helper text content.
   */ helperText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */ InputLabelProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */ InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense",
        "none",
        "normal"
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */ select: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */ SelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The size of the component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "filled",
        "outlined",
        "standard"
    ])
};
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;

});
parcelRegister("OEVqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $09846a8ab0aba36e$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $djhCy = parcelRequire("djhCy");
var $h2sOW = parcelRequire("h2sOW");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $cCThE = parcelRequire("cCThE");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $cCThE.getInputLabelUtilityClasses), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $djhCy.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $h2sOW.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
$09846a8ab0aba36e$var$InputLabel.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "error",
            "info",
            "primary",
            "secondary",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the transition animation is disabled.
   * @default false
   */ disableAnimation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` of this label is focused.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense"
    ]),
    /**
   * if `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is shrunk.
   */ shrink: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The size of the component.
   * @default 'normal'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "normal",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "filled",
        "outlined",
        "standard"
    ])
};
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;

});
parcelRegister("djhCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0ab7de0d37835d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $h2sOW = parcelRequire("h2sOW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $h2sOW.getFormLabelUtilityClasses), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $h2sOW.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $h2sOW.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $h2sOW.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $h2sOW.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
$9b0ab7de0d37835d$var$FormLabel.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "error",
            "info",
            "primary",
            "secondary",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the label should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;

});
parcelRegister("h2sOW", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $c678fac155df4fc3$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $c678fac155df4fc3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)("MuiFormLabel", slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;

});


parcelRegister("cCThE", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)("MuiInputLabel", slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;

});


parcelRegister("gd5y7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd22a386c6068c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $2BbKU = parcelRequire("2BbKU");

var $jTnBY = parcelRequire("jTnBY");

var $cpXNi = parcelRequire("cpXNi");

var $blr6C = parcelRequire("blr6C");

var $hGBKj = parcelRequire("hGBKj");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hGBKj.getFormControlUtilityClasses), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $cpXNi.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $2BbKU.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $2BbKU.isFilled)(child.props, true) || (0, $2BbKU.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const registeredInput = $acw62.useRef(false);
        registerEffect = ()=>{
            if (registeredInput.current) console.error([
                "MUI: There are multiple `InputBase` components inside a FormControl.",
                "This creates visual inconsistencies, only use one `InputBase`."
            ].join("\n"));
            registeredInput.current = true;
            return ()=>{
                registeredInput.current = false;
            };
        };
    }
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
$bcd22a386c6068c0$var$FormControl.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is displayed in focused state.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense",
        "none",
        "normal"
    ]),
    /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "filled",
        "outlined",
        "standard"
    ])
};
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;

});
parcelRegister("hGBKj", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $ce03a37a8cfb980d$export$149c8b8bab2289d1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)("MuiFormControl", slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;

});


parcelRegister("i32L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23aa5c3ca6913fb$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $jTnBY = parcelRequire("jTnBY");

var $e7ceb = parcelRequire("e7ceb");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e7ceb.getFormHelperTextUtilityClasses), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $e7ceb.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $e7ceb.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $1En50.default)(props, $d23aa5c3ca6913fb$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
$d23aa5c3ca6913fb$var$FormHelperText.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the helper text should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, helper text should be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the helper text should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the helper text should use focused classes key.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dense"
    ]),
    /**
   * If `true`, the helper text should use required classes key.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "filled",
            "outlined",
            "standard"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;

});
parcelRegister("e7ceb", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $a46b344d341d82c0$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $a46b344d341d82c0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)("MuiFormHelperText", slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;

});


parcelRegister("3epOE", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $25a6b464d3ca38da$export$c1bdcbaf0596aeda);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)("MuiTextField", slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)("MuiTextField", [
    "root"
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;

});


parcelRegister("g3Qa3", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb15634c27b561c5$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $bb15634c27b561c5$var$_default = module.exports.default = (0, $bb15634c27b561c5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error");

});

parcelRegister("lmaQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $f8c4118e084b2ca1$var$useBaseStyles = (0, $1GFtd.default)({
    /*
      Input container class
    */ inputContainer: {
        borderRadius: 0,
        caretColor: ({ hasCaret: hasCaret })=>hasCaret ? "auto" : "transparent",
        color: ({ textColor: textColor })=>textColor || $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
        lineHeight: 1.2
    },
    /*
      Textfield classes
    */ textField: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        height: ({ isAutoHeight: isAutoHeight })=>isAutoHeight ? "auto" : "3.65em",
        // Input container
        "& .MuiInput-formControl": {
            marginTop: "0"
        },
        // Textfield label
        "& .MuiInputLabel-root": {
            fontSize: "0.9em"
        },
        // Search icon
        "& .MuiSvgIcon-root": {
            fontSize: "1.3em"
        },
        // Start Adornment
        "& .MuiInputBase-adornedStart": {
            paddingLeft: ({ hasStartAdornment: hasStartAdornment, mediaLabel: mediaLabel })=>!hasStartAdornment || mediaLabel ? "0" : "0.8em",
            "& .MuiSvgIcon-root": {
                display: ({ hasStartAdornment: hasStartAdornment })=>!hasStartAdornment ? "none" : "block"
            },
            transition: "padding-left .2s linear"
        },
        // Input
        "& input": {
            paddingLeft: ({ hasStartAdornment: hasStartAdornment })=>hasStartAdornment ? "0.4em" : "0",
            paddingRight: ({ hasEndAdornment: hasEndAdornment })=>hasEndAdornment ? "0.4em" : "0"
        },
        "& ::-webkit-input-placeholder": {
            color: ({ placeholderColor: placeholderColor })=>placeholderColor || $i4KPV.COLORS.BLACK_HIGH_EMPHASIS
        }
    },
    textFieldStandard: {
        // Label
        "& label": {
            marginTop: "-0.7em"
        },
        // Textfield label
        "& .MuiInputLabel-root": {
            fontSize: "0.9em"
        },
        "& .MuiInput-root": {
            marginTop: 0
        }
    },
    textFieldOutlined: {
        // Input
        "& input": {
            paddingLeft: ({ hasStartAdornment: hasStartAdornment })=>hasStartAdornment ? "0.4em" : "0.8em",
            paddingRight: ({ hasEndAdornment: hasEndAdornment })=>hasEndAdornment ? "0.4em" : "0.8em"
        }
    },
    textFieldError: {
        "& .MuiInput-underline:after": {
            borderBottomColor: $i4KPV.COLORS.ERROR_DARK
        },
        "& .MuiFormHelperText-root": {
            color: $i4KPV.COLORS.ERROR_DARK,
            overflow: ({ isAutoHeight: isAutoHeight })=>isAutoHeight ? "initial" : "hidden",
            textOverflow: "ellipsis",
            whiteSpace: ({ isAutoHeight: isAutoHeight })=>isAutoHeight ? "normal" : "nowrap"
        },
        "& svg": {
            color: $i4KPV.COLORS.ERROR_DARK
        },
        "& .MuiInputLabel-root": {
            color: $i4KPV.COLORS.ERROR_DARK
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: $i4KPV.COLORS.ERROR_DARK
            },
            "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: $i4KPV.COLORS.ERROR_DARK,
                opacity: 0.7
            }
        }
    },
    textFieldDisabled: {
        "& .MuiInput-underline:before": {
            borderBottomColor: $i4KPV.COLORS.GRAY_DIVIDER,
            borderBottomStyle: "solid"
        },
        "& svg": {
            color: $i4KPV.COLORS.BLACK_INACTIVE
        }
    },
    errorIcon: {
        color: $i4KPV.COLORS.ERROR_DARK
    },
    startAdornmentWrapper: {
        width: "2.5em",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
    },
    startAdormentSvgWrapper: {
        height: "100%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    mediaLabelWrapper: {
        position: "absolute",
        fontSize: "0.65em",
        color: $i4KPV.COLORS.GRAY_DARK,
        left: "100%",
        top: "-23%",
        backgroundColor: $i4KPV.COLORS.WHITE,
        zIndex: 1,
        padding: "0 0.5em",
        whiteSpace: "nowrap"
    }
});
module.exports.default = $f8c4118e084b2ca1$var$useBaseStyles;

});

parcelRegister("5EhkY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $41ce23061282341e$var$useStylesV1 = (0, $1GFtd.default)({
    inputContainer: {
        height: "2.25em"
    },
    textField: {
        "& input": {
            fontSize: $i4KPV.FONT.SIZE.LARGE
        },
        // Helper text
        "& .MuiFormHelperText-root": {
            margin: "0.25em 0.0625em"
        }
    },
    textFieldStandard: {},
    textFieldEnabled: {
        // Border style
        "& .MuiInput-underline:before": {
            // Semi-transparent underline
            borderBottomColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS.GRAY_DARK
        },
        "& .MuiInput-underline:hover:before": {
            borderBottomColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS.GRAY_DARK,
            opacity: 0.4
        },
        "& .MuiInput-underline:after": {
            // Solid underline on focus
            borderBottomColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
        },
        // Label style
        "& .MuiInputLabel-root": {
            color: ({ labelColor: labelColor })=>labelColor || $i4KPV.COLORS.BLACK_DISABLED
        },
        "& .MuiInputLabel-root.MuiFormLabel-filled": {
            color: ({ labelColor: labelColor })=>labelColor || $i4KPV.COLORS.GRAY_DARK
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: ({ labelColor: labelColor })=>labelColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
        },
        // Border style for outline
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS.GRAY_DARK,
                "& legend": {
                    width: ({ mediaLabel: mediaLabel })=>mediaLabel ? 0 : undefined
                }
            },
            "&:hover fieldset": {
                borderColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS.GRAY_DARK,
                opacity: 0.7
            },
            "&.Mui-focused fieldset": {
                borderColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
            }
        }
    },
    textFieldDisabled: {},
    textFieldEmpty: {
        "& svg": {
            color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS.GRAY_DIVIDER
        },
        "& .Mui-focused": {
            "& svg": {
                color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
            }
        }
    },
    textFieldFilled: {
        "& svg": {
            color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS.GRAY_DARK
        },
        "& .Mui-focused": {
            "& svg": {
                color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
            }
        }
    },
    textFieldError: {
        "& .MuiFormHelperText-root": {
            fontSize: $i4KPV.FONT.SIZE.REGULAR,
            lineHeight: 1.4
        }
    }
});
module.exports.default = $41ce23061282341e$var$useStylesV1;

});

parcelRegister("5QLlK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $442689bcc239a510$var$useStylesV2 = (0, $1GFtd.default)({
    inputContainer: {
        height: "2.3125em"
    },
    textField: {
        "& input": {
            fontSize: $i4KPV.FONT.SIZE.REGULAR,
            fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
            color: ({ textColor: textColor })=>textColor || $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            paddingLeft: "1em",
            paddingRight: "1em"
        },
        "& fieldset": {
            borderRadius: ({ isPillShaped: isPillShaped })=>isPillShaped ? "50px" : 0
        },
        "& svg": {
            marginRight: "-0.25em"
        },
        // Helper text
        "& .MuiFormHelperText-root": {
            margin: "0.545em 0 0.0625em 0",
            fontSize: $i4KPV.FONT.SIZE.SMALL,
            color: $i4KPV.COLORS_V2.NEUTRAL_DARK,
            "&.Mui-error": {
                color: $i4KPV.COLORS_V2.ERROR_DARK
            }
        },
        // Label style
        "& .MuiInputLabel-root": {
            fontSize: $i4KPV.FONT.SIZE.REGULAR,
            lineHeight: "1.625em",
            color: ({ labelColor: labelColor })=>labelColor || $i4KPV.COLORS_V2.NEUTRAL_DARK,
            "&.MuiInputLabel-shrink": {
                fontSize: "0.83333em"
            },
            "&.Mui-disabled": {
                color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        "& .MuiInputLabel-root.MuiFormLabel-filled": {
            fontSize: "0.9167em"
        },
        "& .MuiInputLabel-root.Mui-focused": {
            fontSize: "0.9167em"
        }
    },
    textFieldStandard: {
        "& > .MuiInputBase-adornedStart": {
            paddingLeft: 0,
            "& > svg": {
                margin: 0,
                marginBottom: "-0.685em"
            }
        },
        "& > .MuiInputBase-adornedEnd": {
            "& > svg": {
                margin: 0,
                marginBottom: "-0.625em"
            }
        },
        "& > label": {
            marginTop: "-0.625em",
            "&.MuiInputLabel-shrink": {
                marginTop: "0.375em"
            }
        },
        "& .MuiInputBase-input": {
            margin: 0,
            padding: 0,
            marginTop: "1.5em"
        }
    },
    textFieldEnabled: {
        "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-focused):before": {
            borderBottomColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
            borderWidth: "0.0625em"
        },
        "& .MuiInput-underline.Mui-focused:hover:before": {
            border: "none"
        },
        "& .MuiInput-underline:after": {
            transform: "scaleX(1)",
            border: "none"
        },
        "& .MuiInput-underline.Mui-focused:after": {
            borderBottomWidth: "2px",
            borderBottomStyle: "solid",
            borderBottomColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS_V2.PRIMARY_700
        },
        // Label style
        "& .MuiInputLabel-root": {
            color: ({ labelColor: labelColor })=>labelColor || $i4KPV.COLORS_V2.NEUTRAL_DARK
        },
        "& .MuiInputLabel-root.MuiFormLabel-filled": {
            color: ({ labelColor: labelColor })=>labelColor || $i4KPV.COLORS_V2.NEUTRAL_BLACK
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: ({ labelColor: labelColor })=>labelColor || $i4KPV.COLORS_V2.PRIMARY_700
        },
        // Border style for outline
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS_V2.NEUTRAL_DARK,
                "& legend": {
                    width: ({ mediaLabel: mediaLabel })=>mediaLabel ? 0 : undefined
                }
            },
            "&:hover fieldset": {
                borderColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS_V2.NEUTRAL_BLACK,
                opacity: 1
            },
            "&.Mui-focused fieldset": {
                borderColor: ({ borderColor: borderColor })=>borderColor || $i4KPV.COLORS_V2.PRIMARY_700,
                opacity: 1
            }
        }
    },
    textFieldDisabled: {
        "& .MuiInput-underline:before": {
            borderBottomColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        },
        "& .MuiInputBase-input": {
            color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
            WebkitTextFillColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
            "&::placeholder": {
                WebkitTextFillColor: $i4KPV.COLORS_V2.NEUTRAL_DARK
            }
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        "& > .MuiInputBase-adornedStart": {
            color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
            "& *": {
                color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            }
        }
    },
    textFieldEmpty: {
        "& svg": {
            color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS_V2.NEUTRAL_DARK
        },
        "& .Mui-focused": {
            "& svg": {
                color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS_V2.PRIMARY_700
            }
        }
    },
    textFieldFilled: {
        "& svg": {
            color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS_V2.NEUTRAL_DARK
        },
        "& .Mui-focused": {
            "& svg": {
                color: ({ iconColor: iconColor })=>iconColor || $i4KPV.COLORS_V2.PRIMARY_700
            }
        }
    },
    textFieldError: {
        "& .MuiInput-underline:after": {
            borderBottomColor: $i4KPV.COLORS_V2.ERROR_DARK
        },
        "& .MuiFormHelperText-root": {
            color: $i4KPV.COLORS_V2.ERROR_DARK
        },
        "& svg": {
            color: $i4KPV.COLORS_V2.ERROR_DARK
        },
        "& .MuiInputLabel-root.Mui-error": {
            color: $i4KPV.COLORS_V2.ERROR_DARK
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: $i4KPV.COLORS_V2.ERROR_DARK,
                borderWidth: "0.125em"
            },
            "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: $i4KPV.COLORS_V2.ERROR_DARK,
                opacity: 1
            }
        }
    }
});
module.exports.default = $442689bcc239a510$var$useStylesV2;

});



parcelRegister("htqGM", function(module, exports) {
"use strict";
var $cb89d8f70bddd8d8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb89d8f70bddd8d8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cb89d8f70bddd8d8$var$__createBinding(exports1, m, p);
};
var $cb89d8f70bddd8d8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = void 0;

const $cb89d8f70bddd8d8$var$krg_checkbox_react_1 = $cb89d8f70bddd8d8$var$__importDefault((parcelRequire("8hUjt")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$cb89d8f70bddd8d8$var$__exportStar((parcelRequire("9ptTR")), module.exports);
module.exports.default = $cb89d8f70bddd8d8$var$krg_checkbox_react_1.default;

});
parcelRegister("8hUjt", function(module, exports) {
"use strict";
var $608b97e1063dbc03$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $608b97e1063dbc03$var$react_1 = $608b97e1063dbc03$var$__importDefault((parcelRequire("acw62")));

var $1Aijw = parcelRequire("1Aijw");

var $i4KPV = parcelRequire("i4KPV");

var $9ptTR = parcelRequire("9ptTR");

const $608b97e1063dbc03$var$base_style_1 = $608b97e1063dbc03$var$__importDefault((parcelRequire("ciYQf")));

const $608b97e1063dbc03$var$style_v1_1 = $608b97e1063dbc03$var$__importDefault((parcelRequire("ep42N")));

const $608b97e1063dbc03$var$style_v2_1 = $608b97e1063dbc03$var$__importDefault((parcelRequire("luTCZ")));
const $608b97e1063dbc03$var$KrgCheckbox = ({ id: id, className: className = "", style: style, label: label, labelAlignment: labelAlignment = $9ptTR.LABEL_ALIGNMENT_ENUM.right, hasStopPropagation: hasStopPropagation = true, isChecked: isChecked = false, isIndeterminate: isIndeterminate = false, isEnabled: isEnabled = true, theme: theme = $i4KPV.THEME_ENUM.v1, onToggle: onToggle, onClick: onClick, onBlur: onBlur, onFocus: onFocus })=>{
    const baseClasses = (0, $608b97e1063dbc03$var$base_style_1.default)();
    const classesV1 = (0, $608b97e1063dbc03$var$style_v1_1.default)();
    const classesV2 = (0, $608b97e1063dbc03$var$style_v2_1.default)();
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const checkboxId = `krg-checkbox-${id || Math.random()}`;
    const getLabel = ()=>$608b97e1063dbc03$var$react_1.default.createElement("label", {
            className: `${baseClasses.label} ${classes.label} ${isEnabled ? "" : classes.disabled}`,
            htmlFor: checkboxId
        }, label);
    const onChange = (e)=>{
        if (onToggle) onToggle(e.target.checked);
    };
    return $608b97e1063dbc03$var$react_1.default.createElement("div", {
        className: `${baseClasses.container} ${className}`,
        style: style,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }, labelAlignment === $9ptTR.LABEL_ALIGNMENT_ENUM.left && getLabel(), $608b97e1063dbc03$var$react_1.default.createElement($1Aijw.default, {
        id: checkboxId,
        color: "default",
        disabled: !isEnabled,
        classes: {
            root: `${baseClasses.root} ${classes.root}`,
            checked: classes.selected,
            indeterminate: classes.selected,
            disabled: classes.disabled
        },
        checked: isChecked,
        indeterminate: isIndeterminate,
        onChange: onChange,
        onClick: (e)=>{
            if (hasStopPropagation) e.stopPropagation();
        }
    }), labelAlignment === $9ptTR.LABEL_ALIGNMENT_ENUM.right && getLabel());
};
$608b97e1063dbc03$var$KrgCheckbox.LABEL_ALIGNMENT_ENUM = $9ptTR.LABEL_ALIGNMENT_ENUM;
$608b97e1063dbc03$var$KrgCheckbox.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $608b97e1063dbc03$var$KrgCheckbox;

});
parcelRegister("1Aijw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12775c00f473d955$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $kVqvD = parcelRequire("kVqvD");

var $1yHUZ = parcelRequire("1yHUZ");

var $etWmn = parcelRequire("etWmn");

var $2rW38 = parcelRequire("2rW38");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $9s7Sp = parcelRequire("9s7Sp");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $12775c00f473d955$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9s7Sp.getCheckboxUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $9s7Sp.default).checked}, &.${(0, $9s7Sp.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $9s7Sp.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $etWmn.default), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1yHUZ.default), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2rW38.default), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $1En50.default)(props, $12775c00f473d955$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$CheckboxRoot, (0, $8nd05.default)({
        type: "checkbox",
        inputProps: (0, $8nd05.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
$12775c00f473d955$var$Checkbox.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "default",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */ indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */ indeterminateIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;

});
parcelRegister("kVqvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bdb1b636c81735$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $3yddg = parcelRequire("3yddg");

var $cJQfW = parcelRequire("cJQfW");

var $6n0Ko = parcelRequire("6n0Ko");

var $bxhip = parcelRequire("bxhip");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $f3bdb1b636c81735$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bxhip.getSwitchBaseUtilityClass), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $6n0Ko.default))(({ ownerState: ownerState })=>(0, $8nd05.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)("input", {
    shouldForwardProp: (0, $8Uq77.default)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $1En50.default)(props, $f3bdb1b636c81735$var$_excluded);
    const [checked, setCheckedState] = (0, $3yddg.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $cJQfW.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3bdb1b636c81735$var$SwitchBaseRoot, (0, $8nd05.default)({
        component: "span",
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($f3bdb1b636c81735$var$SwitchBaseInput, (0, $8nd05.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
$f3bdb1b636c81735$var$SwitchBase.propTypes = {
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "end",
        "start",
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /*
   * @ignore
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `input` element is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The input component prop `type`.
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    /**
   * The value of the component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;

});
parcelRegister("bxhip", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", () => $86603163591f910a$export$baa0faa0c7ad8085);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)("PrivateSwitchBase", slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $beCSm.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;

});


parcelRegister("1yHUZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $122b08a8ae2faae5$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRegister("etWmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b10b2b5aaa8e54$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRegister("2rW38", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8b21cdbf539e4f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});

parcelRegister("9s7Sp", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", () => $6e1cd6b997bc70d3$export$6c57c6e16b4063b);
$parcel$export(module.exports, "default", () => $6e1cd6b997bc70d3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)("MuiCheckbox", slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $beCSm.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;

});


parcelRegister("9ptTR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LABEL_ALIGNMENT_ENUM = void 0;
var $6d9da45fb694e072$var$LABEL_ALIGNMENT_ENUM;
(function(LABEL_ALIGNMENT_ENUM) {
    LABEL_ALIGNMENT_ENUM["left"] = "left";
    LABEL_ALIGNMENT_ENUM["right"] = "right";
})($6d9da45fb694e072$var$LABEL_ALIGNMENT_ENUM || (module.exports.LABEL_ALIGNMENT_ENUM = $6d9da45fb694e072$var$LABEL_ALIGNMENT_ENUM = {}));

});

parcelRegister("ciYQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $8f565c626d44619c$var$useBaseStyles = (0, $1GFtd.default)({
    // Checkbox container
    container: {
        alignItems: "center",
        display: "flex",
        fontSize: $i4KPV.FONT.SIZE.BASE
    },
    // Checkbox classes
    root: {
        color: $i4KPV.COLORS.GRAY_DARK,
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
        padding: "0.3em",
        "& .MuiSvgIcon-root": {
            fontSize: "1.5em"
        }
    },
    // Label text
    label: {
        cursor: "pointer"
    }
});
module.exports.default = $8f565c626d44619c$var$useBaseStyles;

});

parcelRegister("ep42N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i4KPV = parcelRequire("i4KPV");

var $1GFtd = parcelRequire("1GFtd");
const $a7c6898c66559ff2$var$useStylesV1 = (0, $1GFtd.default)({
    // Checkbox classes
    root: {},
    // Selected (Checked/Indeterminate)
    selected: {
        color: $i4KPV.COLORS.PRIMARY_500_ACCENT
    },
    // Disabled color
    disabled: {
        color: $i4KPV.COLORS.GRAY_DARK,
        cursor: "default"
    },
    // Label text
    label: {}
});
module.exports.default = $a7c6898c66559ff2$var$useStylesV1;

});

parcelRegister("luTCZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $fa678cd541f7a9aa$var$useStylesV2 = (0, $1GFtd.default)({
    // Checkbox classes
    root: {
        "& .MuiSvgIcon-root": {
            fontSize: "1.25em"
        }
    },
    // Selected (Checked/Indeterminate)
    selected: {
        color: $i4KPV.COLORS_V2.PRIMARY_700
    },
    // Disabled color
    disabled: {
        color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
        cursor: "default"
    },
    // Label text
    label: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        paddingLeft: "0.1875em"
    }
});
module.exports.default = $fa678cd541f7a9aa$var$useStylesV2;

});



parcelRegister("55ofq", function(module, exports) {
"use strict";
var $3b403a7d0c5cd70b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b403a7d0c5cd70b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3b403a7d0c5cd70b$var$__createBinding(exports1, m, p);
};
var $3b403a7d0c5cd70b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = void 0;

const $3b403a7d0c5cd70b$var$krg_menu_react_1 = $3b403a7d0c5cd70b$var$__importDefault((parcelRequire("igNeH")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$3b403a7d0c5cd70b$var$__exportStar((parcelRequire("hI1kz")), module.exports);

$3b403a7d0c5cd70b$var$__exportStar((parcelRequire("j9Pce")), module.exports);
module.exports.default = $3b403a7d0c5cd70b$var$krg_menu_react_1.default;

});
parcelRegister("igNeH", function(module, exports) {
"use strict";
var $d4cfe9ddc9ef4d79$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d4cfe9ddc9ef4d79$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d4cfe9ddc9ef4d79$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d4cfe9ddc9ef4d79$var$__createBinding(result, mod, k);
    }
    $d4cfe9ddc9ef4d79$var$__setModuleDefault(result, mod);
    return result;
};
var $d4cfe9ddc9ef4d79$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d4cfe9ddc9ef4d79$var$react_1 = $d4cfe9ddc9ef4d79$var$__importDefault((parcelRequire("acw62")));

var $lBOb7 = parcelRequire("lBOb7");
var $2iAqv = parcelRequire("2iAqv");
var $9Lykx = parcelRequire("9Lykx");
var $e76iu = parcelRequire("e76iu");
var $7Frhn = parcelRequire("7Frhn");
var $kGwBF = parcelRequire("kGwBF");

var $eOIWT = parcelRequire("eOIWT");
var $42Kj0 = parcelRequire("42Kj0");
var $79Zsh = parcelRequire("79Zsh");
var $bGy2H = parcelRequire("bGy2H");

var $i4KPV = parcelRequire("i4KPV");

const $d4cfe9ddc9ef4d79$var$base_style_1 = $d4cfe9ddc9ef4d79$var$__importDefault((parcelRequire("5itcJ")));

const $d4cfe9ddc9ef4d79$var$style_v1_1 = $d4cfe9ddc9ef4d79$var$__importDefault((parcelRequire("avOqT")));

const $d4cfe9ddc9ef4d79$var$style_v2_1 = $d4cfe9ddc9ef4d79$var$__importDefault((parcelRequire("aMfPC")));

var $hI1kz = parcelRequire("hI1kz");

const $d4cfe9ddc9ef4d79$var$shared_components_krg_button_1 = $d4cfe9ddc9ef4d79$var$__importStar((parcelRequire("dgtCa")));
const $d4cfe9ddc9ef4d79$var$KrgMenu = ({ id: id, classNames: classNames = {
    button: "",
    menuList: "",
    popper: "",
    paper: ""
}, buttonText: buttonText = "", buttonIconType: buttonIconType = $hI1kz.BUTTON_ICON_ENUM.moreVert, buttonVariant: buttonVariant = $d4cfe9ddc9ef4d79$var$shared_components_krg_button_1.VARIANT_ENUM.contained, size: size = $d4cfe9ddc9ef4d79$var$shared_components_krg_button_1.SIZE_ENUM.medium, menuItems: menuItems, menuPlacement: menuPlacement = "bottom-end", isEnabled: isEnabled = true, isHoverEnabled: isHoverEnabled = false, theme: theme = $i4KPV.THEME_ENUM.v1, onClick: onClick, onBlur: onBlur, onFocus: onFocus })=>{
    const [open, setOpen] = $d4cfe9ddc9ef4d79$var$react_1.default.useState(false);
    const anchorRef = $d4cfe9ddc9ef4d79$var$react_1.default.useRef(null);
    const props = {
        isMenuOpen: open
    };
    const baseClasses = (0, $d4cfe9ddc9ef4d79$var$base_style_1.default)(props);
    const classesV1 = (0, $d4cfe9ddc9ef4d79$var$style_v1_1.default)(props);
    const classesV2 = (0, $d4cfe9ddc9ef4d79$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const isIconButton = buttonVariant === $hI1kz.BUTTON_VARIANT_ENUM.icon;
    const buttonIcon = buttonIconType === $hI1kz.BUTTON_ICON_ENUM.moreVert ? $d4cfe9ddc9ef4d79$var$react_1.default.createElement($eOIWT.default, null) : $d4cfe9ddc9ef4d79$var$react_1.default.createElement($42Kj0.default, null);
    const handleToggle = ()=>setOpen(!open);
    const innerContainerTextSizeClass = size === $d4cfe9ddc9ef4d79$var$shared_components_krg_button_1.SIZE_ENUM.small ? classes.smallInnerContainerText : size === $d4cfe9ddc9ef4d79$var$shared_components_krg_button_1.SIZE_ENUM.medium ? classes.mediumInnerContainerText : size === $d4cfe9ddc9ef4d79$var$shared_components_krg_button_1.SIZE_ENUM.large ? classes.largeInnerContainerText : theme === $i4KPV.THEME_ENUM.v2 ? classes.largeInnerContainerText : classes.xLargeInnerContainerText;
    const handleClose = ()=>setOpen(false);
    const handleOpen = ()=>setOpen(true);
    const renderMenuList = ()=>{
        const containsItemIcon = menuItems.some((item)=>item.icon);
        return $d4cfe9ddc9ef4d79$var$react_1.default.createElement($lBOb7.default, {
            className: `${baseClasses.list} ${classNames.menuList}`,
            autoFocusItem: open
        }, menuItems && menuItems.filter(({ isHidden: isHidden })=>!isHidden).map((item, index)=>$d4cfe9ddc9ef4d79$var$react_1.default.createElement($2iAqv.default, {
                classes: {
                    root: classes.listItem
                },
                key: index,
                onClick: (e)=>{
                    var _a;
                    (_a = item.onClick) === null || _a === void 0 || _a.call(item, e);
                    handleClose();
                },
                disabled: !item.isEnabled
            }, item.content ? item.content : $d4cfe9ddc9ef4d79$var$react_1.default.createElement("div", {
                className: baseClasses.innerContainer
            }, containsItemIcon ? $d4cfe9ddc9ef4d79$var$react_1.default.createElement("div", {
                className: `${innerContainerTextSizeClass} ${baseClasses.innerContainerIcon}`
            }, item.icon) : null, $d4cfe9ddc9ef4d79$var$react_1.default.createElement("div", {
                className: `${classes.innerContainerText}  ${innerContainerTextSizeClass}`
            }, item.name)))));
    };
    const renderButton = ()=>{
        return isIconButton ? $d4cfe9ddc9ef4d79$var$react_1.default.createElement($9Lykx.default, {
            className: classNames.button,
            ref: anchorRef,
            "aria-haspopup": "true",
            disabled: !isEnabled,
            onClick: handleToggle
        }, buttonIcon) : $d4cfe9ddc9ef4d79$var$react_1.default.createElement($d4cfe9ddc9ef4d79$var$shared_components_krg_button_1.default, {
            ref: anchorRef,
            className: classNames.button,
            "aria-haspopup": "true",
            text: isIconButton ? "" : buttonText,
            variant: buttonVariant,
            size: size,
            theme: theme,
            startIcon: isIconButton ? buttonIcon : "",
            isEnabled: isEnabled,
            endIcon: !isIconButton ? open ? $d4cfe9ddc9ef4d79$var$react_1.default.createElement($79Zsh.default, null) : $d4cfe9ddc9ef4d79$var$react_1.default.createElement($bGy2H.default, null) : "",
            onClick: handleToggle
        });
    };
    const popperProps = {
        onResize: undefined,
        onResizeCapture: undefined
    };
    return $d4cfe9ddc9ef4d79$var$react_1.default.createElement("div", {
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        onMouseEnter: isHoverEnabled ? handleOpen : undefined,
        onMouseLeave: isHoverEnabled ? handleClose : undefined
    }, renderButton(), $d4cfe9ddc9ef4d79$var$react_1.default.createElement($e76iu.default, Object.assign({
        open: open,
        anchorEl: anchorRef.current,
        placement: menuPlacement,
        className: `${classNames.popper} ${baseClasses.popper}`
    }, popperProps), $d4cfe9ddc9ef4d79$var$react_1.default.createElement($7Frhn.default, {
        classes: {
            root: `${classNames.paper} ${classes.paper}`
        }
    }, $d4cfe9ddc9ef4d79$var$react_1.default.createElement($kGwBF.ClickAwayListener, {
        onClickAway: handleClose
    }, renderMenuList()))));
};
$d4cfe9ddc9ef4d79$var$KrgMenu.BUTTON_ICON_ENUM = $hI1kz.BUTTON_ICON_ENUM;
$d4cfe9ddc9ef4d79$var$KrgMenu.BUTTON_SIZE_ENUM = $hI1kz.BUTTON_SIZE_ENUM;
$d4cfe9ddc9ef4d79$var$KrgMenu.BUTTON_VARIANT_ENUM = $hI1kz.BUTTON_VARIANT_ENUM;
module.exports.default = $d4cfe9ddc9ef4d79$var$KrgMenu;

});
parcelRegister("eOIWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac989a1e618ed6bb$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ac989a1e618ed6bb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVert");

});

parcelRegister("42Kj0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f1b449f6bb23090$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2f1b449f6bb23090$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"
}), "FilterList");

});

parcelRegister("79Zsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53690b5a62ebef3b$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $53690b5a62ebef3b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLessSharp");

});

parcelRegister("bGy2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $881e061b2426aeb6$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $881e061b2426aeb6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMoreSharp");

});

parcelRegister("5itcJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $3db5498fdb14f3fd$var$useStyles = (0, $1GFtd.default)({
    /* Inner Container  */ innerContainer: {
        alignItems: "center",
        display: "flex",
        width: "100%"
    },
    innerContainerText: {
        width: "auto"
    },
    innerContainerIcon: {
        minWidth: "2em",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        "& .MuiSvgIcon-root": {
            fontSize: "1.5em"
        }
    },
    moreIcon: {
        margin: "auto"
    },
    /* Menu */ popper: {
        zIndex: 1
    },
    list: {
        padding: 0,
        width: "auto",
        minWidth: "10.625em",
        "& .MuiList-padding": {
            padding: 0
        }
    }
});
module.exports.default = $3db5498fdb14f3fd$var$useStyles;

});

parcelRegister("avOqT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $7a73eb81656262d4$var$useStylesV1 = (0, $1GFtd.default)({
    /* Inner Container  */ innerContainerText: {},
    moreIcon: {},
    smallInnerContainerText: {
        fontSize: "0.8em"
    },
    mediumInnerContainerText: {
        fontSize: "0.8em"
    },
    largeInnerContainerText: {
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE
    },
    xLargeInnerContainerText: {
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE
    },
    /* Menu */ paper: {
        borderRadius: 0,
        background: $i4KPV.COLORS.WHITE,
        border: `1px solid ${$i4KPV.COLORS.PRIMARY_500_ACCENT}`,
        boxShadow: `0 0.25em 0.25em ${$i4KPV.COLORS.BLACK_SHADOW}`,
        fontSize: $i4KPV.FONT.SIZE.BASE
    },
    listItem: {
        "&:hover": {
            backgroundColor: $i4KPV.COLORS.PRIMARY_50,
            color: $i4KPV.COLORS.PRIMARY_500_ACCENT,
            "& .MuiSvgIcon-root": {
                fill: $i4KPV.COLORS.PRIMARY_500_ACCENT
            }
        }
    }
});
module.exports.default = $7a73eb81656262d4$var$useStylesV1;

});

parcelRegister("aMfPC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $7d8aaae99894de78$var$useStylesV2 = (0, $1GFtd.default)({
    /* Inner Container  */ innerContainerText: {
        textTransform: "none",
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM
    },
    moreIcon: {
        height: "1.125em"
    },
    smallInnerContainerText: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        lineHeight: "1.25em"
    },
    mediumInnerContainerText: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        lineHeight: "1.25em"
    },
    largeInnerContainerText: {
        fontSize: $i4KPV.FONT.SIZE.LARGE,
        lineHeight: "1.825em"
    },
    xLargeInnerContainerText: {},
    /* Menu */ paper: {
        position: "relative",
        width: "125%",
        borderRadius: "0.25em",
        background: $i4KPV.COLORS.WHITE,
        boxShadow: `0 0.25em 0.25em ${$i4KPV.COLORS.BLACK_SHADOW}`,
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM
    },
    listItem: {
        minHeight: "2em",
        "&:hover": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_LIGHT,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            "& .MuiSvgIcon-root": {
                fill: $i4KPV.COLORS_V2.NEUTRAL_BLACK
            }
        }
    }
});
module.exports.default = $7d8aaae99894de78$var$useStylesV2;

});

parcelRegister("hI1kz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BUTTON_ICON_ENUM = module.exports.BUTTON_VARIANT_ENUM = module.exports.BUTTON_SIZE_ENUM = void 0;
var $ce4793fef76ea8d1$var$BUTTON_SIZE_ENUM;
(function(BUTTON_SIZE_ENUM) {
    BUTTON_SIZE_ENUM["small"] = "small";
    BUTTON_SIZE_ENUM["medium"] = "medium";
    BUTTON_SIZE_ENUM["large"] = "large";
    BUTTON_SIZE_ENUM["xlarge"] = "xlarge";
})($ce4793fef76ea8d1$var$BUTTON_SIZE_ENUM || (module.exports.BUTTON_SIZE_ENUM = $ce4793fef76ea8d1$var$BUTTON_SIZE_ENUM = {}));
var $ce4793fef76ea8d1$var$BUTTON_VARIANT_ENUM;
(function(BUTTON_VARIANT_ENUM) {
    BUTTON_VARIANT_ENUM["text"] = "text";
    BUTTON_VARIANT_ENUM["outlined"] = "outlined";
    BUTTON_VARIANT_ENUM["contained"] = "contained";
    BUTTON_VARIANT_ENUM["icon"] = "icon";
})($ce4793fef76ea8d1$var$BUTTON_VARIANT_ENUM || (module.exports.BUTTON_VARIANT_ENUM = $ce4793fef76ea8d1$var$BUTTON_VARIANT_ENUM = {}));
var $ce4793fef76ea8d1$var$BUTTON_ICON_ENUM;
(function(BUTTON_ICON_ENUM) {
    BUTTON_ICON_ENUM["moreVert"] = "more_vert";
    BUTTON_ICON_ENUM["filterList"] = "filter_list";
})($ce4793fef76ea8d1$var$BUTTON_ICON_ENUM || (module.exports.BUTTON_ICON_ENUM = $ce4793fef76ea8d1$var$BUTTON_ICON_ENUM = {}));

});


parcelRegister("j9Pce", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("guTE0", function(module, exports) {
"use strict";
var $c02a9c7c4dd35ef9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c02a9c7c4dd35ef9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c02a9c7c4dd35ef9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c02a9c7c4dd35ef9$var$__createBinding(result, mod, k);
    }
    $c02a9c7c4dd35ef9$var$__setModuleDefault(result, mod);
    return result;
};
var $c02a9c7c4dd35ef9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c02a9c7c4dd35ef9$var$react_1 = $c02a9c7c4dd35ef9$var$__importStar((parcelRequire("acw62")));

var $9yoVa = parcelRequire("9yoVa");

var $6IhJz = parcelRequire("6IhJz");

var $6el2W = parcelRequire("6el2W");

var $4PtY7 = parcelRequire("4PtY7");
var $6kPMt = parcelRequire("6kPMt");

var $i4KPV = parcelRequire("i4KPV");

const $c02a9c7c4dd35ef9$var$shared_components_krg_text_input_1 = $c02a9c7c4dd35ef9$var$__importDefault((parcelRequire("iDAOR")));

var $cPxZ8 = parcelRequire("cPxZ8");

var $cHOUY = parcelRequire("cHOUY");

// Styles
const $c02a9c7c4dd35ef9$var$base_style_1 = $c02a9c7c4dd35ef9$var$__importDefault((parcelRequire("7la50")));

const $c02a9c7c4dd35ef9$var$KrgDatePicker = ({ date: date, dateRange: dateRange, classNames: classNames = {
    input: "",
    popover: "",
    popoverPaper: ""
}, dayPickerClassNames: dayPickerClassNames, inputStyle: inputStyle, inputVariant: inputVariant = $i4KPV.INPUT_VARIANT_ENUM.outlined, label: label, placeholder: placeholder, disabledDates: disabledDates, errorMessage: errorMessage, isRange: isRange = false, isEnabled: isEnabled = true, isClearable: isClearable = true, isOpenCalendarOnClear: isOpenCalendarOnClear = false, onDateClear: onDateClear, onDateChange: onDateChange, onDateRangeChange: onDateRangeChange, onBlur: onBlur, onClick: onClick, onFocus: onFocus })=>{
    const now = new Date();
    const theme = $i4KPV.THEME_ENUM.v2;
    const classes = (0, $c02a9c7c4dd35ef9$var$base_style_1.default)();
    const [anchorEl, setAnchorEl] = (0, $c02a9c7c4dd35ef9$var$react_1.useState)(null);
    const [dateInputText, setDateInputText] = (0, $c02a9c7c4dd35ef9$var$react_1.useState)("");
    const isValidDateText = isRange ? (0, $cHOUY.isValidDateRange)(dateInputText) : (0, $cHOUY.isValidDate)(dateInputText);
    (0, $c02a9c7c4dd35ef9$var$react_1.useEffect)(()=>{
        let newDateInputText = "";
        if (isRange && (dateRange === null || dateRange === void 0 ? void 0 : dateRange.from) && (dateRange === null || dateRange === void 0 ? void 0 : dateRange.to)) newDateInputText = `${(0, $6IhJz.default)(dateRange.from, "P")} - ${(0, $6IhJz.default)(dateRange.to, "P")}`;
        else if (!isRange && date) newDateInputText = (0, $6IhJz.default)(date, "P");
        setDateInputText(newDateInputText);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        date,
        dateRange
    ]);
    const onCalendarClick = (e)=>{
        e.stopPropagation();
        setAnchorEl(e.currentTarget.children[0]);
        onClick === null || onClick === void 0 || onClick(e);
    };
    const onSelectDate = (newDate, { disabled: dateDisabled })=>{
        if (!dateDisabled) {
            setAnchorEl(null);
            onBlur === null || onBlur === void 0 || onBlur(null);
            onDateChange === null || onDateChange === void 0 || onDateChange(newDate);
        }
    };
    const onSelectDateRange = (selectedRange, selectedDay)=>{
        let newRange = selectedRange;
        if ((dateRange === null || dateRange === void 0 ? void 0 : dateRange.from) && (dateRange === null || dateRange === void 0 ? void 0 : dateRange.to)) // Emulate toggling selection. first click from, second click to, third click from...
        newRange = {
            from: selectedDay,
            to: undefined
        };
        onBlur === null || onBlur === void 0 || onBlur(null);
        onDateRangeChange === null || onDateRangeChange === void 0 || onDateRangeChange(newRange);
    };
    const onClearClick = (e)=>{
        e.stopPropagation();
        isRange ? onDateRangeChange === null || onDateRangeChange === void 0 || onDateRangeChange(undefined) : onDateChange === null || onDateChange === void 0 || onDateChange(null);
        onDateClear === null || onDateClear === void 0 || onDateClear();
        if (isOpenCalendarOnClear) setAnchorEl(e.currentTarget.parentElement);
    };
    const isRangeSameDay = ()=>{
        if (dateInputText && isRange) {
            const dateParts = dateInputText.split("-");
            const from = dateParts[0].trim();
            const to = dateParts[1].trim();
            return from === to;
        }
        return false;
    };
    // Style classes definition for date picker
    const datePickerClassNames = Object.assign({
        root: classes.pickerRoot,
        caption_dropdowns: classes.changeMonthYearContainer,
        caption_label: classes.changeMonthYearLabel,
        dropdown_month: classes.changeMonthYearDropdown,
        dropdown_year: classes.changeMonthYearDropdown,
        head_cell: classes.dayOfWeek,
        button: classes.day,
        day_today: classes.dayToday,
        day_selected: classes.daySelected,
        day_disabled: classes.dayDisabled,
        day_range_start: isRangeSameDay() ? classes.daySelected : classes.dayRangeStart,
        day_range_middle: classes.dayRangeMiddle,
        day_range_end: (dateRange === null || dateRange === void 0 ? void 0 : dateRange.to) ? isRangeSameDay() ? classes.daySelected : classes.dayRangeEnd : classes.dayRangeStart
    }, dayPickerClassNames);
    // Common Date picker props (single and range)
    const datePickerProps = {
        classNames: datePickerClassNames,
        defaultMonth: date || (dateRange === null || dateRange === void 0 ? void 0 : dateRange.from) || now,
        disabled: disabledDates || undefined,
        captionLayout: "dropdown",
        fromYear: (date || now).getFullYear() - $cPxZ8.MAX_NUMBER_YEARS / 2,
        toYear: (date || now).getFullYear() + $cPxZ8.MAX_NUMBER_YEARS / 2,
        formatters: {
            formatWeekdayName: $cHOUY.formatWeekdayName
        }
    };
    return $c02a9c7c4dd35ef9$var$react_1.default.createElement($c02a9c7c4dd35ef9$var$react_1.default.Fragment, null, $c02a9c7c4dd35ef9$var$react_1.default.createElement($c02a9c7c4dd35ef9$var$shared_components_krg_text_input_1.default, {
        className: classNames.input,
        style: Object.assign({}, inputStyle),
        variant: inputVariant,
        placeholder: placeholder,
        label: label,
        text: dateInputText,
        startAdornment: (0, $cHOUY.getIcon)($c02a9c7c4dd35ef9$var$react_1.default.createElement($4PtY7.default, null), classes.icon, isEnabled, onCalendarClick),
        endAdornment: (date || dateRange) && isClearable ? (0, $cHOUY.getIcon)($c02a9c7c4dd35ef9$var$react_1.default.createElement($6kPMt.default, null), classes.icon, isEnabled, onClearClick) : undefined,
        errorMessage: errorMessage || (isValidDateText ? undefined : "Error Format"),
        isEnabled: isEnabled,
        theme: theme,
        onTextChange: setDateInputText,
        onFocus: onFocus,
        onBlur: (e)=>{
            onBlur === null || onBlur === void 0 || onBlur(e);
            if (isValidDateText) // If type date and is valid, emit its corresponding date object to apply it
            isRange ? onDateRangeChange === null || onDateRangeChange === void 0 || onDateRangeChange(dateInputText ? (0, $cHOUY.getDateRangeFromText)(dateInputText) : undefined) : onDateChange === null || onDateChange === void 0 || onDateChange(dateInputText ? (0, $cHOUY.getDateFromText)(dateInputText) : null);
        },
        onClick: onClick
    }), $c02a9c7c4dd35ef9$var$react_1.default.createElement($6el2W.default, {
        classes: {
            paper: `${classes.popoverPaper} ${classNames.popoverPaper}`
        },
        className: classNames.popover,
        open: !!anchorEl,
        anchorEl: anchorEl,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        disableAutoFocus: true,
        disableEnforceFocus: true,
        onClose: (e)=>setAnchorEl(null),
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick
    }, isRange ? $c02a9c7c4dd35ef9$var$react_1.default.createElement($9yoVa.DayPicker, Object.assign({}, datePickerProps, {
        mode: "range",
        numberOfMonths: 2,
        selected: dateRange || undefined,
        onSelect: onSelectDateRange
    })) : $c02a9c7c4dd35ef9$var$react_1.default.createElement($9yoVa.DayPicker, Object.assign({}, datePickerProps, {
        mode: "default",
        selected: date || undefined,
        onDayClick: onSelectDate
    }))));
};
$c02a9c7c4dd35ef9$var$KrgDatePicker.VARIANT_ENUM = $i4KPV.INPUT_VARIANT_ENUM;
module.exports.default = $c02a9c7c4dd35ef9$var$KrgDatePicker;

});
parcelRegister("9yoVa", function(module, exports) {

$parcel$export(module.exports, "DayPicker", () => $6f4a9ed0ffbde9dd$export$97e6db89a86ff7ab);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6IhJz = parcelRequire("6IhJz");
var $5E40x = parcelRequire("5E40x");
var $l2vHo = parcelRequire("l2vHo");
var $cJfMa = parcelRequire("cJfMa");
var $R4xmB = parcelRequire("R4xmB");
var $cZ2kT = parcelRequire("cZ2kT");
var $3lKFD = parcelRequire("3lKFD");
var $6eIgt = parcelRequire("6eIgt");
var $1Whvr = parcelRequire("1Whvr");
var $eqWMS = parcelRequire("eqWMS");
var $b27pX = parcelRequire("b27pX");
var $4YTY5 = parcelRequire("4YTY5");
var $Ua0Sr = parcelRequire("Ua0Sr");
var $7yBDJ = parcelRequire("7yBDJ");
var $6OX6Q = parcelRequire("6OX6Q");
var $hjw1k = parcelRequire("hjw1k");
var $baBa1 = parcelRequire("baBa1");
var $4irF8 = parcelRequire("4irF8");
var $lm2ga = parcelRequire("lm2ga");
var $9BdaM = parcelRequire("9BdaM");
var $2MTnF = parcelRequire("2MTnF");
var $kbDwl = parcelRequire("kbDwl");
var $ce8cj = parcelRequire("ce8cj");
var $75XN4 = parcelRequire("75XN4");
var $6atcA = parcelRequire("6atcA");
var $8v9st = parcelRequire("8v9st");
var $hXFBz = parcelRequire("hXFBz");
var $hbMru = parcelRequire("hbMru");
var $dALCP = parcelRequire("dALCP");
var $bRmIc = parcelRequire("bRmIc");
var $auRgN = parcelRequire("auRgN");

var $15nwl = parcelRequire("15nwl");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $6f4a9ed0ffbde9dd$var$__assign = function() {
    $6f4a9ed0ffbde9dd$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6f4a9ed0ffbde9dd$var$__assign.apply(this, arguments);
};
function $6f4a9ed0ffbde9dd$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6f4a9ed0ffbde9dd$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function $6f4a9ed0ffbde9dd$export$2d8c2b43ec0e528(props) {
    return props.mode === "multiple";
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function $6f4a9ed0ffbde9dd$export$f7b9f96866ec1964(props) {
    return props.mode === "range";
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function $6f4a9ed0ffbde9dd$export$e659ce9b264ea61(props) {
    return props.mode === "single";
}
/**
 * The name of the default CSS classes.
 */ var $6f4a9ed0ffbde9dd$var$defaultClassNames = {
    root: "rdp",
    multiple_months: "rdp-multiple_months",
    with_weeknumber: "rdp-with_weeknumber",
    vhidden: "rdp-vhidden",
    button_reset: "rdp-button_reset",
    button: "rdp-button",
    caption: "rdp-caption",
    caption_start: "rdp-caption_start",
    caption_end: "rdp-caption_end",
    caption_between: "rdp-caption_between",
    caption_label: "rdp-caption_label",
    caption_dropdowns: "rdp-caption_dropdowns",
    dropdown: "rdp-dropdown",
    dropdown_month: "rdp-dropdown_month",
    dropdown_year: "rdp-dropdown_year",
    dropdown_icon: "rdp-dropdown_icon",
    months: "rdp-months",
    month: "rdp-month",
    table: "rdp-table",
    tbody: "rdp-tbody",
    tfoot: "rdp-tfoot",
    head: "rdp-head",
    head_row: "rdp-head_row",
    head_cell: "rdp-head_cell",
    nav: "rdp-nav",
    nav_button: "rdp-nav_button",
    nav_button_previous: "rdp-nav_button_previous",
    nav_button_next: "rdp-nav_button_next",
    nav_icon: "rdp-nav_icon",
    row: "rdp-row",
    weeknumber: "rdp-weeknumber",
    cell: "rdp-cell",
    day: "rdp-day",
    day_today: "rdp-day_today",
    day_outside: "rdp-day_outside",
    day_selected: "rdp-day_selected",
    day_disabled: "rdp-day_disabled",
    day_hidden: "rdp-day_hidden",
    day_range_start: "rdp-day_range_start",
    day_range_end: "rdp-day_range_end",
    day_range_middle: "rdp-day_range_middle"
};
/**
 * The default formatter for the caption.
 */ function $6f4a9ed0ffbde9dd$var$formatCaption(month, options) {
    return (0, $6IhJz.default)(month, "LLLL y", options);
}
/**
 * The default formatter for the Day button.
 */ function $6f4a9ed0ffbde9dd$var$formatDay(day, options) {
    return (0, $6IhJz.default)(day, "d", options);
}
/**
 * The default formatter for the Month caption.
 */ function $6f4a9ed0ffbde9dd$var$formatMonthCaption(month, options) {
    return (0, $6IhJz.default)(month, "LLLL", options);
}
/**
 * The default formatter for the week number.
 */ function $6f4a9ed0ffbde9dd$var$formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function $6f4a9ed0ffbde9dd$var$formatWeekdayName(weekday, options) {
    return (0, $6IhJz.default)(weekday, "cccccc", options);
}
/**
 * The default formatter for the Year caption.
 */ function $6f4a9ed0ffbde9dd$var$formatYearCaption(year, options) {
    return (0, $6IhJz.default)(year, "yyyy", options);
}
var $6f4a9ed0ffbde9dd$var$formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: $6f4a9ed0ffbde9dd$var$formatCaption,
    formatDay: $6f4a9ed0ffbde9dd$var$formatDay,
    formatMonthCaption: $6f4a9ed0ffbde9dd$var$formatMonthCaption,
    formatWeekNumber: $6f4a9ed0ffbde9dd$var$formatWeekNumber,
    formatWeekdayName: $6f4a9ed0ffbde9dd$var$formatWeekdayName,
    formatYearCaption: $6f4a9ed0ffbde9dd$var$formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var $6f4a9ed0ffbde9dd$var$labelDay = function(day, activeModifiers, options) {
    return (0, $6IhJz.default)(day, "do MMMM (EEEE)", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $6f4a9ed0ffbde9dd$var$labelMonthDropdown = function() {
    return "Month: ";
};
/**
 * The default ARIA label for next month button in navigation
 */ var $6f4a9ed0ffbde9dd$var$labelNext = function() {
    return "Go to next month";
};
/**
 * The default ARIA label for previous month button in navigation
 */ var $6f4a9ed0ffbde9dd$var$labelPrevious = function() {
    return "Go to previous month";
};
/**
 * The default ARIA label for the Weekday element.
 */ var $6f4a9ed0ffbde9dd$var$labelWeekday = function(day, options) {
    return (0, $6IhJz.default)(day, "cccc", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $6f4a9ed0ffbde9dd$var$labelWeekNumber = function(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $6f4a9ed0ffbde9dd$var$labelYearDropdown = function() {
    return "Year: ";
};
var $6f4a9ed0ffbde9dd$var$labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: $6f4a9ed0ffbde9dd$var$labelDay,
    labelMonthDropdown: $6f4a9ed0ffbde9dd$var$labelMonthDropdown,
    labelNext: $6f4a9ed0ffbde9dd$var$labelNext,
    labelPrevious: $6f4a9ed0ffbde9dd$var$labelPrevious,
    labelWeekNumber: $6f4a9ed0ffbde9dd$var$labelWeekNumber,
    labelWeekday: $6f4a9ed0ffbde9dd$var$labelWeekday,
    labelYearDropdown: $6f4a9ed0ffbde9dd$var$labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function $6f4a9ed0ffbde9dd$var$getDefaultContextValues() {
    var captionLayout = "buttons";
    var classNames = $6f4a9ed0ffbde9dd$var$defaultClassNames;
    var locale = (0, $15nwl.default);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: $6f4a9ed0ffbde9dd$var$formatters,
        labels: $6f4a9ed0ffbde9dd$var$labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: "default"
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function $6f4a9ed0ffbde9dd$var$parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, $5E40x.default)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, $l2vHo.default)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, $cJfMa.default)(fromDate) : undefined,
        toDate: toDate ? (0, $cJfMa.default)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var $6f4a9ed0ffbde9dd$export$5e463664ac32e9a9 = (0, $acw62.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function $6f4a9ed0ffbde9dd$export$a84f964d022d25c(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = $6f4a9ed0ffbde9dd$var$getDefaultContextValues();
    var _b = $6f4a9ed0ffbde9dd$var$parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== "buttons" && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = "buttons";
    var onSelect;
    if ($6f4a9ed0ffbde9dd$export$e659ce9b264ea61(initialProps) || $6f4a9ed0ffbde9dd$export$2d8c2b43ec0e528(initialProps) || $6f4a9ed0ffbde9dd$export$f7b9f96866ec1964(initialProps)) onSelect = initialProps.onSelect;
    var value = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: $6f4a9ed0ffbde9dd$var$__assign({}, initialProps.components),
        formatters: $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$5e463664ac32e9a9.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294() {
    var context = (0, $acw62.useContext)($6f4a9ed0ffbde9dd$export$5e463664ac32e9a9);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function $6f4a9ed0ffbde9dd$export$5b9f95302ae85eba(props) {
    var _a = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (0, $ayMG0.jsx)("div", {
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id,
        children: formatCaption(props.displayMonth, {
            locale: locale
        })
    });
}
/**
 * Render the icon in the styled drop-down.
 */ function $6f4a9ed0ffbde9dd$export$eaf28e65c2d9267c(props) {
    return (0, $ayMG0.jsx)("svg", $6f4a9ed0ffbde9dd$var$__assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props, {
        children: (0, $ayMG0.jsx)("path", {
            d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function $6f4a9ed0ffbde9dd$export$931cbfb6bfb85fc(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : $6f4a9ed0ffbde9dd$export$eaf28e65c2d9267c;
    return (0, $ayMG0.jsxs)("div", {
        className: className,
        style: style,
        children: [
            (0, $ayMG0.jsx)("span", {
                className: dayPicker.classNames.vhidden,
                children: props["aria-label"]
            }),
            (0, $ayMG0.jsx)("select", {
                name: props.name,
                "aria-label": props["aria-label"],
                className: dayPicker.classNames.dropdown,
                style: dayPicker.styles.dropdown,
                value: value,
                onChange: onChange,
                children: children
            }),
            (0, $ayMG0.jsxs)("div", {
                className: dayPicker.classNames.caption_label,
                style: dayPicker.styles.caption_label,
                "aria-hidden": "true",
                children: [
                    caption,
                    (0, $ayMG0.jsx)(IconDropdownComponent, {
                        className: dayPicker.classNames.dropdown_icon,
                        style: dayPicker.styles.dropdown_icon
                    })
                ]
            })
        ]
    });
}
/** Render the dropdown to navigate between months. */ function $6f4a9ed0ffbde9dd$var$MonthsDropdown(props) {
    var _a;
    var _b = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    if (!toDate) return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    var dropdownMonths = [];
    if ((0, $R4xmB.default)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, $5E40x.default)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, $cZ2kT.default)(date, month));
    } else {
        // display all the 12 months
        var date = (0, $5E40x.default)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, $cZ2kT.default)(date, month));
    }
    var handleChange = function(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, $cZ2kT.default)((0, $5E40x.default)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$931cbfb6bfb85fc;
    return (0, $ayMG0.jsx)(DropdownComponent, {
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: formatMonthCaption(props.displayMonth, {
            locale: locale
        }),
        children: dropdownMonths.map(function(m) {
            return (0, $ayMG0.jsx)("option", {
                value: m.getMonth(),
                children: formatMonthCaption(m, {
                    locale: locale
                })
            }, m.getMonth());
        })
    });
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function $6f4a9ed0ffbde9dd$var$YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    if (!toDate) return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, $3lKFD.default)((0, $6eIgt.default)(new Date()), year));
    var handleChange = function(e) {
        var newMonth = (0, $3lKFD.default)((0, $5E40x.default)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$931cbfb6bfb85fc;
    return (0, $ayMG0.jsx)(DropdownComponent, {
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: formatYearCaption(displayMonth, {
            locale: locale
        }),
        children: years.map(function(year) {
            return (0, $ayMG0.jsx)("option", {
                value: year.getFullYear(),
                children: formatYearCaption(year, {
                    locale: locale
                })
            }, year.getFullYear());
        })
    });
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function $6f4a9ed0ffbde9dd$var$useControlledValue(defaultValue, controlledValue) {
    var _a = (0, $acw62.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function $6f4a9ed0ffbde9dd$var$getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, $1Whvr.default)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, $eqWMS.default)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, $1Whvr.default)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, $5E40x.default)(initialMonth);
}
/** Controls the navigation state. */ function $6f4a9ed0ffbde9dd$var$useNavigationState() {
    var context = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var initialMonth = $6f4a9ed0ffbde9dd$var$getInitialMonth(context);
    var _a = $6f4a9ed0ffbde9dd$var$useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, $5E40x.default)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function $6f4a9ed0ffbde9dd$var$getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, $5E40x.default)(month);
    var end = (0, $5E40x.default)((0, $eqWMS.default)(start, numberOfMonths));
    var monthsDiff = (0, $1Whvr.default)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, $eqWMS.default)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function $6f4a9ed0ffbde9dd$var$getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $5E40x.default)(startingMonth);
    if (!toDate) return (0, $eqWMS.default)(month, offset);
    var monthsDiff = (0, $1Whvr.default)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, $eqWMS.default)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function $6f4a9ed0ffbde9dd$var$getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $5E40x.default)(startingMonth);
    if (!fromDate) return (0, $eqWMS.default)(month, -offset);
    var monthsDiff = (0, $1Whvr.default)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, $eqWMS.default)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var $6f4a9ed0ffbde9dd$export$3044ab7fdabeaee6 = (0, $acw62.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function $6f4a9ed0ffbde9dd$export$d91daf425539f32f(props) {
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var _a = $6f4a9ed0ffbde9dd$var$useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = $6f4a9ed0ffbde9dd$var$getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = $6f4a9ed0ffbde9dd$var$getNextMonth(currentMonth, dayPicker);
    var previousMonth = $6f4a9ed0ffbde9dd$var$getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, $b27pX.default)(date, displayMonth);
        });
    };
    var goToDate = function(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, $4YTY5.default)(date, refDate)) goToMonth((0, $eqWMS.default)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$3044ab7fdabeaee6.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $6f4a9ed0ffbde9dd$export$d0fd4b7106de2769() {
    var context = (0, $acw62.useContext)($6f4a9ed0ffbde9dd$export$3044ab7fdabeaee6);
    if (!context) throw new Error("useNavigation must be used within a NavigationProvider");
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function $6f4a9ed0ffbde9dd$export$6a3605aba74bcb3d(props) {
    var _a;
    var _b = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = $6f4a9ed0ffbde9dd$export$d0fd4b7106de2769().goToMonth;
    var handleMonthChange = function(newMonth) {
        goToMonth((0, $eqWMS.default)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$5b9f95302ae85eba;
    var captionLabel = (0, $ayMG0.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return (0, $ayMG0.jsxs)("div", {
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns,
        children: [
            (0, $ayMG0.jsx)("div", {
                className: classNames.vhidden,
                children: captionLabel
            }),
            (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$MonthsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            }),
            (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$YearsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            })
        ]
    });
}
/**
 * Render the "previous month" button in the navigation.
 */ function $6f4a9ed0ffbde9dd$export$fac286bb0d0d0385(props) {
    return (0, $ayMG0.jsx)("svg", $6f4a9ed0ffbde9dd$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $ayMG0.jsx)("path", {
            d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function $6f4a9ed0ffbde9dd$export$142e5a7835580ff5(props) {
    return (0, $ayMG0.jsx)("svg", $6f4a9ed0ffbde9dd$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $ayMG0.jsx)("path", {
            d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
            fill: "currentColor"
        })
    }));
}
/** Render a button HTML element applying the reset class name. */ var $6f4a9ed0ffbde9dd$export$353f5b6fc5456de1 = (0, $acw62.forwardRef)(function(props, ref) {
    var _a = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(" ");
    var style = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return (0, $ayMG0.jsx)("button", $6f4a9ed0ffbde9dd$var$__assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function $6f4a9ed0ffbde9dd$var$Navigation(props) {
    var _a, _b;
    var _c = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(" ");
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(" ");
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$142e5a7835580ff5;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : $6f4a9ed0ffbde9dd$export$fac286bb0d0d0385;
    return (0, $ayMG0.jsxs)("div", {
        className: classNames.nav,
        style: styles.nav,
        children: [
            !props.hidePrevious && (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$353f5b6fc5456de1, {
                name: "previous-month",
                "aria-label": previousLabel,
                className: previousClassName,
                style: styles.nav_button_previous,
                disabled: !props.previousMonth,
                onClick: props.onPreviousClick,
                children: dir === "rtl" ? (0, $ayMG0.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $ayMG0.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            }),
            !props.hideNext && (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$353f5b6fc5456de1, {
                name: "next-month",
                "aria-label": nextLabel,
                className: nextClassName,
                style: styles.nav_button_next,
                disabled: !props.nextMonth,
                onClick: props.onNextClick,
                children: dir === "rtl" ? (0, $ayMG0.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $ayMG0.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            })
        ]
    });
}
/**
 * Render a caption with a button-based navigation.
 */ function $6f4a9ed0ffbde9dd$export$f6e46da460a028c1(props) {
    var numberOfMonths = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294().numberOfMonths;
    var _a = $6f4a9ed0ffbde9dd$export$d0fd4b7106de2769(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, $b27pX.default)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function $6f4a9ed0ffbde9dd$export$32fbfacc5d962e0c(props) {
    var _a;
    var _b = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$5b9f95302ae85eba;
    var caption;
    if (disableNavigation) caption = (0, $ayMG0.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === "dropdown") caption = (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$6a3605aba74bcb3d, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === "dropdown-buttons") caption = (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$6a3605aba74bcb3d, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            }),
            (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            })
        ]
    });
    else caption = (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsx)(CaptionLabelComponent, {
                id: props.id,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                id: props.id
            })
        ]
    });
    return (0, $ayMG0.jsx)("div", {
        className: classNames.caption,
        style: styles.caption,
        children: caption
    });
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $6f4a9ed0ffbde9dd$export$a06f1c675e846f6f(props) {
    var _a = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    return (0, $ayMG0.jsx)("tfoot", {
        className: tfoot,
        style: styles.tfoot,
        children: (0, $ayMG0.jsx)("tr", {
            children: (0, $ayMG0.jsx)("td", {
                colSpan: 8,
                children: footer
            })
        })
    });
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function $6f4a9ed0ffbde9dd$var$getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, $Ua0Sr.default)(new Date()) : (0, $7yBDJ.default)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, $6OX6Q.default)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function $6f4a9ed0ffbde9dd$export$b008e842a2213343() {
    var _a = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = $6f4a9ed0ffbde9dd$var$getWeekdays(locale, weekStartsOn, ISOWeek);
    return (0, $ayMG0.jsxs)("tr", {
        style: styles.head_row,
        className: classNames.head_row,
        children: [
            showWeekNumber && (0, $ayMG0.jsx)("td", {
                style: styles.head_cell,
                className: classNames.head_cell
            }),
            weekdays.map(function(weekday, i) {
                return (0, $ayMG0.jsx)("th", {
                    scope: "col",
                    className: classNames.head_cell,
                    style: styles.head_cell,
                    "aria-label": labelWeekday(weekday, {
                        locale: locale
                    }),
                    children: formatWeekdayName(weekday, {
                        locale: locale
                    })
                }, i);
            })
        ]
    });
}
/** Render the table head. */ function $6f4a9ed0ffbde9dd$export$e93312b7773dfcac() {
    var _a;
    var _b = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$b008e842a2213343;
    return (0, $ayMG0.jsx)("thead", {
        style: styles.head,
        className: classNames.head,
        children: (0, $ayMG0.jsx)(HeadRowComponent, {})
    });
}
/** Render the content of the day cell. */ function $6f4a9ed0ffbde9dd$export$16d0634337daf8ec(props) {
    var _a = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: formatDay(props.date, {
            locale: locale
        })
    });
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var $6f4a9ed0ffbde9dd$export$26e3e4d6f601d4d6 = (0, $acw62.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function $6f4a9ed0ffbde9dd$export$913827019032c8d4(props) {
    if (!$6f4a9ed0ffbde9dd$export$2d8c2b43ec0e528(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$26e3e4d6f601d4d6.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$91128e1c5ca64a0d, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $6f4a9ed0ffbde9dd$export$91128e1c5ca64a0d(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? $6f4a9ed0ffbde9dd$var$__spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, $hjw1k.default)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, $hjw1k.default)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$26e3e4d6f601d4d6.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $6f4a9ed0ffbde9dd$export$458361db477d8ed0() {
    var context = (0, $acw62.useContext)($6f4a9ed0ffbde9dd$export$26e3e4d6f601d4d6);
    if (!context) throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function $6f4a9ed0ffbde9dd$export$27ef550b4e6acc0c(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if ((0, $hjw1k.default)(to, day) && (0, $hjw1k.default)(from, day)) return undefined;
        if ((0, $hjw1k.default)(to, day)) return {
            from: to,
            to: undefined
        };
        if ((0, $hjw1k.default)(from, day)) return undefined;
        if ((0, $baBa1.default)(from, day)) return {
            from: day,
            to: to
        };
        return {
            from: from,
            to: day
        };
    }
    if (to) {
        if ((0, $baBa1.default)(day, to)) return {
            from: to,
            to: day
        };
        return {
            from: day,
            to: to
        };
    }
    if (from) {
        if ((0, $4YTY5.default)(day, from)) return {
            from: day,
            to: from
        };
        return {
            from: from,
            to: day
        };
    }
    return {
        from: day,
        to: undefined
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var $6f4a9ed0ffbde9dd$export$49c734aed8c840bb = (0, $acw62.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function $6f4a9ed0ffbde9dd$export$deb49a47c7ee5fdf(props) {
    if (!$6f4a9ed0ffbde9dd$export$f7b9f96866ec1964(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$49c734aed8c840bb.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$cca59e032fbbe71f, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $6f4a9ed0ffbde9dd$export$cca59e032fbbe71f(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var newRange = $6f4a9ed0ffbde9dd$export$27ef550b4e6acc0c(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, $hjw1k.default)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    } else if (selectedTo) {
        modifiers.range_start = [
            selectedTo
        ];
        modifiers.range_end = [
            selectedTo
        ];
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, $4irF8.default)(selectedFrom, min - 1),
            before: (0, $6OX6Q.default)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, $6OX6Q.default)(selectedFrom, min - 1)
        });
        if (!selectedFrom && selectedTo) modifiers.disabled.push({
            after: (0, $4irF8.default)(selectedTo, min - 1),
            before: (0, $6OX6Q.default)(selectedTo, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, $6OX6Q.default)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $6OX6Q.default)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, $lm2ga.default)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, $4irF8.default)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, $6OX6Q.default)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0, $6OX6Q.default)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $6OX6Q.default)(selectedTo, max - 1)
            });
        }
    }
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$49c734aed8c840bb.Provider, {
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        },
        children: children
    });
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $6f4a9ed0ffbde9dd$export$ad0998138eb321e7() {
    var context = (0, $acw62.useContext)($6f4a9ed0ffbde9dd$export$49c734aed8c840bb);
    if (!context) throw new Error("useSelectRange must be used within a SelectRangeProvider");
    return context;
}
/** Normalize to array a matcher input. */ function $6f4a9ed0ffbde9dd$var$matcherToArray(matcher) {
    if (Array.isArray(matcher)) return $6f4a9ed0ffbde9dd$var$__spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function $6f4a9ed0ffbde9dd$var$getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = $6f4a9ed0ffbde9dd$var$matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})($6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5 || ($6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5 = {}));
var $6f4a9ed0ffbde9dd$var$Selected = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.Selected, $6f4a9ed0ffbde9dd$var$Disabled = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.Disabled, $6f4a9ed0ffbde9dd$var$Hidden = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.Hidden, $6f4a9ed0ffbde9dd$var$Today = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.Today, $6f4a9ed0ffbde9dd$var$RangeEnd = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.RangeEnd, $6f4a9ed0ffbde9dd$var$RangeMiddle = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.RangeMiddle, $6f4a9ed0ffbde9dd$var$RangeStart = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.RangeStart, $6f4a9ed0ffbde9dd$var$Outside = $6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function $6f4a9ed0ffbde9dd$var$getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[$6f4a9ed0ffbde9dd$var$Selected] = $6f4a9ed0ffbde9dd$var$matcherToArray(dayPicker.selected), _a[$6f4a9ed0ffbde9dd$var$Disabled] = $6f4a9ed0ffbde9dd$var$matcherToArray(dayPicker.disabled), _a[$6f4a9ed0ffbde9dd$var$Hidden] = $6f4a9ed0ffbde9dd$var$matcherToArray(dayPicker.hidden), _a[$6f4a9ed0ffbde9dd$var$Today] = [
        dayPicker.today
    ], _a[$6f4a9ed0ffbde9dd$var$RangeEnd] = [], _a[$6f4a9ed0ffbde9dd$var$RangeMiddle] = [], _a[$6f4a9ed0ffbde9dd$var$RangeStart] = [], _a[$6f4a9ed0ffbde9dd$var$Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[$6f4a9ed0ffbde9dd$var$Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[$6f4a9ed0ffbde9dd$var$Disabled].push({
        after: dayPicker.toDate
    });
    if ($6f4a9ed0ffbde9dd$export$2d8c2b43ec0e528(dayPicker)) internalModifiers[$6f4a9ed0ffbde9dd$var$Disabled] = internalModifiers[$6f4a9ed0ffbde9dd$var$Disabled].concat(selectMultiple.modifiers[$6f4a9ed0ffbde9dd$var$Disabled]);
    else if ($6f4a9ed0ffbde9dd$export$f7b9f96866ec1964(dayPicker)) {
        internalModifiers[$6f4a9ed0ffbde9dd$var$Disabled] = internalModifiers[$6f4a9ed0ffbde9dd$var$Disabled].concat(selectRange.modifiers[$6f4a9ed0ffbde9dd$var$Disabled]);
        internalModifiers[$6f4a9ed0ffbde9dd$var$RangeStart] = selectRange.modifiers[$6f4a9ed0ffbde9dd$var$RangeStart];
        internalModifiers[$6f4a9ed0ffbde9dd$var$RangeMiddle] = selectRange.modifiers[$6f4a9ed0ffbde9dd$var$RangeMiddle];
        internalModifiers[$6f4a9ed0ffbde9dd$var$RangeEnd] = selectRange.modifiers[$6f4a9ed0ffbde9dd$var$RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var $6f4a9ed0ffbde9dd$var$ModifiersContext = (0, $acw62.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function $6f4a9ed0ffbde9dd$var$ModifiersProvider(props) {
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var selectMultiple = $6f4a9ed0ffbde9dd$export$458361db477d8ed0();
    var selectRange = $6f4a9ed0ffbde9dd$export$ad0998138eb321e7();
    var internalModifiers = $6f4a9ed0ffbde9dd$var$getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = $6f4a9ed0ffbde9dd$var$getCustomModifiers(dayPicker.modifiers);
    var modifiers = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, internalModifiers), customModifiers);
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$ModifiersContext.Provider, {
        value: modifiers,
        children: props.children
    });
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function $6f4a9ed0ffbde9dd$var$useModifiers() {
    var context = (0, $acw62.useContext)($6f4a9ed0ffbde9dd$var$ModifiersContext);
    if (!context) throw new Error("useModifiers must be used within a ModifiersProvider");
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function $6f4a9ed0ffbde9dd$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function $6f4a9ed0ffbde9dd$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function $6f4a9ed0ffbde9dd$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function $6f4a9ed0ffbde9dd$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function $6f4a9ed0ffbde9dd$export$483c833837970a3(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
/** Return `true` whether `date` is inside `range`. */ function $6f4a9ed0ffbde9dd$var$isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0, $lm2ga.default)(to, from) < 0;
        if (isRangeInverted) _a = [
            to,
            from
        ], from = _a[0], to = _a[1];
        var isInRange = (0, $lm2ga.default)(date, from) >= 0 && (0, $lm2ga.default)(to, date) >= 0;
        return isInRange;
    }
    if (to) return (0, $hjw1k.default)(to, date);
    if (from) return (0, $hjw1k.default)(from, date);
    return false;
}
/** Returns true if `value` is a Date type. */ function $6f4a9ed0ffbde9dd$var$isDateType(value) {
    return (0, $9BdaM.default)(value);
}
/** Returns true if `value` is an array of valid dates. */ function $6f4a9ed0ffbde9dd$var$isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, $9BdaM.default));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function $6f4a9ed0ffbde9dd$export$b74c33566721f70f(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === "boolean") return matcher;
        if ($6f4a9ed0ffbde9dd$var$isDateType(matcher)) return (0, $hjw1k.default)(day, matcher);
        if ($6f4a9ed0ffbde9dd$var$isArrayOfDates(matcher)) return matcher.includes(day);
        if ($6f4a9ed0ffbde9dd$export$dd455b9c98fea187(matcher)) return $6f4a9ed0ffbde9dd$var$isDateInRange(day, matcher);
        if ($6f4a9ed0ffbde9dd$export$483c833837970a3(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if ($6f4a9ed0ffbde9dd$export$654311eaff47f3cd(matcher)) {
            var diffBefore = (0, $lm2ga.default)(matcher.before, day);
            var diffAfter = (0, $lm2ga.default)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, $baBa1.default)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ($6f4a9ed0ffbde9dd$export$4760905e07020cd4(matcher)) return (0, $lm2ga.default)(day, matcher.after) > 0;
        if ($6f4a9ed0ffbde9dd$export$a3bef2c4e855ef4e(matcher)) return (0, $lm2ga.default)(matcher.before, day) > 0;
        if (typeof matcher === "function") return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function $6f4a9ed0ffbde9dd$var$getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if ($6f4a9ed0ffbde9dd$export$b74c33566721f70f(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, $b27pX.default)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function $6f4a9ed0ffbde9dd$var$getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, $5E40x.default)(displayMonths[0]);
    var lastDayInMonth = (0, $l2vHo.default)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = $6f4a9ed0ffbde9dd$var$getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, $6OX6Q.default)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, $6OX6Q.default)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var $6f4a9ed0ffbde9dd$var$MAX_RETRY = 365;
/** Return the next date to be focused. */ function $6f4a9ed0ffbde9dd$var$getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, $6OX6Q.default),
        week: (0, $2MTnF.default),
        month: (0, $eqWMS.default),
        year: (0, $kbDwl.default),
        startOfWeek: function(date) {
            return context.ISOWeek ? (0, $Ua0Sr.default)(date) : (0, $7yBDJ.default)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function(date) {
            return context.ISOWeek ? (0, $ce8cj.default)(date) : (0, $75XN4.default)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === "after" ? 1 : -1);
    if (direction === "before" && fromDate) newFocusedDay = (0, $6atcA.default)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === "after" && toDate) newFocusedDay = (0, $8v9st.default)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = $6f4a9ed0ffbde9dd$var$getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > $6f4a9ed0ffbde9dd$var$MAX_RETRY) return retry.lastFocused;
        return $6f4a9ed0ffbde9dd$var$getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var $6f4a9ed0ffbde9dd$export$e1f21ba6aeca320f = (0, $acw62.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function $6f4a9ed0ffbde9dd$export$97cf4ab9b312b61a(props) {
    var navigation = $6f4a9ed0ffbde9dd$export$d0fd4b7106de2769();
    var modifiers = $6f4a9ed0ffbde9dd$var$useModifiers();
    var _a = (0, $acw62.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, $acw62.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = $6f4a9ed0ffbde9dd$var$getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function(date) {
        setFocusedDay(date);
    };
    var context = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var moveFocus = function(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = $6f4a9ed0ffbde9dd$var$getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, $hjw1k.default)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function() {
            return moveFocus("day", "after");
        },
        focusDayBefore: function() {
            return moveFocus("day", "before");
        },
        focusWeekAfter: function() {
            return moveFocus("week", "after");
        },
        focusWeekBefore: function() {
            return moveFocus("week", "before");
        },
        focusMonthBefore: function() {
            return moveFocus("month", "before");
        },
        focusMonthAfter: function() {
            return moveFocus("month", "after");
        },
        focusYearBefore: function() {
            return moveFocus("year", "before");
        },
        focusYearAfter: function() {
            return moveFocus("year", "after");
        },
        focusStartOfWeek: function() {
            return moveFocus("startOfWeek", "before");
        },
        focusEndOfWeek: function() {
            return moveFocus("endOfWeek", "after");
        }
    };
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$e1f21ba6aeca320f.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $6f4a9ed0ffbde9dd$export$69130071837c676e() {
    var context = (0, $acw62.useContext)($6f4a9ed0ffbde9dd$export$e1f21ba6aeca320f);
    if (!context) throw new Error("useFocusContext must be used within a FocusProvider");
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function $6f4a9ed0ffbde9dd$export$174df9b23ec1eb4b(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = $6f4a9ed0ffbde9dd$var$useModifiers();
    var activeModifiers = $6f4a9ed0ffbde9dd$var$getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var $6f4a9ed0ffbde9dd$export$9632b0427d86eff3 = (0, $acw62.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function $6f4a9ed0ffbde9dd$export$d40a11a5bbe785ba(props) {
    if (!$6f4a9ed0ffbde9dd$export$e659ce9b264ea61(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$9632b0427d86eff3.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$37bf09040cff7c3b, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $6f4a9ed0ffbde9dd$export$37bf09040cff7c3b(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$9632b0427d86eff3.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $6f4a9ed0ffbde9dd$export$2d75d772c98e4b05() {
    var context = (0, $acw62.useContext)($6f4a9ed0ffbde9dd$export$9632b0427d86eff3);
    if (!context) throw new Error("useSelectSingle must be used within a SelectSingleProvider");
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function $6f4a9ed0ffbde9dd$var$useDayEventHandlers(date, activeModifiers) {
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var single = $6f4a9ed0ffbde9dd$export$2d75d772c98e4b05();
    var multiple = $6f4a9ed0ffbde9dd$export$458361db477d8ed0();
    var range = $6f4a9ed0ffbde9dd$export$ad0998138eb321e7();
    var _a = $6f4a9ed0ffbde9dd$export$69130071837c676e(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function(e) {
        var _a, _b, _c, _d;
        if ($6f4a9ed0ffbde9dd$export$e659ce9b264ea61(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if ($6f4a9ed0ffbde9dd$export$2d8c2b43ec0e528(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if ($6f4a9ed0ffbde9dd$export$f7b9f96866ec1964(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function(e) {
        var _a;
        switch(e.key){
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayAfter() : focusDayBefore();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayBefore() : focusDayAfter();
                break;
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case "PageUp":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case "PageDown":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case "Home":
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case "End":
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function $6f4a9ed0ffbde9dd$var$useSelectedDays() {
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var single = $6f4a9ed0ffbde9dd$export$2d75d772c98e4b05();
    var multiple = $6f4a9ed0ffbde9dd$export$458361db477d8ed0();
    var range = $6f4a9ed0ffbde9dd$export$ad0998138eb321e7();
    var selectedDays = $6f4a9ed0ffbde9dd$export$e659ce9b264ea61(dayPicker) ? single.selected : $6f4a9ed0ffbde9dd$export$2d8c2b43ec0e528(dayPicker) ? multiple.selected : $6f4a9ed0ffbde9dd$export$f7b9f96866ec1964(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function $6f4a9ed0ffbde9dd$var$isInternalModifier(modifier) {
    return Object.values($6f4a9ed0ffbde9dd$export$7652a4f8ecc53eb5).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function $6f4a9ed0ffbde9dd$var$getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if ($6f4a9ed0ffbde9dd$var$isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function $6f4a9ed0ffbde9dd$var$getDayStyle(dayPicker, activeModifiers) {
    var style = $6f4a9ed0ffbde9dd$var$__assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function $6f4a9ed0ffbde9dd$export$634dab6d85b953fc(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var focusContext = $6f4a9ed0ffbde9dd$export$69130071837c676e();
    var activeModifiers = $6f4a9ed0ffbde9dd$export$174df9b23ec1eb4b(day, displayMonth);
    var eventHandlers = $6f4a9ed0ffbde9dd$var$useDayEventHandlers(day, activeModifiers);
    var selectedDays = $6f4a9ed0ffbde9dd$var$useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== "default");
    // Focus the button if the day is focused according to the focus context
    (0, $acw62.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, $hjw1k.default)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = $6f4a9ed0ffbde9dd$var$getDayClassNames(dayPicker, activeModifiers).join(" ");
    var style = $6f4a9ed0ffbde9dd$var$getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : $6f4a9ed0ffbde9dd$export$16d0634337daf8ec;
    var children = (0, $ayMG0.jsx)(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: "gridcell"
    };
    var isFocusTarget = focusContext.focusTarget && (0, $hjw1k.default)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, $hjw1k.default)(focusContext.focusedDay, day);
    var buttonProps = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: "gridcell"
    }, _a["aria-selected"] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function $6f4a9ed0ffbde9dd$export$7a9a31a911eb9a20(props) {
    var buttonRef = (0, $acw62.useRef)(null);
    var dayRender = $6f4a9ed0ffbde9dd$export$634dab6d85b953fc(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return (0, $ayMG0.jsx)("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return (0, $ayMG0.jsx)("div", $6f4a9ed0ffbde9dd$var$__assign({}, dayRender.divProps));
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$353f5b6fc5456de1, $6f4a9ed0ffbde9dd$var$__assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function $6f4a9ed0ffbde9dd$export$f52f5e0fedb732da(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return (0, $ayMG0.jsx)("span", {
        className: classNames.weeknumber,
        style: styles.weeknumber,
        children: content
    });
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$353f5b6fc5456de1, {
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick,
        children: content
    });
}
/** Render a row in the calendar, with the days and the week number. */ function $6f4a9ed0ffbde9dd$export$b59bdbef9ce70de2(props) {
    var _a, _b;
    var _c = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$7a9a31a911eb9a20;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : $6f4a9ed0ffbde9dd$export$f52f5e0fedb732da;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = (0, $ayMG0.jsx)("td", {
        className: classNames.cell,
        style: styles.cell,
        children: (0, $ayMG0.jsx)(WeeknumberComponent, {
            number: props.weekNumber,
            dates: props.dates
        })
    });
    return (0, $ayMG0.jsxs)("tr", {
        className: classNames.row,
        style: styles.row,
        children: [
            weekNumberCell,
            props.dates.map(function(date) {
                return (0, $ayMG0.jsx)("td", {
                    className: classNames.cell,
                    style: styles.cell,
                    role: "presentation",
                    children: (0, $ayMG0.jsx)(DayComponent, {
                        displayMonth: props.displayMonth,
                        date: date
                    })
                }, (0, $hXFBz.default)(date));
            })
        ]
    });
}
/** Return the weeks between two dates.  */ function $6f4a9ed0ffbde9dd$var$daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $ce8cj.default)(toDate) : (0, $75XN4.default)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $Ua0Sr.default)(fromDate) : (0, $7yBDJ.default)(fromDate, options);
    var nOfDays = (0, $lm2ga.default)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, $6OX6Q.default)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $hbMru.default)(date) : (0, $dALCP.default)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function $6f4a9ed0ffbde9dd$var$getMonthWeeks(month, options) {
    var weeksInMonth = $6f4a9ed0ffbde9dd$var$daysToMonthWeeks((0, $5E40x.default)(month), (0, $l2vHo.default)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, $bRmIc.default)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, $2MTnF.default)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = $6f4a9ed0ffbde9dd$var$daysToMonthWeeks((0, $2MTnF.default)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function $6f4a9ed0ffbde9dd$var$Table(props) {
    var _a, _b, _c;
    var _d = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = $6f4a9ed0ffbde9dd$var$getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : $6f4a9ed0ffbde9dd$export$e93312b7773dfcac;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : $6f4a9ed0ffbde9dd$export$b59bdbef9ce70de2;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : $6f4a9ed0ffbde9dd$export$a06f1c675e846f6f;
    return (0, $ayMG0.jsxs)("table", {
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props["aria-labelledby"],
        children: [
            !hideHead && (0, $ayMG0.jsx)(HeadComponent, {}),
            (0, $ayMG0.jsx)("tbody", {
                className: classNames.tbody,
                style: styles.tbody,
                children: weeks.map(function(week) {
                    return (0, $ayMG0.jsx)(RowComponent, {
                        displayMonth: props.displayMonth,
                        dates: week.dates,
                        weekNumber: week.weekNumber
                    }, week.weekNumber);
                })
            }),
            (0, $ayMG0.jsx)(FooterComponent, {
                displayMonth: props.displayMonth
            })
        ]
    });
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /* eslint-disable prefer-const */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ function $6f4a9ed0ffbde9dd$var$canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $6f4a9ed0ffbde9dd$var$useIsomorphicLayoutEffect = $6f4a9ed0ffbde9dd$var$canUseDOM() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $6f4a9ed0ffbde9dd$var$serverHandoffComplete = false;
var $6f4a9ed0ffbde9dd$var$id = 0;
function $6f4a9ed0ffbde9dd$var$genId() {
    return "react-day-picker-".concat(++$6f4a9ed0ffbde9dd$var$id);
}
function $6f4a9ed0ffbde9dd$var$useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : $6f4a9ed0ffbde9dd$var$serverHandoffComplete ? $6f4a9ed0ffbde9dd$var$genId() : null;
    var _b = (0, $acw62.useState)(initialId), id = _b[0], setId = _b[1];
    $6f4a9ed0ffbde9dd$var$useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId($6f4a9ed0ffbde9dd$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(function() {
        if ($6f4a9ed0ffbde9dd$var$serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        $6f4a9ed0ffbde9dd$var$serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function $6f4a9ed0ffbde9dd$var$Month(props) {
    var _a;
    var _b;
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = $6f4a9ed0ffbde9dd$export$d0fd4b7106de2769().displayMonths;
    var captionId = $6f4a9ed0ffbde9dd$var$useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === "rtl") _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : $6f4a9ed0ffbde9dd$export$32fbfacc5d962e0c;
    return (0, $ayMG0.jsxs)("div", {
        className: className.join(" "),
        style: style,
        children: [
            (0, $ayMG0.jsx)(CaptionComponent, {
                id: captionId,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$Table, {
                id: tableId,
                "aria-labelledby": captionId,
                displayMonth: props.displayMonth
            })
        ]
    }, props.displayIndex);
}
/**
 * Render the wrapper for the month grids.
 */ function $6f4a9ed0ffbde9dd$export$a0ec4efdb90fa181(props) {
    var _a = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    return (0, $ayMG0.jsx)("div", {
        className: classNames.months,
        style: styles.months,
        children: props.children
    });
}
/** Render the container with the months according to the number of months to display. */ function $6f4a9ed0ffbde9dd$var$Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = $6f4a9ed0ffbde9dd$export$332e9e0d64b1f294();
    var focusContext = $6f4a9ed0ffbde9dd$export$69130071837c676e();
    var navigation = $6f4a9ed0ffbde9dd$export$d0fd4b7106de2769();
    var _d = (0, $acw62.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0, $acw62.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith("data-");
    }).reduce(function(attrs, key) {
        var _a;
        return $6f4a9ed0ffbde9dd$var$__assign($6f4a9ed0ffbde9dd$var$__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : $6f4a9ed0ffbde9dd$export$a0ec4efdb90fa181;
    return (0, $ayMG0.jsx)("div", $6f4a9ed0ffbde9dd$var$__assign({
        className: classNames.join(" "),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id,
        nonce: initialProps.nonce,
        title: initialProps.title,
        lang: initialProps.lang
    }, dataAttributes, {
        children: (0, $ayMG0.jsx)(MonthsComponent, {
            children: navigation.displayMonths.map(function(month, i) {
                return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$Month, {
                    displayIndex: i,
                    displayMonth: month
                }, i);
            })
        })
    }));
}
/** Provide the value for all the context providers. */ function $6f4a9ed0ffbde9dd$export$8f349d07558f59c4(props) {
    var children = props.children, initialProps = $6f4a9ed0ffbde9dd$var$__rest(props, [
        "children"
    ]);
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$a84f964d022d25c, {
        initialProps: initialProps,
        children: (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$d91daf425539f32f, {
            children: (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$d40a11a5bbe785ba, {
                initialProps: initialProps,
                children: (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$913827019032c8d4, {
                    initialProps: initialProps,
                    children: (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$deb49a47c7ee5fdf, {
                        initialProps: initialProps,
                        children: (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$ModifiersProvider, {
                            children: (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$97cf4ab9b312b61a, {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function $6f4a9ed0ffbde9dd$export$97e6db89a86ff7ab(props) {
    return (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$export$8f349d07558f59c4, $6f4a9ed0ffbde9dd$var$__assign({}, props, {
        children: (0, $ayMG0.jsx)($6f4a9ed0ffbde9dd$var$Root, {
            initialProps: props
        })
    }));
}
/** @private */ function $6f4a9ed0ffbde9dd$var$isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function $6f4a9ed0ffbde9dd$export$1e36b9f257eee5fa(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, $15nwl.default) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? "PP" : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = $6f4a9ed0ffbde9dd$var$parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function(value) {
        return (0, $auRgN.default)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, $acw62.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, $acw62.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, $6IhJz.default)(defaultSelected, format$1, {
        locale: locale
    }) : "";
    var _g = (0, $acw62.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : "");
    };
    var setSelected = function(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, $6IhJz.default)(date, format$1, {
            locale: locale
        }) : "");
    };
    var handleDayClick = function(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue("");
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, $6IhJz.default)(day, format$1, {
            locale: locale
        }) : "");
    };
    var handleMonthChange = function(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, $lm2ga.default)(fromDate, day) > 0;
        var isAfter = toDate && (0, $lm2ga.default)(day, toDate) > 0;
        if (!$6f4a9ed0ffbde9dd$var$isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function(e) {
        var day = parseValue(e.target.value);
        if (!$6f4a9ed0ffbde9dd$var$isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if ($6f4a9ed0ffbde9dd$var$isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, $6IhJz.default)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function $6f4a9ed0ffbde9dd$export$92cab9761365b1ec(props) {
    return props.mode === undefined || props.mode === "default";
}

});
parcelRegister("6IhJz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e349bc0dbb08c36$export$2e2bcd8739ae039);

var $cFZfS = parcelRequire("cFZfS");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $iDIba = parcelRequire("iDIba");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");

var $d7Pru = parcelRequire("d7Pru");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4LmDH.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d7Pru.default);
    var firstWeekContainsDate = (0, $esGEx.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $esGEx.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $gdr0J.default)(dirtyDate);
    if (!(0, $cFZfS.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9vfYB.default)(originalDate);
    var utcDate = (0, $8NlMJ.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $iDIba.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ebrmh.isProtectedWeekYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ebrmh.isProtectedDayOfYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("cFZfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a8d45f3f5c7cb9$export$2e2bcd8739ae039);

var $9BdaM = parcelRequire("9BdaM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    if (!(0, $9BdaM.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $gdr0J.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("9BdaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $4LmDH = parcelRequire("4LmDH");
function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $4LmDH.default)(1, arguments);
    return value instanceof Date || (0, $fSwVM.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});
parcelRegister("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("gdr0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $fSwVM.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("8NlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6673cc5b62dfa592$export$2e2bcd8739ae039);

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, -amount);
}

});
parcelRegister("8eaBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd7da45fede2458$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var timestamp = (0, $gdr0J.default)(dirtyDate).getTime();
    var amount = (0, $esGEx.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("esGEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a874c42e2166676d$export$2e2bcd8739ae039);
function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("iDIba", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91e238bf521c720$export$2e2bcd8739ae039);

var $iT1Z6 = parcelRequire("iT1Z6");

var $jsJZZ = parcelRequire("jsJZZ");

var $7sdBg = parcelRequire("7sdBg");

var $gTlfB = parcelRequire("gTlfB");

var $kB1VM = parcelRequire("kB1VM");

var $bGZx9 = parcelRequire("bGZx9");

var $cbpKX = parcelRequire("cbpKX");
var $d91e238bf521c720$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $cbpKX.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $kB1VM.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $bGZx9.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $bGZx9.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $7sdBg.default)(date);
        // Padding
        return (0, $bGZx9.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $bGZx9.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $cbpKX.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $bGZx9.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $gTlfB.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $bGZx9.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $jsJZZ.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $bGZx9.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $cbpKX.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iT1Z6.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $bGZx9.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $bGZx9.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $bGZx9.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $bGZx9.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $cbpKX.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $cbpKX.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $cbpKX.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $cbpKX.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $cbpKX.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $bGZx9.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $bGZx9.default)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $bGZx9.default)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $bGZx9.default)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $bGZx9.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $bGZx9.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;

});
parcelRegister("iT1Z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbfee7256f9ba04c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("jsJZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2b4503c694c959a$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $bY8nB = parcelRequire("bY8nB");

var $6KmMb = parcelRequire("6KmMb");

var $4LmDH = parcelRequire("4LmDH");
var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $bY8nB.default)(date).getTime() - (0, $6KmMb.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("bY8nB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6bcc549b1c1b29$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6KmMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e98b4d5a2488885$export$2e2bcd8739ae039);

var $7sdBg = parcelRequire("7sdBg");

var $bY8nB = parcelRequire("bY8nB");

var $4LmDH = parcelRequire("4LmDH");
function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $7sdBg.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $bY8nB.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("7sdBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d5b29bd1df6af4$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $bY8nB = parcelRequire("bY8nB");
function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $bY8nB.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $bY8nB.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gTlfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c2445bc457b574$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $1cqVL = parcelRequire("1cqVL");

var $7Pzkw = parcelRequire("7Pzkw");

var $4LmDH = parcelRequire("4LmDH");
var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $1cqVL.default)(date, options).getTime() - (0, $7Pzkw.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("1cqVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfbcd4e04a34858$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("2GvpZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $1f47e002602f8387$export$430a3269e24b912e);
var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}

});


parcelRegister("7Pzkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b38b39a484f4993$export$2e2bcd8739ae039);

var $kB1VM = parcelRequire("kB1VM");

var $4LmDH = parcelRequire("4LmDH");

var $1cqVL = parcelRequire("1cqVL");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $kB1VM.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $1cqVL.default)(firstWeek, options);
    return date;
}

});
parcelRegister("kB1VM", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe8c2ce4ac4bd36$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $1cqVL = parcelRequire("1cqVL");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1cqVL.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1cqVL.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bGZx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $88335940ad51fc8f$export$2e2bcd8739ae039);
function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("cbpKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dea7dd01f0b97c2$export$2e2bcd8739ae039);

var $bGZx9 = parcelRequire("bGZx9");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $bGZx9.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $bGZx9.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $bGZx9.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $bGZx9.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $bGZx9.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $bGZx9.default)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;

});


parcelRegister("6MGGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f085685fa15e740$export$2e2bcd8739ae039);
var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;

});

parcelRegister("9vfYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb366e006a8b659$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("ebrmh", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $a5375092e28b891e$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $a5375092e28b891e$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $a5375092e28b891e$export$8073c1ae88f0e727);
var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("d7Pru", function(module, exports) {

$parcel$export(module.exports, "default", () => $98e3d5324cb7d94c$export$2e2bcd8739ae039);

var $15nwl = parcelRequire("15nwl");
var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $15nwl.default);

});
parcelRegister("15nwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca880ce53ce49f9$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $fW24Y = parcelRequire("fW24Y");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: "en-US",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $fW24Y.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;

});
parcelRegister("2qFQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4e78b8ee7f66d8$export$2e2bcd8739ae039);
var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;

});

parcelRegister("fW24Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99de2b03d4f39be$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $b99de2b03d4f39be$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;

});
parcelRegister("uq3Ff", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b7040d79e43f9d$export$2e2bcd8739ae039);
function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("1uXR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $117705cf2af2348d$export$2e2bcd8739ae039);
var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;

});

parcelRegister("cPhtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9567ced935a3b497$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9567ced935a3b497$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;

});
parcelRegister("kp3bq", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda89c8f88184c82$export$2e2bcd8739ae039);
function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("2SJ52", function(module, exports) {

$parcel$export(module.exports, "default", () => $219397ebd8b56b11$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;

});
parcelRegister("gKbFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c309fdccb9ef673a$export$2e2bcd8739ae039);
function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("7pOAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $56621c36efca199b$export$2e2bcd8739ae039);
function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("5E40x", function(module, exports) {

$parcel$export(module.exports, "default", () => $41c3cc0836893904$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("l2vHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5125f9e9edab43e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("cJfMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9445ecc5e7cfb647$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("R4xmB", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f87854553a6255$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $09f87854553a6255$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("cZ2kT", function(module, exports) {

$parcel$export(module.exports, "default", () => $973cfe686ae8d1d7$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $cPszP = parcelRequire("cPszP");

var $4LmDH = parcelRequire("4LmDH");
function $973cfe686ae8d1d7$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = (0, $esGEx.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $cPszP.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("cPszP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95706a37c0d7d1b0$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $95706a37c0d7d1b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("3lKFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2707890d0f47c3ba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2707890d0f47c3ba$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = (0, $esGEx.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("6eIgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a662f07bb27222$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var cleanDate = (0, $gdr0J.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("1Whvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1698c992e2cb67cc$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $1698c992e2cb67cc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eqWMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8211859f65764ad$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("b27pX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8085a298e92e1718$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8085a298e92e1718$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("4YTY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a082e1cb0a32433$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $3a082e1cb0a32433$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("Ua0Sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8cff7ae633de9e$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $4LmDH = parcelRequire("4LmDH");
function $0a8cff7ae633de9e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $7yBDJ.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("7yBDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5808e7e2a5fbbc4c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");
function $5808e7e2a5fbbc4c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("6OX6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f754377033842c6$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("hjw1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ad0c9b51445ea3$export$2e2bcd8739ae039);

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfDay = (0, $cJfMa.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $cJfMa.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("baBa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $821d7431eba4c146$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $821d7431eba4c146$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("4irF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $320e4d083cefb0bc$export$2e2bcd8739ae039);

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $320e4d083cefb0bc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $6OX6Q.default)(dirtyDate, -amount);
}

});

parcelRegister("lm2ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8bd67cac91ee19b$export$2e2bcd8739ae039);

var $9vfYB = parcelRequire("9vfYB");

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var startOfDayLeft = (0, $cJfMa.default)(dirtyDateLeft);
    var startOfDayRight = (0, $cJfMa.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9vfYB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9vfYB.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}

});

parcelRegister("2MTnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $207b05f27970aaba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");
function $207b05f27970aaba$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $6OX6Q.default)(dirtyDate, days);
}

});

parcelRegister("kbDwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb237db400049a40$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $eqWMS.default)(dirtyDate, amount * 12);
}

});

parcelRegister("ce8cj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6d26b6bb7d94cd$export$2e2bcd8739ae039);

var $75XN4 = parcelRequire("75XN4");

var $4LmDH = parcelRequire("4LmDH");
function $8e6d26b6bb7d94cd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $75XN4.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("75XN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a761315a8e3e9c$export$2e2bcd8739ae039);

var $2GvpZ = parcelRequire("2GvpZ");

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $52a761315a8e3e9c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});


parcelRegister("6atcA", function(module, exports) {

$parcel$export(module.exports, "default", () => $47da542d3f4cabcc$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $47da542d3f4cabcc$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $fSwVM.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("8v9st", function(module, exports) {

$parcel$export(module.exports, "default", () => $63088e2bf3abfc06$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $63088e2bf3abfc06$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $fSwVM.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("hXFBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d138384211821eb8$export$2e2bcd8739ae039);

var $2SwgK = parcelRequire("2SwgK");

var $4LmDH = parcelRequire("4LmDH");
function $d138384211821eb8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return Math.floor((0, $2SwgK.default)(dirtyDate) / 1000);
}

});
parcelRegister("2SwgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2189a7e545f8ece8$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2189a7e545f8ece8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});


parcelRegister("hbMru", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8390a6465ec9630$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $2HjQQ = parcelRequire("2HjQQ");

var $4LmDH = parcelRequire("4LmDH");
var $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK = 604800000;
function $c8390a6465ec9630$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $Ua0Sr.default)(date).getTime() - (0, $2HjQQ.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("2HjQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6eff01db4e8676$export$2e2bcd8739ae039);

var $i0SQV = parcelRequire("i0SQV");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $1f6eff01db4e8676$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $i0SQV.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $Ua0Sr.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("i0SQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d2c6aef0e5f696$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $d1d2c6aef0e5f696$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("dALCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e53948deed625c0$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $egLKR = parcelRequire("egLKR");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
var $9e53948deed625c0$var$MILLISECONDS_IN_WEEK = 604800000;
function $9e53948deed625c0$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $7yBDJ.default)(date, options).getTime() - (0, $egLKR.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $9e53948deed625c0$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("egLKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6379a6e1c52ffad$export$2e2bcd8739ae039);

var $9SdoK = parcelRequire("9SdoK");

var $7yBDJ = parcelRequire("7yBDJ");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");
function $a6379a6e1c52ffad$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $9SdoK.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $7yBDJ.default)(firstWeek, options);
    return date;
}

});
parcelRegister("9SdoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $73038cccee83d214$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");
function $73038cccee83d214$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $7yBDJ.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $7yBDJ.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bRmIc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a264309c22e9a4e$export$2e2bcd8739ae039);

var $e4h6L = parcelRequire("e4h6L");

var $daBVs = parcelRequire("daBVs");

var $5E40x = parcelRequire("5E40x");

var $4LmDH = parcelRequire("4LmDH");
function $8a264309c22e9a4e$export$2e2bcd8739ae039(date, options) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $e4h6L.default)((0, $daBVs.default)(date), (0, $5E40x.default)(date), options) + 1;
}

});
parcelRegister("e4h6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3deb5b5de15b12f$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $9vfYB = parcelRequire("9vfYB");

var $4LmDH = parcelRequire("4LmDH");
var $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK = 604800000;
function $a3deb5b5de15b12f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var startOfWeekLeft = (0, $7yBDJ.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $7yBDJ.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $9vfYB.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $9vfYB.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK);
}

});

parcelRegister("daBVs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9969a0ca794c6fe7$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9969a0ca794c6fe7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("auRgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a460707bf147158$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $6Z0ky = parcelRequire("6Z0ky");

var $d7Pru = parcelRequire("d7Pru");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $6yoAC = parcelRequire("6yoAC");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $d6B4A = parcelRequire("d6B4A");

var $gznWl = parcelRequire("gznWl");

var $2GvpZ = parcelRequire("2GvpZ");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7a460707bf147158$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7a460707bf147158$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7a460707bf147158$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7a460707bf147158$var$doubleQuoteRegExp = /''/g;
var $7a460707bf147158$var$notWhitespaceRegExp = /\S/;
var $7a460707bf147158$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7a460707bf147158$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4LmDH.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d7Pru.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $esGEx.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $esGEx.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $gdr0J.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $d6B4A.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($7a460707bf147158$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $6MGGE.default)) {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($7a460707bf147158$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $6Z0ky.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ebrmh.isProtectedWeekYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ebrmh.isProtectedDayOfYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $gznWl.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($7a460707bf147158$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $7a460707bf147158$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $fSwVM.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $7a460707bf147158$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $gdr0J.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $8NlMJ.default)(date, (0, $9vfYB.default)(date));
    var flags = {};
    var _iterator2 = (0, $6Z0ky.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6yoAC.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $7a460707bf147158$var$cleanEscapedString(input) {
    return input.match($7a460707bf147158$var$escapedStringRegExp)[1].replace($7a460707bf147158$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("6Z0ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $5158b23d1f990d5e$export$2e2bcd8739ae039);

var $abLc2 = parcelRequire("abLc2");
function $5158b23d1f990d5e$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $abLc2.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});

parcelRegister("6yoAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c58fe0eb0761e95$export$2e2bcd8739ae039);
function $4c58fe0eb0761e95$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("d6B4A", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $98a897cde0f0abfd$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee);

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");
var $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY = 10;
var $98a897cde0f0abfd$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $6CZeq.default)(this, Setter);
        (0, $kSlfw.default)(this, "priority", void 0);
        (0, $kSlfw.default)(this, "subPriority", 0);
    }
    (0, $cHPF9.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $98a897cde0f0abfd$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $1gYAD.default)(ValueSetter, _Setter);
    var _super = (0, $enfmq.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $6CZeq.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $cHPF9.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);
var $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $1gYAD.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $enfmq.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $6CZeq.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this2), "priority", $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $cHPF9.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);

});
parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $VFVve.default)(t, e);
}

});

parcelRegister("enfmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76f20fb39fa9d46$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $fhGLX = parcelRequire("fhGLX");

var $9715X = parcelRequire("9715X");
function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $fhGLX.default)();
    return function() {
        var e, o = (0, $jDKKo.default)(t);
        if (r) {
            var s = (0, $jDKKo.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $9715X.default)(this, e);
    };
}

});
parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $fSwVM.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(t);
}

});


parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("gznWl", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $c1027c3b7f83f29d$export$19131010e7fd8373);

var $75WXJ = parcelRequire("75WXJ");

var $a8eKR = parcelRequire("a8eKR");

var $fj1li = parcelRequire("fj1li");

var $44HZq = parcelRequire("44HZq");

var $fwa91 = parcelRequire("fwa91");

var $dt2Qm = parcelRequire("dt2Qm");

var $dOVGV = parcelRequire("dOVGV");

var $7o7jr = parcelRequire("7o7jr");

var $8dk1W = parcelRequire("8dk1W");

var $hW0pX = parcelRequire("hW0pX");

var $anGh5 = parcelRequire("anGh5");

var $cjr07 = parcelRequire("cjr07");

var $mnuhN = parcelRequire("mnuhN");

var $gqUjS = parcelRequire("gqUjS");

var $eglEX = parcelRequire("eglEX");

var $7jfsL = parcelRequire("7jfsL");

var $7ANJo = parcelRequire("7ANJo");

var $bUyT3 = parcelRequire("bUyT3");

var $jYJCf = parcelRequire("jYJCf");

var $7q5qq = parcelRequire("7q5qq");

var $2ashg = parcelRequire("2ashg");

var $fGBwT = parcelRequire("fGBwT");

var $1ZCjh = parcelRequire("1ZCjh");

var $8I45K = parcelRequire("8I45K");

var $ajDAU = parcelRequire("ajDAU");

var $9fJ56 = parcelRequire("9fJ56");

var $1If4X = parcelRequire("1If4X");

var $cAns0 = parcelRequire("cAns0");

var $kuK4G = parcelRequire("kuK4G");

var $jhVfr = parcelRequire("jhVfr");

var $gDlDV = parcelRequire("gDlDV");
var $c1027c3b7f83f29d$export$19131010e7fd8373 = {
    G: new (0, $75WXJ.EraParser)(),
    y: new (0, $a8eKR.YearParser)(),
    Y: new (0, $fj1li.LocalWeekYearParser)(),
    R: new (0, $44HZq.ISOWeekYearParser)(),
    u: new (0, $fwa91.ExtendedYearParser)(),
    Q: new (0, $dt2Qm.QuarterParser)(),
    q: new (0, $dOVGV.StandAloneQuarterParser)(),
    M: new (0, $7o7jr.MonthParser)(),
    L: new (0, $8dk1W.StandAloneMonthParser)(),
    w: new (0, $hW0pX.LocalWeekParser)(),
    I: new (0, $anGh5.ISOWeekParser)(),
    d: new (0, $cjr07.DateParser)(),
    D: new (0, $mnuhN.DayOfYearParser)(),
    E: new (0, $gqUjS.DayParser)(),
    e: new (0, $eglEX.LocalDayParser)(),
    c: new (0, $7jfsL.StandAloneLocalDayParser)(),
    i: new (0, $7ANJo.ISODayParser)(),
    a: new (0, $bUyT3.AMPMParser)(),
    b: new (0, $jYJCf.AMPMMidnightParser)(),
    B: new (0, $7q5qq.DayPeriodParser)(),
    h: new (0, $2ashg.Hour1to12Parser)(),
    H: new (0, $fGBwT.Hour0to23Parser)(),
    K: new (0, $1ZCjh.Hour0To11Parser)(),
    k: new (0, $8I45K.Hour1To24Parser)(),
    m: new (0, $ajDAU.MinuteParser)(),
    s: new (0, $9fJ56.SecondParser)(),
    S: new (0, $1If4X.FractionOfSecondParser)(),
    X: new (0, $cAns0.ISOTimezoneWithZParser)(),
    x: new (0, $kuK4G.ISOTimezoneParser)(),
    t: new (0, $jhVfr.TimestampSecondsParser)(),
    T: new (0, $gDlDV.TimestampMillisecondsParser)()
};

});
parcelRegister("75WXJ", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $52a6bcb88b20d48f$export$8e5a1d3f85a9688);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");
var $52a6bcb88b20d48f$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(EraParser, _Parser);
    var _super = (0, $enfmq.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $6CZeq.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 140);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $dVUCv.Parser));

});
parcelRegister("dVUCv", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $a24c84ce3b2e818f$export$7acfa6ed01010e37);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");

var $d6B4A = parcelRequire("d6B4A");
var $a24c84ce3b2e818f$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $6CZeq.default)(this, Parser);
        (0, $kSlfw.default)(this, "incompatibleTokens", void 0);
        (0, $kSlfw.default)(this, "priority", void 0);
        (0, $kSlfw.default)(this, "subPriority", void 0);
    }
    (0, $cHPF9.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $d6B4A.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("a8eKR", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $760618bd8dde9a2e$export$48d352de7cd4a988);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $760618bd8dde9a2e$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(YearParser, _Parser);
    var _super = (0, $enfmq.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $6CZeq.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $XhBEN.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $dVUCv.Parser));

});
parcelRegister("XhBEN", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $0b232b0fb2037abb$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $0b232b0fb2037abb$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $0b232b0fb2037abb$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $0b232b0fb2037abb$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $0b232b0fb2037abb$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $0b232b0fb2037abb$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $0b232b0fb2037abb$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $0b232b0fb2037abb$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $0b232b0fb2037abb$export$3d50627710b84d75);

var $6Q3SV = parcelRequire("6Q3SV");

var $629aZ = parcelRequire("629aZ");
function $0b232b0fb2037abb$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute) + seconds * (0, $6Q3SV.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$d931c43c4608a164(dateString) {
    return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).anyDigitsSigned, dateString);
}
function $0b232b0fb2037abb$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).singleDigit, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).twoDigits, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).threeDigits, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).fourDigits, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $0b232b0fb2037abb$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $0b232b0fb2037abb$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $0b232b0fb2037abb$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $0b232b0fb2037abb$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("6Q3SV", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", () => $4faa9cd956e257dc$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $4faa9cd956e257dc$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $4faa9cd956e257dc$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4faa9cd956e257dc$export$dfd9b671c89acc8e = 7;
var $4faa9cd956e257dc$export$3913210603d8e9ae = 365.2425;
var $4faa9cd956e257dc$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4faa9cd956e257dc$export$91246f0b9bd9beff = 60000;
var $4faa9cd956e257dc$export$7f72910d6dfd237a = 3600000;
var $4faa9cd956e257dc$export$397c2d5776aa9055 = 1000;
var $4faa9cd956e257dc$export$4dec998e48f9c246 = -$4faa9cd956e257dc$export$81caae6e1cc7a622;
var $4faa9cd956e257dc$export$f2f5ae5a8e2d8f9f = 60;
var $4faa9cd956e257dc$export$3c58128db900d44e = 3;
var $4faa9cd956e257dc$export$80d7e435f744f319 = 12;
var $4faa9cd956e257dc$export$4db7641526e3241f = 4;
var $4faa9cd956e257dc$export$698aec755e92c695 = 3600;
var $4faa9cd956e257dc$export$a77c1a7ebebe2a5a = 60;
var $4faa9cd956e257dc$export$815a9362476d2fe3 = $4faa9cd956e257dc$export$698aec755e92c695 * 24;
var $4faa9cd956e257dc$export$34804a017b31e2fe = $4faa9cd956e257dc$export$815a9362476d2fe3 * 7;
var $4faa9cd956e257dc$export$7271e9e3478110d1 = $4faa9cd956e257dc$export$815a9362476d2fe3 * $4faa9cd956e257dc$export$3913210603d8e9ae;
var $4faa9cd956e257dc$export$8e6600bbdee7dabb = $4faa9cd956e257dc$export$7271e9e3478110d1 / 12;
var $4faa9cd956e257dc$export$be1dccf2de902d31 = $4faa9cd956e257dc$export$8e6600bbdee7dabb * 3;

});

parcelRegister("629aZ", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $464a0c2b40e7950e$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $464a0c2b40e7950e$export$a7ee192b982af9c1);
var $464a0c2b40e7950e$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $464a0c2b40e7950e$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("fj1li", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $b249abf1c76e715b$export$b8ef38dfcf05d5db);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $kB1VM = parcelRequire("kB1VM");

var $1cqVL = parcelRequire("1cqVL");
var $b249abf1c76e715b$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $enfmq.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $6CZeq.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $kB1VM.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $XhBEN.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $1cqVL.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $1cqVL.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("44HZq", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $2f79a8958a9b0819$export$951d1df011fde06f);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $bY8nB = parcelRequire("bY8nB");
var $2f79a8958a9b0819$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $enfmq.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $XhBEN.parseNDigitsSigned)(4, dateString);
                return (0, $XhBEN.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $bY8nB.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("fwa91", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ExtendedYearParser, _Parser);
    var _super = (0, $enfmq.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $6CZeq.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $XhBEN.parseNDigitsSigned)(4, dateString);
                return (0, $XhBEN.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("dt2Qm", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $9ce0307b40bcf431$export$5cb0f701186dde1d);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $9ce0307b40bcf431$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(QuarterParser, _Parser);
    var _super = (0, $enfmq.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $6CZeq.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 120);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $dVUCv.Parser));

});

parcelRegister("dOVGV", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $a0fcb22d028fbb12$export$300c0c2990e20e6d);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $a0fcb22d028fbb12$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $enfmq.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $6CZeq.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 120);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7o7jr", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $5610726e2a84c5bb$export$400dd8b40ef138a3);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $XhBEN = parcelRequire("XhBEN");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");
var $5610726e2a84c5bb$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(MonthParser, _Parser);
    var _super = (0, $enfmq.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $6CZeq.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 110);
        return _this;
    }
    (0, $cHPF9.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $dVUCv.Parser));

});

parcelRegister("8dk1W", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $5faf133932f8fa0d$export$1d7eaa53eaa5deba);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $5faf133932f8fa0d$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $enfmq.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $6CZeq.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 110);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $dVUCv.Parser));

});

parcelRegister("hW0pX", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $d0e82d5cf6f5412c$export$c4005ffc174e07c0);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");

var $aj6ZU = parcelRequire("aj6ZU");

var $1cqVL = parcelRequire("1cqVL");
var $d0e82d5cf6f5412c$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(LocalWeekParser, _Parser);
    var _super = (0, $enfmq.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $6CZeq.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 100);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $1cqVL.default)((0, $aj6ZU.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $dVUCv.Parser));

});
parcelRegister("aj6ZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $78111b508c05f859$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $gTlfB = parcelRequire("gTlfB");

var $4LmDH = parcelRequire("4LmDH");
function $78111b508c05f859$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var week = (0, $esGEx.default)(dirtyWeek);
    var diff = (0, $gTlfB.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("anGh5", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $01f34dcf5c011194$export$6fc8dbedd560a6af);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");

var $jIUvX = parcelRequire("jIUvX");

var $bY8nB = parcelRequire("bY8nB");
var $01f34dcf5c011194$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOWeekParser, _Parser);
    var _super = (0, $enfmq.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 100);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $bY8nB.default)((0, $jIUvX.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $dVUCv.Parser));

});
parcelRegister("jIUvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5bdf6fda1ca18fd$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $jsJZZ = parcelRequire("jsJZZ");

var $4LmDH = parcelRequire("4LmDH");
function $e5bdf6fda1ca18fd$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var isoWeek = (0, $esGEx.default)(dirtyISOWeek);
    var diff = (0, $jsJZZ.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("cjr07", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $8f6c3433250540ef$export$e8d4b28a20981dd2);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $XhBEN = parcelRequire("XhBEN");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");
var $8f6c3433250540ef$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f6c3433250540ef$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DateParser, _Parser);
    var _super = (0, $enfmq.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $6CZeq.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "subPriority", 1);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $XhBEN.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $dVUCv.Parser));

});

parcelRegister("mnuhN", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $0434465071b161c2$export$6cfe0d613455f615);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $0434465071b161c2$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DayOfYearParser, _Parser);
    var _super = (0, $enfmq.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $6CZeq.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "subpriority", 1);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $XhBEN.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("gqUjS", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $bf6ac2f87af55cf1$export$1b03c8b76262f7bd);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $hCHMu = parcelRequire("hCHMu");
var $bf6ac2f87af55cf1$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DayParser, _Parser);
    var _super = (0, $enfmq.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $6CZeq.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $dVUCv.Parser));

});
parcelRegister("hCHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd47f247bdfd58ed$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $cd47f247bdfd58ed$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(2, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = (0, $esGEx.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("eglEX", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $a6235c79c7d2d223$export$44d1c127ab42c480);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $hCHMu = parcelRequire("hCHMu");
var $a6235c79c7d2d223$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(LocalDayParser, _Parser);
    var _super = (0, $enfmq.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $6CZeq.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7jfsL", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $55264d63d00b69b4$export$e447a647caaaec1d);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $hCHMu = parcelRequire("hCHMu");
var $55264d63d00b69b4$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $enfmq.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $6CZeq.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7ANJo", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $587278c8279e961b$export$693fb1e525095b2a);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $ay6wS = parcelRequire("ay6wS");
var $587278c8279e961b$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISODayParser, _Parser);
    var _super = (0, $enfmq.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $6CZeq.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $ay6wS.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $dVUCv.Parser));

});
parcelRegister("ay6wS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae224ed93d5e7cb$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $7ae224ed93d5e7cb$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $4LmDH.default)(2, arguments);
    var day = (0, $esGEx.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("bUyT3", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $8abffc7926620950$export$8d1e08492351df91);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $8abffc7926620950$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(AMPMParser, _Parser);
    var _super = (0, $enfmq.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $6CZeq.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 80);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $dVUCv.Parser));

});

parcelRegister("jYJCf", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $e8b7014308632edf$export$73ca2bd0a17d273);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $e8b7014308632edf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $enfmq.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $6CZeq.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 80);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7q5qq", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $566f2b76640556a4$export$bb9212adf05373db);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $566f2b76640556a4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DayPeriodParser, _Parser);
    var _super = (0, $enfmq.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $6CZeq.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 80);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $dVUCv.Parser));

});

parcelRegister("2ashg", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $1942733da4af1ace$export$8a04050a727a1756);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $1942733da4af1ace$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour1to12Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("fGBwT", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour0to23Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("1ZCjh", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $1739347ee422fc25$export$cbbe855312f87d77);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $1739347ee422fc25$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour0To11Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("8I45K", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $65759b4c9622f058$export$6008046d2b34b6a5);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $65759b4c9622f058$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour1To24Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("ajDAU", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $782a6455ff67a7ae$export$2b52670d9e2be53);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $782a6455ff67a7ae$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(MinuteParser, _Parser);
    var _super = (0, $enfmq.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $6CZeq.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 60);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $dVUCv.Parser));

});

parcelRegister("9fJ56", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $6bc87bf726e3a9ef$export$94d46d540cf1366a);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $6bc87bf726e3a9ef$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(SecondParser, _Parser);
    var _super = (0, $enfmq.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $6CZeq.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 50);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $dVUCv.Parser));

});

parcelRegister("1If4X", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $13f598d9d9f39eef$export$b8e6f8b2d70893b1);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $13f598d9d9f39eef$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $enfmq.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $6CZeq.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 30);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $dVUCv.Parser));

});

parcelRegister("cAns0", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $929b09a4780dfe0c$export$104d901d49fea29b);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $929b09a4780dfe0c$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $enfmq.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 10);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $dVUCv.Parser));

});

parcelRegister("kuK4G", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $eeba5969587208af$export$12910e5204b52b9);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $eeba5969587208af$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $enfmq.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 10);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $dVUCv.Parser));

});

parcelRegister("jhVfr", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $e0ac031eec4beddf$export$2cd8bf877a05e96);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $e0ac031eec4beddf$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $enfmq.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $6CZeq.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 40);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $cHPF9.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $XhBEN.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $dVUCv.Parser));

});

parcelRegister("gDlDV", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $c1c113b2a9b78e15$export$6d8f69c6906d6368);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $c1c113b2a9b78e15$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $enfmq.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $6CZeq.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 20);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $cHPF9.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $XhBEN.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $dVUCv.Parser));

});




parcelRegister("4PtY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $38432c00ae053a33$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $38432c00ae053a33$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 18H4V8h16z"
}), "CalendarToday");

});

parcelRegister("6kPMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ccc6ea6bc4b0e2$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $49ccc6ea6bc4b0e2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");

});

parcelRegister("cPxZ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_NUMBER_YEARS = void 0;
module.exports.MAX_NUMBER_YEARS = 10;

});

parcelRegister("cHOUY", function(module, exports) {
"use strict";
var $9400ff7050d38fb8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidDateRange = module.exports.isValidDate = module.exports.getDateRangeFromText = module.exports.getDateFromText = module.exports.getIcon = module.exports.formatWeekdayName = void 0;

const $9400ff7050d38fb8$var$react_1 = $9400ff7050d38fb8$var$__importDefault((parcelRequire("acw62")));

var $auRgN = parcelRequire("auRgN");
var $cFZfS = parcelRequire("cFZfS");
var $4YTY5 = parcelRequire("4YTY5");
// Format top day of the week text to one letter
const $9400ff7050d38fb8$var$formatWeekdayName = (weekNumber)=>weekNumber.toLocaleString("en-us", {
        weekday: "narrow"
    });
module.exports.formatWeekdayName = $9400ff7050d38fb8$var$formatWeekdayName;
// Builds the icon box for the input
const $9400ff7050d38fb8$var$getIcon = (icon, className, isEnabled, onClick)=>$9400ff7050d38fb8$var$react_1.default.createElement("div", {
        className: isEnabled ? className : undefined,
        onClick: isEnabled ? onClick : undefined
    }, icon);
module.exports.getIcon = $9400ff7050d38fb8$var$getIcon;
// Formats date string into a date object
const $9400ff7050d38fb8$var$getDateFromText = (dateText)=>(0, $auRgN.default)(dateText, "P", new Date());
module.exports.getDateFromText = $9400ff7050d38fb8$var$getDateFromText;
// Formats date range string ('<mm/dd/yy> - <mm/dd/yy>') into a DateRange
const $9400ff7050d38fb8$var$getDateRangeFromText = (dateRangeText)=>{
    const dateParts = dateRangeText === null || dateRangeText === void 0 ? void 0 : dateRangeText.split("-");
    return {
        from: (0, module.exports.getDateFromText)(dateParts[0].trim()),
        to: (0, module.exports.getDateFromText)(dateParts[1].trim())
    };
};
module.exports.getDateRangeFromText = $9400ff7050d38fb8$var$getDateRangeFromText;
// Returns 'true' if date (string) is valid (if date has value) to be parsed as date
const $9400ff7050d38fb8$var$isValidDate = (dateText)=>{
    let ret = true;
    if (dateText) {
        const date = (0, module.exports.getDateFromText)(dateText);
        ret = (0, $cFZfS.default)(date);
        ret = ret && date.getFullYear().toString().length === 4;
    }
    return ret;
};
module.exports.isValidDate = $9400ff7050d38fb8$var$isValidDate;
// Returns 'true' if date range ('<mm/dd/yy> - <mm/dd/yy>') is valid parseable DateRange
const $9400ff7050d38fb8$var$isValidDateRange = (dateRangeText)=>{
    let ret = !dateRangeText;
    const dateParts = dateRangeText === null || dateRangeText === void 0 ? void 0 : dateRangeText.split("-");
    // Check format
    if (dateRangeText && (dateParts === null || dateParts === void 0 ? void 0 : dateParts.length) === 2) {
        const from = dateParts[0].trim();
        const to = dateParts[1].trim();
        // Check if values are correct
        if (!!from === !!to) {
            ret = (0, module.exports.isValidDate)(from);
            ret = ret && (0, module.exports.isValidDate)(to);
            // Check if 'from' is before 'to'
            if (ret && from && to) ret = (0, $4YTY5.default)((0, module.exports.getDateFromText)(from), (0, module.exports.getDateFromText)(to));
        }
        if (from === to) ret = true;
    }
    return ret;
};
module.exports.isValidDateRange = $9400ff7050d38fb8$var$isValidDateRange;

});

parcelRegister("7la50", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $5582502fd9184ee0$var$useBaseStyles = (0, $1GFtd.default)({
    // Content container (paper) of popover
    popoverPaper: {
        borderRadius: 0,
        margin: "0.625em 0 0 -0.75em",
        padding: "0.575em 0.5em"
    },
    // icons (calendar and clear)
    icon: {
        display: "flex",
        cursor: "pointer",
        width: "2em"
    },
    // Main container
    pickerRoot: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        fontFamily: $i4KPV.FONT_FAMILY_ENUM.poppins,
        margin: "0.25em 0.25em 0 0.25em"
    },
    // Container for change year and month
    changeMonthYearContainer: {
        display: "flex",
        height: "2.25em"
    },
    // Label for change year and month
    changeMonthYearLabel: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        padding: "0.5em 0.5em 0 0.75em"
    },
    // Dropdown for change year and month
    changeMonthYearDropdown: {
        position: "relative",
        cursor: "pointer",
        "&:hover": {
            color: $i4KPV.COLORS_V2.PRIMARY_700
        }
    },
    // Label for day of week (top)
    dayOfWeek: {
        fontSize: $i4KPV.FONT.SIZE.SMALL,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        color: $i4KPV.COLORS_V2.NEUTRAL_DARK,
        height: "2.75em"
    },
    // Label for day of month (1-31)
    day: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        width: "3.63637em",
        height: "3.63637em",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_LIGHT,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK
        }
    },
    // Label for day + today
    dayToday: {
        border: `1px solid ${$i4KPV.COLORS_V2.PRIMARY_700}`,
        color: $i4KPV.COLORS_V2.PRIMARY_700
    },
    // Label for day + selected
    daySelected: {
        backgroundColor: $i4KPV.COLORS_V2.PRIMARY_700,
        color: $i4KPV.COLORS_V2.NEUTRAL_WHITE
    },
    // Label for day + disabled
    dayDisabled: {
        pointerEvents: "none",
        color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
    },
    dayRangeStart: {
        borderRadius: "100% 0 0 100%"
    },
    dayRangeMiddle: {
        color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        backgroundColor: $i4KPV.COLORS_V2.PRIMARY_50,
        borderRadius: 0
    },
    dayRangeEnd: {
        borderRadius: "0 100% 100% 0"
    }
});
module.exports.default = $5582502fd9184ee0$var$useBaseStyles;

});


parcelRegister("8xCb1", function(module, exports) {
"use strict";
var $637f04e981c6ef24$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $637f04e981c6ef24$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $637f04e981c6ef24$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $637f04e981c6ef24$var$__createBinding(result, mod, k);
    }
    $637f04e981c6ef24$var$__setModuleDefault(result, mod);
    return result;
};
var $637f04e981c6ef24$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $637f04e981c6ef24$var$react_1 = $637f04e981c6ef24$var$__importStar((parcelRequire("acw62")));

var $iAtns = parcelRequire("iAtns");
var $cFBau = parcelRequire("cFBau");

const $637f04e981c6ef24$var$Error_1 = $637f04e981c6ef24$var$__importDefault((parcelRequire("g3Qa3")));

const $637f04e981c6ef24$var$CircularProgress_1 = $637f04e981c6ef24$var$__importDefault((parcelRequire("1sBf1")));

var $cWFSm = parcelRequire("cWFSm");

const $637f04e981c6ef24$var$shared_components_krg_chip_1 = $637f04e981c6ef24$var$__importStar((parcelRequire("hIemg")));

const $637f04e981c6ef24$var$shared_components_krg_checkbox_1 = $637f04e981c6ef24$var$__importDefault((parcelRequire("akHLD")));

const $637f04e981c6ef24$var$base_style_1 = $637f04e981c6ef24$var$__importDefault((parcelRequire("1cg3Z")));

const $637f04e981c6ef24$var$style_v1_1 = $637f04e981c6ef24$var$__importDefault((parcelRequire("iz2Ch")));

const $637f04e981c6ef24$var$style_v2_1 = $637f04e981c6ef24$var$__importDefault((parcelRequire("5nRqh")));
const $637f04e981c6ef24$var$KrgAutocomplete = ({ id: id, className: className = "", label: label, limitTags: limitTags = -1, placeholder: placeholder, options: options = [], value: value, chipType: chipType = $637f04e981c6ef24$var$shared_components_krg_chip_1.TYPE_ENUM.primary, variant: variant = $cWFSm.INPUT_VARIANT_ENUM.outlined, debounceTime: debounceTime = 300, errorMessage: errorMessage, helperText: helperText, hasErrorIcon: hasErrorIcon, hasCheckbox: hasCheckbox = false, isMultiple: isMultiple = false, isLoading: isLoading = false, isEnabled: isEnabled = true, isFreeSolo: isFreeSolo = false, isClearedOnBlur: isClearedOnBlur = true, theme: theme = $cWFSm.THEME_ENUM.v1, getOptionLabel: getOptionLabel, getChipData: getChipData, filterOptions: filterOptions, isOptionEqualToValue: isOptionEqualToValue, renderOption: renderOption, onDebounceRestart: onDebounceRestart, onDebounceEnd: onDebounceEnd, onInputChange: onInputChange, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onClick: onClick })=>{
    const isV2Theme = theme === $cWFSm.THEME_ENUM.v2;
    const baseClasses = (0, $637f04e981c6ef24$var$base_style_1.default)();
    const classesV1 = (0, $637f04e981c6ef24$var$style_v1_1.default)();
    const classesV2 = (0, $637f04e981c6ef24$var$style_v2_1.default)();
    const classes = isV2Theme ? classesV2 : classesV1;
    const timer = (0, $637f04e981c6ef24$var$react_1.useRef)(null);
    const onTextValueChange = (e)=>{
        const textValue = e.target.value;
        onInputChange === null || onInputChange === void 0 || onInputChange(textValue);
        if (onDebounceEnd) handleDebounce(textValue);
    };
    const handleDebounce = (textValue)=>{
        if (timer && timer.current) clearTimeout(timer.current);
        onDebounceRestart === null || onDebounceRestart === void 0 || onDebounceRestart();
        timer.current = setTimeout(()=>{
            onDebounceEnd === null || onDebounceEnd === void 0 || onDebounceEnd(textValue);
        }, debounceTime);
    };
    const textInput = (params)=>{
        return $637f04e981c6ef24$var$react_1.default.createElement($iAtns.default, Object.assign({
            className: `${classes.textFieldRoot}` + ` ${errorMessage && isEnabled ? classes.textFieldError : ""}` + ` ${isEnabled ? classes.textFieldEnabled : ""}`
        }, params, {
            size: "small",
            variant: variant,
            label: label,
            helperText: errorMessage || helperText,
            error: !!errorMessage,
            placeholder: placeholder,
            InputProps: Object.assign(Object.assign({}, params.InputProps), {
                endAdornment: isLoading ? $637f04e981c6ef24$var$react_1.default.createElement($637f04e981c6ef24$var$CircularProgress_1.default, {
                    className: baseClasses.circularProgress,
                    size: 20
                }) : hasErrorIcon && errorMessage ? $637f04e981c6ef24$var$react_1.default.createElement($637f04e981c6ef24$var$Error_1.default, {
                    className: classes.errorIcon
                }) : params.InputProps.endAdornment
            }),
            onChange: onTextValueChange
        }));
    };
    const textFieldDisabledClass = isEnabled ? "" : `${baseClasses.textFieldDisabled} ${classes.textFieldDisabled}`;
    return $637f04e981c6ef24$var$react_1.default.createElement($cFBau.default, {
        id: id,
        className: `${textFieldDisabledClass} ${className}`,
        classes: {
            root: baseClasses.root,
            listbox: classes.listItem,
            loading: classes.listItem,
            noOptions: classes.listItem
        },
        limitTags: limitTags,
        disableCloseOnSelect: isMultiple,
        options: options,
        value: value,
        loading: isLoading,
        multiple: isMultiple,
        disabled: !isEnabled,
        freeSolo: isFreeSolo,
        clearOnBlur: isClearedOnBlur,
        renderTags: (tags, getTagProps)=>tags.map((option, index)=>$637f04e981c6ef24$var$react_1.default.createElement($637f04e981c6ef24$var$shared_components_krg_chip_1.default, Object.assign({
                    data: getChipData ? getChipData(option) : option,
                    type: chipType,
                    theme: theme,
                    isEnabled: !getTagProps({
                        index: index
                    }).disabled
                }, getTagProps({
                    index: index
                }), {
                    disabled: undefined
                }))),
        renderInput: textInput,
        renderOption: hasCheckbox ? (props, option, { selected: selected })=>$637f04e981c6ef24$var$react_1.default.createElement("li", Object.assign({}, props), $637f04e981c6ef24$var$react_1.default.createElement($637f04e981c6ef24$var$shared_components_krg_checkbox_1.default, {
                label: getOptionLabel ? getOptionLabel(option) : option,
                hasStopPropagation: false,
                isChecked: selected,
                theme: theme
            })) : renderOption ? (props, option, { selected: selected })=>renderOption(props, option, {
                selected: selected
            }) : undefined,
        getOptionLabel: getOptionLabel,
        filterOptions: filterOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        onChange: onChange,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    });
};
$637f04e981c6ef24$var$KrgAutocomplete.CHIP_TYPE_ENUM = $637f04e981c6ef24$var$shared_components_krg_chip_1.TYPE_ENUM;
$637f04e981c6ef24$var$KrgAutocomplete.VARIANT_ENUM = $cWFSm.INPUT_VARIANT_ENUM;
$637f04e981c6ef24$var$KrgAutocomplete.THEME_ENUM = $cWFSm.THEME_ENUM;
module.exports.default = $637f04e981c6ef24$var$KrgAutocomplete;

});
parcelRegister("cFBau", function(module, exports) {

$parcel$export(module.exports, "default", () => $9396253983985262$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $iuSDM = parcelRequire("iuSDM");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $33DpT = parcelRequire("33DpT");

var $e76iu = parcelRequire("e76iu");

var $7djgP = parcelRequire("7djgP");

var $7Frhn = parcelRequire("7Frhn");

var $9Lykx = parcelRequire("9Lykx");

var $6ami2 = parcelRequire("6ami2");

var $b3ugU = parcelRequire("b3ugU");

var $dmljZ = parcelRequire("dmljZ");

var $96QZi = parcelRequire("96QZi");

var $faAxf = parcelRequire("faAxf");

var $ldBGF = parcelRequire("ldBGF");

var $7LRfY = parcelRequire("7LRfY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $9O25J = parcelRequire("9O25J");

var $jTnBY = parcelRequire("jTnBY");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $9396253983985262$var$_excluded2 = [
    "ref"
], $9396253983985262$var$_excluded3 = [
    "key"
], $9396253983985262$var$_excluded4 = [
    "key"
];
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9O25J.getAutocompleteUtilityClass), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $9O25J.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $9O25J.default).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $9O25J.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $9O25J.default).input}`]: styles.input
            },
            {
                [`& .${(0, $9O25J.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $9O25J.default).focused} .${(0, $9O25J.default).clearIndicator}`]: {
        visibility: "visible"
    },
    /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
        [`&:hover .${(0, $9O25J.default).clearIndicator}`]: {
            visibility: "visible"
        }
    },
    [`& .${(0, $9O25J.default).tag}`]: {
        margin: 3,
        maxWidth: "calc(100% - 6px)"
    },
    [`& .${(0, $9O25J.default).inputRoot}`]: {
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $9O25J.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $b3ugU.default).root}`]: {
        paddingBottom: 1,
        "& .MuiInput-input": {
            padding: "4px 4px 4px 0px"
        }
    },
    [`& .${(0, $b3ugU.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $b3ugU.default).input}`]: {
            padding: "2px 4px 3px 0"
        }
    },
    [`& .${(0, $96QZi.default).root}`]: {
        padding: 9,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $9O25J.default).input}`]: {
            padding: "7.5px 4px 7.5px 5px"
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $96QZi.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $9O25J.default).input}`]: {
            padding: "2.5px 4px 2.5px 8px"
        }
    },
    [`& .${(0, $faAxf.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $faAxf.default).input}`]: {
            padding: "7px 4px"
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $faAxf.default).input}`]: {
            padding: "2.5px 4px"
        }
    },
    [`& .${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $9O25J.default).input}`]: {
        flexGrow: 1,
        textOverflow: "ellipsis",
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: "100%"
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                [`& .${(0, $9O25J.default).tag}`]: {
                    margin: 2,
                    maxWidth: "calc(100% - 4px)"
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $9O25J.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $9O25J.default).inputRoot}`]: {
                    flexWrap: "wrap"
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate(0, -50%)"
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $8nd05.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: "rotate(180deg)"
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9O25J.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: "absolute"
                }
            }
        ]
    }));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $9O25J.default).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $9O25J.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $9O25J.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $9O25J.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $9O25J.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $7djgP.default), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $9O25J.default).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldBGF.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $7Frhn.default), PopperComponent: PopperComponent = (0, $e76iu.default), popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LRfY.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $9396253983985262$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $33DpT.default)((0, $8nd05.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $1En50.default)(_getListboxProps, $9396253983985262$var$_excluded2);
    const combinedListboxRef = (0, $9Rgf1.default)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $8nd05.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $8nd05.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $1En50.default)(_getCustomizedTagProp, $9396253983985262$var$_excluded3);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), (0, $8nd05.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $1En50.default)(props2, $9396253983985262$var$_excluded4);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", (0, $8nd05.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $8nd05.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    const renderAutocompletePopperChildren = (children)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, (0, $8nd05.default)({
            as: PopperComponent,
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            ownerState: ownerState,
            role: "presentation",
            anchorEl: anchorEl,
            open: popupOpen
        }, popperSlotProps, {
            className: (0, $9QePP.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePaper, (0, $8nd05.default)({
                ownerState: ownerState,
                as: PaperComponent
            }, paperSlotProps, {
                className: (0, $9QePP.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                children: children
            }))
        }));
    let autocompletePopper = null;
    if (groupedOptions.length > 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteListbox, (0, $8nd05.default)({
        as: ListboxComponent,
        className: classes.listbox,
        ownerState: ownerState
    }, otherListboxProps, ListboxProps, {
        ref: combinedListboxRef,
        children: groupedOptions.map((option, index)=>{
            if (groupBy) return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
            });
            return renderListOption(option, index);
        })
    })));
    else if (loading && groupedOptions.length === 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
        className: classes.loading,
        ownerState: ownerState,
        children: loadingText
    }));
    else if (groupedOptions.length === 0 && !freeSolo && !loading) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
        className: classes.noOptions,
        ownerState: ownerState,
        role: "presentation",
        onMouseDown: (event)=>{
            // Prevent input blur when interacting with the "no options" content
            event.preventDefault();
        },
        children: noOptionsText
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, (0, $8nd05.default)({
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $8nd05.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, (0, $8nd05.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, (0, $8nd05.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $8nd05.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? autocompletePopper : null
        ]
    });
});
$9396253983985262$var$Autocomplete.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */ autoHighlight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */ autoSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */ blurOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "mouse",
            "touch"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */ ChipProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */ clearIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */ clearOnBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */ clearOnEscape: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */ clearText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */ closeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        clearIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        popupIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */ defaultValue: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any, (props)=>{
        if (props.multiple && props.defaultValue !== undefined && !Array.isArray(props.defaultValue)) return new Error([
            "MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.",
            `However, ${props.defaultValue} was provided.`
        ].join("\n"));
        return null;
    }),
    /**
   * If `true`, the input can't be cleared.
   * @default false
   */ disableClearable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */ disableCloseOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */ disabledItemsFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */ disableListWrap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */ filterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */ filterSelectedOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */ forcePopupIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */ freeSolo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */ getLimitTagsText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */ getOptionDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */ getOptionKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */ getOptionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */ groupBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */ handleHomeEndKeys: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the highlight can move to the input.
   * @default false
   */ includeInputInList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The input value.
   */ inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */ isOptionEqualToValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */ limitTags: (0, $iuSDM.default),
    /**
   * The component used to render the listbox.
   * @default 'ul'
   */ ListboxComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Props applied to the Listbox element.
   */ ListboxProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */ loadingText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */ noOptionsText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */ onHighlightChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */ onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the popup will open on input focus.
   * @default false
   */ openOnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */ openText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Array of options.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    /**
   * The component used to render the body of the popup.
   * @default Paper
   */ PaperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The component used to position the popup.
   * @default Popper
   */ PopperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */ popupIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */ renderGroup: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */ renderOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */ renderTags: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */ selectOnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "small",
            "medium"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        clearIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        popupIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */ value: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any, (props)=>{
        if (props.multiple && props.value !== undefined && !Array.isArray(props.value)) return new Error([
            "MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.",
            `However, ${props.value} was provided.`
        ].join("\n"));
        return null;
    })
};
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;

});
parcelRegister("33DpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a03a376a300fc5$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $auC0X = parcelRequire("auC0X");
var $agZ85 = parcelRequire("agZ85");
var $9D07P = parcelRequire("9D07P");
var $13KXh = parcelRequire("13KXh");
var $hervl = parcelRequire("hervl");
"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $23a03a376a300fc5$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $auC0X.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") {
            {
                const erroneousReturn = optionLabel === undefined ? "undefined" : `${typeof optionLabel} (${optionLabel})`;
                console.error(`MUI: The \`getOptionLabel\` method of ${componentName} returned ${erroneousReturn} instead of a string for ${JSON.stringify(option)}.`);
            }
            return String(optionLabel);
        }
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $agZ85.default)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $agZ85.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $9D07P.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    if (value !== null && !freeSolo && options.length > 0) {
        const missingValue = (multiple ? value : [
            value
        ]).filter((value2)=>!options.some((option)=>isOptionEqualToValue(option, value2)));
        if (missingValue.length > 0) console.warn([
            `MUI: The value provided to ${componentName} is invalid.`,
            `None of the options match with \`${missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0])}\`.`,
            "You can use the `isOptionEqualToValue` prop to customize the equality test."
        ].join("\n"));
    }
    const focusTag = (0, $13KXh.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $13KXh.default)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $13KXh.default)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $23a03a376a300fc5$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $23a03a376a300fc5$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $23a03a376a300fc5$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $13KXh.default)((node)=>{
        (0, $hervl.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useEffect(()=>{
        if (!inputRef.current || inputRef.current.nodeName !== "INPUT") {
            if (inputRef.current && inputRef.current.nodeName === "TEXTAREA") console.warn([
                `A textarea element was provided to ${componentName} where input was expected.`,
                `This is not a supported scenario but it may work under certain conditions.`,
                `A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).`,
                `Make sure to test keyboard navigation and add custom event handlers if necessary.`
            ].join("\n"));
            else console.error([
                `MUI: Unable to find the input element. It was resolved to ${inputRef.current} while an HTMLInputElement was expected.`,
                `Instead, ${componentName} expects an input element.`,
                "",
                componentName === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."
            ].join("\n"));
        }
    }, [
        componentName
    ]);
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            {
                const matches = newValue.filter((val)=>isOptionEqualToValue(option, val));
                if (matches.length > 1) console.error([
                    `MUI: The \`isOptionEqualToValue\` method of ${componentName} does not handle the arguments correctly.`,
                    `The component expects a single value to match a given option but found ${matches.length} matches.`
                ].join("\n"));
            }
            const itemIndex = $23a03a376a300fc5$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else {
                if (indexBy.get(group) && !warn) {
                    console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${componentName} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`.");
                    warn = true;
                }
                indexBy.set(group, true);
                acc.push({
                    key: index,
                    index: index,
                    group: group,
                    options: [
                        option
                    ]
                });
            }
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $8nd05.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $8nd05.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;

});
parcelRegister("9D07P", function(module, exports) {

$parcel$export(module.exports, "default", () => $7027da6f4b17de9d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;

});


parcelRegister("7djgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5408b2039b9d572c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $ixwSf = parcelRequire("ixwSf");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5408b2039b9d572c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ixwSf.getListSubheaderUtilityClass), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $1En50.default)(props, $5408b2039b9d572c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
$5408b2039b9d572c$var$ListSubheader.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "default",
        "inherit",
        "primary"
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */ disableSticky: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the List Subheader is indented.
   * @default false
   */ inset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;

});
parcelRegister("ixwSf", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", () => $d7f4cf29715b69dd$export$6816d4fc0981ec7);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)("MuiListSubheader", slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;

});


parcelRegister("6ami2", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d4f79319086dc5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $8u0rE = parcelRequire("8u0rE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $gUzNi = parcelRequire("gUzNi");

var $jTnBY = parcelRequire("jTnBY");

var $6n0Ko = parcelRequire("6n0Ko");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $iNSYf = parcelRequire("iNSYf");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $47d4f79319086dc5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iNSYf.getChipUtilityClass), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $8nd05.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $iNSYf.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $iNSYf.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $iNSYf.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $iNSYf.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $iNSYf.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $iNSYf.default).icon}`]: (0, $8nd05.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $8nd05.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $iNSYf.default).deleteIcon}`]: (0, $8nd05.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $iNSYf.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $iNSYf.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $iNSYf.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $iNSYf.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $iNSYf.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $iNSYf.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $iNSYf.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $1En50.default)(props, $47d4f79319086dc5$var$_excluded);
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $6n0Ko.default) : ComponentProp || "div";
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $6n0Ko.default) ? (0, $8nd05.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8u0rE.default), {
        className: (0, $9QePP.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    if (avatar && icon) console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $9QePP.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
$47d4f79319086dc5$var$Chip.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The Avatar element to display.
   */ avatar: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: (0, $gUzNi.default),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */ clickable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "default",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */ deleteIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Icon element.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    /**
   * The content of the component.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */ onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */ skipFocusWhenDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The variant to use.
   * @default 'filled'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "filled",
            "outlined"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;

});
parcelRegister("8u0rE", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d1787512a69c15$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

});

parcelRegister("gUzNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4fda44a4aac44a5$export$2e2bcd8739ae039);

var $g76pT = parcelRequire("g76pT");
var $c4fda44a4aac44a5$export$2e2bcd8739ae039 = (0, $g76pT.default);

});
parcelRegister("g76pT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb247058ab0d5dc$export$2e2bcd8739ae039);
function $bbb247058ab0d5dc$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== "undefined") return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
    return null;
}

});


parcelRegister("iNSYf", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", () => $db0771a9e6a32b1d$export$31444911e4ee6fdd);
$parcel$export(module.exports, "default", () => $db0771a9e6a32b1d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)("MuiChip", slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;

});


parcelRegister("ldBGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7280bbf95507cba$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});

parcelRegister("9O25J", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", () => $723a67e53eb4dc4c$export$8ee01529667e66d9);
$parcel$export(module.exports, "default", () => $723a67e53eb4dc4c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)("MuiAutocomplete", slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;

});


parcelRegister("1sBf1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("2cPwN")).default);
$parcel$export(module.exports, "circularProgressClasses", () => (parcelRequire("fPJfA")).default);

var $2cPwN = parcelRequire("2cPwN");

var $fPJfA = parcelRequire("fPJfA");
"use client";
$parcel$exportWildcard(module.exports, $fPJfA);

});
parcelRegister("2cPwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b4ac261663afa8$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $fPJfA = parcelRequire("fPJfA");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $19b4ac261663afa8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $19b4ac261663afa8$var$_ = (t)=>t, $19b4ac261663afa8$var$_t, $19b4ac261663afa8$var$_t2, $19b4ac261663afa8$var$_t3, $19b4ac261663afa8$var$_t4;
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t || ($19b4ac261663afa8$var$_t = $19b4ac261663afa8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t2 || ($19b4ac261663afa8$var$_t2 = $19b4ac261663afa8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fPJfA.getCircularProgressUtilityClass), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $jjlaj.css)($19b4ac261663afa8$var$_t3 || ($19b4ac261663afa8$var$_t3 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $19b4ac261663afa8$var$circularRotateKeyframe));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $jjlaj.css)($19b4ac261663afa8$var$_t4 || ($19b4ac261663afa8$var$_t4 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $19b4ac261663afa8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $1En50.default)(props, $19b4ac261663afa8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
$19b4ac261663afa8$var$CircularProgress.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "inherit",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */ disableShrink: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool, (props)=>{
        if (props.disableShrink && props.variant && props.variant !== "indeterminate") return new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
        return null;
    }),
    /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The thickness of the circle.
   * @default 3.6
   */ thickness: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "determinate",
        "indeterminate"
    ])
};
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;

});
parcelRegister("fPJfA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getCircularProgressUtilityClass", () => $b86eb8364bb4993c$export$29cad1383b3f235d);
$parcel$export(module.exports, "default", () => $b86eb8364bb4993c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)("MuiCircularProgress", slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;

});



parcelRegister("cWFSm", function(module, exports) {
"use strict";
var $96cb627a2e8d1be5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $96cb627a2e8d1be5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $96cb627a2e8d1be5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("cfpuL")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("hW26l")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("dhx99")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("6ABSD")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("eHKvL")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("hhz0D")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("2sGFp")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("dS8b6")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("3FWhO")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("8TLkb")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("7ShW9")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("5MIn3")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("9dO7Y")), module.exports);

$96cb627a2e8d1be5$var$__exportStar((parcelRequire("9S6F7")), module.exports);

});
parcelRegister("cfpuL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_VIDEO_DURATION = module.exports.MAX_VIDEO_SIZE = module.exports.MAX_FILE_SIZE = module.exports.BACKGROUND_COLOR = module.exports.FONT = module.exports.DATA_UNIT_CONVERSION = module.exports.STORE_KEY_THEME = module.exports.STORE_KEY_FONT_FAMILY = module.exports.COLORS_V2_ALPHA = module.exports.COLORS_V2 = module.exports.COLORS = void 0;

var $hW26l = parcelRequire("hW26l");
module.exports.COLORS = {
    BLACK: "rgb(0, 0, 0)",
    BACKGROUND_DARK: "rgb(167, 179, 189)",
    BLACK_DISABLED: "rgb(145, 160, 173)",
    BLACK_HIGH_EMPHASIS: "rgb(48, 50, 55)",
    BLACK_INACTIVE: "rgb(209, 217, 222)",
    BLACK_MEDIUM_EMPHASIS: "rgb(63, 72, 83)",
    BLACK_SHADOW: "rgba(0, 0, 0, 0.25)",
    CREATIVE_TITLE: "rgb(47, 47, 47)",
    ERROR_DARK: "rgb(255, 48, 55)",
    ERROR_LIGHT: "rgb(255, 234, 235)",
    GRAY_10: "rgb(43, 49, 58)",
    GRAY_3: "rgb(222, 226, 230)",
    GRAY_CHIP_MEDIUM: "rgb(224, 224, 224)",
    GRAY_DARK: "rgb(101, 108, 117)",
    GRAY_DARK_2: "rgb(112, 112, 112)",
    GRAY_DARK_3: "rgb(139, 139, 139)",
    GRAY_DARK_4: "rgb(155, 155, 155)",
    GRAY_DARK_5: "rgb(66, 66, 66)",
    GRAY_DIVIDER: "rgb(167, 179, 189)",
    GRAY_LIGHT: "rgb(238, 240, 242)",
    GRAY_LIGHT_1: "rgb(223, 220, 220)",
    GRAY_LIGHT_2: "rgb(236, 236, 236)",
    GRAY_LIGHT_3: "rgb(196, 196, 196)",
    GRAY_LIGHT_4: "rgb(229, 229, 229)",
    GRAY_LIGHT_5: "rgb(199, 199, 199)",
    GRAY_LINK_INACTIVE: "rgb(128, 131, 137)",
    GRAY_PREVIEW_TEXT: "rgb(199, 207, 213)",
    GRAY_SPONSOR_TEXT: "rgb(142, 148, 160)",
    GRAY_BORDER: "rgb(167, 179, 189)",
    GREEN_LOADER: "rgb(0, 199, 177)",
    PREVIEW_HEADER_TEXT: "rgb(60, 60, 60)",
    PRIMARY_10: "rgb(219, 237, 251)",
    PRIMARY_100: "rgb(179, 233, 246)",
    PRIMARY_400: "rgb(51, 196, 232)",
    PRIMARY_50: "rgb(230, 248, 252)",
    PRIMARY_500_ACCENT: "rgb(0, 181, 226)",
    PRIMARY_900: "rgb(0, 79, 124)",
    PRIMARY_DARK_TEXT: "rgb(0, 72, 128)",
    SUCCESS_DARK: "rgb(0, 148, 126)",
    SUCCESS_LIGHT: "rgb(230, 249, 247)",
    SURFACE_SNACKBAR: "rgb(32, 32, 32)",
    WARNING_BASE: "rgb(255, 205, 0)",
    WARNING_DARK: "rgb(255, 174, 0)",
    WARNING_LIGHT: "rgb(255, 250, 230)",
    WHITE: "rgb(255, 255, 255)",
    WHITE_MEDIUM_EMPHASIS: "rgba(255, 255, 255, 0.7)",
    LOADER_BORDER: "rgb(0, 199, 177)",
    FACEBOOK_BANNER_DIVIDER: "rgb(197, 195, 195)",
    LOADER_LIGHT_BLUE: "rgb(79, 180, 221)",
    LOADER_GREEN: "rgb(88, 196, 178)",
    GRAY_HELPER: "rgb(129, 129, 129)"
};
module.exports.COLORS_V2 = {
    PRIMARY_50: "rgb(229, 235, 255)",
    PRIMARY_100: "rgb(204, 214, 255)",
    PRIMARY_200: "rgb(165, 183, 255)",
    PRIMARY_300: "rgb(123, 150, 255)",
    PRIMARY_400: "rgb(91, 124, 255)",
    PRIMARY_500: "rgb(60, 97, 243)",
    PRIMARY_600: "rgb(37, 80, 250)",
    PRIMARY_700: "rgb(0, 51, 255)",
    PRIMARY_800: "rgb(1, 33, 160)",
    PRIMARY_900: "rgb(8, 8, 48)",
    NEUTRAL_BLACK: "rgb(0, 0, 0)",
    NEUTRAL_DARK: "rgb(145, 160, 173)",
    NEUTRAL_INACTIVE: "rgb(209, 217, 222)",
    NEUTRAL_MEDIUM: "rgb(229, 234, 239)",
    NEUTRAL_LIGHT: "rgb(238, 243, 246)",
    NEUTRAL_WHITE: "rgb(255, 255, 255)",
    SUCCESS_DARK: "rgb(0, 148, 126)",
    SUCCESS_LIGHT: "rgb(0, 199, 177)",
    SUCCESS_LIGHTEST: "rgb(230, 246, 243)",
    WARNING_DARK: "rgb(255, 174, 0)",
    WARNING_LIGHT: "rgb(255, 205, 0)",
    WARNING_LIGHTEST: "rgb(255, 246, 212)",
    ERROR_DARK: "rgb(255, 48, 55)",
    ERROR_LIGHT: "rgb(255, 131, 135)",
    ERROR_LIGHTEST: "rgb(255, 234, 235)"
};
module.exports.COLORS_V2_ALPHA = {
    NEUTRAL_BLACK_SHADOW: module.exports.COLORS_V2.NEUTRAL_BLACK.replace(")", ", 0.25)"),
    NEUTRAL_BLACK_SCRIM: module.exports.COLORS_V2.NEUTRAL_BLACK.replace(")", ", 0.4)"),
    NEUTRAL_WHITE_FADE: module.exports.COLORS_V2.NEUTRAL_WHITE.replace(")", ", 0.54)")
};
module.exports.STORE_KEY_FONT_FAMILY = "demo_font_family";
module.exports.STORE_KEY_THEME = "demo_theme";
module.exports.DATA_UNIT_CONVERSION = 1024;
module.exports.FONT = {
    WEIGHT: {
        // Light
        THIN: 100,
        EXTRA_LIGHT: 200,
        LIGHT: 300,
        // Regular
        NORMAL: 400,
        MEDIUM: 500,
        // Bold
        SEMI_BOLD: 600,
        BOLD: 700,
        EXTRA_BOLD: 800
    },
    SIZE: {
        // Regular Text
        SMALL: "0.625em",
        REGULAR: "0.6875em",
        MEDIUM: "0.75em",
        SEMI_LARGE: "0.8125em",
        LARGE: "0.875em",
        EXTRA_LARGE: "1em",
        // Set default
        BASE: "16px",
        // Titles
        H2: "1.125em",
        H1: "2.25em"
    },
    FAMILY: {
        COLFAX: $hW26l.FONT_FAMILY_ENUM.colfax,
        POPPINS: $hW26l.FONT_FAMILY_ENUM.poppins,
        VERDANA: "Verdana, sans-serif",
        HELVETICA: "Helvetica, sans-serif"
    }
};
module.exports.BACKGROUND_COLOR = {
    [$hW26l.BACKGROUND_ENUM.black]: module.exports.COLORS_V2.NEUTRAL_BLACK,
    [$hW26l.BACKGROUND_ENUM.white]: module.exports.COLORS_V2.NEUTRAL_WHITE,
    [$hW26l.BACKGROUND_ENUM.blue]: module.exports.COLORS_V2.PRIMARY_700
};
module.exports.MAX_FILE_SIZE = 4;
module.exports.MAX_VIDEO_SIZE = 20;
module.exports.MAX_VIDEO_DURATION = 65;

});
parcelRegister("hW26l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEVICE_TYPE_ENUM = module.exports.FILE_TYPE_ENUM = module.exports.ADVANCED_CREATIVE_SIZES_ENUM = module.exports.BACKGROUND_ENUM = module.exports.DATA_UNIT_ENUM = module.exports.TARGET_ENUM = module.exports.CSS_POS_ENUM = module.exports.INPUT_VARIANT_ENUM = module.exports.PROJECT_ENUM = module.exports.FONT_FAMILY_ENUM = module.exports.THEME_ENUM = module.exports.CREATIVE_SOCIAL_TYPE_ENUM = module.exports.CREATIVE_DESTINATION_ENUM = module.exports.CREATIVE_FORMAT_IFRAME_ENUM = module.exports.CREATIVE_FORMAT_ENUM = module.exports.CREATIVE_EDITOR_ENUM = void 0;
var $d0e97bbb6b2cf9e5$var$CREATIVE_EDITOR_ENUM;
(function(CREATIVE_EDITOR_ENUM) {
    CREATIVE_EDITOR_ENUM["lite"] = "lite";
    CREATIVE_EDITOR_ENUM["advanced"] = "advanced";
})($d0e97bbb6b2cf9e5$var$CREATIVE_EDITOR_ENUM || (module.exports.CREATIVE_EDITOR_ENUM = $d0e97bbb6b2cf9e5$var$CREATIVE_EDITOR_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$CREATIVE_FORMAT_ENUM;
(function(CREATIVE_FORMAT_ENUM) {
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardBanner"] = 1] = "StandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["LogoEnhancedBanner"] = 2] = "LogoEnhancedBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["ScrollReactiveBanner"] = 3] = "ScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["AdhesiveBottomBanner"] = 4] = "AdhesiveBottomBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["AdhesiveSideBanner"] = 5] = "AdhesiveSideBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardVideo"] = 6] = "StandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["ScrollReactiveVideo"] = 7] = "ScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGStandardBanner"] = 8] = "IGStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGStandardVideo"] = 9] = "IGStandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGScrollReactiveBanner"] = 10] = "IGScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGScrollReactiveVideo"] = 11] = "IGScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBStandardBanner"] = 12] = "FBStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBStandardVideo"] = 13] = "FBStandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBScrollReactiveBanner"] = 14] = "FBScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBScrollReactiveVideo"] = 15] = "FBScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["TiktokVideo"] = 16] = "TiktokVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["InstagramReelsVideo"] = 17] = "InstagramReelsVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGCarousel"] = 18] = "IGCarousel";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["MiddleBanner"] = 19] = "MiddleBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBCarousel"] = 20] = "FBCarousel";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["DynamicScrollReactiveBanner"] = 21] = "DynamicScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Venti"] = 22] = "Venti";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Breakaway"] = 23] = "Breakaway";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Runway"] = 24] = "Runway";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["DynamicStandardBanner"] = 25] = "DynamicStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["DynamicLogoEnhancedBanner"] = 26] = "DynamicLogoEnhancedBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardCarousel"] = 27] = "StandardCarousel";
/* Uncomment for A/B testing */ // StandardBannerIframe = 101,
// StandardVideoIframe = 102,
})($d0e97bbb6b2cf9e5$var$CREATIVE_FORMAT_ENUM || (module.exports.CREATIVE_FORMAT_ENUM = $d0e97bbb6b2cf9e5$var$CREATIVE_FORMAT_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$CREATIVE_FORMAT_IFRAME_ENUM;
(function(CREATIVE_FORMAT_IFRAME_ENUM) {
    CREATIVE_FORMAT_IFRAME_ENUM[CREATIVE_FORMAT_IFRAME_ENUM["StandardBannerIframe"] = 101] = "StandardBannerIframe";
    CREATIVE_FORMAT_IFRAME_ENUM[CREATIVE_FORMAT_IFRAME_ENUM["StandardVideoIframe"] = 102] = "StandardVideoIframe";
})($d0e97bbb6b2cf9e5$var$CREATIVE_FORMAT_IFRAME_ENUM || (module.exports.CREATIVE_FORMAT_IFRAME_ENUM = $d0e97bbb6b2cf9e5$var$CREATIVE_FORMAT_IFRAME_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$CREATIVE_DESTINATION_ENUM;
(function(CREATIVE_DESTINATION_ENUM) {
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["EntireCreative"] = 1] = "EntireCreative";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["MainAsset"] = 2] = "MainAsset";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["Description"] = 3] = "Description";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["Cta"] = 4] = "Cta";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["SocialLogo"] = 5] = "SocialLogo";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["WatchOnSocial"] = 6] = "WatchOnSocial";
})($d0e97bbb6b2cf9e5$var$CREATIVE_DESTINATION_ENUM || (module.exports.CREATIVE_DESTINATION_ENUM = $d0e97bbb6b2cf9e5$var$CREATIVE_DESTINATION_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$CREATIVE_SOCIAL_TYPE_ENUM;
(function(CREATIVE_SOCIAL_TYPE_ENUM) {
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Standard"] = 1] = "Standard";
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Social"] = 2] = "Social";
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Dynamic"] = 3] = "Dynamic";
})($d0e97bbb6b2cf9e5$var$CREATIVE_SOCIAL_TYPE_ENUM || (module.exports.CREATIVE_SOCIAL_TYPE_ENUM = $d0e97bbb6b2cf9e5$var$CREATIVE_SOCIAL_TYPE_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$THEME_ENUM;
(function(THEME_ENUM) {
    THEME_ENUM["v1"] = "v1";
    THEME_ENUM["v2"] = "v2";
})($d0e97bbb6b2cf9e5$var$THEME_ENUM || (module.exports.THEME_ENUM = $d0e97bbb6b2cf9e5$var$THEME_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$FONT_FAMILY_ENUM;
(function(FONT_FAMILY_ENUM) {
    FONT_FAMILY_ENUM["colfax"] = "Colfax";
    FONT_FAMILY_ENUM["poppins"] = "Poppins";
})($d0e97bbb6b2cf9e5$var$FONT_FAMILY_ENUM || (module.exports.FONT_FAMILY_ENUM = $d0e97bbb6b2cf9e5$var$FONT_FAMILY_ENUM = {}));
// 'external' is a generalized enum, needs to be changed
// when new external company is added to composer
var $d0e97bbb6b2cf9e5$var$PROJECT_ENUM;
(function(PROJECT_ENUM) {
    PROJECT_ENUM["composer"] = "composer";
    PROJECT_ENUM["external"] = "external";
})($d0e97bbb6b2cf9e5$var$PROJECT_ENUM || (module.exports.PROJECT_ENUM = $d0e97bbb6b2cf9e5$var$PROJECT_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$INPUT_VARIANT_ENUM;
(function(INPUT_VARIANT_ENUM) {
    INPUT_VARIANT_ENUM["standard"] = "standard";
    INPUT_VARIANT_ENUM["outlined"] = "outlined";
})($d0e97bbb6b2cf9e5$var$INPUT_VARIANT_ENUM || (module.exports.INPUT_VARIANT_ENUM = $d0e97bbb6b2cf9e5$var$INPUT_VARIANT_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$CSS_POS_ENUM;
(function(CSS_POS_ENUM) {
    CSS_POS_ENUM["fixed"] = "fixed";
    CSS_POS_ENUM["absolute"] = "absolute";
    CSS_POS_ENUM["relative"] = "relative";
    CSS_POS_ENUM["static"] = "static";
    CSS_POS_ENUM["sticky"] = "sticky";
})($d0e97bbb6b2cf9e5$var$CSS_POS_ENUM || (module.exports.CSS_POS_ENUM = $d0e97bbb6b2cf9e5$var$CSS_POS_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$TARGET_ENUM;
(function(TARGET_ENUM) {
    TARGET_ENUM["blank"] = "_blank";
    TARGET_ENUM["self"] = "_self";
})($d0e97bbb6b2cf9e5$var$TARGET_ENUM || (module.exports.TARGET_ENUM = $d0e97bbb6b2cf9e5$var$TARGET_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$DATA_UNIT_ENUM;
(function(DATA_UNIT_ENUM) {
    DATA_UNIT_ENUM["B"] = "B";
    DATA_UNIT_ENUM["KB"] = "KB";
    DATA_UNIT_ENUM["MB"] = "MB";
    DATA_UNIT_ENUM["GB"] = "GB";
    DATA_UNIT_ENUM["TB"] = "TB";
    DATA_UNIT_ENUM["PB"] = "PB";
})($d0e97bbb6b2cf9e5$var$DATA_UNIT_ENUM || (module.exports.DATA_UNIT_ENUM = $d0e97bbb6b2cf9e5$var$DATA_UNIT_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$BACKGROUND_ENUM;
(function(BACKGROUND_ENUM) {
    BACKGROUND_ENUM["white"] = "white";
    BACKGROUND_ENUM["black"] = "black";
    BACKGROUND_ENUM["blue"] = "blue";
})($d0e97bbb6b2cf9e5$var$BACKGROUND_ENUM || (module.exports.BACKGROUND_ENUM = $d0e97bbb6b2cf9e5$var$BACKGROUND_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$ADVANCED_CREATIVE_SIZES_ENUM;
(function(ADVANCED_CREATIVE_SIZES_ENUM) {
    // Middle Banner
    ADVANCED_CREATIVE_SIZES_ENUM["_320x250"] = "320x250";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x250"] = "390x250";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x250"] = "428x250";
    // Venti
    ADVANCED_CREATIVE_SIZES_ENUM["_320x460"] = "320x460";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x460"] = "390x460";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x460"] = "428x460";
    // Breakaway Initial and Runway
    ADVANCED_CREATIVE_SIZES_ENUM["_320x150"] = "320x150";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x150"] = "390x150";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x150"] = "428x150";
    // Breakaway Collapsed
    ADVANCED_CREATIVE_SIZES_ENUM["_130x150"] = "130x150";
})($d0e97bbb6b2cf9e5$var$ADVANCED_CREATIVE_SIZES_ENUM || (module.exports.ADVANCED_CREATIVE_SIZES_ENUM = $d0e97bbb6b2cf9e5$var$ADVANCED_CREATIVE_SIZES_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$FILE_TYPE_ENUM;
(function(FILE_TYPE_ENUM) {
    FILE_TYPE_ENUM["image"] = "image";
    FILE_TYPE_ENUM["video"] = "video";
    FILE_TYPE_ENUM["logo"] = "logo";
})($d0e97bbb6b2cf9e5$var$FILE_TYPE_ENUM || (module.exports.FILE_TYPE_ENUM = $d0e97bbb6b2cf9e5$var$FILE_TYPE_ENUM = {}));
var $d0e97bbb6b2cf9e5$var$DEVICE_TYPE_ENUM;
(function(DEVICE_TYPE_ENUM) {
    DEVICE_TYPE_ENUM["desktop"] = "desktop";
    DEVICE_TYPE_ENUM["mobile"] = "mobile";
})($d0e97bbb6b2cf9e5$var$DEVICE_TYPE_ENUM || (module.exports.DEVICE_TYPE_ENUM = $d0e97bbb6b2cf9e5$var$DEVICE_TYPE_ENUM = {}));

});


parcelRegister("dhx99", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6ABSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eHKvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CREATIVE_FORMAT_BY_CREATIVE_EDITOR = module.exports.CREATIVE_CONFIG_BY_FORMAT = void 0;

var $hW26l = parcelRequire("hW26l");
const $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS = {
    cpc: false,
    viewability: false,
    resolution: "",
    destinationUrls: [
        $hW26l.CREATIVE_DESTINATION_ENUM.EntireCreative
    ],
    creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
    compatibleDevices: [
        $hW26l.DEVICE_TYPE_ENUM.mobile,
        $hW26l.DEVICE_TYPE_ENUM.desktop
    ]
};
// Deprecating CREATIVE_FORMATS v2.0.33,
module.exports.CREATIVE_CONFIG_BY_FORMAT = Object.freeze({
    [$hW26l.CREATIVE_FORMAT_ENUM.StandardBanner]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.StandardBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-banner",
        title: "Standard Banner",
        engagement: true,
        templateId: "aba-display-1"
    }),
    [$hW26l.CREATIVE_FORMAT_ENUM.StandardVideo]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.StandardVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-video",
        title: "Standard Video",
        engagement: true,
        templateId: "aba-video-1"
    }),
    [$hW26l.CREATIVE_FORMAT_ENUM.StandardCarousel]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.StandardCarousel,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-carousel",
        title: "Standard Carousel",
        cpc: false,
        viewability: false,
        engagement: true,
        resolution: "",
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.EntireCreative,
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset
        ],
        templateId: "standard-carousel",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "logo-enhanced-banner",
        title: "Logo Enhanced Banner",
        engagement: true,
        templateId: "aba-display-3"
    }),
    [$hW26l.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "scroll-reactive-banner",
        title: "Scroll Reactive Banner",
        engagement: true,
        templateId: "aba-display-2"
    }),
    [$hW26l.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "scroll-reactive-video",
        title: "Scroll Reactive Video",
        engagement: true,
        templateId: "aba-video-2"
    }),
    [$hW26l.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "adhesive-bottom-banner",
        title: "Adhesive Bottom Banner",
        resolution: "",
        cpc: true,
        viewability: true,
        engagement: false,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-adhesion-display-1",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "adhesive-side-banner",
        title: "Adhesive Side Banner",
        resolution: "",
        cpc: true,
        viewability: true,
        engagement: false,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-adhesion-display-2",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.IGStandardBanner]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.IGStandardBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-standard-banner",
        title: "Instagram Standard Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-2",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.IGStandardVideo]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.IGStandardVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-standard-video",
        title: "Instagram Standard Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-2",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-scroll-reactive-banner",
        title: "Instagram Scroll Reactive Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-1",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.IGCarousel]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.IGCarousel,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-carousel",
        title: "Instagram Carousel",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-carousel-1",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.FBCarousel]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.FBCarousel,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-carousel",
        title: "Facebook Carousel",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "bleeding-carousel",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-scroll-reactive-video",
        title: "Instagram Scroll Reactive Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-1",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.FBStandardBanner]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.FBStandardBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-standard-banner",
        title: "Facebook Standard Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-3",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.FBStandardVideo]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.FBStandardVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-standard-video",
        title: "Facebook Standard Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-3",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-scroll-reactive-banner",
        title: "Facebook Scroll Reactive Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-4",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-scroll-reactive-video",
        title: "Facebook Scroll Reactive Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-4",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.TiktokVideo]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.TiktokVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "tiktok-video",
        title: "Tiktok Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo,
            $hW26l.CREATIVE_DESTINATION_ENUM.WatchOnSocial
        ],
        templateId: "social-video-5",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.InstagramReelsVideo]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.InstagramReelsVideo,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "reels-video",
        title: "Reels Video",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: true,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hW26l.CREATIVE_DESTINATION_ENUM.Description,
            $hW26l.CREATIVE_DESTINATION_ENUM.Cta,
            $hW26l.CREATIVE_DESTINATION_ENUM.SocialLogo,
            $hW26l.CREATIVE_DESTINATION_ENUM.WatchOnSocial
        ],
        templateId: "social-video-5",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hW26l.DEVICE_TYPE_ENUM.mobile,
            $hW26l.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.MiddleBanner]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.MiddleBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "middle-banner",
        title: "Middle Banner",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [],
        templateId: "middle-banner-animated",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._320x250,
                width: 320,
                height: 250
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._390x250,
                width: 390,
                height: 250
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._428x250,
                width: 428,
                height: 250
            }
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Dynamic,
        id: "dynamic-scroll-reactive-banner",
        title: "Scroll Reactive Banner",
        engagement: false,
        templateId: "dynamic-scroll-reactive-banner"
    }),
    [$hW26l.CREATIVE_FORMAT_ENUM.Breakaway]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.Breakaway,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "breakaway",
        title: "Breakaway",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "breakaway",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._320x150,
                width: 320,
                height: 150
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._390x150,
                width: 390,
                height: 150
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._428x150,
                width: 428,
                height: 150
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._130x150,
                width: 130,
                height: 150,
                isCollapsed: true
            }
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.Runway]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.Runway,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "runway",
        title: "Runway",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [
            $hW26l.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "runway",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._320x150,
                width: 320,
                height: 150
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._390x150,
                width: 390,
                height: 150
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._428x150,
                width: 428,
                height: 150
            }
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.Venti]: {
        type: $hW26l.CREATIVE_FORMAT_ENUM.Venti,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "venti",
        title: "Venti",
        resolution: "",
        cpc: false,
        viewability: false,
        engagement: false,
        destinationUrls: [],
        templateId: "venti-animated",
        creativeEditor: $hW26l.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._320x460,
                width: 320,
                height: 460
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._390x460,
                width: 390,
                height: 460
            },
            {
                label: $hW26l.ADVANCED_CREATIVE_SIZES_ENUM._428x460,
                width: 428,
                height: 460
            }
        ]
    },
    [$hW26l.CREATIVE_FORMAT_ENUM.DynamicStandardBanner]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.DynamicStandardBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Dynamic,
        id: "dynamic-standard-banner",
        title: "Standard Banner",
        engagement: true,
        templateId: "dynamic-standard-banner"
    }),
    [$hW26l.CREATIVE_FORMAT_ENUM.DynamicLogoEnhancedBanner]: Object.assign(Object.assign({}, $ab492906cee20184$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hW26l.CREATIVE_FORMAT_ENUM.DynamicLogoEnhancedBanner,
        socialType: $hW26l.CREATIVE_SOCIAL_TYPE_ENUM.Dynamic,
        id: "dynamic-logo-enhanced-banner",
        title: "Logo Enhanced Banner",
        engagement: true,
        templateId: "dynamic-logo-enhanced-banner"
    })
});
module.exports.CREATIVE_FORMAT_BY_CREATIVE_EDITOR = {
    [$hW26l.CREATIVE_EDITOR_ENUM.lite]: [
        $hW26l.CREATIVE_FORMAT_ENUM.StandardBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.StandardVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.StandardCarousel,
        $hW26l.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.IGStandardBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.IGStandardVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.FBStandardBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.FBStandardVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.TiktokVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.InstagramReelsVideo,
        $hW26l.CREATIVE_FORMAT_ENUM.IGCarousel,
        $hW26l.CREATIVE_FORMAT_ENUM.FBCarousel,
        $hW26l.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner
    ],
    [$hW26l.CREATIVE_EDITOR_ENUM.advanced]: [
        $hW26l.CREATIVE_FORMAT_ENUM.MiddleBanner,
        $hW26l.CREATIVE_FORMAT_ENUM.Venti,
        $hW26l.CREATIVE_FORMAT_ENUM.Breakaway,
        $hW26l.CREATIVE_FORMAT_ENUM.Runway
    ]
};

});

parcelRegister("hhz0D", function(module, exports) {
"use strict";
var $c94f2e53edad9e53$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c94f2e53edad9e53$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compressImages = void 0;

const $c94f2e53edad9e53$var$browser_image_compression_1 = $c94f2e53edad9e53$var$__importDefault((parcelRequire("kcyGx")));

var $hW26l = parcelRequire("hW26l");
const $c94f2e53edad9e53$var$compressImages = (files)=>$c94f2e53edad9e53$var$__awaiter(void 0, void 0, void 0, function*() {
        if (files.every((file)=>file.type.includes($hW26l.FILE_TYPE_ENUM.video))) return files;
        const compressionPromises = [];
        const compressionOptions = {
            maxSizeMB: 0.2929,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        };
        try {
            const validBlobs = files.filter((file)=>file.type.includes($hW26l.FILE_TYPE_ENUM.image) && file instanceof Blob);
            if (validBlobs.length < 1) throw new Error("File(s) format unsupported!");
            validBlobs.forEach((blob)=>compressionPromises.push((0, $c94f2e53edad9e53$var$browser_image_compression_1.default)(blob, compressionOptions)));
            const compressedBlobs = yield Promise.all(compressionPromises);
            return compressedBlobs;
        } catch (err) {
            console.log(err);
            return files;
        }
    });
module.exports.compressImages = $c94f2e53edad9e53$var$compressImages;

});

parcelRegister("2sGFp", function(module, exports) {
"use strict";
var $1caf4b0a9687e1fa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOutsideClick = void 0;

const $1caf4b0a9687e1fa$var$react_1 = $1caf4b0a9687e1fa$var$__importDefault((parcelRequire("acw62")));
const $1caf4b0a9687e1fa$var$useOutsideClick = (ref, callback)=>{
    $1caf4b0a9687e1fa$var$react_1.default.useEffect(()=>{
        /**
         * Alert if clicked on outside of element
         */ const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) callback();
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
};
module.exports.useOutsideClick = $1caf4b0a9687e1fa$var$useOutsideClick;

});

parcelRegister("dS8b6", function(module, exports) {
"use strict";
var $a196a97df6f9c043$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a196a97df6f9c043$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a196a97df6f9c043$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a196a97df6f9c043$var$__createBinding(result, mod, k);
    }
    $a196a97df6f9c043$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInterval = void 0;

const $a196a97df6f9c043$var$react_1 = $a196a97df6f9c043$var$__importStar((parcelRequire("acw62")));
const $a196a97df6f9c043$var$useInterval = (callback, delay)=>{
    const intervalId = $a196a97df6f9c043$var$react_1.default.useRef(null);
    const savedCallback = $a196a97df6f9c043$var$react_1.default.useRef(callback);
    (0, $a196a97df6f9c043$var$react_1.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, $a196a97df6f9c043$var$react_1.useEffect)(()=>{
        const tick = ()=>savedCallback.current();
        intervalId.current = window.setInterval(tick, delay);
        return ()=>window.clearInterval(intervalId.current);
    }, [
        delay
    ]);
    return intervalId.current;
};
module.exports.useInterval = $a196a97df6f9c043$var$useInterval;

});

parcelRegister("3FWhO", function(module, exports) {
"use strict";
var $2ad269e110b07277$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePlayVideo = void 0;

const $2ad269e110b07277$var$react_1 = $2ad269e110b07277$var$__importDefault((parcelRequire("acw62")));
const $2ad269e110b07277$var$usePlayVideo = (onVideoEnd, video, videoRef, interval)=>{
    $2ad269e110b07277$var$react_1.default.useEffect(()=>{
        var _a;
        if (!!video && videoRef.current) {
            onVideoEnd();
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            (_a = videoRef.current) === null || _a === void 0 || _a.play().catch(()=>videoRef.current ? videoRef.current.pause() : null);
        }
        return ()=>{
            if (interval) // eslint-disable-next-line react-hooks/exhaustive-deps
            clearInterval(interval.current);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        video
    ]);
};
module.exports.usePlayVideo = $2ad269e110b07277$var$usePlayVideo;

});

parcelRegister("8TLkb", function(module, exports) {
"use strict";
var $67a82b771b40ceea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDeletePressed = void 0;

const $67a82b771b40ceea$var$react_1 = $67a82b771b40ceea$var$__importDefault((parcelRequire("acw62")));
const $67a82b771b40ceea$var$useDeletePressed = (ref, callback)=>{
    $67a82b771b40ceea$var$react_1.default.useEffect(()=>{
        /**
         * Alert if delete pressed
         */ const handleDeletePressed = (event)=>{
            const isDeleteKey = event.key === "Delete" || event.key === "Backspace";
            if (isDeleteKey && ref.current && (ref.current === event.target || ref.current.contains(event.target))) callback();
        };
        // Bind the event listener
        document.addEventListener("keydown", handleDeletePressed);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener("keydown", handleDeletePressed);
        };
    });
};
module.exports.useDeletePressed = $67a82b771b40ceea$var$useDeletePressed;

});

parcelRegister("7ShW9", function(module, exports) {
"use strict";
var $5bbb7d72ff16c2a6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgProvider = void 0;

const $5bbb7d72ff16c2a6$var$krg_provider_react_1 = $5bbb7d72ff16c2a6$var$__importDefault((parcelRequire("6nM4x")));
module.exports.KrgProvider = $5bbb7d72ff16c2a6$var$krg_provider_react_1.default;

});
parcelRegister("6nM4x", function(module, exports) {
"use strict";
var $4a5a2e33976cfdc1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4a5a2e33976cfdc1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4a5a2e33976cfdc1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4a5a2e33976cfdc1$var$__createBinding(result, mod, k);
    }
    $4a5a2e33976cfdc1$var$__setModuleDefault(result, mod);
    return result;
};
var $4a5a2e33976cfdc1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $4a5a2e33976cfdc1$var$react_1 = $4a5a2e33976cfdc1$var$__importStar((parcelRequire("acw62")));

var $2BuCw = parcelRequire("2BuCw");
var $gRp5N = parcelRequire("gRp5N");

const $4a5a2e33976cfdc1$var$krg_provider_style_1 = $4a5a2e33976cfdc1$var$__importDefault((parcelRequire("6ccA7")));

var $cfpuL = parcelRequire("cfpuL");

var $hW26l = parcelRequire("hW26l");

const $4a5a2e33976cfdc1$var$KrgProvider = ({ children: children, theme: theme })=>{
    const demoFontFamily = localStorage.getItem($cfpuL.STORE_KEY_FONT_FAMILY) || $hW26l.FONT_FAMILY_ENUM.colfax;
    const [fontFamily, setFontFamily] = (0, $4a5a2e33976cfdc1$var$react_1.useState)(demoFontFamily);
    const storageCallback = (e)=>{
        setFontFamily(localStorage.getItem($cfpuL.STORE_KEY_FONT_FAMILY) || $hW26l.FONT_FAMILY_ENUM.colfax);
    };
    (0, $4a5a2e33976cfdc1$var$react_1.useEffect)(()=>{
        if (demoFontFamily) window.addEventListener("storage", storageCallback);
        return ()=>{
            if (demoFontFamily) window.removeEventListener("storage", storageCallback);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return $4a5a2e33976cfdc1$var$react_1.default.createElement($2BuCw.default, {
        injectFirst: true
    }, $4a5a2e33976cfdc1$var$react_1.default.createElement($gRp5N.default, {
        theme: theme ? theme : (0, $4a5a2e33976cfdc1$var$krg_provider_style_1.default)(fontFamily)
    }, children));
};
module.exports.default = $4a5a2e33976cfdc1$var$KrgProvider;

});
parcelRegister("6ccA7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ijOKP = parcelRequire("ijOKP");
const $482d9f7f3883ea04$var$defaultTheme = (selectedFontFamily)=>{
    let typography;
    if (selectedFontFamily) typography = {
        fontFamily: [
            selectedFontFamily,
            "Arial",
            "sans-serif"
        ].join(",")
    };
    return (0, $ijOKP.default)({
        typography: typography,
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920
            }
        }
    });
};
module.exports.default = $482d9f7f3883ea04$var$defaultTheme;

});



parcelRegister("5MIn3", function(module, exports) {
"use strict";
var $4363da8df24a13e4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgFontSelector = void 0;

const $4363da8df24a13e4$var$krg_font_selector_react_1 = $4363da8df24a13e4$var$__importDefault((parcelRequire("c0unj")));
module.exports.KrgFontSelector = $4363da8df24a13e4$var$krg_font_selector_react_1.default;

});
parcelRegister("c0unj", function(module, exports) {
"use strict";
var $8bdd0bf1520805ca$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $8bdd0bf1520805ca$var$react_1 = $8bdd0bf1520805ca$var$__importDefault((parcelRequire("acw62")));

var $cWFSm = parcelRequire("cWFSm");

var $hW26l = parcelRequire("hW26l");

var $cfpuL = parcelRequire("cfpuL");
const $8bdd0bf1520805ca$var$KrgFontSelector = ({ setFontFamily: setFontFamily })=>{
    return $8bdd0bf1520805ca$var$react_1.default.createElement($cWFSm.KrgStyleSelector, {
        label: "Select Font",
        options: [
            $hW26l.FONT_FAMILY_ENUM.colfax,
            $hW26l.FONT_FAMILY_ENUM.poppins
        ],
        storageKey: $cfpuL.STORE_KEY_FONT_FAMILY,
        onChange: setFontFamily
    });
};
module.exports.default = $8bdd0bf1520805ca$var$KrgFontSelector;

});


parcelRegister("9dO7Y", function(module, exports) {
"use strict";
var $6b6c363fa778402d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgThemeSelector = void 0;

const $6b6c363fa778402d$var$krg_theme_selector_react_1 = $6b6c363fa778402d$var$__importDefault((parcelRequire("6WYN7")));
module.exports.KrgThemeSelector = $6b6c363fa778402d$var$krg_theme_selector_react_1.default;

});
parcelRegister("6WYN7", function(module, exports) {
"use strict";
var $50f750b8b139bfd2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $50f750b8b139bfd2$var$react_1 = $50f750b8b139bfd2$var$__importDefault((parcelRequire("acw62")));

var $cWFSm = parcelRequire("cWFSm");

var $hW26l = parcelRequire("hW26l");

var $cfpuL = parcelRequire("cfpuL");
const $50f750b8b139bfd2$var$KrgThemeSelector = ({ setTheme: setTheme })=>{
    return $50f750b8b139bfd2$var$react_1.default.createElement($cWFSm.KrgStyleSelector, {
        label: "Select Theme",
        options: [
            $hW26l.THEME_ENUM.v1,
            $hW26l.THEME_ENUM.v2
        ],
        storageKey: $cfpuL.STORE_KEY_THEME,
        onChange: setTheme
    });
};
module.exports.default = $50f750b8b139bfd2$var$KrgThemeSelector;

});


parcelRegister("9S6F7", function(module, exports) {
"use strict";
var $72fe532d45c1fc63$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgStyleSelector = void 0;

const $72fe532d45c1fc63$var$krg_style_selector_react_1 = $72fe532d45c1fc63$var$__importDefault((parcelRequire("8y9ZN")));
module.exports.KrgStyleSelector = $72fe532d45c1fc63$var$krg_style_selector_react_1.default;

});
parcelRegister("8y9ZN", function(module, exports) {
"use strict";
var $639940a198c634b8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $639940a198c634b8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $639940a198c634b8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $639940a198c634b8$var$__createBinding(result, mod, k);
    }
    $639940a198c634b8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $639940a198c634b8$var$react_1 = $639940a198c634b8$var$__importStar((parcelRequire("acw62")));

var $cX7V2 = parcelRequire("cX7V2");
var $2iAqv = parcelRequire("2iAqv");
const $639940a198c634b8$var$KrgStyleSelector = ({ label: label, options: options, storageKey: storageKey, onChange: onChange })=>{
    const [selectedValue, setSelectedValue] = (0, $639940a198c634b8$var$react_1.useState)(storageKey ? localStorage.getItem(storageKey) || options[0] : options[0]);
    (0, $639940a198c634b8$var$react_1.useEffect)(()=>{
        onChange(selectedValue);
        if (storageKey) {
            localStorage.setItem(storageKey, selectedValue);
            window.dispatchEvent(new Event("storage"));
        }
    }, [
        selectedValue,
        storageKey,
        onChange
    ]);
    return $639940a198c634b8$var$react_1.default.createElement("div", {
        style: {
            padding: "1em 1em 1em 0",
            display: "inline-block"
        }
    }, $639940a198c634b8$var$react_1.default.createElement($cX7V2.default, {
        name: label,
        value: selectedValue,
        style: {
            width: "200px",
            height: "36px",
            borderRadius: 0
        },
        onChange: ({ target: target })=>setSelectedValue(target.value)
    }, options.map((item)=>$639940a198c634b8$var$react_1.default.createElement($2iAqv.default, {
            key: item,
            value: item
        }, item))));
};
module.exports.default = $639940a198c634b8$var$KrgStyleSelector;

});



parcelRegister("hIemg", function(module, exports) {
"use strict";
var $ce51aeed6999de0d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ce51aeed6999de0d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ce51aeed6999de0d$var$__createBinding(exports1, m, p);
};
var $ce51aeed6999de0d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = void 0;

const $ce51aeed6999de0d$var$krg_chip_react_1 = $ce51aeed6999de0d$var$__importDefault((parcelRequire("7sMD8")));

var $cWFSm = parcelRequire("cWFSm");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $cWFSm.THEME_ENUM;
    }
});

$ce51aeed6999de0d$var$__exportStar((parcelRequire("enf89")), module.exports);
module.exports.default = $ce51aeed6999de0d$var$krg_chip_react_1.default;

});
parcelRegister("7sMD8", function(module, exports) {
"use strict";
var $56f0ded9642751c6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $56f0ded9642751c6$var$react_1 = $56f0ded9642751c6$var$__importDefault((parcelRequire("acw62")));

var $26QC4 = parcelRequire("26QC4");
var $6ami2 = parcelRequire("6ami2");

var $cWFSm = parcelRequire("cWFSm");

var $enf89 = parcelRequire("enf89");

const $56f0ded9642751c6$var$base_style_1 = $56f0ded9642751c6$var$__importDefault((parcelRequire("dVmlq")));

const $56f0ded9642751c6$var$style_v1_1 = $56f0ded9642751c6$var$__importDefault((parcelRequire("1EpyE")));

const $56f0ded9642751c6$var$style_v2_1 = $56f0ded9642751c6$var$__importDefault((parcelRequire("asCCa")));
const $56f0ded9642751c6$var$KrgChip = ({ id: id, className: className = "", data: data, startAdornment: startAdornment, style: style, type: type, isClickable: isClickable = false, isEnabled: isEnabled = true, theme: theme = $cWFSm.THEME_ENUM.v1, onDelete: onDelete, onBlur: onBlur, onClick: onClick, onFocus: onFocus })=>{
    const props = {
        type: type,
        isClickable: isClickable
    };
    const baseClasses = (0, $56f0ded9642751c6$var$base_style_1.default)(props);
    const classesV1 = (0, $56f0ded9642751c6$var$style_v1_1.default)(props);
    const classesV2 = (0, $56f0ded9642751c6$var$style_v2_1.default)(props);
    const classes = theme === $cWFSm.THEME_ENUM.v2 ? classesV2 : classesV1;
    const variant = type === $enf89.TYPE_ENUM.transparent ? "outlined" : "filled";
    const color = type === $enf89.TYPE_ENUM.primary ? "primary" : "default";
    const avatarBlock = $56f0ded9642751c6$var$react_1.default.createElement($26QC4.default, null, startAdornment);
    const isAvatarAdornment = typeof startAdornment === "string";
    const chipClasses = {
        root: `${baseClasses.root} ${classes.root}`,
        colorPrimary: classes.colorPrimary,
        iconColorPrimary: classes.iconColorPrimary,
        deleteIconColorPrimary: classes.deleteIconColorPrimary
    };
    return $56f0ded9642751c6$var$react_1.default.createElement($6ami2.default, {
        id: id,
        className: className,
        classes: chipClasses,
        style: style,
        avatar: isAvatarAdornment ? avatarBlock : undefined,
        icon: isAvatarAdornment ? undefined : startAdornment,
        label: data.text,
        variant: variant,
        color: color,
        disabled: !isEnabled,
        clickable: isClickable,
        onDelete: !!onDelete ? ()=>onDelete(data.id) : undefined,
        onClick: isClickable && onClick ? ()=>onClick(data.id) : undefined,
        onFocus: onFocus,
        onBlur: onBlur
    });
};
$56f0ded9642751c6$var$KrgChip.TYPE_ENUM = $enf89.TYPE_ENUM;
$56f0ded9642751c6$var$KrgChip.THEME_ENUM = $cWFSm.THEME_ENUM;
module.exports.default = $56f0ded9642751c6$var$KrgChip;

});
parcelRegister("enf89", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TYPE_ENUM = void 0;
var $a76ef340cdac2fd3$var$TYPE_ENUM;
(function(TYPE_ENUM) {
    TYPE_ENUM["primary"] = "primary";
    TYPE_ENUM["gray"] = "gray";
    TYPE_ENUM["transparent"] = "transparent";
})($a76ef340cdac2fd3$var$TYPE_ENUM || (module.exports.TYPE_ENUM = $a76ef340cdac2fd3$var$TYPE_ENUM = {}));

});

parcelRegister("dVmlq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $a231ee60446eea3f$var$useBaseStyles = (0, $1GFtd.default)({
    root: {}
});
module.exports.default = $a231ee60446eea3f$var$useBaseStyles;

});

parcelRegister("1EpyE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $cWFSm = parcelRequire("cWFSm");
const $133d5a237a0208e9$var$useStylesV1 = (0, $1GFtd.default)({
    root: {},
    colorPrimary: {
        backgroundColor: $cWFSm.COLORS.PRIMARY_50,
        color: $cWFSm.COLORS.PRIMARY_500_ACCENT,
        "&:hover, &:focus": {
            backgroundColor: $cWFSm.COLORS.PRIMARY_10,
            color: $cWFSm.COLORS.PRIMARY_DARK_TEXT
        }
    },
    iconColorPrimary: {
        color: `${$cWFSm.COLORS.PRIMARY_500_ACCENT} !important`
    },
    deleteIconColorPrimary: {
        color: `${$cWFSm.COLORS.PRIMARY_500_ACCENT} !important`,
        "&:hover, &:active": {
            color: `${$cWFSm.COLORS.PRIMARY_DARK_TEXT} !important`
        }
    }
});
module.exports.default = $133d5a237a0208e9$var$useStylesV1;

});

parcelRegister("asCCa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $cWFSm = parcelRequire("cWFSm");

var $enf89 = parcelRequire("enf89");
const $79da78fb5671a115$var$useStylesV2 = (0, $1GFtd.default)({
    // Chip root element
    root: {
        fontSize: $cWFSm.FONT.SIZE.BASE,
        height: "1.3125em",
        padding: "0.3125em",
        backgroundColor: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.NEUTRAL_MEDIUM : "transparent",
        borderColor: ({ type: type })=>type === $enf89.TYPE_ENUM.transparent ? $cWFSm.COLORS_V2.NEUTRAL_BLACK : "unset",
        // Label text
        "& > .MuiChip-label": {
            fontSize: $cWFSm.FONT.SIZE.SMALL,
            fontWeight: $cWFSm.FONT.WEIGHT.MEDIUM,
            color: $cWFSm.COLORS_V2.NEUTRAL_BLACK,
            padding: "0 0.4375em"
        },
        // Adornment Icon
        "& > .MuiChip-icon": {
            color: $cWFSm.COLORS_V2.NEUTRAL_BLACK,
            fontSize: $cWFSm.FONT.SIZE.LARGE,
            margin: 0
        },
        // Adornment Avatar
        "& > .MuiAvatar-root": {
            fontSize: $cWFSm.FONT.SIZE.SMALL,
            margin: 0,
            backgroundColor: $cWFSm.COLORS_V2.NEUTRAL_DARK,
            color: $cWFSm.COLORS_V2.NEUTRAL_WHITE,
            width: "1.4em",
            height: "1.4em"
        },
        // Delete Icon
        "& > .MuiChip-deleteIcon": {
            color: $cWFSm.COLORS_V2.NEUTRAL_DARK,
            fontSize: $cWFSm.FONT.SIZE.LARGE,
            marginRight: "-0.1041665em",
            marginLeft: 0,
            background: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? `radial-gradient(circle at center, ${$cWFSm.COLORS_V2.NEUTRAL_LIGHT} 0, ${$cWFSm.COLORS_V2.NEUTRAL_LIGHT} 50%, transparent 51%, transparent 100%)` : `radial-gradient(circle at center, ${$cWFSm.COLORS_V2.NEUTRAL_WHITE} 0, ${$cWFSm.COLORS_V2.NEUTRAL_WHITE} 50%, transparent 51%, transparent 100%)`,
            "&:hover, &:focus": {
                color: $cWFSm.COLORS_V2.PRIMARY_700
            }
        },
        // Chip + Disabled
        "&.Mui-disabled": {
            backgroundColor: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.NEUTRAL_INACTIVE : "transparent",
            borderColor: ({ type: type })=>type === $enf89.TYPE_ENUM.transparent ? $cWFSm.COLORS_V2.NEUTRAL_INACTIVE : "unset",
            opacity: 1,
            // Label text + Disabled
            "& > .MuiChip-label": {
                color: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.NEUTRAL_DARK : $cWFSm.COLORS_V2.NEUTRAL_INACTIVE
            },
            // Adornment Icon + Disabled
            "& > .MuiChip-icon": {
                color: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.NEUTRAL_DARK : $cWFSm.COLORS_V2.NEUTRAL_INACTIVE
            },
            // Adornment Avatar + Disabled
            "& > .MuiAvatar-root": {
                color: $cWFSm.COLORS_V2.NEUTRAL_WHITE,
                backgroundColor: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.NEUTRAL_DARK : $cWFSm.COLORS_V2.NEUTRAL_INACTIVE
            },
            // Delete Icon + Disabled
            "& > .MuiChip-deleteIcon": {
                background: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? `radial-gradient(circle at center, ${$cWFSm.COLORS_V2.NEUTRAL_INACTIVE} 0, ${$cWFSm.COLORS_V2.NEUTRAL_INACTIVE} 50%, transparent 51%, transparent 100%)` : `radial-gradient(circle at center, ${$cWFSm.COLORS_V2.NEUTRAL_WHITE} 0, ${$cWFSm.COLORS_V2.NEUTRAL_WHITE} 50%, transparent 51%, transparent 100%)`,
                color: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.NEUTRAL_LIGHT : $cWFSm.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        "&.MuiChip-clickable:hover, &.MuiChip-clickable:focus": {
            backgroundColor: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.PRIMARY_50 : "transparent",
            borderColor: ({ type: type })=>type === $enf89.TYPE_ENUM.transparent ? $cWFSm.COLORS_V2.PRIMARY_700 : "unset",
            // Label text + Hover
            "& > .MuiChip-label": {
                color: ({ type: type })=>type === $enf89.TYPE_ENUM.transparent ? $cWFSm.COLORS_V2.PRIMARY_700 : $cWFSm.COLORS_V2.NEUTRAL_BLACK
            },
            // Adornment Icon + Hover
            "& > .MuiChip-icon": {
                color: ({ type: type })=>type === $enf89.TYPE_ENUM.transparent ? $cWFSm.COLORS_V2.PRIMARY_700 : $cWFSm.COLORS_V2.NEUTRAL_BLACK
            },
            // Avatar  + Hover
            "& > .MuiAvatar-root": {
                backgroundColor: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? $cWFSm.COLORS_V2.NEUTRAL_DARK : $cWFSm.COLORS_V2.PRIMARY_700
            },
            // Delete Icon + Hover
            "& > .MuiChip-deleteIcon": {
                background: ({ type: type })=>type === $enf89.TYPE_ENUM.gray ? `radial-gradient(circle at center, ${$cWFSm.COLORS_V2.PRIMARY_50} 0, ${$cWFSm.COLORS_V2.PRIMARY_50} 50%, transparent 51%, transparent 100%)` : `radial-gradient(circle at center, ${$cWFSm.COLORS_V2.NEUTRAL_WHITE} 0, ${$cWFSm.COLORS_V2.NEUTRAL_WHITE} 50%, transparent 51%, transparent 100%)`
            }
        },
        "&:active": {
            boxShadow: ({ isClickable: isClickable })=>isClickable ? `0 0.25em 0.25em ${$cWFSm.COLORS_V2_ALPHA.NEUTRAL_BLACK_SHADOW}` : "none"
        }
    },
    colorPrimary: {},
    iconColorPrimary: {},
    deleteIconColorPrimary: {}
});
module.exports.default = $79da78fb5671a115$var$useStylesV2;

});



parcelRegister("akHLD", function(module, exports) {
"use strict";
var $785db8e8399d002a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $785db8e8399d002a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $785db8e8399d002a$var$__createBinding(exports1, m, p);
};
var $785db8e8399d002a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = void 0;

const $785db8e8399d002a$var$krg_checkbox_react_1 = $785db8e8399d002a$var$__importDefault((parcelRequire("gV7U2")));

var $cWFSm = parcelRequire("cWFSm");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $cWFSm.THEME_ENUM;
    }
});

$785db8e8399d002a$var$__exportStar((parcelRequire("3kanr")), module.exports);
module.exports.default = $785db8e8399d002a$var$krg_checkbox_react_1.default;

});
parcelRegister("gV7U2", function(module, exports) {
"use strict";
var $c518198fc260eaea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c518198fc260eaea$var$react_1 = $c518198fc260eaea$var$__importDefault((parcelRequire("acw62")));

var $1Aijw = parcelRequire("1Aijw");

var $cWFSm = parcelRequire("cWFSm");

var $3kanr = parcelRequire("3kanr");

const $c518198fc260eaea$var$base_style_1 = $c518198fc260eaea$var$__importDefault((parcelRequire("1Kg25")));

const $c518198fc260eaea$var$style_v1_1 = $c518198fc260eaea$var$__importDefault((parcelRequire("cOO7y")));

const $c518198fc260eaea$var$style_v2_1 = $c518198fc260eaea$var$__importDefault((parcelRequire("eha8Y")));
const $c518198fc260eaea$var$KrgCheckbox = ({ id: id, className: className = "", style: style, label: label, labelAlignment: labelAlignment = $3kanr.LABEL_ALIGNMENT_ENUM.right, hasStopPropagation: hasStopPropagation = true, isChecked: isChecked = false, isIndeterminate: isIndeterminate = false, isEnabled: isEnabled = true, theme: theme = $cWFSm.THEME_ENUM.v1, onToggle: onToggle, onClick: onClick, onBlur: onBlur, onFocus: onFocus })=>{
    const baseClasses = (0, $c518198fc260eaea$var$base_style_1.default)();
    const classesV1 = (0, $c518198fc260eaea$var$style_v1_1.default)();
    const classesV2 = (0, $c518198fc260eaea$var$style_v2_1.default)();
    const classes = theme === $cWFSm.THEME_ENUM.v2 ? classesV2 : classesV1;
    const checkboxId = `krg-checkbox-${id || Math.random()}`;
    const getLabel = ()=>$c518198fc260eaea$var$react_1.default.createElement("label", {
            className: `${baseClasses.label} ${classes.label} ${isEnabled ? "" : classes.disabled}`,
            htmlFor: checkboxId
        }, label);
    const onChange = (e)=>{
        if (onToggle) onToggle(e.target.checked);
    };
    return $c518198fc260eaea$var$react_1.default.createElement("div", {
        className: `${baseClasses.container} ${className}`,
        style: style,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }, labelAlignment === $3kanr.LABEL_ALIGNMENT_ENUM.left && getLabel(), $c518198fc260eaea$var$react_1.default.createElement($1Aijw.default, {
        id: checkboxId,
        color: "default",
        disabled: !isEnabled,
        classes: {
            root: `${baseClasses.root} ${classes.root}`,
            checked: classes.selected,
            indeterminate: classes.selected,
            disabled: classes.disabled
        },
        checked: isChecked,
        indeterminate: isIndeterminate,
        onChange: onChange,
        onClick: (e)=>{
            if (hasStopPropagation) e.stopPropagation();
        }
    }), labelAlignment === $3kanr.LABEL_ALIGNMENT_ENUM.right && getLabel());
};
$c518198fc260eaea$var$KrgCheckbox.LABEL_ALIGNMENT_ENUM = $3kanr.LABEL_ALIGNMENT_ENUM;
$c518198fc260eaea$var$KrgCheckbox.THEME_ENUM = $cWFSm.THEME_ENUM;
module.exports.default = $c518198fc260eaea$var$KrgCheckbox;

});
parcelRegister("3kanr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LABEL_ALIGNMENT_ENUM = void 0;
var $26bb4a090ce1243f$var$LABEL_ALIGNMENT_ENUM;
(function(LABEL_ALIGNMENT_ENUM) {
    LABEL_ALIGNMENT_ENUM["left"] = "left";
    LABEL_ALIGNMENT_ENUM["right"] = "right";
})($26bb4a090ce1243f$var$LABEL_ALIGNMENT_ENUM || (module.exports.LABEL_ALIGNMENT_ENUM = $26bb4a090ce1243f$var$LABEL_ALIGNMENT_ENUM = {}));

});

parcelRegister("1Kg25", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $cWFSm = parcelRequire("cWFSm");
const $145686105b9fb47c$var$useBaseStyles = (0, $1GFtd.default)({
    // Checkbox container
    container: {
        alignItems: "center",
        display: "flex",
        fontSize: $cWFSm.FONT.SIZE.BASE
    },
    // Checkbox classes
    root: {
        color: $cWFSm.COLORS.GRAY_DARK,
        fontSize: $cWFSm.FONT.SIZE.EXTRA_LARGE,
        padding: "0.3em",
        "& .MuiSvgIcon-root": {
            fontSize: "1.5em"
        }
    },
    // Label text
    label: {
        cursor: "pointer"
    }
});
module.exports.default = $145686105b9fb47c$var$useBaseStyles;

});

parcelRegister("cOO7y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cWFSm = parcelRequire("cWFSm");

var $1GFtd = parcelRequire("1GFtd");
const $955108835d9e214b$var$useStylesV1 = (0, $1GFtd.default)({
    // Checkbox classes
    root: {},
    // Selected (Checked/Indeterminate)
    selected: {
        color: $cWFSm.COLORS.PRIMARY_500_ACCENT
    },
    // Disabled color
    disabled: {
        color: $cWFSm.COLORS.GRAY_DARK,
        cursor: "default"
    },
    // Label text
    label: {}
});
module.exports.default = $955108835d9e214b$var$useStylesV1;

});

parcelRegister("eha8Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $cWFSm = parcelRequire("cWFSm");
const $a64a858968685ba8$var$useStylesV2 = (0, $1GFtd.default)({
    // Checkbox classes
    root: {
        "& .MuiSvgIcon-root": {
            fontSize: "1.25em"
        }
    },
    // Selected (Checked/Indeterminate)
    selected: {
        color: $cWFSm.COLORS_V2.PRIMARY_700
    },
    // Disabled color
    disabled: {
        color: $cWFSm.COLORS_V2.NEUTRAL_INACTIVE,
        cursor: "default"
    },
    // Label text
    label: {
        fontSize: $cWFSm.FONT.SIZE.REGULAR,
        fontWeight: $cWFSm.FONT.WEIGHT.MEDIUM,
        paddingLeft: "0.1875em"
    }
});
module.exports.default = $a64a858968685ba8$var$useStylesV2;

});



parcelRegister("1cg3Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $cWFSm = parcelRequire("cWFSm");
const $0df35f4a2fa50e2c$var$useBaseStyles = (0, $1GFtd.default)({
    root: {
        fontSize: $cWFSm.FONT.SIZE.BASE
    },
    circularProgress: {
        position: "absolute",
        right: "0.5em"
    },
    textFieldDisabled: {
        "& .MuiInput-underline:before": {
            borderBottomColor: $cWFSm.COLORS.GRAY_DIVIDER,
            borderBottomStyle: "solid"
        },
        "& svg": {
            color: $cWFSm.COLORS.BLACK_INACTIVE
        }
    }
});
module.exports.default = $0df35f4a2fa50e2c$var$useBaseStyles;

});

parcelRegister("iz2Ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $cWFSm = parcelRequire("cWFSm");
const $d83d86767e001a7b$var$useStylesV1 = (0, $1GFtd.default)({
    textFieldRoot: {
        "& > div:nth-of-type(1)": {
            borderRadius: 0
        },
        "& .MuiOutlinedInput-root.Mui-error": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: $cWFSm.COLORS.ERROR_DARK
            },
            "& .MuiSvgIcon-root": {
                color: $cWFSm.COLORS.ERROR_DARK
            }
        },
        "& .MuiInputLabel-root.Mui-error": {
            color: $cWFSm.COLORS.ERROR_DARK
        },
        // Helper text
        "& .MuiFormHelperText-root": {
            fontSize: $cWFSm.FONT.SIZE.REGULAR,
            margin: "0.25em 0.0625em",
            "&.Mui-error": {
                color: $cWFSm.COLORS.ERROR_DARK
            }
        }
    },
    textFieldEnabled: {},
    textFieldError: {},
    textFieldDisabled: {},
    errorIcon: {
        color: $cWFSm.COLORS.ERROR_DARK
    },
    listItem: {}
});
module.exports.default = $d83d86767e001a7b$var$useStylesV1;

});

parcelRegister("5nRqh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $cWFSm = parcelRequire("cWFSm");
const $3eb88a6b6cf2cdc3$var$useStylesV2 = (0, $1GFtd.default)({
    textFieldRoot: {
        // Root
        "& .MuiInputBase-root": {
            minHeight: "2.3125em"
        },
        // Root input
        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
            fontSize: $cWFSm.FONT.SIZE.REGULAR,
            fontWeight: $cWFSm.FONT.WEIGHT.MEDIUM,
            marginLeft: "0.25em",
            color: $cWFSm.COLORS_V2.NEUTRAL_BLACK
        },
        // Root input
        "& .MuiAutocomplete-inputRoot": {
            "& .MuiInputBase-input.Mui-disabled": {
                color: $cWFSm.COLORS_V2.NEUTRAL_INACTIVE,
                WebkitTextFillColor: $cWFSm.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        "& > .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
            padding: "0.25em"
        },
        // Label style
        "& .MuiInputLabel-root": {
            color: $cWFSm.COLORS_V2.NEUTRAL_DARK,
            // Label + Outlined
            "&.MuiInputLabel-outlined": {
                fontSize: $cWFSm.FONT.SIZE.REGULAR
            },
            // Label + standard
            "&.MuiInputLabel-standard": {
                fontSize: $cWFSm.FONT.SIZE.SEMI_LARGE,
                marginTop: "0.5em"
            },
            // Label + Focused
            "&.Mui-focused": {
                fontSize: "0.8333333em",
                paddingLeft: "0.0625em"
            },
            // Label + Disabled
            "&.Mui-disabled": {
                color: $cWFSm.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        "& .MuiInputLabel-root.MuiInputLabel-shrink.MuiInputLabel-outlined": {
            fontSize: "0.8333333em",
            paddingLeft: "0.0625em"
        },
        // Borders standard
        "& .MuiInput-underline": {
            "&:before": {
                borderBottomColor: $cWFSm.COLORS_V2.NEUTRAL_DARK,
                borderWidth: "0.0625em"
            },
            "&:hover:not(.Mui-disabled):not(.Mui-focused):before": {
                borderBottomColor: $cWFSm.COLORS_V2.NEUTRAL_BLACK,
                borderWidth: "0.0625em"
            },
            "&:not(.Mui-error):after": {
                transform: "scaleX(1)",
                border: "none"
            },
            "&.Mui-error.Mui-disabled:after": {
                border: "none"
            },
            "&.Mui-focused:after": {
                borderBottomWidth: "0.125em",
                borderBottomStyle: "solid",
                borderBottomColor: $cWFSm.COLORS_V2.PRIMARY_700
            },
            "&.Mui-error:after": {
                borderBottomColor: $cWFSm.COLORS_V2.ERROR_DARK,
                borderWidth: "0.125em"
            },
            "&.Mui-disabled:before": {
                borderBottomColor: $cWFSm.COLORS_V2.NEUTRAL_INACTIVE,
                borderWidth: "0.0625em"
            }
        },
        // Borders Outline
        "& .MuiOutlinedInput-root": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: $cWFSm.COLORS_V2.NEUTRAL_DARK,
                borderRadius: 0,
                borderWidth: "0.0625em"
            },
            "&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) > .MuiOutlinedInput-notchedOutline": {
                borderColor: $cWFSm.COLORS_V2.NEUTRAL_BLACK,
                borderWidth: "0.0625em"
            },
            "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
                borderColor: $cWFSm.COLORS_V2.PRIMARY_700,
                borderWidth: "0.125em"
            },
            "&.Mui-error > .MuiOutlinedInput-notchedOutline": {
                borderColor: $cWFSm.COLORS_V2.ERROR_DARK,
                borderWidth: "0.125em"
            },
            "&.Mui-disabled > .MuiOutlinedInput-notchedOutline": {
                borderColor: $cWFSm.COLORS_V2.NEUTRAL_INACTIVE,
                borderWidth: "0.0625em"
            }
        },
        // Helper text
        "& .MuiFormHelperText-root": {
            margin: "0.545em 0 0.0625em 0",
            fontSize: $cWFSm.FONT.SIZE.SMALL,
            color: $cWFSm.COLORS_V2.NEUTRAL_DARK,
            // Helper + Error
            "&.Mui-error": {
                color: $cWFSm.COLORS_V2.ERROR_DARK
            },
            // Helper + Disabled
            "&.Mui-disabled": {
                color: $cWFSm.COLORS_V2.NEUTRAL_INACTIVE
            }
        }
    },
    textFieldEnabled: {
        // Label style
        "& .MuiInputLabel-root": {
            lineHeight: "1.6em",
            color: $cWFSm.COLORS_V2.NEUTRAL_DARK,
            // Label + Focused
            "&.Mui-focused": {
                color: $cWFSm.COLORS_V2.PRIMARY_700
            }
        },
        "& .MuiInputLabel-root.MuiFormLabel-filled": {
            color: $cWFSm.COLORS_V2.NEUTRAL_BLACK
        }
    },
    textFieldDisabled: {},
    textFieldError: {
        // Error
        "& .MuiOutlinedInput-root.Mui-error:not(.Mui-disabled)": {
            // Error + Icon
            "& .MuiAutocomplete-endAdornment .MuiSvgIcon-root": {
                color: $cWFSm.COLORS_V2.ERROR_DARK
            }
        },
        // Label style
        "& .MuiInputLabel-root": {
            color: $cWFSm.COLORS_V2.ERROR_DARK,
            // Label + Error
            "&.Mui-error": {
                color: $cWFSm.COLORS_V2.ERROR_DARK
            }
        }
    },
    listItem: {
        fontSize: $cWFSm.FONT.SIZE.REGULAR,
        fontWeight: $cWFSm.FONT.WEIGHT.MEDIUM,
        // Label + Focused
        "& > .MuiAutocomplete-option.Mui-focused": {
            color: $cWFSm.COLORS_V2.PRIMARY_700
        }
    },
    errorIcon: {
        color: $cWFSm.COLORS_V2.ERROR_DARK,
        marginRight: "0.35em"
    }
});
module.exports.default = $3eb88a6b6cf2cdc3$var$useStylesV2;

});


parcelRegister("6JYdB", function(module, exports) {
"use strict";
var $4e85a825589c6366$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4e85a825589c6366$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4e85a825589c6366$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4e85a825589c6366$var$__createBinding(result, mod, k);
    }
    $4e85a825589c6366$var$__setModuleDefault(result, mod);
    return result;
};
var $4e85a825589c6366$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $4e85a825589c6366$var$react_1 = $4e85a825589c6366$var$__importStar((parcelRequire("acw62")));

const $4e85a825589c6366$var$isNumber_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("ci8Y7")));

const $4e85a825589c6366$var$isString_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("1SJGG")));

const $4e85a825589c6366$var$clone_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("bTYY2")));

var $cFZfS = parcelRequire("cFZfS");
var $dpjX2 = parcelRequire("dpjX2");
var $baBa1 = parcelRequire("baBa1");

var $7Frhn = parcelRequire("7Frhn");
var $81yMd = parcelRequire("81yMd");
var $30hyv = parcelRequire("30hyv");

var $i4KPV = parcelRequire("i4KPV");

const $4e85a825589c6366$var$shared_components_krg_checkbox_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("htqGM")));

const $4e85a825589c6366$var$table_header_react_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("70S0Q")));

const $4e85a825589c6366$var$table_pagination_react_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("9a9JP")));

const $4e85a825589c6366$var$table_body_react_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("7yHMO")));

const $4e85a825589c6366$var$action_cell_react_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("1H7m9")));

var $e1Hcy = parcelRequire("e1Hcy");

const $4e85a825589c6366$var$base_style_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("aCHxR")));

const $4e85a825589c6366$var$style_v1_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("jIKIQ")));

const $4e85a825589c6366$var$style_v2_1 = $4e85a825589c6366$var$__importDefault((parcelRequire("jFKWo")));
const $4e85a825589c6366$var$KrgDataTable = ({ id: id, className: className = "", style: style, containerClassName: containerClassName = "", containerStyle: containerStyle, config: config, theme: theme = $i4KPV.THEME_ENUM.v1, onClick: onClick, onBlur: onBlur, onFocus: onFocus })=>{
    const baseStyles = (0, $4e85a825589c6366$var$base_style_1.default)();
    const stylesV1 = (0, $4e85a825589c6366$var$style_v1_1.default)();
    const stylesV2 = (0, $4e85a825589c6366$var$style_v2_1.default)();
    const isV2Theme = theme === $i4KPV.THEME_ENUM.v2;
    const classes = Object.assign(Object.assign({}, baseStyles), isV2Theme ? stylesV2 : stylesV1);
    const { data: data, type: type, actionMenu: actionMenu, meta: meta, methods: methods, pagination: pagination } = config;
    const initialPageSize = (pagination === null || pagination === void 0 ? void 0 : pagination.initialPageSize) || 10;
    const hidePagination = (pagination === null || pagination === void 0 ? void 0 : pagination.isHidden) || false;
    const parentPage = (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 1;
    const [page, setPage] = (0, $4e85a825589c6366$var$react_1.useState)(parentPage);
    const [pageSize, setPageSize] = (0, $4e85a825589c6366$var$react_1.useState)(initialPageSize);
    const [order, setOrder] = (0, $4e85a825589c6366$var$react_1.useState)(false);
    const [orderBy, setOrderBy] = (0, $4e85a825589c6366$var$react_1.useState)(null);
    const [rows, setRows] = (0, $4e85a825589c6366$var$react_1.useState)([]);
    const [isAllChecked, setIsAllChecked] = (0, $4e85a825589c6366$var$react_1.useState)(false);
    const [notChecked, setNotChecked] = (0, $4e85a825589c6366$var$react_1.useState)([]);
    const [checkedRows, setCheckedRows] = (0, $4e85a825589c6366$var$react_1.useState)([]);
    const hideActionsColumn = !actionMenu || (actionMenu === null || actionMenu === void 0 ? void 0 : actionMenu.actions.length) === 0;
    const prependDefaultCheckboxToRows = (rowArray)=>{
        return rowArray.map((row)=>Object.assign(Object.assign({}, row), {
                isChecked: isAllChecked ? !notChecked.map((notCheckedRow)=>notCheckedRow.id).includes(row.id) : checkedRows.some((checkedRow)=>checkedRow.id === row.id)
            }));
    };
    (0, $4e85a825589c6366$var$react_1.useEffect)(()=>{
        if (pagination === null || pagination === void 0 ? void 0 : pagination.page) setPage(pagination === null || pagination === void 0 ? void 0 : pagination.page);
    }, [
        pagination === null || pagination === void 0 ? void 0 : pagination.page
    ]);
    (0, $4e85a825589c6366$var$react_1.useEffect)(()=>{
        setRows(type === $e1Hcy.TYPE_ENUM.checkbox ? prependDefaultCheckboxToRows(data.rows) : data.rows);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        type,
        data.rows
    ]);
    const isSortable = (col)=>{
        const defaultUnsortableTypes = [
            "thumbnail",
            "actions",
            "checkbox"
        ];
        return !(col.type && defaultUnsortableTypes.includes(col.type));
    };
    const actionsColumn = {
        field: "actions",
        headerName: theme === $i4KPV.THEME_ENUM.v2 ? "Actions" : "ACTIONS",
        type: $e1Hcy.CELL_TYPE_ENUM.actions,
        hasPreventBubbling: true,
        renderCell: (row, _)=>{
            return $4e85a825589c6366$var$react_1.default.createElement($4e85a825589c6366$var$action_cell_react_1.default, {
                actions: (actionMenu === null || actionMenu === void 0 ? void 0 : actionMenu.actions) || [],
                row: row,
                fontSize: style === null || style === void 0 ? void 0 : style.fontSize,
                isActionMenu: (actionMenu === null || actionMenu === void 0 ? void 0 : actionMenu.display) === $e1Hcy.DISPLAY_ENUM.menu,
                theme: theme
            });
        }
    };
    const checkboxColumn = {
        field: "isChecked",
        headerName: "",
        type: $e1Hcy.CELL_TYPE_ENUM.checkbox,
        renderCell: (row, _)=>{
            return $4e85a825589c6366$var$react_1.default.createElement($4e85a825589c6366$var$shared_components_krg_checkbox_1.default, {
                style: {
                    fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
                    justifyContent: "center"
                },
                isChecked: !!row.isChecked,
                theme: theme,
                onToggle: (isChecked)=>checkRow(isChecked, row)
            });
        },
        renderHeader: (_)=>{
            return $4e85a825589c6366$var$react_1.default.createElement($4e85a825589c6366$var$shared_components_krg_checkbox_1.default, {
                style: {
                    fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
                    justifyContent: "center"
                },
                isIndeterminate: getCheckedRows().length > 0 && rows.length !== getCheckedRows().length,
                isChecked: getCheckedRows().length > 0 && rows.length === getCheckedRows().length,
                theme: theme,
                onToggle: (isChecked)=>checkAllRows(isChecked)
            });
        }
    };
    const getPrependedColumns = ()=>{
        const prependedColumns = [];
        if (type === $e1Hcy.TYPE_ENUM.checkbox) prependedColumns.push(checkboxColumn);
        return prependedColumns;
    };
    const getAppendedColumns = ()=>hideActionsColumn ? [] : [
            actionsColumn
        ];
    const tableColumns = [
        ...getPrependedColumns(),
        ...data.columns,
        ...getAppendedColumns()
    ].map((column)=>Object.assign({
            isSortable: isSortable(column)
        }, column));
    const getRows = ()=>{
        if (pagination === null || pagination === void 0 ? void 0 : pagination.hasStrictRows) return rows;
        let modifiedRows;
        // Sort
        if (order && orderBy) modifiedRows = sortRows(rows);
        else modifiedRows = rows;
        // Paginate
        return modifiedRows.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
    };
    const getCheckedRows = (rowArray)=>{
        return (rowArray || rows).filter((row)=>row.isChecked);
    };
    const sortRows = (rowArray)=>{
        return (0, $4e85a825589c6366$var$clone_1.default)(rowArray || rows).sort((a, b)=>{
            let f1 = a[orderBy];
            let f2 = b[orderBy];
            let sortOrder = 1;
            const multiplier = order === "asc" ? 1 : -1;
            const sortedColumn = data.columns.find((c)=>c.field === orderBy);
            // Use inner title if it is a subtitle column
            if (sortedColumn.type === "subtitle") {
                f1 = f1.title;
                f2 = f2.title;
            }
            if ((0, $4e85a825589c6366$var$isNumber_1.default)(f1) && (0, $4e85a825589c6366$var$isNumber_1.default)(f2)) // Number comparison
            sortOrder = f1 - f2;
            else if ((0, $cFZfS.default)((0, $dpjX2.default)(f1)) && (0, $cFZfS.default)((0, $dpjX2.default)(f2))) // Date comparison
            sortOrder = (0, $baBa1.default)((0, $dpjX2.default)(f1), (0, $dpjX2.default)(f2)) ? 1 : -1;
            else if ((0, $4e85a825589c6366$var$isString_1.default)(f1) && (0, $4e85a825589c6366$var$isString_1.default)(f2)) // String comparison
            sortOrder = f1.localeCompare(f2);
            else // Other
            sortOrder = f1 > f2 ? 1 : -1;
            return multiplier * sortOrder;
        });
    };
    const checkRow = (isChecked, checkedRow)=>{
        var _a, _b;
        // Get modified states
        const newCheckedRow = Object.assign(Object.assign({}, checkedRow), {
            isChecked: isChecked
        });
        const newRows = rows.map((row)=>row.id !== newCheckedRow.id ? row : Object.assign(Object.assign({}, row), {
                isChecked: isChecked
            }));
        // Set rows
        setRows(newRows);
        if (isAllChecked) {
            const tmpNotChecked = notChecked;
            if (!isChecked) {
                tmpNotChecked.push(checkedRow);
                setNotChecked([
                    ...tmpNotChecked
                ]);
            } else setNotChecked([
                ...tmpNotChecked.filter((row)=>checkedRow.id !== row.id)
            ]);
            (_a = methods === null || methods === void 0 ? void 0 : methods.onUncheckedRowsChange) === null || _a === void 0 || _a.call(methods, ((pagination === null || pagination === void 0 ? void 0 : pagination.totalRowCount) || rows.length) !== tmpNotChecked.length, [
                ...tmpNotChecked
            ]);
        }
        // Inform parent object about the isChecked row if the function is defined
        let tmpCheckedRows = checkedRows;
        // Adds isChecked items to checkedRows stack
        tmpCheckedRows = tmpCheckedRows.concat(newRows.filter((row)=>row.isChecked && !tmpCheckedRows.some((uncheckedRow)=>uncheckedRow.id === row.id)));
        const tmpUncheckedRows = newRows.filter((row)=>!row.isChecked);
        // Removes unchecked rows from checkedRows stack
        tmpCheckedRows = tmpCheckedRows.filter((row)=>!tmpUncheckedRows.some((uncheckedRow)=>uncheckedRow.id === row.id));
        setCheckedRows(tmpCheckedRows);
        (_b = methods === null || methods === void 0 ? void 0 : methods.onRowCheck) === null || _b === void 0 || _b.call(methods, isChecked, newCheckedRow, tmpCheckedRows);
    };
    const checkAllRows = (isChecked)=>{
        var _a, _b;
        (_a = methods === null || methods === void 0 ? void 0 : methods.onUncheckedRowsChange) === null || _a === void 0 || _a.call(methods, isChecked, []);
        setNotChecked([]);
        setIsAllChecked(isChecked);
        // Get modified states
        const newRows = rows.map((row)=>Object.assign(Object.assign({}, row), {
                isChecked: isChecked
            }));
        // Set rows
        setRows(newRows);
        // Inform parent component about the checked rows if the function is defined.
        // Instead of a diff array, an empty array is set as new checked rows
        // because of performance concerns
        (_b = methods === null || methods === void 0 ? void 0 : methods.onRowCheck) === null || _b === void 0 || _b.call(methods, isChecked, [], getCheckedRows(newRows));
    };
    const changeTableOrder = (orderParam, orderByParam)=>{
        var _a;
        setOrder(orderParam);
        setOrderBy(orderByParam);
        (_a = methods === null || methods === void 0 ? void 0 : methods.onTableOrderChange) === null || _a === void 0 || _a.call(methods, orderParam, orderByParam);
    };
    const changePagination = (pageParam, pageSizeParam)=>{
        var _a;
        setPage(pageParam);
        setPageSize(pageSizeParam);
        (_a = methods === null || methods === void 0 ? void 0 : methods.onPaginationChange) === null || _a === void 0 || _a.call(methods, pageParam, pageSizeParam);
    };
    const noResults = $4e85a825589c6366$var$react_1.default.createElement("div", {
        className: classes.noResults
    }, "No Results");
    return $4e85a825589c6366$var$react_1.default.createElement($7Frhn.default, {
        className: classes.paper,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick
    }, $4e85a825589c6366$var$react_1.default.createElement($81yMd.default, {
        className: `${classes.tableContainer} ${containerClassName}`,
        style: containerStyle
    }, $4e85a825589c6366$var$react_1.default.createElement($30hyv.default, {
        id: id,
        className: `${classes.table} ${className}`,
        style: style,
        stickyHeader: meta === null || meta === void 0 ? void 0 : meta.isStickyHeader
    }, $4e85a825589c6366$var$react_1.default.createElement($4e85a825589c6366$var$table_header_react_1.default, {
        ref: meta === null || meta === void 0 ? void 0 : meta.headerRef,
        columns: tableColumns,
        onTableOrderChange: changeTableOrder,
        isLoading: pagination === null || pagination === void 0 ? void 0 : pagination.isLoading,
        id: id,
        theme: theme
    }), $4e85a825589c6366$var$react_1.default.createElement($4e85a825589c6366$var$table_body_react_1.default, {
        id: id,
        columns: tableColumns,
        rows: getRows(),
        hasCheckboxSelection: type === $e1Hcy.TYPE_ENUM.checkbox,
        rowClassName: meta === null || meta === void 0 ? void 0 : meta.rowClassName,
        columnClassName: meta === null || meta === void 0 ? void 0 : meta.columnClassName,
        theme: theme,
        onRowChecked: checkRow,
        onRowClick: methods === null || methods === void 0 ? void 0 : methods.onRowClick
    }))), getRows().length === 0 && !(meta === null || meta === void 0 ? void 0 : meta.isNoResultsLabelHidden) && noResults, !hidePagination && $4e85a825589c6366$var$react_1.default.createElement($4e85a825589c6366$var$table_pagination_react_1.default, {
        page: page,
        pageSize: pageSize,
        initialPageSize: initialPageSize,
        rowCount: (pagination === null || pagination === void 0 ? void 0 : pagination.totalRowCount) || rows.length,
        fontSize: style === null || style === void 0 ? void 0 : style.fontSize,
        isLoading: pagination === null || pagination === void 0 ? void 0 : pagination.isLoading,
        onPaginationChange: changePagination,
        theme: theme
    }));
};
$4e85a825589c6366$var$KrgDataTable.CELL_TYPE_ENUM = $e1Hcy.CELL_TYPE_ENUM;
$4e85a825589c6366$var$KrgDataTable.DISPLAY_ENUM = $e1Hcy.DISPLAY_ENUM;
$4e85a825589c6366$var$KrgDataTable.TYPE_ENUM = $e1Hcy.TYPE_ENUM;
$4e85a825589c6366$var$KrgDataTable.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $4e85a825589c6366$var$KrgDataTable;

});
parcelRegister("ci8Y7", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $8f2e1f7d7f8ca8b6$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $8f2e1f7d7f8ca8b6$var$isNumber(value) {
    return typeof value == "number" || $8l89S(value) && $eq6CV(value) == $8f2e1f7d7f8ca8b6$var$numberTag;
}
module.exports = $8f2e1f7d7f8ca8b6$var$isNumber;

});

parcelRegister("bTYY2", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $8aa41f9fe04bb5cc$var$clone(value) {
    return $kqX4j(value, $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $8aa41f9fe04bb5cc$var$clone;

});
parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = "[object Arguments]", $ee040e257a097984$var$arrayTag = "[object Array]", $ee040e257a097984$var$boolTag = "[object Boolean]", $ee040e257a097984$var$dateTag = "[object Date]", $ee040e257a097984$var$errorTag = "[object Error]", $ee040e257a097984$var$funcTag = "[object Function]", $ee040e257a097984$var$genTag = "[object GeneratorFunction]", $ee040e257a097984$var$mapTag = "[object Map]", $ee040e257a097984$var$numberTag = "[object Number]", $ee040e257a097984$var$objectTag = "[object Object]", $ee040e257a097984$var$regexpTag = "[object RegExp]", $ee040e257a097984$var$setTag = "[object Set]", $ee040e257a097984$var$stringTag = "[object String]", $ee040e257a097984$var$symbolTag = "[object Symbol]", $ee040e257a097984$var$weakMapTag = "[object WeakMap]";
var $ee040e257a097984$var$arrayBufferTag = "[object ArrayBuffer]", $ee040e257a097984$var$dataViewTag = "[object DataView]", $ee040e257a097984$var$float32Tag = "[object Float32Array]", $ee040e257a097984$var$float64Tag = "[object Float64Array]", $ee040e257a097984$var$int8Tag = "[object Int8Array]", $ee040e257a097984$var$int16Tag = "[object Int16Array]", $ee040e257a097984$var$int32Tag = "[object Int32Array]", $ee040e257a097984$var$uint8Tag = "[object Uint8Array]", $ee040e257a097984$var$uint8ClampedTag = "[object Uint8ClampedArray]", $ee040e257a097984$var$uint16Tag = "[object Uint16Array]", $ee040e257a097984$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, "Map");
module.exports = $19b02faa57603249$var$Map;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});



parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype["delete"] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $c8dKl,
        "map": new ($2cJKd || $iYOpJ),
        "string": new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, "create");
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $4hwTc) $4hwTc(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});
parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});



parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});

parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});



parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});
parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});




parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});
parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});



parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});



parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, "DataView");
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, "Promise");
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, "Set");
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, "WeakMap");
module.exports = $aedce50092a1e6a6$var$WeakMap;

});


parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $392dfd68f4953502$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = "[object Boolean]", $85aa01d56b12d536$var$dateTag = "[object Date]", $85aa01d56b12d536$var$mapTag = "[object Map]", $85aa01d56b12d536$var$numberTag = "[object Number]", $85aa01d56b12d536$var$regexpTag = "[object RegExp]", $85aa01d56b12d536$var$setTag = "[object Set]", $85aa01d56b12d536$var$stringTag = "[object String]", $85aa01d56b12d536$var$symbolTag = "[object Symbol]";
var $85aa01d56b12d536$var$arrayBufferTag = "[object ArrayBuffer]", $85aa01d56b12d536$var$dataViewTag = "[object DataView]", $85aa01d56b12d536$var$float32Tag = "[object Float32Array]", $85aa01d56b12d536$var$float64Tag = "[object Float64Array]", $85aa01d56b12d536$var$int8Tag = "[object Int8Array]", $85aa01d56b12d536$var$int16Tag = "[object Int16Array]", $85aa01d56b12d536$var$int32Tag = "[object Int32Array]", $85aa01d56b12d536$var$uint8Tag = "[object Uint8Array]", $85aa01d56b12d536$var$uint8ClampedTag = "[object Uint8ClampedArray]", $85aa01d56b12d536$var$uint16Tag = "[object Uint16Array]", $85aa01d56b12d536$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});


parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});


parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});




parcelRegister("dpjX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2d1611e11d9224$export$2e2bcd8739ae039);

var $6Q3SV = parcelRequire("6Q3SV");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $9c2d1611e11d9224$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $4LmDH.default)(1, arguments);
    var additionalDigits = (0, $esGEx.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $9c2d1611e11d9224$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9c2d1611e11d9224$var$parseYear(dateStrings.date, additionalDigits);
        date = $9c2d1611e11d9224$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9c2d1611e11d9224$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9c2d1611e11d9224$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9c2d1611e11d9224$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9c2d1611e11d9224$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9c2d1611e11d9224$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9c2d1611e11d9224$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9c2d1611e11d9224$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9c2d1611e11d9224$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9c2d1611e11d9224$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9c2d1611e11d9224$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9c2d1611e11d9224$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9c2d1611e11d9224$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9c2d1611e11d9224$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9c2d1611e11d9224$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9c2d1611e11d9224$var$parseDateUnit(captures[1]);
    var month = $9c2d1611e11d9224$var$parseDateUnit(captures[2]) - 1;
    var day = $9c2d1611e11d9224$var$parseDateUnit(captures[3]);
    var week = $9c2d1611e11d9224$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9c2d1611e11d9224$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9c2d1611e11d9224$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9c2d1611e11d9224$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9c2d1611e11d9224$var$validateDate(year, month, day) || !$9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9c2d1611e11d9224$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9c2d1611e11d9224$var$parseTime(timeString) {
    var captures = timeString.match($9c2d1611e11d9224$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9c2d1611e11d9224$var$parseTimeUnit(captures[1]);
    var minutes = $9c2d1611e11d9224$var$parseTimeUnit(captures[2]);
    var seconds = $9c2d1611e11d9224$var$parseTimeUnit(captures[3]);
    if (!$9c2d1611e11d9224$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute) + seconds * 1000;
}
function $9c2d1611e11d9224$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $9c2d1611e11d9224$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($9c2d1611e11d9224$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9c2d1611e11d9224$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute));
}
function $9c2d1611e11d9224$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9c2d1611e11d9224$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9c2d1611e11d9224$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9c2d1611e11d9224$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9c2d1611e11d9224$var$daysInMonths[month] || ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9c2d1611e11d9224$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9c2d1611e11d9224$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9c2d1611e11d9224$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("81yMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7964a6269b66c8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $lNHXc = parcelRequire("lNHXc");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5d7964a6269b66c8$var$_excluded = [
    "className",
    "component"
];
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lNHXc.getTableContainerUtilityClass), classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $d8seH.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: "100%",
    overflowX: "auto"
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTableContainer"
    });
    const { className: className, component: component = "div" } = props, other = (0, $1En50.default)(props, $5d7964a6269b66c8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, (0, $8nd05.default)({
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
$5d7964a6269b66c8$var$TableContainer.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Table`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $5d7964a6269b66c8$export$2e2bcd8739ae039 = $5d7964a6269b66c8$var$TableContainer;

});
parcelRegister("lNHXc", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", () => $fdf044e88b1c9ad4$export$eed427986a7abdf9);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fdf044e88b1c9ad4$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)("MuiTableContainer", slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $beCSm.default)("MuiTableContainer", [
    "root"
]);
var $fdf044e88b1c9ad4$export$2e2bcd8739ae039 = $fdf044e88b1c9ad4$var$tableContainerClasses;

});


parcelRegister("30hyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $22fefd5f207422b3$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jWrFr = parcelRequire("jWrFr");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $5kXxI = parcelRequire("5kXxI");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $22fefd5f207422b3$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5kXxI.getTableUtilityClass), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $8nd05.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $22fefd5f207422b3$var$defaultComponent = "table";
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $1En50.default)(props, $22fefd5f207422b3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jWrFr.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, (0, $8nd05.default)({
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
$22fefd5f207422b3$var$Table.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */ padding: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "checkbox",
        "none",
        "normal"
    ]),
    /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */ stickyHeader: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;

});
parcelRegister("jWrFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e848e543ed3bf349$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
$e848e543ed3bf349$var$TableContext.displayName = "TableContext";
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;

});

parcelRegister("5kXxI", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", () => $3e2d01fd3f88b8c8$export$315cb19215f77ce0);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)("MuiTable", slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $beCSm.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;

});


parcelRegister("70S0Q", function(module, exports) {
"use strict";
var $51b26e4b645b8f09$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $51b26e4b645b8f09$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $51b26e4b645b8f09$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $51b26e4b645b8f09$var$__createBinding(result, mod, k);
    }
    $51b26e4b645b8f09$var$__setModuleDefault(result, mod);
    return result;
};
var $51b26e4b645b8f09$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $51b26e4b645b8f09$var$react_1 = $51b26e4b645b8f09$var$__importStar((parcelRequire("acw62")));

var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $elyLx = parcelRequire("elyLx");
var $gjoVE = parcelRequire("gjoVE");
var $jTnBY = parcelRequire("jTnBY");

var $i4KPV = parcelRequire("i4KPV");

var $e1Hcy = parcelRequire("e1Hcy");

const $51b26e4b645b8f09$var$table_header_style_v1_1 = $51b26e4b645b8f09$var$__importDefault((parcelRequire("2V6IG")));

const $51b26e4b645b8f09$var$table_header_style_v2_1 = $51b26e4b645b8f09$var$__importDefault((parcelRequire("kt3uM")));

const $51b26e4b645b8f09$var$table_header_base_style_1 = $51b26e4b645b8f09$var$__importDefault((parcelRequire("2zS3T")));
const $51b26e4b645b8f09$var$TableHeader = (0, $51b26e4b645b8f09$var$react_1.forwardRef)(({ columns: columns, onTableOrderChange: onTableOrderChange, isLoading: isLoading, id: id, theme: theme }, ref)=>{
    const baseStyles = (0, $51b26e4b645b8f09$var$table_header_base_style_1.default)();
    const stylesV1 = (0, $51b26e4b645b8f09$var$table_header_style_v1_1.default)();
    const stylesV2 = (0, $51b26e4b645b8f09$var$table_header_style_v2_1.default)();
    const classes = Object.assign(Object.assign({}, baseStyles), theme === $i4KPV.THEME_ENUM.v2 ? stylesV2 : stylesV1);
    const [order, setOrder] = (0, $51b26e4b645b8f09$var$react_1.useState)(false);
    const [orderBy, setOrderBy] = (0, $51b26e4b645b8f09$var$react_1.useState)(null);
    const [tableRowId] = (0, $51b26e4b645b8f09$var$react_1.useState)(`tableRow-${id || Math.random()}`);
    (0, $51b26e4b645b8f09$var$react_1.useImperativeHandle)(ref, ()=>({
            setOrder: (tableOrder, tableOrderBy)=>{
                let newOrder;
                let newOrderBy;
                const columnExists = columns.find((column)=>column.field === tableOrderBy);
                if (columnExists) {
                    newOrder = tableOrder;
                    newOrderBy = tableOrderBy;
                } else {
                    newOrder = false;
                    newOrderBy = null;
                }
                setOrder(newOrder);
                setOrderBy(newOrderBy);
                if (onTableOrderChange) onTableOrderChange(newOrder, newOrderBy);
            }
        }));
    const toggleOrder = (field)=>{
        const isNewOrderField = field !== orderBy;
        const newOrder = isNewOrderField ? "asc" : order === "asc" ? "desc" : order === "desc" ? false : "asc";
        const newField = newOrder ? field : null;
        setOrder(newOrder);
        setOrderBy(field);
        if (onTableOrderChange) onTableOrderChange(newOrder, newField);
    };
    const tableCellAlign = (column, index)=>{
        if (!column.isSticky) return {};
        const table = document.getElementById(tableRowId);
        if (table && table.cells.length > 0) {
            const lengthOfColumn = table.cells[index] ? table.cells[index].getBoundingClientRect().x : 20;
            return {
                left: lengthOfColumn - 20
            };
        }
        return {};
    };
    return $51b26e4b645b8f09$var$react_1.default.createElement($hjXJ8.default, {
        className: classes.root
    }, $51b26e4b645b8f09$var$react_1.default.createElement($2XjE0.default, {
        id: tableRowId
    }, columns.map((column, idx)=>{
        var _a, _b;
        return $51b26e4b645b8f09$var$react_1.default.createElement($elyLx.default, {
            key: column.field,
            className: `${column.isSticky ? classes.stickyColumn : ""}` + ` ${classes.tableHeaderCell}` + ` ${column.field === "isChecked" ? classes.tableHeaderCellCheckbox : ""}` + ` ${column.type === "actions" ? classes.tableHeaderActionsCell : ""}` + ` ${column.type !== $e1Hcy.CELL_TYPE_ENUM.checkbox && idx === 0 ? classes.tableHeaderFirstCellPadding : ""}` + ` ${isLoading ? classes.tableHeaderCellDisabled : ""}`,
            sortDirection: orderBy === column.field ? order : false,
            style: Object.assign(Object.assign(Object.assign({}, column.width ? {
                minWidth: column.width,
                maxWidth: column.width,
                width: column.width
            } : {}), tableCellAlign(column, idx)), {
                textAlign: column.textAlignment || $e1Hcy.TEXT_ALIGNMENT.left
            })
        }, column.renderHeader ? // Custom header render
        column.renderHeader(column) : // Sorted header render
        column.isSortable ? $51b26e4b645b8f09$var$react_1.default.createElement($gjoVE.default, {
            active: orderBy === column.field && !!order,
            direction: orderBy === column.field ? order || "asc" : "asc",
            onClick: ()=>toggleOrder(column.field)
        }, theme === $i4KPV.THEME_ENUM.v2 ? (0, $jTnBY.default)(column.headerName) : (_a = column.headerName) === null || _a === void 0 ? void 0 : _a.toLocaleUpperCase()) : // Default header render
        $51b26e4b645b8f09$var$react_1.default.createElement("span", null, theme === $i4KPV.THEME_ENUM.v2 ? (0, $jTnBY.default)(column.headerName) : (_b = column.headerName) === null || _b === void 0 ? void 0 : _b.toLocaleUpperCase()));
    })));
});
module.exports.default = $51b26e4b645b8f09$var$TableHeader;

});
parcelRegister("hjXJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c28a8e795911dc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $RbMj7 = parcelRequire("RbMj7");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $hMbPk = parcelRequire("hMbPk");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c9c28a8e795911dc$var$_excluded = [
    "className",
    "component"
];
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hMbPk.getTableHeadUtilityClass), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: "head"
};
const $c9c28a8e795911dc$var$defaultComponent = "thead";
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent } = props, other = (0, $1En50.default)(props, $c9c28a8e795911dc$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RbMj7.default).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
$c9c28a8e795911dc$var$TableHead.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;

});
parcelRegister("RbMj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fe163f52c859c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
$09fe163f52c859c8$var$Tablelvl2Context.displayName = "Tablelvl2Context";
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;

});

parcelRegister("hMbPk", function(module, exports) {

$parcel$export(module.exports, "getTableHeadUtilityClass", () => $cf1017f12785ebe4$export$2e731cea2d1c2392);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $4Cod0.default)("MuiTableHead", slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $beCSm.default)("MuiTableHead", [
    "root"
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;

});


parcelRegister("2XjE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22705465ad6920f8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $RbMj7 = parcelRequire("RbMj7");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $4iLi6 = parcelRequire("4iLi6");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $22705465ad6920f8$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4iLi6.getTableRowUtilityClass), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $4iLi6.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $4iLi6.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $22705465ad6920f8$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $1En50.default)(props, $22705465ad6920f8$var$_excluded);
    const tablelvl2 = $acw62.useContext((0, $RbMj7.default));
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
$22705465ad6920f8$var$TableRow.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Should be valid `<tr>` children such as `TableCell`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the table row will shade on hover.
   * @default false
   */ hover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;

});
parcelRegister("4iLi6", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", () => $321d86e199abda5b$export$ba0a6d6c28940107);
$parcel$export(module.exports, "default", () => $321d86e199abda5b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)("MuiTableRow", slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $beCSm.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;

});


parcelRegister("elyLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71dfe9e22152ea2$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $jTnBY = parcelRequire("jTnBY");

var $jWrFr = parcelRequire("jWrFr");

var $RbMj7 = parcelRequire("RbMj7");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $ev9nI = parcelRequire("ev9nI");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $a71dfe9e22152ea2$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $jTnBY.default)(align)}`,
            padding !== "normal" && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ev9nI.getTableCellUtilityClass), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $kSnzZ.lighten)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.88) : (0, $kSnzZ.darken)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $ev9nI.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1En50.default)(props, $a71dfe9e22152ea2$var$_excluded);
    const table = $acw62.useContext((0, $jWrFr.default));
    const tablelvl2 = $acw62.useContext((0, $RbMj7.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
$a71dfe9e22152ea2$var$TableCell.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "center",
        "inherit",
        "justify",
        "left",
        "right"
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */ padding: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "checkbox",
        "none",
        "normal"
    ]),
    /**
   * Set scope attribute.
   */ scope: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Set aria-sort direction.
   */ sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "asc",
        "desc",
        false
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "body",
            "footer",
            "head"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;

});
parcelRegister("ev9nI", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", () => $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b);
$parcel$export(module.exports, "default", () => $a8eb3ce62ab46dc7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)("MuiTableCell", slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;

});


parcelRegister("gjoVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $be01c206ebbcc5af$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $6n0Ko = parcelRequire("6n0Ko");

var $5egRk = parcelRequire("5egRk");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $9NhvM = parcelRequire("9NhvM");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $be01c206ebbcc5af$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $be01c206ebbcc5af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active"
        ],
        icon: [
            "icon",
            `iconDirection${(0, $jTnBY.default)(direction)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9NhvM.getTableSortLabelUtilityClass), classes);
};
const $be01c206ebbcc5af$var$TableSortLabelRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: "MuiTableSortLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: "pointer",
        display: "inline-flex",
        justifyContent: "flex-start",
        flexDirection: "inherit",
        alignItems: "center",
        "&:focus": {
            color: (theme.vars || theme).palette.text.secondary
        },
        "&:hover": {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $9NhvM.default).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $9NhvM.default).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $9NhvM.default).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $be01c206ebbcc5af$var$TableSortLabelIcon = (0, $d8seH.default)("span", {
    name: "MuiTableSortLabel",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $jTnBY.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            "opacity",
            "transform"
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: "none"
    }, ownerState.direction === "desc" && {
        transform: "rotate(0deg)"
    }, ownerState.direction === "asc" && {
        transform: "rotate(180deg)"
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $be01c206ebbcc5af$var$TableSortLabel = /*#__PURE__*/ $acw62.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTableSortLabel"
    });
    const { active: active = false, children: children, className: className, direction: direction = "asc", hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $5egRk.default) } = props, other = (0, $1En50.default)(props, $be01c206ebbcc5af$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $be01c206ebbcc5af$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($be01c206ebbcc5af$var$TableSortLabelRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($be01c206ebbcc5af$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $9QePP.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
$be01c206ebbcc5af$var$TableSortLabel.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */ active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Label contents, the arrow will be appended automatically.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The current sort direction.
   * @default 'asc'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "asc",
        "desc"
    ]),
    /**
   * Hide sort icon when active is false.
   * @default false
   */ hideSortIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $be01c206ebbcc5af$export$2e2bcd8739ae039 = $be01c206ebbcc5af$var$TableSortLabel;

});
parcelRegister("5egRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ceb567076b478bc$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3ceb567076b478bc$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");

});

parcelRegister("9NhvM", function(module, exports) {

$parcel$export(module.exports, "getTableSortLabelUtilityClass", () => $72164616b8f12725$export$645d356c89a51794);
$parcel$export(module.exports, "default", () => $72164616b8f12725$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $72164616b8f12725$export$645d356c89a51794(slot) {
    return (0, $4Cod0.default)("MuiTableSortLabel", slot);
}
const $72164616b8f12725$var$tableSortLabelClasses = (0, $beCSm.default)("MuiTableSortLabel", [
    "root",
    "active",
    "icon",
    "iconDirectionDesc",
    "iconDirectionAsc"
]);
var $72164616b8f12725$export$2e2bcd8739ae039 = $72164616b8f12725$var$tableSortLabelClasses;

});


parcelRegister("e1Hcy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TEXT_ALIGNMENT = module.exports.ACTION_TYPE_ENUM = module.exports.CELL_TYPE_ENUM = module.exports.TYPE_ENUM = module.exports.DISPLAY_ENUM = void 0;
var $a362ab9b602dd8b3$var$DISPLAY_ENUM;
(function(DISPLAY_ENUM) {
    DISPLAY_ENUM["separate"] = "separate";
    DISPLAY_ENUM["menu"] = "menu";
})($a362ab9b602dd8b3$var$DISPLAY_ENUM || (module.exports.DISPLAY_ENUM = $a362ab9b602dd8b3$var$DISPLAY_ENUM = {}));
var $a362ab9b602dd8b3$var$TYPE_ENUM;
(function(TYPE_ENUM) {
    TYPE_ENUM["standard"] = "standard";
    TYPE_ENUM["checkbox"] = "checkbox";
})($a362ab9b602dd8b3$var$TYPE_ENUM || (module.exports.TYPE_ENUM = $a362ab9b602dd8b3$var$TYPE_ENUM = {}));
var $a362ab9b602dd8b3$var$CELL_TYPE_ENUM;
(function(CELL_TYPE_ENUM) {
    CELL_TYPE_ENUM["thumbnail"] = "thumbnail";
    CELL_TYPE_ENUM["subtitle"] = "subtitle";
    CELL_TYPE_ENUM["actions"] = "actions";
    CELL_TYPE_ENUM["checkbox"] = "checkbox";
})($a362ab9b602dd8b3$var$CELL_TYPE_ENUM || (module.exports.CELL_TYPE_ENUM = $a362ab9b602dd8b3$var$CELL_TYPE_ENUM = {}));
var $a362ab9b602dd8b3$var$ACTION_TYPE_ENUM;
(function(ACTION_TYPE_ENUM) {
    ACTION_TYPE_ENUM["edit"] = "edit";
    ACTION_TYPE_ENUM["duplicate"] = "duplicate";
    ACTION_TYPE_ENUM["preview"] = "preview";
    ACTION_TYPE_ENUM["archive"] = "archive";
    ACTION_TYPE_ENUM["logo"] = "logo";
    ACTION_TYPE_ENUM["approve"] = "approve";
    ACTION_TYPE_ENUM["deny"] = "deny";
    ACTION_TYPE_ENUM["unarchive"] = "unarchive";
    ACTION_TYPE_ENUM["archiveUser"] = "archive-user";
    ACTION_TYPE_ENUM["reactivateUser"] = "reactivate-user";
})($a362ab9b602dd8b3$var$ACTION_TYPE_ENUM || (module.exports.ACTION_TYPE_ENUM = $a362ab9b602dd8b3$var$ACTION_TYPE_ENUM = {}));
var $a362ab9b602dd8b3$var$TEXT_ALIGNMENT;
(function(TEXT_ALIGNMENT) {
    TEXT_ALIGNMENT["left"] = "left";
    TEXT_ALIGNMENT["center"] = "center";
    TEXT_ALIGNMENT["right"] = "right";
})($a362ab9b602dd8b3$var$TEXT_ALIGNMENT || (module.exports.TEXT_ALIGNMENT = $a362ab9b602dd8b3$var$TEXT_ALIGNMENT = {}));

});

parcelRegister("2V6IG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $22061e048ae9eb9a$var$useStylesV1 = (0, $1GFtd.default)({
    tableHeaderCell: {
        backgroundColor: $i4KPV.COLORS.BLACK_INACTIVE,
        borderColor: $i4KPV.COLORS.GRAY_DIVIDER,
        color: $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS,
        fontSize: "0.8em",
        lineHeight: 1.2,
        padding: "0.7em 0.5em"
    },
    stickyColumn: {
        position: "sticky",
        zIndex: 99,
        backgroundColor: $i4KPV.COLORS.BLACK_INACTIVE
    }
});
module.exports.default = $22061e048ae9eb9a$var$useStylesV1;

});

parcelRegister("kt3uM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $ee693a38df4aa82d$var$useStylesV2 = (0, $1GFtd.default)({
    tableHeaderCell: {
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        borderColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
        color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        fontSize: "0.8em",
        lineHeight: 1.2,
        padding: "0.7em 0.5em"
    },
    stickyColumn: {
        position: "sticky",
        zIndex: 99,
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE
    }
});
module.exports.default = $ee693a38df4aa82d$var$useStylesV2;

});

parcelRegister("2zS3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $1e08c92fc51c7104$var$useBaseStyles = (0, $1GFtd.default)({
    root: {
        height: "2.8em"
    },
    tableHeaderCellCheckbox: {
        textAlign: "center",
        width: "3em"
    },
    tableHeaderActionsCell: {
        width: "10em"
    },
    tableHeaderFirstCellPadding: {
        paddingLeft: "1.5em"
    },
    tableHeaderCellDisabled: {
        opacity: 0.7,
        pointerEvents: "none"
    }
});
module.exports.default = $1e08c92fc51c7104$var$useBaseStyles;

});


parcelRegister("9a9JP", function(module, exports) {
"use strict";
var $6abc9a024c710555$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6abc9a024c710555$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6abc9a024c710555$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6abc9a024c710555$var$__createBinding(result, mod, k);
    }
    $6abc9a024c710555$var$__setModuleDefault(result, mod);
    return result;
};
var $6abc9a024c710555$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6abc9a024c710555$var$react_1 = $6abc9a024c710555$var$__importStar((parcelRequire("acw62")));

const $6abc9a024c710555$var$lodash_1 = $6abc9a024c710555$var$__importDefault((parcelRequire("f1q41")));

var $kBtCg = parcelRequire("kBtCg");

var $i4KPV = parcelRequire("i4KPV");

const $6abc9a024c710555$var$table_pagination_base_style_1 = $6abc9a024c710555$var$__importDefault((parcelRequire("1spQL")));

const $6abc9a024c710555$var$table_pagination_style_v1_1 = $6abc9a024c710555$var$__importDefault((parcelRequire("4UigU")));

const $6abc9a024c710555$var$table_pagination_style_v2_1 = $6abc9a024c710555$var$__importDefault((parcelRequire("jKmrs")));
const $6abc9a024c710555$var$TablePagination = ({ rowCount: rowCount, page: page, pageSize: pageSize, initialPageSize: initialPageSize, fontSize: fontSize, isLoading: isLoading = false, onPaginationChange: onPaginationChange, theme: theme })=>{
    const props = {
        fontSize: fontSize
    };
    const baseStyles = (0, $6abc9a024c710555$var$table_pagination_base_style_1.default)(props);
    const v1Styles = (0, $6abc9a024c710555$var$table_pagination_style_v1_1.default)(props);
    const v2Styles = (0, $6abc9a024c710555$var$table_pagination_style_v2_1.default)(props);
    const classes = Object.assign(Object.assign({}, baseStyles), theme === $i4KPV.THEME_ENUM.v2 ? v2Styles : v1Styles);
    const [isOpen, setOpen] = (0, $6abc9a024c710555$var$react_1.useState)(false);
    const pageSizes = $6abc9a024c710555$var$lodash_1.default.uniq([
        initialPageSize,
        10,
        50,
        100
    ].sort((a, b)=>a - b));
    const disabledClass = isLoading ? classes.tablePaginationDisabled : "";
    const openClass = isOpen ? classes.tablePaginationOpen : "";
    return $6abc9a024c710555$var$react_1.default.createElement($kBtCg.default, {
        className: `${classes.tablePagination} ${disabledClass} ${openClass}`,
        classes: {
            menuItem: classes.tablePaginationMenuItem
        },
        rowsPerPageOptions: pageSizes,
        component: "div",
        count: rowCount,
        rowsPerPage: pageSize,
        page: page - 1,
        SelectProps: {
            MenuProps: {
                classes: {
                    paper: classes.tablePaginationMenuPaper
                }
            },
            onOpen: ()=>{
                setOpen(true);
            },
            onClose: ()=>{
                setOpen(false);
            }
        },
        onPageChange: (e, newPage)=>{
            onPaginationChange === null || onPaginationChange === void 0 || onPaginationChange(newPage + 1, pageSize);
        },
        onRowsPerPageChange: (e)=>{
            const newPageSize = parseInt(e.target.value, 10);
            onPaginationChange === null || onPaginationChange === void 0 || onPaginationChange(1, newPageSize);
        }
    });
};
module.exports.default = $6abc9a024c710555$var$TablePagination;

});
parcelRegister("kBtCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $effe3c7e7b91170d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $iuSDM = parcelRequire("iuSDM");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $awhpc = parcelRequire("awhpc");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $95gUw = parcelRequire("95gUw");

var $2iAqv = parcelRequire("2iAqv");

var $cX7V2 = parcelRequire("cX7V2");

var $elyLx = parcelRequire("elyLx");

var $kyRsi = parcelRequire("kyRsi");

var $dLLxV = parcelRequire("dLLxV");

var $5A6d3 = parcelRequire("5A6d3");

var $inBkn = parcelRequire("inBkn");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $d8seH.default)((0, $elyLx.default), {
    name: "MuiTablePagination",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: "auto",
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        "&:last-child": {
            padding: 0
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $d8seH.default)((0, $kyRsi.default), {
    name: "MuiTablePagination",
    slot: "Toolbar",
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $inBkn.default).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up("sm")]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $inBkn.default).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $d8seH.default)("div", {
    name: "MuiTablePagination",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: "1 1 100%"
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $d8seH.default)("p", {
    name: "MuiTablePagination",
    slot: "SelectLabel",
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $d8seH.default)((0, $cX7V2.default), {
    name: "MuiTablePagination",
    slot: "Select",
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $inBkn.default).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $inBkn.default).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: "inherit",
    fontSize: "inherit",
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $inBkn.default).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: "right",
        textAlignLast: "right" // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $d8seH.default)((0, $2iAqv.default), {
    name: "MuiTablePagination",
    slot: "MenuItem",
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $d8seH.default)("p", {
    name: "MuiTablePagination",
    slot: "DisplayedRows",
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        toolbar: [
            "toolbar"
        ],
        spacer: [
            "spacer"
        ],
        selectLabel: [
            "selectLabel"
        ],
        select: [
            "select"
        ],
        input: [
            "input"
        ],
        selectIcon: [
            "selectIcon"
        ],
        menuItem: [
            "menuItem"
        ],
        displayedRows: [
            "displayedRows"
        ],
        actions: [
            "actions"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $inBkn.getTablePaginationUtilityClass), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTablePagination"
    });
    const { ActionsComponent: ActionsComponent = (0, $dLLxV.default), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $elyLx.default), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = "Rows per page:", nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $effe3c7e7b91170d$var$_excluded);
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? "option" : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $elyLx.default) || component === "td") colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $5A6d3.default)(selectProps.id);
    const labelId = (0, $5A6d3.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationRoot, (0, $8nd05.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($effe3c7e7b91170d$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelect, (0, $8nd05.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $8nd05.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $9QePP.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $9QePP.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $9QePP.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemComponent, (0, $8nd05.default)({}, !(0, $awhpc.default)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
$effe3c7e7b91170d$var$TablePagination.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */ ActionsComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */ backIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ colSpan: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */ count: (0, $iuSDM.default).isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */ getItemAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */ labelDisplayedRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */ labelRowsPerPage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */ nextIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */ onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */ onRowsPerPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The zero-based index of the current page.
   */ page: (0, $fEVav.default)((0, $iuSDM.default).isRequired, (props)=>{
        const { count: count, page: page, rowsPerPage: rowsPerPage } = props;
        if (count === -1) return null;
        const newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
        if (page < 0 || page > newLastPage) return new Error("MUI: The page prop of a TablePagination is out of range " + `(0 to ${newLastPage}, but page is ${page}).`);
        return null;
    }),
    /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */ rowsPerPage: (0, $iuSDM.default).isRequired,
    /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */ rowsPerPageOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
        })
    ]).isRequired),
    /**
   * Props applied to the rows per page [`Select`](/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */ SelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, show the first-page button.
   * @default false
   */ showFirstButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, show the last-page button.
   * @default false
   */ showLastButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        actions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        }),
        select: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        actions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
            firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
            lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
            lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
            nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
            nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
            previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
            previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
        })
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $effe3c7e7b91170d$export$2e2bcd8739ae039 = $effe3c7e7b91170d$var$TablePagination;

});
parcelRegister("kyRsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8072c26f712b4c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $iaUmy = parcelRequire("iaUmy");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $ef8072c26f712b4c$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iaUmy.getToolbarUtilityClass), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $1En50.default)(props, $ef8072c26f712b4c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$ef8072c26f712b4c$var$Toolbar.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, disables gutter padding.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   * @default 'regular'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "dense",
            "regular"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;

});
parcelRegister("iaUmy", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", () => $d3b4e1a115786e57$export$b12cb262231eef32);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)("MuiToolbar", slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;

});


parcelRegister("dLLxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0648bcf9b9d5e9c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $58lXc = parcelRequire("58lXc");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $9Lykx = parcelRequire("9Lykx");

var $5izos = parcelRequire("5izos");

var $21SL6 = parcelRequire("21SL6");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $a0648bcf9b9d5e9c$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $a0648bcf9b9d5e9c$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $a0648bcf9b9d5e9c$var$_excluded);
    const isRtl = (0, $58lXc.useRtl)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $9Lykx.default);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $9Lykx.default);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $9Lykx.default);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $9Lykx.default);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $21SL6.default);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $5izos.default);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $f46un.default);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $frMNQ.default);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, (0, $8nd05.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel("first", page),
                title: getItemAriaLabel("first", page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, (0, $8nd05.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel("previous", page),
                title: getItemAriaLabel("previous", page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, (0, $8nd05.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel("next", page),
                title: getItemAriaLabel("next", page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, (0, $8nd05.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel("last", page),
                title: getItemAriaLabel("last", page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
$a0648bcf9b9d5e9c$var$TablePaginationActions.propTypes = {
    /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */ backIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The total number of rows.
   */ count: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */ getItemAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */ nextIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */ onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * The zero-based index of the current page.
   */ page: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    /**
   * The number of rows per page.
   */ rowsPerPage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    /**
   * If `true`, show the first-page button.
   */ showFirstButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * If `true`, show the last-page button.
   */ showLastButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    })
};
var $a0648bcf9b9d5e9c$export$2e2bcd8739ae039 = $a0648bcf9b9d5e9c$var$TablePaginationActions;

});
parcelRegister("frMNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ef3be5c947a70a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");

});

parcelRegister("f46un", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d495bb1a743bb2$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");

});

parcelRegister("5izos", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dba169293b5f5f0$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3dba169293b5f5f0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");

});

parcelRegister("21SL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a626ba35acf52f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $17a626ba35acf52f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");

});


parcelRegister("inBkn", function(module, exports) {

$parcel$export(module.exports, "getTablePaginationUtilityClass", () => $d6175477fd255470$export$909e637b22246f4c);
$parcel$export(module.exports, "default", () => $d6175477fd255470$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d6175477fd255470$export$909e637b22246f4c(slot) {
    return (0, $4Cod0.default)("MuiTablePagination", slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $beCSm.default)("MuiTablePagination", [
    "root",
    "toolbar",
    "spacer",
    "selectLabel",
    "selectRoot",
    "select",
    "selectIcon",
    "input",
    "menuItem",
    "displayedRows",
    "actions"
]);
var $d6175477fd255470$export$2e2bcd8739ae039 = $d6175477fd255470$var$tablePaginationClasses;

});


parcelRegister("1spQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $10fc754516dc8bab$var$useBaseStyles = (0, $1GFtd.default)({
    tablePaginationDisabled: {
        opacity: 0.4,
        pointerEvents: "none"
    }
});
module.exports.default = $10fc754516dc8bab$var$useBaseStyles;

});

parcelRegister("4UigU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $392a90c2c6c4df1e$var$useV1Styles = (0, $1GFtd.default)({
    tablePagination: {
        fontSize: ({ fontSize: fontSize })=>fontSize || $i4KPV.FONT.SIZE.BASE,
        "& .MuiTablePagination-toolbar": {
            minHeight: "2.8em"
        },
        "& .MuiIconButton-label .MuiSvgIcon-root": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE
        },
        "& .MuiTablePagination-caption": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
            color: $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS
        },
        "& .MuiTablePagination-select": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
            color: $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS
        }
    },
    tablePaginationMenuItem: {
        color: $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS,
        fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE
    },
    tablePaginationMenuPaper: {},
    tablePaginationOpen: {}
});
module.exports.default = $392a90c2c6c4df1e$var$useV1Styles;

});

parcelRegister("jKmrs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $e603b8ace42b45a4$var$useV2Styles = (0, $1GFtd.default)({
    tablePagination: {
        fontSize: ({ fontSize: fontSize })=>fontSize || $i4KPV.FONT.SIZE.BASE,
        "& .MuiTablePagination-toolbar": {
            minHeight: "2.8em"
        },
        "& .MuiIconButton-label .MuiSvgIcon-root": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE
        },
        "& .MuiTablePagination-caption": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK
        },
        "& .MuiTablePagination-select": {
            fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            borderStyle: "solid",
            borderColor: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            borderRadius: "4px",
            borderWidth: "1px"
        }
    },
    tablePaginationMenuItem: {
        color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        fontSize: $i4KPV.FONT.SIZE.SEMI_LARGE,
        "&.Mui-selected": {
            backgroundColor: $i4KPV.COLORS_V2.PRIMARY_50,
            color: $i4KPV.COLORS_V2.PRIMARY_700
        }
    },
    tablePaginationMenuPaper: {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: $i4KPV.COLORS_V2.PRIMARY_700
    },
    tablePaginationOpen: {
        "& .MuiTablePagination-select": {
            borderColor: $i4KPV.COLORS_V2.PRIMARY_700
        },
        "& .MuiTablePagination-selectIcon": {
            color: $i4KPV.COLORS_V2.PRIMARY_700
        }
    }
});
module.exports.default = $e603b8ace42b45a4$var$useV2Styles;

});


parcelRegister("7yHMO", function(module, exports) {
"use strict";
var $580dac6b8492d493$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $580dac6b8492d493$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $580dac6b8492d493$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $580dac6b8492d493$var$__createBinding(result, mod, k);
    }
    $580dac6b8492d493$var$__setModuleDefault(result, mod);
    return result;
};
var $580dac6b8492d493$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $580dac6b8492d493$var$react_1 = $580dac6b8492d493$var$__importStar((parcelRequire("acw62")));

var $QpuKB = parcelRequire("QpuKB");
var $2XjE0 = parcelRequire("2XjE0");
var $elyLx = parcelRequire("elyLx");

var $i4KPV = parcelRequire("i4KPV");

const $580dac6b8492d493$var$text_cell_react_1 = $580dac6b8492d493$var$__importDefault((parcelRequire("4a7VA")));

const $580dac6b8492d493$var$subtitle_cell_react_1 = $580dac6b8492d493$var$__importDefault((parcelRequire("3HIMw")));

const $580dac6b8492d493$var$thumbnail_cell_react_1 = $580dac6b8492d493$var$__importDefault((parcelRequire("cqNdQ")));

var $e1Hcy = parcelRequire("e1Hcy");

const $580dac6b8492d493$var$table_body_style_v2_1 = $580dac6b8492d493$var$__importDefault((parcelRequire("l3dRC")));

const $580dac6b8492d493$var$table_body_style_v1_1 = $580dac6b8492d493$var$__importDefault((parcelRequire("6y0CV")));

const $580dac6b8492d493$var$table_body_base_style_1 = $580dac6b8492d493$var$__importDefault((parcelRequire("gGydZ")));
const $580dac6b8492d493$var$TableBody = ({ id: id, rows: rows, columns: columns, hasCheckboxSelection: hasCheckboxSelection = false, theme: theme, onRowChecked: onRowChecked, onRowClick: onRowClick, rowClassName: rowClassName, columnClassName: columnClassName })=>{
    const baseStyles = (0, $580dac6b8492d493$var$table_body_base_style_1.default)();
    const stylesV2 = (0, $580dac6b8492d493$var$table_body_style_v2_1.default)();
    const stylesV1 = (0, $580dac6b8492d493$var$table_body_style_v1_1.default)();
    const classes = Object.assign(Object.assign({}, baseStyles), theme === $i4KPV.THEME_ENUM.v2 ? stylesV2 : stylesV1);
    const [tableBodyId] = (0, $580dac6b8492d493$var$react_1.useState)(`tableBody-${id || Math.random()}`);
    const [firstRowOfTable, setFirstRowOfTable] = (0, $580dac6b8492d493$var$react_1.useState)();
    const renderCustomCell = (row, column)=>{
        if (!column.renderCell) return;
        return $580dac6b8492d493$var$react_1.default.createElement("div", {
            className: classes.customCell,
            style: {
                justifyContent: column.textAlignment || $e1Hcy.TEXT_ALIGNMENT.left,
                paddingRight: column.isSortable ? "2em" : 0
            }
        }, column.renderCell(row, column));
    };
    const clickCell = (row, column)=>{
        if (column.hasPreventBubbling) return;
        if (column.onClick) column.onClick(row[column.field], row);
        else if (onRowClick) onRowClick === null || onRowClick === void 0 || onRowClick(row);
        else if (hasCheckboxSelection) onRowChecked === null || onRowChecked === void 0 || onRowChecked(!row.isChecked, row);
    };
    const tableCellAlign = (column, index)=>{
        if (!column.isSticky) return {};
        setTimeout(()=>{
            const table = document.getElementById(tableBodyId);
            const tableRow = table.rows[0];
            setFirstRowOfTable(tableRow);
        // tslint:disable-next-line: align
        }, 100);
        if (firstRowOfTable && firstRowOfTable.cells.length > 0) {
            const lengthOfColumn = firstRowOfTable.cells[index] ? firstRowOfTable.cells[index].getBoundingClientRect().x : 20;
            return {
                left: lengthOfColumn - 20
            };
        }
        return {};
    };
    const tableRowClassName = (row)=>{
        if (rowClassName === undefined) return "";
        if (typeof rowClassName === "string") return rowClassName;
        return rowClassName(row);
    };
    const tableColumnClassName = (row, column)=>{
        if (columnClassName === undefined) return "";
        if (typeof columnClassName === "string") return columnClassName;
        return columnClassName(row, column);
    };
    return $580dac6b8492d493$var$react_1.default.createElement($QpuKB.default, {
        id: tableBodyId
    }, rows.map((row)=>$580dac6b8492d493$var$react_1.default.createElement($2XjE0.default, {
            key: row.id,
            className: `${classes.tableRow} ${tableRowClassName(row)}` + ` ${onRowClick || hasCheckboxSelection ? classes.tableRowClickable : ""}` + ` ${row.isChecked ? classes.tableRowSelected : ""}`
        }, columns.map((column, idx)=>$580dac6b8492d493$var$react_1.default.createElement($elyLx.default, {
                key: column.field,
                style: Object.assign({}, tableCellAlign(column, idx)),
                className: `${column.isSticky ? classes.stickyColumn : ""}` + ` ${classes.tableRowCell} ${tableColumnClassName(row, column)}` + ` ${column.onClick ? classes.tableCellClickable : ""}` + ` ${column.field === "isChecked" ? classes.tableRowCellCheckbox : ""}` + ` ${column.type !== $e1Hcy.CELL_TYPE_ENUM.checkbox && idx === 0 ? classes.tableRowFirstCellPadding : ""}`,
                scope: "row",
                onClick: ()=>clickCell(row, column)
            }, // Custom rendered cell
            column.renderCell ? renderCustomCell(row, column) : // Subtitle cell
            column.type === "subtitle" ? $580dac6b8492d493$var$react_1.default.createElement($580dac6b8492d493$var$subtitle_cell_react_1.default, {
                row: row,
                column: column,
                theme: theme
            }) : column.type === "thumbnail" ? $580dac6b8492d493$var$react_1.default.createElement($580dac6b8492d493$var$thumbnail_cell_react_1.default, {
                row: row,
                column: column
            }) : $580dac6b8492d493$var$react_1.default.createElement($580dac6b8492d493$var$text_cell_react_1.default, {
                row: row,
                column: column,
                theme: theme
            }))))));
};
module.exports.default = $580dac6b8492d493$var$TableBody;

});
parcelRegister("QpuKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d8a23708c3ccc9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $RbMj7 = parcelRequire("RbMj7");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $dfSTK = parcelRequire("dfSTK");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $09d8a23708c3ccc9$var$_excluded = [
    "className",
    "component"
];
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dfSTK.getTableBodyUtilityClass), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: "body"
};
const $09d8a23708c3ccc9$var$defaultComponent = "tbody";
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent } = props, other = (0, $1En50.default)(props, $09d8a23708c3ccc9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RbMj7.default).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, (0, $8nd05.default)({
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
$09d8a23708c3ccc9$var$TableBody.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;

});
parcelRegister("dfSTK", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", () => $9a6742b7048414d1$export$98bd2a9b566ec665);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)("MuiTableBody", slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $beCSm.default)("MuiTableBody", [
    "root"
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;

});


parcelRegister("4a7VA", function(module, exports) {
"use strict";
var $307e3ee313b96649$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $307e3ee313b96649$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $307e3ee313b96649$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $307e3ee313b96649$var$__createBinding(result, mod, k);
    }
    $307e3ee313b96649$var$__setModuleDefault(result, mod);
    return result;
};
var $307e3ee313b96649$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $307e3ee313b96649$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $307e3ee313b96649$var$react_1 = $307e3ee313b96649$var$__importStar((parcelRequire("acw62")));

var $e4qC9 = parcelRequire("e4qC9");
var $6r9CR = parcelRequire("6r9CR");

const $307e3ee313b96649$var$shared_components_krg_text_input_1 = $307e3ee313b96649$var$__importDefault((parcelRequire("iDAOR")));

const $307e3ee313b96649$var$shared_components_krg_tooltip_1 = $307e3ee313b96649$var$__importDefault((parcelRequire("AfP12")));

const $307e3ee313b96649$var$text_cell_style_1 = $307e3ee313b96649$var$__importDefault((parcelRequire("ez6ZB")));

var $hEH5D = parcelRequire("hEH5D");

var $e1Hcy = parcelRequire("e1Hcy");
const $307e3ee313b96649$var$TextCell = ({ row: row, column: column, theme: theme })=>{
    const props = {
        theme: theme
    };
    const classes = (0, $307e3ee313b96649$var$text_cell_style_1.default)(props);
    const { isEditable: isEditable, editFinishedIconDuration: editFinishedIconDuration = 2000, onEditFinished: onEditFinished, onEditCanceled: onEditCanceled } = column;
    const cellText = row[column.field];
    const [text, setText] = (0, $307e3ee313b96649$var$react_1.useState)(cellText);
    const [editing, setEditing] = (0, $307e3ee313b96649$var$react_1.useState)(false);
    const [isInputEnabled, setIsInputEnabled] = (0, $307e3ee313b96649$var$react_1.useState)(true);
    const [showEditIcon, setShowEditIcon] = (0, $307e3ee313b96649$var$react_1.useState)(false);
    const [showCheckMarkIcon, setShowCheckMarkIcon] = (0, $307e3ee313b96649$var$react_1.useState)(false);
    const handleOnMouseEnter = ()=>{
        setShowEditIcon(true);
    };
    const handleOnMouseMove = ()=>{
        if (!showEditIcon) setShowEditIcon(true);
    };
    const handleMouseLeave = ()=>{
        setShowEditIcon(false);
    };
    const handleEditFinished = ()=>$307e3ee313b96649$var$__awaiter(void 0, void 0, void 0, function*() {
            setIsInputEnabled(false);
            const successful = yield onEditFinished === null || onEditFinished === void 0 ? void 0 : onEditFinished(text, column, row);
            // Revert input text if operation is not successful
            if (successful === false) setText(cellText);
            else if (successful === true) {
                // Show checkmark for the successful operation
                setShowCheckMarkIcon(true);
                setTimeout(()=>{
                    setShowCheckMarkIcon(false);
                }, editFinishedIconDuration);
            }
            setIsInputEnabled(true);
            setShowEditIcon(false);
            setEditing(false);
        });
    const handleEditCanceled = ()=>{
        onEditCanceled === null || onEditCanceled === void 0 || onEditCanceled(text, column, row);
        setShowEditIcon(false);
        setEditing(false);
        setText(cellText);
    };
    const getCellStyle = ()=>{
        const style = {};
        if (!editing && column.width) style.maxWidth = `calc(${column.width} - 1.85em)`;
        if (!editing) style.paddingRight = column.isSortable ? "2em" : 0;
        return style;
    };
    const editingCellElem = $307e3ee313b96649$var$react_1.default.createElement($307e3ee313b96649$var$shared_components_krg_text_input_1.default, {
        text: text,
        hasAutoFocus: true,
        isAutoHeight: true,
        isFullWidth: true,
        isEnabled: isInputEnabled,
        theme: theme,
        onClick: (e)=>e.stopPropagation(),
        onTextChange: setText,
        onBlur: ()=>$307e3ee313b96649$var$__awaiter(void 0, void 0, void 0, function*() {
                return yield handleEditFinished();
            }),
        onKeyDown: ({ key: key })=>$307e3ee313b96649$var$__awaiter(void 0, void 0, void 0, function*() {
                if (key === "Enter") yield handleEditFinished();
                else if (key === "Escape") handleEditCanceled();
            })
    });
    const cellElem = $307e3ee313b96649$var$react_1.default.createElement("div", {
        className: classes.cell,
        style: getCellStyle()
    }, cellText, showEditIcon && isEditable ? $307e3ee313b96649$var$react_1.default.createElement($307e3ee313b96649$var$shared_components_krg_tooltip_1.default, {
        tooltip: "Rename",
        position: $307e3ee313b96649$var$shared_components_krg_tooltip_1.default.POSITION_ENUM.top,
        tooltipProps: {
            PopperProps: (0, $hEH5D.getTablePopperProps)()
        },
        hasArrow: false,
        theme: theme
    }, $307e3ee313b96649$var$react_1.default.createElement($e4qC9.default, {
        className: `${classes.editIcon} ${classes.icon}`,
        onClick: (e)=>{
            e.stopPropagation();
            setEditing(true);
        }
    })) : showCheckMarkIcon ? $307e3ee313b96649$var$react_1.default.createElement($6r9CR.default, {
        className: classes.checkIcon
    }) : null);
    return $307e3ee313b96649$var$react_1.default.createElement("div", {
        className: classes.root,
        style: {
            justifyContent: (column === null || column === void 0 ? void 0 : column.textAlignment) || $e1Hcy.TEXT_ALIGNMENT.left
        },
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseMove: handleOnMouseMove
    }, editing ? editingCellElem : cellElem);
};
module.exports.default = $307e3ee313b96649$var$TextCell;

});
parcelRegister("e4qC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e615725b57d973$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a3e615725b57d973$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 5.8 17.2 4.59c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L3 15.96V20h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83M6.21 18H5v-1.21l8.66-8.66 1.21 1.21zM11 20l4-4h6v4z"
}), "DriveFileRenameOutline");

});

parcelRegister("6r9CR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4afcbb2f1903e252$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $4afcbb2f1903e252$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");

});

parcelRegister("ez6ZB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $a9a9c22907db276e$var$useStyles = (0, $1GFtd.default)({
    root: {
        display: "flex",
        fontSize: $i4KPV.FONT.SIZE.MEDIUM
    },
    /*
      Cell
    */ cell: {
        alignItems: "center",
        display: "flex",
        "& > span": {
            display: "inline-flex"
        }
    },
    /*
      Edit icon
    */ icon: {
        fontSize: "1.6em",
        color: ({ theme: theme })=>theme === $i4KPV.THEME_ENUM.v1 ? $i4KPV.COLORS.BLACK : $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        "&:hover": {
            color: ({ theme: theme })=>theme === $i4KPV.THEME_ENUM.v1 ? $i4KPV.COLORS.PRIMARY_500_ACCENT : $i4KPV.COLORS_V2.PRIMARY_700
        }
    },
    editIcon: {
        flexShrink: 0,
        width: "1.62em"
    },
    checkIcon: {
        height: "0.6em",
        marginLeft: "0.4em",
        width: "0.6em"
    },
    editIconPlaceholder: {
        marginLeft: "1em",
        width: "1.6em"
    }
});
module.exports.default = $a9a9c22907db276e$var$useStyles;

});

parcelRegister("hEH5D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTablePopperProps = void 0;
const $cda798dcaf84919e$var$getTablePopperProps = ()=>{
    return {
        style: {
            pointerEvents: "none"
        },
        popperOptions: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            -3
                        ]
                    }
                }
            ]
        }
    };
};
module.exports.getTablePopperProps = $cda798dcaf84919e$var$getTablePopperProps;

});


parcelRegister("3HIMw", function(module, exports) {
"use strict";
var $2b281ff502fb5e22$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b281ff502fb5e22$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2b281ff502fb5e22$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2b281ff502fb5e22$var$__createBinding(result, mod, k);
    }
    $2b281ff502fb5e22$var$__setModuleDefault(result, mod);
    return result;
};
var $2b281ff502fb5e22$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2b281ff502fb5e22$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2b281ff502fb5e22$var$react_1 = $2b281ff502fb5e22$var$__importStar((parcelRequire("acw62")));

var $e4qC9 = parcelRequire("e4qC9");
var $6r9CR = parcelRequire("6r9CR");

const $2b281ff502fb5e22$var$shared_components_krg_text_input_1 = $2b281ff502fb5e22$var$__importDefault((parcelRequire("iDAOR")));

const $2b281ff502fb5e22$var$shared_components_krg_tooltip_1 = $2b281ff502fb5e22$var$__importDefault((parcelRequire("AfP12")));

var $hEH5D = parcelRequire("hEH5D");

const $2b281ff502fb5e22$var$subtitle_cell_style_1 = $2b281ff502fb5e22$var$__importDefault((parcelRequire("hFMbK")));

var $4fGPb = parcelRequire("4fGPb");
const $2b281ff502fb5e22$var$SubtitleCell = ({ row: row, column: column, theme: theme })=>{
    const props = {
        theme: theme
    };
    const classes = (0, $2b281ff502fb5e22$var$subtitle_cell_style_1.default)(props);
    const { isEditable: isEditable, editFinishedIconDuration: editFinishedIconDuration = 2000, onEditFinished: onEditFinished, onEditCanceled: onEditCanceled } = column;
    const link = row[column.field].link;
    const cellTitle = row[column.field].title;
    const cellSubtitle = row[column.field].subtitle;
    const [text, setText] = (0, $2b281ff502fb5e22$var$react_1.useState)(cellTitle);
    const [editing, setEditing] = (0, $2b281ff502fb5e22$var$react_1.useState)(false);
    const [isInputEnabled, setIsInputEnabled] = (0, $2b281ff502fb5e22$var$react_1.useState)(true);
    const [showEditIcon, setShowEditIcon] = (0, $2b281ff502fb5e22$var$react_1.useState)(false);
    const [showCheckMarkIcon, setShowCheckMarkIcon] = (0, $2b281ff502fb5e22$var$react_1.useState)(false);
    const [isTitleOverflowed, setIsTitleOverflowed] = (0, $2b281ff502fb5e22$var$react_1.useState)(false);
    const textElementRef = (0, $2b281ff502fb5e22$var$react_1.useRef)(null);
    (0, $2b281ff502fb5e22$var$react_1.useEffect)(()=>{
        if (textElementRef.current) setIsTitleOverflowed(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }, []);
    const handleOnMouseEnter = ()=>{
        setShowEditIcon(true);
    };
    const handleOnMouseMove = ()=>{
        if (!showEditIcon) setShowEditIcon(true);
    };
    const handleMouseLeave = ()=>{
        setShowEditIcon(false);
    };
    const handleEditFinished = ()=>$2b281ff502fb5e22$var$__awaiter(void 0, void 0, void 0, function*() {
            setIsInputEnabled(false);
            const successful = yield onEditFinished === null || onEditFinished === void 0 ? void 0 : onEditFinished(text, column, row);
            // Revert input text if operation is not successful
            if (successful === false) setText(cellTitle);
            else if (successful === true) {
                // Show checkmark for the successful operation
                setShowCheckMarkIcon(true);
                setTimeout(()=>{
                    setShowCheckMarkIcon(false);
                }, editFinishedIconDuration);
            }
            // Reset states
            setIsInputEnabled(true);
            setShowEditIcon(false);
            setEditing(false);
        });
    const handleEditCanceled = ()=>{
        onEditCanceled === null || onEditCanceled === void 0 || onEditCanceled(text, column, row);
        setShowEditIcon(false);
        setEditing(false);
        setText(cellTitle);
    };
    const editingCellElem = $2b281ff502fb5e22$var$react_1.default.createElement($2b281ff502fb5e22$var$shared_components_krg_text_input_1.default, {
        text: text,
        hasAutoFocus: true,
        isAutoHeight: true,
        isFullWidth: true,
        isEnabled: isInputEnabled,
        theme: theme,
        onClick: (e)=>e.stopPropagation(),
        onTextChange: setText,
        onBlur: ()=>$2b281ff502fb5e22$var$__awaiter(void 0, void 0, void 0, function*() {
                return yield handleEditFinished();
            }),
        onKeyDown: ({ key: key })=>$2b281ff502fb5e22$var$__awaiter(void 0, void 0, void 0, function*() {
                if (key === "Enter") yield handleEditFinished();
                else if (key === "Escape") handleEditCanceled();
            })
    });
    const getTitleStyle = ()=>{
        const style = {};
        if (!editing && column.width) style.maxWidth = `calc(${column.width} - 1.85em)`;
        return style;
    };
    const cellElem = $2b281ff502fb5e22$var$react_1.default.createElement($2b281ff502fb5e22$var$react_1.default.Fragment, null, $2b281ff502fb5e22$var$react_1.default.createElement("div", {
        className: `
          ${classes.title}
          ${!!row.isChecked ? classes.titleChecked : ""}
        `
    }, $2b281ff502fb5e22$var$react_1.default.createElement($2b281ff502fb5e22$var$shared_components_krg_tooltip_1.default, {
        tooltip: cellTitle,
        position: $2b281ff502fb5e22$var$shared_components_krg_tooltip_1.default.POSITION_ENUM.top,
        tooltipProps: {
            PopperProps: (0, $hEH5D.getTablePopperProps)(),
            disableHoverListener: !isTitleOverflowed
        },
        hasArrow: false,
        theme: theme
    }, $2b281ff502fb5e22$var$react_1.default.createElement("div", {
        ref: textElementRef,
        className: classes.titleText,
        style: getTitleStyle()
    }, cellTitle)), showEditIcon && isEditable ? $2b281ff502fb5e22$var$react_1.default.createElement($2b281ff502fb5e22$var$shared_components_krg_tooltip_1.default, {
        tooltip: "Rename",
        position: $2b281ff502fb5e22$var$shared_components_krg_tooltip_1.default.POSITION_ENUM.top,
        tooltipProps: {
            PopperProps: (0, $hEH5D.getTablePopperProps)()
        },
        hasArrow: false,
        theme: theme
    }, $2b281ff502fb5e22$var$react_1.default.createElement($e4qC9.default, {
        className: `${classes.editIcon} ${classes.icon}`,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            setEditing(true);
        }
    })) : showCheckMarkIcon ? $2b281ff502fb5e22$var$react_1.default.createElement($6r9CR.default, {
        className: `${classes.checkIcon} ${classes.icon}`
    }) : $2b281ff502fb5e22$var$react_1.default.createElement("div", {
        className: classes.editIconPlaceholder
    })), $2b281ff502fb5e22$var$react_1.default.createElement("div", {
        className: classes.subtitle
    }, cellSubtitle));
    return $2b281ff502fb5e22$var$react_1.default.createElement("div", {
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseMove: handleOnMouseMove
    }, editing ? editingCellElem : link ? $2b281ff502fb5e22$var$react_1.default.createElement($4fGPb.Link, {
        to: link,
        style: {
            textDecoration: "none"
        }
    }, cellElem) : cellElem);
};
module.exports.default = $2b281ff502fb5e22$var$SubtitleCell;

});
parcelRegister("hFMbK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $cddba5379b2d8d1b$var$useStyles = (0, $1GFtd.default)({
    /*
      Cell
    */ title: {
        alignItems: "center",
        color: $i4KPV.COLORS.GRAY_10,
        display: "flex",
        fontSize: "0.7em",
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        lineHeight: 1.2,
        "& > span": {
            display: "inline-flex"
        }
    },
    titleChecked: {
        color: ({ theme: theme })=>theme === $i4KPV.THEME_ENUM.v1 ? $i4KPV.COLORS.PRIMARY_500_ACCENT : $i4KPV.COLORS_V2.PRIMARY_700
    },
    subtitle: {
        color: $i4KPV.COLORS.GRAY_10,
        fontSize: "0.65em",
        lineHeight: 1.2
    },
    titleText: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        height: "1.6em",
        lineHeight: "1.6em"
    },
    /*
      Edit icon
    */ icon: {
        fontSize: "1.6em",
        color: ({ theme: theme })=>theme === $i4KPV.THEME_ENUM.v1 ? $i4KPV.COLORS.BLACK : $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        "&:hover": {
            color: ({ theme: theme })=>theme === $i4KPV.THEME_ENUM.v1 ? $i4KPV.COLORS.PRIMARY_500_ACCENT : $i4KPV.COLORS_V2.PRIMARY_700
        }
    },
    editIcon: {
        flexShrink: 0,
        width: "1.62em"
    },
    checkIcon: {
        height: "0.6em",
        marginLeft: "0.4em",
        width: "0.6em"
    },
    editIconPlaceholder: {
        marginLeft: "1em",
        width: "1.6em"
    }
});
module.exports.default = $cddba5379b2d8d1b$var$useStyles;

});


parcelRegister("cqNdQ", function(module, exports) {
"use strict";
var $90ce183f8b2e0f5c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $90ce183f8b2e0f5c$var$react_1 = $90ce183f8b2e0f5c$var$__importDefault((parcelRequire("acw62")));

const $90ce183f8b2e0f5c$var$thumbnail_cell_style_1 = $90ce183f8b2e0f5c$var$__importDefault((parcelRequire("4Yk3U")));
const $90ce183f8b2e0f5c$var$ThumbnailCell = ({ row: row, column: column })=>{
    const classes = (0, $90ce183f8b2e0f5c$var$thumbnail_cell_style_1.default)();
    const thumbnails = row[column.field];
    return $90ce183f8b2e0f5c$var$react_1.default.createElement("div", {
        className: classes.cell
    }, thumbnails.slice(0, 6).map((thumbnail, idx)=>$90ce183f8b2e0f5c$var$react_1.default.createElement("div", {
            className: classes.container,
            key: idx
        }, $90ce183f8b2e0f5c$var$react_1.default.createElement("img", {
            className: classes.thumbnail,
            src: thumbnail,
            alt: "thumbnail"
        }))));
};
module.exports.default = $90ce183f8b2e0f5c$var$ThumbnailCell;

});
parcelRegister("4Yk3U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $39ec53e71eed3951$var$useStyles = (0, $1GFtd.default)({
    /*
      Cell
    */ cell: {
        display: "flex"
    },
    container: {
        padding: "0em 0.5em"
    },
    thumbnail: {
        border: "1px solid #7B7B7B",
        height: "1.4375em",
        width: "1.4375em"
    }
});
module.exports.default = $39ec53e71eed3951$var$useStyles;

});


parcelRegister("l3dRC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $f534a1de1436dcdc$var$useStylesV2 = (0, $1GFtd.default)({
    /*
      Table body
    */ tableRow: {
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        borderColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
        "&:hover": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_MEDIUM,
            boxShadow: "0 0.05rem .2rem 0 rgba(0, 0, 0, 0.2),0 0.05rem 0.05rem 0 rgba(0, 0, 0, 0.14),0 .1rem 0.05rem -0.05rem rgba(0, 0, 0, 0.12)",
            borderColor: $i4KPV.COLORS_V2.PRIMARY_50
        }
    },
    tableRowSelected: {
        backgroundColor: $i4KPV.COLORS_V2.PRIMARY_50,
        "&:hover": {
            backgroundColor: $i4KPV.COLORS_V2.PRIMARY_50,
            boxShadow: "0 0.05rem .2rem 0 rgba(0, 0, 0, 0.2),0 0.05rem 0.05rem 0 rgba(0, 0, 0, 0.14),0 .1rem 0.05rem -0.05rem rgba(0, 0, 0, 0.12)"
        }
    },
    tableRowCell: {
        color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
        lineHeight: 1.2,
        padding: "0.5em"
    }
});
module.exports.default = $f534a1de1436dcdc$var$useStylesV2;

});

parcelRegister("6y0CV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $4c466788be3fe28d$var$useStylesV1 = (0, $1GFtd.default)({
    /*
      Table body
    */ tableRow: {
        "&:hover": {
            backgroundColor: $i4KPV.COLORS.GRAY_LIGHT
        }
    },
    tableRowSelected: {
        backgroundColor: $i4KPV.COLORS.PRIMARY_50,
        "&:hover": {
            backgroundColor: $i4KPV.COLORS.PRIMARY_50
        }
    },
    tableRowCell: {
        borderColor: $i4KPV.COLORS.GRAY_DIVIDER,
        color: $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS,
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
        lineHeight: 1.2,
        padding: "0.5em"
    }
});
module.exports.default = $4c466788be3fe28d$var$useStylesV1;

});

parcelRegister("gGydZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $c25b1ddcf1cfcc01$var$useBaseStyles = (0, $1GFtd.default)({
    /*
      Table body
    */ tableRowCheckable: {
        cursor: "pointer"
    },
    tableRowCellCheckbox: {
        textAlign: "center",
        width: "3em"
    },
    tableRowClickable: {
        cursor: "pointer"
    },
    tableCellClickable: {
        cursor: "pointer"
    },
    tableRowFirstCellPadding: {
        paddingLeft: "1.2em"
    },
    stickyColumn: {
        position: "sticky",
        zIndex: 1
    },
    /*
      Custom cell
    */ customCell: {
        display: "flex",
        fontSize: $i4KPV.FONT.SIZE.MEDIUM
    }
});
module.exports.default = $c25b1ddcf1cfcc01$var$useBaseStyles;

});


parcelRegister("1H7m9", function(module, exports) {
"use strict";
var $13bf83664da307b0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $13bf83664da307b0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $13bf83664da307b0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $13bf83664da307b0$var$__createBinding(result, mod, k);
    }
    $13bf83664da307b0$var$__setModuleDefault(result, mod);
    return result;
};
var $13bf83664da307b0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $13bf83664da307b0$var$react_1 = $13bf83664da307b0$var$__importDefault((parcelRequire("acw62")));

var $hAiFn = parcelRequire("hAiFn");
var $bSP5G = parcelRequire("bSP5G");
var $8mFBI = parcelRequire("8mFBI");
var $7YTJI = parcelRequire("7YTJI");
var $8YLZH = parcelRequire("8YLZH");
var $ljwMU = parcelRequire("ljwMU");
var $lRtW1 = parcelRequire("lRtW1");
var $bTGLl = parcelRequire("bTGLl");
var $fniCy = parcelRequire("fniCy");
var $4YOUM = parcelRequire("4YOUM");

const $13bf83664da307b0$var$shared_components_krg_menu_1 = $13bf83664da307b0$var$__importStar((parcelRequire("55ofq")));

const $13bf83664da307b0$var$action_button_react_1 = $13bf83664da307b0$var$__importDefault((parcelRequire("fGhMZ")));

var $e1Hcy = parcelRequire("e1Hcy");

const $13bf83664da307b0$var$action_cell_style_1 = $13bf83664da307b0$var$__importDefault((parcelRequire("eOExg")));
const $13bf83664da307b0$var$ActionCell = ({ actions: actions, row: row, fontSize: fontSize, isActionMenu: isActionMenu, theme: theme })=>{
    const props = {
        buttonCount: isActionMenu ? 1 : actions.length
    };
    const classes = (0, $13bf83664da307b0$var$action_cell_style_1.default)(props);
    const getMenuLabel = (type, label)=>{
        return label ? label : type === $e1Hcy.ACTION_TYPE_ENUM.edit ? "Edit" : type === $e1Hcy.ACTION_TYPE_ENUM.duplicate ? "Duplicate" : type === $e1Hcy.ACTION_TYPE_ENUM.preview ? "Preview" : type === $e1Hcy.ACTION_TYPE_ENUM.logo ? "Logo" : type === $e1Hcy.ACTION_TYPE_ENUM.archive ? "Archive" : type === $e1Hcy.ACTION_TYPE_ENUM.approve ? "Approve" : type === $e1Hcy.ACTION_TYPE_ENUM.archiveUser ? "Archive" : type === $e1Hcy.ACTION_TYPE_ENUM.unarchive ? "Unarchive" : type === $e1Hcy.ACTION_TYPE_ENUM.reactivateUser ? "Resend Okta invite" : "Deny";
    };
    const getMenuIcon = (type)=>{
        return type === $e1Hcy.ACTION_TYPE_ENUM.edit ? $13bf83664da307b0$var$react_1.default.createElement($hAiFn.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.duplicate ? $13bf83664da307b0$var$react_1.default.createElement($bSP5G.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.preview ? $13bf83664da307b0$var$react_1.default.createElement($8mFBI.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.logo ? $13bf83664da307b0$var$react_1.default.createElement($7YTJI.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.archive ? $13bf83664da307b0$var$react_1.default.createElement($8YLZH.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.approve ? $13bf83664da307b0$var$react_1.default.createElement($ljwMU.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.unarchive ? $13bf83664da307b0$var$react_1.default.createElement($lRtW1.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.archiveUser ? $13bf83664da307b0$var$react_1.default.createElement($bTGLl.default, null) : type === $e1Hcy.ACTION_TYPE_ENUM.reactivateUser ? $13bf83664da307b0$var$react_1.default.createElement($fniCy.default, null) : $13bf83664da307b0$var$react_1.default.createElement($4YOUM.default, null);
    };
    const filteredActions = actions.filter((a)=>{
        if (a.isHidden === undefined) return a;
        if (typeof a.isHidden === "boolean") return !a.isHidden;
        return !a.isHidden(row);
    });
    const isButtonEnabled = (isEnabled)=>{
        if (isEnabled === undefined) return true;
        if (typeof isEnabled === "boolean") return isEnabled;
        return isEnabled(row);
    };
    return $13bf83664da307b0$var$react_1.default.createElement("div", {
        className: `${classes.root}`
    }, isActionMenu ? $13bf83664da307b0$var$react_1.default.createElement($13bf83664da307b0$var$shared_components_krg_menu_1.default, {
        buttonVariant: $13bf83664da307b0$var$shared_components_krg_menu_1.BUTTON_VARIANT_ENUM.icon,
        menuPlacement: "bottom-end",
        theme: theme,
        menuItems: filteredActions.map((action)=>({
                name: getMenuLabel(action.type, action.label),
                icon: getMenuIcon(action.type),
                isEnabled: isButtonEnabled(action.isEnabled),
                onClick: ()=>{
                    var _a;
                    return (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, row);
                }
            }))
    }) : filteredActions.map((action, idx)=>$13bf83664da307b0$var$react_1.default.createElement($13bf83664da307b0$var$action_button_react_1.default, {
            key: idx,
            action: Object.assign(Object.assign({}, action), {
                isEnabled: isButtonEnabled(action.isEnabled)
            }),
            row: row,
            fontSize: fontSize,
            theme: theme
        })));
};
module.exports.default = $13bf83664da307b0$var$ActionCell;

});
parcelRegister("hAiFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd4473bf517ef36$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ccd4473bf517ef36$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");

});

parcelRegister("bSP5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a6c5e5f468b2df6$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8a6c5e5f468b2df6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2m0 16H7V3h14z"
}), "FilterNone");

});

parcelRegister("8mFBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6170a7275bffce61$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $6170a7275bffce61$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), "Visibility");

});

parcelRegister("7YTJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf95f1a8b1eba96$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5cf95f1a8b1eba96$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), "Image");

});

parcelRegister("8YLZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $689927f0df05e8fa$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $689927f0df05e8fa$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");

});

parcelRegister("ljwMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f844ce4c5a1a92c5$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f844ce4c5a1a92c5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "CheckCircleOutline");

});

parcelRegister("lRtW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea5c4a0cf9099fb$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $fea5c4a0cf9099fb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8V4l8 8-8 8v-4H4V8z"
}), "Forward");

});

parcelRegister("bTGLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a9600831e51cf3d$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8a9600831e51cf3d$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m20.54 5.23-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27M6.24 5h11.52l.81.97H5.44zM5 19V8h14v11zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z"
}), "ArchiveOutlined");

});

parcelRegister("fniCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31772b94642f9d6$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b31772b94642f9d6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2m-8 7L4 6h16zm7 4 4 4-4 4v-3h-4v-2h4z"
}), "ForwardToInbox");

});

parcelRegister("4YOUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a04429df24e66bc$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3a04429df24e66bc$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20m6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9"
}), "DoNotDisturb");

});

parcelRegister("fGhMZ", function(module, exports) {
"use strict";
var $b6a893cd89bb5e43$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b6a893cd89bb5e43$var$react_1 = $b6a893cd89bb5e43$var$__importDefault((parcelRequire("acw62")));

var $9Lykx = parcelRequire("9Lykx");

var $hAiFn = parcelRequire("hAiFn");
var $bSP5G = parcelRequire("bSP5G");
var $8mFBI = parcelRequire("8mFBI");
var $7YTJI = parcelRequire("7YTJI");
var $8YLZH = parcelRequire("8YLZH");
var $ljwMU = parcelRequire("ljwMU");
var $bTGLl = parcelRequire("bTGLl");
var $lRtW1 = parcelRequire("lRtW1");
var $fniCy = parcelRequire("fniCy");
var $4YOUM = parcelRequire("4YOUM");

const $b6a893cd89bb5e43$var$shared_components_krg_tooltip_1 = $b6a893cd89bb5e43$var$__importDefault((parcelRequire("AfP12")));

var $e1Hcy = parcelRequire("e1Hcy");

var $hEH5D = parcelRequire("hEH5D");

const $b6a893cd89bb5e43$var$action_button_style_1 = $b6a893cd89bb5e43$var$__importDefault((parcelRequire("6pavu")));
const $b6a893cd89bb5e43$var$ActionButton = ({ action: action, row: row, fontSize: fontSize, theme: theme })=>{
    const props = {
        fontSize: fontSize,
        theme: theme
    };
    const classes = (0, $b6a893cd89bb5e43$var$action_button_style_1.default)(props);
    const { type: type, label: label, isEnabled: isEnabled, tooltip: tooltip, onClick: onClick } = action;
    const buttonLabel = label ? label : type === $e1Hcy.ACTION_TYPE_ENUM.edit ? "Edit" : type === $e1Hcy.ACTION_TYPE_ENUM.duplicate ? "Duplicate" : type === $e1Hcy.ACTION_TYPE_ENUM.preview ? "Preview" : type === $e1Hcy.ACTION_TYPE_ENUM.logo ? "Logo" : type === $e1Hcy.ACTION_TYPE_ENUM.archive ? "Archive" : type === $e1Hcy.ACTION_TYPE_ENUM.approve ? "Approve" : type === $e1Hcy.ACTION_TYPE_ENUM.archiveUser ? "Archive" : type === $e1Hcy.ACTION_TYPE_ENUM.unarchive ? "Unarchive" : type === $e1Hcy.ACTION_TYPE_ENUM.reactivateUser ? "Resend Okta invite" : "Deny";
    const icon = type === $e1Hcy.ACTION_TYPE_ENUM.edit ? $b6a893cd89bb5e43$var$react_1.default.createElement($hAiFn.default, {
        className: classes.actionButtonIcon
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.duplicate ? $b6a893cd89bb5e43$var$react_1.default.createElement($bSP5G.default, {
        className: `${classes.actionButtonIcon} ${classes.duplicateIconActionButton}`
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.preview ? $b6a893cd89bb5e43$var$react_1.default.createElement($8mFBI.default, {
        className: classes.actionButtonIcon
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.logo ? $b6a893cd89bb5e43$var$react_1.default.createElement($7YTJI.default, {
        className: classes.actionButtonIcon
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.archive ? $b6a893cd89bb5e43$var$react_1.default.createElement($8YLZH.default, {
        className: classes.actionButtonIcon
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.approve ? $b6a893cd89bb5e43$var$react_1.default.createElement($ljwMU.default, {
        className: classes.actionButtonIcon
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.archiveUser ? $b6a893cd89bb5e43$var$react_1.default.createElement($bTGLl.default, {
        className: classes.actionButtonIcon
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.unarchive ? $b6a893cd89bb5e43$var$react_1.default.createElement($lRtW1.default, {
        className: `${classes.actionButtonIcon} ${classes.unarchiveActionButton}`
    }) : type === $e1Hcy.ACTION_TYPE_ENUM.reactivateUser ? $b6a893cd89bb5e43$var$react_1.default.createElement($fniCy.default, {
        className: `${classes.actionButtonIcon}`
    }) : $b6a893cd89bb5e43$var$react_1.default.createElement($4YOUM.default, {
        className: classes.actionButtonIcon
    });
    const isButtonEnabled = ()=>{
        if (isEnabled === undefined) return true;
        if (typeof isEnabled === "boolean") return isEnabled;
        return isEnabled(row);
    };
    const getTooltip = ()=>{
        if (tooltip === undefined) return buttonLabel;
        if (typeof tooltip === "string") return tooltip;
        return tooltip(row);
    };
    return $b6a893cd89bb5e43$var$react_1.default.createElement($b6a893cd89bb5e43$var$shared_components_krg_tooltip_1.default, {
        tooltip: getTooltip(),
        position: $b6a893cd89bb5e43$var$shared_components_krg_tooltip_1.default.POSITION_ENUM.top,
        tooltipProps: {
            PopperProps: (0, $hEH5D.getTablePopperProps)()
        },
        hasArrow: false,
        theme: theme
    }, $b6a893cd89bb5e43$var$react_1.default.createElement("span", null, $b6a893cd89bb5e43$var$react_1.default.createElement($9Lykx.default, {
        className: classes.actionButton,
        TouchRippleProps: {
            className: classes.actionButtonRipple
        },
        onClick: ()=>onClick === null || onClick === void 0 ? void 0 : onClick(row),
        disabled: !isButtonEnabled()
    }, icon, type === $e1Hcy.ACTION_TYPE_ENUM.duplicate && $b6a893cd89bb5e43$var$react_1.default.createElement("span", {
        className: classes.actionButtonPlus
    }, "+"))));
};
module.exports.default = $b6a893cd89bb5e43$var$ActionButton;

});
parcelRegister("6pavu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $4a9d3a57b9de0fdb$var$useStyles = (0, $1GFtd.default)({
    /*
      Action button
    */ actionButton: {
        fontSize: ({ fontSize: fontSize })=>fontSize || $i4KPV.FONT.SIZE.BASE,
        color: ({ theme: theme })=>theme === $i4KPV.THEME_ENUM.v1 ? $i4KPV.COLORS.BLACK : $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        padding: "0.375em",
        "&:hover": {
            backgroundColor: "transparent",
            color: ({ theme: theme })=>theme === $i4KPV.THEME_ENUM.v1 ? $i4KPV.COLORS.PRIMARY_500_ACCENT : $i4KPV.COLORS_V2.PRIMARY_700
        }
    },
    actionButtonIcon: {
        fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE
    },
    unarchiveActionButton: {
        transform: "rotate(-90deg)"
    },
    actionButtonPlus: {
        position: "absolute",
        top: "0.65em",
        left: "0.7em",
        fontSize: "0.8em",
        fontWeight: $i4KPV.FONT.WEIGHT.BOLD
    },
    duplicateIconActionButton: {
        transform: "scaleX(-1) scaleY(-1)"
    },
    actionButtonRipple: {
        opacity: 0.5
    }
});
module.exports.default = $4a9d3a57b9de0fdb$var$useStyles;

});


parcelRegister("eOExg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $ac952daf58970b46$var$useStyles = (0, $1GFtd.default)({
    root: {
        minWidth: ({ buttonCount: buttonCount })=>`${buttonCount * 2.4}em`
    }
});
module.exports.default = $ac952daf58970b46$var$useStyles;

});


parcelRegister("aCHxR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $7bbf3b25047cf56a$var$useBaseStyles = (0, $1GFtd.default)({
    /*
      Paper
    */ paper: {
        boxShadow: "unset"
    },
    /*
      Table
    */ table: {
        fontSize: $i4KPV.FONT.SIZE.BASE
    },
    noResults: {
        display: "flex",
        justifyContent: "center",
        padding: "1em 0",
        width: "100%"
    }
});
module.exports.default = $7bbf3b25047cf56a$var$useBaseStyles;

});

parcelRegister("jIKIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $e5b65e704c33e8d4$var$useStylesV1 = (0, $1GFtd.default)({
    /*
      Table container
    */ tableContainer: {
        // This is for scrollbar height
        paddingBottom: ".5em"
    },
    tableHeader: {}
});
module.exports.default = $e5b65e704c33e8d4$var$useStylesV1;

});

parcelRegister("jFKWo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $e526422288a1bd0a$var$useStylesV2 = (0, $1GFtd.default)({
    tableContainer: {
        bgColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        fontFamily: $i4KPV.FONT.FAMILY.POPPINS
    },
    tableHeader: {
        fontWeight: $i4KPV.FONT.WEIGHT.SEMI_BOLD,
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE
    }
});
module.exports.default = $e526422288a1bd0a$var$useStylesV2;

});


parcelRegister("4Pqbs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bp629", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6vVdw", function(module, exports) {
"use strict";
var $4be2057194dca7f2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4be2057194dca7f2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4be2057194dca7f2$var$__createBinding(exports1, m, p);
};
var $4be2057194dca7f2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_ENUM = void 0;

const $4be2057194dca7f2$var$krg_chip_react_1 = $4be2057194dca7f2$var$__importDefault((parcelRequire("6nvXE")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty(module.exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$4be2057194dca7f2$var$__exportStar((parcelRequire("bnozN")), module.exports);
module.exports.default = $4be2057194dca7f2$var$krg_chip_react_1.default;

});
parcelRegister("6nvXE", function(module, exports) {
"use strict";
var $4a4daee327f52de9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $4a4daee327f52de9$var$react_1 = $4a4daee327f52de9$var$__importDefault((parcelRequire("acw62")));

var $26QC4 = parcelRequire("26QC4");
var $6ami2 = parcelRequire("6ami2");

var $i4KPV = parcelRequire("i4KPV");

var $bnozN = parcelRequire("bnozN");

const $4a4daee327f52de9$var$base_style_1 = $4a4daee327f52de9$var$__importDefault((parcelRequire("5nx6L")));

const $4a4daee327f52de9$var$style_v1_1 = $4a4daee327f52de9$var$__importDefault((parcelRequire("6h7TG")));

const $4a4daee327f52de9$var$style_v2_1 = $4a4daee327f52de9$var$__importDefault((parcelRequire("dfMxv")));
const $4a4daee327f52de9$var$KrgChip = ({ id: id, className: className = "", data: data, startAdornment: startAdornment, style: style, type: type, isClickable: isClickable = false, isEnabled: isEnabled = true, theme: theme = $i4KPV.THEME_ENUM.v1, onDelete: onDelete, onBlur: onBlur, onClick: onClick, onFocus: onFocus })=>{
    const props = {
        type: type,
        isClickable: isClickable
    };
    const baseClasses = (0, $4a4daee327f52de9$var$base_style_1.default)(props);
    const classesV1 = (0, $4a4daee327f52de9$var$style_v1_1.default)(props);
    const classesV2 = (0, $4a4daee327f52de9$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const variant = type === $bnozN.TYPE_ENUM.transparent ? "outlined" : "filled";
    const color = type === $bnozN.TYPE_ENUM.primary ? "primary" : "default";
    const avatarBlock = $4a4daee327f52de9$var$react_1.default.createElement($26QC4.default, null, startAdornment);
    const isAvatarAdornment = typeof startAdornment === "string";
    const chipClasses = {
        root: `${baseClasses.root} ${classes.root}`,
        colorPrimary: classes.colorPrimary,
        iconColorPrimary: classes.iconColorPrimary,
        deleteIconColorPrimary: classes.deleteIconColorPrimary
    };
    return $4a4daee327f52de9$var$react_1.default.createElement($6ami2.default, {
        id: id,
        className: className,
        classes: chipClasses,
        style: style,
        avatar: isAvatarAdornment ? avatarBlock : undefined,
        icon: isAvatarAdornment ? undefined : startAdornment,
        label: data.text,
        variant: variant,
        color: color,
        disabled: !isEnabled,
        clickable: isClickable,
        onDelete: !!onDelete ? ()=>onDelete(data.id) : undefined,
        onClick: isClickable && onClick ? ()=>onClick(data.id) : undefined,
        onFocus: onFocus,
        onBlur: onBlur
    });
};
$4a4daee327f52de9$var$KrgChip.TYPE_ENUM = $bnozN.TYPE_ENUM;
$4a4daee327f52de9$var$KrgChip.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $4a4daee327f52de9$var$KrgChip;

});
parcelRegister("bnozN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TYPE_ENUM = void 0;
var $8484e8100ac357ed$var$TYPE_ENUM;
(function(TYPE_ENUM) {
    TYPE_ENUM["primary"] = "primary";
    TYPE_ENUM["gray"] = "gray";
    TYPE_ENUM["transparent"] = "transparent";
})($8484e8100ac357ed$var$TYPE_ENUM || (module.exports.TYPE_ENUM = $8484e8100ac357ed$var$TYPE_ENUM = {}));

});

parcelRegister("5nx6L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");
const $3ea8c8553d2ac166$var$useBaseStyles = (0, $1GFtd.default)({
    root: {}
});
module.exports.default = $3ea8c8553d2ac166$var$useBaseStyles;

});

parcelRegister("6h7TG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $491a74d51eb30696$var$useStylesV1 = (0, $1GFtd.default)({
    root: {},
    colorPrimary: {
        backgroundColor: $i4KPV.COLORS.PRIMARY_50,
        color: $i4KPV.COLORS.PRIMARY_500_ACCENT,
        "&:hover, &:focus": {
            backgroundColor: $i4KPV.COLORS.PRIMARY_10,
            color: $i4KPV.COLORS.PRIMARY_DARK_TEXT
        }
    },
    iconColorPrimary: {
        color: `${$i4KPV.COLORS.PRIMARY_500_ACCENT} !important`
    },
    deleteIconColorPrimary: {
        color: `${$i4KPV.COLORS.PRIMARY_500_ACCENT} !important`,
        "&:hover, &:active": {
            color: `${$i4KPV.COLORS.PRIMARY_DARK_TEXT} !important`
        }
    }
});
module.exports.default = $491a74d51eb30696$var$useStylesV1;

});

parcelRegister("dfMxv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $bnozN = parcelRequire("bnozN");
const $9a625405095306ae$var$useStylesV2 = (0, $1GFtd.default)({
    // Chip root element
    root: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        height: "1.3125em",
        padding: "0.3125em",
        backgroundColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.NEUTRAL_MEDIUM : "transparent",
        borderColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.transparent ? $i4KPV.COLORS_V2.NEUTRAL_BLACK : "unset",
        // Label text
        "& > .MuiChip-label": {
            fontSize: $i4KPV.FONT.SIZE.SMALL,
            fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            padding: "0 0.4375em"
        },
        // Adornment Icon
        "& > .MuiChip-icon": {
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            fontSize: $i4KPV.FONT.SIZE.LARGE,
            margin: 0
        },
        // Adornment Avatar
        "& > .MuiAvatar-root": {
            fontSize: $i4KPV.FONT.SIZE.SMALL,
            margin: 0,
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_DARK,
            color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            width: "1.4em",
            height: "1.4em"
        },
        // Delete Icon
        "& > .MuiChip-deleteIcon": {
            color: $i4KPV.COLORS_V2.NEUTRAL_DARK,
            fontSize: $i4KPV.FONT.SIZE.LARGE,
            marginRight: "-0.1041665em",
            marginLeft: 0,
            background: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? `radial-gradient(circle at center, ${$i4KPV.COLORS_V2.NEUTRAL_LIGHT} 0, ${$i4KPV.COLORS_V2.NEUTRAL_LIGHT} 50%, transparent 51%, transparent 100%)` : `radial-gradient(circle at center, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 0, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 50%, transparent 51%, transparent 100%)`,
            "&:hover, &:focus": {
                color: $i4KPV.COLORS_V2.PRIMARY_700
            }
        },
        // Chip + Disabled
        "&.Mui-disabled": {
            backgroundColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.NEUTRAL_INACTIVE : "transparent",
            borderColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.transparent ? $i4KPV.COLORS_V2.NEUTRAL_INACTIVE : "unset",
            opacity: 1,
            // Label text + Disabled
            "& > .MuiChip-label": {
                color: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            },
            // Adornment Icon + Disabled
            "& > .MuiChip-icon": {
                color: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            },
            // Adornment Avatar + Disabled
            "& > .MuiAvatar-root": {
                color: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
                backgroundColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            },
            // Delete Icon + Disabled
            "& > .MuiChip-deleteIcon": {
                background: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? `radial-gradient(circle at center, ${$i4KPV.COLORS_V2.NEUTRAL_INACTIVE} 0, ${$i4KPV.COLORS_V2.NEUTRAL_INACTIVE} 50%, transparent 51%, transparent 100%)` : `radial-gradient(circle at center, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 0, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 50%, transparent 51%, transparent 100%)`,
                color: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.NEUTRAL_LIGHT : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        "&.MuiChip-clickable:hover, &.MuiChip-clickable:focus": {
            backgroundColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.PRIMARY_50 : "transparent",
            borderColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.transparent ? $i4KPV.COLORS_V2.PRIMARY_700 : "unset",
            // Label text + Hover
            "& > .MuiChip-label": {
                color: ({ type: type })=>type === $bnozN.TYPE_ENUM.transparent ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_BLACK
            },
            // Adornment Icon + Hover
            "& > .MuiChip-icon": {
                color: ({ type: type })=>type === $bnozN.TYPE_ENUM.transparent ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_BLACK
            },
            // Avatar  + Hover
            "& > .MuiAvatar-root": {
                backgroundColor: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.PRIMARY_700
            },
            // Delete Icon + Hover
            "& > .MuiChip-deleteIcon": {
                background: ({ type: type })=>type === $bnozN.TYPE_ENUM.gray ? `radial-gradient(circle at center, ${$i4KPV.COLORS_V2.PRIMARY_50} 0, ${$i4KPV.COLORS_V2.PRIMARY_50} 50%, transparent 51%, transparent 100%)` : `radial-gradient(circle at center, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 0, ${$i4KPV.COLORS_V2.NEUTRAL_WHITE} 50%, transparent 51%, transparent 100%)`
            }
        },
        "&:active": {
            boxShadow: ({ isClickable: isClickable })=>isClickable ? `0 0.25em 0.25em ${$i4KPV.COLORS_V2_ALPHA.NEUTRAL_BLACK_SHADOW}` : "none"
        }
    },
    colorPrimary: {},
    iconColorPrimary: {},
    deleteIconColorPrimary: {}
});
module.exports.default = $9a625405095306ae$var$useStylesV2;

});



parcelRegister("1BMiU", function(module, exports) {
"use strict";
var $12beb74d0287b52b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $12beb74d0287b52b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $12beb74d0287b52b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $12beb74d0287b52b$var$__createBinding(result, mod, k);
    }
    $12beb74d0287b52b$var$__setModuleDefault(result, mod);
    return result;
};
var $12beb74d0287b52b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $12beb74d0287b52b$var$react_1 = $12beb74d0287b52b$var$__importStar((parcelRequire("acw62")));

var $2iAqv = parcelRequire("2iAqv");
var $bjZRT = parcelRequire("bjZRT");
var $gd5y7 = parcelRequire("gd5y7");
var $OEVqP = parcelRequire("OEVqP");
var $cX7V2 = parcelRequire("cX7V2");
var $i32L9 = parcelRequire("i32L9");

var $8XBUQ = parcelRequire("8XBUQ");
var $2LuXZ = parcelRequire("2LuXZ");
var $6dnkd = parcelRequire("6dnkd");

var $bcMh9 = parcelRequire("bcMh9");

const $12beb74d0287b52b$var$shared_components_krg_checkbox_1 = $12beb74d0287b52b$var$__importDefault((parcelRequire("htqGM")));

const $12beb74d0287b52b$var$shared_components_krg_chip_1 = $12beb74d0287b52b$var$__importStar((parcelRequire("6vVdw")));

var $i4KPV = parcelRequire("i4KPV");

const $12beb74d0287b52b$var$base_style_1 = $12beb74d0287b52b$var$__importDefault((parcelRequire("ePnXv")));

const $12beb74d0287b52b$var$style_v2_1 = $12beb74d0287b52b$var$__importDefault((parcelRequire("dpbR3")));

const $12beb74d0287b52b$var$style_v1_1 = $12beb74d0287b52b$var$__importDefault((parcelRequire("clPCA")));
const $12beb74d0287b52b$var$KrgSelect = ({ id: id, classNames: classNames = {
    label: "",
    select: "",
    selectContainer: ""
}, style: style, variant: variant = $i4KPV.INPUT_VARIANT_ENUM.outlined, size: size = $bcMh9.SIZE_ENUM.medium, label: label, items: items, value: value, helperText: helperText, multipleType: multipleType = $bcMh9.MULTIPLE_TYPE_ENUM.chip, errorMessage: errorMessage, isMultiple: isMultiple = false, isFullWidth: isFullWidth = false, isEnabled: isEnabled = true, isRounded: isRounded = false, theme: theme = $i4KPV.THEME_ENUM.v1, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur })=>{
    const selectId = `krg-select-${id || Math.random()}`;
    const props = {
        variant: variant,
        size: size,
        isFullWidth: isFullWidth,
        isEnabled: isEnabled,
        isRounded: isRounded
    };
    const [isOpen, setIsOpen] = (0, $12beb74d0287b52b$var$react_1.useState)(false);
    const isV2Theme = theme === $i4KPV.THEME_ENUM.v2;
    const baseClasses = (0, $12beb74d0287b52b$var$base_style_1.default)(props);
    const classesV1 = (0, $12beb74d0287b52b$var$style_v1_1.default)(props);
    const classesV2 = (0, $12beb74d0287b52b$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    const selectRef = (0, $12beb74d0287b52b$var$react_1.useRef)();
    const isOutlinedVariant = variant === $i4KPV.INPUT_VARIANT_ENUM.outlined;
    const isValueAnObject = typeof value === "object";
    const selectAll = "selectAll";
    const clearAll = "clearAll";
    const renderList = items.filter(({ isHidden: isHidden })=>!isHidden).map((item)=>{
        return $12beb74d0287b52b$var$react_1.default.createElement($2iAqv.default, {
            key: item.value,
            value: item.value,
            disabled: item.isEnabled === false
        }, isMultiple && multipleType === $bcMh9.MULTIPLE_TYPE_ENUM.checkmark && $12beb74d0287b52b$var$react_1.default.createElement($12beb74d0287b52b$var$shared_components_krg_checkbox_1.default, {
            hasStopPropagation: false,
            isChecked: isValueAnObject ? value.findIndex((val)=>val === item.value) > -1 : false,
            isEnabled: isEnabled && item.isEnabled !== false,
            theme: theme
        }), $12beb74d0287b52b$var$react_1.default.createElement("span", null, item.text), isV2Theme && (item.hasArrowIcon || item.customIcon) && $12beb74d0287b52b$var$react_1.default.createElement($bjZRT.default, {
            className: classes.menuItemIcon
        }, item.customIcon || $12beb74d0287b52b$var$react_1.default.createElement($8XBUQ.default, null)));
    });
    const allItemValueArr = items.filter((item)=>!item.isHidden && isEnabled && item.isEnabled !== false).map((item)=>item.value);
    const selectAllButton = ()=>{
        if (!isMultiple && !isValueAnObject) return;
        return $12beb74d0287b52b$var$react_1.default.createElement($2iAqv.default, {
            key: selectAll,
            value: selectAll,
            disabled: (value === null || value === void 0 ? void 0 : value.toString()) === allItemValueArr.toString(),
            classes: {
                root: `${baseClasses.selectAll} ${classes.selectAll}`
            }
        }, $12beb74d0287b52b$var$react_1.default.createElement("span", null, "Select All"));
    };
    const clearAllButton = ()=>{
        if (!isMultiple && !isValueAnObject) return;
        return $12beb74d0287b52b$var$react_1.default.createElement($2iAqv.default, {
            key: clearAll,
            value: clearAll,
            disabled: (value === null || value === void 0 ? void 0 : value.toString()) === "",
            classes: {
                root: `${baseClasses.selectAll} ${classes.selectAll} ${classes.clearAll}`
            }
        }, $12beb74d0287b52b$var$react_1.default.createElement("span", null, "Clear All"));
    };
    const findItem = (itemValue)=>items.find((item)=>item.value === itemValue);
    const renderValue = (selectedValue)=>{
        if (typeof selectedValue === "object" && isMultiple) {
            const texts = selectedValue.map((item)=>{
                var _a;
                return ((_a = findItem(item)) === null || _a === void 0 ? void 0 : _a.text) || "";
            });
            return multipleType === $bcMh9.MULTIPLE_TYPE_ENUM.chip ? texts.map((text, index)=>$12beb74d0287b52b$var$react_1.default.createElement($12beb74d0287b52b$var$shared_components_krg_chip_1.default, {
                    className: classes.chip,
                    key: index,
                    type: $12beb74d0287b52b$var$shared_components_krg_chip_1.TYPE_ENUM.gray,
                    data: {
                        text: (text === null || text === void 0 ? void 0 : text.toString()) || "",
                        id: index
                    },
                    isEnabled: isEnabled,
                    theme: theme
                })) : texts.join(", ");
        }
        const foundItem = findItem(selectedValue);
        return (foundItem === null || foundItem === void 0 ? void 0 : foundItem.text) || "";
    };
    const labelVariantClass = isOutlinedVariant ? baseClasses.labelOutlined : classes.labelStandard;
    const selectVariantClass = isOutlinedVariant ? baseClasses.selectOutlined : baseClasses.selectStandard;
    const selectThemeVariantClass = isOutlinedVariant ? classes.selectOutlined : classes.selectStandard;
    const handleOnChange = (e)=>{
        // multiple selection
        if (typeof e.target.value === "object") {
            const valueArr = e.target.value;
            valueArr.includes(selectAll) ? onChange === null || onChange === void 0 || onChange(allItemValueArr) : valueArr.includes(clearAll) ? onChange === null || onChange === void 0 || onChange([]) : onChange === null || onChange === void 0 || onChange(valueArr);
        } else if (e.target.value !== clearAll || selectAll) // single selection
        onChange === null || onChange === void 0 || onChange(e.target.value);
    };
    return $12beb74d0287b52b$var$react_1.default.createElement($gd5y7.default, {
        className: `${classes.selectContainer} ${classNames.selectContainer}`,
        variant: variant,
        error: !!errorMessage
    }, $12beb74d0287b52b$var$react_1.default.createElement($OEVqP.default, {
        className: `${baseClasses.label}` + ` ${classes.label}` + ` ${labelVariantClass}` + ` ${classNames.label}` + ` ${isEnabled ? "" : classes.labelDisabled}`,
        htmlFor: selectId
    }, label), isOutlinedVariant && isRounded && $12beb74d0287b52b$var$react_1.default.createElement("div", {
        className: `${baseClasses.select} ${classes.outlinedRoundedGap}`,
        style: {
            opacity: isOpen ? 1 : 0
        }
    }), $12beb74d0287b52b$var$react_1.default.createElement($cX7V2.default, {
        id: id,
        ref: selectRef,
        style: style,
        label: label,
        IconComponent: isV2Theme ? isOutlinedVariant ? $2LuXZ.default : $6dnkd.default : undefined,
        className: `${selectVariantClass}` + ` ${selectThemeVariantClass}` + ` ${classes.select}` + ` ${baseClasses.select}` + ` ${classNames === null || classNames === void 0 ? void 0 : classNames.select}`,
        defaultValue: isMultiple ? [] : "",
        fullWidth: isFullWidth,
        labelId: selectId,
        disabled: !isEnabled,
        multiple: isMultiple,
        value: value,
        renderValue: (selected)=>renderValue(selected),
        MenuProps: {
            classes: {
                paper: `${baseClasses.menu}` + ` ${classes.menu}` + ` ${isOutlinedVariant ? classes.menuOutlined : undefined}` + ` ${errorMessage ? classes.menuError : undefined}`
            }
        },
        onOpen: ()=>setIsOpen(true),
        onClose: ()=>{
            setTimeout(()=>{
                var _a;
                return (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.firstChild.blur();
            }, 0);
            setIsOpen(false);
        },
        onChange: handleOnChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick
    }, selectAllButton(), clearAllButton(), renderList), $12beb74d0287b52b$var$react_1.default.createElement($i32L9.default, {
        className: `${baseClasses.helperText} ${classes.helperText}`
    }, errorMessage || helperText));
};
$12beb74d0287b52b$var$KrgSelect.MULTIPLE_TYPE_ENUM = $bcMh9.MULTIPLE_TYPE_ENUM;
$12beb74d0287b52b$var$KrgSelect.SIZE_ENUM = $bcMh9.SIZE_ENUM;
$12beb74d0287b52b$var$KrgSelect.VARIANT_ENUM = $i4KPV.INPUT_VARIANT_ENUM;
$12beb74d0287b52b$var$KrgSelect.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $12beb74d0287b52b$var$KrgSelect;

});
parcelRegister("8XBUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $68613eb14e9ec7e3$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $68613eb14e9ec7e3$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m10 17 5-5-5-5z"
}), "ArrowRight");

});

parcelRegister("6dnkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $48660cdefc9954f1$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $48660cdefc9954f1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), "ArrowDropDown");

});

parcelRegister("bcMh9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SIZE_ENUM = module.exports.MULTIPLE_TYPE_ENUM = void 0;
var $8286433d08f73178$var$MULTIPLE_TYPE_ENUM;
(function(MULTIPLE_TYPE_ENUM) {
    MULTIPLE_TYPE_ENUM["default"] = "default";
    MULTIPLE_TYPE_ENUM["checkmark"] = "checkmark";
    MULTIPLE_TYPE_ENUM["chip"] = "chip";
})($8286433d08f73178$var$MULTIPLE_TYPE_ENUM || (module.exports.MULTIPLE_TYPE_ENUM = $8286433d08f73178$var$MULTIPLE_TYPE_ENUM = {}));
var $8286433d08f73178$var$SIZE_ENUM;
(function(SIZE_ENUM) {
    SIZE_ENUM["small"] = "small";
    SIZE_ENUM["medium"] = "medium";
})($8286433d08f73178$var$SIZE_ENUM || (module.exports.SIZE_ENUM = $8286433d08f73178$var$SIZE_ENUM = {}));

});

parcelRegister("ePnXv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $acb869cc3cc14a22$var$useBaseStyles = (0, $1GFtd.default)({
    label: {
        fontSize: "0.9em",
        "&.Mui-error": {
            color: $i4KPV.COLORS.ERROR_DARK,
            "&.MuiInputLabel-shrink.Mui-focused": {
                color: $i4KPV.COLORS.ERROR_DARK
            }
        }
    },
    labelOutlined: {
        marginTop: "-0.47em",
        "&.MuiInputLabel-filled.MuiInputLabel-shrink": {
            marginTop: "-0.47em"
        },
        "&.MuiInputLabel-shrink": {
            marginTop: "0"
        }
    },
    select: {
        display: "flex",
        alignItems: "center",
        height: "2.25em",
        width: ({ isFullWidth: isFullWidth })=>isFullWidth ? "100%" : "15.625em",
        borderRadius: 0,
        padding: 0,
        color: $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
        opacity: ({ isEnabled: isEnabled })=>isEnabled ? 1 : 0.6,
        "& .MuiSelect-root": {
            fontSize: "0.9em"
        },
        "&.Mui-focused > .MuiSelect-select": {
            backgroundColor: "transparent"
        },
        "& .MuiSelect-icon": {
            color: $i4KPV.COLORS.GRAY_DARK
        },
        "&.Mui-error": {
            "& .MuiSvgIcon-root": {
                color: $i4KPV.COLORS.ERROR_DARK
            }
        }
    },
    helperText: {
        margin: "0.25em 0.0625em",
        fontSize: $i4KPV.FONT.SIZE.MEDIUM,
        "&.Mui-error": {
            color: $i4KPV.COLORS.ERROR_DARK
        }
    },
    selectOutlined: {
        "& .MuiSelect-root": {
            padding: "0.5em 0.8em"
        },
        "&.Mui-error": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: $i4KPV.COLORS.ERROR_DARK
            }
        },
        "&:hover": {
            borderColor: $i4KPV.COLORS.GRAY_DARK
        }
    },
    selectStandard: {
        marginTop: "0 !important",
        "& .MuiFormLabel-root": {
            marginTop: "0"
        },
        "& .MuiSelect-root": {
            padding: "0.7em 0"
        },
        "&.MuiInput-underline:before": {
            borderBottomColor: $i4KPV.COLORS.GRAY_DARK
        },
        "&.MuiInput-underline:hover:before": {
            borderBottom: `0.0625em solid ${$i4KPV.COLORS.GRAY_DARK}`,
            opacity: 0.4
        },
        "&.Mui-error": {
            "&.MuiInput-underline:before": {
                borderBottomColor: $i4KPV.COLORS.ERROR_DARK
            },
            "&.MuiInput-underline:after": {
                borderBottomColor: $i4KPV.COLORS.ERROR_DARK
            }
        }
    },
    menu: {
        marginTop: ({ variant: variant })=>variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? "-0.25em" : "0.0625em",
        borderRadius: "0.25em",
        paddingBottom: "0.5em",
        boxShadow: `0 0.25em 0.25em ${$i4KPV.COLORS.BLACK_SHADOW}`,
        "& .MuiList-root": {
            minWidth: "10.625em",
            width: "auto",
            padding: 0,
            maxHeight: "18.75em",
            background: $i4KPV.COLORS.WHITE,
            overflow: "hidden auto"
        },
        "& .MuiListItem-root": {
            fontSize: "0.9em"
        }
    },
    selectAll: {
        "&.MuiMenuItem-root": {
            width: "40%",
            display: "inline-flex",
            margin: "1em 0 0.5em 0",
            backgroundColor: "white",
            fontWeight: 500
        },
        "&:hover.MuiMenuItem-root": {
            backgroundColor: "white"
        }
    }
});
module.exports.default = $acb869cc3cc14a22$var$useBaseStyles;

});

parcelRegister("dpbR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $bcMh9 = parcelRequire("bcMh9");
const $9c26ce483e30218c$var$useStylesV2 = (0, $1GFtd.default)({
    selectContainer: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        height: ({ size: size })=>size === $bcMh9.SIZE_ENUM.small ? "1.9375em" : "2.3125em",
        minWidth: "3.125em",
        width: "100%",
        "&:hover > .MuiInputLabel-root:not(.Mui-error)": {
            color: ({ isEnabled: isEnabled })=>isEnabled ? $i4KPV.COLORS_V2.NEUTRAL_BLACK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        }
    },
    select: {
        height: ({ size: size })=>size === $bcMh9.SIZE_ENUM.small ? "1.9375em" : "2.3125em",
        width: "100%",
        "& .MuiSelect-select": {
            fontSize: $i4KPV.FONT.SIZE.REGULAR,
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
            paddingLeft: ({ isRounded: isRounded, variant: variant, size: size })=>isRounded && variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? size === $bcMh9.SIZE_ENUM.small ? "2.81818em" : "3.363636em" : variant === $i4KPV.INPUT_VARIANT_ENUM.standard ? "0" : "1.454545em",
            "&.Mui-disabled": {
                opacity: 1,
                WebkitTextFillColor: "unset",
                color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
            }
        },
        "&.Mui-focused .MuiSelect-select": {
            color: $i4KPV.COLORS_V2.PRIMARY_700
        },
        "&.Mui-error .MuiSelect-select": {
            color: $i4KPV.COLORS_V2.ERROR_DARK
        },
        // Borders Outline
        "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: ({ isRounded: isRounded })=>isRounded ? "2em" : 0,
            borderColor: $i4KPV.COLORS_V2.NEUTRAL_DARK,
            borderWidth: "0.0625em",
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            "& > legend": {
                marginLeft: ({ isRounded: isRounded, variant: variant, size: size })=>isRounded && variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? size === $bcMh9.SIZE_ENUM.small ? "0.5em" : "0.75em" : "0.1666em",
                "& > span:not(.notranslate)": {
                    fontSize: "0.91667em",
                    padding: "0 0.363635em"
                }
            }
        },
        "&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) > .MuiOutlinedInput-notchedOutline": {
            borderColor: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            borderWidth: "0.0625em"
        },
        "&.Mui-focused": {
            color: $i4KPV.COLORS_V2.PRIMARY_700
        },
        "&.Mui-error": {
            color: $i4KPV.COLORS_V2.ERROR_DARK
        },
        "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
            borderColor: $i4KPV.COLORS_V2.PRIMARY_700,
            borderWidth: "0.125em"
        },
        "&.Mui-error > .MuiOutlinedInput-notchedOutline": {
            borderColor: $i4KPV.COLORS_V2.ERROR_DARK,
            borderWidth: "0.125em"
        },
        "&.Mui-disabled > .MuiOutlinedInput-notchedOutline": {
            borderColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
            borderWidth: "0.0625em"
        },
        "&.MuiOutlinedInput-root.Mui-disabled": {
            opacity: 1,
            color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        },
        // Borders standard
        "&.MuiInput-underline": {
            "&:before": {
                borderWidth: "0.0625em",
                borderColor: $i4KPV.COLORS_V2.NEUTRAL_DARK,
                borderBottomStyle: "solid"
            },
            "&.Mui-disabled:before": {
                borderColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
                opacity: 1
            },
            "&.Mui-focused:before": {
                borderColor: $i4KPV.COLORS_V2.PRIMARY_700,
                borderWidth: "0.125em"
            },
            "&:hover:not(.Mui-disabled):not(.Mui-focused):before": {
                borderWidth: "0.0625em",
                opacity: 1,
                borderColor: $i4KPV.COLORS_V2.NEUTRAL_BLACK
            },
            "&:not(.Mui-error):after": {
                transform: "scaleX(1)",
                border: "none"
            },
            "&.Mui-error.Mui-disabled:after": {
                border: "none"
            }
        },
        // Force keep same height to the container
        "& .notranslate": {
            display: "block"
        },
        // Shown over the fieldset element
        "& > .MuiSelect-select": {
            zIndex: 1
        },
        "& > .MuiSvgIcon-root": {
            zIndex: 1,
            color: ({ isEnabled: isEnabled })=>isEnabled ? $i4KPV.COLORS_V2.NEUTRAL_DARK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        },
        "&.Mui-error > .MuiSvgIcon-root": {
            color: ({ isEnabled: isEnabled })=>isEnabled ? $i4KPV.COLORS_V2.ERROR_DARK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        },
        "&.Mui-focused:not(.Mui-error) > .MuiSvgIcon-root": {
            color: $i4KPV.COLORS_V2.PRIMARY_700
        },
        "&:hover:not(.Mui-error) > .MuiSvgIcon-root": {
            color: ({ isEnabled: isEnabled })=>isEnabled ? $i4KPV.COLORS_V2.NEUTRAL_BLACK : $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        }
    },
    selectStandard: {
        "& > .MuiInput-input": {
            height: ({ size: size })=>size === $bcMh9.SIZE_ENUM.small ? "1.9375em" : "2.3125em",
            minHeight: ({ size: size })=>size === $bcMh9.SIZE_ENUM.small ? "2em" : "2.5452em"
        },
        "& .MuiSelect-select": {
            lineHeight: ({ size: size })=>size === $bcMh9.SIZE_ENUM.small ? "3.181818em" : "4.272727em"
        },
        "&.Mui-disabled": {
            opacity: 1,
            WebkitTextFillColor: "unset",
            color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        }
    },
    selectOutlined: {},
    label: {
        color: $i4KPV.COLORS_V2.NEUTRAL_DARK,
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        transition: "cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
        height: "1em",
        lineHeight: "1em",
        marginTop: ({ size: size, variant: variant })=>variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? size === $bcMh9.SIZE_ENUM.medium ? "-0.272727em" : "-0.5625em" : size === $bcMh9.SIZE_ENUM.medium ? "-0.625em" : "-0.875em",
        marginLeft: ({ isRounded: isRounded, variant: variant, size: size })=>isRounded && variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? size === $bcMh9.SIZE_ENUM.small ? "1.454545em" : "2em" : variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? "0.181818em" : 0,
        "&.MuiInputLabel-shrink": {
            fontWeight: $i4KPV.FONT.WEIGHT.NORMAL,
            fontSize: "0.83em",
            marginTop: ({ size: size, variant: variant })=>size === $bcMh9.SIZE_ENUM.small && variant === $i4KPV.INPUT_VARIANT_ENUM.standard ? "-0.15em" : "0.3em",
            marginLeft: ({ isRounded: isRounded, variant: variant, size: size })=>isRounded && variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? size === $bcMh9.SIZE_ENUM.small ? "0.4285715em" : "0.6428571em" : variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? "0.142857em" : 0,
            "&.Mui-focused": {
                color: $i4KPV.COLORS_V2.PRIMARY_700
            }
        }
    },
    labelStandard: {},
    labelDisabled: {
        color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
        "&.Mui-error": {
            color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        }
    },
    menu: {
        marginTop: 0,
        boxShadow: `0 0.25em 0.25em ${$i4KPV.COLORS_V2_ALPHA.NEUTRAL_BLACK_SHADOW}`,
        background: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        "& .MuiList-root": {
            minWidth: "auto"
        },
        "& > ul > li": {
            color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
            fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
            height: ({ size: size })=>size === $bcMh9.SIZE_ENUM.small ? "1.9375em" : "2.3125em",
            paddingLeft: "0.75em",
            "& > span": {
                fontSize: $i4KPV.FONT.SIZE.REGULAR,
                flex: 1
            },
            "&.Mui-selected": {
                background: $i4KPV.COLORS_V2.PRIMARY_50
            },
            "&.Mui-disabled": {
                color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
                opacity: 1,
                "& .MuiSvgIcon-root": {
                    color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
                }
            },
            "&:hover, &.Mui-selected:hover": {
                background: $i4KPV.COLORS_V2.PRIMARY_100
            },
            "& .MuiCheckbox-root": {
                marginLeft: "-0.4375em",
                marginRight: "0.625em"
            }
        }
    },
    menuOutlined: {
        borderTop: 0,
        padding: 0,
        paddingTop: ({ isRounded: isRounded })=>isRounded ? "1em" : 0,
        paddingBottom: "0.5em"
    },
    menuError: {
        borderColor: $i4KPV.COLORS_V2.ERROR_DARK,
        borderWidth: "0.125em"
    },
    menuItemIcon: {
        "&.MuiListItemIcon-root": {
            minWidth: "auto",
            "& > .MuiSvgIcon-root": {
                fontSize: "1.25em"
            }
        }
    },
    outlinedRoundedGap: {
        position: "absolute",
        height: "50%",
        width: "inherit",
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        bottom: 0,
        transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    },
    chip: {
        "&.MuiChip-root": {
            margin: ({ variant: variant })=>variant === $i4KPV.INPUT_VARIANT_ENUM.standard ? "0 0.25em 0.5em 0" : "0 0.25em 0 0"
        }
    },
    helperText: {
        fontSize: $i4KPV.FONT.SIZE.SMALL,
        marginLeft: ({ isRounded: isRounded, size: size, variant: variant })=>isRounded && variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? size === $bcMh9.SIZE_ENUM.small ? "1.25em" : "1.5em" : 0
    },
    selectAll: {
        "&.MuiMenuItem-root": {
            width: "30%",
            marginTop: ({ isRounded: isRounded, variant: variant })=>isRounded && variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? 0 : "1em",
            marginLeft: 0,
            marginBottom: 0,
            paddingLeft: "0.75em"
        },
        "&:hover.MuiMenuItem-root": {
            color: $i4KPV.COLORS_V2.PRIMARY_700
        }
    },
    clearAll: {
        "&.MuiMenuItem-root": {
            marginLeft: "40%",
            paddingLeft: "1.5em"
        }
    }
});
module.exports.default = $9c26ce483e30218c$var$useStylesV2;

});

parcelRegister("clPCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $8fdf7d2285f41d22$var$useStylesV1 = (0, $1GFtd.default)({
    selectContainer: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        height: "2.25em"
    },
    select: {
        "&.Mui-focused > .MuiSelect-icon": {
            color: $i4KPV.COLORS.PRIMARY_500_ACCENT
        }
    },
    selectStandard: {
        "&.MuiInput-underline:after": {
            borderBottomColor: $i4KPV.COLORS.PRIMARY_500_ACCENT
        }
    },
    selectOutlined: {
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: `0.0625em solid ${$i4KPV.COLORS.PRIMARY_500_ACCENT}`
        }
    },
    label: {
        "&.MuiInputLabel-shrink.Mui-focused": {
            color: $i4KPV.COLORS.PRIMARY_500_ACCENT
        }
    },
    labelStandard: {
        marginTop: "-0.7em"
    },
    labelDisabled: {},
    menu: {},
    menuOutlined: {},
    menuError: {},
    menuItemIcon: {},
    outlinedRoundedGap: {},
    chip: {
        "&.MuiChip-root": {
            height: "1.5625em",
            margin: "0 0.3125em"
        }
    },
    helperText: {},
    selectAll: {
        "&:hover.MuiMenuItem-root": {
            color: $i4KPV.COLORS.PRIMARY_500_ACCENT
        }
    },
    clearAll: {
        "&.MuiMenuItem-root": {
            marginLeft: "20%"
        }
    }
});
module.exports.default = $8fdf7d2285f41d22$var$useStylesV1;

});


parcelRegister("aD0se", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6yJwi", function(module, exports) {
"use strict";
var $4c693a5f9b088889$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4c693a5f9b088889$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4c693a5f9b088889$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4c693a5f9b088889$var$__createBinding(result, mod, k);
    }
    $4c693a5f9b088889$var$__setModuleDefault(result, mod);
    return result;
};
var $4c693a5f9b088889$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $4c693a5f9b088889$var$react_1 = $4c693a5f9b088889$var$__importStar((parcelRequire("acw62")));

var $iAtns = parcelRequire("iAtns");

var $i4KPV = parcelRequire("i4KPV");

var $j6RuV = parcelRequire("j6RuV");

var $dUvwV = parcelRequire("dUvwV");

const $4c693a5f9b088889$var$base_style_1 = $4c693a5f9b088889$var$__importDefault((parcelRequire("5e1Cs")));

const $4c693a5f9b088889$var$style_v1_1 = $4c693a5f9b088889$var$__importDefault((parcelRequire("14Hsl")));

const $4c693a5f9b088889$var$style_v2_1 = $4c693a5f9b088889$var$__importDefault((parcelRequire("bUq9l")));
const $4c693a5f9b088889$var$KrgTextArea = ({ className: className, style: style, borderColor: borderColor, text: text, debounceTime: debounceTime = 300, textColor: textColor, label: label, labelColor: labelColor, placeholder: placeholder, placeholderColor: placeholderColor, maxCharacter: maxCharacter, variant: variant = $i4KPV.INPUT_VARIANT_ENUM.outlined, resize: resize = $dUvwV.RESIZE_ENUM.vertical, rows: rows = 4, rowsMax: rowsMax, errorMessage: errorMessage, validations: validations, isFullWidth: isFullWidth = true, isAutoHeight: isAutoHeight = false, isEnabled: isEnabled = true, theme: theme = $i4KPV.THEME_ENUM.v1, onTextChange: onTextChange, onDebounceEnd: onDebounceEnd, onDebounceRestart: onDebounceRestart, onClick: onClick, onFocus: onFocus, onBlur: onBlur })=>{
    const [innerText, setInnerText] = (0, $4c693a5f9b088889$var$react_1.useState)("");
    const [trackerValidation, setTrackerValidation] = (0, $4c693a5f9b088889$var$react_1.useState)({
        default: true,
        noscript: true,
        script: true,
        img: true,
        imgSrc: true,
        iframe: true
    });
    const timer = (0, $4c693a5f9b088889$var$react_1.useRef)(null);
    const isControlled = text !== undefined;
    const inputValue = isControlled ? text : innerText;
    const props = {
        resize: resize,
        textColor: textColor,
        labelColor: labelColor,
        placeholderColor: placeholderColor,
        borderColor: borderColor,
        isAutoHeight: isAutoHeight
    };
    const baseClasses = (0, $4c693a5f9b088889$var$base_style_1.default)(props)();
    const classesV1 = (0, $4c693a5f9b088889$var$style_v1_1.default)(props)();
    const classesV2 = (0, $4c693a5f9b088889$var$style_v2_1.default)(props)();
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    (0, $4c693a5f9b088889$var$react_1.useEffect)(()=>{
        if (validations === null || validations === void 0 ? void 0 : validations.url) handleUrlValidation();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        inputValue
    ]);
    const handleUrlValidation = ()=>{
        const matchTags = {
            noscript: [],
            img: [],
            imgSrc: [],
            script: [],
            iframe: [],
            default: []
        };
        const splitUrls = inputValue.split(/\r?\n/);
        const urls = splitUrls.filter((url)=>{
            return url.trim().length > 0;
        });
        // validate url imp trackers
        urls.forEach((url)=>{
            const trackerUrl = url.toLowerCase().trim();
            if (trackerUrl.startsWith("<script")) matchTags.script.push(trackerUrl.endsWith("</script>"));
            else if (trackerUrl.startsWith("<noscript")) matchTags.noscript.push(trackerUrl.endsWith("</noscript>"));
            else if (trackerUrl.startsWith("<img")) {
                const imgSrcMatch = trackerUrl.match(/<img[^>]+src=["']([^"'>]*)/gi) !== null;
                matchTags.img.push(trackerUrl.endsWith("/>"));
                matchTags.imgSrc.push(imgSrcMatch);
            } else if (trackerUrl.startsWith("<iframe")) matchTags.iframe.push(trackerUrl.endsWith("</iframe>"));
            else {
                // eslint-disable-next-line
                const defaultMatch = url.match(/^https:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%\{\}]+$/) !== null;
                matchTags.default.push(defaultMatch);
            }
        });
        setTrackerValidation({
            noscript: matchTags.noscript.every((val)=>val),
            img: matchTags.img.every((val)=>val),
            imgSrc: matchTags.imgSrc.every((val)=>val),
            script: matchTags.script.every((val)=>val),
            iframe: matchTags.iframe.every((val)=>val),
            default: matchTags.default.every((val)=>val)
        });
    };
    const onTextValueChange = (e)=>{
        const value = e.target.value;
        if (isControlled) {
            onTextChange === null || onTextChange === void 0 || onTextChange(value);
            if (onDebounceEnd) handleDebounce(value);
        } else {
            setInnerText(value);
            if (onDebounceEnd) handleDebounce(value);
        }
    };
    const handleDebounce = (value)=>{
        if (timer && timer.current) clearTimeout(timer.current);
        onDebounceRestart === null || onDebounceRestart === void 0 || onDebounceRestart();
        timer.current = setTimeout(()=>{
            onDebounceEnd === null || onDebounceEnd === void 0 || onDebounceEnd(value);
        }, debounceTime);
    };
    const getHelperText = ()=>{
        if (errorMessage) return errorMessage;
        if (maxCharacter) {
            const remainingLength = maxCharacter - inputValue.length;
            if (remainingLength > -1) return `${remainingLength} characters remaining`;
            return `${Math.abs(remainingLength)} characters over`;
        }
    };
    const hasError = ()=>{
        if (errorMessage) return true;
        if (maxCharacter) return maxCharacter - inputValue.length < 0;
        if (validations === null || validations === void 0 ? void 0 : validations.url) return !trackerValidation.default || !trackerValidation.iframe || !trackerValidation.script || !trackerValidation.noscript || !trackerValidation.img || !trackerValidation.imgSrc;
    };
    const textAreaDecoratorClass = isEnabled ? hasError() ? classes.textAreaError : classes.textAreaEnabled : `${baseClasses.textAreaDisabled} ${classes.textAreaDisabled}`;
    const textAreaVariantClass = variant === $i4KPV.INPUT_VARIANT_ENUM.outlined ? "" : baseClasses.textAreaStandard;
    const trackerValidationError = $4c693a5f9b088889$var$react_1.default.createElement($4c693a5f9b088889$var$react_1.default.Fragment, null, trackerValidation.script && trackerValidation.noscript && trackerValidation.iframe && trackerValidation.img && trackerValidation.imgSrc && !trackerValidation.default && $4c693a5f9b088889$var$react_1.default.createElement("p", {
        className: baseClasses.errorText
    }, $j6RuV.ERRORS.default), !trackerValidation.script && $4c693a5f9b088889$var$react_1.default.createElement("p", {
        className: baseClasses.errorText
    }, $j6RuV.ERRORS.script), !trackerValidation.noscript && $4c693a5f9b088889$var$react_1.default.createElement("p", {
        className: baseClasses.errorText
    }, $j6RuV.ERRORS.noscript), !trackerValidation.img && $4c693a5f9b088889$var$react_1.default.createElement("p", {
        className: baseClasses.errorText
    }, $j6RuV.ERRORS.img), trackerValidation.img && !trackerValidation.imgSrc && $4c693a5f9b088889$var$react_1.default.createElement("p", {
        className: baseClasses.errorText
    }, $j6RuV.ERRORS.imgSrc), !trackerValidation.iframe && $4c693a5f9b088889$var$react_1.default.createElement("p", {
        className: baseClasses.errorText
    }, $j6RuV.ERRORS.iframe));
    return $4c693a5f9b088889$var$react_1.default.createElement($4c693a5f9b088889$var$react_1.default.Fragment, null, $4c693a5f9b088889$var$react_1.default.createElement($iAtns.default, {
        className: `${className}` + ` ${baseClasses.textArea}` + ` ${textAreaDecoratorClass}` + ` ${textAreaVariantClass}`,
        InputProps: {
            className: baseClasses.container
        },
        rows: rows,
        maxRows: rowsMax,
        multiline: true,
        fullWidth: isFullWidth,
        style: style,
        label: label,
        placeholder: placeholder,
        disabled: !isEnabled,
        variant: variant,
        value: inputValue,
        onChange: onTextValueChange,
        error: hasError(),
        helperText: getHelperText(),
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick
    }), trackerValidationError);
};
$4c693a5f9b088889$var$KrgTextArea.RESIZE_ENUM = $dUvwV.RESIZE_ENUM;
$4c693a5f9b088889$var$KrgTextArea.VARIANT_ENUM = $i4KPV.INPUT_VARIANT_ENUM;
$4c693a5f9b088889$var$KrgTextArea.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $4c693a5f9b088889$var$KrgTextArea;

});
parcelRegister("j6RuV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERRORS = void 0;
module.exports.ERRORS = {
    default: "Invalid or incomplete trackers. Contact Kargo support if you need help.",
    noscript: "Format nonscript to be on one line, including closing the tag",
    script: "Format your script to be on the same line and close tags",
    iframe: "Format your iframe to be on one line, including the closing tag",
    img: "Format image to be on one line, including closing the tag",
    imgSrc: "Format your image to include a valid src value"
};

});

parcelRegister("dUvwV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RESIZE_ENUM = void 0;
var $a208f68f28b998bd$var$RESIZE_ENUM;
(function(RESIZE_ENUM) {
    RESIZE_ENUM["none"] = "none";
    RESIZE_ENUM["horizontal"] = "horizontal";
    RESIZE_ENUM["vertical"] = "vertical";
    RESIZE_ENUM["both"] = "both";
})($a208f68f28b998bd$var$RESIZE_ENUM || (module.exports.RESIZE_ENUM = $a208f68f28b998bd$var$RESIZE_ENUM = {}));

});

parcelRegister("5e1Cs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $3cdf8419e352b48f$var$useBaseStyles = ({ resize: resize, textColor: textColor, labelColor: labelColor, placeholderColor: placeholderColor, borderColor: borderColor, isAutoHeight: isAutoHeight })=>(0, $1GFtd.default)({
        /*
      Container class
    */ container: {
            borderRadius: 0,
            color: textColor || $i4KPV.COLORS.BLACK_HIGH_EMPHASIS,
            fontSize: $i4KPV.FONT.SIZE.EXTRA_LARGE,
            lineHeight: 1.2
        },
        textArea: {
            fontSize: $i4KPV.FONT.SIZE.BASE,
            "& textarea": {
                resize: resize,
                fontSize: $i4KPV.FONT.SIZE.LARGE
            },
            "& .MuiInput-formControl": {
                marginTop: "0"
            },
            // Textfield label
            "& .MuiInputLabel-root": {
                fontSize: "0.9em"
            },
            "& ::-webkit-input-placeholder": {
                color: placeholderColor || $i4KPV.COLORS.BLACK_HIGH_EMPHASIS
            },
            "& .MuiFormHelperText-root": {
                margin: "0.25em 0.0625em"
            }
        },
        textAreaStandard: {
            // Textarea label
            "& .MuiInputLabel-root": {
                fontSize: "0.9em"
            }
        },
        textAreaDisabled: {
            "& .MuiInput-underline:before": {
                borderBottomColor: $i4KPV.COLORS.GRAY_DIVIDER,
                borderBottomStyle: "solid"
            }
        },
        errorText: {
            width: "100%",
            color: $i4KPV.COLORS.ERROR_DARK,
            fontSize: $i4KPV.FONT.SIZE.MEDIUM,
            lineHeight: 1.4,
            overflow: isAutoHeight ? "initial" : "hidden",
            textOverflow: "ellipsis",
            whiteSpace: isAutoHeight ? "normal" : "nowrap"
        }
    });
module.exports.default = $3cdf8419e352b48f$var$useBaseStyles;

});

parcelRegister("14Hsl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $0c87dfab3057f7d9$var$useStylesV1 = ({ labelColor: labelColor, borderColor: borderColor, isAutoHeight: isAutoHeight })=>(0, $1GFtd.default)({
        textAreaEnabled: {
            // Border style
            "& .MuiInput-underline:before": {
                // Semi-transparent underline
                borderBottomColor: borderColor || $i4KPV.COLORS.GRAY_DARK
            },
            "& .MuiInput-underline:hover:before": {
                borderBottomColor: borderColor || $i4KPV.COLORS.GRAY_DARK,
                opacity: 0.4
            },
            "& .MuiInput-underline:after": {
                // Solid underline on focus
                borderBottomColor: borderColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
            },
            // Label style
            "& .MuiInputLabel-root": {
                color: labelColor || $i4KPV.COLORS.BLACK_DISABLED
            },
            "& .MuiInputLabel-root.MuiFormLabel-filled": {
                color: labelColor || $i4KPV.COLORS.GRAY_DARK
            },
            "& .MuiInputLabel-root.Mui-focused": {
                color: labelColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
            },
            // Border style for outline
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: borderColor || $i4KPV.COLORS.GRAY_DARK
                },
                "&:hover fieldset": {
                    borderColor: borderColor || $i4KPV.COLORS.GRAY_DARK,
                    opacity: 0.7
                },
                "&.Mui-focused fieldset": {
                    borderColor: borderColor || $i4KPV.COLORS.PRIMARY_500_ACCENT
                }
            }
        },
        textAreaDisabled: {},
        textAreaError: {
            "& .MuiInput-underline:after": {
                borderBottomColor: $i4KPV.COLORS.ERROR_DARK
            },
            "& .MuiFormHelperText-root": {
                color: $i4KPV.COLORS.ERROR_DARK,
                fontSize: $i4KPV.FONT.SIZE.MEDIUM,
                lineHeight: 1.4,
                overflow: isAutoHeight ? "initial" : "hidden",
                textOverflow: "ellipsis",
                whiteSpace: isAutoHeight ? "normal" : "nowrap"
            },
            "& .MuiInputLabel-root": {
                color: $i4KPV.COLORS.ERROR_DARK
            },
            "& .MuiOutlinedInput-root": {
                "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                    borderColor: $i4KPV.COLORS.ERROR_DARK
                },
                "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: $i4KPV.COLORS.ERROR_DARK,
                    opacity: 0.7
                }
            }
        }
    });
module.exports.default = $0c87dfab3057f7d9$var$useStylesV1;

});

parcelRegister("bUq9l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $8ab9357840d63321$var$useStylesV2 = ({ labelColor: labelColor, borderColor: borderColor, isAutoHeight: isAutoHeight })=>(0, $1GFtd.default)({
        textAreaEnabled: {
            // Border style for underline
            "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-focused):before": {
                borderBottomColor: borderColor || $i4KPV.COLORS_V2.NEUTRAL_BLACK,
                borderWidth: "0.0625em"
            },
            "& .MuiInput-underline.Mui-focused:hover:before": {
                border: "none"
            },
            "& .MuiInput-underline:after": {
                transform: "scaleX(1)",
                border: "none"
            },
            "& .MuiInput-underline.Mui-focused:after": {
                borderBottomWidth: "0.125em",
                borderBottomStyle: "solid",
                borderBottomColor: borderColor || $i4KPV.COLORS_V2.PRIMARY_700
            },
            // Border style for outline
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: borderColor || $i4KPV.COLORS_V2.NEUTRAL_DARK
                },
                "&:hover fieldset": {
                    borderColor: borderColor || $i4KPV.COLORS_V2.NEUTRAL_BLACK,
                    opacity: 1
                },
                "&.Mui-focused fieldset": {
                    borderColor: borderColor || $i4KPV.COLORS_V2.PRIMARY_700,
                    opacity: 1
                }
            },
            // Input style
            "& .MuiInputBase-root": {
                "&.Mui-focused": {
                    "& fieldset": {
                        borderColor: borderColor || $i4KPV.COLORS_V2.PRIMARY_700
                    }
                }
            },
            // Label style
            "& .MuiInputLabel-root": {
                color: labelColor || $i4KPV.COLORS_V2.NEUTRAL_DARK,
                "&.MuiFormLabel-filled": {
                    color: labelColor || $i4KPV.COLORS_V2.NEUTRAL_BLACK
                },
                "&.Mui-focused": {
                    color: labelColor || $i4KPV.COLORS_V2.PRIMARY_700
                }
            }
        },
        textAreaDisabled: {
            "& .MuiInput-underline.Mui-error:after": {
                borderWidth: "0.0625em",
                borderBottomColor: $i4KPV.COLORS_V2.NEUTRAL_DARK
            },
            "& .MuiOutlinedInput-root": {
                "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                    borderColor: $i4KPV.COLORS_V2.NEUTRAL_DARK
                }
            },
            "& .MuiFormHelperText-root": {
                color: $i4KPV.COLORS_V2.ERROR_DARK
            }
        },
        textAreaError: {
            "& .MuiInput-underline.Mui-error:after": {
                borderBottomColor: $i4KPV.COLORS_V2.ERROR_DARK
            },
            "& .MuiFormHelperText-root": {
                color: $i4KPV.COLORS_V2.ERROR_DARK,
                fontSize: $i4KPV.FONT.SIZE.MEDIUM,
                lineHeight: 1.4,
                overflow: isAutoHeight ? "initial" : "hidden",
                textOverflow: "ellipsis",
                whiteSpace: isAutoHeight ? "normal" : "nowrap"
            },
            "& .MuiInputLabel-root": {
                color: $i4KPV.COLORS_V2.ERROR_DARK
            },
            "& .MuiOutlinedInput-root": {
                "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                    borderColor: $i4KPV.COLORS_V2.ERROR_DARK,
                    borderWidth: "0.12em"
                },
                "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: $i4KPV.COLORS_V2.ERROR_DARK
                }
            }
        }
    });
module.exports.default = $8ab9357840d63321$var$useStylesV2;

});


parcelRegister("qZSsd", function(module, exports) {
"use strict";
var $05126d5d2166fed0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $05126d5d2166fed0$var$react_1 = $05126d5d2166fed0$var$__importDefault((parcelRequire("acw62")));

var $aDtBU = parcelRequire("aDtBU");
var $jNGAr = parcelRequire("jNGAr");

var $i4KPV = parcelRequire("i4KPV");

var $4eFsB = parcelRequire("4eFsB");

const $05126d5d2166fed0$var$base_style_1 = $05126d5d2166fed0$var$__importDefault((parcelRequire("6v6nt")));

const $05126d5d2166fed0$var$style_v1_1 = $05126d5d2166fed0$var$__importDefault((parcelRequire("bgy0X")));

const $05126d5d2166fed0$var$style_v2_1 = $05126d5d2166fed0$var$__importDefault((parcelRequire("jQkXE")));
const $05126d5d2166fed0$var$KrgTabs = ({ className: className = "", style: style, background: background = $i4KPV.BACKGROUND_ENUM.white, variant: variant = $4eFsB.VARIANT_ENUM.standard, size: size = $4eFsB.SIZE_ENUM.small, selectedTab: selectedTab, tabs: tabs, isEnabled: isEnabled = true, theme: theme = $i4KPV.THEME_ENUM.v1, onChange: onChange, onClick: onClick, onBlur: onBlur, onFocus: onFocus })=>{
    var _a;
    const props = {
        background: background,
        size: size,
        isEnabled: isEnabled
    };
    const baseClasses = (0, $05126d5d2166fed0$var$base_style_1.default)(props);
    const classesV1 = (0, $05126d5d2166fed0$var$style_v1_1.default)(props);
    const classesV2 = (0, $05126d5d2166fed0$var$style_v2_1.default)(props);
    const classes = theme === $i4KPV.THEME_ENUM.v2 ? classesV2 : classesV1;
    return $05126d5d2166fed0$var$react_1.default.createElement("div", {
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        className: `${baseClasses.root} ${className}`,
        style: style
    }, $05126d5d2166fed0$var$react_1.default.createElement($aDtBU.default, {
        classes: {
            root: classes.tabs,
            indicator: `${classes.indicator} ` + `${!isEnabled || ((_a = tabs[selectedTab]) === null || _a === void 0 ? void 0 : _a.isEnabled) === false ? classes.indicatorDisabled : undefined} `
        },
        onChange: onChange,
        value: selectedTab,
        variant: variant,
        centered: variant !== $4eFsB.VARIANT_ENUM.scrollable
    }, tabs.map((item, index)=>{
        return $05126d5d2166fed0$var$react_1.default.createElement($jNGAr.default, {
            key: index,
            classes: {
                root: `${classes.tab} ${!!item.icon !== !!item.label ? classes.tabTextOrIcon : classes.tabTextAndIcon}`
            },
            label: item.label,
            icon: item.icon,
            disabled: !isEnabled || item.isEnabled === false
        });
    })));
};
$05126d5d2166fed0$var$KrgTabs.BACKGROUND_ENUM = $i4KPV.BACKGROUND_ENUM;
$05126d5d2166fed0$var$KrgTabs.VARIANT_ENUM = $4eFsB.VARIANT_ENUM;
$05126d5d2166fed0$var$KrgTabs.SIZE_ENUM = $4eFsB.SIZE_ENUM;
$05126d5d2166fed0$var$KrgTabs.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $05126d5d2166fed0$var$KrgTabs;

});
parcelRegister("aDtBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be483edbed3b474$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");

var $1iGrQ = parcelRequire("1iGrQ");

var $7EC2D = parcelRequire("7EC2D");

var $kRsYK = parcelRequire("kRsYK");

var $l0ZbI = parcelRequire("l0ZbI");

var $dz5QO = parcelRequire("dz5QO");

var $4o7uD = parcelRequire("4o7uD");

var $bTm2Q = parcelRequire("bTm2Q");

var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7be483edbed3b474$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bTm2Q.getTabsUtilityClass), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $bTm2Q.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $bTm2Q.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $bTm2Q.default).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $7be483edbed3b474$var$FlexContainer = (0, $d8seH.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $l0ZbI.default))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $dz5QO.default), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $1En50.default)(props, $7be483edbed3b474$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    if (centered && scrollable) console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $7EC2D.getNormalizedScrollLeft)(tabsNode, isRtl ? "rtl" : "ltr"),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                if (!tab) console.error([
                    `MUI: The \`value\` provided to the Tabs component is invalid.`,
                    `None of the Tabs' children match with "${value}".`,
                    valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(", ")}.` : null
                ].join("\n"));
                tabMeta = tab ? tab.getBoundingClientRect() : null;
                if (!$7be483edbed3b474$var$warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 && // if the whole Tabs component is hidden, don't warn
                tabsMeta.clientWidth !== 0) {
                    tabsMeta = null;
                    console.error([
                        "MUI: The `value` provided to the Tabs component is invalid.",
                        `The Tab with this \`value\` ("${value}") is not part of the document layout.`,
                        "Make sure the tab item is present in the document or that it's not `display: none`."
                    ].join("\n"));
                    $7be483edbed3b474$var$warnedOnceTabPresent = true;
                }
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $4o7uD.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $kRsYK.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $7EC2D.detectScrollType)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $4o7uD.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $4o7uD.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $9Evvr.default)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsIndicator, (0, $8nd05.default)({}, TabIndicatorProps, {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $8nd05.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Tabs component doesn't accept a Fragment as a child.",
            "Consider providing an array instead."
        ].join("\n"));
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, (0, $8nd05.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $gzyUk.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
$7be483edbed3b474$var$Tabs.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */ action: (0, $i582X.default),
    /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */ allowScrollButtonsMobile: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The label for the Tabs as a string.
   */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * An id or list of ids separated by a space that label the Tabs.
   */ "aria-labelledby": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */ centered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Determines the color of the indicator.
   * @default 'primary'
   */ indicatorColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "horizontal",
        "vertical"
    ]),
    /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */ ScrollButtonComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */ scrollButtons: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOf([
        "auto",
        false,
        true
    ]),
    /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */ selectionFollowsFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        endScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        startScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        EndScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        StartScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Props applied to the tab indicator element.
   * @default  {}
   */ TabIndicatorProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */ TabScrollButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */ textColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "inherit",
        "primary",
        "secondary"
    ]),
    /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "fullWidth",
        "scrollable",
        "standard"
    ]),
    /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */ visibleScrollbar: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;

});
parcelRegister("7EC2D", function(module, exports) {

$parcel$export(module.exports, "detectScrollType", () => $5929c7187933e9a1$export$a10970ffb6510128);
$parcel$export(module.exports, "getNormalizedScrollLeft", () => $5929c7187933e9a1$export$3c615b88e5d7e4f6);
// Source from https://github.com/alitaheri/normalize-scroll-left
let $5929c7187933e9a1$var$cachedType;
function $5929c7187933e9a1$export$a10970ffb6510128() {
    if ($5929c7187933e9a1$var$cachedType) return $5929c7187933e9a1$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $5929c7187933e9a1$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $5929c7187933e9a1$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $5929c7187933e9a1$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $5929c7187933e9a1$var$cachedType;
}
function $5929c7187933e9a1$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $5929c7187933e9a1$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

});

parcelRegister("kRsYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ff3c73ed46b37c$export$2e2bcd8739ae039);
function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("l0ZbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c90fbbf54d23af$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $1iGrQ = parcelRequire("1iGrQ");

var $khjmj = parcelRequire("khjmj");
var $9Evvr = parcelRequire("9Evvr");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $f4c90fbbf54d23af$var$_excluded = [
    "onChange"
];
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $1En50.default)(props, $f4c90fbbf54d23af$var$_excluded);
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $khjmj.default)(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $9Evvr.default)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        style: $f4c90fbbf54d23af$var$styles,
        ref: nodeRef
    }, other));
}
$f4c90fbbf54d23af$export$2e2bcd8739ae039.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};

});

parcelRegister("dz5QO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e031514df70ea8e$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $6n0Ko = parcelRequire("6n0Ko");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $4CguH = parcelRequire("4CguH");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $9e031514df70ea8e$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4CguH.getTabScrollButtonUtilityClass), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $4CguH.default).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $1En50.default)(props, $9e031514df70ea8e$var$_excluded);
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = (0, $8nd05.default)({
        isRtl: isRtl
    }, props);
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $frMNQ.default);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $f46un.default);
    const startButtonIconProps = (0, $eD6Co.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $eD6Co.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, (0, $8nd05.default)({
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, (0, $8nd05.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, (0, $8nd05.default)({}, endButtonIconProps))
    }));
});
$9e031514df70ea8e$var$TabScrollButton.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The direction the button should indicate.
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "left",
        "right"
    ]).isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The component orientation (layout flow direction).
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "horizontal",
        "vertical"
    ]).isRequired,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        endScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        startScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        EndScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        StartScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;

});
parcelRegister("4CguH", function(module, exports) {

$parcel$export(module.exports, "getTabScrollButtonUtilityClass", () => $35c7816ebadb07c9$export$34861783d3c2eef8);
$parcel$export(module.exports, "default", () => $35c7816ebadb07c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)("MuiTabScrollButton", slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $beCSm.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;

});


parcelRegister("bTm2Q", function(module, exports) {

$parcel$export(module.exports, "getTabsUtilityClass", () => $8a85ee70c626268d$export$cdd93bd054dec359);
$parcel$export(module.exports, "default", () => $8a85ee70c626268d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)("MuiTabs", slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $beCSm.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;

});


parcelRegister("jNGAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6a3a0c577f6eee9$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $gUzNi = parcelRequire("gUzNi");

var $jHfLJ = parcelRequire("jHfLJ");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $e6a3a0c577f6eee9$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jHfLJ.getTabUtilityClass), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $jHfLJ.default).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $jHfLJ.default).iconWrapper}`]: (0, $8nd05.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $jHfLJ.default).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $jHfLJ.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $jHfLJ.default).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $jHfLJ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $jHfLJ.default).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $jHfLJ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $1En50.default)(props, $e6a3a0c577f6eee9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, (0, $8nd05.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
$e6a3a0c577f6eee9$var$Tab.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: (0, $gUzNi.default),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The position of the icon relative to the label.
   * @default 'top'
   */ iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "bottom",
        "end",
        "start",
        "top"
    ]),
    /**
   * The label element.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */ wrapped: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;

});
parcelRegister("jHfLJ", function(module, exports) {

$parcel$export(module.exports, "getTabUtilityClass", () => $e56e43dd06ac0faa$export$72aef224d6115253);
$parcel$export(module.exports, "default", () => $e56e43dd06ac0faa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)("MuiTab", slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $beCSm.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;

});


parcelRegister("4eFsB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SIZE_ENUM = module.exports.VARIANT_ENUM = void 0;
var $3158a1626e75785e$var$VARIANT_ENUM;
(function(VARIANT_ENUM) {
    VARIANT_ENUM["standard"] = "standard";
    VARIANT_ENUM["scrollable"] = "scrollable";
    VARIANT_ENUM["fullWidth"] = "fullWidth";
})($3158a1626e75785e$var$VARIANT_ENUM || (module.exports.VARIANT_ENUM = $3158a1626e75785e$var$VARIANT_ENUM = {}));
var $3158a1626e75785e$var$SIZE_ENUM;
(function(SIZE_ENUM) {
    SIZE_ENUM["small"] = "small";
    SIZE_ENUM["large"] = "large";
})($3158a1626e75785e$var$SIZE_ENUM || (module.exports.SIZE_ENUM = $3158a1626e75785e$var$SIZE_ENUM = {}));

});

parcelRegister("6v6nt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $4bba95c647b57d8d$var$useBaseStyles = (0, $1GFtd.default)({
    /* Tabs container */ root: {
        alignItems: "center",
        display: "flex",
        fontSize: $i4KPV.FONT.SIZE.BASE
    }
});
module.exports.default = $4bba95c647b57d8d$var$useBaseStyles;

});

parcelRegister("bgy0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $833b92dea3baf40f$var$useStylesV1 = (0, $1GFtd.default)({
    /* Tabs */ tabs: {
        backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS.WHITE : $i4KPV.COLORS.PRIMARY_500_ACCENT
    },
    /* Tab */ tab: {
        fontSize: $i4KPV.FONT.SIZE.MEDIUM,
        color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS.BLACK_MEDIUM_EMPHASIS : $i4KPV.COLORS.WHITE_MEDIUM_EMPHASIS,
        borderBottom: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? `0.1667em solid ${$i4KPV.COLORS.GRAY_LIGHT_4}` : "none",
        "&.Mui-selected": {
            color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS.PRIMARY_500_ACCENT : $i4KPV.COLORS.WHITE
        },
        "&:hover": {
            backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? "rgb(250, 251, 251)" : "inherit",
            color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS.PRIMARY_500_ACCENT : $i4KPV.COLORS.WHITE
        }
    },
    /* Tab text or icon, smaller height for one element */ tabTextOrIcon: {},
    /* Tab text and icon, bigger height for two elements */ tabTextAndIcon: {},
    indicator: {
        backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS.PRIMARY_500_ACCENT : $i4KPV.COLORS.WHITE,
        marginBottom: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? 0 : "0.3125em"
    },
    indicatorDisabled: {}
});
module.exports.default = $833b92dea3baf40f$var$useStylesV1;

});

parcelRegister("jQkXE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");

var $4eFsB = parcelRequire("4eFsB");
const $e72322185551d0e2$var$useStylesV2 = (0, $1GFtd.default)({
    tabs: {},
    /* Tab */ tab: {
        fontWeight: $i4KPV.FONT.WEIGHT.SEMI_BOLD,
        padding: 0,
        // By size
        minWidth: ({ size: size })=>size === $4eFsB.SIZE_ENUM.small ? "11.6363637em" : "11.3888888em",
        fontSize: ({ size: size })=>size === $4eFsB.SIZE_ENUM.small ? $i4KPV.FONT.SIZE.REGULAR : $i4KPV.FONT.SIZE.H2,
        "& svg": {
            fontSize: ({ size: size })=>size === $4eFsB.SIZE_ENUM.small ? "2.18181818em" : "2em"
        },
        // By background
        color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.NEUTRAL_BLACK : $i4KPV.COLORS_V2.NEUTRAL_WHITE,
        "&.Mui-disabled": {
            color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.NEUTRAL_INACTIVE : background === $i4KPV.BACKGROUND_ENUM.blue ? $i4KPV.COLORS_V2.PRIMARY_400 : $i4KPV.COLORS_V2.NEUTRAL_DARK
        },
        "&:not(.Mui-disabled).Mui-selected": {
            color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_WHITE
        },
        "&:hover": {
            color: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_WHITE,
            backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.NEUTRAL_LIGHT : background === $i4KPV.BACKGROUND_ENUM.blue ? $i4KPV.COLORS_V2.PRIMARY_500 : $i4KPV.COLORS_V2.PRIMARY_700
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_WHITE
        },
        // By size + background
        borderBottom: ({ size: size, background: background })=>`${size === $4eFsB.SIZE_ENUM.small ? "0.1" : "0.1125"}em solid ${background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.NEUTRAL_INACTIVE : background === $i4KPV.BACKGROUND_ENUM.blue ? $i4KPV.COLORS_V2.PRIMARY_400 : $i4KPV.COLORS_V2.NEUTRAL_DARK}`
    },
    /* Tab text or icon, smaller height for one element */ tabTextOrIcon: {
        minHeight: ({ size: size })=>size === $4eFsB.SIZE_ENUM.small ? "4.36363637em" : "4.3333333em"
    },
    /* Tab text and icon, bigger height for two elements */ tabTextAndIcon: {
        minHeight: ({ size: size })=>size === $4eFsB.SIZE_ENUM.small ? "6.5454545em" : "6.1111111em"
    },
    indicator: {
        height: ({ size: size })=>size === $4eFsB.SIZE_ENUM.small ? "0.125em" : "0.25em",
        backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.PRIMARY_700 : $i4KPV.COLORS_V2.NEUTRAL_WHITE
    },
    indicatorDisabled: {
        backgroundColor: ({ background: background })=>background === $i4KPV.BACKGROUND_ENUM.white ? $i4KPV.COLORS_V2.NEUTRAL_INACTIVE : background === $i4KPV.BACKGROUND_ENUM.blue ? $i4KPV.COLORS_V2.PRIMARY_400 : $i4KPV.COLORS_V2.NEUTRAL_DARK
    }
});
module.exports.default = $e72322185551d0e2$var$useStylesV2;

});


parcelRegister("i0PuK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("56GVS", function(module, exports) {
"use strict";
var $3b7ed0c9b78a76ef$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3b7ed0c9b78a76ef$var$react_1 = $3b7ed0c9b78a76ef$var$__importDefault((parcelRequire("acw62")));

var $7s24a = parcelRequire("7s24a");
var $2esSG = parcelRequire("2esSG");

var $i4KPV = parcelRequire("i4KPV");

var $fsTIa = parcelRequire("fsTIa");

const $3b7ed0c9b78a76ef$var$shared_components_krg_tooltip_1 = $3b7ed0c9b78a76ef$var$__importDefault((parcelRequire("AfP12")));

const $3b7ed0c9b78a76ef$var$base_style_1 = $3b7ed0c9b78a76ef$var$__importDefault((parcelRequire("5qZeg")));

const $3b7ed0c9b78a76ef$var$style_v1_1 = $3b7ed0c9b78a76ef$var$__importDefault((parcelRequire("gzsQk")));

const $3b7ed0c9b78a76ef$var$style_v2_1 = $3b7ed0c9b78a76ef$var$__importDefault((parcelRequire("02DtR")));
const $3b7ed0c9b78a76ef$var$KrgSwitch = ({ className: className = "", style: style, size: size = $fsTIa.SIZE_ENUM.medium, label: label = "", tooltipConfig: tooltipConfig, hasTrackIcon: hasTrackIcon = false, isChecked: isChecked, isEnabled: isEnabled = true, theme: theme = $i4KPV.THEME_ENUM.v1, onToggle: onToggle, onClick: onClick, onFocus: onFocus, onBlur: onBlur })=>{
    const isV2Theme = theme === $i4KPV.THEME_ENUM.v2;
    const baseClasses = (0, $3b7ed0c9b78a76ef$var$base_style_1.default)();
    const classesV1 = (0, $3b7ed0c9b78a76ef$var$style_v1_1.default)();
    const classesV2 = (0, $3b7ed0c9b78a76ef$var$style_v2_1.default)();
    const classes = isV2Theme ? classesV2 : classesV1;
    const onSwitchToggle = (e)=>onToggle === null || onToggle === void 0 ? void 0 : onToggle(e.target.checked);
    const SwitchComponent = $3b7ed0c9b78a76ef$var$react_1.default.createElement($7s24a.default, {
        className: className,
        classes: {
            root: classes.switchRoot,
            switchBase: classes.switchBase,
            checked: classes.checked,
            track: `${classes.track} ${hasTrackIcon ? classes.trackIcons : ""}`,
            disabled: `${baseClasses.disabled} ${classes.disabled}`
        },
        style: style,
        checked: isChecked,
        size: size,
        disabled: !isEnabled,
        color: "default",
        onChange: onSwitchToggle,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: (e)=>e.stopPropagation()
    });
    const MainComponent = (tooltipConfig === null || tooltipConfig === void 0 ? void 0 : tooltipConfig.tooltip) ? $3b7ed0c9b78a76ef$var$react_1.default.createElement($3b7ed0c9b78a76ef$var$shared_components_krg_tooltip_1.default, Object.assign({}, tooltipConfig), SwitchComponent) : SwitchComponent;
    return $3b7ed0c9b78a76ef$var$react_1.default.createElement($3b7ed0c9b78a76ef$var$react_1.default.Fragment, null, label ? $3b7ed0c9b78a76ef$var$react_1.default.createElement($2esSG.default, {
        classes: {
            root: baseClasses.root,
            label: classes.label
        },
        control: MainComponent,
        labelPlacement: "start",
        label: label
    }) : MainComponent);
};
$3b7ed0c9b78a76ef$var$KrgSwitch.SIZE_ENUM = $fsTIa.SIZE_ENUM;
$3b7ed0c9b78a76ef$var$KrgSwitch.THEME_ENUM = $i4KPV.THEME_ENUM;
module.exports.default = $3b7ed0c9b78a76ef$var$KrgSwitch;

});
parcelRegister("7s24a", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ccc0421702a0be$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $jTnBY = parcelRequire("jTnBY");

var $kVqvD = parcelRequire("kVqvD");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $89Onw = parcelRequire("89Onw");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $56ccc0421702a0be$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $jTnBY.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $89Onw.getSwitchUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inline-flex",
    width: 58,
    height: 38,
    overflow: "hidden",
    padding: 12,
    boxSizing: "border-box",
    position: "relative",
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: "middle",
    // For correct alignment with the text.
    "@media print": {
        colorAdjust: "exact"
    },
    variants: [
        {
            props: {
                edge: "start"
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: "end"
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $89Onw.default).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $89Onw.default).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $89Onw.default).checked}`]: {
                        transform: "translateX(16px)"
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $kVqvD.default), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $89Onw.default).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $89Onw.default).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $89Onw.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $89Onw.default).checked} + .${(0, $89Onw.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $89Onw.default).disabled} + .${(0, $89Onw.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $89Onw.default).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme })=>({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $89Onw.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            "&:hover": {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                "@media (hover: none)": {
                                    backgroundColor: "transparent"
                                }
                            },
                            [`&.${(0, $89Onw.default).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $kSnzZ.lighten)(theme.palette[color].main, 0.62) : (0, $kSnzZ.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $89Onw.default).checked} + .${(0, $89Onw.default).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $1En50.default)(props, $56ccc0421702a0be$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($56ccc0421702a0be$var$SwitchRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, (0, $8nd05.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $8nd05.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
$56ccc0421702a0be$var$Switch.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "default",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "end",
        "start",
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;

});
parcelRegister("89Onw", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", () => $5f063e1b0f6d278b$export$39f6debbec19b3ba);
$parcel$export(module.exports, "default", () => $5f063e1b0f6d278b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)("MuiSwitch", slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $beCSm.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;

});


parcelRegister("2esSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a034abd43bd8eee$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $cJQfW = parcelRequire("cJQfW");

var $30UGG = parcelRequire("30UGG");

var $3bYfT = parcelRequire("3bYfT");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Z1x5 = parcelRequire("7Z1x5");

var $aaphR = parcelRequire("aaphR");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $1a034abd43bd8eee$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7Z1x5.getFormControlLabelUtilityClasses), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7Z1x5.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $7Z1x5.default).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $7Z1x5.default).label}`]: {
            [`&.${(0, $7Z1x5.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $7Z1x5.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $1a034abd43bd8eee$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $3bYfT.default) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), (0, $8nd05.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $9QePP.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
$1a034abd43bd8eee$var$FormControlLabel.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component appears selected.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        typography: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */ control: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element.isRequired,
    /**
   * If `true`, the control is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * A text or an element to be used in an enclosing label element.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The position of the label.
   * @default 'end'
   */ labelPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "bottom",
        "end",
        "start",
        "top"
    ]),
    /**
   * @ignore
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        typography: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The value of the component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;

});
parcelRegister("30UGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $231d58234d437bc0$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $isyt6 = parcelRequire("isyt6");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
"use client";
const $231d58234d437bc0$var$Stack = (0, $isyt6.default)({
    createStyledComponent: (0, $d8seH.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: "MuiStack"
        })
});
$231d58234d437bc0$var$Stack.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "column-reverse",
            "column",
            "row-reverse",
            "row"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "column-reverse",
            "column",
            "row-reverse",
            "row"
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Add an element between each child.
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Defines the space between immediate children.
   * @default 0
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */ useFlexGap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;

});
parcelRegister("isyt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70594339ba23534$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $dFNG2 = parcelRequire("dFNG2");

var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");

var $3OJTQ = parcelRequire("3OJTQ");

var $cKRCq = parcelRequire("cKRCq");

var $ayMG0 = parcelRequire("ayMG0");
const $d70594339ba23534$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $d70594339ba23534$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d70594339ba23534$var$defaultCreateStyledComponent = (0, $0tqaY.default)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $d70594339ba23534$var$useThemePropsDefault(props) {
    return (0, $dFNG2.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $d70594339ba23534$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d70594339ba23534$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d70594339ba23534$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $d70594339ba23534$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $8nd05.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $cKRCq.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$d70594339ba23534$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $cKRCq.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $3OJTQ.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d70594339ba23534$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d70594339ba23534$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d70594339ba23534$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d70594339ba23534$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $1En50.default)(props, $d70594339ba23534$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: divider ? $d70594339ba23534$var$joinChildren(children, divider) : children
        }));
    });
    Stack.propTypes /* remove-proptypes */  = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                "column-reverse",
                "column",
                "row-reverse",
                "row"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                "column-reverse",
                "column",
                "row-reverse",
                "row"
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        spacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]),
        sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    };
    return Stack;
}

});
parcelRegister("0tqaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0016d2a363b4c314$export$2e2bcd8739ae039);

var $dNfBQ = parcelRequire("dNfBQ");
const $0016d2a363b4c314$var$styled = (0, $dNfBQ.default)();
var $0016d2a363b4c314$export$2e2bcd8739ae039 = $0016d2a363b4c314$var$styled;

});
parcelRegister("dNfBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0abf5ad226c4fb0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bOOlK = parcelRequire("bOOlK");

var $3z1Ay = parcelRequire("3z1Ay");

var $gxvzd = parcelRequire("gxvzd");

var $eWm0o = parcelRequire("eWm0o");

var $6o2lr = parcelRequire("6o2lr");

var $9dZwz = parcelRequire("9dZwz");
const $a0abf5ad226c4fb0$var$_excluded = [
    "ownerState"
], $a0abf5ad226c4fb0$var$_excluded2 = [
    "variants"
], $a0abf5ad226c4fb0$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $a0abf5ad226c4fb0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0abf5ad226c4fb0$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $a0abf5ad226c4fb0$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $a0abf5ad226c4fb0$export$35e57303dbd8a66 = (0, $6o2lr.default)();
const $a0abf5ad226c4fb0$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0abf5ad226c4fb0$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a0abf5ad226c4fb0$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a0abf5ad226c4fb0$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a0abf5ad226c4fb0$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $1En50.default)(_ref, $a0abf5ad226c4fb0$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $8nd05.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a0abf5ad226c4fb0$var$processStyleArg(resolvedStyle, (0, $8nd05.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1En50.default)(resolvedStylesArg, $a0abf5ad226c4fb0$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $8nd05.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $8nd05.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $a0abf5ad226c4fb0$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a0abf5ad226c4fb0$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $9dZwz.default)((0, $8nd05.default)({}, props, {
            theme: $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $bOOlK.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a0abf5ad226c4fb0$var$defaultOverridesResolver($a0abf5ad226c4fb0$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1En50.default)(inputOptions, $a0abf5ad226c4fb0$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        if (componentName) // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${$a0abf5ad226c4fb0$var$lowercaseFirstLetter(componentSlot || "Root")}`;
        let shouldForwardPropOption = $a0abf5ad226c4fb0$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0abf5ad226c4fb0$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$a0abf5ad226c4fb0$var$processStyleArg(stylesArg, (0, $8nd05.default)({}, props, {
                    theme: $a0abf5ad226c4fb0$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a0abf5ad226c4fb0$var$processStyleArg(slotStyle, (0, $8nd05.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a0abf5ad226c4fb0$var$processStyleArg({
                    variants: themeVariants
                }, (0, $8nd05.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            {
                let displayName;
                if (componentName) displayName = `${componentName}${(0, $gxvzd.default)(componentSlot || "")}`;
                if (displayName === undefined) displayName = `Styled(${(0, $eWm0o.default)(tag)})`;
                Component.displayName = displayName;
            }
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});


parcelRegister("dFNG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f45a3834bb6880f$export$2e2bcd8739ae039);

var $cfUWu = parcelRequire("cfUWu");

var $7HKeb = parcelRequire("7HKeb");
"use client";
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $7HKeb.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $cfUWu.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("cfUWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ec30e4d54713c84$export$2e2bcd8739ae039);

var $4FZD0 = parcelRequire("4FZD0");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}

});




parcelRegister("7Z1x5", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", () => $5cff6b4166fff27c$export$717666c39ec07e12);
$parcel$export(module.exports, "default", () => $5cff6b4166fff27c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)("MuiFormControlLabel", slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;

});


parcelRegister("fsTIa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SIZE_ENUM = void 0;
var $b424afa3d9bca3c7$var$SIZE_ENUM;
(function(SIZE_ENUM) {
    SIZE_ENUM["small"] = "small";
    SIZE_ENUM["medium"] = "medium";
})($b424afa3d9bca3c7$var$SIZE_ENUM || (module.exports.SIZE_ENUM = $b424afa3d9bca3c7$var$SIZE_ENUM = {}));

});

parcelRegister("5qZeg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $3f4ee048ed9213a7$var$useBaseStyles = (0, $1GFtd.default)({
    root: {
        fontSize: $i4KPV.FONT.SIZE.BASE,
        marginLeft: 0
    },
    disabled: {
        pointerEvents: "none"
    }
});
module.exports.default = $3f4ee048ed9213a7$var$useBaseStyles;

});

parcelRegister("gzsQk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i4KPV = parcelRequire("i4KPV");

var $1GFtd = parcelRequire("1GFtd");
const $c10649d9e925ed4e$var$useStylesV1 = (0, $1GFtd.default)({
    switchRoot: {
        // Checked track color
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: $i4KPV.COLORS.PRIMARY_100,
            opacity: 1
        },
        // Disabled track color
        "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: $i4KPV.COLORS.GRAY_LIGHT,
            opacity: 1
        }
    },
    // Unchecked track color
    track: {
        backgroundColor: $i4KPV.COLORS.GRAY_DARK,
        opacity: 1
    },
    // Unchecked color
    switchBase: {
        color: $i4KPV.COLORS.GRAY_LIGHT
    },
    // Checked color
    checked: {
        color: $i4KPV.COLORS.PRIMARY_500_ACCENT
    },
    trackIcons: {},
    label: {},
    disabled: {}
});
module.exports.default = $c10649d9e925ed4e$var$useStylesV1;

});

parcelRegister("02DtR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1GFtd = parcelRequire("1GFtd");

var $i4KPV = parcelRequire("i4KPV");
const $007ed00cf7ae4cba$var$useStylesV2 = (0, $1GFtd.default)({
    switchRoot: {
        // Disabled switch color
        "& .MuiSwitch-switchBase.Mui-disabled": {
            color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        },
        // Disabled track color
        "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE,
            opacity: 0.5
        }
    },
    // Unchecked color bullet
    switchBase: {
        color: $i4KPV.COLORS_V2.NEUTRAL_LIGHT
    },
    track: {
        backgroundColor: $i4KPV.COLORS_V2.NEUTRAL_DARK,
        opacity: 1
    },
    // Track selection icon indicators
    trackIcons: {
        "&:before, &:after": {
            content: '""',
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            width: "0.625em",
            height: "0.625em",
            backgroundRepeat: "no-repeat"
        },
        // Checked icon
        "&:before": {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg width="11" height="8" viewBox="0 -1 11 8" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0.353553" y1="2.64645" x2="4.35355" y2="6.64645" stroke="white"/><line x1="10.1653" y1="0.318348" x2="4.38556" y2="7.31835" stroke="white"/></svg>')`,
            left: "1em"
        },
        // Unchecked icon
        "&:after": {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0.353553" y1="1.64645" x2="7.35355" y2="8.64645" stroke="white"/><line x1="7.35355" y1="1.23568" x2="0.474468" y2="8.64645" stroke="white"/></svg>')`,
            right: "1em"
        }
    },
    // Checked color
    checked: {
        color: $i4KPV.COLORS_V2.PRIMARY_700,
        "&.Mui-checked+.MuiSwitch-track": {
            backgroundColor: $i4KPV.COLORS_V2.PRIMARY_100,
            opacity: 1
        }
    },
    label: {
        fontSize: $i4KPV.FONT.SIZE.REGULAR,
        fontWeight: $i4KPV.FONT.WEIGHT.MEDIUM,
        marginRight: "1.5em",
        minWidth: "8em",
        color: $i4KPV.COLORS_V2.NEUTRAL_BLACK,
        "&.MuiFormControlLabel-label.Mui-disabled": {
            color: $i4KPV.COLORS_V2.NEUTRAL_INACTIVE
        }
    },
    disabled: {
        "& > .MuiSwitch-thumb": {
            boxShadow: "none"
        }
    }
});
module.exports.default = $007ed00cf7ae4cba$var$useStylesV2;

});


parcelRegister("fcvb5", function(module, exports) {
"use strict";
var $b110293f76a1ab1c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b110293f76a1ab1c$var$react_1 = $b110293f76a1ab1c$var$__importDefault((parcelRequire("acw62")));

var $9ZYXn = parcelRequire("9ZYXn");
var $eJ0JC = parcelRequire("eJ0JC");

var $yCxgx = parcelRequire("yCxgx");

var $lPPDP = parcelRequire("lPPDP");
const $b110293f76a1ab1c$var$KrgToggleButton = ({ buttonGroupClassName: buttonGroupClassName = "", buttonClassName: buttonClassName = "", buttons: buttons, size: size = $lPPDP.SIZE_ENUM.medium, color: color = $lPPDP.COLOR_ENUM_STANDARD.standard, selectedButtons: selectedButtons = [], orientation: orientation = $lPPDP.ORIENTATION_ENUM.horizontal, isSingleSelection: isSingleSelection = true, isEnabled: isEnabled = true, onChange: onChange, onFocus: onFocus, onBlur: onBlur })=>{
    return $b110293f76a1ab1c$var$react_1.default.createElement($9ZYXn.default, {
        className: buttonGroupClassName,
        orientation: orientation,
        color: color,
        size: size,
        value: selectedButtons,
        exclusive: isSingleSelection,
        disabled: !isEnabled,
        onChange: (e, value)=>onChange === null || onChange === void 0 ? void 0 : onChange(isSingleSelection ? [
                value
            ] : value),
        onFocus: onFocus,
        onBlur: onBlur
    }, buttons.map((button)=>$b110293f76a1ab1c$var$react_1.default.createElement($eJ0JC.default, {
            id: button.id,
            key: button.value,
            size: size,
            className: buttonClassName,
            value: button.value || "",
            disabled: !isEnabled || button.isEnabled === false,
            sx: {
                height: size === "large" ? "3.7334em" : "auto",
                "& svg": {
                    fontSize: "1.5rem"
                }
            }
        }, button.isStartIcon && button.icon, button.label && button.label, !button.isStartIcon && button.icon)));
};
$b110293f76a1ab1c$var$KrgToggleButton.ORIENTATION_ENUM = $lPPDP.ORIENTATION_ENUM;
$b110293f76a1ab1c$var$KrgToggleButton.SIZE_ENUM = $lPPDP.SIZE_ENUM;
$b110293f76a1ab1c$var$KrgToggleButton.COLOR_ENUM = $yCxgx.COLOR_ENUM;
module.exports.default = $b110293f76a1ab1c$var$KrgToggleButton;

});
parcelRegister("9ZYXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7479184c3cda7f5d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $djmpM = parcelRequire("djmpM");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $i9RU8 = parcelRequire("i9RU8");

var $lOkLt = parcelRequire("lOkLt");

var $jCUp4 = parcelRequire("jCUp4");

var $3cuAs = parcelRequire("3cuAs");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7479184c3cda7f5d$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $7479184c3cda7f5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation === "vertical" && "vertical",
            fullWidth && "fullWidth"
        ],
        grouped: [
            "grouped",
            `grouped${(0, $jTnBY.default)(orientation)}`,
            disabled && "disabled"
        ],
        firstButton: [
            "firstButton"
        ],
        lastButton: [
            "lastButton"
        ],
        middleButton: [
            "middleButton"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $i9RU8.getToggleButtonGroupUtilityClass), classes);
};
const $7479184c3cda7f5d$var$ToggleButtonGroupRoot = (0, $d8seH.default)("div", {
    name: "MuiToggleButtonGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $i9RU8.default).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $i9RU8.default).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $i9RU8.default).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $i9RU8.default).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $i9RU8.default).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: "inline-flex",
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $i9RU8.default).grouped}`]: (0, $8nd05.default)({}, ownerState.orientation === "horizontal" ? {
            [`&.${(0, $i9RU8.default).selected} + .${(0, $i9RU8.default).grouped}.${(0, $i9RU8.default).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $i9RU8.default).selected} + .${(0, $i9RU8.default).grouped}.${(0, $i9RU8.default).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === "horizontal" ? {
        [`& .${(0, $i9RU8.default).firstButton},& .${(0, $i9RU8.default).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $i9RU8.default).lastButton},& .${(0, $i9RU8.default).middleButton}`]: {
            marginLeft: -1,
            borderLeft: "1px solid transparent",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $i9RU8.default).firstButton},& .${(0, $i9RU8.default).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $i9RU8.default).lastButton},& .${(0, $i9RU8.default).middleButton}`]: {
            marginTop: -1,
            borderTop: "1px solid transparent",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === "horizontal" ? {
        [`& .${(0, $i9RU8.default).lastButton}.${(0, $3cuAs.default).disabled},& .${(0, $i9RU8.default).middleButton}.${(0, $3cuAs.default).disabled}`]: {
            borderLeft: "1px solid transparent"
        }
    } : {
        [`& .${(0, $i9RU8.default).lastButton}.${(0, $3cuAs.default).disabled},& .${(0, $i9RU8.default).middleButton}.${(0, $3cuAs.default).disabled}`]: {
            borderTop: "1px solid transparent"
        }
    }));
const $7479184c3cda7f5d$var$ToggleButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiToggleButtonGroup"
    });
    const { children: children, className: className, color: color = "standard", disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = "horizontal", size: size = "medium", value: value } = props, other = (0, $1En50.default)(props, $7479184c3cda7f5d$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $7479184c3cda7f5d$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $djmpM.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return "";
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$ToggleButtonGroupRoot, (0, $8nd05.default)({
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOkLt.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                if ((0, $4jPKB.isFragment)(child)) console.error([
                    "MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.",
                    "Consider providing an array instead."
                ].join("\n"));
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCUp4.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
$7479184c3cda7f5d$var$ToggleButtonGroup.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the button when it is selected.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "standard",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   * @default false
   */ exclusive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the button group will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback fired when the value changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "horizontal",
        "vertical"
    ]),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "small",
            "medium",
            "large"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   *
   * The value must have reference equality with the option in order to be selected.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $7479184c3cda7f5d$export$2e2bcd8739ae039 = $7479184c3cda7f5d$var$ToggleButtonGroup;

});
parcelRegister("djmpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0e6fd5d31b1b95$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9b0e6fd5d31b1b95$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}

});

parcelRegister("i9RU8", function(module, exports) {

$parcel$export(module.exports, "getToggleButtonGroupUtilityClass", () => $d382e18949ecbd32$export$44aa3ae5b353cef1);
$parcel$export(module.exports, "default", () => $d382e18949ecbd32$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d382e18949ecbd32$export$44aa3ae5b353cef1(slot) {
    return (0, $4Cod0.default)("MuiToggleButtonGroup", slot);
}
const $d382e18949ecbd32$var$toggleButtonGroupClasses = (0, $beCSm.default)("MuiToggleButtonGroup", [
    "root",
    "selected",
    "horizontal",
    "vertical",
    "disabled",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
    "fullWidth",
    "firstButton",
    "lastButton",
    "middleButton"
]);
var $d382e18949ecbd32$export$2e2bcd8739ae039 = $d382e18949ecbd32$var$toggleButtonGroupClasses;

});

parcelRegister("lOkLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0e5fe90030f3ad$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $fe0e5fe90030f3ad$var$ToggleButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
$fe0e5fe90030f3ad$var$ToggleButtonGroupContext.displayName = "ToggleButtonGroupContext";
var $fe0e5fe90030f3ad$export$2e2bcd8739ae039 = $fe0e5fe90030f3ad$var$ToggleButtonGroupContext;

});

parcelRegister("jCUp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49d517bbbfb7eee$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
$e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext.displayName = "ToggleButtonGroupButtonContext";
var $e49d517bbbfb7eee$export$2e2bcd8739ae039 = $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext;

});

parcelRegister("3cuAs", function(module, exports) {

$parcel$export(module.exports, "getToggleButtonUtilityClass", () => $254a3802f36599bb$export$21f89b560b65a301);
$parcel$export(module.exports, "default", () => $254a3802f36599bb$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $254a3802f36599bb$export$21f89b560b65a301(slot) {
    return (0, $4Cod0.default)("MuiToggleButton", slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $beCSm.default)("MuiToggleButton", [
    "root",
    "disabled",
    "selected",
    "standard",
    "primary",
    "secondary",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "fullWidth"
]);
var $254a3802f36599bb$export$2e2bcd8739ae039 = $254a3802f36599bb$var$toggleButtonClasses;

});


parcelRegister("eJ0JC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab85d69438d76ec5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $3cuAs = parcelRequire("3cuAs");

var $lOkLt = parcelRequire("lOkLt");

var $jCUp4 = parcelRequire("jCUp4");

var $d0d3x = parcelRequire("d0d3x");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $ab85d69438d76ec5$var$_excluded = [
    "value"
], $ab85d69438d76ec5$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $ab85d69438d76ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled",
            fullWidth && "fullWidth",
            `size${(0, $jTnBY.default)(size)}`,
            color
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3cuAs.getToggleButtonUtilityClass), classes);
};
const $ab85d69438d76ec5$var$ToggleButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: "MuiToggleButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === "standard" ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === "standard" ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === "standard" ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $8nd05.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`&.${(0, $3cuAs.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        "&:hover": {
            textDecoration: "none",
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $3cuAs.default).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(selectedColor, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $jgarO.alpha)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === "small" && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $ab85d69438d76ec5$var$ToggleButton = /*#__PURE__*/ $acw62.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $acw62.useContext((0, $lOkLt.default)), { value: contextValue } = _React$useContext, contextProps = (0, $1En50.default)(_React$useContext, $ab85d69438d76ec5$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $acw62.useContext((0, $jCUp4.default));
    const resolvedProps = (0, $4FZD0.default)((0, $8nd05.default)({}, contextProps, {
        selected: (0, $d0d3x.default)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: "MuiToggleButton"
    });
    const { children: children, className: className, color: color = "standard", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = "medium", value: value } = props, other = (0, $1En50.default)(props, $ab85d69438d76ec5$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $ab85d69438d76ec5$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab85d69438d76ec5$var$ToggleButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
$ab85d69438d76ec5$var$ToggleButton.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "standard",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the button is rendered in an active state.
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "small",
            "medium",
            "large"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).any.isRequired
};
var $ab85d69438d76ec5$export$2e2bcd8739ae039 = $ab85d69438d76ec5$var$ToggleButton;

});
parcelRegister("jgarO", function(module, exports) {

$parcel$export(module.exports, "alpha", () => $e0579d99723e0dfe$export$58f0f39f63f3cf42);


var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e0579d99723e0dfe$var$clampWrapper(value, min = 0, max = 1) {
    if (value < min || value > max) console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    return (0, $1jJMI.default)(value, min, max);
}
function $e0579d99723e0dfe$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $e0579d99723e0dfe$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e0579d99723e0dfe$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error(`MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`);
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error(`MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`);
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e0579d99723e0dfe$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e0579d99723e0dfe$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $e0579d99723e0dfe$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $e0579d99723e0dfe$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
};
function $e0579d99723e0dfe$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $e0579d99723e0dfe$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $e0579d99723e0dfe$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e0579d99723e0dfe$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $e0579d99723e0dfe$export$29fb7152bd3f781a(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e0579d99723e0dfe$export$c852d90bf7403b62(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e0579d99723e0dfe$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e0579d99723e0dfe$export$c852d90bf7403b62(foreground);
    const lumB = $e0579d99723e0dfe$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    value = $e0579d99723e0dfe$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e0579d99723e0dfe$export$c852d90bf7403b62(color) > 0.5 ? $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) : $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
}
function $e0579d99723e0dfe$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $e0579d99723e0dfe$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $e0579d99723e0dfe$export$677b39864803984e(background);
    const overlayColor = $e0579d99723e0dfe$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});

parcelRegister("d0d3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9775671ab3ebd2db$export$2e2bcd8739ae039);
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $9775671ab3ebd2db$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}

});


parcelRegister("yCxgx", function(module, exports) {
"use strict";
var $06811172526e6b8e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $06811172526e6b8e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $06811172526e6b8e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$06811172526e6b8e$var$__exportStar((parcelRequire("fVgN8")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("hBUtx")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("eP5IC")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("9q4Vo")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("7SEbW")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("dkgsx")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("ho2km")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("8Q6eN")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("8cJF7")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("5syHx")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("7Byxj")), module.exports);

$06811172526e6b8e$var$__exportStar((parcelRequire("lMXxq")), module.exports);

});
parcelRegister("fVgN8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.COLORS_ALPHA = module.exports.BACKGROUND_COLOR = module.exports.COLORS = module.exports.MAX_VIDEO_DURATION = module.exports.MAX_VIDEO_SIZE = module.exports.MAX_FILE_SIZE = module.exports.FONT = module.exports.DATA_UNIT_CONVERSION = module.exports.STORE_KEY_THEME = module.exports.STORE_KEY_FONT_FAMILY = void 0;

var $hBUtx = parcelRequire("hBUtx");
module.exports.STORE_KEY_FONT_FAMILY = "demo_font_family";
module.exports.STORE_KEY_THEME = "demo_theme";
module.exports.DATA_UNIT_CONVERSION = 1024;
module.exports.FONT = {
    WEIGHT: {
        // Light
        THIN: 100,
        EXTRA_LIGHT: 200,
        LIGHT: 300,
        // Regular
        NORMAL: 400,
        MEDIUM: 500,
        // Bold
        SEMI_BOLD: 600,
        BOLD: 700,
        EXTRA_BOLD: 800
    },
    SIZE: {
        // Regular Text
        SMALL: "0.625em",
        REGULAR: "0.6875em",
        MEDIUM: "0.75em",
        SEMI_LARGE: "0.8125em",
        LARGE: "0.875em",
        EXTRA_LARGE: "1em",
        // Set default
        BASE: "16px",
        // Titles
        H2: "1.125em",
        H1: "2.25em"
    },
    FAMILY: {
        POPPINS: $hBUtx.FONT_FAMILY_ENUM.poppins,
        VERDANA: "Verdana, sans-serif",
        HELVETICA: "Helvetica, sans-serif"
    }
};
module.exports.MAX_FILE_SIZE = 4;
module.exports.MAX_VIDEO_SIZE = 20;
module.exports.MAX_VIDEO_DURATION = 65;
module.exports.COLORS = {
    BLACK: "rgb(0, 0, 0)",
    BACKGROUND_DARK: "rgb(167, 179, 189)",
    BLACK_DISABLED: "rgb(145, 160, 173)",
    BLACK_HIGH_EMPHASIS: "rgb(48, 50, 55)",
    BLACK_INACTIVE: "rgb(209, 217, 222)",
    BLACK_MEDIUM_EMPHASIS: "rgb(63, 72, 83)",
    BLACK_SHADOW: "rgba(0, 0, 0, 0.25)",
    CREATIVE_TITLE: "rgb(47, 47, 47)",
    ERROR_DARK: "rgb(255, 48, 55)",
    ERROR_LIGHT: "rgb(255, 131, 135)",
    GRAY_10: "rgb(43, 49, 58)",
    GRAY_3: "rgb(222, 226, 230)",
    GRAY_CHIP_MEDIUM: "rgb(224, 224, 224)",
    GRAY_DARK: "rgb(101, 108, 117)",
    GRAY_DARK_2: "rgb(112, 112, 112)",
    GRAY_DARK_3: "rgb(139, 139, 139)",
    GRAY_DARK_4: "rgb(155, 155, 155)",
    GRAY_DARK_5: "rgb(66, 66, 66)",
    GRAY_DIVIDER: "rgb(167, 179, 189)",
    GRAY_LIGHT: "rgb(238, 240, 242)",
    GRAY_LIGHT_1: "rgb(223, 220, 220)",
    GRAY_LIGHT_2: "rgb(236, 236, 236)",
    GRAY_LIGHT_3: "rgb(196, 196, 196)",
    GRAY_LIGHT_4: "rgb(229, 229, 229)",
    GRAY_LIGHT_5: "rgb(199, 199, 199)",
    GRAY_LINK_INACTIVE: "rgb(128, 131, 137)",
    GRAY_PREVIEW_TEXT: "rgb(199, 207, 213)",
    GRAY_SPONSOR_TEXT: "rgb(142, 148, 160)",
    GRAY_BORDER: "rgb(167, 179, 189)",
    GREEN_LOADER: "rgb(0, 199, 177)",
    PREVIEW_HEADER_TEXT: "rgb(60, 60, 60)",
    PRIMARY_10: "rgb(219, 237, 251)",
    PRIMARY_100: "rgb(204, 214, 255)",
    PRIMARY_400: "rgb(91, 124, 255)",
    PRIMARY_50: "rgb(229, 235, 255)",
    PRIMARY_500_ACCENT: "rgb(0, 181, 226)",
    PRIMARY_900: "rgb(8, 8, 48)",
    PRIMARY_DARK_TEXT: "rgb(0, 72, 128)",
    SUCCESS_DARK: "rgb(0, 148, 126)",
    SUCCESS_LIGHT: "rgb(0, 199, 177)",
    SURFACE_SNACKBAR: "rgb(32, 32, 32)",
    WARNING_BASE: "rgb(255, 205, 0)",
    WARNING_DARK: "rgb(255, 174, 0)",
    WARNING_LIGHT: "rgb(255, 205, 0)",
    WHITE: "rgb(255, 255, 255)",
    WHITE_MEDIUM_EMPHASIS: "rgba(255, 255, 255, 0.7)",
    LOADER_BORDER: "rgb(0, 199, 177)",
    FACEBOOK_BANNER_DIVIDER: "rgb(197, 195, 195)",
    LOADER_LIGHT_BLUE: "rgb(79, 180, 221)",
    LOADER_GREEN: "rgb(88, 196, 178)",
    GRAY_HELPER: "rgb(129, 129, 129)",
    PRIMARY_200: "rgb(165, 183, 255)",
    PRIMARY_300: "rgb(123, 150, 255)",
    PRIMARY_500: "rgb(60, 97, 243)",
    PRIMARY_600: "rgb(37, 80, 250)",
    PRIMARY_700: "rgb(0, 51, 255)",
    PRIMARY_800: "rgb(1, 33, 160)",
    NEUTRAL_BLACK: "rgb(0, 0, 0)",
    NEUTRAL_DARK: "rgb(145, 160, 173)",
    NEUTRAL_INACTIVE: "rgb(209, 217, 222)",
    NEUTRAL_MEDIUM: "rgb(229, 234, 239)",
    NEUTRAL_LIGHT: "rgb(238, 243, 246)",
    NEUTRAL_WHITE: "rgb(255, 255, 255)",
    SUCCESS_LIGHTEST: "rgb(230, 246, 243)",
    WARNING_LIGHTEST: "rgb(255, 246, 212)",
    ERROR_LIGHTEST: "rgb(255, 234, 235)",
    HOME_DEPOT_ORANGE: "rgb(249, 99, 2)"
};
module.exports.BACKGROUND_COLOR = {
    [$hBUtx.BACKGROUND_ENUM.black]: module.exports.COLORS.NEUTRAL_BLACK,
    [$hBUtx.BACKGROUND_ENUM.white]: module.exports.COLORS.NEUTRAL_WHITE,
    [$hBUtx.BACKGROUND_ENUM.blue]: module.exports.COLORS.PRIMARY_700
};
module.exports.COLORS_ALPHA = {
    NEUTRAL_BLACK_SHADOW: module.exports.COLORS.NEUTRAL_BLACK.replace("rgb", "rgba").replace(")", ", 0.25)"),
    NEUTRAL_BLACK_SCRIM: module.exports.COLORS.NEUTRAL_BLACK.replace("rgb", "rgba").replace(")", ", 0.4)"),
    NEUTRAL_WHITE_FADE: module.exports.COLORS.NEUTRAL_WHITE.replace("rgb", "rgba").replace(")", ", 0.54)")
};

});
parcelRegister("hBUtx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MODE = module.exports.THEME = module.exports.COLOR_WITH_STANDARD = module.exports.COLOR_WITH_INHERIT = module.exports.COLOR_WITH_DEFAULT = module.exports.COLOR_ENUM = module.exports.SIZE_VARIANT_ENUM = module.exports.VARIANT_WITH_CONTAINED = module.exports.VARIANT_WITH_DEFAULT = module.exports.INPUT_VARIANT_ENUM = module.exports.DEVICE_TYPE_ENUM = module.exports.FILE_TYPE_ENUM = module.exports.ADVANCED_CREATIVE_SIZES_ENUM = module.exports.BACKGROUND_ENUM = module.exports.DATA_UNIT_ENUM = module.exports.TARGET_ENUM = module.exports.CSS_POS_ENUM = module.exports.PROJECT_ENUM = module.exports.FONT_FAMILY_ENUM = module.exports.CREATIVE_SOCIAL_TYPE_ENUM = module.exports.CREATIVE_DESTINATION_ENUM = module.exports.CREATIVE_FORMAT_IFRAME_ENUM = module.exports.CREATIVE_FORMAT_ENUM = module.exports.CREATIVE_EDITOR_ENUM = void 0;
var $cd21b33b055a3f7a$var$CREATIVE_EDITOR_ENUM;
(function(CREATIVE_EDITOR_ENUM) {
    CREATIVE_EDITOR_ENUM["lite"] = "lite";
    CREATIVE_EDITOR_ENUM["ctv"] = "ctv";
    CREATIVE_EDITOR_ENUM["advanced"] = "advanced";
})($cd21b33b055a3f7a$var$CREATIVE_EDITOR_ENUM || (module.exports.CREATIVE_EDITOR_ENUM = $cd21b33b055a3f7a$var$CREATIVE_EDITOR_ENUM = {}));
var $cd21b33b055a3f7a$var$CREATIVE_FORMAT_ENUM;
(function(CREATIVE_FORMAT_ENUM) {
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardBanner"] = 1] = "StandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["LogoEnhancedBanner"] = 2] = "LogoEnhancedBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["ScrollReactiveBanner"] = 3] = "ScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["AdhesiveBottomBanner"] = 4] = "AdhesiveBottomBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["AdhesiveSideBanner"] = 5] = "AdhesiveSideBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardVideo"] = 6] = "StandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["ScrollReactiveVideo"] = 7] = "ScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGStandardBanner"] = 8] = "IGStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGStandardVideo"] = 9] = "IGStandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGScrollReactiveBanner"] = 10] = "IGScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGScrollReactiveVideo"] = 11] = "IGScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBStandardBanner"] = 12] = "FBStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBStandardVideo"] = 13] = "FBStandardVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBScrollReactiveBanner"] = 14] = "FBScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBScrollReactiveVideo"] = 15] = "FBScrollReactiveVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["TiktokVideo"] = 16] = "TiktokVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["InstagramReelsVideo"] = 17] = "InstagramReelsVideo";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGCarousel"] = 18] = "IGCarousel";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["MiddleBanner"] = 19] = "MiddleBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBCarousel"] = 20] = "FBCarousel";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["DynamicScrollReactiveBanner"] = 21] = "DynamicScrollReactiveBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Venti"] = 22] = "Venti";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Breakaway"] = 23] = "Breakaway";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Runway"] = 24] = "Runway";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["DynamicStandardBanner"] = 25] = "DynamicStandardBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["DynamicLogoEnhancedBanner"] = 26] = "DynamicLogoEnhancedBanner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["StandardCarousel"] = 27] = "StandardCarousel";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["CollapsibleCard"] = 28] = "CollapsibleCard";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["CollapsibleBacksplash"] = 29] = "CollapsibleBacksplash";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Cornerstone"] = 30] = "Cornerstone";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["Backsplash"] = 31] = "Backsplash";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["FBEcho"] = 32] = "FBEcho";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["IGEcho"] = 33] = "IGEcho";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["_300x250Banner"] = 34] = "_300x250Banner";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["HPToast"] = 35] = "HPToast";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["CtvBrandedCanvas"] = 36] = "CtvBrandedCanvas";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["HomeDepotCollapsibleCard"] = 37] = "HomeDepotCollapsibleCard";
    CREATIVE_FORMAT_ENUM[CREATIVE_FORMAT_ENUM["HomeDepotStandardCarousel"] = 38] = "HomeDepotStandardCarousel";
/* Uncomment for A/B testing */ // StandardBannerIframe = 101,
// StandardVideoIframe = 102,
})($cd21b33b055a3f7a$var$CREATIVE_FORMAT_ENUM || (module.exports.CREATIVE_FORMAT_ENUM = $cd21b33b055a3f7a$var$CREATIVE_FORMAT_ENUM = {}));
var $cd21b33b055a3f7a$var$CREATIVE_FORMAT_IFRAME_ENUM;
(function(CREATIVE_FORMAT_IFRAME_ENUM) {
    CREATIVE_FORMAT_IFRAME_ENUM[CREATIVE_FORMAT_IFRAME_ENUM["StandardBannerIframe"] = 101] = "StandardBannerIframe";
    CREATIVE_FORMAT_IFRAME_ENUM[CREATIVE_FORMAT_IFRAME_ENUM["StandardVideoIframe"] = 102] = "StandardVideoIframe";
})($cd21b33b055a3f7a$var$CREATIVE_FORMAT_IFRAME_ENUM || (module.exports.CREATIVE_FORMAT_IFRAME_ENUM = $cd21b33b055a3f7a$var$CREATIVE_FORMAT_IFRAME_ENUM = {}));
var $cd21b33b055a3f7a$var$CREATIVE_DESTINATION_ENUM;
(function(CREATIVE_DESTINATION_ENUM) {
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["EntireCreative"] = 1] = "EntireCreative";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["MainAsset"] = 2] = "MainAsset";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["Description"] = 3] = "Description";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["Cta"] = 4] = "Cta";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["SocialLogo"] = 5] = "SocialLogo";
    CREATIVE_DESTINATION_ENUM[CREATIVE_DESTINATION_ENUM["WatchOnSocial"] = 6] = "WatchOnSocial";
})($cd21b33b055a3f7a$var$CREATIVE_DESTINATION_ENUM || (module.exports.CREATIVE_DESTINATION_ENUM = $cd21b33b055a3f7a$var$CREATIVE_DESTINATION_ENUM = {}));
var $cd21b33b055a3f7a$var$CREATIVE_SOCIAL_TYPE_ENUM;
(function(CREATIVE_SOCIAL_TYPE_ENUM) {
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Standard"] = 1] = "Standard";
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Social"] = 2] = "Social";
    CREATIVE_SOCIAL_TYPE_ENUM[CREATIVE_SOCIAL_TYPE_ENUM["Dynamic"] = 3] = "Dynamic";
})($cd21b33b055a3f7a$var$CREATIVE_SOCIAL_TYPE_ENUM || (module.exports.CREATIVE_SOCIAL_TYPE_ENUM = $cd21b33b055a3f7a$var$CREATIVE_SOCIAL_TYPE_ENUM = {}));
var $cd21b33b055a3f7a$var$FONT_FAMILY_ENUM;
(function(FONT_FAMILY_ENUM) {
    FONT_FAMILY_ENUM["poppins"] = "Poppins";
})($cd21b33b055a3f7a$var$FONT_FAMILY_ENUM || (module.exports.FONT_FAMILY_ENUM = $cd21b33b055a3f7a$var$FONT_FAMILY_ENUM = {}));
// 'external' is a generalized enum, needs to be changed
// when new external company is added to composer
var $cd21b33b055a3f7a$var$PROJECT_ENUM;
(function(PROJECT_ENUM) {
    PROJECT_ENUM["composer"] = "composer";
    PROJECT_ENUM["external"] = "external";
})($cd21b33b055a3f7a$var$PROJECT_ENUM || (module.exports.PROJECT_ENUM = $cd21b33b055a3f7a$var$PROJECT_ENUM = {}));
var $cd21b33b055a3f7a$var$CSS_POS_ENUM;
(function(CSS_POS_ENUM) {
    CSS_POS_ENUM["fixed"] = "fixed";
    CSS_POS_ENUM["absolute"] = "absolute";
    CSS_POS_ENUM["relative"] = "relative";
    CSS_POS_ENUM["static"] = "static";
    CSS_POS_ENUM["sticky"] = "sticky";
})($cd21b33b055a3f7a$var$CSS_POS_ENUM || (module.exports.CSS_POS_ENUM = $cd21b33b055a3f7a$var$CSS_POS_ENUM = {}));
var $cd21b33b055a3f7a$var$TARGET_ENUM;
(function(TARGET_ENUM) {
    TARGET_ENUM["blank"] = "_blank";
    TARGET_ENUM["self"] = "_self";
    TARGET_ENUM["parent"] = "_parent";
    TARGET_ENUM["top"] = "_top";
})($cd21b33b055a3f7a$var$TARGET_ENUM || (module.exports.TARGET_ENUM = $cd21b33b055a3f7a$var$TARGET_ENUM = {}));
var $cd21b33b055a3f7a$var$DATA_UNIT_ENUM;
(function(DATA_UNIT_ENUM) {
    DATA_UNIT_ENUM["B"] = "B";
    DATA_UNIT_ENUM["KB"] = "KB";
    DATA_UNIT_ENUM["MB"] = "MB";
    DATA_UNIT_ENUM["GB"] = "GB";
    DATA_UNIT_ENUM["TB"] = "TB";
    DATA_UNIT_ENUM["PB"] = "PB";
})($cd21b33b055a3f7a$var$DATA_UNIT_ENUM || (module.exports.DATA_UNIT_ENUM = $cd21b33b055a3f7a$var$DATA_UNIT_ENUM = {}));
var $cd21b33b055a3f7a$var$BACKGROUND_ENUM;
(function(BACKGROUND_ENUM) {
    BACKGROUND_ENUM["white"] = "white";
    BACKGROUND_ENUM["black"] = "black";
    BACKGROUND_ENUM["blue"] = "blue";
})($cd21b33b055a3f7a$var$BACKGROUND_ENUM || (module.exports.BACKGROUND_ENUM = $cd21b33b055a3f7a$var$BACKGROUND_ENUM = {}));
var $cd21b33b055a3f7a$var$ADVANCED_CREATIVE_SIZES_ENUM;
(function(ADVANCED_CREATIVE_SIZES_ENUM) {
    // Middle Banner
    ADVANCED_CREATIVE_SIZES_ENUM["_320x250"] = "320x250";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x250"] = "390x250";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x250"] = "428x250";
    // Venti
    ADVANCED_CREATIVE_SIZES_ENUM["_320x460"] = "320x460";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x460"] = "390x460";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x460"] = "428x460";
    // Breakaway Initial and Runway
    ADVANCED_CREATIVE_SIZES_ENUM["_320x150"] = "320x150";
    ADVANCED_CREATIVE_SIZES_ENUM["_390x150"] = "390x150";
    ADVANCED_CREATIVE_SIZES_ENUM["_428x150"] = "428x150";
    // Breakaway Collapsed
    ADVANCED_CREATIVE_SIZES_ENUM["_130x150"] = "130x150";
})($cd21b33b055a3f7a$var$ADVANCED_CREATIVE_SIZES_ENUM || (module.exports.ADVANCED_CREATIVE_SIZES_ENUM = $cd21b33b055a3f7a$var$ADVANCED_CREATIVE_SIZES_ENUM = {}));
var $cd21b33b055a3f7a$var$FILE_TYPE_ENUM;
(function(FILE_TYPE_ENUM) {
    FILE_TYPE_ENUM["image"] = "image";
    FILE_TYPE_ENUM["video"] = "video";
    FILE_TYPE_ENUM["logo"] = "logo";
})($cd21b33b055a3f7a$var$FILE_TYPE_ENUM || (module.exports.FILE_TYPE_ENUM = $cd21b33b055a3f7a$var$FILE_TYPE_ENUM = {}));
var $cd21b33b055a3f7a$var$DEVICE_TYPE_ENUM;
(function(DEVICE_TYPE_ENUM) {
    DEVICE_TYPE_ENUM["desktop"] = "desktop";
    DEVICE_TYPE_ENUM["mobile"] = "mobile";
    DEVICE_TYPE_ENUM["ctv"] = "ctv";
})($cd21b33b055a3f7a$var$DEVICE_TYPE_ENUM || (module.exports.DEVICE_TYPE_ENUM = $cd21b33b055a3f7a$var$DEVICE_TYPE_ENUM = {}));
var $cd21b33b055a3f7a$var$INPUT_VARIANT_ENUM;
(function(INPUT_VARIANT_ENUM) {
    INPUT_VARIANT_ENUM["outlined"] = "outlined";
    INPUT_VARIANT_ENUM["filled"] = "filled";
})($cd21b33b055a3f7a$var$INPUT_VARIANT_ENUM || (module.exports.INPUT_VARIANT_ENUM = $cd21b33b055a3f7a$var$INPUT_VARIANT_ENUM = {}));
module.exports.VARIANT_WITH_DEFAULT = Object.assign(Object.assign({}, $cd21b33b055a3f7a$var$INPUT_VARIANT_ENUM), {
    standard: "standard"
});
module.exports.VARIANT_WITH_CONTAINED = Object.assign(Object.assign({}, $cd21b33b055a3f7a$var$INPUT_VARIANT_ENUM), {
    contained: "contained"
});
var $cd21b33b055a3f7a$var$SIZE_VARIANT_ENUM;
(function(SIZE_VARIANT_ENUM) {
    SIZE_VARIANT_ENUM["medium"] = "medium";
    SIZE_VARIANT_ENUM["small"] = "small";
})($cd21b33b055a3f7a$var$SIZE_VARIANT_ENUM || (module.exports.SIZE_VARIANT_ENUM = $cd21b33b055a3f7a$var$SIZE_VARIANT_ENUM = {}));
var $cd21b33b055a3f7a$var$COLOR_ENUM;
(function(COLOR_ENUM) {
    COLOR_ENUM["primary"] = "primary";
    COLOR_ENUM["secondary"] = "secondary";
    COLOR_ENUM["error"] = "error";
    COLOR_ENUM["warning"] = "warning";
    COLOR_ENUM["info"] = "info";
    COLOR_ENUM["success"] = "success";
})($cd21b33b055a3f7a$var$COLOR_ENUM || (module.exports.COLOR_ENUM = $cd21b33b055a3f7a$var$COLOR_ENUM = {}));
module.exports.COLOR_WITH_DEFAULT = Object.assign(Object.assign({}, $cd21b33b055a3f7a$var$COLOR_ENUM), {
    default: "default"
});
module.exports.COLOR_WITH_INHERIT = Object.assign(Object.assign({}, $cd21b33b055a3f7a$var$COLOR_ENUM), {
    inherit: "inherit"
});
module.exports.COLOR_WITH_STANDARD = Object.assign(Object.assign({}, $cd21b33b055a3f7a$var$COLOR_ENUM), {
    standard: "standard"
});
var $cd21b33b055a3f7a$var$THEME;
(function(THEME) {
    THEME["default"] = "default";
    THEME["whiteLabel"] = "white_label";
})($cd21b33b055a3f7a$var$THEME || (module.exports.THEME = $cd21b33b055a3f7a$var$THEME = {}));
var $cd21b33b055a3f7a$var$MODE;
(function(MODE) {
    MODE["light"] = "light";
    MODE["dark"] = "dark";
})($cd21b33b055a3f7a$var$MODE || (module.exports.MODE = $cd21b33b055a3f7a$var$MODE = {}));

});


parcelRegister("eP5IC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9q4Vo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7SEbW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CREATIVE_FORMAT_BY_CREATIVE_EDITOR = module.exports.CREATIVE_CONFIG_BY_FORMAT = void 0;

var $hBUtx = parcelRequire("hBUtx");
const $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS = {
    resolution: "",
    destinationUrls: [
        $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
    ],
    creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
    compatibleDevices: [
        $hBUtx.DEVICE_TYPE_ENUM.mobile,
        $hBUtx.DEVICE_TYPE_ENUM.desktop
    ]
};
// Deprecating CREATIVE_FORMATS v2.0.33,
module.exports.CREATIVE_CONFIG_BY_FORMAT = Object.freeze({
    [$hBUtx.CREATIVE_FORMAT_ENUM.StandardBanner]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.StandardBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-banner",
        title: "Standard Banner",
        templateId: "aba-display-1"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.StandardVideo]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.StandardVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-video",
        title: "Standard Video",
        templateId: "aba-video-1"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.StandardCarousel]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.StandardCarousel,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "standard-carousel",
        title: "Standard Carousel",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative,
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset
        ],
        templateId: "standard-carousel",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "logo-enhanced-banner",
        title: "Logo Enhanced Banner",
        templateId: "aba-display-3"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "scroll-reactive-banner",
        title: "Scroll Reactive Banner",
        templateId: "aba-display-2"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "scroll-reactive-video",
        title: "Scroll Reactive Video",
        templateId: "aba-video-2"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "adhesive-bottom-banner",
        title: "Adhesive Bottom Banner",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-adhesion-display-1",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "adhesive-side-banner",
        title: "Adhesive Side Banner",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "aba-adhesion-display-2",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.Backsplash]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.Backsplash,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "backsplash",
        title: "Backsplash",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "backsplash",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM._300x250Banner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM._300x250Banner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "300x250-banner",
        title: "300x250 banner",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "300x250-banner",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.Cornerstone]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.Cornerstone,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "cornerstone",
        title: "Cornerstone",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "cornerstone",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.CollapsibleCard]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.CollapsibleCard,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "collapsible-card",
        title: "Collapsible Card",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "collapsible-card",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.CollapsibleBacksplash]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.CollapsibleBacksplash,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "collapsible-backsplash",
        title: "Collapsible Backsplash",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "collapsible-backsplash",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.IGStandardBanner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.IGStandardBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-standard-banner",
        title: "Instagram Standard Banner",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-2",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.IGStandardVideo]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.IGStandardVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-standard-video",
        title: "Instagram Standard Video",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-2",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-scroll-reactive-banner",
        title: "Instagram Scroll Reactive Banner",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-1",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.IGCarousel]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.IGCarousel,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-carousel",
        title: "Instagram Carousel",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-carousel-1",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.FBCarousel]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.FBCarousel,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-carousel",
        title: "Facebook Carousel",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "bleeding-carousel",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-scroll-reactive-video",
        title: "Instagram Scroll Reactive Video",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-1",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.FBStandardBanner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.FBStandardBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-standard-banner",
        title: "Facebook Standard Banner",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-3",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.FBStandardVideo]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.FBStandardVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-standard-video",
        title: "Facebook Standard Video",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-3",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-scroll-reactive-banner",
        title: "Facebook Scroll Reactive Banner",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-banner-4",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-scroll-reactive-video",
        title: "Facebook Scroll Reactive Video",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo
        ],
        templateId: "social-video-4",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.FBEcho]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.FBEcho,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "facebook-echo",
        title: "Facebook Echo",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "facebook-echo",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.IGEcho]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.IGEcho,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "instagram-echo",
        title: "Instagram Echo",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "instagram-echo",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.TiktokVideo]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.TiktokVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "tiktok-video",
        title: "Tiktok Video",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo,
            $hBUtx.CREATIVE_DESTINATION_ENUM.WatchOnSocial
        ],
        templateId: "social-video-5",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.InstagramReelsVideo]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.InstagramReelsVideo,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Social,
        id: "reels-video",
        title: "Reels Video",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Description,
            $hBUtx.CREATIVE_DESTINATION_ENUM.Cta,
            $hBUtx.CREATIVE_DESTINATION_ENUM.SocialLogo,
            $hBUtx.CREATIVE_DESTINATION_ENUM.WatchOnSocial
        ],
        templateId: "social-video-5",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.HPToast]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.HPToast,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "hp-toast",
        title: "HP Toast",
        templateId: "hp-toast",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.MiddleBanner]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.MiddleBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "middle-banner",
        title: "Middle Banner",
        resolution: "",
        destinationUrls: [],
        templateId: "middle-banner-animated",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._320x250,
                width: 320,
                height: 250
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._390x250,
                width: 390,
                height: 250
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._428x250,
                width: 428,
                height: 250
            }
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Dynamic,
        id: "dynamic-scroll-reactive-banner",
        title: "Scroll Reactive Banner",
        templateId: "dynamic-scroll-reactive-banner"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.Breakaway]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.Breakaway,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "breakaway",
        title: "Breakaway",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "breakaway",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._320x150,
                width: 320,
                height: 150
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._390x150,
                width: 390,
                height: 150
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._428x150,
                width: 428,
                height: 150
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._130x150,
                width: 130,
                height: 150,
                isCollapsed: true
            }
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.Runway]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.Runway,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "runway",
        title: "Runway",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "runway",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._320x150,
                width: 320,
                height: 150
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._390x150,
                width: 390,
                height: 150
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._428x150,
                width: 428,
                height: 150
            }
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.Venti]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.Venti,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "venti",
        title: "Venti",
        resolution: "",
        destinationUrls: [],
        templateId: "venti-animated",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.advanced,
        creativeDimensions: [
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._320x460,
                width: 320,
                height: 460
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._390x460,
                width: 390,
                height: 460
            },
            {
                label: $hBUtx.ADVANCED_CREATIVE_SIZES_ENUM._428x460,
                width: 428,
                height: 460
            }
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.DynamicStandardBanner]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.DynamicStandardBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Dynamic,
        id: "dynamic-standard-banner",
        title: "Standard Banner",
        templateId: "dynamic-standard-banner"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.DynamicLogoEnhancedBanner]: Object.assign(Object.assign({}, $5bccc0c2e5d42ef7$var$CREATIVE_FORMATS_COMMON_CONFIGS), {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.DynamicLogoEnhancedBanner,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Dynamic,
        id: "dynamic-logo-enhanced-banner",
        title: "Logo Enhanced Banner",
        templateId: "dynamic-logo-enhanced-banner"
    }),
    [$hBUtx.CREATIVE_FORMAT_ENUM.CtvBrandedCanvas]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.CtvBrandedCanvas,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "ctv-branded-canvas",
        title: "Branded Canvas",
        templateId: "ctv-branded-canvas",
        resolution: "",
        destinationUrls: [],
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.ctv,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.ctv
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.HomeDepotCollapsibleCard]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.HomeDepotCollapsibleCard,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "home-depot-collapsible-card",
        title: "Home Depot Collapsible Card",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative
        ],
        templateId: "home-depot-collapsible-card",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile
        ]
    },
    [$hBUtx.CREATIVE_FORMAT_ENUM.HomeDepotStandardCarousel]: {
        type: $hBUtx.CREATIVE_FORMAT_ENUM.HomeDepotStandardCarousel,
        socialType: $hBUtx.CREATIVE_SOCIAL_TYPE_ENUM.Standard,
        id: "home-depot-standard-carousel",
        title: "Home Depot Standard Carousel",
        resolution: "",
        destinationUrls: [
            $hBUtx.CREATIVE_DESTINATION_ENUM.EntireCreative,
            $hBUtx.CREATIVE_DESTINATION_ENUM.MainAsset
        ],
        templateId: "home-depot-standard-carousel",
        creativeEditor: $hBUtx.CREATIVE_EDITOR_ENUM.lite,
        compatibleDevices: [
            $hBUtx.DEVICE_TYPE_ENUM.mobile,
            $hBUtx.DEVICE_TYPE_ENUM.desktop
        ]
    }
});
module.exports.CREATIVE_FORMAT_BY_CREATIVE_EDITOR = {
    [$hBUtx.CREATIVE_EDITOR_ENUM.lite]: [
        $hBUtx.CREATIVE_FORMAT_ENUM.StandardBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.StandardVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.StandardCarousel,
        $hBUtx.CREATIVE_FORMAT_ENUM.LogoEnhancedBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.ScrollReactiveBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.AdhesiveBottomBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.AdhesiveSideBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.Cornerstone,
        $hBUtx.CREATIVE_FORMAT_ENUM.CollapsibleCard,
        $hBUtx.CREATIVE_FORMAT_ENUM.ScrollReactiveVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.IGStandardBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.IGStandardVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.IGScrollReactiveBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.IGScrollReactiveVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.FBStandardBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.FBStandardVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.FBScrollReactiveBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.FBScrollReactiveVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.TiktokVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.InstagramReelsVideo,
        $hBUtx.CREATIVE_FORMAT_ENUM.IGCarousel,
        $hBUtx.CREATIVE_FORMAT_ENUM.FBCarousel,
        $hBUtx.CREATIVE_FORMAT_ENUM.DynamicScrollReactiveBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.FBEcho,
        $hBUtx.CREATIVE_FORMAT_ENUM.IGEcho,
        $hBUtx.CREATIVE_FORMAT_ENUM._300x250Banner,
        $hBUtx.CREATIVE_FORMAT_ENUM.HPToast,
        $hBUtx.CREATIVE_FORMAT_ENUM.HomeDepotCollapsibleCard,
        $hBUtx.CREATIVE_FORMAT_ENUM.HomeDepotStandardCarousel
    ],
    [$hBUtx.CREATIVE_EDITOR_ENUM.ctv]: [
        $hBUtx.CREATIVE_FORMAT_ENUM.CtvBrandedCanvas
    ],
    [$hBUtx.CREATIVE_EDITOR_ENUM.advanced]: [
        $hBUtx.CREATIVE_FORMAT_ENUM.MiddleBanner,
        $hBUtx.CREATIVE_FORMAT_ENUM.Venti,
        $hBUtx.CREATIVE_FORMAT_ENUM.Breakaway,
        $hBUtx.CREATIVE_FORMAT_ENUM.Runway
    ]
};

});

parcelRegister("dkgsx", function(module, exports) {
"use strict";
var $9b39e91d3d389077$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b39e91d3d389077$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compressImages = void 0;

const $9b39e91d3d389077$var$browser_image_compression_1 = $9b39e91d3d389077$var$__importDefault((parcelRequire("kcyGx")));

var $hBUtx = parcelRequire("hBUtx");
const $9b39e91d3d389077$var$compressImages = (files)=>$9b39e91d3d389077$var$__awaiter(void 0, void 0, void 0, function*() {
        if (files.every((file)=>file.type.includes($hBUtx.FILE_TYPE_ENUM.video))) return files;
        const compressionPromises = [];
        const compressionOptions = {
            maxSizeMB: 0.2929,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        };
        try {
            const validBlobs = files.filter((file)=>file.type.includes($hBUtx.FILE_TYPE_ENUM.image) && file instanceof Blob);
            if (validBlobs.length < 1) throw new Error("File(s) format unsupported!");
            validBlobs.forEach((blob)=>compressionPromises.push((0, $9b39e91d3d389077$var$browser_image_compression_1.default)(blob, compressionOptions)));
            const compressedBlobs = yield Promise.all(compressionPromises);
            return compressedBlobs;
        } catch (err) {
            console.log(err);
            return files;
        }
    });
module.exports.compressImages = $9b39e91d3d389077$var$compressImages;

});

parcelRegister("ho2km", function(module, exports) {
"use strict";
var $ca867bbe142bfcac$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOutsideClick = void 0;

const $ca867bbe142bfcac$var$react_1 = $ca867bbe142bfcac$var$__importDefault((parcelRequire("acw62")));
const $ca867bbe142bfcac$var$useOutsideClick = (ref, callback)=>{
    $ca867bbe142bfcac$var$react_1.default.useEffect(()=>{
        /**
         * Alert if clicked on outside of element
         */ const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) callback();
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
};
module.exports.useOutsideClick = $ca867bbe142bfcac$var$useOutsideClick;

});

parcelRegister("8Q6eN", function(module, exports) {
"use strict";
var $66f804b8d9306d8a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $66f804b8d9306d8a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $66f804b8d9306d8a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $66f804b8d9306d8a$var$__createBinding(result, mod, k);
    }
    $66f804b8d9306d8a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInterval = void 0;

const $66f804b8d9306d8a$var$react_1 = $66f804b8d9306d8a$var$__importStar((parcelRequire("acw62")));
const $66f804b8d9306d8a$var$useInterval = (callback, delay)=>{
    const intervalId = $66f804b8d9306d8a$var$react_1.default.useRef(null);
    const savedCallback = $66f804b8d9306d8a$var$react_1.default.useRef(callback);
    (0, $66f804b8d9306d8a$var$react_1.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, $66f804b8d9306d8a$var$react_1.useEffect)(()=>{
        const tick = ()=>savedCallback.current();
        intervalId.current = window.setInterval(tick, delay);
        return ()=>window.clearInterval(intervalId.current);
    }, [
        delay
    ]);
    return intervalId.current;
};
module.exports.useInterval = $66f804b8d9306d8a$var$useInterval;

});

parcelRegister("8cJF7", function(module, exports) {
"use strict";
var $5f92dd446df2e926$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePlayVideo = void 0;

const $5f92dd446df2e926$var$react_1 = $5f92dd446df2e926$var$__importDefault((parcelRequire("acw62")));
const $5f92dd446df2e926$var$usePlayVideo = (onVideoEnd, video, videoRef, interval)=>{
    $5f92dd446df2e926$var$react_1.default.useEffect(()=>{
        var _a;
        if (!!video && videoRef.current) {
            onVideoEnd();
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            (_a = videoRef.current) === null || _a === void 0 || _a.play().catch(()=>videoRef.current ? videoRef.current.pause() : null);
        }
        return ()=>{
            if (interval) // eslint-disable-next-line react-hooks/exhaustive-deps
            clearInterval(interval.current);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        video
    ]);
};
module.exports.usePlayVideo = $5f92dd446df2e926$var$usePlayVideo;

});

parcelRegister("5syHx", function(module, exports) {
"use strict";
var $3f9a7c3661c0a366$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDeletePressed = void 0;

const $3f9a7c3661c0a366$var$react_1 = $3f9a7c3661c0a366$var$__importDefault((parcelRequire("acw62")));
const $3f9a7c3661c0a366$var$useDeletePressed = (ref, callback)=>{
    $3f9a7c3661c0a366$var$react_1.default.useEffect(()=>{
        /**
         * Alert if delete pressed
         */ const handleDeletePressed = (event)=>{
            const isDeleteKey = event.key === "Delete" || event.key === "Backspace";
            if (isDeleteKey && ref.current && (ref.current === event.target || ref.current.contains(event.target))) callback();
        };
        // Bind the event listener
        document.addEventListener("keydown", handleDeletePressed);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener("keydown", handleDeletePressed);
        };
    });
};
module.exports.useDeletePressed = $3f9a7c3661c0a366$var$useDeletePressed;

});

parcelRegister("7Byxj", function(module, exports) {
"use strict";
var $5896c74b6780912e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgProvider = void 0;

const $5896c74b6780912e$var$krg_provider_react_1 = $5896c74b6780912e$var$__importDefault((parcelRequire("buVPR")));
module.exports.KrgProvider = $5896c74b6780912e$var$krg_provider_react_1.default;

});
parcelRegister("buVPR", function(module, exports) {
"use strict";
var $85ef5bfb33a25b55$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $85ef5bfb33a25b55$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $85ef5bfb33a25b55$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $85ef5bfb33a25b55$var$__createBinding(result, mod, k);
    }
    $85ef5bfb33a25b55$var$__setModuleDefault(result, mod);
    return result;
};
var $85ef5bfb33a25b55$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $85ef5bfb33a25b55$var$react_1 = $85ef5bfb33a25b55$var$__importStar((parcelRequire("acw62")));

var $2BuCw = parcelRequire("2BuCw");
var $gRp5N = parcelRequire("gRp5N");
var $gODrq = parcelRequire("gODrq");

const $85ef5bfb33a25b55$var$krg_provider_style_1 = $85ef5bfb33a25b55$var$__importDefault((parcelRequire("5TXTl")));

var $fVgN8 = parcelRequire("fVgN8");

var $hBUtx = parcelRequire("hBUtx");

const $85ef5bfb33a25b55$var$KrgProvider = ({ children: children, mode: mode = $hBUtx.MODE.light, theme: theme = $hBUtx.THEME.default })=>{
    const defaultFontFamily = localStorage.getItem($fVgN8.STORE_KEY_FONT_FAMILY) || $hBUtx.FONT_FAMILY_ENUM.poppins;
    const [fontFamily, setFontFamily] = (0, $85ef5bfb33a25b55$var$react_1.useState)(defaultFontFamily);
    const storageCallback = ()=>{
        setFontFamily(localStorage.getItem($fVgN8.STORE_KEY_FONT_FAMILY) || $hBUtx.FONT_FAMILY_ENUM.poppins);
        // Temporal usage to avoid lint issues
        console.log(fontFamily);
    };
    (0, $85ef5bfb33a25b55$var$react_1.useEffect)(()=>{
        if (defaultFontFamily) window.addEventListener("storage", storageCallback);
        return ()=>{
            if (defaultFontFamily) window.removeEventListener("storage", storageCallback);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return $85ef5bfb33a25b55$var$react_1.default.createElement($2BuCw.default, {
        injectFirst: true
    }, $85ef5bfb33a25b55$var$react_1.default.createElement($gRp5N.default, {
        theme: (0, $85ef5bfb33a25b55$var$krg_provider_style_1.default)(mode, theme)
    }, $85ef5bfb33a25b55$var$react_1.default.createElement($gODrq.default, null), children));
};
module.exports.default = $85ef5bfb33a25b55$var$KrgProvider;

});
parcelRegister("gODrq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3dfe91526ac04a1$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $1iOpW = parcelRequire("1iOpW");

var $ldx2z = parcelRequire("ldx2z");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c3dfe91526ac04a1$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $8nd05.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $c3dfe91526ac04a1$export$32180ef41b15b513 = (theme)=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $c3dfe91526ac04a1$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $8nd05.default)({
        html: $c3dfe91526ac04a1$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $8nd05.default)({
            margin: 0
        }, $c3dfe91526ac04a1$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $c3dfe91526ac04a1$var$CssBaseline(inProps) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldx2z.default), {
                styles: (theme)=>$c3dfe91526ac04a1$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
$c3dfe91526ac04a1$var$CssBaseline.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * You can wrap a node.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */ enableColorScheme: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $c3dfe91526ac04a1$export$2e2bcd8739ae039 = $c3dfe91526ac04a1$var$CssBaseline;

});

parcelRegister("5TXTl", function(module, exports) {
"use strict";
var $44c08c0b970de3e1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $44c08c0b970de3e1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $44c08c0b970de3e1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $44c08c0b970de3e1$var$__createBinding(result, mod, k);
    }
    $44c08c0b970de3e1$var$__setModuleDefault(result, mod);
    return result;
};
var $44c08c0b970de3e1$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $44c08c0b970de3e1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $44c08c0b970de3e1$var$omit_1 = $44c08c0b970de3e1$var$__importDefault((parcelRequire("5c7W3")));

var $ijOKP = parcelRequire("ijOKP");

const $44c08c0b970de3e1$var$defaultToken = $44c08c0b970de3e1$var$__importStar((parcelRequire("88QVG")));

const $44c08c0b970de3e1$var$whiteLabelToken = $44c08c0b970de3e1$var$__importStar((parcelRequire("3EpKA")));

var $hBUtx = parcelRequire("hBUtx");
const $44c08c0b970de3e1$var$defaultTheme = (selectedMode, theme)=>{
    const selectedToken = theme === $hBUtx.THEME.whiteLabel ? $44c08c0b970de3e1$var$whiteLabelToken : $44c08c0b970de3e1$var$defaultToken;
    const mode = selectedMode;
    const modifiedToken = (0, $44c08c0b970de3e1$var$omit_1.default)(selectedToken, "components");
    // Remove invalid "common" key to satisfy MUI ThemeOptions typing
    const _a = modifiedToken.colorSchemes[mode].palette, { common: common } = _a, restPalette = $44c08c0b970de3e1$var$__rest(_a, [
        "common"
    ]);
    const mergedPalette = Object.assign(Object.assign({}, restPalette), {
        mode: mode
    });
    const finalThemeObject = Object.assign(Object.assign({}, modifiedToken), {
        palette: mergedPalette,
        spacing: 0
    });
    return (0, $ijOKP.default)(finalThemeObject);
};
module.exports.default = $44c08c0b970de3e1$var$defaultTheme;

});
parcelRegister("5c7W3", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $kqX4j = parcelRequire("kqX4j");

var $gSeoX = parcelRequire("gSeoX");

var $4RK0h = parcelRequire("4RK0h");

var $cYlGN = parcelRequire("cYlGN");

var $lJ3Ig = parcelRequire("lJ3Ig");

var $8KK0w = parcelRequire("8KK0w");

var $i0kKc = parcelRequire("i0kKc");
/** Used to compose bitmasks for cloning. */ var $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG = 1, $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG = 2, $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3c843a8ff84cd42d$var$omit = $8KK0w(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $i46jW(paths, function(path) {
        path = $4RK0h(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $cYlGN(object, $i0kKc(object), result);
    if (isDeep) result = $kqX4j(result, $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG | $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG | $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG, $lJ3Ig);
    var length = paths.length;
    while(length--)$gSeoX(result, paths[length]);
    return result;
});
module.exports = $3c843a8ff84cd42d$var$omit;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});

parcelRegister("gSeoX", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $hkfXi = parcelRequire("hkfXi");

var $f865s = parcelRequire("f865s");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c48cdc53eae67a7f$var$baseUnset(object, path) {
    path = $4RK0h(path, object);
    object = $f865s(object, path);
    return object == null || delete object[$6DSvu($hkfXi(path))];
}
module.exports = $c48cdc53eae67a7f$var$baseUnset;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});


parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});



parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + "";
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});



parcelRegister("hkfXi", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $c9d0ae50fd1d1372$var$last;

});

parcelRegister("f865s", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $1quiu = parcelRequire("1quiu");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $b03c5325a6e99e83$var$parent(object, path) {
    return path.length < 2 ? object : $lJEX1(object, $1quiu(path, 0, -1));
}
module.exports = $b03c5325a6e99e83$var$parent;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $9dr3u(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});


parcelRegister("1quiu", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $109fb88fe59de104$var$baseSlice;

});



parcelRegister("lJ3Ig", function(module, exports) {

var $xMy82 = parcelRequire("xMy82");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $fd10ae4394ad99ac$var$customOmitClone(value) {
    return $xMy82(value) ? undefined : value;
}
module.exports = $fd10ae4394ad99ac$var$customOmitClone;

});
parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});


parcelRegister("8KK0w", function(module, exports) {

var $20Rgr = parcelRequire("20Rgr");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $iGMVy($b86t6(func, undefined, $20Rgr), func + "");
}
module.exports = $65f64eb9f31faa0d$var$flatRest;

});
parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});



parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $9HRmE(string),
        "writable": true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});
parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});

parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});


parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});




parcelRegister("88QVG", function(module, exports) {
module.exports = JSON.parse('{"colorSchemes":{"light":{"palette":{"text":{"hover":"rgba(0, 0, 0, 0.04)","selected":"rgba(0, 0, 0, 0.08)","focus":"rgba(0, 0, 0, 0.12)","focusVisible":"rgba(0, 0, 0, 0.3)","primary":"rgba(0, 0, 0, 0.87)"},"primary":{"main":"#3C61F3","dark":"#2550FA","light":"#5B7CFF","hover":"rgba(47, 55, 255, 0.04)","selected":"rgba(47, 55, 255, 0.08)","focus":"rgba(47, 55, 255, 0.12)","focusVisible":"rgba(47, 55, 255, 0.3)","outlinedBorder":"rgba(47, 55, 255, 0.5)","contrast":"#FFFFFF"},"secondary":{"main":"#FF9800","dark":"#F57C00","light":"#FFB74D","hover":"rgba(255, 152, 0, 0.04)","selected":"rgba(255, 152, 0, 0.08)","focus":"rgba(255, 152, 0, 0.12)","focusVisible":"rgba(255, 152, 0, 0.3)","outlinedBorder":"rgba(255, 152, 0, 0.5)","contrast":"#FFFFFF"},"error":{"hover":"rgba(211, 47, 47, 0.04)","selected":"rgba(211, 47, 47, 0.08)","focusVisible":"rgba(211, 47, 47, 0.3)","outlinedBorder":"rgba(211, 47, 47, 0.5)","contrast":"#FFFFFF","main":"#D32F2F","dark":"#C62828"},"warning":{"main":"#FBC02D","dark":"#F9A825","light":"#FFA726","hover":"rgba(251, 192, 45, 0.04)","selected":"rgba(251, 192, 45, 0.08)","focusVisible":"rgba(251, 192, 45, 0.3)","outlinedBorder":"rgba(251, 192, 45, 0.5)","contrast":"#FFFFFF"},"info":{"main":"#4D26BD","dark":"#1F11AB","light":"#6633CC","hover":"rgba(77, 38, 189, 0.04)","selected":"rgba(77, 38, 189, 0.08)","focusVisible":"rgba(77, 38, 189, 0.3)","outlinedBorder":"rgba(77, 38, 189, 0.5)","contrast":"#FFFFFF"},"success":{"main":"#138500","dark":"#006300","light":"#5BBC18","hover":"rgba(46, 125, 50, 0.04)","selected":"rgba(46, 125, 50, 0.08)","focusVisible":"rgba(46, 125, 50, 0.3)","outlinedBorder":"rgba(46, 125, 50, 0.5)","contrast":"#FFFFFF"},"common":{"black":{"main":"#000000","hover":"rgba(0, 0, 0, 0.04)","selected":"rgba(0, 0, 0, 0.08)","focus":"rgba(0, 0, 0, 0.12)","focusVisible":"rgba(0, 0, 0, 0.3)","outlinedBorder":"rgba(0, 0, 0, 0.5)"},"white":{"main":"#FFFFFF","hover":"rgba(255, 255, 255, 0.04)","selected":"rgba(255, 255, 255, 0.08)","focus":"rgba(255, 255, 255, 0.12)","focusVisible":"rgba(255, 255, 255, 0.3)","outlinedBorder":"rgba(255, 255, 255, 0.5)"}},"components":{"switch":{"knobFillEnabled":"#FAFAFA","slideFill":"#000000","knowFillDisabled":"#F5F5F5"},"avatar":{"fill":"#BDBDBD"},"input":{"standard":{"enabledBorder":"rgba(0, 0, 0, 0.42)","hoverBorder":"#000000"},"filled":{"enabledFill":"rgba(0, 0, 0, 0.06)","hoverFill":"rgba(0, 0, 0, 0.09)"},"outlined":{"hoverBorder":"#000000","enabledBorder":"rgba(0, 0, 0, 0.23)"}},"rating":{"enabledBorder":"rgba(0, 0, 0, 0.23)","activeFill":"#FFB400"},"snackbar":{"fill":"#323232"},"appBar":{"defaultFill":"#F5F5F5"},"tooltip":{"fill":"rgba(97, 97, 97, 0.9)"},"chip":{"defaultHoverFill":"rgba(0, 0, 0, 0.12)","defaultCloseFill":"#000000","defaultEnabledBorder":"#BDBDBD","defaultFocusFill":"rgba(0, 0, 0, 0.2)"},"breadcrumbs":{"collapseFill":"#F5F5F5"},"alert":{"error":{"color":"#5F2120","background":"#FDEDED"},"info":{"color":"#014361","background":"#E5F6FD"},"success":{"background":"#EDF7ED","color":"#1E4620"},"warning":{"color":"#663C00","background":"#FFF4E5"}},"backdrop":{"fill":"rgba(0, 0, 0, 0.5)"},"stepper":{"connector":"#BDBDBD"}},"action":{"disabled":"rgba(0, 0, 0, 0.38)","disabledBackground":"rgba(0, 0, 0, 0.12)","hover":"rgba(0, 0, 0, 0.04)"}}},"dark":{"palette":{"text":{"hover":"rgba(255, 255, 255, 0.08)","selected":"rgba(255, 255, 255, 0.16)","focus":"rgba(255, 255, 255, 0.12)","focusVisible":"rgba(255, 255, 255, 0.3)","primary":"#FFFFFF"},"primary":{"main":"#A5B7FF","dark":"#5B7CFF","light":"#E5EBFF","hover":"rgba(144, 202, 249, 0.08)","selected":"rgba(144, 202, 249, 0.16)","focus":"rgba(144, 202, 249, 0.12)","focusVisible":"rgba(144, 202, 249, 0.3)","outlinedBorder":"rgba(144, 202, 249, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"secondary":{"main":"#FFCC80","dark":"#FFA726","light":"#FFF3E0","hover":"rgba(255, 204, 128, 0.08)","selected":"rgba(255, 204, 128, 0.16)","focus":"rgba(255, 204, 128, 0.12)","focusVisible":"rgba(255, 204, 128, 0.3)","outlinedBorder":"rgba(255, 204, 128, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"error":{"hover":"rgba(244, 67, 54, 0.08)","selected":"rgba(244, 67, 54, 0.16)","focusVisible":"rgba(244, 67, 54, 0.3)","outlinedBorder":"rgba(244, 67, 54, 0.5)","contrast":"#FFFFFF","main":"#F44336","dark":"#D32F2F"},"warning":{"main":"#FFEE58","dark":"#FBC02D","light":"#FFF176","hover":"rgba(255, 238, 88, 0.08)","selected":"rgba(255, 238, 88, 0.16)","focusVisible":"rgba(255, 238, 88, 0.3)","outlinedBorder":"rgba(255, 238, 88, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"info":{"main":"#7F53D4","dark":"#4D26BD","light":"#9772DC","hover":"rgba(127, 83, 212, 0.08)","selected":"rgba(127, 83, 212, 0.16)","focusVisible":"rgba(127, 83, 212, 0.3)","outlinedBorder":"rgba(127, 83, 212, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"success":{"main":"#76C645","dark":"#339900","light":"#90D068","hover":"rgba(102, 187, 106, 0.08)","selected":"rgba(102, 187, 106, 0.16)","focusVisible":"rgba(102, 187, 106, 0.3)","outlinedBorder":"rgba(102, 187, 106, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"common":{"black":{"main":"#000000","hover":"rgba(0, 0, 0, 0.08)","selected":"rgba(0, 0, 0, 0.16)","focus":"rgba(0, 0, 0, 0.12)","focusVisible":"rgba(0, 0, 0, 0.3)","outlinedBorder":"rgba(0, 0, 0, 0.5)"},"white":{"main":"#FFFFFF","hover":"rgba(255, 255, 255, 0.08)","selected":"rgba(255, 255, 255, 0.16)","focus":"rgba(255, 255, 255, 0.12)","focusVisible":"rgba(255, 255, 255, 0.3)","outlinedBorder":"rgba(255, 255, 255, 0.5)"}},"components":{"switch":{"knobFillEnabled":"#E0E0E0","slideFill":"rgba(255, 255, 255, 0.38)","knowFillDisabled":"#757575"},"avatar":{"fill":"#757575"},"input":{"standard":{"enabledBorder":"rgba(255, 255, 255, 0.42)","hoverBorder":"#FFFFFF"},"filled":{"enabledFill":"rgba(255, 255, 255, 0.09)","hoverFill":"rgba(255, 255, 255, 0.12)"},"outlined":{"hoverBorder":"#FFFFFF","enabledBorder":"rgba(255, 255, 255, 0.23)"}},"rating":{"enabledBorder":"rgba(255, 255, 255, 0.23)","activeFill":"#FFB400"},"snackbar":{"fill":"#FFFFFF"},"appBar":{"defaultFill":"#FFFFFF"},"tooltip":{"fill":"rgba(97, 97, 97, 0.9)"},"chip":{"defaultHoverFill":"rgba(255, 255, 255, 0.12)","defaultCloseFill":"#FFFFFF","defaultEnabledBorder":"#616161","defaultFocusFill":"rgba(255, 255, 255, 0.2)"},"breadcrumbs":{"collapseFill":"#757575"},"alert":{"error":{"color":"#F4C7C7","background":"#160B0B"},"info":{"color":"#B8E7FB","background":"#071318"},"success":{"background":"#0C130D","color":"#CCE8CD"},"warning":{"color":"#FFE2B7","background":"#191207"}},"backdrop":{"fill":"rgba(0, 0, 0, 0.5)"},"stepper":{"connector":"#757575"}},"action":{"disabled":"rgba(255, 255, 255, 0.38)","disabledBackground":"rgba(255, 255, 255, 0.12)","hover":"rgba(255, 255, 255, 0.08)"}}}},"typography":{"h1":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h2":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h3":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h4":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h5":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h6":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"body1":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"body2":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"subtitle1":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"subtitle2":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"overline":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"caption":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"}},"shape":{"borderRadius":10,"ButtonBorderRadius":100,"test radius":50},"spacing":[0],"components":{"MuiButton":{"styleOverrides":{"root":{"&.MuiButton-sizeLarge.MuiButton-containedPrimary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-primary-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedInherit":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedInherit (white)":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-common-white-main)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedSecondary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-secondary-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedError":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-error-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedWarning":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-warning-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedInfo":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-info-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedSuccess":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-success-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeMedium.MuiButton-containedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-primary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-common-white-main)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-secondary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-error-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-warning-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-info-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-success-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-primary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-common-white-main)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-secondary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-error-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-warning-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-info-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"0.3","background":"var(--mui-palette-success-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeLarge.MuiButton-outlinedPrimary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedInherit":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedInherit (white)":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedSecondary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedError":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedWarning":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedInfo":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedSuccess":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-outlinedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"var(--mui-palette-primary-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"var(--mui-palette-secondary-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"var(--mui-palette-error-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"var(--mui-palette-warning-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"var(--mui-palette-info-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"var(--mui-palette-success-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"var(--mui-palette-primary-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"var(--mui-palette-secondary-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"var(--mui-palette-error-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"var(--mui-palette-warning-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"var(--mui-palette-info-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"var(--mui-palette-success-hover)"}},"&.MuiButton-sizeMedium.MuiButton-textPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textPrimary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textInherit":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textInherit (white)":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textSecondary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textError":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textWarning":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textInfo":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textSuccess":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}}}}},"MuiSwitch":{"styleOverrides":{"root":{"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorSecondary)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"34px","height":"14px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-hover)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}}},"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorWarning)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"34px","height":"14px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-hover)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}}},"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorInfo)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"34px","height":"14px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-info-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-info-hover)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-info-focusVisible)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}}},"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorSuccess)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"34px","height":"14px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-main)","padding":"0","boxShadow":"none"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorSecondary)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"26px","height":"10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-hover)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-secondary-focusVisible)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorWarning)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"26px","height":"10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-hover)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-warning-focusVisible)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorInfo)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"26px","height":"10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-info-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-info-hover)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-info-focusVisible)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorSuccess)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"26px","height":"10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-success-main)","padding":"0","boxShadow":"none"}}},"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorPrimary)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"34px","height":"14px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-hover)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorPrimary)":{"& .MuiSwitch-switchBase":{"& + .MuiSwitch-track":{"width":"26px","height":"10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-main)","padding":"0","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-hover)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","background":"var(--mui-palette-primary-focusVisible)","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"}}}}}}}}');

});

parcelRegister("3EpKA", function(module, exports) {
module.exports = JSON.parse('{"colorSchemes":{"light":{"palette":{"text":{"hover":"rgba(0, 0, 0, 0.04)","selected":"rgba(0, 0, 0, 0.08)","focus":"rgba(0, 0, 0, 0.12)","focusVisible":"rgba(0, 0, 0, 0.3)","primary":"rgba(0, 0, 0, 0.87)"},"primary":{"main":"#262626","dark":"#000000","light":"#C4C4C4","hover":"rgba(0, 0, 0, 0.04)","selected":"rgba(0, 0, 0, 0.08)","focus":"rgba(0, 0, 0, 0.12)","focusVisible":"rgba(0, 0, 0, 0.3)","outlinedBorder":"rgba(0, 0, 0, 0.5)","contrast":"#FFFFFF"},"secondary":{"main":"#FF9800","dark":"#F57C00","light":"#FFB74D","hover":"rgba(255, 152, 0, 0.04)","selected":"rgba(255, 152, 0, 0.08)","focus":"rgba(255, 152, 0, 0.12)","focusVisible":"rgba(255, 152, 0, 0.3)","outlinedBorder":"rgba(255, 152, 0, 0.5)","contrast":"#FFFFFF"},"error":{"hover":"rgba(211, 47, 47, 0.04)","selected":"rgba(211, 47, 47, 0.08)","focusVisible":"rgba(211, 47, 47, 0.3)","outlinedBorder":"rgba(211, 47, 47, 0.5)","contrast":"#FFFFFF","main":"#D32F2F","dark":"#C62828"},"warning":{"main":"#FBC02D","dark":"#F9A825","light":"#FFA726","hover":"rgba(251, 192, 45, 0.04)","selected":"rgba(251, 192, 45, 0.08)","focusVisible":"rgba(251, 192, 45, 0.3)","outlinedBorder":"rgba(251, 192, 45, 0.5)","contrast":"#FFFFFF"},"info":{"main":"#4D26BD","dark":"#1F11AB","light":"#6633CC","hover":"rgba(77, 38, 189, 0.04)","selected":"rgba(77, 38, 189, 0.08)","focusVisible":"rgba(77, 38, 189, 0.3)","outlinedBorder":"rgba(77, 38, 189, 0.5)","contrast":"#FFFFFF"},"success":{"main":"#138500","dark":"#006300","light":"#5BBC18","hover":"rgba(46, 125, 50, 0.04)","selected":"rgba(46, 125, 50, 0.08)","focusVisible":"rgba(46, 125, 50, 0.3)","outlinedBorder":"rgba(46, 125, 50, 0.5)","contrast":"#FFFFFF"},"common":{"black":{"main":"#000000","hover":"rgba(0, 0, 0, 0.04)","selected":"rgba(0, 0, 0, 0.08)","focus":"rgba(0, 0, 0, 0.12)","focusVisible":"rgba(0, 0, 0, 0.3)","outlinedBorder":"rgba(0, 0, 0, 0.5)"},"white":{"main":"#FFFFFF","hover":"rgba(255, 255, 255, 0.04)","selected":"rgba(255, 255, 255, 0.08)","focus":"rgba(255, 255, 255, 0.12)","focusVisible":"rgba(255, 255, 255, 0.3)","outlinedBorder":"rgba(255, 255, 255, 0.5)"}},"components":{"avatar":{"fill":"#BDBDBD"},"input":{"standard":{"enabledBorder":"rgba(0, 0, 0, 0.42)","hoverBorder":"#000000"},"filled":{"enabledFill":"rgba(0, 0, 0, 0.06)","hoverFill":"rgba(0, 0, 0, 0.09)"},"outlined":{"enabledBorder":"rgba(0, 0, 0, 0.23)","hoverBorder":"#000000"}},"switch":{"knobFillEnabled":"#FAFAFA","slideFill":"#000000","knowFillDisabled":"#F5F5F5"},"rating":{"enabledBorder":"rgba(0, 0, 0, 0.23)","activeFill":"#FFB400"},"snackbar":{"fill":"#323232"},"chip":{"defaultEnabledBorder":"#BDBDBD","defaultHoverFill":"rgba(0, 0, 0, 0.12)","defaultCloseFill":"#000000","defaultFocusFill":"rgba(0, 0, 0, 0.2)"},"backdrop":{"fill":"rgba(0, 0, 0, 0.5)"},"appBar":{"defaultFill":"#F5F5F5"},"tooltip":{"fill":"rgba(97, 97, 97, 0.9)"},"breadcrumbs":{"collapseFill":"#F5F5F5"},"stepper":{"connector":"#BDBDBD"},"alert":{"error":{"color":"#5F2120","background":"#FDEDED"},"warning":{"color":"#663C00","background":"#FFF4E5"},"info":{"color":"#014361","background":"#E5F6FD"},"success":{"color":"#1E4620","background":"#EDF7ED"}}},"action":{"disabled":"rgba(0, 0, 0, 0.38)","disabledBackground":"rgba(0, 0, 0, 0.12)","hover":"rgba(0, 0, 0, 0.04)"}}},"dark":{"palette":{"text":{"hover":"rgba(255, 255, 255, 0.08)","selected":"rgba(255, 255, 255, 0.16)","focus":"rgba(255, 255, 255, 0.12)","focusVisible":"rgba(255, 255, 255, 0.3)","primary":"#FFFFFF"},"primary":{"main":"#D9D9D9","dark":"#9D9D9D","light":"#F5F5F5","hover":"rgba(144, 202, 249, 0.08)","selected":"rgba(144, 202, 249, 0.16)","focus":"rgba(144, 202, 249, 0.12)","focusVisible":"rgba(144, 202, 249, 0.3)","outlinedBorder":"rgba(144, 202, 249, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"secondary":{"main":"#FFCC80","dark":"#FFA726","light":"#FFF3E0","hover":"rgba(255, 204, 128, 0.08)","selected":"rgba(255, 204, 128, 0.16)","focus":"rgba(255, 204, 128, 0.12)","focusVisible":"rgba(255, 204, 128, 0.3)","outlinedBorder":"rgba(255, 204, 128, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"error":{"hover":"rgba(244, 67, 54, 0.08)","selected":"rgba(244, 67, 54, 0.16)","focusVisible":"rgba(244, 67, 54, 0.3)","outlinedBorder":"rgba(244, 67, 54, 0.5)","contrast":"#FFFFFF","main":"#F44336","dark":"#D32F2F"},"warning":{"main":"#FFEE58","dark":"#FBC02D","light":"#FFF176","hover":"rgba(255, 238, 88, 0.08)","selected":"rgba(255, 238, 88, 0.16)","focusVisible":"rgba(255, 238, 88, 0.3)","outlinedBorder":"rgba(255, 238, 88, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"info":{"main":"#7F53D4","dark":"#4D26BD","light":"#9772DC","hover":"rgba(127, 83, 212, 0.08)","selected":"rgba(127, 83, 212, 0.16)","focusVisible":"rgba(127, 83, 212, 0.3)","outlinedBorder":"rgba(127, 83, 212, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"success":{"main":"#76C645","dark":"#339900","light":"#90D068","hover":"rgba(102, 187, 106, 0.08)","selected":"rgba(102, 187, 106, 0.16)","focusVisible":"rgba(102, 187, 106, 0.3)","outlinedBorder":"rgba(102, 187, 106, 0.5)","contrast":"rgba(0, 0, 0, 0.87)"},"common":{"black":{"main":"#000000","hover":"rgba(0, 0, 0, 0.08)","selected":"rgba(0, 0, 0, 0.16)","focus":"rgba(0, 0, 0, 0.12)","focusVisible":"rgba(0, 0, 0, 0.3)","outlinedBorder":"rgba(0, 0, 0, 0.5)"},"white":{"main":"#FFFFFF","hover":"rgba(255, 255, 255, 0.08)","selected":"rgba(255, 255, 255, 0.16)","focus":"rgba(255, 255, 255, 0.12)","focusVisible":"rgba(255, 255, 255, 0.3)","outlinedBorder":"rgba(255, 255, 255, 0.5)"}},"components":{"avatar":{"fill":"#757575"},"input":{"standard":{"enabledBorder":"rgba(255, 255, 255, 0.42)","hoverBorder":"#FFFFFF"},"filled":{"enabledFill":"rgba(255, 255, 255, 0.09)","hoverFill":"rgba(255, 255, 255, 0.12)"},"outlined":{"enabledBorder":"rgba(255, 255, 255, 0.23)","hoverBorder":"#FFFFFF"}},"switch":{"knobFillEnabled":"#E0E0E0","slideFill":"rgba(255, 255, 255, 0.38)","knowFillDisabled":"#757575"},"rating":{"enabledBorder":"rgba(255, 255, 255, 0.23)","activeFill":"#FFB400"},"snackbar":{"fill":"#FFFFFF"},"chip":{"defaultEnabledBorder":"#616161","defaultHoverFill":"rgba(255, 255, 255, 0.12)","defaultCloseFill":"#FFFFFF","defaultFocusFill":"rgba(255, 255, 255, 0.2)"},"backdrop":{"fill":"rgba(0, 0, 0, 0.5)"},"appBar":{"defaultFill":"#FFFFFF"},"tooltip":{"fill":"rgba(97, 97, 97, 0.9)"},"breadcrumbs":{"collapseFill":"#757575"},"stepper":{"connector":"#757575"},"alert":{"error":{"color":"#F4C7C7","background":"#160B0B"},"warning":{"color":"#FFE2B7","background":"#191207"},"info":{"color":"#B8E7FB","background":"#071318"},"success":{"color":"#CCE8CD","background":"#0C130D"}}},"action":{"disabled":"rgba(255, 255, 255, 0.38)","disabledBackground":"rgba(255, 255, 255, 0.12)","hover":"rgba(255, 255, 255, 0.08)"}}}},"typography":{"h1":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h2":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h3":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h4":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h5":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"h6":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"body1":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"body2":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"subtitle1":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"subtitle2":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"overline":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"},"caption":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif"}},"shape":{"borderRadius":10,"ButtonBorderRadius":100,"test radius":50},"spacing":[0],"components":{"MuiButton":{"styleOverrides":{"root":{"&.MuiButton-sizeLarge.MuiButton-containedPrimary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-primary-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedInherit":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedInherit (white)":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-common-white-main)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedSecondary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-secondary-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedError":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-error-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedWarning":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-warning-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedInfo":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-info-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeLarge.MuiButton-containedSuccess":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-success-contrast)","padding":"0","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-dark)","boxShadow":"var(--mui-shadows-4)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"}},"&.MuiButton-sizeMedium.MuiButton-containedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-primary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-common-white-main)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-secondary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-error-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-warning-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-info-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeMedium.MuiButton-containedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-success-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-primary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-contrast)","background":"var(--mui-palette-primary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"#E0E0E0","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-common-white-main)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"#F5F5F5","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-secondary-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-contrast)","background":"var(--mui-palette-secondary-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-error-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-warning-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-warning-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-contrast)","background":"var(--mui-palette-error-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-info-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-contrast)","background":"var(--mui-palette-info-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeSmall.MuiButton-containedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-2)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-main)","boxShadow":"var(--mui-shadows-6)","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","opacity":"0.3","background":"var(--mui-palette-success-contrast)","padding":"0","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"var(--mui-palette-action-disabledBackground)","boxShadow":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-contrast)","background":"var(--mui-palette-success-dark)","boxShadow":"var(--mui-shadows-4)"}},"&.MuiButton-sizeLarge.MuiButton-outlinedPrimary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedInherit":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedInherit (white)":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedSecondary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedError":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedWarning":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedInfo":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-outlinedSuccess":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 22px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"64.055px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-outlinedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"var(--mui-palette-primary-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"var(--mui-palette-secondary-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"var(--mui-palette-error-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"var(--mui-palette-warning-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"var(--mui-palette-info-hover)"}},"&.MuiButton-sizeMedium.MuiButton-outlinedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 16px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"53.011px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"var(--mui-palette-success-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","border":"1px solid var(--mui-palette-primary-outlinedBorder)","background":"var(--mui-palette-primary-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","border":"1px solid var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","border":"1px solid var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","border":"1px solid var(--mui-palette-secondary-outlinedBorder)","background":"var(--mui-palette-secondary-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","border":"1px solid var(--mui-palette-error-outlinedBorder)","background":"var(--mui-palette-error-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","border":"1px solid var(--mui-palette-warning-outlinedBorder)","background":"var(--mui-palette-warning-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","border":"1px solid var(--mui-palette-info-outlinedBorder)","background":"var(--mui-palette-info-hover)"}},"&.MuiButton-sizeSmall.MuiButton-outlinedSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 10px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"none","& .MuiTouchRipple-root":{"width":"42.703px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"1px solid var(--mui-palette-action-disabledBackground)","background":"none"},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","border":"1px solid var(--mui-palette-success-outlinedBorder)","background":"var(--mui-palette-success-hover)"}},"&.MuiButton-sizeMedium.MuiButton-textPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none","display":"none","border":"0px solid var(--mui-palette-action-disabledBackground)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeMedium.MuiButton-textSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.875rem","fontStyle":"normal","fontWeight":"500","lineHeight":"24px /* 171.429% */","letterSpacing":"0.4px","textTransform":"uppercase","padding":"6px 8px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none","& .MuiTouchRipple-root":{"width":"41.231px","height":"46.286px","borderRadius":"100px","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textPrimary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none","display":"none","border":"0px solid var(--mui-palette-action-disabledBackground)"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textInherit":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textInherit (white)":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textSecondary":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textError":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textWarning":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textInfo":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeLarge.MuiButton-textSuccess":{"fontFeatureSettings":"\'liga\' off, \'clig\' off","fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.9375rem","fontStyle":"normal","fontWeight":"500","lineHeight":"26px /* 173.333% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"8px 11px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none","& .MuiTouchRipple-root":{"width":"47.857px","height":"54px","borderRadius":"100px","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","border":"0px solid var(--mui-palette-action-disabledBackground)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textPrimary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none","display":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-primary-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-primary-main)","background":"var(--mui-palette-primary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textInherit":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-text-primary)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-text-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-text-primary)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textInherit (white)":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-common-white-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-common-white-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-common-white-main)","background":"var(--mui-palette-action-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textSecondary":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-secondary-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-secondary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-secondary-main)","background":"var(--mui-palette-secondary-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textError":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-error-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-error-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-error-main)","background":"var(--mui-palette-error-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textWarning":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-warning-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-warning-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-warning-main)","background":"var(--mui-palette-warning-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textInfo":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-info-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-primary-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-info-main)","background":"var(--mui-palette-info-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}},"&.MuiButton-sizeSmall.MuiButton-textSuccess":{"fontFamily":"Poppins, Helvetica, Arial, sans-serif","fontSize":"0.8125rem","fontStyle":"normal","fontWeight":"500","lineHeight":"22px /* 169.231% */","letterSpacing":"0.46px","textTransform":"uppercase","padding":"4px 5px","borderRadius":"var(--mui-shape-ButtonBorderRadius)","opacity":"1","boxShadow":"none","&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none"},"&:not(.Mui-disabled).Mui-focusVisible:not(:hover)":{"color":"var(--mui-palette-success-main)","background":"none","& .MuiTouchRipple-root":{"width":"35.341px","height":"38.571px","borderRadius":"100px","background":"var(--mui-palette-success-focusVisible)","padding":"0","opacity":"1","boxShadow":"none"}},"&:not(.Mui-disabled):not(.Mui-focusVisible):hover":{"color":"var(--mui-palette-success-main)","background":"var(--mui-palette-success-hover)"},"&.Mui-disabled:not(.Mui-focusVisible):not(:hover)":{"color":"var(--mui-palette-action-disabled)","background":"none"}}}}},"MuiSwitch":{"styleOverrides":{"root":{"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorSecondary)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"100px","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-secondary-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-secondary-focusVisible)"}}},"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorWarning)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"100px","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-warning-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-warning-focusVisible)"}}},"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorInfo)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"100px","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-info-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-info-focusVisible)"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorSecondary)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"100px","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-secondary-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-secondary-focusVisible)"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorWarning)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"100px","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-warning-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-warning-focusVisible)"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorInfo)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"100px","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-info-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-info-focusVisible)"}}},"&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorPrimary)":{"& .MuiSwitch-switchBase":{"padding":"9px","borderRadius":"100px","transform":"translateX(20px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-primary-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-primary-focusVisible)"}}},"&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorPrimary)":{"& .MuiSwitch-switchBase":{"padding":"4px","borderRadius":"100px","transform":"translateX(16px) translateY(0px)","opacity":"1","boxShadow":"none"},"&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible)):hover":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-primary-hover)"}},"&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":{"& .MuiSwitch-switchBase":{"background":"var(--mui-palette-primary-focusVisible)"}}}}}}}}');

});




parcelRegister("lMXxq", function(module, exports) {
"use strict";
var $fdcc43b598f296b9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KrgThemeSelector = void 0;

const $fdcc43b598f296b9$var$krg_theme_selector_react_1 = $fdcc43b598f296b9$var$__importDefault((parcelRequire("ieL1p")));
module.exports.KrgThemeSelector = $fdcc43b598f296b9$var$krg_theme_selector_react_1.default;

});
parcelRegister("ieL1p", function(module, exports) {
"use strict";
var $d46e02549f50a613$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d46e02549f50a613$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d46e02549f50a613$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d46e02549f50a613$var$__createBinding(result, mod, k);
    }
    $d46e02549f50a613$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d46e02549f50a613$var$react_1 = $d46e02549f50a613$var$__importStar((parcelRequire("acw62")));

var $OEVqP = parcelRequire("OEVqP");
var $5cKqR = parcelRequire("5cKqR");

var $hBUtx = parcelRequire("hBUtx");
const $d46e02549f50a613$var$KrgThemeSelector = ({ setTheme: setTheme, setMode: setMode })=>{
    const themeOptions = [
        {
            value: $hBUtx.THEME.default,
            label: "Default"
        },
        {
            value: $hBUtx.THEME.whiteLabel,
            label: "White Label"
        }
    ];
    const modeOptions = [
        {
            value: $hBUtx.MODE.dark,
            label: "Dark"
        },
        {
            value: $hBUtx.MODE.light,
            label: "Light"
        }
    ];
    const [selectedTheme, setSelectedTheme] = (0, $d46e02549f50a613$var$react_1.useState)($hBUtx.THEME.default);
    const [selectedMode, setSelectedMode] = (0, $d46e02549f50a613$var$react_1.useState)($hBUtx.MODE.light);
    (0, $d46e02549f50a613$var$react_1.useEffect)(()=>{
        setTheme(selectedTheme);
    }, [
        selectedTheme,
        setTheme
    ]);
    (0, $d46e02549f50a613$var$react_1.useEffect)(()=>{
        if (setMode) setMode(selectedMode);
    }, [
        selectedMode,
        setMode
    ]);
    return $d46e02549f50a613$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            alignItems: "flex-start"
        }
    }, $d46e02549f50a613$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: "0.25em"
        }
    }, $d46e02549f50a613$var$react_1.default.createElement($OEVqP.default, {
        id: "theme-label"
    }, "Select Theme:"), $d46e02549f50a613$var$react_1.default.createElement($5cKqR.default, {
        id: "theme-label",
        fullWidth: true,
        value: selectedTheme,
        style: {
            width: "200px",
            height: "36px",
            borderRadius: 0
        },
        onChange: ({ target: target })=>setSelectedTheme(target.value)
    }, themeOptions.map((item, i)=>$d46e02549f50a613$var$react_1.default.createElement("option", {
            key: i,
            value: item.value
        }, item.label)))), $d46e02549f50a613$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: "0.25em"
        }
    }, $d46e02549f50a613$var$react_1.default.createElement($OEVqP.default, {
        id: "mode-label"
    }, "Select Mode:"), $d46e02549f50a613$var$react_1.default.createElement($5cKqR.default, {
        id: "mode-label",
        fullWidth: true,
        value: selectedMode,
        style: {
            width: "200px",
            height: "36px",
            borderRadius: 0
        },
        onChange: ({ target: target })=>setSelectedMode(target.value)
    }, modeOptions.map((item, i)=>$d46e02549f50a613$var$react_1.default.createElement("option", {
            key: i,
            value: item.value
        }, item.label)))));
};
module.exports.default = $d46e02549f50a613$var$KrgThemeSelector;

});
parcelRegister("5cKqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ca2173d4de87b59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $c9Z8w = parcelRequire("c9Z8w");

var $8Indx = parcelRequire("8Indx");

var $iOErJ = parcelRequire("iOErJ");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $7LRfY = parcelRequire("7LRfY");

var $ab7Se = parcelRequire("ab7Se");

var $1iOpW = parcelRequire("1iOpW");

var $6jVRo = parcelRequire("6jVRo");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $3ca2173d4de87b59$var$_excluded = [
    "className",
    "children",
    "classes",
    "IconComponent",
    "input",
    "inputProps",
    "variant"
], $3ca2173d4de87b59$var$_excluded2 = [
    "root"
];
const $3ca2173d4de87b59$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6jVRo.getNativeSelectUtilityClasses), classes);
};
const $3ca2173d4de87b59$var$defaultInput = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab7Se.default), {});
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ const $3ca2173d4de87b59$var$NativeSelect = /*#__PURE__*/ $acw62.forwardRef(function NativeSelect(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: "MuiNativeSelect",
        props: inProps
    });
    const { className: className, children: children, classes: classesProp = {}, IconComponent: IconComponent = (0, $7LRfY.default), input: input = $3ca2173d4de87b59$var$defaultInput, inputProps: inputProps } = props, other = (0, $1En50.default)(props, $3ca2173d4de87b59$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: classesProp
    });
    const classes = $3ca2173d4de87b59$var$useUtilityClasses(ownerState);
    const otherClasses = (0, $1En50.default)(classesProp, $3ca2173d4de87b59$var$_excluded2);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(input, (0, $8nd05.default)({
            // Most of the logic is implemented in `NativeSelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent: (0, $iOErJ.default),
            inputProps: (0, $8nd05.default)({
                children: children,
                classes: otherClasses,
                IconComponent: IconComponent,
                variant: fcs.variant,
                type: undefined
            }, inputProps, input ? input.props.inputProps : {}),
            ref: ref
        }, other, {
            className: (0, $9QePP.default)(classes.root, input.props.className, className)
        }))
    });
});
$3ca2173d4de87b59$var$NativeSelect.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   * @default {}
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   * @default <Input />
   */ input: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#attributes) applied to the `select` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {React.ChangeEvent<HTMLSelectElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The `input` value. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "filled",
        "outlined",
        "standard"
    ])
};
$3ca2173d4de87b59$var$NativeSelect.muiName = "Select";
var $3ca2173d4de87b59$export$2e2bcd8739ae039 = $3ca2173d4de87b59$var$NativeSelect;

});




parcelRegister("lPPDP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.COLOR_ENUM_STANDARD = module.exports.ORIENTATION_ENUM = module.exports.SIZE_ENUM = void 0;
var $fe566b52fd5c95d2$var$SIZE_ENUM;
(function(SIZE_ENUM) {
    SIZE_ENUM["small"] = "small";
    SIZE_ENUM["medium"] = "medium";
    SIZE_ENUM["large"] = "large";
})($fe566b52fd5c95d2$var$SIZE_ENUM || (module.exports.SIZE_ENUM = $fe566b52fd5c95d2$var$SIZE_ENUM = {}));
var $fe566b52fd5c95d2$var$ORIENTATION_ENUM;
(function(ORIENTATION_ENUM) {
    ORIENTATION_ENUM["horizontal"] = "horizontal";
    ORIENTATION_ENUM["vertical"] = "vertical";
})($fe566b52fd5c95d2$var$ORIENTATION_ENUM || (module.exports.ORIENTATION_ENUM = $fe566b52fd5c95d2$var$ORIENTATION_ENUM = {}));
var $fe566b52fd5c95d2$var$COLOR_ENUM_STANDARD;
(function(COLOR_ENUM_STANDARD) {
    COLOR_ENUM_STANDARD["standard"] = "standard";
})($fe566b52fd5c95d2$var$COLOR_ENUM_STANDARD || (module.exports.COLOR_ENUM_STANDARD = $fe566b52fd5c95d2$var$COLOR_ENUM_STANDARD = {}));

});


parcelRegister("cftMu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i = $1u0KT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$7e96a608cb33bf79$export$882461b6382ed46c = function(c, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $1u0KT.createRoot(c, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};
$7e96a608cb33bf79$export$757ceba2d55c277e = function(c, h, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $1u0KT.hydrateRoot(c, h, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/*
 * Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ // Logging constants
var $3685f81745c941bf$export$480ff6141d16ea0 = 26;
var $3685f81745c941bf$export$b28184bf79b04783 = 1048576;
var $3685f81745c941bf$export$a21f820c9933d674 = 256000;
var $3685f81745c941bf$export$13470c6f1642bbce = "Logging";
var $3685f81745c941bf$export$d781556e70493844 = "AWSCloudWatch";
var $3685f81745c941bf$export$9a85ff898770a423 = "No credentials";
var $3685f81745c941bf$export$569d67cd7966b708 = [
    "ResourceNotFoundException",
    "InvalidSequenceTokenException"
];


var $22e905ae30d82ab4$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $22e905ae30d82ab4$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $22e905ae30d82ab4$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($22e905ae30d82ab4$var$__read(arguments[i]));
    return ar;
};
var $22e905ae30d82ab4$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var $22e905ae30d82ab4$export$ee432113040024a6;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})($22e905ae30d82ab4$export$ee432113040024a6 || ($22e905ae30d82ab4$export$ee432113040024a6 = {}));
/**
 * Write logs
 * @class Logger
 */ var $22e905ae30d82ab4$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = $22e905ae30d82ab4$export$ee432113040024a6.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? "0" + n : "" + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $22e905ae30d82ab4$var$LOG_LEVELS[logger_level_name];
        var type_level = $22e905ae30d82ab4$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === $22e905ae30d82ab4$export$ee432113040024a6.ERROR && console.error) log = console.error.bind(console);
        if (type === $22e905ae30d82ab4$export$ee432113040024a6.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        var message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = prefix + " - " + msg[0];
            log(message);
        } else if (msg.length === 1) {
            message = prefix + " " + msg[0];
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = prefix + " - " + msg[0] + " " + obj;
            log(prefix + " - " + msg[0], obj);
        } else {
            message = prefix + " " + msg;
            log(prefix, msg);
        }
        try {
            for(var _b = $22e905ae30d82ab4$var$__values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spread([
            $22e905ae30d82ab4$export$ee432113040024a6.INFO
        ], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spread([
            $22e905ae30d82ab4$export$ee432113040024a6.INFO
        ], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spread([
            $22e905ae30d82ab4$export$ee432113040024a6.WARN
        ], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spread([
            $22e905ae30d82ab4$export$ee432113040024a6.ERROR
        ], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spread([
            $22e905ae30d82ab4$export$ee432113040024a6.DEBUG
        ], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spread([
            $22e905ae30d82ab4$export$ee432113040024a6.VERBOSE
        ], msg));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $3685f81745c941bf$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();


var $36606c730099e1c8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $36606c730099e1c8$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Amplify");
var $36606c730099e1c8$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Logger = (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $36606c730099e1c8$var$logger.debug("component registered in amplify", comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === "function") {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $36606c730099e1c8$var$logger.debug("no getModuleName method for component", comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $36606c730099e1c8$var$logger.debug("amplify config", this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $36606c730099e1c8$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") this._components.map(function(comp) {
            if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $36606c730099e1c8$export$a3858a9a153cffc7 = new $36606c730099e1c8$export$b412d755cfa0136();
var /**
 * @deprecated use named import
 */ $36606c730099e1c8$export$2e2bcd8739ae039 = $36606c730099e1c8$export$a3858a9a153cffc7;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ // generated by genversion
var $ebc0a6a6220d1fd4$export$83d89fbfd8236492 = "4.7.14";


var $2c4730a78a7bdcd6$var$BASE_USER_AGENT = "aws-amplify/" + (0, $ebc0a6a6220d1fd4$export$83d89fbfd8236492);
var $2c4730a78a7bdcd6$export$2dffd0b5373a4389 = {
    userAgent: $2c4730a78a7bdcd6$var$BASE_USER_AGENT + " js",
    product: "",
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== "undefined" && navigator.product) {
    $2c4730a78a7bdcd6$export$2dffd0b5373a4389.product = navigator.product || "";
    $2c4730a78a7bdcd6$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case "ReactNative":
            $2c4730a78a7bdcd6$export$2dffd0b5373a4389.userAgent = $2c4730a78a7bdcd6$var$BASE_USER_AGENT + " react-native";
            $2c4730a78a7bdcd6$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $2c4730a78a7bdcd6$export$2dffd0b5373a4389.userAgent = $2c4730a78a7bdcd6$var$BASE_USER_AGENT + " js";
            $2c4730a78a7bdcd6$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $2c4730a78a7bdcd6$export$ede38edb26c0bfdf = function(content) {
    return "" + $2c4730a78a7bdcd6$export$2dffd0b5373a4389.userAgent + (content ? content : "");
};
var /**
 * @deprecated use named import
 */ $2c4730a78a7bdcd6$export$2e2bcd8739ae039 = $2c4730a78a7bdcd6$export$2dffd0b5373a4389;





/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $1a908fb961b3fa6b$var$__assign = undefined && undefined.__assign || function() {
    $1a908fb961b3fa6b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a908fb961b3fa6b$var$__assign.apply(this, arguments);
};
var $1a908fb961b3fa6b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $1a908fb961b3fa6b$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1a908fb961b3fa6b$var$__read(arguments[i]));
    return ar;
};
var $1a908fb961b3fa6b$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Hub");
var $1a908fb961b3fa6b$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function $1a908fb961b3fa6b$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $1a908fb961b3fa6b$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $1a908fb961b3fa6b$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = $1a908fb961b3fa6b$var$__spread(this.patterns.filter(function(x) {
                return x !== pattern_1;
            }));
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $1a908fb961b3fa6b$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = $1a908fb961b3fa6b$var$__spread(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = "";
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $1a908fb961b3fa6b$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $1a908fb961b3fa6b$var$logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
        }
        var capsule = {
            channel: channel,
            payload: $1a908fb961b3fa6b$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $1a908fb961b3fa6b$var$logger.error(e);
        }
    };
    HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = "noname";
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($1a908fb961b3fa6b$var$isLegacyCallback(callback)) {
            $1a908fb961b3fa6b$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== "function") throw new Error("No callback supplied to Hub");
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this.remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $1a908fb961b3fa6b$var$logger.debug("Dispatching to " + channel + " with ", payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $1a908fb961b3fa6b$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $1a908fb961b3fa6b$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $1a908fb961b3fa6b$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $1a908fb961b3fa6b$var$__assign($1a908fb961b3fa6b$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $1a908fb961b3fa6b$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $1a908fb961b3fa6b$export$8c41bb232f1008b1 = new $1a908fb961b3fa6b$export$6b38ef2be9abbbb9("__default__");
var /**
 * @deprecated use named import
 */ $1a908fb961b3fa6b$export$2e2bcd8739ae039 = $1a908fb961b3fa6b$export$8c41bb232f1008b1;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $0d974636016b3300$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("I18n");
/**
 * Language transition class
 */ var $0d974636016b3300$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        $0d974636016b3300$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();




var $a204f73577cd8409$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("I18n");
var $a204f73577cd8409$var$_config = null;
var $a204f73577cd8409$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $a204f73577cd8409$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $a204f73577cd8409$var$logger.debug("configure I18n");
        if (!config) return $a204f73577cd8409$var$_config;
        $a204f73577cd8409$var$_config = Object.assign({}, $a204f73577cd8409$var$_config, config.I18n || config);
        I18n.createInstance();
        return $a204f73577cd8409$var$_config;
    };
    I18n.getModuleName = function() {
        return "I18n";
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $a204f73577cd8409$var$logger.debug("create I18n instance");
        if ($a204f73577cd8409$var$_i18n) return;
        $a204f73577cd8409$var$_i18n = new (0, $0d974636016b3300$export$dbe3113d60765c1a)($a204f73577cd8409$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $a204f73577cd8409$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        return $a204f73577cd8409$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $a204f73577cd8409$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $a204f73577cd8409$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$a204f73577cd8409$var$_i18n) $a204f73577cd8409$var$_i18n = new (0, $0d974636016b3300$export$dbe3113d60765c1a)($a204f73577cd8409$var$_config);
        return true;
    };
    return I18n;
}();
(0, $36606c730099e1c8$export$a3858a9a153cffc7).register($a204f73577cd8409$export$dbe3113d60765c1a);
var /**
 * @deprecated use named import
 */ $a204f73577cd8409$export$2e2bcd8739ae039 = $a204f73577cd8409$export$dbe3113d60765c1a;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $hPtJY = parcelRequire("hPtJY");
var $28ca6f9027b485a7$var$MIME_MAP = [
    {
        type: "text/plain",
        ext: "txt"
    },
    {
        type: "text/html",
        ext: "html"
    },
    {
        type: "text/javascript",
        ext: "js"
    },
    {
        type: "text/css",
        ext: "css"
    },
    {
        type: "text/csv",
        ext: "csv"
    },
    {
        type: "text/yaml",
        ext: "yml"
    },
    {
        type: "text/yaml",
        ext: "yaml"
    },
    {
        type: "text/calendar",
        ext: "ics"
    },
    {
        type: "text/calendar",
        ext: "ical"
    },
    {
        type: "image/apng",
        ext: "apng"
    },
    {
        type: "image/bmp",
        ext: "bmp"
    },
    {
        type: "image/gif",
        ext: "gif"
    },
    {
        type: "image/x-icon",
        ext: "ico"
    },
    {
        type: "image/x-icon",
        ext: "cur"
    },
    {
        type: "image/jpeg",
        ext: "jpg"
    },
    {
        type: "image/jpeg",
        ext: "jpeg"
    },
    {
        type: "image/jpeg",
        ext: "jfif"
    },
    {
        type: "image/jpeg",
        ext: "pjp"
    },
    {
        type: "image/jpeg",
        ext: "pjpeg"
    },
    {
        type: "image/png",
        ext: "png"
    },
    {
        type: "image/svg+xml",
        ext: "svg"
    },
    {
        type: "image/tiff",
        ext: "tif"
    },
    {
        type: "image/tiff",
        ext: "tiff"
    },
    {
        type: "image/webp",
        ext: "webp"
    },
    {
        type: "application/json",
        ext: "json"
    },
    {
        type: "application/xml",
        ext: "xml"
    },
    {
        type: "application/x-sh",
        ext: "sh"
    },
    {
        type: "application/zip",
        ext: "zip"
    },
    {
        type: "application/x-rar-compressed",
        ext: "rar"
    },
    {
        type: "application/x-tar",
        ext: "tar"
    },
    {
        type: "application/x-bzip",
        ext: "bz"
    },
    {
        type: "application/x-bzip2",
        ext: "bz2"
    },
    {
        type: "application/pdf",
        ext: "pdf"
    },
    {
        type: "application/java-archive",
        ext: "jar"
    },
    {
        type: "application/msword",
        ext: "doc"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xls"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    },
    {
        type: "message/rfc822",
        ext: "eml"
    }
];
var $28ca6f9027b485a7$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $28ca6f9027b485a7$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === "desc" ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === "undefined") return typeof a_val === "undefined" ? 0 : 1 * dirX;
        if (typeof a_val === "undefined") return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $28ca6f9027b485a7$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === "string") delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $28ca6f9027b485a7$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = "application/octet-stream";
    var name = filename.toLowerCase();
    var filtered = $28ca6f9027b485a7$var$MIME_MAP.filter(function(mime) {
        return name.endsWith("." + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $28ca6f9027b485a7$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith("text/")) return true;
    return "application/json" === type || "application/xml" === type || "application/sh" === type;
};
var $28ca6f9027b485a7$export$9e15fb06e64c4810 = function() {
    var result = "";
    var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $28ca6f9027b485a7$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $28ca6f9027b485a7$export$97b87b8868ff7a3c = function() {
    if (typeof self === "undefined") return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};
var $28ca6f9027b485a7$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    var isNode = typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $28ca6f9027b485a7$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$28ca6f9027b485a7$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $28ca6f9027b485a7$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $28ca6f9027b485a7$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$28ca6f9027b485a7$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $28ca6f9027b485a7$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $28ca6f9027b485a7$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};
/**
 * @deprecated use per-function imports
 */ var $28ca6f9027b485a7$export$174a40858393256b = /** @class */ function() {
    function JS() {}
    JS.isEmpty = $28ca6f9027b485a7$export$dd1bc94b04021eeb;
    JS.sortByField = $28ca6f9027b485a7$export$756e1e7707954007;
    JS.objectLessAttributes = $28ca6f9027b485a7$export$5e10ed067f63a9ea;
    JS.filenameToContentType = $28ca6f9027b485a7$export$49cecb876bed446d;
    JS.isTextFile = $28ca6f9027b485a7$export$689bea3eece53c0e;
    JS.generateRandomString = $28ca6f9027b485a7$export$9e15fb06e64c4810;
    JS.makeQuerablePromise = $28ca6f9027b485a7$export$8f33cb495ca11832;
    JS.isWebWorker = $28ca6f9027b485a7$export$97b87b8868ff7a3c;
    JS.browserOrNode = $28ca6f9027b485a7$export$a2708fdb45cd35f;
    JS.transferKeyToLowerCase = $28ca6f9027b485a7$export$6281ea8cfc59a49c;
    JS.transferKeyToUpperCase = $28ca6f9027b485a7$export$f8790a3d3d35829c;
    JS.isStrictObject = $28ca6f9027b485a7$export$250974ab4f95003c;
    return JS;
}();
var /**
 * @deprecated use per-function imports
 */ $28ca6f9027b485a7$export$2e2bcd8739ae039 = $28ca6f9027b485a7$export$174a40858393256b;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $55e8f78e861134b5$exports = {};
"use strict";
Object.defineProperty($55e8f78e861134b5$exports, "__esModule", {
    value: true
});

var $7lMqe = parcelRequire("7lMqe");

$7lMqe.__exportStar((parcelRequire("bhLLf")), $55e8f78e861134b5$exports);


var $e02f91f5e6e2edfe$var$SHORT_TO_HEX = {};
var $e02f91f5e6e2edfe$var$HEX_TO_SHORT = {};
for(var $e02f91f5e6e2edfe$var$i = 0; $e02f91f5e6e2edfe$var$i < 256; $e02f91f5e6e2edfe$var$i++){
    var $e02f91f5e6e2edfe$var$encodedByte = $e02f91f5e6e2edfe$var$i.toString(16).toLowerCase();
    if ($e02f91f5e6e2edfe$var$encodedByte.length === 1) $e02f91f5e6e2edfe$var$encodedByte = "0" + $e02f91f5e6e2edfe$var$encodedByte;
    $e02f91f5e6e2edfe$var$SHORT_TO_HEX[$e02f91f5e6e2edfe$var$i] = $e02f91f5e6e2edfe$var$encodedByte;
    $e02f91f5e6e2edfe$var$HEX_TO_SHORT[$e02f91f5e6e2edfe$var$encodedByte] = $e02f91f5e6e2edfe$var$i;
}
function $e02f91f5e6e2edfe$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $e02f91f5e6e2edfe$var$HEX_TO_SHORT) out[i / 2] = $e02f91f5e6e2edfe$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $e02f91f5e6e2edfe$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $e02f91f5e6e2edfe$var$SHORT_TO_HEX[bytes[i]];
    return out;
}



var $biuEp = parcelRequire("biuEp");
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var $ab4134d35d0ec0ff$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// Comment - TODO: remove
var $ab4134d35d0ec0ff$var$FIVE_MINUTES_IN_MS = 300000;
var $ab4134d35d0ec0ff$export$3e048df13f4eb60b = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if ($ab4134d35d0ec0ff$export$3e048df13f4eb60b.clockOffset) return new Date(new Date().getTime() + $ab4134d35d0ec0ff$export$3e048df13f4eb60b.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return $ab4134d35d0ec0ff$export$3e048df13f4eb60b.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = $ab4134d35d0ec0ff$export$3e048df13f4eb60b.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    },
    getDateFromHeaderString: function(header) {
        var _a = $ab4134d35d0ec0ff$var$__read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - $ab4134d35d0ec0ff$export$3e048df13f4eb60b.getDateWithClockOffset().getTime()) >= $ab4134d35d0ec0ff$var$FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean([
            "BadRequestException",
            "InvalidSignatureException"
        ].includes(headers["x-amzn-errortype"]) && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        $ab4134d35d0ec0ff$export$3e048df13f4eb60b.clockOffset = offset;
    }
};


var $3150f83da5fbd558$var$__assign = undefined && undefined.__assign || function() {
    $3150f83da5fbd558$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3150f83da5fbd558$var$__assign.apply(this, arguments);
};
var $3150f83da5fbd558$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3150f83da5fbd558$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Signer");
var $3150f83da5fbd558$var$DEFAULT_ALGORITHM = "AWS4-HMAC-SHA256";
var $3150f83da5fbd558$var$IOT_SERVICE_NAME = "iotdevicegateway";
var $3150f83da5fbd558$var$encrypt = function(key, src) {
    var hash = new (0, $55e8f78e861134b5$exports.Sha256)(key);
    hash.update(src);
    return hash.digestSync();
};
var $3150f83da5fbd558$var$hash = function(src) {
    var arg = src || "";
    var hash = new (0, $55e8f78e861134b5$exports.Sha256)();
    hash.update(arg);
    return (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(hash.digestSync());
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */ var $3150f83da5fbd558$var$escape_RFC3986 = function(component) {
    return component.replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
};
/**
 * @private
 * Create canonical query string
 *
 */ var $3150f83da5fbd558$var$canonical_query = function(query) {
    if (!query || query.length === 0) return "";
    return query.split("&").map(function(e) {
        var key_val = e.split("=");
        if (key_val.length === 1) return e;
        else {
            var reencoded_val = $3150f83da5fbd558$var$escape_RFC3986(key_val[1]);
            return key_val[0] + "=" + reencoded_val;
        }
    }).sort(function(a, b) {
        var key_a = a.split("=")[0];
        var key_b = b.split("=")[0];
        if (key_a === key_b) return a < b ? -1 : 1;
        else return key_a < key_b ? -1 : 1;
    }).join("&");
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $3150f83da5fbd558$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return "";
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, " ") : ""
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ":" + item.value;
    }).join("\n") + "\n";
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */ var $3150f83da5fbd558$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(";");
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $3150f83da5fbd558$var$canonical_request = function(request) {
    var url_info = (0, $biuEp.parse)(request.url);
    return [
        request.method || "/",
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, "/"),
        $3150f83da5fbd558$var$canonical_query(url_info.query),
        $3150f83da5fbd558$var$canonical_headers(request.headers),
        $3150f83da5fbd558$var$signed_headers(request.headers),
        $3150f83da5fbd558$var$hash(request.data)
    ].join("\n");
};
var $3150f83da5fbd558$var$parse_service_info = function(request) {
    var url_info = (0, $biuEp.parse)(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === "es") // Elastic Search
    parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $3150f83da5fbd558$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        "aws4_request"
    ].join("/");
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $3150f83da5fbd558$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $3150f83da5fbd558$var$hash(canonical_request)
    ].join("\n");
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $3150f83da5fbd558$var$get_signing_key = function(secret_key, d_str, service_info) {
    $3150f83da5fbd558$var$logger.debug(service_info);
    var k = "AWS4" + secret_key, k_date = $3150f83da5fbd558$var$encrypt(k, d_str), k_region = $3150f83da5fbd558$var$encrypt(k_date, service_info.region), k_service = $3150f83da5fbd558$var$encrypt(k_region, service_info.service), k_signing = $3150f83da5fbd558$var$encrypt(k_service, "aws4_request");
    return k_signing;
};
var $3150f83da5fbd558$var$get_signature = function(signing_key, str_to_sign) {
    return (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)($3150f83da5fbd558$var$encrypt(signing_key, str_to_sign));
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */ var $3150f83da5fbd558$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + " " + "Credential=" + access_key + "/" + scope,
        "SignedHeaders=" + signed_headers,
        "Signature=" + signature
    ].join(", ");
};
var $3150f83da5fbd558$export$fdf54fdde81cc9f0 = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, access_info, service_info) {
        if (service_info === void 0) service_info = null;
        request.headers = request.headers || {};
        if (request.body && !request.data) throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
        // datetime string and date string
        var dt = (0, $ab4134d35d0ec0ff$export$3e048df13f4eb60b).getDateWithClockOffset(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ""), d_str = dt_str.substr(0, 8);
        var url_info = (0, $biuEp.parse)(request.url);
        request.headers["host"] = url_info.host;
        request.headers["x-amz-date"] = dt_str;
        if (access_info.session_token) request.headers["X-Amz-Security-Token"] = access_info.session_token;
        // Task 1: Create a Canonical Request
        var request_str = $3150f83da5fbd558$var$canonical_request(request);
        $3150f83da5fbd558$var$logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || $3150f83da5fbd558$var$parse_service_info(request), scope = $3150f83da5fbd558$var$credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = $3150f83da5fbd558$var$string_to_sign($3150f83da5fbd558$var$DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = $3150f83da5fbd558$var$get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = $3150f83da5fbd558$var$get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = $3150f83da5fbd558$var$get_authorization_header($3150f83da5fbd558$var$DEFAULT_ALGORITHM, access_info.access_key, scope, $3150f83da5fbd558$var$signed_headers(request.headers), signature);
        request.headers["Authorization"] = authorization_header;
        return request;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === "object" ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === "object" ? urlOrRequest.method : "GET";
        var body = typeof urlOrRequest === "object" ? urlOrRequest.body : undefined;
        var now = (0, $ab4134d35d0ec0ff$export$3e048df13f4eb60b).getDateWithClockOffset().toISOString().replace(/[:\-]|\.\d{3}/g, "");
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = (0, $biuEp.parse)(urlToSign, true, true), search = _a.search, parsedUrl = $3150f83da5fbd558$var$__rest(_a, [
            "search"
        ]);
        var host = parsedUrl.host;
        var signedHeaders = {
            host: host
        };
        var _b = serviceInfo || $3150f83da5fbd558$var$parse_service_info({
            url: (0, $biuEp.format)(parsedUrl)
        }), region = _b.region, service = _b.service;
        var credentialScope = $3150f83da5fbd558$var$credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== $3150f83da5fbd558$var$IOT_SERVICE_NAME;
        var queryParams = $3150f83da5fbd558$var$__assign($3150f83da5fbd558$var$__assign($3150f83da5fbd558$var$__assign({
            "X-Amz-Algorithm": $3150f83da5fbd558$var$DEFAULT_ALGORITHM,
            "X-Amz-Credential": [
                accessInfo.access_key,
                credentialScope
            ].join("/"),
            "X-Amz-Date": now.substr(0, 16)
        }, sessionTokenRequired ? {
            "X-Amz-Security-Token": "" + accessInfo.session_token
        } : {}), expiration ? {
            "X-Amz-Expires": "" + expiration
        } : {}), {
            "X-Amz-SignedHeaders": Object.keys(signedHeaders).join(",")
        });
        var canonicalRequest = $3150f83da5fbd558$var$canonical_request({
            method: method,
            url: (0, $biuEp.format)($3150f83da5fbd558$var$__assign($3150f83da5fbd558$var$__assign({}, parsedUrl), {
                query: $3150f83da5fbd558$var$__assign($3150f83da5fbd558$var$__assign({}, parsedUrl.query), queryParams)
            })),
            headers: signedHeaders,
            data: body
        });
        var stringToSign = $3150f83da5fbd558$var$string_to_sign($3150f83da5fbd558$var$DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = $3150f83da5fbd558$var$get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service
        });
        var signature = $3150f83da5fbd558$var$get_signature(signing_key, stringToSign);
        var additionalQueryParams = $3150f83da5fbd558$var$__assign({
            "X-Amz-Signature": signature
        }, accessInfo.session_token && {
            "X-Amz-Security-Token": accessInfo.session_token
        });
        var result = (0, $biuEp.format)({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: $3150f83da5fbd558$var$__assign($3150f83da5fbd558$var$__assign($3150f83da5fbd558$var$__assign({}, parsedUrl.query), queryParams), additionalQueryParams)
        });
        return result;
    };
    return Signer;
}();
var /**
 * @deprecated use per-function import
 */ $3150f83da5fbd558$export$2e2bcd8739ae039 = $3150f83da5fbd558$export$fdf54fdde81cc9f0;



var $b04fed49d5c1afc7$var$__assign = undefined && undefined.__assign || function() {
    $b04fed49d5c1afc7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b04fed49d5c1afc7$var$__assign.apply(this, arguments);
};
var $b04fed49d5c1afc7$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Parser");
var $b04fed49d5c1afc7$export$33f4f68299e2efa8 = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config["aws_mobile_analytics_app_id"]) {
        var Analytics = {
            AWSPinpoint: {
                appId: config["aws_mobile_analytics_app_id"],
                region: config["aws_mobile_analytics_app_region"]
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) amplifyConfig.Auth = {
        userPoolId: config["aws_user_pools_id"],
        userPoolWebClientId: config["aws_user_pools_web_client_id"],
        region: config["aws_cognito_region"],
        identityPoolId: config["aws_cognito_identity_pool_id"],
        identityPoolRegion: config["aws_cognito_region"],
        mandatorySignIn: config["aws_mandatory_sign_in"] === "enable",
        signUpVerificationMethod: config["aws_cognito_sign_up_verification_method"] || "code"
    };
    // Storage
    var storageConfig;
    if (config["aws_user_files_s3_bucket"]) storageConfig = {
        AWSS3: {
            bucket: config["aws_user_files_s3_bucket"],
            region: config["aws_user_files_s3_bucket_region"],
            dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config["Logging"]) amplifyConfig.Logging = $b04fed49d5c1afc7$var$__assign($b04fed49d5c1afc7$var$__assign({}, config["Logging"]), {
        region: config["aws_project_region"]
    });
    // Geo
    if (config["geo"]) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo["amazon_location_service"]) amplifyConfig.Geo = {
            AmazonLocationService: config.geo["amazon_location_service"]
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    $b04fed49d5c1afc7$var$logger.debug("parse config", config, "to amplifyconfig", amplifyConfig);
    return amplifyConfig;
};
/**
 * @deprecated use per-function export
 */ var $b04fed49d5c1afc7$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser() {}
    Parser.parseMobilehubConfig = $b04fed49d5c1afc7$export$33f4f68299e2efa8;
    return Parser;
}();
var /**
 * @deprecated use per-function export
 */ $b04fed49d5c1afc7$export$2e2bcd8739ae039 = $b04fed49d5c1afc7$export$7acfa6ed01010e37;






/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $7a47fb194d2f9787$var$dataMemory = {};
/** @class */ var $7a47fb194d2f9787$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $7a47fb194d2f9787$var$dataMemory[key] = value;
        return $7a47fb194d2f9787$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($7a47fb194d2f9787$var$dataMemory, key) ? $7a47fb194d2f9787$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $7a47fb194d2f9787$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $7a47fb194d2f9787$var$dataMemory = {};
        return $7a47fb194d2f9787$var$dataMemory;
    };
    return MemoryStorage;
}();
var $7a47fb194d2f9787$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.amplify.test-ls", 1);
            this.storageWindow.removeItem("aws.amplify.test-ls");
        } catch (exception) {
            this.storageWindow = $7a47fb194d2f9787$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();
var /**
 * @deprecated use named import
 */ $7a47fb194d2f9787$export$2e2bcd8739ae039 = $7a47fb194d2f9787$export$a2bd19c49e4760e8;



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 


var $f37409221557361a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f37409221557361a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f37409221557361a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f37409221557361a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f37409221557361a$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f37409221557361a$var$__read(arguments[i]));
    return ar;
};
var $f37409221557361a$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Util");
var $f37409221557361a$export$1e38badc838ad384 = /** @class */ function(_super) {
    $f37409221557361a$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $f37409221557361a$var$isNonRetryableError = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $f37409221557361a$export$9369b12211e1fce4(functionToRetry, args, delayFn, onTerminate) {
    return $f37409221557361a$var$__awaiter(this, void 0, void 0, function() {
        var _this = this;
        return $f37409221557361a$var$__generator(this, function(_a) {
            if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return $f37409221557361a$var$__awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return $f37409221557361a$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function() {
                                        var _a, _b, err_1, retryIn_1;
                                        return $f37409221557361a$var$__generator(this, function(_c) {
                                            switch(_c.label){
                                                case 0:
                                                    attempt++;
                                                    $f37409221557361a$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with this vars: " + JSON.stringify(args));
                                                    _c.label = 1;
                                                case 1:
                                                    _c.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _a = {};
                                                    _b = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, $f37409221557361a$var$__spread(args))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_a.value = _b.apply(void 0, [
                                                            _c.sent()
                                                        ]), _a)
                                                    ];
                                                case 3:
                                                    err_1 = _c.sent();
                                                    lastError = err_1;
                                                    $f37409221557361a$var$logger.debug("error on " + functionToRetry.name, err_1);
                                                    if ($f37409221557361a$var$isNonRetryableError(err_1)) {
                                                        $f37409221557361a$var$logger.debug(functionToRetry.name + " non retryable error", err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    $f37409221557361a$var$logger.debug(functionToRetry.name + " retrying in " + retryIn_1 + " ms");
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _c.sent();
                                                    _c.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var $f37409221557361a$var$MAX_DELAY_MS = 300000;
function $f37409221557361a$export$caea50bde345f648(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $f37409221557361a$var$MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $f37409221557361a$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = $f37409221557361a$var$MAX_DELAY_MS;
    return $f37409221557361a$export$9369b12211e1fce4(functionToRetry, args, $f37409221557361a$export$caea50bde345f648(maxDelayMs), onTerminate);
};


var $05e6294b0a9e5f29$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $05e6294b0a9e5f29$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $05e6294b0a9e5f29$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("CognitoCredentials");
var $05e6294b0a9e5f29$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) {
        $05e6294b0a9e5f29$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
    if (ga) {
        $05e6294b0a9e5f29$var$logger.debug("google api already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $05e6294b0a9e5f29$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $05e6294b0a9e5f29$var$__awaiter(this, void 0, void 0, function() {
            return $05e6294b0a9e5f29$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $05e6294b0a9e5f29$var$logger.debug("need to wait for the Google SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $05e6294b0a9e5f29$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $05e6294b0a9e5f29$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
        if (!ga) {
            $05e6294b0a9e5f29$var$logger.debug("no gapi auth2 available");
            return Promise.reject("no gapi auth2 available");
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $05e6294b0a9e5f29$var$logger.debug("google Auth undefined");
                    rej(new (0, $f37409221557361a$export$1e38badc838ad384)("google Auth undefined"));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $05e6294b0a9e5f29$var$logger.debug("refreshing the google access token");
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === "network_error") // Not using NonRetryableError so handler will be retried
                        rej("Network error reloading google auth response");
                        else rej(new (0, $f37409221557361a$export$1e38badc838ad384)("Failed to reload google auth response"));
                    });
                } else rej(new (0, $f37409221557361a$export$1e38badc838ad384)("User is not signed in with Google"));
            }).catch(function(err) {
                $05e6294b0a9e5f29$var$logger.debug("Failed to refresh google token", err);
                rej(new (0, $f37409221557361a$export$1e38badc838ad384)("Failed to refresh google token"));
            });
        });
    };
    return GoogleOAuth;
}();
var /**
 * @deprecated use named import
 */ $05e6294b0a9e5f29$export$2e2bcd8739ae039 = $05e6294b0a9e5f29$export$75ace714083c1340;





var $635604cca324ad48$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $635604cca324ad48$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $635604cca324ad48$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("CognitoCredentials");
var $635604cca324ad48$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) {
        $635604cca324ad48$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var fb = window["FB"];
    if (fb) {
        $635604cca324ad48$var$logger.debug("FB SDK already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $635604cca324ad48$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $635604cca324ad48$var$__awaiter(this, void 0, void 0, function() {
            return $635604cca324ad48$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $635604cca324ad48$var$logger.debug("need to wait for the Facebook SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $635604cca324ad48$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $635604cca324ad48$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) fb = window["FB"];
        if (!fb) {
            var errorMessage = "no fb sdk available";
            $635604cca324ad48$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $f37409221557361a$export$1e38badc838ad384)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = "no response from facebook when refreshing the jwt token";
                    $635604cca324ad48$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $f37409221557361a$export$1e38badc838ad384)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = "the jwtToken is undefined";
                        $635604cca324ad48$var$logger.debug(errorMessage);
                        rej(new (0, $f37409221557361a$export$1e38badc838ad384)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: "public_profile,email"
            });
        });
    };
    return FacebookOAuth;
}();
var /**
 * @deprecated use named import
 */ $635604cca324ad48$export$2e2bcd8739ae039 = $635604cca324ad48$export$1b6b8b5328e38349;


var $7dd2573c500c67b1$export$75ace714083c1340 = new (0, $05e6294b0a9e5f29$export$75ace714083c1340)();
var $7dd2573c500c67b1$export$1b6b8b5328e38349 = new (0, $635604cca324ad48$export$1b6b8b5328e38349)();




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6086fce0f58f9460$var$extendStatics = function(d, b) {
    $6086fce0f58f9460$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6086fce0f58f9460$var$extendStatics(d, b);
};
function $6086fce0f58f9460$export$a8ba968b8961cb8a(d, b) {
    $6086fce0f58f9460$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6086fce0f58f9460$export$18ce0697a983be9b = function() {
    $6086fce0f58f9460$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6086fce0f58f9460$export$18ce0697a983be9b.apply(this, arguments);
};
function $6086fce0f58f9460$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6086fce0f58f9460$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6086fce0f58f9460$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6086fce0f58f9460$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6086fce0f58f9460$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6086fce0f58f9460$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6086fce0f58f9460$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $6086fce0f58f9460$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $6086fce0f58f9460$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6086fce0f58f9460$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6086fce0f58f9460$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6086fce0f58f9460$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6086fce0f58f9460$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6086fce0f58f9460$export$10c90e4f7922046c(v) {
    return this instanceof $6086fce0f58f9460$export$10c90e4f7922046c ? (this.v = v, this) : new $6086fce0f58f9460$export$10c90e4f7922046c(v);
}
function $6086fce0f58f9460$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6086fce0f58f9460$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6086fce0f58f9460$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6086fce0f58f9460$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6086fce0f58f9460$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6086fce0f58f9460$export$19a8beecd37a4c45 === "function" ? $6086fce0f58f9460$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6086fce0f58f9460$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $6086fce0f58f9460$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $6086fce0f58f9460$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6086fce0f58f9460$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $6086fce0f58f9460$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};



var $9e1485fd03aaadab$export$dc00db384271fff6;
(function(AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})($9e1485fd03aaadab$export$dc00db384271fff6 || ($9e1485fd03aaadab$export$dc00db384271fff6 = {}));
var $9e1485fd03aaadab$export$8a7902a72d4cb6dd;
(function(CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$8a7902a72d4cb6dd || ($9e1485fd03aaadab$export$8a7902a72d4cb6dd = {}));
var $9e1485fd03aaadab$export$2d7512435854af72;
(function(CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$2d7512435854af72 || ($9e1485fd03aaadab$export$2d7512435854af72 = {}));
var $9e1485fd03aaadab$export$8d556ce24d00472;
(function(IdentityPool) {
    IdentityPool.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$8d556ce24d00472 || ($9e1485fd03aaadab$export$8d556ce24d00472 = {}));
var $9e1485fd03aaadab$export$8b0f706f4df56c63;
(function(InternalErrorException) {
    InternalErrorException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$8b0f706f4df56c63 || ($9e1485fd03aaadab$export$8b0f706f4df56c63 = {}));
var $9e1485fd03aaadab$export$fa781b52e13bf866;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$fa781b52e13bf866 || ($9e1485fd03aaadab$export$fa781b52e13bf866 = {}));
var $9e1485fd03aaadab$export$cd419aa7f32ec382;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$cd419aa7f32ec382 || ($9e1485fd03aaadab$export$cd419aa7f32ec382 = {}));
var $9e1485fd03aaadab$export$82cff5e5a0a874dd;
(function(NotAuthorizedException) {
    NotAuthorizedException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$82cff5e5a0a874dd || ($9e1485fd03aaadab$export$82cff5e5a0a874dd = {}));
var $9e1485fd03aaadab$export$cbdaf31887dd0603;
(function(ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$cbdaf31887dd0603 || ($9e1485fd03aaadab$export$cbdaf31887dd0603 = {}));
var $9e1485fd03aaadab$export$4a67805ad445f61;
(function(TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$4a67805ad445f61 || ($9e1485fd03aaadab$export$4a67805ad445f61 = {}));
var $9e1485fd03aaadab$export$6ce299b58e0ab8fe;
(function(DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$6ce299b58e0ab8fe || ($9e1485fd03aaadab$export$6ce299b58e0ab8fe = {}));
var $9e1485fd03aaadab$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})($9e1485fd03aaadab$export$d4e71bc0b80dc0fb || ($9e1485fd03aaadab$export$d4e71bc0b80dc0fb = {}));
var $9e1485fd03aaadab$export$7235a8ee19d2bee3;
(function(UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$7235a8ee19d2bee3 || ($9e1485fd03aaadab$export$7235a8ee19d2bee3 = {}));
var $9e1485fd03aaadab$export$2b5603236acc81d9;
(function(DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$2b5603236acc81d9 || ($9e1485fd03aaadab$export$2b5603236acc81d9 = {}));
var $9e1485fd03aaadab$export$cb6981b8f9a703c2;
(function(DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$cb6981b8f9a703c2 || ($9e1485fd03aaadab$export$cb6981b8f9a703c2 = {}));
var $9e1485fd03aaadab$export$ecba565262f8bb2;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$ecba565262f8bb2 || ($9e1485fd03aaadab$export$ecba565262f8bb2 = {}));
var $9e1485fd03aaadab$export$46587acc7855d6e2;
(function(DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$46587acc7855d6e2 || ($9e1485fd03aaadab$export$46587acc7855d6e2 = {}));
var $9e1485fd03aaadab$export$16e1ea20d4f13fa7;
(function(IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$16e1ea20d4f13fa7 || ($9e1485fd03aaadab$export$16e1ea20d4f13fa7 = {}));
var $9e1485fd03aaadab$export$4b5909fe2abc147d;
(function(DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$4b5909fe2abc147d || ($9e1485fd03aaadab$export$4b5909fe2abc147d = {}));
var $9e1485fd03aaadab$export$cb77a58cb7dbb17;
(function(ExternalServiceException) {
    ExternalServiceException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$cb77a58cb7dbb17 || ($9e1485fd03aaadab$export$cb77a58cb7dbb17 = {}));
var $9e1485fd03aaadab$export$bb51e43959182308;
(function(GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$bb51e43959182308 || ($9e1485fd03aaadab$export$bb51e43959182308 = {}));
var $9e1485fd03aaadab$export$a9627919734faa48;
(function(Credentials) {
    Credentials.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$a9627919734faa48 || ($9e1485fd03aaadab$export$a9627919734faa48 = {}));
var $9e1485fd03aaadab$export$ba56c4cb277a72f9;
(function(GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$ba56c4cb277a72f9 || ($9e1485fd03aaadab$export$ba56c4cb277a72f9 = {}));
var $9e1485fd03aaadab$export$90d12448d3766cda;
(function(InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$90d12448d3766cda || ($9e1485fd03aaadab$export$90d12448d3766cda = {}));
var $9e1485fd03aaadab$export$badc3094716a9faa;
(function(GetIdInput) {
    GetIdInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$badc3094716a9faa || ($9e1485fd03aaadab$export$badc3094716a9faa = {}));
var $9e1485fd03aaadab$export$c3ec238968a6e7ac;
(function(GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$c3ec238968a6e7ac || ($9e1485fd03aaadab$export$c3ec238968a6e7ac = {}));
var $9e1485fd03aaadab$export$f5f529c0b4e5eb30;
(function(GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$f5f529c0b4e5eb30 || ($9e1485fd03aaadab$export$f5f529c0b4e5eb30 = {}));
var $9e1485fd03aaadab$export$819b5ceb37e06be;
(function(MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})($9e1485fd03aaadab$export$819b5ceb37e06be || ($9e1485fd03aaadab$export$819b5ceb37e06be = {}));
var $9e1485fd03aaadab$export$3f8398961535c3a;
(function(MappingRule) {
    MappingRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$3f8398961535c3a || ($9e1485fd03aaadab$export$3f8398961535c3a = {}));
var $9e1485fd03aaadab$export$269dcf2519324984;
(function(RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$269dcf2519324984 || ($9e1485fd03aaadab$export$269dcf2519324984 = {}));
var $9e1485fd03aaadab$export$c726ef784882c23e;
(function(RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})($9e1485fd03aaadab$export$c726ef784882c23e || ($9e1485fd03aaadab$export$c726ef784882c23e = {}));
var $9e1485fd03aaadab$export$c8be61b857de8364;
(function(RoleMapping) {
    RoleMapping.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$c8be61b857de8364 || ($9e1485fd03aaadab$export$c8be61b857de8364 = {}));
var $9e1485fd03aaadab$export$69a6cbc1a215fcdf;
(function(GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$69a6cbc1a215fcdf || ($9e1485fd03aaadab$export$69a6cbc1a215fcdf = {}));
var $9e1485fd03aaadab$export$e31993063e9290fd;
(function(GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$e31993063e9290fd || ($9e1485fd03aaadab$export$e31993063e9290fd = {}));
var $9e1485fd03aaadab$export$c2cdb3ad9240cf7d;
(function(GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$c2cdb3ad9240cf7d || ($9e1485fd03aaadab$export$c2cdb3ad9240cf7d = {}));
var $9e1485fd03aaadab$export$f9e8c5d2069aeea4;
(function(DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$f9e8c5d2069aeea4 || ($9e1485fd03aaadab$export$f9e8c5d2069aeea4 = {}));
var $9e1485fd03aaadab$export$b30c26022c4ccb98;
(function(GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$b30c26022c4ccb98 || ($9e1485fd03aaadab$export$b30c26022c4ccb98 = {}));
var $9e1485fd03aaadab$export$39b050249a579e7b;
(function(GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$39b050249a579e7b || ($9e1485fd03aaadab$export$39b050249a579e7b = {}));
var $9e1485fd03aaadab$export$8c1e5f4b8dc33aa1;
(function(ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$8c1e5f4b8dc33aa1 || ($9e1485fd03aaadab$export$8c1e5f4b8dc33aa1 = {}));
var $9e1485fd03aaadab$export$5270c3e17502575a;
(function(ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$5270c3e17502575a || ($9e1485fd03aaadab$export$5270c3e17502575a = {}));
var $9e1485fd03aaadab$export$1d38161f8b62ad;
(function(ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$1d38161f8b62ad || ($9e1485fd03aaadab$export$1d38161f8b62ad = {}));
var $9e1485fd03aaadab$export$5a7a0c97755dcf8e;
(function(IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$5a7a0c97755dcf8e || ($9e1485fd03aaadab$export$5a7a0c97755dcf8e = {}));
var $9e1485fd03aaadab$export$f862a07a4a7c6250;
(function(ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$f862a07a4a7c6250 || ($9e1485fd03aaadab$export$f862a07a4a7c6250 = {}));
var $9e1485fd03aaadab$export$8eb1e3f42ea35fee;
(function(ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$8eb1e3f42ea35fee || ($9e1485fd03aaadab$export$8eb1e3f42ea35fee = {}));
var $9e1485fd03aaadab$export$6db0c8c0f26e7fec;
(function(ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$6db0c8c0f26e7fec || ($9e1485fd03aaadab$export$6db0c8c0f26e7fec = {}));
var $9e1485fd03aaadab$export$1624698866821668;
(function(LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$1624698866821668 || ($9e1485fd03aaadab$export$1624698866821668 = {}));
var $9e1485fd03aaadab$export$fb0cf3531245501b;
(function(LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$fb0cf3531245501b || ($9e1485fd03aaadab$export$fb0cf3531245501b = {}));
var $9e1485fd03aaadab$export$8f282934b0cfbc4a;
(function(MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$8f282934b0cfbc4a || ($9e1485fd03aaadab$export$8f282934b0cfbc4a = {}));
var $9e1485fd03aaadab$export$13aa23992eef667b;
(function(MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$13aa23992eef667b || ($9e1485fd03aaadab$export$13aa23992eef667b = {}));
var $9e1485fd03aaadab$export$21f15e80c2bbca09;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$21f15e80c2bbca09 || ($9e1485fd03aaadab$export$21f15e80c2bbca09 = {}));
var $9e1485fd03aaadab$export$20f43a93eb8d3b02;
(function(SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$20f43a93eb8d3b02 || ($9e1485fd03aaadab$export$20f43a93eb8d3b02 = {}));
var $9e1485fd03aaadab$export$a5e7dff780e8dcb0;
(function(TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$a5e7dff780e8dcb0 || ($9e1485fd03aaadab$export$a5e7dff780e8dcb0 = {}));
var $9e1485fd03aaadab$export$2d5279802486e8b0;
(function(TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$2d5279802486e8b0 || ($9e1485fd03aaadab$export$2d5279802486e8b0 = {}));
var $9e1485fd03aaadab$export$b977eb1c8f754bfa;
(function(UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$b977eb1c8f754bfa || ($9e1485fd03aaadab$export$b977eb1c8f754bfa = {}));
var $9e1485fd03aaadab$export$2415026a66f5e70b;
(function(UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$2415026a66f5e70b || ($9e1485fd03aaadab$export$2415026a66f5e70b = {}));
var $9e1485fd03aaadab$export$4dbbd8ede80c9c36;
(function(UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$4dbbd8ede80c9c36 || ($9e1485fd03aaadab$export$4dbbd8ede80c9c36 = {}));
var $9e1485fd03aaadab$export$2128f49a7cd2e47f;
(function(UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($9e1485fd03aaadab$export$2128f49a7cd2e47f || ($9e1485fd03aaadab$export$2128f49a7cd2e47f = {}));



var $8e579238f5eb4a6f$export$1d94dfe0d9d1f1e7 = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3651214a896eb763$var$extendStatics = function(d, b) {
    $3651214a896eb763$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3651214a896eb763$var$extendStatics(d, b);
};
function $3651214a896eb763$export$a8ba968b8961cb8a(d, b) {
    $3651214a896eb763$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3651214a896eb763$export$18ce0697a983be9b = function() {
    $3651214a896eb763$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3651214a896eb763$export$18ce0697a983be9b.apply(this, arguments);
};
function $3651214a896eb763$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3651214a896eb763$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3651214a896eb763$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3651214a896eb763$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3651214a896eb763$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3651214a896eb763$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $3651214a896eb763$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $3651214a896eb763$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $3651214a896eb763$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3651214a896eb763$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3651214a896eb763$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3651214a896eb763$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3651214a896eb763$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3651214a896eb763$export$10c90e4f7922046c(v) {
    return this instanceof $3651214a896eb763$export$10c90e4f7922046c ? (this.v = v, this) : new $3651214a896eb763$export$10c90e4f7922046c(v);
}
function $3651214a896eb763$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3651214a896eb763$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3651214a896eb763$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3651214a896eb763$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3651214a896eb763$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3651214a896eb763$export$19a8beecd37a4c45 === "function" ? $3651214a896eb763$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3651214a896eb763$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $3651214a896eb763$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $3651214a896eb763$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3651214a896eb763$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $3651214a896eb763$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $2368114ecf8ea544$export$7587955500404ec3 = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, $3651214a896eb763$export$18ce0697a983be9b)((0, $3651214a896eb763$export$18ce0697a983be9b)({}, this), {
            headers: (0, $3651214a896eb763$export$18ce0697a983be9b)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $2368114ecf8ea544$var$cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function $2368114ecf8ea544$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $3651214a896eb763$export$18ce0697a983be9b)((0, $3651214a896eb763$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $3651214a896eb763$export$afc72e2116322959)(param) : param, _a));
    }, {});
}




function $361944e32d9342a8$export$e024c793399bdd01(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}




var $70fcbdc71fa0eb4a$export$44d8caf684388429 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.CreateIdentityPool"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1CreateIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$2f9133f6d812a2b4 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentities"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1DeleteIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$900e66311faca63a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentityPool"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1DeleteIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$f0f695bb22170112 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentity"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1DescribeIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$24669e6016ff61f7 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentityPool"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1DescribeIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$88af91ae17f8527c = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1GetCredentialsForIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$83083ba13837129b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetId"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1GetIdInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$291166950901964 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetIdentityPoolRoles"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1GetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$32ecbc22cb6e2bd8 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdToken"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1GetOpenIdTokenInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$ace1f9f6edceb0aa = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdTokenForDeveloperIdentity"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$dcc2b10f333c963c = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentities"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1ListIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$dfc0836148ba7f7b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentityPools"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1ListIdentityPoolsInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$aea8c8426f72de9a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListTagsForResource"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1ListTagsForResourceInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$3ddf979554ffe001 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.LookupDeveloperIdentity"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1LookupDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$5d3f7522269fe239 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.MergeDeveloperIdentities"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1MergeDeveloperIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$50298d3eb327ab40 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.SetIdentityPoolRoles"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1SetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$be03555111349623 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.TagResource"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1TagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$43e326e2b54f124a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkDeveloperIdentity"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1UnlinkDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$4ee03f1a7a9d5800 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkIdentity"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1UnlinkIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$3f5f89d1d8515037 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UntagResource"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1UntagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$7a962066e209647 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UpdateIdentityPool"
            };
            body = JSON.stringify($70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPool(input, context));
            return [
                2 /*return*/ ,
                $70fcbdc71fa0eb4a$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$export$2065e670c73ee068 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1CreateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1CreateIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$a14663734e0f26e7 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeleteIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeleteIdentitiesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeleteIdentitiesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$77baf36526f7cd7e = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeleteIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeleteIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$1863cd4cff27fb2f = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DescribeIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityDescription(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DescribeIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$1457f79b69c648d1 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DescribeIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DescribeIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$ebea9103431f9a50 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetCredentialsForIdentityResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$9f5769abdc93f0b4 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$731e618e28a38bab = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdentityPoolRolesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$ccfef68aa75a7c47 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$c7916ef0d543f5e3 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$a2439911ac8089ba = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentitiesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentitiesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$36b32c966a7eefbd = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentityPoolsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentityPoolsResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentityPoolsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$efb57976dadbc12b = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListTagsForResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListTagsForResourceResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListTagsForResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$6476ab94d95217ab = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LookupDeveloperIdentityResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$73edba62ad60e9b9 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$4d01436d85148f27 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$2bbf6fe70d6779a6 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TagResourceResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TagResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$d8ee329529310a85 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$b3b4038b9cc6cf0c = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnlinkIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnlinkIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$4e56caf614610ee8 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UntagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UntagResourceResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UntagResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$export$e9cc2af0cb85eeaa = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UpdateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UpdateIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "DeveloperUserAlreadyRegisteredException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ExternalServiceExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ExternalServiceException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "ExternalServiceException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "InternalErrorException",
                $fault: "server",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "InvalidIdentityPoolConfigurationException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "NotAuthorizedException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "ResourceConflictException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsException(body, context);
            contents = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                name: "TooManyRequestsException",
                $fault: "client",
                $metadata: $70fcbdc71fa0eb4a$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1CognitoIdentityProvider = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ClientId !== undefined && input.ClientId !== null && {
        ClientId: input.ClientId
    }), input.ProviderName !== undefined && input.ProviderName !== null && {
        ProviderName: input.ProviderName
    }), input.ServerSideTokenCheck !== undefined && input.ServerSideTokenCheck !== null && {
        ServerSideTokenCheck: input.ServerSideTokenCheck
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1CognitoIdentityProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $70fcbdc71fa0eb4a$var$serializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1CreateIdentityPoolInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $70fcbdc71fa0eb4a$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $70fcbdc71fa0eb4a$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $70fcbdc71fa0eb4a$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1DeleteIdentitiesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityIdsToDelete !== undefined && input.IdentityIdsToDelete !== null && {
        IdentityIdsToDelete: $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityIdList(input.IdentityIdsToDelete, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1DeleteIdentityPoolInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1DescribeIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1DescribeIdentityPoolInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1GetCredentialsForIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.CustomRoleArn !== undefined && input.CustomRoleArn !== null && {
        CustomRoleArn: input.CustomRoleArn
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1GetIdentityPoolRolesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1GetIdInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AccountId !== undefined && input.AccountId !== null && {
        AccountId: input.AccountId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.TokenDuration !== undefined && input.TokenDuration !== null && {
        TokenDuration: input.TokenDuration
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1GetOpenIdTokenInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPool = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $70fcbdc71fa0eb4a$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $70fcbdc71fa0eb4a$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $70fcbdc71fa0eb4a$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPoolTagsListType = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPoolTagsType = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityProviders = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1ListIdentitiesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.HideDisabled !== undefined && input.HideDisabled !== null && {
        HideDisabled: input.HideDisabled
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1ListIdentityPoolsInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1ListTagsForResourceInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1LookupDeveloperIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1MappingRule = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.Claim !== undefined && input.Claim !== null && {
        Claim: input.Claim
    }), input.MatchType !== undefined && input.MatchType !== null && {
        MatchType: input.MatchType
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.Value !== undefined && input.Value !== null && {
        Value: input.Value
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1MappingRulesList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $70fcbdc71fa0eb4a$var$serializeAws_json1_1MappingRule(entry, context);
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1MergeDeveloperIdentitiesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.DestinationUserIdentifier !== undefined && input.DestinationUserIdentifier !== null && {
        DestinationUserIdentifier: input.DestinationUserIdentifier
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.SourceUserIdentifier !== undefined && input.SourceUserIdentifier !== null && {
        SourceUserIdentifier: input.SourceUserIdentifier
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1OIDCProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1RoleMapping = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AmbiguousRoleResolution !== undefined && input.AmbiguousRoleResolution !== null && {
        AmbiguousRoleResolution: input.AmbiguousRoleResolution
    }), input.RulesConfiguration !== undefined && input.RulesConfiguration !== null && {
        RulesConfiguration: $70fcbdc71fa0eb4a$var$serializeAws_json1_1RulesConfigurationType(input.RulesConfiguration, context)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1RoleMappingMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $70fcbdc71fa0eb4a$var$serializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1RolesMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1RulesConfigurationType = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.Rules !== undefined && input.Rules !== null && {
        Rules: $70fcbdc71fa0eb4a$var$serializeAws_json1_1MappingRulesList(input.Rules, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1SAMLProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1SetIdentityPoolRolesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.RoleMappings !== undefined && input.RoleMappings !== null && {
        RoleMappings: $70fcbdc71fa0eb4a$var$serializeAws_json1_1RoleMappingMap(input.RoleMappings, context)
    }), input.Roles !== undefined && input.Roles !== null && {
        Roles: $70fcbdc71fa0eb4a$var$serializeAws_json1_1RolesMap(input.Roles, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1TagResourceInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPoolTagsType(input.Tags, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1UnlinkDeveloperIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1UnlinkIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.LoginsToRemove !== undefined && input.LoginsToRemove !== null && {
        LoginsToRemove: $70fcbdc71fa0eb4a$var$serializeAws_json1_1LoginsList(input.LoginsToRemove, context)
    });
};
var $70fcbdc71fa0eb4a$var$serializeAws_json1_1UntagResourceInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: $70fcbdc71fa0eb4a$var$serializeAws_json1_1IdentityPoolTagsListType(input.TagKeys, context)
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1CognitoIdentityProvider = function(output, context) {
    return {
        ClientId: output.ClientId !== undefined && output.ClientId !== null ? output.ClientId : undefined,
        ProviderName: output.ProviderName !== undefined && output.ProviderName !== null ? output.ProviderName : undefined,
        ServerSideTokenCheck: output.ServerSideTokenCheck !== undefined && output.ServerSideTokenCheck !== null ? output.ServerSideTokenCheck : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1CognitoIdentityProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $70fcbdc71fa0eb4a$var$deserializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1Credentials = function(output, context) {
    return {
        AccessKeyId: output.AccessKeyId !== undefined && output.AccessKeyId !== null ? output.AccessKeyId : undefined,
        Expiration: output.Expiration !== undefined && output.Expiration !== null ? new Date(Math.round(output.Expiration * 1000)) : undefined,
        SecretKey: output.SecretKey !== undefined && output.SecretKey !== null ? output.SecretKey : undefined,
        SessionToken: output.SessionToken !== undefined && output.SessionToken !== null ? output.SessionToken : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeleteIdentitiesResponse = function(output, context) {
    return {
        UnprocessedIdentityIds: output.UnprocessedIdentityIds !== undefined && output.UnprocessedIdentityIds !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnprocessedIdentityIdList(output.UnprocessedIdentityIds, context) : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeveloperUserIdentifierList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ExternalServiceException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetCredentialsForIdentityResponse = function(output, context) {
    return {
        Credentials: output.Credentials !== undefined && output.Credentials !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1Credentials(output.Credentials, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdentityPoolRolesResponse = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        RoleMappings: output.RoleMappings !== undefined && output.RoleMappings !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RoleMappingMap(output.RoleMappings, context) : undefined,
        Roles: output.Roles !== undefined && output.Roles !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RolesMap(output.Roles, context) : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetIdResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1GetOpenIdTokenResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentitiesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityDescription(entry, context);
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityDescription = function(output, context) {
    return {
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null ? new Date(Math.round(output.CreationDate * 1000)) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null ? new Date(Math.round(output.LastModifiedDate * 1000)) : undefined,
        Logins: output.Logins !== undefined && output.Logins !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LoginsList(output.Logins, context) : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPool = function(output, context) {
    return {
        AllowClassicFlow: output.AllowClassicFlow !== undefined && output.AllowClassicFlow !== null ? output.AllowClassicFlow : undefined,
        AllowUnauthenticatedIdentities: output.AllowUnauthenticatedIdentities !== undefined && output.AllowUnauthenticatedIdentities !== null ? output.AllowUnauthenticatedIdentities : undefined,
        CognitoIdentityProviders: output.CognitoIdentityProviders !== undefined && output.CognitoIdentityProviders !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1CognitoIdentityProviderList(output.CognitoIdentityProviders, context) : undefined,
        DeveloperProviderName: output.DeveloperProviderName !== undefined && output.DeveloperProviderName !== null ? output.DeveloperProviderName : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined,
        IdentityPoolTags: output.IdentityPoolTags !== undefined && output.IdentityPoolTags !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPoolTagsType(output.IdentityPoolTags, context) : undefined,
        OpenIdConnectProviderARNs: output.OpenIdConnectProviderARNs !== undefined && output.OpenIdConnectProviderARNs !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1OIDCProviderList(output.OpenIdConnectProviderARNs, context) : undefined,
        SamlProviderARNs: output.SamlProviderARNs !== undefined && output.SamlProviderARNs !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1SAMLProviderList(output.SamlProviderARNs, context) : undefined,
        SupportedLoginProviders: output.SupportedLoginProviders !== undefined && output.SupportedLoginProviders !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityProviders(output.SupportedLoginProviders, context) : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPoolShortDescription = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPoolsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPoolShortDescription(entry, context);
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPoolTagsType = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityProviders = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InternalErrorException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentitiesResponse = function(output, context) {
    return {
        Identities: output.Identities !== undefined && output.Identities !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentitiesList(output.Identities, context) : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListIdentityPoolsResponse = function(output, context) {
    return {
        IdentityPools: output.IdentityPools !== undefined && output.IdentityPools !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPoolsList(output.IdentityPools, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ListTagsForResourceResponse = function(output, context) {
    return {
        Tags: output.Tags !== undefined && output.Tags !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1IdentityPoolTagsType(output.Tags, context) : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LoginsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1LookupDeveloperIdentityResponse = function(output, context) {
    return {
        DeveloperUserIdentifierList: output.DeveloperUserIdentifierList !== undefined && output.DeveloperUserIdentifierList !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1DeveloperUserIdentifierList(output.DeveloperUserIdentifierList, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MappingRule = function(output, context) {
    return {
        Claim: output.Claim !== undefined && output.Claim !== null ? output.Claim : undefined,
        MatchType: output.MatchType !== undefined && output.MatchType !== null ? output.MatchType : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MappingRulesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MappingRule(entry, context);
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1NotAuthorizedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1OIDCProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceConflictException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RoleMapping = function(output, context) {
    return {
        AmbiguousRoleResolution: output.AmbiguousRoleResolution !== undefined && output.AmbiguousRoleResolution !== null ? output.AmbiguousRoleResolution : undefined,
        RulesConfiguration: output.RulesConfiguration !== undefined && output.RulesConfiguration !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RulesConfigurationType(output.RulesConfiguration, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RoleMappingMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RolesMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1RulesConfigurationType = function(output, context) {
    return {
        Rules: output.Rules !== undefined && output.Rules !== null ? $70fcbdc71fa0eb4a$var$deserializeAws_json1_1MappingRulesList(output.Rules, context) : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1SAMLProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TagResourceResponse = function(output, context) {
    return {};
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1TooManyRequestsException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnprocessedIdentityId = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnprocessedIdentityIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UnprocessedIdentityId(entry, context);
    });
};
var $70fcbdc71fa0eb4a$var$deserializeAws_json1_1UntagResourceResponse = function(output, context) {
    return {};
};
var $70fcbdc71fa0eb4a$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $70fcbdc71fa0eb4a$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $70fcbdc71fa0eb4a$var$collectBodyString = function(streamBody, context) {
    return $70fcbdc71fa0eb4a$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $70fcbdc71fa0eb4a$var$buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)(contents)
                    ];
            }
        });
    });
};
var $70fcbdc71fa0eb4a$var$parseBody = function(streamBody, context) {
    return $70fcbdc71fa0eb4a$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var $70fcbdc71fa0eb4a$var$loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c6773eee53ec04b7$var$extendStatics = function(d, b) {
    $c6773eee53ec04b7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c6773eee53ec04b7$var$extendStatics(d, b);
};
function $c6773eee53ec04b7$export$a8ba968b8961cb8a(d, b) {
    $c6773eee53ec04b7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c6773eee53ec04b7$export$18ce0697a983be9b = function() {
    $c6773eee53ec04b7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6773eee53ec04b7$export$18ce0697a983be9b.apply(this, arguments);
};
function $c6773eee53ec04b7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c6773eee53ec04b7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c6773eee53ec04b7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c6773eee53ec04b7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c6773eee53ec04b7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c6773eee53ec04b7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c6773eee53ec04b7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c6773eee53ec04b7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c6773eee53ec04b7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c6773eee53ec04b7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c6773eee53ec04b7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c6773eee53ec04b7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c6773eee53ec04b7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c6773eee53ec04b7$export$10c90e4f7922046c(v) {
    return this instanceof $c6773eee53ec04b7$export$10c90e4f7922046c ? (this.v = v, this) : new $c6773eee53ec04b7$export$10c90e4f7922046c(v);
}
function $c6773eee53ec04b7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c6773eee53ec04b7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c6773eee53ec04b7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c6773eee53ec04b7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c6773eee53ec04b7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c6773eee53ec04b7$export$19a8beecd37a4c45 === "function" ? $c6773eee53ec04b7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c6773eee53ec04b7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c6773eee53ec04b7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c6773eee53ec04b7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c6773eee53ec04b7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c6773eee53ec04b7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $493f994f533b9cdf$export$d10196e291075f95 = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, $c6773eee53ec04b7$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var response, parsed;
                return (0, $c6773eee53ec04b7$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};



var $ebd7c6f1cecc2a98$export$125a23d36094c5de = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, $c6773eee53ec04b7$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request;
                return (0, $c6773eee53ec04b7$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2 /*return*/ ,
                                next((0, $c6773eee53ec04b7$export$18ce0697a983be9b)((0, $c6773eee53ec04b7$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};




var $7380dd9cf39fedd9$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var $7380dd9cf39fedd9$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $7380dd9cf39fedd9$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, $493f994f533b9cdf$export$d10196e291075f95)(config, deserializer), $7380dd9cf39fedd9$export$f5d82b333b4f39c9);
            commandStack.add((0, $ebd7c6f1cecc2a98$export$125a23d36094c5de)(config, serializer), $7380dd9cf39fedd9$export$1bd449976e9c484d);
        }
    };
}




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $deb2ec7499635e8f$var$extendStatics = function(d, b) {
    $deb2ec7499635e8f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $deb2ec7499635e8f$var$extendStatics(d, b);
};
function $deb2ec7499635e8f$export$a8ba968b8961cb8a(d, b) {
    $deb2ec7499635e8f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $deb2ec7499635e8f$export$18ce0697a983be9b = function() {
    $deb2ec7499635e8f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $deb2ec7499635e8f$export$18ce0697a983be9b.apply(this, arguments);
};
function $deb2ec7499635e8f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $deb2ec7499635e8f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $deb2ec7499635e8f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $deb2ec7499635e8f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $deb2ec7499635e8f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $deb2ec7499635e8f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $deb2ec7499635e8f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $deb2ec7499635e8f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $deb2ec7499635e8f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $deb2ec7499635e8f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $deb2ec7499635e8f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($deb2ec7499635e8f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $deb2ec7499635e8f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $deb2ec7499635e8f$export$10c90e4f7922046c(v) {
    return this instanceof $deb2ec7499635e8f$export$10c90e4f7922046c ? (this.v = v, this) : new $deb2ec7499635e8f$export$10c90e4f7922046c(v);
}
function $deb2ec7499635e8f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $deb2ec7499635e8f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $deb2ec7499635e8f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $deb2ec7499635e8f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $deb2ec7499635e8f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $deb2ec7499635e8f$export$19a8beecd37a4c45 === "function" ? $deb2ec7499635e8f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $deb2ec7499635e8f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $deb2ec7499635e8f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $deb2ec7499635e8f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $deb2ec7499635e8f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $deb2ec7499635e8f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $e710bfee10cda5cc$export$73604a93307363d8 = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return $e710bfee10cda5cc$var$stepWeights[b.step] - $e710bfee10cda5cc$var$stepWeights[a.step] || $e710bfee10cda5cc$var$priorityWeights[b.priority || "normal"] - $e710bfee10cda5cc$var$priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, $deb2ec7499635e8f$export$18ce0697a983be9b)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, $deb2ec7499635e8f$export$18ce0697a983be9b)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $deb2ec7499635e8f$export$afc72e2116322959)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $deb2ec7499635e8f$export$afc72e2116322959)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, $deb2ec7499635e8f$export$18ce0697a983be9b)((0, $deb2ec7499635e8f$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, $deb2ec7499635e8f$export$18ce0697a983be9b)((0, $deb2ec7499635e8f$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, $deb2ec7499635e8f$export$afc72e2116322959)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, $deb2ec7499635e8f$export$18ce0697a983be9b)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"' + name + '" middleware with ' + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, $deb2ec7499635e8f$export$18ce0697a983be9b)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"' + name + '" middleware ' + toOverride.relation + ' "' + toOverride.toMiddleware + '" middleware cannot be overridden ' + ("by same-name middleware " + entry.relation + ' "' + entry.toMiddleware + '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo($e710bfee10cda5cc$export$73604a93307363d8());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo($e710bfee10cda5cc$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, $deb2ec7499635e8f$export$19a8beecd37a4c45)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var $e710bfee10cda5cc$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var $e710bfee10cda5cc$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




var $e3a8e149f1290509$export$1f2bb630327ac4b6 = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, $e710bfee10cda5cc$export$73604a93307363d8)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();



var $0287324a59c7b0be$export$cc7e12c76513e857 = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, $e710bfee10cda5cc$export$73604a93307363d8)();
    }
    return Command;
}();






/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ function $5bb55e60897073a2$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}


/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var $3cac61d5afd59793$export$52272e038712c64e = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};


/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var $23fbce306a7ffebd$export$113d90026b452881 = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $23fbce306a7ffebd$export$113d90026b452881(obj[key]);
    }
    return obj;
};


/**
 * Lazy String holder for JSON typed contents.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $8709215f64be2875$var$extendStatics = function(d, b) {
    $8709215f64be2875$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $8709215f64be2875$var$extendStatics(d, b);
};
function $8709215f64be2875$export$a8ba968b8961cb8a(d, b) {
    $8709215f64be2875$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8709215f64be2875$export$18ce0697a983be9b = function() {
    $8709215f64be2875$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8709215f64be2875$export$18ce0697a983be9b.apply(this, arguments);
};
function $8709215f64be2875$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8709215f64be2875$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8709215f64be2875$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8709215f64be2875$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8709215f64be2875$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8709215f64be2875$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $8709215f64be2875$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $8709215f64be2875$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $8709215f64be2875$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8709215f64be2875$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8709215f64be2875$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8709215f64be2875$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8709215f64be2875$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8709215f64be2875$export$10c90e4f7922046c(v) {
    return this instanceof $8709215f64be2875$export$10c90e4f7922046c ? (this.v = v, this) : new $8709215f64be2875$export$10c90e4f7922046c(v);
}
function $8709215f64be2875$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8709215f64be2875$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8709215f64be2875$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8709215f64be2875$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $8709215f64be2875$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8709215f64be2875$export$19a8beecd37a4c45 === "function" ? $8709215f64be2875$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8709215f64be2875$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $8709215f64be2875$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $8709215f64be2875$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8709215f64be2875$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $8709215f64be2875$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $bd1ee347ddc0f38f$export$40e2db4f1ce24b10 = function() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, $8709215f64be2875$export$afc72e2116322959)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$bd1ee347ddc0f38f$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $bd1ee347ddc0f38f$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($bd1ee347ddc0f38f$export$40e2db4f1ce24b10, String);
var $bd1ee347ddc0f38f$export$494ed5148690ecaf = /** @class */ function(_super) {
    (0, $8709215f64be2875$export$a8ba968b8961cb8a)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}($bd1ee347ddc0f38f$export$40e2db4f1ce24b10);


/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var $43662a98672ca59d$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var $43662a98672ca59d$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $43662a98672ca59d$export$5b50865171ed23a9(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return $43662a98672ca59d$var$days[dayOfWeek] + ", " + dayOfMonthString + " " + $43662a98672ca59d$var$months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}


/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ function $8e200a98c6abdf8a$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}


var $a2e835843b722421$export$17127055dc9ac067 = "***SensitiveInformation***";








/**
 * <p>Returns credentials for the provided identity ID. Any provided logins will be
 *          validated against supported login providers. If the token is for
 *          cognito-identity.amazonaws.com, it will be passed through to AWS Security Token Service
 *          with the appropriate role for the token.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */ var $9fc70c4868f3b336$export$e08b3308c36761ec = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GetCredentialsForIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCredentialsForIdentityCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetCredentialsForIdentityCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetCredentialsForIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $9e1485fd03aaadab$export$bb51e43959182308).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $9e1485fd03aaadab$export$ba56c4cb277a72f9).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCredentialsForIdentityCommand.prototype.serialize = function(input, context) {
        return (0, $70fcbdc71fa0eb4a$export$88af91ae17f8527c)(input, context);
    };
    GetCredentialsForIdentityCommand.prototype.deserialize = function(output, context) {
        return (0, $70fcbdc71fa0eb4a$export$ebea9103431f9a50)(output, context);
    };
    return GetCredentialsForIdentityCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));




/**
 * An error representing a failure of an individual credential provider.
 *
 * This error class has special meaning to the {@link chain} method. If a
 * provider in the chain is rejected with an error, the chain will only proceed
 * to the next provider if the value of the `tryNextLink` property on the error
 * is truthy. This allows individual providers to halt the chain and also
 * ensures the chain will stop if an entirely unexpected error is encountered.
 */ var $b38a8fef12682553$export$478ec1fdae99aa79 = /** @class */ function(_super) {
    (0, $6086fce0f58f9460$export$a8ba968b8961cb8a)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    return ProviderError;
}(Error);


function $a416a166fc406041$export$e08e3b67e392101e() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, $b38a8fef12682553$export$478ec1fdae99aa79)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, $6086fce0f58f9460$export$19a8beecd37a4c45)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}


var $f96a46b84990606f$export$294ab423a8f4a426 = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};



var $1a43eafde76a26e1$export$fc10aeed3a532e2a = function(provider, isExpired, requiresRefresh) {
    var result;
    var hasResult;
    if (isExpired === undefined) // This is a static memoization; no need to incorporate refreshing
    return function() {
        if (!hasResult) {
            result = provider();
            hasResult = true;
        }
        return result;
    };
    var isConstant = false;
    return function() {
        return (0, $6086fce0f58f9460$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            var resolved;
            return (0, $6086fce0f58f9460$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!hasResult) {
                            result = provider();
                            hasResult = true;
                        }
                        if (isConstant) return [
                            2 /*return*/ ,
                            result
                        ];
                        return [
                            4 /*yield*/ ,
                            result
                        ];
                    case 1:
                        resolved = _a.sent();
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2 /*return*/ ,
                                resolved
                            ];
                        }
                        if (isExpired(resolved)) return [
                            2 /*return*/ ,
                            result = provider()
                        ];
                        return [
                            2 /*return*/ ,
                            resolved
                        ];
                }
            });
        });
    };
};






function $f1f9357f51026062$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce(function(arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then(function(token) {
            return [
                name,
                token
            ];
        }));
        return arr;
    }, [])).then(function(resolvedPairs) {
        return resolvedPairs.reduce(function(logins, _a) {
            var _b = (0, $6086fce0f58f9460$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}


function $ffed8061a5c2b81f$export$4d624d71eb462130(parameters) {
    var _this = this;
    return function() {
        return (0, $6086fce0f58f9460$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var _a, _b, _c, AccessKeyId, Expiration, _d, SecretKey, SessionToken, _e, _f, _g, _h;
            var _j;
            return (0, $6086fce0f58f9460$export$67ebef60e6f28a6)(this, function(_k) {
                switch(_k.label){
                    case 0:
                        _f = (_e = parameters.client).send;
                        _g = (0, $9fc70c4868f3b336$export$e08b3308c36761ec).bind;
                        _j = {
                            CustomRoleArn: parameters.customRoleArn,
                            IdentityId: parameters.identityId
                        };
                        if (!parameters.logins) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $f1f9357f51026062$export$fb1e896f6704b6a6)(parameters.logins)
                        ];
                    case 1:
                        _h = _k.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _h = undefined;
                        _k.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            _f.apply(_e, [
                                new (_g.apply((0, $9fc70c4868f3b336$export$e08b3308c36761ec), [
                                    void 0,
                                    (_j.Logins = _h, _j)
                                ]))()
                            ])
                        ];
                    case 4:
                        _a = _k.sent().Credentials, _b = _a === void 0 ? $ffed8061a5c2b81f$var$throwOnMissingCredentials() : _a, _c = _b.AccessKeyId, AccessKeyId = _c === void 0 ? $ffed8061a5c2b81f$var$throwOnMissingAccessKeyId() : _c, Expiration = _b.Expiration, _d = _b.SecretKey, SecretKey = _d === void 0 ? $ffed8061a5c2b81f$var$throwOnMissingSecretKey() : _d, SessionToken = _b.SessionToken;
                        return [
                            2 /*return*/ ,
                            {
                                identityId: parameters.identityId,
                                accessKeyId: AccessKeyId,
                                secretAccessKey: SecretKey,
                                sessionToken: SessionToken,
                                expiration: Expiration
                            }
                        ];
                }
            });
        });
    };
}
function $ffed8061a5c2b81f$var$throwOnMissingAccessKeyId() {
    throw new (0, $b38a8fef12682553$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no access key ID");
}
function $ffed8061a5c2b81f$var$throwOnMissingCredentials() {
    throw new (0, $b38a8fef12682553$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no credentials");
}
function $ffed8061a5c2b81f$var$throwOnMissingSecretKey() {
    throw new (0, $b38a8fef12682553$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no secret key");
}







/**
 * <p>Generates (or retrieves) a Cognito ID. Supplying multiple logins will create an
 *          implicit linked account.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */ var $cfc9333b49fd25a9$export$41ceb4ced4f97a44 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GetIdCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetIdCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetIdCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $9e1485fd03aaadab$export$badc3094716a9faa).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $9e1485fd03aaadab$export$c3ec238968a6e7ac).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdCommand.prototype.serialize = function(input, context) {
        return (0, $70fcbdc71fa0eb4a$export$83083ba13837129b)(input, context);
    };
    GetIdCommand.prototype.deserialize = function(output, context) {
        return (0, $70fcbdc71fa0eb4a$export$9f5769abdc93f0b4)(output, context);
    };
    return GetIdCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));




var $4706f6943c134f6f$var$STORE_NAME = "IdentityIds";
var $4706f6943c134f6f$export$55d38e5384f402 = /** @class */ function() {
    function IndexedDbStorage(dbName) {
        if (dbName === void 0) dbName = "aws:cognito-identity-ids";
        this.dbName = dbName;
    }
    IndexedDbStorage.prototype.getItem = function(key) {
        return this.withObjectStore("readonly", function(store) {
            var req = store.get(key);
            return new Promise(function(resolve) {
                req.onerror = function() {
                    return resolve(null);
                };
                req.onsuccess = function() {
                    return resolve(req.result ? req.result.value : null);
                };
            });
        }).catch(function() {
            return null;
        });
    };
    IndexedDbStorage.prototype.removeItem = function(key) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.delete(key);
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.setItem = function(id, value) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.put({
                id: id,
                value: value
            });
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.getDb = function() {
        var openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise(function(resolve, reject) {
            openDbRequest.onsuccess = function() {
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = function() {
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = function() {
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = function() {
                var db = openDbRequest.result;
                db.onerror = function() {
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($4706f6943c134f6f$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    };
    IndexedDbStorage.prototype.withObjectStore = function(mode, action) {
        return this.getDb().then(function(db) {
            var tx = db.transaction($4706f6943c134f6f$var$STORE_NAME, mode);
            tx.oncomplete = function() {
                return db.close();
            };
            return new Promise(function(resolve, reject) {
                tx.onerror = function() {
                    return reject(tx.error);
                };
                resolve(action(tx.objectStore($4706f6943c134f6f$var$STORE_NAME)));
            }).catch(function(err) {
                db.close();
                throw err;
            });
        });
    };
    return IndexedDbStorage;
}();


var $8487065b0657a809$export$e4315e25b840a0ea = /** @class */ function() {
    function InMemoryStorage(store) {
        if (store === void 0) store = {};
        this.store = store;
    }
    InMemoryStorage.prototype.getItem = function(key) {
        if (key in this.store) return this.store[key];
        return null;
    };
    InMemoryStorage.prototype.removeItem = function(key) {
        delete this.store[key];
    };
    InMemoryStorage.prototype.setItem = function(key, value) {
        this.store[key] = value;
    };
    return InMemoryStorage;
}();


var $cee2ab60b4e2854a$var$inMemoryStorage = new (0, $8487065b0657a809$export$e4315e25b840a0ea)();
function $cee2ab60b4e2854a$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $4706f6943c134f6f$export$55d38e5384f402)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $cee2ab60b4e2854a$var$inMemoryStorage;
}



function $416e6c5617707f9e$export$6c7d622e9507a2e(_a) {
    var _this = this;
    var accountId = _a.accountId, _b = _a.cache, cache = _b === void 0 ? (0, $cee2ab60b4e2854a$export$c2ed3351cac403d1)() : _b, client = _a.client, customRoleArn = _a.customRoleArn, identityPoolId = _a.identityPoolId, logins = _a.logins, _c = _a.userIdentifier, userIdentifier = _c === void 0 ? !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined : _c;
    var cacheKey = userIdentifier ? "aws:cognito-identity-credentials:" + identityPoolId + ":" + userIdentifier : undefined;
    var provider = function() {
        return (0, $6086fce0f58f9460$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var identityId, _a, _b, IdentityId, _c, _d, _e, _f;
            var _g;
            return (0, $6086fce0f58f9460$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        _a = cacheKey;
                        if (!_a) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            cache.getItem(cacheKey)
                        ];
                    case 1:
                        _a = _h.sent();
                        _h.label = 2;
                    case 2:
                        identityId = _a;
                        if (!!identityId) return [
                            3 /*break*/ ,
                            7
                        ];
                        _d = (_c = client).send;
                        _e = (0, $cfc9333b49fd25a9$export$41ceb4ced4f97a44).bind;
                        _g = {
                            AccountId: accountId,
                            IdentityPoolId: identityPoolId
                        };
                        if (!logins) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $f1f9357f51026062$export$fb1e896f6704b6a6)(logins)
                        ];
                    case 3:
                        _f = _h.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _f = undefined;
                        _h.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _d.apply(_c, [
                                new (_e.apply((0, $cfc9333b49fd25a9$export$41ceb4ced4f97a44), [
                                    void 0,
                                    (_g.Logins = _f, _g)
                                ]))()
                            ])
                        ];
                    case 6:
                        _b = _h.sent().IdentityId, IdentityId = _b === void 0 ? $416e6c5617707f9e$var$throwOnMissingId() : _b;
                        identityId = IdentityId;
                        if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(function() {});
                        _h.label = 7;
                    case 7:
                        provider = (0, $ffed8061a5c2b81f$export$4d624d71eb462130)({
                            client: client,
                            customRoleArn: customRoleArn,
                            logins: logins,
                            identityId: identityId
                        });
                        return [
                            2 /*return*/ ,
                            provider()
                        ];
                }
            });
        });
    };
    return function() {
        return provider().catch(function(err) {
            return (0, $6086fce0f58f9460$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                return (0, $6086fce0f58f9460$export$67ebef60e6f28a6)(this, function(_a) {
                    if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(function() {});
                    throw err;
                });
            });
        });
    };
}
function $416e6c5617707f9e$var$throwOnMissingId() {
    throw new (0, $b38a8fef12682553$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no identity ID");
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $7f49ddf9bf74d7ef$exports = {};
$7f49ddf9bf74d7ef$exports = JSON.parse('{"name":"@aws-sdk/client-cognito-identity","description":"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test:unit":"mocha **/cjs/**/*.spec.js","test:e2e":"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js","test":"yarn test:unit","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@aws-sdk/client-iam":"3.6.1","@types/chai":"^4.2.11","@types/mocha":"^8.0.4","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-cognito-identity"}}');


var $3ce7992f05548527$exports = {};
"use strict";
Object.defineProperty($3ce7992f05548527$exports, "__esModule", {
    value: true
});
$3ce7992f05548527$exports.WebCryptoSha256 = $3ce7992f05548527$exports.Ie11Sha256 = void 0;

var $fo9tD = parcelRequire("fo9tD");

(0, $fo9tD.__exportStar)((parcelRequire("dZNvx")), $3ce7992f05548527$exports);

var $jLgwE = parcelRequire("jLgwE");
Object.defineProperty($3ce7992f05548527$exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $jLgwE.Sha256;
    }
});

var $iS0p3 = parcelRequire("iS0p3");
Object.defineProperty($3ce7992f05548527$exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $iS0p3.Sha256;
    }
});


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7d798cbcdc135b57$var$extendStatics = function(d, b) {
    $7d798cbcdc135b57$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7d798cbcdc135b57$var$extendStatics(d, b);
};
function $7d798cbcdc135b57$export$a8ba968b8961cb8a(d, b) {
    $7d798cbcdc135b57$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7d798cbcdc135b57$export$18ce0697a983be9b = function() {
    $7d798cbcdc135b57$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d798cbcdc135b57$export$18ce0697a983be9b.apply(this, arguments);
};
function $7d798cbcdc135b57$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7d798cbcdc135b57$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7d798cbcdc135b57$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7d798cbcdc135b57$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7d798cbcdc135b57$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7d798cbcdc135b57$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $7d798cbcdc135b57$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $7d798cbcdc135b57$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $7d798cbcdc135b57$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7d798cbcdc135b57$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7d798cbcdc135b57$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7d798cbcdc135b57$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7d798cbcdc135b57$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7d798cbcdc135b57$export$10c90e4f7922046c(v) {
    return this instanceof $7d798cbcdc135b57$export$10c90e4f7922046c ? (this.v = v, this) : new $7d798cbcdc135b57$export$10c90e4f7922046c(v);
}
function $7d798cbcdc135b57$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7d798cbcdc135b57$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7d798cbcdc135b57$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7d798cbcdc135b57$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7d798cbcdc135b57$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7d798cbcdc135b57$export$19a8beecd37a4c45 === "function" ? $7d798cbcdc135b57$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7d798cbcdc135b57$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $7d798cbcdc135b57$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $7d798cbcdc135b57$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7d798cbcdc135b57$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $7d798cbcdc135b57$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $69ddf22509354066$var$extendStatics = function(d, b) {
    $69ddf22509354066$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $69ddf22509354066$var$extendStatics(d, b);
};
function $69ddf22509354066$export$a8ba968b8961cb8a(d, b) {
    $69ddf22509354066$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $69ddf22509354066$export$18ce0697a983be9b = function() {
    $69ddf22509354066$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $69ddf22509354066$export$18ce0697a983be9b.apply(this, arguments);
};
function $69ddf22509354066$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $69ddf22509354066$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $69ddf22509354066$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $69ddf22509354066$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $69ddf22509354066$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $69ddf22509354066$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $69ddf22509354066$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $69ddf22509354066$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $69ddf22509354066$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $69ddf22509354066$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $69ddf22509354066$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($69ddf22509354066$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $69ddf22509354066$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $69ddf22509354066$export$10c90e4f7922046c(v) {
    return this instanceof $69ddf22509354066$export$10c90e4f7922046c ? (this.v = v, this) : new $69ddf22509354066$export$10c90e4f7922046c(v);
}
function $69ddf22509354066$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $69ddf22509354066$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $69ddf22509354066$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $69ddf22509354066$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $69ddf22509354066$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $69ddf22509354066$export$19a8beecd37a4c45 === "function" ? $69ddf22509354066$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $69ddf22509354066$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $69ddf22509354066$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $69ddf22509354066$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $69ddf22509354066$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $69ddf22509354066$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $3edb1bb4e9c68459$export$c3b4775ad75a73db = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, $3edb1bb4e9c68459$var$hexEncode);
};
var $3edb1bb4e9c68459$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};



var $8d5ea8e73103c785$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $3edb1bb4e9c68459$export$c3b4775ad75a73db)).join("/");
};




function $c40265ee6312ebb2$export$6b17a39e52c8ee53(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, $69ddf22509354066$export$19a8beecd37a4c45)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, $3edb1bb4e9c68459$export$c3b4775ad75a73db)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, $3edb1bb4e9c68459$export$c3b4775ad75a73db)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, $3edb1bb4e9c68459$export$c3b4775ad75a73db)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}


function $bdd2fec83ea2b380$export$363ac302bdbd807b(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


var $262081bbd00b028c$export$83588b87edbfa7e0 = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, $c40265ee6312ebb2$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, $7d798cbcdc135b57$export$19a8beecd37a4c45)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, $8e579238f5eb4a6f$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, $8e579238f5eb4a6f$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $bdd2fec83ea2b380$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();



var $7193c901dfcaa70c$var$alphabetByEncoding = {};
var $7193c901dfcaa70c$var$alphabetByValue = new Array(64);
for(var $7193c901dfcaa70c$var$i = 0, $7193c901dfcaa70c$var$start = "A".charCodeAt(0), $7193c901dfcaa70c$var$limit = "Z".charCodeAt(0); $7193c901dfcaa70c$var$i + $7193c901dfcaa70c$var$start <= $7193c901dfcaa70c$var$limit; $7193c901dfcaa70c$var$i++){
    var $7193c901dfcaa70c$var$char = String.fromCharCode($7193c901dfcaa70c$var$i + $7193c901dfcaa70c$var$start);
    $7193c901dfcaa70c$var$alphabetByEncoding[$7193c901dfcaa70c$var$char] = $7193c901dfcaa70c$var$i;
    $7193c901dfcaa70c$var$alphabetByValue[$7193c901dfcaa70c$var$i] = $7193c901dfcaa70c$var$char;
}
for(var $7193c901dfcaa70c$var$i = 0, $7193c901dfcaa70c$var$start = "a".charCodeAt(0), $7193c901dfcaa70c$var$limit = "z".charCodeAt(0); $7193c901dfcaa70c$var$i + $7193c901dfcaa70c$var$start <= $7193c901dfcaa70c$var$limit; $7193c901dfcaa70c$var$i++){
    var $7193c901dfcaa70c$var$char = String.fromCharCode($7193c901dfcaa70c$var$i + $7193c901dfcaa70c$var$start);
    var $7193c901dfcaa70c$var$index = $7193c901dfcaa70c$var$i + 26;
    $7193c901dfcaa70c$var$alphabetByEncoding[$7193c901dfcaa70c$var$char] = $7193c901dfcaa70c$var$index;
    $7193c901dfcaa70c$var$alphabetByValue[$7193c901dfcaa70c$var$index] = $7193c901dfcaa70c$var$char;
}
for(var $7193c901dfcaa70c$var$i = 0; $7193c901dfcaa70c$var$i < 10; $7193c901dfcaa70c$var$i++){
    $7193c901dfcaa70c$var$alphabetByEncoding[$7193c901dfcaa70c$var$i.toString(10)] = $7193c901dfcaa70c$var$i + 52;
    var $7193c901dfcaa70c$var$char = $7193c901dfcaa70c$var$i.toString(10);
    var $7193c901dfcaa70c$var$index = $7193c901dfcaa70c$var$i + 52;
    $7193c901dfcaa70c$var$alphabetByEncoding[$7193c901dfcaa70c$var$char] = $7193c901dfcaa70c$var$index;
    $7193c901dfcaa70c$var$alphabetByValue[$7193c901dfcaa70c$var$index] = $7193c901dfcaa70c$var$char;
}
$7193c901dfcaa70c$var$alphabetByEncoding["+"] = 62;
$7193c901dfcaa70c$var$alphabetByValue[62] = "+";
$7193c901dfcaa70c$var$alphabetByEncoding["/"] = 63;
$7193c901dfcaa70c$var$alphabetByValue[63] = "/";
var $7193c901dfcaa70c$var$bitsPerLetter = 6;
var $7193c901dfcaa70c$var$bitsPerByte = 8;
var $7193c901dfcaa70c$var$maxLetterValue = 63;
function $7193c901dfcaa70c$export$c537b38001c583b7(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= $7193c901dfcaa70c$var$alphabetByEncoding[input[j]] << (limit - j) * $7193c901dfcaa70c$var$bitsPerLetter;
            bitLength += $7193c901dfcaa70c$var$bitsPerLetter;
        } else bits >>= $7193c901dfcaa70c$var$bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % $7193c901dfcaa70c$var$bitsPerByte;
        var byteLength = Math.floor(bitLength / $7193c901dfcaa70c$var$bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * $7193c901dfcaa70c$var$bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function $7193c901dfcaa70c$export$37cc283d8fbd3462(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * $7193c901dfcaa70c$var$bitsPerByte;
            bitLength += $7193c901dfcaa70c$var$bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / $7193c901dfcaa70c$var$bitsPerLetter);
        bits <<= bitClusterCount * $7193c901dfcaa70c$var$bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * $7193c901dfcaa70c$var$bitsPerLetter;
            str += $7193c901dfcaa70c$var$alphabetByValue[(bits & $7193c901dfcaa70c$var$maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}


var $8e0c4dd6b83dcffc$export$17bf97b72e307d52 = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return $8e0c4dd6b83dcffc$var$collectBlob(stream);
    return $8e0c4dd6b83dcffc$var$collectStream(stream);
};
function $8e0c4dd6b83dcffc$var$collectBlob(blob) {
    return (0, $7d798cbcdc135b57$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, $7d798cbcdc135b57$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $8e0c4dd6b83dcffc$var$readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, $7193c901dfcaa70c$export$c537b38001c583b7)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function $8e0c4dd6b83dcffc$var$collectStream(stream) {
    return (0, $7d798cbcdc135b57$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, $7d798cbcdc135b57$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function $8e0c4dd6b83dcffc$var$readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}




var $c0b436dd1fe163f5$export$8b6362171c4dfa64 = function(message) {
    return function() {
        throw new Error(message);
    };
};


var $77b3b9daef425c4b$export$d59dd53963f8f3d5 = function(message) {
    return function() {
        return Promise.reject(message);
    };
};




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $89f7ec80a215fd61$var$extendStatics = function(d, b) {
    $89f7ec80a215fd61$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $89f7ec80a215fd61$var$extendStatics(d, b);
};
function $89f7ec80a215fd61$export$a8ba968b8961cb8a(d, b) {
    $89f7ec80a215fd61$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $89f7ec80a215fd61$export$18ce0697a983be9b = function() {
    $89f7ec80a215fd61$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $89f7ec80a215fd61$export$18ce0697a983be9b.apply(this, arguments);
};
function $89f7ec80a215fd61$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $89f7ec80a215fd61$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $89f7ec80a215fd61$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $89f7ec80a215fd61$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $89f7ec80a215fd61$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $89f7ec80a215fd61$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $89f7ec80a215fd61$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $89f7ec80a215fd61$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $89f7ec80a215fd61$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $89f7ec80a215fd61$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $89f7ec80a215fd61$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($89f7ec80a215fd61$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $89f7ec80a215fd61$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $89f7ec80a215fd61$export$10c90e4f7922046c(v) {
    return this instanceof $89f7ec80a215fd61$export$10c90e4f7922046c ? (this.v = v, this) : new $89f7ec80a215fd61$export$10c90e4f7922046c(v);
}
function $89f7ec80a215fd61$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $89f7ec80a215fd61$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $89f7ec80a215fd61$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $89f7ec80a215fd61$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $89f7ec80a215fd61$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $89f7ec80a215fd61$export$19a8beecd37a4c45 === "function" ? $89f7ec80a215fd61$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $89f7ec80a215fd61$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $89f7ec80a215fd61$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $89f7ec80a215fd61$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $89f7ec80a215fd61$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $89f7ec80a215fd61$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $2efb85a1f6a92e50$export$a3922aa5f87bae85 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $89f7ec80a215fd61$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var _a;
                return (0, $89f7ec80a215fd61$export$67ebef60e6f28a6)(this, function(_b) {
                    if ((_a = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a === void 0 ? void 0 : _a.mode) context.userAgent = (0, $89f7ec80a215fd61$export$afc72e2116322959)(context.userAgent || [], [
                        [
                            "cfg/retry-mode",
                            options.retryStrategy.mode
                        ]
                    ]);
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var $2efb85a1f6a92e50$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var $2efb85a1f6a92e50$export$c73199e2b1df9340 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($2efb85a1f6a92e50$export$a3922aa5f87bae85(options), $2efb85a1f6a92e50$export$44d3d03587957ce9);
        }
    };
};




/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var $7069e85a77f25f19$export$7067ba90effbd789 = 100;
var $7069e85a77f25f19$export$2412c80d04e902c6 = 20000;
var $7069e85a77f25f19$export$4af31f8250b48e23 = 500;
var $7069e85a77f25f19$export$f8c3d11675a1153 = 500;
var $7069e85a77f25f19$export$797febae1136bc84 = 5;
var $7069e85a77f25f19$export$b643545eaf9af837 = 10;
var $7069e85a77f25f19$export$a25da3406dc148e4 = 1;
var $7069e85a77f25f19$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
var $7069e85a77f25f19$export$d4f764f0ec4f52f = "amz-sdk-request";


var $1078117b00eb72e3$export$536b11ee0b9c4a95 = function() {
    return function(next) {
        return function(args) {
            return (0, $89f7ec80a215fd61$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request;
                return (0, $89f7ec80a215fd61$export$67ebef60e6f28a6)(this, function(_a) {
                    request = args.request;
                    if ((0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request)) {
                        delete request.headers[0, $7069e85a77f25f19$export$197fd517bf66ccb2];
                        delete request.headers[0, $7069e85a77f25f19$export$d4f764f0ec4f52f];
                    }
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $1078117b00eb72e3$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var $1078117b00eb72e3$export$fa165e6edc16c2a2 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($1078117b00eb72e3$export$536b11ee0b9c4a95(), $1078117b00eb72e3$export$3ec587d8f35e7a2c);
        }
    };
};




/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var $27cddd6a74f7645b$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var $27cddd6a74f7645b$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var $27cddd6a74f7645b$export$18bd3bfe89ded398 = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $27cddd6a74f7645b$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];


var $4c9aacc9d8776753$export$46428803f4bd8a0c = function(error) {
    return error.$retryable !== undefined;
};
var $4c9aacc9d8776753$export$7b87435661177a94 = function(error) {
    return (0, $27cddd6a74f7645b$export$9fde012b8b2a10ca).includes(error.name);
};
var $4c9aacc9d8776753$export$cbecb89f6256ccc8 = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, $27cddd6a74f7645b$export$89cd1b0ccfcb99d).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var $4c9aacc9d8776753$export$31778435da988512 = function(error) {
    var _a;
    return (0, $27cddd6a74f7645b$export$18bd3bfe89ded398).includes(error.name) || (0, $27cddd6a74f7645b$export$38bf589d26009e4f).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};


var $665cf99d053a9587$exports = {};
var $664a331dabbb8233$exports = {};
var $b6e8f60da77e75b0$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $b6e8f60da77e75b0$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($b6e8f60da77e75b0$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $b6e8f60da77e75b0$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $b6e8f60da77e75b0$exports = function whatwgRNG() {
        $b6e8f60da77e75b0$var$getRandomValues($b6e8f60da77e75b0$var$rnds8);
        return $b6e8f60da77e75b0$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $b6e8f60da77e75b0$var$rnds = new Array(16);
    $b6e8f60da77e75b0$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $b6e8f60da77e75b0$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $b6e8f60da77e75b0$var$rnds;
    };
}


var $8b2d42a4f7f8c657$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8b2d42a4f7f8c657$var$byteToHex = [];
for(var $8b2d42a4f7f8c657$var$i = 0; $8b2d42a4f7f8c657$var$i < 256; ++$8b2d42a4f7f8c657$var$i)$8b2d42a4f7f8c657$var$byteToHex[$8b2d42a4f7f8c657$var$i] = ($8b2d42a4f7f8c657$var$i + 0x100).toString(16).substr(1);
function $8b2d42a4f7f8c657$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $8b2d42a4f7f8c657$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$8b2d42a4f7f8c657$exports = $8b2d42a4f7f8c657$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $664a331dabbb8233$var$_nodeId;
var $664a331dabbb8233$var$_clockseq;
// Previous uuid creation time
var $664a331dabbb8233$var$_lastMSecs = 0;
var $664a331dabbb8233$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $664a331dabbb8233$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $664a331dabbb8233$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $664a331dabbb8233$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $b6e8f60da77e75b0$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $664a331dabbb8233$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $664a331dabbb8233$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $664a331dabbb8233$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $664a331dabbb8233$var$_lastMSecs + (nsecs - $664a331dabbb8233$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $664a331dabbb8233$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $664a331dabbb8233$var$_lastMSecs = msecs;
    $664a331dabbb8233$var$_lastNSecs = nsecs;
    $664a331dabbb8233$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $8b2d42a4f7f8c657$exports(b);
}
$664a331dabbb8233$exports = $664a331dabbb8233$var$v1;


var $07faa04f0d7b670f$exports = {};


function $07faa04f0d7b670f$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $b6e8f60da77e75b0$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $8b2d42a4f7f8c657$exports(rnds);
}
$07faa04f0d7b670f$exports = $07faa04f0d7b670f$var$v4;


var $665cf99d053a9587$var$uuid = $07faa04f0d7b670f$exports;
$665cf99d053a9587$var$uuid.v1 = $664a331dabbb8233$exports;
$665cf99d053a9587$var$uuid.v4 = $07faa04f0d7b670f$exports;
$665cf99d053a9587$exports = $665cf99d053a9587$var$uuid;




var $71bb0b70d234eebd$export$2ebe7988802fc284 = function(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? (0, $7069e85a77f25f19$export$b643545eaf9af837) : (0, $7069e85a77f25f19$export$797febae1136bc84);
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, $7069e85a77f25f19$export$a25da3406dc148e4);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



var $97a5a8c3aaa7172e$export$1cddd42598a3b1f6 = function(delayBase, attempts) {
    return Math.floor(Math.min((0, $7069e85a77f25f19$export$2412c80d04e902c6), Math.random() * Math.pow(2, attempts) * delayBase));
};



var $638ddae9b99b0e6d$export$3839fd261f89ec2 = function(error) {
    if (!error) return false;
    return (0, $4c9aacc9d8776753$export$46428803f4bd8a0c)(error) || (0, $4c9aacc9d8776753$export$7b87435661177a94)(error) || (0, $4c9aacc9d8776753$export$cbecb89f6256ccc8)(error) || (0, $4c9aacc9d8776753$export$31778435da988512)(error);
};


var $2d1974589a37c0fb$export$2c7e51f38ba5a406 = 3;
var $2d1974589a37c0fb$export$41315747b7c5d042 = "standard";
var $2d1974589a37c0fb$export$64af437cce00eae8 = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = $2d1974589a37c0fb$export$41315747b7c5d042;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, $638ddae9b99b0e6d$export$3839fd261f89ec2);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, $97a5a8c3aaa7172e$export$1cddd42598a3b1f6);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, $71bb0b70d234eebd$export$2ebe7988802fc284)((0, $7069e85a77f25f19$export$f8c3d11675a1153));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, $89f7ec80a215fd61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, $89f7ec80a215fd61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = $2d1974589a37c0fb$export$2c7e51f38ba5a406;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, $89f7ec80a215fd61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, $89f7ec80a215fd61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request)) request.headers[0, $7069e85a77f25f19$export$197fd517bf66ccb2] = (0, $665cf99d053a9587$exports.v4)();
                        _loop_1 = function() {
                            var _a, response, output, err_1, delay_1;
                            return (0, $89f7ec80a215fd61$export$67ebef60e6f28a6)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request)) request.headers[0, $7069e85a77f25f19$export$d4f764f0ec4f52f] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, $4c9aacc9d8776753$export$cbecb89f6256ccc8)(err_1) ? (0, $7069e85a77f25f19$export$4af31f8250b48e23) : (0, $7069e85a77f25f19$export$7067ba90effbd789), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();




var $626ed5f895800a82$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
var $626ed5f895800a82$export$9ae8a04532f798bc = "max_attempts";
var $626ed5f895800a82$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: function(env) {
        var value = env[$626ed5f895800a82$export$a19952f9e421517c];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + $626ed5f895800a82$export$a19952f9e421517c + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[$626ed5f895800a82$export$9ae8a04532f798bc];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + $626ed5f895800a82$export$9ae8a04532f798bc + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    default: (0, $2d1974589a37c0fb$export$2c7e51f38ba5a406)
};
var $626ed5f895800a82$export$ca7f6138f2c98476 = function(input) {
    var maxAttempts = $626ed5f895800a82$var$normalizeMaxAttempts(input.maxAttempts);
    return (0, $89f7ec80a215fd61$export$18ce0697a983be9b)((0, $89f7ec80a215fd61$export$18ce0697a983be9b)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, $2d1974589a37c0fb$export$64af437cce00eae8)(maxAttempts)
    });
};
var $626ed5f895800a82$var$normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, $2d1974589a37c0fb$export$2c7e51f38ba5a406);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var $626ed5f895800a82$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
var $626ed5f895800a82$export$c5c0171a17765aea = "retry_mode";
var $626ed5f895800a82$export$972bf2bb01959ff5 = {
    environmentVariableSelector: function(env) {
        return env[$626ed5f895800a82$export$4728af91ff39ef3b];
    },
    configFileSelector: function(profile) {
        return profile[$626ed5f895800a82$export$c5c0171a17765aea];
    },
    default: (0, $2d1974589a37c0fb$export$41315747b7c5d042)
};







function $fd1dc5c280790e1b$export$967f3527bf233bc0(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e9172be6e6d15adc$var$extendStatics = function(d, b) {
    $e9172be6e6d15adc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e9172be6e6d15adc$var$extendStatics(d, b);
};
function $e9172be6e6d15adc$export$a8ba968b8961cb8a(d, b) {
    $e9172be6e6d15adc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e9172be6e6d15adc$export$18ce0697a983be9b = function() {
    $e9172be6e6d15adc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9172be6e6d15adc$export$18ce0697a983be9b.apply(this, arguments);
};
function $e9172be6e6d15adc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e9172be6e6d15adc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e9172be6e6d15adc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e9172be6e6d15adc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e9172be6e6d15adc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e9172be6e6d15adc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e9172be6e6d15adc$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e9172be6e6d15adc$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e9172be6e6d15adc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e9172be6e6d15adc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e9172be6e6d15adc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e9172be6e6d15adc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e9172be6e6d15adc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e9172be6e6d15adc$export$10c90e4f7922046c(v) {
    return this instanceof $e9172be6e6d15adc$export$10c90e4f7922046c ? (this.v = v, this) : new $e9172be6e6d15adc$export$10c90e4f7922046c(v);
}
function $e9172be6e6d15adc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e9172be6e6d15adc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e9172be6e6d15adc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e9172be6e6d15adc$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e9172be6e6d15adc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e9172be6e6d15adc$export$19a8beecd37a4c45 === "function" ? $e9172be6e6d15adc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e9172be6e6d15adc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e9172be6e6d15adc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e9172be6e6d15adc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e9172be6e6d15adc$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e9172be6e6d15adc$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $03dc96944173e4d6$exports = {};
!function(e, t) {
    $03dc96944173e4d6$exports = t();
}($03dc96944173e4d6$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


var $efbdd3c561c88f76$export$69d579f32876892f = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, $e9172be6e6d15adc$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, $e9172be6e6d15adc$export$67ebef60e6f28a6)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, (/*@__PURE__*/$parcel$interopDefault($03dc96944173e4d6$exports))).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};


/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $b48f383dcffed7fe$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $b48f383dcffed7fe$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};


function $02fe42b10b06432f$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $02fe42b10b06432f$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}


var $afcc34d5c80283e8$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $02fe42b10b06432f$export$c7c5cef950a4d2fc)(input) : (0, $b48f383dcffed7fe$export$c7c5cef950a4d2fc)(input);
};
var $afcc34d5c80283e8$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $02fe42b10b06432f$export$b4b216764bb846eb)(input) : (0, $b48f383dcffed7fe$export$b4b216764bb846eb)(input);
};



// Partition default templates
var $d2f97d281f533ebc$var$AWS_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
var $d2f97d281f533ebc$var$AWS_CN_TEMPLATE = "cognito-identity.{region}.amazonaws.com.cn";
var $d2f97d281f533ebc$var$AWS_ISO_TEMPLATE = "cognito-identity.{region}.c2s.ic.gov";
var $d2f97d281f533ebc$var$AWS_ISO_B_TEMPLATE = "cognito-identity.{region}.sc2s.sgov.gov";
var $d2f97d281f533ebc$var$AWS_US_GOV_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
// Partition regions
var $d2f97d281f533ebc$var$AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $d2f97d281f533ebc$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $d2f97d281f533ebc$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $d2f97d281f533ebc$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $d2f97d281f533ebc$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $d2f97d281f533ebc$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "ap-northeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "cognito-identity.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "cognito-identity.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "cognito-identity.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "cognito-identity.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "cognito-identity.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "cognito-identity.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "cognito-identity.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "cognito-identity.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "cognito-identity.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "cognito-identity.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "cognito-identity.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "cognito-identity.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($d2f97d281f533ebc$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $d2f97d281f533ebc$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($d2f97d281f533ebc$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $d2f97d281f533ebc$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($d2f97d281f533ebc$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $d2f97d281f533ebc$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($d2f97d281f533ebc$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $d2f97d281f533ebc$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($d2f97d281f533ebc$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $d2f97d281f533ebc$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $d2f97d281f533ebc$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        signingService: "cognito-identity"
    }, regionInfo));
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $00b73e3940f919c6$var$extendStatics = function(d, b) {
    $00b73e3940f919c6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $00b73e3940f919c6$var$extendStatics(d, b);
};
function $00b73e3940f919c6$export$a8ba968b8961cb8a(d, b) {
    $00b73e3940f919c6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $00b73e3940f919c6$export$18ce0697a983be9b = function() {
    $00b73e3940f919c6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $00b73e3940f919c6$export$18ce0697a983be9b.apply(this, arguments);
};
function $00b73e3940f919c6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $00b73e3940f919c6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $00b73e3940f919c6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $00b73e3940f919c6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $00b73e3940f919c6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $00b73e3940f919c6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $00b73e3940f919c6$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $00b73e3940f919c6$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $00b73e3940f919c6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $00b73e3940f919c6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $00b73e3940f919c6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($00b73e3940f919c6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $00b73e3940f919c6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $00b73e3940f919c6$export$10c90e4f7922046c(v) {
    return this instanceof $00b73e3940f919c6$export$10c90e4f7922046c ? (this.v = v, this) : new $00b73e3940f919c6$export$10c90e4f7922046c(v);
}
function $00b73e3940f919c6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $00b73e3940f919c6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $00b73e3940f919c6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $00b73e3940f919c6$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $00b73e3940f919c6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $00b73e3940f919c6$export$19a8beecd37a4c45 === "function" ? $00b73e3940f919c6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $00b73e3940f919c6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $00b73e3940f919c6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $00b73e3940f919c6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $00b73e3940f919c6$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $00b73e3940f919c6$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $2f6f7cce789f6fe3$export$66256f83798e5415(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, $00b73e3940f919c6$export$19a8beecd37a4c45)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, $00b73e3940f919c6$export$8d051b38c9118094)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}


var $13c693b8bb1dde50$export$7a5253c0f62e0150 = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, $2f6f7cce789f6fe3$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};


var $4a5ad25ee6f25c8a$export$608864383388f904 = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $d2f97d281f533ebc$export$2e4318bf13462aa2),
    serviceId: "Cognito Identity",
    urlParser: (0, $13c693b8bb1dde50$export$7a5253c0f62e0150)
};


var $6ecb31f2132dc9b9$export$b1f2d721b555a243 = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $4a5ad25ee6f25c8a$export$608864383388f904)), {
    runtime: "browser",
    base64Decoder: (0, $7193c901dfcaa70c$export$c537b38001c583b7),
    base64Encoder: (0, $7193c901dfcaa70c$export$37cc283d8fbd3462),
    bodyLengthChecker: (0, $fd1dc5c280790e1b$export$967f3527bf233bc0),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, $efbdd3c561c88f76$export$69d579f32876892f)({
        serviceId: (0, $4a5ad25ee6f25c8a$export$608864383388f904).serviceId,
        clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($7f49ddf9bf74d7ef$exports))).version
    }),
    maxAttempts: (0, $2d1974589a37c0fb$export$2c7e51f38ba5a406),
    region: (0, $77b3b9daef425c4b$export$d59dd53963f8f3d5)("Region is missing"),
    requestHandler: new (0, $262081bbd00b028c$export$83588b87edbfa7e0)(),
    sha256: (0, $3ce7992f05548527$exports.Sha256),
    streamCollector: (0, $8e0c4dd6b83dcffc$export$17bf97b72e307d52),
    utf8Decoder: (0, $afcc34d5c80283e8$export$c7c5cef950a4d2fc),
    utf8Encoder: (0, $afcc34d5c80283e8$export$b4b216764bb846eb)
});


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5fbab0b8dd781d15$var$extendStatics = function(d, b) {
    $5fbab0b8dd781d15$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5fbab0b8dd781d15$var$extendStatics(d, b);
};
function $5fbab0b8dd781d15$export$a8ba968b8961cb8a(d, b) {
    $5fbab0b8dd781d15$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5fbab0b8dd781d15$export$18ce0697a983be9b = function() {
    $5fbab0b8dd781d15$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5fbab0b8dd781d15$export$18ce0697a983be9b.apply(this, arguments);
};
function $5fbab0b8dd781d15$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5fbab0b8dd781d15$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5fbab0b8dd781d15$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5fbab0b8dd781d15$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5fbab0b8dd781d15$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5fbab0b8dd781d15$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5fbab0b8dd781d15$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5fbab0b8dd781d15$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5fbab0b8dd781d15$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5fbab0b8dd781d15$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5fbab0b8dd781d15$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5fbab0b8dd781d15$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5fbab0b8dd781d15$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5fbab0b8dd781d15$export$10c90e4f7922046c(v) {
    return this instanceof $5fbab0b8dd781d15$export$10c90e4f7922046c ? (this.v = v, this) : new $5fbab0b8dd781d15$export$10c90e4f7922046c(v);
}
function $5fbab0b8dd781d15$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5fbab0b8dd781d15$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5fbab0b8dd781d15$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5fbab0b8dd781d15$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5fbab0b8dd781d15$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5fbab0b8dd781d15$export$19a8beecd37a4c45 === "function" ? $5fbab0b8dd781d15$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5fbab0b8dd781d15$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5fbab0b8dd781d15$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5fbab0b8dd781d15$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5fbab0b8dd781d15$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5fbab0b8dd781d15$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $6aff6722f8b97662$export$24f352b1bd1e2f8b = function(input) {
    var _a;
    return (0, $5fbab0b8dd781d15$export$18ce0697a983be9b)((0, $5fbab0b8dd781d15$export$18ce0697a983be9b)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? $6aff6722f8b97662$var$normalizeEndpoint(input) : function() {
            return $6aff6722f8b97662$var$getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var $6aff6722f8b97662$var$normalizeEndpoint = function(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var $6aff6722f8b97662$var$getEndPointFromRegion = function(input) {
    return (0, $5fbab0b8dd781d15$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, $5fbab0b8dd781d15$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};



var $b027526b3945190a$export$26513716e2900bad = "AWS_REGION";
var $b027526b3945190a$export$8afb1c306a7d01b = "region";
var $b027526b3945190a$export$1509d3ea54119a08 = {
    environmentVariableSelector: function(env) {
        return env[$b027526b3945190a$export$26513716e2900bad];
    },
    configFileSelector: function(profile) {
        return profile[$b027526b3945190a$export$8afb1c306a7d01b];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var $b027526b3945190a$export$9a37503ca194454d = {
    preferredFile: "credentials"
};
var $b027526b3945190a$export$7696ef37558bd0ec = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, $5fbab0b8dd781d15$export$18ce0697a983be9b)((0, $5fbab0b8dd781d15$export$18ce0697a983be9b)({}, input), {
        region: $b027526b3945190a$var$normalizeRegion(input.region)
    });
};
var $b027526b3945190a$var$normalizeRegion = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $194eff4205a56688$var$extendStatics = function(d, b) {
    $194eff4205a56688$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $194eff4205a56688$var$extendStatics(d, b);
};
function $194eff4205a56688$export$a8ba968b8961cb8a(d, b) {
    $194eff4205a56688$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $194eff4205a56688$export$18ce0697a983be9b = function() {
    $194eff4205a56688$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $194eff4205a56688$export$18ce0697a983be9b.apply(this, arguments);
};
function $194eff4205a56688$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $194eff4205a56688$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $194eff4205a56688$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $194eff4205a56688$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $194eff4205a56688$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $194eff4205a56688$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $194eff4205a56688$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $194eff4205a56688$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $194eff4205a56688$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $194eff4205a56688$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $194eff4205a56688$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($194eff4205a56688$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $194eff4205a56688$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $194eff4205a56688$export$10c90e4f7922046c(v) {
    return this instanceof $194eff4205a56688$export$10c90e4f7922046c ? (this.v = v, this) : new $194eff4205a56688$export$10c90e4f7922046c(v);
}
function $194eff4205a56688$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $194eff4205a56688$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $194eff4205a56688$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $194eff4205a56688$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $194eff4205a56688$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $194eff4205a56688$export$19a8beecd37a4c45 === "function" ? $194eff4205a56688$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $194eff4205a56688$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $194eff4205a56688$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $194eff4205a56688$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $194eff4205a56688$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $194eff4205a56688$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $ff4a9738848c11ef$var$CONTENT_LENGTH_HEADER = "content-length";
function $ff4a9738848c11ef$export$940b29eb2788b975(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $194eff4205a56688$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, $194eff4205a56688$export$67ebef60e6f28a6)(this, function(_b) {
                    request = args.request;
                    if ((0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf($ff4a9738848c11ef$var$CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, $194eff4205a56688$export$18ce0697a983be9b)((0, $194eff4205a56688$export$18ce0697a983be9b)({}, request.headers), (_a = {}, _a[$ff4a9738848c11ef$var$CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $194eff4205a56688$export$18ce0697a983be9b)((0, $194eff4205a56688$export$18ce0697a983be9b)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $ff4a9738848c11ef$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var $ff4a9738848c11ef$export$7e6ddf9365a30fe9 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($ff4a9738848c11ef$export$940b29eb2788b975(options.bodyLengthChecker), $ff4a9738848c11ef$export$1f7816f8f350b2f5);
        }
    };
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $8c01ccaf468fb1ed$var$extendStatics = function(d, b) {
    $8c01ccaf468fb1ed$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $8c01ccaf468fb1ed$var$extendStatics(d, b);
};
function $8c01ccaf468fb1ed$export$a8ba968b8961cb8a(d, b) {
    $8c01ccaf468fb1ed$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8c01ccaf468fb1ed$export$18ce0697a983be9b = function() {
    $8c01ccaf468fb1ed$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8c01ccaf468fb1ed$export$18ce0697a983be9b.apply(this, arguments);
};
function $8c01ccaf468fb1ed$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8c01ccaf468fb1ed$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8c01ccaf468fb1ed$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8c01ccaf468fb1ed$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8c01ccaf468fb1ed$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8c01ccaf468fb1ed$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $8c01ccaf468fb1ed$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $8c01ccaf468fb1ed$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $8c01ccaf468fb1ed$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8c01ccaf468fb1ed$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8c01ccaf468fb1ed$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8c01ccaf468fb1ed$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8c01ccaf468fb1ed$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8c01ccaf468fb1ed$export$10c90e4f7922046c(v) {
    return this instanceof $8c01ccaf468fb1ed$export$10c90e4f7922046c ? (this.v = v, this) : new $8c01ccaf468fb1ed$export$10c90e4f7922046c(v);
}
function $8c01ccaf468fb1ed$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8c01ccaf468fb1ed$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8c01ccaf468fb1ed$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8c01ccaf468fb1ed$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $8c01ccaf468fb1ed$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8c01ccaf468fb1ed$export$19a8beecd37a4c45 === "function" ? $8c01ccaf468fb1ed$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8c01ccaf468fb1ed$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $8c01ccaf468fb1ed$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $8c01ccaf468fb1ed$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8c01ccaf468fb1ed$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $8c01ccaf468fb1ed$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $c1f22e97875f8f21$export$c1625bf0b32b4481(input) {
    return input;
}
var $c1f22e97875f8f21$export$858685d7aeef192d = function(options) {
    return function(next) {
        return function(args) {
            return (0, $8c01ccaf468fb1ed$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, $8c01ccaf468fb1ed$export$67ebef60e6f28a6)(this, function(_b) {
                    if (!(0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $c1f22e97875f8f21$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var $c1f22e97875f8f21$export$23d3b647211be53a = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($c1f22e97875f8f21$export$858685d7aeef192d(options), $c1f22e97875f8f21$export$696d244ba96181e8);
        }
    };
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c950eb2d4c39c880$var$extendStatics = function(d, b) {
    $c950eb2d4c39c880$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c950eb2d4c39c880$var$extendStatics(d, b);
};
function $c950eb2d4c39c880$export$a8ba968b8961cb8a(d, b) {
    $c950eb2d4c39c880$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c950eb2d4c39c880$export$18ce0697a983be9b = function() {
    $c950eb2d4c39c880$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c950eb2d4c39c880$export$18ce0697a983be9b.apply(this, arguments);
};
function $c950eb2d4c39c880$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c950eb2d4c39c880$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c950eb2d4c39c880$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c950eb2d4c39c880$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c950eb2d4c39c880$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c950eb2d4c39c880$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c950eb2d4c39c880$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c950eb2d4c39c880$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c950eb2d4c39c880$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c950eb2d4c39c880$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c950eb2d4c39c880$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c950eb2d4c39c880$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c950eb2d4c39c880$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c950eb2d4c39c880$export$10c90e4f7922046c(v) {
    return this instanceof $c950eb2d4c39c880$export$10c90e4f7922046c ? (this.v = v, this) : new $c950eb2d4c39c880$export$10c90e4f7922046c(v);
}
function $c950eb2d4c39c880$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c950eb2d4c39c880$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c950eb2d4c39c880$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c950eb2d4c39c880$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c950eb2d4c39c880$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c950eb2d4c39c880$export$19a8beecd37a4c45 === "function" ? $c950eb2d4c39c880$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c950eb2d4c39c880$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c950eb2d4c39c880$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c950eb2d4c39c880$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c950eb2d4c39c880$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c950eb2d4c39c880$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $d7c9db6585161f99$export$fe0e777ee4f58cde = function() {
    return function(next, context) {
        return function(args) {
            return (0, $c950eb2d4c39c880$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, $c950eb2d4c39c880$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, $c950eb2d4c39c880$export$3c9a16f847548506)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $d7c9db6585161f99$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var $d7c9db6585161f99$export$f6ef65d7766fc255 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($d7c9db6585161f99$export$fe0e777ee4f58cde(), $d7c9db6585161f99$export$877c148ab4ad0722);
        }
    };
};





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ff221da8c1a04980$var$extendStatics = function(d, b) {
    $ff221da8c1a04980$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ff221da8c1a04980$var$extendStatics(d, b);
};
function $ff221da8c1a04980$export$a8ba968b8961cb8a(d, b) {
    $ff221da8c1a04980$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ff221da8c1a04980$export$18ce0697a983be9b = function() {
    $ff221da8c1a04980$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff221da8c1a04980$export$18ce0697a983be9b.apply(this, arguments);
};
function $ff221da8c1a04980$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ff221da8c1a04980$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ff221da8c1a04980$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ff221da8c1a04980$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ff221da8c1a04980$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ff221da8c1a04980$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ff221da8c1a04980$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ff221da8c1a04980$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ff221da8c1a04980$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ff221da8c1a04980$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ff221da8c1a04980$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ff221da8c1a04980$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ff221da8c1a04980$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ff221da8c1a04980$export$10c90e4f7922046c(v) {
    return this instanceof $ff221da8c1a04980$export$10c90e4f7922046c ? (this.v = v, this) : new $ff221da8c1a04980$export$10c90e4f7922046c(v);
}
function $ff221da8c1a04980$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ff221da8c1a04980$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ff221da8c1a04980$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ff221da8c1a04980$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ff221da8c1a04980$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ff221da8c1a04980$export$19a8beecd37a4c45 === "function" ? $ff221da8c1a04980$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ff221da8c1a04980$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ff221da8c1a04980$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ff221da8c1a04980$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ff221da8c1a04980$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ff221da8c1a04980$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}




var $756dc7ccf16f513c$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $756dc7ccf16f513c$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $756dc7ccf16f513c$export$6e114beec37430d7 = "X-Amz-Date";
var $756dc7ccf16f513c$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $756dc7ccf16f513c$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $756dc7ccf16f513c$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $756dc7ccf16f513c$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $756dc7ccf16f513c$export$9924a64a4b8b0d58 = "authorization";
var $756dc7ccf16f513c$export$acf4b8bdf24aab34 = $756dc7ccf16f513c$export$6e114beec37430d7.toLowerCase();
var $756dc7ccf16f513c$export$c65c8c9f514da472 = "date";
var $756dc7ccf16f513c$export$20d6a73fd0b10982 = [
    $756dc7ccf16f513c$export$9924a64a4b8b0d58,
    $756dc7ccf16f513c$export$acf4b8bdf24aab34,
    $756dc7ccf16f513c$export$c65c8c9f514da472
];
var $756dc7ccf16f513c$export$29961f34c719157e = $756dc7ccf16f513c$export$41ae838dc1e0f082.toLowerCase();
var $756dc7ccf16f513c$export$eaef12179141669a = "x-amz-content-sha256";
var $756dc7ccf16f513c$export$fdc81b663012a8d2 = $756dc7ccf16f513c$export$8e1383b7eea7bee.toLowerCase();
var $756dc7ccf16f513c$export$96307741595055fc = "host";
var $756dc7ccf16f513c$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $756dc7ccf16f513c$export$8085db98abbe0597 = /^proxy-/;
var $756dc7ccf16f513c$export$758380400526c39 = /^sec-/;
var $756dc7ccf16f513c$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $756dc7ccf16f513c$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $756dc7ccf16f513c$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $756dc7ccf16f513c$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $756dc7ccf16f513c$export$bf665777b4a1722f = 50;
var $756dc7ccf16f513c$export$c4bf0942098f6bb = "aws4_request";
var $756dc7ccf16f513c$export$274df788bdcca184 = 604800;


var $4119dfe958f9447d$var$signingKeyCache = {};
var $4119dfe958f9447d$var$cacheQueue = [];
function $4119dfe958f9447d$export$41a9651decfe2bde(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $756dc7ccf16f513c$export$c4bf0942098f6bb);
}
var $4119dfe958f9447d$export$8b95a069d16dd783 = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, $ff221da8c1a04980$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $4119dfe958f9447d$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in $4119dfe958f9447d$var$signingKeyCache) return [
                        2 /*return*/ ,
                        $4119dfe958f9447d$var$signingKeyCache[cacheKey]
                    ];
                    $4119dfe958f9447d$var$cacheQueue.push(cacheKey);
                    while($4119dfe958f9447d$var$cacheQueue.length > (0, $756dc7ccf16f513c$export$bf665777b4a1722f))delete $4119dfe958f9447d$var$signingKeyCache[$4119dfe958f9447d$var$cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, $ff221da8c1a04980$export$19a8beecd37a4c45)([
                        shortDate,
                        region,
                        service,
                        (0, $756dc7ccf16f513c$export$c4bf0942098f6bb)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4 /*yield*/ ,
                        $4119dfe958f9447d$var$hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        $4119dfe958f9447d$var$signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
function $4119dfe958f9447d$export$a31b95746ea0a30a() {
    $4119dfe958f9447d$var$cacheQueue.length = 0;
    Object.keys($4119dfe958f9447d$var$signingKeyCache).forEach(function(cacheKey) {
        delete $4119dfe958f9447d$var$signingKeyCache[cacheKey];
    });
}
function $4119dfe958f9447d$var$hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}








function $d1f7a191b42da212$export$859d7f1bb55e2914(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $ff221da8c1a04980$export$19a8beecd37a4c45)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $756dc7ccf16f513c$export$8ffdcd58c4092560) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $756dc7ccf16f513c$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $756dc7ccf16f513c$export$758380400526c39).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}



var $c34ad7b4d80623d5$export$c3b4775ad75a73db = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, $c34ad7b4d80623d5$var$hexEncode);
};
var $c34ad7b4d80623d5$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};



var $8084a9bff519c343$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $c34ad7b4d80623d5$export$c3b4775ad75a73db)).join("/");
};





function $0d4f59aa7a8befe9$export$8fea7e63ecd1ddbb(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $756dc7ccf16f513c$export$29961f34c719157e)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $c34ad7b4d80623d5$export$c3b4775ad75a73db)(key) + "=" + (0, $c34ad7b4d80623d5$export$c3b4775ad75a73db)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $c34ad7b4d80623d5$export$c3b4775ad75a73db)(key) + "=" + (0, $c34ad7b4d80623d5$export$c3b4775ad75a73db)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $ff221da8c1a04980$export$19a8beecd37a4c45)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}



var $37fef351ec9da733$export$9dd3754ae86f0017 = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};




function $e6532a988c25d6f9$export$a46a74202b0efd71(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $ff221da8c1a04980$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $756dc7ccf16f513c$export$eaef12179141669a)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $37fef351ec9da733$export$9dd3754ae86f0017)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, $756dc7ccf16f513c$export$91f7321b40d9fd07)
                    ];
            }
        });
    });
}



function $d1e4f354e9f919d9$export$17944590be865217(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $ff221da8c1a04980$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}




function $9e818a7d9538baaa$export$d043aa0bf7223286(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $ff221da8c1a04980$export$3c9a16f847548506)(_a, [
        "headers",
        "query"
    ]);
    return (0, $ff221da8c1a04980$export$18ce0697a983be9b)((0, $ff221da8c1a04980$export$18ce0697a983be9b)({}, rest), {
        headers: (0, $ff221da8c1a04980$export$18ce0697a983be9b)({}, headers),
        query: query ? $9e818a7d9538baaa$var$cloneQuery(query) : undefined
    });
}
function $9e818a7d9538baaa$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $ff221da8c1a04980$export$18ce0697a983be9b)((0, $ff221da8c1a04980$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $ff221da8c1a04980$export$afc72e2116322959)(param) : param, _a));
    }, {});
}


function $8faedc749e9af789$export$bfc08a76d4bd60f6(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, $9e818a7d9538baaa$export$d043aa0bf7223286)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, $ff221da8c1a04980$export$19a8beecd37a4c45)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $ff221da8c1a04980$export$18ce0697a983be9b)((0, $ff221da8c1a04980$export$18ce0697a983be9b)({}, request), {
        headers: headers,
        query: query
    });
}





function $73498605469193a2$export$a7cfe9131aa06be4(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, $9e818a7d9538baaa$export$d043aa0bf7223286)(request);
    try {
        for(var _b = (0, $ff221da8c1a04980$export$19a8beecd37a4c45)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $756dc7ccf16f513c$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}


function $1d803466dd4db0d2$export$b65d57190c224ef2(time) {
    return $1d803466dd4db0d2$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $1d803466dd4db0d2$export$e67a095c620b86fe(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}


var $f751fc4569ab1c26$export$20baf4d3f65eb30c = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = $f751fc4569ab1c26$var$normalizeRegionProvider(region);
        this.credentialProvider = $f751fc4569ab1c26$var$normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $f751fc4569ab1c26$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $756dc7ccf16f513c$export$274df788bdcca184)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $4119dfe958f9447d$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $8faedc749e9af789$export$bfc08a76d4bd60f6)((0, $73498605469193a2$export$a7cfe9131aa06be4)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, $756dc7ccf16f513c$export$8e1383b7eea7bee] = credentials.sessionToken;
                        request.query[0, $756dc7ccf16f513c$export$186cd8495ba0377d] = (0, $756dc7ccf16f513c$export$863a63fba5b2ddf5);
                        request.query[0, $756dc7ccf16f513c$export$5c8e6dd7758f59d6] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $756dc7ccf16f513c$export$6e114beec37430d7] = longDate;
                        request.query[0, $756dc7ccf16f513c$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
                        canonicalHeaders = (0, $d1f7a191b42da212$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $756dc7ccf16f513c$export$2dcbb254f883c238] = $f751fc4569ab1c26$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $756dc7ccf16f513c$export$41ae838dc1e0f082);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $e6532a988c25d6f9$export$a46a74202b0efd71)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $f751fc4569ab1c26$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $4119dfe958f9447d$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, $e6532a988c25d6f9$export$a46a74202b0efd71)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $756dc7ccf16f513c$export$9a1f6cf06ac56167),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $f751fc4569ab1c26$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $73498605469193a2$export$a7cfe9131aa06be4)(requestToSign);
                        _e = $f751fc4569ab1c26$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $4119dfe958f9447d$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $756dc7ccf16f513c$export$acf4b8bdf24aab34] = longDate;
                        if (credentials.sessionToken) request.headers[0, $756dc7ccf16f513c$export$fdc81b663012a8d2] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, $e6532a988c25d6f9$export$a46a74202b0efd71)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $d1e4f354e9f919d9$export$17944590be865217)((0, $756dc7ccf16f513c$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $756dc7ccf16f513c$export$eaef12179141669a] = payloadHash;
                        canonicalHeaders = (0, $d1f7a191b42da212$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $756dc7ccf16f513c$export$9924a64a4b8b0d58] = (0, $756dc7ccf16f513c$export$863a63fba5b2ddf5) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $f751fc4569ab1c26$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $0d4f59aa7a8befe9$export$8fea7e63ecd1ddbb)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $756dc7ccf16f513c$export$863a63fba5b2ddf5) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $4119dfe958f9447d$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $f751fc4569ab1c26$var$formatDate = function(now) {
    var longDate = (0, $1d803466dd4db0d2$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $f751fc4569ab1c26$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var $f751fc4569ab1c26$var$normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $f751fc4569ab1c26$var$normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};




function $de5bc339d6480fbe$export$1dd62920de1feabb(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = $de5bc339d6480fbe$var$normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = $de5bc339d6480fbe$var$normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function() {
        return $de5bc339d6480fbe$var$normalizeProvider(input.region)().then(function(region) {
            return (0, $ff221da8c1a04980$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, $ff221da8c1a04980$export$8d051b38c9118094)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            //signing name resolving order:
            //user supplied signingName -> endpoints.json inferred (credential scope -> model arnNamespace) -> model service id
            input.signingName = input.signingName || signingService || input.serviceId;
            return new (0, $f751fc4569ab1c26$export$20baf4d3f65eb30c)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, $ff221da8c1a04980$export$18ce0697a983be9b)((0, $ff221da8c1a04980$export$18ce0697a983be9b)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function $de5bc339d6480fbe$var$normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}




var $f11240e09b9084dd$var$isClockSkewed = function(newServerTime, systemClockOffset) {
    return Math.abs($f11240e09b9084dd$var$getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var $f11240e09b9084dd$var$getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function $f11240e09b9084dd$export$78af9708f8cf3422(options) {
    return function(next, context) {
        return function(args) {
            return (0, $ff221da8c1a04980$export$1050f835b63b671e)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, $ff221da8c1a04980$export$67ebef60e6f28a6)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, $ff221da8c1a04980$export$18ce0697a983be9b)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, $ff221da8c1a04980$export$18ce0697a983be9b).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if ($f11240e09b9084dd$var$isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var $f11240e09b9084dd$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var $f11240e09b9084dd$export$59c2b7ad30ed4046 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($f11240e09b9084dd$export$78af9708f8cf3422(options), $f11240e09b9084dd$export$29f4b3a6e94017d3);
        }
    };
};




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $142c7fc4b8e618eb$var$extendStatics = function(d, b) {
    $142c7fc4b8e618eb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $142c7fc4b8e618eb$var$extendStatics(d, b);
};
function $142c7fc4b8e618eb$export$a8ba968b8961cb8a(d, b) {
    $142c7fc4b8e618eb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $142c7fc4b8e618eb$export$18ce0697a983be9b = function() {
    $142c7fc4b8e618eb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $142c7fc4b8e618eb$export$18ce0697a983be9b.apply(this, arguments);
};
function $142c7fc4b8e618eb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $142c7fc4b8e618eb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $142c7fc4b8e618eb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $142c7fc4b8e618eb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $142c7fc4b8e618eb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $142c7fc4b8e618eb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $142c7fc4b8e618eb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $142c7fc4b8e618eb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $142c7fc4b8e618eb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $142c7fc4b8e618eb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $142c7fc4b8e618eb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($142c7fc4b8e618eb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $142c7fc4b8e618eb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $142c7fc4b8e618eb$export$10c90e4f7922046c(v) {
    return this instanceof $142c7fc4b8e618eb$export$10c90e4f7922046c ? (this.v = v, this) : new $142c7fc4b8e618eb$export$10c90e4f7922046c(v);
}
function $142c7fc4b8e618eb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $142c7fc4b8e618eb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $142c7fc4b8e618eb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $142c7fc4b8e618eb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $142c7fc4b8e618eb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $142c7fc4b8e618eb$export$19a8beecd37a4c45 === "function" ? $142c7fc4b8e618eb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $142c7fc4b8e618eb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $142c7fc4b8e618eb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $142c7fc4b8e618eb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $142c7fc4b8e618eb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $142c7fc4b8e618eb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $db78c77ef8974ed8$export$ec9a2d5663958cb(input) {
    return (0, $142c7fc4b8e618eb$export$18ce0697a983be9b)((0, $142c7fc4b8e618eb$export$18ce0697a983be9b)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}




var $659a0e0d670ca23d$export$97a08a1bb7ee0545 = "user-agent";
var $659a0e0d670ca23d$export$e010e3d6246262a3 = "x-amz-user-agent";
var $659a0e0d670ca23d$export$27b7b95a5fde2b31 = " ";
var $659a0e0d670ca23d$export$92df4a8c4ea32a70 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;


var $7b73a126ebb97ab9$export$62c460923941c0b0 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $142c7fc4b8e618eb$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, $142c7fc4b8e618eb$export$67ebef60e6f28a6)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map($7b73a126ebb97ab9$var$escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map($7b73a126ebb97ab9$var$escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map($7b73a126ebb97ab9$var$escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, $659a0e0d670ca23d$export$e010e3d6246262a3] = (0, $142c7fc4b8e618eb$export$afc72e2116322959)(defaultUserAgent, userAgent, customUserAgent).join((0, $659a0e0d670ca23d$export$27b7b95a5fde2b31));
                            normalUAValue = (0, $142c7fc4b8e618eb$export$afc72e2116322959)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, $659a0e0d670ca23d$export$27b7b95a5fde2b31));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, $659a0e0d670ca23d$export$97a08a1bb7ee0545] = headers[0, $659a0e0d670ca23d$export$97a08a1bb7ee0545] ? headers[0, $659a0e0d670ca23d$export$97a08a1bb7ee0545] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, $142c7fc4b8e618eb$export$18ce0697a983be9b)((0, $142c7fc4b8e618eb$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var $7b73a126ebb97ab9$var$escapeUserAgent = function(_a) {
    var _b = (0, $142c7fc4b8e618eb$export$8d051b38c9118094)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, $659a0e0d670ca23d$export$92df4a8c4ea32a70), "_");
    }).join("/");
};
var $7b73a126ebb97ab9$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var $7b73a126ebb97ab9$export$5393c0d2d7f4f5f0 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($7b73a126ebb97ab9$export$62c460923941c0b0(config), $7b73a126ebb97ab9$export$29eb04da6afef73f);
        }
    };
};





/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */ var $cca6a50e25ba8c66$export$e576def690e850f7 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CognitoIdentityClient, _super);
    function CognitoIdentityClient(configuration) {
        var _this = this;
        var _config_0 = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $6ecb31f2132dc9b9$export$b1f2d721b555a243)), configuration);
        var _config_1 = (0, $b027526b3945190a$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $6aff6722f8b97662$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $de5bc339d6480fbe$export$1dd62920de1feabb)(_config_2);
        var _config_4 = (0, $626ed5f895800a82$export$ca7f6138f2c98476)(_config_3);
        var _config_5 = (0, $c1f22e97875f8f21$export$c1625bf0b32b4481)(_config_4);
        var _config_6 = (0, $db78c77ef8974ed8$export$ec9a2d5663958cb)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $2efb85a1f6a92e50$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $ff4a9738848c11ef$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $c1f22e97875f8f21$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $d7c9db6585161f99$export$f6ef65d7766fc255)(_this.config));
        _this.middlewareStack.use((0, $7b73a126ebb97ab9$export$5393c0d2d7f4f5f0)(_this.config));
        return _this;
    }
    CognitoIdentityClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CognitoIdentityClient;
}((0, $e3a8e149f1290509$export$1f2bb630327ac4b6));



var $fbc557a417764e78$var$__assign = undefined && undefined.__assign || function() {
    $fbc557a417764e78$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fbc557a417764e78$var$__assign.apply(this, arguments);
};
function $fbc557a417764e78$export$4dc42d1682bf6ec4(config) {
    var client = new (0, $cca6a50e25ba8c66$export$e576def690e850f7)({
        region: config.region,
        customUserAgent: (0, $2c4730a78a7bdcd6$export$ede38edb26c0bfdf)()
    });
    client.middlewareStack.add(function(next, _) {
        return function(args) {
            return next($fbc557a417764e78$export$43d5d423bebf581b(args));
        };
    }, {
        step: "build",
        name: "cacheControlMiddleWare"
    });
    return client;
}
function $fbc557a417764e78$export$43d5d423bebf581b(args) {
    return $fbc557a417764e78$var$__assign($fbc557a417764e78$var$__assign({}, args), {
        request: $fbc557a417764e78$var$__assign($fbc557a417764e78$var$__assign({}, args.request), {
            headers: $fbc557a417764e78$var$__assign($fbc557a417764e78$var$__assign({}, args.request.headers), {
                "cache-control": "no-store"
            })
        })
    });
}


var $de9f45d92f772164$var$__assign = undefined && undefined.__assign || function() {
    $de9f45d92f772164$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de9f45d92f772164$var$__assign.apply(this, arguments);
};
var $de9f45d92f772164$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $de9f45d92f772164$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $de9f45d92f772164$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Credentials");
var $de9f45d92f772164$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $de9f45d92f772164$var$COGNITO_IDENTITY_KEY_PREFIX = "CognitoIdentityId-";
var $de9f45d92f772164$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers["google"] = (0, $7dd2573c500c67b1$export$75ace714083c1340).refreshGoogleToken;
        this._refreshHandlers["facebook"] = (0, $7dd2573c500c67b1$export$1b6b8b5328e38349).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return "Credentials";
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $de9f45d92f772164$var$__assign($de9f45d92f772164$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $7a47fb194d2f9787$export$a2bd19c49e4760e8)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $de9f45d92f772164$var$logger.debug("getting credentials");
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "" + $de9f45d92f772164$var$COGNITO_IDENTITY_KEY_PREFIX + identityPoolId;
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $de9f45d92f772164$var$logger.debug("picking up credentials");
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $de9f45d92f772164$var$logger.debug("getting new cred promise");
            this._gettingCredPromise = (0, $28ca6f9027b485a7$export$8f33cb495ca11832)(this._keepAlive());
        } else $de9f45d92f772164$var$logger.debug("getting old cred promise");
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $de9f45d92f772164$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $de9f45d92f772164$var$logger.debug("checking if credentials exists and not expired");
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $de9f45d92f772164$var$logger.debug("credentials not changed and not expired, directly return");
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $de9f45d92f772164$var$logger.debug("need to get a new credential or refresh the existing one");
                        _a = this.Auth, Auth = _a === void 0 ? (0, $36606c730099e1c8$export$a3858a9a153cffc7).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== "function") return [
                            2 /*return*/ ,
                            Promise.reject("No Auth module registered in Amplify")
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $de9f45d92f772164$var$logger.debug("ttl has passed but token is not yet expired");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $de9f45d92f772164$var$logger.debug("Error attempting to refreshing the session", err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $de9f45d92f772164$var$logger.debug("Getting federated credentials");
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $de9f45d92f772164$var$logger.debug("checking if federated jwt token expired");
        if (expires_at > new Date().getTime()) {
            // if not expired
            $de9f45d92f772164$var$logger.debug("token not expired");
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
            $de9f45d92f772164$var$logger.debug("getting refreshed jwt token from federation provider");
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $de9f45d92f772164$var$logger.debug("no refresh handler for provider:", provider);
            this.clear();
            return Promise.reject("no refresh handler for provider");
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $f37409221557361a$export$a24aa7705df9cf44)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $de9f45d92f772164$var$logger.debug("refresh federated token sucessfully", data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === "string" && e.toLowerCase().lastIndexOf("network error", e.length) === 0;
            if (!isNetworkError) _this.clear();
            $de9f45d92f772164$var$logger.debug("refresh federated token failed", e);
            return Promise.reject("refreshing federation token failed: " + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $de9f45d92f772164$var$logger.debug("no credentials for expiration check");
            return true;
        }
        $de9f45d92f772164$var$logger.debug("are these credentials expired?", credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var _a, identityPoolId, region, mandatorySignIn, identityId, _b, cognitoClient, credentials, cognitoIdentityParams, credentialsProvider;
            var _this = this;
            return $de9f45d92f772164$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $de9f45d92f772164$var$logger.debug("setting credentials for guest");
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject("cannot get guest credentials when mandatory signin enabled")
                        ];
                        if (!identityPoolId) {
                            $de9f45d92f772164$var$logger.debug("No Cognito Identity pool provided for unauthenticated access");
                            return [
                                2 /*return*/ ,
                                Promise.reject("No Cognito Identity pool provided for unauthenticated access")
                            ];
                        }
                        if (!region) {
                            $de9f45d92f772164$var$logger.debug("region is not configured for getting the credentials");
                            return [
                                2 /*return*/ ,
                                Promise.reject("region is not configured for getting the credentials")
                            ];
                        }
                        _b = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _b._identityId = _c.sent();
                        cognitoClient = (0, $fbc557a417764e78$export$4dc42d1682bf6ec4)({
                            region: region
                        });
                        credentials = undefined;
                        if (identityId) {
                            cognitoIdentityParams = {
                                identityId: identityId,
                                client: cognitoClient
                            };
                            credentials = (0, $ffed8061a5c2b81f$export$4d624d71eb462130)(cognitoIdentityParams)();
                        } else {
                            credentialsProvider = function() {
                                return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                    return $de9f45d92f772164$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    cognitoClient.send(new (0, $cfc9333b49fd25a9$export$41ceb4ced4f97a44)({
                                                        IdentityPoolId: identityPoolId
                                                    }))
                                                ];
                                            case 1:
                                                IdentityId = _a.sent().IdentityId;
                                                this._identityId = IdentityId;
                                                cognitoIdentityParams = {
                                                    client: cognitoClient,
                                                    identityId: IdentityId
                                                };
                                                credentialsFromCognitoIdentity = (0, $ffed8061a5c2b81f$export$4d624d71eb462130)(cognitoIdentityParams);
                                                return [
                                                    2 /*return*/ ,
                                                    credentialsFromCognitoIdentity()
                                                ];
                                        }
                                    });
                                });
                            };
                            credentials = credentialsProvider().catch(function(err) {
                                return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                    return $de9f45d92f772164$var$__generator(this, function(_a) {
                                        throw err;
                                    });
                                });
                            });
                        }
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                    var credentialsProvider;
                                    var _this = this;
                                    return $de9f45d92f772164$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === "ResourceNotFoundException" && e.message === "Identity '" + identityId + "' not found.")) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                $de9f45d92f772164$var$logger.debug("Failed to load guest credentials");
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                credentialsProvider = function() {
                                                    return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                                        return $de9f45d92f772164$var$__generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        cognitoClient.send(new (0, $cfc9333b49fd25a9$export$41ceb4ced4f97a44)({
                                                                            IdentityPoolId: identityPoolId
                                                                        }))
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    cognitoIdentityParams = {
                                                                        client: cognitoClient,
                                                                        identityId: IdentityId
                                                                    };
                                                                    credentialsFromCognitoIdentity = (0, $ffed8061a5c2b81f$export$4d624d71eb462130)(cognitoIdentityParams);
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        credentialsFromCognitoIdentity()
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = credentialsProvider().catch(function(err) {
                                                    return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                                        return $de9f45d92f772164$var$__generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, "guest", false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id;
        var domains = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject("You must specify a federated provider");
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            $de9f45d92f772164$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!region) {
            $de9f45d92f772164$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var cognitoClient = (0, $fbc557a417764e78$export$4dc42d1682bf6ec4)({
            region: region
        });
        var credentials = undefined;
        if (identity_id) {
            var cognitoIdentityParams = {
                identityId: identity_id,
                logins: logins,
                client: cognitoClient
            };
            credentials = (0, $ffed8061a5c2b81f$export$4d624d71eb462130)(cognitoIdentityParams)();
        } else {
            var cognitoIdentityParams = {
                logins: logins,
                identityPoolId: identityPoolId,
                client: cognitoClient
            };
            credentials = (0, $416e6c5617707f9e$export$6c7d622e9507a2e)(cognitoIdentityParams)();
        }
        return this._loadCredentials(credentials, "federated", true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $de9f45d92f772164$var$logger.debug("set credentials from session");
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            $de9f45d92f772164$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!region) {
            $de9f45d92f772164$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoClient = (0, $fbc557a417764e78$export$4dc42d1682bf6ec4)({
            region: region
        });
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return $de9f45d92f772164$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                cognitoClient.send(new (0, $cfc9333b49fd25a9$export$41ceb4ced4f97a44)({
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                }))
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                cognitoClient.send(new (0, $9fc70c4868f3b336$export$e08b3308c36761ec)({
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                }))
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            $de9f45d92f772164$var$logger.debug("The guest identity " + guestIdentityId + " has been successfully linked to the logins");
                            if (guestIdentityId === primaryIdentityId) $de9f45d92f772164$var$logger.debug("The guest identity " + guestIdentityId + " has become the primary identity");
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                return $de9f45d92f772164$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "userPool", true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return $de9f45d92f772164$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $de9f45d92f772164$var$logger.debug("Load credentials successfully", credentials);
                                if (this._identityId && !credentials.identityId) credentials["identityId"] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $de9f45d92f772164$var$CREDENTIALS_TTL;
                                if (source === "federated") {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $de9f45d92f772164$var$logger.debug("Failed to put federated info into auth storage", e);
                                    }
                                }
                                if (!(source === "guest")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $de9f45d92f772164$var$logger.debug("Failed to load credentials", credentials);
                    $de9f45d92f772164$var$logger.debug("Error loading credentials", err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === "session") return this._setCredentialsFromSession(params);
        else if (source === "federation") return this._setCredentialsFromFederation(params);
        else if (source === "guest") return this._setCredentialsForGuest();
        else {
            $de9f45d92f772164$var$logger.debug("no source specified for setting credentials");
            return Promise.reject("invalid source");
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $de9f45d92f772164$var$logger.debug("removing aws-amplify-federatedInfo from storage");
                this._storage.removeItem("aws-amplify-federatedInfo");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        $de9f45d92f772164$var$logger.debug("Failed to get the cached guest identityId", e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        $de9f45d92f772164$var$logger.debug("Failed to cache guest identityId", e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                $de9f45d92f772164$var$logger.debug("removing " + this._getCognitoIdentityIdStorageKey(identityPoolId) + " from storage");
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $de9f45d92f772164$export$a9627919734faa48 = new $de9f45d92f772164$export$9be509043bd0c09a(null);
(0, $36606c730099e1c8$export$a3858a9a153cffc7).register($de9f45d92f772164$export$a9627919734faa48);
var /**
 * @deprecated use named import
 */ $de9f45d92f772164$export$2e2bcd8739ae039 = $de9f45d92f772164$export$a9627919734faa48;


/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 


/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var $88fb3af5ba4cdf42$export$efa87b877bb98f58 = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("ServiceWorker");
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = "/service-worker.js";
        if (scope === void 0) scope = "/";
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function(resolve, reject) {
            if (navigator && "serviceWorker" in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: " + registration);
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed " + error);
                return reject(error);
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error("Service Worker not registered");
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = "=".repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === "object" ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener("statechange", function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if ((0, $36606c730099e1c8$export$a3858a9a153cffc7).Analytics && typeof (0, $36606c730099e1c8$export$a3858a9a153cffc7).Analytics.record === "function") (0, $36606c730099e1c8$export$a3858a9a153cffc7).Analytics.record({
                name: "ServiceWorker",
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener("message", function(event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}();
var /**
 * @deprecated use named import
 */ $88fb3af5ba4cdf42$export$2e2bcd8739ae039 = $88fb3af5ba4cdf42$export$efa87b877bb98f58;



/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $b8b4115605c878ec$export$98e6a39c04603d36;
var $b8b4115605c878ec$export$dfdc1655ccc5b9cb;
"use strict";
$b8b4115605c878ec$export$98e6a39c04603d36 = $b8b4115605c878ec$var$parse;
$b8b4115605c878ec$export$dfdc1655ccc5b9cb = $b8b4115605c878ec$var$serialize;
/**
 * Module variables.
 * @private
 */ var $b8b4115605c878ec$var$decode = decodeURIComponent;
var $b8b4115605c878ec$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $b8b4115605c878ec$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $b8b4115605c878ec$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $b8b4115605c878ec$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $b8b4115605c878ec$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $b8b4115605c878ec$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $b8b4115605c878ec$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$b8b4115605c878ec$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$b8b4115605c878ec$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$b8b4115605c878ec$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$b8b4115605c878ec$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $b8b4115605c878ec$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $fdf7998ace1a9ccf$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function $fdf7998ace1a9ccf$export$bfce569af136abdc() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function $fdf7998ace1a9ccf$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === "string") return $b8b4115605c878ec$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function $fdf7998ace1a9ccf$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function $fdf7998ace1a9ccf$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $fdf7998ace1a9ccf$var$cleanupCookieValue(value);
    if ($fdf7998ace1a9ccf$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $fdf7998ace1a9ccf$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}


var $1563e9259f492e76$var$__assign = undefined && undefined.__assign || function() {
    $1563e9259f492e76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1563e9259f492e76$var$__assign.apply(this, arguments);
};
var $1563e9259f492e76$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $fdf7998ace1a9ccf$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $fdf7998ace1a9ccf$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $b8b4115605c878ec$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $b8b4115605c878ec$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $1563e9259f492e76$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $b8b4115605c878ec$export$dfdc1655ccc5b9cb(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $1563e9259f492e76$export$2e2bcd8739ae039 = $1563e9259f492e76$var$Cookies;


var $9814bc57a8c0985e$export$2e2bcd8739ae039 = (0, $1563e9259f492e76$export$2e2bcd8739ae039);



var $68a581920a34423d$var$isBrowser = (0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser;
var $68a581920a34423d$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)();
        this.store = $68a581920a34423d$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)(context.req.headers.cookie) : new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: true,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: "/"
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split(".").pop();
        switch(tokenType){
            // LastAuthUser is needed for computing other key names
            case "LastAuthUser":
            // accessToken is required for CognitoUserSession
            case "accessToken":
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            case "refreshToken":
            // Required for CognitoUserSession
            case "idToken":
                $68a581920a34423d$var$isBrowser ? this.setUniversalItem(key, value) : this.setLocalItem(key, value);
        }
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value) {
        this.cookies.set(key, value, {
            path: "/",
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: window.location.hostname === "localhost" ? false : true
        });
    };
    return UniversalStorage;
}();



function $571068c73bf08655$export$b855308a44508212(str) {
    return str.split("").map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, "0");
    }).join("");
}
function $571068c73bf08655$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join("");
}


var $1a573b73ffb0f9d8$export$a002182e51710d39 = {
    userAgent: (0, $2c4730a78a7bdcd6$export$2dffd0b5373a4389).userAgent
};
var /**
 * @deprecated use named import
 */ $1a573b73ffb0f9d8$export$2e2bcd8739ae039 = (0, $36606c730099e1c8$export$a3858a9a153cffc7);


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *	 http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $d71e9f4e74f3bfef$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($d71e9f4e74f3bfef$export$eeb013770cb92342 || ($d71e9f4e74f3bfef$export$eeb013770cb92342 = {}));
function $d71e9f4e74f3bfef$export$9b905d6895bdc426(obj) {
    var keys = [
        "provider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $d71e9f4e74f3bfef$export$828f8efbdf71714b(obj) {
    var keys = [
        "customProvider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $d71e9f4e74f3bfef$export$6bae5520ca265d22(obj) {
    var keys = [
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $d71e9f4e74f3bfef$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $d71e9f4e74f3bfef$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})($d71e9f4e74f3bfef$export$edb367c0a140d3db || ($d71e9f4e74f3bfef$export$edb367c0a140d3db = {}));
function $d71e9f4e74f3bfef$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}
var $d71e9f4e74f3bfef$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($d71e9f4e74f3bfef$export$cfce9c15015bef96 || ($d71e9f4e74f3bfef$export$cfce9c15015bef96 = {}));



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $010becf709f0452a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $7fb856e564cccfe9$export$a143d493d941bafc;
var $7fb856e564cccfe9$export$e4cf37d7f6fb9e0a;
var $7fb856e564cccfe9$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $7fb856e564cccfe9$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $a7bbd831b0dbced9$exports = {};
var $a7bbd831b0dbced9$var$toString = {}.toString;
$a7bbd831b0dbced9$exports = Array.isArray || function(arr) {
    return $a7bbd831b0dbced9$var$toString.call(arr) == "[object Array]";
};


$7fb856e564cccfe9$export$a143d493d941bafc = $7fb856e564cccfe9$var$Buffer;
$7fb856e564cccfe9$export$e4cf37d7f6fb9e0a = $7fb856e564cccfe9$var$SlowBuffer;
$7fb856e564cccfe9$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $7fb856e564cccfe9$var$typedArraySupport();
$7fb856e564cccfe9$export$599f31c3813fae4d = $7fb856e564cccfe9$var$kMaxLength();
function $7fb856e564cccfe9$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $7fb856e564cccfe9$var$kMaxLength() {
    return $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $7fb856e564cccfe9$var$createBuffer(that, length) {
    if ($7fb856e564cccfe9$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $7fb856e564cccfe9$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length) {
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $7fb856e564cccfe9$var$Buffer)) return new $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $7fb856e564cccfe9$var$allocUnsafe(this, arg);
    }
    return $7fb856e564cccfe9$var$from(this, arg, encodingOrOffset, length);
}
$7fb856e564cccfe9$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$7fb856e564cccfe9$var$Buffer._augment = function(arr) {
    arr.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    return arr;
};
function $7fb856e564cccfe9$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $7fb856e564cccfe9$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $7fb856e564cccfe9$var$fromString(that, value, encodingOrOffset);
    return $7fb856e564cccfe9$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7fb856e564cccfe9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7fb856e564cccfe9$var$from(null, value, encodingOrOffset, length);
};
if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $7fb856e564cccfe9$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $7fb856e564cccfe9$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $7fb856e564cccfe9$var$Buffer[Symbol.species] === $7fb856e564cccfe9$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($7fb856e564cccfe9$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $7fb856e564cccfe9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $7fb856e564cccfe9$var$alloc(that, size, fill, encoding) {
    $7fb856e564cccfe9$var$assertSize(size);
    if (size <= 0) return $7fb856e564cccfe9$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill, encoding) : $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill);
    return $7fb856e564cccfe9$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7fb856e564cccfe9$var$Buffer.alloc = function(size, fill, encoding) {
    return $7fb856e564cccfe9$var$alloc(null, size, fill, encoding);
};
function $7fb856e564cccfe9$var$allocUnsafe(that, size) {
    $7fb856e564cccfe9$var$assertSize(size);
    that = $7fb856e564cccfe9$var$createBuffer(that, size < 0 ? 0 : $7fb856e564cccfe9$var$checked(size) | 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7fb856e564cccfe9$var$Buffer.allocUnsafe = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7fb856e564cccfe9$var$Buffer.allocUnsafeSlow = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
function $7fb856e564cccfe9$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $7fb856e564cccfe9$var$byteLength(string, encoding) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $7fb856e564cccfe9$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $7fb856e564cccfe9$var$checked(array.length) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $7fb856e564cccfe9$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $7fb856e564cccfe9$var$fromArrayLike(that, array);
    return that;
}
function $7fb856e564cccfe9$var$fromObject(that, obj) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(obj)) {
        var len = $7fb856e564cccfe9$var$checked(obj.length) | 0;
        that = $7fb856e564cccfe9$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $7fb856e564cccfe9$var$isnan(obj.length)) return $7fb856e564cccfe9$var$createBuffer(that, 0);
            return $7fb856e564cccfe9$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $a7bbd831b0dbced9$exports(obj.data)) return $7fb856e564cccfe9$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $7fb856e564cccfe9$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7fb856e564cccfe9$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7fb856e564cccfe9$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $7fb856e564cccfe9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7fb856e564cccfe9$var$Buffer.alloc(+length);
}
$7fb856e564cccfe9$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$7fb856e564cccfe9$var$Buffer.compare = function compare(a, b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(a) || !$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7fb856e564cccfe9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$7fb856e564cccfe9$var$Buffer.concat = function concat(list, length) {
    if (!$a7bbd831b0dbced9$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7fb856e564cccfe9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $7fb856e564cccfe9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7fb856e564cccfe9$var$byteLength(string, encoding) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $7fb856e564cccfe9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $7fb856e564cccfe9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $7fb856e564cccfe9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7fb856e564cccfe9$var$Buffer.byteLength = $7fb856e564cccfe9$var$byteLength;
function $7fb856e564cccfe9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $7fb856e564cccfe9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $7fb856e564cccfe9$var$utf8Slice(this, start, end);
        case "ascii":
            return $7fb856e564cccfe9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $7fb856e564cccfe9$var$latin1Slice(this, start, end);
        case "base64":
            return $7fb856e564cccfe9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7fb856e564cccfe9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$7fb856e564cccfe9$var$Buffer.prototype._isBuffer = true;
function $7fb856e564cccfe9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7fb856e564cccfe9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$7fb856e564cccfe9$var$swap(this, i, i + 1);
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $7fb856e564cccfe9$var$swap(this, i, i + 3);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $7fb856e564cccfe9$var$swap(this, i, i + 7);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 6);
        $7fb856e564cccfe9$var$swap(this, i + 2, i + 5);
        $7fb856e564cccfe9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $7fb856e564cccfe9$var$utf8Slice(this, 0, length);
    return $7fb856e564cccfe9$var$slowToString.apply(this, arguments);
};
$7fb856e564cccfe9$var$Buffer.prototype.equals = function equals(b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $7fb856e564cccfe9$var$Buffer.compare(this, b) === 0;
};
$7fb856e564cccfe9$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $7fb856e564cccfe9$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$7fb856e564cccfe9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7fb856e564cccfe9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $7fb856e564cccfe9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $7fb856e564cccfe9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7fb856e564cccfe9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7fb856e564cccfe9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7fb856e564cccfe9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7fb856e564cccfe9$var$utf8Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$asciiToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$latin1Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length);
}
function $7fb856e564cccfe9$var$base64Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$base64ToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$ucs2Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7fb856e564cccfe9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $7fb856e564cccfe9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $7fb856e564cccfe9$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $7fb856e564cccfe9$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $7fb856e564cccfe9$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $7fb856e564cccfe9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7fb856e564cccfe9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7fb856e564cccfe9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7fb856e564cccfe9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $7fb856e564cccfe9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7fb856e564cccfe9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7fb856e564cccfe9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7fb856e564cccfe9$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7fb856e564cccfe9$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7fb856e564cccfe9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $7fb856e564cccfe9$var$toHex(buf[i]);
    return out;
}
function $7fb856e564cccfe9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7fb856e564cccfe9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $7fb856e564cccfe9$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7fb856e564cccfe9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$7fb856e564cccfe9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $7fb856e564cccfe9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $7fb856e564cccfe9$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $7fb856e564cccfe9$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $7fb856e564cccfe9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, false, noAssert);
};
function $7fb856e564cccfe9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7fb856e564cccfe9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7fb856e564cccfe9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $7fb856e564cccfe9$var$Buffer.isBuffer(val) ? val : $7fb856e564cccfe9$var$utf8ToBytes(new $7fb856e564cccfe9$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $7fb856e564cccfe9$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $7fb856e564cccfe9$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $7fb856e564cccfe9$var$stringtrim(str).replace($7fb856e564cccfe9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $7fb856e564cccfe9$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $7fb856e564cccfe9$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $7fb856e564cccfe9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $7fb856e564cccfe9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7fb856e564cccfe9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7fb856e564cccfe9$var$base64ToBytes(str) {
    return $kuxul.toByteArray($7fb856e564cccfe9$var$base64clean(str));
}
function $7fb856e564cccfe9$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $7fb856e564cccfe9$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}



var $3OBZa = parcelRequire("3OBZa");
parcelRequire("dOqqi");

var $dCBbD = parcelRequire("dCBbD");

var $WS9F7 = parcelRequire("WS9F7");
var $b1d17d9b5b43e6ab$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $b1d17d9b5b43e6ab$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof window !== "undefined" && window.msCrypto) $b1d17d9b5b43e6ab$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $b1d17d9b5b43e6ab$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$b1d17d9b5b43e6ab$var$crypto && true) try {
    $b1d17d9b5b43e6ab$var$crypto = (parcelRequire("kjyEk"));
} catch (err) {}
function $b1d17d9b5b43e6ab$export$2e2bcd8739ae039() {
    if ($b1d17d9b5b43e6ab$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.getRandomValues === "function") try {
            return $b1d17d9b5b43e6ab$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.randomBytes === "function") try {
            return $b1d17d9b5b43e6ab$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $604987de3d14fe69$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $604987de3d14fe69$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $b1d17d9b5b43e6ab$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $604987de3d14fe69$var$hexStringify(this);
    };
    return WordArray;
}();


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $4cdeaf8f1e22336b$export$2e2bcd8739ae039 = $4cdeaf8f1e22336b$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $4cdeaf8f1e22336b$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $4cdeaf8f1e22336b$var$nbi() {
    return new $4cdeaf8f1e22336b$var$BigInteger(null);
}
// Bits per digit
var $4cdeaf8f1e22336b$var$dbits;
// JavaScript engine analysis
var $4cdeaf8f1e22336b$var$canary = 0xdeadbeefcafe;
var $4cdeaf8f1e22336b$var$j_lm = ($4cdeaf8f1e22336b$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $4cdeaf8f1e22336b$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $4cdeaf8f1e22336b$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $4cdeaf8f1e22336b$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $4cdeaf8f1e22336b$var$inBrowser = typeof navigator !== "undefined";
if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am2;
    $4cdeaf8f1e22336b$var$dbits = 30;
} else if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName != "Netscape") {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am1;
    $4cdeaf8f1e22336b$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am3;
    $4cdeaf8f1e22336b$var$dbits = 28;
}
$4cdeaf8f1e22336b$var$BigInteger.prototype.DB = $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DM = (1 << $4cdeaf8f1e22336b$var$dbits) - 1;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DV = 1 << $4cdeaf8f1e22336b$var$dbits;
var $4cdeaf8f1e22336b$var$BI_FP = 52;
$4cdeaf8f1e22336b$var$BigInteger.prototype.FV = Math.pow(2, $4cdeaf8f1e22336b$var$BI_FP);
$4cdeaf8f1e22336b$var$BigInteger.prototype.F1 = $4cdeaf8f1e22336b$var$BI_FP - $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.F2 = 2 * $4cdeaf8f1e22336b$var$dbits - $4cdeaf8f1e22336b$var$BI_FP;
// Digit conversions
var $4cdeaf8f1e22336b$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $4cdeaf8f1e22336b$var$BI_RC = new Array();
var $4cdeaf8f1e22336b$var$rr, $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "0".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 0; $4cdeaf8f1e22336b$var$vv <= 9; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "a".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "A".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
function $4cdeaf8f1e22336b$var$int2char(n) {
    return $4cdeaf8f1e22336b$var$BI_RM.charAt(n);
}
function $4cdeaf8f1e22336b$var$intAt(s, i) {
    var c = $4cdeaf8f1e22336b$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $4cdeaf8f1e22336b$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $4cdeaf8f1e22336b$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $4cdeaf8f1e22336b$var$nbv(i) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $4cdeaf8f1e22336b$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $4cdeaf8f1e22336b$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $4cdeaf8f1e22336b$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $4cdeaf8f1e22336b$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $4cdeaf8f1e22336b$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $4cdeaf8f1e22336b$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $4cdeaf8f1e22336b$var$bnNegate() {
    var r = $4cdeaf8f1e22336b$var$nbi();
    $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $4cdeaf8f1e22336b$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $4cdeaf8f1e22336b$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $4cdeaf8f1e22336b$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $4cdeaf8f1e22336b$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $4cdeaf8f1e22336b$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $4cdeaf8f1e22336b$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $4cdeaf8f1e22336b$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $4cdeaf8f1e22336b$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $4cdeaf8f1e22336b$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $4cdeaf8f1e22336b$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $4cdeaf8f1e22336b$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $4cdeaf8f1e22336b$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $4cdeaf8f1e22336b$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $4cdeaf8f1e22336b$var$nbi();
    var y = $4cdeaf8f1e22336b$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $4cdeaf8f1e22336b$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $4cdeaf8f1e22336b$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $4cdeaf8f1e22336b$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $4cdeaf8f1e22336b$var$bnMod(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $4cdeaf8f1e22336b$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $4cdeaf8f1e22336b$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $4cdeaf8f1e22336b$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $4cdeaf8f1e22336b$var$bnAdd(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $4cdeaf8f1e22336b$var$bnSubtract(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $4cdeaf8f1e22336b$var$bnMultiply(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $4cdeaf8f1e22336b$var$bnDivide(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $4cdeaf8f1e22336b$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $4cdeaf8f1e22336b$var$montConvert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $4cdeaf8f1e22336b$var$montRevert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $4cdeaf8f1e22336b$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $4cdeaf8f1e22336b$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $4cdeaf8f1e22336b$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$4cdeaf8f1e22336b$var$Montgomery.prototype.convert = $4cdeaf8f1e22336b$var$montConvert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.revert = $4cdeaf8f1e22336b$var$montRevert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.reduce = $4cdeaf8f1e22336b$var$montReduce;
$4cdeaf8f1e22336b$var$Montgomery.prototype.mulTo = $4cdeaf8f1e22336b$var$montMulTo;
$4cdeaf8f1e22336b$var$Montgomery.prototype.sqrTo = $4cdeaf8f1e22336b$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $4cdeaf8f1e22336b$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $4cdeaf8f1e22336b$var$nbv(1), z = new $4cdeaf8f1e22336b$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $4cdeaf8f1e22336b$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $4cdeaf8f1e22336b$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $4cdeaf8f1e22336b$var$nbi(), t;
    i = $4cdeaf8f1e22336b$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$4cdeaf8f1e22336b$var$BigInteger.prototype.copyTo = $4cdeaf8f1e22336b$var$bnpCopyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromInt = $4cdeaf8f1e22336b$var$bnpFromInt;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromString = $4cdeaf8f1e22336b$var$bnpFromString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.clamp = $4cdeaf8f1e22336b$var$bnpClamp;
$4cdeaf8f1e22336b$var$BigInteger.prototype.dlShiftTo = $4cdeaf8f1e22336b$var$bnpDLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.drShiftTo = $4cdeaf8f1e22336b$var$bnpDRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.lShiftTo = $4cdeaf8f1e22336b$var$bnpLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.rShiftTo = $4cdeaf8f1e22336b$var$bnpRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subTo = $4cdeaf8f1e22336b$var$bnpSubTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiplyTo = $4cdeaf8f1e22336b$var$bnpMultiplyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.squareTo = $4cdeaf8f1e22336b$var$bnpSquareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divRemTo = $4cdeaf8f1e22336b$var$bnpDivRemTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.invDigit = $4cdeaf8f1e22336b$var$bnpInvDigit;
$4cdeaf8f1e22336b$var$BigInteger.prototype.addTo = $4cdeaf8f1e22336b$var$bnpAddTo;
// public
$4cdeaf8f1e22336b$var$BigInteger.prototype.toString = $4cdeaf8f1e22336b$var$bnToString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.negate = $4cdeaf8f1e22336b$var$bnNegate;
$4cdeaf8f1e22336b$var$BigInteger.prototype.abs = $4cdeaf8f1e22336b$var$bnAbs;
$4cdeaf8f1e22336b$var$BigInteger.prototype.compareTo = $4cdeaf8f1e22336b$var$bnCompareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.bitLength = $4cdeaf8f1e22336b$var$bnBitLength;
$4cdeaf8f1e22336b$var$BigInteger.prototype.mod = $4cdeaf8f1e22336b$var$bnMod;
$4cdeaf8f1e22336b$var$BigInteger.prototype.equals = $4cdeaf8f1e22336b$var$bnEquals;
$4cdeaf8f1e22336b$var$BigInteger.prototype.add = $4cdeaf8f1e22336b$var$bnAdd;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subtract = $4cdeaf8f1e22336b$var$bnSubtract;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiply = $4cdeaf8f1e22336b$var$bnMultiply;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divide = $4cdeaf8f1e22336b$var$bnDivide;
$4cdeaf8f1e22336b$var$BigInteger.prototype.modPow = $4cdeaf8f1e22336b$var$bnModPow;
// "constants"
$4cdeaf8f1e22336b$var$BigInteger.ZERO = $4cdeaf8f1e22336b$var$nbv(0);
$4cdeaf8f1e22336b$var$BigInteger.ONE = $4cdeaf8f1e22336b$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $80fee53f057853d0$var$randomBytes(nBytes) {
    return (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(new (0, $604987de3d14fe69$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $80fee53f057853d0$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $80fee53f057853d0$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $80fee53f057853d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)($80fee53f057853d0$var$initN, 16);
        this.g = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $7fb856e564cccfe9$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $80fee53f057853d0$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $80fee53f057853d0$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $80fee53f057853d0$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $7fb856e564cccfe9$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($dCBbD)))(str).toString();
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]));
        var ikmWordArray = ikm instanceof (0, $7fb856e564cccfe9$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $7fb856e564cccfe9$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(infoBitsWordArray, prk);
        return (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(hmac.toString(), "hex").slice(0, 16);
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $80fee53f057853d0$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $3ebef4e0e2340f79$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $8281217ccf88c1bf$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8281217ccf88c1bf$var$_setPrototypeOf(subClass, superClass);
}
function $8281217ccf88c1bf$var$_setPrototypeOf(o, p) {
    $8281217ccf88c1bf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8281217ccf88c1bf$var$_setPrototypeOf(o, p);
}
/** @class */ var $8281217ccf88c1bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8281217ccf88c1bf$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $3ebef4e0e2340f79$export$2e2bcd8739ae039));



function $8eb7209a41983bfc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8eb7209a41983bfc$var$_setPrototypeOf(subClass, superClass);
}
function $8eb7209a41983bfc$var$_setPrototypeOf(o, p) {
    $8eb7209a41983bfc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8eb7209a41983bfc$var$_setPrototypeOf(o, p);
}
/** @class */ var $8eb7209a41983bfc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8eb7209a41983bfc$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $3ebef4e0e2340f79$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $c59d7f07074bc9f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $3OBZa = parcelRequire("3OBZa");
parcelRequire("dOqqi");

var $33Dov = parcelRequire("33Dov");

var $WS9F7 = parcelRequire("WS9F7");





/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $82508fd376aeac3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a942b99a35e53a72$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $a942b99a35e53a72$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $a942b99a35e53a72$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $a942b99a35e53a72$var$weekNames[now.getUTCDay()];
        var month = $a942b99a35e53a72$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $38555859a52f4863$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a337e11db75e0691$var$dataMemory = {};
var $a337e11db75e0691$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $a337e11db75e0691$var$dataMemory[key] = value;
        return $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($a337e11db75e0691$var$dataMemory, key) ? $a337e11db75e0691$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $a337e11db75e0691$var$dataMemory = {};
        return $a337e11db75e0691$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $a337e11db75e0691$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $a337e11db75e0691$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $737214f2f07cda56$var$isBrowser = typeof navigator !== "undefined";
var $737214f2f07cda56$var$userAgent = $737214f2f07cda56$var$isBrowser ? navigator.userAgent : "nodejs";
/** @class */ var $737214f2f07cda56$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $a337e11db75e0691$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $a942b99a35e53a72$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $737214f2f07cda56$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $a942b99a35e53a72$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $737214f2f07cda56$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $38555859a52f4863$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload2 = token.decodePayload(), origin_jti = _token$decodePayload2.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $436950a2454b4407$exports = {};


$436950a2454b4407$exports = self.fetch || (self.fetch = (parcelRequire("laOt8")).default || (parcelRequire("laOt8")));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $09728a2d1518e4a6$export$83d89fbfd8236492 = "5.0.4";


var $d09126a5f5299c10$var$BASE_USER_AGENT = "aws-amplify/" + (0, $09728a2d1518e4a6$export$83d89fbfd8236492);
var $d09126a5f5299c10$export$2dffd0b5373a4389 = {
    userAgent: $d09126a5f5299c10$var$BASE_USER_AGENT + " js",
    product: "",
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== "undefined" && navigator.product) {
    $d09126a5f5299c10$export$2dffd0b5373a4389.product = navigator.product || "";
    $d09126a5f5299c10$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case "ReactNative":
            $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent = $d09126a5f5299c10$var$BASE_USER_AGENT + " react-native";
            $d09126a5f5299c10$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent = $d09126a5f5299c10$var$BASE_USER_AGENT + " js";
            $d09126a5f5299c10$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $d09126a5f5299c10$export$7935961ef7719cb0 = function getUserAgent() {
    return $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $d09126a5f5299c10$export$2e2bcd8739ae039 = $d09126a5f5299c10$export$2dffd0b5373a4389;


// constructor
function $68caf4bd6c7da8b9$var$UserAgent() {}
// public
$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = (0, $d09126a5f5299c10$export$7935961ef7719cb0)();
var $68caf4bd6c7da8b9$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent && !$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.includes(content)) $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent || $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent === "") $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = content;
};
var // class for defining the amzn user-agent
$68caf4bd6c7da8b9$export$2e2bcd8739ae039 = $68caf4bd6c7da8b9$var$UserAgent;


function $bb0b3502dd43cbf5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $bb0b3502dd43cbf5$var$_setPrototypeOf(subClass, superClass);
}
function $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb0b3502dd43cbf5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb0b3502dd43cbf5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb0b3502dd43cbf5$var$_construct(Class, arguments, $bb0b3502dd43cbf5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb0b3502dd43cbf5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class);
}
function $bb0b3502dd43cbf5$var$_construct(Parent, args, Class) {
    if ($bb0b3502dd43cbf5$var$_isNativeReflectConstruct()) $bb0b3502dd43cbf5$var$_construct = Reflect.construct.bind();
    else $bb0b3502dd43cbf5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb0b3502dd43cbf5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb0b3502dd43cbf5$var$_construct.apply(null, arguments);
}
function $bb0b3502dd43cbf5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb0b3502dd43cbf5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p) {
    $bb0b3502dd43cbf5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p);
}
function $bb0b3502dd43cbf5$var$_getPrototypeOf(o) {
    $bb0b3502dd43cbf5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb0b3502dd43cbf5$var$_getPrototypeOf(o);
}
var $bb0b3502dd43cbf5$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
/** @class */ var $bb0b3502dd43cbf5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $bb0b3502dd43cbf5$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $bb0b3502dd43cbf5$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $68caf4bd6c7da8b9$export$2e2bcd8739ae039).prototype.userAgent,
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $bb0b3502dd43cbf5$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $bb0b3502dd43cbf5$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
var $bb0b3502dd43cbf5$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $bb0b3502dd43cbf5$var$logger.debug("error on " + functionToRetry.name, err);
        if ($bb0b3502dd43cbf5$var$isNonRetryableError(err)) {
            $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $bb0b3502dd43cbf5$var$MAX_DELAY_MS = 300000;
function $bb0b3502dd43cbf5$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $bb0b3502dd43cbf5$var$MAX_DELAY_MS;
    return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs));
}




var $b355f5e976985f5d$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $b355f5e976985f5d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $b355f5e976985f5d$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $bb0b3502dd43cbf5$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $a337e11db75e0691$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $ae921eff144f1916$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $ae921eff144f1916$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $d2150fd716ee36a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error("The domain of cookieStorage can not be undefined.");
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $ae921eff144f1916$exports.set(key, value, options);
        return $ae921eff144f1916$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $ae921eff144f1916$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $ae921eff144f1916$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $ae921eff144f1916$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();








var $biuEp = parcelRequire("biuEp");
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $biuEp = parcelRequire("biuEp");
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $32e7ded170a35dd0$var$SELF = "_self";
var $32e7ded170a35dd0$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $32e7ded170a35dd0$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $eb5688ac97e97bd7$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem("oauth_state", state);
};
var $eb5688ac97e97bd7$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem("oauth_state");
    window.sessionStorage.removeItem("oauth_state");
    return oauth_state;
};
var $eb5688ac97e97bd7$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var $eb5688ac97e97bd7$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
    window.sessionStorage.removeItem("ouath_pkce_key");
    return ouath_pkce_key;
};
var $eb5688ac97e97bd7$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem("ouath_pkce_key");
    window.sessionStorage.removeItem("oauth_state");
};





var $dCBbD = parcelRequire("dCBbD");

var $33Dov = parcelRequire("33Dov");
var $f5a1b2886f9afa8c$var$__assign = undefined && undefined.__assign || function() {
    $f5a1b2886f9afa8c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5a1b2886f9afa8c$var$__assign.apply(this, arguments);
};
var $f5a1b2886f9afa8c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f5a1b2886f9afa8c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f5a1b2886f9afa8c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f5a1b2886f9afa8c$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $f5a1b2886f9afa8c$var$dispatchAuthEvent = function(event, data, message) {
    (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $f5a1b2886f9afa8c$var$AMPLIFY_SYMBOL);
};
var $f5a1b2886f9afa8c$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("OAuth");
var $f5a1b2886f9afa8c$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $32e7ded170a35dd0$export$9b38228bd9928080);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error("scopes must be a String Array");
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === "string";
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = "code";
        if (provider === void 0) provider = (0, $d71e9f4e74f3bfef$export$eeb013770cb92342).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $571068c73bf08655$export$b855308a44508212)(customState) : generatedState;
        $eb5688ac97e97bd7$export$42fffed799c298bb(state);
        var pkce_key = this._generateRandom(128);
        $eb5688ac97e97bd7$export$14934cb45d589fa1(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = "S256";
        var scopesString = this._scopes.join(" ");
        var queryString = Object.entries($f5a1b2886f9afa8c$var$__assign($f5a1b2886f9afa8c$var$__assign({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === "code" ? {
            code_challenge: code_challenge
        } : {}), responseType === "code" ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = $f5a1b2886f9afa8c$var$__read(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join("&");
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $f5a1b2886f9afa8c$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return $f5a1b2886f9afa8c$var$__awaiter(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, _a, access_token, refresh_token, id_token, error;
            return $f5a1b2886f9afa8c$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        code = ((0, $biuEp.parse)(currentUrl).query || "").split("&").map(function(pairings) {
                            return pairings.split("=");
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = $f5a1b2886f9afa8c$var$__read(_a, 2), k = _c[0], v = _c[1];
                            return $f5a1b2886f9afa8c$var$__assign($f5a1b2886f9afa8c$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, $biuEp.parse)(currentUrl).pathname || "/";
                        redirectSignInPathname = (0, $biuEp.parse)(this._config.redirectSignIn).pathname || "/";
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
                        $f5a1b2886f9afa8c$var$dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $eb5688ac97e97bd7$export$742ac7ded61fbfce();
                        oAuthTokenBody = $f5a1b2886f9afa8c$var$__assign({
                            grant_type: "authorization_code",
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $f5a1b2886f9afa8c$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = $f5a1b2886f9afa8c$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join("&");
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _b.sent().json()
                        ];
                    case 2:
                        _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return $f5a1b2886f9afa8c$var$__awaiter(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return $f5a1b2886f9afa8c$var$__generator(this, function(_b) {
                _a = ((0, $biuEp.parse)(currentUrl).hash || "#").substr(1) // Remove # from returned code
                .split("&").map(function(pairings) {
                    return pairings.split("=");
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = $f5a1b2886f9afa8c$var$__read(_a, 2), k = _c[0], v = _c[1];
                    return $f5a1b2886f9afa8c$var$__assign($f5a1b2886f9afa8c$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $f5a1b2886f9afa8c$var$dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
                $f5a1b2886f9afa8c$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return $f5a1b2886f9afa8c$var$__awaiter(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return $f5a1b2886f9afa8c$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? $f5a1b2886f9afa8c$var$__assign($f5a1b2886f9afa8c$var$__assign({}, ((0, $biuEp.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = $f5a1b2886f9afa8c$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $biuEp.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = $f5a1b2886f9afa8c$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $f5a1b2886f9afa8c$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === "code")) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            $f5a1b2886f9afa8c$var$__assign.apply(void 0, [
                                $f5a1b2886f9afa8c$var$__assign.apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            $f5a1b2886f9afa8c$var$__assign.apply(void 0, [
                                $f5a1b2886f9afa8c$var$__assign.apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $f5a1b2886f9afa8c$var$logger.error("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $eb5688ac97e97bd7$export$50fdfeece43146fd();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error("Invalid state in OAuth flow");
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return $f5a1b2886f9afa8c$var$__awaiter(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return $f5a1b2886f9afa8c$var$__generator(this, function(_a) {
                oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
                client_id = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = $f5a1b2886f9afa8c$var$__read(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join("&");
                $f5a1b2886f9afa8c$var$dispatchAuthEvent("oAuthSignOut", {
                    oAuth: "signOut"
                }, "Signing out from " + oAuthLogoutEndpoint);
                $f5a1b2886f9afa8c$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = "";
        var i = length;
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        return this._base64URL((0, (/*@__PURE__*/$parcel$interopDefault($dCBbD)))(code));
    };
    OAuth.prototype._base64URL = function(string) {
        return string.toString((0, (/*@__PURE__*/$parcel$interopDefault($33Dov)))).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        var buffer = new Uint8Array(size);
        if (typeof window !== "undefined" && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join("");
    };
    return OAuth;
}();
var $f5a1b2886f9afa8c$export$2e2bcd8739ae039 = $f5a1b2886f9afa8c$var$OAuth;


/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $4fc5cb59076d8792$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isNode) ;
    else throw new Error("Not supported");
};


/*
 * Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7814ae8782f2f7db$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})($7814ae8782f2f7db$export$c3070468b9d65120 || ($7814ae8782f2f7db$export$c3070468b9d65120 = {}));


var $dab9793fb28d116e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dab9793fb28d116e$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("AuthError");
var $dab9793fb28d116e$export$145273558d58e0ac = /** @class */ function(_super) {
    $dab9793fb28d116e$var$__extends(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $dab9793fb28d116e$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = "AuthError";
        _this.log = log || message;
        $dab9793fb28d116e$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $dab9793fb28d116e$export$71192787e041818c = /** @class */ function(_super) {
    $dab9793fb28d116e$var$__extends(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = "NoUserPoolError";
        return _this;
    }
    return NoUserPoolError;
}($dab9793fb28d116e$export$145273558d58e0ac);
var $dab9793fb28d116e$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEFAULT_MSG
    }
};



var $cc420cb14b670b2a$var$__assign = undefined && undefined.__assign || function() {
    $cc420cb14b670b2a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cc420cb14b670b2a$var$__assign.apply(this, arguments);
};
var $cc420cb14b670b2a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cc420cb14b670b2a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cc420cb14b670b2a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $cc420cb14b670b2a$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("AuthClass");
var $cc420cb14b670b2a$var$USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $cc420cb14b670b2a$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $cc420cb14b670b2a$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $cc420cb14b670b2a$var$dispatchAuthEvent = function(event, data, message) {
    (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $cc420cb14b670b2a$var$AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var $cc420cb14b670b2a$var$MAX_DEVICES = 60;
var $cc420cb14b670b2a$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var $cc420cb14b670b2a$export$eeff9d1a8b8c057b = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.Credentials = (0, $de9f45d92f772164$export$a9627919734faa48);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $cc420cb14b670b2a$var$dispatchAuthEvent("tokenRefresh", undefined, "New token retrieved");
                else $cc420cb14b670b2a$var$dispatchAuthEvent("tokenRefresh_failure", error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).listen("auth", function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case "signIn":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "false");
                    break;
                case "signOut":
                    _this._storage.removeItem("amplify-signin-with-hostedUI");
                    break;
                case "cognitoHostedUI":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "true");
                    break;
            }
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return "Auth";
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $cc420cb14b670b2a$var$logger.debug("configure Auth");
        var conf = Object.assign({}, this._config, (0, $b04fed49d5c1afc7$export$7acfa6ed01010e37).parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint;
        if (!this._config.storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $d2150fd716ee36a9$export$2e2bcd8739ae039)(cookieStorage);
            else this._storage = config.ssr ? new (0, $68a581920a34423d$export$ded9c57084144144)() : new (0, $7a47fb194d2f9787$export$a2bd19c49e4760e8)().getStorage();
        } else {
            if (!this._isValidAuthStorage(this._config.storage)) {
                $cc420cb14b670b2a$var$logger.error("The storage in the Auth config is not valid!");
                throw new Error("Empty storage object");
            }
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $b355f5e976985f5d$export$2e2bcd8739ae039)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig["domain"],
                scopes: cognitoHostedUIConfig["scope"],
                redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
                redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
                responseType: cognitoHostedUIConfig["responseType"],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig["urlOpener"],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig["options"]);
            this._oAuthHandler = new (0, $f5a1b2886f9afa8c$export$2e2bcd8739ae039)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $4fc5cb59076d8792$export$2e2bcd8739ae039)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $cc420cb14b670b2a$var$dispatchAuthEvent("configured", null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage["getItem"] === "function") {
            var pollingInitiated = this.isTrueStorageValue("amplify-polling-started");
            if (pollingInitiated) {
                $cc420cb14b670b2a$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).AutoSignInError);
                this._storage.removeItem("amplify-auto-sign-in");
            }
            this._storage.removeItem("amplify-polling-started");
        }
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === "string") {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                Name: "email",
                Value: email
            }));
            if (phone_number) attributes.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                Name: "phone_number",
                Value: phone_number
            }));
        } else if (params && typeof params === "object") {
            username = params["username"];
            password = params["password"];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params["attributes"];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params["validationData"];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem("amplify-auto-sign-in", "true");
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).SignUpError);
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyPassword);
        $cc420cb14b670b2a$var$logger.debug("signUp attrs:", attributes);
        $cc420cb14b670b2a$var$logger.debug("signUp validation data:", validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $cc420cb14b670b2a$var$dispatchAuthEvent("signUp_failure", err, username + " failed to signup");
                    reject(err);
                } else {
                    $cc420cb14b670b2a$var$dispatchAuthEvent("signUp", data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, $010becf709f0452a$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === "link") this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    AuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function(_a) {
            var payload = _a.payload;
            if (payload.event === "confirmSignUp") _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).listen("auth", listenEvent);
    };
    AuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem("amplify-polling-started", "true");
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > $cc420cb14b670b2a$var$MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                $cc420cb14b670b2a$var$dispatchAuthEvent("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in.");
                _this._storage.removeItem("amplify-auto-sign-in");
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    AuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                $cc420cb14b670b2a$var$dispatchAuthEvent("autoSignIn", value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).remove("auth", listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem("amplify-polling-started");
                                }
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }, function(error) {
                                $cc420cb14b670b2a$var$logger.error(error);
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        $cc420cb14b670b2a$var$logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    $cc420cb14b670b2a$var$dispatchAuthEvent("confirmSignUp", data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue("amplify-auto-sign-in");
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        $cc420cb14b670b2a$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).AutoSignInError);
                        _this._storage.removeItem("amplify-auto-sign-in");
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === "true" : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === "string") {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $d71e9f4e74f3bfef$export$ad34f09783c4cb16)(usernameOrSignInOpts)) {
            if (typeof pw !== "undefined") $cc420cb14b670b2a$var$logger.warn("The password should be defined under the first parameter object!");
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        var authDetails = new (0, $010becf709f0452a$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $cc420cb14b670b2a$var$logger.debug(session);
                                delete user["challengeName"];
                                delete user["challengeParam"];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, "session")
                                ];
                            case 3:
                                cred = _a.sent();
                                $cc420cb14b670b2a$var$logger.debug("succeed to get cognito credentials", cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $cc420cb14b670b2a$var$logger.debug("cannot get cognito credentials", e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $cc420cb14b670b2a$var$dispatchAuthEvent("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $cc420cb14b670b2a$var$logger.error("Failed to get the signed in user", e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $cc420cb14b670b2a$var$logger.debug("signIn failure", err);
                $cc420cb14b670b2a$var$dispatchAuthEvent("signIn_failure", err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $cc420cb14b670b2a$var$logger.debug("signIn custom challenge answer required");
                user["challengeName"] = "CUSTOM_CHALLENGE";
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $cc420cb14b670b2a$var$logger.debug("signIn MFA required");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $cc420cb14b670b2a$var$logger.debug("signIn mfa setup", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $cc420cb14b670b2a$var$logger.debug("signIn new password");
                user["challengeName"] = "NEW_PASSWORD_REQUIRED";
                user["challengeParam"] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $cc420cb14b670b2a$var$logger.debug("signIn totpRequired");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $cc420cb14b670b2a$var$logger.debug("signIn selectMFAType", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error("Pending sign-in attempt already in progress");
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType("CUSTOM_AUTH");
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $cc420cb14b670b2a$var$logger.debug("get MFA Options failed", err);
                    rej(err);
                    return;
                }
                $cc420cb14b670b2a$var$logger.debug("get MFA options success", mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $cc420cb14b670b2a$var$logger.debug("getting preferred mfa failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej("invalid MFA Type");
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = "SMS_MFA";
                else ret = "NOMFA";
            } else if (mfaList.length === 0) ret = "NOMFA";
            else $cc420cb14b670b2a$var$logger.debug("invalid case for getPreferredMFA", data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $cc420cb14b670b2a$var$logger.debug("getting user data failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return $cc420cb14b670b2a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case "TOTP":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SOFTWARE_TOKEN_MFA":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SMS":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "SMS_MFA":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "NOMFA":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData["UserMFASettingList"];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === "NOMFA") return [
                            2 /*return*/ ,
                            Promise.resolve("No change for mfa type")
                        ];
                        else if (currentMFAType === "SMS_MFA") smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === "SMS_MFA") smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $cc420cb14b670b2a$var$logger.debug("no validmfa method provided");
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $cc420cb14b670b2a$var$logger.debug("Set user mfa preference error", err);
                                        return rej(err);
                                    }
                                    $cc420cb14b670b2a$var$logger.debug("Set user mfa success", result);
                                    $cc420cb14b670b2a$var$logger.debug("Caching the latest user data into local");
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $cc420cb14b670b2a$var$logger.debug("getting user data failed", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $cc420cb14b670b2a$var$logger.debug("disable mfa failed", err);
                    rej(err);
                    return;
                }
                $cc420cb14b670b2a$var$logger.debug("disable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $cc420cb14b670b2a$var$logger.debug("enable mfa failed", err);
                    rej(err);
                    return;
                }
                $cc420cb14b670b2a$var$logger.debug("enable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $cc420cb14b670b2a$var$logger.debug("associateSoftwareToken failed", err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $cc420cb14b670b2a$var$logger.debug("associateSoftwareToken sucess", secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $cc420cb14b670b2a$var$logger.debug("verification totp token", user, challengeAnswer);
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
                onFailure: function(err) {
                    $cc420cb14b670b2a$var$logger.debug("verifyTotpToken failed", err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    $cc420cb14b670b2a$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    $cc420cb14b670b2a$var$logger.debug("verifyTotpToken success", data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_3;
                        return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $cc420cb14b670b2a$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $cc420cb14b670b2a$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $cc420cb14b670b2a$var$logger.debug("cannot get cognito credentials", e_3);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $cc420cb14b670b2a$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $cc420cb14b670b2a$var$logger.debug("confirm signIn failure", err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_4;
                        return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $cc420cb14b670b2a$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $cc420cb14b670b2a$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_4 = _a.sent();
                                    $cc420cb14b670b2a$var$logger.debug("cannot get cognito credentials", e_4);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $cc420cb14b670b2a$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $cc420cb14b670b2a$var$logger.debug("completeNewPassword failure", err);
                    $cc420cb14b670b2a$var$dispatchAuthEvent("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $cc420cb14b670b2a$var$logger.debug("signIn MFA required");
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $cc420cb14b670b2a$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $cc420cb14b670b2a$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var e_5, isSignedInHostedUI;
            var _this = this;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_5 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("Failed to sync cache info into memory", e_5);
                        throw new Error(e_5);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                $cc420cb14b670b2a$var$logger.debug("Failed to get user from user pool");
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error("No current user."))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                $cc420cb14b670b2a$var$logger.debug("Failed to get the user session", err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        $cc420cb14b670b2a$var$dispatchAuthEvent("userDeleted", result, "The authenticated user has been deleted.");
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            $cc420cb14b670b2a$var$logger.debug("failed to clear cached items");
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            $cc420cb14b670b2a$var$dispatchAuthEvent("signOut", _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            $cc420cb14b670b2a$var$logger.debug("no Congito User pool");
                                            rej(new Error("Cognito User pool does not exist"));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== "sub" && key.indexOf("_verified") < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                }, clientMetadata);
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs["email"]) {
                if (attrs["email_verified"]) verified["email"] = attrs["email"];
                else unverified["email"] = attrs["email"];
            }
            if (attrs["phone_number"]) {
                if (attrs["phone_number_verified"]) verified["phone_number"] = attrs["phone_number"];
                else unverified["phone_number"] = attrs["phone_number"];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    AuthClass.prototype.isErrorWithMessage = function(err) {
        return typeof err === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    };
    // Session revoked by another app
    AuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    };
    AuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    };
    AuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    };
    AuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    };
    AuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    };
    AuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    };
    AuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err);
    };
    AuthClass.prototype.cleanUpInvalidSession = function(user) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var e_6;
            var _this = this;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_6 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else $cc420cb14b670b2a$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                    var user, clientMetadata;
                    var _this = this;
                    return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $cc420cb14b670b2a$var$logger.debug("OAuth signIn in progress, waiting for resolution...");
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $cc420cb14b670b2a$var$logger.debug("OAuth signIn in progress timeout");
                                            (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).remove("auth", hostedUISignCallback);
                                            res();
                                        }, $cc420cb14b670b2a$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).listen("auth", hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === "cognitoHostedUI" || event === "cognitoHostedUI_failure") {
                                                $cc420cb14b670b2a$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).remove("auth", hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $cc420cb14b670b2a$var$logger.debug("Failed to get user from user pool");
                                    rej("No current user");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                clientMetadata = this._config.clientMetadata;
                                // refresh the session if the session expired.
                                user.getSession(function(err, session) {
                                    return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                                        var cleanUpError_5, bypassCache, clientMetadata, _a, scope;
                                        var _this = this;
                                        return $cc420cb14b670b2a$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    $cc420cb14b670b2a$var$logger.debug("Failed to get the user session", err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    _b.label = 1;
                                                case 1:
                                                    _b.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _b.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _b.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 5:
                                                    bypassCache = params ? params.bypassCache : false;
                                                    if (!bypassCache) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.Credentials.clear()
                                                    ];
                                                case 6:
                                                    _b.sent();
                                                    _b.label = 7;
                                                case 7:
                                                    clientMetadata = this._config.clientMetadata;
                                                    _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? "" : _a;
                                                    if (scope.split(" ").includes($cc420cb14b670b2a$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                                        return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                                                            var cleanUpError_6, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                                            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        if (!err) return [
                                                                            3 /*break*/ ,
                                                                            7
                                                                        ];
                                                                        $cc420cb14b670b2a$var$logger.debug("getting user data failed", err);
                                                                        if (!this.isSessionInvalid(err)) return [
                                                                            3 /*break*/ ,
                                                                            5
                                                                        ];
                                                                        _a.label = 1;
                                                                    case 1:
                                                                        _a.trys.push([
                                                                            1,
                                                                            3,
                                                                            ,
                                                                            4
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.cleanUpInvalidSession(user)
                                                                        ];
                                                                    case 2:
                                                                        _a.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            4
                                                                        ];
                                                                    case 3:
                                                                        cleanUpError_6 = _a.sent();
                                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 4:
                                                                        rej(err);
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            6
                                                                        ];
                                                                    case 5:
                                                                        res(user);
                                                                        _a.label = 6;
                                                                    case 6:
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 7:
                                                                        preferredMFA = data.PreferredMfaSetting || "NOMFA";
                                                                        attributeList = [];
                                                                        for(i = 0; i < data.UserAttributes.length; i++){
                                                                            attribute = {
                                                                                Name: data.UserAttributes[i].Name,
                                                                                Value: data.UserAttributes[i].Value
                                                                            };
                                                                            userAttribute = new (0, $38555859a52f4863$export$2e2bcd8739ae039)(attribute);
                                                                            attributeList.push(userAttribute);
                                                                        }
                                                                        attributes = this.attributesToObject(attributeList);
                                                                        Object.assign(user, {
                                                                            attributes: attributes,
                                                                            preferredMFA: preferredMFA
                                                                        });
                                                                        return [
                                                                            2 /*return*/ ,
                                                                            res(user)
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, {
                                                        bypassCache: bypassCache,
                                                        clientMetadata: clientMetadata
                                                    });
                                                    else {
                                                        $cc420cb14b670b2a$var$logger.debug("Unable to get the user data because the " + $cc420cb14b670b2a$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                                        return [
                                                            2 /*return*/ ,
                                                            res(user)
                                                        ];
                                                    }
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    clientMetadata: clientMetadata
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $cc420cb14b670b2a$var$logger.debug("Failed to sync cache info into memory", e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var federatedUser, e_7, federatedInfo, user, e_8;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $cc420cb14b670b2a$var$logger.debug("getting current authenticated user");
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("Failed to sync cache info into memory", e_7);
                        throw e_7;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                            if (federatedInfo) federatedUser = $cc420cb14b670b2a$var$__assign($cc420cb14b670b2a$var$__assign({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $cc420cb14b670b2a$var$logger.debug("cannot load federated user from auth storage");
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $cc420cb14b670b2a$var$logger.debug("get current authenticated federated user", this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $cc420cb14b670b2a$var$logger.debug("get current authenticated userpool user");
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_8 = _a.sent();
                        if (e_8 === "No userPool") $cc420cb14b670b2a$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $cc420cb14b670b2a$var$logger.debug("The user is not authenticated by the error", e_8);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $cc420cb14b670b2a$var$logger.debug("Getting current session");
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error("No User Pool in the configuration."));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $cc420cb14b670b2a$var$logger.debug("Failed to get the current session", e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $cc420cb14b670b2a$var$logger.debug("Failed to get the current user", e);
                rej(e);
                return;
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        var _this = this;
        if (!user) {
            $cc420cb14b670b2a$var$logger.debug("the user is null");
            return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NoUserSession);
        }
        var clientMetadata = this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
        return new Promise(function(res, rej) {
            $cc420cb14b670b2a$var$logger.debug("Getting the session from this user:", user);
            user.getSession(function(err, session) {
                return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                    var cleanUpError_7;
                    return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $cc420cb14b670b2a$var$logger.debug("Failed to get the session from user", user);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_7 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                $cc420cb14b670b2a$var$logger.debug("Succeed to get the user session", session);
                                res(session);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                clientMetadata: clientMetadata
            });
        });
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var e_9, federatedInfo;
            var _this = this;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $cc420cb14b670b2a$var$logger.debug("Getting current user credentials");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_9 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("Failed to sync cache info into memory", e_9);
                        throw e_9;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                        } catch (e) {
                            $cc420cb14b670b2a$var$logger.debug("failed to get or parse item aws-amplify-federatedInfo", e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $cc420cb14b670b2a$var$logger.debug("getting session success", session);
                                return _this.Credentials.set(session, "session");
                            }).catch(function() {
                                $cc420cb14b670b2a$var$logger.debug("getting guest credentials");
                                return _this.Credentials.set(null, "guest");
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $cc420cb14b670b2a$var$logger.debug("getting current credentials");
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function(success) {
                    return resolve(success);
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var e_10, isSignedInHostedUI;
            var _this = this;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_10 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("Failed to sync cache info into memory", e_10);
                        throw e_10;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $cc420cb14b670b2a$var$logger.debug("user global sign out", user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return $cc420cb14b670b2a$var$__awaiter(_this, void 0, void 0, function() {
                                            var cleanUpError_8;
                                            var _this = this;
                                            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $cc420cb14b670b2a$var$logger.debug("failed to get the user session", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_8 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_8.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function(data) {
                                                                $cc420cb14b670b2a$var$logger.debug("global sign out success");
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function(err) {
                                                                $cc420cb14b670b2a$var$logger.debug("global sign out failed", err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    $cc420cb14b670b2a$var$logger.debug("user sign out", user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error("Signout timeout fail"));
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var e_11, user;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $cc420cb14b670b2a$var$logger.debug("no current Cognito user");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $cc420cb14b670b2a$var$logger.debug("no Cognito User pool");
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $cc420cb14b670b2a$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $cc420cb14b670b2a$var$logger.debug("change password failure", err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $cc420cb14b670b2a$var$logger.debug("forgot password failure", err);
                    $cc420cb14b670b2a$var$dispatchAuthEvent("forgotPassword_failure", err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $cc420cb14b670b2a$var$dispatchAuthEvent("forgotPassword", user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        if (!password) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function(success) {
                    $cc420cb14b670b2a$var$dispatchAuthEvent("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function(err) {
                    $cc420cb14b670b2a$var$dispatchAuthEvent("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_12, info, err_1, user;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === "aws" || source === "userPool")) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $cc420cb14b670b2a$var$logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_12 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("Failed to retrieve credentials while getting current user info", e_12);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_1 = _a.sent();
                        $cc420cb14b670b2a$var$logger.error("currentUserInfo error", err_1);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === "federated") {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === "undefined") {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $d71e9f4e74f3bfef$export$9b905d6895bdc426)(providerOrOptions) || (0, $d71e9f4e74f3bfef$export$828f8efbdf71714b)(providerOrOptions) || (0, $d71e9f4e74f3bfef$export$6bae5520ca265d22)(providerOrOptions) || typeof providerOrOptions === "undefined")) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $d71e9f4e74f3bfef$export$eeb013770cb92342).Cognito
                        };
                        provider = (0, $d71e9f4e74f3bfef$export$9b905d6895bdc426)(options) ? options.provider : options.customProvider;
                        customState = (0, $d71e9f4e74f3bfef$export$9b905d6895bdc426)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                            if (loggedInUser) $cc420cb14b670b2a$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, "federation")
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $cc420cb14b670b2a$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
                        $cc420cb14b670b2a$var$logger.debug("federated sign in credentials", credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_2;
            return $cc420cb14b670b2a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $cc420cb14b670b2a$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $cc420cb14b670b2a$var$dispatchAuthEvent("parsingCallbackUrl", {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser ? window.location.href : "");
                        hasCodeOrError = !!((0, $biuEp.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = $cc420cb14b670b2a$var$__read(_a, 1), k = _b[0];
                            return k === "code" || k === "error";
                        });
                        hasTokenOrError = !!((0, $biuEp.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = $cc420cb14b670b2a$var$__read(_a, 1), k = _b[0];
                            return k === "access_token" || k === "error";
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)({
                            IdToken: new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, "session")
                        ];
                    case 4:
                        credentials = _b.sent();
                        $cc420cb14b670b2a$var$logger.debug("AWS credentials", credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $cc420cb14b670b2a$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $cc420cb14b670b2a$var$dispatchAuthEvent("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split("-").splice(1).join("-");
                            $cc420cb14b670b2a$var$dispatchAuthEvent("customOAuthState", (0, $571068c73bf08655$export$a7ea17e93539f9a5)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_2 = _b.sent();
                        $cc420cb14b670b2a$var$logger.debug("Error in cognito hosted auth response", err_2);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $cc420cb14b670b2a$var$dispatchAuthEvent("signIn_failure", err_2, "The OAuth response flow failed");
                        $cc420cb14b670b2a$var$dispatchAuthEvent("cognitoHostedUI_failure", err_2, "A failure occurred when returning to the Cognito Hosted UI");
                        $cc420cb14b670b2a$var$dispatchAuthEvent("customState_failure", err_2, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).MissingAuthConfig;
        }
        return (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $dab9793fb28d116e$export$145273558d58e0ac)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $dab9793fb28d116e$export$71192787e041818c)(type));
    };
    AuthClass.prototype.rememberDevice = function() {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var currUser, error_2;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("The user is not authenticated by the error", error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function() {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var currUser, error_3;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("The user is not authenticated by the error", error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function() {
        return $cc420cb14b670b2a$var$__awaiter(this, void 0, void 0, function() {
            var currUser, error_4;
            return $cc420cb14b670b2a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        $cc420cb14b670b2a$var$logger.debug("The user is not authenticated by the error", error_4);
                        throw new Error("The user is not authenticated");
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === "device_name";
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices($cc420cb14b670b2a$var$MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return AuthClass;
}();
var $cc420cb14b670b2a$export$334c29725a78c21d = new $cc420cb14b670b2a$export$eeff9d1a8b8c057b(null);
(0, $36606c730099e1c8$export$a3858a9a153cffc7).register($cc420cb14b670b2a$export$334c29725a78c21d);





var /**
 * @deprecated use named import
 */ $ebb48d86fd8997a4$export$2e2bcd8739ae039 = (0, $cc420cb14b670b2a$export$334c29725a78c21d);


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $d91c4e97e29599d6$export$f84bd70098573c5c = {
    keyPrefix: "aws-amplify-cache",
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, $7a47fb194d2f9787$export$a2bd19c49e4760e8)().getStorage()
};
function $d91c4e97e29599d6$export$cc8c3b705bb8e6e2(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function $d91c4e97e29599d6$export$dd144842d7b22d3a() {
    var currTime = new Date();
    return currTime.getTime();
}
function $d91c4e97e29599d6$export$a287f47fed4544b8(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return $d91c4e97e29599d6$var$_isInteger(value);
}
function $d91c4e97e29599d6$var$_isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var $d91c4e97e29599d6$var$store = {};
var $d91c4e97e29599d6$export$2dd5b9e5ba192a1a = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        $d91c4e97e29599d6$var$store = {};
    };
    CacheObject.getItem = function(key) {
        return $d91c4e97e29599d6$var$store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        $d91c4e97e29599d6$var$store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete $d91c4e97e29599d6$var$store[key];
    };
    return CacheObject;
}();


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

var $aec3ba5e8b5294b2$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("StorageCache");
/**
 * Initialization of the cache
 *
 */ var $aec3ba5e8b5294b2$export$947ed1997bd112b4 = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + "CurSize";
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return "Cache";
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, $d91c4e97e29599d6$export$a287f47fed4544b8)(this.config.capacityInBytes)) {
            $aec3ba5e8b5294b2$var$logger.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.");
            this.config.capacityInBytes = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).capacityInBytes;
        }
        if (!(0, $d91c4e97e29599d6$export$a287f47fed4544b8)(this.config.itemMaxSize)) {
            $aec3ba5e8b5294b2$var$logger.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.");
            this.config.itemMaxSize = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).itemMaxSize;
        }
        if (!(0, $d91c4e97e29599d6$export$a287f47fed4544b8)(this.config.defaultTTL)) {
            $aec3ba5e8b5294b2$var$logger.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.");
            this.config.defaultTTL = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).defaultTTL;
        }
        if (!(0, $d91c4e97e29599d6$export$a287f47fed4544b8)(this.config.defaultPriority)) {
            $aec3ba5e8b5294b2$var$logger.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.");
            this.config.defaultPriority = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            $aec3ba5e8b5294b2$var$logger.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.");
            this.config.itemMaxSize = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            $aec3ba5e8b5294b2$var$logger.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.");
            this.config.defaultPriority = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            $aec3ba5e8b5294b2$var$logger.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.");
            this.config.warningThreshold = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            $aec3ba5e8b5294b2$var$logger.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.");
            this.config.capacityInBytes = (0, $d91c4e97e29599d6$export$f84bd70098573c5c).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, $d91c4e97e29599d6$export$dd144842d7b22d3a)(),
            visitedTime: (0, $d91c4e97e29599d6$export$dd144842d7b22d3a)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, $d91c4e97e29599d6$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, $d91c4e97e29599d6$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) $aec3ba5e8b5294b2$var$logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();
var /**
 * @deprecated use named import
 */ $aec3ba5e8b5294b2$export$2e2bcd8739ae039 = $aec3ba5e8b5294b2$export$947ed1997bd112b4;



var $aafd43a5aa7da9fd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aafd43a5aa7da9fd$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Cache");
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var $aafd43a5aa7da9fd$export$e6fda0405fa98d6d = /** @class */ function(_super) {
    $aafd43a5aa7da9fd$var$__extends(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $d91c4e97e29599d6$export$f84bd70098573c5c), config) : (0, $d91c4e97e29599d6$export$f84bd70098573c5c);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, $d91c4e97e29599d6$export$dd144842d7b22d3a)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, $d91c4e97e29599d6$export$dd144842d7b22d3a)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            $aafd43a5aa7da9fd$var$logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        $aafd43a5aa7da9fd$var$logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $aafd43a5aa7da9fd$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === "undefined") {
            $aafd43a5aa7da9fd$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $d91c4e97e29599d6$export$dd144842d7b22d3a)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $aafd43a5aa7da9fd$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $aafd43a5aa7da9fd$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            $aafd43a5aa7da9fd$var$logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        $aafd43a5aa7da9fd$var$logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $aafd43a5aa7da9fd$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            $aafd43a5aa7da9fd$var$logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        $aafd43a5aa7da9fd$var$logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            $aafd43a5aa7da9fd$var$logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        $aafd43a5aa7da9fd$var$logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            $aafd43a5aa7da9fd$var$logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, "0");
            ret = "0";
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, $d91c4e97e29599d6$export$f84bd70098573c5c).keyPrefix) {
            $aafd43a5aa7da9fd$var$logger.error("invalid keyPrefix, setting keyPrefix with timeStamp");
            config.keyPrefix = (0, $d91c4e97e29599d6$export$dd144842d7b22d3a).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, $aec3ba5e8b5294b2$export$947ed1997bd112b4));
var $aafd43a5aa7da9fd$export$2a9787695d97e2c4 = new $aafd43a5aa7da9fd$export$e6fda0405fa98d6d();
var /**
 * @deprecated use named import
 */ $aafd43a5aa7da9fd$export$2e2bcd8739ae039 = $aafd43a5aa7da9fd$export$2a9787695d97e2c4;



var /**
 * @deprecated use named import
 */ $b69e10b8f9e19003$export$2e2bcd8739ae039 = (0, $aafd43a5aa7da9fd$export$2a9787695d97e2c4);
(0, $36606c730099e1c8$export$a3858a9a153cffc7).register((0, $aafd43a5aa7da9fd$export$2a9787695d97e2c4));



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 




var $a75d087c013e1d7d$export$ff1e75b1e93a2588;
(function(AbortIncompleteMultipartUpload) {
    AbortIncompleteMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ff1e75b1e93a2588 || ($a75d087c013e1d7d$export$ff1e75b1e93a2588 = {}));
var $a75d087c013e1d7d$export$80a5621784397e06;
(function(AbortMultipartUploadOutput) {
    AbortMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$80a5621784397e06 || ($a75d087c013e1d7d$export$80a5621784397e06 = {}));
var $a75d087c013e1d7d$export$2509116d04cdd782;
(function(AbortMultipartUploadRequest) {
    AbortMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2509116d04cdd782 || ($a75d087c013e1d7d$export$2509116d04cdd782 = {}));
var $a75d087c013e1d7d$export$1de06065cff890a8;
(function(NoSuchUpload) {
    NoSuchUpload.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$1de06065cff890a8 || ($a75d087c013e1d7d$export$1de06065cff890a8 = {}));
var $a75d087c013e1d7d$export$b73224f1e3e6ea55;
(function(AccelerateConfiguration) {
    AccelerateConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b73224f1e3e6ea55 || ($a75d087c013e1d7d$export$b73224f1e3e6ea55 = {}));
var $a75d087c013e1d7d$export$4882adf346b33e1a;
(function(Grantee) {
    Grantee.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4882adf346b33e1a || ($a75d087c013e1d7d$export$4882adf346b33e1a = {}));
var $a75d087c013e1d7d$export$16844950929e022f;
(function(Grant) {
    Grant.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$16844950929e022f || ($a75d087c013e1d7d$export$16844950929e022f = {}));
var $a75d087c013e1d7d$export$25fb39c3824c9c44;
(function(Owner) {
    Owner.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$25fb39c3824c9c44 || ($a75d087c013e1d7d$export$25fb39c3824c9c44 = {}));
var $a75d087c013e1d7d$export$6a42fa102a072c77;
(function(AccessControlPolicy) {
    AccessControlPolicy.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$6a42fa102a072c77 || ($a75d087c013e1d7d$export$6a42fa102a072c77 = {}));
var $a75d087c013e1d7d$export$3db5322b6b5badd4;
(function(AccessControlTranslation) {
    AccessControlTranslation.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3db5322b6b5badd4 || ($a75d087c013e1d7d$export$3db5322b6b5badd4 = {}));
var $a75d087c013e1d7d$export$edcc5df28126c9bc;
(function(CompleteMultipartUploadOutput) {
    CompleteMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$edcc5df28126c9bc || ($a75d087c013e1d7d$export$edcc5df28126c9bc = {}));
var $a75d087c013e1d7d$export$76f56660c9039ec5;
(function(CompletedPart) {
    CompletedPart.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$76f56660c9039ec5 || ($a75d087c013e1d7d$export$76f56660c9039ec5 = {}));
var $a75d087c013e1d7d$export$394f3a16361c2a83;
(function(CompletedMultipartUpload) {
    CompletedMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$394f3a16361c2a83 || ($a75d087c013e1d7d$export$394f3a16361c2a83 = {}));
var $a75d087c013e1d7d$export$2998881f143b41ec;
(function(CompleteMultipartUploadRequest) {
    CompleteMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2998881f143b41ec || ($a75d087c013e1d7d$export$2998881f143b41ec = {}));
var $a75d087c013e1d7d$export$32f1916074d2607f;
(function(CopyObjectResult) {
    CopyObjectResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$32f1916074d2607f || ($a75d087c013e1d7d$export$32f1916074d2607f = {}));
var $a75d087c013e1d7d$export$a9f99871811ebc49;
(function(CopyObjectOutput) {
    CopyObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$a9f99871811ebc49 || ($a75d087c013e1d7d$export$a9f99871811ebc49 = {}));
var $a75d087c013e1d7d$export$e84f0e76c8b259eb;
(function(CopyObjectRequest) {
    CopyObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$e84f0e76c8b259eb || ($a75d087c013e1d7d$export$e84f0e76c8b259eb = {}));
var $a75d087c013e1d7d$export$77615b2f7cde9dd7;
(function(ObjectNotInActiveTierError) {
    ObjectNotInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$77615b2f7cde9dd7 || ($a75d087c013e1d7d$export$77615b2f7cde9dd7 = {}));
var $a75d087c013e1d7d$export$b6b374c2bfd60422;
(function(BucketAlreadyExists) {
    BucketAlreadyExists.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b6b374c2bfd60422 || ($a75d087c013e1d7d$export$b6b374c2bfd60422 = {}));
var $a75d087c013e1d7d$export$3d44152d602e5b07;
(function(BucketAlreadyOwnedByYou) {
    BucketAlreadyOwnedByYou.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3d44152d602e5b07 || ($a75d087c013e1d7d$export$3d44152d602e5b07 = {}));
var $a75d087c013e1d7d$export$b9395efd4905ea2f;
(function(CreateBucketOutput) {
    CreateBucketOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b9395efd4905ea2f || ($a75d087c013e1d7d$export$b9395efd4905ea2f = {}));
var $a75d087c013e1d7d$export$80fb9034e13a84f5;
(function(CreateBucketConfiguration) {
    CreateBucketConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$80fb9034e13a84f5 || ($a75d087c013e1d7d$export$80fb9034e13a84f5 = {}));
var $a75d087c013e1d7d$export$8aca1806c1d8d130;
(function(CreateBucketRequest) {
    CreateBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$8aca1806c1d8d130 || ($a75d087c013e1d7d$export$8aca1806c1d8d130 = {}));
var $a75d087c013e1d7d$export$196bb0482ff68428;
(function(CreateMultipartUploadOutput) {
    CreateMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$196bb0482ff68428 || ($a75d087c013e1d7d$export$196bb0482ff68428 = {}));
var $a75d087c013e1d7d$export$f65faae2a46e45c2;
(function(CreateMultipartUploadRequest) {
    CreateMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$f65faae2a46e45c2 || ($a75d087c013e1d7d$export$f65faae2a46e45c2 = {}));
var $a75d087c013e1d7d$export$8b74a2c46a921740;
(function(DeleteBucketRequest) {
    DeleteBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$8b74a2c46a921740 || ($a75d087c013e1d7d$export$8b74a2c46a921740 = {}));
var $a75d087c013e1d7d$export$c5ab088f35618173;
(function(DeleteBucketAnalyticsConfigurationRequest) {
    DeleteBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c5ab088f35618173 || ($a75d087c013e1d7d$export$c5ab088f35618173 = {}));
var $a75d087c013e1d7d$export$eedf1d80102f9cff;
(function(DeleteBucketCorsRequest) {
    DeleteBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$eedf1d80102f9cff || ($a75d087c013e1d7d$export$eedf1d80102f9cff = {}));
var $a75d087c013e1d7d$export$67cbcb88080a155a;
(function(DeleteBucketEncryptionRequest) {
    DeleteBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$67cbcb88080a155a || ($a75d087c013e1d7d$export$67cbcb88080a155a = {}));
var $a75d087c013e1d7d$export$301f370253f11f3b;
(function(DeleteBucketIntelligentTieringConfigurationRequest) {
    DeleteBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$301f370253f11f3b || ($a75d087c013e1d7d$export$301f370253f11f3b = {}));
var $a75d087c013e1d7d$export$3603c2e1b3558471;
(function(DeleteBucketInventoryConfigurationRequest) {
    DeleteBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3603c2e1b3558471 || ($a75d087c013e1d7d$export$3603c2e1b3558471 = {}));
var $a75d087c013e1d7d$export$6c38b78c3c77b60c;
(function(DeleteBucketLifecycleRequest) {
    DeleteBucketLifecycleRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$6c38b78c3c77b60c || ($a75d087c013e1d7d$export$6c38b78c3c77b60c = {}));
var $a75d087c013e1d7d$export$ff4b8fc3fb36fbd;
(function(DeleteBucketMetricsConfigurationRequest) {
    DeleteBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ff4b8fc3fb36fbd || ($a75d087c013e1d7d$export$ff4b8fc3fb36fbd = {}));
var $a75d087c013e1d7d$export$4c49e000fa5b0b86;
(function(DeleteBucketOwnershipControlsRequest) {
    DeleteBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4c49e000fa5b0b86 || ($a75d087c013e1d7d$export$4c49e000fa5b0b86 = {}));
var $a75d087c013e1d7d$export$cce16146386a1316;
(function(DeleteBucketPolicyRequest) {
    DeleteBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$cce16146386a1316 || ($a75d087c013e1d7d$export$cce16146386a1316 = {}));
var $a75d087c013e1d7d$export$238256546e65e80f;
(function(DeleteBucketReplicationRequest) {
    DeleteBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$238256546e65e80f || ($a75d087c013e1d7d$export$238256546e65e80f = {}));
var $a75d087c013e1d7d$export$e9cefd124b305be3;
(function(DeleteBucketTaggingRequest) {
    DeleteBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$e9cefd124b305be3 || ($a75d087c013e1d7d$export$e9cefd124b305be3 = {}));
var $a75d087c013e1d7d$export$15e654f934b26a7b;
(function(DeleteBucketWebsiteRequest) {
    DeleteBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$15e654f934b26a7b || ($a75d087c013e1d7d$export$15e654f934b26a7b = {}));
var $a75d087c013e1d7d$export$64d4f4fac943bc25;
(function(DeleteObjectOutput) {
    DeleteObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$64d4f4fac943bc25 || ($a75d087c013e1d7d$export$64d4f4fac943bc25 = {}));
var $a75d087c013e1d7d$export$7d123f24a24f15cf;
(function(DeleteObjectRequest) {
    DeleteObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$7d123f24a24f15cf || ($a75d087c013e1d7d$export$7d123f24a24f15cf = {}));
var $a75d087c013e1d7d$export$d17347461b0f9a2b;
(function(DeletedObject) {
    DeletedObject.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d17347461b0f9a2b || ($a75d087c013e1d7d$export$d17347461b0f9a2b = {}));
var $a75d087c013e1d7d$export$afd90478dc782af0;
(function(_Error) {
    _Error.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$afd90478dc782af0 || ($a75d087c013e1d7d$export$afd90478dc782af0 = {}));
var $a75d087c013e1d7d$export$e1c86a39185a896f;
(function(DeleteObjectsOutput) {
    DeleteObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$e1c86a39185a896f || ($a75d087c013e1d7d$export$e1c86a39185a896f = {}));
var $a75d087c013e1d7d$export$84d9d258efc6700d;
(function(ObjectIdentifier) {
    ObjectIdentifier.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$84d9d258efc6700d || ($a75d087c013e1d7d$export$84d9d258efc6700d = {}));
var $a75d087c013e1d7d$export$bfadae053a633538;
(function(Delete) {
    Delete.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$bfadae053a633538 || ($a75d087c013e1d7d$export$bfadae053a633538 = {}));
var $a75d087c013e1d7d$export$c19f81fd3ccd8fc2;
(function(DeleteObjectsRequest) {
    DeleteObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c19f81fd3ccd8fc2 || ($a75d087c013e1d7d$export$c19f81fd3ccd8fc2 = {}));
var $a75d087c013e1d7d$export$4d816bf2553d6082;
(function(DeleteObjectTaggingOutput) {
    DeleteObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4d816bf2553d6082 || ($a75d087c013e1d7d$export$4d816bf2553d6082 = {}));
var $a75d087c013e1d7d$export$2d561b57455087e8;
(function(DeleteObjectTaggingRequest) {
    DeleteObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2d561b57455087e8 || ($a75d087c013e1d7d$export$2d561b57455087e8 = {}));
var $a75d087c013e1d7d$export$cac29ea1b5d93b5d;
(function(DeletePublicAccessBlockRequest) {
    DeletePublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$cac29ea1b5d93b5d || ($a75d087c013e1d7d$export$cac29ea1b5d93b5d = {}));
var $a75d087c013e1d7d$export$d592399f8c69d061;
(function(GetBucketAccelerateConfigurationOutput) {
    GetBucketAccelerateConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d592399f8c69d061 || ($a75d087c013e1d7d$export$d592399f8c69d061 = {}));
var $a75d087c013e1d7d$export$c2ed0589b585987a;
(function(GetBucketAccelerateConfigurationRequest) {
    GetBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c2ed0589b585987a || ($a75d087c013e1d7d$export$c2ed0589b585987a = {}));
var $a75d087c013e1d7d$export$1e656ec1fa0dbccd;
(function(GetBucketAclOutput) {
    GetBucketAclOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$1e656ec1fa0dbccd || ($a75d087c013e1d7d$export$1e656ec1fa0dbccd = {}));
var $a75d087c013e1d7d$export$5543bf3f517c214;
(function(GetBucketAclRequest) {
    GetBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$5543bf3f517c214 || ($a75d087c013e1d7d$export$5543bf3f517c214 = {}));
var $a75d087c013e1d7d$export$3288d34c523a1192;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3288d34c523a1192 || ($a75d087c013e1d7d$export$3288d34c523a1192 = {}));
var $a75d087c013e1d7d$export$b9ae9bceb2811d5d;
(function(AnalyticsAndOperator) {
    AnalyticsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b9ae9bceb2811d5d || ($a75d087c013e1d7d$export$b9ae9bceb2811d5d = {}));
var $a75d087c013e1d7d$export$c9ec61557dcb764a;
(function(AnalyticsFilter) {
    AnalyticsFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    AnalyticsFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $a75d087c013e1d7d$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $a75d087c013e1d7d$export$b9ae9bceb2811d5d.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($a75d087c013e1d7d$export$c9ec61557dcb764a || ($a75d087c013e1d7d$export$c9ec61557dcb764a = {}));
var $a75d087c013e1d7d$export$fc566d9f8f854701;
(function(AnalyticsS3BucketDestination) {
    AnalyticsS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$fc566d9f8f854701 || ($a75d087c013e1d7d$export$fc566d9f8f854701 = {}));
var $a75d087c013e1d7d$export$20f751b8dcd24833;
(function(AnalyticsExportDestination) {
    AnalyticsExportDestination.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$20f751b8dcd24833 || ($a75d087c013e1d7d$export$20f751b8dcd24833 = {}));
var $a75d087c013e1d7d$export$a14156deb587d512;
(function(StorageClassAnalysisDataExport) {
    StorageClassAnalysisDataExport.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a14156deb587d512 || ($a75d087c013e1d7d$export$a14156deb587d512 = {}));
var $a75d087c013e1d7d$export$13f5184561469c95;
(function(StorageClassAnalysis) {
    StorageClassAnalysis.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$13f5184561469c95 || ($a75d087c013e1d7d$export$13f5184561469c95 = {}));
var $a75d087c013e1d7d$export$15f94404a081a771;
(function(AnalyticsConfiguration) {
    AnalyticsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $a75d087c013e1d7d$export$c9ec61557dcb764a.filterSensitiveLog(obj.Filter)
        });
    };
})($a75d087c013e1d7d$export$15f94404a081a771 || ($a75d087c013e1d7d$export$15f94404a081a771 = {}));
var $a75d087c013e1d7d$export$32ac99bb59e9ea35;
(function(GetBucketAnalyticsConfigurationOutput) {
    GetBucketAnalyticsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.AnalyticsConfiguration && {
            AnalyticsConfiguration: $a75d087c013e1d7d$export$15f94404a081a771.filterSensitiveLog(obj.AnalyticsConfiguration)
        });
    };
})($a75d087c013e1d7d$export$32ac99bb59e9ea35 || ($a75d087c013e1d7d$export$32ac99bb59e9ea35 = {}));
var $a75d087c013e1d7d$export$a4b635f541d39c02;
(function(GetBucketAnalyticsConfigurationRequest) {
    GetBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a4b635f541d39c02 || ($a75d087c013e1d7d$export$a4b635f541d39c02 = {}));
var $a75d087c013e1d7d$export$483798435237259b;
(function(CORSRule) {
    CORSRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$483798435237259b || ($a75d087c013e1d7d$export$483798435237259b = {}));
var $a75d087c013e1d7d$export$3ff8c9c489aa7ab5;
(function(GetBucketCorsOutput) {
    GetBucketCorsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3ff8c9c489aa7ab5 || ($a75d087c013e1d7d$export$3ff8c9c489aa7ab5 = {}));
var $a75d087c013e1d7d$export$cdc36c4a20d66833;
(function(GetBucketCorsRequest) {
    GetBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$cdc36c4a20d66833 || ($a75d087c013e1d7d$export$cdc36c4a20d66833 = {}));
var $a75d087c013e1d7d$export$5e055b8b357210fd;
(function(ServerSideEncryptionByDefault) {
    ServerSideEncryptionByDefault.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.KMSMasterKeyID && {
            KMSMasterKeyID: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$5e055b8b357210fd || ($a75d087c013e1d7d$export$5e055b8b357210fd = {}));
var $a75d087c013e1d7d$export$614e3b57594b8702;
(function(ServerSideEncryptionRule) {
    ServerSideEncryptionRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.ApplyServerSideEncryptionByDefault && {
            ApplyServerSideEncryptionByDefault: $a75d087c013e1d7d$export$5e055b8b357210fd.filterSensitiveLog(obj.ApplyServerSideEncryptionByDefault)
        });
    };
})($a75d087c013e1d7d$export$614e3b57594b8702 || ($a75d087c013e1d7d$export$614e3b57594b8702 = {}));
var $a75d087c013e1d7d$export$d53e5f9e3c3507bf;
(function(ServerSideEncryptionConfiguration) {
    ServerSideEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $a75d087c013e1d7d$export$614e3b57594b8702.filterSensitiveLog(item);
            })
        });
    };
})($a75d087c013e1d7d$export$d53e5f9e3c3507bf || ($a75d087c013e1d7d$export$d53e5f9e3c3507bf = {}));
var $a75d087c013e1d7d$export$a5d815db4065bb4e;
(function(GetBucketEncryptionOutput) {
    GetBucketEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $a75d087c013e1d7d$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($a75d087c013e1d7d$export$a5d815db4065bb4e || ($a75d087c013e1d7d$export$a5d815db4065bb4e = {}));
var $a75d087c013e1d7d$export$3871e35cee114580;
(function(GetBucketEncryptionRequest) {
    GetBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3871e35cee114580 || ($a75d087c013e1d7d$export$3871e35cee114580 = {}));
var $a75d087c013e1d7d$export$538012949ecb1f02;
(function(IntelligentTieringAndOperator) {
    IntelligentTieringAndOperator.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$538012949ecb1f02 || ($a75d087c013e1d7d$export$538012949ecb1f02 = {}));
var $a75d087c013e1d7d$export$ee31c5d57e861da9;
(function(IntelligentTieringFilter) {
    IntelligentTieringFilter.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ee31c5d57e861da9 || ($a75d087c013e1d7d$export$ee31c5d57e861da9 = {}));
var $a75d087c013e1d7d$export$45a8dbc307fd1b69;
(function(Tiering) {
    Tiering.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$45a8dbc307fd1b69 || ($a75d087c013e1d7d$export$45a8dbc307fd1b69 = {}));
var $a75d087c013e1d7d$export$a9d6845d45635cd6;
(function(IntelligentTieringConfiguration) {
    IntelligentTieringConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a9d6845d45635cd6 || ($a75d087c013e1d7d$export$a9d6845d45635cd6 = {}));
var $a75d087c013e1d7d$export$a5c98daa4e4d0978;
(function(GetBucketIntelligentTieringConfigurationOutput) {
    GetBucketIntelligentTieringConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a5c98daa4e4d0978 || ($a75d087c013e1d7d$export$a5c98daa4e4d0978 = {}));
var $a75d087c013e1d7d$export$2bc70aedd92acdd9;
(function(GetBucketIntelligentTieringConfigurationRequest) {
    GetBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2bc70aedd92acdd9 || ($a75d087c013e1d7d$export$2bc70aedd92acdd9 = {}));
var $a75d087c013e1d7d$export$51ca0161a096cac2;
(function(SSEKMS) {
    SSEKMS.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.KeyId && {
            KeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$51ca0161a096cac2 || ($a75d087c013e1d7d$export$51ca0161a096cac2 = {}));
var $a75d087c013e1d7d$export$e6fda754462bc5e9;
(function(SSES3) {
    SSES3.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$e6fda754462bc5e9 || ($a75d087c013e1d7d$export$e6fda754462bc5e9 = {}));
var $a75d087c013e1d7d$export$4507106f7965dad8;
(function(InventoryEncryption) {
    InventoryEncryption.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMS && {
            SSEKMS: $a75d087c013e1d7d$export$51ca0161a096cac2.filterSensitiveLog(obj.SSEKMS)
        });
    };
})($a75d087c013e1d7d$export$4507106f7965dad8 || ($a75d087c013e1d7d$export$4507106f7965dad8 = {}));
var $a75d087c013e1d7d$export$dbf61758afa382d2;
(function(InventoryS3BucketDestination) {
    InventoryS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Encryption && {
            Encryption: $a75d087c013e1d7d$export$4507106f7965dad8.filterSensitiveLog(obj.Encryption)
        });
    };
})($a75d087c013e1d7d$export$dbf61758afa382d2 || ($a75d087c013e1d7d$export$dbf61758afa382d2 = {}));
var $a75d087c013e1d7d$export$95a07687ea92cc86;
(function(InventoryDestination) {
    InventoryDestination.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.S3BucketDestination && {
            S3BucketDestination: $a75d087c013e1d7d$export$dbf61758afa382d2.filterSensitiveLog(obj.S3BucketDestination)
        });
    };
})($a75d087c013e1d7d$export$95a07687ea92cc86 || ($a75d087c013e1d7d$export$95a07687ea92cc86 = {}));
var $a75d087c013e1d7d$export$9cab1f8eb4898ac3;
(function(InventoryFilter) {
    InventoryFilter.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$9cab1f8eb4898ac3 || ($a75d087c013e1d7d$export$9cab1f8eb4898ac3 = {}));
var $a75d087c013e1d7d$export$80a40dd3d0e79f33;
(function(InventorySchedule) {
    InventorySchedule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$80a40dd3d0e79f33 || ($a75d087c013e1d7d$export$80a40dd3d0e79f33 = {}));
var $a75d087c013e1d7d$export$e13e8ea2fe7b5717;
(function(InventoryConfiguration) {
    InventoryConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Destination && {
            Destination: $a75d087c013e1d7d$export$95a07687ea92cc86.filterSensitiveLog(obj.Destination)
        });
    };
})($a75d087c013e1d7d$export$e13e8ea2fe7b5717 || ($a75d087c013e1d7d$export$e13e8ea2fe7b5717 = {}));
var $a75d087c013e1d7d$export$4b7c0b968f94593a;
(function(GetBucketInventoryConfigurationOutput) {
    GetBucketInventoryConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $a75d087c013e1d7d$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($a75d087c013e1d7d$export$4b7c0b968f94593a || ($a75d087c013e1d7d$export$4b7c0b968f94593a = {}));
var $a75d087c013e1d7d$export$2bcb6519092e8dbf;
(function(GetBucketInventoryConfigurationRequest) {
    GetBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2bcb6519092e8dbf || ($a75d087c013e1d7d$export$2bcb6519092e8dbf = {}));
var $a75d087c013e1d7d$export$87e69778058ef73d;
(function(LifecycleExpiration) {
    LifecycleExpiration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$87e69778058ef73d || ($a75d087c013e1d7d$export$87e69778058ef73d = {}));
var $a75d087c013e1d7d$export$70a8e907770d2a36;
(function(LifecycleRuleAndOperator) {
    LifecycleRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$70a8e907770d2a36 || ($a75d087c013e1d7d$export$70a8e907770d2a36 = {}));
var $a75d087c013e1d7d$export$4338dba1e93ddaf4;
(function(LifecycleRuleFilter) {
    LifecycleRuleFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    LifecycleRuleFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $a75d087c013e1d7d$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $a75d087c013e1d7d$export$70a8e907770d2a36.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($a75d087c013e1d7d$export$4338dba1e93ddaf4 || ($a75d087c013e1d7d$export$4338dba1e93ddaf4 = {}));
var $a75d087c013e1d7d$export$a99742a437d0fdf9;
(function(NoncurrentVersionExpiration) {
    NoncurrentVersionExpiration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a99742a437d0fdf9 || ($a75d087c013e1d7d$export$a99742a437d0fdf9 = {}));
var $a75d087c013e1d7d$export$9250e73c985ce931;
(function(NoncurrentVersionTransition) {
    NoncurrentVersionTransition.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$9250e73c985ce931 || ($a75d087c013e1d7d$export$9250e73c985ce931 = {}));
var $a75d087c013e1d7d$export$be58926105124dd4;
(function(Transition) {
    Transition.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$be58926105124dd4 || ($a75d087c013e1d7d$export$be58926105124dd4 = {}));
var $a75d087c013e1d7d$export$1ac30bbe41f1f9ef;
(function(LifecycleRule) {
    LifecycleRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $a75d087c013e1d7d$export$4338dba1e93ddaf4.filterSensitiveLog(obj.Filter)
        });
    };
})($a75d087c013e1d7d$export$1ac30bbe41f1f9ef || ($a75d087c013e1d7d$export$1ac30bbe41f1f9ef = {}));
var $a75d087c013e1d7d$export$f2f23f80c8c1c7c4;
(function(GetBucketLifecycleConfigurationOutput) {
    GetBucketLifecycleConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $a75d087c013e1d7d$export$1ac30bbe41f1f9ef.filterSensitiveLog(item);
            })
        });
    };
})($a75d087c013e1d7d$export$f2f23f80c8c1c7c4 || ($a75d087c013e1d7d$export$f2f23f80c8c1c7c4 = {}));
var $a75d087c013e1d7d$export$86e3489ab08ca98d;
(function(GetBucketLifecycleConfigurationRequest) {
    GetBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$86e3489ab08ca98d || ($a75d087c013e1d7d$export$86e3489ab08ca98d = {}));
var $a75d087c013e1d7d$export$ed9828a2500d585f;
(function(GetBucketLocationOutput) {
    GetBucketLocationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ed9828a2500d585f || ($a75d087c013e1d7d$export$ed9828a2500d585f = {}));
var $a75d087c013e1d7d$export$4109a69a89893a5d;
(function(GetBucketLocationRequest) {
    GetBucketLocationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4109a69a89893a5d || ($a75d087c013e1d7d$export$4109a69a89893a5d = {}));
var $a75d087c013e1d7d$export$cf4abd6ae8fde913;
(function(TargetGrant) {
    TargetGrant.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$cf4abd6ae8fde913 || ($a75d087c013e1d7d$export$cf4abd6ae8fde913 = {}));
var $a75d087c013e1d7d$export$a1484d354b9c56b2;
(function(LoggingEnabled) {
    LoggingEnabled.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a1484d354b9c56b2 || ($a75d087c013e1d7d$export$a1484d354b9c56b2 = {}));
var $a75d087c013e1d7d$export$f9d2a0e32a2aa91f;
(function(GetBucketLoggingOutput) {
    GetBucketLoggingOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$f9d2a0e32a2aa91f || ($a75d087c013e1d7d$export$f9d2a0e32a2aa91f = {}));
var $a75d087c013e1d7d$export$182d23383f8b69bd;
(function(GetBucketLoggingRequest) {
    GetBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$182d23383f8b69bd || ($a75d087c013e1d7d$export$182d23383f8b69bd = {}));
var $a75d087c013e1d7d$export$4774797e6eda832;
(function(MetricsAndOperator) {
    MetricsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4774797e6eda832 || ($a75d087c013e1d7d$export$4774797e6eda832 = {}));
var $a75d087c013e1d7d$export$564a1f9c338cae45;
(function(MetricsFilter) {
    MetricsFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    MetricsFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $a75d087c013e1d7d$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $a75d087c013e1d7d$export$4774797e6eda832.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($a75d087c013e1d7d$export$564a1f9c338cae45 || ($a75d087c013e1d7d$export$564a1f9c338cae45 = {}));
var $a75d087c013e1d7d$export$908bafa154008a5e;
(function(MetricsConfiguration) {
    MetricsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $a75d087c013e1d7d$export$564a1f9c338cae45.filterSensitiveLog(obj.Filter)
        });
    };
})($a75d087c013e1d7d$export$908bafa154008a5e || ($a75d087c013e1d7d$export$908bafa154008a5e = {}));
var $a75d087c013e1d7d$export$a52baffc56d738d2;
(function(GetBucketMetricsConfigurationOutput) {
    GetBucketMetricsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.MetricsConfiguration && {
            MetricsConfiguration: $a75d087c013e1d7d$export$908bafa154008a5e.filterSensitiveLog(obj.MetricsConfiguration)
        });
    };
})($a75d087c013e1d7d$export$a52baffc56d738d2 || ($a75d087c013e1d7d$export$a52baffc56d738d2 = {}));
var $a75d087c013e1d7d$export$af907f7627ae4ae9;
(function(GetBucketMetricsConfigurationRequest) {
    GetBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$af907f7627ae4ae9 || ($a75d087c013e1d7d$export$af907f7627ae4ae9 = {}));
var $a75d087c013e1d7d$export$f00ac87a35076252;
(function(GetBucketNotificationConfigurationRequest) {
    GetBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$f00ac87a35076252 || ($a75d087c013e1d7d$export$f00ac87a35076252 = {}));
var $a75d087c013e1d7d$export$74fc6120f048b9bc;
(function(FilterRule) {
    FilterRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$74fc6120f048b9bc || ($a75d087c013e1d7d$export$74fc6120f048b9bc = {}));
var $a75d087c013e1d7d$export$46101b74c47ec83a;
(function(S3KeyFilter) {
    S3KeyFilter.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$46101b74c47ec83a || ($a75d087c013e1d7d$export$46101b74c47ec83a = {}));
var $a75d087c013e1d7d$export$c3d4fc0e09105ced;
(function(NotificationConfigurationFilter) {
    NotificationConfigurationFilter.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c3d4fc0e09105ced || ($a75d087c013e1d7d$export$c3d4fc0e09105ced = {}));
var $a75d087c013e1d7d$export$4916e52bc544d4ef;
(function(LambdaFunctionConfiguration) {
    LambdaFunctionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4916e52bc544d4ef || ($a75d087c013e1d7d$export$4916e52bc544d4ef = {}));
var $a75d087c013e1d7d$export$b48f9efe98802c25;
(function(QueueConfiguration) {
    QueueConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b48f9efe98802c25 || ($a75d087c013e1d7d$export$b48f9efe98802c25 = {}));
var $a75d087c013e1d7d$export$c98b07f3d2e31343;
(function(TopicConfiguration) {
    TopicConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c98b07f3d2e31343 || ($a75d087c013e1d7d$export$c98b07f3d2e31343 = {}));
var $a75d087c013e1d7d$export$165cf006a6abc4b3;
(function(NotificationConfiguration) {
    NotificationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$165cf006a6abc4b3 || ($a75d087c013e1d7d$export$165cf006a6abc4b3 = {}));
var $a75d087c013e1d7d$export$403b2dc6ec5b8d13;
(function(OwnershipControlsRule) {
    OwnershipControlsRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$403b2dc6ec5b8d13 || ($a75d087c013e1d7d$export$403b2dc6ec5b8d13 = {}));
var $a75d087c013e1d7d$export$ae516ccf061cd7d1;
(function(OwnershipControls) {
    OwnershipControls.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ae516ccf061cd7d1 || ($a75d087c013e1d7d$export$ae516ccf061cd7d1 = {}));
var $a75d087c013e1d7d$export$bb1e71315d618124;
(function(GetBucketOwnershipControlsOutput) {
    GetBucketOwnershipControlsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$bb1e71315d618124 || ($a75d087c013e1d7d$export$bb1e71315d618124 = {}));
var $a75d087c013e1d7d$export$55fbc6554b27a2f6;
(function(GetBucketOwnershipControlsRequest) {
    GetBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$55fbc6554b27a2f6 || ($a75d087c013e1d7d$export$55fbc6554b27a2f6 = {}));
var $a75d087c013e1d7d$export$29a8c95926d10996;
(function(GetBucketPolicyOutput) {
    GetBucketPolicyOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$29a8c95926d10996 || ($a75d087c013e1d7d$export$29a8c95926d10996 = {}));
var $a75d087c013e1d7d$export$fde59d57a80f46c6;
(function(GetBucketPolicyRequest) {
    GetBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$fde59d57a80f46c6 || ($a75d087c013e1d7d$export$fde59d57a80f46c6 = {}));
var $a75d087c013e1d7d$export$77c4d21e3fd2b633;
(function(PolicyStatus) {
    PolicyStatus.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$77c4d21e3fd2b633 || ($a75d087c013e1d7d$export$77c4d21e3fd2b633 = {}));
var $a75d087c013e1d7d$export$c9cb93f92e1c4228;
(function(GetBucketPolicyStatusOutput) {
    GetBucketPolicyStatusOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c9cb93f92e1c4228 || ($a75d087c013e1d7d$export$c9cb93f92e1c4228 = {}));
var $a75d087c013e1d7d$export$2e3b292047386a35;
(function(GetBucketPolicyStatusRequest) {
    GetBucketPolicyStatusRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2e3b292047386a35 || ($a75d087c013e1d7d$export$2e3b292047386a35 = {}));
var $a75d087c013e1d7d$export$594f35c535ed76a3;
(function(DeleteMarkerReplication) {
    DeleteMarkerReplication.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$594f35c535ed76a3 || ($a75d087c013e1d7d$export$594f35c535ed76a3 = {}));
var $a75d087c013e1d7d$export$949641a4ad7f11d4;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$949641a4ad7f11d4 || ($a75d087c013e1d7d$export$949641a4ad7f11d4 = {}));
var $a75d087c013e1d7d$export$d9823a04d7ef0d38;
(function(ReplicationTimeValue) {
    ReplicationTimeValue.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d9823a04d7ef0d38 || ($a75d087c013e1d7d$export$d9823a04d7ef0d38 = {}));
var $a75d087c013e1d7d$export$ed9166ec0f465b5e;
(function(Metrics) {
    Metrics.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ed9166ec0f465b5e || ($a75d087c013e1d7d$export$ed9166ec0f465b5e = {}));
var $a75d087c013e1d7d$export$666325b7ed44b812;
(function(ReplicationTime) {
    ReplicationTime.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$666325b7ed44b812 || ($a75d087c013e1d7d$export$666325b7ed44b812 = {}));
var $a75d087c013e1d7d$export$5c4bdf44e1e9cea1;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$5c4bdf44e1e9cea1 || ($a75d087c013e1d7d$export$5c4bdf44e1e9cea1 = {}));
var $a75d087c013e1d7d$export$18e0c6d9cc0aaef5;
(function(ExistingObjectReplication) {
    ExistingObjectReplication.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$18e0c6d9cc0aaef5 || ($a75d087c013e1d7d$export$18e0c6d9cc0aaef5 = {}));
var $a75d087c013e1d7d$export$f149404143b7fc4f;
(function(ReplicationRuleAndOperator) {
    ReplicationRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$f149404143b7fc4f || ($a75d087c013e1d7d$export$f149404143b7fc4f = {}));
var $a75d087c013e1d7d$export$c5652b893758d9eb;
(function(ReplicationRuleFilter) {
    ReplicationRuleFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    ReplicationRuleFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $a75d087c013e1d7d$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $a75d087c013e1d7d$export$f149404143b7fc4f.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($a75d087c013e1d7d$export$c5652b893758d9eb || ($a75d087c013e1d7d$export$c5652b893758d9eb = {}));
var $a75d087c013e1d7d$export$79ea81eaeed7f3c8;
(function(ReplicaModifications) {
    ReplicaModifications.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$79ea81eaeed7f3c8 || ($a75d087c013e1d7d$export$79ea81eaeed7f3c8 = {}));
var $a75d087c013e1d7d$export$d6dbaa0624096385;
(function(SseKmsEncryptedObjects) {
    SseKmsEncryptedObjects.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d6dbaa0624096385 || ($a75d087c013e1d7d$export$d6dbaa0624096385 = {}));
var $a75d087c013e1d7d$export$8f4bdf07a780e3ac;
(function(SourceSelectionCriteria) {
    SourceSelectionCriteria.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$8f4bdf07a780e3ac || ($a75d087c013e1d7d$export$8f4bdf07a780e3ac = {}));
var $a75d087c013e1d7d$export$4ef0a2a837294f64;
(function(ReplicationRule) {
    ReplicationRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $a75d087c013e1d7d$export$c5652b893758d9eb.filterSensitiveLog(obj.Filter)
        });
    };
})($a75d087c013e1d7d$export$4ef0a2a837294f64 || ($a75d087c013e1d7d$export$4ef0a2a837294f64 = {}));
var $a75d087c013e1d7d$export$74f8efd37d5209b2;
(function(ReplicationConfiguration) {
    ReplicationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $a75d087c013e1d7d$export$4ef0a2a837294f64.filterSensitiveLog(item);
            })
        });
    };
})($a75d087c013e1d7d$export$74f8efd37d5209b2 || ($a75d087c013e1d7d$export$74f8efd37d5209b2 = {}));
var $a75d087c013e1d7d$export$8ec47a87cc54e339;
(function(GetBucketReplicationOutput) {
    GetBucketReplicationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.ReplicationConfiguration && {
            ReplicationConfiguration: $a75d087c013e1d7d$export$74f8efd37d5209b2.filterSensitiveLog(obj.ReplicationConfiguration)
        });
    };
})($a75d087c013e1d7d$export$8ec47a87cc54e339 || ($a75d087c013e1d7d$export$8ec47a87cc54e339 = {}));
var $a75d087c013e1d7d$export$e8f64af8ca33bbfd;
(function(GetBucketReplicationRequest) {
    GetBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$e8f64af8ca33bbfd || ($a75d087c013e1d7d$export$e8f64af8ca33bbfd = {}));
var $a75d087c013e1d7d$export$8b846c4a43a75e9e;
(function(GetBucketRequestPaymentOutput) {
    GetBucketRequestPaymentOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$8b846c4a43a75e9e || ($a75d087c013e1d7d$export$8b846c4a43a75e9e = {}));
var $a75d087c013e1d7d$export$a3b6600fe888f873;
(function(GetBucketRequestPaymentRequest) {
    GetBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a3b6600fe888f873 || ($a75d087c013e1d7d$export$a3b6600fe888f873 = {}));
var $a75d087c013e1d7d$export$b794c693046ccc37;
(function(GetBucketTaggingOutput) {
    GetBucketTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b794c693046ccc37 || ($a75d087c013e1d7d$export$b794c693046ccc37 = {}));
var $a75d087c013e1d7d$export$4cb4643c20453b75;
(function(GetBucketTaggingRequest) {
    GetBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4cb4643c20453b75 || ($a75d087c013e1d7d$export$4cb4643c20453b75 = {}));
var $a75d087c013e1d7d$export$6f458e80d9a168b;
(function(GetBucketVersioningOutput) {
    GetBucketVersioningOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$6f458e80d9a168b || ($a75d087c013e1d7d$export$6f458e80d9a168b = {}));
var $a75d087c013e1d7d$export$199936fd6251213c;
(function(GetBucketVersioningRequest) {
    GetBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$199936fd6251213c || ($a75d087c013e1d7d$export$199936fd6251213c = {}));
var $a75d087c013e1d7d$export$4afca95d558fb444;
(function(ErrorDocument) {
    ErrorDocument.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4afca95d558fb444 || ($a75d087c013e1d7d$export$4afca95d558fb444 = {}));
var $a75d087c013e1d7d$export$c07750ef20ad8d6c;
(function(IndexDocument) {
    IndexDocument.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c07750ef20ad8d6c || ($a75d087c013e1d7d$export$c07750ef20ad8d6c = {}));
var $a75d087c013e1d7d$export$98dc4d8bbaac5b7c;
(function(RedirectAllRequestsTo) {
    RedirectAllRequestsTo.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$98dc4d8bbaac5b7c || ($a75d087c013e1d7d$export$98dc4d8bbaac5b7c = {}));
var $a75d087c013e1d7d$export$fcea0b2db26e6b18;
(function(Condition) {
    Condition.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$fcea0b2db26e6b18 || ($a75d087c013e1d7d$export$fcea0b2db26e6b18 = {}));
var $a75d087c013e1d7d$export$2d8d895a0a0f636e;
(function(Redirect) {
    Redirect.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2d8d895a0a0f636e || ($a75d087c013e1d7d$export$2d8d895a0a0f636e = {}));
var $a75d087c013e1d7d$export$6464c2c4399038e2;
(function(RoutingRule) {
    RoutingRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$6464c2c4399038e2 || ($a75d087c013e1d7d$export$6464c2c4399038e2 = {}));
var $a75d087c013e1d7d$export$4632dcd1018fd6bd;
(function(GetBucketWebsiteOutput) {
    GetBucketWebsiteOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4632dcd1018fd6bd || ($a75d087c013e1d7d$export$4632dcd1018fd6bd = {}));
var $a75d087c013e1d7d$export$b51e2df1df27d690;
(function(GetBucketWebsiteRequest) {
    GetBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b51e2df1df27d690 || ($a75d087c013e1d7d$export$b51e2df1df27d690 = {}));
var $a75d087c013e1d7d$export$9fb6bec1a5c954d6;
(function(GetObjectOutput) {
    GetObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$9fb6bec1a5c954d6 || ($a75d087c013e1d7d$export$9fb6bec1a5c954d6 = {}));
var $a75d087c013e1d7d$export$3373ea9743883feb;
(function(GetObjectRequest) {
    GetObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$3373ea9743883feb || ($a75d087c013e1d7d$export$3373ea9743883feb = {}));
var $a75d087c013e1d7d$export$6424f05126e7daf8;
(function(InvalidObjectState) {
    InvalidObjectState.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$6424f05126e7daf8 || ($a75d087c013e1d7d$export$6424f05126e7daf8 = {}));
var $a75d087c013e1d7d$export$1f6f8c73c651f3ca;
(function(NoSuchKey) {
    NoSuchKey.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$1f6f8c73c651f3ca || ($a75d087c013e1d7d$export$1f6f8c73c651f3ca = {}));
var $a75d087c013e1d7d$export$7c40a2227fecdc12;
(function(GetObjectAclOutput) {
    GetObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$7c40a2227fecdc12 || ($a75d087c013e1d7d$export$7c40a2227fecdc12 = {}));
var $a75d087c013e1d7d$export$cb1a4ad2e0f38f95;
(function(GetObjectAclRequest) {
    GetObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$cb1a4ad2e0f38f95 || ($a75d087c013e1d7d$export$cb1a4ad2e0f38f95 = {}));
var $a75d087c013e1d7d$export$f3dff23941310d9;
(function(ObjectLockLegalHold) {
    ObjectLockLegalHold.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$f3dff23941310d9 || ($a75d087c013e1d7d$export$f3dff23941310d9 = {}));
var $a75d087c013e1d7d$export$9939dc80bbea1acd;
(function(GetObjectLegalHoldOutput) {
    GetObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$9939dc80bbea1acd || ($a75d087c013e1d7d$export$9939dc80bbea1acd = {}));
var $a75d087c013e1d7d$export$5f8862ba76850511;
(function(GetObjectLegalHoldRequest) {
    GetObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$5f8862ba76850511 || ($a75d087c013e1d7d$export$5f8862ba76850511 = {}));
var $a75d087c013e1d7d$export$705dac3c9e25f673;
(function(DefaultRetention) {
    DefaultRetention.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$705dac3c9e25f673 || ($a75d087c013e1d7d$export$705dac3c9e25f673 = {}));
var $a75d087c013e1d7d$export$62ac1d02f31163e0;
(function(ObjectLockRule) {
    ObjectLockRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$62ac1d02f31163e0 || ($a75d087c013e1d7d$export$62ac1d02f31163e0 = {}));
var $a75d087c013e1d7d$export$262d239426342c96;
(function(ObjectLockConfiguration) {
    ObjectLockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$262d239426342c96 || ($a75d087c013e1d7d$export$262d239426342c96 = {}));
var $a75d087c013e1d7d$export$486dc804d3714e8e;
(function(GetObjectLockConfigurationOutput) {
    GetObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$486dc804d3714e8e || ($a75d087c013e1d7d$export$486dc804d3714e8e = {}));
var $a75d087c013e1d7d$export$43efa1cb9cbd5c84;
(function(GetObjectLockConfigurationRequest) {
    GetObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$43efa1cb9cbd5c84 || ($a75d087c013e1d7d$export$43efa1cb9cbd5c84 = {}));
var $a75d087c013e1d7d$export$a0bcf720e4ebfa6b;
(function(ObjectLockRetention) {
    ObjectLockRetention.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a0bcf720e4ebfa6b || ($a75d087c013e1d7d$export$a0bcf720e4ebfa6b = {}));
var $a75d087c013e1d7d$export$5a061f69fa492eee;
(function(GetObjectRetentionOutput) {
    GetObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$5a061f69fa492eee || ($a75d087c013e1d7d$export$5a061f69fa492eee = {}));
var $a75d087c013e1d7d$export$bd618fd4d0be1150;
(function(GetObjectRetentionRequest) {
    GetObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$bd618fd4d0be1150 || ($a75d087c013e1d7d$export$bd618fd4d0be1150 = {}));
var $a75d087c013e1d7d$export$21e84ade4ffc813f;
(function(GetObjectTaggingOutput) {
    GetObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$21e84ade4ffc813f || ($a75d087c013e1d7d$export$21e84ade4ffc813f = {}));
var $a75d087c013e1d7d$export$e8c3f2a82ba22432;
(function(GetObjectTaggingRequest) {
    GetObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$e8c3f2a82ba22432 || ($a75d087c013e1d7d$export$e8c3f2a82ba22432 = {}));
var $a75d087c013e1d7d$export$c7be7807f0a3eea;
(function(GetObjectTorrentOutput) {
    GetObjectTorrentOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c7be7807f0a3eea || ($a75d087c013e1d7d$export$c7be7807f0a3eea = {}));
var $a75d087c013e1d7d$export$93e32e1b0e5460eb;
(function(GetObjectTorrentRequest) {
    GetObjectTorrentRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$93e32e1b0e5460eb || ($a75d087c013e1d7d$export$93e32e1b0e5460eb = {}));
var $a75d087c013e1d7d$export$d5abbb05d727be20;
(function(PublicAccessBlockConfiguration) {
    PublicAccessBlockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d5abbb05d727be20 || ($a75d087c013e1d7d$export$d5abbb05d727be20 = {}));
var $a75d087c013e1d7d$export$3606af58a9ffe87;
(function(GetPublicAccessBlockOutput) {
    GetPublicAccessBlockOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3606af58a9ffe87 || ($a75d087c013e1d7d$export$3606af58a9ffe87 = {}));
var $a75d087c013e1d7d$export$f768b28d574460bb;
(function(GetPublicAccessBlockRequest) {
    GetPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$f768b28d574460bb || ($a75d087c013e1d7d$export$f768b28d574460bb = {}));
var $a75d087c013e1d7d$export$ce473fe6d5e62bdd;
(function(HeadBucketRequest) {
    HeadBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ce473fe6d5e62bdd || ($a75d087c013e1d7d$export$ce473fe6d5e62bdd = {}));
var $a75d087c013e1d7d$export$bbe89283205bd874;
(function(NoSuchBucket) {
    NoSuchBucket.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$bbe89283205bd874 || ($a75d087c013e1d7d$export$bbe89283205bd874 = {}));
var $a75d087c013e1d7d$export$fd185f7330520684;
(function(HeadObjectOutput) {
    HeadObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$fd185f7330520684 || ($a75d087c013e1d7d$export$fd185f7330520684 = {}));
var $a75d087c013e1d7d$export$e9eaca65791fc4c;
(function(HeadObjectRequest) {
    HeadObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$e9eaca65791fc4c || ($a75d087c013e1d7d$export$e9eaca65791fc4c = {}));
var $a75d087c013e1d7d$export$cccced7f72820034;
(function(ListBucketAnalyticsConfigurationsOutput) {
    ListBucketAnalyticsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.AnalyticsConfigurationList && {
            AnalyticsConfigurationList: obj.AnalyticsConfigurationList.map(function(item) {
                return $a75d087c013e1d7d$export$15f94404a081a771.filterSensitiveLog(item);
            })
        });
    };
})($a75d087c013e1d7d$export$cccced7f72820034 || ($a75d087c013e1d7d$export$cccced7f72820034 = {}));
var $a75d087c013e1d7d$export$397b8f33cb9cfc07;
(function(ListBucketAnalyticsConfigurationsRequest) {
    ListBucketAnalyticsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$397b8f33cb9cfc07 || ($a75d087c013e1d7d$export$397b8f33cb9cfc07 = {}));
var $a75d087c013e1d7d$export$b33d88b03a3d62f7;
(function(ListBucketIntelligentTieringConfigurationsOutput) {
    ListBucketIntelligentTieringConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b33d88b03a3d62f7 || ($a75d087c013e1d7d$export$b33d88b03a3d62f7 = {}));
var $a75d087c013e1d7d$export$8bc390bdd26b4fe7;
(function(ListBucketIntelligentTieringConfigurationsRequest) {
    ListBucketIntelligentTieringConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$8bc390bdd26b4fe7 || ($a75d087c013e1d7d$export$8bc390bdd26b4fe7 = {}));
var $a75d087c013e1d7d$export$9e6dae27db161fe4;
(function(ListBucketInventoryConfigurationsOutput) {
    ListBucketInventoryConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.InventoryConfigurationList && {
            InventoryConfigurationList: obj.InventoryConfigurationList.map(function(item) {
                return $a75d087c013e1d7d$export$e13e8ea2fe7b5717.filterSensitiveLog(item);
            })
        });
    };
})($a75d087c013e1d7d$export$9e6dae27db161fe4 || ($a75d087c013e1d7d$export$9e6dae27db161fe4 = {}));
var $a75d087c013e1d7d$export$443f8cd22179a9b7;
(function(ListBucketInventoryConfigurationsRequest) {
    ListBucketInventoryConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$443f8cd22179a9b7 || ($a75d087c013e1d7d$export$443f8cd22179a9b7 = {}));
var $a75d087c013e1d7d$export$a94e91ae224bc393;
(function(ListBucketMetricsConfigurationsOutput) {
    ListBucketMetricsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.MetricsConfigurationList && {
            MetricsConfigurationList: obj.MetricsConfigurationList.map(function(item) {
                return $a75d087c013e1d7d$export$908bafa154008a5e.filterSensitiveLog(item);
            })
        });
    };
})($a75d087c013e1d7d$export$a94e91ae224bc393 || ($a75d087c013e1d7d$export$a94e91ae224bc393 = {}));
var $a75d087c013e1d7d$export$18bea5a661e91351;
(function(ListBucketMetricsConfigurationsRequest) {
    ListBucketMetricsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$18bea5a661e91351 || ($a75d087c013e1d7d$export$18bea5a661e91351 = {}));
var $a75d087c013e1d7d$export$356eb44c374cfc19;
(function(Bucket) {
    Bucket.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$356eb44c374cfc19 || ($a75d087c013e1d7d$export$356eb44c374cfc19 = {}));
var $a75d087c013e1d7d$export$fb68aea51fc1aaa8;
(function(ListBucketsOutput) {
    ListBucketsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$fb68aea51fc1aaa8 || ($a75d087c013e1d7d$export$fb68aea51fc1aaa8 = {}));
var $a75d087c013e1d7d$export$70a8419756bd30c7;
(function(CommonPrefix) {
    CommonPrefix.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$70a8419756bd30c7 || ($a75d087c013e1d7d$export$70a8419756bd30c7 = {}));
var $a75d087c013e1d7d$export$f2cea2a27584e4aa;
(function(Initiator) {
    Initiator.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$f2cea2a27584e4aa || ($a75d087c013e1d7d$export$f2cea2a27584e4aa = {}));
var $a75d087c013e1d7d$export$60e639cfe2512bff;
(function(MultipartUpload) {
    MultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$60e639cfe2512bff || ($a75d087c013e1d7d$export$60e639cfe2512bff = {}));
var $a75d087c013e1d7d$export$ed83d15740b9f76d;
(function(ListMultipartUploadsOutput) {
    ListMultipartUploadsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ed83d15740b9f76d || ($a75d087c013e1d7d$export$ed83d15740b9f76d = {}));
var $a75d087c013e1d7d$export$d96c3e2cf9803f5e;
(function(ListMultipartUploadsRequest) {
    ListMultipartUploadsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d96c3e2cf9803f5e || ($a75d087c013e1d7d$export$d96c3e2cf9803f5e = {}));
var $a75d087c013e1d7d$export$dcacc4a8f6015c36;
(function(_Object) {
    _Object.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$dcacc4a8f6015c36 || ($a75d087c013e1d7d$export$dcacc4a8f6015c36 = {}));
var $a75d087c013e1d7d$export$bd5de99c03e50bdf;
(function(ListObjectsOutput) {
    ListObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$bd5de99c03e50bdf || ($a75d087c013e1d7d$export$bd5de99c03e50bdf = {}));
var $a75d087c013e1d7d$export$b17e2bd91a04aa76;
(function(ListObjectsRequest) {
    ListObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b17e2bd91a04aa76 || ($a75d087c013e1d7d$export$b17e2bd91a04aa76 = {}));
var $a75d087c013e1d7d$export$6fb2827b4fe28be3;
(function(ListObjectsV2Output) {
    ListObjectsV2Output.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$6fb2827b4fe28be3 || ($a75d087c013e1d7d$export$6fb2827b4fe28be3 = {}));
var $a75d087c013e1d7d$export$32fa6adfa8e5165a;
(function(ListObjectsV2Request) {
    ListObjectsV2Request.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$32fa6adfa8e5165a || ($a75d087c013e1d7d$export$32fa6adfa8e5165a = {}));
var $a75d087c013e1d7d$export$a834fe68df71f671;
(function(DeleteMarkerEntry) {
    DeleteMarkerEntry.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a834fe68df71f671 || ($a75d087c013e1d7d$export$a834fe68df71f671 = {}));
var $a75d087c013e1d7d$export$3288b5b55ddbb34f;
(function(ObjectVersion) {
    ObjectVersion.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3288b5b55ddbb34f || ($a75d087c013e1d7d$export$3288b5b55ddbb34f = {}));
var $a75d087c013e1d7d$export$4037923dade2a143;
(function(ListObjectVersionsOutput) {
    ListObjectVersionsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4037923dade2a143 || ($a75d087c013e1d7d$export$4037923dade2a143 = {}));
var $a75d087c013e1d7d$export$7420470087543a24;
(function(ListObjectVersionsRequest) {
    ListObjectVersionsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$7420470087543a24 || ($a75d087c013e1d7d$export$7420470087543a24 = {}));
var $a75d087c013e1d7d$export$7b5bf7981d51054e;
(function(Part) {
    Part.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$7b5bf7981d51054e || ($a75d087c013e1d7d$export$7b5bf7981d51054e = {}));
var $a75d087c013e1d7d$export$8c83b46649a5c089;
(function(ListPartsOutput) {
    ListPartsOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$8c83b46649a5c089 || ($a75d087c013e1d7d$export$8c83b46649a5c089 = {}));
var $a75d087c013e1d7d$export$756cf37efa2403e6;
(function(ListPartsRequest) {
    ListPartsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$756cf37efa2403e6 || ($a75d087c013e1d7d$export$756cf37efa2403e6 = {}));
var $a75d087c013e1d7d$export$95f02e50cfd87383;
(function(PutBucketAccelerateConfigurationRequest) {
    PutBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$95f02e50cfd87383 || ($a75d087c013e1d7d$export$95f02e50cfd87383 = {}));
var $a75d087c013e1d7d$export$15919ea85d7751db;
(function(PutBucketAclRequest) {
    PutBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$15919ea85d7751db || ($a75d087c013e1d7d$export$15919ea85d7751db = {}));
var $a75d087c013e1d7d$export$b29e71de1c43092d;
(function(PutBucketAnalyticsConfigurationRequest) {
    PutBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.AnalyticsConfiguration && {
            AnalyticsConfiguration: $a75d087c013e1d7d$export$15f94404a081a771.filterSensitiveLog(obj.AnalyticsConfiguration)
        });
    };
})($a75d087c013e1d7d$export$b29e71de1c43092d || ($a75d087c013e1d7d$export$b29e71de1c43092d = {}));
var $a75d087c013e1d7d$export$4efc44a8f577c4c6;
(function(CORSConfiguration) {
    CORSConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$4efc44a8f577c4c6 || ($a75d087c013e1d7d$export$4efc44a8f577c4c6 = {}));
var $a75d087c013e1d7d$export$48388c72802bf3b4;
(function(PutBucketCorsRequest) {
    PutBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$48388c72802bf3b4 || ($a75d087c013e1d7d$export$48388c72802bf3b4 = {}));
var $a75d087c013e1d7d$export$b9464fee92783639;
(function(PutBucketEncryptionRequest) {
    PutBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $a75d087c013e1d7d$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($a75d087c013e1d7d$export$b9464fee92783639 || ($a75d087c013e1d7d$export$b9464fee92783639 = {}));
var $a75d087c013e1d7d$export$8ecc19836abd960;
(function(PutBucketIntelligentTieringConfigurationRequest) {
    PutBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$8ecc19836abd960 || ($a75d087c013e1d7d$export$8ecc19836abd960 = {}));
var $a75d087c013e1d7d$export$7bce979f7abe4f73;
(function(PutBucketInventoryConfigurationRequest) {
    PutBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $a75d087c013e1d7d$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($a75d087c013e1d7d$export$7bce979f7abe4f73 || ($a75d087c013e1d7d$export$7bce979f7abe4f73 = {}));
var $a75d087c013e1d7d$export$2bad5a8856023522;
(function(BucketLifecycleConfiguration) {
    BucketLifecycleConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $a75d087c013e1d7d$export$1ac30bbe41f1f9ef.filterSensitiveLog(item);
            })
        });
    };
})($a75d087c013e1d7d$export$2bad5a8856023522 || ($a75d087c013e1d7d$export$2bad5a8856023522 = {}));
var $a75d087c013e1d7d$export$b1f1a3c5136805f6;
(function(PutBucketLifecycleConfigurationRequest) {
    PutBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.LifecycleConfiguration && {
            LifecycleConfiguration: $a75d087c013e1d7d$export$2bad5a8856023522.filterSensitiveLog(obj.LifecycleConfiguration)
        });
    };
})($a75d087c013e1d7d$export$b1f1a3c5136805f6 || ($a75d087c013e1d7d$export$b1f1a3c5136805f6 = {}));
var $a75d087c013e1d7d$export$c183b06f38322f46;
(function(BucketLoggingStatus) {
    BucketLoggingStatus.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$c183b06f38322f46 || ($a75d087c013e1d7d$export$c183b06f38322f46 = {}));
var $a75d087c013e1d7d$export$b7513dc0595a23bf;
(function(PutBucketLoggingRequest) {
    PutBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b7513dc0595a23bf || ($a75d087c013e1d7d$export$b7513dc0595a23bf = {}));
var $a75d087c013e1d7d$export$848d3e19e2b6526f;
(function(PutBucketMetricsConfigurationRequest) {
    PutBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.MetricsConfiguration && {
            MetricsConfiguration: $a75d087c013e1d7d$export$908bafa154008a5e.filterSensitiveLog(obj.MetricsConfiguration)
        });
    };
})($a75d087c013e1d7d$export$848d3e19e2b6526f || ($a75d087c013e1d7d$export$848d3e19e2b6526f = {}));
var $a75d087c013e1d7d$export$832249f88bdec051;
(function(PutBucketNotificationConfigurationRequest) {
    PutBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$832249f88bdec051 || ($a75d087c013e1d7d$export$832249f88bdec051 = {}));
var $a75d087c013e1d7d$export$dd5b80748bfa876c;
(function(PutBucketOwnershipControlsRequest) {
    PutBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$dd5b80748bfa876c || ($a75d087c013e1d7d$export$dd5b80748bfa876c = {}));
var $a75d087c013e1d7d$export$a3745e522d5251e6;
(function(PutBucketPolicyRequest) {
    PutBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a3745e522d5251e6 || ($a75d087c013e1d7d$export$a3745e522d5251e6 = {}));
var $a75d087c013e1d7d$export$80d3d606687bccbe;
(function(PutBucketReplicationRequest) {
    PutBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.ReplicationConfiguration && {
            ReplicationConfiguration: $a75d087c013e1d7d$export$74f8efd37d5209b2.filterSensitiveLog(obj.ReplicationConfiguration)
        });
    };
})($a75d087c013e1d7d$export$80d3d606687bccbe || ($a75d087c013e1d7d$export$80d3d606687bccbe = {}));
var $a75d087c013e1d7d$export$5b5564785205c8b6;
(function(RequestPaymentConfiguration) {
    RequestPaymentConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$5b5564785205c8b6 || ($a75d087c013e1d7d$export$5b5564785205c8b6 = {}));
var $a75d087c013e1d7d$export$efe882c45e4d54c5;
(function(PutBucketRequestPaymentRequest) {
    PutBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$efe882c45e4d54c5 || ($a75d087c013e1d7d$export$efe882c45e4d54c5 = {}));
var $a75d087c013e1d7d$export$2c6436847badca04;
(function(Tagging) {
    Tagging.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$2c6436847badca04 || ($a75d087c013e1d7d$export$2c6436847badca04 = {}));
var $a75d087c013e1d7d$export$907025fe881c3d35;
(function(PutBucketTaggingRequest) {
    PutBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$907025fe881c3d35 || ($a75d087c013e1d7d$export$907025fe881c3d35 = {}));
var $a75d087c013e1d7d$export$12496b4e466310a9;
(function(VersioningConfiguration) {
    VersioningConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$12496b4e466310a9 || ($a75d087c013e1d7d$export$12496b4e466310a9 = {}));
var $a75d087c013e1d7d$export$b342a4ff3cacc8f6;
(function(PutBucketVersioningRequest) {
    PutBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$b342a4ff3cacc8f6 || ($a75d087c013e1d7d$export$b342a4ff3cacc8f6 = {}));
var $a75d087c013e1d7d$export$aec172fe960d640d;
(function(WebsiteConfiguration) {
    WebsiteConfiguration.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$aec172fe960d640d || ($a75d087c013e1d7d$export$aec172fe960d640d = {}));
var $a75d087c013e1d7d$export$98e48334698c13d8;
(function(PutBucketWebsiteRequest) {
    PutBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$98e48334698c13d8 || ($a75d087c013e1d7d$export$98e48334698c13d8 = {}));
var $a75d087c013e1d7d$export$792cedced515bdbd;
(function(PutObjectOutput) {
    PutObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$792cedced515bdbd || ($a75d087c013e1d7d$export$792cedced515bdbd = {}));
var $a75d087c013e1d7d$export$90c5c1bf0f634d21;
(function(PutObjectRequest) {
    PutObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$90c5c1bf0f634d21 || ($a75d087c013e1d7d$export$90c5c1bf0f634d21 = {}));
var $a75d087c013e1d7d$export$e533775617728d56;
(function(PutObjectAclOutput) {
    PutObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$e533775617728d56 || ($a75d087c013e1d7d$export$e533775617728d56 = {}));
var $a75d087c013e1d7d$export$3dc01ad48475bf08;
(function(PutObjectAclRequest) {
    PutObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$3dc01ad48475bf08 || ($a75d087c013e1d7d$export$3dc01ad48475bf08 = {}));
var $a75d087c013e1d7d$export$d9144478e705d522;
(function(PutObjectLegalHoldOutput) {
    PutObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d9144478e705d522 || ($a75d087c013e1d7d$export$d9144478e705d522 = {}));
var $a75d087c013e1d7d$export$71c3c7a041df44ca;
(function(PutObjectLegalHoldRequest) {
    PutObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$71c3c7a041df44ca || ($a75d087c013e1d7d$export$71c3c7a041df44ca = {}));
var $a75d087c013e1d7d$export$93f296cba8bc1760;
(function(PutObjectLockConfigurationOutput) {
    PutObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$93f296cba8bc1760 || ($a75d087c013e1d7d$export$93f296cba8bc1760 = {}));
var $a75d087c013e1d7d$export$693145724507a617;
(function(PutObjectLockConfigurationRequest) {
    PutObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$693145724507a617 || ($a75d087c013e1d7d$export$693145724507a617 = {}));
var $a75d087c013e1d7d$export$edd40f596f5fa31e;
(function(PutObjectRetentionOutput) {
    PutObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$edd40f596f5fa31e || ($a75d087c013e1d7d$export$edd40f596f5fa31e = {}));
var $a75d087c013e1d7d$export$117e9cab66df5006;
(function(PutObjectRetentionRequest) {
    PutObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$117e9cab66df5006 || ($a75d087c013e1d7d$export$117e9cab66df5006 = {}));
var $a75d087c013e1d7d$export$d9e3a7e4f51c31d5;
(function(PutObjectTaggingOutput) {
    PutObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$d9e3a7e4f51c31d5 || ($a75d087c013e1d7d$export$d9e3a7e4f51c31d5 = {}));
var $a75d087c013e1d7d$export$f5517f211c9a0baf;
(function(PutObjectTaggingRequest) {
    PutObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$f5517f211c9a0baf || ($a75d087c013e1d7d$export$f5517f211c9a0baf = {}));
var $a75d087c013e1d7d$export$11868106b24a9ab0;
(function(PutPublicAccessBlockRequest) {
    PutPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$11868106b24a9ab0 || ($a75d087c013e1d7d$export$11868106b24a9ab0 = {}));
var $a75d087c013e1d7d$export$a97e3c65be291319;
(function(ObjectAlreadyInActiveTierError) {
    ObjectAlreadyInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$a97e3c65be291319 || ($a75d087c013e1d7d$export$a97e3c65be291319 = {}));
var $a75d087c013e1d7d$export$ee3cf9307c2a87ae;
(function(RestoreObjectOutput) {
    RestoreObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$ee3cf9307c2a87ae || ($a75d087c013e1d7d$export$ee3cf9307c2a87ae = {}));
var $a75d087c013e1d7d$export$e9e40009732846c;
(function(GlacierJobParameters) {
    GlacierJobParameters.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($a75d087c013e1d7d$export$e9e40009732846c || ($a75d087c013e1d7d$export$e9e40009732846c = {}));
var $a75d087c013e1d7d$export$d60a27d0da10cee5;
(function(Encryption) {
    Encryption.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.KMSKeyId && {
            KMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($a75d087c013e1d7d$export$d60a27d0da10cee5 || ($a75d087c013e1d7d$export$d60a27d0da10cee5 = {}));






/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a2c0da0b56e88d50$var$extendStatics = function(d, b) {
    $a2c0da0b56e88d50$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a2c0da0b56e88d50$var$extendStatics(d, b);
};
function $a2c0da0b56e88d50$export$a8ba968b8961cb8a(d, b) {
    $a2c0da0b56e88d50$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a2c0da0b56e88d50$export$18ce0697a983be9b = function() {
    $a2c0da0b56e88d50$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a2c0da0b56e88d50$export$18ce0697a983be9b.apply(this, arguments);
};
function $a2c0da0b56e88d50$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a2c0da0b56e88d50$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a2c0da0b56e88d50$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a2c0da0b56e88d50$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a2c0da0b56e88d50$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a2c0da0b56e88d50$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a2c0da0b56e88d50$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a2c0da0b56e88d50$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a2c0da0b56e88d50$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a2c0da0b56e88d50$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a2c0da0b56e88d50$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a2c0da0b56e88d50$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a2c0da0b56e88d50$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a2c0da0b56e88d50$export$10c90e4f7922046c(v) {
    return this instanceof $a2c0da0b56e88d50$export$10c90e4f7922046c ? (this.v = v, this) : new $a2c0da0b56e88d50$export$10c90e4f7922046c(v);
}
function $a2c0da0b56e88d50$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a2c0da0b56e88d50$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a2c0da0b56e88d50$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a2c0da0b56e88d50$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a2c0da0b56e88d50$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a2c0da0b56e88d50$export$19a8beecd37a4c45 === "function" ? $a2c0da0b56e88d50$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a2c0da0b56e88d50$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a2c0da0b56e88d50$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a2c0da0b56e88d50$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a2c0da0b56e88d50$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a2c0da0b56e88d50$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/**
 * Escapes characters that can not be in an XML attribute.
 */ function $f0219b8a87e0be7b$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}


/**
 * Represents an XML node.
 */ var $624db86d198ff371$export$e775a15d806cbddc = /** @class */ function() {
    function XmlNode(name, children) {
        if (children === void 0) children = [];
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    XmlNode.prototype.withName = function(name) {
        this.name = name;
        return this;
    };
    XmlNode.prototype.addAttribute = function(name, value) {
        this.attributes[name] = value;
        return this;
    };
    XmlNode.prototype.addChildNode = function(child) {
        this.children.push(child);
        return this;
    };
    XmlNode.prototype.removeAttribute = function(name) {
        delete this.attributes[name];
        return this;
    };
    XmlNode.prototype.toString = function() {
        var e_1, _a;
        var hasChildren = Boolean(this.children.length);
        var xmlText = "<" + this.name;
        // add attributes
        var attributes = this.attributes;
        try {
            for(var _b = (0, $a2c0da0b56e88d50$export$19a8beecd37a4c45)(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var attributeName = _c.value;
                var attribute = attributes[attributeName];
                if (typeof attribute !== "undefined" && attribute !== null) xmlText += " " + attributeName + '="' + (0, $f0219b8a87e0be7b$export$30330f3d5eb70e11)("" + attribute) + '"';
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return xmlText += !hasChildren ? "/>" : ">" + this.children.map(function(c) {
            return c.toString();
        }).join("") + "</" + this.name + ">";
    };
    return XmlNode;
}();


/**
 * Escapes characters that can not be in an XML element.
 */ function $74c395e479398db2$export$e5104ffd394b43ec(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


/**
 * Represents an XML text value.
 */ var $cd594e57aad4e5d1$export$b35b8f45887823df = /** @class */ function() {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function() {
        return (0, $74c395e479398db2$export$e5104ffd394b43ec)("" + this.value);
    };
    return XmlText;
}();




var $3519767cfc6fdeeb$export$98e6a39c04603d36;
var $3519767cfc6fdeeb$export$e4f0b40d01c251ab;
var $3519767cfc6fdeeb$export$2ca3eb0a2f8a693a;
var $3519767cfc6fdeeb$export$e31c2b05678acf26;
var $3519767cfc6fdeeb$export$54ffaacfc0931fb0;
var $3519767cfc6fdeeb$export$a22775fa5e2eebd9;
var $3519767cfc6fdeeb$export$30384b60aedf98a5;
var $3519767cfc6fdeeb$export$3a5cfc971f52ee31;
"use strict";
var $ef0918dddd13d48e$export$e31c2b05678acf26;
"use strict";

var $l8rQG = parcelRequire("l8rQG");
const $ef0918dddd13d48e$var$convertToJson = function(node, options, parentTagName) {
    const jObj = {};
    // when no child node or attr is present
    if (!options.alwaysCreateTextNode && (!node.child || $l8rQG.isEmptyObject(node.child)) && (!node.attrsMap || $l8rQG.isEmptyObject(node.attrsMap))) return $l8rQG.isExist(node.val) ? node.val : "";
    // otherwise create a textnode if node has some text
    if ($l8rQG.isExist(node.val) && !(typeof node.val === "string" && (node.val === "" || node.val === options.cdataPositionChar))) {
        const asArray = $l8rQG.isTagNameInArrayMode(node.tagname, options.arrayMode, parentTagName);
        jObj[options.textNodeName] = asArray ? [
            node.val
        ] : node.val;
    }
    $l8rQG.merge(jObj, node.attrsMap, options.arrayMode);
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagName = keys[index];
        if (node.child[tagName] && node.child[tagName].length > 1) {
            jObj[tagName] = [];
            for(let tag in node.child[tagName])if (node.child[tagName].hasOwnProperty(tag)) jObj[tagName].push($ef0918dddd13d48e$var$convertToJson(node.child[tagName][tag], options, tagName));
        } else {
            const result = $ef0918dddd13d48e$var$convertToJson(node.child[tagName][0], options, tagName);
            const asArray = options.arrayMode === true && typeof result === "object" || $l8rQG.isTagNameInArrayMode(tagName, options.arrayMode, parentTagName);
            jObj[tagName] = asArray ? [
                result
            ] : result;
        }
    }
    //add value
    return jObj;
};
$ef0918dddd13d48e$export$e31c2b05678acf26 = $ef0918dddd13d48e$var$convertToJson;



var $21YsA = parcelRequire("21YsA");

var $21YsA = parcelRequire("21YsA");

var $l8rQG = parcelRequire("l8rQG");
var $3519767cfc6fdeeb$require$buildOptions = $l8rQG.buildOptions;
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $e6697f46f4a0942a$export$a22775fa5e2eebd9;
"use strict";

var $l8rQG = parcelRequire("l8rQG");
const $e6697f46f4a0942a$var$defaultOptions = {
    allowBooleanAttributes: false
};
const $e6697f46f4a0942a$var$props = [
    "allowBooleanAttributes"
];
$e6697f46f4a0942a$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = $l8rQG.buildOptions(options, $e6697f46f4a0942a$var$defaultOptions, $e6697f46f4a0942a$var$props);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === "\uFEFF") // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === "<" && xmlData[i + 1] === "?") {
            i += 2;
            i = $e6697f46f4a0942a$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === "<") {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === "!") {
                i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === "/") {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = "";
                for(; i < xmlData.length && xmlData[i] !== ">" && xmlData[i] !== " " && xmlData[i] !== "	" && xmlData[i] !== "\n" && xmlData[i] !== "\r"; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === "/") {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$e6697f46f4a0942a$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $e6697f46f4a0942a$var$readAttributeStr(xmlData, i);
                if (result === false) return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attributes for '" + tagName + "' have open quote.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === "/") {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", "Closing tag '" + tagName + "' doesn't have proper closing.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "Multiple possible root nodes found.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === "<") {
                        if (xmlData[i + 1] === "!") {
                            //comment or CADATA
                            i++;
                            i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === "?") {
                            i = $e6697f46f4a0942a$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === "&") {
                        const afterAmp = $e6697f46f4a0942a$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $e6697f46f4a0942a$var$getErrorObject("InvalidChar", "char '&' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    }
                } //end of reading tag text value
                if (xmlData[i] === "<") i--;
            }
        } else {
            if (xmlData[i] === " " || xmlData[i] === "	" || xmlData[i] === "\n" || xmlData[i] === "\r") continue;
            return $e6697f46f4a0942a$var$getErrorObject("InvalidChar", "char '" + xmlData[i] + "' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "Start tag expected.", 1);
    else if (tags.length == 1) return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", "Unclosed tag '" + tags[0].tagName + "'.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $e6697f46f4a0942a$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == "?" || xmlData[i] == " ") {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === "xml") return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "XML declaration allowed only at the start of the document.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == "?" && xmlData[i + 1] == ">") {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === "-" && xmlData[i + 2] === "-") {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === "-" && xmlData[i + 1] === "-" && xmlData[i + 2] === ">") {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === "D" && xmlData[i + 2] === "O" && xmlData[i + 3] === "C" && xmlData[i + 4] === "T" && xmlData[i + 5] === "Y" && xmlData[i + 6] === "P" && xmlData[i + 7] === "E") {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === "<") angleBracketsCount++;
            else if (xmlData[i] === ">") {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === "[" && xmlData[i + 2] === "C" && xmlData[i + 3] === "D" && xmlData[i + 4] === "A" && xmlData[i + 5] === "T" && xmlData[i + 6] === "A" && xmlData[i + 7] === "[") {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === "]" && xmlData[i + 1] === "]" && xmlData[i + 2] === ">") {
            i += 2;
            break;
        }
    }
    return i;
}
const $e6697f46f4a0942a$var$doubleQuote = '"';
const $e6697f46f4a0942a$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $e6697f46f4a0942a$var$readAttributeStr(xmlData, i) {
    let attrStr = "";
    let startChar = "";
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $e6697f46f4a0942a$var$doubleQuote || xmlData[i] === $e6697f46f4a0942a$var$singleQuote) {
            if (startChar === "") startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = "";
        } else if (xmlData[i] === ">") {
            if (startChar === "") {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== "") return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $e6697f46f4a0942a$var$validAttrStrRegxp = new RegExp("(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['\"])(([\\s\\S])*?)\\5)?", "g");
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $e6697f46f4a0942a$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $l8rQG.getAllMatches(attrStr, $e6697f46f4a0942a$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attribute '" + matches[i][2] + "' has no space in starting.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "boolean attribute '" + matches[i][2] + "' is not allowed.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$e6697f46f4a0942a$var$validateAttrName(attrName)) return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is an invalid name.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is repeated.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === "x") {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ";") return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $e6697f46f4a0942a$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ";") return -1;
    if (xmlData[i] === "#") {
        i++;
        return $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ";") break;
        return -1;
    }
    return i;
}
function $e6697f46f4a0942a$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $e6697f46f4a0942a$var$validateAttrName(attrName) {
    return $l8rQG.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $e6697f46f4a0942a$var$validateTagName(tagname) {
    return $l8rQG.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $e6697f46f4a0942a$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}


$3519767cfc6fdeeb$export$98e6a39c04603d36 = function(xmlData, givenOptions = {}, validationOption) {
    if (validationOption) {
        if (validationOption === true) validationOption = {};
        const result = $e6697f46f4a0942a$export$a22775fa5e2eebd9(xmlData, validationOption);
        if (result !== true) throw Error(result.err.msg);
    }
    if (givenOptions.parseTrueNumberOnly && givenOptions.parseNodeValue !== false && !givenOptions.numParseOptions) givenOptions.numParseOptions = {
        leadingZeros: false
    };
    let options = $3519767cfc6fdeeb$require$buildOptions(givenOptions, $21YsA.defaultOptions, $21YsA.props);
    const traversableObj = $21YsA.getTraversalObj(xmlData, options);
    //print(traversableObj, "  ");
    return $ef0918dddd13d48e$export$e31c2b05678acf26(traversableObj, options);
};

$3519767cfc6fdeeb$export$e4f0b40d01c251ab = (parcelRequire("9CiNR")).convert2nimn;
$3519767cfc6fdeeb$export$2ca3eb0a2f8a693a = $21YsA.getTraversalObj;
$3519767cfc6fdeeb$export$e31c2b05678acf26 = $ef0918dddd13d48e$export$e31c2b05678acf26;

$3519767cfc6fdeeb$export$54ffaacfc0931fb0 = (parcelRequire("ajMmB")).convertToJsonString;
$3519767cfc6fdeeb$export$a22775fa5e2eebd9 = $e6697f46f4a0942a$export$a22775fa5e2eebd9;

$3519767cfc6fdeeb$export$30384b60aedf98a5 = (parcelRequire("gnljR"));
$3519767cfc6fdeeb$export$3a5cfc971f52ee31 = function(xmlData, schema, options) {
    return $3519767cfc6fdeeb$export$e4f0b40d01c251ab($3519767cfc6fdeeb$export$2ca3eb0a2f8a693a(xmlData, options), schema, options);
};
function $3519767cfc6fdeeb$var$print(xmlNode, indentation) {
    if (xmlNode) {
        console.log(indentation + "{");
        console.log(indentation + '  "tagName": "' + xmlNode.tagname + '", ');
        if (xmlNode.parent) console.log(indentation + '  "parent": "' + xmlNode.parent.tagname + '", ');
        console.log(indentation + '  "val": "' + xmlNode.val + '", ');
        console.log(indentation + '  "attrs": ' + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
        if (xmlNode.child) {
            console.log(indentation + '"child": {');
            const indentation2 = indentation + indentation;
            Object.keys(xmlNode.child).forEach(function(key) {
                const node = xmlNode.child[key];
                if (Array.isArray(node)) {
                    console.log(indentation + '"' + key + '" :[');
                    node.forEach(function(item, index) {
                        //console.log(indentation + " \""+index+"\" : [")
                        $3519767cfc6fdeeb$var$print(item, indentation2);
                    });
                    console.log(indentation + "],");
                } else {
                    console.log(indentation + ' "' + key + '" : {');
                    $3519767cfc6fdeeb$var$print(node, indentation2);
                    console.log(indentation + "},");
                }
            });
            console.log(indentation + "},");
        }
        console.log(indentation + "},");
    }
}


var $748b18c285b09559$export$a7d2d025c66f9235 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "x-id": "AbortMultipartUpload"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$2a09fb9495f08c55 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.MultipartUpload !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlCompletedMultipartUpload(input.MultipartUpload, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$3fa883360ffbe82d = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.MetadataDirective) && {
                        "x-amz-metadata-directive": input.MetadataDirective
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.TaggingDirective) && {
                        "x-amz-tagging-directive": input.TaggingDirective
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "CopyObject"
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ff9b8bd3304a2cc2 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockEnabledForBucket) && {
                        "x-amz-bucket-object-lock-enabled": input.ObjectLockEnabledForBucket.toString()
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.CreateBucketConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlCreateBucketConfiguration(input.CreateBucketConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$4730de34492fdc2 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        uploads: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$4c739e7bdecdc09e = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$1599103c79e9cc48 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$328eda7443168fa1 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$a935f4341563a8e5 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c04145b770da67a8 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "intelligent-tiering": ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ea4a1894e3000c1a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ff5be01ded2fe32 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$f050fc1ef4eb3607 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9809275ad1405c95 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$d35e7f7cfb4671a8 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9a7bb1ffbd4a4abf = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$898454ff9153710a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$55003dd0346cc6e0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$400c19cbac9616f7 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "x-id": "DeleteObject"
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$6867c23377cf4e18 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        delete: ""
                    };
                    if (input.Delete !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlDelete(input.Delete, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c5216ce889528f85 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$6e75832e2b10791c = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$401fbb1296db6719 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$36598b1e884464d4 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$4d648e59e03d69d2 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        analytics: "",
                        "x-id": "GetBucketAnalyticsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c50cfec8b08a5bc7 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$59a2b88153b9bcd3 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$f5f10fa8975a8db2 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "intelligent-tiering": "",
                        "x-id": "GetBucketIntelligentTieringConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$27733aaa6f8bdfce = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        inventory: "",
                        "x-id": "GetBucketInventoryConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$a45e301366f2d4b7 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$57578b49828da279 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        location: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$fba64f4839ba2759 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$55cedf3b8782e93a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        metrics: "",
                        "x-id": "GetBucketMetricsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$28aa3066de46a217 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$8ff61553a991ad45 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9c4ddc2418c2498a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$5cc8b1c7c38eaa70 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policyStatus: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7bfb07297b27feda = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c40582f35b41168f = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7fe7f3d9e83c1258 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$33bb47afa1d36b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$86d6bcc10cc7214f = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$713ae52666bf2204 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.IfMatch) && {
                        "if-match": input.IfMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "if-modified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "if-none-match": input.IfNoneMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "if-unmodified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Range) && {
                        range: input.Range
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "x-id": "GetObject"
                    }, input.ResponseCacheControl !== undefined && {
                        "response-cache-control": input.ResponseCacheControl
                    }), input.ResponseContentDisposition !== undefined && {
                        "response-content-disposition": input.ResponseContentDisposition
                    }), input.ResponseContentEncoding !== undefined && {
                        "response-content-encoding": input.ResponseContentEncoding
                    }), input.ResponseContentLanguage !== undefined && {
                        "response-content-language": input.ResponseContentLanguage
                    }), input.ResponseContentType !== undefined && {
                        "response-content-type": input.ResponseContentType
                    }), input.ResponseExpires !== undefined && {
                        "response-expires": (input.ResponseExpires.toISOString().split(".")[0] + "Z").toString()
                    }), input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$915aba65107b1e0b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9c08e676bdd74a0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$6b8bcfdbd9049617 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$73761af73f60c98c = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9eb633d3ed47ffa4 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$19b09331a932f5f6 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        torrent: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$96bfd3c7dd0a4d0a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$33042663db00ac59 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7d02887d047f6825 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.IfMatch) && {
                        "if-match": input.IfMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "if-modified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "if-none-match": input.IfNoneMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "if-unmodified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Range) && {
                        range: input.Range
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$1af1bbf8ced1a360 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        analytics: "",
                        "x-id": "ListBucketAnalyticsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$471f09a61710187f = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "intelligent-tiering": "",
                        "x-id": "ListBucketIntelligentTieringConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$84049d82728011d8 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        inventory: "",
                        "x-id": "ListBucketInventoryConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$4386fb1e1f56eefe = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        metrics: "",
                        "x-id": "ListBucketMetricsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$94ca891f34564e01 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/";
                    body = "";
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$67092c8b2bd6afb9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        uploads: ""
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxUploads !== undefined && {
                        "max-uploads": input.MaxUploads.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.UploadIdMarker !== undefined && {
                        "upload-id-marker": input.UploadIdMarker
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$acd8b176cbc51cb9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.Marker !== undefined && {
                        marker: input.Marker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ea6ee77e40f86bd9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "list-type": "2"
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    }), input.FetchOwner !== undefined && {
                        "fetch-owner": input.FetchOwner.toString()
                    }), input.StartAfter !== undefined && {
                        "start-after": input.StartAfter
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e9deb593aaba1069 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        versions: ""
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.VersionIdMarker !== undefined && {
                        "version-id-marker": input.VersionIdMarker
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$b2b39cf3937e8c76 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "x-id": "ListParts"
                    }, input.MaxParts !== undefined && {
                        "max-parts": input.MaxParts.toString()
                    }), input.PartNumberMarker !== undefined && {
                        "part-number-marker": input.PartNumberMarker
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$4d770bb452c6d670 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    if (input.AccelerateConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlAccelerateConfiguration(input.AccelerateConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$415e832013d5f94b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$82791d7115b07b04 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.AnalyticsConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlAnalyticsConfiguration(input.AnalyticsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c86e5c4d1766d14 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    if (input.CORSConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlCORSConfiguration(input.CORSConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c279f7b43c9bb310 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    if (input.ServerSideEncryptionConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c9101820ff6720b2 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/xml"
                    };
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "intelligent-tiering": ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.IntelligentTieringConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlIntelligentTieringConfiguration(input.IntelligentTieringConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$6d95946d99f43eaa = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.InventoryConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlInventoryConfiguration(input.InventoryConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$70f4fe83400d730d = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    if (input.LifecycleConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlBucketLifecycleConfiguration(input.LifecycleConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$2426ada7dacc12b9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    if (input.BucketLoggingStatus !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlBucketLoggingStatus(input.BucketLoggingStatus, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$dd9ccb6c86dc9b75 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.MetricsConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlMetricsConfiguration(input.MetricsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$cc9aba63382b97f4 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    if (input.NotificationConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlNotificationConfiguration(input.NotificationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$cd645fbb22474aad = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    if (input.OwnershipControls !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlOwnershipControls(input.OwnershipControls, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$46f7931bb495aaa = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "text/plain"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ConfirmRemoveSelfBucketAccess) && {
                        "x-amz-confirm-remove-self-bucket-access": input.ConfirmRemoveSelfBucketAccess.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    if (input.Policy !== undefined) {
                        contents = input.Policy;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$bc85604c47270690 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    if (input.ReplicationConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlReplicationConfiguration(input.ReplicationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$d688e45835bb412b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    if (input.RequestPaymentConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlRequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$fb33aa4addeb7925 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    if (input.Tagging !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$b2b33319a5c1fa1b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    if (input.VersioningConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlVersioningConfiguration(input.VersioningConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$3684a013c739abf7 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    if (input.WebsiteConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlWebsiteConfiguration(input.WebsiteConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$6c3f9d82bec72a8d = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/octet-stream"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentLength) && {
                        "content-length": input.ContentLength.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "PutObject"
                    };
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c5f7c1bb4a245310 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$3cae5f4de1f7d8e0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.LegalHold !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlObjectLockLegalHold(input.LegalHold, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e85a5935e0b9ebcf = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    if (input.ObjectLockConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlObjectLockConfiguration(input.ObjectLockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$401e449dfbceed84 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Retention !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlObjectLockRetention(input.Retention, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c73061b6e5d6a95a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Tagging !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9f1c307a4d5bd5b3 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    if (input.PublicAccessBlockConfiguration !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlPublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$99a912d071900c76 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        restore: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.RestoreRequest !== undefined) {
                        contents = $748b18c285b09559$var$serializeAws_restXmlRestoreRequest(input.RestoreRequest, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$47ebf91740d2ce6f = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, bodyNode, node, node, node, node, node, node, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        select: "",
                        "select-type": "2"
                    };
                    body = '<?xml version="1.0" encoding="UTF-8"?>';
                    bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SelectObjectContentRequest");
                    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                    if (input.Expression !== undefined) {
                        node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Expression").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Expression)).withName("Expression");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ExpressionType !== undefined) {
                        node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ExpressionType").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ExpressionType)).withName("ExpressionType");
                        bodyNode.addChildNode(node);
                    }
                    if (input.InputSerialization !== undefined) {
                        node = $748b18c285b09559$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.OutputSerialization !== undefined) {
                        node = $748b18c285b09559$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.RequestProgress !== undefined) {
                        node = $748b18c285b09559$var$serializeAws_restXmlRequestProgress(input.RequestProgress, context).withName("RequestProgress");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ScanRange !== undefined) {
                        node = $748b18c285b09559$var$serializeAws_restXmlScanRange(input.ScanRange, context).withName("ScanRange");
                        bodyNode.addChildNode(node);
                    }
                    body += bodyNode.toString();
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$6dfc42032d3f37d4 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "content-type": "application/octet-stream"
                    }, $748b18c285b09559$var$isSerializableHeaderValue(input.ContentLength) && {
                        "content-length": input.ContentLength.toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "x-id": "UploadPart"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$90763da135bbc5f9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $748b18c285b09559$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $43662a98672ca59d$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceRange) && {
                        "x-amz-copy-source-range": input.CopySourceRange
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $748b18c285b09559$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $5bb55e60897073a2$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        "x-id": "UploadPartCopy"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $2368114ecf8ea544$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$87447564e9ee4b69 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlAbortMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlAbortMultipartUploadCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ee5aaa25931389ce = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Bucket: undefined,
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Key: undefined,
                        Location: undefined,
                        RequestCharged: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["ETag"] !== undefined) contents.ETag = data["ETag"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["Location"] !== undefined) contents.Location = data["Location"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlCompleteMultipartUploadCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$a5d77c8b6651b993 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlCopyObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        CopyObjectResult: undefined,
                        CopySourceVersionId: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyObjectResult = $748b18c285b09559$var$deserializeAws_restXmlCopyObjectResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlCopyObjectCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$b4e8f8f452bdb204 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlCreateBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Location: undefined
                    };
                    if (output.headers["location"] !== undefined) contents.Location = output.headers["location"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlCreateBucketCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlBucketAlreadyExistsResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$95cf7bc6357ae5a8 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlCreateMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        BucketKeyEnabled: undefined,
                        Key: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlCreateMultipartUploadCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c5d62536e1c56e82 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$820ce8b5969d2c78 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$dea26f8b4dad38ea = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketCorsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$48d65b1878f8cb7f = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$bfa9d8ef1df37dec = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$dc33768e2651b6cb = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$1660bb2bbec5b369 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ea7eb03b8f77dc6a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$649e1231e4f3b774 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$470e22ed3eb8b871 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketPolicyCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$a8348308c83bfe9d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketReplicationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$8f5814a38b853d38 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketTaggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$bc95350311fac763 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$987b292ae9f16665 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        DeleteMarker: undefined,
                        RequestCharged: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteObjectCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ebb9378c7c531fa5 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Deleted: undefined,
                        Errors: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Deleted === "") contents.Deleted = [];
                    if (data["Deleted"] !== undefined) contents.Deleted = $748b18c285b09559$var$deserializeAws_restXmlDeletedObjects((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Deleted"]), context);
                    if (data.Error === "") contents.Errors = [];
                    if (data["Error"] !== undefined) contents.Errors = $748b18c285b09559$var$deserializeAws_restXmlErrors((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Error"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteObjectsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7021ac5189f9792d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeleteObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteObjectTaggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$4cf24390776e8eb6 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$30393acaf6414a50 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$56e18e7cfcb102eb = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $748b18c285b09559$var$deserializeAws_restXmlGrants((0, $3cac61d5afd59793$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketAclCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$8103ef82db64a4aa = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        AnalyticsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.AnalyticsConfiguration = $748b18c285b09559$var$deserializeAws_restXmlAnalyticsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$472fdec99155a887 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        CORSRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CORSRule === "") contents.CORSRules = [];
                    if (data["CORSRule"] !== undefined) contents.CORSRules = $748b18c285b09559$var$deserializeAws_restXmlCORSRules((0, $3cac61d5afd59793$export$52272e038712c64e)(data["CORSRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketCorsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$d83d67d0bf5676cb = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        ServerSideEncryptionConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ServerSideEncryptionConfiguration = $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketEncryptionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$3055c22f7a188cb2 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        IntelligentTieringConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.IntelligentTieringConfiguration = $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$cd1101fd9c222af8 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        InventoryConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.InventoryConfiguration = $748b18c285b09559$var$deserializeAws_restXmlInventoryConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$b85a74c7951988c1 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Rules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Rule === "") contents.Rules = [];
                    if (data["Rule"] !== undefined) contents.Rules = $748b18c285b09559$var$deserializeAws_restXmlLifecycleRules((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Rule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$d332d0a204c1f2de = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketLocationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        LocationConstraint: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LocationConstraint"] !== undefined) contents.LocationConstraint = data["LocationConstraint"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketLocationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$99325a82aa21e152 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        LoggingEnabled: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LoggingEnabled"] !== undefined) contents.LoggingEnabled = $748b18c285b09559$var$deserializeAws_restXmlLoggingEnabled(data["LoggingEnabled"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketLoggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$33f849a042e960f2 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        MetricsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.MetricsConfiguration = $748b18c285b09559$var$deserializeAws_restXmlMetricsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$f7ea4be33406a0a0 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        LambdaFunctionConfigurations: undefined,
                        QueueConfigurations: undefined,
                        TopicConfigurations: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CloudFunctionConfiguration === "") contents.LambdaFunctionConfigurations = [];
                    if (data["CloudFunctionConfiguration"] !== undefined) contents.LambdaFunctionConfigurations = $748b18c285b09559$var$deserializeAws_restXmlLambdaFunctionConfigurationList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["CloudFunctionConfiguration"]), context);
                    if (data.QueueConfiguration === "") contents.QueueConfigurations = [];
                    if (data["QueueConfiguration"] !== undefined) contents.QueueConfigurations = $748b18c285b09559$var$deserializeAws_restXmlQueueConfigurationList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["QueueConfiguration"]), context);
                    if (data.TopicConfiguration === "") contents.TopicConfigurations = [];
                    if (data["TopicConfiguration"] !== undefined) contents.TopicConfigurations = $748b18c285b09559$var$deserializeAws_restXmlTopicConfigurationList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["TopicConfiguration"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e51b6b0868913b77 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        OwnershipControls: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.OwnershipControls = $748b18c285b09559$var$deserializeAws_restXmlOwnershipControls(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$74beb134589fee09 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Policy: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Policy"] !== undefined) contents.Policy = data["Policy"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketPolicyCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$bb27e87cf2face4 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        PolicyStatus: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PolicyStatus = $748b18c285b09559$var$deserializeAws_restXmlPolicyStatus(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$640745a275665c3f = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        ReplicationConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ReplicationConfiguration = $748b18c285b09559$var$deserializeAws_restXmlReplicationConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketReplicationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$95dd746113207b99 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Payer: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Payer"] !== undefined) contents.Payer = data["Payer"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e91d7dc8d3f2bb37 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        TagSet: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $748b18c285b09559$var$deserializeAws_restXmlTagSet((0, $3cac61d5afd59793$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketTaggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$87fb664bdbc56c8d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        MFADelete: undefined,
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["MfaDelete"] !== undefined) contents.MFADelete = data["MfaDelete"];
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketVersioningCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e9648c335e4af37a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        ErrorDocument: undefined,
                        IndexDocument: undefined,
                        RedirectAllRequestsTo: undefined,
                        RoutingRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ErrorDocument"] !== undefined) contents.ErrorDocument = $748b18c285b09559$var$deserializeAws_restXmlErrorDocument(data["ErrorDocument"], context);
                    if (data["IndexDocument"] !== undefined) contents.IndexDocument = $748b18c285b09559$var$deserializeAws_restXmlIndexDocument(data["IndexDocument"], context);
                    if (data["RedirectAllRequestsTo"] !== undefined) contents.RedirectAllRequestsTo = $748b18c285b09559$var$deserializeAws_restXmlRedirectAllRequestsTo(data["RedirectAllRequestsTo"], context);
                    if (data.RoutingRules === "") contents.RoutingRules = [];
                    if (data["RoutingRules"] !== undefined && data["RoutingRules"]["RoutingRule"] !== undefined) contents.RoutingRules = $748b18c285b09559$var$deserializeAws_restXmlRoutingRules((0, $3cac61d5afd59793$export$52272e038712c64e)(data["RoutingRules"]["RoutingRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetBucketWebsiteCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$c8faba1b7abd4024 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $748b18c285b09559$var$deserializeAws_restXmlGetObjectCommandError(output, context)
            ];
            contents = {
                $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                AcceptRanges: undefined,
                Body: undefined,
                BucketKeyEnabled: undefined,
                CacheControl: undefined,
                ContentDisposition: undefined,
                ContentEncoding: undefined,
                ContentLanguage: undefined,
                ContentLength: undefined,
                ContentRange: undefined,
                ContentType: undefined,
                DeleteMarker: undefined,
                ETag: undefined,
                Expiration: undefined,
                Expires: undefined,
                LastModified: undefined,
                Metadata: undefined,
                MissingMeta: undefined,
                ObjectLockLegalHoldStatus: undefined,
                ObjectLockMode: undefined,
                ObjectLockRetainUntilDate: undefined,
                PartsCount: undefined,
                ReplicationStatus: undefined,
                RequestCharged: undefined,
                Restore: undefined,
                SSECustomerAlgorithm: undefined,
                SSECustomerKeyMD5: undefined,
                SSEKMSKeyId: undefined,
                ServerSideEncryption: undefined,
                StorageClass: undefined,
                TagCount: undefined,
                VersionId: undefined,
                WebsiteRedirectLocation: undefined
            };
            if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
            if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
            if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
            if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
            if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
            if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
            if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
            if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
            if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
            if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
            if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
            if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
            if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
            if (output.headers["content-range"] !== undefined) contents.ContentRange = output.headers["content-range"];
            if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
            if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
            if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
            if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
            if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
            if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
            if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
            if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
            if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
            if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
            if (output.headers["x-amz-tagging-count"] !== undefined) contents.TagCount = parseInt(output.headers["x-amz-tagging-count"], 10);
            if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
            if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
            if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
            Object.keys(output.headers).forEach(function(header) {
                if (contents.Metadata === undefined) contents.Metadata = {};
                if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
            });
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetObjectCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidObjectState":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#InvalidObjectState":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlInvalidObjectStateResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7334ba1348400806 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $748b18c285b09559$var$deserializeAws_restXmlGrants((0, $3cac61d5afd59793$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetObjectAclCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$3fe12927f071d9c2 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        LegalHold: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.LegalHold = $748b18c285b09559$var$deserializeAws_restXmlObjectLockLegalHold(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetObjectLegalHoldCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$8a6b0973efae922a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        ObjectLockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ObjectLockConfiguration = $748b18c285b09559$var$deserializeAws_restXmlObjectLockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e8bb8c760a500abf = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Retention: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Retention = $748b18c285b09559$var$deserializeAws_restXmlObjectLockRetention(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetObjectRetentionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$b55a093fbe745f1a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        TagSet: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $748b18c285b09559$var$deserializeAws_restXmlTagSet((0, $3cac61d5afd59793$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetObjectTaggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$77cab76edb05348f = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $748b18c285b09559$var$deserializeAws_restXmlGetObjectTorrentCommandError(output, context)
            ];
            contents = {
                $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                Body: undefined,
                RequestCharged: undefined
            };
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetObjectTorrentCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ca2eb582f189d59e = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlGetPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        PublicAccessBlockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PublicAccessBlockConfiguration = $748b18c285b09559$var$deserializeAws_restXmlPublicAccessBlockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGetPublicAccessBlockCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7da61a6d1be4855c = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlHeadBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlHeadBucketCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$6facb3b50649bd07 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlHeadObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        AcceptRanges: undefined,
                        ArchiveStatus: undefined,
                        BucketKeyEnabled: undefined,
                        CacheControl: undefined,
                        ContentDisposition: undefined,
                        ContentEncoding: undefined,
                        ContentLanguage: undefined,
                        ContentLength: undefined,
                        ContentType: undefined,
                        DeleteMarker: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Expires: undefined,
                        LastModified: undefined,
                        Metadata: undefined,
                        MissingMeta: undefined,
                        ObjectLockLegalHoldStatus: undefined,
                        ObjectLockMode: undefined,
                        ObjectLockRetainUntilDate: undefined,
                        PartsCount: undefined,
                        ReplicationStatus: undefined,
                        RequestCharged: undefined,
                        Restore: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        StorageClass: undefined,
                        VersionId: undefined,
                        WebsiteRedirectLocation: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
                    if (output.headers["x-amz-archive-status"] !== undefined) contents.ArchiveStatus = output.headers["x-amz-archive-status"];
                    if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
                    if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
                    if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
                    if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
                    if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
                    if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
                    if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
                    if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
                    if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
                    if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
                    if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
                    if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
                    Object.keys(output.headers).forEach(function(header) {
                        if (contents.Metadata === undefined) contents.Metadata = {};
                        if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
                    });
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlHeadObjectCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7c3a4eeaff09f66a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        AnalyticsConfigurationList: undefined,
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AnalyticsConfiguration === "") contents.AnalyticsConfigurationList = [];
                    if (data["AnalyticsConfiguration"] !== undefined) contents.AnalyticsConfigurationList = $748b18c285b09559$var$deserializeAws_restXmlAnalyticsConfigurationList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["AnalyticsConfiguration"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e5945e65caff371e = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListBucketIntelligentTieringConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IntelligentTieringConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.IntelligentTieringConfiguration === "") contents.IntelligentTieringConfigurationList = [];
                    if (data["IntelligentTieringConfiguration"] !== undefined) contents.IntelligentTieringConfigurationList = $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringConfigurationList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["IntelligentTieringConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListBucketIntelligentTieringConfigurationsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$690ef4b20b3078b6 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        InventoryConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.InventoryConfiguration === "") contents.InventoryConfigurationList = [];
                    if (data["InventoryConfiguration"] !== undefined) contents.InventoryConfigurationList = $748b18c285b09559$var$deserializeAws_restXmlInventoryConfigurationList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["InventoryConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$906cb5e8f067f67 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        MetricsConfigurationList: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data.MetricsConfiguration === "") contents.MetricsConfigurationList = [];
                    if (data["MetricsConfiguration"] !== undefined) contents.MetricsConfigurationList = $748b18c285b09559$var$deserializeAws_restXmlMetricsConfigurationList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["MetricsConfiguration"]), context);
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$63be43683e761a25 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListBucketsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Buckets: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Buckets === "") contents.Buckets = [];
                    if (data["Buckets"] !== undefined && data["Buckets"]["Bucket"] !== undefined) contents.Buckets = $748b18c285b09559$var$deserializeAws_restXmlBuckets((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Buckets"]["Bucket"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListBucketsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$8da47d46285c7a0 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListMultipartUploadsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        Bucket: undefined,
                        CommonPrefixes: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxUploads: undefined,
                        NextKeyMarker: undefined,
                        NextUploadIdMarker: undefined,
                        Prefix: undefined,
                        UploadIdMarker: undefined,
                        Uploads: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $748b18c285b09559$var$deserializeAws_restXmlCommonPrefixList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxUploads"] !== undefined) contents.MaxUploads = parseInt(data["MaxUploads"]);
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextUploadIdMarker"] !== undefined) contents.NextUploadIdMarker = data["NextUploadIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["UploadIdMarker"] !== undefined) contents.UploadIdMarker = data["UploadIdMarker"];
                    if (data.Upload === "") contents.Uploads = [];
                    if (data["Upload"] !== undefined) contents.Uploads = $748b18c285b09559$var$deserializeAws_restXmlMultipartUploadList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Upload"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListMultipartUploadsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$f8d39cd754f5521d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        Marker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextMarker: undefined,
                        Prefix: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $748b18c285b09559$var$deserializeAws_restXmlCommonPrefixList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $748b18c285b09559$var$deserializeAws_restXmlObjectList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Contents"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Marker"] !== undefined) contents.Marker = data["Marker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextMarker"] !== undefined) contents.NextMarker = data["NextMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListObjectsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$2b371fcdd686ba8b = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListObjectsV2CommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        ContinuationToken: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyCount: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextContinuationToken: undefined,
                        Prefix: undefined,
                        StartAfter: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $748b18c285b09559$var$deserializeAws_restXmlCommonPrefixList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $748b18c285b09559$var$deserializeAws_restXmlObjectList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Contents"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyCount"] !== undefined) contents.KeyCount = parseInt(data["KeyCount"]);
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["StartAfter"] !== undefined) contents.StartAfter = data["StartAfter"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListObjectsV2CommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$637e7cd668cf8615 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListObjectVersionsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        DeleteMarkers: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextKeyMarker: undefined,
                        NextVersionIdMarker: undefined,
                        Prefix: undefined,
                        VersionIdMarker: undefined,
                        Versions: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $748b18c285b09559$var$deserializeAws_restXmlCommonPrefixList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.DeleteMarker === "") contents.DeleteMarkers = [];
                    if (data["DeleteMarker"] !== undefined) contents.DeleteMarkers = $748b18c285b09559$var$deserializeAws_restXmlDeleteMarkers((0, $3cac61d5afd59793$export$52272e038712c64e)(data["DeleteMarker"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextVersionIdMarker"] !== undefined) contents.NextVersionIdMarker = data["NextVersionIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["VersionIdMarker"] !== undefined) contents.VersionIdMarker = data["VersionIdMarker"];
                    if (data.Version === "") contents.Versions = [];
                    if (data["Version"] !== undefined) contents.Versions = $748b18c285b09559$var$deserializeAws_restXmlObjectVersionList((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Version"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListObjectVersionsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$584d994fd27ec2bb = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlListPartsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        Initiator: undefined,
                        IsTruncated: undefined,
                        Key: undefined,
                        MaxParts: undefined,
                        NextPartNumberMarker: undefined,
                        Owner: undefined,
                        PartNumberMarker: undefined,
                        Parts: undefined,
                        RequestCharged: undefined,
                        StorageClass: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Initiator"] !== undefined) contents.Initiator = $748b18c285b09559$var$deserializeAws_restXmlInitiator(data["Initiator"], context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["MaxParts"] !== undefined) contents.MaxParts = parseInt(data["MaxParts"]);
                    if (data["NextPartNumberMarker"] !== undefined) contents.NextPartNumberMarker = data["NextPartNumberMarker"];
                    if (data["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    if (data["PartNumberMarker"] !== undefined) contents.PartNumberMarker = data["PartNumberMarker"];
                    if (data.Part === "") contents.Parts = [];
                    if (data["Part"] !== undefined) contents.Parts = $748b18c285b09559$var$deserializeAws_restXmlParts((0, $3cac61d5afd59793$export$52272e038712c64e)(data["Part"]), context);
                    if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlListPartsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e654cd63b770e3c4 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$468a83c548434951 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketAclCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$488c2e199ebb898d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$3eb4d44bdf561f91 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketCorsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$d0f1e0a2cb4f5db6 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketEncryptionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$96bb8c8575dc5439 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$a7487a3c5377a809 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9e27fb99395eb8b3 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$9e24aeee62aeef65 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketLoggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$3a85a94ca87604e2 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ec8129277a63ef1e = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$8d1d3805e977d457 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$2b7b6f0e8b2cc8a1 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketPolicyCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$8ea9e7fadc7c189a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketReplicationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$12b0ab2c5846a509 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$5bf4de3b4501436e = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketTaggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$ef405e59c399a368 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketVersioningCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$514d37c55d4fb4b5 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutBucketWebsiteCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$45bbdbf5181c3607 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutObjectCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$e0d1dc79dd7bc4d6 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutObjectAclCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$a32f5469ffeef979 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutObjectLegalHoldCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$470735cd3fe9e5b5 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$5377eccfb6cedf8b = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutObjectRetentionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$cecf7bb838bf1182 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutObjectTaggingCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$7a1b291f9ae3d668 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlPutPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPutPublicAccessBlockCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$317606d55789efe9 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlRestoreObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        RequestCharged: undefined,
                        RestoreOutputPath: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-restore-output-path"] !== undefined) contents.RestoreOutputPath = output.headers["x-amz-restore-output-path"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlRestoreObjectCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$285881e5f25758a3 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $748b18c285b09559$var$deserializeAws_restXmlSelectObjectContentCommandError(output, context)
            ];
            contents = {
                $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                Payload: undefined
            };
            data = context.eventStreamMarshaller.deserialize(output.body, function(event) {
                return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                    var eventName, eventHeaders, eventMessage, parsedEvent;
                    var _a;
                    return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                eventName = Object.keys(event)[0];
                                eventHeaders = Object.entries(event[eventName].headers).reduce(function(accummulator, curr) {
                                    accummulator[curr[0]] = curr[1].value;
                                    return accummulator;
                                }, {});
                                eventMessage = {
                                    headers: eventHeaders,
                                    body: event[eventName].body
                                };
                                parsedEvent = (_a = {}, _a[eventName] = eventMessage, _a);
                                return [
                                    4 /*yield*/ ,
                                    $748b18c285b09559$var$deserializeAws_restXmlSelectObjectContentEventStream_event(parsedEvent, context)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    _b.sent()
                                ];
                        }
                    });
                });
            });
            contents.Payload = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlSelectObjectContentCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$176ef954f1bec178 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlUploadPartCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlUploadPartCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$export$460d1831a8acdf23 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlUploadPartCopyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        CopyPartResult: undefined,
                        CopySourceVersionId: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyPartResult = $748b18c285b09559$var$deserializeAws_restXmlCopyPartResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlUploadPartCopyCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $748b18c285b09559$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $748b18c285b09559$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlSelectObjectContentEventStream_event = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, _b, _c, _d, _e;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!(output["Records"] !== undefined)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _a = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlRecordsEvent_event(output["Records"], context)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        (_a.Records = _f.sent(), _a)
                    ];
                case 2:
                    if (!(output["Stats"] !== undefined)) return [
                        3 /*break*/ ,
                        4
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlStatsEvent_event(output["Stats"], context)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        (_b.Stats = _f.sent(), _b)
                    ];
                case 4:
                    if (!(output["Progress"] !== undefined)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlProgressEvent_event(output["Progress"], context)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        (_c.Progress = _f.sent(), _c)
                    ];
                case 6:
                    if (!(output["Cont"] !== undefined)) return [
                        3 /*break*/ ,
                        8
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlContinuationEvent_event(output["Cont"], context)
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        (_d.Cont = _f.sent(), _d)
                    ];
                case 8:
                    if (!(output["End"] !== undefined)) return [
                        3 /*break*/ ,
                        10
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$deserializeAws_restXmlEndEvent_event(output["End"], context)
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        (_e.End = _f.sent(), _e)
                    ];
                case 10:
                    return [
                        2 /*return*/ ,
                        {
                            $unknown: output
                        }
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlContinuationEvent_event = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlEndEvent_event = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlProgressEvent_event = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlRecordsEvent_event = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            contents.Payload = output.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlStatsEvent_event = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $748b18c285b09559$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlBucketAlreadyExistsResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "BucketAlreadyExists",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "BucketAlreadyOwnedByYou",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlInvalidObjectStateResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidObjectState",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput),
                AccessTier: undefined,
                StorageClass: undefined
            };
            data = parsedOutput.body;
            if (data["AccessTier"] !== undefined) contents.AccessTier = data["AccessTier"];
            if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlNoSuchBucketResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchBucket",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlNoSuchKeyResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchKey",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlNoSuchUploadResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchUpload",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ObjectAlreadyInActiveTierError",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ObjectNotInActiveTierError",
                $fault: "client",
                $metadata: $748b18c285b09559$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $748b18c285b09559$var$serializeAws_restXmlAbortIncompleteMultipartUpload = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AbortIncompleteMultipartUpload");
    if (input.DaysAfterInitiation !== undefined && input.DaysAfterInitiation !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("DaysAfterInitiation").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.DaysAfterInitiation))).withName("DaysAfterInitiation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAccelerateConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccelerateConfiguration");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketAccelerateStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAccessControlPolicy = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccessControlPolicy");
    if (input.Grants !== undefined && input.Grants !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlGrants(input.Grants, context);
        var containerNode_1 = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccessControlList");
        nodes.map(function(node) {
            containerNode_1.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_1);
    }
    if (input.Owner !== undefined && input.Owner !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlOwner(input.Owner, context).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAccessControlTranslation = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccessControlTranslation");
    if (input.Owner !== undefined && input.Owner !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("OwnerOverride").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Owner)).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAllowedHeaders = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AllowedHeader").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlAllowedMethods = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AllowedMethod").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlAllowedOrigins = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AllowedOrigin").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlAnalyticsAndOperator = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AnalyticsAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAnalyticsConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AnalyticsConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AnalyticsId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlAnalyticsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClassAnalysis !== undefined && input.StorageClassAnalysis !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlStorageClassAnalysis(input.StorageClassAnalysis, context).withName("StorageClassAnalysis");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAnalyticsExportDestination = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AnalyticsExportDestination");
    if (input.S3BucketDestination !== undefined && input.S3BucketDestination !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlAnalyticsS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAnalyticsFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AnalyticsFilter");
    (0, $a75d087c013e1d7d$export$c9ec61557dcb764a).visit(input, {
        Prefix: function(value) {
            var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlAnalyticsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $624db86d198ff371$export$e775a15d806cbddc) || value instanceof (0, $cd594e57aad4e5d1$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $624db86d198ff371$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlAnalyticsS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AnalyticsS3BucketDestination");
    if (input.Format !== undefined && input.Format !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AnalyticsS3ExportFileFormat").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.BucketAccountId !== undefined && input.BucketAccountId !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.BucketAccountId)).withName("BucketAccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlBucketLifecycleConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketLifecycleConfiguration");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlLifecycleRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlBucketLoggingStatus = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketLoggingStatus");
    if (input.LoggingEnabled !== undefined && input.LoggingEnabled !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlLoggingEnabled(input.LoggingEnabled, context).withName("LoggingEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCompletedMultipartUpload = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CompletedMultipartUpload");
    if (input.Parts !== undefined && input.Parts !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlCompletedPartList(input.Parts, context);
        nodes.map(function(node) {
            node = node.withName("Part");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCompletedPart = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CompletedPart");
    if (input.ETag !== undefined && input.ETag !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ETag").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ETag)).withName("ETag");
        bodyNode.addChildNode(node);
    }
    if (input.PartNumber !== undefined && input.PartNumber !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("PartNumber").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.PartNumber))).withName("PartNumber");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCompletedPartList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlCompletedPart(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlCondition = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Condition");
    if (input.HttpErrorCodeReturnedEquals !== undefined && input.HttpErrorCodeReturnedEquals !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("HttpErrorCodeReturnedEquals").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.HttpErrorCodeReturnedEquals)).withName("HttpErrorCodeReturnedEquals");
        bodyNode.addChildNode(node);
    }
    if (input.KeyPrefixEquals !== undefined && input.KeyPrefixEquals !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("KeyPrefixEquals").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.KeyPrefixEquals)).withName("KeyPrefixEquals");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCORSConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CORSConfiguration");
    if (input.CORSRules !== undefined && input.CORSRules !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlCORSRules(input.CORSRules, context);
        nodes.map(function(node) {
            node = node.withName("CORSRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCORSRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CORSRule");
    if (input.AllowedHeaders !== undefined && input.AllowedHeaders !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlAllowedHeaders(input.AllowedHeaders, context);
        nodes.map(function(node) {
            node = node.withName("AllowedHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedMethods !== undefined && input.AllowedMethods !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlAllowedMethods(input.AllowedMethods, context);
        nodes.map(function(node) {
            node = node.withName("AllowedMethod");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedOrigins !== undefined && input.AllowedOrigins !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlAllowedOrigins(input.AllowedOrigins, context);
        nodes.map(function(node) {
            node = node.withName("AllowedOrigin");
            bodyNode.addChildNode(node);
        });
    }
    if (input.ExposeHeaders !== undefined && input.ExposeHeaders !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlExposeHeaders(input.ExposeHeaders, context);
        nodes.map(function(node) {
            node = node.withName("ExposeHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.MaxAgeSeconds !== undefined && input.MaxAgeSeconds !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MaxAgeSeconds").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.MaxAgeSeconds))).withName("MaxAgeSeconds");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCORSRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlCORSRule(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlCreateBucketConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CreateBucketConfiguration");
    if (input.LocationConstraint !== undefined && input.LocationConstraint !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketLocationConstraint").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.LocationConstraint)).withName("LocationConstraint");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCSVInput = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CSVInput");
    if (input.FileHeaderInfo !== undefined && input.FileHeaderInfo !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("FileHeaderInfo").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.FileHeaderInfo)).withName("FileHeaderInfo");
        bodyNode.addChildNode(node);
    }
    if (input.Comments !== undefined && input.Comments !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Comments").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Comments)).withName("Comments");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined && input.QuoteEscapeCharacter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("QuoteEscapeCharacter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter !== undefined && input.FieldDelimiter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("FieldDelimiter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined && input.QuoteCharacter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("QuoteCharacter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.AllowQuotedRecordDelimiter !== undefined && input.AllowQuotedRecordDelimiter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AllowQuotedRecordDelimiter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.AllowQuotedRecordDelimiter))).withName("AllowQuotedRecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlCSVOutput = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CSVOutput");
    if (input.QuoteFields !== undefined && input.QuoteFields !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("QuoteFields").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.QuoteFields)).withName("QuoteFields");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined && input.QuoteEscapeCharacter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("QuoteEscapeCharacter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter !== undefined && input.FieldDelimiter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("FieldDelimiter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined && input.QuoteCharacter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("QuoteCharacter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlDefaultRetention = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("DefaultRetention");
    if (input.Mode !== undefined && input.Mode !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockRetentionMode").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Days").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Years !== undefined && input.Years !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Years").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Years))).withName("Years");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlDelete = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Delete");
    if (input.Objects !== undefined && input.Objects !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlObjectIdentifierList(input.Objects, context);
        nodes.map(function(node) {
            node = node.withName("Object");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Quiet !== undefined && input.Quiet !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Quiet").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Quiet))).withName("Quiet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlDeleteMarkerReplication = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("DeleteMarkerReplication");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("DeleteMarkerReplicationStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlDestination = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Destination");
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Account !== undefined && input.Account !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Account)).withName("Account");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("StorageClass").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlTranslation !== undefined && input.AccessControlTranslation !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlAccessControlTranslation(input.AccessControlTranslation, context).withName("AccessControlTranslation");
        bodyNode.addChildNode(node);
    }
    if (input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlEncryptionConfiguration(input.EncryptionConfiguration, context).withName("EncryptionConfiguration");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicationTime !== undefined && input.ReplicationTime !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlReplicationTime(input.ReplicationTime, context).withName("ReplicationTime");
        bodyNode.addChildNode(node);
    }
    if (input.Metrics !== undefined && input.Metrics !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlMetrics(input.Metrics, context).withName("Metrics");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlEncryption = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Encryption");
    if (input.EncryptionType !== undefined && input.EncryptionType !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ServerSideEncryption").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.EncryptionType)).withName("EncryptionType");
        bodyNode.addChildNode(node);
    }
    if (input.KMSKeyId !== undefined && input.KMSKeyId !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.KMSKeyId)).withName("KMSKeyId");
        bodyNode.addChildNode(node);
    }
    if (input.KMSContext !== undefined && input.KMSContext !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("KMSContext").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.KMSContext)).withName("KMSContext");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("EncryptionConfiguration");
    if (input.ReplicaKmsKeyID !== undefined && input.ReplicaKmsKeyID !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicaKmsKeyID").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ReplicaKmsKeyID)).withName("ReplicaKmsKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlErrorDocument = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ErrorDocument");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlEventList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Event").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlExistingObjectReplication = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ExistingObjectReplication");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ExistingObjectReplicationStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlExposeHeaders = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ExposeHeader").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlFilterRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("FilterRule");
    if (input.Name !== undefined && input.Name !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("FilterRuleName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("FilterRuleValue").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlFilterRuleList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlFilterRule(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlGlacierJobParameters = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("GlacierJobParameters");
    if (input.Tier !== undefined && input.Tier !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Tier").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlGrant = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Grant");
    if (input.Grantee !== undefined && input.Grantee !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined && input.Permission !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Permission").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlGrantee = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Grantee");
    if (input.DisplayName !== undefined && input.DisplayName !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("DisplayName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.EmailAddress !== undefined && input.EmailAddress !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("EmailAddress").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.EmailAddress)).withName("EmailAddress");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ID").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.URI !== undefined && input.URI !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("URI").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.URI)).withName("URI");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined && input.Type !== null) bodyNode.addAttribute("xsi:type", input.Type);
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlGrants = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlGrant(entry, context);
        return node.withName("Grant");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlIndexDocument = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IndexDocument");
    if (input.Suffix !== undefined && input.Suffix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Suffix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Suffix)).withName("Suffix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlInputSerialization = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InputSerialization");
    if (input.CSV !== undefined && input.CSV !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlCSVInput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.CompressionType !== undefined && input.CompressionType !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("CompressionType").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.CompressionType)).withName("CompressionType");
        bodyNode.addChildNode(node);
    }
    if (input.JSON !== undefined && input.JSON !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlJSONInput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.Parquet !== undefined && input.Parquet !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlParquetInput(input.Parquet, context).withName("Parquet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlIntelligentTieringAndOperator = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IntelligentTieringAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlIntelligentTieringConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IntelligentTieringConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IntelligentTieringId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlIntelligentTieringFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IntelligentTieringStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Tierings !== undefined && input.Tierings !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTieringList(input.Tierings, context);
        nodes.map(function(node) {
            node = node.withName("Tiering");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlIntelligentTieringFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IntelligentTieringFilter");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined && input.Tag !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.And !== undefined && input.And !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlIntelligentTieringAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlInventoryConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryConfiguration");
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlInventoryDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.IsEnabled !== undefined && input.IsEnabled !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IsEnabled").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.IsEnabled))).withName("IsEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlInventoryFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.IncludedObjectVersions !== undefined && input.IncludedObjectVersions !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryIncludedObjectVersions").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.IncludedObjectVersions)).withName("IncludedObjectVersions");
        bodyNode.addChildNode(node);
    }
    if (input.OptionalFields !== undefined && input.OptionalFields !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlInventoryOptionalFields(input.OptionalFields, context);
        var containerNode_2 = new (0, $624db86d198ff371$export$e775a15d806cbddc)("OptionalFields");
        nodes.map(function(node) {
            containerNode_2.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_2);
    }
    if (input.Schedule !== undefined && input.Schedule !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlInventorySchedule(input.Schedule, context).withName("Schedule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlInventoryDestination = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryDestination");
    if (input.S3BucketDestination !== undefined && input.S3BucketDestination !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlInventoryS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlInventoryEncryption = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryEncryption");
    if (input.SSES3 !== undefined && input.SSES3 !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlSSES3(input.SSES3, context).withName("SSE-S3");
        bodyNode.addChildNode(node);
    }
    if (input.SSEKMS !== undefined && input.SSEKMS !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlSSEKMS(input.SSEKMS, context).withName("SSE-KMS");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlInventoryFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryFilter");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlInventoryOptionalFields = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryOptionalField").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(entry));
        return node.withName("Field");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlInventoryS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryS3BucketDestination");
    if (input.AccountId !== undefined && input.AccountId !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.AccountId)).withName("AccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Format !== undefined && input.Format !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryFormat").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined && input.Encryption !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlInventoryEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlInventorySchedule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventorySchedule");
    if (input.Frequency !== undefined && input.Frequency !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("InventoryFrequency").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Frequency)).withName("Frequency");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlJSONInput = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("JSONInput");
    if (input.Type !== undefined && input.Type !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("JSONType").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlJSONOutput = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("JSONOutput");
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlLambdaFunctionConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LambdaFunctionConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.LambdaFunctionArn !== undefined && input.LambdaFunctionArn !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LambdaFunctionArn").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.LambdaFunctionArn)).withName("CloudFunction");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlLambdaFunctionConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlLambdaFunctionConfiguration(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlLifecycleExpiration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LifecycleExpiration");
    if (input.Date !== undefined && input.Date !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Date").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Days").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.ExpiredObjectDeleteMarker !== undefined && input.ExpiredObjectDeleteMarker !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ExpiredObjectDeleteMarker").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.ExpiredObjectDeleteMarker))).withName("ExpiredObjectDeleteMarker");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlLifecycleRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LifecycleRule");
    if (input.Expiration !== undefined && input.Expiration !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlLifecycleExpiration(input.Expiration, context).withName("Expiration");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ID").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlLifecycleRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ExpirationStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Transitions !== undefined && input.Transitions !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTransitionList(input.Transitions, context);
        nodes.map(function(node) {
            node = node.withName("Transition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionTransitions !== undefined && input.NoncurrentVersionTransitions !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlNoncurrentVersionTransitionList(input.NoncurrentVersionTransitions, context);
        nodes.map(function(node) {
            node = node.withName("NoncurrentVersionTransition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionExpiration !== undefined && input.NoncurrentVersionExpiration !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlNoncurrentVersionExpiration(input.NoncurrentVersionExpiration, context).withName("NoncurrentVersionExpiration");
        bodyNode.addChildNode(node);
    }
    if (input.AbortIncompleteMultipartUpload !== undefined && input.AbortIncompleteMultipartUpload !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlAbortIncompleteMultipartUpload(input.AbortIncompleteMultipartUpload, context).withName("AbortIncompleteMultipartUpload");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlLifecycleRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LifecycleRuleAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlLifecycleRuleFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LifecycleRuleFilter");
    (0, $a75d087c013e1d7d$export$4338dba1e93ddaf4).visit(input, {
        Prefix: function(value) {
            var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlLifecycleRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $624db86d198ff371$export$e775a15d806cbddc) || value instanceof (0, $cd594e57aad4e5d1$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $624db86d198ff371$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlLifecycleRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlLifecycleRule(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlLoggingEnabled = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LoggingEnabled");
    if (input.TargetBucket !== undefined && input.TargetBucket !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TargetBucket").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.TargetBucket)).withName("TargetBucket");
        bodyNode.addChildNode(node);
    }
    if (input.TargetGrants !== undefined && input.TargetGrants !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTargetGrants(input.TargetGrants, context);
        var containerNode_3 = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TargetGrants");
        nodes.map(function(node) {
            containerNode_3.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_3);
    }
    if (input.TargetPrefix !== undefined && input.TargetPrefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TargetPrefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.TargetPrefix)).withName("TargetPrefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlMetadataEntry = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetadataEntry");
    if (input.Name !== undefined && input.Name !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetadataKey").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetadataValue").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlMetrics = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Metrics");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetricsStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.EventThreshold !== undefined && input.EventThreshold !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlReplicationTimeValue(input.EventThreshold, context).withName("EventThreshold");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlMetricsAndOperator = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetricsAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlMetricsConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetricsConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetricsId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlMetricsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlMetricsFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MetricsFilter");
    (0, $a75d087c013e1d7d$export$564a1f9c338cae45).visit(input, {
        Prefix: function(value) {
            var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlMetricsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $624db86d198ff371$export$e775a15d806cbddc) || value instanceof (0, $cd594e57aad4e5d1$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $624db86d198ff371$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlNoncurrentVersionExpiration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("NoncurrentVersionExpiration");
    if (input.NoncurrentDays !== undefined && input.NoncurrentDays !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Days").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlNoncurrentVersionTransition = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("NoncurrentVersionTransition");
    if (input.NoncurrentDays !== undefined && input.NoncurrentDays !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Days").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TransitionStorageClass").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlNoncurrentVersionTransitionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlNoncurrentVersionTransition(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlNotificationConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("NotificationConfiguration");
    if (input.TopicConfigurations !== undefined && input.TopicConfigurations !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTopicConfigurationList(input.TopicConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("TopicConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.QueueConfigurations !== undefined && input.QueueConfigurations !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlQueueConfigurationList(input.QueueConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("QueueConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.LambdaFunctionConfigurations !== undefined && input.LambdaFunctionConfigurations !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlLambdaFunctionConfigurationList(input.LambdaFunctionConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("CloudFunctionConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlNotificationConfigurationFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("NotificationConfigurationFilter");
    if (input.Key !== undefined && input.Key !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlS3KeyFilter(input.Key, context).withName("S3Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlObjectIdentifier = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectIdentifier");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.VersionId !== undefined && input.VersionId !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectVersionId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.VersionId)).withName("VersionId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlObjectIdentifierList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlObjectIdentifier(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlObjectLockConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockConfiguration");
    if (input.ObjectLockEnabled !== undefined && input.ObjectLockEnabled !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockEnabled").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ObjectLockEnabled)).withName("ObjectLockEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Rule !== undefined && input.Rule !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlObjectLockRule(input.Rule, context).withName("Rule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlObjectLockLegalHold = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockLegalHold");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockLegalHoldStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlObjectLockRetention = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockRetention");
    if (input.Mode !== undefined && input.Mode !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockRetentionMode").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.RetainUntilDate !== undefined && input.RetainUntilDate !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Date").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.RetainUntilDate.toISOString().split(".")[0] + "Z")).withName("RetainUntilDate");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlObjectLockRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectLockRule");
    if (input.DefaultRetention !== undefined && input.DefaultRetention !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlDefaultRetention(input.DefaultRetention, context).withName("DefaultRetention");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlOutputLocation = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("OutputLocation");
    if (input.S3 !== undefined && input.S3 !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlS3Location(input.S3, context).withName("S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlOutputSerialization = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("OutputSerialization");
    if (input.CSV !== undefined && input.CSV !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlCSVOutput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.JSON !== undefined && input.JSON !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlJSONOutput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlOwner = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Owner");
    if (input.DisplayName !== undefined && input.DisplayName !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("DisplayName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ID").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlOwnershipControls = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("OwnershipControls");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlOwnershipControlsRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlOwnershipControlsRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("OwnershipControlsRule");
    if (input.ObjectOwnership !== undefined && input.ObjectOwnership !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectOwnership").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ObjectOwnership)).withName("ObjectOwnership");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlOwnershipControlsRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlOwnershipControlsRule(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlParquetInput = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ParquetInput");
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlPublicAccessBlockConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("PublicAccessBlockConfiguration");
    if (input.BlockPublicAcls !== undefined && input.BlockPublicAcls !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.BlockPublicAcls))).withName("BlockPublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.IgnorePublicAcls !== undefined && input.IgnorePublicAcls !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.IgnorePublicAcls))).withName("IgnorePublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.BlockPublicPolicy !== undefined && input.BlockPublicPolicy !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.BlockPublicPolicy))).withName("BlockPublicPolicy");
        bodyNode.addChildNode(node);
    }
    if (input.RestrictPublicBuckets !== undefined && input.RestrictPublicBuckets !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.RestrictPublicBuckets))).withName("RestrictPublicBuckets");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlQueueConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("QueueConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.QueueArn !== undefined && input.QueueArn !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("QueueArn").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.QueueArn)).withName("Queue");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlQueueConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlQueueConfiguration(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlRedirect = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Redirect");
    if (input.HostName !== undefined && input.HostName !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("HostName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.HttpRedirectCode !== undefined && input.HttpRedirectCode !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("HttpRedirectCode").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.HttpRedirectCode)).withName("HttpRedirectCode");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined && input.Protocol !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Protocol").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyPrefixWith !== undefined && input.ReplaceKeyPrefixWith !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplaceKeyPrefixWith").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ReplaceKeyPrefixWith)).withName("ReplaceKeyPrefixWith");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyWith !== undefined && input.ReplaceKeyWith !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplaceKeyWith").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ReplaceKeyWith)).withName("ReplaceKeyWith");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlRedirectAllRequestsTo = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RedirectAllRequestsTo");
    if (input.HostName !== undefined && input.HostName !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("HostName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined && input.Protocol !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Protocol").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlReplicaModifications = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicaModifications");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicaModificationsStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlReplicationConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationConfiguration");
    if (input.Role !== undefined && input.Role !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Role").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Role)).withName("Role");
        bodyNode.addChildNode(node);
    }
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlReplicationRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlReplicationRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationRule");
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ID").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Priority !== undefined && input.Priority !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Priority").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Priority))).withName("Priority");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlReplicationRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationRuleStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.SourceSelectionCriteria !== undefined && input.SourceSelectionCriteria !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlSourceSelectionCriteria(input.SourceSelectionCriteria, context).withName("SourceSelectionCriteria");
        bodyNode.addChildNode(node);
    }
    if (input.ExistingObjectReplication !== undefined && input.ExistingObjectReplication !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlExistingObjectReplication(input.ExistingObjectReplication, context).withName("ExistingObjectReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.DeleteMarkerReplication !== undefined && input.DeleteMarkerReplication !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlDeleteMarkerReplication(input.DeleteMarkerReplication, context).withName("DeleteMarkerReplication");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlReplicationRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationRuleAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlReplicationRuleFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationRuleFilter");
    (0, $a75d087c013e1d7d$export$c5652b893758d9eb).visit(input, {
        Prefix: function(value) {
            var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $748b18c285b09559$var$serializeAws_restXmlReplicationRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $624db86d198ff371$export$e775a15d806cbddc) || value instanceof (0, $cd594e57aad4e5d1$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $624db86d198ff371$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlReplicationRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlReplicationRule(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlReplicationTime = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationTime");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationTimeStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Time !== undefined && input.Time !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlReplicationTimeValue(input.Time, context).withName("Time");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlReplicationTimeValue = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ReplicationTimeValue");
    if (input.Minutes !== undefined && input.Minutes !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Minutes").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Minutes))).withName("Minutes");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlRequestPaymentConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RequestPaymentConfiguration");
    if (input.Payer !== undefined && input.Payer !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Payer").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Payer)).withName("Payer");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlRequestProgress = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RequestProgress");
    if (input.Enabled !== undefined && input.Enabled !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("EnableRequestProgress").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Enabled))).withName("Enabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlRestoreRequest = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RestoreRequest");
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Days").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.GlacierJobParameters !== undefined && input.GlacierJobParameters !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlGlacierJobParameters(input.GlacierJobParameters, context).withName("GlacierJobParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined && input.Type !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RestoreRequestType").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    if (input.Tier !== undefined && input.Tier !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Tier").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    if (input.Description !== undefined && input.Description !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Description").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Description)).withName("Description");
        bodyNode.addChildNode(node);
    }
    if (input.SelectParameters !== undefined && input.SelectParameters !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlSelectParameters(input.SelectParameters, context).withName("SelectParameters");
        bodyNode.addChildNode(node);
    }
    if (input.OutputLocation !== undefined && input.OutputLocation !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlOutputLocation(input.OutputLocation, context).withName("OutputLocation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlRoutingRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RoutingRule");
    if (input.Condition !== undefined && input.Condition !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlCondition(input.Condition, context).withName("Condition");
        bodyNode.addChildNode(node);
    }
    if (input.Redirect !== undefined && input.Redirect !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlRedirect(input.Redirect, context).withName("Redirect");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlRoutingRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlRoutingRule(entry, context);
        return node.withName("RoutingRule");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlS3KeyFilter = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("S3KeyFilter");
    if (input.FilterRules !== undefined && input.FilterRules !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlFilterRuleList(input.FilterRules, context);
        nodes.map(function(node) {
            node = node.withName("FilterRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlS3Location = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("S3Location");
    if (input.BucketName !== undefined && input.BucketName !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.BucketName)).withName("BucketName");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("LocationPrefix").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined && input.Encryption !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.CannedACL !== undefined && input.CannedACL !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectCannedACL").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.CannedACL)).withName("CannedACL");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlList !== undefined && input.AccessControlList !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlGrants(input.AccessControlList, context);
        var containerNode_4 = new (0, $624db86d198ff371$export$e775a15d806cbddc)("AccessControlList");
        nodes.map(function(node) {
            containerNode_4.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_4);
    }
    if (input.Tagging !== undefined && input.Tagging !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlTagging(input.Tagging, context).withName("Tagging");
        bodyNode.addChildNode(node);
    }
    if (input.UserMetadata !== undefined && input.UserMetadata !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlUserMetadata(input.UserMetadata, context);
        var containerNode_5 = new (0, $624db86d198ff371$export$e775a15d806cbddc)("UserMetadata");
        nodes.map(function(node) {
            containerNode_5.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_5);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("StorageClass").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlScanRange = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ScanRange");
    if (input.Start !== undefined && input.Start !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Start").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Start))).withName("Start");
        bodyNode.addChildNode(node);
    }
    if (input.End !== undefined && input.End !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("End").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.End))).withName("End");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlSelectParameters = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SelectParameters");
    if (input.InputSerialization !== undefined && input.InputSerialization !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.ExpressionType !== undefined && input.ExpressionType !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ExpressionType").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.ExpressionType)).withName("ExpressionType");
        bodyNode.addChildNode(node);
    }
    if (input.Expression !== undefined && input.Expression !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Expression").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Expression)).withName("Expression");
        bodyNode.addChildNode(node);
    }
    if (input.OutputSerialization !== undefined && input.OutputSerialization !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionByDefault = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ServerSideEncryptionByDefault");
    if (input.SSEAlgorithm !== undefined && input.SSEAlgorithm !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ServerSideEncryption").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.SSEAlgorithm)).withName("SSEAlgorithm");
        bodyNode.addChildNode(node);
    }
    if (input.KMSMasterKeyID !== undefined && input.KMSMasterKeyID !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.KMSMasterKeyID)).withName("KMSMasterKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ServerSideEncryptionConfiguration");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionRule = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ServerSideEncryptionRule");
    if (input.ApplyServerSideEncryptionByDefault !== undefined && input.ApplyServerSideEncryptionByDefault !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionByDefault(input.ApplyServerSideEncryptionByDefault, context).withName("ApplyServerSideEncryptionByDefault");
        bodyNode.addChildNode(node);
    }
    if (input.BucketKeyEnabled !== undefined && input.BucketKeyEnabled !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketKeyEnabled").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.BucketKeyEnabled))).withName("BucketKeyEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlServerSideEncryptionRule(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlSourceSelectionCriteria = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SourceSelectionCriteria");
    if (input.SseKmsEncryptedObjects !== undefined && input.SseKmsEncryptedObjects !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlSseKmsEncryptedObjects(input.SseKmsEncryptedObjects, context).withName("SseKmsEncryptedObjects");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicaModifications !== undefined && input.ReplicaModifications !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlReplicaModifications(input.ReplicaModifications, context).withName("ReplicaModifications");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlSSEKMS = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SSE-KMS");
    if (input.KeyId !== undefined && input.KeyId !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.KeyId)).withName("KeyId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlSseKmsEncryptedObjects = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SseKmsEncryptedObjects");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SseKmsEncryptedObjectsStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlSSES3 = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("SSE-S3");
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlStorageClassAnalysis = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("StorageClassAnalysis");
    if (input.DataExport !== undefined && input.DataExport !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlStorageClassAnalysisDataExport(input.DataExport, context).withName("DataExport");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlStorageClassAnalysisDataExport = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("StorageClassAnalysisDataExport");
    if (input.OutputSchemaVersion !== undefined && input.OutputSchemaVersion !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("StorageClassAnalysisSchemaVersion").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.OutputSchemaVersion)).withName("OutputSchemaVersion");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlAnalyticsExportDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlTag = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Tag");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Value").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlTagging = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Tagging");
    if (input.TagSet !== undefined && input.TagSet !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlTagSet(input.TagSet, context);
        var containerNode_6 = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TagSet");
        nodes.map(function(node) {
            containerNode_6.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_6);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlTagSet = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlTag(entry, context);
        return node.withName("Tag");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlTargetGrant = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TargetGrant");
    if (input.Grantee !== undefined && input.Grantee !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined && input.Permission !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketLogsPermission").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlTargetGrants = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlTargetGrant(entry, context);
        return node.withName("Grant");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlTiering = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Tiering");
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IntelligentTieringDays").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.AccessTier !== undefined && input.AccessTier !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("IntelligentTieringAccessTier").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.AccessTier)).withName("AccessTier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlTieringList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlTiering(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlTopicConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TopicConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.TopicArn !== undefined && input.TopicArn !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TopicArn").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.TopicArn)).withName("Topic");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlTopicConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlTopicConfiguration(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlTransition = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Transition");
    if (input.Date !== undefined && input.Date !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Date").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("Days").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("TransitionStorageClass").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlTransitionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlTransition(entry, context);
        return node.withName("member");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlUserMetadata = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $748b18c285b09559$var$serializeAws_restXmlMetadataEntry(entry, context);
        return node.withName("MetadataEntry");
    });
};
var $748b18c285b09559$var$serializeAws_restXmlVersioningConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("VersioningConfiguration");
    if (input.MFADelete !== undefined && input.MFADelete !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("MFADelete").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.MFADelete)).withName("MfaDelete");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $624db86d198ff371$export$e775a15d806cbddc)("BucketVersioningStatus").addChildNode(new (0, $cd594e57aad4e5d1$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $748b18c285b09559$var$serializeAws_restXmlWebsiteConfiguration = function(input, context) {
    var bodyNode = new (0, $624db86d198ff371$export$e775a15d806cbddc)("WebsiteConfiguration");
    if (input.ErrorDocument !== undefined && input.ErrorDocument !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlErrorDocument(input.ErrorDocument, context).withName("ErrorDocument");
        bodyNode.addChildNode(node);
    }
    if (input.IndexDocument !== undefined && input.IndexDocument !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlIndexDocument(input.IndexDocument, context).withName("IndexDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RedirectAllRequestsTo !== undefined && input.RedirectAllRequestsTo !== null) {
        var node = $748b18c285b09559$var$serializeAws_restXmlRedirectAllRequestsTo(input.RedirectAllRequestsTo, context).withName("RedirectAllRequestsTo");
        bodyNode.addChildNode(node);
    }
    if (input.RoutingRules !== undefined && input.RoutingRules !== null) {
        var nodes = $748b18c285b09559$var$serializeAws_restXmlRoutingRules(input.RoutingRules, context);
        var containerNode_7 = new (0, $624db86d198ff371$export$e775a15d806cbddc)("RoutingRules");
        nodes.map(function(node) {
            containerNode_7.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_7);
    }
    return bodyNode;
};
var $748b18c285b09559$var$deserializeAws_restXmlAbortIncompleteMultipartUpload = function(output, context) {
    var contents = {
        DaysAfterInitiation: undefined
    };
    if (output["DaysAfterInitiation"] !== undefined) contents.DaysAfterInitiation = parseInt(output["DaysAfterInitiation"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlAccessControlTranslation = function(output, context) {
    var contents = {
        Owner: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = output["Owner"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlAllowedHeaders = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlAllowedMethods = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlAllowedOrigins = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlAnalyticsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $748b18c285b09559$var$deserializeAws_restXmlTagSet((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlAnalyticsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined,
        StorageClassAnalysis: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlAnalyticsFilter(output["Filter"], context);
    if (output["StorageClassAnalysis"] !== undefined) contents.StorageClassAnalysis = $748b18c285b09559$var$deserializeAws_restXmlStorageClassAnalysis(output["StorageClassAnalysis"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlAnalyticsConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlAnalyticsConfiguration(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlAnalyticsExportDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $748b18c285b09559$var$deserializeAws_restXmlAnalyticsS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlAnalyticsFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $748b18c285b09559$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $748b18c285b09559$var$deserializeAws_restXmlAnalyticsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $748b18c285b09559$var$deserializeAws_restXmlAnalyticsS3BucketDestination = function(output, context) {
    var contents = {
        Format: undefined,
        BucketAccountId: undefined,
        Bucket: undefined,
        Prefix: undefined
    };
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["BucketAccountId"] !== undefined) contents.BucketAccountId = output["BucketAccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlBucket = function(output, context) {
    var contents = {
        Name: undefined,
        CreationDate: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["CreationDate"] !== undefined) contents.CreationDate = new Date(output["CreationDate"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlBuckets = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlBucket(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlCommonPrefix = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlCommonPrefixList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlCommonPrefix(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlCondition = function(output, context) {
    var contents = {
        HttpErrorCodeReturnedEquals: undefined,
        KeyPrefixEquals: undefined
    };
    if (output["HttpErrorCodeReturnedEquals"] !== undefined) contents.HttpErrorCodeReturnedEquals = output["HttpErrorCodeReturnedEquals"];
    if (output["KeyPrefixEquals"] !== undefined) contents.KeyPrefixEquals = output["KeyPrefixEquals"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlCopyObjectResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlCopyPartResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlCORSRule = function(output, context) {
    var contents = {
        AllowedHeaders: undefined,
        AllowedMethods: undefined,
        AllowedOrigins: undefined,
        ExposeHeaders: undefined,
        MaxAgeSeconds: undefined
    };
    if (output.AllowedHeader === "") contents.AllowedHeaders = [];
    if (output["AllowedHeader"] !== undefined) contents.AllowedHeaders = $748b18c285b09559$var$deserializeAws_restXmlAllowedHeaders((0, $3cac61d5afd59793$export$52272e038712c64e)(output["AllowedHeader"]), context);
    if (output.AllowedMethod === "") contents.AllowedMethods = [];
    if (output["AllowedMethod"] !== undefined) contents.AllowedMethods = $748b18c285b09559$var$deserializeAws_restXmlAllowedMethods((0, $3cac61d5afd59793$export$52272e038712c64e)(output["AllowedMethod"]), context);
    if (output.AllowedOrigin === "") contents.AllowedOrigins = [];
    if (output["AllowedOrigin"] !== undefined) contents.AllowedOrigins = $748b18c285b09559$var$deserializeAws_restXmlAllowedOrigins((0, $3cac61d5afd59793$export$52272e038712c64e)(output["AllowedOrigin"]), context);
    if (output.ExposeHeader === "") contents.ExposeHeaders = [];
    if (output["ExposeHeader"] !== undefined) contents.ExposeHeaders = $748b18c285b09559$var$deserializeAws_restXmlExposeHeaders((0, $3cac61d5afd59793$export$52272e038712c64e)(output["ExposeHeader"]), context);
    if (output["MaxAgeSeconds"] !== undefined) contents.MaxAgeSeconds = parseInt(output["MaxAgeSeconds"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlCORSRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlCORSRule(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDefaultRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        Days: undefined,
        Years: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["Years"] !== undefined) contents.Years = parseInt(output["Years"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlDeletedObject = function(output, context) {
    var contents = {
        Key: undefined,
        VersionId: undefined,
        DeleteMarker: undefined,
        DeleteMarkerVersionId: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["DeleteMarker"] !== undefined) contents.DeleteMarker = output["DeleteMarker"] == "true";
    if (output["DeleteMarkerVersionId"] !== undefined) contents.DeleteMarkerVersionId = output["DeleteMarkerVersionId"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlDeletedObjects = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlDeletedObject(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteMarkerEntry = function(output, context) {
    var contents = {
        Owner: undefined,
        Key: undefined,
        VersionId: undefined,
        IsLatest: undefined,
        LastModified: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteMarkerReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlDeleteMarkers = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlDeleteMarkerEntry(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlDestination = function(output, context) {
    var contents = {
        Bucket: undefined,
        Account: undefined,
        StorageClass: undefined,
        AccessControlTranslation: undefined,
        EncryptionConfiguration: undefined,
        ReplicationTime: undefined,
        Metrics: undefined
    };
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Account"] !== undefined) contents.Account = output["Account"];
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["AccessControlTranslation"] !== undefined) contents.AccessControlTranslation = $748b18c285b09559$var$deserializeAws_restXmlAccessControlTranslation(output["AccessControlTranslation"], context);
    if (output["EncryptionConfiguration"] !== undefined) contents.EncryptionConfiguration = $748b18c285b09559$var$deserializeAws_restXmlEncryptionConfiguration(output["EncryptionConfiguration"], context);
    if (output["ReplicationTime"] !== undefined) contents.ReplicationTime = $748b18c285b09559$var$deserializeAws_restXmlReplicationTime(output["ReplicationTime"], context);
    if (output["Metrics"] !== undefined) contents.Metrics = $748b18c285b09559$var$deserializeAws_restXmlMetrics(output["Metrics"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlEncryptionConfiguration = function(output, context) {
    var contents = {
        ReplicaKmsKeyID: undefined
    };
    if (output["ReplicaKmsKeyID"] !== undefined) contents.ReplicaKmsKeyID = output["ReplicaKmsKeyID"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXml_Error = function(output, context) {
    var contents = {
        Key: undefined,
        VersionId: undefined,
        Code: undefined,
        Message: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["Code"] !== undefined) contents.Code = output["Code"];
    if (output["Message"] !== undefined) contents.Message = output["Message"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlErrorDocument = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlErrors = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXml_Error(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlEventList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlExistingObjectReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlExposeHeaders = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlFilterRule = function(output, context) {
    var contents = {
        Name: undefined,
        Value: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlFilterRuleList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlFilterRule(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $748b18c285b09559$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlGrantee = function(output, context) {
    var contents = {
        DisplayName: undefined,
        EmailAddress: undefined,
        ID: undefined,
        URI: undefined,
        Type: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["EmailAddress"] !== undefined) contents.EmailAddress = output["EmailAddress"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["URI"] !== undefined) contents.URI = output["URI"];
    if (output["xsi:type"] !== undefined) contents.Type = output["xsi:type"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlGrants = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlGrant(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlIndexDocument = function(output, context) {
    var contents = {
        Suffix: undefined
    };
    if (output["Suffix"] !== undefined) contents.Suffix = output["Suffix"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlInitiator = function(output, context) {
    var contents = {
        ID: undefined,
        DisplayName: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $748b18c285b09559$var$deserializeAws_restXmlTagSet((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined,
        Status: undefined,
        Tierings: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output.Tiering === "") contents.Tierings = [];
    if (output["Tiering"] !== undefined) contents.Tierings = $748b18c285b09559$var$deserializeAws_restXmlTieringList((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Tiering"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringConfiguration(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringFilter = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tag: undefined,
        And: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $748b18c285b09559$var$deserializeAws_restXmlTag(output["Tag"], context);
    if (output["And"] !== undefined) contents.And = $748b18c285b09559$var$deserializeAws_restXmlIntelligentTieringAndOperator(output["And"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlInventoryConfiguration = function(output, context) {
    var contents = {
        Destination: undefined,
        IsEnabled: undefined,
        Filter: undefined,
        Id: undefined,
        IncludedObjectVersions: undefined,
        OptionalFields: undefined,
        Schedule: undefined
    };
    if (output["Destination"] !== undefined) contents.Destination = $748b18c285b09559$var$deserializeAws_restXmlInventoryDestination(output["Destination"], context);
    if (output["IsEnabled"] !== undefined) contents.IsEnabled = output["IsEnabled"] == "true";
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlInventoryFilter(output["Filter"], context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["IncludedObjectVersions"] !== undefined) contents.IncludedObjectVersions = output["IncludedObjectVersions"];
    if (output.OptionalFields === "") contents.OptionalFields = [];
    if (output["OptionalFields"] !== undefined && output["OptionalFields"]["Field"] !== undefined) contents.OptionalFields = $748b18c285b09559$var$deserializeAws_restXmlInventoryOptionalFields((0, $3cac61d5afd59793$export$52272e038712c64e)(output["OptionalFields"]["Field"]), context);
    if (output["Schedule"] !== undefined) contents.Schedule = $748b18c285b09559$var$deserializeAws_restXmlInventorySchedule(output["Schedule"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlInventoryConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlInventoryConfiguration(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlInventoryDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $748b18c285b09559$var$deserializeAws_restXmlInventoryS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlInventoryEncryption = function(output, context) {
    var contents = {
        SSES3: undefined,
        SSEKMS: undefined
    };
    if (output["SSE-S3"] !== undefined) contents.SSES3 = $748b18c285b09559$var$deserializeAws_restXmlSSES3(output["SSE-S3"], context);
    if (output["SSE-KMS"] !== undefined) contents.SSEKMS = $748b18c285b09559$var$deserializeAws_restXmlSSEKMS(output["SSE-KMS"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlInventoryFilter = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlInventoryOptionalFields = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlInventoryS3BucketDestination = function(output, context) {
    var contents = {
        AccountId: undefined,
        Bucket: undefined,
        Format: undefined,
        Prefix: undefined,
        Encryption: undefined
    };
    if (output["AccountId"] !== undefined) contents.AccountId = output["AccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Encryption"] !== undefined) contents.Encryption = $748b18c285b09559$var$deserializeAws_restXmlInventoryEncryption(output["Encryption"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlInventorySchedule = function(output, context) {
    var contents = {
        Frequency: undefined
    };
    if (output["Frequency"] !== undefined) contents.Frequency = output["Frequency"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlLambdaFunctionConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        LambdaFunctionArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["CloudFunction"] !== undefined) contents.LambdaFunctionArn = output["CloudFunction"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $748b18c285b09559$var$deserializeAws_restXmlEventList((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlLambdaFunctionConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlLambdaFunctionConfiguration(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlLifecycleExpiration = function(output, context) {
    var contents = {
        Date: undefined,
        Days: undefined,
        ExpiredObjectDeleteMarker: undefined
    };
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["ExpiredObjectDeleteMarker"] !== undefined) contents.ExpiredObjectDeleteMarker = output["ExpiredObjectDeleteMarker"] == "true";
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlLifecycleRule = function(output, context) {
    var contents = {
        Expiration: undefined,
        ID: undefined,
        Prefix: undefined,
        Filter: undefined,
        Status: undefined,
        Transitions: undefined,
        NoncurrentVersionTransitions: undefined,
        NoncurrentVersionExpiration: undefined,
        AbortIncompleteMultipartUpload: undefined
    };
    if (output["Expiration"] !== undefined) contents.Expiration = $748b18c285b09559$var$deserializeAws_restXmlLifecycleExpiration(output["Expiration"], context);
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlLifecycleRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output.Transition === "") contents.Transitions = [];
    if (output["Transition"] !== undefined) contents.Transitions = $748b18c285b09559$var$deserializeAws_restXmlTransitionList((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Transition"]), context);
    if (output.NoncurrentVersionTransition === "") contents.NoncurrentVersionTransitions = [];
    if (output["NoncurrentVersionTransition"] !== undefined) contents.NoncurrentVersionTransitions = $748b18c285b09559$var$deserializeAws_restXmlNoncurrentVersionTransitionList((0, $3cac61d5afd59793$export$52272e038712c64e)(output["NoncurrentVersionTransition"]), context);
    if (output["NoncurrentVersionExpiration"] !== undefined) contents.NoncurrentVersionExpiration = $748b18c285b09559$var$deserializeAws_restXmlNoncurrentVersionExpiration(output["NoncurrentVersionExpiration"], context);
    if (output["AbortIncompleteMultipartUpload"] !== undefined) contents.AbortIncompleteMultipartUpload = $748b18c285b09559$var$deserializeAws_restXmlAbortIncompleteMultipartUpload(output["AbortIncompleteMultipartUpload"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlLifecycleRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $748b18c285b09559$var$deserializeAws_restXmlTagSet((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlLifecycleRuleFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $748b18c285b09559$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $748b18c285b09559$var$deserializeAws_restXmlLifecycleRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $748b18c285b09559$var$deserializeAws_restXmlLifecycleRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlLifecycleRule(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlLoggingEnabled = function(output, context) {
    var contents = {
        TargetBucket: undefined,
        TargetGrants: undefined,
        TargetPrefix: undefined
    };
    if (output["TargetBucket"] !== undefined) contents.TargetBucket = output["TargetBucket"];
    if (output.TargetGrants === "") contents.TargetGrants = [];
    if (output["TargetGrants"] !== undefined && output["TargetGrants"]["Grant"] !== undefined) contents.TargetGrants = $748b18c285b09559$var$deserializeAws_restXmlTargetGrants((0, $3cac61d5afd59793$export$52272e038712c64e)(output["TargetGrants"]["Grant"]), context);
    if (output["TargetPrefix"] !== undefined) contents.TargetPrefix = output["TargetPrefix"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlMetrics = function(output, context) {
    var contents = {
        Status: undefined,
        EventThreshold: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["EventThreshold"] !== undefined) contents.EventThreshold = $748b18c285b09559$var$deserializeAws_restXmlReplicationTimeValue(output["EventThreshold"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlMetricsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $748b18c285b09559$var$deserializeAws_restXmlTagSet((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlMetricsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlMetricsFilter(output["Filter"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlMetricsConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlMetricsConfiguration(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlMetricsFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $748b18c285b09559$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $748b18c285b09559$var$deserializeAws_restXmlMetricsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $748b18c285b09559$var$deserializeAws_restXmlMultipartUpload = function(output, context) {
    var contents = {
        UploadId: undefined,
        Key: undefined,
        Initiated: undefined,
        StorageClass: undefined,
        Owner: undefined,
        Initiator: undefined
    };
    if (output["UploadId"] !== undefined) contents.UploadId = output["UploadId"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Initiated"] !== undefined) contents.Initiated = new Date(output["Initiated"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["Initiator"] !== undefined) contents.Initiator = $748b18c285b09559$var$deserializeAws_restXmlInitiator(output["Initiator"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlMultipartUploadList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlMultipartUpload(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlNoncurrentVersionExpiration = function(output, context) {
    var contents = {
        NoncurrentDays: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlNoncurrentVersionTransition = function(output, context) {
    var contents = {
        NoncurrentDays: undefined,
        StorageClass: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlNoncurrentVersionTransitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlNoncurrentVersionTransition(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlNotificationConfigurationFilter = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["S3Key"] !== undefined) contents.Key = $748b18c285b09559$var$deserializeAws_restXmlS3KeyFilter(output["S3Key"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXml_Object = function(output, context) {
    var contents = {
        Key: undefined,
        LastModified: undefined,
        ETag: undefined,
        Size: undefined,
        StorageClass: undefined,
        Owner: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXml_Object(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectLockConfiguration = function(output, context) {
    var contents = {
        ObjectLockEnabled: undefined,
        Rule: undefined
    };
    if (output["ObjectLockEnabled"] !== undefined) contents.ObjectLockEnabled = output["ObjectLockEnabled"];
    if (output["Rule"] !== undefined) contents.Rule = $748b18c285b09559$var$deserializeAws_restXmlObjectLockRule(output["Rule"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectLockLegalHold = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectLockRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        RetainUntilDate: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["RetainUntilDate"] !== undefined) contents.RetainUntilDate = new Date(output["RetainUntilDate"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectLockRule = function(output, context) {
    var contents = {
        DefaultRetention: undefined
    };
    if (output["DefaultRetention"] !== undefined) contents.DefaultRetention = $748b18c285b09559$var$deserializeAws_restXmlDefaultRetention(output["DefaultRetention"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectVersion = function(output, context) {
    var contents = {
        ETag: undefined,
        Size: undefined,
        StorageClass: undefined,
        Key: undefined,
        VersionId: undefined,
        IsLatest: undefined,
        LastModified: undefined,
        Owner: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["Owner"] !== undefined) contents.Owner = $748b18c285b09559$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlObjectVersionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlObjectVersion(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlOwner = function(output, context) {
    var contents = {
        DisplayName: undefined,
        ID: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlOwnershipControls = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $748b18c285b09559$var$deserializeAws_restXmlOwnershipControlsRules((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlOwnershipControlsRule = function(output, context) {
    var contents = {
        ObjectOwnership: undefined
    };
    if (output["ObjectOwnership"] !== undefined) contents.ObjectOwnership = output["ObjectOwnership"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlOwnershipControlsRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlOwnershipControlsRule(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPart = function(output, context) {
    var contents = {
        PartNumber: undefined,
        LastModified: undefined,
        ETag: undefined,
        Size: undefined
    };
    if (output["PartNumber"] !== undefined) contents.PartNumber = parseInt(output["PartNumber"]);
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlParts = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlPart(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlPolicyStatus = function(output, context) {
    var contents = {
        IsPublic: undefined
    };
    if (output["IsPublic"] !== undefined) contents.IsPublic = output["IsPublic"] == "true";
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlPublicAccessBlockConfiguration = function(output, context) {
    var contents = {
        BlockPublicAcls: undefined,
        IgnorePublicAcls: undefined,
        BlockPublicPolicy: undefined,
        RestrictPublicBuckets: undefined
    };
    if (output["BlockPublicAcls"] !== undefined) contents.BlockPublicAcls = output["BlockPublicAcls"] == "true";
    if (output["IgnorePublicAcls"] !== undefined) contents.IgnorePublicAcls = output["IgnorePublicAcls"] == "true";
    if (output["BlockPublicPolicy"] !== undefined) contents.BlockPublicPolicy = output["BlockPublicPolicy"] == "true";
    if (output["RestrictPublicBuckets"] !== undefined) contents.RestrictPublicBuckets = output["RestrictPublicBuckets"] == "true";
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlQueueConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        QueueArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Queue"] !== undefined) contents.QueueArn = output["Queue"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $748b18c285b09559$var$deserializeAws_restXmlEventList((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlQueueConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlQueueConfiguration(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlRedirect = function(output, context) {
    var contents = {
        HostName: undefined,
        HttpRedirectCode: undefined,
        Protocol: undefined,
        ReplaceKeyPrefixWith: undefined,
        ReplaceKeyWith: undefined
    };
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["HttpRedirectCode"] !== undefined) contents.HttpRedirectCode = output["HttpRedirectCode"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    if (output["ReplaceKeyPrefixWith"] !== undefined) contents.ReplaceKeyPrefixWith = output["ReplaceKeyPrefixWith"];
    if (output["ReplaceKeyWith"] !== undefined) contents.ReplaceKeyWith = output["ReplaceKeyWith"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlRedirectAllRequestsTo = function(output, context) {
    var contents = {
        HostName: undefined,
        Protocol: undefined
    };
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicaModifications = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicationConfiguration = function(output, context) {
    var contents = {
        Role: undefined,
        Rules: undefined
    };
    if (output["Role"] !== undefined) contents.Role = output["Role"];
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $748b18c285b09559$var$deserializeAws_restXmlReplicationRules((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicationRule = function(output, context) {
    var contents = {
        ID: undefined,
        Priority: undefined,
        Prefix: undefined,
        Filter: undefined,
        Status: undefined,
        SourceSelectionCriteria: undefined,
        ExistingObjectReplication: undefined,
        Destination: undefined,
        DeleteMarkerReplication: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["Priority"] !== undefined) contents.Priority = parseInt(output["Priority"]);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlReplicationRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["SourceSelectionCriteria"] !== undefined) contents.SourceSelectionCriteria = $748b18c285b09559$var$deserializeAws_restXmlSourceSelectionCriteria(output["SourceSelectionCriteria"], context);
    if (output["ExistingObjectReplication"] !== undefined) contents.ExistingObjectReplication = $748b18c285b09559$var$deserializeAws_restXmlExistingObjectReplication(output["ExistingObjectReplication"], context);
    if (output["Destination"] !== undefined) contents.Destination = $748b18c285b09559$var$deserializeAws_restXmlDestination(output["Destination"], context);
    if (output["DeleteMarkerReplication"] !== undefined) contents.DeleteMarkerReplication = $748b18c285b09559$var$deserializeAws_restXmlDeleteMarkerReplication(output["DeleteMarkerReplication"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicationRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $748b18c285b09559$var$deserializeAws_restXmlTagSet((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicationRuleFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $748b18c285b09559$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $748b18c285b09559$var$deserializeAws_restXmlReplicationRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicationRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlReplicationRule(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicationTime = function(output, context) {
    var contents = {
        Status: undefined,
        Time: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["Time"] !== undefined) contents.Time = $748b18c285b09559$var$deserializeAws_restXmlReplicationTimeValue(output["Time"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlReplicationTimeValue = function(output, context) {
    var contents = {
        Minutes: undefined
    };
    if (output["Minutes"] !== undefined) contents.Minutes = parseInt(output["Minutes"]);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlRoutingRule = function(output, context) {
    var contents = {
        Condition: undefined,
        Redirect: undefined
    };
    if (output["Condition"] !== undefined) contents.Condition = $748b18c285b09559$var$deserializeAws_restXmlCondition(output["Condition"], context);
    if (output["Redirect"] !== undefined) contents.Redirect = $748b18c285b09559$var$deserializeAws_restXmlRedirect(output["Redirect"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlRoutingRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlRoutingRule(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlS3KeyFilter = function(output, context) {
    var contents = {
        FilterRules: undefined
    };
    if (output.FilterRule === "") contents.FilterRules = [];
    if (output["FilterRule"] !== undefined) contents.FilterRules = $748b18c285b09559$var$deserializeAws_restXmlFilterRuleList((0, $3cac61d5afd59793$export$52272e038712c64e)(output["FilterRule"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionByDefault = function(output, context) {
    var contents = {
        SSEAlgorithm: undefined,
        KMSMasterKeyID: undefined
    };
    if (output["SSEAlgorithm"] !== undefined) contents.SSEAlgorithm = output["SSEAlgorithm"];
    if (output["KMSMasterKeyID"] !== undefined) contents.KMSMasterKeyID = output["KMSMasterKeyID"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionConfiguration = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionRules((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionRule = function(output, context) {
    var contents = {
        ApplyServerSideEncryptionByDefault: undefined,
        BucketKeyEnabled: undefined
    };
    if (output["ApplyServerSideEncryptionByDefault"] !== undefined) contents.ApplyServerSideEncryptionByDefault = $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionByDefault(output["ApplyServerSideEncryptionByDefault"], context);
    if (output["BucketKeyEnabled"] !== undefined) contents.BucketKeyEnabled = output["BucketKeyEnabled"] == "true";
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlServerSideEncryptionRule(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlSourceSelectionCriteria = function(output, context) {
    var contents = {
        SseKmsEncryptedObjects: undefined,
        ReplicaModifications: undefined
    };
    if (output["SseKmsEncryptedObjects"] !== undefined) contents.SseKmsEncryptedObjects = $748b18c285b09559$var$deserializeAws_restXmlSseKmsEncryptedObjects(output["SseKmsEncryptedObjects"], context);
    if (output["ReplicaModifications"] !== undefined) contents.ReplicaModifications = $748b18c285b09559$var$deserializeAws_restXmlReplicaModifications(output["ReplicaModifications"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlSSEKMS = function(output, context) {
    var contents = {
        KeyId: undefined
    };
    if (output["KeyId"] !== undefined) contents.KeyId = output["KeyId"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlSseKmsEncryptedObjects = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlSSES3 = function(output, context) {
    var contents = {};
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlStorageClassAnalysis = function(output, context) {
    var contents = {
        DataExport: undefined
    };
    if (output["DataExport"] !== undefined) contents.DataExport = $748b18c285b09559$var$deserializeAws_restXmlStorageClassAnalysisDataExport(output["DataExport"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlStorageClassAnalysisDataExport = function(output, context) {
    var contents = {
        OutputSchemaVersion: undefined,
        Destination: undefined
    };
    if (output["OutputSchemaVersion"] !== undefined) contents.OutputSchemaVersion = output["OutputSchemaVersion"];
    if (output["Destination"] !== undefined) contents.Destination = $748b18c285b09559$var$deserializeAws_restXmlAnalyticsExportDestination(output["Destination"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlTag = function(output, context) {
    var contents = {
        Key: undefined,
        Value: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlTagSet = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlTag(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlTargetGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $748b18c285b09559$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlTargetGrants = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlTargetGrant(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlTiering = function(output, context) {
    var contents = {
        Days: undefined,
        AccessTier: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["AccessTier"] !== undefined) contents.AccessTier = output["AccessTier"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlTieringList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlTiering(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlTopicConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        TopicArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Topic"] !== undefined) contents.TopicArn = output["Topic"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $748b18c285b09559$var$deserializeAws_restXmlEventList((0, $3cac61d5afd59793$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $748b18c285b09559$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlTopicConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlTopicConfiguration(entry, context);
    });
};
var $748b18c285b09559$var$deserializeAws_restXmlTransition = function(output, context) {
    var contents = {
        Date: undefined,
        Days: undefined,
        StorageClass: undefined
    };
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $748b18c285b09559$var$deserializeAws_restXmlTransitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $748b18c285b09559$var$deserializeAws_restXmlTransition(entry, context);
    });
};
var $748b18c285b09559$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $748b18c285b09559$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $748b18c285b09559$var$collectBodyString = function(streamBody, context) {
    return $748b18c285b09559$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $748b18c285b09559$var$isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var $748b18c285b09559$var$decodeEscapedXML = function(str) {
    return str.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<");
};
var $748b18c285b09559$var$parseBody = function(streamBody, context) {
    return $748b18c285b09559$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) {
            var parsedObj = (0, $3519767cfc6fdeeb$export$98e6a39c04603d36)(encoded, {
                attributeNamePrefix: "",
                ignoreAttributes: false,
                parseNodeValue: false,
                tagValueProcessor: function(val, tagName) {
                    return $748b18c285b09559$var$decodeEscapedXML(val);
                }
            });
            var textNodeName = "#text";
            var key = Object.keys(parsedObj)[0];
            var parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $23fbce306a7ffebd$export$113d90026b452881)(parsedObjToReturn);
        }
        return {};
    });
};
var $748b18c285b09559$var$loadRestXmlErrorCode = function(output, data) {
    if (data.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
    return "";
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cb9973b5442bbf64$var$extendStatics = function(d, b) {
    $cb9973b5442bbf64$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $cb9973b5442bbf64$var$extendStatics(d, b);
};
function $cb9973b5442bbf64$export$a8ba968b8961cb8a(d, b) {
    $cb9973b5442bbf64$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cb9973b5442bbf64$export$18ce0697a983be9b = function() {
    $cb9973b5442bbf64$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cb9973b5442bbf64$export$18ce0697a983be9b.apply(this, arguments);
};
function $cb9973b5442bbf64$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cb9973b5442bbf64$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cb9973b5442bbf64$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cb9973b5442bbf64$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cb9973b5442bbf64$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cb9973b5442bbf64$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $cb9973b5442bbf64$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $cb9973b5442bbf64$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $cb9973b5442bbf64$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cb9973b5442bbf64$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cb9973b5442bbf64$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cb9973b5442bbf64$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cb9973b5442bbf64$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cb9973b5442bbf64$export$10c90e4f7922046c(v) {
    return this instanceof $cb9973b5442bbf64$export$10c90e4f7922046c ? (this.v = v, this) : new $cb9973b5442bbf64$export$10c90e4f7922046c(v);
}
function $cb9973b5442bbf64$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cb9973b5442bbf64$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cb9973b5442bbf64$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cb9973b5442bbf64$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $cb9973b5442bbf64$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cb9973b5442bbf64$export$19a8beecd37a4c45 === "function" ? $cb9973b5442bbf64$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cb9973b5442bbf64$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $cb9973b5442bbf64$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $cb9973b5442bbf64$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cb9973b5442bbf64$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $cb9973b5442bbf64$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $40df7d06d6272d79$var$extendStatics = function(d, b) {
    $40df7d06d6272d79$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $40df7d06d6272d79$var$extendStatics(d, b);
};
function $40df7d06d6272d79$export$a8ba968b8961cb8a(d, b) {
    $40df7d06d6272d79$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $40df7d06d6272d79$export$18ce0697a983be9b = function() {
    $40df7d06d6272d79$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40df7d06d6272d79$export$18ce0697a983be9b.apply(this, arguments);
};
function $40df7d06d6272d79$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $40df7d06d6272d79$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $40df7d06d6272d79$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $40df7d06d6272d79$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $40df7d06d6272d79$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $40df7d06d6272d79$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $40df7d06d6272d79$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $40df7d06d6272d79$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $40df7d06d6272d79$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $40df7d06d6272d79$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $40df7d06d6272d79$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($40df7d06d6272d79$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $40df7d06d6272d79$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $40df7d06d6272d79$export$10c90e4f7922046c(v) {
    return this instanceof $40df7d06d6272d79$export$10c90e4f7922046c ? (this.v = v, this) : new $40df7d06d6272d79$export$10c90e4f7922046c(v);
}
function $40df7d06d6272d79$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $40df7d06d6272d79$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $40df7d06d6272d79$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $40df7d06d6272d79$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $40df7d06d6272d79$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $40df7d06d6272d79$export$19a8beecd37a4c45 === "function" ? $40df7d06d6272d79$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $40df7d06d6272d79$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $40df7d06d6272d79$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $40df7d06d6272d79$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $40df7d06d6272d79$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $40df7d06d6272d79$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $5edcde9d7842c535$export$a22775fa5e2eebd9 = function(str) {
    return typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
};
var $5edcde9d7842c535$export$98e6a39c04603d36 = function(arn) {
    var segments = arn.split(":");
    if (segments.length < 6 || segments[0] !== "arn") throw new Error("Malformed ARN");
    var _a = (0, $40df7d06d6272d79$export$8d051b38c9118094)(segments), //Skip "arn" literal
    partition = _a[1], service = _a[2], region = _a[3], accountId = _a[4], resource = _a.slice(5);
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resource: resource.join(":")
    };
};
var $5edcde9d7842c535$export$3f8fe6489e95757d = function(arnObject) {
    var _a = arnObject.partition, partition = _a === void 0 ? "aws" : _a, service = arnObject.service, region = arnObject.region, accountId = arnObject.accountId, resource = arnObject.resource;
    if ([
        service,
        region,
        accountId,
        resource
    ].some(function(segment) {
        return typeof segment !== "string";
    })) throw new Error("Input ARN object is invalid");
    return "arn:" + partition + ":" + service + ":" + region + ":" + accountId + ":" + resource;
};




var $196dc502db2a6516$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var $196dc502db2a6516$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var $196dc502db2a6516$var$DOTS_PATTERN = /\.\./;
var $196dc502db2a6516$export$b0b24e5455be29b0 = /\./;
var $196dc502db2a6516$export$43f53815580748f = /^(.+\.)?s3[.-]([a-z0-9-]+)\./;
var $196dc502db2a6516$var$S3_US_EAST_1_ALTNAME_PATTERN = /^s3(-external-1)?\.amazonaws\.com$/;
var $196dc502db2a6516$var$AWS_PARTITION_SUFFIX = "amazonaws.com";
var $196dc502db2a6516$export$5b522ec9d0d23583 = function(options) {
    return typeof options.bucketName === "string";
};
var $196dc502db2a6516$export$2041e7d2db741fc6 = function(region) {
    return $196dc502db2a6516$var$isFipsRegion(region) ? region.replace(/fips-|-fips/, "") : region;
};
var $196dc502db2a6516$export$360a1e07839d0d27 = function(bucketName) {
    return $196dc502db2a6516$var$DOMAIN_PATTERN.test(bucketName) && !$196dc502db2a6516$var$IP_ADDRESS_PATTERN.test(bucketName) && !$196dc502db2a6516$var$DOTS_PATTERN.test(bucketName);
};
var $196dc502db2a6516$var$getRegionalSuffix = function(hostname) {
    var parts = hostname.match($196dc502db2a6516$export$43f53815580748f);
    return [
        parts[2],
        hostname.replace(new RegExp("^" + parts[0]), "")
    ];
};
var $196dc502db2a6516$export$661d620f7edbf69d = function(hostname) {
    return $196dc502db2a6516$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        "us-east-1",
        $196dc502db2a6516$var$AWS_PARTITION_SUFFIX
    ] : $196dc502db2a6516$var$getRegionalSuffix(hostname);
};
var $196dc502db2a6516$export$9822f1db281a24ef = function(hostname) {
    return $196dc502db2a6516$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        hostname.replace("." + $196dc502db2a6516$var$AWS_PARTITION_SUFFIX, ""),
        $196dc502db2a6516$var$AWS_PARTITION_SUFFIX
    ] : $196dc502db2a6516$var$getRegionalSuffix(hostname);
};
var $196dc502db2a6516$export$9d570635889bea10 = function(options) {
    if (options.pathStyleEndpoint) throw new Error("Path-style S3 endpoint is not supported when bucket is an ARN");
    if (options.accelerateEndpoint) throw new Error("Accelerate endpoint is not supported when bucket is an ARN");
    if (!options.tlsCompatible) throw new Error("HTTPS is required when bucket is an ARN");
};
var $196dc502db2a6516$export$56395344d8f6da92 = function(service) {
    if (service !== "s3" && service !== "s3-outposts") throw new Error("Expect 's3' or 's3-outposts' in ARN service component");
};
var $196dc502db2a6516$export$ee796dc843960f7e = function(service) {
    if (service !== "s3") throw new Error("Expect 's3' in Accesspoint ARN service component");
};
var $196dc502db2a6516$export$32ff3a9330dbd031 = function(service) {
    if (service !== "s3-outposts") throw new Error("Expect 's3-posts' in Outpost ARN service component");
};
var $196dc502db2a6516$export$2514cb957fb286b = function(partition, options) {
    if (partition !== options.clientPartition) throw new Error('Partition in ARN is incompatible, got "' + partition + '" but expected "' + options.clientPartition + '"');
};
var $196dc502db2a6516$export$6cc2fb0ca7159d47 = function(region, options) {
    if (region === "") throw new Error("ARN region is empty");
    if (!options.useArnRegion && !$196dc502db2a6516$var$isEqualRegions(region, options.clientRegion) && !$196dc502db2a6516$var$isEqualRegions(region, options.clientSigningRegion)) throw new Error("Region in ARN is incompatible, got " + region + " but expected " + options.clientRegion);
    if (options.useArnRegion && $196dc502db2a6516$var$isFipsRegion(region)) throw new Error("Endpoint does not support FIPS region");
};
var $196dc502db2a6516$var$isFipsRegion = function(region) {
    return region.startsWith("fips-") || region.endsWith("-fips");
};
var $196dc502db2a6516$var$isEqualRegions = function(regionA, regionB) {
    return regionA === regionB || $196dc502db2a6516$export$2041e7d2db741fc6(regionA) === regionB || regionA === $196dc502db2a6516$export$2041e7d2db741fc6(regionB);
};
var $196dc502db2a6516$export$311f0c1e79834f5a = function(accountId) {
    if (!/[0-9]{12}/.exec(accountId)) throw new Error("Access point ARN accountID does not match regex '[0-9]{12}'");
};
var $196dc502db2a6516$export$eab3c0a6ee9b0457 = function(label, options) {
    if (options === void 0) options = {
        tlsCompatible: true
    };
    // reference: https://tools.ietf.org/html/rfc3986#section-3.2.2
    if (label.length >= 64 || !/^[a-z0-9][a-z0-9.-]+[a-z0-9]$/.test(label) || /(\d+\.){3}\d+/.test(label) || /[.-]{2}/.test(label) || (options === null || options === void 0 ? void 0 : options.tlsCompatible) && $196dc502db2a6516$export$b0b24e5455be29b0.test(label)) throw new Error("Invalid DNS label " + label);
};
var $196dc502db2a6516$export$6b274ce9ea6c3c3a = function(resource) {
    var delimiter = resource.includes(":") ? ":" : "/";
    var _a = (0, $cb9973b5442bbf64$export$8d051b38c9118094)(resource.split(delimiter)), resourceType = _a[0], rest = _a.slice(1);
    if (resourceType === "accesspoint") {
        // Parse accesspoint ARN
        if (rest.length !== 1 || rest[0] === "") throw new Error("Access Point ARN should have one resource accesspoint" + delimiter + "{accesspointname}");
        return {
            accesspointName: rest[0]
        };
    } else if (resourceType === "outpost") {
        // Parse outpost ARN
        if (!rest[0] || rest[1] !== "accesspoint" || !rest[2] || rest.length !== 3) throw new Error("Outpost ARN should have resource outpost" + delimiter + "{outpostId}" + delimiter + "accesspoint" + delimiter + "{accesspointName}");
        var _b = (0, $cb9973b5442bbf64$export$8d051b38c9118094)(rest, 3), outpostId = _b[0], _ = _b[1], accesspointName = _b[2];
        return {
            outpostId: outpostId,
            accesspointName: accesspointName
        };
    } else throw new Error("ARN resource should begin with 'accesspoint" + delimiter + "' or 'outpost" + delimiter + "'");
};
var $196dc502db2a6516$export$76b09f028141bdfc = function(dualstackEndpoint) {
    if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with Outpost");
};
var $196dc502db2a6516$export$8b4c0cb10287799f = function(region) {
    if ($196dc502db2a6516$var$isFipsRegion(region !== null && region !== void 0 ? region : "")) throw new Error("FIPS region is not supported with Outpost, got " + region);
};


var $684ce4f43d621550$export$92dc36ff3a4794f7 = function(options) {
    var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname, dualstackEndpoint = options.dualstackEndpoint, accelerateEndpoint = options.accelerateEndpoint;
    if (isCustomEndpoint) {
        if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with custom endpoint");
        if (accelerateEndpoint) throw new Error("Accelerate endpoint is not supported with custom endpoint");
    }
    return (0, $196dc502db2a6516$export$5b522ec9d0d23583)(options) ? $684ce4f43d621550$var$getEndpointFromBucketName((0, $cb9973b5442bbf64$export$18ce0697a983be9b)((0, $cb9973b5442bbf64$export$18ce0697a983be9b)({}, options), {
        isCustomEndpoint: isCustomEndpoint
    })) : $684ce4f43d621550$var$getEndpointFromArn((0, $cb9973b5442bbf64$export$18ce0697a983be9b)((0, $cb9973b5442bbf64$export$18ce0697a983be9b)({}, options), {
        isCustomEndpoint: isCustomEndpoint
    }));
};
var $684ce4f43d621550$var$getEndpointFromArn = function(options) {
    var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname;
    var _a = (0, $cb9973b5442bbf64$export$8d051b38c9118094)(isCustomEndpoint ? [
        options.clientRegion,
        baseHostname
    ] : (0, $196dc502db2a6516$export$9822f1db281a24ef)(baseHostname), 2), clientRegion = _a[0], hostnameSuffix = _a[1];
    var pathStyleEndpoint = options.pathStyleEndpoint, _b = options.dualstackEndpoint, dualstackEndpoint = _b === void 0 ? false : _b, _c = options.accelerateEndpoint, accelerateEndpoint = _c === void 0 ? false : _c, _d = options.tlsCompatible, tlsCompatible = _d === void 0 ? true : _d, useArnRegion = options.useArnRegion, bucketName = options.bucketName, _e = options.clientPartition, clientPartition = _e === void 0 ? "aws" : _e, _f = options.clientSigningRegion, clientSigningRegion = _f === void 0 ? clientRegion : _f;
    (0, $196dc502db2a6516$export$9d570635889bea10)({
        pathStyleEndpoint: pathStyleEndpoint,
        accelerateEndpoint: accelerateEndpoint,
        tlsCompatible: tlsCompatible
    });
    // Validate and parse the ARN supplied as a bucket name
    var service = bucketName.service, partition = bucketName.partition, accountId = bucketName.accountId, region = bucketName.region, resource = bucketName.resource;
    (0, $196dc502db2a6516$export$56395344d8f6da92)(service);
    (0, $196dc502db2a6516$export$2514cb957fb286b)(partition, {
        clientPartition: clientPartition
    });
    (0, $196dc502db2a6516$export$311f0c1e79834f5a)(accountId);
    (0, $196dc502db2a6516$export$6cc2fb0ca7159d47)(region, {
        useArnRegion: useArnRegion,
        clientRegion: clientRegion,
        clientSigningRegion: clientSigningRegion
    });
    var _g = (0, $196dc502db2a6516$export$6b274ce9ea6c3c3a)(resource), accesspointName = _g.accesspointName, outpostId = _g.outpostId;
    (0, $196dc502db2a6516$export$eab3c0a6ee9b0457)(accesspointName + "-" + accountId, {
        tlsCompatible: tlsCompatible
    });
    var endpointRegion = useArnRegion ? region : clientRegion;
    var signingRegion = useArnRegion ? region : clientSigningRegion;
    if (outpostId) {
        // if this is an Outpost ARN
        (0, $196dc502db2a6516$export$32ff3a9330dbd031)(service);
        (0, $196dc502db2a6516$export$eab3c0a6ee9b0457)(outpostId, {
            tlsCompatible: tlsCompatible
        });
        (0, $196dc502db2a6516$export$76b09f028141bdfc)(dualstackEndpoint);
        (0, $196dc502db2a6516$export$8b4c0cb10287799f)(endpointRegion);
        var hostnamePrefix_1 = accesspointName + "-" + accountId + "." + outpostId;
        return {
            bucketEndpoint: true,
            hostname: "" + hostnamePrefix_1 + (isCustomEndpoint ? "" : ".s3-outposts." + endpointRegion) + "." + hostnameSuffix,
            signingRegion: signingRegion,
            signingService: "s3-outposts"
        };
    }
    // construct endpoint from Accesspoint ARN
    (0, $196dc502db2a6516$export$ee796dc843960f7e)(service);
    var hostnamePrefix = accesspointName + "-" + accountId;
    return {
        bucketEndpoint: true,
        hostname: "" + hostnamePrefix + (isCustomEndpoint ? "" : ".s3-accesspoint" + (dualstackEndpoint ? ".dualstack" : "") + "." + endpointRegion) + "." + hostnameSuffix,
        signingRegion: signingRegion
    };
};
var $684ce4f43d621550$var$getEndpointFromBucketName = function(_a) {
    var _b = _a.accelerateEndpoint, accelerateEndpoint = _b === void 0 ? false : _b, region = _a.clientRegion, baseHostname = _a.baseHostname, bucketName = _a.bucketName, _c = _a.dualstackEndpoint, dualstackEndpoint = _c === void 0 ? false : _c, _d = _a.pathStyleEndpoint, pathStyleEndpoint = _d === void 0 ? false : _d, _e = _a.tlsCompatible, tlsCompatible = _e === void 0 ? true : _e, _f = _a.isCustomEndpoint, isCustomEndpoint = _f === void 0 ? false : _f;
    var _g = (0, $cb9973b5442bbf64$export$8d051b38c9118094)(isCustomEndpoint ? [
        region,
        baseHostname
    ] : (0, $196dc502db2a6516$export$661d620f7edbf69d)(baseHostname), 2), clientRegion = _g[0], hostnameSuffix = _g[1];
    if (pathStyleEndpoint || !(0, $196dc502db2a6516$export$360a1e07839d0d27)(bucketName) || tlsCompatible && (0, $196dc502db2a6516$export$b0b24e5455be29b0).test(bucketName)) return {
        bucketEndpoint: false,
        hostname: dualstackEndpoint ? "s3.dualstack." + clientRegion + "." + hostnameSuffix : baseHostname
    };
    if (accelerateEndpoint) baseHostname = "s3-accelerate" + (dualstackEndpoint ? ".dualstack" : "") + "." + hostnameSuffix;
    else if (dualstackEndpoint) baseHostname = "s3.dualstack." + clientRegion + "." + hostnameSuffix;
    return {
        bucketEndpoint: true,
        hostname: bucketName + "." + baseHostname
    };
};



var $8e8aaee3d42fae4c$export$f49f3b47ec112939 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $cb9973b5442bbf64$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var bucketName, replaceBucketInPath, request, bucketArn, clientRegion, _a, _b, partition, _c, signingRegion, useArnRegion, _d, hostname, bucketEndpoint, modifiedSigningRegion, signingService, clientRegion, _e, _f, hostname, bucketEndpoint;
                return (0, $cb9973b5442bbf64$export$67ebef60e6f28a6)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            bucketName = args.input.Bucket;
                            replaceBucketInPath = options.bucketEndpoint;
                            request = args.request;
                            if (!(0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request)) return [
                                3 /*break*/ ,
                                8
                            ];
                            if (!options.bucketEndpoint) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = bucketName;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 1:
                            if (!(0, $5edcde9d7842c535$export$a22775fa5e2eebd9)(bucketName)) return [
                                3 /*break*/ ,
                                5
                            ];
                            bucketArn = (0, $5edcde9d7842c535$export$98e6a39c04603d36)(bucketName);
                            _a = (0, $196dc502db2a6516$export$2041e7d2db741fc6);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 2:
                            clientRegion = _a.apply(void 0, [
                                _g.sent()
                            ]);
                            return [
                                4 /*yield*/ ,
                                options.regionInfoProvider(clientRegion)
                            ];
                        case 3:
                            _b = _g.sent() || {}, partition = _b.partition, _c = _b.signingRegion, signingRegion = _c === void 0 ? clientRegion : _c;
                            return [
                                4 /*yield*/ ,
                                options.useArnRegion()
                            ];
                        case 4:
                            useArnRegion = _g.sent();
                            _d = (0, $684ce4f43d621550$export$92dc36ff3a4794f7)({
                                bucketName: bucketArn,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                useArnRegion: useArnRegion,
                                clientPartition: partition,
                                clientSigningRegion: signingRegion,
                                clientRegion: clientRegion,
                                isCustomEndpoint: options.isCustomEndpoint
                            }), hostname = _d.hostname, bucketEndpoint = _d.bucketEndpoint, modifiedSigningRegion = _d.signingRegion, signingService = _d.signingService;
                            // If the request needs to use a region or service name inferred from ARN that different from client region, we
                            // need to set them in the handler context so the signer will use them
                            if (modifiedSigningRegion && modifiedSigningRegion !== signingRegion) context["signing_region"] = modifiedSigningRegion;
                            if (signingService && signingService !== "s3") context["signing_service"] = signingService;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 5:
                            _e = (0, $196dc502db2a6516$export$2041e7d2db741fc6);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 6:
                            clientRegion = _e.apply(void 0, [
                                _g.sent()
                            ]);
                            _f = (0, $684ce4f43d621550$export$92dc36ff3a4794f7)({
                                bucketName: bucketName,
                                clientRegion: clientRegion,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                isCustomEndpoint: options.isCustomEndpoint
                            }), hostname = _f.hostname, bucketEndpoint = _f.bucketEndpoint;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            _g.label = 7;
                        case 7:
                            if (replaceBucketInPath) {
                                request.path = request.path.replace(/^(\/)?[^\/]+/, "");
                                if (request.path === "") request.path = "/";
                            }
                            _g.label = 8;
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $cb9973b5442bbf64$export$18ce0697a983be9b)((0, $cb9973b5442bbf64$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var $8e8aaee3d42fae4c$export$3912e6e4bed18209 = {
    tags: [
        "BUCKET_ENDPOINT"
    ],
    name: "bucketEndpointMiddleware",
    relation: "before",
    toMiddleware: "hostHeaderMiddleware",
    override: true
};
var $8e8aaee3d42fae4c$export$6b750e866330f2fe = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($8e8aaee3d42fae4c$export$f49f3b47ec112939(options), $8e8aaee3d42fae4c$export$3912e6e4bed18209);
        }
    };
};




function $576b485ca7f1e057$export$9810f1a949e3136(input) {
    var _a = input.bucketEndpoint, bucketEndpoint = _a === void 0 ? false : _a, _b = input.forcePathStyle, forcePathStyle = _b === void 0 ? false : _b, _c = input.useAccelerateEndpoint, useAccelerateEndpoint = _c === void 0 ? false : _c, _d = input.useDualstackEndpoint, useDualstackEndpoint = _d === void 0 ? false : _d, _e = input.useArnRegion, useArnRegion = _e === void 0 ? false : _e;
    return (0, $cb9973b5442bbf64$export$18ce0697a983be9b)((0, $cb9973b5442bbf64$export$18ce0697a983be9b)({}, input), {
        bucketEndpoint: bucketEndpoint,
        forcePathStyle: forcePathStyle,
        useAccelerateEndpoint: useAccelerateEndpoint,
        useDualstackEndpoint: useDualstackEndpoint,
        useArnRegion: typeof useArnRegion === "function" ? useArnRegion : function() {
            return Promise.resolve(useArnRegion);
        }
    });
}
var $576b485ca7f1e057$export$7eb281bbdddd5d12 = "AWS_S3_USE_ARN_REGION";
var $576b485ca7f1e057$export$812c693bf225d32a = "s3_use_arn_region";
var $576b485ca7f1e057$export$bac037ab69dc2bd4 = {
    environmentVariableSelector: function(env) {
        if (!Object.prototype.hasOwnProperty.call(env, $576b485ca7f1e057$export$7eb281bbdddd5d12)) return undefined;
        if (env[$576b485ca7f1e057$export$7eb281bbdddd5d12] === "true") return true;
        if (env[$576b485ca7f1e057$export$7eb281bbdddd5d12] === "false") return false;
        throw new Error("Cannot load env " + $576b485ca7f1e057$export$7eb281bbdddd5d12 + '. Expected "true" or "false", got ' + env[$576b485ca7f1e057$export$7eb281bbdddd5d12] + ".");
    },
    configFileSelector: function(profile) {
        if (!Object.prototype.hasOwnProperty.call(profile, $576b485ca7f1e057$export$812c693bf225d32a)) return undefined;
        if (profile[$576b485ca7f1e057$export$812c693bf225d32a] === "true") return true;
        if (profile[$576b485ca7f1e057$export$812c693bf225d32a] === "false") return false;
        throw new Error("Cannot load shared config entry " + $576b485ca7f1e057$export$812c693bf225d32a + '. Expected "true" or "false", got ' + profile[$576b485ca7f1e057$export$812c693bf225d32a] + ".");
    },
    default: false
};





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $52d707e19a8e2fb0$var$extendStatics = function(d, b) {
    $52d707e19a8e2fb0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $52d707e19a8e2fb0$var$extendStatics(d, b);
};
function $52d707e19a8e2fb0$export$a8ba968b8961cb8a(d, b) {
    $52d707e19a8e2fb0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $52d707e19a8e2fb0$export$18ce0697a983be9b = function() {
    $52d707e19a8e2fb0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52d707e19a8e2fb0$export$18ce0697a983be9b.apply(this, arguments);
};
function $52d707e19a8e2fb0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $52d707e19a8e2fb0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $52d707e19a8e2fb0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $52d707e19a8e2fb0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $52d707e19a8e2fb0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $52d707e19a8e2fb0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $52d707e19a8e2fb0$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $52d707e19a8e2fb0$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $52d707e19a8e2fb0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $52d707e19a8e2fb0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $52d707e19a8e2fb0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($52d707e19a8e2fb0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $52d707e19a8e2fb0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $52d707e19a8e2fb0$export$10c90e4f7922046c(v) {
    return this instanceof $52d707e19a8e2fb0$export$10c90e4f7922046c ? (this.v = v, this) : new $52d707e19a8e2fb0$export$10c90e4f7922046c(v);
}
function $52d707e19a8e2fb0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $52d707e19a8e2fb0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $52d707e19a8e2fb0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $52d707e19a8e2fb0$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $52d707e19a8e2fb0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $52d707e19a8e2fb0$export$19a8beecd37a4c45 === "function" ? $52d707e19a8e2fb0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $52d707e19a8e2fb0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $52d707e19a8e2fb0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $52d707e19a8e2fb0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $52d707e19a8e2fb0$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $52d707e19a8e2fb0$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $dfab7746d8755a65$export$97e70cdcaaace32a() {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $52d707e19a8e2fb0$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var Bucket, err;
                return (0, $52d707e19a8e2fb0$export$67ebef60e6f28a6)(this, function(_a) {
                    Bucket = args.input.Bucket;
                    if (typeof Bucket === "string" && !(0, $5edcde9d7842c535$export$a22775fa5e2eebd9)(Bucket) && Bucket.indexOf("/") >= 0) {
                        err = new Error("Bucket name shouldn't contain '/', received '" + Bucket + "'");
                        err.name = "InvalidBucketName";
                        throw err;
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $52d707e19a8e2fb0$export$18ce0697a983be9b)({}, args))
                    ];
                });
            });
        };
    };
}
var $dfab7746d8755a65$export$db8005617bec77bd = {
    step: "initialize",
    tags: [
        "VALIDATE_BUCKET_NAME"
    ],
    name: "validateBucketNameMiddleware",
    override: true
};
var $dfab7746d8755a65$export$c30d61978fbb3ad8 = function(unused) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($dfab7746d8755a65$export$97e70cdcaaace32a(), $dfab7746d8755a65$export$db8005617bec77bd);
        }
    };
};




var $32eebb3bc4f2581c$export$47830883dba0cb3a = function(config) {
    return function(next) {
        return function(args) {
            return (0, $52d707e19a8e2fb0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, _a;
                return (0, $52d707e19a8e2fb0$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            request = args.request;
                            if (!(0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request) || config.isCustomEndpoint) return [
                                2 /*return*/ ,
                                next((0, $52d707e19a8e2fb0$export$18ce0697a983be9b)({}, args))
                            ];
                            if (!(request.hostname === "s3.amazonaws.com")) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = "s3.us-east-1.amazonaws.com";
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 1:
                            _a = "aws-global";
                            return [
                                4 /*yield*/ ,
                                config.region()
                            ];
                        case 2:
                            if (_a === _b.sent()) request.hostname = "s3.amazonaws.com";
                            _b.label = 3;
                        case 3:
                            return [
                                2 /*return*/ ,
                                next((0, $52d707e19a8e2fb0$export$18ce0697a983be9b)({}, args))
                            ];
                    }
                });
            });
        };
    };
};
var $32eebb3bc4f2581c$export$984fdb6c4de63240 = {
    step: "build",
    tags: [
        "USE_REGIONAL_ENDPOINT",
        "S3"
    ],
    name: "useRegionalEndpointMiddleware",
    override: true
};
var $32eebb3bc4f2581c$export$8512187c26b3935b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($32eebb3bc4f2581c$export$47830883dba0cb3a(config), $32eebb3bc4f2581c$export$984fdb6c4de63240);
        }
    };
};




var $2f72a11a979d95c5$export$61d7988259be6660 = function(config) {
    return function(next) {
        return function(args) {
            return (0, $52d707e19a8e2fb0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var result, response, statusCode, body, bodyBytes, bodyString, err;
                return (0, $52d707e19a8e2fb0$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            result = _a.sent();
                            response = result.response;
                            if (!(0, $8e579238f5eb4a6f$export$1d94dfe0d9d1f1e7).isInstance(response)) return [
                                2 /*return*/ ,
                                result
                            ];
                            statusCode = response.statusCode, body = response.body;
                            if (statusCode < 200 && statusCode >= 300) return [
                                2 /*return*/ ,
                                result
                            ];
                            return [
                                4 /*yield*/ ,
                                $2f72a11a979d95c5$var$collectBody(body, config)
                            ];
                        case 2:
                            bodyBytes = _a.sent();
                            return [
                                4 /*yield*/ ,
                                $2f72a11a979d95c5$var$collectBodyString(bodyBytes, config)
                            ];
                        case 3:
                            bodyString = _a.sent();
                            if (bodyBytes.length === 0) {
                                err = new Error("S3 aborted request");
                                err.name = "InternalError";
                                throw err;
                            }
                            if (bodyString && bodyString.match("<Error>")) // Set the error code to 4XX so that error deserializer can parse them
                            response.statusCode = 400;
                            // Body stream is consumed and paused at this point. So replace the response.body to the collected bytes.
                            // So that the deserializer can consume the body as normal.
                            response.body = bodyBytes;
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        };
    };
};
// Collect low-level response body stream to Uint8Array.
var $2f72a11a979d95c5$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $2f72a11a979d95c5$var$collectBodyString = function(streamBody, context) {
    return $2f72a11a979d95c5$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $2f72a11a979d95c5$export$ea0247469da1888 = {
    relation: "after",
    toMiddleware: "deserializerMiddleware",
    tags: [
        "THROW_200_EXCEPTIONS",
        "S3"
    ],
    name: "throw200ExceptionsMiddleware",
    override: true
};
var $2f72a11a979d95c5$export$97cbbd0d754f3189 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($2f72a11a979d95c5$export$61d7988259be6660(config), $2f72a11a979d95c5$export$ea0247469da1888);
        }
    };
};





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5ab4de02ae67b6fd$var$extendStatics = function(d, b) {
    $5ab4de02ae67b6fd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5ab4de02ae67b6fd$var$extendStatics(d, b);
};
function $5ab4de02ae67b6fd$export$a8ba968b8961cb8a(d, b) {
    $5ab4de02ae67b6fd$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5ab4de02ae67b6fd$export$18ce0697a983be9b = function() {
    $5ab4de02ae67b6fd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5ab4de02ae67b6fd$export$18ce0697a983be9b.apply(this, arguments);
};
function $5ab4de02ae67b6fd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5ab4de02ae67b6fd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5ab4de02ae67b6fd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5ab4de02ae67b6fd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5ab4de02ae67b6fd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5ab4de02ae67b6fd$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5ab4de02ae67b6fd$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5ab4de02ae67b6fd$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5ab4de02ae67b6fd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5ab4de02ae67b6fd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5ab4de02ae67b6fd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5ab4de02ae67b6fd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5ab4de02ae67b6fd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5ab4de02ae67b6fd$export$10c90e4f7922046c(v) {
    return this instanceof $5ab4de02ae67b6fd$export$10c90e4f7922046c ? (this.v = v, this) : new $5ab4de02ae67b6fd$export$10c90e4f7922046c(v);
}
function $5ab4de02ae67b6fd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5ab4de02ae67b6fd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5ab4de02ae67b6fd$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5ab4de02ae67b6fd$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5ab4de02ae67b6fd$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5ab4de02ae67b6fd$export$19a8beecd37a4c45 === "function" ? $5ab4de02ae67b6fd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5ab4de02ae67b6fd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5ab4de02ae67b6fd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5ab4de02ae67b6fd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5ab4de02ae67b6fd$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5ab4de02ae67b6fd$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $9a68e4ce915c38f9$export$16515ae394ee1bc8(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $5ab4de02ae67b6fd$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var input, properties, properties_1, properties_1_1, prop, value, valueView, encoded, hash, _a, _b, _c, _d, e_1_1;
                var e_1, _e, _f;
                return (0, $5ab4de02ae67b6fd$export$67ebef60e6f28a6)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            input = (0, $5ab4de02ae67b6fd$export$18ce0697a983be9b)({}, args.input);
                            properties = [
                                {
                                    target: "SSECustomerKey",
                                    hash: "SSECustomerKeyMD5"
                                },
                                {
                                    target: "CopySourceSSECustomerKey",
                                    hash: "CopySourceSSECustomerKeyMD5"
                                }
                            ];
                            _g.label = 1;
                        case 1:
                            _g.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            properties_1 = (0, $5ab4de02ae67b6fd$export$19a8beecd37a4c45)(properties), properties_1_1 = properties_1.next();
                            _g.label = 2;
                        case 2:
                            if (!!properties_1_1.done) return [
                                3 /*break*/ ,
                                5
                            ];
                            prop = properties_1_1.value;
                            value = input[prop.target];
                            if (!value) return [
                                3 /*break*/ ,
                                4
                            ];
                            valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options.utf8Decoder(value) : new Uint8Array(value);
                            encoded = options.base64Encoder(valueView);
                            hash = new options.md5();
                            hash.update(valueView);
                            _a = [
                                (0, $5ab4de02ae67b6fd$export$18ce0697a983be9b)({}, input)
                            ];
                            _f = {}, _f[prop.target] = encoded;
                            _b = prop.hash;
                            _d = (_c = options).base64Encoder;
                            return [
                                4 /*yield*/ ,
                                hash.digest()
                            ];
                        case 3:
                            input = (0, $5ab4de02ae67b6fd$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                (_f[_b] = _d.apply(_c, [
                                    _g.sent()
                                ]), _f)
                            ]));
                            _g.label = 4;
                        case 4:
                            properties_1_1 = properties_1.next();
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 6:
                            e_1_1 = _g.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            try {
                                if (properties_1_1 && !properties_1_1.done && (_e = properties_1.return)) _e.call(properties_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $5ab4de02ae67b6fd$export$18ce0697a983be9b)((0, $5ab4de02ae67b6fd$export$18ce0697a983be9b)({}, args), {
                                    input: input
                                }))
                            ];
                    }
                });
            });
        };
    };
}
var $9a68e4ce915c38f9$export$bd3ed071b8ca05b3 = {
    name: "ssecMiddleware",
    step: "initialize",
    tags: [
        "SSE"
    ],
    override: true
};
var $9a68e4ce915c38f9$export$baf25e0187b0946b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($9a68e4ce915c38f9$export$16515ae394ee1bc8(config), $9a68e4ce915c38f9$export$bd3ed071b8ca05b3);
        }
    };
};



/**
 * <p>Creates a copy of an object that is already stored in Amazon S3.</p>
 *          <note>
 *             <p>You can store individual objects of up to 5 TB in Amazon S3. You create a copy of your
 *             object up to 5 GB in size in a single atomic operation using this API. However, to copy
 *             an object greater than 5 GB, you must use the multipart upload Upload Part - Copy API.
 *             For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/CopyingObjctsUsingRESTMPUapi.html">Copy Object Using the REST Multipart Upload API</a>.</p>
 *          </note>
 *          <p>All copy requests must be authenticated. Additionally, you must have
 *             <i>read</i> access to the source object and <i>write</i>
 *          access to the destination bucket. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/RESTAuthentication.html">REST Authentication</a>. Both the Region
 *          that you want to copy the object from and the Region that you want to copy the object to
 *          must be enabled for your account.</p>
 *          <p>A copy request might return an error when Amazon S3 receives the copy request or while Amazon S3
 *          is copying the files. If the error occurs before the copy operation starts, you receive a
 *          standard Amazon S3 error. If the error occurs during the copy operation, the error response is
 *          embedded in the <code>200 OK</code> response. This means that a <code>200 OK</code>
 *          response can contain either a success or an error. Design your application to parse the
 *          contents of the response and handle it appropriately.</p>
 *          <p>If the copy is successful, you receive a response with information about the copied
 *          object.</p>
 *          <note>
 *             <p>If the request is an HTTP 1.1 request, the response is chunk encoded. If it were not,
 *             it would not contain the content-length, and you would need to read the entire
 *             body.</p>
 *          </note>
 *          <p>The copy request charge is based on the storage class and Region that you specify for
 *          the destination object. For pricing information, see <a href="https://aws.amazon.com/s3/pricing/">Amazon S3 pricing</a>.</p>
 *          <important>
 *             <p>Amazon S3 transfer acceleration does not support cross-Region copies. If you request a
 *             cross-Region copy using a transfer acceleration endpoint, you get a 400 <code>Bad
 *                Request</code> error. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/transfer-acceleration.html">Transfer Acceleration</a>.</p>
 *          </important>
 *          <p>
 *             <b>Metadata</b>
 *          </p>
 *          <p>When copying an object, you can preserve all metadata (default) or specify new metadata.
 *          However, the ACL is not preserved and is set to private for the user making the request. To
 *          override the default ACL setting, specify a new ACL when generating a copy request. For
 *          more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3_ACLs_UsingACLs.html">Using ACLs</a>. </p>
 *          <p>To specify whether you want the object metadata copied from the source object or
 *          replaced with metadata provided in the request, you can optionally add the
 *             <code>x-amz-metadata-directive</code> header. When you grant permissions, you can use
 *          the <code>s3:x-amz-metadata-directive</code> condition key to enforce certain metadata
 *          behavior when objects are uploaded. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/amazon-s3-policy-keys.html">Specifying Conditions in a
 *             Policy</a> in the <i>Amazon S3 Developer Guide</i>. For a complete list of
 *          Amazon S3-specific condition keys, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/list_amazons3.html">Actions, Resources, and Condition Keys for
 *             Amazon S3</a>.</p>
 *          <p>
 *             <b>
 *                <code>x-amz-copy-source-if</code> Headers</b>
 *          </p>
 *          <p>To only copy an object under certain conditions, such as whether the <code>Etag</code>
 *          matches or whether the object was modified before or after a specified date, use the
 *          following request parameters:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-match</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-none-match</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-unmodified-since</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-modified-since</code>
 *                </p>
 *             </li>
 *          </ul>
 *          <p> If both the <code>x-amz-copy-source-if-match</code> and
 *             <code>x-amz-copy-source-if-unmodified-since</code> headers are present in the request
 *          and evaluate as follows, Amazon S3 returns <code>200 OK</code> and copies the data:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-match</code> condition evaluates to true</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-unmodified-since</code> condition evaluates to
 *                false</p>
 *             </li>
 *          </ul>
 *
 *          <p>If both the <code>x-amz-copy-source-if-none-match</code> and
 *             <code>x-amz-copy-source-if-modified-since</code> headers are present in the request and
 *          evaluate as follows, Amazon S3 returns the <code>412 Precondition Failed</code> response
 *          code:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-none-match</code> condition evaluates to false</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-modified-since</code> condition evaluates to
 *                true</p>
 *             </li>
 *          </ul>
 *
 *          <note>
 *             <p>All headers with the <code>x-amz-</code> prefix, including
 *                <code>x-amz-copy-source</code>, must be signed.</p>
 *          </note>
 *          <p>
 *             <b>Server-side encryption</b>
 *          </p>
 *          <p>When you perform a CopyObject operation, you can optionally use the appropriate encryption-related headers to encrypt the object using server-side encryption with AWS managed encryption keys (SSE-S3 or SSE-KMS) or a customer-provided encryption key. With server-side encryption, Amazon S3 encrypts your data as it writes it to disks in its data centers and decrypts the data when you access it. For more information about server-side encryption, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/serv-side-encryption.html">Using
 *          Server-Side Encryption</a>.</p>
 *          <p>If a target object uses SSE-KMS, you can enable an S3 Bucket Key for the object. For more
 *          information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/bucket-key.html">Amazon S3 Bucket Keys</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *          <p>
 *             <b>Access Control List (ACL)-Specific Request
 *          Headers</b>
 *          </p>
 *          <p>When copying an object, you can optionally use headers to grant ACL-based permissions.
 *          By default, all objects are private. Only the owner has full access control. When adding a
 *          new object, you can grant permissions to individual AWS accounts or to predefined groups
 *          defined by Amazon S3. These permissions are then added to the ACL on the object. For more
 *          information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List (ACL) Overview</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-using-rest-api.html">Managing ACLs Using the REST
 *             API</a>. </p>
 *
 *          <p>
 *             <b>Storage Class Options</b>
 *          </p>
 *          <p>You can use the <code>CopyObject</code> operation to change the storage class of an
 *          object that is already stored in Amazon S3 using the <code>StorageClass</code> parameter. For
 *          more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/storage-class-intro.html">Storage
 *             Classes</a> in the <i>Amazon S3 Service Developer Guide</i>.</p>
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>By default, <code>x-amz-copy-source</code> identifies the current version of an object
 *          to copy. If the current version is a delete marker, Amazon S3 behaves as if the object was
 *          deleted. To copy a different version, use the <code>versionId</code> subresource.</p>
 *          <p>If you enable versioning on the target bucket, Amazon S3 generates a unique version ID for
 *          the object being copied. This version ID is different from the version ID of the source
 *          object. Amazon S3 returns the version ID of the copied object in the
 *             <code>x-amz-version-id</code> response header in the response.</p>
 *          <p>If you do not enable versioning or suspend it on the target bucket, the version ID that
 *          Amazon S3 generates is always null.</p>
 *          <p>If the source object's storage class is GLACIER, you must restore a copy of this object
 *          before you can use it as a source object for the copy operation. For more information, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_RestoreObject.html">RestoreObject</a>.</p>
 *          <p>The following operations are related to <code>CopyObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObject.html">GetObject</a>
 *                </p>
 *             </li>
 *          </ul>
 *          <p>For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/CopyingObjectsExamples.html">Copying
 *             Objects</a>.</p>
 */ var $39a4f50a4faa6416$export$dae1e139b4ba0d49 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CopyObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CopyObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CopyObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $2f72a11a979d95c5$export$97cbbd0d754f3189)(configuration));
        this.middlewareStack.use((0, $9a68e4ce915c38f9$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CopyObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$e84f0e76c8b259eb).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$a9f99871811ebc49).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CopyObjectCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$3fa883360ffbe82d)(input, context);
    };
    CopyObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$a5d77c8b6651b993)(output, context);
    };
    return CopyObjectCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));








/**
 * <p>Retrieves objects from Amazon S3. To use <code>GET</code>, you must have <code>READ</code>
 *          access to the object. If you grant <code>READ</code> access to the anonymous user, you can
 *          return the object without using an authorization header.</p>
 *
 *          <p>An Amazon S3 bucket has no directory hierarchy such as you would find in a typical computer
 *          file system. You can, however, create a logical hierarchy by using object key names that
 *          imply a folder structure. For example, instead of naming an object <code>sample.jpg</code>,
 *          you can name it <code>photos/2006/February/sample.jpg</code>.</p>
 *
 *          <p>To get an object from such a logical hierarchy, specify the full key name for the object
 *          in the <code>GET</code> operation. For a virtual hosted-style request example, if you have
 *          the object <code>photos/2006/February/sample.jpg</code>, specify the resource as
 *             <code>/photos/2006/February/sample.jpg</code>. For a path-style request example, if you
 *          have the object <code>photos/2006/February/sample.jpg</code> in the bucket named
 *             <code>examplebucket</code>, specify the resource as
 *             <code>/examplebucket/photos/2006/February/sample.jpg</code>. For more information about
 *          request types, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/VirtualHosting.html#VirtualHostingSpecifyBucket">HTTP Host Header Bucket Specification</a>.</p>
 *
 *          <p>To distribute large files to many people, you can save bandwidth costs by using
 *          BitTorrent. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3Torrent.html">Amazon S3
 *             Torrent</a>. For more information about returning the ACL of an object, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectAcl.html">GetObjectAcl</a>.</p>
 *
 *          <p>If the object you are retrieving is stored in the S3 Glacier or
 *          S3 Glacier Deep Archive storage class, or S3 Intelligent-Tiering Archive or
 *          S3 Intelligent-Tiering Deep Archive tiers, before you can retrieve the object you must first restore a
 *          copy using <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_RestoreObject.html">RestoreObject</a>. Otherwise, this operation returns an
 *             <code>InvalidObjectStateError</code> error. For information about restoring archived
 *          objects, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/restoring-objects.html">Restoring Archived
 *             Objects</a>.</p>
 *
 *          <p>Encryption request headers, like <code>x-amz-server-side-encryption</code>, should not
 *          be sent for GET requests if your object uses server-side encryption with CMKs stored in AWS
 *          KMS (SSE-KMS) or server-side encryption with Amazon S3–managed encryption keys (SSE-S3). If your
 *          object does use these types of keys, you’ll get an HTTP 400 BadRequest error.</p>
 *          <p>If you encrypt an object by using server-side encryption with customer-provided
 *          encryption keys (SSE-C) when you store the object in Amazon S3, then when you GET the object,
 *          you must use the following headers:</p>
 *          <ul>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-algorithm</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *             </li>
 *          </ul>
 *          <p>For more information about SSE-C, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/ServerSideEncryptionCustomerKeys.html">Server-Side Encryption (Using
 *             Customer-Provided Encryption Keys)</a>.</p>
 *
 *          <p>Assuming you have permission to read object tags (permission for the
 *             <code>s3:GetObjectVersionTagging</code> action), the response also returns the
 *             <code>x-amz-tagging-count</code> header that provides the count of number of tags
 *          associated with the object. You can use <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectTagging.html">GetObjectTagging</a> to retrieve
 *          the tag set associated with an object.</p>
 *
 *          <p>
 *             <b>Permissions</b>
 *          </p>
 *          <p>You need the <code>s3:GetObject</code> permission for this operation. For more
 *          information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/using-with-s3-actions.html">Specifying Permissions
 *             in a Policy</a>. If the object you request does not exist, the error Amazon S3 returns
 *          depends on whether you also have the <code>s3:ListBucket</code> permission.</p>
 *          <ul>
 *             <li>
 *                <p>If you have the <code>s3:ListBucket</code> permission on the bucket, Amazon S3 will
 *                return an HTTP status code 404 ("no such key") error.</p>
 *             </li>
 *             <li>
 *                <p>If you don’t have the <code>s3:ListBucket</code> permission, Amazon S3 will return an
 *                HTTP status code 403 ("access denied") error.</p>
 *             </li>
 *          </ul>
 *
 *
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>By default, the GET operation returns the current version of an object. To return a
 *          different version, use the <code>versionId</code> subresource.</p>
 *
 *          <note>
 *             <p>If the current version of the object is a delete marker, Amazon S3 behaves as if the
 *             object was deleted and includes <code>x-amz-delete-marker: true</code> in the
 *             response.</p>
 *          </note>
 *
 *
 *          <p>For more information about versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutBucketVersioning.html">PutBucketVersioning</a>. </p>
 *
 *          <p>
 *             <b>Overriding Response Header Values</b>
 *          </p>
 *          <p>There are times when you want to override certain response header values in a GET
 *          response. For example, you might override the Content-Disposition response header value in
 *          your GET request.</p>
 *
 *          <p>You can override values for a set of response headers using the following query
 *          parameters. These response header values are sent only on a successful request, that is,
 *          when status code 200 OK is returned. The set of headers you can override using these
 *          parameters is a subset of the headers that Amazon S3 accepts when you create an object. The
 *          response headers that you can override for the GET response are <code>Content-Type</code>,
 *             <code>Content-Language</code>, <code>Expires</code>, <code>Cache-Control</code>,
 *             <code>Content-Disposition</code>, and <code>Content-Encoding</code>. To override these
 *          header values in the GET response, you use the following request parameters.</p>
 *
 *          <note>
 *             <p>You must sign the request, either using an Authorization header or a presigned URL,
 *             when using these parameters. They cannot be used with an unsigned (anonymous)
 *             request.</p>
 *          </note>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>response-content-type</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-language</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-expires</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-cache-control</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-disposition</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-encoding</code>
 *                </p>
 *             </li>
 *          </ul>
 *
 *          <p>
 *             <b>Additional Considerations about Request Headers</b>
 *          </p>
 *
 *          <p>If both of the <code>If-Match</code> and <code>If-Unmodified-Since</code> headers are
 *          present in the request as follows: <code>If-Match</code> condition evaluates to
 *             <code>true</code>, and; <code>If-Unmodified-Since</code> condition evaluates to
 *             <code>false</code>; then, S3 returns 200 OK and the data requested. </p>
 *
 *          <p>If both of the <code>If-None-Match</code> and <code>If-Modified-Since</code> headers are
 *          present in the request as follows:<code> If-None-Match</code> condition evaluates to
 *             <code>false</code>, and; <code>If-Modified-Since</code> condition evaluates to
 *             <code>true</code>; then, S3 returns 304 Not Modified response code.</p>
 *
 *          <p>For more information about conditional requests, see <a href="https://tools.ietf.org/html/rfc7232">RFC 7232</a>.</p>
 *
 *          <p>The following operations are related to <code>GetObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListBuckets.html">ListBuckets</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectAcl.html">GetObjectAcl</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $0cf21e6f5da31179$export$25364b3fa12a4666 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GetObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $9a68e4ce915c38f9$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "GetObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$3373ea9743883feb).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$9fb6bec1a5c954d6).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetObjectCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$713ae52666bf2204)(input, context);
    };
    GetObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$c8faba1b7abd4024)(output, context);
    };
    return GetObjectCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));







/**
 * <p>Removes the null version (if there is one) of an object and inserts a delete marker,
 *          which becomes the latest version of the object. If there isn't a null version, Amazon S3 does
 *          not remove any objects.</p>
 *
 *          <p>To remove a specific version, you must be the bucket owner and you must use the version
 *          Id subresource. Using this subresource permanently deletes the version. If the object
 *          deleted is a delete marker, Amazon S3 sets the response header,
 *          <code>x-amz-delete-marker</code>, to true. </p>
 *
 *          <p>If the object you want to delete is in a bucket where the bucket versioning
 *          configuration is MFA Delete enabled, you must include the <code>x-amz-mfa</code> request
 *          header in the DELETE <code>versionId</code> request. Requests that include
 *             <code>x-amz-mfa</code> must use HTTPS. </p>
 *
 *          <p> For more information about MFA Delete, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMFADelete.html">Using MFA Delete</a>. To see sample requests that use versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/RESTObjectDELETE.html#ExampleVersionObjectDelete">Sample Request</a>. </p>
 *
 *          <p>You can delete objects by explicitly calling the DELETE Object API or configure its
 *          lifecycle (<a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutBucketLifecycle.html">PutBucketLifecycle</a>) to
 *          enable Amazon S3 to remove them for you. If you want to block users or accounts from removing or
 *          deleting objects from your bucket, you must deny them the <code>s3:DeleteObject</code>,
 *             <code>s3:DeleteObjectVersion</code>, and <code>s3:PutLifeCycleConfiguration</code>
 *          actions. </p>
 *
 *          <p>The following operation is related to <code>DeleteObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $e1051b371fda55f0$export$d60592d05571c4ef = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DeleteObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DeleteObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "DeleteObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$7d123f24a24f15cf).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$64d4f4fac943bc25).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteObjectCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$400c19cbac9616f7)(input, context);
    };
    DeleteObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$987b292ae9f16665)(output, context);
    };
    return DeleteObjectCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));







/**
 * <p>Returns some or all (up to 1,000) of the objects in a bucket. You can use the request
 *          parameters as selection criteria to return a subset of the objects in a bucket. A <code>200
 *             OK</code> response can contain valid or invalid XML. Make sure to design your
 *          application to parse the contents of the response and handle it appropriately.</p>
 *
 *          <p>To use this operation, you must have READ access to the bucket.</p>
 *
 *          <p>To use this operation in an AWS Identity and Access Management (IAM) policy, you must
 *          have permissions to perform the <code>s3:ListBucket</code> action. The bucket owner has
 *          this permission by default and can grant this permission to others. For more information
 *          about permissions, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/using-with-s3-actions.html#using-with-s3-actions-related-to-bucket-subresources">Permissions Related to Bucket Subresource Operations</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/s3-access-control.html">Managing Access Permissions to Your Amazon S3
 *             Resources</a>.</p>
 *          <important>
 *             <p>This section describes the latest revision of the API. We recommend that you use this
 *             revised API for application development. For backward compatibility, Amazon S3 continues to
 *             support the prior version of this API, <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListObjects.html">ListObjects</a>.</p>
 *          </important>
 *
 *          <p>To get a list of your buckets, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListBuckets.html">ListBuckets</a>.</p>
 *
 *          <p>The following operations are related to <code>ListObjectsV2</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObject.html">GetObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateBucket.html">CreateBucket</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $3859c4d3df57bfa7$export$479061a53a55f030 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ListObjectsV2Command, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListObjectsV2Command(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ ListObjectsV2Command.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListObjectsV2Command";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$32fa6adfa8e5165a).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$6fb2827b4fe28be3).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListObjectsV2Command.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$ea6ee77e40f86bd9)(input, context);
    };
    ListObjectsV2Command.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$2b371fcdd686ba8b)(output, context);
    };
    return ListObjectsV2Command;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));



function $eaea2d0b0b5b4fe5$export$75025487296cba38(request) {
    var port = request.port, query = request.query;
    var protocol = request.protocol, path = request.path, hostname = request.hostname;
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    if (port) hostname += ":" + port;
    if (path && path.charAt(0) !== "/") path = "/" + path;
    var queryString = query ? (0, $c40265ee6312ebb2$export$6b17a39e52c8ee53)(query) : "";
    if (queryString && queryString[0] !== "?") queryString = "?" + queryString;
    return protocol + "//" + hostname + path + queryString;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e6d6115024c79849$var$extendStatics = function(d, b) {
    $e6d6115024c79849$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e6d6115024c79849$var$extendStatics(d, b);
};
function $e6d6115024c79849$export$a8ba968b8961cb8a(d, b) {
    $e6d6115024c79849$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e6d6115024c79849$export$18ce0697a983be9b = function() {
    $e6d6115024c79849$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e6d6115024c79849$export$18ce0697a983be9b.apply(this, arguments);
};
function $e6d6115024c79849$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e6d6115024c79849$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e6d6115024c79849$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e6d6115024c79849$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e6d6115024c79849$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e6d6115024c79849$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e6d6115024c79849$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e6d6115024c79849$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e6d6115024c79849$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e6d6115024c79849$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e6d6115024c79849$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e6d6115024c79849$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e6d6115024c79849$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e6d6115024c79849$export$10c90e4f7922046c(v) {
    return this instanceof $e6d6115024c79849$export$10c90e4f7922046c ? (this.v = v, this) : new $e6d6115024c79849$export$10c90e4f7922046c(v);
}
function $e6d6115024c79849$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e6d6115024c79849$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e6d6115024c79849$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e6d6115024c79849$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e6d6115024c79849$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e6d6115024c79849$export$19a8beecd37a4c45 === "function" ? $e6d6115024c79849$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e6d6115024c79849$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e6d6115024c79849$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e6d6115024c79849$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e6d6115024c79849$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e6d6115024c79849$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $eea18618b585622f$export$72e3afa9ac8966be(client, command) {
    return (0, $e6d6115024c79849$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var interceptMiddleware, clientStack, handler;
        var _this = this;
        return (0, $e6d6115024c79849$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    interceptMiddleware = function(next) {
                        return function(args) {
                            return (0, $e6d6115024c79849$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                return (0, $e6d6115024c79849$export$67ebef60e6f28a6)(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            output: {
                                                request: args.request
                                            },
                                            response: undefined
                                        }
                                    ];
                                });
                            });
                        };
                    };
                    clientStack = client.middlewareStack.clone();
                    // @ts-ignore: add middleware to the last of 'build' step
                    clientStack.add(interceptMiddleware, {
                        step: "build",
                        priority: "low"
                    });
                    handler = command.resolveMiddleware(clientStack, client.config, undefined);
                    return [
                        4 /*yield*/ ,
                        handler(command).then(function(output) {
                            return output.output.request;
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $86f80d0bf2133041$var$extendStatics = function(d, b) {
    $86f80d0bf2133041$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $86f80d0bf2133041$var$extendStatics(d, b);
};
function $86f80d0bf2133041$export$a8ba968b8961cb8a(d, b) {
    $86f80d0bf2133041$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $86f80d0bf2133041$export$18ce0697a983be9b = function() {
    $86f80d0bf2133041$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86f80d0bf2133041$export$18ce0697a983be9b.apply(this, arguments);
};
function $86f80d0bf2133041$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $86f80d0bf2133041$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $86f80d0bf2133041$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $86f80d0bf2133041$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $86f80d0bf2133041$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $86f80d0bf2133041$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $86f80d0bf2133041$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $86f80d0bf2133041$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $86f80d0bf2133041$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $86f80d0bf2133041$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $86f80d0bf2133041$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($86f80d0bf2133041$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $86f80d0bf2133041$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $86f80d0bf2133041$export$10c90e4f7922046c(v) {
    return this instanceof $86f80d0bf2133041$export$10c90e4f7922046c ? (this.v = v, this) : new $86f80d0bf2133041$export$10c90e4f7922046c(v);
}
function $86f80d0bf2133041$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $86f80d0bf2133041$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $86f80d0bf2133041$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $86f80d0bf2133041$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $86f80d0bf2133041$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $86f80d0bf2133041$export$19a8beecd37a4c45 === "function" ? $86f80d0bf2133041$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $86f80d0bf2133041$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $86f80d0bf2133041$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $86f80d0bf2133041$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $86f80d0bf2133041$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $86f80d0bf2133041$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}




var $80b0323958b3e71c$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $80b0323958b3e71c$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $80b0323958b3e71c$export$6e114beec37430d7 = "X-Amz-Date";
var $80b0323958b3e71c$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $80b0323958b3e71c$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $80b0323958b3e71c$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $80b0323958b3e71c$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $80b0323958b3e71c$export$9924a64a4b8b0d58 = "authorization";
var $80b0323958b3e71c$export$acf4b8bdf24aab34 = $80b0323958b3e71c$export$6e114beec37430d7.toLowerCase();
var $80b0323958b3e71c$export$c65c8c9f514da472 = "date";
var $80b0323958b3e71c$export$20d6a73fd0b10982 = [
    $80b0323958b3e71c$export$9924a64a4b8b0d58,
    $80b0323958b3e71c$export$acf4b8bdf24aab34,
    $80b0323958b3e71c$export$c65c8c9f514da472
];
var $80b0323958b3e71c$export$29961f34c719157e = $80b0323958b3e71c$export$41ae838dc1e0f082.toLowerCase();
var $80b0323958b3e71c$export$eaef12179141669a = "x-amz-content-sha256";
var $80b0323958b3e71c$export$fdc81b663012a8d2 = $80b0323958b3e71c$export$8e1383b7eea7bee.toLowerCase();
var $80b0323958b3e71c$export$96307741595055fc = "host";
var $80b0323958b3e71c$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $80b0323958b3e71c$export$8085db98abbe0597 = /^proxy-/;
var $80b0323958b3e71c$export$758380400526c39 = /^sec-/;
var $80b0323958b3e71c$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $80b0323958b3e71c$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $80b0323958b3e71c$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $80b0323958b3e71c$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $80b0323958b3e71c$export$bf665777b4a1722f = 50;
var $80b0323958b3e71c$export$c4bf0942098f6bb = "aws4_request";
var $80b0323958b3e71c$export$274df788bdcca184 = 604800;


var $ee58d829ca65171a$var$signingKeyCache = {};
var $ee58d829ca65171a$var$cacheQueue = [];
function $ee58d829ca65171a$export$41a9651decfe2bde(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $80b0323958b3e71c$export$c4bf0942098f6bb);
}
var $ee58d829ca65171a$export$8b95a069d16dd783 = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, $86f80d0bf2133041$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $ee58d829ca65171a$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in $ee58d829ca65171a$var$signingKeyCache) return [
                        2 /*return*/ ,
                        $ee58d829ca65171a$var$signingKeyCache[cacheKey]
                    ];
                    $ee58d829ca65171a$var$cacheQueue.push(cacheKey);
                    while($ee58d829ca65171a$var$cacheQueue.length > (0, $80b0323958b3e71c$export$bf665777b4a1722f))delete $ee58d829ca65171a$var$signingKeyCache[$ee58d829ca65171a$var$cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, $86f80d0bf2133041$export$19a8beecd37a4c45)([
                        shortDate,
                        region,
                        service,
                        (0, $80b0323958b3e71c$export$c4bf0942098f6bb)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4 /*yield*/ ,
                        $ee58d829ca65171a$var$hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        $ee58d829ca65171a$var$signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
function $ee58d829ca65171a$export$a31b95746ea0a30a() {
    $ee58d829ca65171a$var$cacheQueue.length = 0;
    Object.keys($ee58d829ca65171a$var$signingKeyCache).forEach(function(cacheKey) {
        delete $ee58d829ca65171a$var$signingKeyCache[cacheKey];
    });
}
function $ee58d829ca65171a$var$hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}








function $1d9380e1ad45351b$export$859d7f1bb55e2914(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $86f80d0bf2133041$export$19a8beecd37a4c45)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $80b0323958b3e71c$export$8ffdcd58c4092560) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $80b0323958b3e71c$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $80b0323958b3e71c$export$758380400526c39).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}



var $cb8cdff3894b595d$export$c3b4775ad75a73db = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, $cb8cdff3894b595d$var$hexEncode);
};
var $cb8cdff3894b595d$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};



var $c1d14e2ed1b502cc$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $cb8cdff3894b595d$export$c3b4775ad75a73db)).join("/");
};





function $ad91d59414dc2ddf$export$8fea7e63ecd1ddbb(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $80b0323958b3e71c$export$29961f34c719157e)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $cb8cdff3894b595d$export$c3b4775ad75a73db)(key) + "=" + (0, $cb8cdff3894b595d$export$c3b4775ad75a73db)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $cb8cdff3894b595d$export$c3b4775ad75a73db)(key) + "=" + (0, $cb8cdff3894b595d$export$c3b4775ad75a73db)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $86f80d0bf2133041$export$19a8beecd37a4c45)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}






function $e8b3ed16d281899f$export$a46a74202b0efd71(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $86f80d0bf2133041$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $80b0323958b3e71c$export$eaef12179141669a)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $37fef351ec9da733$export$9dd3754ae86f0017)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, $80b0323958b3e71c$export$91f7321b40d9fd07)
                    ];
            }
        });
    });
}



function $6c67164ddf9a84ed$export$17944590be865217(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $86f80d0bf2133041$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}




function $86acd1ee5ea36792$export$d043aa0bf7223286(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $86f80d0bf2133041$export$3c9a16f847548506)(_a, [
        "headers",
        "query"
    ]);
    return (0, $86f80d0bf2133041$export$18ce0697a983be9b)((0, $86f80d0bf2133041$export$18ce0697a983be9b)({}, rest), {
        headers: (0, $86f80d0bf2133041$export$18ce0697a983be9b)({}, headers),
        query: query ? $86acd1ee5ea36792$var$cloneQuery(query) : undefined
    });
}
function $86acd1ee5ea36792$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $86f80d0bf2133041$export$18ce0697a983be9b)((0, $86f80d0bf2133041$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $86f80d0bf2133041$export$afc72e2116322959)(param) : param, _a));
    }, {});
}


function $0feea7af0f945b7f$export$bfc08a76d4bd60f6(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, $86acd1ee5ea36792$export$d043aa0bf7223286)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, $86f80d0bf2133041$export$19a8beecd37a4c45)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $86f80d0bf2133041$export$18ce0697a983be9b)((0, $86f80d0bf2133041$export$18ce0697a983be9b)({}, request), {
        headers: headers,
        query: query
    });
}





function $259db092bf067425$export$a7cfe9131aa06be4(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, $86acd1ee5ea36792$export$d043aa0bf7223286)(request);
    try {
        for(var _b = (0, $86f80d0bf2133041$export$19a8beecd37a4c45)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $80b0323958b3e71c$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}


function $91eeb19f9774a055$export$b65d57190c224ef2(time) {
    return $91eeb19f9774a055$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $91eeb19f9774a055$export$e67a095c620b86fe(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}


var $bbb359c0dbe68b52$export$20baf4d3f65eb30c = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = $bbb359c0dbe68b52$var$normalizeRegionProvider(region);
        this.credentialProvider = $bbb359c0dbe68b52$var$normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $bbb359c0dbe68b52$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $80b0323958b3e71c$export$274df788bdcca184)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $ee58d829ca65171a$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $0feea7af0f945b7f$export$bfc08a76d4bd60f6)((0, $259db092bf067425$export$a7cfe9131aa06be4)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, $80b0323958b3e71c$export$8e1383b7eea7bee] = credentials.sessionToken;
                        request.query[0, $80b0323958b3e71c$export$186cd8495ba0377d] = (0, $80b0323958b3e71c$export$863a63fba5b2ddf5);
                        request.query[0, $80b0323958b3e71c$export$5c8e6dd7758f59d6] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $80b0323958b3e71c$export$6e114beec37430d7] = longDate;
                        request.query[0, $80b0323958b3e71c$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
                        canonicalHeaders = (0, $1d9380e1ad45351b$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $80b0323958b3e71c$export$2dcbb254f883c238] = $bbb359c0dbe68b52$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $80b0323958b3e71c$export$41ae838dc1e0f082);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $e8b3ed16d281899f$export$a46a74202b0efd71)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $bbb359c0dbe68b52$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $ee58d829ca65171a$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, $e8b3ed16d281899f$export$a46a74202b0efd71)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $80b0323958b3e71c$export$9a1f6cf06ac56167),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $bbb359c0dbe68b52$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $259db092bf067425$export$a7cfe9131aa06be4)(requestToSign);
                        _e = $bbb359c0dbe68b52$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $ee58d829ca65171a$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $80b0323958b3e71c$export$acf4b8bdf24aab34] = longDate;
                        if (credentials.sessionToken) request.headers[0, $80b0323958b3e71c$export$fdc81b663012a8d2] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, $e8b3ed16d281899f$export$a46a74202b0efd71)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $6c67164ddf9a84ed$export$17944590be865217)((0, $80b0323958b3e71c$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $80b0323958b3e71c$export$eaef12179141669a] = payloadHash;
                        canonicalHeaders = (0, $1d9380e1ad45351b$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $80b0323958b3e71c$export$9924a64a4b8b0d58] = (0, $80b0323958b3e71c$export$863a63fba5b2ddf5) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $bbb359c0dbe68b52$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $ad91d59414dc2ddf$export$8fea7e63ecd1ddbb)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $80b0323958b3e71c$export$863a63fba5b2ddf5) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $ee58d829ca65171a$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $bbb359c0dbe68b52$var$formatDate = function(now) {
    var longDate = (0, $91eeb19f9774a055$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $bbb359c0dbe68b52$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var $bbb359c0dbe68b52$var$normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $bbb359c0dbe68b52$var$normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};




var $6995a60eda50674c$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $6995a60eda50674c$export$eaef12179141669a = "X-Amz-Content-Sha256";
var $6995a60eda50674c$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $6995a60eda50674c$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $6995a60eda50674c$export$6e114beec37430d7 = "X-Amz-Date";
var $6995a60eda50674c$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $6995a60eda50674c$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $6995a60eda50674c$export$96307741595055fc = "host";
var $6995a60eda50674c$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";


var $4c2d32f64b3820e3$export$a1673011a6b3560f = /** @class */ function() {
    function S3RequestPresigner(options) {
        var resolvedOptions = (0, $86f80d0bf2133041$export$18ce0697a983be9b)({
            // Allow `signingName` because we want to support usecase of supply client's resolved config
            // directly. Where service equals signingName.
            service: options.signingName || options.service || "s3",
            uriEscapePath: options.uriEscapePath || false
        }, options);
        this.signer = new (0, $bbb359c0dbe68b52$export$20baf4d3f65eb30c)(resolvedOptions);
    }
    S3RequestPresigner.prototype.presign = function(requestToSign, _a) {
        if (_a === void 0) _a = {};
        var _b = _a.unsignableHeaders, unsignableHeaders = _b === void 0 ? new Set() : _b, _c = _a.unhoistableHeaders, unhoistableHeaders = _c === void 0 ? new Set() : _c, options = (0, $86f80d0bf2133041$export$3c9a16f847548506)(_a, [
            "unsignableHeaders",
            "unhoistableHeaders"
        ]);
        return (0, $86f80d0bf2133041$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_d) {
                unsignableHeaders.add("content-type");
                // S3 requires SSE headers to be signed in headers instead of query
                // See: https://github.com/aws/aws-sdk-js-v3/issues/1576
                Object.keys(requestToSign.headers).map(function(header) {
                    return header.toLowerCase();
                }).filter(function(header) {
                    return header.startsWith("x-amz-server-side-encryption");
                }).forEach(function(header) {
                    unhoistableHeaders.add(header);
                });
                requestToSign.headers[0, $6995a60eda50674c$export$eaef12179141669a] = (0, $6995a60eda50674c$export$91f7321b40d9fd07);
                if (!requestToSign.headers["host"]) requestToSign.headers.host = requestToSign.hostname;
                return [
                    2 /*return*/ ,
                    this.signer.presign(requestToSign, (0, $86f80d0bf2133041$export$18ce0697a983be9b)({
                        expiresIn: 900,
                        unsignableHeaders: unsignableHeaders,
                        unhoistableHeaders: unhoistableHeaders
                    }, options))
                ];
            });
        });
    };
    return S3RequestPresigner;
}();






var $713352c166dc846e$export$d6e65e470b2c127c = function(client, command, options) {
    if (options === void 0) options = {};
    return (0, $86f80d0bf2133041$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var s3Presigner, presignInterceptMiddleware, middlewareName, presigned, output;
        return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    s3Presigner = new (0, $4c2d32f64b3820e3$export$a1673011a6b3560f)((0, $86f80d0bf2133041$export$18ce0697a983be9b)({}, client.config));
                    presignInterceptMiddleware = function(next, context) {
                        return function(args) {
                            return (0, $86f80d0bf2133041$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                                var request, presigned;
                                var _a, _b;
                                return (0, $86f80d0bf2133041$export$67ebef60e6f28a6)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            request = args.request;
                                            if (!(0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request)) throw new Error("Request to be presigned is not an valid HTTP request.");
                                            // Retry information headers are not meaningful in presigned URLs
                                            delete request.headers["amz-sdk-invocation-id"];
                                            delete request.headers["amz-sdk-request"];
                                            return [
                                                4 /*yield*/ ,
                                                s3Presigner.presign(request, (0, $86f80d0bf2133041$export$18ce0697a983be9b)((0, $86f80d0bf2133041$export$18ce0697a983be9b)({}, options), {
                                                    signingRegion: (_a = options.signingRegion) !== null && _a !== void 0 ? _a : context["signing_region"],
                                                    signingService: (_b = options.signingService) !== null && _b !== void 0 ? _b : context["signing_service"]
                                                }))
                                            ];
                                        case 1:
                                            presigned = _c.sent();
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    // Intercept the middleware stack by returning fake response
                                                    response: {},
                                                    output: {
                                                        $metadata: {
                                                            httpStatusCode: 200
                                                        },
                                                        presigned: presigned
                                                    }
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                    };
                    middlewareName = "presignInterceptMiddleware";
                    client.middlewareStack.addRelativeTo(presignInterceptMiddleware, {
                        name: middlewareName,
                        relation: "before",
                        toMiddleware: "awsAuthMiddleware",
                        override: true
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        client.send(command)
                    ];
                case 2:
                    output = _a.sent();
                    //@ts-ignore the output is faked, so it's not actually OutputType
                    presigned = output.presigned;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    client.middlewareStack.remove(middlewareName);
                    return [
                        7 /*endfinally*/ 
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        (0, $eaea2d0b0b5b4fe5$export$75025487296cba38)(presigned)
                    ];
            }
        });
    });
};




/*
 * Copyright 2017-2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));



var $5c596c808c2de5fe$export$148a3867c72aff96;
(function(StorageErrorStrings) {
    StorageErrorStrings["NO_CREDENTIALS"] = "No credentials";
    StorageErrorStrings["NO_SRC_KEY"] = 'source param should be an object with the property "key" with value of type string';
    StorageErrorStrings["NO_DEST_KEY"] = 'destination param should be an object with the property "key" with value of type string';
    StorageErrorStrings["INVALID_BLOB"] = "Object must be an instance of Blob";
})($5c596c808c2de5fe$export$148a3867c72aff96 || ($5c596c808c2de5fe$export$148a3867c72aff96 = {}));
var $5c596c808c2de5fe$export$85f5425ead1c79c0;
(function(AWSS3ProviderMultipartCopierErrors) {
    AWSS3ProviderMultipartCopierErrors["CLEANUP_FAILED"] = "Multipart copy clean up failed";
    AWSS3ProviderMultipartCopierErrors["NO_OBJECT_FOUND"] = "Object does not exist";
    AWSS3ProviderMultipartCopierErrors["INVALID_QUEUESIZE"] = "Queue size must be a positive number";
    AWSS3ProviderMultipartCopierErrors["NO_COPYSOURCE"] = "You must specify a copy source";
    AWSS3ProviderMultipartCopierErrors["MAX_NUM_PARTS_EXCEEDED"] = "Only a maximum of 10000 parts are allowed";
})($5c596c808c2de5fe$export$85f5425ead1c79c0 || ($5c596c808c2de5fe$export$85f5425ead1c79c0 = {}));
var $5c596c808c2de5fe$export$179814ca32efa022;
(function(AWSS3ProviderUploadErrorStrings) {
    AWSS3ProviderUploadErrorStrings["UPLOAD_PAUSED_MESSAGE"] = "paused";
})($5c596c808c2de5fe$export$179814ca32efa022 || ($5c596c808c2de5fe$export$179814ca32efa022 = {}));


var $5da18860f75886e9$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $5da18860f75886e9$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5da18860f75886e9$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("axios-http-handler");
var $5da18860f75886e9$export$c5e6923933be22a0 = "sendUploadProgress";
var $5da18860f75886e9$export$660a92f3322ba11a = "sendDownloadProgress";
function $5da18860f75886e9$var$isBlob(body) {
    return typeof Blob !== "undefined" && body instanceof Blob;
}
function $5da18860f75886e9$var$hasErrorResponse(error) {
    return typeof error !== "undefined" && Object.prototype.hasOwnProperty.call(error, "response") && typeof error.response !== "undefined" && Object.prototype.hasOwnProperty.call(error.response, "status") && typeof error.response.status === "number";
}
var $5da18860f75886e9$var$normalizeHeaders = function(headers, normalizedName) {
    var e_1, _a;
    try {
        for(var _b = $5da18860f75886e9$var$__values(Object.entries(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $5da18860f75886e9$var$__read(_c.value, 2), k = _d[0], v = _d[1];
            if (k !== normalizedName && k.toUpperCase() === normalizedName.toUpperCase()) {
                headers[normalizedName] = v;
                delete headers[k];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
};
var $5da18860f75886e9$export$7415af030ea6a2ae = [
    function(data, headers) {
        if ($5da18860f75886e9$var$isBlob(data)) {
            $5da18860f75886e9$var$normalizeHeaders(headers, "Content-Type");
            $5da18860f75886e9$var$normalizeHeaders(headers, "Accept");
            return data;
        }
        // Axios' default transformRequest is an array
        return (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.transformRequest[0].call(null, data, headers);
    }
];
var $5da18860f75886e9$export$43af02f23afacda3 = /** @class */ function() {
    function AxiosHttpHandler(httpOptions, emitter, cancelTokenSource) {
        if (httpOptions === void 0) httpOptions = {};
        this.httpOptions = httpOptions;
        this.emitter = emitter;
        this.cancelTokenSource = cancelTokenSource;
    }
    AxiosHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
    };
    AxiosHttpHandler.prototype.handle = function(request, options) {
        var requestTimeoutInMs = this.httpOptions.requestTimeout;
        // prioritize the call specific event emitter, this is useful for multipart upload as each individual parts has
        // their own event emitter, without having to create s3client for every individual calls.
        var emitter = options.emitter || this.emitter;
        var path = request.path;
        if (request.query) {
            var queryString = (0, $c40265ee6312ebb2$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        var axiosRequest = {};
        axiosRequest.url = url;
        axiosRequest.method = request.method;
        axiosRequest.headers = request.headers;
        // The host header is automatically added by the browser and adding it explicitly in the
        // axios request throws an error https://github.com/aws-amplify/amplify-js/issues/5376
        // This is because the host header is a forbidden header for the http client to set
        // see https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name and
        // https://fetch.spec.whatwg.org/#forbidden-header-name
        // The reason we are removing this header here instead of in the aws-sdk's client
        // middleware is that the host header is required to be in the request signature and if
        // we remove it from the middlewares, then the request fails because the header is added
        // by the browser but is absent from the signature.
        delete axiosRequest.headers["host"];
        if (request.body) axiosRequest.data = request.body;
        else // Fix for https://github.com/aws-amplify/amplify-js/issues/5432
        // If the POST request body is empty but content-type header is set, axios is forcibly removing it
        // See https://github.com/axios/axios/issues/1535 and refusing to fix it https://github.com/axios/axios/issues/755
        // This change is a workaround to set the data as null (instead of undefined) to prevent axios from
        // removing the content-type header. Link for the source code
        // https://github.com/axios/axios/blob/dc4bc49673943e35280e5df831f5c3d0347a9393/lib/adapters/xhr.js#L121-L123
        if (axiosRequest.headers[Object.keys(axiosRequest.headers).find(function(key) {
            return key.toLowerCase() === "content-type";
        })]) axiosRequest.data = null;
        if (emitter) {
            // TODO: Unify linting rules across JS repo
            axiosRequest.onUploadProgress = function(event) {
                emitter.emit($5da18860f75886e9$export$c5e6923933be22a0, event);
                $5da18860f75886e9$var$logger.debug(event);
            };
            // TODO: Unify linting rules across JS repo
            axiosRequest.onDownloadProgress = function(event) {
                emitter.emit($5da18860f75886e9$export$660a92f3322ba11a, event);
                $5da18860f75886e9$var$logger.debug(event);
            };
        }
        // If a cancel token source is passed down from the provider, allows cancellation of in-flight requests
        if (this.cancelTokenSource) axiosRequest.cancelToken = this.cancelTokenSource.token;
        if (options.cancelTokenSource) axiosRequest.cancelToken = options.cancelTokenSource.token;
        // From gamma release, aws-sdk now expects all response type to be of blob or streams
        axiosRequest.responseType = "blob";
        // In Axios, Blobs are identified by calling Object.prototype.toString on the object. However, on React Native,
        // calling Object.prototype.toString on a Blob returns '[object Object]' instead of '[object Blob]', which causes
        // Axios to treat Blobs as generic Javascript objects. Therefore we need a to use a custom request transformer
        // to correctly handle Blob in React Native.
        if ((0, $2c4730a78a7bdcd6$export$2dffd0b5373a4389).isReactNative) axiosRequest.transformRequest = $5da18860f75886e9$export$7415af030ea6a2ae;
        var raceOfPromises = [
            (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).request(axiosRequest).then(function(response) {
                return {
                    response: new (0, $8e579238f5eb4a6f$export$1d94dfe0d9d1f1e7)({
                        headers: response.headers,
                        statusCode: response.status,
                        body: response.data
                    })
                };
            }).catch(function(error) {
                var _a, _b;
                // Error
                if (error.message !== (0, $5c596c808c2de5fe$export$179814ca32efa022).UPLOAD_PAUSED_MESSAGE) $5da18860f75886e9$var$logger.error(error.message);
                // for axios' cancel error, we should re-throw it back so it's not considered an s3client error
                // if we return empty, or an abitrary error HttpResponse, it will be hard to debug down the line.
                //
                // for errors that does not have a 'response' object, it's very likely that it is an unexpected error for
                // example a disconnect. Without it we cannot meaningfully reconstruct a HttpResponse, and the AWS SDK might
                // consider the request successful by mistake. In this case we should also re-throw the error.
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).isCancel(error) || !$5da18860f75886e9$var$hasErrorResponse(error)) throw error;
                // otherwise, we should re-construct an HttpResponse from the error, so that it can be passed down to other
                // aws sdk middleware (e.g retry, clock skew correction, error message serializing)
                return {
                    response: new (0, $8e579238f5eb4a6f$export$1d94dfe0d9d1f1e7)({
                        statusCode: error.response.status,
                        body: (_a = error.response) === null || _a === void 0 ? void 0 : _a.data,
                        headers: (_b = error.response) === null || _b === void 0 ? void 0 : _b.headers
                    })
                };
            }),
            $5da18860f75886e9$var$requestTimeout(requestTimeoutInMs)
        ];
        return Promise.race(raceOfPromises);
    };
    return AxiosHttpHandler;
}();
function $5da18860f75886e9$var$requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}




var $a77011a119d9fd1c$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $a77011a119d9fd1c$export$8179b8ba0ab1e018 = "contentLengthMiddleware";
var $a77011a119d9fd1c$export$b7bd51f6ce311d83 = "http://localhost:20005";
var $a77011a119d9fd1c$export$b9acc545d1bd0170 = "__uploadInProgress";


var $6b11143ba342dd3c$export$a48f0734ac7c2329 = function(x) {
    if (typeof x === "string") return x.length;
    else if ($6b11143ba342dd3c$var$isArrayBuffer(x)) return x.byteLength;
    else if ($6b11143ba342dd3c$export$5bcd6e94ed871c88(x)) return x.size;
    else throw new Error("Cannot determine byte length of " + x);
};
var $6b11143ba342dd3c$export$f4575af7aa417855 = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data["metrics"] = metrics;
        (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).dispatch("storage", {
            event: event,
            data: data,
            message: message
        }, "Storage", (0, $a77011a119d9fd1c$export$aadf71dd9875dd20));
    }
};
var $6b11143ba342dd3c$export$be78b3111c50efdd = function(x) {
    return typeof x !== "undefined" && x instanceof File;
};
var $6b11143ba342dd3c$export$5bcd6e94ed871c88 = function(x) {
    return typeof x !== "undefined" && x instanceof Blob;
};
var $6b11143ba342dd3c$var$isArrayBuffer = function(x) {
    return typeof x !== "undefined" && x instanceof ArrayBuffer;
};





var $4192e7cd1849eb6d$exports = {};
$4192e7cd1849eb6d$exports = JSON.parse('{"name":"@aws-sdk/client-s3","description":"AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test:unit":"mocha **/cjs/**/*.spec.js","test:e2e":"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js","test":"yarn test:unit","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/eventstream-serde-browser":"3.6.1","@aws-sdk/eventstream-serde-config-resolver":"3.6.1","@aws-sdk/eventstream-serde-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-blob-browser":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/hash-stream-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/md5-js":"3.6.1","@aws-sdk/middleware-apply-body-checksum":"3.6.1","@aws-sdk/middleware-bucket-endpoint":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-expect-continue":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-location-constraint":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-sdk-s3":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-ssec":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","@aws-sdk/util-waiter":"3.6.1","@aws-sdk/xml-builder":"3.6.1","fast-xml-parser":"^3.16.0","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/chai":"^4.2.11","@types/mocha":"^8.0.4","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-s3"}}');



var $b7f3b53f1fc9834e$exports = {};
"use strict";
Object.defineProperty($b7f3b53f1fc9834e$exports, "__esModule", {
    value: true
});
$b7f3b53f1fc9834e$exports.AwsCrc32 = $b7f3b53f1fc9834e$exports.Crc32 = $b7f3b53f1fc9834e$exports.crc32 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6dbcd32fdc8a0589$var$extendStatics = function(d, b) {
    $6dbcd32fdc8a0589$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6dbcd32fdc8a0589$var$extendStatics(d, b);
};
function $6dbcd32fdc8a0589$export$a8ba968b8961cb8a(d, b) {
    $6dbcd32fdc8a0589$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6dbcd32fdc8a0589$export$18ce0697a983be9b = function() {
    $6dbcd32fdc8a0589$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6dbcd32fdc8a0589$export$18ce0697a983be9b.apply(this, arguments);
};
function $6dbcd32fdc8a0589$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6dbcd32fdc8a0589$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6dbcd32fdc8a0589$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6dbcd32fdc8a0589$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6dbcd32fdc8a0589$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6dbcd32fdc8a0589$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6dbcd32fdc8a0589$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $6dbcd32fdc8a0589$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $6dbcd32fdc8a0589$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6dbcd32fdc8a0589$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6dbcd32fdc8a0589$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6dbcd32fdc8a0589$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6dbcd32fdc8a0589$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6dbcd32fdc8a0589$export$10c90e4f7922046c(v) {
    return this instanceof $6dbcd32fdc8a0589$export$10c90e4f7922046c ? (this.v = v, this) : new $6dbcd32fdc8a0589$export$10c90e4f7922046c(v);
}
function $6dbcd32fdc8a0589$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6dbcd32fdc8a0589$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6dbcd32fdc8a0589$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6dbcd32fdc8a0589$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6dbcd32fdc8a0589$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6dbcd32fdc8a0589$export$19a8beecd37a4c45 === "function" ? $6dbcd32fdc8a0589$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6dbcd32fdc8a0589$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $6dbcd32fdc8a0589$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $6dbcd32fdc8a0589$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6dbcd32fdc8a0589$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $6dbcd32fdc8a0589$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $5b89ca217acaad7b$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($5b89ca217acaad7b$exports, "__esModule", {
    value: true
});
$5b89ca217acaad7b$exports.uint32ArrayFrom = $5b89ca217acaad7b$exports.numToUint8 = $5b89ca217acaad7b$exports.isEmptyData = $5b89ca217acaad7b$exports.convertToBuffer = void 0;
var $317e977c31497c39$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $317e977c31497c39$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($317e977c31497c39$exports, "__esModule", {
    value: true
});
$317e977c31497c39$exports.convertToBuffer = void 0;
const $c38c058d624741f5$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $c38c058d624741f5$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};


function $a3de02f07e868e93$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $a3de02f07e868e93$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}


const $eed253017fc3984a$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $a3de02f07e868e93$export$c7c5cef950a4d2fc)(input) : (0, $c38c058d624741f5$export$c7c5cef950a4d2fc)(input);
const $eed253017fc3984a$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $a3de02f07e868e93$export$b4b216764bb846eb)(input) : (0, $c38c058d624741f5$export$b4b216764bb846eb)(input);


// Quick polyfill
var $317e977c31497c39$var$fromUtf8 = typeof $317e977c31497c39$require$Buffer !== "undefined" && $317e977c31497c39$require$Buffer.from ? function(input) {
    return $317e977c31497c39$require$Buffer.from(input, "utf8");
} : $eed253017fc3984a$export$c7c5cef950a4d2fc;
function $317e977c31497c39$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $317e977c31497c39$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
$317e977c31497c39$exports.convertToBuffer = $317e977c31497c39$var$convertToBuffer;


Object.defineProperty($5b89ca217acaad7b$exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $317e977c31497c39$exports.convertToBuffer;
    }
});
var $e6341175af2d521f$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($e6341175af2d521f$exports, "__esModule", {
    value: true
});
$e6341175af2d521f$exports.isEmptyData = void 0;
function $e6341175af2d521f$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
$e6341175af2d521f$exports.isEmptyData = $e6341175af2d521f$var$isEmptyData;


Object.defineProperty($5b89ca217acaad7b$exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $e6341175af2d521f$exports.isEmptyData;
    }
});
var $29b41cdeaf2e52b2$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($29b41cdeaf2e52b2$exports, "__esModule", {
    value: true
});
$29b41cdeaf2e52b2$exports.numToUint8 = void 0;
function $29b41cdeaf2e52b2$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
$29b41cdeaf2e52b2$exports.numToUint8 = $29b41cdeaf2e52b2$var$numToUint8;


Object.defineProperty($5b89ca217acaad7b$exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $29b41cdeaf2e52b2$exports.numToUint8;
    }
});
var $7ea6106501c08d83$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($7ea6106501c08d83$exports, "__esModule", {
    value: true
});
$7ea6106501c08d83$exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $7ea6106501c08d83$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
$7ea6106501c08d83$exports.uint32ArrayFrom = $7ea6106501c08d83$var$uint32ArrayFrom;


Object.defineProperty($5b89ca217acaad7b$exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $7ea6106501c08d83$exports.uint32ArrayFrom;
    }
});


function $b7f3b53f1fc9834e$var$crc32(data) {
    return new $b7f3b53f1fc9834e$var$Crc32().update(data).digest();
}
$b7f3b53f1fc9834e$exports.crc32 = $b7f3b53f1fc9834e$var$crc32;
var $b7f3b53f1fc9834e$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $6dbcd32fdc8a0589$export$19a8beecd37a4c45)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $b7f3b53f1fc9834e$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
$b7f3b53f1fc9834e$exports.Crc32 = $b7f3b53f1fc9834e$var$Crc32;
// prettier-ignore
var $b7f3b53f1fc9834e$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $b7f3b53f1fc9834e$var$lookupTable = (0, $5b89ca217acaad7b$exports.uint32ArrayFrom)($b7f3b53f1fc9834e$var$a_lookUpTable);
var $b7e822c9cce6c6c2$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($b7e822c9cce6c6c2$exports, "__esModule", {
    value: true
});
$b7e822c9cce6c6c2$exports.AwsCrc32 = void 0;



var $b7e822c9cce6c6c2$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $b7f3b53f1fc9834e$exports.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $5b89ca217acaad7b$exports.isEmptyData)(toHash)) return;
        this.crc32.update((0, $5b89ca217acaad7b$exports.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $6dbcd32fdc8a0589$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $6dbcd32fdc8a0589$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $5b89ca217acaad7b$exports.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
$b7e822c9cce6c6c2$exports.AwsCrc32 = $b7e822c9cce6c6c2$var$AwsCrc32;


Object.defineProperty($b7f3b53f1fc9834e$exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $b7e822c9cce6c6c2$exports.AwsCrc32;
    }
});





/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var $eb5d120590cbbc32$export$8a5e19712a0a5deb = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $eb5d120590cbbc32$var$negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) $eb5d120590cbbc32$var$negate(bytes);
        return parseInt((0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function $eb5d120590cbbc32$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


/**
 * @internal
 */ var $38b7ae13a16059cd$export$74fd41a85c5dcec9 = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, $6dbcd32fdc8a0589$export$19a8beecd37a4c45)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, $6dbcd32fdc8a0589$export$19a8beecd37a4c45)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, $eb5d120590cbbc32$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$38b7ae13a16059cd$var$UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, $e02f91f5e6e2edfe$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: $38b7ae13a16059cd$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: $38b7ae13a16059cd$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: $38b7ae13a16059cd$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: $38b7ae13a16059cd$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: $38b7ae13a16059cd$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: $38b7ae13a16059cd$var$LONG_TAG,
                        value: new (0, $eb5d120590cbbc32$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $38b7ae13a16059cd$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $38b7ae13a16059cd$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: $38b7ae13a16059cd$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $eb5d120590cbbc32$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $38b7ae13a16059cd$var$UUID_TAG,
                        value: (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(uuidBytes.subarray(0, 4)) + "-" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(uuidBytes.subarray(4, 6)) + "-" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(uuidBytes.subarray(6, 8)) + "-" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(uuidBytes.subarray(8, 10)) + "-" + (0, $e02f91f5e6e2edfe$export$7ea66e3774a60b67)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var $38b7ae13a16059cd$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($38b7ae13a16059cd$var$HEADER_VALUE_TYPE || ($38b7ae13a16059cd$var$HEADER_VALUE_TYPE = {}));
var $38b7ae13a16059cd$var$BOOLEAN_TAG = "boolean";
var $38b7ae13a16059cd$var$BYTE_TAG = "byte";
var $38b7ae13a16059cd$var$SHORT_TAG = "short";
var $38b7ae13a16059cd$var$INT_TAG = "integer";
var $38b7ae13a16059cd$var$LONG_TAG = "long";
var $38b7ae13a16059cd$var$BINARY_TAG = "binary";
var $38b7ae13a16059cd$var$STRING_TAG = "string";
var $38b7ae13a16059cd$var$TIMESTAMP_TAG = "timestamp";
var $38b7ae13a16059cd$var$UUID_TAG = "uuid";
var $38b7ae13a16059cd$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



// All prelude components are unsigned, 32-bit integers
var $742a2cfef2bf82a6$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $742a2cfef2bf82a6$var$PRELUDE_LENGTH = $742a2cfef2bf82a6$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $742a2cfef2bf82a6$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $742a2cfef2bf82a6$var$MINIMUM_MESSAGE_LENGTH = $742a2cfef2bf82a6$var$PRELUDE_LENGTH + $742a2cfef2bf82a6$var$CHECKSUM_LENGTH * 2;
function $742a2cfef2bf82a6$export$546b6bc432bd9a53(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < $742a2cfef2bf82a6$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32($742a2cfef2bf82a6$var$PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32($742a2cfef2bf82a6$var$PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - $742a2cfef2bf82a6$var$CHECKSUM_LENGTH, false);
    var checksummer = new (0, $b7f3b53f1fc9834e$exports.Crc32)().update(new Uint8Array(buffer, byteOffset, $742a2cfef2bf82a6$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + $742a2cfef2bf82a6$var$PRELUDE_LENGTH, byteLength - ($742a2cfef2bf82a6$var$PRELUDE_LENGTH + $742a2cfef2bf82a6$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + $742a2cfef2bf82a6$var$PRELUDE_LENGTH + $742a2cfef2bf82a6$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $742a2cfef2bf82a6$var$PRELUDE_LENGTH + $742a2cfef2bf82a6$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($742a2cfef2bf82a6$var$PRELUDE_LENGTH + $742a2cfef2bf82a6$var$CHECKSUM_LENGTH + $742a2cfef2bf82a6$var$CHECKSUM_LENGTH))
    };
}


/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var $056147cc4e0dd5d9$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, $38b7ae13a16059cd$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, $b7f3b53f1fc9834e$exports.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, $742a2cfef2bf82a6$export$546b6bc432bd9a53)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();







/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1089bda799ee621b$var$extendStatics = function(d, b) {
    $1089bda799ee621b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1089bda799ee621b$var$extendStatics(d, b);
};
function $1089bda799ee621b$export$a8ba968b8961cb8a(d, b) {
    $1089bda799ee621b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1089bda799ee621b$export$18ce0697a983be9b = function() {
    $1089bda799ee621b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1089bda799ee621b$export$18ce0697a983be9b.apply(this, arguments);
};
function $1089bda799ee621b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1089bda799ee621b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1089bda799ee621b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1089bda799ee621b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1089bda799ee621b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1089bda799ee621b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1089bda799ee621b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $1089bda799ee621b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $1089bda799ee621b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1089bda799ee621b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1089bda799ee621b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1089bda799ee621b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1089bda799ee621b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1089bda799ee621b$export$10c90e4f7922046c(v) {
    return this instanceof $1089bda799ee621b$export$10c90e4f7922046c ? (this.v = v, this) : new $1089bda799ee621b$export$10c90e4f7922046c(v);
}
function $1089bda799ee621b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1089bda799ee621b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1089bda799ee621b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1089bda799ee621b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $1089bda799ee621b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1089bda799ee621b$export$19a8beecd37a4c45 === "function" ? $1089bda799ee621b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1089bda799ee621b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $1089bda799ee621b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $1089bda799ee621b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1089bda799ee621b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $1089bda799ee621b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}




function $c2a020b2d33f9026$export$3071cd8be9cd01e0(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function() {
        return (0, $1089bda799ee621b$export$e427f37a30a4de9b)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, $1089bda799ee621b$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}



function $ff69617990ac7a15$export$a1a364c5c6ddc1b4(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $1089bda799ee621b$export$e427f37a30a4de9b)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, $1089bda799ee621b$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, $1089bda799ee621b$export$e3b29a3d6162315f)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}


var $f9721d3e7398cd8b$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $056147cc4e0dd5d9$export$b64afa0aa6ce60e2)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, $c2a020b2d33f9026$export$3071cd8be9cd01e0)(body);
        var unmarshalledStream = (0, $ff69617990ac7a15$export$a1a364c5c6ddc1b4)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function() {
            return (0, $1089bda799ee621b$export$e427f37a30a4de9b)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, $1089bda799ee621b$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, $1089bda799ee621b$export$e3b29a3d6162315f)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, $1089bda799ee621b$export$10c90e4f7922046c)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, $1089bda799ee621b$export$10c90e4f7922046c)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $1089bda799ee621b$export$10c90e4f7922046c)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, $1089bda799ee621b$export$10c90e4f7922046c)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();


var $82d1910543df7a71$export$9d23a885702ebafb = function(options) {
    return new (0, $f9721d3e7398cd8b$export$b64afa0aa6ce60e2)(options);
};






var $0d326187987542c7$export$2346526b0991dd88 = function(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $1089bda799ee621b$export$e427f37a30a4de9b)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, $1089bda799ee621b$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, $1089bda799ee621b$export$10c90e4f7922046c)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var $0d326187987542c7$export$92326f9d37f111f = function(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function(controller) {
            return (0, $1089bda799ee621b$export$1050f835b63b671e)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, $1089bda799ee621b$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};


/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var $4895e97f3eb6056b$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $056147cc4e0dd5d9$export$b64afa0aa6ce60e2)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, $f9721d3e7398cd8b$export$b64afa0aa6ce60e2)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = $4895e97f3eb6056b$var$isReadableStream(body) ? (0, $0d326187987542c7$export$2346526b0991dd88)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $0d326187987542c7$export$92326f9d37f111f)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var $4895e97f3eb6056b$var$isReadableStream = function(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};


var $5cdd947ba5aca1b2$export$9d23a885702ebafb = function(options) {
    return new (0, $4895e97f3eb6056b$export$b64afa0aa6ce60e2)(options);
};







/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $26c6056efce9e220$var$extendStatics = function(d, b) {
    $26c6056efce9e220$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $26c6056efce9e220$var$extendStatics(d, b);
};
function $26c6056efce9e220$export$a8ba968b8961cb8a(d, b) {
    $26c6056efce9e220$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $26c6056efce9e220$export$18ce0697a983be9b = function() {
    $26c6056efce9e220$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26c6056efce9e220$export$18ce0697a983be9b.apply(this, arguments);
};
function $26c6056efce9e220$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $26c6056efce9e220$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $26c6056efce9e220$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $26c6056efce9e220$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $26c6056efce9e220$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $26c6056efce9e220$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $26c6056efce9e220$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $26c6056efce9e220$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $26c6056efce9e220$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $26c6056efce9e220$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $26c6056efce9e220$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($26c6056efce9e220$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $26c6056efce9e220$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $26c6056efce9e220$export$10c90e4f7922046c(v) {
    return this instanceof $26c6056efce9e220$export$10c90e4f7922046c ? (this.v = v, this) : new $26c6056efce9e220$export$10c90e4f7922046c(v);
}
function $26c6056efce9e220$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $26c6056efce9e220$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $26c6056efce9e220$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $26c6056efce9e220$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $26c6056efce9e220$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $26c6056efce9e220$export$19a8beecd37a4c45 === "function" ? $26c6056efce9e220$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $26c6056efce9e220$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $26c6056efce9e220$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $26c6056efce9e220$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $26c6056efce9e220$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $26c6056efce9e220$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $d86f1d376b9548e5$export$7541dba16c2127c8(blob, onChunk, chunkSize) {
    if (chunkSize === void 0) chunkSize = 1048576;
    return new Promise(function(resolve, reject) {
        var fileReader = new FileReader();
        fileReader.addEventListener("error", reject);
        fileReader.addEventListener("abort", reject);
        var size = blob.size;
        var totalBytesRead = 0;
        function read() {
            if (totalBytesRead >= size) {
                resolve();
                return;
            }
            fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
        }
        fileReader.addEventListener("load", function(event) {
            var result = event.target.result;
            onChunk(new Uint8Array(result));
            totalBytesRead += result.byteLength;
            // read the next block
            read();
        });
        // kick off the read
        read();
    });
}


var $36e98309aff35929$export$ea66e9c498b7933c = function blobHasher(hashCtor, blob) {
    return (0, $26c6056efce9e220$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var hash;
        return (0, $26c6056efce9e220$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    hash = new hashCtor();
                    return [
                        4 /*yield*/ ,
                        (0, $d86f1d376b9548e5$export$7541dba16c2127c8)(blob, function(chunk) {
                            hash.update(chunk);
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        hash.digest()
                    ];
            }
        });
    });
};



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $08f595eaf9ab5af7$var$extendStatics = function(d, b) {
    $08f595eaf9ab5af7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $08f595eaf9ab5af7$var$extendStatics(d, b);
};
function $08f595eaf9ab5af7$export$a8ba968b8961cb8a(d, b) {
    $08f595eaf9ab5af7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $08f595eaf9ab5af7$export$18ce0697a983be9b = function() {
    $08f595eaf9ab5af7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $08f595eaf9ab5af7$export$18ce0697a983be9b.apply(this, arguments);
};
function $08f595eaf9ab5af7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $08f595eaf9ab5af7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $08f595eaf9ab5af7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $08f595eaf9ab5af7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $08f595eaf9ab5af7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $08f595eaf9ab5af7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $08f595eaf9ab5af7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $08f595eaf9ab5af7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $08f595eaf9ab5af7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $08f595eaf9ab5af7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $08f595eaf9ab5af7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($08f595eaf9ab5af7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $08f595eaf9ab5af7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $08f595eaf9ab5af7$export$10c90e4f7922046c(v) {
    return this instanceof $08f595eaf9ab5af7$export$10c90e4f7922046c ? (this.v = v, this) : new $08f595eaf9ab5af7$export$10c90e4f7922046c(v);
}
function $08f595eaf9ab5af7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $08f595eaf9ab5af7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $08f595eaf9ab5af7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $08f595eaf9ab5af7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $08f595eaf9ab5af7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $08f595eaf9ab5af7$export$19a8beecd37a4c45 === "function" ? $08f595eaf9ab5af7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $08f595eaf9ab5af7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $08f595eaf9ab5af7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $08f595eaf9ab5af7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $08f595eaf9ab5af7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $08f595eaf9ab5af7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



/**
 * @internal
 */ var $1ef6502d44216ece$export$b2e3d6d444266a5c = 64;
var $1ef6502d44216ece$export$d7bd469488748c5f = 16;
var $1ef6502d44216ece$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];


var $c5eb66eff9f868bd$export$9f5a3dfc7a9f5dd = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, $1ef6502d44216ece$export$d788bc089976c004));
        this.buffer = new DataView(new ArrayBuffer((0, $1ef6502d44216ece$export$b2e3d6d444266a5c)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if ($c5eb66eff9f868bd$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = $c5eb66eff9f868bd$var$convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $1ef6502d44216ece$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, $08f595eaf9ab5af7$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, $08f595eaf9ab5af7$export$67ebef60e6f28a6)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, $1ef6502d44216ece$export$b2e3d6d444266a5c) >= (0, $1ef6502d44216ece$export$b2e3d6d444266a5c) - 8) {
                        for(i = this.bufferLength; i < (0, $1ef6502d44216ece$export$b2e3d6d444266a5c); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, $1ef6502d44216ece$export$b2e3d6d444266a5c) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, $1ef6502d44216ece$export$b2e3d6d444266a5c) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, $1ef6502d44216ece$export$b2e3d6d444266a5c) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, $1ef6502d44216ece$export$d7bd469488748c5f)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = $c5eb66eff9f868bd$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $c5eb66eff9f868bd$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $c5eb66eff9f868bd$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $c5eb66eff9f868bd$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $c5eb66eff9f868bd$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $c5eb66eff9f868bd$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $c5eb66eff9f868bd$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $c5eb66eff9f868bd$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $c5eb66eff9f868bd$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $c5eb66eff9f868bd$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $c5eb66eff9f868bd$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $c5eb66eff9f868bd$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $c5eb66eff9f868bd$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $c5eb66eff9f868bd$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $c5eb66eff9f868bd$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $c5eb66eff9f868bd$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $c5eb66eff9f868bd$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $c5eb66eff9f868bd$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $c5eb66eff9f868bd$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $c5eb66eff9f868bd$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $c5eb66eff9f868bd$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $c5eb66eff9f868bd$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $c5eb66eff9f868bd$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $c5eb66eff9f868bd$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $c5eb66eff9f868bd$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $c5eb66eff9f868bd$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $c5eb66eff9f868bd$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $c5eb66eff9f868bd$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $c5eb66eff9f868bd$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $c5eb66eff9f868bd$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $c5eb66eff9f868bd$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $c5eb66eff9f868bd$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $c5eb66eff9f868bd$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $c5eb66eff9f868bd$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $c5eb66eff9f868bd$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $c5eb66eff9f868bd$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $c5eb66eff9f868bd$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $c5eb66eff9f868bd$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $c5eb66eff9f868bd$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $c5eb66eff9f868bd$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $c5eb66eff9f868bd$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $c5eb66eff9f868bd$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $c5eb66eff9f868bd$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $c5eb66eff9f868bd$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $c5eb66eff9f868bd$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $c5eb66eff9f868bd$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $c5eb66eff9f868bd$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $c5eb66eff9f868bd$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $c5eb66eff9f868bd$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $c5eb66eff9f868bd$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $c5eb66eff9f868bd$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $c5eb66eff9f868bd$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $c5eb66eff9f868bd$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $c5eb66eff9f868bd$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $c5eb66eff9f868bd$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $c5eb66eff9f868bd$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $c5eb66eff9f868bd$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $c5eb66eff9f868bd$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $c5eb66eff9f868bd$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $c5eb66eff9f868bd$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $c5eb66eff9f868bd$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $c5eb66eff9f868bd$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $c5eb66eff9f868bd$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $c5eb66eff9f868bd$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function $c5eb66eff9f868bd$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $c5eb66eff9f868bd$var$ff(a, b, c, d, x, s, t) {
    return $c5eb66eff9f868bd$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $c5eb66eff9f868bd$var$gg(a, b, c, d, x, s, t) {
    return $c5eb66eff9f868bd$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $c5eb66eff9f868bd$var$hh(a, b, c, d, x, s, t) {
    return $c5eb66eff9f868bd$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $c5eb66eff9f868bd$var$ii(a, b, c, d, x, s, t) {
    return $c5eb66eff9f868bd$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $c5eb66eff9f868bd$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $c5eb66eff9f868bd$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $afcc34d5c80283e8$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}








// Partition default templates
var $b071387e34326c49$var$AWS_TEMPLATE = "s3.{region}.amazonaws.com";
var $b071387e34326c49$var$AWS_CN_TEMPLATE = "s3.{region}.amazonaws.com.cn";
var $b071387e34326c49$var$AWS_ISO_TEMPLATE = "s3.{region}.c2s.ic.gov";
var $b071387e34326c49$var$AWS_ISO_B_TEMPLATE = "s3.{region}.sc2s.sgov.gov";
var $b071387e34326c49$var$AWS_US_GOV_TEMPLATE = "s3.{region}.amazonaws.com";
// Partition regions
var $b071387e34326c49$var$AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $b071387e34326c49$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $b071387e34326c49$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $b071387e34326c49$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $b071387e34326c49$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $b071387e34326c49$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "s3.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "s3.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "s3.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "s3.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "s3.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "s3.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "s3.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "aws-global":
            regionInfo = {
                hostname: "s3.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "s3.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "s3.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "s3.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "s3.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "s3.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "s3.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "s3.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "s3.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "s3.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "s3-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "s3.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "s3-external-1":
            regionInfo = {
                hostname: "s3-external-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "s3.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "s3.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "s3.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "s3.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "s3.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "s3.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "s3.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "s3.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "s3.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($b071387e34326c49$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $b071387e34326c49$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($b071387e34326c49$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $b071387e34326c49$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($b071387e34326c49$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $b071387e34326c49$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($b071387e34326c49$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $b071387e34326c49$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($b071387e34326c49$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $b071387e34326c49$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $b071387e34326c49$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        signingService: "s3"
    }, regionInfo));
};



var $a1924a4679880af2$export$608864383388f904 = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $b071387e34326c49$export$2e4318bf13462aa2),
    serviceId: "S3",
    signingEscapePath: false,
    urlParser: (0, $13c693b8bb1dde50$export$7a5253c0f62e0150),
    useArnRegion: false
};


var $dbc0947e150bf7dd$export$b1f2d721b555a243 = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $a1924a4679880af2$export$608864383388f904)), {
    runtime: "browser",
    base64Decoder: (0, $7193c901dfcaa70c$export$c537b38001c583b7),
    base64Encoder: (0, $7193c901dfcaa70c$export$37cc283d8fbd3462),
    bodyLengthChecker: (0, $fd1dc5c280790e1b$export$967f3527bf233bc0),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, $efbdd3c561c88f76$export$69d579f32876892f)({
        serviceId: (0, $a1924a4679880af2$export$608864383388f904).serviceId,
        clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($4192e7cd1849eb6d$exports))).version
    }),
    eventStreamSerdeProvider: (0, $5cdd947ba5aca1b2$export$9d23a885702ebafb),
    maxAttempts: (0, $2d1974589a37c0fb$export$2c7e51f38ba5a406),
    md5: (0, $c5eb66eff9f868bd$export$9f5a3dfc7a9f5dd),
    region: (0, $77b3b9daef425c4b$export$d59dd53963f8f3d5)("Region is missing"),
    requestHandler: new (0, $262081bbd00b028c$export$83588b87edbfa7e0)(),
    sha256: (0, $3ce7992f05548527$exports.Sha256),
    streamCollector: (0, $8e0c4dd6b83dcffc$export$17bf97b72e307d52),
    streamHasher: (0, $36e98309aff35929$export$ea66e9c498b7933c),
    utf8Decoder: (0, $afcc34d5c80283e8$export$c7c5cef950a4d2fc),
    utf8Encoder: (0, $afcc34d5c80283e8$export$b4b216764bb846eb)
});



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1805368a349ab17e$var$extendStatics = function(d, b) {
    $1805368a349ab17e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1805368a349ab17e$var$extendStatics(d, b);
};
function $1805368a349ab17e$export$a8ba968b8961cb8a(d, b) {
    $1805368a349ab17e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1805368a349ab17e$export$18ce0697a983be9b = function() {
    $1805368a349ab17e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1805368a349ab17e$export$18ce0697a983be9b.apply(this, arguments);
};
function $1805368a349ab17e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1805368a349ab17e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1805368a349ab17e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1805368a349ab17e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1805368a349ab17e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1805368a349ab17e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1805368a349ab17e$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $1805368a349ab17e$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $1805368a349ab17e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1805368a349ab17e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1805368a349ab17e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1805368a349ab17e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1805368a349ab17e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1805368a349ab17e$export$10c90e4f7922046c(v) {
    return this instanceof $1805368a349ab17e$export$10c90e4f7922046c ? (this.v = v, this) : new $1805368a349ab17e$export$10c90e4f7922046c(v);
}
function $1805368a349ab17e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1805368a349ab17e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1805368a349ab17e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1805368a349ab17e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $1805368a349ab17e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1805368a349ab17e$export$19a8beecd37a4c45 === "function" ? $1805368a349ab17e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1805368a349ab17e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $1805368a349ab17e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $1805368a349ab17e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1805368a349ab17e$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $1805368a349ab17e$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $e247a2577eeebf82$export$5e2ae00bf65442f0 = function(input) {
    return (0, $1805368a349ab17e$export$18ce0697a983be9b)((0, $1805368a349ab17e$export$18ce0697a983be9b)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};






/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $4011fc56cc6e3a46$var$extendStatics = function(d, b) {
    $4011fc56cc6e3a46$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $4011fc56cc6e3a46$var$extendStatics(d, b);
};
function $4011fc56cc6e3a46$export$a8ba968b8961cb8a(d, b) {
    $4011fc56cc6e3a46$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4011fc56cc6e3a46$export$18ce0697a983be9b = function() {
    $4011fc56cc6e3a46$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4011fc56cc6e3a46$export$18ce0697a983be9b.apply(this, arguments);
};
function $4011fc56cc6e3a46$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4011fc56cc6e3a46$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4011fc56cc6e3a46$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4011fc56cc6e3a46$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4011fc56cc6e3a46$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4011fc56cc6e3a46$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $4011fc56cc6e3a46$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $4011fc56cc6e3a46$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $4011fc56cc6e3a46$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4011fc56cc6e3a46$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4011fc56cc6e3a46$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4011fc56cc6e3a46$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4011fc56cc6e3a46$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4011fc56cc6e3a46$export$10c90e4f7922046c(v) {
    return this instanceof $4011fc56cc6e3a46$export$10c90e4f7922046c ? (this.v = v, this) : new $4011fc56cc6e3a46$export$10c90e4f7922046c(v);
}
function $4011fc56cc6e3a46$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4011fc56cc6e3a46$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4011fc56cc6e3a46$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4011fc56cc6e3a46$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $4011fc56cc6e3a46$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4011fc56cc6e3a46$export$19a8beecd37a4c45 === "function" ? $4011fc56cc6e3a46$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4011fc56cc6e3a46$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $4011fc56cc6e3a46$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $4011fc56cc6e3a46$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4011fc56cc6e3a46$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $4011fc56cc6e3a46$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $bb57643d1f599a26$export$ea55ca13ab589d75(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $4011fc56cc6e3a46$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var request;
                return (0, $4011fc56cc6e3a46$export$67ebef60e6f28a6)(this, function(_a) {
                    request = args.request;
                    if ((0, $2368114ecf8ea544$export$7587955500404ec3).isInstance(request) && request.body && options.runtime === "node") request.headers = (0, $4011fc56cc6e3a46$export$18ce0697a983be9b)((0, $4011fc56cc6e3a46$export$18ce0697a983be9b)({}, request.headers), {
                        Expect: "100-continue"
                    });
                    return [
                        2 /*return*/ ,
                        next((0, $4011fc56cc6e3a46$export$18ce0697a983be9b)((0, $4011fc56cc6e3a46$export$18ce0697a983be9b)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $bb57643d1f599a26$export$582010bfa3126ad3 = {
    step: "build",
    tags: [
        "SET_EXPECT_HEADER",
        "EXPECT_HEADER"
    ],
    name: "addExpectContinueMiddleware",
    override: true
};
var $bb57643d1f599a26$export$7692e5e7214e5cd1 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($bb57643d1f599a26$export$ea55ca13ab589d75(options), $bb57643d1f599a26$export$582010bfa3126ad3);
        }
    };
};









/**
 * <p></p>
 */ var $478ba5531405b3f7$export$b5be36c66bc46237 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(S3Client, _super);
    function S3Client(configuration) {
        var _this = this;
        var _config_0 = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $dbc0947e150bf7dd$export$b1f2d721b555a243)), configuration);
        var _config_1 = (0, $b027526b3945190a$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $6aff6722f8b97662$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $de5bc339d6480fbe$export$1dd62920de1feabb)(_config_2);
        var _config_4 = (0, $626ed5f895800a82$export$ca7f6138f2c98476)(_config_3);
        var _config_5 = (0, $c1f22e97875f8f21$export$c1625bf0b32b4481)(_config_4);
        var _config_6 = (0, $576b485ca7f1e057$export$9810f1a949e3136)(_config_5);
        var _config_7 = (0, $db78c77ef8974ed8$export$ec9a2d5663958cb)(_config_6);
        var _config_8 = (0, $e247a2577eeebf82$export$5e2ae00bf65442f0)(_config_7);
        _this = _super.call(this, _config_8) || this;
        _this.config = _config_8;
        _this.middlewareStack.use((0, $f11240e09b9084dd$export$59c2b7ad30ed4046)(_this.config));
        _this.middlewareStack.use((0, $2efb85a1f6a92e50$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $ff4a9738848c11ef$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $c1f22e97875f8f21$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $d7c9db6585161f99$export$f6ef65d7766fc255)(_this.config));
        _this.middlewareStack.use((0, $dfab7746d8755a65$export$c30d61978fbb3ad8)(_this.config));
        _this.middlewareStack.use((0, $32eebb3bc4f2581c$export$8512187c26b3935b)(_this.config));
        _this.middlewareStack.use((0, $bb57643d1f599a26$export$7692e5e7214e5cd1)(_this.config));
        _this.middlewareStack.use((0, $7b73a126ebb97ab9$export$5393c0d2d7f4f5f0)(_this.config));
        return _this;
    }
    S3Client.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return S3Client;
}((0, $e3a8e149f1290509$export$1f2bb630327ac4b6));




var $40959b47ff8c567f$var$__assign = undefined && undefined.__assign || function() {
    $40959b47ff8c567f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40959b47ff8c567f$var$__assign.apply(this, arguments);
};
var $40959b47ff8c567f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $40959b47ff8c567f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $40959b47ff8c567f$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("S3ClientUtils");
// placeholder credentials in order to satisfy type requirement, always results in 403 when used
var $40959b47ff8c567f$var$INVALID_CRED = {
    accessKeyId: "",
    secretAccessKey: ""
};
var $40959b47ff8c567f$export$36e24695f02d4503 = function(config) {
    var credentials = config.credentials, level = config.level, customPrefix = config.customPrefix, identityId = config.identityId;
    var resolvedCustomPrefix = customPrefix || {};
    var resolvedIdentityId = identityId || credentials.identityId;
    var privatePath = (resolvedCustomPrefix.private !== undefined ? resolvedCustomPrefix.private : "private/") + resolvedIdentityId + "/";
    var protectedPath = (resolvedCustomPrefix.protected !== undefined ? resolvedCustomPrefix.protected : "protected/") + resolvedIdentityId + "/";
    var publicPath = resolvedCustomPrefix.public !== undefined ? resolvedCustomPrefix.public : "public/";
    switch(level){
        case "private":
            return privatePath;
        case "protected":
            return protectedPath;
        default:
            return publicPath;
    }
};
var $40959b47ff8c567f$export$95bc4f3188064861 = function(opt, key) {
    return function(next, _context) {
        return function(args) {
            return $40959b47ff8c567f$var$__awaiter(void 0, void 0, void 0, function() {
                var credentials, cred, prefix, clonedInput, result;
                return $40959b47ff8c567f$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                (0, $de9f45d92f772164$export$a9627919734faa48).get()
                            ];
                        case 1:
                            credentials = _a.sent();
                            cred = (0, $de9f45d92f772164$export$a9627919734faa48).shear(credentials);
                            prefix = $40959b47ff8c567f$export$36e24695f02d4503($40959b47ff8c567f$var$__assign($40959b47ff8c567f$var$__assign({}, opt), {
                                credentials: cred
                            }));
                            clonedInput = Object.assign({}, args.input);
                            if (Object.prototype.hasOwnProperty.call(args.input, "Key")) {
                                clonedInput.Key = prefix + key;
                                args.input = clonedInput;
                            } else if (Object.prototype.hasOwnProperty.call(args.input, "Prefix")) {
                                clonedInput.Prefix = prefix + key;
                                args.input = clonedInput;
                            }
                            result = next(args);
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        };
    };
};
var $40959b47ff8c567f$var$isTimeSkewedError = function(err) {
    return err.ServerTime && typeof err.Code === "string" && err.Code === "RequestTimeTooSkewed";
};
var $40959b47ff8c567f$export$d1971fb9f9448f = function(config) {
    return function(next, _context) {
        return function(args) {
            return $40959b47ff8c567f$var$__awaiter(void 0, void 0, void 0, function() {
                var err_1, serverDate;
                return $40959b47ff8c567f$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 2:
                            err_1 = _a.sent();
                            if ($40959b47ff8c567f$var$isTimeSkewedError(err_1)) {
                                serverDate = new Date(err_1.ServerTime);
                                config.systemClockOffset = serverDate.getTime() - Date.now();
                            }
                            throw err_1;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var $40959b47ff8c567f$export$2edd0200412be327 = {
    step: "finalizeRequest",
    name: "autoAdjustClockskewMiddleware"
};
var $40959b47ff8c567f$export$52daf78b33f1adcd = {
    step: "initialize",
    name: "addPrefixMiddleware"
};
var $40959b47ff8c567f$export$ae4c744fb23e6d32 = function() {
    return $40959b47ff8c567f$var$__awaiter(void 0, void 0, void 0, function() {
        var credentials, cred, error_1;
        return $40959b47ff8c567f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $de9f45d92f772164$export$a9627919734faa48).get()
                    ];
                case 1:
                    credentials = _a.sent();
                    if (!credentials) return [
                        2 /*return*/ ,
                        $40959b47ff8c567f$var$INVALID_CRED
                    ];
                    cred = (0, $de9f45d92f772164$export$a9627919734faa48).shear(credentials);
                    $40959b47ff8c567f$var$logger.debug("credentials provider get credentials", cred);
                    return [
                        2 /*return*/ ,
                        cred
                    ];
                case 2:
                    error_1 = _a.sent();
                    $40959b47ff8c567f$var$logger.warn("credentials provider error", error_1);
                    return [
                        2 /*return*/ ,
                        $40959b47ff8c567f$var$INVALID_CRED
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $40959b47ff8c567f$export$4cdd37a0748e6ad9 = function(config, emitter) {
    var region = config.region, cancelTokenSource = config.cancelTokenSource, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting, useAccelerateEndpoint = config.useAccelerateEndpoint;
    var localTestingConfig = {};
    if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
        endpoint: (0, $a77011a119d9fd1c$export$b7bd51f6ce311d83),
        tls: false,
        bucketEndpoint: false,
        forcePathStyle: true
    };
    var s3client = new (0, $478ba5531405b3f7$export$b5be36c66bc46237)($40959b47ff8c567f$var$__assign($40959b47ff8c567f$var$__assign({
        region: region,
        // Using provider instead of a static credentials, so that if an upload task was in progress, but credentials gets
        // changed or invalidated (e.g user signed out), the subsequent requests will fail.
        credentials: $40959b47ff8c567f$export$ae4c744fb23e6d32,
        customUserAgent: (0, $2c4730a78a7bdcd6$export$ede38edb26c0bfdf)()
    }, localTestingConfig), {
        requestHandler: new (0, $5da18860f75886e9$export$43af02f23afacda3)({}, emitter, cancelTokenSource),
        useAccelerateEndpoint: useAccelerateEndpoint
    }));
    s3client.middlewareStack.remove((0, $a77011a119d9fd1c$export$8179b8ba0ab1e018));
    return s3client;
};


/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 







/**
 * <p>Adds an object to a bucket. You must have WRITE permissions on a bucket to add an object
 *          to it.</p>
 *
 *
 *          <p>Amazon S3 never adds partial objects; if you receive a success response, Amazon S3 added the
 *          entire object to the bucket.</p>
 *
 *          <p>Amazon S3 is a distributed system. If it receives multiple write requests for the same object
 *          simultaneously, it overwrites all but the last object written. Amazon S3 does not provide object
 *          locking; if you need this, make sure to build it into your application layer or use
 *          versioning instead.</p>
 *
 *          <p>To ensure that data is not corrupted traversing the network, use the
 *             <code>Content-MD5</code> header. When you use this header, Amazon S3 checks the object
 *          against the provided MD5 value and, if they do not match, returns an error. Additionally,
 *          you can calculate the MD5 while putting an object to Amazon S3 and compare the returned ETag to
 *          the calculated MD5 value.</p>
 *          <note>
 *             <p> The <code>Content-MD5</code> header is required for any request to upload an object
 *             with a retention period configured using Amazon S3 Object Lock. For more information about
 *             Amazon S3 Object Lock, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/object-lock-overview.html">Amazon S3 Object Lock Overview</a>
 *             in the <i>Amazon Simple Storage Service Developer Guide</i>. </p>
 *          </note>
 *
 *
 *          <p>
 *             <b>Server-side Encryption</b>
 *          </p>
 *          <p>You can optionally request server-side encryption. With server-side encryption, Amazon S3 encrypts your data as it writes it to disks in its data centers and decrypts the data
 *          when you access it. You have the option to provide your own encryption key or use AWS
 *          managed encryption keys (SSE-S3 or SSE-KMS). For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingServerSideEncryption.html">Using Server-Side
 *             Encryption</a>.</p>
 *          <p>If you request server-side encryption using AWS Key Management Service (SSE-KMS), you can enable an S3 Bucket Key at the object-level. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/bucket-key.html">Amazon S3 Bucket Keys</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *          <p>
 *             <b>Access Control List (ACL)-Specific Request
 *          Headers</b>
 *          </p>
 *          <p>You can use headers to grant ACL- based permissions. By default, all objects are
 *          private. Only the owner has full access control. When adding a new object, you can grant
 *          permissions to individual AWS accounts or to predefined groups defined by Amazon S3. These
 *          permissions are then added to the ACL on the object. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List
 *             (ACL) Overview</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-using-rest-api.html">Managing ACLs Using the REST
 *             API</a>. </p>
 *
 *          <p>
 *             <b>Storage Class Options</b>
 *          </p>
 *          <p>By default, Amazon S3 uses the STANDARD Storage Class to store newly created objects. The
 *          STANDARD storage class provides high durability and high availability. Depending on
 *          performance needs, you can specify a different Storage Class. Amazon S3 on Outposts only uses
 *          the OUTPOSTS Storage Class. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/storage-class-intro.html">Storage Classes</a> in the <i>Amazon S3
 *             Service Developer Guide</i>.</p>
 *
 *
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>If you enable versioning for a bucket, Amazon S3 automatically generates a unique version ID
 *          for the object being stored. Amazon S3 returns this ID in the response. When you enable
 *          versioning for a bucket, if Amazon S3 receives multiple write requests for the same object
 *          simultaneously, it stores all of the objects.</p>
 *          <p>For more information about versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/AddingObjectstoVersioningEnabledBuckets.html">Adding Objects to
 *             Versioning Enabled Buckets</a>. For information about returning the versioning state
 *          of a bucket, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetBucketVersioning.html">GetBucketVersioning</a>. </p>
 *
 *
 *          <p class="title">
 *             <b>Related Resources</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CopyObject.html">CopyObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_DeleteObject.html">DeleteObject</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $993df36854c53178$export$4afa2352f8871c26 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PutObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $9a68e4ce915c38f9$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$90c5c1bf0f634d21).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$792cedced515bdbd).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutObjectCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$6c3f9d82bec72a8d)(input, context);
    };
    PutObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$45bbdbf5181c3607)(output, context);
    };
    return PutObjectCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));








/**
 * <p>This operation initiates a multipart upload and returns an upload ID. This upload ID is
 *          used to associate all of the parts in the specific multipart upload. You specify this
 *          upload ID in each of your subsequent upload part requests (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>). You also include this
 *          upload ID in the final request to either complete or abort the multipart upload
 *          request.</p>
 *
 *          <p>For more information about multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html">Multipart Upload Overview</a>.</p>
 *
 *          <p>If you have configured a lifecycle rule to abort incomplete multipart uploads, the
 *          upload must complete within the number of days specified in the bucket lifecycle
 *          configuration. Otherwise, the incomplete multipart upload becomes eligible for an abort
 *          operation and Amazon S3 aborts the multipart upload. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html#mpu-abort-incomplete-mpu-lifecycle-config">Aborting
 *             Incomplete Multipart Uploads Using a Bucket Lifecycle Policy</a>.</p>
 *
 *          <p>For information about the permissions required to use the multipart upload API, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *             Permissions</a>.</p>
 *
 *          <p>For request signing, multipart upload is just a series of regular requests. You initiate
 *          a multipart upload, send one or more requests to upload parts, and then complete the
 *          multipart upload process. You sign each request individually. There is nothing special
 *          about signing multipart upload requests. For more information about signing, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/sig-v4-authenticating-requests.html">Authenticating
 *             Requests (AWS Signature Version 4)</a>.</p>
 *
 *          <note>
 *             <p> After you initiate a multipart upload and upload one or more parts, to stop being
 *             charged for storing the uploaded parts, you must either complete or abort the multipart
 *             upload. Amazon S3 frees up the space used to store the parts and stop charging you for
 *             storing them only after you either complete or abort a multipart upload. </p>
 *          </note>
 *
 *          <p>You can optionally request server-side encryption. For server-side encryption, Amazon S3
 *          encrypts your data as it writes it to disks in its data centers and decrypts it when you
 *          access it. You can provide your own encryption key, or use AWS Key Management Service (AWS
 *          KMS) customer master keys (CMKs) or Amazon S3-managed encryption keys. If you choose to provide
 *          your own encryption key, the request headers you provide in <a href="AmazonS3/latest/API/API_UploadPart.html">UploadPart</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPartCopy.html">UploadPartCopy</a> requests must match the headers you used in the request to
 *          initiate the upload by using <code>CreateMultipartUpload</code>. </p>
 *          <p>To perform a multipart upload with encryption using an AWS KMS CMK, the requester must
 *          have permission to the <code>kms:Encrypt</code>, <code>kms:Decrypt</code>,
 *             <code>kms:ReEncrypt*</code>, <code>kms:GenerateDataKey*</code>, and
 *             <code>kms:DescribeKey</code> actions on the key. These permissions are required because
 *          Amazon S3 must decrypt and read data from the encrypted file parts before it completes the
 *          multipart upload.</p>
 *
 *          <p>If your AWS Identity and Access Management (IAM) user or role is in the same AWS account
 *          as the AWS KMS CMK, then you must have these permissions on the key policy. If your IAM
 *          user or role belongs to a different account than the key, then you must have the
 *          permissions on both the key policy and your IAM user or role.</p>
 *
 *
 *          <p> For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/serv-side-encryption.html">Protecting
 *             Data Using Server-Side Encryption</a>.</p>
 *
 *          <dl>
 *             <dt>Access Permissions</dt>
 *             <dd>
 *                <p>When copying an object, you can optionally specify the accounts or groups that
 *                   should be granted specific permissions on the new object. There are two ways to
 *                   grant the permissions using the request headers:</p>
 *                <ul>
 *                   <li>
 *                      <p>Specify a canned ACL with the <code>x-amz-acl</code> request header. For
 *                         more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#CannedACL">Canned ACL</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Specify access permissions explicitly with the
 *                            <code>x-amz-grant-read</code>, <code>x-amz-grant-read-acp</code>,
 *                            <code>x-amz-grant-write-acp</code>, and
 *                            <code>x-amz-grant-full-control</code> headers. These parameters map to
 *                         the set of permissions that Amazon S3 supports in an ACL. For more information,
 *                         see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List (ACL)
 *                            Overview</a>.</p>
 *                   </li>
 *                </ul>
 *                <p>You can use either a canned ACL or specify access permissions explicitly. You
 *                   cannot do both.</p>
 *             </dd>
 *             <dt>Server-Side- Encryption-Specific Request Headers</dt>
 *             <dd>
 *                <p>You can optionally tell Amazon S3 to encrypt data at rest using server-side
 *                   encryption. Server-side encryption is for data encryption at rest. Amazon S3 encrypts
 *                   your data as it writes it to disks in its data centers and decrypts it when you
 *                   access it. The option you use depends on whether you want to use AWS managed
 *                   encryption keys or provide your own encryption key. </p>
 *                <ul>
 *                   <li>
 *                      <p>Use encryption keys managed by Amazon S3 or customer master keys (CMKs) stored
 *                         in AWS Key Management Service (AWS KMS) – If you want AWS to manage the keys
 *                         used to encrypt data, specify the following headers in the request.</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-server-side-encryption</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-aws-kms-key-id</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-context</p>
 *                         </li>
 *                      </ul>
 *                      <note>
 *                         <p>If you specify <code>x-amz-server-side-encryption:aws:kms</code>, but
 *                            don't provide <code>x-amz-server-side-encryption-aws-kms-key-id</code>,
 *                            Amazon S3 uses the AWS managed CMK in AWS KMS to protect the data.</p>
 *                      </note>
 *                      <important>
 *                         <p>All GET and PUT requests for an object protected by AWS KMS fail if
 *                            you don't make them with SSL or by using SigV4.</p>
 *                      </important>
 *                      <p>For more information about server-side encryption with CMKs stored in AWS
 *                         KMS (SSE-KMS), see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingKMSEncryption.html">Protecting Data Using Server-Side Encryption with CMKs stored in AWS
 *                            KMS</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Use customer-provided encryption keys – If you want to manage your own
 *                         encryption keys, provide all the following headers in the request.</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-algorithm</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-key</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *                         </li>
 *                      </ul>
 *                      <p>For more information about server-side encryption with CMKs stored in AWS
 *                         KMS (SSE-KMS), see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingKMSEncryption.html">Protecting Data Using Server-Side Encryption with CMKs stored in AWS
 *                            KMS</a>.</p>
 *                   </li>
 *                </ul>
 *             </dd>
 *             <dt>Access-Control-List (ACL)-Specific Request Headers</dt>
 *             <dd>
 *                <p>You also can use the following access control–related headers with this
 *                   operation. By default, all objects are private. Only the owner has full access
 *                   control. When adding a new object, you can grant permissions to individual AWS
 *                   accounts or to predefined groups defined by Amazon S3. These permissions are then added
 *                   to the access control list (ACL) on the object. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3_ACLs_UsingACLs.html">Using ACLs</a>. With this
 *                   operation, you can grant access permissions using one of the following two
 *                   methods:</p>
 *                <ul>
 *                   <li>
 *                      <p>Specify a canned ACL (<code>x-amz-acl</code>) — Amazon S3 supports a set of
 *                         predefined ACLs, known as <i>canned ACLs</i>. Each canned ACL
 *                         has a predefined set of grantees and permissions. For more information, see
 *                            <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#CannedACL">Canned
 *                         ACL</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Specify access permissions explicitly — To explicitly grant access
 *                         permissions to specific AWS accounts or groups, use the following headers.
 *                         Each header maps to specific permissions that Amazon S3 supports in an ACL. For
 *                         more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access
 *                            Control List (ACL) Overview</a>. In the header, you specify a list of
 *                         grantees who get the specific permission. To grant permissions explicitly,
 *                         use:</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-grant-read</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-write</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-read-acp</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-write-acp</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-full-control</p>
 *                         </li>
 *                      </ul>
 *                      <p>You specify each grantee as a type=value pair, where the type is one of
 *                         the following:</p>
 *                      <ul>
 *                         <li>
 *                            <p>
 *                               <code>id</code> – if the value specified is the canonical user ID
 *                               of an AWS account</p>
 *                         </li>
 *                         <li>
 *                            <p>
 *                               <code>uri</code> – if you are granting permissions to a predefined
 *                               group</p>
 *                         </li>
 *                         <li>
 *                            <p>
 *                               <code>emailAddress</code> – if the value specified is the email
 *                               address of an AWS account</p>
 *                            <note>
 *                               <p>Using email addresses to specify a grantee is only supported in the following AWS Regions: </p>
 *                               <ul>
 *                                  <li>
 *                                     <p>US East (N. Virginia)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>US West (N. California)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p> US West (Oregon)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p> Asia Pacific (Singapore)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Asia Pacific (Sydney)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Asia Pacific (Tokyo)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Europe (Ireland)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>South America (São Paulo)</p>
 *                                  </li>
 *                               </ul>
 *                               <p>For a list of all the Amazon S3 supported Regions and endpoints, see <a href="https://docs.aws.amazon.com/general/latest/gr/rande.html#s3_region">Regions and Endpoints</a> in the AWS General Reference.</p>
 *                            </note>
 *                         </li>
 *                      </ul>
 *                      <p>For example, the following <code>x-amz-grant-read</code> header grants the AWS accounts identified by account IDs permissions to read object data and its metadata:</p>
 *                      <p>
 *                         <code>x-amz-grant-read: id="11112222333", id="444455556666" </code>
 *                      </p>
 *                   </li>
 *                </ul>
 *
 *             </dd>
 *          </dl>
 *
 *          <p>The following operations are related to <code>CreateMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $97a978e7d53bee8f$export$76155123c96043b8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CreateMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $9a68e4ce915c38f9$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CreateMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$f65faae2a46e45c2).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$196bb0482ff68428).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$4730de34492fdc2)(input, context);
    };
    CreateMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$95cf7bc6357ae5a8)(output, context);
    };
    return CreateMultipartUploadCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));





var $6867052ed8458e29$export$9c5e83992d724a63;
(function(MetadataEntry) {
    MetadataEntry.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$9c5e83992d724a63 || ($6867052ed8458e29$export$9c5e83992d724a63 = {}));
var $6867052ed8458e29$export$7bb542410b46ffb9;
(function(S3Location) {
    S3Location.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Encryption && {
            Encryption: (0, $a75d087c013e1d7d$export$d60a27d0da10cee5).filterSensitiveLog(obj.Encryption)
        });
    };
})($6867052ed8458e29$export$7bb542410b46ffb9 || ($6867052ed8458e29$export$7bb542410b46ffb9 = {}));
var $6867052ed8458e29$export$cc3fbbd78713fc6c;
(function(OutputLocation) {
    OutputLocation.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.S3 && {
            S3: $6867052ed8458e29$export$7bb542410b46ffb9.filterSensitiveLog(obj.S3)
        });
    };
})($6867052ed8458e29$export$cc3fbbd78713fc6c || ($6867052ed8458e29$export$cc3fbbd78713fc6c = {}));
var $6867052ed8458e29$export$e0a8b40ee8e7958f;
(function(FileHeaderInfo) {
    FileHeaderInfo["IGNORE"] = "IGNORE";
    FileHeaderInfo["NONE"] = "NONE";
    FileHeaderInfo["USE"] = "USE";
})($6867052ed8458e29$export$e0a8b40ee8e7958f || ($6867052ed8458e29$export$e0a8b40ee8e7958f = {}));
var $6867052ed8458e29$export$cd4a4cfd0598253e;
(function(CSVInput) {
    CSVInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$cd4a4cfd0598253e || ($6867052ed8458e29$export$cd4a4cfd0598253e = {}));
var $6867052ed8458e29$export$b8d04dd3765058e2;
(function(JSONType) {
    JSONType["DOCUMENT"] = "DOCUMENT";
    JSONType["LINES"] = "LINES";
})($6867052ed8458e29$export$b8d04dd3765058e2 || ($6867052ed8458e29$export$b8d04dd3765058e2 = {}));
var $6867052ed8458e29$export$1bc8a3cf179ad9c;
(function(JSONInput) {
    JSONInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$1bc8a3cf179ad9c || ($6867052ed8458e29$export$1bc8a3cf179ad9c = {}));
var $6867052ed8458e29$export$a457f185006c756f;
(function(ParquetInput) {
    ParquetInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$a457f185006c756f || ($6867052ed8458e29$export$a457f185006c756f = {}));
var $6867052ed8458e29$export$71ed8fe19d426eb7;
(function(InputSerialization) {
    InputSerialization.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$71ed8fe19d426eb7 || ($6867052ed8458e29$export$71ed8fe19d426eb7 = {}));
var $6867052ed8458e29$export$b4890521754421ba;
(function(QuoteFields) {
    QuoteFields["ALWAYS"] = "ALWAYS";
    QuoteFields["ASNEEDED"] = "ASNEEDED";
})($6867052ed8458e29$export$b4890521754421ba || ($6867052ed8458e29$export$b4890521754421ba = {}));
var $6867052ed8458e29$export$623bc581753795b3;
(function(CSVOutput) {
    CSVOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$623bc581753795b3 || ($6867052ed8458e29$export$623bc581753795b3 = {}));
var $6867052ed8458e29$export$403a844dcc531976;
(function(JSONOutput) {
    JSONOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$403a844dcc531976 || ($6867052ed8458e29$export$403a844dcc531976 = {}));
var $6867052ed8458e29$export$cb22c2d1ef9f03c1;
(function(OutputSerialization) {
    OutputSerialization.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$cb22c2d1ef9f03c1 || ($6867052ed8458e29$export$cb22c2d1ef9f03c1 = {}));
var $6867052ed8458e29$export$722dd036ddb6b3f;
(function(SelectParameters) {
    SelectParameters.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$722dd036ddb6b3f || ($6867052ed8458e29$export$722dd036ddb6b3f = {}));
var $6867052ed8458e29$export$ee855080cc4fa5a8;
(function(RestoreRequestType) {
    RestoreRequestType["SELECT"] = "SELECT";
})($6867052ed8458e29$export$ee855080cc4fa5a8 || ($6867052ed8458e29$export$ee855080cc4fa5a8 = {}));
var $6867052ed8458e29$export$116b002a1c4d25c0;
(function(RestoreRequest) {
    RestoreRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.OutputLocation && {
            OutputLocation: $6867052ed8458e29$export$cc3fbbd78713fc6c.filterSensitiveLog(obj.OutputLocation)
        });
    };
})($6867052ed8458e29$export$116b002a1c4d25c0 || ($6867052ed8458e29$export$116b002a1c4d25c0 = {}));
var $6867052ed8458e29$export$bd1b29d0f94512e7;
(function(RestoreObjectRequest) {
    RestoreObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.RestoreRequest && {
            RestoreRequest: $6867052ed8458e29$export$116b002a1c4d25c0.filterSensitiveLog(obj.RestoreRequest)
        });
    };
})($6867052ed8458e29$export$bd1b29d0f94512e7 || ($6867052ed8458e29$export$bd1b29d0f94512e7 = {}));
var $6867052ed8458e29$export$d20e6aaa08a7363f;
(function(ContinuationEvent) {
    ContinuationEvent.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$d20e6aaa08a7363f || ($6867052ed8458e29$export$d20e6aaa08a7363f = {}));
var $6867052ed8458e29$export$2066b1507471daea;
(function(EndEvent) {
    EndEvent.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$2066b1507471daea || ($6867052ed8458e29$export$2066b1507471daea = {}));
var $6867052ed8458e29$export$b25a304ec7d746bb;
(function(Progress) {
    Progress.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$b25a304ec7d746bb || ($6867052ed8458e29$export$b25a304ec7d746bb = {}));
var $6867052ed8458e29$export$863d066dc35784fb;
(function(ProgressEvent) {
    ProgressEvent.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$863d066dc35784fb || ($6867052ed8458e29$export$863d066dc35784fb = {}));
var $6867052ed8458e29$export$bb48554e89f06bf8;
(function(RecordsEvent) {
    RecordsEvent.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$bb48554e89f06bf8 || ($6867052ed8458e29$export$bb48554e89f06bf8 = {}));
var $6867052ed8458e29$export$3cdec2bba15e3523;
(function(Stats) {
    Stats.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$3cdec2bba15e3523 || ($6867052ed8458e29$export$3cdec2bba15e3523 = {}));
var $6867052ed8458e29$export$72935df6390a4cde;
(function(StatsEvent) {
    StatsEvent.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$72935df6390a4cde || ($6867052ed8458e29$export$72935df6390a4cde = {}));
var $6867052ed8458e29$export$4c951f3462fad8ac;
(function(SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = function(value, visitor) {
        if (value.Records !== undefined) return visitor.Records(value.Records);
        if (value.Stats !== undefined) return visitor.Stats(value.Stats);
        if (value.Progress !== undefined) return visitor.Progress(value.Progress);
        if (value.Cont !== undefined) return visitor.Cont(value.Cont);
        if (value.End !== undefined) return visitor.End(value.End);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SelectObjectContentEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Records !== undefined) return {
            Records: $6867052ed8458e29$export$bb48554e89f06bf8.filterSensitiveLog(obj.Records)
        };
        if (obj.Stats !== undefined) return {
            Stats: $6867052ed8458e29$export$72935df6390a4cde.filterSensitiveLog(obj.Stats)
        };
        if (obj.Progress !== undefined) return {
            Progress: $6867052ed8458e29$export$863d066dc35784fb.filterSensitiveLog(obj.Progress)
        };
        if (obj.Cont !== undefined) return {
            Cont: $6867052ed8458e29$export$d20e6aaa08a7363f.filterSensitiveLog(obj.Cont)
        };
        if (obj.End !== undefined) return {
            End: $6867052ed8458e29$export$2066b1507471daea.filterSensitiveLog(obj.End)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($6867052ed8458e29$export$4c951f3462fad8ac || ($6867052ed8458e29$export$4c951f3462fad8ac = {}));
var $6867052ed8458e29$export$5bf8ed4e571234e3;
(function(SelectObjectContentOutput) {
    SelectObjectContentOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.Payload && {
            Payload: "STREAMING_CONTENT"
        });
    };
})($6867052ed8458e29$export$5bf8ed4e571234e3 || ($6867052ed8458e29$export$5bf8ed4e571234e3 = {}));
var $6867052ed8458e29$export$b8081f25e3a7bfbd;
(function(RequestProgress) {
    RequestProgress.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$b8081f25e3a7bfbd || ($6867052ed8458e29$export$b8081f25e3a7bfbd = {}));
var $6867052ed8458e29$export$33f7c3433c085364;
(function(ScanRange) {
    ScanRange.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$33f7c3433c085364 || ($6867052ed8458e29$export$33f7c3433c085364 = {}));
var $6867052ed8458e29$export$852c159401aad03e;
(function(SelectObjectContentRequest) {
    SelectObjectContentRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($6867052ed8458e29$export$852c159401aad03e || ($6867052ed8458e29$export$852c159401aad03e = {}));
var $6867052ed8458e29$export$1e083fd90afa2f51;
(function(UploadPartOutput) {
    UploadPartOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($6867052ed8458e29$export$1e083fd90afa2f51 || ($6867052ed8458e29$export$1e083fd90afa2f51 = {}));
var $6867052ed8458e29$export$ecf841796ea7b1f0;
(function(UploadPartRequest) {
    UploadPartRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($6867052ed8458e29$export$ecf841796ea7b1f0 || ($6867052ed8458e29$export$ecf841796ea7b1f0 = {}));
var $6867052ed8458e29$export$ff4e5952953c0084;
(function(CopyPartResult) {
    CopyPartResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($6867052ed8458e29$export$ff4e5952953c0084 || ($6867052ed8458e29$export$ff4e5952953c0084 = {}));
var $6867052ed8458e29$export$d6a8bd15a4edcee7;
(function(UploadPartCopyOutput) {
    UploadPartCopyOutput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($6867052ed8458e29$export$d6a8bd15a4edcee7 || ($6867052ed8458e29$export$d6a8bd15a4edcee7 = {}));
var $6867052ed8458e29$export$b68c35e4811b33e;
(function(UploadPartCopyRequest) {
    UploadPartCopyRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $a2e835843b722421$export$17127055dc9ac067)
        });
    };
})($6867052ed8458e29$export$b68c35e4811b33e || ($6867052ed8458e29$export$b68c35e4811b33e = {}));







/**
 * <p>Uploads a part in a multipart upload.</p>
 *          <note>
 *             <p>In this operation, you provide part data in your request. However, you have an option
 *             to specify your existing Amazon S3 object as a data source for the part you are uploading. To
 *             upload a part from an existing object, you use the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPartCopy.html">UploadPartCopy</a> operation.
 *          </p>
 *          </note>
 *
 *          <p>You must initiate a multipart upload (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>)
 *          before you can upload any part. In response to your initiate request, Amazon S3 returns an
 *          upload ID, a unique identifier, that you must include in your upload part request.</p>
 *          <p>Part numbers can be any number from 1 to 10,000, inclusive. A part number uniquely
 *          identifies a part and also defines its position within the object being created. If you
 *          upload a new part using the same part number that was used with a previous part, the
 *          previously uploaded part is overwritten. Each part must be at least 5 MB in size, except
 *          the last part. There is no size limit on the last part of your multipart upload.</p>
 *          <p>To ensure that data is not corrupted when traversing the network, specify the
 *             <code>Content-MD5</code> header in the upload part request. Amazon S3 checks the part data
 *          against the provided MD5 value. If they do not match, Amazon S3 returns an error. </p>
 *
 *          <p>If the upload request is signed with Signature Version 4, then AWS S3 uses the
 *             <code>x-amz-content-sha256</code> header as a checksum instead of
 *             <code>Content-MD5</code>. For more information see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-auth-using-authorization-header.html">Authenticating Requests: Using the Authorization Header (AWS Signature Version
 *             4)</a>. </p>
 *
 *
 *
 *          <p>
 *             <b>Note:</b> After you initiate multipart upload and upload
 *          one or more parts, you must either complete or abort multipart upload in order to stop
 *          getting charged for storage of the uploaded parts. Only after you either complete or abort
 *          multipart upload, Amazon S3 frees up the parts storage and stops charging you for the parts
 *          storage.</p>
 *
 *          <p>For more information on multipart uploads, go to <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html">Multipart Upload Overview</a> in the
 *             <i>Amazon Simple Storage Service Developer Guide </i>.</p>
 *          <p>For information on the permissions required to use the multipart upload API, go to
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *             Permissions</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *
 *          <p>You can optionally request server-side encryption where Amazon S3 encrypts your data as it
 *          writes it to disks in its data centers and decrypts it for you when you access it. You have
 *          the option of providing your own encryption key, or you can use the AWS managed encryption
 *          keys. If you choose to provide your own encryption key, the request headers you provide in
 *          the request must match the headers you used in the request to initiate the upload by using
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>. For more information, go to <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingServerSideEncryption.html">Using Server-Side Encryption</a> in
 *          the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *
 *          <p>Server-side encryption is supported by the S3 Multipart Upload actions. Unless you are
 *          using a customer-provided encryption key, you don't need to specify the encryption
 *          parameters in each UploadPart request. Instead, you only need to specify the server-side
 *          encryption parameters in the initial Initiate Multipart request. For more information, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>.</p>
 *
 *          <p>If you requested server-side encryption using a customer-provided encryption key in your
 *          initiate multipart upload request, you must provide identical encryption information in
 *          each part upload using the following headers.</p>
 *
 *
 *          <ul>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-algorithm</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *             </li>
 *          </ul>
 *
 *          <p class="title">
 *             <b>Special Errors</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <ul>
 *                   <li>
 *                      <p>
 *                         <i>Code: NoSuchUpload</i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i>Cause: The specified multipart upload does not exist. The upload
 *                         ID might be invalid, or the multipart upload might have been aborted or
 *                         completed.</i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i> HTTP Status Code: 404 Not Found </i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i>SOAP Fault Code Prefix: Client</i>
 *                      </p>
 *                   </li>
 *                </ul>
 *             </li>
 *          </ul>
 *
 *
 *
 *
 *
 *
 *          <p class="title">
 *             <b>Related Resources</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $c20e149c877e753b$export$20fd13f6cebe56f0 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(UploadPartCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UploadPartCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ UploadPartCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $9a68e4ce915c38f9$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "UploadPartCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $6867052ed8458e29$export$ecf841796ea7b1f0).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $6867052ed8458e29$export$1e083fd90afa2f51).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UploadPartCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$6dfc42032d3f37d4)(input, context);
    };
    UploadPartCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$176ef954f1bec178)(output, context);
    };
    return UploadPartCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));








/**
 * <p>Completes a multipart upload by assembling previously uploaded parts.</p>
 *          <p>You first initiate the multipart upload and then upload all parts using the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *          operation. After successfully uploading all relevant parts of an upload, you call this
 *          operation to complete the upload. Upon receiving this request, Amazon S3 concatenates all
 *          the parts in ascending order by part number to create a new object. In the Complete
 *          Multipart Upload request, you must provide the parts list. You must ensure that the parts
 *          list is complete. This operation concatenates the parts that you provide in the list. For
 *          each part in the list, you must provide the part number and the <code>ETag</code> value,
 *          returned after that part was uploaded.</p>
 *          <p>Processing of a Complete Multipart Upload request could take several minutes to
 *          complete. After Amazon S3 begins processing the request, it sends an HTTP response header that
 *          specifies a 200 OK response. While processing is in progress, Amazon S3 periodically sends white
 *          space characters to keep the connection from timing out. Because a request could fail after
 *          the initial 200 OK response has been sent, it is important that you check the response body
 *          to determine whether the request succeeded.</p>
 *          <p>Note that if <code>CompleteMultipartUpload</code> fails, applications should be prepared
 *          to retry the failed requests. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/ErrorBestPractices.html">Amazon S3 Error Best Practices</a>.</p>
 *          <p>For more information about multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/uploadobjusingmpu.html">Uploading Objects Using Multipart
 *             Upload</a>.</p>
 *          <p>For information about permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *
 *
 *          <p>
 *             <code>CompleteMultipartUpload</code> has the following special errors:</p>
 *          <ul>
 *             <li>
 *                <p>Error code: <code>EntityTooSmall</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: Your proposed upload is smaller than the minimum allowed object
 *                      size. Each part must be at least 5 MB in size, except the last part.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>InvalidPart</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: One or more of the specified parts could not be found. The part
 *                      might not have been uploaded, or the specified entity tag might not have
 *                      matched the part's entity tag.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>InvalidPartOrder</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: The list of parts was not in ascending order. The parts list
 *                      must be specified in order by part number.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>NoSuchUpload</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: The specified multipart upload does not exist. The upload ID
 *                      might be invalid, or the multipart upload might have been aborted or
 *                      completed.</p>
 *                   </li>
 *                   <li>
 *                      <p>404 Not Found</p>
 *                   </li>
 *                </ul>
 *             </li>
 *          </ul>
 *
 *          <p>The following operations are related to <code>CompleteMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $8f6bfcb4e589f667$export$f827ea0301b4eeff = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CompleteMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CompleteMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CompleteMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $2f72a11a979d95c5$export$97cbbd0d754f3189)(configuration));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CompleteMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$2998881f143b41ec).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$edcc5df28126c9bc).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CompleteMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$2a09fb9495f08c55)(input, context);
    };
    CompleteMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$ee5aaa25931389ce)(output, context);
    };
    return CompleteMultipartUploadCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));







/**
 * <p>This operation aborts a multipart upload. After a multipart upload is aborted, no
 *          additional parts can be uploaded using that upload ID. The storage consumed by any
 *          previously uploaded parts will be freed. However, if any part uploads are currently in
 *          progress, those part uploads might or might not succeed. As a result, it might be necessary
 *          to abort a given multipart upload multiple times in order to completely free all storage
 *          consumed by all parts. </p>
 *          <p>To verify that all parts have been removed, so you don't get charged for the part
 *          storage, you should call the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a> operation and ensure that
 *          the parts list is empty.</p>
 *          <p>For information about permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *          <p>The following operations are related to <code>AbortMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $7a53e01981486cf1$export$87d2388f8662d995 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AbortMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function AbortMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ AbortMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "AbortMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$2509116d04cdd782).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$80a5621784397e06).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AbortMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$a7d2d025c66f9235)(input, context);
    };
    AbortMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$87447564e9ee4b69)(output, context);
    };
    return AbortMultipartUploadCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));







/**
 * <p>Lists the parts that have been uploaded for a specific multipart upload. This operation
 *          must include the upload ID, which you obtain by sending the initiate multipart upload
 *          request (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>).
 *          This request returns a maximum of 1,000 uploaded parts. The default number of parts
 *          returned is 1,000 parts. You can restrict the number of parts returned by specifying the
 *             <code>max-parts</code> request parameter. If your multipart upload consists of more than
 *          1,000 parts, the response returns an <code>IsTruncated</code> field with the value of true,
 *          and a <code>NextPartNumberMarker</code> element. In subsequent <code>ListParts</code>
 *          requests you can include the part-number-marker query string parameter and set its value to
 *          the <code>NextPartNumberMarker</code> field value from the previous response.</p>
 *
 *          <p>For more information on multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/uploadobjusingmpu.html">Uploading Objects Using Multipart
 *             Upload</a>.</p>
 *
 *          <p>For information on permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *
 *          <p>The following operations are related to <code>ListParts</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $b5572f3d5f392603$export$17fb27d830090508 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ListPartsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListPartsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ ListPartsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7380dd9cf39fedd9$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $8e8aaee3d42fae4c$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListPartsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$756cf37efa2403e6).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $a75d087c013e1d7d$export$8c83b46649a5c089).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListPartsCommand.prototype.serialize = function(input, context) {
        return (0, $748b18c285b09559$export$b2b39cf3937e8c76)(input, context);
    };
    ListPartsCommand.prototype.deserialize = function(output, context) {
        return (0, $748b18c285b09559$export$584d994fd27ec2bb)(output, context);
    };
    return ListPartsCommand;
}((0, $0287324a59c7b0be$export$cc7e12c76513e857));



var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}



var $fd8ad2a2fc82e91d$var$__assign = undefined && undefined.__assign || function() {
    $fd8ad2a2fc82e91d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fd8ad2a2fc82e91d$var$__assign.apply(this, arguments);
};
var $fd8ad2a2fc82e91d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fd8ad2a2fc82e91d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fd8ad2a2fc82e91d$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("AWSS3ProviderManagedUpload");
var $fd8ad2a2fc82e91d$export$da75ae8ad0285104 = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        // Defaults
        this.minPartSize = 5242880; // in MB
        this.queueSize = 4;
        // Data for current upload
        this.body = null;
        this.params = null;
        this.opts = null;
        this.completedParts = [];
        this.uploadId = null;
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = opts;
        this.emitter = emitter;
        this.s3client = this._createNewS3Client(opts, emitter);
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return $fd8ad2a2fc82e91d$var$__awaiter(this, void 0, void 0, function() {
            var _a, putObjectCommand, _b, numberOfPartsToUpload, parts, start, error_1;
            var _this = this;
            return $fd8ad2a2fc82e91d$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            10,
                            ,
                            12
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.validateAndSanitizeBody(this.params.Body)
                        ];
                    case 1:
                        _a.body = _c.sent();
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= this.minPartSize)) return [
                            3 /*break*/ ,
                            2
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        putObjectCommand = new (0, $993df36854c53178$export$4afa2352f8871c26)(this.params);
                        return [
                            2 /*return*/ ,
                            this.s3client.send(putObjectCommand)
                        ];
                    case 2:
                        // Step 1: Initiate the multi part upload
                        _b = this;
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 3:
                        // Step 1: Initiate the multi part upload
                        _b.uploadId = _c.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.minPartSize);
                        parts = this.createParts();
                        start = 0;
                        _c.label = 4;
                    case 4:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            7
                        ];
                        // Upload as many as `queueSize` parts simultaneously
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(this.uploadId, parts.slice(start, start + this.queueSize))
                        ];
                    case 5:
                        // Upload as many as `queueSize` parts simultaneously
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        start += this.queueSize;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 7:
                        parts.map(function(part) {
                            _this.removeEventListener(part);
                        });
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(this.uploadId)
                        ];
                    case 8:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        error_1 = _c.sent();
                        // if any error is thrown, call cleanup
                        return [
                            4 /*yield*/ ,
                            this.cleanup(this.uploadId)
                        ];
                    case 11:
                        // if any error is thrown, call cleanup
                        _c.sent();
                        $fd8ad2a2fc82e91d$var$logger.error("Error. Cancelling the multipart upload.");
                        throw error_1;
                    case 12:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function() {
        try {
            var parts = [];
            for(var bodyStart = 0; bodyStart < this.totalBytesToUpload;){
                var bodyEnd = Math.min(bodyStart + this.minPartSize, this.totalBytesToUpload);
                parts.push({
                    bodyPart: this.body.slice(bodyStart, bodyEnd),
                    partNumber: parts.length + 1,
                    emitter: new $5440e9199a418654$exports.EventEmitter(),
                    _lastUploadedBytes: 0
                });
                bodyStart += this.minPartSize;
            }
            return parts;
        } catch (error) {
            $fd8ad2a2fc82e91d$var$logger.error(error);
            throw error;
        }
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return $fd8ad2a2fc82e91d$var$__awaiter(this, void 0, void 0, function() {
            var createMultiPartUploadCommand, response, error_2;
            return $fd8ad2a2fc82e91d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        createMultiPartUploadCommand = new (0, $97a978e7d53bee8f$export$76155123c96043b8)(this.params);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(createMultiPartUploadCommand)
                        ];
                    case 1:
                        response = _a.sent();
                        $fd8ad2a2fc82e91d$var$logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                    case 2:
                        error_2 = _a.sent();
                        $fd8ad2a2fc82e91d$var$logger.error(error_2);
                        throw error_2;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return $fd8ad2a2fc82e91d$var$__awaiter(this, void 0, void 0, function() {
            var allResults, i, error_3;
            var _this = this;
            return $fd8ad2a2fc82e91d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(parts.map(function(part) {
                                return $fd8ad2a2fc82e91d$var$__awaiter(_this, void 0, void 0, function() {
                                    var options, _a, Key, Bucket, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, res;
                                    return $fd8ad2a2fc82e91d$var$__generator(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                this.setupEventListener(part);
                                                options = {
                                                    emitter: part.emitter
                                                };
                                                _a = this.params, Key = _a.Key, Bucket = _a.Bucket, SSECustomerAlgorithm = _a.SSECustomerAlgorithm, SSECustomerKey = _a.SSECustomerKey, SSECustomerKeyMD5 = _a.SSECustomerKeyMD5;
                                                return [
                                                    4 /*yield*/ ,
                                                    this.s3client.send(new (0, $c20e149c877e753b$export$20fd13f6cebe56f0)($fd8ad2a2fc82e91d$var$__assign($fd8ad2a2fc82e91d$var$__assign($fd8ad2a2fc82e91d$var$__assign({
                                                        PartNumber: part.partNumber,
                                                        Body: part.bodyPart,
                                                        UploadId: uploadId,
                                                        Key: Key,
                                                        Bucket: Bucket
                                                    }, SSECustomerAlgorithm && {
                                                        SSECustomerAlgorithm: SSECustomerAlgorithm
                                                    }), SSECustomerKey && {
                                                        SSECustomerKey: SSECustomerKey
                                                    }), SSECustomerKeyMD5 && {
                                                        SSECustomerKeyMD5: SSECustomerKeyMD5
                                                    })), options)
                                                ];
                                            case 1:
                                                res = _b.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    res
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        allResults = _a.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.completedParts.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $fd8ad2a2fc82e91d$var$logger.error("Error happened while uploading a part. Cancelling the multipart upload");
                        throw error_3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return $fd8ad2a2fc82e91d$var$__awaiter(this, void 0, void 0, function() {
            var input, completeUploadCommand, data, error_4;
            return $fd8ad2a2fc82e91d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId,
                            MultipartUpload: {
                                Parts: this.completedParts
                            }
                        };
                        completeUploadCommand = new (0, $8f6bfcb4e589f667$export$f827ea0301b4eeff)(input);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(completeUploadCommand)
                        ];
                    case 2:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            data.Key
                        ];
                    case 3:
                        error_4 = _a.sent();
                        $fd8ad2a2fc82e91d$var$logger.error("Error happened while finishing the upload.");
                        throw error_4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return $fd8ad2a2fc82e91d$var$__awaiter(this, void 0, void 0, function() {
            var input, data;
            return $fd8ad2a2fc82e91d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId
                        };
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $7a53e01981486cf1$export$87d2388f8662d995)(input))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $b5572f3d5f392603$export$17fb27d830090508)(input))
                        ];
                    case 2:
                        data = _a.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error("Multipart upload clean up failed.");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.removeEventListener = function(part) {
        part.emitter.removeAllListeners((0, $5da18860f75886e9$export$c5e6923933be22a0));
        part.emitter.removeAllListeners((0, $5da18860f75886e9$export$660a92f3322ba11a));
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, $5da18860f75886e9$export$c5e6923933be22a0), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, $5da18860f75886e9$export$c5e6923933be22a0), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === "number") return input.byteLength;
        else if (typeof input.length === "number") return input.length;
        else if (typeof input.size === "number") return input.size;
        else if (typeof input.path === "string") ;
        else throw new Error("Cannot determine length of " + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        return $fd8ad2a2fc82e91d$var$__awaiter(this, void 0, void 0, function() {
            return $fd8ad2a2fc82e91d$var$__generator(this, function(_a) {
                if (this.isGenericObject(body)) // Any javascript object
                return [
                    2 /*return*/ ,
                    JSON.stringify(body)
                ];
                else // Files, arrayBuffer etc
                return [
                    2 /*return*/ ,
                    body
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === "object") try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    AWSS3ProviderManagedUpload.prototype._createNewS3Client = function(config, emitter) {
        var s3client = (0, $40959b47ff8c567f$export$4cdd37a0748e6ad9)(config, emitter);
        s3client.middlewareStack.add((0, $40959b47ff8c567f$export$95bc4f3188064861)(this.opts, this.params.Key), (0, $40959b47ff8c567f$export$52daf78b33f1adcd));
        s3client.middlewareStack.add((0, $40959b47ff8c567f$export$d1971fb9f9448f)(s3client.config), (0, $40959b47ff8c567f$export$2edd0200412be327));
        return s3client;
    };
    return AWSS3ProviderManagedUpload;
}();








var $e669222ae6fd056b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e669222ae6fd056b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e669222ae6fd056b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e669222ae6fd056b$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e669222ae6fd056b$var$__read(arguments[i]));
    return ar;
};
var $e669222ae6fd056b$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("AWSS3UploadTask");
var $e669222ae6fd056b$export$badc82e7c9337824;
(function(AWSS3UploadTaskState) {
    AWSS3UploadTaskState[AWSS3UploadTaskState["INIT"] = 0] = "INIT";
    AWSS3UploadTaskState[AWSS3UploadTaskState["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AWSS3UploadTaskState[AWSS3UploadTaskState["PAUSED"] = 2] = "PAUSED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["CANCELLED"] = 3] = "CANCELLED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["COMPLETED"] = 4] = "COMPLETED";
})($e669222ae6fd056b$export$badc82e7c9337824 || ($e669222ae6fd056b$export$badc82e7c9337824 = {}));
var $e669222ae6fd056b$export$1c9379601995aced;
(function(TaskEvents) {
    TaskEvents["CANCEL"] = "cancel";
    TaskEvents["UPLOAD_COMPLETE"] = "uploadComplete";
    TaskEvents["UPLOAD_PROGRESS"] = "uploadPartProgress";
    TaskEvents["ERROR"] = "error";
})($e669222ae6fd056b$export$1c9379601995aced || ($e669222ae6fd056b$export$1c9379601995aced = {}));
// maximum number of parts per upload request according the S3 spec,
// see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/qfacts.html
var $e669222ae6fd056b$var$MAX_PARTS = 10000;
// 5MB in bytes
var $e669222ae6fd056b$var$PART_SIZE = 5242880;
var $e669222ae6fd056b$var$DEFAULT_QUEUE_SIZE = 4;
function $e669222ae6fd056b$var$comparePartNumber(a, b) {
    return a.PartNumber - b.PartNumber;
}
var $e669222ae6fd056b$export$ca4ab80441206528 = /** @class */ function() {
    function AWSS3UploadTask(_a) {
        var s3Client = _a.s3Client, file = _a.file, emitter = _a.emitter, storage = _a.storage, params = _a.params, level = _a.level, prefixPromise = _a.prefixPromise;
        this.partSize = $e669222ae6fd056b$var$PART_SIZE;
        this.queueSize = $e669222ae6fd056b$var$DEFAULT_QUEUE_SIZE;
        this.inProgress = [];
        this.completedParts = [];
        this.queued = [];
        this.bytesUploaded = 0;
        this.totalBytes = 0;
        this.state = $e669222ae6fd056b$export$badc82e7c9337824.INIT;
        this.prefixPromise = prefixPromise;
        this.s3client = s3Client;
        this.s3client.middlewareStack.remove((0, $a77011a119d9fd1c$export$8179b8ba0ab1e018));
        this.storage = storage;
        this.storageSync = Promise.resolve();
        if (typeof this.storage["sync"] === "function") this.storageSync = this.storage["sync"]();
        this.params = params;
        this.file = file;
        this.totalBytes = this.file.size;
        this.bytesUploaded = 0;
        this.emitter = emitter;
        this.queued = [];
        this.fileId = this._getFileId(level);
        this._validateParams();
        // event emitter will re-throw an error if an event emits an error unless there's a listener, attaching a no-op
        // function to it unless user adds their own onError callback
        this.emitter.on($e669222ae6fd056b$export$1c9379601995aced.ERROR, function() {});
    }
    Object.defineProperty(AWSS3UploadTask.prototype, "percent", {
        get: function() {
            return this.bytesUploaded / this.totalBytes * 100;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AWSS3UploadTask.prototype, "isInProgress", {
        get: function() {
            return this.state === $e669222ae6fd056b$export$badc82e7c9337824.IN_PROGRESS;
        },
        enumerable: true,
        configurable: true
    });
    AWSS3UploadTask.prototype._listSingleFile = function(_a) {
        var key = _a.key, bucket = _a.bucket;
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var listObjectRes, _b, Contents, prefix, obj;
            return $e669222ae6fd056b$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $3859c4d3df57bfa7$export$479061a53a55f030)({
                                Bucket: bucket,
                                Prefix: key
                            }))
                        ];
                    case 1:
                        listObjectRes = _c.sent();
                        _b = listObjectRes.Contents, Contents = _b === void 0 ? [] : _b;
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 2:
                        prefix = _c.sent();
                        obj = Contents.find(function(o) {
                            return o.Key === "" + prefix + key;
                        });
                        return [
                            2 /*return*/ ,
                            obj
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._getFileId = function(level) {
        // We should check if it's a File first because File is also instance of a Blob
        if ((0, $6b11143ba342dd3c$export$be78b3111c50efdd)(this.file)) return [
            this.file.name,
            this.file.lastModified,
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
        else return [
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
    };
    AWSS3UploadTask.prototype._findCachedUploadParts = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests, cachedUploadFileData, listPartsOutput;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        if (Object.keys(uploadRequests).length === 0 || !Object.prototype.hasOwnProperty.call(uploadRequests, this.fileId)) return [
                            2 /*return*/ ,
                            {
                                parts: [],
                                uploadId: null
                            }
                        ];
                        cachedUploadFileData = uploadRequests[this.fileId];
                        cachedUploadFileData.lastTouched = Date.now();
                        this.storage.setItem((0, $a77011a119d9fd1c$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $b5572f3d5f392603$export$17fb27d830090508)({
                                Bucket: this.params.Bucket,
                                Key: this.params.Key,
                                UploadId: cachedUploadFileData.uploadId
                            }))
                        ];
                    case 2:
                        listPartsOutput = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                parts: listPartsOutput.Parts || [],
                                uploadId: cachedUploadFileData.uploadId
                            }
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._emitEvent = function(event, payload) {
        this.emitter.emit(event, payload);
    };
    AWSS3UploadTask.prototype._validateParams = function() {
        if (this.file.size / this.partSize > $e669222ae6fd056b$var$MAX_PARTS) throw new Error("Too many parts. Number of parts is " + this.file.size / this.partSize + ", maximum is " + $e669222ae6fd056b$var$MAX_PARTS + ".");
    };
    AWSS3UploadTask.prototype._listCachedUploadTasks = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var tasks;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storageSync
                        ];
                    case 1:
                        _a.sent();
                        tasks = this.storage.getItem((0, $a77011a119d9fd1c$export$b9acc545d1bd0170)) || "{}";
                        return [
                            2 /*return*/ ,
                            JSON.parse(tasks)
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._cache = function(fileMetadata) {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        uploadRequests[this.fileId] = fileMetadata;
                        this.storage.setItem((0, $a77011a119d9fd1c$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isCached = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b;
            return $e669222ae6fd056b$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = Object.prototype.hasOwnProperty).call;
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.apply(_a, [
                                _c.sent(),
                                this.fileId
                            ])
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._removeFromCache = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        delete uploadRequests[this.fileId];
                        this.storage.setItem((0, $a77011a119d9fd1c$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._onPartUploadCompletion = function(_a) {
        var eTag = _a.eTag, partNumber = _a.partNumber, chunk = _a.chunk;
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            return $e669222ae6fd056b$var$__generator(this, function(_b) {
                this.completedParts.push({
                    ETag: eTag,
                    PartNumber: partNumber
                });
                this.bytesUploaded += (0, $6b11143ba342dd3c$export$a48f0734ac7c2329)(chunk);
                this._emitEvent($e669222ae6fd056b$export$1c9379601995aced.UPLOAD_PROGRESS, {
                    loaded: this.bytesUploaded,
                    total: this.totalBytes
                });
                // Remove the completed item from the inProgress array
                this.inProgress = this.inProgress.filter(function(job) {
                    return job.uploadPartInput.PartNumber !== partNumber;
                });
                if (this.queued.length && this.state !== $e669222ae6fd056b$export$badc82e7c9337824.PAUSED) this._startNextPart();
                if (this._isDone()) this._completeUpload();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3UploadTask.prototype._completeUpload = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var err_1;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $8f6bfcb4e589f667$export$f827ea0301b4eeff)({
                                Bucket: this.params.Bucket,
                                Key: this.params.Key,
                                UploadId: this.uploadId,
                                MultipartUpload: {
                                    // Parts are not always completed in order, we need to manually sort them
                                    Parts: this.completedParts.sort($e669222ae6fd056b$var$comparePartNumber)
                                }
                            }))
                        ];
                    case 1:
                        _a.sent();
                        this._verifyFileSize();
                        this._emitEvent($e669222ae6fd056b$export$1c9379601995aced.UPLOAD_COMPLETE, {
                            key: this.params.Bucket + "/" + this.params.Key
                        });
                        this._removeFromCache();
                        this.state = $e669222ae6fd056b$export$badc82e7c9337824.COMPLETED;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        err_1 = _a.sent();
                        $e669222ae6fd056b$var$logger.error("error completing upload", err_1);
                        this._emitEvent($e669222ae6fd056b$export$1c9379601995aced.ERROR, err_1);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._makeUploadPartRequest = function(input, cancelTokenSource) {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var res, err_2;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $c20e149c877e753b$export$20fd13f6cebe56f0)(input), {
                                cancelTokenSource: cancelTokenSource
                            })
                        ];
                    case 1:
                        res = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this._onPartUploadCompletion({
                                eTag: res.ETag,
                                partNumber: input.PartNumber,
                                chunk: input.Body
                            })
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_2 = _a.sent();
                        if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.PAUSED) $e669222ae6fd056b$var$logger.log("upload paused");
                        else if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.CANCELLED) $e669222ae6fd056b$var$logger.log("upload aborted");
                        else $e669222ae6fd056b$var$logger.error("error starting next part of upload: ", err_2);
                        // axios' cancel will also throw an error, however we don't need to emit an event in that case as it's an
                        // expected behavior
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).isCancel(err_2) && err_2.message !== (0, $5c596c808c2de5fe$export$179814ca32efa022).UPLOAD_PAUSED_MESSAGE) {
                            this._emitEvent($e669222ae6fd056b$export$1c9379601995aced.ERROR, err_2);
                            this.pause();
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._startNextPart = function() {
        if (this.queued.length > 0 && this.state !== $e669222ae6fd056b$export$badc82e7c9337824.PAUSED) {
            var cancelTokenSource = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).CancelToken.source();
            var nextPart = this.queued.shift();
            this.inProgress.push({
                uploadPartInput: nextPart,
                s3Request: this._makeUploadPartRequest(nextPart, cancelTokenSource),
                cancel: cancelTokenSource.cancel
            });
        }
    };
    /**
     * Verify on S3 side that the file size matches the one on the client side.
     *
     * @async
     * @throws throws an error if the file size does not match between local copy of the file and the file on s3.
     */ AWSS3UploadTask.prototype._verifyFileSize = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var obj, valid;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listSingleFile({
                                key: this.params.Key,
                                bucket: this.params.Bucket
                            })
                        ];
                    case 1:
                        obj = _a.sent();
                        valid = Boolean(obj && obj.Size === this.file.size);
                        if (!valid) throw new Error("File size does not match between local file and file on s3");
                        return [
                            2 /*return*/ ,
                            valid
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isDone = function() {
        return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    };
    AWSS3UploadTask.prototype._createParts = function() {
        var size = this.file.size;
        var parts = [];
        for(var bodyStart = 0; bodyStart < size;){
            var bodyEnd = Math.min(bodyStart + this.partSize, size);
            parts.push({
                Body: this.file.slice(bodyStart, bodyEnd),
                Key: this.params.Key,
                Bucket: this.params.Bucket,
                PartNumber: parts.length + 1,
                UploadId: this.uploadId
            });
            bodyStart += this.partSize;
        }
        return parts;
    };
    AWSS3UploadTask.prototype._initCachedUploadParts = function(cachedParts) {
        this.bytesUploaded += cachedParts.reduce(function(acc, part) {
            return acc + part.Size;
        }, 0);
        // Find the set of part numbers that have already been uploaded
        var uploadedPartNumSet = new Set(cachedParts.map(function(part) {
            return part.PartNumber;
        }));
        this.queued = this.queued.filter(function(part) {
            return !uploadedPartNumSet.has(part.PartNumber);
        });
        this.completedParts = cachedParts.map(function(part) {
            return {
                PartNumber: part.PartNumber,
                ETag: part.ETag
            };
        });
        this._emitEvent($e669222ae6fd056b$export$1c9379601995aced.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
        });
    };
    AWSS3UploadTask.prototype._initMultipartUpload = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var res;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $97a978e7d53bee8f$export$76155123c96043b8)(this.params))
                        ];
                    case 1:
                        res = _a.sent();
                        this._cache({
                            uploadId: res.UploadId,
                            lastTouched: Date.now(),
                            bucket: this.params.Bucket,
                            key: this.params.Key,
                            fileName: this.file instanceof File ? this.file.name : ""
                        });
                        return [
                            2 /*return*/ ,
                            res.UploadId
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._initializeUploadTask = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var _a, parts, uploadId, uploadId, err_3;
            return $e669222ae6fd056b$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.state = $e669222ae6fd056b$export$badc82e7c9337824.IN_PROGRESS;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._isCached()
                        ];
                    case 2:
                        if (!_b.sent()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._findCachedUploadParts()
                        ];
                    case 3:
                        _a = _b.sent(), parts = _a.parts, uploadId = _a.uploadId;
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._initCachedUploadParts(parts);
                        this._startUpload();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        if (!!this.uploadId) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._initMultipartUpload()
                        ];
                    case 5:
                        uploadId = _b.sent();
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._startUpload();
                        _b.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        err_3 = _b.sent();
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).isCancel(err_3)) $e669222ae6fd056b$var$logger.error("Error initializing the upload task", err_3);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype.resume = function() {
        if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.CANCELLED) $e669222ae6fd056b$var$logger.warn("This task has already been cancelled");
        else if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.COMPLETED) $e669222ae6fd056b$var$logger.warn("This task has already been completed");
        else if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.IN_PROGRESS) $e669222ae6fd056b$var$logger.warn("Upload task already in progress");
        else if (!this.uploadId) this._initializeUploadTask();
        else this._startUpload();
    };
    AWSS3UploadTask.prototype._startUpload = function() {
        this.state = $e669222ae6fd056b$export$badc82e7c9337824.IN_PROGRESS;
        for(var i = 0; i < this.queueSize; i++)this._startNextPart();
    };
    AWSS3UploadTask.prototype._cancel = function() {
        return $e669222ae6fd056b$var$__awaiter(this, void 0, void 0, function() {
            var err_4;
            return $e669222ae6fd056b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.state === $e669222ae6fd056b$export$badc82e7c9337824.CANCELLED)) return [
                            3 /*break*/ ,
                            1
                        ];
                        $e669222ae6fd056b$var$logger.warn("This task has already been cancelled");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 1:
                        if (!(this.state === $e669222ae6fd056b$export$badc82e7c9337824.COMPLETED)) return [
                            3 /*break*/ ,
                            2
                        ];
                        $e669222ae6fd056b$var$logger.warn("This task has already been completed");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 2:
                        this.pause();
                        this.queued = [];
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.state = $e669222ae6fd056b$export$badc82e7c9337824.CANCELLED;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([
                            3,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $7a53e01981486cf1$export$87d2388f8662d995)({
                                Bucket: this.params.Bucket,
                                Key: this.params.Key,
                                UploadId: this.uploadId
                            }))
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this._removeFromCache()
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 6:
                        err_4 = _a.sent();
                        $e669222ae6fd056b$var$logger.error("Error cancelling upload task", err_4);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * pause this particular upload task
     **/ AWSS3UploadTask.prototype.pause = function() {
        var _a;
        if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.CANCELLED) $e669222ae6fd056b$var$logger.warn("This task has already been cancelled");
        else if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.COMPLETED) $e669222ae6fd056b$var$logger.warn("This task has already been completed");
        else if (this.state === $e669222ae6fd056b$export$badc82e7c9337824.PAUSED) $e669222ae6fd056b$var$logger.warn("This task is already paused");
        this.state = $e669222ae6fd056b$export$badc82e7c9337824.PAUSED;
        // Use axios cancel token to abort the part request immediately
        // Add the inProgress parts back to pending
        var removedInProgressReq = this.inProgress.splice(0, this.inProgress.length);
        removedInProgressReq.forEach(function(req) {
            req.cancel((0, $5c596c808c2de5fe$export$179814ca32efa022).UPLOAD_PAUSED_MESSAGE);
        });
        // Put all removed in progress parts back into the queue
        (_a = this.queued).unshift.apply(_a, $e669222ae6fd056b$var$__spread(removedInProgressReq.map(function(req) {
            return req.uploadPartInput;
        })));
    };
    return AWSS3UploadTask;
}();




var $d36a475c80107258$var$__assign = undefined && undefined.__assign || function() {
    $d36a475c80107258$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d36a475c80107258$var$__assign.apply(this, arguments);
};
var $d36a475c80107258$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d36a475c80107258$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d36a475c80107258$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d36a475c80107258$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d36a475c80107258$var$__read(arguments[i]));
    return ar;
};
var $d36a475c80107258$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("AWSS3Provider");
var $d36a475c80107258$var$DEFAULT_STORAGE_LEVEL = "public";
var $d36a475c80107258$var$DEFAULT_PRESIGN_EXPIRATION = 900;
/**
 * Provide storage methods to use AWS S3
 */ var $d36a475c80107258$export$a8628d9eb315b139 = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        var _this = this;
        this._config = config ? config : {};
        this._storage = new (0, $7a47fb194d2f9787$export$a2bd19c49e4760e8)().getStorage();
        (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).listen("auth", function(data) {
            var payload = data.payload;
            if (payload.event === "signOut" || payload.event === "signIn") _this._storage.removeItem((0, $a77011a119d9fd1c$export$b9acc545d1bd0170));
        });
        $d36a475c80107258$var$logger.debug("Storage Options", this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        $d36a475c80107258$var$logger.debug("configure Storage", config);
        if (!config) return this._config;
        var amplifyConfig = (0, $b04fed49d5c1afc7$export$7acfa6ed01010e37).parseMobilehubConfig(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) $d36a475c80107258$var$logger.debug("Do not have bucket yet");
        return this._config;
    };
    AWSS3Provider.prototype.startResumableUpload = function(addTaskInput, config) {
        var s3Client = addTaskInput.s3Client, emitter = addTaskInput.emitter, key = addTaskInput.key, file = addTaskInput.file, params = addTaskInput.params;
        var progressCallback = config.progressCallback, completeCallback = config.completeCallback, errorCallback = config.errorCallback, _a = config.track, track = _a === void 0 ? false : _a;
        if (!(file instanceof Blob)) throw new Error((0, $5c596c808c2de5fe$export$148a3867c72aff96).INVALID_BLOB);
        emitter.on((0, $e669222ae6fd056b$export$1c9379601995aced).UPLOAD_PROGRESS, function(event) {
            if (progressCallback) {
                if (typeof progressCallback === "function") progressCallback(event);
                else $d36a475c80107258$var$logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
        });
        emitter.on((0, $e669222ae6fd056b$export$1c9379601995aced).UPLOAD_COMPLETE, function(event) {
            if (completeCallback) {
                if (typeof completeCallback === "function") completeCallback(event);
                else $d36a475c80107258$var$logger.warn("completeCallback should be a function, not a " + typeof completeCallback);
            }
        });
        emitter.on((0, $e669222ae6fd056b$export$1c9379601995aced).ERROR, function(err) {
            if (errorCallback) {
                if (typeof errorCallback === "function") errorCallback(err);
                else $d36a475c80107258$var$logger.warn("errorCallback should be a function, not a " + typeof errorCallback);
            }
        });
        // we want to keep this function sync so we defer this promise to AWSS3UploadTask to resolve when it's needed
        // when its doing a final check with _listSingleFile function
        var prefixPromise = (0, $de9f45d92f772164$export$a9627919734faa48).get().then(function(credentials) {
            var cred = (0, $de9f45d92f772164$export$a9627919734faa48).shear(credentials);
            return (0, $40959b47ff8c567f$export$36e24695f02d4503)($d36a475c80107258$var$__assign($d36a475c80107258$var$__assign({}, config), {
                credentials: cred
            }));
        });
        var task = new (0, $e669222ae6fd056b$export$ca4ab80441206528)({
            s3Client: s3Client,
            file: file,
            emitter: emitter,
            level: config.level,
            storage: this._storage,
            params: params,
            prefixPromise: prefixPromise
        });
        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "upload", {
            method: "put",
            result: "success"
        }, null, "Upload Task created successfully for " + key);
        // automatically start the upload task
        task.resume();
        return task;
    };
    /**
     * Copy an object from a source object to a new object within the same bucket. Can optionally copy files across
     * different level or identityId (if source object's level is 'protected').
     *
     * @async
     * @param {S3CopySource} src - Key and optionally access level and identityId of the source object.
     * @param {S3CopyDestination} dest - Key and optionally access level of the destination object.
     * @param {S3ProviderCopyConfig} [config] - Optional configuration for s3 commands.
     * @return {Promise<S3ProviderCopyOutput>} The key of the copied object.
     */ AWSS3Provider.prototype.copy = function(src, dest, config) {
        return $d36a475c80107258$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, acl, bucket, cacheControl, expires, track, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, _a, srcLevel, srcIdentityId, srcKey, _b, destLevel, destKey, srcPrefix, destPrefix, finalSrcKey, finalDestKey, params, s3, error_1;
            return $d36a475c80107258$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $5c596c808c2de5fe$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        acl = opt.acl, bucket = opt.bucket, cacheControl = opt.cacheControl, expires = opt.expires, track = opt.track, serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        _a = src.level, srcLevel = _a === void 0 ? $d36a475c80107258$var$DEFAULT_STORAGE_LEVEL : _a, srcIdentityId = src.identityId, srcKey = src.key;
                        _b = dest.level, destLevel = _b === void 0 ? $d36a475c80107258$var$DEFAULT_STORAGE_LEVEL : _b, destKey = dest.key;
                        if (!srcKey || typeof srcKey !== "string") throw new Error((0, $5c596c808c2de5fe$export$148a3867c72aff96).NO_SRC_KEY);
                        if (!destKey || typeof destKey !== "string") throw new Error((0, $5c596c808c2de5fe$export$148a3867c72aff96).NO_DEST_KEY);
                        if (srcLevel !== "protected" && srcIdentityId) $d36a475c80107258$var$logger.warn('You may copy files from another user if the source level is "protected", currently it\'s ' + srcLevel);
                        srcPrefix = this._prefix($d36a475c80107258$var$__assign($d36a475c80107258$var$__assign($d36a475c80107258$var$__assign({}, opt), {
                            level: srcLevel
                        }), srcIdentityId && {
                            identityId: srcIdentityId
                        }));
                        destPrefix = this._prefix($d36a475c80107258$var$__assign($d36a475c80107258$var$__assign({}, opt), {
                            level: destLevel
                        }));
                        finalSrcKey = bucket + "/" + srcPrefix + srcKey;
                        finalDestKey = "" + destPrefix + destKey;
                        $d36a475c80107258$var$logger.debug("copying " + finalSrcKey + " to " + finalDestKey);
                        params = {
                            Bucket: bucket,
                            CopySource: finalSrcKey,
                            Key: finalDestKey,
                            // Copies over metadata like contentType as well
                            MetadataDirective: "COPY"
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (expires) params.Expires = expires;
                        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        if (acl) params.ACL = acl;
                        s3 = this._createNewS3Client(opt);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $39a4f50a4faa6416$export$dae1e139b4ba0d49)(params))
                        ];
                    case 3:
                        _c.sent();
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "copy", {
                            method: "copy",
                            result: "success"
                        }, null, "Copy success from " + srcKey + " to " + destKey);
                        return [
                            2 /*return*/ ,
                            {
                                key: destKey
                            }
                        ];
                    case 4:
                        error_1 = _c.sent();
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "copy", {
                            method: "copy",
                            result: "failed"
                        }, null, "Copy failed from " + srcKey + " to " + destKey);
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype.get = function(key, config) {
        return $d36a475c80107258$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, progressCallback, prefix, final_key, emitter, s3, params, getObjectCommand, response, error_2, signer, request, url, _a, error_3;
            return $d36a475c80107258$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $5c596c808c2de5fe$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, progressCallback = opt.progressCallback;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        emitter = new $5440e9199a418654$exports.EventEmitter();
                        s3 = this._createNewS3Client(opt, emitter);
                        $d36a475c80107258$var$logger.debug("get " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        getObjectCommand = new (0, $0cf21e6f5da31179$export$25364b3fa12a4666)(params);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        if (progressCallback) {
                            if (typeof progressCallback === "function") emitter.on((0, $5da18860f75886e9$export$660a92f3322ba11a), function(progress) {
                                progressCallback(progress);
                            });
                            else $d36a475c80107258$var$logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
                        }
                        return [
                            4 /*yield*/ ,
                            s3.send(getObjectCommand)
                        ];
                    case 3:
                        response = _b.sent();
                        emitter.removeAllListeners((0, $5da18860f75886e9$export$660a92f3322ba11a));
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "download", {
                            method: "get",
                            result: "success"
                        }, {
                            fileSize: Number(response.Body["size"] || response.Body["length"])
                        }, "Download success for " + key);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_2 = _b.sent();
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "download", {
                            method: "get",
                            result: "failed"
                        }, null, "Download failed with " + error_2.message);
                        throw error_2;
                    case 5:
                        _b.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        signer = new (0, $4c2d32f64b3820e3$export$a1673011a6b3560f)($d36a475c80107258$var$__assign({}, s3.config));
                        return [
                            4 /*yield*/ ,
                            (0, $eea18618b585622f$export$72e3afa9ac8966be)(s3, new (0, $0cf21e6f5da31179$export$25364b3fa12a4666)(params))
                        ];
                    case 6:
                        request = _b.sent();
                        _a = (0, $eaea2d0b0b5b4fe5$export$75025487296cba38);
                        return [
                            4 /*yield*/ ,
                            signer.presign(request, {
                                expiresIn: expires || $d36a475c80107258$var$DEFAULT_PRESIGN_EXPIRATION
                            })
                        ];
                    case 7:
                        url = _a.apply(void 0, [
                            _b.sent()
                        ]);
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "getSignedUrl", {
                            method: "get",
                            result: "success"
                        }, null, "Signed URL: " + url);
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 8:
                        error_3 = _b.sent();
                        $d36a475c80107258$var$logger.warn("get signed url error", error_3);
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "Could not get a signed URL for " + key);
                        throw error_3;
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param key - key of the object
     * @param object - File to be put in Amazon S3 bucket
     * @param [config] - Optional configuration for the underlying S3 command
     * @return an instance of AWSS3UploadTask or a promise that resolves to an object with the new object's key on
     * success.
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        var opt = Object.assign({}, this._config, config);
        var bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback, level = opt.level, resumable = opt.resumable;
        var contentType = opt.contentType, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
        var serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
        var type = contentType ? contentType : "binary/octet-stream";
        var params = {
            Bucket: bucket,
            Key: key,
            Body: object,
            ContentType: type
        };
        if (cacheControl) params.CacheControl = cacheControl;
        if (contentDisposition) params.ContentDisposition = contentDisposition;
        if (contentEncoding) params.ContentEncoding = contentEncoding;
        if (expires) params.Expires = expires;
        if (metadata) params.Metadata = metadata;
        if (tagging) params.Tagging = tagging;
        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
        var emitter = new $5440e9199a418654$exports.EventEmitter();
        var uploader = new (0, $fd8ad2a2fc82e91d$export$da75ae8ad0285104)(params, opt, emitter);
        if (acl) params.ACL = acl;
        if (resumable === true) {
            var s3Client = this._createNewS3Client(opt);
            // we are using aws sdk middleware to inject the prefix to key, this way we don't have to call
            // this._ensureCredentials() which allows us to make this function sync so we can return non-Promise like UploadTask
            s3Client.middlewareStack.add((0, $40959b47ff8c567f$export$95bc4f3188064861)(opt, key), (0, $40959b47ff8c567f$export$52daf78b33f1adcd));
            var addTaskInput = {
                bucket: bucket,
                key: key,
                s3Client: s3Client,
                file: object,
                emitter: emitter,
                accessLevel: level,
                params: params
            };
            // explicitly asserting the type here as Typescript could not infer that resumable is of type true
            return this.startResumableUpload(addTaskInput, config);
        }
        try {
            if (progressCallback) {
                if (typeof progressCallback === "function") emitter.on((0, $5da18860f75886e9$export$c5e6923933be22a0), function(progress) {
                    progressCallback(progress);
                });
                else $d36a475c80107258$var$logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
            return uploader.upload().then(function(response) {
                $d36a475c80107258$var$logger.debug("upload result", response);
                (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "upload", {
                    method: "put",
                    result: "success"
                }, null, "Upload success for " + key);
                return {
                    key: key
                };
            });
        } catch (error) {
            $d36a475c80107258$var$logger.warn("error uploading", error);
            (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "upload", {
                method: "put",
                result: "failed"
            }, null, "Error uploading " + key);
            throw error;
        }
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {S3ProviderRemoveConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderRemoveOutput>} - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return $d36a475c80107258$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, s3, params, deleteObjectCommand, response, error_4;
            return $d36a475c80107258$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $5c596c808c2de5fe$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $d36a475c80107258$var$logger.debug("remove " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        deleteObjectCommand = new (0, $e1051b371fda55f0$export$d60592d05571c4ef)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(deleteObjectCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "delete", {
                            method: "remove",
                            result: "success"
                        }, null, "Deleted " + key + " successfully");
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_4 = _a.sent();
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "delete", {
                            method: "remove",
                            result: "failed"
                        }, null, "Deletion of " + key + " failed with " + error_4);
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._list = function(params, opt, prefix) {
        return $d36a475c80107258$var$__awaiter(this, void 0, void 0, function() {
            var result, s3, listObjectsV2Command, response;
            return $d36a475c80107258$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        result = {
                            contents: [],
                            nextToken: ""
                        };
                        s3 = this._createNewS3Client(opt);
                        listObjectsV2Command = new (0, $3859c4d3df57bfa7$export$479061a53a55f030)($d36a475c80107258$var$__assign({}, params));
                        return [
                            4 /*yield*/ ,
                            s3.send(listObjectsV2Command)
                        ];
                    case 1:
                        response = _a.sent();
                        if (response && response.Contents) {
                            result.contents = response.Contents.map(function(item) {
                                return {
                                    key: item.Key.substr(prefix.length),
                                    eTag: item.ETag,
                                    lastModified: item.LastModified,
                                    size: item.Size
                                };
                            });
                            result.nextToken = response.NextContinuationToken;
                        }
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {S3ProviderListConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderListOutput>} - Promise resolves to list of keys, eTags, lastModified and file size for
     * all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return $d36a475c80107258$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, maxKeys, prefix, final_path, list, token, listResult, params, error_5;
            return $d36a475c80107258$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $5c596c808c2de5fe$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, maxKeys = opt.maxKeys;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        $d36a475c80107258$var$logger.debug("list " + path + " from " + final_path);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            10,
                            ,
                            11
                        ]);
                        list = [];
                        token = void 0;
                        listResult = void 0;
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: 1000
                        };
                        if (!(maxKeys === "ALL")) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a.label = 3;
                    case 3:
                        params.ContinuationToken = token;
                        params.MaxKeys = 1000;
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 4:
                        listResult = _a.sent();
                        list.push.apply(list, $d36a475c80107258$var$__spread(listResult.contents));
                        if (listResult.nextToken) token = listResult.nextToken;
                        _a.label = 5;
                    case 5:
                        if (listResult.nextToken) return [
                            3 /*break*/ ,
                            3
                        ];
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        maxKeys < 1000 || typeof maxKeys === "string" ? params.MaxKeys = maxKeys : params.MaxKeys = 1000;
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 8:
                        listResult = _a.sent();
                        list.push.apply(list, $d36a475c80107258$var$__spread(listResult.contents));
                        if (maxKeys > 1000) $d36a475c80107258$var$logger.warn("maxkeys can be from 0 - 1000 or 'ALL'. To list all files you can set maxKeys to 'ALL'.");
                        _a.label = 9;
                    case 9:
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "list", {
                            method: "list",
                            result: "success"
                        }, null, list.length + " items returned from list operation");
                        $d36a475c80107258$var$logger.debug("list", list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 10:
                        error_5 = _a.sent();
                        $d36a475c80107258$var$logger.warn("list error", error_5);
                        (0, $6b11143ba342dd3c$export$f4575af7aa417855)(track, "list", {
                            method: "list",
                            result: "failed"
                        }, null, "Listing items failed: " + error_5.message);
                        throw error_5;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._ensureCredentials = function() {
        return $d36a475c80107258$var$__awaiter(this, void 0, void 0, function() {
            var credentials, cred, error_6;
            return $d36a475c80107258$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $de9f45d92f772164$export$a9627919734faa48).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, $de9f45d92f772164$export$a9627919734faa48).shear(credentials);
                        $d36a475c80107258$var$logger.debug("set credentials for storage", cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_6 = _a.sent();
                        $d36a475c80107258$var$logger.warn("ensure credentials error", error_6);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._isWithCredentials = function(config) {
        return typeof config === "object" && config.hasOwnProperty("credentials");
    };
    AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : "private/") + identityId + "/";
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : "protected/") + identityId + "/";
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : "public/";
        switch(level){
            case "private":
                return privatePath;
            case "protected":
                return protectedPath;
            default:
                return publicPath;
        }
    };
    /**
     * Creates an S3 client with new V3 aws sdk
     */ AWSS3Provider.prototype._createNewS3Client = function(config, emitter) {
        var s3client = (0, $40959b47ff8c567f$export$4cdd37a0748e6ad9)(config, emitter);
        s3client.middlewareStack.add((0, $40959b47ff8c567f$export$d1971fb9f9448f)(s3client.config), (0, $40959b47ff8c567f$export$2edd0200412be327));
        return s3client;
    };
    AWSS3Provider.CATEGORY = "Storage";
    AWSS3Provider.PROVIDER_NAME = "AWSS3";
    return AWSS3Provider;
}();
var /**
 * @deprecated use named import
 */ $d36a475c80107258$export$2e2bcd8739ae039 = $d36a475c80107258$export$a8628d9eb315b139;




var $f9f280b60a435aa2$var$__assign = undefined && undefined.__assign || function() {
    $f9f280b60a435aa2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f9f280b60a435aa2$var$__assign.apply(this, arguments);
};
var $f9f280b60a435aa2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f9f280b60a435aa2$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("StorageClass");
var $f9f280b60a435aa2$var$DEFAULT_PROVIDER = "AWSS3";
/**
 * Provide storage methods to use AWS S3
 */ var $f9f280b60a435aa2$export$bf2a15d34f3c441c = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        this._cancelTokenSourceMap = new WeakMap();
        $f9f280b60a435aa2$var$logger.debug("Storage Options", this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return "Storage";
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Storage") {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $f9f280b60a435aa2$var$logger.debug("No plugin found with providerName", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        $f9f280b60a435aa2$var$logger.debug("configure Storage");
        if (!config) return this._config;
        var amplifyConfig = (0, $b04fed49d5c1afc7$export$7acfa6ed01010e37).parseMobilehubConfig(config);
        var storageKeysFromConfig = Object.keys(amplifyConfig.Storage);
        var storageArrayKeys = [
            "bucket",
            "region",
            "level",
            "track",
            "customPrefix",
            "serverSideEncryption",
            "SSECustomerAlgorithm",
            "SSECustomerKey",
            "SSECustomerKeyMD5",
            "SSEKMSKeyId"
        ];
        var isInStorageArrayKeys = function(k) {
            return storageArrayKeys.some(function(x) {
                return x === k;
            });
        };
        var checkConfigKeysFromArray = function(k) {
            return k.find(function(k) {
                return isInStorageArrayKeys(k);
            });
        };
        if (storageKeysFromConfig && checkConfigKeysFromArray(storageKeysFromConfig) && !amplifyConfig.Storage[$f9f280b60a435aa2$var$DEFAULT_PROVIDER]) amplifyConfig.Storage[$f9f280b60a435aa2$var$DEFAULT_PROVIDER] = {};
        Object.entries(amplifyConfig.Storage).map(function(_a) {
            var _b = $f9f280b60a435aa2$var$__read(_a, 2), key = _b[0], value = _b[1];
            if (key && isInStorageArrayKeys(key) && value !== undefined) {
                amplifyConfig.Storage[$f9f280b60a435aa2$var$DEFAULT_PROVIDER][key] = value;
                delete amplifyConfig.Storage[key];
            }
        });
        // only update new values for each provider
        Object.keys(amplifyConfig.Storage).forEach(function(providerName) {
            if (typeof amplifyConfig.Storage[providerName] !== "string") _this._config[providerName] = $f9f280b60a435aa2$var$__assign($f9f280b60a435aa2$var$__assign({}, _this._config[providerName]), amplifyConfig.Storage[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $d36a475c80107258$export$a8628d9eb315b139)());
        return this._config;
    };
    Storage.prototype.getCancellableTokenSource = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).CancelToken.source();
    };
    Storage.prototype.updateRequestToBeCancellable = function(request, cancelTokenSource) {
        this._cancelTokenSourceMap.set(request, cancelTokenSource);
    };
    Storage.prototype.isUploadTask = function(x) {
        return typeof x !== "undefined" && typeof x["pause"] === "function" && typeof x["resume"] === "function";
    };
    Storage.prototype.cancel = function(request, message) {
        if (request instanceof (0, $e669222ae6fd056b$export$ca4ab80441206528)) return request._cancel();
        var cancelTokenSource = this._cancelTokenSourceMap.get(request);
        if (cancelTokenSource) cancelTokenSource.cancel(message);
        else $f9f280b60a435aa2$var$logger.debug("The request does not map to any cancel token");
    };
    Storage.prototype.copy = function(src, dest, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $f9f280b60a435aa2$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $f9f280b60a435aa2$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        if (typeof prov.copy !== "function") return Promise.reject(".copy is not implemented on provider " + prov.getProviderName());
        var responsePromise = prov.copy(src, dest, $f9f280b60a435aa2$var$__assign($f9f280b60a435aa2$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
        return responsePromise;
    };
    Storage.prototype.get = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $f9f280b60a435aa2$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $f9f280b60a435aa2$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        var responsePromise = prov.get(key, $f9f280b60a435aa2$var$__assign($f9f280b60a435aa2$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
        return responsePromise;
    };
    Storage.prototype.isCancelError = function(error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).isCancel(error);
    };
    Storage.prototype.put = function(key, object, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $f9f280b60a435aa2$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $f9f280b60a435aa2$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        var response = prov.put(key, object, $f9f280b60a435aa2$var$__assign($f9f280b60a435aa2$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        if (!this.isUploadTask(response)) this.updateRequestToBeCancellable(response, cancelTokenSource);
        return response;
    };
    Storage.prototype.remove = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $f9f280b60a435aa2$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $f9f280b60a435aa2$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return prov.remove(key, config);
    };
    Storage.prototype.list = function(path, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $f9f280b60a435aa2$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $f9f280b60a435aa2$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return prov.list(path, config);
    };
    return Storage;
}();
var /**
 * @deprecated use named import
 */ $f9f280b60a435aa2$export$2e2bcd8739ae039 = $f9f280b60a435aa2$export$bf2a15d34f3c441c;




var $e4fb3dbc82e348f8$var$__assign = undefined && undefined.__assign || function() {
    $e4fb3dbc82e348f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e4fb3dbc82e348f8$var$__assign.apply(this, arguments);
};
var $e4fb3dbc82e348f8$var$logger = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("Storage");
var $e4fb3dbc82e348f8$var$_instance = null;
var $e4fb3dbc82e348f8$var$getInstance = function() {
    if ($e4fb3dbc82e348f8$var$_instance) return $e4fb3dbc82e348f8$var$_instance;
    $e4fb3dbc82e348f8$var$logger.debug("Create Storage Instance, debug");
    $e4fb3dbc82e348f8$var$_instance = new (0, $f9f280b60a435aa2$export$bf2a15d34f3c441c)();
    $e4fb3dbc82e348f8$var$_instance.vault = new (0, $f9f280b60a435aa2$export$bf2a15d34f3c441c)();
    var old_configure = $e4fb3dbc82e348f8$var$_instance.configure;
    $e4fb3dbc82e348f8$var$_instance.configure = function(options) {
        $e4fb3dbc82e348f8$var$logger.debug("storage configure called");
        var vaultConfig = $e4fb3dbc82e348f8$var$__assign({}, old_configure.call($e4fb3dbc82e348f8$var$_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== "string") vaultConfig[providerName] = $e4fb3dbc82e348f8$var$__assign($e4fb3dbc82e348f8$var$__assign({}, vaultConfig[providerName]), {
                level: "private"
            });
        });
        $e4fb3dbc82e348f8$var$logger.debug("storage vault configure called");
        $e4fb3dbc82e348f8$var$_instance.vault.configure(vaultConfig);
    };
    return $e4fb3dbc82e348f8$var$_instance;
};
var $e4fb3dbc82e348f8$export$bf2a15d34f3c441c = $e4fb3dbc82e348f8$var$getInstance();
(0, $36606c730099e1c8$export$a3858a9a153cffc7).register($e4fb3dbc82e348f8$export$bf2a15d34f3c441c);
var /**
 * @deprecated use named import
 */ $e4fb3dbc82e348f8$export$2e2bcd8739ae039 = $e4fb3dbc82e348f8$export$bf2a15d34f3c441c;






var $2d060a6395dcf0dd$exports = {};
!function(t, _) {
    $2d060a6395dcf0dd$exports = _();
}($2d060a6395dcf0dd$exports, function() {
    return function(t) {
        var _ = {};
        function n(o) {
            if (_[o]) return _[o].exports;
            var e = _[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(e.exports, e, e.exports, n), e.l = !0, e.exports;
        }
        return n.m = t, n.c = _, n.d = function(t, _, o) {
            n.o(t, _) || Object.defineProperty(t, _, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, _) {
            if (1 & _ && (t = n(t)), 8 & _) return t;
            if (4 & _ && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & _ && "string" != typeof t) for(var e in t)n.d(o, e, (function(_) {
                return t[_];
            }).bind(null, e));
            return o;
        }, n.n = function(t) {
            var _ = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(_, "a", _), _;
        }, n.o = function(t, _) {
            return Object.prototype.hasOwnProperty.call(t, _);
        }, n.p = "", n(n.s = 0);
    }([
        function(t, _, n) {
            "use strict";
            function o(t) {
                for(var n in t)_.hasOwnProperty(n) || (_[n] = t[n]);
            }
            Object.defineProperty(_, "__esModule", {
                value: !0
            }), o(n(1)), o(n(2)), o(n(3)), o(n(4)), o(n(5)), o(n(6)), o(n(7)), o(n(8)), o(n(9)), o(n(10)), o(n(11)), o(n(12)), o(n(13));
        },
        function(t, _, n) {
            t.exports = {
                a: "Anchor__a___1_Iz8"
            };
        },
        function(t, _, n) {
            t.exports = {
                button: "Button__button___vS7Mv",
                signInButton: "Button__signInButton___3bUH-",
                googleSignInButton: "Button__googleSignInButton___1YiCu",
                signInButtonIcon: "Button__signInButtonIcon___ihN75",
                auth0SignInButton: "Button__auth0SignInButton___znnCj",
                facebookSignInButton: "Button__facebookSignInButton___34Txh",
                amazonSignInButton: "Button__amazonSignInButton___2EMtl",
                oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
                signInButtonContent: "Button__signInButtonContent___xqTXJ"
            };
        },
        function(t, _, n) {
            t.exports = {
                formContainer: "Form__formContainer___1GA3x",
                formSection: "Form__formSection___1PPvW",
                formField: "Form__formField___38Ikl",
                formRow: "Form__formRow___2mwRs"
            };
        },
        function(t, _, n) {
            t.exports = {
                hint: "Hint__hint___2XngB"
            };
        },
        function(t, _, n) {
            t.exports = {
                input: "Input__input___3e_bf",
                inputLabel: "Input__inputLabel___3VF0S",
                label: "Input__label___23sO8",
                radio: "Input__radio___2hllK"
            };
        },
        function(t, _, n) {
            t.exports = {
                navBar: "Nav__navBar___xtCFA",
                navRight: "Nav__navRight___1QG2J",
                nav: "Nav__nav___2Dx2Y",
                navItem: "Nav__navItem___1LtFQ"
            };
        },
        function(t, _, n) {
            t.exports = {
                photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
                photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
                photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
            };
        },
        function(t, _, n) {
            t.exports = {
                container: "Section__container___3YYTG",
                actionRow: "Section__actionRow___2LWSU",
                sectionHeader: "Section__sectionHeader___2djyg",
                sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
                sectionBody: "Section__sectionBody___ihqqd",
                sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
                sectionFooter: "Section__sectionFooter___1T54C",
                sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
                sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
            };
        },
        function(t, _, n) {
            t.exports = {
                selectInput: "SelectInput__selectInput___3efO4"
            };
        },
        function(t, _, n) {
            t.exports = {
                strike: "Strike__strike___1XV1b",
                strikeContent: "Strike__strikeContent___10gLb"
            };
        },
        function(t, _, n) {
            t.exports = {
                toast: "Toast__toast___XXr3v",
                toastClose: "Toast__toastClose___18lU4"
            };
        },
        function(t, _, n) {
            t.exports = {
                totpQrcode: "Totp__totpQrcode___1crLx"
            };
        },
        function(t, _, n) {
            t.exports = {
                sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
                sumerianScene: "XR__sumerianScene___2Tt7-",
                loadingOverlay: "XR__loadingOverlay___IbqcI",
                loadingContainer: "XR__loadingContainer___2Itxb",
                loadingLogo: "XR__loadingLogo___Ub7xQ",
                loadingSceneName: "XR__loadingSceneName___3__ne",
                loadingBar: "XR__loadingBar___2vcke",
                loadingBarFill: "XR__loadingBarFill___3M-D9",
                sceneErrorText: "XR__sceneErrorText___2y0tp",
                sceneBar: "XR__sceneBar___2ShrP",
                sceneName: "XR__sceneName___1ApHr",
                sceneActions: "XR__sceneActions___7plGs",
                actionButton: "XR__actionButton___2poIM",
                tooltip: "XR__tooltip___UYyhn",
                actionIcon: "XR__actionIcon___2qnd2",
                autoShowTooltip: "XR__autoShowTooltip___V1QH7"
            };
        }
    ]);
});






/** Always importing Auth when users import Amplify such that
    for unauthenticated access (no sign in and sign up),
    users don't have to import Auth explicitly **/ (0, $36606c730099e1c8$export$a3858a9a153cffc7).Auth = (0, $cc420cb14b670b2a$export$334c29725a78c21d);
(0, $36606c730099e1c8$export$a3858a9a153cffc7).Cache = (0, $aafd43a5aa7da9fd$export$2a9787695d97e2c4);
(0, $36606c730099e1c8$export$a3858a9a153cffc7).ServiceWorker = (0, $88fb3af5ba4cdf42$export$efa87b877bb98f58);
var /**
 * @deprecated use named import
 */ $ae0538f3e231a007$export$2e2bcd8739ae039 = (0, $36606c730099e1c8$export$a3858a9a153cffc7);



var $8nd05 = parcelRequire("8nd05");

var $8nd05 = parcelRequire("8nd05");
var $4730acf0753ac89a$export$6acf61af03e62db = typeof window === "undefined";
function $4730acf0753ac89a$export$8793edee2d425525() {
    return undefined;
}
function $4730acf0753ac89a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $4730acf0753ac89a$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $4730acf0753ac89a$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $4730acf0753ac89a$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $4730acf0753ac89a$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $4730acf0753ac89a$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $4730acf0753ac89a$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return (0, $8nd05.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $8nd05.default)({}, arg2, {
        queryKey: arg1
    });
}
function $4730acf0753ac89a$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return (0, $8nd05.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $8nd05.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === "function") return (0, $8nd05.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $8nd05.default)({}, arg1);
}
function $4730acf0753ac89a$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? [
        (0, $8nd05.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $4730acf0753ac89a$export$42387eeaac09cf54(arg1, arg2) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? (0, $8nd05.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $4730acf0753ac89a$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return "all";
    else if (active === false && inactive === false) return "none";
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? "active" : "inactive";
    }
}
function $4730acf0753ac89a$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $4730acf0753ac89a$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === "none") return false;
    else if (queryStatusFilter !== "all") {
        var isActive = query.isActive();
        if (queryStatusFilter === "active" && !isActive) return false;
        if (queryStatusFilter === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetching === "boolean" && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $4730acf0753ac89a$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($4730acf0753ac89a$export$5fcb678681417b54(mutation.options.mutationKey) !== $4730acf0753ac89a$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $4730acf0753ac89a$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $4730acf0753ac89a$export$5fcb678681417b54(queryKey) {
    var asArray = $4730acf0753ac89a$export$4d32d63f64b825b9(queryKey);
    return $4730acf0753ac89a$export$e7f2f041280beb00(asArray);
}
function $4730acf0753ac89a$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $4730acf0753ac89a$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $4730acf0753ac89a$export$2f07189bb9fa26a7(a, b) {
    return $4730acf0753ac89a$export$3bc9138b70293839($4730acf0753ac89a$export$4d32d63f64b825b9(a), $4730acf0753ac89a$export$4d32d63f64b825b9(b));
}
function $4730acf0753ac89a$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !$4730acf0753ac89a$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $4730acf0753ac89a$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $4730acf0753ac89a$export$53b83ca8eaab0383(a) && $4730acf0753ac89a$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $4730acf0753ac89a$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $4730acf0753ac89a$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $4730acf0753ac89a$export$53b83ca8eaab0383(o) {
    if (!$4730acf0753ac89a$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$4730acf0753ac89a$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $4730acf0753ac89a$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $4730acf0753ac89a$export$aaae5295ec3351c9(value) {
    return typeof value === "string" || Array.isArray(value);
}
function $4730acf0753ac89a$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $4730acf0753ac89a$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $4730acf0753ac89a$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $4730acf0753ac89a$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
}



var $g7ajw = parcelRequire("g7ajw");


var $8nd05 = parcelRequire("8nd05");


var $a326eb7faf36b653$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    } /**
   * All calls to the wrapped function will be batched.
   */ ;
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    } /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ ;
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    } /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ ;
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $a326eb7faf36b653$export$520687f44db6e1ab = new $a326eb7faf36b653$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $71a71a329ca2584f$var$logger = console;
function $71a71a329ca2584f$export$2b1d391cd05230fd() {
    return $71a71a329ca2584f$var$logger;
}
function $71a71a329ca2584f$export$3abbd92f765bee58(newLogger) {
    $71a71a329ca2584f$var$logger = newLogger;
}



var $g7ajw = parcelRequire("g7ajw");
var $8806d6a418db4b9d$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $dd382c2a22c34b78$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $g7ajw.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === "boolean") _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $dd382c2a22c34b78$export$6bf54661be5b02cf = new $dd382c2a22c34b78$export$86f1af424b2ca4de();



var $g7ajw = parcelRequire("g7ajw");


var $8283b4ebace21c13$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $g7ajw.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener("online", listener, false);
                window.addEventListener("offline", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("online", listener);
                    window.removeEventListener("offline", listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === "boolean") _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $8283b4ebace21c13$export$b113e788b2dd3fdc = new $8283b4ebace21c13$export$58774fb55d5ff7fc();



function $90c5b2b1a5489698$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $90c5b2b1a5489698$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === "function";
}
var $90c5b2b1a5489698$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $90c5b2b1a5489698$export$986cc6445c1d323(value) {
    return value instanceof $90c5b2b1a5489698$export$a8430ed4188f35a9;
} // CLASS
var $90c5b2b1a5489698$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $90c5b2b1a5489698$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $90c5b2b1a5489698$var$defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && _this.failureCount < retry || typeof retry === "function" && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $4730acf0753ac89a$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() || !(0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $b3c5b3b704751c57$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $8nd05.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $4730acf0753ac89a$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $4730acf0753ac89a$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $4730acf0753ac89a$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, "signal", {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject("Missing queryFn");
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: "error",
                    error: error
                });
                if (!(0, $90c5b2b1a5489698$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: "queryUpdated",
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== "undefined";
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== "undefined";
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? "success" : "idle"
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case "failed":
                return (0, $8nd05.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case "pause":
                return (0, $8nd05.default)({}, state, {
                    isPaused: true
                });
            case "continue":
                return (0, $8nd05.default)({}, state, {
                    isPaused: false
                });
            case "fetch":
                return (0, $8nd05.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: "loading"
                });
            case "success":
                return (0, $8nd05.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: "success"
                });
            case "error":
                var error = action.error;
                if ((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $8nd05.default)({}, this.revertState);
                return (0, $8nd05.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: "error"
                });
            case "invalidate":
                return (0, $8nd05.default)({}, state, {
                    isInvalidated: true
                });
            case "setState":
                return (0, $8nd05.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $55146b963a737dee$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $g7ajw.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $b3c5b3b704751c57$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "queryAdded",
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "queryRemoved",
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));



var $g7ajw = parcelRequire("g7ajw");


var $8nd05 = parcelRequire("8nd05");




var $8d56420e30839da2$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $8nd05.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $8d56420e30839da2$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === "loading";
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: "loading",
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: "loading",
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: "success",
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: "error",
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject("No mutationFn found");
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $8d56420e30839da2$var$reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $8d56420e30839da2$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}
function $8d56420e30839da2$var$reducer(state, action) {
    switch(action.type){
        case "failed":
            return (0, $8nd05.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case "pause":
            return (0, $8nd05.default)({}, state, {
                isPaused: true
            });
        case "continue":
            return (0, $8nd05.default)({}, state, {
                isPaused: false
            });
        case "loading":
            return (0, $8nd05.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: "loading",
                variables: action.variables
            });
        case "success":
            return (0, $8nd05.default)({}, state, {
                data: action.data,
                error: null,
                status: "success",
                isPaused: false
            });
        case "error":
            return (0, $8nd05.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: "error"
            });
        case "setState":
            return (0, $8nd05.default)({}, state, action.state);
        default:
            return state;
    }
}




var $10b6fdd47d933258$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $g7ajw.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $8d56420e30839da2$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $4730acf0753ac89a$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));







function $73df723cfc461e76$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject("Missing queryFn");
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== "undefined";
                    var param = manual ? pageParam : $73df723cfc461e76$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== "undefined";
                    var _param = _manual ? pageParam : $73df723cfc461e76$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === "undefined";
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $73df723cfc461e76$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $73df723cfc461e76$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $73df723cfc461e76$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $73df723cfc461e76$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
}
function $73df723cfc461e76$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
}


var $13e074efb1ecf7c6$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $55146b963a737dee$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $10b6fdd47d933258$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $8nd05.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $8nd05.default)({}, filters, {
            active: true
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $8nd05.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $8nd05.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $73df723cfc461e76$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(queryKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(mutationKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $8nd05.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $8nd05.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $1u0KT = parcelRequire("1u0KT");
var $d0188f2d930898c2$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unstable_batchedUpdates;


(0, $a326eb7faf36b653$export$520687f44db6e1ab).setBatchNotifyFunction((0, $d0188f2d930898c2$export$c78a37762a8d58e1));



var $a9338c6a303143c8$export$af88d00dbe7f521 = console;


(0, $71a71a329ca2584f$export$3abbd92f765bee58)((0, $a9338c6a303143c8$export$af88d00dbe7f521));



var $acw62 = parcelRequire("acw62");
var $ccb8f828cefd6075$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $ccb8f828cefd6075$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $ccb8f828cefd6075$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $ccb8f828cefd6075$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $ccb8f828cefd6075$var$defaultContext;
}
var $ccb8f828cefd6075$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
var $ccb8f828cefd6075$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $ccb8f828cefd6075$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ccb8f828cefd6075$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: client
    }, children));
};






var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $8nd05 = parcelRequire("8nd05");

var $g7ajw = parcelRequire("g7ajw");



var $d69ec76a7f524d37$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $g7ajw.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $8nd05.default)({}, this.options, {
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $8d56420e30839da2$export$a1659b54bac3252a)();
        var result = (0, $8nd05.default)({}, state, {
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));



function $a92a0ee821c291b8$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === "boolean") return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $0bcdd0ea2a5866d5$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $4730acf0753ac89a$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $d69ec76a7f524d37$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $8nd05.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}



var $8nd05 = parcelRequire("8nd05");

var $g7ajw = parcelRequire("g7ajw");






var $461f073e5b72a6b1$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $g7ajw.default)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($461f073e5b72a6b1$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp("error");
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $8nd05.default)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.options.enabled === false || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $461f073e5b72a6b1$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = "loading";
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && (status === "loading" || status === "idle")) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        var result = {
            status: status,
            isLoading: status === "loading",
            isSuccess: status === "success",
            isError: status === "error",
            isIdle: status === "idle",
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== "loading",
            isLoadingError: status === "error" && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === "error" && state.dataUpdatedAt !== 0,
            isStale: $461f073e5b72a6b1$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === "tracked" && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === "tracked" ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $4730acf0753ac89a$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $8nd05.default)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error" && !(0, $90c5b2b1a5489698$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    };
    return QueryObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
function $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $461f073e5b72a6b1$var$shouldFetchOnMount(query, options) {
    return $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $461f073e5b72a6b1$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $461f073e5b72a6b1$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $461f073e5b72a6b1$var$isStale(query, options);
    }
    return false;
}
function $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $461f073e5b72a6b1$var$isStale(query, options);
}
function $461f073e5b72a6b1$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $af499ad4852a56cf$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $af499ad4852a56cf$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($af499ad4852a56cf$var$createValue()); // HOOK
var $af499ad4852a56cf$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($af499ad4852a56cf$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $af499ad4852a56cf$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $af499ad4852a56cf$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($af499ad4852a56cf$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};




function $02303e84e5b435f8$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $af499ad4852a56cf$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === "tracked") result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $369f47a093b8c0cf$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $02303e84e5b435f8$export$fff0865807e996c5)(parsedOptions, (0, $461f073e5b72a6b1$export$a06cf8c0066f0d4c));
}




var $8nd05 = parcelRequire("8nd05");

var $g7ajw = parcelRequire("g7ajw");


var $abb8e2f00b146f38$export$85d960eb3ab339c8 = /*#__PURE__*/ function(_QueryObserver) {
    (0, $g7ajw.default)(InfiniteQueryObserver, _QueryObserver);
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function InfiniteQueryObserver(client, options) {
        return _QueryObserver.call(this, client, options) || this;
    }
    var _proto = InfiniteQueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        _QueryObserver.prototype.bindMethods.call(this);
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        _QueryObserver.prototype.setOptions.call(this, (0, $8nd05.default)({}, options, {
            behavior: (0, $73df723cfc461e76$export$84470d1367601e8d)()
        }), notifyOptions);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        options.behavior = (0, $73df723cfc461e76$export$84470d1367601e8d)();
        return _QueryObserver.prototype.getOptimisticResult.call(this, options);
    };
    _proto.fetchNextPage = function fetchNextPage(options) {
        var _options$cancelRefetc;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: "forward",
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.fetchPreviousPage = function fetchPreviousPage(options) {
        var _options$cancelRefetc2;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: "backward",
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.createResult = function createResult(query, options) {
        var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;
        var state = query.state;
        var result = _QueryObserver.prototype.createResult.call(this, query, options);
        return (0, $8nd05.default)({}, result, {
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $73df723cfc461e76$export$b9c88add8b8b5e6a)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, $73df723cfc461e76$export$db1663b730a8e6e4)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === "forward",
            isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === "backward"
        });
    };
    return InfiniteQueryObserver;
}((0, $461f073e5b72a6b1$export$a06cf8c0066f0d4c));




function $2ae43d8d5d3a2a12$export$bdc59d3c1a6569aa(arg1, arg2, arg3) {
    var options = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $02303e84e5b435f8$export$fff0865807e996c5)(options, (0, $abb8e2f00b146f38$export$85d960eb3ab339c8));
}









var $i4KPV = parcelRequire("i4KPV");

var $ijOKP = parcelRequire("ijOKP");
var $227f11a6809b1d6b$export$2e2bcd8739ae039 = (0, $ijOKP.default)({
    typography: {
        fontFamily: "'Poppins', sans-serif"
    },
    palette: {
        success: {
            main: "#00947E"
        }
    }
});



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $5e01f9464c1d6970$exports = {};
"use strict";
var $5e01f9464c1d6970$var$__createBinding = $5e01f9464c1d6970$exports && $5e01f9464c1d6970$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e01f9464c1d6970$var$__exportStar = $5e01f9464c1d6970$exports && $5e01f9464c1d6970$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5e01f9464c1d6970$var$__createBinding(exports1, m, p);
};
var $5e01f9464c1d6970$var$__importDefault = $5e01f9464c1d6970$exports && $5e01f9464c1d6970$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5e01f9464c1d6970$exports, "__esModule", {
    value: true
});
$5e01f9464c1d6970$exports.THEME_ENUM = void 0;

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($5e01f9464c1d6970$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

const $5e01f9464c1d6970$var$krg_snackbar_react_1 = $5e01f9464c1d6970$var$__importDefault((parcelRequire("5WRsZ")));

$5e01f9464c1d6970$var$__exportStar((parcelRequire("3xrB1")), $5e01f9464c1d6970$exports);
$5e01f9464c1d6970$exports.default = $5e01f9464c1d6970$var$krg_snackbar_react_1.default;


/* eslint-disable no-nested-ternary, react/prop-types, @typescript-eslint/no-unused-vars */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $1GFtd = parcelRequire("1GFtd");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $35c8e43691ef923a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), "RemoveCircle");


var $5WoTm = parcelRequire("5WoTm");
var $bNGtB = parcelRequire("bNGtB");
// TODO: Look into whether or not we need `useStyles` method && `classes` attribute in this file.
const $552b4be2693e49c5$var$useStyles = (0, $1GFtd.default)({
    snackbar: {
        "&>div": {
            height: "50px",
            minHeight: "auto",
            paddingLeft: "7px",
            paddingRight: "2px",
            "&>div": {
                alignItems: "center",
                "&:has(svg)": {
                    background: "radial-gradient(circle at center center, rgb(255, 255, 255) 0px, rgb(255, 255, 255) 49%, transparent 50%, transparent 100%)"
                }
            }
        },
        "& .MuiSvgIcon-root": {
            fontSize: "24px"
        }
    }
});
function $552b4be2693e49c5$export$2e2bcd8739ae039({ ...props }) {
    const classes = $552b4be2693e49c5$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))), {
        autoHideDuration: 2000,
        // className={classes.snackbar}
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).THEME_ENUM.v2,
        // TODO: Look into creating ternary helper function instead?
        icon: props.type === (0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).TYPE_ENUM.error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35c8e43691ef923a$export$2e2bcd8739ae039), {}) : props.type === (0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).TYPE_ENUM.warning ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WoTm.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bNGtB.default), {}),
        ...props
    });
}


var $fbb25d8420b2bfb5$export$2e2bcd8739ae039 = (0, $552b4be2693e49c5$export$2e2bcd8739ae039);


const $9d761cac11c11d44$export$216a88342db54c29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $9d761cac11c11d44$export$d1e619fddc3508ce({ children: children }) {
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [text, setText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).TYPE_ENUM.dark);
    function snackbarSuccess(newText) {
        setText(newText);
        setType((0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).TYPE_ENUM.success);
        setIsOpen(true);
    }
    function snackbarError(newText) {
        setText(newText);
        setType((0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).TYPE_ENUM.error);
        setIsOpen(true);
    }
    function snackbarWarning(newText) {
        setText(newText);
        setType((0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).TYPE_ENUM.warning);
        setIsOpen(true);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9d761cac11c11d44$export$216a88342db54c29.Provider, {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
                snackbarSuccess: snackbarSuccess,
                snackbarError: snackbarError,
                snackbarWarning: snackbarWarning
            }), []),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fbb25d8420b2bfb5$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                text: text,
                type: type
            }),
            children
        ]
    });
}
function $9d761cac11c11d44$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($9d761cac11c11d44$export$216a88342db54c29);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
function $14c705ecf5141c7b$export$1aae215f59ea61d5() {
    return JSON.parse(sessionStorage.getItem("publisherList")) || [];
}
function $14c705ecf5141c7b$export$e8a0b30c06b2b0be() {
    const regex = /.*\/admin\/([^/]+)\/domain.*/;
    const match = window.location.pathname.match(regex);
    return match?.length > 1 ? match[1] : null;
}
function $14c705ecf5141c7b$export$a1bdc0fcf3479e85(publisher) {
    if (!publisher) {
        sessionStorage.setItem("publisherList", JSON.stringify([]));
        return;
    }
    const publisherList = $14c705ecf5141c7b$export$1aae215f59ea61d5() || [];
    const hasDuplicate = publisherList?.includes(publisher);
    const publisherIndex = publisherList?.indexOf(publisher);
    if (publisherList?.length > 2 && !hasDuplicate) publisherList?.pop();
    else if (hasDuplicate && publisherIndex >= 0) publisherList?.splice(publisherIndex, 1);
    publisherList?.unshift(publisher);
    sessionStorage.setItem("publisherList", JSON.stringify(publisherList));
}


function $636507560a861811$export$204da773c0191bd8() {
    return sessionStorage.getItem("publisherUsername");
}
function $636507560a861811$export$6ae5cbbde4bec733(username) {
    if (!username) {
        sessionStorage.setItem("publisherUsername", "");
        return;
    }
    sessionStorage.setItem("publisherUsername", username);
}
function $636507560a861811$export$905949cbe54a49f1() {
    return sessionStorage.getItem("publisherGroup");
}
function $636507560a861811$export$c0a147212ba524b4(groupName) {
    if (!groupName) {
        sessionStorage.setItem("publisherGroup", "");
        return;
    }
    sessionStorage.setItem("publisherGroup", groupName);
}


const $556b5b2da5bfbb21$var$DEFAULT_PUBLISHER_NAME = "kargo";
const $556b5b2da5bfbb21$var$PublisherContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $556b5b2da5bfbb21$export$f2ee90d31ef8a5d8({ children: children }) {
    const [publisherSlug, setPublisherSlug] = (0, $acw62.useState)(null);
    const [publisherUsername, setPublisherUsername] = (0, $acw62.useState)(null);
    const [publisherGroup, setPublisherGroup] = (0, $acw62.useState)(null);
    const switchToPublisher = (plSlug)=>setPublisherSlug(plSlug);
    const switchToPublisherUsername = (username)=>setPublisherUsername(username);
    const switchToPublisherGroup = (groupName)=>setPublisherGroup(groupName);
    (0, $acw62.useEffect)(()=>{
        const recentPublisherList = (0, $14c705ecf5141c7b$export$1aae215f59ea61d5)();
        let plSlug = recentPublisherList?.length ? recentPublisherList[0].toLowerCase().replace(/ /g, "-") : $556b5b2da5bfbb21$var$DEFAULT_PUBLISHER_NAME;
        if (recentPublisherList?.length < 1) {
            const plSlugFromPathname = (0, $14c705ecf5141c7b$export$e8a0b30c06b2b0be)();
            if (plSlugFromPathname) plSlug = plSlugFromPathname;
        }
        switchToPublisher(plSlug);
    }, []);
    (0, $acw62.useEffect)(()=>{
        switchToPublisherUsername((0, $636507560a861811$export$204da773c0191bd8)() || "");
    }, []);
    (0, $acw62.useEffect)(()=>{
        const plUsername = (0, $636507560a861811$export$905949cbe54a49f1)() || $556b5b2da5bfbb21$var$DEFAULT_PUBLISHER_NAME;
        switchToPublisherGroup(plUsername);
    }, []);
    const contextValues = (0, $acw62.useMemo)(()=>({
            publisherSlug: publisherSlug,
            switchToPublisher: switchToPublisher,
            publisherUsername: publisherUsername,
            switchToPublisherUsername: switchToPublisherUsername,
            publisherGroup: publisherGroup,
            switchToPublisherGroup: switchToPublisherGroup
        }), [
        publisherSlug,
        switchToPublisher,
        publisherUsername,
        switchToPublisherUsername,
        publisherGroup,
        switchToPublisherGroup
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($556b5b2da5bfbb21$var$PublisherContext.Provider, {
        value: contextValues,
        children: children
    });
}
const $556b5b2da5bfbb21$export$dc4ef782e1b5fd70 = (isAdmin)=>{
    const context = (0, $acw62.useContext)($556b5b2da5bfbb21$var$PublisherContext);
    if (!isAdmin) return {
        publisherSlug: "",
        publisherGroup: "",
        publisherUsername: "",
        switchToPublisherGroup: ()=>"",
        switchToPublisher: ()=>"",
        switchToPublisherUsername: ()=>""
    };
    return context;
};


/* eslint-disable */ // WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const $1d959da113fdf5c0$var$awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_jisFigcXQ",
    "aws_user_pools_web_client_id": "6ooqpmvvgh0s7v8rgg0npcgaut",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": []
};
var $1d959da113fdf5c0$export$2e2bcd8739ae039 = $1d959da113fdf5c0$var$awsmobile;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $d9c803f633d21408$export$18ce0697a983be9b = function() {
    $d9c803f633d21408$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9c803f633d21408$export$18ce0697a983be9b.apply(this, arguments);
};
function $d9c803f633d21408$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d9c803f633d21408$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d9c803f633d21408$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d9c803f633d21408$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}


var $b74e93109ba456db$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($b74e93109ba456db$export$1385d81a6c6bbcd4 || ($b74e93109ba456db$export$1385d81a6c6bbcd4 = {}));
var $b74e93109ba456db$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($b74e93109ba456db$export$79f5baa747fbdd45 || ($b74e93109ba456db$export$79f5baa747fbdd45 = {}));



var $9700b9c4f37abdbc$export$b060f3cec92ef5c9 = ".";
var $9700b9c4f37abdbc$export$505a390a702f4a23 = {};
var $9700b9c4f37abdbc$export$656461011b562379 = "xstate.guard";
var $9700b9c4f37abdbc$export$31935b4577455331 = "";





var $41059b6f2e1b7a0a$export$b3571188c770cc5a = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Start;
var $41059b6f2e1b7a0a$export$fa6813432f753b0d = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Stop;
var $41059b6f2e1b7a0a$export$66313c302b2ea154 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Raise;
var $41059b6f2e1b7a0a$export$89db4734f6c919c4 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Send;
var $41059b6f2e1b7a0a$export$70b61ad426ddbe54 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Cancel;
var $41059b6f2e1b7a0a$export$9477ceca5dcd796a = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).NullEvent;
var $41059b6f2e1b7a0a$export$e6e34fd1f2686227 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Assign;
var $41059b6f2e1b7a0a$export$742acabee3dd6465 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).After;
var $41059b6f2e1b7a0a$export$de2557b5933c9ac6 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).DoneState;
var $41059b6f2e1b7a0a$export$bef1f36f5486a6a3 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Log;
var $41059b6f2e1b7a0a$export$2cd8252107eb640b = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Init;
var $41059b6f2e1b7a0a$export$468cda29b159ee5d = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Invoke;
var $41059b6f2e1b7a0a$export$aca059ee6fbf94e8 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorExecution;
var $41059b6f2e1b7a0a$export$503a23d0e5cd1226 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorPlatform;
var $41059b6f2e1b7a0a$export$a3bc9b8ed74fc = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorCustom;
var $41059b6f2e1b7a0a$export$722fbec263ad908a = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Update;
var $41059b6f2e1b7a0a$export$7877a478dd30fd3d = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Choose;
var $41059b6f2e1b7a0a$export$48ec4a2b1cfc6557 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Pure;



var $bb41c361a1818c2b$export$9b5f2e1c20ef6571 = false;


var $0ba2bc18e91bd780$var$_a;
function $0ba2bc18e91bd780$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $0ba2bc18e91bd780$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $9700b9c4f37abdbc$export$b060f3cec92ef5c9);
    var parentStateValue = $0ba2bc18e91bd780$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $0ba2bc18e91bd780$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(childStateValue)) {
        if ($0ba2bc18e91bd780$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $0ba2bc18e91bd780$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $0ba2bc18e91bd780$export$7193fc8c8cd445e9(event) {
    try {
        return $0ba2bc18e91bd780$export$844ec244b1367d54(event) || typeof event === "number" ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error("Events must be strings or objects with a string event.type property.");
    }
}
function $0ba2bc18e91bd780$export$e303144c5506946a(action) {
    try {
        return $0ba2bc18e91bd780$export$844ec244b1367d54(action) || typeof action === "number" ? "".concat(action) : $0ba2bc18e91bd780$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error("Actions must be strings or objects with a string action.type property.");
    }
}
function $0ba2bc18e91bd780$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($0ba2bc18e91bd780$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $0ba2bc18e91bd780$export$e080e3931a079c9b(state) {
    return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function $0ba2bc18e91bd780$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($0ba2bc18e91bd780$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($0ba2bc18e91bd780$export$43bee75e5e14138e(stateValue)) return $0ba2bc18e91bd780$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== "string") return stateValue;
    var statePath = $0ba2bc18e91bd780$export$304cde62ecda7af8(stateValue, delimiter);
    return $0ba2bc18e91bd780$export$f2ee84fc53c45e74(statePath);
}
function $0ba2bc18e91bd780$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $0ba2bc18e91bd780$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $0ba2bc18e91bd780$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $0ba2bc18e91bd780$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $0ba2bc18e91bd780$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $0ba2bc18e91bd780$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $0ba2bc18e91bd780$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $0ba2bc18e91bd780$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $0ba2bc18e91bd780$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $0ba2bc18e91bd780$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(array), false));
}
function $0ba2bc18e91bd780$export$2c0b6b2f4faf21e1(value) {
    if ($0ba2bc18e91bd780$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $0ba2bc18e91bd780$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $0ba2bc18e91bd780$export$2c0b6b2f4faf21e1(value);
}
function $0ba2bc18e91bd780$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $0ba2bc18e91bd780$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $0ba2bc18e91bd780$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($0ba2bc18e91bd780$export$f6e2535fb5126e54(value) || typeof value === "object") && $0ba2bc18e91bd780$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $0ba2bc18e91bd780$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function $0ba2bc18e91bd780$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $d9c803f633d21408$export$8d051b38c9118094)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $0ba2bc18e91bd780$export$3737909a0074eb1(hist, stateValue) {
    return $0ba2bc18e91bd780$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($0ba2bc18e91bd780$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $0ba2bc18e91bd780$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $0ba2bc18e91bd780$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $0ba2bc18e91bd780$export$3737909a0074eb1(hist, stateValue)
    };
}
function $0ba2bc18e91bd780$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) $0ba2bc18e91bd780$export$c106dd0671a0fc2d(!!context, "Attempting to update undefined context");
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $0ba2bc18e91bd780$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $0ba2bc18e91bd780$export$c106dd0671a0fc2d = function() {};
if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) $0ba2bc18e91bd780$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $0ba2bc18e91bd780$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $0ba2bc18e91bd780$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $0ba2bc18e91bd780$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $0ba2bc18e91bd780$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(condition)) return {
        type: (0, $9700b9c4f37abdbc$export$656461011b562379),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(condition)) return {
        type: (0, $9700b9c4f37abdbc$export$656461011b562379),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $0ba2bc18e91bd780$export$5cd057a6046189f9(value) {
    try {
        return "subscribe" in value && $0ba2bc18e91bd780$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $0ba2bc18e91bd780$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $0ba2bc18e91bd780$export$a6273dafbee7f61e = ($0ba2bc18e91bd780$var$_a = {}, $0ba2bc18e91bd780$var$_a[$0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
    return this;
}, $0ba2bc18e91bd780$var$_a[Symbol.observable] = function() {
    return this;
}, $0ba2bc18e91bd780$var$_a);
function $0ba2bc18e91bd780$export$2163e7903738b5df(value) {
    return !!value && "__xstatenode" in value;
}
function $0ba2bc18e91bd780$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === "function";
}
var $0ba2bc18e91bd780$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $0ba2bc18e91bd780$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(event) || typeof event === "number") return (0, $d9c803f633d21408$export$18ce0697a983be9b)({
        type: event
    }, payload);
    return event;
}
function $0ba2bc18e91bd780$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$0ba2bc18e91bd780$export$844ec244b1367d54(event) && "$$type" in event && event.$$type === "scxml") return event;
    var eventObject = $0ba2bc18e91bd780$export$5a4ea50826a01d14(event);
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)({
        name: eventObject.type,
        data: eventObject,
        $$type: "scxml",
        type: "external"
    }, scxmlEvent);
}
function $0ba2bc18e91bd780$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $0ba2bc18e91bd780$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || $0ba2bc18e91bd780$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $0ba2bc18e91bd780$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $9700b9c4f37abdbc$export$31935b4577455331)) return undefined;
    return $0ba2bc18e91bd780$export$45b10814cc054894(target);
}
function $0ba2bc18e91bd780$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ""; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $0ba2bc18e91bd780$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $9700b9c4f37abdbc$export$656461011b562379)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $0ba2bc18e91bd780$export$436e852aa2feda95(src) {
    if (typeof src === "string") return {
        type: src
    };
    return src;
}
function $0ba2bc18e91bd780$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === "object";
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $0ba2bc18e91bd780$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $0ba2bc18e91bd780$export$37dc2eda56cb25a5(action) {
    return (action.type === (0, $41059b6f2e1b7a0a$export$66313c302b2ea154) || action.type === (0, $41059b6f2e1b7a0a$export$89db4734f6c919c4) && action.to === (0, $b74e93109ba456db$export$79f5baa747fbdd45).Internal) && typeof action.delay !== "number";
}




var $83ffdf18b0958611$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === "atomic" || stateNode.type === "final";
};
function $83ffdf18b0958611$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $83ffdf18b0958611$export$f8cf48ee793b41be(stateNode) {
    return $83ffdf18b0958611$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== "history";
    });
}
function $83ffdf18b0958611$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($83ffdf18b0958611$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)($83ffdf18b0958611$export$f8cf48ee793b41be(stateNode).map($83ffdf18b0958611$export$3de19bba299e3801)));
}
function $83ffdf18b0958611$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $83ffdf18b0958611$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $83ffdf18b0958611$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === "compound" && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === "parallel") try {
                    for(var _e = (e_3 = void 0, (0, $d9c803f633d21408$export$19a8beecd37a4c45)($83ffdf18b0958611$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $83ffdf18b0958611$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === "compound") {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($83ffdf18b0958611$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $83ffdf18b0958611$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $83ffdf18b0958611$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $83ffdf18b0958611$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $83ffdf18b0958611$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $83ffdf18b0958611$var$getValueFromAdj(rootNode, $83ffdf18b0958611$export$b837d8c2d0189d63(config));
}
function $83ffdf18b0958611$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $83ffdf18b0958611$export$c661ab6895e3ed73(configuration) {
    return (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(new Set((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $83ffdf18b0958611$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === "compound") return $83ffdf18b0958611$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === "final" && $83ffdf18b0958611$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === "parallel") return $83ffdf18b0958611$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $83ffdf18b0958611$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $83ffdf18b0958611$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $83ffdf18b0958611$export$5301196121335ca0(configuration) {
    return new Set((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(configuration.map(function(sn) {
        return sn.tags;
    })));
}







var $ab1fe168d053d080$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $0ba2bc18e91bd780$export$eaf22249b410f633)({
    type: (0, $41059b6f2e1b7a0a$export$2cd8252107eb640b)
});
function $ab1fe168d053d080$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $ab1fe168d053d080$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action) || typeof action === "number") {
        var exec = $ab1fe168d053d080$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $ab1fe168d053d080$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(exec)) actionObject = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $ab1fe168d053d080$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $0ba2bc18e91bd780$export$43bee75e5e14138e)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $ab1fe168d053d080$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $ab1fe168d053d080$export$e81fdd8937d44864(action) {
    var actionObject = $ab1fe168d053d080$export$b38b66cc2da3ede7(action);
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
        id: (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $ab1fe168d053d080$export$66313c302b2ea154(event, options) {
    return {
        type: (0, $41059b6f2e1b7a0a$export$66313c302b2ea154),
        event: typeof event === "function" ? event : (0, $0ba2bc18e91bd780$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $ab1fe168d053d080$export$ed3daf8e935ede01(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        type: (0, $41059b6f2e1b7a0a$export$66313c302b2ea154),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $ab1fe168d053d080$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $41059b6f2e1b7a0a$export$89db4734f6c919c4),
        event: (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(event) ? event : (0, $0ba2bc18e91bd780$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(event) ? event.name : (0, $0ba2bc18e91bd780$export$7193fc8c8cd445e9)(event)
    };
}
function $ab1fe168d053d080$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $ab1fe168d053d080$export$408d8d51fa351f53(event, options) {
    return $ab1fe168d053d080$export$89db4734f6c919c4(event, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: (0, $b74e93109ba456db$export$79f5baa747fbdd45).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $ab1fe168d053d080$export$daa976aaff721e41(actor, event, options) {
    return $ab1fe168d053d080$export$89db4734f6c919c4(event, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $ab1fe168d053d080$export$7f8b724299523eb6() {
    return $ab1fe168d053d080$export$408d8d51fa351f53((0, $41059b6f2e1b7a0a$export$722fbec263ad908a));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $ab1fe168d053d080$export$72b816ae90496f19(event, options) {
    return $ab1fe168d053d080$export$89db4734f6c919c4(event, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $ab1fe168d053d080$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $ab1fe168d053d080$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $ab1fe168d053d080$var$defaultLogExpr;
    return {
        type: (0, $41059b6f2e1b7a0a$export$bef1f36f5486a6a3),
        label: label,
        expr: expr
    };
}
var $ab1fe168d053d080$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        value: (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $ab1fe168d053d080$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $41059b6f2e1b7a0a$export$70b61ad426ddbe54),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $ab1fe168d053d080$export$b3571188c770cc5a(activity) {
    var activityDef = $ab1fe168d053d080$export$e81fdd8937d44864(activity);
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $ab1fe168d053d080$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(actorRef) ? actorRef : $ab1fe168d053d080$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Stop,
        activity: activity,
        exec: undefined
    };
}
function $ab1fe168d053d080$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === "string" ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $ab1fe168d053d080$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $41059b6f2e1b7a0a$export$e6e34fd1f2686227),
        assignment: assignment
    };
};
function $ab1fe168d053d080$export$6e816592f80fc079(action) {
    return typeof action === "object" && "type" in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $ab1fe168d053d080$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : "";
    return "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $ab1fe168d053d080$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $ab1fe168d053d080$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $ab1fe168d053d080$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $ab1fe168d053d080$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $ab1fe168d053d080$export$eb147b7589db8e8a(target, options) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && (!target || typeof target === "function")) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === "function" ? originalTarget_1.apply(void 0, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $ab1fe168d053d080$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $ab1fe168d053d080$export$f514678a4137c4d6(errorData, options) {
    return $ab1fe168d053d080$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $41059b6f2e1b7a0a$export$a3bc9b8ed74fc),
            data: (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: (0, $b74e93109ba456db$export$79f5baa747fbdd45).Parent
    }));
}
function $ab1fe168d053d080$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Choose,
        conds: conds
    };
}
var $ab1fe168d053d080$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, $41059b6f2e1b7a0a$export$e6e34fd1f2686227)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $ab1fe168d053d080$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $ab1fe168d053d080$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $0ba2bc18e91bd780$export$d84706064a6e6c1c)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $41059b6f2e1b7a0a$export$66313c302b2ea154:
                var raisedAction = $ab1fe168d053d080$export$ed3daf8e935ede01(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === "number") predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, $41059b6f2e1b7a0a$export$89db4734f6c919c4:
                var sendAction = $ab1fe168d053d080$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!(0, $0ba2bc18e91bd780$export$844ec244b1367d54)(configuredDelay) || typeof sendAction.delay === "number", "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, $b74e93109ba456db$export$79f5baa747fbdd45).Internal) {
                    if (blockType === "entry") deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, $41059b6f2e1b7a0a$export$bef1f36f5486a6a3:
                var resolved = $ab1fe168d053d080$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $41059b6f2e1b7a0a$export$7877a478dd30fd3d:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $0ba2bc18e91bd780$export$b0f5a08e0ca47933)(condition.cond, machine.options.guards);
                    return !guard || (0, $0ba2bc18e91bd780$export$91646ab912d254e8)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $d9c803f633d21408$export$8d051b38c9118094)($ab1fe168d053d080$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $ab1fe168d053d080$export$aa68691f32e6c459((0, $0ba2bc18e91bd780$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $41059b6f2e1b7a0a$export$48ec4a2b1cfc6557:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $d9c803f633d21408$export$8d051b38c9118094)($ab1fe168d053d080$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $ab1fe168d053d080$export$aa68691f32e6c459((0, $0ba2bc18e91bd780$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $41059b6f2e1b7a0a$export$fa6813432f753b0d:
                var resolved = $ab1fe168d053d080$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $41059b6f2e1b7a0a$export$e6e34fd1f2686227:
                updatedContext = (0, $0ba2bc18e91bd780$export$d84706064a6e6c1c)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $ab1fe168d053d080$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $d9c803f633d21408$export$1216008129fb82ed)([
                                preservedContexts[contextIndex_1]
                            ], (0, $d9c803f633d21408$export$8d051b38c9118094)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}



function $db5fc64655327378$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(a) || (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $db5fc64655327378$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $db5fc64655327378$export$4c86eb6450eda77a(state) {
    if (typeof state !== "object" || state === null) return false;
    return "value" in state && "_event" in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $db5fc64655327378$export$e5d60a6bbabd36f = $db5fc64655327378$export$4c86eb6450eda77a;
function $db5fc64655327378$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $db5fc64655327378$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $9700b9c4f37abdbc$export$505a390a702f4a23);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $9700b9c4f37abdbc$export$505a390a702f4a23);
        this.meta = (0, $83ffdf18b0958611$export$c47913ca32a5c6f7)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, "nextEvents", {
            get: function() {
                return (0, $83ffdf18b0958611$export$c661ab6895e3ed73)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $ab1fe168d053d080$export$163c566c60ed2ec9);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $ab1fe168d053d080$export$163c566c60ed2ec9);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = ".";
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $d9c803f633d21408$export$3c9a16f847548506)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $0ba2bc18e91bd780$export$2870710bf0eac88e)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();







var $d4afdeb7da3b7c9c$var$defaultOptions = {
    deferEvents: false
};
var $d4afdeb7da3b7c9c$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $d4afdeb7da3b7c9c$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error("Event queue should be empty when it is not processing events");
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();




/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $d5fd06e17ea1d0ca$var$serviceStack = [];
var $d5fd06e17ea1d0ca$export$abe1e183e22e10ad = function(service, fn) {
    $d5fd06e17ea1d0ca$var$serviceStack.push(service);
    var result = fn(service);
    $d5fd06e17ea1d0ca$var$serviceStack.pop();
    return result;
};
var $d5fd06e17ea1d0ca$export$e11e6a155c5c4d9d = function(fn) {
    return fn($d5fd06e17ea1d0ca$var$serviceStack[$d5fd06e17ea1d0ca$var$serviceStack.length - 1]);
};


function $4b4d9290e25c7ae7$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $4b4d9290e25c7ae7$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $0ba2bc18e91bd780$export$436e852aa2feda95)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $4b4d9290e25c7ae7$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $4b4d9290e25c7ae7$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $4b4d9290e25c7ae7$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $4b4d9290e25c7ae7$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $4b4d9290e25c7ae7$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === "function";
    } catch (e) {
        return false;
    }
}
function $4b4d9290e25c7ae7$export$b0f989039dc164f9(item) {
    return $4b4d9290e25c7ae7$export$e769f6913f14f1b7(item) && "id" in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $4b4d9290e25c7ae7$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: "anonymous",
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a), actorRefLike);
}


var $9a2b924c76081ce4$var$children = /*#__PURE__*/ new Map();
var $9a2b924c76081ce4$var$sessionIdIndex = 0;
var $9a2b924c76081ce4$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($9a2b924c76081ce4$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $9a2b924c76081ce4$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $9a2b924c76081ce4$var$children.get(id);
    },
    free: function(id) {
        $9a2b924c76081ce4$var$children.delete(id);
    }
};



function $4e631aba0bc90519$export$a4e55266d2135a7f() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function $4e631aba0bc90519$var$getDevTools() {
    var global1 = $4e631aba0bc90519$export$a4e55266d2135a7f();
    if (global1 && "__xstate__" in global1) return global1.__xstate__;
    return undefined;
}
function $4e631aba0bc90519$export$4d7a7d14704ebc13(service) {
    if (!$4e631aba0bc90519$export$a4e55266d2135a7f()) return;
    var devTools = $4e631aba0bc90519$var$getDevTools();
    if (devTools) devTools.register(service);
}






/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $1a367ba7ff6a0efe$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $1a367ba7ff6a0efe$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: "pending"
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case "fulfill":
                    parent === null || parent === void 0 || parent.send((0, $ab1fe168d053d080$export$c105e588793f70b4)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: "fulfilled"
                    };
                case "reject":
                    parent === null || parent === void 0 || parent.send((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: "rejected"
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: "fulfill",
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: "reject",
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $1a367ba7ff6a0efe$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $4b4d9290e25c7ae7$export$ccadea5f6b9e9b4e)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || "anonymous",
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}


var $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $9ab7fd156e8ddce7$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($9ab7fd156e8ddce7$export$7a567c9c5088a551 || ($9ab7fd156e8ddce7$export$7a567c9c5088a551 = {}));
var $9ab7fd156e8ddce7$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $0ba2bc18e91bd780$export$43bee75e5e14138e)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $0ba2bc18e91bd780$export$5a4ea50826a01d14)(event1, payload));
            if (_this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, 'Event "'.concat(_event.name, '" was sent to stopped service "').concat(_this.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $b74e93109ba456db$export$79f5baa747fbdd45).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(to) ? to === (0, $b74e93109ba456db$export$79f5baa747fbdd45).Internal ? _this : _this.children.get(to) || (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).get(to) : (0, $0ba2bc18e91bd780$export$e769f6913f14f1b7)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ("machine" in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, event1), {
                        name: event1.name === (0, $41059b6f2e1b7a0a$export$a3bc9b8ed74fc) ? "".concat((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $ab1fe168d053d080$export$c7e5ca927bd4567)(action.type, actionFunctionMap);
            var exec = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: "xstate.error",
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $41059b6f2e1b7a0a$export$66313c302b2ea154:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, $41059b6f2e1b7a0a$export$89db4734f6c919c4:
                    var sendAction = action;
                    if (typeof sendAction.delay === "number") {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $ab1fe168d053d080$export$163c566c60ed2ec9));
                    else _this.send(sendAction._event);
                    break;
                case 0, $41059b6f2e1b7a0a$export$70b61ad426ddbe54:
                    _this.cancel(action.sendId);
                    break;
                case 0, $41059b6f2e1b7a0a$export$b3571188c770cc5a:
                    if (_this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Invoke) {
                        var invokeSource = (0, $0ba2bc18e91bd780$export$436e852aa2feda95)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!("forward" in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(data, context, _event) : undefined;
                        if (typeof serviceCreator === "string") // TODO: warn
                        return;
                        var source = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $41059b6f2e1b7a0a$export$fa6813432f753b0d:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $41059b6f2e1b7a0a$export$bef1f36f5486a6a3:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $d4afdeb7da3b7c9c$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $ab1fe168d053d080$export$163c566c60ed2ec9)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === "final" && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, $ab1fe168d053d080$export$c105e588793f70b4)(this.id, doneData);
            try {
                for(var _l = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).register(this.sessionId, this);
        this.initialized = true;
        this.status = $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(this, function() {
            return (0, $db5fc64655327378$export$4c86eb6450eda77a)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $db5fc64655327378$export$7254cc27399e90bd).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $ab1fe168d053d080$export$163c566c60ed2ec9));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $d4afdeb7da3b7c9c$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            var _a;
            if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) return;
             // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)({
                type: "xstate.stop"
            });
            var nextState = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(_this, function() {
                var exitActions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $ab1fe168d053d080$export$aa68691f32e6c459)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $ab1fe168d053d080$export$b8b9e7ba5b8c7b3e)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: "exit",
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $db5fc64655327378$export$7254cc27399e90bd)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, $0ba2bc18e91bd780$export$37dc2eda56cb25a5)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));
        } else if (this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event_1);
                _this.forward(_event);
                nextState = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $db5fc64655327378$export$e42513ad58964418)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event1);
        if (_event.name.indexOf((0, $41059b6f2e1b7a0a$export$503a23d0e5cd1226)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $41059b6f2e1b7a0a$export$503a23d0e5cd1226)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ("to" in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) return (0, $4b4d9290e25c7ae7$export$59bcb51d8e40ed48)(entity, name);
        if ((0, $0ba2bc18e91bd780$export$ae936b9d47e5870e)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $4b4d9290e25c7ae7$export$b0f989039dc164f9)(entity)) return this.spawnActor(entity, name);
        else if ((0, $0ba2bc18e91bd780$export$5cd057a6046189f9)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity)) return this.spawnMachine(entity, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
            id: name
        }));
        else if ((0, $0ba2bc18e91bd780$export$42749ebe1e7fdef7)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error('Unable to spawn entity "'.concat(name, '" of type "').concat(typeof entity, '".'));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $41059b6f2e1b7a0a$export$722fbec263ad908a), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $1a367ba7ff6a0efe$export$cc3859917b3feaf8)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $ab1fe168d053d080$export$c105e588793f70b4)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $0ba2bc18e91bd780$export$b240b9b7a78b5f3e)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, err));
        }
        if ((0, $0ba2bc18e91bd780$export$ae936b9d47e5870e)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $ab1fe168d053d080$export$c105e588793f70b4)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $4e631aba0bc90519$export$a4e55266d2135a7f)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $d9c803f633d21408$export$18ce0697a983be9b)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $4e631aba0bc90519$export$4d7a7d14704ebc13)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $9ab7fd156e8ddce7$export$67beed298888a38b;
    return Interpreter;
}();
var $9ab7fd156e8ddce7$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(nameOrOptions)) return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $0ba2bc18e91bd780$export$8b15d37bc3f197d4)()
    }), nameOrOptions);
};
function $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $9ab7fd156e8ddce7$var$resolveSpawnOptions(nameOrOptions);
    return (0, $d5fd06e17ea1d0ca$export$e11e6a155c5c4d9d)(function(service) {
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) {
            var isLazyEntity = (0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity) || (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(entity);
            (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!!service || isLazyEntity, 'Attempted to spawn an Actor (ID: "'.concat((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity) ? entity.id : "undefined", '") outside of a service. This will have no effect.'));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $4b4d9290e25c7ae7$export$59bcb51d8e40ed48)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $9ab7fd156e8ddce7$export$67beed298888a38b(machine, options) {
    var interpreter = new $9ab7fd156e8ddce7$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}



var $acw62 = parcelRequire("acw62");
function $f2491f7f97e8a9c7$export$2e2bcd8739ae039(fn) {
    var ref = $acw62.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}


var $5d3f760e9d626625$var$__assign = undefined && undefined.__assign || function() {
    $5d3f760e9d626625$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5d3f760e9d626625$var$__assign.apply(this, arguments);
};
var $5d3f760e9d626625$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5d3f760e9d626625$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $5d3f760e9d626625$export$d09836c9e303db57(getMachine, options) {
    var machine = (0, $f2491f7f97e8a9c7$export$2e2bcd8739ae039)(function() {
        return typeof getMachine === "function" ? getMachine() : getMachine;
    });
    if (typeof getMachine !== "function") {
        var _a = $5d3f760e9d626625$var$__read((0, $acw62.useState)(machine), 1), initialMachine = _a[0];
        if (getMachine !== initialMachine) console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
    }
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $5d3f760e9d626625$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $f2491f7f97e8a9c7$export$2e2bcd8739ae039)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return $5d3f760e9d626625$var$__assign($5d3f760e9d626625$var$__assign({}, machine.context), context);
        });
        return (0, $9ab7fd156e8ddce7$export$67beed298888a38b)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function $5d3f760e9d626625$export$d9e9b060fbbae528(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $5d3f760e9d626625$var$__read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = $5d3f760e9d626625$export$d09836c9e303db57(getMachine, options);
    (0, $acw62.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, $0ba2bc18e91bd780$export$75b67481063f2f98)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $acw62.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $db5fc64655327378$export$7254cc27399e90bd).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $9ab7fd156e8ddce7$export$7a567c9c5088a551).NotStarted;
        };
    }, []);
    return service;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e62042a96a9aa8b8$var$extendStatics = function(d, b) {
    $e62042a96a9aa8b8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e62042a96a9aa8b8$var$extendStatics(d, b);
};
function $e62042a96a9aa8b8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e62042a96a9aa8b8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e62042a96a9aa8b8$export$18ce0697a983be9b = function() {
    $e62042a96a9aa8b8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e62042a96a9aa8b8$export$18ce0697a983be9b.apply(this, arguments);
};
function $e62042a96a9aa8b8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e62042a96a9aa8b8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e62042a96a9aa8b8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e62042a96a9aa8b8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e62042a96a9aa8b8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e62042a96a9aa8b8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e62042a96a9aa8b8$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e62042a96a9aa8b8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e62042a96a9aa8b8$export$45d3717a4c69092e(o, m, p);
}
function $e62042a96a9aa8b8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e62042a96a9aa8b8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e62042a96a9aa8b8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e62042a96a9aa8b8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e62042a96a9aa8b8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e62042a96a9aa8b8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e62042a96a9aa8b8$export$10c90e4f7922046c(v) {
    return this instanceof $e62042a96a9aa8b8$export$10c90e4f7922046c ? (this.v = v, this) : new $e62042a96a9aa8b8$export$10c90e4f7922046c(v);
}
function $e62042a96a9aa8b8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e62042a96a9aa8b8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e62042a96a9aa8b8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e62042a96a9aa8b8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e62042a96a9aa8b8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e62042a96a9aa8b8$export$19a8beecd37a4c45 === "function" ? $e62042a96a9aa8b8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e62042a96a9aa8b8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e62042a96a9aa8b8$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e62042a96a9aa8b8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e62042a96a9aa8b8$export$45d3717a4c69092e(result, mod, k);
    }
    $e62042a96a9aa8b8$var$__setModuleDefault(result, mod);
    return result;
}
function $e62042a96a9aa8b8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e62042a96a9aa8b8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e62042a96a9aa8b8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e62042a96a9aa8b8$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
















function $700c0fa66ede1df8$export$436e852aa2feda95(src) {
    if (typeof src === "string") {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $700c0fa66ede1df8$export$4c73f685ba879446(invokeConfig) {
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
        type: (0, $41059b6f2e1b7a0a$export$468cda29b159ee5d)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $d9c803f633d21408$export$3c9a16f847548506)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, invokeDef), {
                type: (0, $41059b6f2e1b7a0a$export$468cda29b159ee5d),
                src: $700c0fa66ede1df8$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}


var $7c7ca11796d1b64f$var$NULL_EVENT = "";
var $7c7ca11796d1b64f$var$STATE_IDENTIFIER = "#";
var $7c7ca11796d1b64f$var$WILDCARD = "*";
var $7c7ca11796d1b64f$var$EMPTY_OBJECT = {};
var $7c7ca11796d1b64f$var$isStateId = function(str) {
    return str[0] === $7c7ca11796d1b64f$var$STATE_IDENTIFIER;
};
var $7c7ca11796d1b64f$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $7c7ca11796d1b64f$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !("cond" in transition) && !("in" in transition) && ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(transition.target) || (0, $0ba2bc18e91bd780$export$2163e7903738b5df)(transition.target));
    });
    var eventText = event === $7c7ca11796d1b64f$var$NULL_EVENT ? "the transient event" : "event '".concat(event, "'");
    (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $7c7ca11796d1b64f$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = "context" in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($7c7ca11796d1b64f$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $9700b9c4f37abdbc$export$b060f3cec92ef5c9));
        this.id = this.config.id || (0, $d9c803f633d21408$export$1216008129fb82ed)([
            this.machine.key
        ], (0, $d9c803f633d21408$export$8d051b38c9118094)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $0ba2bc18e91bd780$export$825e789796ab7275)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $d9c803f633d21408$export$18ce0697a983be9b)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $7c7ca11796d1b64f$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)((0, $83ffdf18b0958611$export$ad3d2e38d4deaf6d)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? "shallow" : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $7c7ca11796d1b64f$var$NULL_EVENT;
        }) : $7c7ca11796d1b64f$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $ab1fe168d053d080$export$b38b66cc2da3ede7)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $ab1fe168d053d080$export$b38b66cc2da3ede7)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === "final" ? this.config.data : undefined;
        this.invoke = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(invokeConfig)) {
                var invokeId = (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $d9c803f633d21408$export$18ce0697a983be9b)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i);
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(invokeConfig.src) || (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $d9c803f633d21408$export$18ce0697a983be9b)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
                    id: (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $ab1fe168d053d080$export$e81fdd8937d44864)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $83ffdf18b0958611$export$3de19bba299e3801)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, actions), options.actions),
            activities: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, activities), options.activities),
            guards: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, guards), options.guards),
            services: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, services), options.services),
            delays: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $0ba2bc18e91bd780$export$825e789796ab7275)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $7c7ca11796d1b64f$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $7c7ca11796d1b64f$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $ab1fe168d053d080$export$742acabee3dd6465)(delayRef, _this.id);
            _this.onEntry.push((0, $ab1fe168d053d080$export$89db4734f6c919c4)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $ab1fe168d053d080$export$70b61ad426ddbe54)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $0ba2bc18e91bd780$export$43bee75e5e14138e)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transition), {
                event: eventType
            });
        }) : (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $0ba2bc18e91bd780$export$45b10814cc054894)(resolvedTransition).map(function(transition) {
                return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $db5fc64655327378$export$7254cc27399e90bd) ? state.value : (0, $0ba2bc18e91bd780$export$fb3aecd1d93744e3)(state, this.delimiter);
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $0ba2bc18e91bd780$export$7193fc8c8cd445e9)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $db5fc64655327378$export$7254cc27399e90bd) ? state : (0, $db5fc64655327378$export$7254cc27399e90bd).create(state);
        var configuration = Array.from((0, $83ffdf18b0958611$export$3de01744a82b21a4)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $db5fc64655327378$export$7254cc27399e90bd)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $83ffdf18b0958611$export$cf3d5dae927fcf63)(configuration, this),
            tags: (0, $83ffdf18b0958611$export$5301196121335ca0)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateIn) && $7c7ca11796d1b64f$var$isStateId(stateIn) ? state.matches((0, $0ba2bc18e91bd780$export$fb3aecd1d93744e3)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $0ba2bc18e91bd780$export$2870710bf0eac88e)((0, $0ba2bc18e91bd780$export$fb3aecd1d93744e3)(stateIn, this.delimiter), (0, $0ba2bc18e91bd780$export$bb654e07daaf8c3a)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $0ba2bc18e91bd780$export$91646ab912d254e8)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, $83ffdf18b0958611$export$3de01744a82b21a4)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(prevConfig, sn) || (0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(resolvedConfig, sn) || (0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== "final") return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $ab1fe168d053d080$export$3df11c9c20e7b288)(sn.id, sn.doneData), (0, $ab1fe168d053d080$export$3df11c9c20e7b288)(parent.id, sn.doneData ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === "parallel") {
                if ((0, $83ffdf18b0958611$export$f8cf48ee793b41be)(grandparent).every(function(parentNode) {
                    return (0, $83ffdf18b0958611$export$cf3d5dae927fcf63)(transition.configuration, parentNode);
                })) events.push((0, $ab1fe168d053d080$export$3df11c9c20e7b288)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $ab1fe168d053d080$export$b3571188c770cc5a)(activity);
            });
            return {
                type: "entry",
                actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)(predictableExec ? (0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(entryActions), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(invokeActions), false) : (0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(invokeActions), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: "state_done",
            actions: doneEvents.map(function(event) {
                return (0, $ab1fe168d053d080$export$66313c302b2ea154)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: "exit",
                actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(stateNode.onExit), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(stateNode.activities.map(function(activity) {
                    return (0, $ab1fe168d053d080$export$fa6813432f753b0d)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: "transition",
            actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $ab1fe168d053d080$export$aa68691f32e6c459)((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, $0ba2bc18e91bd780$export$37dc2eda56cb25a5)(action);
            });
            return actions.concat({
                type: "stop",
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event);
        var currentState;
        if (state instanceof (0, $db5fc64655327378$export$7254cc27399e90bd)) currentState = context === undefined ? state : this.resolveState((0, $db5fc64655327378$export$7254cc27399e90bd).from(state, context));
        else {
            var resolvedStateValue = (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(state) ? this.resolve((0, $0ba2bc18e91bd780$export$f2ee84fc53c45e74)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $db5fc64655327378$export$7254cc27399e90bd).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && _event.name === $7c7ca11796d1b64f$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($7c7ca11796d1b64f$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $0ba2bc18e91bd780$export$479b1b8942fd0b8d)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $83ffdf18b0958611$export$3de01744a82b21a4)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $83ffdf18b0958611$export$3de01744a82b21a4)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $ab1fe168d053d080$export$163c566c60ed2ec9);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $83ffdf18b0958611$export$cf3d5dae927fcf63)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $83ffdf18b0958611$export$bf7199a9ebcb84a9)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $d9c803f633d21408$export$18ce0697a983be9b)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, $d9c803f633d21408$export$19a8beecd37a4c45)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, $41059b6f2e1b7a0a$export$b3571188c770cc5a)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $41059b6f2e1b7a0a$export$fa6813432f753b0d)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $ab1fe168d053d080$export$b8b9e7ba5b8c7b3e)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$b29f828819edca8d)(resolvedActions, (0, $0ba2bc18e91bd780$export$37dc2eda56cb25a5)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $41059b6f2e1b7a0a$export$b3571188c770cc5a) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $41059b6f2e1b7a0a$export$468cda29b159ee5d);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $4b4d9290e25c7ae7$export$78b4a98dcb5ac328)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $d9c803f633d21408$export$18ce0697a983be9b)({}, currentState.children) : {});
        var nextState = new (0, $db5fc64655327378$export$7254cc27399e90bd)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $0ba2bc18e91bd780$export$240d7cdd99ccb95a)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $83ffdf18b0958611$export$5301196121335ca0)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $41059b6f2e1b7a0a$export$722fbec263ad908a) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $7c7ca11796d1b64f$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $41059b6f2e1b7a0a$export$9477ceca5dcd796a)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $db5fc64655327378$export$3a6d15eeb5fb214c)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($7c7ca11796d1b64f$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $7c7ca11796d1b64f$var$isStateId(stateId) ? stateId.slice($7c7ca11796d1b64f$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === "string" && $7c7ca11796d1b64f$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $0ba2bc18e91bd780$export$304cde62ecda7af8)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $7c7ca11796d1b64f$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case "parallel":
                return (0, $0ba2bc18e91bd780$export$825e789796ab7275)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $7c7ca11796d1b64f$var$EMPTY_OBJECT;
                });
            case "compound":
                if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === "parallel" || subStateNode.type === "compound") return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $0ba2bc18e91bd780$export$825e789796ab7275)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $7c7ca11796d1b64f$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $7c7ca11796d1b64f$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($7c7ca11796d1b64f$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($7c7ca11796d1b64f$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $0ba2bc18e91bd780$export$304cde62ecda7af8)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === "parallel") initialStateValue = (0, $0ba2bc18e91bd780$export$2d4204fe9b34204e)(this.states, function(state) {
                return state.initialStateValue || $7c7ca11796d1b64f$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === "history");
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $83ffdf18b0958611$export$335db82b86111fd1)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === "history") {
                var historyConfig = this.config;
                if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(historyConfig.target)) target = $7c7ca11796d1b64f$var$isStateId(historyConfig.target) ? (0, $0ba2bc18e91bd780$export$f2ee84fc53c45e74)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $83ffdf18b0958611$export$335db82b86111fd1)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === "compound" && !this.initial) {
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $0ba2bc18e91bd780$export$a2618e9e89698dd6)(this.initialStateValue);
            return (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $d9c803f633d21408$export$8d051b38c9118094)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === "history") return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $0ba2bc18e91bd780$export$2d4204fe9b34204e)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== "history") return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $0ba2bc18e91bd780$export$a2618e9e89698dd6)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $0ba2bc18e91bd780$export$314d0a1a7c835392)(parent.path, "states")(historyValue).current;
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $0ba2bc18e91bd780$export$a2618e9e89698dd6)(subHistoryValue).map(function(subStatePath) {
            return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $d9c803f633d21408$export$19a8beecd37a4c45)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $0ba2bc18e91bd780$export$844ec244b1367d54)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $0ba2bc18e91bd780$export$2a4fe5c3c80e3288)(transitionConfig.target);
        var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transitionConfig), {
            actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)((0, $0ba2bc18e91bd780$export$45b10814cc054894)(transitionConfig.actions)),
            cond: (0, $0ba2bc18e91bd780$export$b0f5a08e0ca47933)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $7c7ca11796d1b64f$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $d9c803f633d21408$export$3c9a16f847548506)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && key === $7c7ca11796d1b64f$var$NULL_EVENT) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
                var transitionConfigArray = (0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(key, strictTransitionConfigs_1[key]);
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) $7c7ca11796d1b64f$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)($7c7ca11796d1b64f$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)("", this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(String((0, $ab1fe168d053d080$export$3df11c9c20e7b288)(this.id)), this.config.onDone) : [];
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
        var invokeConfig = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(String((0, $ab1fe168d053d080$export$c105e588793f70b4)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(String((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(doneConfig), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(invokeConfig), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(onConfig), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $0ba2bc18e91bd780$export$45b10814cc054894)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();



var $c9f97204c6723ccf$var$warned = false;
function $c9f97204c6723ccf$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $7c7ca11796d1b64f$export$342f24f5edd47b1)(config, options, initialContext);
}
function $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && !("predictableActionArguments" in config) && !$c9f97204c6723ccf$var$warned) {
        $c9f97204c6723ccf$var$warned = true;
        console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
    }
    return new (0, $7c7ca11796d1b64f$export$342f24f5edd47b1)(config, options);
}













var $9cec7b12efdda519$export$e6e34fd1f2686227 = (0, $ab1fe168d053d080$export$e6e34fd1f2686227), $9cec7b12efdda519$export$70b61ad426ddbe54 = (0, $ab1fe168d053d080$export$70b61ad426ddbe54), $9cec7b12efdda519$export$89db4734f6c919c4 = (0, $ab1fe168d053d080$export$89db4734f6c919c4), $9cec7b12efdda519$export$daa976aaff721e41 = (0, $ab1fe168d053d080$export$daa976aaff721e41), $9cec7b12efdda519$export$408d8d51fa351f53 = (0, $ab1fe168d053d080$export$408d8d51fa351f53), $9cec7b12efdda519$export$7f8b724299523eb6 = (0, $ab1fe168d053d080$export$7f8b724299523eb6), $9cec7b12efdda519$export$eb147b7589db8e8a = (0, $ab1fe168d053d080$export$eb147b7589db8e8a), $9cec7b12efdda519$export$c105e588793f70b4 = (0, $ab1fe168d053d080$export$c105e588793f70b4), $9cec7b12efdda519$export$66313c302b2ea154 = (0, $ab1fe168d053d080$export$66313c302b2ea154), $9cec7b12efdda519$export$bef1f36f5486a6a3 = (0, $ab1fe168d053d080$export$bef1f36f5486a6a3), $9cec7b12efdda519$export$48ec4a2b1cfc6557 = (0, $ab1fe168d053d080$export$48ec4a2b1cfc6557), $9cec7b12efdda519$export$7877a478dd30fd3d = (0, $ab1fe168d053d080$export$7877a478dd30fd3d), $9cec7b12efdda519$export$fa6813432f753b0d = (0, $ab1fe168d053d080$export$fa6813432f753b0d);


var $cb680e241675046e$exports = {};
"use strict";
Object.defineProperty($cb680e241675046e$exports, "__esModule", {
    value: true
});
var $a75e40c3098bb17e$exports = {};
"use strict";
Object.defineProperty($a75e40c3098bb17e$exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ $a75e40c3098bb17e$exports.__assign = function() {
    $a75e40c3098bb17e$exports.__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a75e40c3098bb17e$exports.__assign.apply(this, arguments);
};
function $a75e40c3098bb17e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a75e40c3098bb17e$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a75e40c3098bb17e$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a75e40c3098bb17e$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
$a75e40c3098bb17e$exports.__read = $a75e40c3098bb17e$var$__read;
$a75e40c3098bb17e$exports.__rest = $a75e40c3098bb17e$var$__rest;
$a75e40c3098bb17e$exports.__spreadArray = $a75e40c3098bb17e$var$__spreadArray;
$a75e40c3098bb17e$exports.__values = $a75e40c3098bb17e$var$__values;


var $145e86c6caf13578$exports = {};
"use strict";
Object.defineProperty($145e86c6caf13578$exports, "__esModule", {
    value: true
});
$145e86c6caf13578$exports.ActionTypes = void 0;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($145e86c6caf13578$exports.ActionTypes || ($145e86c6caf13578$exports.ActionTypes = {}));
$145e86c6caf13578$exports.SpecialTargets = void 0;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($145e86c6caf13578$exports.SpecialTargets || ($145e86c6caf13578$exports.SpecialTargets = {}));


var $4ef0a905d724033d$exports = {};
"use strict";
Object.defineProperty($4ef0a905d724033d$exports, "__esModule", {
    value: true
});

var $4ef0a905d724033d$var$start = $145e86c6caf13578$exports.ActionTypes.Start;
var $4ef0a905d724033d$var$stop = $145e86c6caf13578$exports.ActionTypes.Stop;
var $4ef0a905d724033d$var$raise = $145e86c6caf13578$exports.ActionTypes.Raise;
var $4ef0a905d724033d$var$send = $145e86c6caf13578$exports.ActionTypes.Send;
var $4ef0a905d724033d$var$cancel = $145e86c6caf13578$exports.ActionTypes.Cancel;
var $4ef0a905d724033d$var$nullEvent = $145e86c6caf13578$exports.ActionTypes.NullEvent;
var $4ef0a905d724033d$var$assign = $145e86c6caf13578$exports.ActionTypes.Assign;
var $4ef0a905d724033d$var$after = $145e86c6caf13578$exports.ActionTypes.After;
var $4ef0a905d724033d$var$doneState = $145e86c6caf13578$exports.ActionTypes.DoneState;
var $4ef0a905d724033d$var$log = $145e86c6caf13578$exports.ActionTypes.Log;
var $4ef0a905d724033d$var$init = $145e86c6caf13578$exports.ActionTypes.Init;
var $4ef0a905d724033d$var$invoke = $145e86c6caf13578$exports.ActionTypes.Invoke;
var $4ef0a905d724033d$var$errorExecution = $145e86c6caf13578$exports.ActionTypes.ErrorExecution;
var $4ef0a905d724033d$var$errorPlatform = $145e86c6caf13578$exports.ActionTypes.ErrorPlatform;
var $4ef0a905d724033d$var$error = $145e86c6caf13578$exports.ActionTypes.ErrorCustom;
var $4ef0a905d724033d$var$update = $145e86c6caf13578$exports.ActionTypes.Update;
var $4ef0a905d724033d$var$choose = $145e86c6caf13578$exports.ActionTypes.Choose;
var $4ef0a905d724033d$var$pure = $145e86c6caf13578$exports.ActionTypes.Pure;
$4ef0a905d724033d$exports.after = $4ef0a905d724033d$var$after;
$4ef0a905d724033d$exports.assign = $4ef0a905d724033d$var$assign;
$4ef0a905d724033d$exports.cancel = $4ef0a905d724033d$var$cancel;
$4ef0a905d724033d$exports.choose = $4ef0a905d724033d$var$choose;
$4ef0a905d724033d$exports.doneState = $4ef0a905d724033d$var$doneState;
$4ef0a905d724033d$exports.error = $4ef0a905d724033d$var$error;
$4ef0a905d724033d$exports.errorExecution = $4ef0a905d724033d$var$errorExecution;
$4ef0a905d724033d$exports.errorPlatform = $4ef0a905d724033d$var$errorPlatform;
$4ef0a905d724033d$exports.init = $4ef0a905d724033d$var$init;
$4ef0a905d724033d$exports.invoke = $4ef0a905d724033d$var$invoke;
$4ef0a905d724033d$exports.log = $4ef0a905d724033d$var$log;
$4ef0a905d724033d$exports.nullEvent = $4ef0a905d724033d$var$nullEvent;
$4ef0a905d724033d$exports.pure = $4ef0a905d724033d$var$pure;
$4ef0a905d724033d$exports.raise = $4ef0a905d724033d$var$raise;
$4ef0a905d724033d$exports.send = $4ef0a905d724033d$var$send;
$4ef0a905d724033d$exports.start = $4ef0a905d724033d$var$start;
$4ef0a905d724033d$exports.stop = $4ef0a905d724033d$var$stop;
$4ef0a905d724033d$exports.update = $4ef0a905d724033d$var$update;


var $e7756ac6994a59a6$exports = {};
"use strict";
Object.defineProperty($e7756ac6994a59a6$exports, "__esModule", {
    value: true
});



var $0107ffaa41d995ea$exports = {};
"use strict";
Object.defineProperty($0107ffaa41d995ea$exports, "__esModule", {
    value: true
});
var $0107ffaa41d995ea$var$STATE_DELIMITER = ".";
var $0107ffaa41d995ea$var$EMPTY_ACTIVITY_MAP = {};
var $0107ffaa41d995ea$var$DEFAULT_GUARD_TYPE = "xstate.guard";
var $0107ffaa41d995ea$var$TARGETLESS_KEY = "";
$0107ffaa41d995ea$exports.DEFAULT_GUARD_TYPE = $0107ffaa41d995ea$var$DEFAULT_GUARD_TYPE;
$0107ffaa41d995ea$exports.EMPTY_ACTIVITY_MAP = $0107ffaa41d995ea$var$EMPTY_ACTIVITY_MAP;
$0107ffaa41d995ea$exports.STATE_DELIMITER = $0107ffaa41d995ea$var$STATE_DELIMITER;
$0107ffaa41d995ea$exports.TARGETLESS_KEY = $0107ffaa41d995ea$var$TARGETLESS_KEY;


var $abdf40c536a76ff3$exports = {};
"use strict";
Object.defineProperty($abdf40c536a76ff3$exports, "__esModule", {
    value: true
});
var $abdf40c536a76ff3$var$IS_PRODUCTION = false;
$abdf40c536a76ff3$exports.IS_PRODUCTION = $abdf40c536a76ff3$var$IS_PRODUCTION;


var $e7756ac6994a59a6$var$_a;
function $e7756ac6994a59a6$var$keys(value) {
    return Object.keys(value);
}
function $e7756ac6994a59a6$var$matchesState(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = $0107ffaa41d995ea$exports.STATE_DELIMITER;
    var parentStateValue = $e7756ac6994a59a6$var$toStateValue(parentStateId, delimiter);
    var childStateValue = $e7756ac6994a59a6$var$toStateValue(childStateId, delimiter);
    if ($e7756ac6994a59a6$var$isString(childStateValue)) {
        if ($e7756ac6994a59a6$var$isString(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($e7756ac6994a59a6$var$isString(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $e7756ac6994a59a6$var$matchesState(parentStateValue[key], childStateValue[key]);
    });
}
function $e7756ac6994a59a6$var$getEventType(event) {
    try {
        return $e7756ac6994a59a6$var$isString(event) || typeof event === "number" ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error("Events must be strings or objects with a string event.type property.");
    }
}
function $e7756ac6994a59a6$var$getActionType(action) {
    try {
        return $e7756ac6994a59a6$var$isString(action) || typeof action === "number" ? "".concat(action) : $e7756ac6994a59a6$var$isFunction(action) ? action.name : action.type;
    } catch (e) {
        throw new Error("Actions must be strings or objects with a string action.type property.");
    }
}
function $e7756ac6994a59a6$var$toStatePath(stateId, delimiter) {
    try {
        if ($e7756ac6994a59a6$var$isArray(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $e7756ac6994a59a6$var$isStateLike(state) {
    return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function $e7756ac6994a59a6$var$toStateValue(stateValue, delimiter) {
    if ($e7756ac6994a59a6$var$isStateLike(stateValue)) return stateValue.value;
    if ($e7756ac6994a59a6$var$isArray(stateValue)) return $e7756ac6994a59a6$var$pathToStateValue(stateValue);
    if (typeof stateValue !== "string") return stateValue;
    var statePath = $e7756ac6994a59a6$var$toStatePath(stateValue, delimiter);
    return $e7756ac6994a59a6$var$pathToStateValue(statePath);
}
function $e7756ac6994a59a6$var$pathToStateValue(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $e7756ac6994a59a6$var$mapValues(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $e7756ac6994a59a6$var$mapFilterValues(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = $a75e40c3098bb17e$exports.__values(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $e7756ac6994a59a6$var$path = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = $a75e40c3098bb17e$exports.__values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $e7756ac6994a59a6$var$nestedPath(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = $a75e40c3098bb17e$exports.__values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $e7756ac6994a59a6$var$toStatePaths(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($e7756ac6994a59a6$var$isString(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $e7756ac6994a59a6$var$flatten(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $e7756ac6994a59a6$var$toStatePaths(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $e7756ac6994a59a6$var$pathsToStateValue(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = $a75e40c3098bb17e$exports.__values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $e7756ac6994a59a6$var$flatten(array) {
    var _a;
    return (_a = []).concat.apply(_a, $a75e40c3098bb17e$exports.__spreadArray([], $a75e40c3098bb17e$exports.__read(array), false));
}
function $e7756ac6994a59a6$var$toArrayStrict(value) {
    if ($e7756ac6994a59a6$var$isArray(value)) return value;
    return [
        value
    ];
}
function $e7756ac6994a59a6$var$toArray(value) {
    if (value === undefined) return [];
    return $e7756ac6994a59a6$var$toArrayStrict(value);
}
function $e7756ac6994a59a6$var$mapContext(mapper, context, _event) {
    var e_5, _a;
    if ($e7756ac6994a59a6$var$isFunction(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = $a75e40c3098bb17e$exports.__values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($e7756ac6994a59a6$var$isFunction(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $e7756ac6994a59a6$var$isBuiltInEvent(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $e7756ac6994a59a6$var$isPromiseLike(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($e7756ac6994a59a6$var$isFunction(value) || typeof value === "object") && $e7756ac6994a59a6$var$isFunction(value.then)) return true;
    return false;
}
function $e7756ac6994a59a6$var$isBehavior(value) {
    return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function $e7756ac6994a59a6$var$partition(items, predicate) {
    var e_6, _a;
    var _b = $a75e40c3098bb17e$exports.__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $a75e40c3098bb17e$exports.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $e7756ac6994a59a6$var$updateHistoryStates(hist, stateValue) {
    return $e7756ac6994a59a6$var$mapValues(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($e7756ac6994a59a6$var$isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $e7756ac6994a59a6$var$updateHistoryStates(subHist, subStateValue)
        };
    });
}
function $e7756ac6994a59a6$var$updateHistoryValue(hist, stateValue) {
    return {
        current: stateValue,
        states: $e7756ac6994a59a6$var$updateHistoryStates(hist, stateValue)
    };
}
function $e7756ac6994a59a6$var$updateContext(context, _event, assignActions, state) {
    if (!$abdf40c536a76ff3$exports.IS_PRODUCTION) $e7756ac6994a59a6$exports.warn(!!context, "Attempting to update undefined context");
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($e7756ac6994a59a6$var$isFunction(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = $a75e40c3098bb17e$exports.__values(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $e7756ac6994a59a6$var$isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
$e7756ac6994a59a6$exports.warn = function() {};
if (!$abdf40c536a76ff3$exports.IS_PRODUCTION) $e7756ac6994a59a6$exports.warn = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $e7756ac6994a59a6$var$isArray(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $e7756ac6994a59a6$var$isFunction(value) {
    return typeof value === "function";
}
function $e7756ac6994a59a6$var$isString(value) {
    return typeof value === "string";
}
function $e7756ac6994a59a6$var$toGuard(condition, guardMap) {
    if (!condition) return undefined;
    if ($e7756ac6994a59a6$var$isString(condition)) return {
        type: $0107ffaa41d995ea$exports.DEFAULT_GUARD_TYPE,
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($e7756ac6994a59a6$var$isFunction(condition)) return {
        type: $0107ffaa41d995ea$exports.DEFAULT_GUARD_TYPE,
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $e7756ac6994a59a6$var$isObservable(value) {
    try {
        return "subscribe" in value && $e7756ac6994a59a6$var$isFunction(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $e7756ac6994a59a6$var$symbolObservable = /*#__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $e7756ac6994a59a6$var$interopSymbols = ($e7756ac6994a59a6$var$_a = {}, $e7756ac6994a59a6$var$_a[$e7756ac6994a59a6$var$symbolObservable] = function() {
    return this;
}, $e7756ac6994a59a6$var$_a[Symbol.observable] = function() {
    return this;
}, $e7756ac6994a59a6$var$_a);
function $e7756ac6994a59a6$var$isMachine(value) {
    return !!value && "__xstatenode" in value;
}
function $e7756ac6994a59a6$var$isActor(value) {
    return !!value && typeof value.send === "function";
}
var $e7756ac6994a59a6$var$uniqueId = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $e7756ac6994a59a6$var$toEventObject(event, payload // id?: TEvent['type']
) {
    if ($e7756ac6994a59a6$var$isString(event) || typeof event === "number") return $a75e40c3098bb17e$exports.__assign({
        type: event
    }, payload);
    return event;
}
function $e7756ac6994a59a6$var$toSCXMLEvent(event, scxmlEvent) {
    if (!$e7756ac6994a59a6$var$isString(event) && "$$type" in event && event.$$type === "scxml") return event;
    var eventObject = $e7756ac6994a59a6$var$toEventObject(event);
    return $a75e40c3098bb17e$exports.__assign({
        name: eventObject.type,
        data: eventObject,
        $$type: "scxml",
        type: "external"
    }, scxmlEvent);
}
function $e7756ac6994a59a6$var$toTransitionConfigArray(event, configLike) {
    var transitions = $e7756ac6994a59a6$var$toArrayStrict(configLike).map(function(transitionLike) {
        if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || $e7756ac6994a59a6$var$isMachine(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $e7756ac6994a59a6$var$normalizeTarget(target) {
    if (target === undefined || target === $0107ffaa41d995ea$exports.TARGETLESS_KEY) return undefined;
    return $e7756ac6994a59a6$var$toArray(target);
}
function $e7756ac6994a59a6$var$reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
    if (!$abdf40c536a76ff3$exports.IS_PRODUCTION) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ""; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $e7756ac6994a59a6$var$evaluateGuard(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === $0107ffaa41d995ea$exports.DEFAULT_GUARD_TYPE) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $e7756ac6994a59a6$var$toInvokeSource(src) {
    if (typeof src === "string") return {
        type: src
    };
    return src;
}
function $e7756ac6994a59a6$var$toObserver(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === "object";
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $e7756ac6994a59a6$var$createInvokeId(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $e7756ac6994a59a6$var$isRaisableAction(action) {
    return (action.type === $4ef0a905d724033d$exports.raise || action.type === $4ef0a905d724033d$exports.send && action.to === $145e86c6caf13578$exports.SpecialTargets.Internal) && typeof action.delay !== "number";
}
$e7756ac6994a59a6$exports.createInvokeId = $e7756ac6994a59a6$var$createInvokeId;
$e7756ac6994a59a6$exports.evaluateGuard = $e7756ac6994a59a6$var$evaluateGuard;
$e7756ac6994a59a6$exports.flatten = $e7756ac6994a59a6$var$flatten;
$e7756ac6994a59a6$exports.getActionType = $e7756ac6994a59a6$var$getActionType;
$e7756ac6994a59a6$exports.getEventType = $e7756ac6994a59a6$var$getEventType;
$e7756ac6994a59a6$exports.interopSymbols = $e7756ac6994a59a6$var$interopSymbols;
$e7756ac6994a59a6$exports.isActor = $e7756ac6994a59a6$var$isActor;
$e7756ac6994a59a6$exports.isArray = $e7756ac6994a59a6$var$isArray;
$e7756ac6994a59a6$exports.isBehavior = $e7756ac6994a59a6$var$isBehavior;
$e7756ac6994a59a6$exports.isBuiltInEvent = $e7756ac6994a59a6$var$isBuiltInEvent;
$e7756ac6994a59a6$exports.isFunction = $e7756ac6994a59a6$var$isFunction;
$e7756ac6994a59a6$exports.isMachine = $e7756ac6994a59a6$var$isMachine;
$e7756ac6994a59a6$exports.isObservable = $e7756ac6994a59a6$var$isObservable;
$e7756ac6994a59a6$exports.isPromiseLike = $e7756ac6994a59a6$var$isPromiseLike;
$e7756ac6994a59a6$exports.isRaisableAction = $e7756ac6994a59a6$var$isRaisableAction;
$e7756ac6994a59a6$exports.isStateLike = $e7756ac6994a59a6$var$isStateLike;
$e7756ac6994a59a6$exports.isString = $e7756ac6994a59a6$var$isString;
$e7756ac6994a59a6$exports.keys = $e7756ac6994a59a6$var$keys;
$e7756ac6994a59a6$exports.mapContext = $e7756ac6994a59a6$var$mapContext;
$e7756ac6994a59a6$exports.mapFilterValues = $e7756ac6994a59a6$var$mapFilterValues;
$e7756ac6994a59a6$exports.mapValues = $e7756ac6994a59a6$var$mapValues;
$e7756ac6994a59a6$exports.matchesState = $e7756ac6994a59a6$var$matchesState;
$e7756ac6994a59a6$exports.nestedPath = $e7756ac6994a59a6$var$nestedPath;
$e7756ac6994a59a6$exports.normalizeTarget = $e7756ac6994a59a6$var$normalizeTarget;
$e7756ac6994a59a6$exports.partition = $e7756ac6994a59a6$var$partition;
$e7756ac6994a59a6$exports.path = $e7756ac6994a59a6$var$path;
$e7756ac6994a59a6$exports.pathToStateValue = $e7756ac6994a59a6$var$pathToStateValue;
$e7756ac6994a59a6$exports.pathsToStateValue = $e7756ac6994a59a6$var$pathsToStateValue;
$e7756ac6994a59a6$exports.reportUnhandledExceptionOnInvocation = $e7756ac6994a59a6$var$reportUnhandledExceptionOnInvocation;
$e7756ac6994a59a6$exports.symbolObservable = $e7756ac6994a59a6$var$symbolObservable;
$e7756ac6994a59a6$exports.toArray = $e7756ac6994a59a6$var$toArray;
$e7756ac6994a59a6$exports.toArrayStrict = $e7756ac6994a59a6$var$toArrayStrict;
$e7756ac6994a59a6$exports.toEventObject = $e7756ac6994a59a6$var$toEventObject;
$e7756ac6994a59a6$exports.toGuard = $e7756ac6994a59a6$var$toGuard;
$e7756ac6994a59a6$exports.toInvokeSource = $e7756ac6994a59a6$var$toInvokeSource;
$e7756ac6994a59a6$exports.toObserver = $e7756ac6994a59a6$var$toObserver;
$e7756ac6994a59a6$exports.toSCXMLEvent = $e7756ac6994a59a6$var$toSCXMLEvent;
$e7756ac6994a59a6$exports.toStatePath = $e7756ac6994a59a6$var$toStatePath;
$e7756ac6994a59a6$exports.toStatePaths = $e7756ac6994a59a6$var$toStatePaths;
$e7756ac6994a59a6$exports.toStateValue = $e7756ac6994a59a6$var$toStateValue;
$e7756ac6994a59a6$exports.toTransitionConfigArray = $e7756ac6994a59a6$var$toTransitionConfigArray;
$e7756ac6994a59a6$exports.uniqueId = $e7756ac6994a59a6$var$uniqueId;
$e7756ac6994a59a6$exports.updateContext = $e7756ac6994a59a6$var$updateContext;
$e7756ac6994a59a6$exports.updateHistoryStates = $e7756ac6994a59a6$var$updateHistoryStates;
$e7756ac6994a59a6$exports.updateHistoryValue = $e7756ac6994a59a6$var$updateHistoryValue;



var $cb680e241675046e$var$initEvent = /*#__PURE__*/ $e7756ac6994a59a6$exports.toSCXMLEvent({
    type: $4ef0a905d724033d$exports.init
});
function $cb680e241675046e$var$getActionFunction(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $cb680e241675046e$var$toActionObject(action, actionFunctionMap) {
    var actionObject;
    if ($e7756ac6994a59a6$exports.isString(action) || typeof action === "number") {
        var exec = $cb680e241675046e$var$getActionFunction(action, actionFunctionMap);
        if ($e7756ac6994a59a6$exports.isFunction(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ($e7756ac6994a59a6$exports.isFunction(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $cb680e241675046e$var$getActionFunction(action.type, actionFunctionMap);
        if ($e7756ac6994a59a6$exports.isFunction(exec)) actionObject = $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $cb680e241675046e$var$toActionObjects = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = $e7756ac6994a59a6$exports.isArray(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $cb680e241675046e$var$toActionObject(subAction, actionFunctionMap);
    });
};
function $cb680e241675046e$var$toActivityDefinition(action) {
    var actionObject = $cb680e241675046e$var$toActionObject(action);
    return $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({
        id: $e7756ac6994a59a6$exports.isString(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $cb680e241675046e$var$raise(event, options) {
    return {
        type: $4ef0a905d724033d$exports.raise,
        event: typeof event === "function" ? event : $e7756ac6994a59a6$exports.toEventObject(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $cb680e241675046e$var$resolveRaise(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = $e7756ac6994a59a6$exports.toSCXMLEvent($e7756ac6994a59a6$exports.isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ($e7756ac6994a59a6$exports.isString(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = $e7756ac6994a59a6$exports.isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = $e7756ac6994a59a6$exports.isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, action), {
        type: $4ef0a905d724033d$exports.raise,
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $cb680e241675046e$var$send(event, options) {
    return {
        to: options ? options.to : undefined,
        type: $4ef0a905d724033d$exports.send,
        event: $e7756ac6994a59a6$exports.isFunction(event) ? event : $e7756ac6994a59a6$exports.toEventObject(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : $e7756ac6994a59a6$exports.isFunction(event) ? event.name : $e7756ac6994a59a6$exports.getEventType(event)
    };
}
function $cb680e241675046e$var$resolveSend(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = $e7756ac6994a59a6$exports.toSCXMLEvent($e7756ac6994a59a6$exports.isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ($e7756ac6994a59a6$exports.isString(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = $e7756ac6994a59a6$exports.isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = $e7756ac6994a59a6$exports.isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = $e7756ac6994a59a6$exports.isFunction(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $cb680e241675046e$var$sendParent(event, options) {
    return $cb680e241675046e$var$send(event, $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, options), {
        to: $145e86c6caf13578$exports.SpecialTargets.Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $cb680e241675046e$var$sendTo(actor, event, options) {
    return $cb680e241675046e$var$send(event, $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $cb680e241675046e$var$sendUpdate() {
    return $cb680e241675046e$var$sendParent($4ef0a905d724033d$exports.update);
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $cb680e241675046e$var$respond(event, options) {
    return $cb680e241675046e$var$send(event, $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $cb680e241675046e$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $cb680e241675046e$var$log(expr, label) {
    if (expr === void 0) expr = $cb680e241675046e$var$defaultLogExpr;
    return {
        type: $4ef0a905d724033d$exports.log,
        label: label,
        expr: expr
    };
}
var $cb680e241675046e$var$resolveLog = function(action, ctx, _event) {
    return $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, action), {
        value: $e7756ac6994a59a6$exports.isString(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $cb680e241675046e$var$cancel = function(sendId) {
    return {
        type: $4ef0a905d724033d$exports.cancel,
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $cb680e241675046e$var$start(activity) {
    var activityDef = $cb680e241675046e$var$toActivityDefinition(activity);
    return {
        type: $145e86c6caf13578$exports.ActionTypes.Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $cb680e241675046e$var$stop(actorRef) {
    var activity = $e7756ac6994a59a6$exports.isFunction(actorRef) ? actorRef : $cb680e241675046e$var$toActivityDefinition(actorRef);
    return {
        type: $145e86c6caf13578$exports.ActionTypes.Stop,
        activity: activity,
        exec: undefined
    };
}
function $cb680e241675046e$var$resolveStop(action, context, _event) {
    var actorRefOrString = $e7756ac6994a59a6$exports.isFunction(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === "string" ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: $145e86c6caf13578$exports.ActionTypes.Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $cb680e241675046e$var$assign = function(assignment) {
    return {
        type: $4ef0a905d724033d$exports.assign,
        assignment: assignment
    };
};
function $cb680e241675046e$var$isActionObject(action) {
    return typeof action === "object" && "type" in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $cb680e241675046e$var$after(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : "";
    return "".concat($145e86c6caf13578$exports.ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $cb680e241675046e$var$done(id, data) {
    var type = "".concat($145e86c6caf13578$exports.ActionTypes.DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $cb680e241675046e$var$doneInvoke(id, data) {
    var type = "".concat($145e86c6caf13578$exports.ActionTypes.DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $cb680e241675046e$var$error(id, data) {
    var type = "".concat($145e86c6caf13578$exports.ActionTypes.ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $cb680e241675046e$var$pure(getActions) {
    return {
        type: $145e86c6caf13578$exports.ActionTypes.Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $cb680e241675046e$var$forwardTo(target, options) {
    if (!$abdf40c536a76ff3$exports.IS_PRODUCTION && (!target || typeof target === "function")) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === "function" ? originalTarget_1.apply(void 0, $a75e40c3098bb17e$exports.__spreadArray([], $a75e40c3098bb17e$exports.__read(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $cb680e241675046e$var$send(function(_, event) {
        return event;
    }, $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $cb680e241675046e$var$escalate(errorData, options) {
    return $cb680e241675046e$var$sendParent(function(context, event, meta) {
        return {
            type: $4ef0a905d724033d$exports.error,
            data: $e7756ac6994a59a6$exports.isFunction(errorData) ? errorData(context, event, meta) : errorData
        };
    }, $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, options), {
        to: $145e86c6caf13578$exports.SpecialTargets.Parent
    }));
}
function $cb680e241675046e$var$choose(conds) {
    return {
        type: $145e86c6caf13578$exports.ActionTypes.Choose,
        conds: conds
    };
}
var $cb680e241675046e$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = $a75e40c3098bb17e$exports.__values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === $4ef0a905d724033d$exports.assign) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $cb680e241675046e$var$resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $cb680e241675046e$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? $e7756ac6994a59a6$exports.updateContext(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case $4ef0a905d724033d$exports.raise:
                var raisedAction = $cb680e241675046e$var$resolveRaise(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === "number") predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case $4ef0a905d724033d$exports.send:
                var sendAction = $cb680e241675046e$var$resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!$abdf40c536a76ff3$exports.IS_PRODUCTION) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    $e7756ac6994a59a6$exports.warn(!$e7756ac6994a59a6$exports.isString(configuredDelay) || typeof sendAction.delay === "number", "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== $145e86c6caf13578$exports.SpecialTargets.Internal) {
                    if (blockType === "entry") deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case $4ef0a905d724033d$exports.log:
                var resolved = $cb680e241675046e$var$resolveLog(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case $4ef0a905d724033d$exports.choose:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = $e7756ac6994a59a6$exports.toGuard(condition.cond, machine.options.guards);
                    return !guard || $e7756ac6994a59a6$exports.evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = $a75e40c3098bb17e$exports.__read($cb680e241675046e$var$resolveActions(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $cb680e241675046e$var$toActionObjects($e7756ac6994a59a6$exports.toArray(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case $4ef0a905d724033d$exports.pure:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = $a75e40c3098bb17e$exports.__read($cb680e241675046e$var$resolveActions(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $cb680e241675046e$var$toActionObjects($e7756ac6994a59a6$exports.toArray(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case $4ef0a905d724033d$exports.stop:
                var resolved = $cb680e241675046e$var$resolveStop(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case $4ef0a905d724033d$exports.assign:
                updatedContext = $e7756ac6994a59a6$exports.updateContext(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $cb680e241675046e$var$toActionObject(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, $a75e40c3098bb17e$exports.__spreadArray([
                                preservedContexts[contextIndex_1]
                            ], $a75e40c3098bb17e$exports.__read(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = $a75e40c3098bb17e$exports.__values(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = $e7756ac6994a59a6$exports.flatten(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}
$cb680e241675046e$exports.actionTypes = $4ef0a905d724033d$exports;
$cb680e241675046e$exports.after = $cb680e241675046e$var$after;
$cb680e241675046e$exports.assign = $cb680e241675046e$var$assign;
$cb680e241675046e$exports.cancel = $cb680e241675046e$var$cancel;
$cb680e241675046e$exports.choose = $cb680e241675046e$var$choose;
$cb680e241675046e$exports.done = $cb680e241675046e$var$done;
$cb680e241675046e$exports.doneInvoke = $cb680e241675046e$var$doneInvoke;
$cb680e241675046e$exports.error = $cb680e241675046e$var$error;
$cb680e241675046e$exports.escalate = $cb680e241675046e$var$escalate;
$cb680e241675046e$exports.forwardTo = $cb680e241675046e$var$forwardTo;
$cb680e241675046e$exports.getActionFunction = $cb680e241675046e$var$getActionFunction;
$cb680e241675046e$exports.initEvent = $cb680e241675046e$var$initEvent;
$cb680e241675046e$exports.isActionObject = $cb680e241675046e$var$isActionObject;
$cb680e241675046e$exports.log = $cb680e241675046e$var$log;
$cb680e241675046e$exports.pure = $cb680e241675046e$var$pure;
$cb680e241675046e$exports.raise = $cb680e241675046e$var$raise;
$cb680e241675046e$exports.resolveActions = $cb680e241675046e$var$resolveActions;
$cb680e241675046e$exports.resolveLog = $cb680e241675046e$var$resolveLog;
$cb680e241675046e$exports.resolveRaise = $cb680e241675046e$var$resolveRaise;
$cb680e241675046e$exports.resolveSend = $cb680e241675046e$var$resolveSend;
$cb680e241675046e$exports.resolveStop = $cb680e241675046e$var$resolveStop;
$cb680e241675046e$exports.respond = $cb680e241675046e$var$respond;
$cb680e241675046e$exports.send = $cb680e241675046e$var$send;
$cb680e241675046e$exports.sendParent = $cb680e241675046e$var$sendParent;
$cb680e241675046e$exports.sendTo = $cb680e241675046e$var$sendTo;
$cb680e241675046e$exports.sendUpdate = $cb680e241675046e$var$sendUpdate;
$cb680e241675046e$exports.start = $cb680e241675046e$var$start;
$cb680e241675046e$exports.stop = $cb680e241675046e$var$stop;
$cb680e241675046e$exports.toActionObject = $cb680e241675046e$var$toActionObject;
$cb680e241675046e$exports.toActionObjects = $cb680e241675046e$var$toActionObjects;
$cb680e241675046e$exports.toActivityDefinition = $cb680e241675046e$var$toActivityDefinition;




var $1305f10b63a5651f$export$b6947cfc708251b6 = function(e) {
    return (0, $cb680e241675046e$exports.stop)(e);
}, $1305f10b63a5651f$export$9faa50368a7b3c89 = (0, $cb680e241675046e$exports.assign)({
    attributeToVerify: function(e) {}
}), $1305f10b63a5651f$export$aa3d1e2603b6b393 = (0, $cb680e241675046e$exports.assign)({
    challengeName: function(e) {}
}), $1305f10b63a5651f$export$f59683a2f5c65c18 = (0, $cb680e241675046e$exports.assign)({
    requiredAttributes: function(e) {}
}), $1305f10b63a5651f$export$a15ba4bdf59dacc9 = (0, $cb680e241675046e$exports.assign)({
    remoteError: function(e) {
        return "";
    }
}), $1305f10b63a5651f$export$bfa16614c507dc4b = (0, $cb680e241675046e$exports.assign)({
    formValues: function(e) {
        return {};
    }
}), $1305f10b63a5651f$export$c459b227ec8b5bb = (0, $cb680e241675046e$exports.assign)({
    touched: function(e) {
        return {};
    }
}), $1305f10b63a5651f$export$58692221bc9d7254 = (0, $cb680e241675046e$exports.assign)({
    unverifiedContactMethods: function(e) {}
}), $1305f10b63a5651f$export$1d20f61d217c468f = (0, $cb680e241675046e$exports.assign)({
    username: function(e) {}
}), $1305f10b63a5651f$export$5270f204082eebfb = (0, $cb680e241675046e$exports.assign)({
    validationError: function(e) {
        return {};
    }
}), $1305f10b63a5651f$export$11d8ed3bd13bb8e3 = (0, $cb680e241675046e$exports.assign)({
    challengeName: function(e, r) {
        var n;
        return null === (n = r.data) || void 0 === n ? void 0 : n.challengeName;
    }
}), $1305f10b63a5651f$export$f18efc7fc22567f3 = (0, $cb680e241675046e$exports.assign)({
    requiredAttributes: function(e, r) {
        var n, t;
        return null === (t = null === (n = r.data) || void 0 === n ? void 0 : n.challengeParam) || void 0 === t ? void 0 : t.requiredAttributes;
    }
}), $1305f10b63a5651f$export$e574184fef92c521 = (0, $cb680e241675046e$exports.assign)({
    redirectIntent: function(e) {
        return "confirmPasswordReset";
    }
}), $1305f10b63a5651f$export$95541f1a5e3a994 = (0, $cb680e241675046e$exports.assign)({
    redirectIntent: function(e) {
        return "confirmSignUp";
    }
}), $1305f10b63a5651f$export$3a6cdb4d139acb5f = (0, $cb680e241675046e$exports.assign)({
    authAttributes: function(e, r) {
        var n, t, o = e.loginMechanisms[0];
        return {
            username: null !== (n = e.formValues[o]) && void 0 !== n ? n : e.formValues.username,
            password: null === (t = e.formValues) || void 0 === t ? void 0 : t.password
        };
    }
}), $1305f10b63a5651f$export$6c79f1f160aff8ba = (0, $cb680e241675046e$exports.assign)({
    validationError: function(e, r) {
        return r.data;
    }
}), $1305f10b63a5651f$export$a6a2df750d905c59 = (0, $cb680e241675046e$exports.assign)({
    remoteError: function(e, r) {
        var n;
        return "NoUserPoolError" === r.data.name ? "Configuration error (see console) \u2013 please contact the administrator" : (null === (n = r.data) || void 0 === n ? void 0 : n.message) || r.data;
    }
}), $1305f10b63a5651f$export$a15839655cde632a = (0, $cb680e241675046e$exports.assign)({
    unverifiedContactMethods: function(e, r) {
        return r.data.unverified;
    }
}), $1305f10b63a5651f$export$8b6bb3dd62a01be2 = (0, $cb680e241675046e$exports.assign)({
    user: function(e, r) {
        return r.data.user || r.data;
    }
}), $1305f10b63a5651f$export$6ae5cbbde4bec733 = (0, $cb680e241675046e$exports.assign)({
    username: function(e, r) {
        var n = e.formValues, t = n.username, o = n.country_code;
        return o && (t = "".concat(o).concat(t)), t;
    }
}), $1305f10b63a5651f$export$f9df8f75fe67ab58 = (0, $cb680e241675046e$exports.assign)({
    codeDeliveryDetails: function(e, r) {
        return r.data.codeDeliveryDetails;
    }
}), $1305f10b63a5651f$export$12b5e0d209e80876 = (0, $cb680e241675046e$exports.assign)({
    authAttributes: function(e, r) {
        return {
            username: e.formValues.username
        };
    }
}), $1305f10b63a5651f$export$412508d679148d5c = (0, $cb680e241675046e$exports.assign)({
    formValues: function(r, n) {
        var t, o = n.data, u = o.name, a = o.value;
        return (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, r.formValues), ((t = {})[u] = a, t));
    }
}), $1305f10b63a5651f$export$89c2621768820c8b = (0, $cb680e241675046e$exports.assign)({
    formValues: function(r, n) {
        return (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, r.formValues), n.data);
    }
}), $1305f10b63a5651f$export$27d5d91e7417534c = (0, $cb680e241675046e$exports.assign)({
    touched: function(r, n) {
        var t, o = n.data.name;
        return (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, r.touched), ((t = {})["".concat(o)] = !0, t));
    }
}), $1305f10b63a5651f$export$da44e4eaa54bc82e = (0, $cb680e241675046e$exports.assign)({
    formValues: function(r, n) {
        var t, o, u = r.loginMechanisms[0], a = void 0 === u ? "username" : u;
        if (!r.formValues.phone_number && "phone_number" !== a) return r.formValues;
        var i = r.formValues, c = r.country_code, s = i.phone_number ? "phone_number" : "username", d = "".concat(null !== (o = i.country_code) && void 0 !== o ? o : c).concat(i[s]).replace(/[^A-Z0-9+]/gi, ""), l = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, i), ((t = {})[s] = d, t));
        return delete l.country_code, l;
    }
});




var $d299ac421c05c135$exports = {};

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


var $2f7f607262506341$exports = {};

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $eMthh = parcelRequire("eMthh");

var $f504n = parcelRequire("f504n");

var $3wZFp = parcelRequire("3wZFp");

var $1Q21n = parcelRequire("1Q21n");
/** `Object#toString` result references. */ var $2f7f607262506341$var$mapTag = "[object Map]", $2f7f607262506341$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $2f7f607262506341$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f7f607262506341$var$hasOwnProperty = $2f7f607262506341$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $2f7f607262506341$var$isEmpty(value) {
    if (value == null) return true;
    if ($eMthh(value) && ($o8HxT(value) || typeof value == "string" || typeof value.splice == "function" || $f504n(value) || $1Q21n(value) || $aJD6g(value))) return !value.length;
    var tag = $67A6V(value);
    if (tag == $2f7f607262506341$var$mapTag || tag == $2f7f607262506341$var$setTag) return !value.size;
    if ($3wZFp(value)) return !$jViFF(value).length;
    for(var key in value){
        if ($2f7f607262506341$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
$2f7f607262506341$exports = $2f7f607262506341$var$isEmpty;





var $4524f833ae45779b$exports = {};
var $34696005ed9b3f30$exports = {};

var $g779E = parcelRequire("g779E");
var $5bab87b519c266a0$exports = {};

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6TC8i(object[key], value) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
$5bab87b519c266a0$exports = $5bab87b519c266a0$var$assignMergeValue;


var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;


var $964a7bd734d0fbad$exports = {};


var $uQ1Em = parcelRequire("uQ1Em");

var $5JAGM = parcelRequire("5JAGM");

var $aA0pv = parcelRequire("aA0pv");

var $dFJsF = parcelRequire("dFJsF");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
var $e5599ea424e07f76$exports = {};

var $eMthh = parcelRequire("eMthh");

var $8l89S = parcelRequire("8l89S");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $8l89S(value) && $eMthh(value);
}
$e5599ea424e07f76$exports = $e5599ea424e07f76$var$isArrayLikeObject;



var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $xMy82 = parcelRequire("xMy82");

var $1Q21n = parcelRequire("1Q21n");
var $121eb86ef7ce6b9c$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$121eb86ef7ce6b9c$exports = $121eb86ef7ce6b9c$var$safeGet;


var $eda853de6b056001$exports = {};

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $cYlGN(value, $f4lqP(value));
}
$eda853de6b056001$exports = $eda853de6b056001$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $121eb86ef7ce6b9c$exports(object, key), srcValue = $121eb86ef7ce6b9c$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $5bab87b519c266a0$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $o8HxT(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $1Q21n(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($o8HxT(objValue)) newValue = objValue;
            else if ($e5599ea424e07f76$exports(objValue)) newValue = $aA0pv(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5JAGM(srcValue, true);
            } else newValue = [];
        } else if ($xMy82(srcValue) || $aJD6g(srcValue)) {
            newValue = objValue;
            if ($aJD6g(objValue)) newValue = $eda853de6b056001$exports(objValue);
            else if (!$lsJ54(objValue) || $01ubZ(objValue)) newValue = $dFJsF(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $5bab87b519c266a0$exports(object, key, newValue);
}
$964a7bd734d0fbad$exports = $964a7bd734d0fbad$var$baseMergeDeep;



var $lsJ54 = parcelRequire("lsJ54");

var $f4lqP = parcelRequire("f4lqP");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $9f0778b809a8c692$exports(source, function(srcValue, key) {
        stack || (stack = new $g779E);
        if ($lsJ54(srcValue)) $964a7bd734d0fbad$exports(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($121eb86ef7ce6b9c$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $5bab87b519c266a0$exports(object, key, newValue);
        }
    }, $f4lqP);
}
$34696005ed9b3f30$exports = $34696005ed9b3f30$var$baseMerge;


var $d1e75591f556b111$exports = {};
var $3db9ad8fe1351fef$exports = {};

var $4Nq5y = parcelRequire("4Nq5y");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $iGMVy($b86t6(func, start, $4Nq5y), func + "");
}
$3db9ad8fe1351fef$exports = $3db9ad8fe1351fef$var$baseRest;


var $81b21e8b41d211e8$exports = {};

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == "number" ? $eMthh(object) && $iyUuu(index, object.length) : type == "string" && index in object) return $6TC8i(object[index], value);
    return false;
}
$81b21e8b41d211e8$exports = $81b21e8b41d211e8$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $3db9ad8fe1351fef$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $81b21e8b41d211e8$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$d1e75591f556b111$exports = $d1e75591f556b111$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4524f833ae45779b$var$merge = $d1e75591f556b111$exports(function(object, source, srcIndex) {
    $34696005ed9b3f30$exports(object, source, srcIndex);
});
$4524f833ae45779b$exports = $4524f833ae45779b$var$merge;


var $8ae14af0a6bbf07c$export$59e2b39f02edfada = function(n, s, m, a) {
    return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var r, l;
        return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(o) {
            switch(o.label){
                case 0:
                    return [
                        4,
                        Promise.all(a.map(function(r) {
                            return r(n, s, m);
                        }))
                    ];
                case 1:
                    return r = o.sent(), l = (0, (/*@__PURE__*/$parcel$interopDefault($4524f833ae45779b$exports))).apply(void 0, (0, $e62042a96a9aa8b8$export$1216008129fb82ed)([
                        {}
                    ], r, !1)), (0, (/*@__PURE__*/$parcel$interopDefault($2f7f607262506341$exports)))(l) ? [
                        2,
                        Promise.resolve()
                    ] : [
                        2,
                        Promise.reject(l)
                    ];
            }
        });
    });
};





var $bd85b94eaceb5cbd$exports = {};
var $565b5ed18efa4b9c$exports = {};
var $a9e76203bd7c412f$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a9e76203bd7c412f$exports = $a9e76203bd7c412f$var$baseFindIndex;


var $c66d4063f81f4687$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
$c66d4063f81f4687$exports = $c66d4063f81f4687$var$baseIsNaN;


var $a1f1a90cd7caaefa$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$a1f1a90cd7caaefa$exports = $a1f1a90cd7caaefa$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $a1f1a90cd7caaefa$exports(array, value, fromIndex) : $a9e76203bd7c412f$exports(array, $c66d4063f81f4687$exports, fromIndex);
}
$565b5ed18efa4b9c$exports = $565b5ed18efa4b9c$var$baseIndexOf;



var $eMthh = parcelRequire("eMthh");

var $1SJGG = parcelRequire("1SJGG");
var $20712de2064d78dd$exports = {};
var $6ceabe126a95a54e$exports = {};
var $dc614d828223dea6$exports = {};
var $0542da1d887b1c4d$exports = {};
var $ef99cce288c7323e$exports = {};
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$ef99cce288c7323e$exports = $ef99cce288c7323e$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $ef99cce288c7323e$exports(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, "") : string;
}
$0542da1d887b1c4d$exports = $0542da1d887b1c4d$var$baseTrim;



var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $lsJ54(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $0542da1d887b1c4d$exports(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $dc614d828223dea6$exports(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$6ceabe126a95a54e$exports = $6ceabe126a95a54e$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $6ceabe126a95a54e$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$20712de2064d78dd$exports = $20712de2064d78dd$var$toInteger;


var $58e15c1958c92f73$exports = {};
var $df5daa5e60cd3cbe$exports = {};

var $i46jW = parcelRequire("i46jW");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $df5daa5e60cd3cbe$var$baseValues(object, props) {
    return $i46jW(props, function(key) {
        return object[key];
    });
}
$df5daa5e60cd3cbe$exports = $df5daa5e60cd3cbe$var$baseValues;



var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $58e15c1958c92f73$var$values(object) {
    return object == null ? [] : $df5daa5e60cd3cbe$exports(object, $LAMcS(object));
}
$58e15c1958c92f73$exports = $58e15c1958c92f73$var$values;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $bd85b94eaceb5cbd$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $bd85b94eaceb5cbd$var$includes(collection, value, fromIndex, guard) {
    collection = $eMthh(collection) ? collection : $58e15c1958c92f73$exports(collection);
    fromIndex = fromIndex && !guard ? $20712de2064d78dd$exports(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $bd85b94eaceb5cbd$var$nativeMax(length + fromIndex, 0);
    return $1SJGG(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $565b5ed18efa4b9c$exports(collection, value, fromIndex) > -1;
}
$bd85b94eaceb5cbd$exports = $bd85b94eaceb5cbd$var$includes;








var $2746ff49da407695$export$a51e8cda1526c737 = [
    "+1",
    "+7",
    "+20",
    "+27",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+36",
    "+39",
    "+40",
    "+41",
    "+43",
    "+44",
    "+45",
    "+46",
    "+47",
    "+48",
    "+49",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+81",
    "+82",
    "+84",
    "+86",
    "+90",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+98",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+223",
    "+224",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+230",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+242",
    "+243",
    "+244",
    "+245",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+345",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+356",
    "+357",
    "+358",
    "+359",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+385",
    "+386",
    "+387",
    "+389",
    "+420",
    "+421",
    "+423",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+537",
    "+590",
    "+591",
    "+593",
    "+594",
    "+595",
    "+596",
    "+597",
    "+598",
    "+599",
    "+670",
    "+672",
    "+673",
    "+674",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+687",
    "+688",
    "+689",
    "+690",
    "+691",
    "+692",
    "+850",
    "+852",
    "+853",
    "+855",
    "+856",
    "+872",
    "+880",
    "+886",
    "+960",
    "+961",
    "+962",
    "+963",
    "+964",
    "+965",
    "+966",
    "+967",
    "+968",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998"
];



var $bc2ad104d785472a$export$1222d357a3c2c47f = {
    birthdate: {
        label: "Birthdate",
        labelHidden: !0,
        placeholder: "Birthdate",
        type: "date",
        autocomplete: "bday",
        isRequired: !0
    },
    confirmation_code: {
        label: "Confirmation Code",
        labelHidden: !0,
        placeholder: "Code",
        type: "number",
        autocomplete: "one-time-code",
        isRequired: !0
    },
    confirm_password: {
        label: "Confirm Password",
        labelHidden: !0,
        placeholder: "Confirm Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    email: {
        label: "Email",
        labelHidden: !0,
        placeholder: "Email",
        type: "email",
        autocomplete: "username",
        isRequired: !0
    },
    family_name: {
        label: "Family Name",
        labelHidden: !0,
        placeholder: "Family Name",
        type: "text",
        autocomplete: "family-name",
        isRequired: !0
    },
    given_name: {
        label: "Given Name",
        labelHidden: !0,
        placeholder: "Given Name",
        type: "text",
        autocomplete: "given-name",
        isRequired: !0
    },
    middle_name: {
        label: "Middle Name",
        labelHidden: !0,
        placeholder: "Middle Name",
        type: "text",
        autocomplete: "additional-name",
        isRequired: !0
    },
    name: {
        label: "Name",
        labelHidden: !0,
        placeholder: "Name",
        type: "text",
        autocomplete: "name",
        isRequired: !0
    },
    nickname: {
        label: "Nickname",
        labelHidden: !0,
        placeholder: "Nickname",
        type: "text",
        autocomplete: "tel",
        isRequired: !0
    },
    password: {
        label: "Password",
        labelHidden: !0,
        placeholder: "Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    phone_number: {
        label: "Phone Number",
        labelHidden: !0,
        placeholder: "Phone",
        type: "tel",
        autocomplete: "tel",
        dialCode: "+1",
        dialCodeList: (0, $2746ff49da407695$export$a51e8cda1526c737),
        isRequired: !0
    },
    preferred_username: {
        label: "Preferred Username",
        labelHidden: !0,
        placeholder: "Preferred Username",
        type: "text",
        isRequired: !0
    },
    profile: {
        label: "Profile",
        labelHidden: !0,
        placeholder: "Profile",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    website: {
        label: "Website",
        labelHidden: !0,
        placeholder: "Website",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    username: {
        label: "Username",
        labelHidden: !0,
        placeholder: "Username",
        type: "text",
        autocomplete: "username",
        isRequired: !0
    }
}, $bc2ad104d785472a$export$4223938282102ea7 = [
    "^",
    "$",
    "*",
    ".",
    "[",
    "]",
    "{",
    "}",
    "(",
    ")",
    "?",
    '"',
    "!",
    "@",
    "#",
    "%",
    "&",
    "/",
    "\\",
    ",",
    ">",
    "<",
    "'",
    ":",
    ";",
    "|",
    "_",
    "~",
    "`",
    "=",
    "+",
    "-",
    " "
];


var $b694cdd7ed95d843$export$3c7f711f5942602f = function(t) {
    var e = t.packageName, a = t.version;
    (0, $68caf4bd6c7da8b9$export$ad34c5a3baecdb02)("".concat(e, "/").concat(a));
}, $b694cdd7ed95d843$export$655775443891f2b8 = function(t) {
    for(var n = t.trim().split(""), e = 0; e < n.length; e++)e > 0 && e < n.length - 1 && (n[e] = "*");
    return n.join("");
}, $b694cdd7ed95d843$export$72b2b64445441bf7 = function(t) {
    if (t.length < 4) return t;
    for(var n = t.split(""), e = 0; e < n.length - 4; e++)n[e] = "*";
    return n.join("");
}, $b694cdd7ed95d843$export$f726708373635d8a = function(t, n) {
    var e = n.send, a = n.getSnapshot();
    switch(t.payload.event){
        case "tokenRefresh":
            a.matches("authenticated.idle") && e("TOKEN_REFRESH");
            break;
        case "signOut":
        case "tokenRefresh_failure":
            a.matches("authenticated.idle") && e("SIGN_OUT");
    }
}, $b694cdd7ed95d843$export$4776c363cae9362c = function(n, e) {
    return void 0 === e && (e = $b694cdd7ed95d843$export$f726708373635d8a), (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).listen("auth", function(t) {
        e(t, n);
    }, "authenticator-hub-handler");
}, $b694cdd7ed95d843$export$1ec93875315f071d = function(t) {
    return (0, $bc2ad104d785472a$export$4223938282102ea7).some(function(n) {
        return t.includes(n);
    });
}, $b694cdd7ed95d843$export$f1f323074be5cac0 = function(t, n, e) {
    return encodeURI("otpauth://totp/".concat(t, ":").concat(n, "?secret=").concat(e, "&issuer=").concat(t));
};


var $d9b513d63d79678d$exports = {};

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $d9b513d63d79678d$var$CLONE_DEEP_FLAG = 1, $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d9b513d63d79678d$var$cloneDeep(value) {
    return $kqX4j(value, $d9b513d63d79678d$var$CLONE_DEEP_FLAG | $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG);
}
$d9b513d63d79678d$exports = $d9b513d63d79678d$var$cloneDeep;


var $df55ec0aa99eabf3$export$7ae2d201ca9520b = {
    getAmplifyConfig: function() {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2,
                    (0, $36606c730099e1c8$export$a3858a9a153cffc7).configure()
                ];
            });
        });
    },
    getCurrentUser: function() {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2,
                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentAuthenticatedUser()
                ];
            });
        });
    },
    handleSignUp: function(r) {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2,
                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).signUp(r)
                ];
            });
        });
    },
    handleSignIn: function(r) {
        var o = r.username, s = r.password;
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2,
                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).signIn(o, s)
                ];
            });
        });
    },
    handleConfirmSignIn: function(r) {
        var o = r.user, s = r.code, e = r.mfaType;
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2,
                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).confirmSignIn(o, s, e)
                ];
            });
        });
    },
    handleConfirmSignUp: function(r) {
        var o = r.username, s = r.code;
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            (0, $cc420cb14b670b2a$export$334c29725a78c21d).confirmSignUp(o, s)
                        ];
                    case 1:
                        return [
                            2,
                            t.sent()
                        ];
                }
            });
        });
    },
    handleForgotPasswordSubmit: function(r) {
        var o = r.username, s = r.code, e = r.password;
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2,
                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).forgotPasswordSubmit(o, s, e)
                ];
            });
        });
    },
    handleForgotPassword: function(r) {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2,
                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).forgotPassword(r)
                ];
            });
        });
    },
    validateCustomSignUp: function(r, i) {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2
                ];
            });
        });
    },
    validateFormPassword: function(r, i, s) {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var t, e, u, a;
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(n) {
                return t = r.password, i.password && s ? (e = [], u = +(null == s ? void 0 : s.passwordPolicyMinLength), t.length < u && e.push("Password must have at least ".concat(u, " characters")), null == (a = null == s ? void 0 : s.passwordPolicyCharacters) || a.forEach(function(n) {
                    switch(n){
                        case "REQUIRES_LOWERCASE":
                            /[a-z]/.test(t) || e.push("Password must have lower case letters");
                            break;
                        case "REQUIRES_UPPERCASE":
                            /[A-Z]/.test(t) || e.push("Password must have upper case letters");
                            break;
                        case "REQUIRES_NUMBERS":
                            /[0-9]/.test(t) || e.push("Password must have numbers");
                            break;
                        case "REQUIRES_SYMBOLS":
                            (0, $b694cdd7ed95d843$export$1ec93875315f071d)(t) || e.push("Password must have special characters");
                    }
                }), [
                    2,
                    0 !== e.length ? {
                        password: e
                    } : null
                ]) : [
                    2,
                    null
                ];
            });
        });
    },
    validateConfirmPassword: function(r, i) {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var t, o, s, e;
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(n) {
                return t = r.password, o = r.confirm_password, s = i.confirm_password, e = i.password, t || o ? (t || o) && t !== o && (s && e || (null == t ? void 0 : t.length) >= 6 && (null == o ? void 0 : o.length) >= 6) ? [
                    2,
                    {
                        confirm_password: "Your passwords must match"
                    }
                ] : [
                    2
                ] : [
                    2,
                    null
                ];
            });
        });
    },
    validatePreferredUsername: function(r, i) {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                return [
                    2
                ];
            });
        });
    }
};


var $bd263d51ec7085ae$var$_ = [
    "SMS_MFA",
    "SOFTWARE_TOKEN_MFA"
], $bd263d51ec7085ae$var$k = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(e, "data.challengeName");
}, $bd263d51ec7085ae$var$D = function(e, t) {
    return e === t;
}, $bd263d51ec7085ae$var$M = function(e) {
    return $bd263d51ec7085ae$var$_.includes(e);
};
function $bd263d51ec7085ae$export$f9c30eaa77191700(o) {
    var _ = o.services;
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        initial: "init",
        id: "signInActor",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "autoSignIn",
                        cond: "shouldAutoSignIn"
                    },
                    {
                        target: "signIn"
                    }
                ]
            },
            signIn: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            FEDERATED_SIGN_IN: "federatedSignIn"
                        }
                    },
                    federatedSignIn: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "federatedSignIn",
                            onError: {
                                actions: "setRemoteError"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "parsePhoneNumber",
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "signIn",
                            onDone: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "verifying"
                                }
                            ],
                            onError: [
                                {
                                    cond: "shouldRedirectToConfirmSignUp",
                                    actions: [
                                        "setCredentials",
                                        "setConfirmSignUpIntent"
                                    ],
                                    target: "rejected"
                                },
                                {
                                    cond: "shouldRedirectToConfirmResetPassword",
                                    actions: [
                                        "setUsernameAuthAttributes",
                                        "setConfirmResetPasswordIntent"
                                    ],
                                    target: "rejected"
                                },
                                {
                                    actions: "setRemoteError",
                                    target: "edit"
                                }
                            ]
                        }
                    },
                    verifying: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "checkVerifiedContact",
                            onDone: [
                                {
                                    cond: "shouldRequestVerification",
                                    target: "#signInActor.verifyUser",
                                    actions: "setUnverifiedContactMethods"
                                },
                                {
                                    target: "resolved"
                                }
                            ],
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    },
                    resolved: {
                        always: "#signInActor.resolved"
                    },
                    rejected: {
                        always: "#signInActor.rejected"
                    }
                }
            },
            autoSignIn: {
                initial: "submit",
                states: {
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "signIn",
                            onDone: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "#signInActor.resolved"
                                }
                            ],
                            onError: [
                                {
                                    cond: "shouldRedirectToConfirmSignUp",
                                    actions: [
                                        "setCredentials",
                                        "setConfirmSignUpIntent"
                                    ],
                                    target: "#signInActor.rejected"
                                },
                                {
                                    cond: "shouldRedirectToConfirmResetPassword",
                                    actions: [
                                        "setUsernameAuthAttributes",
                                        "setConfirmResetPasswordIntent"
                                    ],
                                    target: "#signInActor.rejected"
                                },
                                {
                                    actions: "setRemoteError",
                                    target: "#signInActor.signIn"
                                }
                            ]
                        }
                    }
                }
            },
            confirmSignIn: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmSignIn",
                            onDone: {
                                target: "#signInActor.resolved",
                                actions: [
                                    "setUser",
                                    "clearChallengeName",
                                    "clearRequiredAttributes"
                                ]
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    }
                }
            },
            forceNewPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submit: {
                        initial: "idle",
                        entry: "clearError",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "forceNewPassword",
                                    onDone: [
                                        {
                                            cond: "shouldConfirmSignIn",
                                            actions: [
                                                "setUser",
                                                "setChallengeName"
                                            ],
                                            target: "#signInActor.confirmSignIn"
                                        },
                                        {
                                            cond: "shouldSetupTOTP",
                                            actions: [
                                                "setUser",
                                                "setChallengeName"
                                            ],
                                            target: "#signInActor.setupTOTP"
                                        },
                                        {
                                            target: "resolved",
                                            actions: [
                                                "setUser",
                                                "setCredentials"
                                            ]
                                        }
                                    ],
                                    onError: {
                                        target: "idle",
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            resolved: {
                                type: "final",
                                always: "#signInActor.resolved"
                            }
                        }
                    }
                }
            },
            setupTOTP: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "verifyTotpToken",
                            onDone: {
                                actions: [
                                    "clearChallengeName",
                                    "clearRequiredAttributes"
                                ],
                                target: "#signInActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            verifyUser: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#signInActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: "clearError",
                        invoke: {
                            src: "verifyUser",
                            onDone: {
                                target: "#signInActor.confirmVerifyUser"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmVerifyUser: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearUnverifiedContactMethods",
                    "clearAttributeToVerify",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#signInActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: "clearError",
                        invoke: {
                            src: "confirmVerifyUser",
                            onDone: {
                                target: "#signInActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: function(e) {
                    return {
                        user: e.user
                    };
                }
            },
            rejected: {
                type: "final",
                data: function(e, t) {
                    return {
                        intent: e.redirectIntent,
                        authAttributes: e.authAttributes
                    };
                }
            }
        }
    }, {
        actions: {
            clearAttributeToVerify: (0, $1305f10b63a5651f$export$9faa50368a7b3c89),
            clearChallengeName: (0, $1305f10b63a5651f$export$aa3d1e2603b6b393),
            clearRequiredAttributes: (0, $1305f10b63a5651f$export$f59683a2f5c65c18),
            clearError: (0, $1305f10b63a5651f$export$a15ba4bdf59dacc9),
            clearFormValues: (0, $1305f10b63a5651f$export$bfa16614c507dc4b),
            clearTouched: (0, $1305f10b63a5651f$export$c459b227ec8b5bb),
            clearUnverifiedContactMethods: (0, $1305f10b63a5651f$export$58692221bc9d7254),
            clearValidationError: (0, $1305f10b63a5651f$export$5270f204082eebfb),
            handleInput: (0, $1305f10b63a5651f$export$412508d679148d5c),
            handleSubmit: (0, $1305f10b63a5651f$export$89c2621768820c8b),
            handleBlur: (0, $1305f10b63a5651f$export$27d5d91e7417534c),
            parsePhoneNumber: (0, $1305f10b63a5651f$export$da44e4eaa54bc82e),
            setChallengeName: (0, $1305f10b63a5651f$export$11d8ed3bd13bb8e3),
            setConfirmResetPasswordIntent: (0, $1305f10b63a5651f$export$e574184fef92c521),
            setConfirmSignUpIntent: (0, $1305f10b63a5651f$export$95541f1a5e3a994),
            setRequiredAttributes: (0, $1305f10b63a5651f$export$f18efc7fc22567f3),
            setCredentials: (0, $1305f10b63a5651f$export$3a6cdb4d139acb5f),
            setFieldErrors: (0, $1305f10b63a5651f$export$6c79f1f160aff8ba),
            setRemoteError: (0, $1305f10b63a5651f$export$a6a2df750d905c59),
            setUnverifiedContactMethods: (0, $1305f10b63a5651f$export$a15839655cde632a),
            setUser: (0, $1305f10b63a5651f$export$8b6bb3dd62a01be2),
            setUsernameAuthAttributes: (0, $1305f10b63a5651f$export$12b5e0d209e80876),
            sendUpdate: (0, $9cec7b12efdda519$export$7f8b724299523eb6)()
        },
        guards: {
            shouldConfirmSignIn: function(e, t) {
                return $bd263d51ec7085ae$var$M($bd263d51ec7085ae$var$k(t));
            },
            shouldAutoSignIn: function(e) {
                return "autoSignIn" === (null == e ? void 0 : e.intent);
            },
            shouldRedirectToConfirmSignUp: function(e, t) {
                return "UserNotConfirmedException" === t.data.code;
            },
            shouldRedirectToConfirmResetPassword: function(e, t) {
                return "PasswordResetRequiredException" === t.data.code;
            },
            shouldSetupTOTP: function(e, t) {
                return $bd263d51ec7085ae$var$D($bd263d51ec7085ae$var$k(t), "MFA_SETUP");
            },
            shouldForceChangePassword: function(e, t) {
                return $bd263d51ec7085ae$var$D($bd263d51ec7085ae$var$k(t), "NEW_PASSWORD_REQUIRED");
            },
            shouldRequestVerification: function(e, t) {
                var r = t.data, n = r.unverified, i = r.verified;
                return (0, (/*@__PURE__*/$parcel$interopDefault($2f7f607262506341$exports)))(i) && !(0, (/*@__PURE__*/$parcel$interopDefault($2f7f607262506341$exports)))(n);
            }
        },
        services: {
            signIn: function(n) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, i, o, s, a, c, d;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = n.authAttributes, i = void 0 === e ? {} : e, o = n.formValues, s = void 0 === o ? {} : o, a = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, i), s), c = a.username, d = a.password, [
                                    4,
                                    _.handleSignIn({
                                        username: c,
                                        password: d
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    t.sent()
                                ];
                        }
                    });
                });
            },
            confirmSignIn: function(r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, n, o, s;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = r.challengeName, n = r.user, o = r.formValues.confirmation_code, s = $bd263d51ec7085ae$var$M(e) ? e : void 0, [
                                    4,
                                    _.handleConfirmSignIn({
                                        user: n,
                                        code: o,
                                        mfaType: s
                                    })
                                ];
                            case 1:
                                return t.sent(), [
                                    4,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentAuthenticatedUser()
                                ];
                            case 2:
                                return [
                                    2,
                                    t.sent()
                                ];
                        }
                    });
                });
            },
            forceNewPassword: function(o) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, s, a, c, d, u, l, g, f;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        switch(t.label){
                            case 0:
                                e = o.user, s = o.formValues, a = s.password, s.confirm_password, c = s.phone_number, d = s.country_code, u = (0, $e62042a96a9aa8b8$export$3c9a16f847548506)(s, [
                                    "password",
                                    "confirm_password",
                                    "phone_number",
                                    "country_code"
                                ]), c && (l = "".concat(d).concat(c).replace(/[^A-Z0-9+]/gi, ""), u = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, u), {
                                    phone_number: l
                                })), t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).completeNewPassword(e, a, u)
                                ];
                            case 2:
                                return (g = t.sent()).challengeName ? [
                                    2,
                                    g
                                ] : [
                                    2,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentAuthenticatedUser()
                                ];
                            case 3:
                                return f = t.sent(), [
                                    2,
                                    Promise.reject(f)
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            },
            verifyTotpToken: function(r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, n, o;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        return e = r.formValues, n = r.user, o = e.confirmation_code, [
                            2,
                            (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifyTotpToken(n, o)
                        ];
                    });
                });
            },
            federatedSignIn: function(r, n) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = n.data.provider, [
                                    4,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).federatedSignIn({
                                        provider: e
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    t.sent()
                                ];
                        }
                    });
                });
            },
            checkVerifiedContact: function(r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = r.user, [
                                    4,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifiedContact(e)
                                ];
                            case 1:
                                return [
                                    2,
                                    t.sent()
                                ];
                        }
                    });
                });
            },
            verifyUser: function(r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, n;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = r.formValues.unverifiedAttr, [
                                    4,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifyCurrentUserAttribute(e)
                                ];
                            case 1:
                                return n = t.sent(), r.attributeToVerify = e, [
                                    2,
                                    n
                                ];
                        }
                    });
                });
            },
            confirmVerifyUser: function(r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, n;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = r.attributeToVerify, n = r.formValues.confirmation_code, [
                                    4,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifyCurrentUserAttributeSubmit(e, n)
                                ];
                            case 1:
                                return [
                                    2,
                                    t.sent()
                                ];
                        }
                    });
                });
            },
            validateFields: function(r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(e) {
                        return [
                            2,
                            (0, $8ae14af0a6bbf07c$export$59e2b39f02edfada)(r.formValues, r.touched, r.passwordSettings, [
                                (0, $df55ec0aa99eabf3$export$7ae2d201ca9520b).validateConfirmPassword
                            ])
                        ];
                    });
                });
            }
        }
    });
}




var $0a0e7d6b532b57c6$export$2f15f45f1f7b7787 = (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
    initial: "pending",
    id: "signOutActor",
    predictableActionArguments: !0,
    states: {
        pending: {
            tags: [
                "pending"
            ],
            invoke: {
                src: "signOut",
                onDone: "resolved",
                onError: "rejected"
            }
        },
        resolved: {
            type: "final"
        },
        rejected: {
            type: "final"
        }
    }
}, {
    services: {
        signOut: function() {
            return (0, $cc420cb14b670b2a$export$334c29725a78c21d).signOut();
        }
    }
});







function $6a09bac45e5617d7$export$9e01526a2f4b3199(E) {
    var h = E.services;
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        id: "resetPasswordActor",
        initial: "init",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "confirmResetPassword",
                        cond: "shouldAutoConfirmReset"
                    },
                    {
                        target: "resetPassword"
                    }
                ]
            },
            resetPassword: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "setUsername",
                            "clearError"
                        ],
                        invoke: {
                            src: "resetPassword",
                            onDone: {
                                target: "#resetPasswordActor.confirmResetPassword"
                            },
                            onError: {
                                actions: [
                                    "setRemoteError"
                                ],
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmResetPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearUsername",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    RESEND: "resendCode",
                                    CHANGE: {
                                        actions: "handleInput"
                                    },
                                    BLUR: {
                                        actions: "handleBlur"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            resendCode: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "resetPassword",
                                    onDone: {
                                        target: "idle"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "confirmResetPassword",
                                    onDone: {
                                        actions: "clearUsername",
                                        target: "#resetPasswordActor.resolved"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final"
            }
        }
    }, {
        actions: {
            clearError: (0, $1305f10b63a5651f$export$a15ba4bdf59dacc9),
            clearFormValues: (0, $1305f10b63a5651f$export$bfa16614c507dc4b),
            clearTouched: (0, $1305f10b63a5651f$export$c459b227ec8b5bb),
            clearUsername: (0, $1305f10b63a5651f$export$1d20f61d217c468f),
            clearValidationError: (0, $1305f10b63a5651f$export$5270f204082eebfb),
            handleInput: (0, $1305f10b63a5651f$export$412508d679148d5c),
            handleSubmit: (0, $1305f10b63a5651f$export$89c2621768820c8b),
            handleBlur: (0, $1305f10b63a5651f$export$27d5d91e7417534c),
            setFieldErrors: (0, $1305f10b63a5651f$export$6c79f1f160aff8ba),
            setRemoteError: (0, $1305f10b63a5651f$export$a6a2df750d905c59),
            setUsername: (0, $1305f10b63a5651f$export$6ae5cbbde4bec733),
            sendUpdate: (0, $9cec7b12efdda519$export$7f8b724299523eb6)()
        },
        guards: {
            shouldAutoConfirmReset: function(e, r) {
                return !(!e.intent || "confirmPasswordReset" !== e.intent);
            }
        },
        services: {
            resetPassword: function(t) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(r) {
                        return e = t.username, [
                            2,
                            h.handleForgotPassword(e)
                        ];
                    });
                });
            },
            confirmResetPassword: function(t) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, n, s, o;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(r) {
                        return e = t.username, n = t.formValues, s = n.confirmation_code, o = n.password, [
                            2,
                            h.handleForgotPasswordSubmit({
                                username: e,
                                code: s,
                                password: o
                            })
                        ];
                    });
                });
            },
            validateFields: function(t, n) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(e) {
                        return [
                            2,
                            (0, $8ae14af0a6bbf07c$export$59e2b39f02edfada)(t.formValues, t.touched, t.passwordSettings, [
                                (0, $df55ec0aa99eabf3$export$7ae2d201ca9520b).validateConfirmPassword
                            ])
                        ];
                    });
                });
            }
        }
    });
}






var $9b6d46093811e2aa$exports = {};

var $i46jW = parcelRequire("i46jW");
var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};

var $g779E = parcelRequire("g779E");
var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $g779E = parcelRequire("g779E");
var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $6gDBQ = parcelRequire("6gDBQ");
var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;



var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $g779E;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$lsJ54(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



var $LAMcS = parcelRequire("LAMcS");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $LAMcS(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;



var $kPpic = parcelRequire("kPpic");



var $6DSvu = parcelRequire("6DSvu");
/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($kPpic(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($6DSvu(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;



var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");
var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

var $lJEX1 = parcelRequire("lJEX1");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $lJEX1(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;



var $kPpic = parcelRequire("kPpic");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $kPpic(path) ? $d45a621b4548f6bb$exports($6DSvu(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $4Nq5y;
    if (typeof value == "object") return $o8HxT(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $4e551d8e73f04819$exports = {};

var $lJEX1 = parcelRequire("lJEX1");
var $aba0e6d66e8d80dd$exports = {};

var $5i71d = parcelRequire("5i71d");

var $4RK0h = parcelRequire("4RK0h");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $4RK0h(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $6DSvu(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $5i71d(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$aba0e6d66e8d80dd$exports = $aba0e6d66e8d80dd$var$baseSet;



var $4RK0h = parcelRequire("4RK0h");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $lJEX1(object, path);
        if (predicate(value, path)) $aba0e6d66e8d80dd$exports(result, $4RK0h(path, object), value);
    }
    return result;
}
$4e551d8e73f04819$exports = $4e551d8e73f04819$var$basePickBy;



var $i0kKc = parcelRequire("i0kKc");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $9b6d46093811e2aa$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $i46jW($i0kKc(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $5aba4f6d9f8304a3$exports(predicate);
    return $4e551d8e73f04819$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$9b6d46093811e2aa$exports = $9b6d46093811e2aa$var$pickBy;





function $9b7ec60ebabacf20$export$a5c4b20d9017fce9(C) {
    var I = C.services;
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        id: "signUpActor",
        initial: "init",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "confirmSignUp",
                        cond: "shouldInitConfirmSignUp"
                    },
                    {
                        target: "signUp"
                    }
                ]
            },
            signUp: {
                type: "parallel",
                exit: [
                    "clearError",
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    FEDERATED_SIGN_IN: "federatedSignIn"
                                }
                            },
                            federatedSignIn: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "federatedSignIn",
                                    onDone: "#signUpActor.resolved",
                                    onError: {
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "parsePhoneNumber",
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "signUp",
                                    onDone: [
                                        {
                                            cond: "shouldSkipConfirm",
                                            target: "skipConfirm",
                                            actions: [
                                                "setUser",
                                                "setCredentials"
                                            ]
                                        },
                                        {
                                            target: "resolved",
                                            actions: [
                                                "setUser",
                                                "setCredentials",
                                                "setCodeDeliveryDetails"
                                            ]
                                        }
                                    ],
                                    onError: {
                                        target: "idle",
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            skipConfirm: {
                                always: {
                                    target: "#signUpActor.resolved",
                                    actions: "setAutoSignInIntent"
                                }
                            },
                            resolved: {
                                type: "final",
                                always: "#signUpActor.confirmSignUp"
                            }
                        }
                    }
                }
            },
            confirmSignUp: {
                initial: "edit",
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            },
                            RESEND: "resend"
                        }
                    },
                    resend: {
                        tags: [
                            "pending"
                        ],
                        entry: "sendUpdate",
                        invoke: {
                            src: "resendConfirmationCode",
                            onDone: {
                                target: "edit"
                            },
                            onError: [
                                {
                                    target: "#signUpActor.resolved",
                                    actions: "setAutoSignInIntent",
                                    cond: "isUserAlreadyConfirmed"
                                },
                                {
                                    target: "edit",
                                    actions: "setRemoteError"
                                }
                            ]
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "confirmSignUp",
                            onDone: {
                                target: "#signUpActor.resolved",
                                actions: "setAutoSignInIntent"
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: function(e, n) {
                    var t = e.authAttributes, i = t.username, a = t.password;
                    return {
                        user: (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(n, "data.user") || e.user,
                        authAttributes: {
                            username: i,
                            password: a
                        },
                        intent: e.intent
                    };
                }
            }
        }
    }, {
        guards: {
            isUserAlreadyConfirmed: function(e, n) {
                return "User is already confirmed." === n.data.message;
            },
            shouldInitConfirmSignUp: function(e) {
                return e.intent && "confirmSignUp" === e.intent;
            },
            shouldSkipConfirm: function(e, n) {
                return n.data.userConfirmed;
            }
        },
        actions: {
            clearError: (0, $1305f10b63a5651f$export$a15ba4bdf59dacc9),
            clearFormValues: (0, $1305f10b63a5651f$export$bfa16614c507dc4b),
            clearTouched: (0, $1305f10b63a5651f$export$c459b227ec8b5bb),
            clearValidationError: (0, $1305f10b63a5651f$export$5270f204082eebfb),
            handleInput: (0, $1305f10b63a5651f$export$412508d679148d5c),
            handleSubmit: (0, $1305f10b63a5651f$export$89c2621768820c8b),
            handleBlur: (0, $1305f10b63a5651f$export$27d5d91e7417534c),
            parsePhoneNumber: (0, $1305f10b63a5651f$export$da44e4eaa54bc82e),
            setCredentials: (0, $1305f10b63a5651f$export$3a6cdb4d139acb5f),
            setFieldErrors: (0, $1305f10b63a5651f$export$6c79f1f160aff8ba),
            setRemoteError: (0, $1305f10b63a5651f$export$a6a2df750d905c59),
            setCodeDeliveryDetails: (0, $1305f10b63a5651f$export$f9df8f75fe67ab58),
            setUser: (0, $1305f10b63a5651f$export$8b6bb3dd62a01be2),
            sendUpdate: (0, $9cec7b12efdda519$export$7f8b724299523eb6)(),
            setAutoSignInIntent: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                intent: function(e) {
                    return "autoSignIn";
                }
            })
        },
        services: {
            confirmSignUp: function(t, i) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, i, a, s, o;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(n) {
                        switch(n.label){
                            case 0:
                                return e = t.user, i = t.authAttributes, a = t.formValues, s = a.confirmation_code, o = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(e, "username") || (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(i, "username"), [
                                    4,
                                    I.handleConfirmSignUp({
                                        username: o,
                                        code: s
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    n.sent()
                                ];
                        }
                    });
                });
            },
            resendConfirmationCode: function(i, a) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, a, s;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(n) {
                        return e = i.user, a = i.authAttributes, s = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(e, "username") || (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(a, "username"), [
                            2,
                            (0, $cc420cb14b670b2a$export$334c29725a78c21d).resendSignUp(s)
                        ];
                    });
                });
            },
            federatedSignIn: function(r, i) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(n) {
                        switch(n.label){
                            case 0:
                                return e = i.data.provider, [
                                    4,
                                    (0, $cc420cb14b670b2a$export$334c29725a78c21d).federatedSignIn({
                                        provider: e
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    n.sent()
                                ];
                        }
                    });
                });
            },
            signUp: function(t, r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    var e, r, a, s, o, d, c;
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(n) {
                        switch(n.label){
                            case 0:
                                return e = t.formValues, r = t.loginMechanisms, a = r[0], o = (s = e)[void 0 === a ? "username" : a], d = s.password, c = (0, (/*@__PURE__*/$parcel$interopDefault($9b6d46093811e2aa$exports)))(e, function(e, n) {
                                    switch(n){
                                        case "address":
                                        case "birthdate":
                                        case "email":
                                        case "family_name":
                                        case "gender":
                                        case "given_name":
                                        case "locale":
                                        case "middle_name":
                                        case "name":
                                        case "nickname":
                                        case "phone_number":
                                        case "picture":
                                        case "preferred_username":
                                        case "profile":
                                        case "updated_at":
                                        case "website":
                                        case "zoneinfo":
                                            return !0;
                                        default:
                                            return n.startsWith("custom:");
                                    }
                                }), [
                                    4,
                                    I.handleSignUp({
                                        username: o,
                                        password: d,
                                        attributes: c
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    n.sent()
                                ];
                        }
                    });
                });
            },
            validateSignUp: function(t, r) {
                return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function() {
                    return (0, $e62042a96a9aa8b8$export$67ebef60e6f28a6)(this, function(e) {
                        return [
                            2,
                            (0, $8ae14af0a6bbf07c$export$59e2b39f02edfada)(t.formValues, t.touched, t.passwordSettings, [
                                I.validateFormPassword,
                                I.validateConfirmPassword,
                                I.validatePreferredUsername,
                                I.validateCustomSignUp
                            ])
                        ];
                    });
                });
            }
        }
    });
}


function $ea4c183a7d15aa3b$export$af98f08c6e0e0d4d() {
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        id: "authenticator",
        initial: "idle",
        context: {
            user: void 0,
            config: {},
            services: (0, $df55ec0aa99eabf3$export$7ae2d201ca9520b),
            actorRef: void 0,
            hasSetup: !1
        },
        predictableActionArguments: !0,
        states: {
            idle: {
                invoke: {
                    src: "getCurrentUser",
                    onDone: {
                        actions: "setUser",
                        target: "authenticated"
                    },
                    onError: {
                        target: "setup"
                    }
                }
            },
            setup: {
                initial: "waitConfig",
                states: {
                    waitConfig: {
                        on: {
                            INIT: {
                                actions: [
                                    "configure",
                                    "setHasSetup"
                                ],
                                target: "applyConfig"
                            }
                        }
                    },
                    applyConfig: {
                        invoke: {
                            src: "getAmplifyConfig",
                            onDone: {
                                actions: "applyAmplifyConfig",
                                target: "goToInitialState"
                            }
                        }
                    },
                    goToInitialState: {
                        always: [
                            {
                                target: "#authenticator.signUp",
                                cond: "isInitialStateSignUp"
                            },
                            {
                                target: "#authenticator.resetPassword",
                                cond: "isInitialStateResetPassword"
                            },
                            {
                                target: "#authenticator.signIn"
                            }
                        ]
                    }
                }
            },
            signIn: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignInActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopSignInActor"
                    }
                },
                on: {
                    SIGN_UP: "signUp",
                    RESET_PASSWORD: "resetPassword",
                    "done.invoke.signInActor": [
                        {
                            target: "signUp",
                            actions: "setActorDoneData",
                            cond: "shouldRedirectToSignUp"
                        },
                        {
                            target: "resetPassword",
                            actions: "setActorDoneData",
                            cond: "shouldRedirectToResetPassword"
                        },
                        {
                            target: "authenticated",
                            actions: "setActorDoneData"
                        }
                    ]
                }
            },
            signUp: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignUpActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopSignUpActor"
                    },
                    autoSignIn: {
                        invoke: {
                            src: "getCurrentUser",
                            onDone: "#authenticator.authenticated",
                            onError: "#authenticator.setup.goToInitialState"
                        }
                    }
                },
                on: {
                    SIGN_IN: "signIn",
                    "done.invoke.signUpActor": {
                        target: "#authenticator.signIn",
                        actions: "setActorDoneData",
                        cond: "shouldAutoSignIn"
                    }
                }
            },
            resetPassword: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnResetPasswordActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopResetPasswordActor"
                    }
                },
                on: {
                    SIGN_IN: "signIn",
                    "done.invoke.resetPasswordActor": {
                        target: "signIn",
                        actions: "setActorDoneData"
                    }
                }
            },
            signOut: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignOutActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: [
                            "stopSignOutActor",
                            "clearUser"
                        ]
                    }
                },
                on: {
                    "done.invoke.signOutActor": [
                        {
                            target: "setup",
                            cond: "shouldSetup"
                        },
                        {
                            target: "setup.goToInitialState"
                        }
                    ]
                }
            },
            authenticated: {
                initial: "idle",
                states: {
                    idle: {
                        on: {
                            TOKEN_REFRESH: "refreshUser"
                        }
                    },
                    refreshUser: {
                        invoke: {
                            src: "getCurrentUser",
                            onDone: {
                                actions: "setUser",
                                target: "idle"
                            },
                            onError: {
                                target: "#authenticator.signOut"
                            }
                        }
                    }
                },
                on: {
                    SIGN_OUT: "signOut"
                }
            }
        },
        on: {
            CHANGE: {
                actions: "forwardToActor"
            },
            BLUR: {
                actions: "forwardToActor"
            },
            SUBMIT: {
                actions: "forwardToActor"
            },
            FEDERATED_SIGN_IN: {
                actions: "forwardToActor"
            },
            RESEND: {
                actions: "forwardToActor"
            },
            SIGN_IN: {
                actions: "forwardToActor"
            },
            SKIP: {
                actions: "forwardToActor"
            }
        }
    }, {
        actions: {
            forwardToActor: (0, $cb680e241675046e$exports.choose)([
                {
                    cond: "hasActor",
                    actions: (0, $9cec7b12efdda519$export$eb147b7589db8e8a)(function(t) {
                        return t.actorRef;
                    })
                }
            ]),
            setUser: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                user: function(t, o) {
                    return o.data;
                }
            }),
            setActorDoneData: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorDoneData: function(o, n) {
                    var r, i;
                    return {
                        authAttributes: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, null === (r = n.data) || void 0 === r ? void 0 : r.authAttributes),
                        intent: null === (i = n.data) || void 0 === i ? void 0 : i.intent
                    };
                },
                user: function(t, o) {
                    var n;
                    return null === (n = o.data) || void 0 === n ? void 0 : n.user;
                }
            }),
            clearUser: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                user: void 0
            }),
            clearActorDoneData: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorDoneData: void 0
            }),
            applyAmplifyConfig: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                config: function(t, n) {
                    var r, i, e, a, s, c, u, d, l, g = null !== (i = null === (r = n.data.aws_cognito_username_attributes) || void 0 === r ? void 0 : r.map(function(t) {
                        return t.toLowerCase();
                    })) && void 0 !== i ? i : [], v = null !== (a = null === (e = n.data.aws_cognito_verification_mechanisms) || void 0 === e ? void 0 : e.map(function(t) {
                        return t.toLowerCase();
                    })) && void 0 !== a ? a : [], f = null !== (c = null === (s = n.data.aws_cognito_signup_attributes) || void 0 === s ? void 0 : s.map(function(t) {
                        return t.toLowerCase();
                    })) && void 0 !== c ? c : [], A = null !== (d = null === (u = n.data.aws_cognito_social_providers) || void 0 === u ? void 0 : u.map(function(t) {
                        return t.toLowerCase();
                    })) && void 0 !== d ? d : [], w = n.data.aws_cognito_password_protection_settings || {};
                    0 === g.length && g.push("username");
                    var m = t.config, S = m.loginMechanisms, h = m.signUpAttributes, D = m.socialProviders, I = m.initialState;
                    return {
                        loginMechanisms: null != S ? S : g,
                        formFields: null !== (l = $ea4c183a7d15aa3b$var$p(m.formFields)) && void 0 !== l ? l : {},
                        passwordSettings: w,
                        signUpAttributes: null != h ? h : Array.from(new Set((0, $e62042a96a9aa8b8$export$1216008129fb82ed)((0, $e62042a96a9aa8b8$export$1216008129fb82ed)([], v, !0), f, !0))),
                        socialProviders: null != D ? D : A.sort(),
                        initialState: I
                    };
                }
            }),
            spawnSignInActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: function(t, o) {
                    var n, r, i, e, s, c, d = t.services, l = (0, $bd263d51ec7085ae$export$f9c30eaa77191700)({
                        services: d
                    }).withContext({
                        authAttributes: null !== (r = null === (n = t.actorDoneData) || void 0 === n ? void 0 : n.authAttributes) && void 0 !== r ? r : {},
                        user: t.user,
                        intent: null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.intent,
                        country_code: "+1",
                        formValues: {},
                        touched: {},
                        validationError: {},
                        loginMechanisms: null === (e = t.config) || void 0 === e ? void 0 : e.loginMechanisms,
                        socialProviders: null === (s = t.config) || void 0 === s ? void 0 : s.socialProviders,
                        formFields: null === (c = t.config) || void 0 === c ? void 0 : c.formFields
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(l, {
                        name: "signInActor"
                    });
                }
            }),
            spawnSignUpActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: function(t, o) {
                    var n, r, i, e, s, c, u, d = t.services, l = (0, $9b7ec60ebabacf20$export$a5c4b20d9017fce9)({
                        services: d
                    }).withContext({
                        authAttributes: null !== (r = null === (n = t.actorDoneData) || void 0 === n ? void 0 : n.authAttributes) && void 0 !== r ? r : {},
                        country_code: "+1",
                        intent: null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.intent,
                        formValues: {},
                        touched: {},
                        validationError: {},
                        loginMechanisms: null === (e = t.config) || void 0 === e ? void 0 : e.loginMechanisms,
                        socialProviders: null === (s = t.config) || void 0 === s ? void 0 : s.socialProviders,
                        formFields: null === (c = t.config) || void 0 === c ? void 0 : c.formFields,
                        passwordSettings: null === (u = t.config) || void 0 === u ? void 0 : u.passwordSettings
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(l, {
                        name: "signUpActor"
                    });
                }
            }),
            spawnResetPasswordActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: function(t, o) {
                    var n, r, i, e, s = t.services, c = (0, $6a09bac45e5617d7$export$9e01526a2f4b3199)({
                        services: s
                    }).withContext({
                        formValues: {},
                        touched: {},
                        intent: null === (n = t.actorDoneData) || void 0 === n ? void 0 : n.intent,
                        username: null === (i = null === (r = t.actorDoneData) || void 0 === r ? void 0 : r.authAttributes) || void 0 === i ? void 0 : i.username,
                        formFields: null === (e = t.config) || void 0 === e ? void 0 : e.formFields,
                        validationError: {}
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(c, {
                        name: "resetPasswordActor"
                    });
                }
            }),
            spawnSignOutActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: function(t) {
                    var o = (0, $0a0e7d6b532b57c6$export$2f15f45f1f7b7787).withContext({
                        user: t.user
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(o, {
                        name: "signOutActor"
                    });
                }
            }),
            stopSignInActor: (0, $1305f10b63a5651f$export$b6947cfc708251b6)("signInActor"),
            stopSignUpActor: (0, $1305f10b63a5651f$export$b6947cfc708251b6)("signUpActor"),
            stopResetPasswordActor: (0, $1305f10b63a5651f$export$b6947cfc708251b6)("resetPasswordActor"),
            stopSignOutActor: (0, $1305f10b63a5651f$export$b6947cfc708251b6)("signOutActor"),
            configure: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)(function(o, r) {
                var i = r.data, e = i.services, a = (0, $e62042a96a9aa8b8$export$3c9a16f847548506)(i, [
                    "services"
                ]);
                return {
                    services: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $df55ec0aa99eabf3$export$7ae2d201ca9520b)), e),
                    config: a
                };
            }),
            setHasSetup: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                hasSetup: !0
            })
        },
        guards: {
            isInitialStateSignUp: function(t) {
                return "signUp" === t.config.initialState;
            },
            isInitialStateResetPassword: function(t) {
                return "resetPassword" === t.config.initialState;
            },
            shouldRedirectToSignUp: function(t, o) {
                var n;
                return "confirmSignUp" === (null === (n = o.data) || void 0 === n ? void 0 : n.intent);
            },
            shouldRedirectToResetPassword: function(t, o) {
                var n;
                return "confirmPasswordReset" === (null === (n = o.data) || void 0 === n ? void 0 : n.intent);
            },
            shouldAutoSignIn: function(t, o) {
                var n;
                return "autoSignIn" === (null === (n = o.data) || void 0 === n ? void 0 : n.intent);
            },
            shouldSetup: function(t) {
                return !1 === t.hasSetup;
            },
            hasActor: function(t) {
                return !!t.actorRef;
            }
        },
        services: {
            getCurrentUser: function(t, o) {
                return t.services.getCurrentUser();
            },
            getAmplifyConfig: function(t, o) {
                return t.services.getAmplifyConfig();
            }
        }
    });
}
function $ea4c183a7d15aa3b$var$p(t) {
    return t && Object.keys(t).forEach(function(o) {
        Object.keys(t[o]).forEach(function(n) {
            var r = t[o][n];
            r.required = r.isRequired;
        });
    }), t;
}



var $acw62 = parcelRequire("acw62");
const $0dbfd3c00bf87d48$export$2254a7bd02a5abf7 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


function $870bcf77de627b81$export$2e2bcd8739ae039({ children: children }) {
    /**
     * Based on use cases, developer might already have added another Provider
     * outside Authenticator. In that case, we sync the two providers by just
     * passing the parent value.
     *
     * TODO(BREAKING): enforce only one provider in App tree
     */ const parentProviderVal = (0, $acw62.useContext)((0, $0dbfd3c00bf87d48$export$2254a7bd02a5abf7));
    const service = (0, $5d3f760e9d626625$export$d9e9b060fbbae528)((0, $ea4c183a7d15aa3b$export$af98f08c6e0e0d4d));
    const value = (0, $acw62.useMemo)(()=>!parentProviderVal ? {
            service: service
        } : parentProviderVal, [
        parentProviderVal,
        service
    ]);
    const { service: activeService } = value;
    (0, $acw62.useEffect)(()=>{
        const unsubscribe = (0, $b694cdd7ed95d843$export$4776c363cae9362c)(activeService);
        return unsubscribe;
    }, [
        activeService
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0dbfd3c00bf87d48$export$2254a7bd02a5abf7).Provider, {
        value: value
    }, children);
}







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $6ae5e5baff12bbf7$exports = {};
"use strict";

$6ae5e5baff12bbf7$exports = (parcelRequire("jZ8n5"));



var $acw62 = parcelRequire("acw62");



var $hfliI = parcelRequire("hfliI");
function $5658e11017504936$export$656eb38a7c1ce0b6(actorRef) {
    return "state" in actorRef;
}
function $5658e11017504936$var$isDeferredActor(actorRef) {
    return "deferred" in actorRef;
}
function $5658e11017504936$var$defaultGetSnapshot(actorRef) {
    return "getSnapshot" in actorRef ? actorRef.getSnapshot() : $5658e11017504936$export$656eb38a7c1ce0b6(actorRef) ? actorRef.state : undefined;
}
function $5658e11017504936$export$25c4ab29592aabd9(actorRef, getSnapshot) {
    if (getSnapshot === void 0) getSnapshot = $5658e11017504936$var$defaultGetSnapshot;
    var actorRefRef = (0, $acw62.useRef)(actorRef);
    var deferredEventsRef = (0, $acw62.useRef)([]);
    var subscribe = (0, $acw62.useCallback)(function(handleStoreChange) {
        var unsubscribe = actorRef.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actorRef
    ]);
    var boundGetSnapshot = (0, $acw62.useCallback)(function() {
        return getSnapshot(actorRef);
    }, [
        actorRef,
        getSnapshot
    ]);
    var storeSnapshot = (0, $hfliI.useSyncExternalStore)(subscribe, boundGetSnapshot, boundGetSnapshot);
    var send = (0, $f2491f7f97e8a9c7$export$2e2bcd8739ae039)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var event = args[0];
            if (args.length > 1) console.warn("Unexpected payload: ".concat(JSON.stringify(args[1]), ". Only a single event object can be sent to actor send() functions."));
            var currentActorRef = actorRefRef.current;
            // If the previous actor is a deferred actor,
            // queue the events so that they can be replayed
            // on the non-deferred actor.
            if ($5658e11017504936$var$isDeferredActor(currentActorRef) && currentActorRef.deferred) deferredEventsRef.current.push(event);
            else currentActorRef.send(event);
        };
    });
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        actorRefRef.current = actorRef;
        // Dequeue deferred events from the previous deferred actorRef
        while(deferredEventsRef.current.length > 0){
            var deferredEvent = deferredEventsRef.current.shift();
            actorRef.send(deferredEvent);
        }
    }, [
        actorRef
    ]);
    return [
        storeSnapshot,
        send
    ];
}


var $50a5f64dadc75dff$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $50a5f64dadc75dff$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $50a5f64dadc75dff$export$b29f828819edca8d(items, predicate) {
    var e_1, _a;
    var _b = $50a5f64dadc75dff$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $50a5f64dadc75dff$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $50a5f64dadc75dff$export$2b6ccfda635c9803(service) {
    return service.status !== 0 ? service.state : service.machine.initialState;
}
// From https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
function $50a5f64dadc75dff$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $50a5f64dadc75dff$export$d36bdfa510afb180(objA, objB) {
    if ($50a5f64dadc75dff$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$50a5f64dadc75dff$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $2652fe8f8a24878d$var$isService(actor) {
    return "state" in actor && "machine" in actor;
}
var $2652fe8f8a24878d$var$defaultCompare = function(a, b) {
    return a === b;
};
var $2652fe8f8a24878d$var$defaultGetSnapshot = function(a, initialStateCacheRef) {
    if ($2652fe8f8a24878d$var$isService(a)) {
        // A status of 0 = interpreter not started
        if (a.status === 0 && initialStateCacheRef.current) return initialStateCacheRef.current;
        var snapshot = (0, $50a5f64dadc75dff$export$2b6ccfda635c9803)(a);
        initialStateCacheRef.current = a.status === 0 ? snapshot : null;
        return snapshot;
    }
    return (0, $5658e11017504936$export$656eb38a7c1ce0b6)(a) ? a.state : undefined;
};
function $2652fe8f8a24878d$export$2105062e25df4afe(actor, selector, compare, getSnapshot) {
    if (compare === void 0) compare = $2652fe8f8a24878d$var$defaultCompare;
    var initialStateCacheRef = (0, $acw62.useRef)(null);
    var subscribe = (0, $acw62.useCallback)(function(handleStoreChange) {
        var unsubscribe = actor.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actor
    ]);
    var boundGetSnapshot = (0, $acw62.useCallback)(function() {
        if (getSnapshot) return getSnapshot(actor);
        return $2652fe8f8a24878d$var$defaultGetSnapshot(actor, initialStateCacheRef);
    }, [
        actor,
        getSnapshot
    ]);
    var selectedSnapshot = (0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}



var $ed9f310e3d5fb25d$export$99a4282e2c3b772d = function(t) {
    var n;
    return null === (n = t.context.actorRef) || void 0 === n ? void 0 : n.getSnapshot();
}, $ed9f310e3d5fb25d$export$c39505fa2700473f = function(n) {
    var o;
    return null === (o = $ed9f310e3d5fb25d$export$99a4282e2c3b772d(n)) || void 0 === o ? void 0 : o.context;
};


var $7fbff47e1392358f$export$2def2023b76dbf7d = function(e) {
    var t = function(t) {
        return function(n) {
            return e({
                type: t,
                data: n
            });
        };
    };
    return {
        initializeMachine: t("INIT"),
        resendCode: t("RESEND"),
        signOut: t("SIGN_OUT"),
        submitForm: t("SUBMIT"),
        updateForm: t("CHANGE"),
        updateBlur: t("BLUR"),
        toFederatedSignIn: t("FEDERATED_SIGN_IN"),
        toResetPassword: t("RESET_PASSWORD"),
        toSignIn: t("SIGN_IN"),
        toSignUp: t("SIGN_UP"),
        skipVerification: t("SKIP")
    };
}, $7fbff47e1392358f$export$e6da373757d26435 = function(e) {
    var r, i, s, a, o, u = null !== (r = (0, $ed9f310e3d5fb25d$export$c39505fa2700473f)(e)) && void 0 !== r ? r : {}, c = u.codeDeliveryDetails, d = u.remoteError, l = u.unverifiedContactMethods, v = u.validationError, f = (null !== (s = null === (i = e.context) || void 0 === i ? void 0 : i.config) && void 0 !== s ? s : {}).socialProviders, m = null !== (a = null == u ? void 0 : u.user) && void 0 !== a ? a : null === (o = e.context) || void 0 === o ? void 0 : o.user, h = v && Object.keys(v).length > 0, g = (0, $ed9f310e3d5fb25d$export$99a4282e2c3b772d)(e), S = e.hasTag("pending") || (null == g ? void 0 : g.hasTag("pending")), p = function() {
        switch(!0){
            case e.matches("idle"):
                return "idle";
            case e.matches("setup"):
                return "setup";
            case e.matches("signOut"):
                return "signOut";
            case e.matches("authenticated"):
                return "authenticated";
            case null == g ? void 0 : g.matches("autoSignIn"):
                return "autoSignIn";
            case null == g ? void 0 : g.matches("confirmSignUp"):
                return "confirmSignUp";
            case null == g ? void 0 : g.matches("confirmSignIn"):
                return "confirmSignIn";
            case null == g ? void 0 : g.matches("setupTOTP"):
                return "setupTOTP";
            case null == g ? void 0 : g.matches("signIn"):
                return "signIn";
            case null == g ? void 0 : g.matches("signUp"):
                return "signUp";
            case null == g ? void 0 : g.matches("forceNewPassword"):
                return "forceNewPassword";
            case null == g ? void 0 : g.matches("resetPassword"):
                return "resetPassword";
            case null == g ? void 0 : g.matches("confirmResetPassword"):
                return "confirmResetPassword";
            case null == g ? void 0 : g.matches("verifyUser"):
                return "verifyUser";
            case null == g ? void 0 : g.matches("confirmVerifyUser"):
                return "confirmVerifyUser";
            default:
                return console.debug("Cannot infer `route` from Authenticator state:", e.value), null;
        }
    }(), I = function(e) {
        switch(e){
            case "idle":
            case "setup":
                return "configuring";
            case "authenticated":
                return "authenticated";
            default:
                return "unauthenticated";
        }
    }(p);
    return {
        authStatus: I,
        codeDeliveryDetails: c,
        error: d,
        hasValidationErrors: h,
        isPending: S,
        route: p,
        socialProviders: f,
        unverifiedContactMethods: l,
        user: m,
        validationErrors: v
    };
}, $7fbff47e1392358f$export$5f925d5954b1c10b = function(t) {
    var n = t.send, s = t.state, a = $7fbff47e1392358f$export$2def2023b76dbf7d(n), o = $7fbff47e1392358f$export$e6da373757d26435(s);
    return (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, a), o);
};



const $9547d8fe27a259c6$export$7e92b2e9f0809b11 = "`useAuthenticator` must be used inside an `Authenticator.Provider`.";
const $9547d8fe27a259c6$export$297d226dd86a0de7 = [
    "signIn",
    "signUp",
    "forceNewPassword",
    "confirmResetPassword",
    "confirmSignIn",
    "confirmSignUp",
    "confirmVerifyUser",
    "resetPassword",
    "setupTOTP",
    "verifyUser"
];











var $b1b59600e958c108$export$43a753047a354e27 = [
    "birthdate",
    "email",
    "family_name",
    "given_name",
    "middle_name",
    "name",
    "nickname",
    "phone_number",
    "preferred_username",
    "profile",
    "website"
], $b1b59600e958c108$export$a263a0ca54f86170 = [
    "address",
    "gender",
    "locale",
    "picture",
    "updated_at",
    "zoneinfo"
], $b1b59600e958c108$export$c3f13f1789f7946b = [
    "username",
    "email",
    "phone_number"
], $b1b59600e958c108$export$ee5f111526f572af = (0, $e62042a96a9aa8b8$export$1216008129fb82ed)((0, $e62042a96a9aa8b8$export$1216008129fb82ed)((0, $e62042a96a9aa8b8$export$1216008129fb82ed)([], $b1b59600e958c108$export$c3f13f1789f7946b, !0), $b1b59600e958c108$export$43a753047a354e27, !0), [
    "confirmation_code",
    "password",
    "confirm_password"
], !1);



var $a8aacd3c09dd95f8$export$65f2c683ca9e9a02 = function(i) {
    var t, n = null === (t = null == i ? void 0 : i.context.config) || void 0 === t ? void 0 : t.loginMechanisms;
    return (null != n ? n : [
        "username"
    ])[0];
}, $a8aacd3c09dd95f8$export$961a103988e4c668 = function(n) {
    var o, r = (null === (o = n.config) || void 0 === o ? void 0 : o.loginMechanisms).filter(function(n) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bd85b94eaceb5cbd$exports)))((0, $b1b59600e958c108$export$c3f13f1789f7946b), n);
    });
    return {
        primaryAlias: r[0],
        secondaryAliases: r.slice(1)
    };
};






var $a6236a322edc45bc$export$e29bbbec84471f66 = function(r) {
    var t = new FormData(r.target);
    return Object.fromEntries(t);
}, $a6236a322edc45bc$export$b5859dd113079414 = function(t, n) {
    var e = [];
    return t && (e = Object.keys(t).reduce(function(r, n) {
        var e;
        return r.push([
            n,
            null === (e = t[n]) || void 0 === e ? void 0 : e.order
        ]), r;
    }, []).sort(function(r, t) {
        return r[1] - t[1];
    }).filter(function(r) {
        return void 0 !== r[1];
    }).map(function(r) {
        return r[0];
    })), Array.from(new Set((0, $e62042a96a9aa8b8$export$1216008129fb82ed)((0, $e62042a96a9aa8b8$export$1216008129fb82ed)([], e, !0), n, !0)));
}, $a6236a322edc45bc$export$3237178b1c616b9f = function(r) {
    return (0, $b1b59600e958c108$export$ee5f111526f572af).includes(r);
}, $a6236a322edc45bc$export$501239432719417d = function(r) {
    var t;
    return r ? (t = r, Array.isArray(t) ? r : [
        r
    ]) : null;
};


var $f14b2dcc942b476f$var$i = function(r, e) {
    var a = (0, $ed9f310e3d5fb25d$export$c39505fa2700473f)(r).country_code, s = (0, $bc2ad104d785472a$export$1222d357a3c2c47f)[e];
    return "tel" === s.type && (s = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, s), {
        dialCode: a
    })), s;
}, $f14b2dcc942b476f$var$c = function(r) {
    var e = (0, $a8aacd3c09dd95f8$export$65f2c683ca9e9a02)(r);
    return (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$i(r, e)), {
        autocomplete: "username"
    });
}, $f14b2dcc942b476f$var$d = function(r) {
    return {
        confirmation_code: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$i(r, "confirmation_code")), {
            label: "Code *",
            placeholder: "Code"
        })
    };
}, $f14b2dcc942b476f$export$9bcaa03841470ad7 = {
    signIn: function(r) {
        return {
            username: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$c(r)),
            password: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$i(r, "password")), {
                autocomplete: "current-password"
            })
        };
    },
    signUp: function(e) {
        for(var n = e.context.config, t = n.loginMechanisms, d = n.signUpAttributes, u = (0, $a8aacd3c09dd95f8$export$65f2c683ca9e9a02)(e), f = {}, m = 0, l = Array.from(new Set((0, $e62042a96a9aa8b8$export$1216008129fb82ed)((0, $e62042a96a9aa8b8$export$1216008129fb82ed)((0, $e62042a96a9aa8b8$export$1216008129fb82ed)([], t, !0), [
            "password",
            "confirm_password"
        ], !1), d, !0))); m < l.length; m++){
            var p = l[m];
            if ((0, $a6236a322edc45bc$export$3237178b1c616b9f)(p)) {
                var w = p === u ? $f14b2dcc942b476f$var$c(e) : $f14b2dcc942b476f$var$i(e, p);
                f[p] = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, w);
            } else console.debug("Authenticator does not have a default implementation for ".concat(p, ". Customize SignUp FormFields to add your own."));
        }
        return f;
    },
    confirmSignUp: function(r) {
        return {
            confirmation_code: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$i(r, "confirmation_code")), {
                placeholder: "Enter your code"
            })
        };
    },
    confirmSignIn: $f14b2dcc942b476f$var$d,
    forceNewPassword: function(n) {
        for(var t = (0, $ed9f310e3d5fb25d$export$99a4282e2c3b772d)(n).context.requiredAttributes, a = {}, c = 0, d = Array.from(new Set((0, $e62042a96a9aa8b8$export$1216008129fb82ed)([
            "password",
            "confirm_password"
        ], t, !0))); c < d.length; c++){
            var u = d[c];
            (0, $a6236a322edc45bc$export$3237178b1c616b9f)(u) ? a[u] = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$i(n, u)) : console.debug("Authenticator does not have a default implementation for ".concat(u, ". Customize ForceNewPassword FormFields to add your own."));
        }
        return a;
    },
    resetPassword: function(r) {
        var e = (0, $a8aacd3c09dd95f8$export$65f2c683ca9e9a02)(r), n = (0, $bc2ad104d785472a$export$1222d357a3c2c47f)[e].label;
        return {
            username: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$c(r)), {
                label: "Enter your ".concat(n.toLowerCase()),
                placeholder: "Enter your ".concat(n.toLowerCase())
            })
        };
    },
    confirmResetPassword: function(r) {
        return (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$d(r)), {
            password: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$i(r, "password")), {
                label: "New Password",
                placeholder: "New Password"
            }),
            confirm_password: (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, $f14b2dcc942b476f$var$i(r, "confirm_password")), {
                label: "Confirm Password",
                placeholder: "Confirm Password"
            })
        });
    },
    confirmVerifyUser: $f14b2dcc942b476f$var$d,
    setupTOTP: $f14b2dcc942b476f$var$d
};







var $ce0368d6191c8cca$export$cca4a41bdb910c51 = {
    "Account recovery requires verified contact information": "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
    "Back to Sign In": "Zur\xfcck zur Anmeldung",
    "Change Password": "Passwort \xe4ndern",
    Changing: "\xc4ndern von",
    Code: "Code",
    "Confirm Password": "Passwort best\xe4tigen",
    "Confirm Sign Up": "Registrierung best\xe4tigen",
    "Confirm SMS Code": "SMS-Code best\xe4tigen",
    "Confirm TOTP Code": "TOTP-Code best\xe4tigen",
    Confirm: "Best\xe4tigen",
    "Confirmation Code": "Best\xe4tigungs-Code",
    Confirming: "Wird best\xe4tigt",
    "Create a new account": "Einen neuen Account erstellen",
    "Create Account": "Account erstellen",
    "Creating Account": "Account wird erstellt",
    "Dismiss alert": "Warnung verwerfen",
    Email: "Email",
    "Enter your code": "Geben Sie Ihren Code ein",
    "Enter your email": "Geben Sie Ihre Email ein",
    "Enter your phone number": "Geben Sie Ihre Telefonnummer ein",
    "Enter your username": "Geben Sie Ihren Benutzernamen ein",
    "Forgot your password?": "Passwort vergessen? ",
    "Hide password": "Passwort verbergen",
    Loading: "Wird geladen",
    "New password": "Neues Passwort",
    Password: "Passwort",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Code erneut senden",
    "Reset your Password": "Zur\xfccksetzen des Passwort",
    "Reset your password": "Zur\xfccksetzen des passwort",
    "Send code": "Code senden",
    "Send Code": "Code senden",
    Sending: "Wird gesendet",
    "Setup TOTP": "TOTP einrichten",
    "Show password": "Passwort anzeigen",
    "Sign in to your account": "Melden Sie sich mit Ihrem Account an",
    "Sign In with Amazon": "Mit Amazon anmelden",
    "Sign In with Apple": "Mit Apple anmelden",
    "Sign In with Facebook": "Mit Facebook anmelden",
    "Sign In with Google": "Mit Google anmelden",
    "Sign in": "Anmelden",
    "Sign In": "Anmelden",
    "Signing in": "Wird angemeldet",
    Skip: "\xdcberspringen",
    Submit: "Abschicken",
    Submitting: "Wird gesendet",
    Username: "Benutzername",
    "Verify Contact": "Kontakt verifizieren",
    Verify: "Verifizieren",
    "An account with the given email already exists.": "Ein Account mit dieser Email existiert bereits.",
    "Confirm a Code": "Code best\xe4tigen",
    "Confirm Sign In": "Anmeldung best\xe4tigen",
    "Create account": "Hier registrieren",
    "Enter your password": "Geben Sie Ihr Passwort ein",
    "Forgot Password": "Passwort vergessen",
    "Have an account? ": "Schon registriert? ",
    "Incorrect username or password": "Falscher Benutzername oder falsches Passwort",
    "Invalid password format": "Ung\xfcltiges Passwort-Format",
    "Invalid phone number format": "Ung\xfcltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900",
    "It may take a minute to arrive.": "Es k\xf6nnte eine Minute dauern, bis der Code eintrifft.",
    "Lost your code? ": "Code verloren? ",
    "New Password": "Neues Passwort",
    "No account? ": "Kein Account? ",
    or: "oder",
    "Password attempts exceeded": "Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht",
    "Reset password": "Passwort zur\xfccksetzen",
    "Sign Out": "Abmelden",
    "Sign Up": "Registrieren",
    "User already exists": "Dieser Benutzer existiert bereits",
    "User does not exist": "Dieser Benutzer existiert nicht",
    "Username cannot be empty": "Benutzername darf nicht leer sein",
    "We Emailed You": "Email wurde versendet",
    "Your code is on the way. To log in, enter the code we emailed to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an",
    "Your code is on the way. To log in, enter the code we texted to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an"
};


var $a19559f0f239105d$export$eb91f595f110d703 = {
    "Account recovery requires verified contact information": "Account recovery requires verified contact information",
    "Back to Sign In": "Back to Sign In",
    "Change Password": "Change Password",
    Changing: "Changing",
    Code: "Code",
    "Confirm Password": "Confirm Password",
    "Confirm Sign Up": "Confirm Sign Up",
    "Confirm SMS Code": "Confirm SMS Code",
    "Confirm TOTP Code": "Confirm TOTP Code",
    Confirm: "Confirm",
    "Confirmation Code": "Confirmation Code",
    Confirming: "Confirming",
    "Create a new account": "Create a new account",
    "Create Account": "Create Account",
    "Creating Account": "Creating Account",
    "Dismiss alert": "Dismiss alert",
    Email: "Email",
    "Enter your code": "Enter your code",
    "Enter your email": "Enter your email",
    "Enter your phone number": "Enter your phone number",
    "Enter your username": "Enter your username",
    "Forgot your password?": "Forgot your password?",
    "Hide password": "Hide password",
    Loading: "Loading",
    "New password": "New password",
    Password: "Password",
    "Phone Number": "Phone Number",
    "Resend Code": "Resend Code",
    "Reset your password": "Reset your password",
    "Reset your Password": "Reset your Password",
    "Send code": "Send code",
    "Send Code": "Send Code",
    Sending: "Sending",
    "Setup TOTP": "Setup TOTP",
    "Show password": "Show password",
    "Sign in to your account": "Sign in to your account",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "Sign in",
    "Sign In": "Sign In",
    "Signing in": "Signing in",
    Skip: "Skip",
    Submit: "Submit",
    Submitting: "Submitting",
    Username: "Username",
    "Verify Contact": "Verify Contact",
    Verify: "Verify"
};


var $86c38a6ac877bb92$export$1d204a99f5862ba9 = {
    "Account recovery requires verified contact information": "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
    "Back to Sign In": "Volver a inicio de sesi\xf3n",
    "Change Password": "Cambiar contrase\xf1a",
    Changing: "Cambiando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirmar contrase\xf1a",
    "Confirm Sign Up": "Confirmar registro",
    "Confirm SMS Code": "Confirmar el c\xf3digo de SMS",
    "Confirm TOTP Code": "Confirmar c\xf3digo TOTP",
    Confirm: "Confirmar",
    "Confirmation Code": "C\xf3digo de confirmaci\xf3n",
    Confirming: "Confirmando",
    "Create a new account": "Crear una cuenta nueva",
    "Create Account": "Crear cuenta",
    "Creating Account": "Creando cuenta",
    "Dismiss alert": "Descartar alerta",
    Email: "Email",
    "Enter your code": "Ingrese el c\xf3digo",
    "Enter your email": "Escriba su Email",
    "Enter your phone number": "Ingrese el n\xfamero de tel\xe9fono",
    "Enter your username": "Ingrese el nombre de usuario",
    "Forgot your password?": "\xbfOlvid\xf3 su contrase\xf1a?",
    "Hide password": "Ocultar contrase\xf1a",
    Loading: "Cargando",
    "New password": "Nueva contrase\xf1a",
    Password: "Contrase\xf1a",
    "Phone Number": "N\xfamero de tel\xe9fono",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Restablecer su contrase\xf1a",
    "Reset your Password": "Restablecer su Contrase\xf1a",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar contrase\xf1a",
    "Sign in to your account": "Iniciar sesi\xf3n en tu cuenta",
    "Sign In with Amazon": "Iniciar Sesi\xf3n con Amazon",
    "Sign In with Apple": "Iniciar Sesi\xf3n con Apple",
    "Sign In with Facebook": "Iniciar Sesi\xf3n con Facebook",
    "Sign In with Google": "Iniciar Sesi\xf3n con Google",
    "Sign in": "Iniciar sesi\xf3n",
    "Sign In": "Iniciar Sesi\xf3n",
    "Signing in": "Iniciando sesi\xf3n",
    Skip: "Omitir",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nombre de usuario",
    "Verify Contact": "Verificar contacto",
    Verify: "Verificar",
    "An account with the given email already exists.": "Ya existe una cuenta con el correo ingresado.",
    "Confirm a Code": "Confirmar un c\xf3digo",
    "Confirm Sign In": "Confirmar inicio de sesi\xf3n",
    "Forgot Password": "Olvid\xe9 mi contrase\xf1a",
    "Incorrect username or password.": "Nombre de usuario o contrase\xf1a incorrecta",
    "Invalid password format": "Formato de contrase\xf1a inv\xe1lido",
    "Invalid phone number format": "Formato de n\xfamero de tel\xe9fono inv\xe1lido",
    "Loading...": "Cargando...",
    "New Password": "Nueva contrase\xf1a",
    or: "o",
    "Resend a Code": "Reenviar un c\xf3digo",
    "Sign Out": "Cerrar sesi\xf3n",
    "Sign Up with Amazon": "Crear cuenta con Amazon",
    "Sign Up with Apple": "Crear cuenta con Apple",
    "Sign Up with Facebook": "Crear cuenta con Facebook",
    "Sign Up with Google": "Crear cuenta con Google",
    "Sign Up": "Crear cuenta",
    "User already exists": "El usuario ya existe",
    "User does not exist": "El usuario no existe",
    "Username cannot be empty": "El nombre de usuario no puede estar vac\xedo",
    "Your passwords must match": "Las contrase\xf1as deben coincidir"
};


var $02f7d482e07472ab$export$8cfa91bfcf8d11c8 = {
    "Account recovery requires verified contact information": "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
    "Back to Sign In": "Retour \xe0 la connexion",
    "Change Password": "Modifier le mot de passe",
    Changing: "Modification en cours",
    Code: "Code",
    "Confirm Password": "Confirmez le mot de passe",
    "Confirm Sign Up": "Confirmer l'inscription",
    "Confirm SMS Code": "Confirmer le code SMS",
    "Confirm TOTP Code": "Confirmer le code TOTP",
    Confirm: "Confirmer",
    "Confirmation Code": "Code de confirmation",
    Confirming: "Confirmation",
    "Create a new account": "Cr\xe9er un nouveau compte",
    "Create Account": "Cr\xe9er un compte",
    "Creating Account": "Cr\xe9ation d'un compte",
    "Dismiss alert": "Supprimer l'alerte",
    Email: "Email",
    "Enter your code": "Saisissez cotre code de confirmation",
    "Enter your email": "Saisissez votre adresse email",
    "Enter your phone number": "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    "Enter your username": "Saisissez votre nom d'utilisateur",
    "Forgot your password?": "Mot de passe oubli\xe9 ? ",
    "Hide password": "Masquer le mot de passe",
    Loading: "Chargement en cours",
    "New password": "Nouveau mot de passe",
    Password: "Mot de passe",
    "Phone Number": "Num\xe9ro de t\xe9l\xe9phone",
    "Resend Code": "Renvoyer le code",
    "Reset your Password": "R\xe9initialiser votre mot de passe",
    "Reset your password": "R\xe9initialisez votre mot de passe",
    "Send code": "Envoyer le code",
    "Send Code": "M'envoyer un code",
    Sending: "Envoi en cours",
    "Setup TOTP": "Configuration de TOTP",
    "Show password": "Afficher le mot de passe",
    "Sign in to your account": "Connexion \xe0 votre compte",
    "Sign In with Amazon": "Se connecter avec Amazon",
    "Sign In with Apple": "Se connecter avec Apple",
    "Sign In with Facebook": "Se connecter avec Facebook",
    "Sign In with Google": "Se connecter avec Google",
    "Sign in": "Se connecter",
    "Sign In": "Se connecter",
    "Signing in": "Connexion en cours",
    Skip: "Passer",
    Submit: "Soumettre",
    Submitting: "Envoi en cours",
    Username: "Nom d'utilisateur",
    "Verify Contact": "V\xe9rifier le contact",
    Verify: "V\xe9rifier",
    "An account with the given email already exists.": "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
    Change: "Modifier",
    "Confirm a Code": "Confirmer un code",
    "Confirm Sign In": "Confirmer la connexion",
    "Create account": "Cr\xe9er un compte",
    "Enter your password": "Saisissez votre mot de passe",
    "Forgot Password": "Mot de passe oubli\xe9",
    "Have an account? ": "D\xe9j\xe0 un compte ? ",
    Hello: "Bonjour",
    "Incorrect username or password": "Identifiant ou mot de passe incorrect",
    "Invalid password format": "Format de mot de passe invalide",
    "Invalid phone number format": "Format de num\xe9ro de t\xe9l\xe9phone invalide. Veuillez utiliser un format +12345678900",
    "Loading...": "Chargement...",
    "Lost your code? ": "Vous avez perdu votre code ? ",
    "Network error": "Erreur r\xe9seau",
    "New Password": "Nouveau mot de passe",
    "No account? ": "Pas de compte ? ",
    or: "ou",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "R\xe9initialisez votre mot de passe",
    Send: "Envoyer",
    "Sign In with AWS": "Se connecter avec AWS",
    "Sign Out": "D\xe9connexion",
    "Sign Up": "S'inscrire",
    SMS: "SMS",
    "User already exists": "L'utilisateur existe d\xe9j\xe0",
    "User does not exist": "L'utilisateur n'existe pas",
    "Username cannot be empty": "Le nom d'utilisateur doit \xeatre renseign\xe9",
    "Username/client id combination not found.": "L'utilisateur n'existe pas"
};


var $4d39884df14249f1$export$5c8da73de176fccc = {
    "Account recovery requires verified contact information": "Il ripristino dell'account richiede informazioni di contatto verificate",
    "Back to Sign In": "Torna alla schermata di accesso",
    "Change Password": "Cambia la password",
    Changing: "Modifica in corso",
    Code: "Codice",
    "Confirm Password": "Conferma la password",
    "Confirm Sign Up": "Conferma registrazione",
    "Confirm SMS Code": "Conferma codice SMS",
    "Confirm TOTP Code": "Conferma codice TOTP",
    Confirm: "Conferma",
    "Confirmation Code": "Codice di verifica",
    Confirming: "Conferma in corso",
    "Create a new account": "Crea un nuovo account",
    "Create Account": "Crea Account",
    "Creating Account": "Creazione account in corso",
    "Dismiss alert": "Ignora l'avviso",
    Email: "Email",
    "Enter your code": "Inserisci il tuo codice",
    "Enter your email": "Inserisci la tua e-mail",
    "Enter your phone number": 'Inserisci il tuo numero di telefono"',
    "Enter your username": "Inserisci il tuo nome utente",
    "Forgot your password?": "Password dimenticata?",
    "Hide password": "Nascondi password",
    Loading: "Caricamento in corso",
    "New password": "Nuova password",
    Password: "Password",
    "Phone Number": "Numero di telefono",
    "Resend Code": "Invia nuovamente il codice",
    "Reset your Password": "Reimposta la tua Password",
    "Reset your password": "Reimposta la tua password",
    "Send code": "Invia codice",
    "Send Code": "Invia codice",
    Sending: "Invio in corso",
    "Setup TOTP": "Configura TOTP",
    "Show password": "Mostra password",
    "Sign in to your account": "Accedi al tuo account",
    "Sign In with Amazon": "Accedi con Amazon",
    "Sign In with Apple": "Accedi con Apple",
    "Sign In with Facebook": "Accedi con Facebook",
    "Sign In with Google": "Accedi con Google",
    "Sign in": "Accedi",
    "Sign In": "Accedi",
    "Signing in": "Accesso in corso",
    Skip: "Salta",
    Submit: "Invia",
    Submitting: "Invio in corso",
    Username: "Nome utente",
    "Verify Contact": "Verifica contatto",
    Verify: "Verifica",
    "An account with the given email already exists.": "Questa email \xe8 gi\xe0 utilizzata da un altro account.",
    "Confirm a Code": "Conferma un codice",
    "Confirm Sign In": "Conferma l'accesso",
    "Create account": "Crea account",
    "Enter your password": "Inserisci la tua password",
    "Forgot Password": "Password dimenticata",
    "Have an account? ": "Gi\xe0 registrato?",
    "Incorrect username or password": "Nome utente o password errati",
    "Invalid password format": "Formato della password non valido",
    "Invalid phone number format": "Formato del numero di telefono non valido",
    "Lost your code?": "Codice smarrito?",
    "New Password": "Nuova password",
    "No account? ": "Non hai un account?",
    or: "o",
    "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
    "Reset password": "Reimposta password",
    "Sign Out": "Esci",
    "Sign Up": "Registrati",
    "User already exists": "Utente gi\xe0 esistente",
    "User does not exist": "Utente inesistente",
    "Username cannot be empty": "Il nome utente non pu\xf2 essere vuoto"
};


var $a1aa95de55c98f81$export$c416809cd76fbf21 = {
    "Account recovery requires verified contact information": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
    "Back to Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
    "Change Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
    Changing: "\u5909\u66F4\u4E2D",
    Code: "\u30B3\u30FC\u30C9",
    "Confirm Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
    "Confirm Sign Up": "\u767B\u9332\u3059\u308B",
    "Confirm SMS Code": "SMS \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm TOTP Code": "TOTP \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    Confirm: "\u78BA\u5B9A",
    "Confirmation Code": "\u78BA\u8A8D\u30B3\u30FC\u30C9",
    Confirming: "\u78BA\u8A8D\u4E2D",
    "Create a new account": "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Create Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Creating Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u4E2D",
    "Dismiss alert": "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308B",
    Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    "Enter your code": "\u30B3\u30FC\u30C9\u3092\u5165\u529B",
    "Enter your email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
    "Enter your phone number": "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B",
    "Enter your username": "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
    "Forgot your password?": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
    "Hide password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u975E\u8868\u793A",
    Loading: "\u30ED\u30FC\u30C9\u4E2D",
    "New password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
    "Phone Number": "\u96FB\u8A71\u756A\u53F7",
    "Resend Code": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
    "Reset your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Reset your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
    "Send code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    "Send Code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    Sending: "\u9001\u4FE1\u4E2D",
    "Setup TOTP": "TOTP \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    "Show password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A",
    "Sign in to your account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign In with Amazon": "Amazon\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Apple": "Apple \u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Facebook": "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Google": "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign in": "\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Signing in": "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D",
    Skip: "\u30B9\u30AD\u30C3\u30D7",
    Submit: "\u9001\u4FE1",
    Submitting: "\u9001\u4FE1\u4E2D",
    Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
    "Verify Contact": "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
    Verify: "\u78BA\u8A8D",
    "An account with the given email already exists.": "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
    "Confirm a Code": "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
    "Create account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
    "Enter your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
    "Forgot Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
    "Have an account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
    "Incorrect username or password": "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
    "Invalid password format": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
    "Invalid phone number format": "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    "It may take a minute to arrive.": "\u30B3\u30FC\u30C9\u3092\u53D7\u4FE1\u3059\u308B\u307E\u3067\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    "Lost your code? ": "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
    "New Password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    "No account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
    or: "\u53C8\u306F",
    "Password attempts exceeded": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
    "Reset password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
    "Sign Out": "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
    "Sign Up": "\u767B\u9332 ",
    "User already exists": "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
    "User does not exist": "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
    "Username cannot be empty": "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
    "We Emailed You": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:",
    "Your code is on the way. To log in, enter the code we texted to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:"
};


var $aadf9e1c4862778e$export$fb1930c2b96707b2 = {
    "Account recovery requires verified contact information": "\uACC4\uC815 \uBCF5\uAD6C\uB97C \uC704\uD574 \uC5F0\uB77D\uCC98 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
    "Back to Sign In": "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
    "Change Password": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30",
    Changing: "\uBCC0\uACBD\uC911",
    Code: "\uCF54\uB4DC",
    "Confirm Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778",
    "Confirm Sign Up": "\uD68C\uC6D0\uAC00\uC785 \uD655\uC778",
    "Confirm SMS Code": "\uD734\uB300\uD3F0 \uBCF8\uC778 \uD655\uC778",
    "Confirm TOTP Code": "TOTP \uC778\uC99D\uBC88\uD638 \uD655\uC778",
    Confirm: "\uD655\uC778",
    "Confirmation Code": "\uC778\uC99D\uBC88\uD638",
    Confirming: "\uD655\uC778\uC911",
    "Create a new account": "\uD68C\uC6D0\uAC00\uC785",
    "Create Account": "\uD68C\uC6D0\uAC00\uC785",
    "Creating Account": "\uD68C\uC6D0\uAC00\uC785\uC911",
    "Dismiss alert": "\uC54C\uB9BC \uBB34\uC2DC",
    Email: "\uC774\uBA54\uC77C",
    "Enter your code": "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Enter your email": "\uC774\uBA54\uC77C \uC785\uB825",
    "Enter your phone number": "\uC804\uD654\uBC88\uD638 \uC785\uB825",
    "Enter your username": "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Hide password": "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
    Loading: "\uB85C\uB529\uC911",
    "New password": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
    Password: "\uBE44\uBC00\uBC88\uD638",
    "Phone Number": "\uC804\uD654\uBC88\uD638",
    "Resend Code": "\uC778\uC99D\uBC88\uD638 \uC7AC\uC804\uC1A1",
    "Reset your password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Reset your Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Send code": "\uC778\uC99D\uCF54\uB4DC \uBCF4\uB0B4\uAE30",
    "Send Code": "\uCF54\uB4DC \uC804\uC1A1",
    Sending: "\uC804\uC1A1\uC911",
    "Setup TOTP": "TOTP \uC124\uC815\uD558\uAE30",
    "Show password": "\uBE44\uBC00\uBC88\uD638 \uBCF4\uC774\uAE30",
    "Sign in to your account": "\uB85C\uADF8\uC778",
    "Sign In with Amazon": "Amazon \uB85C\uADF8\uC778",
    "Sign In with Apple": "Apple \uB85C\uADF8\uC778",
    "Sign In with Facebook": "Facebook \uB85C\uADF8\uC778",
    "Sign In with Google": "Google \uB85C\uADF8\uC778",
    "Sign in": "\uB85C\uADF8\uC778",
    "Sign In": "\uB85C\uADF8\uC778",
    "Signing in": "\uB85C\uADF8\uC778\uC911",
    Skip: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
    Submit: "\uD655\uC778",
    Submitting: "\uD655\uC778\uC911",
    Username: "\uC544\uC774\uB514",
    "Verify Contact": "\uC5F0\uB77D\uCC98 \uD655\uC778",
    Verify: "\uC778\uC99D",
    Birthdate: "\uC0DD\uB144\uC6D4\uC77C",
    "Family Name": "\uC131",
    "Forgot your password?": "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
    "Given Name": "\uC774\uB984",
    Name: "\uC131\uD568",
    Nickname: "\uB2C9\uB124\uC784",
    "Preferred Username": "\uB2C9\uB124\uC784",
    Profile: "\uD504\uB85C\uD544",
    "Reset Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    Website: "\uC6F9\uC0AC\uC774\uD2B8"
};


var $ebe512b7b13cd07a$export$8569df33fbaae243 = {
    "Account recovery requires verified contact information": "Accountherstel vereist geverifieerde contactgegevens",
    "Back to Sign In": "Terug naar inloggen",
    "Change Password": "Wachtwoord wijzigen",
    Changing: "Wordt aangepast",
    Code: "Code",
    "Confirm Password": "Bevestig Wachtwoord",
    "Confirm Sign Up": "Bevestig inschrijving",
    "Confirm SMS Code": "Bevestig SMS Code",
    "Confirm TOTP Code": "Bevestig TOTP Code",
    Confirm: "Bevestig",
    "Confirmation Code": "Bevestigingscode",
    Confirming: "Bevestigen",
    "Create a new account": "Nieuw account aanmaken",
    "Create Account": "Account aanmaken",
    "Creating Account": "Account wordt aangemaakt",
    "Dismiss alert": "Waarschuwing sluiten",
    Email: "E-mail",
    "Enter your code": "Vul je code in",
    "Enter your email": "Vul je e-mail in",
    "Enter your phone number": "Vul je telefoonnummer in",
    "Enter your username": "Vul je gebruikersnaam in",
    "Forgot your password?": "Wachtwoord vergeten? ",
    "Hide password": "Verberg wachtwoord",
    Loading: "Laden",
    "New password": "Nieuw wachtwoord",
    Password: "Wachtwoord",
    "Phone Number": "Telefoonnummer",
    "Resend Code": "Verstuur code nogmaals",
    "Reset your password": "Reset je wachtwoord",
    "Reset your Password": "Wachtwoord resetten",
    "Send code": "Verstuur code",
    "Send Code": "Verstuur Code",
    Sending: "Versturen",
    "Setup TOTP": "TOTP Instellingen",
    "Show password": "Toon wachtwoord",
    "Sign in to your account": "Inloggen op je account",
    "Sign In with Amazon": "Inloggen met Amazon",
    "Sign In with Apple": "Inloggen met Apple",
    "Sign In with Facebook": "Inloggen met Facebook",
    "Sign In with Google": "Inloggen met Google",
    "Sign in": "Inloggen",
    "Sign In": "Inloggen",
    "Signing in": "Inloggen",
    Skip: "Overslaan",
    Submit: "Versturen",
    Submitting: "Wordt verstuurd",
    Username: "Gebruikersnaam",
    "Verify Contact": "Verifieer Contact",
    Verify: "Verifieer"
};


var $db344bf2bb4df578$export$6fb0e8139f7ef98d = {
    "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
    "Back to Sign In": "Powr\xf3t do logowania",
    "Change Password": "Zmie\u0144 has\u0142o",
    Changing: "Zmienianie",
    Code: "Kod",
    "Confirm Password": "Potwierd\u017A Has\u0142o",
    "Confirm Sign Up": "Potwierd\u017A rejestracj\u0119",
    "Confirm SMS Code": "Potwierd\u017A kod SMS",
    "Confirm TOTP Code": "Potwierd\u017A has\u0142o jednorazowe",
    Confirm: "Potwierd\u017A",
    "Confirmation Code": "Kod potwierdzenia",
    Confirming: "Potwierdzanie",
    "Create a new account": "Utw\xf3rz nowe konto",
    "Create Account": "Utw\xf3rz konto",
    "Creating Account": "Tworzenie konta",
    "Dismiss alert": "Odrzu\u0107 alert",
    Email: "E-mail",
    "Enter your code": "Wprowad\u017A sw\xf3j kod",
    "Enter your email": "Wpisz sw\xf3j adres e-mail",
    "Enter your phone number": "Wpisz sw\xf3j numer telefonu",
    "Enter your username": "Wprowad\u017A swoj\u0105 nazw\u0119 u\u017Cytkownika",
    "Forgot your password?": "Zapomnia\u0142e\u015B has\u0142a? ",
    "Hide password": "Ukryj has\u0142o",
    Loading: "\u0141adowanie",
    "New password": "Nowe has\u0142o",
    Password: "Has\u0142o",
    "Phone Number": "Numer telefonu",
    "Resend Code": "Wy\u015Blij kod ponownie",
    "Reset your password": "Zresetuj swoje has\u0142o",
    "Reset your Password": "Zresetuj swoje has\u0142o",
    "Send code": "Wy\u015Blij kod",
    "Send Code": "Zresetuj has\u0142o",
    Sending: "Wysy\u0142anie",
    "Setup TOTP": "Konfiguruj TOTP",
    "Show password": "Poka\u017C has\u0142o",
    "Sign in to your account": "Zaloguj si\u0119 na swoje konto",
    "Sign In with Amazon": "Zaloguj z Amazon",
    "Sign In with Apple": "Zaloguj z Apple",
    "Sign In with Facebook": "Zaloguj z Facebook",
    "Sign In with Google": "Zaloguj z Google",
    "Sign In": "Logowanie",
    "Sign in": "Zaloguj",
    "Signing in": "Logowanie",
    Skip: "Pomi\u0144",
    Submit: "Wy\u015Blij",
    Submitting: "Wysy\u0142anie",
    Username: "Nazwa u\u017Cytkownika",
    "Verify Contact": "Weryfikacja danych kontaktowych",
    Verify: "Zweryfikuj",
    Birthdate: "Data urodzenia",
    "Family Name": "Nazwisko",
    "Given Name": "Pierwsze imi\u0119",
    "Middle Name": "Drugie imi\u0119",
    Name: "Imi\u0119 i nazwisko",
    Nickname: "Pseudonim",
    "Preferred Username": "Preferowana nazwa u\u017Cytkownika",
    Profile: "Profil",
    Website: "Strona internetowa"
};


var $19334c07d164f10a$export$c7dddbf179b434d1 = {
    "Account recovery requires verified contact information": "A recupera\xe7\xe3o da conta requer informa\xe7\xf5es de contato verificadas",
    "Back to Sign In": "Voltar para Entrar",
    "Change Password": "Mudar senha",
    Changing: "Mudando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirme a Senha",
    "Confirm Sign Up": "Confirmar inscri\xe7\xe3o",
    "Confirm SMS Code": "Confirme o c\xf3digo SMS",
    "Confirm TOTP Code": "Confirme o c\xf3digo TOTP",
    Confirm: "confirme",
    "Confirmation Code": "C\xf3digo de confirma\xe7\xe3o",
    Confirming: "Confirmando",
    "Create a new account": "Criar uma nova conta",
    "Create Account": "Criar Conta",
    "Creating Account": "Criando conta",
    "Dismiss alert": "Descartar alerta",
    Email: "O email",
    "Enter your code": "Insira seu c\xf3digo",
    "Enter your email": "Digite seu e-mail",
    "Enter your phone number": "Digite seu n\xfamero de telefone",
    "Enter your username": "entre com seu nome de usu\xe1rio",
    "Forgot your password?": "Esqueceu sua senha? ",
    "Hide password": "Esconder a senha",
    Loading: "Carregando",
    "New password": "Nova Senha",
    Password: "Senha",
    "Phone Number": "N\xfamero de telefone",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Redefina sua senha",
    "Reset your Password": "Redefina sua senha",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar senha",
    "Sign in to your account": "Fa\xe7a login em sua conta",
    "Sign In with Amazon": "Entrar com a Amazon",
    "Sign In with Apple": "Entrar com a Apple",
    "Sign In with Facebook": "Entrar com o Facebook",
    "Sign In with Google": "Fa\xe7a login no Google",
    "Sign in": "Entrar",
    "Sign In": "Entrar",
    "Signing in": "Entrando",
    Skip: "Pular",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nome do usu\xe1rio",
    "Verify Contact": "Verificar contato",
    Verify: "Verificar"
};


var $fa8dd0366ec3d3d9$export$2a86dc37ee9734c = {
    "Account recovery requires verified contact information": "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
    "Back to Sign In": "\u56DE\u5230\u767B\u5F55",
    "Change Password": "\u66F4\u6539\u5BC6\u7801",
    Changing: "\u6B63\u5728\u4FEE\u6539",
    Code: "\u786E\u8BA4\u7801",
    "Confirm Password": "\u786E\u8BA4\u5BC6\u7801",
    "Confirm Sign Up": "\u786E\u8BA4\u6CE8\u518C",
    "Confirm SMS Code": "\u786E\u8BA4\u77ED\u4FE1\u9A8C\u8BC1\u7801",
    "Confirm TOTP Code": "\u786E\u8BA4 TOTP \u4EE3\u7801",
    Confirm: "\u786E\u8BA4",
    "Confirmation Code": "\u786E\u8BA4\u7801",
    Confirming: "\u6B63\u5728\u786E\u8BA4",
    "Create a new account": "\u521B\u5EFA\u65B0\u8D26\u6237",
    "Create Account": "\u521B\u5EFA\u8D26\u6237",
    "Creating Account": "\u6B63\u5728\u521B\u5EFA\u8D26\u6237",
    "Dismiss alert": "\u5173\u95ED\u8B66\u62A5",
    Email: "\u90AE\u7BB1",
    "Enter your code": "\u8F93\u5165\u9A8C\u8BC1\u7801",
    "Enter your email": "\u8F93\u5165\u7535\u5B50\u90AE\u4EF6",
    "Enter your phone number": "\u8F93\u5165\u7535\u8BDD\u53F7\u7801",
    "Enter your username": "\u8F93\u5165\u7528\u6237\u540D",
    "Forgot your password?": "\u5FD8\u8BB0\u5BC6\u7801\u4E86\uFF1F",
    "Hide password": "\u9690\u85CF\u5BC6\u7801",
    Loading: "\u6B63\u5728\u52A0\u8F7D",
    "New password": "\u65B0\u5BC6\u7801",
    Password: "\u5BC6\u7801",
    "Phone Number": "\u7535\u8BDD",
    "Resend Code": "\u91CD\u53D1\u9A8C\u8BC1\u7801",
    "Reset your password": "\u91CD\u7F6E\u5BC6\u7801",
    "Reset your Password": "\u91CD\u7F6E\u5BC6\u7801",
    "Send Code": "\u53D1\u9001\u786E\u8BA4\u7801",
    "Send code": "\u53D1\u9001\u9A8C\u8BC1\u7801",
    Sending: "\u6B63\u5728\u53D1\u9001",
    "Setup TOTP": "\u8BBE\u7F6E TOTP",
    "Show password": "\u663E\u793A\u5BC6\u7801",
    "Sign in to your account": "\u767B\u5F55\u8D26\u6237",
    "Sign In with Amazon": "\u901A\u8FC7 Amazon \u767B\u5F55",
    "Sign In with Apple": "\u901A\u8FC7 Apple \u767B\u5F55",
    "Sign In with Facebook": "\u901A\u8FC7 Facebook \u767B\u5F55",
    "Sign In with Google": "\u901A\u8FC7 Google \u767B\u5F55",
    "Sign in": "\u767B\u5F55",
    "Sign In": "\u767B\u5F55",
    "Signing in": "\u6B63\u5728\u767B\u5F55",
    Skip: "\u8DF3\u8FC7",
    Submit: "\u63D0\u4EA4",
    Submitting: "\u6B63\u5728\u63D0\u4EA4",
    Username: "\u7528\u6237\u540D",
    "Verify Contact": "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
    Verify: "\u9A8C\u8BC1",
    "Confirm a Code": "\u786E\u8BA4\u7801",
    "Confirm Sign In": "\u786E\u8BA4\u767B\u5F55",
    "Forgot Password": "\u5FD8\u8BB0\u5BC6\u7801",
    "Incorrect username or password": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
    "Invalid password format": "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
    "Invalid phone number format": "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900",
    "New Password": "\u65B0\u5BC6\u7801",
    or: "\u6216\u8005",
    "Resend a Code": "\u91CD\u53D1\u786E\u8BA4\u7801",
    "Sign Out": "\u9000\u51FA",
    "Sign Up": "\u6CE8\u518C",
    "User already exists": "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
    "User does not exist": "\u7528\u6237\u4E0D\u5B58\u5728"
};


var $150d2aebee58f077$export$9f1a61f9baaa2d2e = {
    "Account recovery requires verified contact information": "F\xf6r att \xe5terst\xe4lla kontot beh\xf6ver du ett verifierat konto",
    "Back to Sign In": "Tillbaka till inloggningen",
    "Change Password": "Byt l\xf6senord",
    Changing: "\xc4ndra",
    Code: "Kod",
    "Confirm Password": "Bekr\xe4fta l\xf6senord",
    "Confirm Sign Up": "Bekr\xe4fta registrering",
    "Confirm SMS Code": "Bekr\xe4fta SMS-kod",
    "Confirm TOTP Code": "Bekr\xe4fta TOTP-kod",
    Confirm: "Bekr\xe4fta",
    "Confirmation Code": "Verifikationskod",
    Confirming: "Bekr\xe4ftar",
    "Create a new account": "Skapa ett nytt konto",
    "Create Account": "Skapa konto",
    "Creating Account": "Skapar konto",
    "Dismiss alert": "Avvisa varning",
    Email: "E-post",
    "Enter your code": "Skriv din kod",
    "Enter your email": "Fyll i din e-post",
    "Enter your phone number": "Ange ditt telefonnummer",
    "Enter your username": "Ange ditt anv\xe4ndarnamn",
    "Forgot your password?": "Gl\xf6mt ditt l\xf6senord? ",
    "Hide password": "D\xf6lj l\xf6senord",
    Loading: "Laddar",
    "New password": "Nytt l\xf6senord",
    Password: "L\xf6senord",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Skicka koden igen",
    "Reset your password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Reset your Password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Send code": "Skicka kod",
    "Send Code": "Skicka kod",
    Sending: "Skickar",
    "Setup TOTP": "Konfigurera TOTP",
    "Show password": "Visa l\xf6senord",
    "Sign in to your account": "Logga in till ditt konto",
    "Sign In with Amazon": "Logga in med Amazon",
    "Sign In with Apple": "Logga in med Apple",
    "Sign In with Facebook": "Logga in med Facebook",
    "Sign In with Google": "Logga in med Google",
    "Sign in": "Logga in",
    "Sign In": "Logga in",
    "Signing in": "Loggar in",
    Skip: "Hoppa \xf6ver",
    Submit: "Skicka",
    Submitting: "Skickar in",
    Username: "Anv\xe4ndarnamn",
    "Verify Contact": "Verifiera kontakt",
    Verify: "Verifiera",
    "An account with the given email already exists.": "Det finns redan ett konto med denna e-postadress",
    "Confirm a Code": "Bekr\xe4fta koden",
    "Confirm Sign In": "Bekr\xe4fta inloggning",
    "Create account": "Skapa konto",
    "Enter your password": "Ange ditt l\xf6senord",
    "Forgot Password": "Gl\xf6mt l\xf6senordet",
    "Have an account? ": "Redan registrerad? ",
    "Incorrect username or password": "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    "Invalid password format": "Ogiltigt l\xf6senordsformat",
    "Invalid phone number format": "Ogiltigt format f\xf6r telefonnummer",
    "Lost your code? ": "F\xf6rlorat koden? ",
    "New Password": "Nytt l\xf6senord",
    "No account? ": "Inget konto? ",
    or: "eller",
    "Password attempts exceeded": "Maximalt antal felaktiga inloggningsf\xf6rs\xf6k har uppn\xe5tts",
    "Reset password": "\xc5terst\xe4ll l\xf6senord",
    "Sign Out": "Logga ut",
    "Sign Up": "Registrering",
    "User already exists": "Anv\xe4ndaren finns redan",
    "User does not exist": "Anv\xe4ndaren finns inte",
    "Username cannot be empty": "Anv\xe4ndarnamnet kan inte vara tomt",
    "We Emailed You": "Vi har skickat e-post till dig"
};


var $46e308de86fa33f5$export$710642024bfcbd8f = {
    "Account recovery requires verified contact information": "Pemulihan akun memerlukan informasi kontak terverifikasi",
    "Back to Sign In": "Kembali ke Masuk",
    "Change Password": "Ubah kata sandi",
    Changing: "Mengubah",
    Code: "Kode",
    "Confirm Password": "Konfirmasi kata sandi",
    "Confirm Sign Up": "Konfirmasi Pendaftaran",
    "Confirm SMS Code": "Konfirmasi Kode SMS",
    "Confirm TOTP Code": "Konfirmasi Kode TOTP",
    Confirm: "Konfirmasi",
    "Confirmation Code": "Kode Konfirmasi",
    Confirming: "Mengkonfirmasi",
    "Create a new account": "Buat akun baru",
    "Create Account": "Buat Akun",
    "Creating Account": "Membuat Akun",
    "Dismiss alert": "Hentikan pemberitahuan",
    Email: "Email",
    "Enter your code": "Masukkan kode anda",
    "Enter your email": "Masukkan email anda",
    "Enter your phone number": "Masukkan nomor telepon anda",
    "Enter your username": "Masukkan nama akun anda",
    "Forgot your password?": "Lupa kata sandi? ",
    "Hide password": "Sembunyikan kata sandi",
    Loading: "Memuat",
    "New password": "Kata sandi baru",
    Password: "Kata sandi",
    "Phone Number": "Nomor telepon",
    "Resend Code": "Kirim ulang kodenya",
    "Reset your Password": "Reset Kata Sandi",
    "Reset your password": "Ubah kata sandi anda",
    "Send code": "Kirim kode",
    "Send Code": "Kirim Kode",
    Sending: "Mengirim",
    "Setup TOTP": "Siapkan TOTP",
    "Show password": "Tampilkan kata sandi",
    "Sign in to your account": "Masuk akun anda",
    "Sign In with Amazon": "Masuk dengan Amazon",
    "Sign In with Apple": "Masuk dengan Apple",
    "Sign In with Facebook": "Masuk dengan Facebook",
    "Sign In with Google": "Masuk dengan Google",
    "Sign in": "Masuk",
    "Sign In": "Masuk",
    "Signing in": "Memasuki",
    Skip: "Lewati",
    Submit: "Ajukan",
    Submitting: "Mengajukan",
    Username: "Nama akun",
    "Verify Contact": "Verifikasi Kontak",
    Verify: "Verifikasi",
    "An account with the given email already exists.": "Akun dengan email tersebut sudah terdaftar.",
    "Attempt limit exceeded, please try after some time.": "Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.",
    "Cannot reset password for the user as there is no registered/verified email or phone_number": "Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon",
    Change: "Ubah",
    "Confirm a Code": "Konfirmasi kode",
    "Create account": "Buat akun",
    "Enter your password": "Masukkan kata sandi anda",
    "Forgot Password": "Lupa kata sandi",
    "Have an account? ": "Sudah punya akun? ",
    Hello: "Halo",
    "Incorrect username or password.": "Nama akun atau kata sandi salah.",
    "Invalid phone number format": "Nomor telepon tidak sesuai dengan format.",
    "Invalid verification code provided, please try again.": "Kode verifikasi tidak sesuai, mohon coba lagi.",
    "It may take a minute to arrive.": "Mungkin perlu beberapa waktu untuk tiba.",
    "Lost your code? ": "Kode anda hilang?",
    Name: "Nama",
    "Network error": "Galat jaringan",
    "No account? ": "Tidak ada akun?",
    or: "atau",
    "Password did not conform with policy: Password not long enough": "Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "Ubah kata sandi anda",
    Send: "Kirim",
    "Sign In with AWS": "Masuk dengan AWS",
    "Sign Up with Amazon": "Daftar dengan Amazon",
    "Sign Up with AWS": "Daftar dengan AWS",
    "Sign Up with Facebook": "Daftar dengan Facebook",
    "Sign Up with Google": "Daftar dengan Google",
    SMS: "SMS",
    "User already exists": "Akun sudah terdaftar",
    "User does not exist.": "Akun tidak terdaftar.",
    "User is disabled.": "Akun dinonaktifkan.",
    "Username cannot be empty": "Nama akun tidak boleh kosong",
    "Username/client id combination not found.": "Nama akun atau id tidak ditemukan.",
    "We Emailed You": "Kami mengirimkanmu email",
    "Your code is on the way. To log in, enter the code we emailed to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke",
    "Your code is on the way. To log in, enter the code we texted to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke",
    "Your passwords must match": "Kata sandi harus sama"
};


var $27fde27e75d888ab$export$6961fa2059aeacf0 = {
    "Account recovery requires verified contact information": "Hesap kurtarma, do\u011Frulanm\u0131\u015F ileti\u015Fim bilgilerini gerektirir",
    "Back to Sign In": "Oturum A\xe7maya Geri D\xf6n",
    "Change Password": "\u015Eifreyi De\u011Fi\u015Ftir",
    Changing: "De\u011Fi\u015Ftiriliyor",
    Code: "Kod",
    "Confirm Password": "\u015Eifreyi Do\u011Frula",
    "Confirm Sign Up": "Kay\u0131t \u0130\u015Flemini Do\u011Frula",
    "Confirm SMS Code": "SMS Kodunu Do\u011Frula",
    "Confirm TOTP Code": "Tek Kullan\u0131ml\u0131k \u015Eifreyi Do\u011Frula",
    Confirm: "Do\u011Frula",
    "Confirmation Code": "Do\u011Frulama Kodu",
    Confirming: "Do\u011Frulan\u0131yor",
    "Create a new account": "Yeni bir hesap olu\u015Ftur",
    "Create Account": "Hesap Olu\u015Ftur",
    "Creating Account": "Hesap Olu\u015Fturuluyor",
    "Dismiss alert": "Uyar\u0131y\u0131 reddet",
    Email: "E-posta",
    "Enter your code": "Kodu girin",
    "Enter your email": "E-posta adresinizi girin",
    "Enter your phone number": "Telefon numaran\u0131z\u0131 girin",
    "Enter your username": "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
    "Forgot your password?": "\u015Eifrenizi mi unuttunuz?",
    "Hide password": "\u015Eifreyi gizle",
    Loading: "Y\xfckleniyor",
    "New password": "Yeni \u015Fifre",
    Password: "\u015Eifre",
    "Phone Number": "Telefon Numaras\u0131",
    "Resend Code": "Kodu Yeniden G\xf6nder",
    "Reset your password": "\u015Eifrenizi s\u0131f\u0131rlay\u0131n",
    "Reset your Password": "\u015Eifrenizi S\u0131f\u0131rlay\u0131n",
    "Send code": "Kod g\xf6nder",
    "Send Code": "Kod G\xf6nder",
    Sending: "G\xf6nderiliyor",
    "Setup TOTP": "Tek kullan\u0131ml\u0131k \u015Fifre kurulumu yap",
    "Show password": "\u015Eifreyi g\xf6ster",
    "Sign in to your account": "Hesab\u0131n\u0131zda oturum a\xe7\u0131n",
    "Sign In with Amazon": "Amazon ile Oturum A\xe7",
    "Sign In with Apple": "Apple ile Oturum A\xe7",
    "Sign In with Facebook": "Facebook ile Oturum A\xe7",
    "Sign In with Google": "Google ile Oturum A\xe7",
    "Sign in": "Oturum a\xe7",
    "Sign In": "Oturum A\xe7",
    "Signing in": "Oturum a\xe7\u0131l\u0131yor",
    Skip: "Atla",
    Submit: "G\xf6nder",
    Submitting: "G\xf6nderiliyor",
    Username: "Kullan\u0131c\u0131 ad\u0131",
    "Verify Contact": "Ki\u015Fiyi Do\u011Frula",
    Verify: "Do\u011Frula",
    "An account with the given email already exists.": "Bu e-postaya ait zaten bir hesap var.",
    "Confirm Sign In": "Oturum A\xe7may\u0131 Do\u011Frula",
    "Have an account? ": "Hesab\u0131n\u0131z var m\u0131? ",
    "Incorrect username or password": "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre",
    "Invalid password format": "Ge\xe7ersiz parola format\u0131",
    "Invalid phone number format": "Ge\xe7ersiz telefon numaras\u0131 format\u0131",
    "Lost your code? ": "Kodu mu kaybettiniz? ",
    "No account? ": "Hesab\u0131n\u0131z yok mu? ",
    or: "veya",
    "Password attempts exceeded": "Maksimum oturum a\xe7ma giri\u015Fimi a\u015F\u0131ld\u0131",
    "Sign Out": "\xc7\u0131k\u0131\u015F yap",
    "Sign Up": "Kay\u0131t Ol",
    "User already exists": "Bu kullan\u0131c\u0131 zaten var",
    "User does not exist": "B\xf6yle bir kullan\u0131c\u0131 mevcut de\u011Fil",
    "Username cannot be empty": "Kullan\u0131c\u0131 ad\u0131 bo\u015F olamaz"
};


var $33220ff79c4bb3a1$export$6240aeddf7c74bb8 = {
    "Account recovery requires verified contact information": "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434, \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438",
    "Change Password": "\u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
    "Confirm Sign Up": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    "Confirm SMS Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 CMC-\u041A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 TOTP-\u041A\u043E\u0434",
    Confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044C",
    "Confirmation Code": "\u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
    Confirming: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
    "Create a new account": "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Create Account": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Creating Account": "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
    "Dismiss alert": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
    Email: "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your code": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u041A\u043E\u0434",
    "Enter your email": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your phone number": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Enter your username": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Forgot your password?": "\u0417\u0430\u0431\u044B\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    "New password": "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Resend Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u044C \u0435\u0449\u0435 \u0440\u0430\u0437 \u041A\u043E\u0434",
    "Reset your password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u041F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    "Send Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    Sending: "\u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430",
    "Setup TOTP": "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0437\u043D\u0430\u043A \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    "Sign In with Amazon": "\u0437\u043D\u0430\u043A \u0432 \u0441 Amazon",
    "Sign In with Apple": "\u0437\u043D\u0430\u043A \u0432 \u0441 Apple",
    "Sign In with Facebook": "\u0437\u043D\u0430\u043A \u0432 \u0441 Facebook",
    "Sign In with Google": "\u0437\u043D\u0430\u043A \u0432 \u0441 Google",
    "Sign in": "\u0437\u043D\u0430\u043A \u0432",
    "Sign In": "\u0437\u043D\u0430\u043A \u0432",
    "Signing in": "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0442\u044C",
    Submit: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435",
    Submitting: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0432",
    Username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Verify Contact": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C"
};


var $23415dd0ee647f5d$export$320d289eca4cc695 = {
    BACK_SIGN_IN: "Back to Sign In",
    BIRTHDATE: "Birthdate",
    CHANGE_PASSWORD: "Change Password",
    CHANGING_PASSWORD: "Changing",
    CODE: "Code",
    CONFIRM_PASSWORD: "Confirm Password",
    CONFIRM_RESET_PASSWORD_HEADING: "Reset your Password",
    CONFIRM_SIGNUP_HEADING: "Confirm Sign Up",
    CONFIRM_SMS: "Confirm SMS Code",
    CONFIRM_TOTP: "Confirm TOTP Code",
    CONFIRM: "Confirm",
    CONFIRMATION_CODE: "Confirmation Code",
    CONFIRMING: "Confirming",
    CREATE_ACCOUNT: "Create Account",
    CREATING_ACCOUNT: "Creating Account",
    EMAIL_ADDRESS: "Email",
    ENTER_CODE: "Enter your code",
    ENTER_USERNAME: "Enter your username",
    FAMILY_NAME: "Family Name",
    GIVEN_NAME: "Given Name",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    FORGOT_YOUR_PASSWORD_LEGACY: "Forgot your password? ",
    HIDE_PASSWORD: "Hide password",
    LOADING: "Loading",
    LOGIN_NAME: "Username",
    MIDDLE_NAME: "Middle Name",
    NAME: "Name",
    NICKNAME: "Nickname",
    NEW_PASSWORD: "New password",
    PASSWORD: "Password",
    PHONE_NUMBER: "Phone Number",
    PREFERRED_USERNAME: "Preferred Username",
    PROFILE: "Profile",
    RESEND_CODE: "Resend Code",
    RESET_PASSWORD_HEADING: "Reset your password",
    RESET_PASSWORD: "Reset Password",
    SEND_CODE: "Send code",
    SENDING: "Sending",
    SETUP_TOTP: "Setup TOTP",
    SHOW_PASSWORD: "Show password",
    SIGN_IN_BUTTON: "Sign in",
    SIGN_IN_TAB: "Sign In",
    SIGN_IN_WITH_AMAZON: "Sign In with Amazon",
    SIGN_IN_WITH_APPLE: "Sign In with Apple",
    SIGN_IN_WITH_FACEBOOK: "Sign In with Facebook",
    SIGN_IN_WITH_GOOGLE: "Sign In with Google",
    SIGN_IN: "Sign in to your account",
    SIGN_UP_BUTTON: "Create a new account",
    SIGNING_IN_BUTTON: "Signing in",
    SKIP: "Skip",
    SUBMIT: "Submit",
    SUBMITTING: "Submitting",
    VERIFY_CONTACT: "Verify Contact",
    VERIFY_HEADING: "Account recovery requires verified contact information",
    VERIFY: "Verify",
    WEBSITE: "Website"
};


var $e1b5d834a4634e0c$export$cca4a41bdb910c51 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $ce0368d6191c8cca$export$cca4a41bdb910c51)), $e1b5d834a4634e0c$export$eb91f595f110d703 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $a19559f0f239105d$export$eb91f595f110d703)), $e1b5d834a4634e0c$export$1d204a99f5862ba9 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $86c38a6ac877bb92$export$1d204a99f5862ba9)), $e1b5d834a4634e0c$export$8cfa91bfcf8d11c8 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $02f7d482e07472ab$export$8cfa91bfcf8d11c8)), $e1b5d834a4634e0c$export$5c8da73de176fccc = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $4d39884df14249f1$export$5c8da73de176fccc)), $e1b5d834a4634e0c$export$c416809cd76fbf21 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $a1aa95de55c98f81$export$c416809cd76fbf21)), $e1b5d834a4634e0c$export$fb1930c2b96707b2 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $aadf9e1c4862778e$export$fb1930c2b96707b2)), $e1b5d834a4634e0c$export$8569df33fbaae243 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $ebe512b7b13cd07a$export$8569df33fbaae243)), $e1b5d834a4634e0c$export$6fb0e8139f7ef98d = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $db344bf2bb4df578$export$6fb0e8139f7ef98d)), $e1b5d834a4634e0c$export$c7dddbf179b434d1 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $19334c07d164f10a$export$c7dddbf179b434d1)), $e1b5d834a4634e0c$export$2a86dc37ee9734c = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $fa8dd0366ec3d3d9$export$2a86dc37ee9734c)), $e1b5d834a4634e0c$export$9f1a61f9baaa2d2e = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $150d2aebee58f077$export$9f1a61f9baaa2d2e)), $e1b5d834a4634e0c$export$710642024bfcbd8f = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $46e308de86fa33f5$export$710642024bfcbd8f)), $e1b5d834a4634e0c$export$6961fa2059aeacf0 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $27fde27e75d888ab$export$6961fa2059aeacf0)), $e1b5d834a4634e0c$export$6240aeddf7c74bb8 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $33220ff79c4bb3a1$export$6240aeddf7c74bb8)), $e1b5d834a4634e0c$export$320d289eca4cc695 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $23415dd0ee647f5d$export$320d289eca4cc695));


var $698780b76c9b9475$export$6ba37fd455cdd594 = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, (0, $e1b5d834a4634e0c$export$320d289eca4cc695));
function $698780b76c9b9475$export$d73ee8ef04f5226a(r) {
    return (0, $a204f73577cd8409$export$dbe3113d60765c1a).get(r);
}
function $698780b76c9b9475$export$8a4bbd9646545970(r) {
    return (0, $a204f73577cd8409$export$dbe3113d60765c1a).get(r) !== r;
}
var $698780b76c9b9475$export$150b732325d14d04 = {
    de: (0, $e1b5d834a4634e0c$export$cca4a41bdb910c51),
    en: (0, $e1b5d834a4634e0c$export$eb91f595f110d703),
    es: (0, $e1b5d834a4634e0c$export$1d204a99f5862ba9),
    fr: (0, $e1b5d834a4634e0c$export$8cfa91bfcf8d11c8),
    id: (0, $e1b5d834a4634e0c$export$710642024bfcbd8f),
    it: (0, $e1b5d834a4634e0c$export$5c8da73de176fccc),
    ja: (0, $e1b5d834a4634e0c$export$c416809cd76fbf21),
    kr: (0, $e1b5d834a4634e0c$export$fb1930c2b96707b2),
    nl: (0, $e1b5d834a4634e0c$export$8569df33fbaae243),
    pl: (0, $e1b5d834a4634e0c$export$6fb0e8139f7ef98d),
    pt: (0, $e1b5d834a4634e0c$export$c7dddbf179b434d1),
    zh: (0, $e1b5d834a4634e0c$export$2a86dc37ee9734c),
    sv: (0, $e1b5d834a4634e0c$export$9f1a61f9baaa2d2e),
    tr: (0, $e1b5d834a4634e0c$export$6961fa2059aeacf0),
    ru: (0, $e1b5d834a4634e0c$export$6240aeddf7c74bb8)
};


var $4c07519063dfa32b$export$850c34c1087496e6 = function(e) {
    for(var t = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, e), n = 0, i = Object.entries(e); n < i.length; n++){
        var l = i[n], c = l[0], u = l[1], a = u.label, f = u.placeholder;
        t[c] = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, u), {
            label: a ? (0, $698780b76c9b9475$export$d73ee8ef04f5226a)(a) : void 0,
            placeholder: f ? (0, $698780b76c9b9475$export$d73ee8ef04f5226a)(f) : void 0
        });
    }
    return t;
}, $4c07519063dfa32b$export$c610ae674f32e5d9 = function(r) {
    return Object.entries(r).sort(function(r, e) {
        return (r[1].order || Number.MAX_VALUE) - (e[1].order || Number.MAX_VALUE);
    }).filter(function(r) {
        return void 0 !== r[1];
    });
}, $4c07519063dfa32b$export$981532776ab2217e = function(o, t) {
    void 0 === t && (t = {});
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($d9b513d63d79678d$exports)))(o);
    return Object.keys(t).forEach(function(e) {
        n[e] = (0, $e62042a96a9aa8b8$export$18ce0697a983be9b)((0, $e62042a96a9aa8b8$export$18ce0697a983be9b)({}, n[e]), t[e]);
    }), n;
};


var $f30f435d664d259a$export$bafc1c085dad2945 = function(r, i) {
    var n = (0, (0, $f14b2dcc942b476f$export$9bcaa03841470ad7)[r])(i);
    return (0, $4c07519063dfa32b$export$850c34c1087496e6)(n);
}, $f30f435d664d259a$export$5e097831852eb087 = function(o, t) {
    var n, u, f = $f30f435d664d259a$export$bafc1c085dad2945(o, t), l = (null === (u = null === (n = (0, $ed9f310e3d5fb25d$export$99a4282e2c3b772d)(t).context) || void 0 === n ? void 0 : n.formFields) || void 0 === u ? void 0 : u[o]) || {}, v = (0, $4c07519063dfa32b$export$981532776ab2217e)(f, l);
    return delete v.QR, v;
}, $f30f435d664d259a$export$2fcee3580f06a0ca = function(r, o) {
    var t = $f30f435d664d259a$export$5e097831852eb087(r, o);
    return (0, $4c07519063dfa32b$export$c610ae674f32e5d9)(t);
};




var $lsJ54 = parcelRequire("lsJ54");
function $884fbf1cef0a5b9f$var$isEmptyArray(value) {
    return Array.isArray(value) && (0, (/*@__PURE__*/$parcel$interopDefault($2f7f607262506341$exports)))(value);
}
function $884fbf1cef0a5b9f$export$2c02be4a78959098(...values) {
    return values.every($884fbf1cef0a5b9f$var$isEmptyArray);
}
function $884fbf1cef0a5b9f$var$isEmptyObject(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lsJ54)))(value) && !Array.isArray(value) && (0, (/*@__PURE__*/$parcel$interopDefault($2f7f607262506341$exports)))(value);
}
function $884fbf1cef0a5b9f$export$d6708a3543c32fe4(...values) {
    return values.every($884fbf1cef0a5b9f$var$isEmptyObject);
}



const $dc360d121cb8e998$export$6756c954b2014a15 = ()=>false;
function $dc360d121cb8e998$export$6d39b5fae5236692(currentDeps, nextDeps) {
    if (currentDeps.length !== nextDeps.length) return false;
    return currentDeps.every((currentDep, index)=>{
        const nextDep = nextDeps[index];
        if ((0, $884fbf1cef0a5b9f$export$2c02be4a78959098)(currentDep, nextDep) || (0, $884fbf1cef0a5b9f$export$d6708a3543c32fe4)(currentDep, nextDep)) return true;
        return currentDep === nextDep;
    });
}
const $dc360d121cb8e998$export$1f14d6e84ea4650a = (selector)=>(currentFacade, nextFacade)=>{
        const currentSelectorDeps = selector(currentFacade);
        const nextSelectorDeps = selector(nextFacade);
        // Shallow compare the array values
        return $dc360d121cb8e998$export$6d39b5fae5236692(currentSelectorDeps, nextSelectorDeps);
    };
const $dc360d121cb8e998$export$bc28d83edeb430b5 = (user)=>function getTotpSecretCode() {
        return (0, $e62042a96a9aa8b8$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).setupTOTP(user);
        });
    };
const $dc360d121cb8e998$export$65443658c81b32cc = (route)=>(0, $9547d8fe27a259c6$export$297d226dd86a0de7).some((componentRoute)=>componentRoute === route);
const $dc360d121cb8e998$var$flattenFormFields = (fields)=>fields.flatMap(([name, options])=>Object.assign({
            name: name
        }, options));
const $dc360d121cb8e998$export$e1740c275512617 = (route, state)=>// verifyUser is a component route, but does not have form fields
    $dc360d121cb8e998$export$65443658c81b32cc(route) && route !== "verifyUser" ? $dc360d121cb8e998$var$flattenFormFields((0, $f30f435d664d259a$export$2fcee3580f06a0ca)(route, state)) : [];


function $ac0a16ef242d249b$export$2e2bcd8739ae039(selector) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $0dbfd3c00bf87d48$export$2254a7bd02a5abf7));
    if (!context) throw new Error((0, $9547d8fe27a259c6$export$7e92b2e9f0809b11));
    const { service: service } = context;
    const { send: send } = service;
    const xstateSelector = (0, $acw62.useCallback)((state)=>Object.assign({}, (0, $7fbff47e1392358f$export$5f925d5954b1c10b)({
            send: send,
            state: state
        })), [
        send
    ]);
    const comparator = selector ? (0, $dc360d121cb8e998$export$1f14d6e84ea4650a)(selector) : (0, $dc360d121cb8e998$export$6756c954b2014a15);
    const facade = (0, $2652fe8f8a24878d$export$2105062e25df4afe)(service, xstateSelector, comparator);
    const { route: route, user: user } = facade, rest = (0, $e62042a96a9aa8b8$export$3c9a16f847548506)(facade, [
        "route",
        "user"
    ]);
    // do not memoize output. `service.getSnapshot` reference remains stable preventing
    // `fields` from updating with current form state on value changes
    const serviceSnapshot = service.getSnapshot();
    // legacy `formFields` values required until form state is removed from state machine
    const fields = (0, $acw62.useMemo)(()=>(0, $dc360d121cb8e998$export$e1740c275512617)(route, serviceSnapshot), [
        route,
        serviceSnapshot
    ]);
    return Object.assign(Object.assign({}, rest), {
        getTotpSecretCode: (0, $dc360d121cb8e998$export$bc28d83edeb430b5)(user),
        route: route,
        user: user,
        fields: /** @deprecated For internal use only */ fields,
        /** @deprecated For internal use only */ _state: serviceSnapshot,
        /** @deprecated For internal use only */ _send: send
    });
}












var $acw62 = parcelRequire("acw62");
"use client";
const $f52e2ccccb0d538f$export$b16d9fb1a22de840 = (0, $acw62.createContext)(null);
const $f52e2ccccb0d538f$var$initialState = {
    didCatch: false,
    error: null
};
class $f52e2ccccb0d538f$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $f52e2ccccb0d538f$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $f52e2ccccb0d538f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $acw62.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $acw62.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $acw62.createElement)($f52e2ccccb0d538f$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $f52e2ccccb0d538f$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $f52e2ccccb0d538f$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $f52e2ccccb0d538f$export$c052f6604b7d51fe() {
    const context = (0, $acw62.useContext)($f52e2ccccb0d538f$export$b16d9fb1a22de840);
    $f52e2ccccb0d538f$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $acw62.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $acw62.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $f52e2ccccb0d538f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $acw62.forwardRef)((props, ref)=>(0, $acw62.createElement)($f52e2ccccb0d538f$export$e926676385687eaf, errorBoundaryProps, (0, $acw62.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}


/* eslint-disable react/function-component-definition, react/prop-types */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $bOOlK = parcelRequire("bOOlK");

var $9dZwz = parcelRequire("9dZwz");
var $hcz0Q = parcelRequire("hcz0Q");

var $7HKeb = parcelRequire("7HKeb");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $b85125360b778ad2$var$_excluded = [
    "className",
    "component"
];
function $b85125360b778ad2$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $bOOlK.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $9dZwz.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $7HKeb.default)(defaultTheme);
        const _extendSxProp = (0, $hcz0Q.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $b85125360b778ad2$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}



var $c9Z8w = parcelRequire("c9Z8w");

var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)("MuiBox", [
    "root"
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;


"use client";
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $b85125360b778ad2$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $cf808af3a1d339c9$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bnost.default).generate
});
$00a20d475386f68c$var$Box.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;


var $3bYfT = parcelRequire("3bYfT");
var $6lXkL = parcelRequire("6lXkL");
var $a0a5450dd7e50a49$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($a0a5450dd7e50a49$exports, "__esModule", {
    value: true
});
$a0a5450dd7e50a49$exports.default = void 0;

var $a0a5450dd7e50a49$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a0a5450dd7e50a49$var$_default = $a0a5450dd7e50a49$exports.default = (0, $a0a5450dd7e50a49$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutline");



var $kfZjc = parcelRequire("kfZjc");

const $29836994947f98a9$export$807b1b70df68fbc6 = {
    // Main routes
    ROOT: "/",
    PUBLISHER_HUB: "/publisher-hub",
    PLAYLISTS: "/playlists",
    REPORTING: "/reporting",
    MEDIA_GALLERY: "/media-gallery",
    SINGLE_MEDIA_EDIT_PAGE: "/video/edit/:token",
    MEDIA_GALLERY_PLAYLISTS: "/media-gallery?tab=1",
    SINGLE_PLAYLIST_EDIT_PAGE: "/playlist/edit/:token",
    // Admin routes
    ADMIN: "/admin",
    EDIT: "/edit",
    CLONE: "/clone",
    ADMIN_USERS: "/admin/users",
    ADMIN_DOMAIN: "/admin/:slug/domain",
    ADMIN_PUBLISHER_ONBOARD: "/admin/publisher/onboard",
    ADMIN_BULK_UPDATE: "/admin/bulk-update",
    ADMIN_BULK_DELETE: "/admin/bulk-delete",
    // admin dynamic routes
    ADMIN_DOMAIN_CONFIG: "/admin/:slug/domain/:domainToken",
    ADMIN_CONFIG_EDIT: "/admin/:slug/domain/:domainToken/add-config/edit",
    ADMIN_PLAYER_CONFIG: "/admin/:slug/domain/:domainToken/:playerToken",
    ADMIN_PLAYER_EDIT: "/admin/:slug/domain/:domainToken/:playerToken/edit",
    ADMIN_REVISION_EDIT: "/admin/:slug/domain/:domainToken/:playerToken/:revision/edit",
    ADMIN_PLAYER_CLONE: "/admin/:slug/domain/:domainToken/:playerToken/clone",
    // Bulk and not found
    BULK_EDIT: "/bulk",
    NOT_FOUND: "*"
};


const $51a692b93140ffe5$var$ErrorFallback = ({ error: error, resetErrorBoundary: resetErrorBoundary })=>{
    const { snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const history = (0, $kfZjc.useHistory)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        snackbarError(error.message);
        const timeout = setTimeout(()=>{
            history.push((0, $29836994947f98a9$export$807b1b70df68fbc6).PUBLISHER_HUB);
            resetErrorBoundary();
        }, 2000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        history,
        error.message
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            backgroundColor: "#f8d7da",
            color: "#721c24",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a0a5450dd7e50a49$exports))), {
                sx: {
                    fontSize: "4rem",
                    marginBottom: "16px"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h4",
                component: "h1",
                gutterBottom: true,
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body1",
                gutterBottom: true,
                children: error.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                variant: "contained",
                color: "secondary",
                onClick: resetErrorBoundary,
                sx: {
                    marginTop: "16px"
                },
                children: "Try again"
            })
        ]
    });
};
var $51a692b93140ffe5$export$2e2bcd8739ae039 = $51a692b93140ffe5$var$ErrorFallback;


/* eslint-disable @typescript-eslint/naming-convention */ var $6fb9842575b03497$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($6fb9842575b03497$var$NodeType || ($6fb9842575b03497$var$NodeType = {}));
function $6fb9842575b03497$var$isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $6fb9842575b03497$var$isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean((host === null || host === void 0 ? void 0 : host.shadowRoot) === n);
}
function $6fb9842575b03497$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $6fb9842575b03497$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $6fb9842575b03497$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $6fb9842575b03497$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $6fb9842575b03497$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $6fb9842575b03497$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $6fb9842575b03497$var$stringifyRule(rule) {
    let importStringified;
    if ($6fb9842575b03497$var$isCSSImportRule(rule)) try {
        importStringified = $6fb9842575b03497$var$stringifyStylesheet(rule.styleSheet) || $6fb9842575b03497$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($6fb9842575b03497$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $6fb9842575b03497$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $6fb9842575b03497$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $6fb9842575b03497$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $6fb9842575b03497$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $6fb9842575b03497$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        var _a;
        if (!n) return -1;
        const id = (_a = this.getMeta(n)) === null || _a === void 0 ? void 0 : _a.id;
        return id !== null && id !== void 0 ? id : -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $6fb9842575b03497$var$createMirror() {
    return new $6fb9842575b03497$var$Mirror();
}
function $6fb9842575b03497$var$maskInputValue({ element: element, maskInputOptions: maskInputOptions, tagName: tagName, type: type, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    const actualType = type && $6fb9842575b03497$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $6fb9842575b03497$var$toLowerCase(str) {
    return str.toLowerCase();
}
const $6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $6fb9842575b03497$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $6fb9842575b03497$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $6fb9842575b03497$var$toLowerCase(type) : null;
}
function $6fb9842575b03497$var$extractFileExtension(path, baseURL) {
    var _a;
    let url;
    try {
        url = new URL(path, baseURL !== null && baseURL !== void 0 ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : null;
}
let $6fb9842575b03497$var$_id = 1;
const $6fb9842575b03497$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $6fb9842575b03497$var$IGNORED_NODE = -2;
function $6fb9842575b03497$var$genId() {
    return $6fb9842575b03497$var$_id++;
}
function $6fb9842575b03497$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $6fb9842575b03497$var$toLowerCase(element.tagName);
    if ($6fb9842575b03497$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $6fb9842575b03497$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $6fb9842575b03497$var$canvasService;
let $6fb9842575b03497$var$canvasCtx;
const $6fb9842575b03497$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $6fb9842575b03497$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $6fb9842575b03497$var$URL_WWW_MATCH = /^www\..*/i;
const $6fb9842575b03497$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $6fb9842575b03497$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($6fb9842575b03497$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($6fb9842575b03497$var$URL_PROTOCOL_MATCH.test(filePath) || $6fb9842575b03497$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($6fb9842575b03497$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$6fb9842575b03497$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $6fb9842575b03497$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $6fb9842575b03497$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $6fb9842575b03497$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($6fb9842575b03497$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($6fb9842575b03497$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $6fb9842575b03497$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $6fb9842575b03497$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $6fb9842575b03497$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $6fb9842575b03497$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $6fb9842575b03497$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $6fb9842575b03497$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $6fb9842575b03497$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $6fb9842575b03497$var$absoluteToStylesheet(value, $6fb9842575b03497$var$getHref());
    else if (tagName === "object" && name === "data") return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    return value;
}
function $6fb9842575b03497$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $6fb9842575b03497$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $6fb9842575b03497$var$classMatchesRegex(node, regex, checkAncestors) {
    if (!node) return false;
    if (node.nodeType !== node.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $6fb9842575b03497$var$classMatchesRegex(node.parentNode, regex, checkAncestors);
    }
    for(let eIndex = node.classList.length; eIndex--;){
        const className = node.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $6fb9842575b03497$var$classMatchesRegex(node.parentNode, regex, checkAncestors);
}
function $6fb9842575b03497$var$needMaskingText(node, maskTextClass, maskTextSelector, checkAncestors) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest(`.${maskTextClass}`)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($6fb9842575b03497$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e) {}
    return false;
}
function $6fb9842575b03497$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $6fb9842575b03497$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $6fb9842575b03497$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, needsMask: needsMask, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $6fb9842575b03497$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $6fb9842575b03497$var$NodeType.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $6fb9842575b03497$var$NodeType.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $6fb9842575b03497$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n.TEXT_NODE:
            return $6fb9842575b03497$var$serializeTextNode(n, {
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $6fb9842575b03497$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $6fb9842575b03497$var$serializeTextNode(n, options) {
    var _a;
    const { needsMask: needsMask, maskTextFn: maskTextFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $6fb9842575b03497$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $6fb9842575b03497$var$absoluteToStylesheet(textContent, $6fb9842575b03497$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    if (!isStyle && !isScript && textContent && needsMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    return {
        type: $6fb9842575b03497$var$NodeType.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $6fb9842575b03497$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId } = options;
    const needBlock = $6fb9842575b03497$var$_isBlockedElement(n, blockClass, blockSelector);
    const tagName = $6fb9842575b03497$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (!$6fb9842575b03497$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $6fb9842575b03497$var$transformAttribute(doc, tagName, $6fb9842575b03497$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $6fb9842575b03497$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $6fb9842575b03497$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $6fb9842575b03497$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $6fb9842575b03497$var$absoluteToStylesheet(cssText, $6fb9842575b03497$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        const value = n.value;
        const checked = n.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $6fb9842575b03497$var$maskInputValue({
            element: n,
            type: $6fb9842575b03497$var$getInputType(n),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$6fb9842575b03497$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$6fb9842575b03497$var$canvasService) {
            $6fb9842575b03497$var$canvasService = doc.createElement("canvas");
            $6fb9842575b03497$var$canvasCtx = $6fb9842575b03497$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $6fb9842575b03497$var$canvasService.width = image.naturalWidth;
                $6fb9842575b03497$var$canvasService.height = image.naturalHeight;
                $6fb9842575b03497$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $6fb9842575b03497$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        const mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n.playbackRate;
        mediaAttributes.rr_mediaMuted = n.muted;
        mediaAttributes.rr_mediaLoop = n.loop;
        mediaAttributes.rr_mediaVolume = n.volume;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $6fb9842575b03497$var$NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $6fb9842575b03497$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $6fb9842575b03497$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $6fb9842575b03497$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $6fb9842575b03497$var$NodeType.Comment) return true;
    else if (sn.type === $6fb9842575b03497$var$NodeType.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $6fb9842575b03497$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "application-name" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "icon" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "robots" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "googlebot" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "author" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "generator" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "framework" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "publisher" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "progid" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $6fb9842575b03497$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { needsMask: needsMask } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    if (!needsMask && n.childNodes) {
        const checkAncestors = needsMask === undefined;
        needsMask = $6fb9842575b03497$var$needMaskingText(n, maskTextClass, maskTextSelector, checkAncestors);
    }
    const _serializedNode = $6fb9842575b03497$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($6fb9842575b03497$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $6fb9842575b03497$var$NodeType.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $6fb9842575b03497$var$IGNORED_NODE;
    else id = $6fb9842575b03497$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $6fb9842575b03497$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $6fb9842575b03497$var$NodeType.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $6fb9842575b03497$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $6fb9842575b03497$var$NodeType.Document || serializedNode.type === $6fb9842575b03497$var$NodeType.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $6fb9842575b03497$var$NodeType.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        if (serializedNode.type === $6fb9842575b03497$var$NodeType.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== undefined) ;
        else for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $6fb9842575b03497$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($6fb9842575b03497$var$isElement(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $6fb9842575b03497$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $6fb9842575b03497$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $6fb9842575b03497$var$isShadowRoot(n.parentNode) && $6fb9842575b03497$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $6fb9842575b03497$var$NodeType.Element && serializedNode.tagName === "iframe") $6fb9842575b03497$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $6fb9842575b03497$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $6fb9842575b03497$var$NodeType.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $6fb9842575b03497$var$extractFileExtension(serializedNode.attributes.href) === "css")) $6fb9842575b03497$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $6fb9842575b03497$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $6fb9842575b03497$var$snapshot(n, options) {
    const { mirror: mirror = new $6fb9842575b03497$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, maskTextClass: maskTextClass = "rr-mask", maskTextSelector: maskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $6fb9842575b03497$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $6fb9842575b03497$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $6fb9842575b03497$var$_mirror = {
    map: {},
    getId () {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $6fb9842575b03497$var$_mirror = new Proxy($6fb9842575b03497$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $6fb9842575b03497$var$throttle(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $6fb9842575b03497$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$6fb9842575b03497$var$hookSetter(target, key, original || {}, true);
}
function $6fb9842575b03497$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (_a) {
        return ()=>{};
    }
}
let $6fb9842575b03497$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $6fb9842575b03497$var$nowTimestamp = ()=>new Date().getTime();
function $6fb9842575b03497$var$getWindowScroll(win) {
    var _a, _b, _c, _d, _e, _f;
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollLeft) || ((_b = (_a = doc === null || doc === void 0 ? void 0 : doc.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || ((_c = doc === null || doc === void 0 ? void 0 : doc.body) === null || _c === void 0 ? void 0 : _c.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || ((_e = (_d = doc === null || doc === void 0 ? void 0 : doc.body) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.scrollTop) || ((_f = doc === null || doc === void 0 ? void 0 : doc.body) === null || _f === void 0 ? void 0 : _f.scrollTop) || 0
    };
}
function $6fb9842575b03497$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $6fb9842575b03497$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $6fb9842575b03497$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $6fb9842575b03497$var$isBlocked(node, blockClass, blockSelector, checkAncestors) {
    if (!node) return false;
    const el = $6fb9842575b03497$var$closestElementOfNode(node);
    if (!el) return false;
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if ($6fb9842575b03497$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $6fb9842575b03497$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $6fb9842575b03497$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $6fb9842575b03497$var$IGNORED_NODE;
}
function $6fb9842575b03497$var$isAncestorRemoved(target, mirror) {
    if ($6fb9842575b03497$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $6fb9842575b03497$var$isAncestorRemoved(target.parentNode, mirror);
}
function $6fb9842575b03497$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $6fb9842575b03497$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $6fb9842575b03497$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $6fb9842575b03497$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $6fb9842575b03497$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
class $6fb9842575b03497$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        var _a;
        return (_a = this.styleIDMap.get(stylesheet)) !== null && _a !== void 0 ? _a : -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $6fb9842575b03497$var$getShadowHost(n) {
    var _a, _b;
    let shadowHost = null;
    if (((_b = (_a = n.getRootNode) === null || _a === void 0 ? void 0 : _a.call(n)) === null || _b === void 0 ? void 0 : _b.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $6fb9842575b03497$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $6fb9842575b03497$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $6fb9842575b03497$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $6fb9842575b03497$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $6fb9842575b03497$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $6fb9842575b03497$var$shadowHostInDom(n);
}
var $6fb9842575b03497$var$EventType$1 = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($6fb9842575b03497$var$EventType$1 || {});
var $6fb9842575b03497$var$IncrementalSource$1 = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($6fb9842575b03497$var$IncrementalSource$1 || {});
var $6fb9842575b03497$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($6fb9842575b03497$var$MouseInteractions || {});
var $6fb9842575b03497$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($6fb9842575b03497$var$PointerTypes || {});
var $6fb9842575b03497$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($6fb9842575b03497$var$CanvasContext || {});
function $6fb9842575b03497$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $6fb9842575b03497$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $6fb9842575b03497$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $6fb9842575b03497$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $6fb9842575b03497$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $6fb9842575b03497$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $6fb9842575b03497$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $6fb9842575b03497$var$IGNORED_NODE;
                while(nextId === $6fb9842575b03497$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$6fb9842575b03497$var$inDom(n) || n.parentNode.tagName === "TEXTAREA") return;
                const parentId = $6fb9842575b03497$var$isShadowRoot(n.parentNode) ? this.mirror.getId($6fb9842575b03497$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $6fb9842575b03497$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($6fb9842575b03497$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($6fb9842575b03497$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($6fb9842575b03497$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($6fb9842575b03497$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$6fb9842575b03497$var$isAncestorInSet(this.droppedSet, n) && !$6fb9842575b03497$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($6fb9842575b03497$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>{
                    const n = text.node;
                    if (n.parentNode && n.parentNode.tagName === "TEXTAREA") this.genTextAreaValueMutation(n.parentNode);
                    return {
                        id: this.mirror.getId(n),
                        value: text.value
                    };
                }).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.genTextAreaValueMutation = (textarea)=>{
            let item = this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                this.attributes.push(item);
                this.attributeMap.set(textarea, item);
            }
            item.attributes.value = Array.from(textarea.childNodes, (cn)=>cn.textContent || "").join("");
        };
        this.processMutation = (m)=>{
            if ($6fb9842575b03497$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$6fb9842575b03497$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $6fb9842575b03497$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, true) && value ? this.maskTextFn ? this.maskTextFn(value, $6fb9842575b03497$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $6fb9842575b03497$var$getInputType(target);
                            value = $6fb9842575b03497$var$maskInputValue({
                                element: target,
                                maskInputOptions: this.maskInputOptions,
                                tagName: target.tagName,
                                type: type,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($6fb9842575b03497$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$6fb9842575b03497$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $6fb9842575b03497$var$transformAttribute(this.doc, $6fb9842575b03497$var$toLowerCase(target.tagName), $6fb9842575b03497$var$toLowerCase(attributeName), value);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($6fb9842575b03497$var$isBlocked(m.target, this.blockClass, this.blockSelector, true)) return;
                    if (m.target.tagName === "TEXTAREA") {
                        this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $6fb9842575b03497$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($6fb9842575b03497$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) || $6fb9842575b03497$var$isIgnored(n, this.mirror) || !$6fb9842575b03497$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $6fb9842575b03497$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($6fb9842575b03497$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$6fb9842575b03497$var$moveKey(nodeId, parentId)]) $6fb9842575b03497$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $6fb9842575b03497$var$isShadowRoot(m.target) && $6fb9842575b03497$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($6fb9842575b03497$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$6fb9842575b03497$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$6fb9842575b03497$var$isBlocked(n, this.blockClass, this.blockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($6fb9842575b03497$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $6fb9842575b03497$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$6fb9842575b03497$var$deepDelete(addsSet, childN));
}
function $6fb9842575b03497$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $6fb9842575b03497$var$_isParentRemoved(removes, n, mirror);
}
function $6fb9842575b03497$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $6fb9842575b03497$var$_isParentRemoved(removes, parentNode, mirror);
}
function $6fb9842575b03497$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $6fb9842575b03497$var$_isAncestorInSet(set, n);
}
function $6fb9842575b03497$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $6fb9842575b03497$var$_isAncestorInSet(set, parentNode);
}
let $6fb9842575b03497$var$errorHandler;
function $6fb9842575b03497$var$registerErrorHandler(handler) {
    $6fb9842575b03497$var$errorHandler = handler;
}
function $6fb9842575b03497$var$unregisterErrorHandler() {
    $6fb9842575b03497$var$errorHandler = undefined;
}
const $6fb9842575b03497$var$callbackWrapper = (cb)=>{
    if (!$6fb9842575b03497$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($6fb9842575b03497$var$errorHandler && $6fb9842575b03497$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
const $6fb9842575b03497$var$mutationBuffers = [];
function $6fb9842575b03497$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (_a) {}
    return event && event.target;
}
function $6fb9842575b03497$var$initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new $6fb9842575b03497$var$MutationBuffer();
    $6fb9842575b03497$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, "MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($6fb9842575b03497$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $6fb9842575b03497$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper((evt)=>{
        const target = $6fb9842575b03497$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $6fb9842575b03497$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $6fb9842575b03497$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $6fb9842575b03497$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $6fb9842575b03497$var$IncrementalSource$1.Drag : evt instanceof MouseEvent ? $6fb9842575b03497$var$IncrementalSource$1.MouseMove : $6fb9842575b03497$var$IncrementalSource$1.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $6fb9842575b03497$var$on("mousemove", updatePosition, doc),
        $6fb9842575b03497$var$on("touchmove", updatePosition, doc),
        $6fb9842575b03497$var$on("drag", updatePosition, doc)
    ];
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $6fb9842575b03497$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $6fb9842575b03497$var$getEventTarget(event);
            if ($6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $6fb9842575b03497$var$PointerTypes.Touch) {
                    if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $6fb9842575b03497$var$PointerTypes.Pen;
            } else if ($6fb9842575b03497$var$legacy_isTouchEvent(event)) pointerType = $6fb9842575b03497$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $6fb9842575b03497$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $6fb9842575b03497$var$PointerTypes.Mouse) pointerType = null;
            } else if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $6fb9842575b03497$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $6fb9842575b03497$var$callbackWrapper(mouseInteractionCb)(Object.assign({
                type: $6fb9842575b03497$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($6fb9842575b03497$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $6fb9842575b03497$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($6fb9842575b03497$var$MouseInteractions[eventKey]){
            case $6fb9842575b03497$var$MouseInteractions.MouseDown:
            case $6fb9842575b03497$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $6fb9842575b03497$var$MouseInteractions.TouchStart:
            case $6fb9842575b03497$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($6fb9842575b03497$var$on(eventName, handler, doc));
    });
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $6fb9842575b03497$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, sampling: sampling }) {
    const updatePosition = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper((evt)=>{
        const target = $6fb9842575b03497$var$getEventTarget(evt);
        if (!target || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $6fb9842575b03497$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $6fb9842575b03497$var$on("scroll", updatePosition, doc);
}
function $6fb9842575b03497$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(()=>{
        const height = $6fb9842575b03497$var$getWindowHeight();
        const width = $6fb9842575b03497$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $6fb9842575b03497$var$on("resize", updateDimension, win);
}
const $6fb9842575b03497$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $6fb9842575b03497$var$lastInputValueMap = new WeakMap();
function $6fb9842575b03497$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput }) {
    function eventHandler(event) {
        let target = $6fb9842575b03497$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && target.tagName;
        if (target && tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $6fb9842575b03497$var$INPUT_TAGS.indexOf(tagName) < 0 || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        let text = target.value;
        let isChecked = false;
        const type = $6fb9842575b03497$var$getInputType(target) || "";
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $6fb9842575b03497$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $6fb9842575b03497$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $6fb9842575b03497$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $6fb9842575b03497$var$callbackWrapper(inputCb)(Object.assign(Object.assign({}, v), {
                id: id
            }));
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$6fb9842575b03497$var$on(eventName, $6fb9842575b03497$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$6fb9842575b03497$var$hookSetter(p[0], p[1], {
            set () {
                $6fb9842575b03497$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $6fb9842575b03497$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($6fb9842575b03497$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $6fb9842575b03497$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $6fb9842575b03497$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $6fb9842575b03497$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $6fb9842575b03497$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $6fb9842575b03497$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$6fb9842575b03497$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$6fb9842575b03497$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $6fb9842575b03497$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    var _a, _b, _c;
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? (_a = host.defaultView) === null || _a === void 0 ? void 0 : _a.Document : (_c = (_b = host.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView) === null || _c === void 0 ? void 0 : _c.ShadowRoot;
    const originalPropertyDescriptor = (patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            var _a;
            return (_a = originalPropertyDescriptor.get) === null || _a === void 0 ? void 0 : _a.call(this);
        },
        set (sheets) {
            var _a;
            const result = (_a = originalPropertyDescriptor.set) === null || _a === void 0 ? void 0 : _a.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $6fb9842575b03497$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a;
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $6fb9842575b03497$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $6fb9842575b03497$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a;
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $6fb9842575b03497$var$getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $6fb9842575b03497$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $6fb9842575b03497$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $6fb9842575b03497$var$callbackWrapper((type)=>$6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper((event)=>{
            const target = $6fb9842575b03497$var$getEventTarget(event);
            if (!target || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate, loop: loop } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500));
    const handlers = [
        $6fb9842575b03497$var$on("play", handler(0), doc),
        $6fb9842575b03497$var$on("pause", handler(1), doc),
        $6fb9842575b03497$var$on("seeked", handler(2), doc),
        $6fb9842575b03497$var$on("volumechange", handler(3), doc),
        $6fb9842575b03497$var$on("ratechange", handler(4), doc)
    ];
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $6fb9842575b03497$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $6fb9842575b03497$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($6fb9842575b03497$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $6fb9842575b03497$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $6fb9842575b03497$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && (selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $6fb9842575b03497$var$isBlocked(startContainer, blockClass, blockSelector, true) || $6fb9842575b03497$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $6fb9842575b03497$var$on("selectionchange", updateSelection);
}
function $6fb9842575b03497$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $6fb9842575b03497$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {
                console.warn(`Custom element callback failed for ${name}`);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $6fb9842575b03497$var$mergeHooks(o, hooks) {
    const { mutationCb: mutationCb, mousemoveCb: mousemoveCb, mouseInteractionCb: mouseInteractionCb, scrollCb: scrollCb, viewportResizeCb: viewportResizeCb, inputCb: inputCb, mediaInteractionCb: mediaInteractionCb, styleSheetRuleCb: styleSheetRuleCb, styleDeclarationCb: styleDeclarationCb, canvasMutationCb: canvasMutationCb, fontCb: fontCb, selectionCb: selectionCb, customElementCb: customElementCb } = o;
    o.mutationCb = (...p)=>{
        if (hooks.mutation) hooks.mutation(...p);
        mutationCb(...p);
    };
    o.mousemoveCb = (...p)=>{
        if (hooks.mousemove) hooks.mousemove(...p);
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) hooks.mouseInteraction(...p);
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p)=>{
        if (hooks.scroll) hooks.scroll(...p);
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) hooks.viewportResize(...p);
        viewportResizeCb(...p);
    };
    o.inputCb = (...p)=>{
        if (hooks.input) hooks.input(...p);
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) hooks.mediaInteaction(...p);
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) hooks.styleSheetRule(...p);
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) hooks.styleDeclaration(...p);
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) hooks.canvasMutation(...p);
        canvasMutationCb(...p);
    };
    o.fontCb = (...p)=>{
        if (hooks.font) hooks.font(...p);
        fontCb(...p);
    };
    o.selectionCb = (...p)=>{
        if (hooks.selection) hooks.selection(...p);
        selectionCb(...p);
    };
    o.customElementCb = (...c)=>{
        if (hooks.customElement) hooks.customElement(...c);
        customElementCb(...c);
    };
}
function $6fb9842575b03497$var$initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    $6fb9842575b03497$var$mergeHooks(o, hooks);
    let mutationObserver;
    if (o.recordDOM) mutationObserver = $6fb9842575b03497$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $6fb9842575b03497$var$initMoveObserver(o);
    const mouseInteractionHandler = $6fb9842575b03497$var$initMouseInteractionObserver(o);
    const scrollHandler = $6fb9842575b03497$var$initScrollObserver(o);
    const viewportResizeHandler = $6fb9842575b03497$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $6fb9842575b03497$var$initInputObserver(o);
    const mediaInteractionHandler = $6fb9842575b03497$var$initMediaInteractionObserver(o);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o.recordDOM) {
        styleSheetObserver = $6fb9842575b03497$var$initStyleSheetObserver(o, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $6fb9842575b03497$var$initAdoptedStyleSheetObserver(o, o.doc);
        styleDeclarationObserver = $6fb9842575b03497$var$initStyleDeclarationObserver(o, {
            win: currentWindow
        });
        if (o.collectFonts) fontObserver = $6fb9842575b03497$var$initFontObserver(o);
    }
    const selectionObserver = $6fb9842575b03497$var$initSelectionObserver(o);
    const customElementObserver = $6fb9842575b03497$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $6fb9842575b03497$var$callbackWrapper(()=>{
        $6fb9842575b03497$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver === null || mutationObserver === void 0 || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $6fb9842575b03497$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $6fb9842575b03497$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $6fb9842575b03497$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $6fb9842575b03497$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $6fb9842575b03497$var$CrossOriginIframeMirror($6fb9842575b03497$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $6fb9842575b03497$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        var _a;
        switch(e.type){
            case $6fb9842575b03497$var$EventType$1.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: {
                            source: $6fb9842575b03497$var$IncrementalSource$1.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $6fb9842575b03497$var$EventType$1.Meta:
            case $6fb9842575b03497$var$EventType$1.Load:
            case $6fb9842575b03497$var$EventType$1.DomContentLoaded:
                return false;
            case $6fb9842575b03497$var$EventType$1.Plugin:
                return e;
            case $6fb9842575b03497$var$EventType$1.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $6fb9842575b03497$var$EventType$1.IncrementalSnapshot:
                switch(e.data.source){
                    case $6fb9842575b03497$var$IncrementalSource$1.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $6fb9842575b03497$var$IncrementalSource$1.Drag:
                    case $6fb9842575b03497$var$IncrementalSource$1.TouchMove:
                    case $6fb9842575b03497$var$IncrementalSource$1.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $6fb9842575b03497$var$IncrementalSource$1.ViewportResize:
                        return false;
                    case $6fb9842575b03497$var$IncrementalSource$1.MediaInteraction:
                    case $6fb9842575b03497$var$IncrementalSource$1.MouseInteraction:
                    case $6fb9842575b03497$var$IncrementalSource$1.Scroll:
                    case $6fb9842575b03497$var$IncrementalSource$1.CanvasMutation:
                    case $6fb9842575b03497$var$IncrementalSource$1.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $6fb9842575b03497$var$IncrementalSource$1.StyleSheetRule:
                    case $6fb9842575b03497$var$IncrementalSource$1.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $6fb9842575b03497$var$IncrementalSource$1.Font:
                        return e;
                    case $6fb9842575b03497$var$IncrementalSource$1.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $6fb9842575b03497$var$IncrementalSource$1.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        (_a = e.data.styles) === null || _a === void 0 || _a.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $6fb9842575b03497$var$NodeType.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $6fb9842575b03497$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$6fb9842575b03497$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $6fb9842575b03497$var$initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($6fb9842575b03497$var$initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        })));
        setTimeout(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($6fb9842575b03497$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($6fb9842575b03497$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $6fb9842575b03497$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6fb9842575b03497$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6fb9842575b03497$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $6fb9842575b03497$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $6fb9842575b03497$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $6fb9842575b03497$var$i = 0; $6fb9842575b03497$var$i < $6fb9842575b03497$var$chars.length; $6fb9842575b03497$var$i++)$6fb9842575b03497$var$lookup[$6fb9842575b03497$var$chars.charCodeAt($6fb9842575b03497$var$i)] = $6fb9842575b03497$var$i;
var $6fb9842575b03497$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $6fb9842575b03497$var$chars[bytes[i] >> 2];
        base64 += $6fb9842575b03497$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $6fb9842575b03497$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $6fb9842575b03497$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $6fb9842575b03497$var$canvasVarMap = new Map();
function $6fb9842575b03497$var$variableListFor(ctx, ctor) {
    let contextMap = $6fb9842575b03497$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $6fb9842575b03497$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $6fb9842575b03497$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($6fb9842575b03497$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $6fb9842575b03497$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $6fb9842575b03497$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$6fb9842575b03497$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $6fb9842575b03497$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $6fb9842575b03497$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $6fb9842575b03497$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($6fb9842575b03497$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $6fb9842575b03497$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $6fb9842575b03497$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$6fb9842575b03497$var$serializeArg(arg, win, ctx));
};
const $6fb9842575b03497$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $6fb9842575b03497$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $6fb9842575b03497$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$6fb9842575b03497$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(()=>{
                    const recordArgs = $6fb9842575b03497$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $6fb9842575b03497$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $6fb9842575b03497$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $6fb9842575b03497$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $6fb9842575b03497$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $6fb9842575b03497$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$6fb9842575b03497$var$isBlocked(this, blockClass, blockSelector, true)) {
                    const ctxName = $6fb9842575b03497$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $6fb9842575b03497$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = $6fb9842575b03497$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $6fb9842575b03497$var$saveWebGLVar(result, win, this);
                    if ("tagName" in this.canvas && !$6fb9842575b03497$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        const recordArgs = $6fb9842575b03497$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (_a) {
            const hookHandler = $6fb9842575b03497$var$hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $6fb9842575b03497$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, mirror) {
    const handlers = [];
    handlers.push(...$6fb9842575b03497$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $6fb9842575b03497$var$CanvasContext.WebGL, cb, blockClass, blockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$6fb9842575b03497$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $6fb9842575b03497$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $6fb9842575b03497$var$funcToSource(fn, sourcemapArg) {
    var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
    var source = fn.toString();
    var lines = source.split("\n");
    lines.pop();
    lines.shift();
    var blankPrefixLength = lines[0].search(/\S/);
    var regex = /(['"])__worker_loader_strict__(['"])/g;
    for(var i = 0, n = lines.length; i < n; ++i)lines[i] = lines[i].substring(blankPrefixLength).replace(regex, "$1use strict$2") + "\n";
    if (sourcemap) lines.push("//# sourceMappingURL=" + sourcemap + "\n");
    return lines;
}
function $6fb9842575b03497$var$createURL(fn, sourcemapArg) {
    var lines = $6fb9842575b03497$var$funcToSource(fn, sourcemapArg);
    var blob = new Blob(lines, {
        type: "application/javascript"
    });
    return URL.createObjectURL(blob);
}
function $6fb9842575b03497$var$createInlineWorkerFactory(fn, sourcemapArg) {
    var url;
    return function WorkerFactory(options) {
        url = url || $6fb9842575b03497$var$createURL(fn, sourcemapArg);
        return new Worker(url, options);
    };
}
var $6fb9842575b03497$var$WorkerFactory = $6fb9842575b03497$var$createInlineWorkerFactory(/* rollup-plugin-web-worker-loader */ function() {
    (function() {
        "__worker_loader_strict__";
        /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function __awaiter(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        }
        /*
     * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        // Use a lookup table to find the index.
        var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
        var encode = function(arraybuffer) {
            var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
            for(i = 0; i < len; i += 3){
                base64 += chars[bytes[i] >> 2];
                base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                base64 += chars[bytes[i + 2] & 63];
            }
            if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
            else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
            return base64;
        };
        const lastBlobMap = new Map();
        const transparentBlobMap = new Map();
        function getTransparentBlobFor(width, height, dataURLOptions) {
            return __awaiter(this, void 0, void 0, function*() {
                const id = `${width}-${height}`;
                if ("OffscreenCanvas" in globalThis) {
                    if (transparentBlobMap.has(id)) return transparentBlobMap.get(id);
                    const offscreen = new OffscreenCanvas(width, height);
                    offscreen.getContext("2d");
                    const blob = yield offscreen.convertToBlob(dataURLOptions);
                    const arrayBuffer = yield blob.arrayBuffer();
                    const base64 = encode(arrayBuffer);
                    transparentBlobMap.set(id, base64);
                    return base64;
                } else return "";
            });
        }
        const worker = self;
        worker.onmessage = function(e) {
            return __awaiter(this, void 0, void 0, function*() {
                if ("OffscreenCanvas" in globalThis) {
                    const { id: id, bitmap: bitmap, width: width, height: height, dataURLOptions: dataURLOptions } = e.data;
                    const transparentBase64 = getTransparentBlobFor(width, height, dataURLOptions);
                    const offscreen = new OffscreenCanvas(width, height);
                    const ctx = offscreen.getContext("2d");
                    ctx.drawImage(bitmap, 0, 0);
                    bitmap.close();
                    const blob = yield offscreen.convertToBlob(dataURLOptions);
                    const type = blob.type;
                    const arrayBuffer = yield blob.arrayBuffer();
                    const base64 = encode(arrayBuffer);
                    if (!lastBlobMap.has(id) && (yield transparentBase64) === base64) {
                        lastBlobMap.set(id, base64);
                        return worker.postMessage({
                            id: id
                        });
                    }
                    if (lastBlobMap.get(id) === base64) return worker.postMessage({
                        id: id
                    });
                    worker.postMessage({
                        id: id,
                        type: type,
                        base64: base64,
                        width: width,
                        height: height
                    });
                    lastBlobMap.set(id, base64);
                } else return worker.postMessage({
                    id: e.data.id
                });
            });
        };
    })();
}, null);
class $6fb9842575b03497$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling: sampling = "all", win: win, blockClass: blockClass, blockSelector: blockSelector, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        const canvasContextReset = $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        const snapshotInProgressMap = new Map();
        const worker = new $6fb9842575b03497$var$WorkerFactory();
        worker.onmessage = (e)=>{
            const { id: id } = e.data;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e.data)) return;
            const { base64: base64, type: type, width: width, height: height } = e.data;
            this.mutationCb({
                id: id,
                type: $6fb9842575b03497$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = ()=>{
            const matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach((canvas)=>{
                if (!$6fb9842575b03497$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas().forEach((canvas)=>$6fb9842575b03497$var$__awaiter(this, void 0, void 0, function*() {
                    var _a;
                    const id = this.mirror.getId(canvas);
                    if (snapshotInProgressMap.get(id)) return;
                    if (canvas.width === 0 || canvas.height === 0) return;
                    snapshotInProgressMap.set(id, true);
                    if ([
                        "webgl",
                        "webgl2"
                    ].includes(canvas.__context)) {
                        const context = canvas.getContext(canvas.__context);
                        if (((_a = context === null || context === void 0 ? void 0 : context.getContextAttributes()) === null || _a === void 0 ? void 0 : _a.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                    }
                    const bitmap = yield createImageBitmap(canvas);
                    worker.postMessage({
                        id: id,
                        bitmap: bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions: options.dataURLOptions
                    }, [
                        bitmap
                    ]);
                }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        const canvas2DReset = $6fb9842575b03497$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        const canvasWebGL1and2Reset = $6fb9842575b03497$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const rest = $6fb9842575b03497$var$__rest(value, [
                "type"
            ]);
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
class $6fb9842575b03497$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $6fb9842575b03497$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $6fb9842575b03497$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $6fb9842575b03497$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        requestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
function $6fb9842575b03497$var$wrapEvent(e) {
    return Object.assign(Object.assign({}, e), {
        timestamp: $6fb9842575b03497$var$nowTimestamp()
    });
}
let $6fb9842575b03497$var$wrappedEmit;
let $6fb9842575b03497$var$takeFullSnapshot;
let $6fb9842575b03497$var$canvasManager;
let $6fb9842575b03497$var$recording = false;
const $6fb9842575b03497$var$mirror = $6fb9842575b03497$var$createMirror();
function $6fb9842575b03497$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskTextClass: maskTextClass = "rr-mask", maskTextSelector: maskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn: maskInputFn, maskTextFn: maskTextFn, hooks: hooks, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler } = options;
    $6fb9842575b03497$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $6fb9842575b03497$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {
        password: true
    };
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $6fb9842575b03497$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $6fb9842575b03497$var$wrappedEmit = (e, isCheckout)=>{
        var _a;
        if (((_a = $6fb9842575b03497$var$mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== $6fb9842575b03497$var$EventType$1.FullSnapshot && !(e.type === $6fb9842575b03497$var$EventType$1.IncrementalSnapshot && e.data.source === $6fb9842575b03497$var$IncrementalSource$1.Mutation)) $6fb9842575b03497$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit === null || emit === void 0 || emit(eventProcessor(e), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $6fb9842575b03497$var$EventType$1.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $6fb9842575b03497$var$EventType$1.IncrementalSnapshot) {
            if (e.data.source === $6fb9842575b03497$var$IncrementalSource$1.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $6fb9842575b03497$var$takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
            type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6fb9842575b03497$var$IncrementalSource$1.Mutation
            }, m)
        }));
    };
    const wrappedScrollEmit = (p)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
            type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6fb9842575b03497$var$IncrementalSource$1.Scroll
            }, p)
        }));
    const wrappedCanvasMutationEmit = (p)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
            type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6fb9842575b03497$var$IncrementalSource$1.CanvasMutation
            }, p)
        }));
    const wrappedAdoptedStyleSheetEmit = (a)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
            type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6fb9842575b03497$var$IncrementalSource$1.AdoptedStyleSheet
            }, a)
        }));
    const stylesheetManager = new $6fb9842575b03497$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = new $6fb9842575b03497$var$IframeManager({
        mirror: $6fb9842575b03497$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $6fb9842575b03497$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $6fb9842575b03497$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $6fb9842575b03497$var$ProcessedNodeManager();
    $6fb9842575b03497$var$canvasManager = new $6fb9842575b03497$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $6fb9842575b03497$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    const shadowDomManager = new $6fb9842575b03497$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $6fb9842575b03497$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $6fb9842575b03497$var$mirror
    });
    $6fb9842575b03497$var$takeFullSnapshot = (isCheckout = false)=>{
        if (!recordDOM) return;
        $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
            type: $6fb9842575b03497$var$EventType$1.Meta,
            data: {
                href: window.location.href,
                width: $6fb9842575b03497$var$getWindowWidth(),
                height: $6fb9842575b03497$var$getWindowHeight()
            }
        }), isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $6fb9842575b03497$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $6fb9842575b03497$var$snapshot(document, {
            mirror: $6fb9842575b03497$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($6fb9842575b03497$var$isSerializedIframe(n, $6fb9842575b03497$var$mirror)) iframeManager.addIframe(n);
                if ($6fb9842575b03497$var$isSerializedStylesheet(n, $6fb9842575b03497$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($6fb9842575b03497$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
            type: $6fb9842575b03497$var$EventType$1.FullSnapshot,
            data: {
                node: node,
                initialOffset: $6fb9842575b03497$var$getWindowScroll(window)
            }
        }), isCheckout);
        $6fb9842575b03497$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $6fb9842575b03497$var$mirror.getId(document));
    };
    try {
        const handlers = [];
        const observe = (doc)=>{
            var _a;
            return $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.MouseInteraction
                        }, d)
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.ViewportResize
                        }, d)
                    })),
                inputCb: (v)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.Input
                        }, v)
                    })),
                mediaInteractionCb: (p)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.MediaInteraction
                        }, p)
                    })),
                styleSheetRuleCb: (r)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.StyleSheetRule
                        }, r)
                    })),
                styleDeclarationCb: (r)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.StyleDeclaration
                        }, r)
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.Font
                        }, p)
                    })),
                selectionCb: (p)=>{
                    $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.Selection
                        }, p)
                    }));
                },
                customElementCb: (c)=>{
                    $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                        type: $6fb9842575b03497$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6fb9842575b03497$var$IncrementalSource$1.CustomElement
                        }, c)
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $6fb9842575b03497$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $6fb9842575b03497$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p)=>p.observer)) === null || _a === void 0 ? void 0 : _a.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                                type: $6fb9842575b03497$var$EventType$1.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }))
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            $6fb9842575b03497$var$takeFullSnapshot();
            handlers.push(observe(document));
            $6fb9842575b03497$var$recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($6fb9842575b03497$var$on("DOMContentLoaded", ()=>{
                $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                    type: $6fb9842575b03497$var$EventType$1.DomContentLoaded,
                    data: {}
                }));
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($6fb9842575b03497$var$on("load", ()=>{
                $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
                    type: $6fb9842575b03497$var$EventType$1.Load,
                    data: {}
                }));
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $6fb9842575b03497$var$recording = false;
            $6fb9842575b03497$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$6fb9842575b03497$var$record.addCustomEvent = (tag, payload)=>{
    if (!$6fb9842575b03497$var$recording) throw new Error("please add custom event after start recording");
    $6fb9842575b03497$var$wrappedEmit($6fb9842575b03497$var$wrapEvent({
        type: $6fb9842575b03497$var$EventType$1.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$6fb9842575b03497$var$record.freezePage = ()=>{
    $6fb9842575b03497$var$mutationBuffers.forEach((buf)=>buf.freeze());
};
$6fb9842575b03497$var$record.takeFullSnapshot = (isCheckout)=>{
    if (!$6fb9842575b03497$var$recording) throw new Error("please take full snapshot after start recording");
    $6fb9842575b03497$var$takeFullSnapshot(isCheckout);
};
$6fb9842575b03497$var$record.mirror = $6fb9842575b03497$var$mirror;
var $6fb9842575b03497$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($6fb9842575b03497$var$EventType || {});
var $6fb9842575b03497$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($6fb9842575b03497$var$IncrementalSource || {});
var $6fb9842575b03497$var$Config = {
    DEBUG: false,
    LIB_VERSION: "2.55.0"
};
/* eslint camelcase: "off", eqeqeq: "off" */ // since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $6fb9842575b03497$var$win;
if (typeof window === "undefined") {
    var $6fb9842575b03497$var$loc = {
        hostname: ""
    };
    $6fb9842575b03497$var$win = {
        navigator: {
            userAgent: ""
        },
        document: {
            location: $6fb9842575b03497$var$loc,
            referrer: ""
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $6fb9842575b03497$var$loc
    };
} else $6fb9842575b03497$var$win = window;
// Maximum allowed session recording length
var $6fb9842575b03497$var$MAX_RECORDING_MS = 86400000; // 24 hours
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $6fb9842575b03497$var$ArrayProto = Array.prototype, $6fb9842575b03497$var$FuncProto = Function.prototype, $6fb9842575b03497$var$ObjProto = Object.prototype, $6fb9842575b03497$var$slice = $6fb9842575b03497$var$ArrayProto.slice, $6fb9842575b03497$var$toString = $6fb9842575b03497$var$ObjProto.toString, $6fb9842575b03497$var$hasOwnProperty = $6fb9842575b03497$var$ObjProto.hasOwnProperty, $6fb9842575b03497$var$windowConsole = $6fb9842575b03497$var$win.console, $6fb9842575b03497$var$navigator = $6fb9842575b03497$var$win.navigator, $6fb9842575b03497$var$document$1 = $6fb9842575b03497$var$win.document, $6fb9842575b03497$var$windowOpera = $6fb9842575b03497$var$win.opera, $6fb9842575b03497$var$screen = $6fb9842575b03497$var$win.screen, $6fb9842575b03497$var$userAgent = $6fb9842575b03497$var$navigator.userAgent;
var $6fb9842575b03497$var$nativeBind = $6fb9842575b03497$var$FuncProto.bind, $6fb9842575b03497$var$nativeForEach = $6fb9842575b03497$var$ArrayProto.forEach, $6fb9842575b03497$var$nativeIndexOf = $6fb9842575b03497$var$ArrayProto.indexOf, $6fb9842575b03497$var$nativeMap = $6fb9842575b03497$var$ArrayProto.map, $6fb9842575b03497$var$nativeIsArray = Array.isArray, $6fb9842575b03497$var$breaker = {};
var $6fb9842575b03497$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
};
// Console override
var $6fb9842575b03497$var$console$1 = {
    /** @type {function(...*)} */ log: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) try {
            $6fb9842575b03497$var$windowConsole.log.apply($6fb9842575b03497$var$windowConsole, arguments);
        } catch (err) {
            $6fb9842575b03497$var$_.each(arguments, function(arg) {
                $6fb9842575b03497$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                "Mixpanel warning:"
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.warn.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.error.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.error.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $6fb9842575b03497$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = "[" + prefix + "] " + arguments[0];
        return func.apply($6fb9842575b03497$var$console$1, arguments);
    };
};
var $6fb9842575b03497$var$console_with_prefix = function(prefix) {
    return {
        log: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.log, prefix),
        error: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.error, prefix),
        critical: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$6fb9842575b03497$var$_.bind = function(func, context) {
    var args, bound;
    if ($6fb9842575b03497$var$nativeBind && func.bind === $6fb9842575b03497$var$nativeBind) return $6fb9842575b03497$var$nativeBind.apply(func, $6fb9842575b03497$var$slice.call(arguments, 1));
    if (!$6fb9842575b03497$var$_.isFunction(func)) throw new TypeError();
    args = $6fb9842575b03497$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($6fb9842575b03497$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self1 = new ctor();
        ctor.prototype = null;
        var result = func.apply(self1, args.concat($6fb9842575b03497$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self1;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $6fb9842575b03497$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($6fb9842575b03497$var$nativeForEach && obj.forEach === $6fb9842575b03497$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $6fb9842575b03497$var$breaker) return;
    }
    else {
        for(var key in obj)if ($6fb9842575b03497$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $6fb9842575b03497$var$breaker) return;
        }
    }
};
$6fb9842575b03497$var$_.extend = function(obj) {
    $6fb9842575b03497$var$_.each($6fb9842575b03497$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$6fb9842575b03497$var$_.isArray = $6fb9842575b03497$var$nativeIsArray || function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) === "[object Array]";
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$6fb9842575b03497$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$6fb9842575b03497$var$_.isArguments = function(obj) {
    return !!(obj && $6fb9842575b03497$var$hasOwnProperty.call(obj, "callee"));
};
$6fb9842575b03497$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($6fb9842575b03497$var$_.isArray(iterable)) return $6fb9842575b03497$var$slice.call(iterable);
    if ($6fb9842575b03497$var$_.isArguments(iterable)) return $6fb9842575b03497$var$slice.call(iterable);
    return $6fb9842575b03497$var$_.values(iterable);
};
$6fb9842575b03497$var$_.map = function(arr, callback, context) {
    if ($6fb9842575b03497$var$nativeMap && arr.map === $6fb9842575b03497$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $6fb9842575b03497$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$6fb9842575b03497$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6fb9842575b03497$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$6fb9842575b03497$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6fb9842575b03497$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$6fb9842575b03497$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($6fb9842575b03497$var$nativeIndexOf && obj.indexOf === $6fb9842575b03497$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $6fb9842575b03497$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $6fb9842575b03497$var$breaker;
    });
    return found;
};
$6fb9842575b03497$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$6fb9842575b03497$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$6fb9842575b03497$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$6fb9842575b03497$var$_.isArray(obj);
};
$6fb9842575b03497$var$_.isEmptyObject = function(obj) {
    if ($6fb9842575b03497$var$_.isObject(obj)) {
        for(var key in obj){
            if ($6fb9842575b03497$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$6fb9842575b03497$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$6fb9842575b03497$var$_.isString = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == "[object String]";
};
$6fb9842575b03497$var$_.isDate = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == "[object Date]";
};
$6fb9842575b03497$var$_.isNumber = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == "[object Number]";
};
$6fb9842575b03497$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$6fb9842575b03497$var$_.encodeDates = function(obj) {
    $6fb9842575b03497$var$_.each(obj, function(v, k) {
        if ($6fb9842575b03497$var$_.isDate(v)) obj[k] = $6fb9842575b03497$var$_.formatDate(v);
        else if ($6fb9842575b03497$var$_.isObject(v)) obj[k] = $6fb9842575b03497$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$6fb9842575b03497$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$6fb9842575b03497$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? "0" + n : n;
    }
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds());
};
$6fb9842575b03497$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $6fb9842575b03497$var$_.each(p, function(v, k) {
        if ($6fb9842575b03497$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $6fb9842575b03497$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === "string") ret = obj.slice(0, length);
    else if ($6fb9842575b03497$var$_.isArray(obj)) {
        ret = [];
        $6fb9842575b03497$var$_.each(obj, function(val) {
            ret.push($6fb9842575b03497$var$_.truncate(val, length));
        });
    } else if ($6fb9842575b03497$var$_.isObject(obj)) {
        ret = {};
        $6fb9842575b03497$var$_.each(obj, function(val, key) {
            ret[key] = $6fb9842575b03497$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$6fb9842575b03497$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                "\b": "\\b",
                "	": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = "";
            var indent = "    ";
            var i = 0; // The loop counter.
            var k = ""; // The member key.
            var v = ""; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case "string":
                    return quote(value);
                case "number":
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : "null";
                case "boolean":
                case "null":
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case "object":
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return "null";
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($6fb9842575b03497$var$toString.apply(value) === "[object Array]") {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($6fb9842575b03497$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? "{}" : gap ? "{" + partial.join(",") + "" + mind + "}" : "{" + partial.join(",") + "}";
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $6fb9842575b03497$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        "b": "\b",
        "f": "\f",
        "n": "\n",
        "r": "\r",
        "t": "	"
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === "\\") {
                next();
                if (ch === "u") {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === "string") string += escapee[ch];
                else break;
            } else string += ch;
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        return result;
    };
}();
$6fb9842575b03497$var$_.base64Encode = function(data) {
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
    if (!data) return data;
    data = $6fb9842575b03497$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join("");
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + "==";
            break;
        case 2:
            enc = enc.slice(0, -1) + "=";
            break;
    }
    return enc;
};
$6fb9842575b03497$var$_.utf8Encode = function(string) {
    string = (string + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var utftext = "", start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$6fb9842575b03497$var$_.UUID = function() {
    // Time-based entropy
    var T = function() {
        var time = 1 * new Date(); // cross-browser version of Date.now()
        var ticks;
        if ($6fb9842575b03497$var$win.performance && $6fb9842575b03497$var$win.performance.now) ticks = $6fb9842575b03497$var$win.performance.now();
        else {
            // fall back to busy loop
            ticks = 0;
            // this while loop figures how many browser ticks go by
            // before 1*new Date() returns a new number, ie the amount
            // of ticks that go by per millisecond
            while(time == 1 * new Date())ticks++;
        }
        return time.toString(16) + Math.floor(ticks).toString(16);
    };
    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace(".", "");
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = $6fb9842575b03497$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($6fb9842575b03497$var$screen.height * $6fb9842575b03497$var$screen.width).toString(16);
        return T() + "-" + R() + "-" + UA() + "-" + se + "-" + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $6fb9842575b03497$var$BLOCKED_UA_STRS = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "facebookexternal",
    "petalbot",
    "pinterest",
    "screaming frog",
    "yahoo! slurp",
    "yandexbot",
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
];
$6fb9842575b03497$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $6fb9842575b03497$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($6fb9842575b03497$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $6fb9842575b03497$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($6fb9842575b03497$var$_.isUndefined(arg_separator)) arg_separator = "&";
    $6fb9842575b03497$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + "=" + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$6fb9842575b03497$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + param + "=([^&#]*)", regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== "string" && results[1].length) return "";
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $6fb9842575b03497$var$console$1.error("Skipping decoding for malformed query param: " + result);
        }
        return result.replace(/\+/g, " ");
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$6fb9842575b03497$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + "=";
        var ca = $6fb9842575b03497$var$document$1.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $6fb9842575b03497$var$_.JSONDecode($6fb9842575b03497$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6fb9842575b03497$var$extract_domain($6fb9842575b03497$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        $6fb9842575b03497$var$document$1.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6fb9842575b03497$var$extract_domain($6fb9842575b03497$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        var new_cookie_val = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
        $6fb9842575b03497$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $6fb9842575b03497$var$_.cookie.set(name, "", -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $6fb9842575b03497$var$_localStorageSupported = null;
var $6fb9842575b03497$var$localStorageSupported = function(storage, forceCheck) {
    if ($6fb9842575b03497$var$_localStorageSupported !== null && !forceCheck) return $6fb9842575b03497$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = "__mplss_" + $6fb9842575b03497$var$cheap_guid(8), val = "xyz";
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $6fb9842575b03497$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$6fb9842575b03497$var$_.localStorage = {
    is_supported: function(force_check) {
        var supported = $6fb9842575b03497$var$localStorageSupported(null, force_check);
        if (!supported) $6fb9842575b03497$var$console$1.error("localStorage unsupported; falling back to cookie store");
        return supported;
    },
    error: function(msg) {
        $6fb9842575b03497$var$console$1.error("localStorage error: " + msg);
    },
    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            $6fb9842575b03497$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function(name) {
        try {
            return $6fb9842575b03497$var$_.JSONDecode($6fb9842575b03497$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            $6fb9842575b03497$var$_.localStorage.error(err);
        }
    },
    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            $6fb9842575b03497$var$_.localStorage.error(err);
        }
    }
};
$6fb9842575b03497$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $6fb9842575b03497$var$console$1.error("No valid element provided to register_event");
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = "on" + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($6fb9842575b03497$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $6fb9842575b03497$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$6fb9842575b03497$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName("*");
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = " " + selector + " ";
        return (" " + elem.className + " ").replace(bad_whitespace, " ").indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$6fb9842575b03497$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(" ");
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $6fb9842575b03497$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, "").replace(/\s+$/, "");
            if (token.indexOf("#") > -1) {
                // Token is an ID selector
                bits = token.split("#");
                tagName = bits[0];
                var id = bits[1];
                var element = $6fb9842575b03497$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf(".") > -1) {
                // Token contains a class selector
                bits = token.split(".");
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = "*";
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $6fb9842575b03497$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($6fb9842575b03497$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = "*";
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case "=":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case "~":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("\\b" + attrValue + "\\b"));
                        };
                        break;
                    case "|":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("^" + attrValue + "-?"));
                        };
                        break;
                    case "^":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case "$":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case "*":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($6fb9842575b03497$var$_.isElement(query)) return [
            query
        ];
        else if ($6fb9842575b03497$var$_.isObject(query) && !$6fb9842575b03497$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $6fb9842575b03497$var$CAMPAIGN_KEYWORDS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term"
];
var $6fb9842575b03497$var$CLICK_IDS = [
    "dclid",
    "fbclid",
    "gclid",
    "ko_click_id",
    "li_fat_id",
    "msclkid",
    "ttclid",
    "twclid",
    "wbraid"
];
$6fb9842575b03497$var$_.info = {
    campaignParams: function(default_value) {
        var kw = "", params = {};
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $6fb9842575b03497$var$_.getQueryParam($6fb9842575b03497$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = "", params = {};
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CLICK_IDS, function(idkey) {
            id = $6fb9842575b03497$var$_.getQueryParam($6fb9842575b03497$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.info.campaignParams(), $6fb9842575b03497$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search("https?://(.*)google.([^/?]*)") === 0) return "google";
        else if (referrer.search("https?://(.*)bing.com") === 0) return "bing";
        else if (referrer.search("https?://(.*)yahoo.com") === 0) return "yahoo";
        else if (referrer.search("https?://(.*)duckduckgo.com") === 0) return "duckduckgo";
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $6fb9842575b03497$var$_.info.searchEngine(referrer), param = search != "yahoo" ? "q" : "p", ret = {};
        if (search !== null) {
            ret["$search_engine"] = search;
            var keyword = $6fb9842575b03497$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret["mp_keyword"] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ""; // vendor is undefined for at least IE9
        if (opera || $6fb9842575b03497$var$_.includes(user_agent, " OPR/")) {
            if ($6fb9842575b03497$var$_.includes(user_agent, "Mini")) return "Opera Mini";
            return "Opera";
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "IEMobile") || $6fb9842575b03497$var$_.includes(user_agent, "WPDesktop")) return "Internet Explorer Mobile";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "SamsungBrowser/")) // https://developer.samsung.com/internet/user-agent-string-format
        return "Samsung Internet";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "Edge") || $6fb9842575b03497$var$_.includes(user_agent, "Edg/")) return "Microsoft Edge";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "FBIOS")) return "Facebook Mobile";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "Chrome")) return "Chrome";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "CriOS")) return "Chrome iOS";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "UCWEB") || $6fb9842575b03497$var$_.includes(user_agent, "UCBrowser")) return "UC Browser";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "FxiOS")) return "Firefox iOS";
        else if ($6fb9842575b03497$var$_.includes(vendor, "Apple")) {
            if ($6fb9842575b03497$var$_.includes(user_agent, "Mobile")) return "Mobile Safari";
            return "Safari";
        } else if ($6fb9842575b03497$var$_.includes(user_agent, "Android")) return "Android Mobile";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "Konqueror")) return "Konqueror";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "Firefox")) return "Firefox";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "MSIE") || $6fb9842575b03497$var$_.includes(user_agent, "Trident/")) return "Internet Explorer";
        else if ($6fb9842575b03497$var$_.includes(user_agent, "Gecko")) return "Mozilla";
        else return "";
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $6fb9842575b03497$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
            "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
            "Chrome": /Chrome\/(\d+(\.\d+)?)/,
            "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
            "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            "Safari": /Version\/(\d+(\.\d+)?)/,
            "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
            "Opera": /(Opera|OPR)\/(\d+(\.\d+)?)/,
            "Firefox": /Firefox\/(\d+(\.\d+)?)/,
            "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
            "Konqueror": /Konqueror:(\d+(\.\d+)?)/,
            "BlackBerry": /BlackBerry (\d+(\.\d+)?)/,
            "Android Mobile": /android\s(\d+(\.\d+)?)/,
            "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
            "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
            "Mozilla": /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $6fb9842575b03497$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return "Windows Phone";
            return "Windows";
        } else if (/(iPhone|iPad|iPod)/.test(a)) return "iOS";
        else if (/Android/.test(a)) return "Android";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return "BlackBerry";
        else if (/Mac/i.test(a)) return "Mac OS X";
        else if (/Linux/.test(a)) return "Linux";
        else if (/CrOS/.test(a)) return "Chrome OS";
        else return "";
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return "Windows Phone";
        else if (/iPad/.test(user_agent)) return "iPad";
        else if (/iPod/.test(user_agent)) return "iPod Touch";
        else if (/iPhone/.test(user_agent)) return "iPhone";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if (/Android/.test(user_agent)) return "Android";
        else return "";
    },
    referringDomain: function(referrer) {
        var split = referrer.split("/");
        if (split.length >= 3) return split[2];
        return "";
    },
    currentUrl: function() {
        return $6fb9842575b03497$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== "object") extra_props = {};
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.strip_empty_properties({
            "$os": $6fb9842575b03497$var$_.info.os(),
            "$browser": $6fb9842575b03497$var$_.info.browser($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera),
            "$referrer": $6fb9842575b03497$var$document$1.referrer,
            "$referring_domain": $6fb9842575b03497$var$_.info.referringDomain($6fb9842575b03497$var$document$1.referrer),
            "$device": $6fb9842575b03497$var$_.info.device($6fb9842575b03497$var$userAgent)
        }), {
            "$current_url": $6fb9842575b03497$var$_.info.currentUrl(),
            "$browser_version": $6fb9842575b03497$var$_.info.browserVersion($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera),
            "$screen_height": $6fb9842575b03497$var$screen.height,
            "$screen_width": $6fb9842575b03497$var$screen.width,
            "mp_lib": "web",
            "$lib_version": $6fb9842575b03497$var$Config.LIB_VERSION,
            "$insert_id": $6fb9842575b03497$var$cheap_guid(),
            "time": $6fb9842575b03497$var$_.timestamp() / 1000 // epoch time in seconds
        }, $6fb9842575b03497$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.strip_empty_properties({
            "$os": $6fb9842575b03497$var$_.info.os(),
            "$browser": $6fb9842575b03497$var$_.info.browser($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera)
        }), {
            "$browser_version": $6fb9842575b03497$var$_.info.browserVersion($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $6fb9842575b03497$var$_.strip_empty_properties({
            "current_page_title": $6fb9842575b03497$var$document$1.title,
            "current_domain": $6fb9842575b03497$var$win.location.hostname,
            "current_url_path": $6fb9842575b03497$var$win.location.pathname,
            "current_url_protocol": $6fb9842575b03497$var$win.location.protocol,
            "current_url_search": $6fb9842575b03497$var$win.location.search
        });
    }
};
var $6fb9842575b03497$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $6fb9842575b03497$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $6fb9842575b03497$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $6fb9842575b03497$var$extract_domain = function(hostname) {
    var domain_regex = $6fb9842575b03497$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split(".");
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === "com" || tld === "org") domain_regex = $6fb9842575b03497$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : "";
};
var $6fb9842575b03497$var$JSONStringify = null, $6fb9842575b03497$var$JSONParse = null;
if (typeof JSON !== "undefined") {
    $6fb9842575b03497$var$JSONStringify = JSON.stringify;
    $6fb9842575b03497$var$JSONParse = JSON.parse;
}
$6fb9842575b03497$var$JSONStringify = $6fb9842575b03497$var$JSONStringify || $6fb9842575b03497$var$_.JSONEncode;
$6fb9842575b03497$var$JSONParse = $6fb9842575b03497$var$JSONParse || $6fb9842575b03497$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$6fb9842575b03497$var$_["toArray"] = $6fb9842575b03497$var$_.toArray;
$6fb9842575b03497$var$_["isObject"] = $6fb9842575b03497$var$_.isObject;
$6fb9842575b03497$var$_["JSONEncode"] = $6fb9842575b03497$var$_.JSONEncode;
$6fb9842575b03497$var$_["JSONDecode"] = $6fb9842575b03497$var$_.JSONDecode;
$6fb9842575b03497$var$_["isBlockedUA"] = $6fb9842575b03497$var$_.isBlockedUA;
$6fb9842575b03497$var$_["isEmptyObject"] = $6fb9842575b03497$var$_.isEmptyObject;
$6fb9842575b03497$var$_["info"] = $6fb9842575b03497$var$_.info;
$6fb9842575b03497$var$_["info"]["device"] = $6fb9842575b03497$var$_.info.device;
$6fb9842575b03497$var$_["info"]["browser"] = $6fb9842575b03497$var$_.info.browser;
$6fb9842575b03497$var$_["info"]["browserVersion"] = $6fb9842575b03497$var$_.info.browserVersion;
$6fb9842575b03497$var$_["info"]["properties"] = $6fb9842575b03497$var$_.info.properties;
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $6fb9842575b03497$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = "__mp_opt_in_out_";
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$optIn(token, options) {
    $6fb9842575b03497$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $6fb9842575b03497$var$optOut(token, options) {
    $6fb9842575b03497$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $6fb9842575b03497$var$hasOptedIn(token, options) {
    return $6fb9842575b03497$var$_getStorageValue(token, options) === "1";
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $6fb9842575b03497$var$hasOptedOut(token, options) {
    if ($6fb9842575b03497$var$_hasDoNotTrackFlagOn(options)) {
        $6fb9842575b03497$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $6fb9842575b03497$var$_getStorageValue(token, options) === "0";
    if (optedOut) $6fb9842575b03497$var$console$1.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.");
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelLib(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$clearOptInOut(token, options) {
    options = options || {};
    $6fb9842575b03497$var$_getStorage(options).remove($6fb9842575b03497$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $6fb9842575b03497$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === "localStorage" ? $6fb9842575b03497$var$_.localStorage : $6fb9842575b03497$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $6fb9842575b03497$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $6fb9842575b03497$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $6fb9842575b03497$var$_getStorageValue(token, options) {
    return $6fb9842575b03497$var$_getStorage(options).get($6fb9842575b03497$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $6fb9842575b03497$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $6fb9842575b03497$var$win;
    var nav = win$1["navigator"] || {};
    var hasDntOn = false;
    $6fb9842575b03497$var$_.each([
        nav["doNotTrack"],
        nav["msDoNotTrack"],
        win$1["doNotTrack"]
    ], function(dntValue) {
        if ($6fb9842575b03497$var$_.includes([
            true,
            1,
            "1",
            "yes"
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$_optInOut(optValue, token, options) {
    if (!$6fb9842575b03497$var$_.isString(token) || !token.length) {
        $6fb9842575b03497$var$console$1.error("gdpr." + (optValue ? "optIn" : "optOut") + " called with an invalid token");
        return;
    }
    options = options || {};
    $6fb9842575b03497$var$_getStorage(options).set($6fb9842575b03497$var$_getStorageKey(token, options), optValue ? 1 : 0, $6fb9842575b03497$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || "$opt_in", options.trackProperties, {
        "send_immediately": true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, "token");
            var ignoreDnt = getConfigValue.call(this, "ignore_dnt");
            var persistenceType = getConfigValue.call(this, "opt_out_tracking_persistence_type");
            var persistencePrefix = getConfigValue.call(this, "opt_out_tracking_cookie_prefix");
            var win = getConfigValue.call(this, "window"); // used to override window during browser tests
            if (token) optedOut = $6fb9842575b03497$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $6fb9842575b03497$var$console$1.error("Unexpected error when checking tracking opt-out status: " + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === "function") callback(0);
        return;
    };
}
var $6fb9842575b03497$var$logger$3 = $6fb9842575b03497$var$console_with_prefix("lock");
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $6fb9842575b03497$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$6fb9842575b03497$var$SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== "function") {
        pid = errorCB;
        errorCB = null;
    }
    var i = pid || new Date().getTime() + "|" + Math.random();
    var startTime = new Date().getTime();
    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;
    var keyX = key + ":X";
    var keyY = key + ":Y";
    var keyZ = key + ":Z";
    var reportError = function(err) {
        errorCB && errorCB(err);
    };
    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            $6fb9842575b03497$var$logger$3.error("Timeout waiting for mutex on " + key + "; clearing lock. [" + i + "]");
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch (err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };
    var waitFor = function(predicate, cb) {
        if (predicate()) cb();
        else delay(function() {
            waitFor(predicate, cb);
        });
    };
    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) return false;
        else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) return true;
            else {
                if (!$6fb9842575b03497$var$localStorageSupported(storage, true)) throw new Error("localStorage support dropped while acquiring lock");
                return false;
            }
        }
    };
    var loop = function() {
        storage.setItem(keyX, i);
        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }
            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };
    var criticalSection = function() {
        storage.setItem(keyZ, "1");
        try {
            lockedCB();
        } finally{
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) storage.removeItem(keyY);
            if (storage.getItem(keyX) === i) storage.removeItem(keyX);
        }
    };
    try {
        if ($6fb9842575b03497$var$localStorageSupported(storage, true)) loop();
        else throw new Error("localStorage support check failed");
    } catch (err) {
        reportError(err);
    }
};
var $6fb9842575b03497$var$logger$2 = $6fb9842575b03497$var$console_with_prefix("batch");
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $6fb9842575b03497$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || $6fb9842575b03497$var$_.bind($6fb9842575b03497$var$logger$2.error, $6fb9842575b03497$var$logger$2);
    this.lock = new $6fb9842575b03497$var$SharedLock(storageKey, {
        storage: this.storage
    });
    this.usePersistence = options.usePersistence;
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $6fb9842575b03497$var$RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        "id": $6fb9842575b03497$var$cheap_guid(),
        "flushAfter": new Date().getTime() + flushInterval * 2,
        "payload": item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        if (cb) cb(true);
    } else this.lock.withLock($6fb9842575b03497$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) // only add to in-memory queue when storage succeeds
            this.memQueue.push(queueEntry);
        } catch (err) {
            this.reportError("Error enqueueing item", item);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $6fb9842575b03497$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $6fb9842575b03497$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $6fb9842575b03497$var$_.each(batch, function(item) {
                idsInBatch[item["id"]] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item["flushAfter"] && !idsInBatch[item["id"]]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
    }
    return batch;
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $6fb9842575b03497$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $6fb9842575b03497$var$_.each(items, function(item) {
        if (item["id"] && !idSet[item["id"]]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $6fb9842575b03497$var$RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    $6fb9842575b03497$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $6fb9842575b03497$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) {
        if (cb) cb(true);
    } else {
        var removeFromStorage = $6fb9842575b03497$var$_.bind(function() {
            var succeeded;
            try {
                var storedQueue = this.readFromStorage();
                storedQueue = $6fb9842575b03497$var$filterOutIDsAndInvalid(storedQueue, idSet);
                succeeded = this.saveToStorage(storedQueue);
                // an extra check: did storage report success but somehow
                // the items are still there?
                if (succeeded) {
                    storedQueue = this.readFromStorage();
                    for(var i = 0; i < storedQueue.length; i++){
                        var item = storedQueue[i];
                        if (item["id"] && !!idSet[item["id"]]) {
                            this.reportError("Item not removed from storage");
                            return false;
                        }
                    }
                }
            } catch (err) {
                this.reportError("Error removing items", ids);
                succeeded = false;
            }
            return succeeded;
        }, this);
        this.lock.withLock(function lockAcquired() {
            var succeeded = removeFromStorage();
            if (cb) cb(succeeded);
        }, $6fb9842575b03497$var$_.bind(function lockFailure(err) {
            var succeeded = false;
            this.reportError("Error acquiring storage lock", err);
            if (!$6fb9842575b03497$var$localStorageSupported(this.storage, true)) {
                // Looks like localStorage writes have stopped working sometime after
                // initialization (probably full), and so nobody can acquire locks
                // anymore. Consider it temporarily safe to remove items without the
                // lock, since nobody's writing successfully anyway.
                succeeded = removeFromStorage();
                if (!succeeded) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                try {
                    this.storage.removeItem(this.storageKey);
                } catch (err) {
                    this.reportError("Error clearing queue", err);
                }
            }
            if (cb) cb(succeeded);
        }, this), this.pid);
    }
};
// internal helper for RequestQueue.updatePayloads
var $6fb9842575b03497$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $6fb9842575b03497$var$_.each(existingItems, function(item) {
        var id = item["id"];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item["payload"] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $6fb9842575b03497$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = $6fb9842575b03497$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) {
        if (cb) cb(true);
    } else this.lock.withLock($6fb9842575b03497$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $6fb9842575b03497$var$updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch (err) {
            this.reportError("Error updating items", itemsToUpdate);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $6fb9842575b03497$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $6fb9842575b03497$var$RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = $6fb9842575b03497$var$JSONParse(storageEntry);
            if (!$6fb9842575b03497$var$_.isArray(storageEntry)) {
                this.reportError("Invalid storage entry:", storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError("Error retrieving queue", err);
        storageEntry = null;
    }
    return storageEntry || [];
};
/**
 * Serialize the given items array to localStorage.
 */ $6fb9842575b03497$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, $6fb9842575b03497$var$JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError("Error saving queue", err);
        return false;
    }
};
/**
 * Clear out queues (memory and localStorage).
 */ $6fb9842575b03497$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) this.storage.removeItem(this.storageKey);
};
// maximum interval between request retries after exponential backoff
var $6fb9842575b03497$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $6fb9842575b03497$var$logger$1 = $6fb9842575b03497$var$console_with_prefix("batch");
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $6fb9842575b03497$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $6fb9842575b03497$var$RequestQueue(storageKey, {
        errorReporter: $6fb9842575b03497$var$_.bind(this.reportError, this),
        storage: options.storage,
        usePersistence: options.usePersistence
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig["batch_size"];
    this.flushInterval = this.libConfig["batch_flush_interval_ms"];
    this.stopped = !this.libConfig["batch_autostart"];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
};
/**
 * Add one item to queue.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $6fb9842575b03497$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig["batch_size"];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig["batch_flush_interval_ms"]);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($6fb9842575b03497$var$_.bind(function() {
        if (!this.stopped) this.flush();
    }, this), this.flushInterval);
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $6fb9842575b03497$var$RequestBatcher.prototype.flush = function(options) {
    try {
        if (this.requestInProgress) {
            $6fb9842575b03497$var$logger$1.log("Flush: Request already in progress");
            return;
        }
        options = options || {};
        var timeoutMS = this.libConfig["batch_request_timeout_ms"];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $6fb9842575b03497$var$_.each(batch, function(item) {
            var payload = item["payload"];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload["event"] && payload["properties"]) payload["properties"] = $6fb9842575b03497$var$_.extend({}, payload["properties"], {
                    "mp_sent_by_lib_version": $6fb9842575b03497$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item["id"];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError("[dupe] item ID sent too many times, not sending", {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError("[dupe] found item with no ID", {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item["id"]] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }
        this.requestInProgress = true;
        var batchSendCallback = $6fb9842575b03497$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                var removeItemsFromQueue = false;
                if (options.unloading) // update persisted data to include hook transformations
                this.queue.updatePayloads(transformedItems);
                else if ($6fb9842575b03497$var$_.isObject(res) && res.error === "timeout" && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError("Network timeout; retrying");
                    this.flush();
                } else if ($6fb9842575b03497$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.error === "timeout")) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($6fb9842575b03497$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError("Error; retry in " + retryMS + " ms");
                    this.scheduleFlush(retryMS);
                } else if ($6fb9842575b03497$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError("413 response; reducing batch size to " + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError("Single-event request too large; dropping", batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                removeItemsFromQueue = true;
                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID($6fb9842575b03497$var$_.map(batch, function(item) {
                        return item["id"];
                    }), $6fb9842575b03497$var$_.bind(function(succeeded) {
                        if (succeeded) {
                            this.consecutiveRemovalFailures = 0;
                            if (this.flushOnlyOnInterval && !attemptSecondaryFlush) this.resetFlush(); // schedule next batch with a delay
                            else this.flush(); // handle next batch if the queue isn't empty
                        } else {
                            this.reportError("Failed to remove items from queue");
                            if (++this.consecutiveRemovalFailures > 5) {
                                this.reportError("Too many queue failures; disabling batching system.");
                                this.stopAllBatching();
                            } else this.resetFlush();
                        }
                    }, this));
                    // client-side dedupe
                    $6fb9842575b03497$var$_.each(batch, $6fb9842575b03497$var$_.bind(function(item) {
                        var itemId = item["id"];
                        if (itemId) {
                            this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                            this.itemIdsSentSuccessfully[itemId]++;
                            if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError("[dupe] item ID sent too many times", {
                                item: item,
                                batchSize: batch.length,
                                timesSent: this.itemIdsSentSuccessfully[itemId]
                            });
                        } else this.reportError("[dupe] found item with no ID while removing", {
                            item: item
                        });
                    }, this));
                }
            } catch (err) {
                this.reportError("Error handling API response", err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: "POST",
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = "sendBeacon";
        $6fb9842575b03497$var$logger$1.log("MIXPANEL REQUEST:", dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
    } catch (err) {
        this.reportError("Error flushing request queue", err);
        this.resetFlush();
    }
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $6fb9842575b03497$var$logger$1.error.apply($6fb9842575b03497$var$logger$1.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$logger$1.error(err);
    }
};
var $6fb9842575b03497$var$logger = $6fb9842575b03497$var$console_with_prefix("recorder");
var $6fb9842575b03497$var$CompressionStream = $6fb9842575b03497$var$win["CompressionStream"];
var $6fb9842575b03497$var$RECORDER_BATCHER_LIB_CONFIG = {
    "batch_size": 1000,
    "batch_flush_interval_ms": 10000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true
};
var $6fb9842575b03497$var$ACTIVE_SOURCES = new Set([
    $6fb9842575b03497$var$IncrementalSource.MouseMove,
    $6fb9842575b03497$var$IncrementalSource.MouseInteraction,
    $6fb9842575b03497$var$IncrementalSource.Scroll,
    $6fb9842575b03497$var$IncrementalSource.ViewportResize,
    $6fb9842575b03497$var$IncrementalSource.Input,
    $6fb9842575b03497$var$IncrementalSource.TouchMove,
    $6fb9842575b03497$var$IncrementalSource.MediaInteraction,
    $6fb9842575b03497$var$IncrementalSource.Drag,
    $6fb9842575b03497$var$IncrementalSource.Selection
]);
function $6fb9842575b03497$var$isUserEvent(ev) {
    return ev.type === $6fb9842575b03497$var$EventType.IncrementalSnapshot && $6fb9842575b03497$var$ACTIVE_SOURCES.has(ev.data.source);
}
var $6fb9842575b03497$var$MixpanelRecorder = function(mixpanelInstance) {
    this._mixpanel = mixpanelInstance;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.recEvents = [];
    this.seqNo = 0;
    this.replayId = null;
    this.replayStartTime = null;
    this.sendBatchId = null;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $6fb9842575b03497$var$MAX_RECORDING_MS;
    this._initBatcher();
};
$6fb9842575b03497$var$MixpanelRecorder.prototype._initBatcher = function() {
    this.batcher = new $6fb9842575b03497$var$RequestBatcher("__mprec", {
        libConfig: $6fb9842575b03497$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: $6fb9842575b03497$var$_.bind(this.flushEventsWithOptOut, this),
        errorReporter: $6fb9842575b03497$var$_.bind(this.reportError, this),
        flushOnlyOnInterval: true,
        usePersistence: false
    });
};
// eslint-disable-next-line camelcase
$6fb9842575b03497$var$MixpanelRecorder.prototype.get_config = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.startRecording = function(shouldStopBatcher) {
    if (this._stopRecording !== null) {
        $6fb9842575b03497$var$logger.log("Recording already in progress, skipping startRecording.");
        return;
    }
    this.recordMaxMs = this.get_config("record_max_ms");
    if (this.recordMaxMs > $6fb9842575b03497$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $6fb9842575b03497$var$MAX_RECORDING_MS;
        $6fb9842575b03497$var$logger.critical("record_max_ms cannot be greater than " + $6fb9842575b03497$var$MAX_RECORDING_MS + "ms. Capping value.");
    }
    this.recEvents = [];
    this.seqNo = 0;
    this.replayStartTime = null;
    this.replayId = $6fb9842575b03497$var$_.UUID();
    if (shouldStopBatcher) // this is the case when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = $6fb9842575b03497$var$_.bind(function() {
        clearTimeout(this.idleTimeoutId);
        this.idleTimeoutId = setTimeout($6fb9842575b03497$var$_.bind(function() {
            $6fb9842575b03497$var$logger.log("Idle timeout reached, restarting recording.");
            this.resetRecording();
        }, this), this.get_config("record_idle_timeout_ms"));
    }, this);
    this._stopRecording = $6fb9842575b03497$var$record({
        "emit": $6fb9842575b03497$var$_.bind(function(ev) {
            this.batcher.enqueue(ev);
            if ($6fb9842575b03497$var$isUserEvent(ev)) {
                if (this.batcher.stopped) // start flushing again after user activity
                this.batcher.start();
                resetIdleTimeout();
            }
        }, this),
        "blockClass": this.get_config("record_block_class"),
        "blockSelector": this.get_config("record_block_selector"),
        "collectFonts": this.get_config("record_collect_fonts"),
        "inlineImages": this.get_config("record_inline_images"),
        "maskAllInputs": true,
        "maskTextClass": this.get_config("record_mask_text_class"),
        "maskTextSelector": this.get_config("record_mask_text_selector")
    });
    resetIdleTimeout();
    this.maxTimeoutId = setTimeout($6fb9842575b03497$var$_.bind(this.resetRecording, this), this.recordMaxMs);
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording(true);
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.stopRecording = function() {
    if (this._stopRecording !== null) {
        this._stopRecording();
        this._stopRecording = null;
    }
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    this.batcher.clear();
    else {
        // flush any remaining events from running batcher
        this.batcher.flush();
        this.batcher.stop();
    }
    this.replayId = null;
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $6fb9842575b03497$var$MixpanelRecorder.prototype.flushEventsWithOptOut = function(data, options, cb) {
    this._flushEvents(data, options, cb, $6fb9842575b03497$var$_.bind(this._onOptOut, this));
};
$6fb9842575b03497$var$MixpanelRecorder.prototype._onOptOut = function(code) {
    // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
    if (code === 0) {
        this.recEvents = [];
        this.stopRecording();
    }
};
$6fb9842575b03497$var$MixpanelRecorder.prototype._sendRequest = function(reqParams, reqBody, callback) {
    var onSuccess = $6fb9842575b03497$var$_.bind(function(response, responseBody) {
        // Increment sequence counter only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        if (response.status === 200) this.seqNo++;
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get("Retry-After")
        });
    }, this);
    $6fb9842575b03497$var$win["fetch"](this.get_config("api_host") + "/" + this.get_config("api_routes")["record"] + "?" + new URLSearchParams(reqParams), {
        "method": "POST",
        "headers": {
            "Authorization": "Basic " + btoa(this.get_config("token") + ":"),
            "Content-Type": "application/octet-stream"
        },
        "body": reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        }).catch(function(error) {
            callback({
                error: error
            });
        });
    }).catch(function(error) {
        callback({
            error: error
        });
    });
};
$6fb9842575b03497$var$MixpanelRecorder.prototype._flushEvents = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    const numEvents = data.length;
    if (numEvents > 0) {
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = data[0].timestamp;
        if (this.seqNo === 0) this.replayStartTime = batchStartTime;
        var replayLengthMs = data[numEvents - 1].timestamp - this.replayStartTime;
        var reqParams = {
            "distinct_id": String(this._mixpanel.get_distinct_id()),
            "seq": this.seqNo,
            "batch_start_time": batchStartTime / 1000,
            "replay_id": this.replayId,
            "replay_length_ms": replayLengthMs,
            "replay_start_time": this.replayStartTime / 1000
        };
        var eventsJson = $6fb9842575b03497$var$_.JSONEncode(data);
        // send ID management props if they exist
        var deviceId = this._mixpanel.get_property("$device_id");
        if (deviceId) reqParams["$device_id"] = deviceId;
        var userId = this._mixpanel.get_property("$user_id");
        if (userId) reqParams["$user_id"] = userId;
        if ($6fb9842575b03497$var$CompressionStream) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: "application/json"
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $6fb9842575b03497$var$CompressionStream("gzip"));
            new Response(gzipStream).blob().then($6fb9842575b03497$var$_.bind(function(compressedBlob) {
                reqParams["format"] = "gzip";
                this._sendRequest(reqParams, compressedBlob, callback);
            }, this));
        } else {
            reqParams["format"] = "body";
            this._sendRequest(reqParams, eventsJson, callback);
        }
    }
});
$6fb9842575b03497$var$MixpanelRecorder.prototype.reportError = function(msg, err) {
    $6fb9842575b03497$var$logger.error.apply($6fb9842575b03497$var$logger.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config("error_reporter")(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$logger.error(err);
    }
};
$6fb9842575b03497$var$win["__mp_recorder"] = $6fb9842575b03497$var$MixpanelRecorder;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $6fb9842575b03497$var$DomTracker = function() {};
// interface
$6fb9842575b03497$var$DomTracker.prototype.create_properties = function() {};
$6fb9842575b03497$var$DomTracker.prototype.event_handler = function() {};
$6fb9842575b03497$var$DomTracker.prototype.after_track_handler = function() {};
$6fb9842575b03497$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $6fb9842575b03497$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $6fb9842575b03497$var$_.dom_query(query);
    if (elements.length === 0) {
        $6fb9842575b03497$var$console$1.error("The DOM query (" + query + ") returned 0 elements");
        return;
    }
    $6fb9842575b03497$var$_.each(elements, function(element) {
        $6fb9842575b03497$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config("track_links_timeout");
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $6fb9842575b03497$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$6fb9842575b03497$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === "function") props = properties(element);
    else props = $6fb9842575b03497$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6fb9842575b03497$var$LinkTracker = function() {
    this.override_event = "click";
};
$6fb9842575b03497$var$_.inherit($6fb9842575b03497$var$LinkTracker, $6fb9842575b03497$var$DomTracker);
$6fb9842575b03497$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $6fb9842575b03497$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props["url"] = element.href;
    return props;
};
$6fb9842575b03497$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === "_blank";
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$6fb9842575b03497$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6fb9842575b03497$var$FormTracker = function() {
    this.override_event = "submit";
};
$6fb9842575b03497$var$_.inherit($6fb9842575b03497$var$FormTracker, $6fb9842575b03497$var$DomTracker);
$6fb9842575b03497$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$6fb9842575b03497$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $6fb9842575b03497$var$SET_ACTION = "$set";
/** @const */ var $6fb9842575b03497$var$SET_ONCE_ACTION = "$set_once";
/** @const */ var $6fb9842575b03497$var$UNSET_ACTION = "$unset";
/** @const */ var $6fb9842575b03497$var$ADD_ACTION = "$add";
/** @const */ var $6fb9842575b03497$var$APPEND_ACTION = "$append";
/** @const */ var $6fb9842575b03497$var$UNION_ACTION = "$union";
/** @const */ var $6fb9842575b03497$var$REMOVE_ACTION = "$remove";
/** @const */ var $6fb9842575b03497$var$DELETE_ACTION = "$delete";
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $6fb9842575b03497$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($6fb9842575b03497$var$_.isObject(prop)) $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$6fb9842575b03497$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$6fb9842575b03497$var$_.isArray(prop)) prop = [
            prop
        ];
        $6fb9842575b03497$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$6fb9842575b03497$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($6fb9842575b03497$var$_.isObject(prop)) $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$6fb9842575b03497$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $6fb9842575b03497$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $6fb9842575b03497$var$_.isArray(values) ? values : [
            values
        ];
        data[$6fb9842575b03497$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$6fb9842575b03497$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$6fb9842575b03497$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$6fb9842575b03497$var$DELETE_ACTION] = "";
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelGroup = function() {};
$6fb9842575b03497$var$_.extend($6fb9842575b03497$var$MixpanelGroup.prototype, $6fb9842575b03497$var$apiActions);
$6fb9842575b03497$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.set = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.set_once = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.unset = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.union = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype["delete"] = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.remove = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$6fb9842575b03497$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data["$group_key"] = this._group_key;
    data["$group_id"] = this._group_id;
    data["$token"] = this._get_config("token");
    var date_encoded_data = $6fb9842575b03497$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: "groups",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes")["groups"],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$6fb9842575b03497$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === "$group_key" || prop === "$group_id";
};
$6fb9842575b03497$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$6fb9842575b03497$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
// MixpanelGroup Exports
$6fb9842575b03497$var$MixpanelGroup.prototype["remove"] = $6fb9842575b03497$var$MixpanelGroup.prototype.remove;
$6fb9842575b03497$var$MixpanelGroup.prototype["set"] = $6fb9842575b03497$var$MixpanelGroup.prototype.set;
$6fb9842575b03497$var$MixpanelGroup.prototype["set_once"] = $6fb9842575b03497$var$MixpanelGroup.prototype.set_once;
$6fb9842575b03497$var$MixpanelGroup.prototype["union"] = $6fb9842575b03497$var$MixpanelGroup.prototype.union;
$6fb9842575b03497$var$MixpanelGroup.prototype["unset"] = $6fb9842575b03497$var$MixpanelGroup.prototype.unset;
$6fb9842575b03497$var$MixpanelGroup.prototype["toString"] = $6fb9842575b03497$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelPeople = function() {};
$6fb9842575b03497$var$_.extend($6fb9842575b03497$var$MixpanelPeople.prototype, $6fb9842575b03497$var$apiActions);
$6fb9842575b03497$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.set = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config("save_referrer")) this._mixpanel["persistence"].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$6fb9842575b03497$var$SET_ACTION] = $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$_.info.people_properties(), data[$6fb9842575b03497$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.set_once = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.unset = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.increment = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($6fb9842575b03497$var$_.isObject(prop)) {
        $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $6fb9842575b03497$var$console$1.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($6fb9842575b03497$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$6fb9842575b03497$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.append = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.remove = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.union = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelPeople.prototype.track_charge = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$6fb9842575b03497$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $6fb9842575b03497$var$console$1.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
            return;
        }
    }
    return this.append("$transactions", $6fb9842575b03497$var$_.extend({
        "$amount": amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set("$transactions", [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $6fb9842575b03497$var$console$1.error("mixpanel.people.delete_user() requires you to call identify() first");
        return;
    }
    var data = {
        "$delete": this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$6fb9842575b03497$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + ".people";
};
$6fb9842575b03497$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data["$token"] = this._get_config("token");
    data["$distinct_id"] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property("$device_id");
    var user_id = this._mixpanel.get_property("$user_id");
    var had_persisted_distinct_id = this._mixpanel.get_property("$had_persisted_distinct_id");
    if (device_id) data["$device_id"] = device_id;
    if (user_id) data["$user_id"] = user_id;
    if (had_persisted_distinct_id) data["$had_persisted_distinct_id"] = had_persisted_distinct_id;
    var date_encoded_data = $6fb9842575b03497$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$6fb9842575b03497$var$_.isUndefined(callback)) {
            if (this._get_config("verbose")) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $6fb9842575b03497$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: "people",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes")["engage"],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$6fb9842575b03497$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($6fb9842575b03497$var$SET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$SET_ACTION, data);
    else if ($6fb9842575b03497$var$SET_ONCE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$SET_ONCE_ACTION, data);
    else if ($6fb9842575b03497$var$UNSET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$UNSET_ACTION, data);
    else if ($6fb9842575b03497$var$ADD_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$ADD_ACTION, data);
    else if ($6fb9842575b03497$var$APPEND_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$APPEND_ACTION, data);
    else if ($6fb9842575b03497$var$REMOVE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$REMOVE_ACTION, data);
    else if ($6fb9842575b03497$var$UNION_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$UNION_ACTION, data);
    else $6fb9842575b03497$var$console$1.error("Invalid call to _enqueue():", data);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $6fb9842575b03497$var$_.extend({}, this._mixpanel["persistence"].load_queue(action));
    var action_params = queued_data;
    if (!$6fb9842575b03497$var$_.isUndefined(queued_data) && $6fb9842575b03497$var$_.isObject(queued_data) && !$6fb9842575b03497$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel["persistence"]._pop_from_people_queue(action, queued_data);
        _this._mixpanel["persistence"].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue(action, queued_data);
            if (!$6fb9842575b03497$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$6fb9842575b03497$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($6fb9842575b03497$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($6fb9842575b03497$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($6fb9842575b03497$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $6fb9842575b03497$var$_.keys(queue);
    });
    this._flush_one_queue($6fb9842575b03497$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($6fb9842575b03497$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel["persistence"].load_queue($6fb9842575b03497$var$APPEND_ACTION);
    if (!$6fb9842575b03497$var$_.isUndefined($append_queue) && $6fb9842575b03497$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$APPEND_ACTION, $append_item);
            if (!$6fb9842575b03497$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel["persistence"].load_queue($6fb9842575b03497$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$6fb9842575b03497$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel["persistence"].load_queue($6fb9842575b03497$var$REMOVE_ACTION);
    if (!$6fb9842575b03497$var$_.isUndefined($remove_queue) && $6fb9842575b03497$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($6fb9842575b03497$var$REMOVE_ACTION, $remove_item);
            if (!$6fb9842575b03497$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel["persistence"].load_queue($6fb9842575b03497$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$6fb9842575b03497$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$6fb9842575b03497$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === "$distinct_id" || prop === "$token" || prop === "$device_id" || prop === "$user_id" || prop === "$had_persisted_distinct_id";
};
// MixpanelPeople Exports
$6fb9842575b03497$var$MixpanelPeople.prototype["set"] = $6fb9842575b03497$var$MixpanelPeople.prototype.set;
$6fb9842575b03497$var$MixpanelPeople.prototype["set_once"] = $6fb9842575b03497$var$MixpanelPeople.prototype.set_once;
$6fb9842575b03497$var$MixpanelPeople.prototype["unset"] = $6fb9842575b03497$var$MixpanelPeople.prototype.unset;
$6fb9842575b03497$var$MixpanelPeople.prototype["increment"] = $6fb9842575b03497$var$MixpanelPeople.prototype.increment;
$6fb9842575b03497$var$MixpanelPeople.prototype["append"] = $6fb9842575b03497$var$MixpanelPeople.prototype.append;
$6fb9842575b03497$var$MixpanelPeople.prototype["remove"] = $6fb9842575b03497$var$MixpanelPeople.prototype.remove;
$6fb9842575b03497$var$MixpanelPeople.prototype["union"] = $6fb9842575b03497$var$MixpanelPeople.prototype.union;
$6fb9842575b03497$var$MixpanelPeople.prototype["track_charge"] = $6fb9842575b03497$var$MixpanelPeople.prototype.track_charge;
$6fb9842575b03497$var$MixpanelPeople.prototype["clear_charges"] = $6fb9842575b03497$var$MixpanelPeople.prototype.clear_charges;
$6fb9842575b03497$var$MixpanelPeople.prototype["delete_user"] = $6fb9842575b03497$var$MixpanelPeople.prototype.delete_user;
$6fb9842575b03497$var$MixpanelPeople.prototype["toString"] = $6fb9842575b03497$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $6fb9842575b03497$var$SET_QUEUE_KEY = "__mps";
/** @const */ var $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY = "__mpso";
/** @const */ var $6fb9842575b03497$var$UNSET_QUEUE_KEY = "__mpus";
/** @const */ var $6fb9842575b03497$var$ADD_QUEUE_KEY = "__mpa";
/** @const */ var $6fb9842575b03497$var$APPEND_QUEUE_KEY = "__mpap";
/** @const */ var $6fb9842575b03497$var$REMOVE_QUEUE_KEY = "__mpr";
/** @const */ var $6fb9842575b03497$var$UNION_QUEUE_KEY = "__mpu";
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY = "$people_distinct_id";
/** @const */ var $6fb9842575b03497$var$ALIAS_ID_KEY = "__alias";
/** @const */ var $6fb9842575b03497$var$EVENT_TIMERS_KEY = "__timers";
/** @const */ var $6fb9842575b03497$var$RESERVED_PROPERTIES = [
    $6fb9842575b03497$var$SET_QUEUE_KEY,
    $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY,
    $6fb9842575b03497$var$UNSET_QUEUE_KEY,
    $6fb9842575b03497$var$ADD_QUEUE_KEY,
    $6fb9842575b03497$var$APPEND_QUEUE_KEY,
    $6fb9842575b03497$var$REMOVE_QUEUE_KEY,
    $6fb9842575b03497$var$UNION_QUEUE_KEY,
    $6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY,
    $6fb9842575b03497$var$ALIAS_ID_KEY,
    $6fb9842575b03497$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelPersistence = function(config) {
    this["props"] = {};
    this.campaign_params_saved = false;
    if (config["persistence_name"]) this.name = "mp_" + config["persistence_name"];
    else this.name = "mp_" + config["token"] + "_mixpanel";
    var storage_type = config["persistence"];
    if (storage_type !== "cookie" && storage_type !== "localStorage") {
        $6fb9842575b03497$var$console$1.critical("Unknown persistence type " + storage_type + "; falling back to cookie");
        storage_type = config["persistence"] = "cookie";
    }
    if (storage_type === "localStorage" && $6fb9842575b03497$var$_.localStorage.is_supported()) this.storage = $6fb9842575b03497$var$_.localStorage;
    else this.storage = $6fb9842575b03497$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $6fb9842575b03497$var$_.each(this["props"], function(v, k) {
        if (!$6fb9842575b03497$var$_.include($6fb9842575b03497$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this["props"] = $6fb9842575b03497$var$_.extend({}, entry);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $6fb9842575b03497$var$_.localStorage) {
        old_cookie = $6fb9842575b03497$var$_.cookie.parse(this.name);
        $6fb9842575b03497$var$_.cookie.remove(this.name);
        $6fb9842575b03497$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $6fb9842575b03497$var$_.cookie) {
        old_localstorage = $6fb9842575b03497$var$_.localStorage.parse(this.name);
        $6fb9842575b03497$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $6fb9842575b03497$var$_.JSONEncode(this["props"]), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this["props"][key];
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$6fb9842575b03497$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this["props"] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $6fb9842575b03497$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($6fb9842575b03497$var$_.isObject(props)) {
        if (typeof default_value === "undefined") default_value = "None";
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $6fb9842575b03497$var$_.each(props, function(val, prop) {
            if (!this["props"].hasOwnProperty(prop) || this["props"][prop] === default_value) this["props"][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $6fb9842575b03497$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($6fb9842575b03497$var$_.isObject(props)) {
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $6fb9842575b03497$var$_.extend(this["props"], props);
        this.save();
        return true;
    }
    return false;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this["props"]) {
        delete this["props"][prop];
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($6fb9842575b03497$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        "$initial_referrer": referrer || "$direct",
        "$initial_referring_domain": $6fb9842575b03497$var$_.info.referringDomain(referrer) || "$direct"
    }, "");
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $6fb9842575b03497$var$_.strip_empty_properties({
        "$initial_referrer": this["props"]["$initial_referrer"],
        "$initial_referring_domain": this["props"]["$initial_referring_domain"]
    });
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config["cookie_expiration"];
    this.set_disabled(config["disable_persistence"]);
    this.set_cookie_domain(config["cookie_domain"]);
    this.set_cross_site(config["cross_site_cookie"]);
    this.set_cross_subdomain(config["cross_subdomain_cookie"]);
    this.set_secure(config["secure_cookie"]);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($6fb9842575b03497$var$SET_ACTION), set_once_q = this._get_or_create_queue($6fb9842575b03497$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($6fb9842575b03497$var$UNSET_ACTION), add_q = this._get_or_create_queue($6fb9842575b03497$var$ADD_ACTION), union_q = this._get_or_create_queue($6fb9842575b03497$var$UNION_ACTION), remove_q = this._get_or_create_queue($6fb9842575b03497$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($6fb9842575b03497$var$APPEND_ACTION, []);
    if (q_key === $6fb9842575b03497$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $6fb9842575b03497$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($6fb9842575b03497$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($6fb9842575b03497$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$UNSET_QUEUE_KEY) $6fb9842575b03497$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $6fb9842575b03497$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $6fb9842575b03497$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $6fb9842575b03497$var$ADD_QUEUE_KEY) {
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$UNION_QUEUE_KEY) {
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            if ($6fb9842575b03497$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$APPEND_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    }
    $6fb9842575b03497$var$console$1.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):");
    $6fb9842575b03497$var$console$1.log(data);
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this["props"][this._get_queue_key(queue)];
    if (!$6fb9842575b03497$var$_.isUndefined(q)) $6fb9842575b03497$var$_.each(data, function(v, k) {
        if (queue === $6fb9842575b03497$var$APPEND_ACTION || queue === $6fb9842575b03497$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $6fb9842575b03497$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $6fb9842575b03497$var$SET_ACTION) return $6fb9842575b03497$var$SET_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$SET_ONCE_ACTION) return $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$UNSET_ACTION) return $6fb9842575b03497$var$UNSET_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$ADD_ACTION) return $6fb9842575b03497$var$ADD_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$APPEND_ACTION) return $6fb9842575b03497$var$APPEND_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$REMOVE_ACTION) return $6fb9842575b03497$var$REMOVE_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$UNION_ACTION) return $6fb9842575b03497$var$UNION_QUEUE_KEY;
    else $6fb9842575b03497$var$console$1.error("Invalid queue:", queue);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $6fb9842575b03497$var$_.isUndefined(default_val) ? {} : default_val;
    return this["props"][key] || (this["props"][key] = default_val);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($6fb9842575b03497$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this["props"][$6fb9842575b03497$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($6fb9842575b03497$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$6fb9842575b03497$var$_.isUndefined(timestamp)) {
        delete this["props"][$6fb9842575b03497$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $6fb9842575b03497$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $6fb9842575b03497$var$load_extra_bundle = function(src, _onload) {
    throw new Error(src + " not available in this build.");
};
var $6fb9842575b03497$var$mixpanel_master; // main mixpanel instance / object
var $6fb9842575b03497$var$INIT_MODULE = 0;
var $6fb9842575b03497$var$INIT_SNIPPET = 1;
var $6fb9842575b03497$var$IDENTITY_FUNC = function(x) {
    return x;
};
var $6fb9842575b03497$var$NOOP_FUNC = function() {};
/** @const */ var $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME = "mixpanel";
/** @const */ var $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64 = "base64";
/** @const */ var $6fb9842575b03497$var$PAYLOAD_TYPE_JSON = "json";
/** @const */ var $6fb9842575b03497$var$DEVICE_ID_PREFIX = "$device:";
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $6fb9842575b03497$var$USE_XHR = $6fb9842575b03497$var$win.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $6fb9842575b03497$var$ENQUEUE_REQUESTS = !$6fb9842575b03497$var$USE_XHR && $6fb9842575b03497$var$userAgent.indexOf("MSIE") === -1 && $6fb9842575b03497$var$userAgent.indexOf("Mozilla") === -1;
// save reference to navigator.sendBeacon so it can be minified
var $6fb9842575b03497$var$sendBeacon = null;
if ($6fb9842575b03497$var$navigator["sendBeacon"]) $6fb9842575b03497$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $6fb9842575b03497$var$navigator["sendBeacon"].apply($6fb9842575b03497$var$navigator, arguments);
};
var $6fb9842575b03497$var$DEFAULT_API_ROUTES = {
    "track": "track/",
    "engage": "engage/",
    "groups": "groups/",
    "record": "record/"
};
/*
 * Module-level globals
 */ var $6fb9842575b03497$var$DEFAULT_CONFIG = {
    "api_host": "https://api-js.mixpanel.com",
    "api_routes": $6fb9842575b03497$var$DEFAULT_API_ROUTES,
    "api_method": "POST",
    "api_transport": "XHR",
    "api_payload_format": $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64,
    "app_host": "https://mixpanel.com",
    "cdn": "https://cdn.mxpnl.com",
    "cross_site_cookie": false,
    "cross_subdomain_cookie": true,
    "error_reporter": $6fb9842575b03497$var$NOOP_FUNC,
    "persistence": "cookie",
    "persistence_name": "",
    "cookie_domain": "",
    "cookie_name": "",
    "loaded": $6fb9842575b03497$var$NOOP_FUNC,
    "mp_loader": null,
    "track_marketing": true,
    "track_pageview": false,
    "skip_first_touch_marketing": false,
    "store_google": true,
    "stop_utm_persistence": false,
    "save_referrer": true,
    "test": false,
    "verbose": false,
    "img": false,
    "debug": false,
    "track_links_timeout": 300,
    "cookie_expiration": 365,
    "upgrade": false,
    "disable_persistence": false,
    "disable_cookie": false,
    "secure_cookie": false,
    "ip": true,
    "opt_out_tracking_by_default": false,
    "opt_out_persistence_by_default": false,
    "opt_out_tracking_persistence_type": "localStorage",
    "opt_out_tracking_cookie_prefix": null,
    "property_blacklist": [],
    "xhr_headers": {},
    "ignore_dnt": false,
    "batch_requests": true,
    "batch_size": 50,
    "batch_flush_interval_ms": 5000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true,
    "hooks": {},
    "record_block_class": new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
    "record_block_selector": "img, video",
    "record_collect_fonts": false,
    "record_idle_timeout_ms": 1800000,
    "record_inline_images": false,
    "record_mask_text_class": new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
    "record_mask_text_selector": "*",
    "record_max_ms": $6fb9842575b03497$var$MAX_RECORDING_MS,
    "record_sessions_percent": 0,
    "recorder_src": "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
};
var $6fb9842575b03497$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $6fb9842575b03497$var$create_mplib = function(token, config, name) {
    var instance, target = name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME ? $6fb9842575b03497$var$mixpanel_master : $6fb9842575b03497$var$mixpanel_master[name];
    if (target && $6fb9842575b03497$var$init_type === $6fb9842575b03497$var$INIT_MODULE) instance = target;
    else {
        if (target && !$6fb9842575b03497$var$_.isArray(target)) {
            $6fb9842575b03497$var$console$1.error("You have already initialized " + name);
            return;
        }
        instance = new $6fb9842575b03497$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance["people"] = new $6fb9842575b03497$var$MixpanelPeople();
    instance["people"]._init(instance);
    if (!instance.get_config("skip_first_touch_marketing")) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $6fb9842575b03497$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $6fb9842575b03497$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params["initial_" + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance["people"].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $6fb9842575b03497$var$Config.DEBUG = $6fb9842575b03497$var$Config.DEBUG || instance.get_config("debug");
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$6fb9842575b03497$var$_.isUndefined(target) && $6fb9842575b03497$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance["people"], target["people"]);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $6fb9842575b03497$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($6fb9842575b03497$var$_.isUndefined(name)) {
        this.report_error("You must name your new library: init(token, config, name)");
        return;
    }
    if (name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) {
        this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
        return;
    }
    var instance = $6fb9842575b03497$var$create_mplib(token, config, name);
    $6fb9842575b03497$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$6fb9842575b03497$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this["__loaded"] = true;
    this["config"] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!("api_payload_format" in config)) {
        var api_host = config["api_host"] || $6fb9842575b03497$var$DEFAULT_CONFIG["api_host"];
        if (api_host.match(/\.mixpanel\.com/)) variable_features["api_payload_format"] = $6fb9842575b03497$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$DEFAULT_CONFIG, variable_features, config, {
        "name": name,
        "token": token,
        "callback_fn": (name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME ? name : $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME + "." + name) + "._jsc"
    }));
    this["_jsc"] = $6fb9842575b03497$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        "disable_all_events": false,
        "identify_called": false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config("batch_requests");
    if (this._batch_requests) {
        if (!$6fb9842575b03497$var$_.localStorage.is_supported(true) || !$6fb9842575b03497$var$USE_XHR) {
            this._batch_requests = false;
            $6fb9842575b03497$var$console$1.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support");
            $6fb9842575b03497$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $6fb9842575b03497$var$console$1.log("Clearing batch queue " + batcher_config.queue_key);
                $6fb9842575b03497$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($6fb9842575b03497$var$sendBeacon && $6fb9842575b03497$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $6fb9842575b03497$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $6fb9842575b03497$var$win.addEventListener("pagehide", function(ev) {
                    if (ev["persisted"]) flush_on_unload();
                });
                $6fb9842575b03497$var$win.addEventListener("visibilitychange", function() {
                    if ($6fb9842575b03497$var$document$1["visibilityState"] === "hidden") flush_on_unload();
                });
            }
        }
    }
    this["persistence"] = this["cookie"] = new $6fb9842575b03497$var$MixpanelPersistence(this["config"]);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $6fb9842575b03497$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        "distinct_id": $6fb9842575b03497$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
    var track_pageview_option = this.get_config("track_pageview");
    if (track_pageview_option) this._init_url_change_tracking(track_pageview_option);
    if (this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent")) this.start_session_recording();
};
$6fb9842575b03497$var$MixpanelLib.prototype.start_session_recording = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function() {
    if (!$6fb9842575b03497$var$win["MutationObserver"]) {
        $6fb9842575b03497$var$console$1.critical("Browser does not support MutationObserver; skipping session recording");
        return;
    }
    var handleLoadedRecorder = $6fb9842575b03497$var$_.bind(function() {
        this._recorder = this._recorder || new $6fb9842575b03497$var$win["__mp_recorder"](this);
        this._recorder["startRecording"]();
    }, this);
    if ($6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$win["__mp_recorder"])) $6fb9842575b03497$var$load_extra_bundle(this.get_config("recorder_src"), handleLoadedRecorder);
    else handleLoadedRecorder();
});
$6fb9842575b03497$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder["stopRecording"]();
    else $6fb9842575b03497$var$console$1.critical("Session recorder module not loaded");
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    if (this._recorder) {
        var replay_id = this._recorder["replayId"];
        if (replay_id) props["$mp_replay_id"] = replay_id;
    }
    return props;
};
// Private methods
$6fb9842575b03497$var$MixpanelLib.prototype._loaded = function() {
    this.get_config("loaded")(this);
    this._set_default_superprops();
    this["people"].set_once(this["persistence"].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
        var utm_params = $6fb9842575b03497$var$_.info.campaignParams(null);
        $6fb9842575b03497$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$6fb9842575b03497$var$MixpanelLib.prototype._set_default_superprops = function() {
    this["persistence"].update_search_keyword($6fb9842575b03497$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config("store_google") && !this.get_config("stop_utm_persistence")) this.register($6fb9842575b03497$var$_.info.campaignParams());
    if (this.get_config("save_referrer")) this["persistence"].update_referrer_info($6fb9842575b03497$var$document$1.referrer);
};
$6fb9842575b03497$var$MixpanelLib.prototype._dom_loaded = function() {
    $6fb9842575b03497$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $6fb9842575b03497$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$6fb9842575b03497$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config("img")) {
        this.report_error("You can't use DOM tracking functions with img = true.");
        return false;
    }
    if (!$6fb9842575b03497$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
$6fb9842575b03497$var$MixpanelLib.prototype._init_url_change_tracking = function(track_pageview_option) {
    var previous_tracked_url = "";
    var tracked = this.track_pageview();
    if (tracked) previous_tracked_url = $6fb9842575b03497$var$_.info.currentUrl();
    if ($6fb9842575b03497$var$_.include([
        "full-url",
        "url-with-path-and-query-string",
        "url-with-path"
    ], track_pageview_option)) {
        $6fb9842575b03497$var$win.addEventListener("popstate", function() {
            $6fb9842575b03497$var$win.dispatchEvent(new Event("mp_locationchange"));
        });
        $6fb9842575b03497$var$win.addEventListener("hashchange", function() {
            $6fb9842575b03497$var$win.dispatchEvent(new Event("mp_locationchange"));
        });
        var nativePushState = $6fb9842575b03497$var$win.history.pushState;
        if (typeof nativePushState === "function") $6fb9842575b03497$var$win.history.pushState = function(state, unused, url) {
            nativePushState.call($6fb9842575b03497$var$win.history, state, unused, url);
            $6fb9842575b03497$var$win.dispatchEvent(new Event("mp_locationchange"));
        };
        var nativeReplaceState = $6fb9842575b03497$var$win.history.replaceState;
        if (typeof nativeReplaceState === "function") $6fb9842575b03497$var$win.history.replaceState = function(state, unused, url) {
            nativeReplaceState.call($6fb9842575b03497$var$win.history, state, unused, url);
            $6fb9842575b03497$var$win.dispatchEvent(new Event("mp_locationchange"));
        };
        $6fb9842575b03497$var$win.addEventListener("mp_locationchange", (function() {
            var current_url = $6fb9842575b03497$var$_.info.currentUrl();
            var should_track = false;
            if (track_pageview_option === "full-url") should_track = current_url !== previous_tracked_url;
            else if (track_pageview_option === "url-with-path-and-query-string") should_track = current_url.split("#")[0] !== previous_tracked_url.split("#")[0];
            else if (track_pageview_option === "url-with-path") should_track = current_url.split("#")[0].split("?")[0] !== previous_tracked_url.split("#")[0].split("?")[0];
            if (should_track) {
                var tracked = this.track_pageview();
                if (tracked) previous_tracked_url = current_url;
            }
        }).bind(this));
    }
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $6fb9842575b03497$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($6fb9842575b03497$var$_.isUndefined(callback)) return null;
    if ($6fb9842575b03497$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this["_jsc"];
        var randomized_cb = "" + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config("callback_fn") + "[" + randomized_cb + "]";
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$6fb9842575b03497$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($6fb9842575b03497$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config("api_method"),
        transport: this.get_config("api_transport"),
        verbose: this.get_config("verbose")
    };
    var body_data = null;
    if (!callback && ($6fb9842575b03497$var$_.isFunction(options) || typeof options === "string")) {
        callback = options;
        options = null;
    }
    options = $6fb9842575b03497$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$6fb9842575b03497$var$USE_XHR) options.method = "GET";
    var use_post = options.method === "POST";
    var use_sendBeacon = $6fb9842575b03497$var$sendBeacon && use_post && options.transport.toLowerCase() === "sendbeacon";
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data["verbose"]) verbose_mode = true;
    if (this.get_config("test")) data["test"] = 1;
    if (verbose_mode) data["verbose"] = 1;
    if (this.get_config("img")) data["img"] = 1;
    if (!$6fb9842575b03497$var$USE_XHR) {
        if (callback) data["callback"] = callback;
        else if (verbose_mode || this.get_config("test")) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data["callback"] = "(function(){})";
    }
    data["ip"] = this.get_config("ip") ? 1 : 0;
    data["_"] = new Date().getTime().toString();
    if (use_post) {
        body_data = "data=" + encodeURIComponent(data["data"]);
        delete data["data"];
    }
    url += "?" + $6fb9842575b03497$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ("img" in data) {
        var img = $6fb9842575b03497$var$document$1.createElement("img");
        img.src = url;
        $6fb9842575b03497$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $6fb9842575b03497$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($6fb9842575b03497$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config("xhr_headers");
        if (use_post) headers["Content-Type"] = "application/x-www-form-urlencoded";
        $6fb9842575b03497$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== "undefined") {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $6fb9842575b03497$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = "timeout";
                    else error = "Bad HTTP status: " + req.status + " " + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req["responseHeaders"] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req["status"],
                                error: error,
                                retryAfter: response_headers["Retry-After"]
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $6fb9842575b03497$var$document$1.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $6fb9842575b03497$var$document$1.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $6fb9842575b03497$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $6fb9842575b03497$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($6fb9842575b03497$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === "function") item.call(this);
            else if ($6fb9842575b03497$var$_.isArray(item) && fn_name === "alias") alias_calls.push(item);
            else if ($6fb9842575b03497$var$_.isArray(item) && fn_name.indexOf("track") !== -1 && typeof this[fn_name] === "function") tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $6fb9842575b03497$var$_.each(calls, function(item) {
            if ($6fb9842575b03497$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $6fb9842575b03497$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$6fb9842575b03497$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = "__mpq_" + this.get_config("token");
    var api_routes = this.get_config("api_routes");
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: "events",
            endpoint: "/" + api_routes["track"],
            queue_key: queue_prefix + "_ev"
        },
        people: {
            type: "people",
            endpoint: "/" + api_routes["engage"],
            queue_key: queue_prefix + "_pp"
        },
        groups: {
            type: "groups",
            endpoint: "/" + api_routes["groups"],
            queue_key: queue_prefix + "_gr"
        }
    };
    return this._batcher_configs;
};
$6fb9842575b03497$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $6fb9842575b03497$var$_.bind(function(attrs) {
            return new $6fb9842575b03497$var$RequestBatcher(attrs.queue_key, {
                libConfig: this["config"],
                errorReporter: this.get_config("error_reporter"),
                sendRequestFunc: $6fb9842575b03497$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config("api_host") + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $6fb9842575b03497$var$_.bind(function(item) {
                    return this._run_hook("before_send_" + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $6fb9842575b03497$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config("batch_autostart")) this.start_batch_senders();
};
$6fb9842575b03497$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$6fb9842575b03497$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $6fb9842575b03497$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $6fb9842575b03497$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === "undefined") this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$6fb9842575b03497$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $6fb9842575b03497$var$_.JSONEncode(data);
    if (this.get_config("api_payload_format") === $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64) encoded_data = $6fb9842575b03497$var$_.base64Encode(encoded_data);
    return {
        "data": encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$6fb9842575b03497$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $6fb9842575b03497$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $6fb9842575b03497$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $6fb9842575b03497$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook("before_send_" + options.type, truncated_data);
        if (truncated_data) {
            $6fb9842575b03497$var$console$1.log("MIXPANEL REQUEST:");
            $6fb9842575b03497$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data, function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === "function") {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options["transport"]; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options["send_immediately"];
    if (typeof callback !== "function") callback = $6fb9842575b03497$var$NOOP_FUNC;
    if ($6fb9842575b03497$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.track");
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $6fb9842575b03497$var$_.extend({}, properties);
    properties["token"] = this.get_config("token");
    // set $duration if time_event was previously called for this event
    var start_timestamp = this["persistence"].remove_event_timer(event_name);
    if (!$6fb9842575b03497$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties["$duration"] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config("track_marketing") ? $6fb9842575b03497$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$_.info.properties({
        "mp_loader": this.get_config("mp_loader")
    }), marketing_properties, this["persistence"].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config("property_blacklist");
    if ($6fb9842575b03497$var$_.isArray(property_blacklist)) $6fb9842575b03497$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error("Invalid value for property_blacklist config: " + property_blacklist);
    var data = {
        "event": event_name,
        "properties": properties
    };
    var ret = this._track_or_batch({
        type: "events",
        data: data,
        endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes")["track"],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $6fb9842575b03497$var$MixpanelLib.prototype.set_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$6fb9842575b03497$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this["people"].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.add_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this["people"].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.remove_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this["people"].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_with_groups = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $6fb9842575b03497$var$_.extend({}, properties || {});
    $6fb9842575b03497$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$6fb9842575b03497$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + "_" + JSON.stringify(group_id);
};
$6fb9842575b03497$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $6fb9842575b03497$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_pageview = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== "object") properties = {};
    options = options || {};
    var event_name = options["event_name"] || "$mp_web_page_view";
    var default_page_properties = $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.info.mpPageViewProperties(), $6fb9842575b03497$var$_.info.campaignParams(), $6fb9842575b03497$var$_.info.clickParams());
    var event_properties = $6fb9842575b03497$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $6fb9842575b03497$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $6fb9842575b03497$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($6fb9842575b03497$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.time_event");
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this["persistence"].set_event_timer(event_name, new Date().getTime());
};
var $6fb9842575b03497$var$REGISTER_DEFAULTS = {
    "persistent": true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $6fb9842575b03497$var$options_for_register = function(days_or_options) {
    var options;
    if ($6fb9842575b03497$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$6fb9842575b03497$var$_.isUndefined(days_or_options)) options = {
        "days": days_or_options
    };
    else options = {};
    return $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $6fb9842575b03497$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register(props, options["days"]);
    else $6fb9842575b03497$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $6fb9842575b03497$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register_once(props, default_value, options["days"]);
    else {
        if (typeof default_value === "undefined") default_value = "None";
        $6fb9842575b03497$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $6fb9842575b03497$var$options_for_register(options);
    if (options["persistent"]) this["persistence"].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$6fb9842575b03497$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === "string" && new_distinct_id.indexOf($6fb9842575b03497$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error("distinct_id cannot have $device: prefix");
            return -1;
        }
        this.register({
            "$user_id": new_distinct_id
        });
    }
    if (!this.get_property("$device_id")) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            "$had_persisted_distinct_id": true,
            "$device_id": device_id
        }, "");
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($6fb9842575b03497$var$ALIAS_ID_KEY)) {
        this.unregister($6fb9842575b03497$var$ALIAS_ID_KEY);
        this.register({
            "distinct_id": new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this["people"]._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track("$identify", {
        "distinct_id": new_distinct_id,
        "$anon_distinct_id": previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.reset = function() {
    this["persistence"].clear();
    this._flags.identify_called = false;
    var uuid = $6fb9842575b03497$var$_.UUID();
    this.register_once({
        "distinct_id": $6fb9842575b03497$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property("distinct_id");
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error("Attempting to create alias for existing People user - aborting.");
        return -2;
    }
    var _this = this;
    if ($6fb9842575b03497$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($6fb9842575b03497$var$ALIAS_ID_KEY, alias);
        return this.track("$create_alias", {
            "alias": alias,
            "distinct_id": original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error("alias matches current distinct_id - skipping api call.");
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single("mp_name_tag", name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $6fb9842575b03497$var$MixpanelLib.prototype.set_config = function(config) {
    if ($6fb9842575b03497$var$_.isObject(config)) {
        $6fb9842575b03497$var$_.extend(this["config"], config);
        var new_batch_size = config["batch_size"];
        if (new_batch_size) $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config("persistence_name")) this["config"]["persistence_name"] = this["config"]["cookie_name"];
        if (!this.get_config("disable_persistence")) this["config"]["disable_persistence"] = this["config"]["disable_cookie"];
        if (this["persistence"]) this["persistence"].update_config(this["config"]);
        $6fb9842575b03497$var$Config.DEBUG = $6fb9842575b03497$var$Config.DEBUG || this.get_config("debug");
    }
};
/**
 * returns the current config object for the library.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this["config"][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $6fb9842575b03497$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this["config"]["hooks"][hook_name] || $6fb9842575b03497$var$IDENTITY_FUNC).apply(this, $6fb9842575b03497$var$slice.call(arguments, 1));
    if (typeof ret === "undefined") {
        this.report_error(hook_name + " hook did not return a value");
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this["persistence"].load_prop([
        property_name
    ]);
};
$6fb9842575b03497$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config("name");
    if (name !== $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) name = $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME + "." + name;
    return name;
};
$6fb9842575b03497$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $6fb9842575b03497$var$_.isBlockedUA($6fb9842575b03497$var$userAgent) || this._flags.disable_all_events || $6fb9842575b03497$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$6fb9842575b03497$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $6fb9842575b03497$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            "persistence_type": "cookie"
        })) this.opt_in_tracking({
            "enable_persistence": false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            "persistence_type": "cookie"
        })) this.opt_out_tracking({
            "clear_persistence": false
        });
        this.clear_opt_in_out_tracking({
            "persistence_type": "cookie",
            "enable_persistence": false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        "clear_persistence": true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || $6fb9842575b03497$var$_.cookie.get("mp_optout"))) {
        $6fb9842575b03497$var$_.cookie.remove("mp_optout");
        this.opt_out_tracking({
            "clear_persistence": this.get_config("opt_out_persistence_by_default")
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $6fb9842575b03497$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options["clear_persistence"]) disabled = true;
    else if (options && options["enable_persistence"]) disabled = false;
    else return;
    if (!this.get_config("disable_persistence") && this["persistence"].disabled !== disabled) this["persistence"].set_disabled(disabled);
    if (disabled) this.stop_batch_senders();
    else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$6fb9842575b03497$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $6fb9842575b03497$var$_.extend({
        "track": $6fb9842575b03497$var$_.bind(this.track, this),
        "persistence_type": this.get_config("opt_out_tracking_persistence_type"),
        "cookie_prefix": this.get_config("opt_out_tracking_cookie_prefix"),
        "cookie_expiration": this.get_config("cookie_expiration"),
        "cross_site_cookie": this.get_config("cross_site_cookie"),
        "cross_subdomain_cookie": this.get_config("cross_subdomain_cookie"),
        "cookie_domain": this.get_config("cookie_domain"),
        "secure_cookie": this.get_config("secure_cookie"),
        "ignore_dnt": this.get_config("ignore_dnt")
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$6fb9842575b03497$var$_.localStorage.is_supported()) options["persistence_type"] = "cookie";
    return func(this.get_config("token"), {
        track: options["track"],
        trackEventName: options["track_event_name"],
        trackProperties: options["track_properties"],
        persistenceType: options["persistence_type"],
        persistencePrefix: options["cookie_prefix"],
        cookieDomain: options["cookie_domain"],
        cookieExpiration: options["cookie_expiration"],
        crossSiteCookie: options["cross_site_cookie"],
        crossSubdomainCookie: options["cross_subdomain_cookie"],
        secureCookie: options["secure_cookie"],
        ignoreDnt: options["ignore_dnt"]
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($6fb9842575b03497$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        "clear_persistence": true,
        "delete_user": true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options["delete_user"] && this["people"] && this["people"]._identify_called()) {
        this["people"].delete_user();
        this["people"].clear_charges();
    }
    this._gdpr_call_func($6fb9842575b03497$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($6fb9842575b03497$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($6fb9842575b03497$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($6fb9842575b03497$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$6fb9842575b03497$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $6fb9842575b03497$var$console$1.error.apply($6fb9842575b03497$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config("error_reporter")(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$6fb9842575b03497$var$MixpanelLib.prototype["init"] = $6fb9842575b03497$var$MixpanelLib.prototype.init;
$6fb9842575b03497$var$MixpanelLib.prototype["reset"] = $6fb9842575b03497$var$MixpanelLib.prototype.reset;
$6fb9842575b03497$var$MixpanelLib.prototype["disable"] = $6fb9842575b03497$var$MixpanelLib.prototype.disable;
$6fb9842575b03497$var$MixpanelLib.prototype["time_event"] = $6fb9842575b03497$var$MixpanelLib.prototype.time_event;
$6fb9842575b03497$var$MixpanelLib.prototype["track"] = $6fb9842575b03497$var$MixpanelLib.prototype.track;
$6fb9842575b03497$var$MixpanelLib.prototype["track_links"] = $6fb9842575b03497$var$MixpanelLib.prototype.track_links;
$6fb9842575b03497$var$MixpanelLib.prototype["track_forms"] = $6fb9842575b03497$var$MixpanelLib.prototype.track_forms;
$6fb9842575b03497$var$MixpanelLib.prototype["track_pageview"] = $6fb9842575b03497$var$MixpanelLib.prototype.track_pageview;
$6fb9842575b03497$var$MixpanelLib.prototype["register"] = $6fb9842575b03497$var$MixpanelLib.prototype.register;
$6fb9842575b03497$var$MixpanelLib.prototype["register_once"] = $6fb9842575b03497$var$MixpanelLib.prototype.register_once;
$6fb9842575b03497$var$MixpanelLib.prototype["unregister"] = $6fb9842575b03497$var$MixpanelLib.prototype.unregister;
$6fb9842575b03497$var$MixpanelLib.prototype["identify"] = $6fb9842575b03497$var$MixpanelLib.prototype.identify;
$6fb9842575b03497$var$MixpanelLib.prototype["alias"] = $6fb9842575b03497$var$MixpanelLib.prototype.alias;
$6fb9842575b03497$var$MixpanelLib.prototype["name_tag"] = $6fb9842575b03497$var$MixpanelLib.prototype.name_tag;
$6fb9842575b03497$var$MixpanelLib.prototype["set_config"] = $6fb9842575b03497$var$MixpanelLib.prototype.set_config;
$6fb9842575b03497$var$MixpanelLib.prototype["get_config"] = $6fb9842575b03497$var$MixpanelLib.prototype.get_config;
$6fb9842575b03497$var$MixpanelLib.prototype["get_property"] = $6fb9842575b03497$var$MixpanelLib.prototype.get_property;
$6fb9842575b03497$var$MixpanelLib.prototype["get_distinct_id"] = $6fb9842575b03497$var$MixpanelLib.prototype.get_distinct_id;
$6fb9842575b03497$var$MixpanelLib.prototype["toString"] = $6fb9842575b03497$var$MixpanelLib.prototype.toString;
$6fb9842575b03497$var$MixpanelLib.prototype["opt_out_tracking"] = $6fb9842575b03497$var$MixpanelLib.prototype.opt_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype["opt_in_tracking"] = $6fb9842575b03497$var$MixpanelLib.prototype.opt_in_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype["has_opted_out_tracking"] = $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype["has_opted_in_tracking"] = $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_in_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype["clear_opt_in_out_tracking"] = $6fb9842575b03497$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype["get_group"] = $6fb9842575b03497$var$MixpanelLib.prototype.get_group;
$6fb9842575b03497$var$MixpanelLib.prototype["set_group"] = $6fb9842575b03497$var$MixpanelLib.prototype.set_group;
$6fb9842575b03497$var$MixpanelLib.prototype["add_group"] = $6fb9842575b03497$var$MixpanelLib.prototype.add_group;
$6fb9842575b03497$var$MixpanelLib.prototype["remove_group"] = $6fb9842575b03497$var$MixpanelLib.prototype.remove_group;
$6fb9842575b03497$var$MixpanelLib.prototype["track_with_groups"] = $6fb9842575b03497$var$MixpanelLib.prototype.track_with_groups;
$6fb9842575b03497$var$MixpanelLib.prototype["start_batch_senders"] = $6fb9842575b03497$var$MixpanelLib.prototype.start_batch_senders;
$6fb9842575b03497$var$MixpanelLib.prototype["stop_batch_senders"] = $6fb9842575b03497$var$MixpanelLib.prototype.stop_batch_senders;
$6fb9842575b03497$var$MixpanelLib.prototype["start_session_recording"] = $6fb9842575b03497$var$MixpanelLib.prototype.start_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype["stop_session_recording"] = $6fb9842575b03497$var$MixpanelLib.prototype.stop_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype["get_session_recording_properties"] = $6fb9842575b03497$var$MixpanelLib.prototype.get_session_recording_properties;
$6fb9842575b03497$var$MixpanelLib.prototype["DEFAULT_API_ROUTES"] = $6fb9842575b03497$var$DEFAULT_API_ROUTES;
// MixpanelPersistence Exports
$6fb9842575b03497$var$MixpanelPersistence.prototype["properties"] = $6fb9842575b03497$var$MixpanelPersistence.prototype.properties;
$6fb9842575b03497$var$MixpanelPersistence.prototype["update_search_keyword"] = $6fb9842575b03497$var$MixpanelPersistence.prototype.update_search_keyword;
$6fb9842575b03497$var$MixpanelPersistence.prototype["update_referrer_info"] = $6fb9842575b03497$var$MixpanelPersistence.prototype.update_referrer_info;
$6fb9842575b03497$var$MixpanelPersistence.prototype["get_cross_subdomain"] = $6fb9842575b03497$var$MixpanelPersistence.prototype.get_cross_subdomain;
$6fb9842575b03497$var$MixpanelPersistence.prototype["clear"] = $6fb9842575b03497$var$MixpanelPersistence.prototype.clear;
var $6fb9842575b03497$var$instances = {};
var $6fb9842575b03497$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $6fb9842575b03497$var$_.each($6fb9842575b03497$var$instances, function(instance, name) {
        if (name !== $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) $6fb9842575b03497$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $6fb9842575b03497$var$mixpanel_master["_"] = $6fb9842575b03497$var$_;
};
var $6fb9842575b03497$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $6fb9842575b03497$var$mixpanel_master["init"] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$6fb9842575b03497$var$mixpanel_master[name]) {
                $6fb9842575b03497$var$mixpanel_master[name] = $6fb9842575b03497$var$instances[name] = $6fb9842575b03497$var$create_mplib(token, config, name);
                $6fb9842575b03497$var$mixpanel_master[name]._loaded();
            }
            return $6fb9842575b03497$var$mixpanel_master[name];
        } else {
            var instance = $6fb9842575b03497$var$mixpanel_master;
            if ($6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $6fb9842575b03497$var$create_mplib(token, config, $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $6fb9842575b03497$var$mixpanel_master = instance;
            if ($6fb9842575b03497$var$init_type === $6fb9842575b03497$var$INIT_SNIPPET) $6fb9842575b03497$var$win[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME] = $6fb9842575b03497$var$mixpanel_master;
            $6fb9842575b03497$var$extend_mp();
        }
    };
};
var $6fb9842575b03497$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $6fb9842575b03497$var$DOM_LOADED = true;
        $6fb9842575b03497$var$ENQUEUE_REQUESTS = false;
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $6fb9842575b03497$var$document$1.documentElement.doScroll("left");
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($6fb9842575b03497$var$document$1.addEventListener) {
        if ($6fb9842575b03497$var$document$1.readyState === "complete") // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $6fb9842575b03497$var$document$1.addEventListener("DOMContentLoaded", dom_loaded_handler, false);
    } else if ($6fb9842575b03497$var$document$1.attachEvent) {
        // IE
        $6fb9842575b03497$var$document$1.attachEvent("onreadystatechange", dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $6fb9842575b03497$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($6fb9842575b03497$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $6fb9842575b03497$var$_.register_event($6fb9842575b03497$var$win, "load", dom_loaded_handler, true);
};
function $6fb9842575b03497$var$init_as_module(bundle_loader) {
    $6fb9842575b03497$var$load_extra_bundle = bundle_loader;
    $6fb9842575b03497$var$init_type = $6fb9842575b03497$var$INIT_MODULE;
    $6fb9842575b03497$var$mixpanel_master = new $6fb9842575b03497$var$MixpanelLib();
    $6fb9842575b03497$var$override_mp_init_func();
    $6fb9842575b03497$var$mixpanel_master["init"]();
    $6fb9842575b03497$var$add_dom_loaded_handler();
    return $6fb9842575b03497$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// For builds that have everything in one bundle, no extra work.
function $6fb9842575b03497$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $6fb9842575b03497$export$2e2bcd8739ae039 = $6fb9842575b03497$var$init_as_module($6fb9842575b03497$var$loadNoop);


const $db434a401f2c9abc$var$tracker = (()=>{
    let isInitialized = false;
    const shouldInit = ()=>{
        if (isInitialized) return false;
        return window.location.host === "cms-stage.kargovideo.com" || window.location.host === "video.fabrik.com";
    };
    const init = (config = {})=>{
        if (!shouldInit()) return;
        let token;
        if (window.location.host === "cms-stage.kargovideo.com") token = "99144ac6006d194045bb085160dbb2a9";
        if (window.location.host === "video.fabrik.com") token = "84d187900eb610c048e16c161066c44a";
        if (!token) throw Error("Missing token");
        (0, $6fb9842575b03497$export$2e2bcd8739ae039).init(token, config);
        isInitialized = true;
    };
    const add_group = (key, id)=>{
        if (!isInitialized) return;
        (0, $6fb9842575b03497$export$2e2bcd8739ae039).add_group(key, id);
    };
    const track = (event, properties)=>{
        if (!isInitialized) return;
        (0, $6fb9842575b03497$export$2e2bcd8739ae039).track(event, properties);
    };
    const track_button_click = (id)=>{
        if (!isInitialized) return;
        (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("Button Clicked", {
            button: id
        });
    };
    const track_pageview = (page)=>{
        if (!isInitialized) return;
        (0, $6fb9842575b03497$export$2e2bcd8739ae039).track_pageview(page);
    };
    const identify = (id)=>{
        if (!isInitialized) return;
        (0, $6fb9842575b03497$export$2e2bcd8739ae039).identify(id);
    };
    const reset = ()=>{
        if (!isInitialized) return;
        (0, $6fb9842575b03497$export$2e2bcd8739ae039).reset();
    };
    const people = {
        set: (data)=>{
            if (!isInitialized) return;
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).people.set(data);
        }
    };
    return {
        add_group: add_group,
        init: init,
        track: track,
        track_pageview: track_pageview,
        track_button_click: track_button_click,
        identify: identify,
        reset: reset,
        people: people
    };
})();
var $db434a401f2c9abc$export$2e2bcd8739ae039 = $db434a401f2c9abc$var$tracker;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $39374a9a8256255a$export$e879e0396685d75e() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {});
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $ef0c9f16e4e520e5$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $ef0c9f16e4e520e5$var$__createBinding = $ef0c9f16e4e520e5$exports && $ef0c9f16e4e520e5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ef0c9f16e4e520e5$var$__exportStar = $ef0c9f16e4e520e5$exports && $ef0c9f16e4e520e5$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ef0c9f16e4e520e5$var$__createBinding(exports1, m, p);
};
Object.defineProperty($ef0c9f16e4e520e5$exports, "__esModule", {
    value: true
});
$ef0c9f16e4e520e5$exports.LookerEmbedSDK = void 0;
var $8f410de3e8b48e99$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ Object.defineProperty($8f410de3e8b48e99$exports, "__esModule", {
    value: true
});
$8f410de3e8b48e99$exports.EmbedBuilder = void 0;
var $b3fbc483e1e2bca9$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $b3fbc483e1e2bca9$var$__awaiter = $b3fbc483e1e2bca9$exports && $b3fbc483e1e2bca9$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b3fbc483e1e2bca9$var$__generator = $b3fbc483e1e2bca9$exports && $b3fbc483e1e2bca9$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b3fbc483e1e2bca9$var$__rest = $b3fbc483e1e2bca9$exports && $b3fbc483e1e2bca9$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($b3fbc483e1e2bca9$exports, "__esModule", {
    value: true
});
$b3fbc483e1e2bca9$exports.EmbedClient = void 0;
var $bcb878c6abdbfd50$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $bcb878c6abdbfd50$var$__createBinding = $bcb878c6abdbfd50$exports && $bcb878c6abdbfd50$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bcb878c6abdbfd50$var$__exportStar = $bcb878c6abdbfd50$exports && $bcb878c6abdbfd50$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bcb878c6abdbfd50$var$__createBinding(exports1, m, p);
};
Object.defineProperty($bcb878c6abdbfd50$exports, "__esModule", {
    value: true
});
$bcb878c6abdbfd50$exports.Chatty = $bcb878c6abdbfd50$exports.ChattyHostMessages = $bcb878c6abdbfd50$exports.ChattyClientMessages = $bcb878c6abdbfd50$exports.ChattyHostStates = $bcb878c6abdbfd50$exports.ChattyHost = $bcb878c6abdbfd50$exports.ChattyClientStates = $bcb878c6abdbfd50$exports.ChattyClient = $bcb878c6abdbfd50$exports.ChattyHostBuilder = $bcb878c6abdbfd50$exports.ChattyClientBuilder = void 0;
var $43d276b110beee29$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ Object.defineProperty($43d276b110beee29$exports, "__esModule", {
    value: true
});
$43d276b110beee29$exports.ChattyClientBuilder = void 0;
var $37ef33cd37f414d4$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $37ef33cd37f414d4$var$__assign = $37ef33cd37f414d4$exports && $37ef33cd37f414d4$exports.__assign || function() {
    $37ef33cd37f414d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37ef33cd37f414d4$var$__assign.apply(this, arguments);
};
var $37ef33cd37f414d4$var$__awaiter = $37ef33cd37f414d4$exports && $37ef33cd37f414d4$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $37ef33cd37f414d4$var$__generator = $37ef33cd37f414d4$exports && $37ef33cd37f414d4$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $37ef33cd37f414d4$var$__spreadArray = $37ef33cd37f414d4$exports && $37ef33cd37f414d4$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($37ef33cd37f414d4$exports, "__esModule", {
    value: true
});
$37ef33cd37f414d4$exports.ChattyClient = $37ef33cd37f414d4$exports.ChattyClientStates = void 0;

var $iqpWY = parcelRequire("iqpWY");
var $50fbf9176af0e354$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ Object.defineProperty($50fbf9176af0e354$exports, "__esModule", {
    value: true
});
$50fbf9176af0e354$exports.ChattyClientMessages = void 0;
/**
 * The recognized set of events that are sent from the client to the host.
 * @private
 */ // IMPORTANT - ALWAYS add new members at the END of the enum. Failure to do
// so will break interaction with a different version of chatty.
var $50fbf9176af0e354$var$ChattyClientMessages;
(function(ChattyClientMessages) {
    /** First part of handshake message */ ChattyClientMessages[ChattyClientMessages["Syn"] = 0] = "Syn";
    /** Final part of handshake message */ ChattyClientMessages[ChattyClientMessages["Ack"] = 1] = "Ack";
    /** Normal message */ ChattyClientMessages[ChattyClientMessages["Message"] = 2] = "Message";
    /** Message that expects a response */ ChattyClientMessages[ChattyClientMessages["MessageWithResponse"] = 3] = "MessageWithResponse";
    /** Response */ ChattyClientMessages[ChattyClientMessages["Response"] = 4] = "Response";
    /** Asynchronous error response */ ChattyClientMessages[ChattyClientMessages["ResponseError"] = 5] = "ResponseError";
    /** Abort message */ ChattyClientMessages[ChattyClientMessages["AbortMessage"] = 6] = "AbortMessage";
})($50fbf9176af0e354$var$ChattyClientMessages = $50fbf9176af0e354$exports.ChattyClientMessages || ($50fbf9176af0e354$exports.ChattyClientMessages = {}));


var $9f6ea473a55b9503$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ Object.defineProperty($9f6ea473a55b9503$exports, "__esModule", {
    value: true
});
$9f6ea473a55b9503$exports.ChattyHostMessages = void 0;
/**
 * The recognized set of messages that are sent from the host to the client.
 * @private
 */ // IMPORTANT - ALWAYS add new members at the END of the enum. Failure to do
// so will break interaction with a different version of chatty.
var $9f6ea473a55b9503$var$ChattyHostMessages;
(function(ChattyHostMessages) {
    /** Acknowledge client connection */ ChattyHostMessages[ChattyHostMessages["SynAck"] = 0] = "SynAck";
    /** Normal message */ ChattyHostMessages[ChattyHostMessages["Message"] = 1] = "Message";
    /** Message that expects a response */ ChattyHostMessages[ChattyHostMessages["MessageWithResponse"] = 2] = "MessageWithResponse";
    /** Response  */ ChattyHostMessages[ChattyHostMessages["Response"] = 3] = "Response";
    /** Asynchronous error response */ ChattyHostMessages[ChattyHostMessages["ResponseError"] = 4] = "ResponseError";
    /** Abort message */ ChattyHostMessages[ChattyHostMessages["AbortMessage"] = 5] = "AbortMessage";
})($9f6ea473a55b9503$var$ChattyHostMessages = $9f6ea473a55b9503$exports.ChattyHostMessages || ($9f6ea473a55b9503$exports.ChattyHostMessages = {}));


var $735dce6d90977bd4$exports = {};
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');
"use strict";

$735dce6d90977bd4$exports = (parcelRequire("lcSRC")).polyfill();


/**
 * @private
 * Client connection status
 */ var $37ef33cd37f414d4$var$ChattyClientStates;
(function(ChattyClientStates) {
    ChattyClientStates[ChattyClientStates["Connecting"] = 0] = "Connecting";
    ChattyClientStates[ChattyClientStates["Syn"] = 1] = "Syn";
    ChattyClientStates[ChattyClientStates["Connected"] = 2] = "Connected";
})($37ef33cd37f414d4$var$ChattyClientStates = $37ef33cd37f414d4$exports.ChattyClientStates || ($37ef33cd37f414d4$exports.ChattyClientStates = {}));
/**
 * The client object for an iframe. The user should not create this object directly, it
 * is returned by the [[ChattyClientBuilder.build]] method.
 */ var $37ef33cd37f414d4$var$ChattyClient = /** @class */ function() {
    /**
     * @param builder The client builder that is responsible for constructing this object.
     * @hidden
     */ function ChattyClient(builder) {
        this._clientWindow = window;
        this._connection = null;
        this._hostWindow = this._clientWindow.parent;
        this._state = $37ef33cd37f414d4$var$ChattyClientStates.Connecting;
        this._sequence = 0;
        this._receivers = {};
        this._handlers = builder.handlers;
        this._abortControllers = {};
        this._targetOrigin = builder.targetOrigin;
        this._defaultTimeout = builder.defaultTimeout;
        this._channel = new MessageChannel();
    }
    Object.defineProperty(ChattyClient.prototype, "connection", {
        /**
         * @returns a Promise to an object that resolves when the host has acknowledged the connection.
         */ get: function() {
            return this._connection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyClient.prototype, "isConnected", {
        /**
         * @returns a flag indicating whether the client has successfully connected to the host.
         */ get: function() {
            return this._state === $37ef33cd37f414d4$var$ChattyClientStates.Connected;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Connects to the host window.
     * @returns a Promise to an object that resolves when the host has acknowledged the connection. The
     * object implements the [[ChattyClientConnection]] interface that can be used to talk to the host.
     */ ChattyClient.prototype.connect = function() {
        return $37ef33cd37f414d4$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $37ef33cd37f414d4$var$__generator(this, function(_a) {
                if (this._connection) return [
                    2 /*return*/ ,
                    this._connection
                ];
                this._connection = new Promise(function(resolve, reject) {
                    _this._channel.port1.onmessage = function(evt) {
                        ChattyClient._debug("received", evt.data.action, evt.data.data);
                        switch(evt.data.action){
                            case $9f6ea473a55b9503$exports.ChattyHostMessages.SynAck:
                                _this._state = $37ef33cd37f414d4$var$ChattyClientStates.Connected;
                                _this.sendMsg($50fbf9176af0e354$exports.ChattyClientMessages.Ack);
                                resolve({
                                    send: function(eventName) {
                                        var payload = [];
                                        for(var _i = 1; _i < arguments.length; _i++)payload[_i - 1] = arguments[_i];
                                        _this.sendMsg($50fbf9176af0e354$exports.ChattyClientMessages.Message, {
                                            eventName: eventName,
                                            payload: payload
                                        });
                                    },
                                    sendAndReceive: function(eventName) {
                                        var _payload = [];
                                        for(var _i = 1; _i < arguments.length; _i++)_payload[_i - 1] = arguments[_i];
                                        return $37ef33cd37f414d4$var$__awaiter(_this, void 0, void 0, function() {
                                            var signal, propagateSignal, payload, options, sequence;
                                            var _this = this;
                                            var _a, _b;
                                            return $37ef33cd37f414d4$var$__generator(this, function(_c) {
                                                if (_payload.length > 0 && ((_a = _payload[_payload.length - 1]) === null || _a === void 0 ? void 0 : _a.signal) && ((_b = _payload[_payload.length - 1]) === null || _b === void 0 ? void 0 : _b.signal) instanceof AbortSignal) {
                                                    options = _payload[_payload.length - 1];
                                                    signal = options.signal;
                                                    propagateSignal = options.propagateSignal;
                                                    payload = _payload.slice(0, _payload.length - 1);
                                                } else payload = _payload;
                                                sequence = ++this._sequence;
                                                this.sendMsg($50fbf9176af0e354$exports.ChattyClientMessages.MessageWithResponse, {
                                                    eventName: eventName,
                                                    payload: payload
                                                }, sequence, propagateSignal);
                                                return [
                                                    2 /*return*/ ,
                                                    new Promise(function(resolve, reject) {
                                                        var timeoutId;
                                                        if (signal) signal.addEventListener("abort", function(event) {
                                                            var errorMessage = event.target.reason;
                                                            if (typeof errorMessage !== "string") errorMessage = "Abort";
                                                            if (propagateSignal) _this.sendMsg($50fbf9176af0e354$exports.ChattyClientMessages.AbortMessage, {
                                                                eventName: eventName,
                                                                payload: {
                                                                    reason: errorMessage
                                                                }
                                                            }, sequence);
                                                            delete _this._receivers[sequence];
                                                            reject(new Error(errorMessage));
                                                        });
                                                        else if (_this._defaultTimeout > -1) timeoutId = setTimeout(function() {
                                                            delete _this._receivers[sequence];
                                                            reject(new Error("Timeout"));
                                                        }, _this._defaultTimeout);
                                                        _this._receivers[sequence] = {
                                                            reject: reject,
                                                            resolve: resolve,
                                                            timeoutId: timeoutId
                                                        };
                                                    })
                                                ];
                                            });
                                        });
                                    }
                                });
                                break;
                            case $9f6ea473a55b9503$exports.ChattyHostMessages.Message:
                                if (_this._handlers[evt.data.data.eventName]) _this._handlers[evt.data.data.eventName].forEach(function(fn) {
                                    return fn.apply(_this, evt.data.data.payload);
                                });
                                break;
                            case $9f6ea473a55b9503$exports.ChattyHostMessages.MessageWithResponse:
                                var _a = evt.data.data, eventName_1 = _a.eventName, payload = _a.payload, sequence_1 = _a.sequence, signal = _a.signal;
                                var results = [];
                                var abortStoreName_1 = "".concat(eventName_1).concat(sequence_1);
                                if (_this._handlers[eventName_1]) {
                                    var _payload_1;
                                    if (signal) {
                                        _this._abortControllers[abortStoreName_1] = new AbortController();
                                        if (Array.isArray(payload)) _payload_1 = $37ef33cd37f414d4$var$__spreadArray($37ef33cd37f414d4$var$__spreadArray([], payload, true), [
                                            _this._abortControllers[abortStoreName_1].signal
                                        ], false);
                                        else _payload_1 = [
                                            payload,
                                            _this._abortControllers[abortStoreName_1].signal
                                        ];
                                    } else _payload_1 = payload;
                                    results = _this._handlers[eventName_1].map(function(fn) {
                                        return fn.apply(_this, _payload_1);
                                    });
                                }
                                Promise.all(results).then(function(resolvedResults) {
                                    delete _this._abortControllers[abortStoreName_1];
                                    _this.sendMsg($50fbf9176af0e354$exports.ChattyClientMessages.Response, {
                                        eventName: eventName_1,
                                        payload: resolvedResults
                                    }, sequence_1);
                                }).catch(function(error) {
                                    delete _this._abortControllers[abortStoreName_1];
                                    _this.sendMsg($50fbf9176af0e354$exports.ChattyClientMessages.ResponseError, {
                                        eventName: eventName_1,
                                        payload: error.toString()
                                    }, sequence_1);
                                });
                                break;
                            case $9f6ea473a55b9503$exports.ChattyHostMessages.AbortMessage:
                                var _b = evt.data.data, eventName = _b.eventName, payload = _b.payload, sequence = _b.sequence;
                                var abortStoreName = "".concat(eventName).concat(sequence);
                                if (_this._abortControllers[abortStoreName]) {
                                    _this._abortControllers[abortStoreName].abort(payload === null || payload === void 0 ? void 0 : payload.reason);
                                    delete _this._abortControllers[abortStoreName];
                                }
                                break;
                            case $9f6ea473a55b9503$exports.ChattyHostMessages.Response:
                                var receiver = _this._receivers[evt.data.data.sequence];
                                if (receiver) {
                                    delete _this._receivers[evt.data.data.sequence];
                                    if (receiver.timeoutId) clearTimeout(receiver.timeoutId);
                                    receiver.resolve(evt.data.data.payload);
                                }
                                break;
                            case $9f6ea473a55b9503$exports.ChattyHostMessages.ResponseError:
                                var receiver = _this._receivers[evt.data.data.sequence];
                                if (receiver) {
                                    delete _this._receivers[evt.data.data.sequence];
                                    if (receiver.timeoutId) clearTimeout(receiver.timeoutId);
                                    receiver.reject(typeof evt.data.data.payload === "string" ? new Error(evt.data.data.payload) : evt.data.data.payload);
                                }
                                break;
                        }
                    };
                    _this.initiateHandshake();
                });
                return [
                    2 /*return*/ ,
                    this._connection
                ];
            });
        });
    };
    ChattyClient.prototype.initiateHandshake = function() {
        ChattyClient._debug("connecting to", this._targetOrigin);
        this._hostWindow.postMessage({
            action: $50fbf9176af0e354$exports.ChattyClientMessages.Syn
        }, this._targetOrigin, [
            this._channel.port2
        ]);
        this._state = $37ef33cd37f414d4$var$ChattyClientStates.Syn;
    };
    ChattyClient.prototype.sendMsg = function(action, data, sequence, propagateSignal) {
        if (data === void 0) data = {};
        var sequenceData = sequence ? {
            sequence: sequence
        } : {};
        var signalData = propagateSignal === true ? {
            signal: propagateSignal
        } : {};
        var dataWithSequence = $37ef33cd37f414d4$var$__assign($37ef33cd37f414d4$var$__assign($37ef33cd37f414d4$var$__assign({}, data), sequenceData), signalData);
        ChattyClient._debug("sending", action, dataWithSequence);
        this._channel.port1.postMessage({
            action: action,
            data: dataWithSequence
        });
    };
    ChattyClient._debug = $iqpWY("looker:chatty:client");
    return ChattyClient;
}();
$37ef33cd37f414d4$exports.ChattyClient = $37ef33cd37f414d4$var$ChattyClient;


/**
 * Provides methods to define the properties of a [[ChattyClient]]
 */ var $43d276b110beee29$var$ChattyClientBuilder = /** @class */ function() {
    function ChattyClientBuilder() {
        this._targetOrigin = "*";
        this._handlers = {};
        this._defaultTimeout = 30000;
    }
    Object.defineProperty(ChattyClientBuilder.prototype, "targetOrigin", {
        get: function() {
            return this._targetOrigin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyClientBuilder.prototype, "handlers", {
        get: function() {
            return this._handlers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyClientBuilder.prototype, "defaultTimeout", {
        get: function() {
            return this._defaultTimeout;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Removes an event handler to the client.
     *
     * @param name Event name
     * @param fn Callback function to remove
     * @returns the client builder
     */ ChattyClientBuilder.prototype.off = function(name, fn) {
        if (this._handlers[name]) this._handlers[name] = this._handlers[name].filter(function(handler) {
            return handler !== fn;
        });
    };
    /**
     * Adds an event handler to the client.
     *
     * @param name Event name to which to listen.
     * @param fn Callback function that is invoked when the event
     * is received, and accepts any parameters that were passed with the event.
     * If the event received is sent using [[ChattyHostConnection.sendAndReceive]], its return value is
     * included in the array that will be passed to the resolved promise.
     * @returns the client builder
     */ ChattyClientBuilder.prototype.on = function(name, fn) {
        this._handlers[name] = this._handlers[name] || [];
        this._handlers[name].push(fn);
        return this;
    };
    /**
     * Sets the default period of time a [[ChattyClientConnection.sendAndReceive]] message will wait.
     * Use a negative number to wait indefinitely.
     * The default is 30000ms
     *
     * @param timeout in milliseconds
     * @returns the client builder
     */ ChattyClientBuilder.prototype.withDefaultTimeout = function(timeout) {
        this._defaultTimeout = timeout;
        return this;
    };
    /**
     * Optional. Sets the target origin parameter used to communicate with the host. Default
     * is '*'. If possible it should be set the the host window's origin.
     *
     * @param targetOrigin targetOrigin to use with postMessage()
     * @returns the client builder
     */ ChattyClientBuilder.prototype.withTargetOrigin = function(targetOrigin) {
        this._targetOrigin = targetOrigin;
        return this;
    };
    /**
     * Builds a [[ChattyClient]] with the provided properties.
     * @returns a new Chatty client.
     */ ChattyClientBuilder.prototype.build = function() {
        return new $37ef33cd37f414d4$exports.ChattyClient(this);
    };
    return ChattyClientBuilder;
}();
$43d276b110beee29$exports.ChattyClientBuilder = $43d276b110beee29$var$ChattyClientBuilder;


var $910d8f7605aa2b65$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ Object.defineProperty($910d8f7605aa2b65$exports, "__esModule", {
    value: true
});
$910d8f7605aa2b65$exports.ChattyHostBuilder = void 0;
var $0b0da33dcbc0a299$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2021 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $0b0da33dcbc0a299$var$__assign = $0b0da33dcbc0a299$exports && $0b0da33dcbc0a299$exports.__assign || function() {
    $0b0da33dcbc0a299$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b0da33dcbc0a299$var$__assign.apply(this, arguments);
};
var $0b0da33dcbc0a299$var$__awaiter = $0b0da33dcbc0a299$exports && $0b0da33dcbc0a299$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0b0da33dcbc0a299$var$__generator = $0b0da33dcbc0a299$exports && $0b0da33dcbc0a299$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0b0da33dcbc0a299$var$__spreadArray = $0b0da33dcbc0a299$exports && $0b0da33dcbc0a299$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($0b0da33dcbc0a299$exports, "__esModule", {
    value: true
});
$0b0da33dcbc0a299$exports.ChattyHost = $0b0da33dcbc0a299$exports.ChattyHostStates = void 0;

var $iqpWY = parcelRequire("iqpWY");



/**
 * @private
 * Host connection status
 */ var $0b0da33dcbc0a299$var$ChattyHostStates;
(function(ChattyHostStates) {
    ChattyHostStates[ChattyHostStates["Connecting"] = 0] = "Connecting";
    ChattyHostStates[ChattyHostStates["SynAck"] = 1] = "SynAck";
    ChattyHostStates[ChattyHostStates["Connected"] = 2] = "Connected";
})($0b0da33dcbc0a299$var$ChattyHostStates = $0b0da33dcbc0a299$exports.ChattyHostStates || ($0b0da33dcbc0a299$exports.ChattyHostStates = {}));
/**
 * The host object for an iframe. The user should not create this object directly, it
 * is returned by the [[ChattyHostBuilder.build]] method.
 */ var $0b0da33dcbc0a299$var$ChattyHost = /** @class */ function() {
    /**
     * @param builder The client builder that is responsible for constructing this object.
     * @hidden
     */ function ChattyHost(builder) {
        var _this = this;
        this._hostWindow = window;
        this._connection = null;
        this._state = $0b0da33dcbc0a299$var$ChattyHostStates.Connecting;
        this._sequence = 0;
        this._receivers = {};
        this.iframe = document.createElement("iframe");
        builder.sandboxAttrs.forEach(function(attr) {
            return _this.iframe.sandbox.add(attr);
        });
        if ("allow" in this.iframe) this.iframe.allow = builder.allowAttrs.join("; ");
        // tslint:disable-next-line:deprecation
        this.iframe.frameBorder = builder.getFrameBorder();
        if (builder.url) this.iframe.src = builder.url;
        else if (builder.source) this.iframe.srcdoc = builder.source;
        else console.warn("url or source required to initialize Chatty host correctly");
        this._appendTo = builder.el;
        this._handlers = builder.handlers;
        this._abortControllers = {};
        this._port = null;
        this._targetOrigin = builder.targetOrigin;
        this._defaultTimeout = builder.defaultTimeout;
    }
    Object.defineProperty(ChattyHost.prototype, "connection", {
        /**
         * @returns a Promise to an object that resolves when the client initiates the connection.
         */ get: function() {
            return this._connection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHost.prototype, "isConnected", {
        /**
         * @returns a flag indicating whether the client successfully connected to the host.
         */ get: function() {
            return this._state === $0b0da33dcbc0a299$var$ChattyHostStates.Connected;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Connects to the client iframe. Waits for the client iframe to load and initiate a
     * connection using the chatty client.
     *
     * @returns a Promise to an object that resolves when the client has initiated the connection. The
     * object implements the [[ChattyHostConnection]] that can be used to talk to the host.
     */ ChattyHost.prototype.connect = function() {
        return $0b0da33dcbc0a299$var$__awaiter(this, void 0, void 0, function() {
            var createConnection;
            var _this = this;
            return $0b0da33dcbc0a299$var$__generator(this, function(_a) {
                if (this._connection) return [
                    2 /*return*/ ,
                    this._connection
                ];
                createConnection = function() {
                    return $0b0da33dcbc0a299$var$__awaiter(_this, void 0, void 0, function() {
                        var _this = this;
                        return $0b0da33dcbc0a299$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(resolve, reject) {
                                    var eventListener = function(evt) {
                                        ChattyHost._debug("port received", evt.data.action, evt.data.data);
                                        switch(evt.data.action){
                                            case $50fbf9176af0e354$exports.ChattyClientMessages.Ack:
                                                _this._state = $0b0da33dcbc0a299$var$ChattyHostStates.Connected;
                                                resolve({
                                                    send: function(eventName) {
                                                        var payload = [];
                                                        for(var _i = 1; _i < arguments.length; _i++)payload[_i - 1] = arguments[_i];
                                                        _this.sendMsg($9f6ea473a55b9503$exports.ChattyHostMessages.Message, {
                                                            eventName: eventName,
                                                            payload: payload
                                                        });
                                                    },
                                                    sendAndReceive: function(eventName) {
                                                        var _payload = [];
                                                        for(var _i = 1; _i < arguments.length; _i++)_payload[_i - 1] = arguments[_i];
                                                        return $0b0da33dcbc0a299$var$__awaiter(_this, void 0, void 0, function() {
                                                            var signal, propagateSignal, payload, options, sequence;
                                                            var _this = this;
                                                            var _a, _b;
                                                            return $0b0da33dcbc0a299$var$__generator(this, function(_c) {
                                                                if (_payload.length > 0 && ((_a = _payload[_payload.length - 1]) === null || _a === void 0 ? void 0 : _a.signal) && ((_b = _payload[_payload.length - 1]) === null || _b === void 0 ? void 0 : _b.signal) instanceof AbortSignal) {
                                                                    options = _payload[_payload.length - 1];
                                                                    signal = options.signal;
                                                                    propagateSignal = options.propagateSignal;
                                                                    payload = _payload.slice(0, _payload.length - 1);
                                                                } else payload = _payload;
                                                                sequence = ++this._sequence;
                                                                this.sendMsg($9f6ea473a55b9503$exports.ChattyHostMessages.MessageWithResponse, {
                                                                    eventName: eventName,
                                                                    payload: payload
                                                                }, sequence, propagateSignal);
                                                                return [
                                                                    2 /*return*/ ,
                                                                    new Promise(function(resolve, reject) {
                                                                        var timeoutId;
                                                                        if (signal) signal.addEventListener("abort", function(event) {
                                                                            if (propagateSignal) {
                                                                                var errorMessage_1 = event.target.reason;
                                                                                if (typeof errorMessage_1 !== "string") errorMessage_1 = "Abort";
                                                                                _this.sendMsg($9f6ea473a55b9503$exports.ChattyHostMessages.AbortMessage, {
                                                                                    eventName: eventName,
                                                                                    payload: {
                                                                                        reason: errorMessage_1
                                                                                    }
                                                                                }, sequence);
                                                                            }
                                                                            delete _this._receivers[sequence];
                                                                            var errorMessage = event.target.reason;
                                                                            if (typeof errorMessage !== "string") errorMessage = "Abort";
                                                                            reject(new Error(errorMessage));
                                                                        });
                                                                        else if (_this._defaultTimeout > -1) timeoutId = setTimeout(function() {
                                                                            delete _this._receivers[sequence];
                                                                            reject(new Error("Timeout"));
                                                                        }, _this._defaultTimeout);
                                                                        _this._receivers[sequence] = {
                                                                            reject: reject,
                                                                            resolve: resolve,
                                                                            timeoutId: timeoutId
                                                                        };
                                                                    })
                                                                ];
                                                            });
                                                        });
                                                    }
                                                });
                                                break;
                                            case $50fbf9176af0e354$exports.ChattyClientMessages.Message:
                                                if (_this._handlers[evt.data.data.eventName]) _this._handlers[evt.data.data.eventName].forEach(function(fn) {
                                                    return fn.apply(_this, evt.data.data.payload);
                                                });
                                                break;
                                            case $50fbf9176af0e354$exports.ChattyClientMessages.MessageWithResponse:
                                                var _a = evt.data.data, eventName_1 = _a.eventName, payload = _a.payload, sequence_1 = _a.sequence, signal = _a.signal;
                                                var results = [];
                                                var abortStoreName_1 = "".concat(eventName_1).concat(sequence_1);
                                                if (_this._handlers[eventName_1]) {
                                                    var _payload_1;
                                                    if (signal) {
                                                        _this._abortControllers[abortStoreName_1] = new AbortController();
                                                        if (Array.isArray(payload)) _payload_1 = $0b0da33dcbc0a299$var$__spreadArray($0b0da33dcbc0a299$var$__spreadArray([], payload, true), [
                                                            _this._abortControllers[abortStoreName_1].signal
                                                        ], false);
                                                        else _payload_1 = [
                                                            payload,
                                                            _this._abortControllers[abortStoreName_1].signal
                                                        ];
                                                    } else _payload_1 = payload;
                                                    results = _this._handlers[eventName_1].map(function(fn) {
                                                        return fn.apply(_this, _payload_1);
                                                    });
                                                }
                                                Promise.all(results).then(function(resolvedResults) {
                                                    delete _this._abortControllers[abortStoreName_1];
                                                    _this.sendMsg($9f6ea473a55b9503$exports.ChattyHostMessages.Response, {
                                                        eventName: eventName_1,
                                                        payload: resolvedResults
                                                    }, sequence_1);
                                                }).catch(function(error) {
                                                    delete _this._abortControllers[abortStoreName_1];
                                                    _this.sendMsg($9f6ea473a55b9503$exports.ChattyHostMessages.ResponseError, {
                                                        eventName: eventName_1,
                                                        payload: error.toString()
                                                    }, sequence_1);
                                                });
                                                break;
                                            case $50fbf9176af0e354$exports.ChattyClientMessages.AbortMessage:
                                                var _b = evt.data.data, eventName = _b.eventName, payload = _b.payload, sequence = _b.sequence;
                                                var abortStoreName = "".concat(eventName).concat(sequence);
                                                if (_this._abortControllers[abortStoreName]) {
                                                    _this._abortControllers[abortStoreName].abort(payload === null || payload === void 0 ? void 0 : payload.reason);
                                                    delete _this._abortControllers[abortStoreName];
                                                }
                                                break;
                                            case $50fbf9176af0e354$exports.ChattyClientMessages.Response:
                                                var receiver = _this._receivers[evt.data.data.sequence];
                                                if (receiver) {
                                                    delete _this._receivers[evt.data.data.sequence];
                                                    if (receiver.timeoutId) clearTimeout(receiver.timeoutId);
                                                    receiver.resolve(evt.data.data.payload);
                                                }
                                                break;
                                            case $50fbf9176af0e354$exports.ChattyClientMessages.ResponseError:
                                                var receiver = _this._receivers[evt.data.data.sequence];
                                                if (receiver) {
                                                    delete _this._receivers[evt.data.data.sequence];
                                                    if (receiver.timeoutId) clearTimeout(receiver.timeoutId);
                                                    receiver.reject(typeof evt.data.data.payload === "string" ? new Error(evt.data.data.payload) : evt.data.data.payload);
                                                }
                                                break;
                                        }
                                    };
                                    var windowListener = function(evt) {
                                        if (!_this.isValidMsg(evt)) {
                                            // don't reject here, since that breaks the promise resolution chain
                                            ChattyHost._debug("window received invalid", evt);
                                            return;
                                        }
                                        ChattyHost._debug("window received", evt.data.action, evt.data.data);
                                        switch(evt.data.action){
                                            case $50fbf9176af0e354$exports.ChattyClientMessages.Syn:
                                                if (_this._port) {
                                                    // If targetOrigin is set and we receive another Syn, the frame has potentially
                                                    // navigated to another valid webpage and we should re-connect
                                                    if (_this._targetOrigin && _this._targetOrigin === "*" || _this._targetOrigin === evt.origin) {
                                                        ChattyHost._debug("reconnecting to", evt.origin);
                                                        _this._port.close();
                                                    } else {
                                                        ChattyHost._debug("rejected new connection from", evt.origin);
                                                        return;
                                                    }
                                                }
                                                _this._port = evt.ports[0];
                                                _this._port.onmessage = eventListener;
                                                _this.sendMsg($9f6ea473a55b9503$exports.ChattyHostMessages.SynAck);
                                                _this._state = $0b0da33dcbc0a299$var$ChattyHostStates.SynAck;
                                                break;
                                        }
                                    };
                                    _this._hostWindow.addEventListener("message", windowListener);
                                })
                            ];
                        });
                    });
                };
                this._appendTo.appendChild(this.iframe);
                return [
                    2 /*return*/ ,
                    this._connection = createConnection()
                ];
            });
        });
    };
    ChattyHost.prototype.sendMsg = function(action, data, sequence, propagateSignal) {
        if (data === void 0) data = {};
        var sequenceData = sequence ? {
            sequence: sequence
        } : {};
        var signalData = propagateSignal === true ? {
            signal: propagateSignal
        } : {};
        var dataWithSequence = $0b0da33dcbc0a299$var$__assign($0b0da33dcbc0a299$var$__assign($0b0da33dcbc0a299$var$__assign({}, data), sequenceData), signalData);
        ChattyHost._debug("sending", action, dataWithSequence);
        this._port.postMessage({
            action: action,
            data: dataWithSequence
        });
    };
    // TODO: natenate
    // Frustratingly, enabling `allow-scripts` on a sandboxed iframe sets its origin to `'null'`
    // (that is, a string literal with a value of null). This means that in order to `postMessage`
    // to the client we must use `'*'` as the origin parameter.  To ensure messages received from
    // the client are who they claim to be, we check the origin is `'null'` and the contentWindow
    // is the one we have access to from the parent frame.  This method is described here:
    // https://www.html5rocks.com/en/tutorials/security/sandboxed-iframes/#safely-sandboxing-eval
    // If sandboxing is not enabled targetOrigin can be set and validated
    ChattyHost.prototype.isValidMsg = function(evt) {
        if (evt.source !== this.iframe.contentWindow) return false;
        if (this._targetOrigin && !(this._targetOrigin === "*" || this._targetOrigin === evt.origin)) return false;
        return true;
    };
    ChattyHost._debug = $iqpWY("looker:chatty:host");
    return ChattyHost;
}();
$0b0da33dcbc0a299$exports.ChattyHost = $0b0da33dcbc0a299$var$ChattyHost;


/**
 * Provides methods to define the properties of a [[ChattyHost]]
 */ var $910d8f7605aa2b65$var$ChattyHostBuilder = /** @class */ function() {
    /** @hidden */ function ChattyHostBuilder(_url, _source) {
        this._url = _url;
        this._source = _source;
        this._appendTo = null;
        this._handlers = {};
        this._sandboxAttrs = [];
        this._allowAttrs = [];
        this._frameBorder = "0";
        this._targetOrigin = null;
        this._defaultTimeout = 30000;
    }
    Object.defineProperty(ChattyHostBuilder.prototype, "el", {
        get: function() {
            return this._appendTo || document.body;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHostBuilder.prototype, "handlers", {
        get: function() {
            return this._handlers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHostBuilder.prototype, "sandboxAttrs", {
        get: function() {
            return this._sandboxAttrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHostBuilder.prototype, "allowAttrs", {
        get: function() {
            return this._allowAttrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHostBuilder.prototype, "targetOrigin", {
        get: function() {
            return this._targetOrigin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHostBuilder.prototype, "url", {
        get: function() {
            return this._url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHostBuilder.prototype, "source", {
        get: function() {
            return this._source;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChattyHostBuilder.prototype, "defaultTimeout", {
        get: function() {
            return this._defaultTimeout;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @param el the HTML element that the iframe will live inside. The iframe will be created as
     * a direct child of the element.
     * @returns the host builder
     */ ChattyHostBuilder.prototype.appendTo = function(el) {
        this._appendTo = el;
        return this;
    };
    /**
     * Removes an event handler to the host.
     *
     * @param name Event name
     * @param fn Callback function to remove.
     * @returns the host builder
     */ ChattyHostBuilder.prototype.off = function(name, fn) {
        if (this._handlers[name]) this._handlers[name] = this._handlers[name].filter(function(handler) {
            return handler !== fn;
        });
    };
    /**
     * Adds an event handler to the host.
     *
     * @param name Event name to which to listen.
     * @param fn Callback function that is invoked when the event
     * is received, and accepts any parameters that were passed with the event. If the event
     * received is sent using [[ChattyClientConnection.sendAndReceive]], its return value is included
     * in the array that will be passed to the resolved promise.
     * @returns the host builder
     */ ChattyHostBuilder.prototype.on = function(name, fn) {
        this._handlers[name] = this._handlers[name] || [];
        this._handlers[name].push(fn);
        return this;
    };
    /**
     * Sets the default period of time a [[ChattyHostConnection.sendAndReceive]] message will wait.
     * Use a negative number to wait indefinitely.
     *
     * @param timeout in milliseconds
     * @returns the host builder
     */ ChattyHostBuilder.prototype.withDefaultTimeout = function(timeout) {
        this._defaultTimeout = timeout;
        return this;
    };
    /** @deprecated The frame-board attribute is deprecated, use CSS instead */ ChattyHostBuilder.prototype.getFrameBorder = function() {
        return this._frameBorder;
    };
    /** @deprecated The frame-board attribute is deprecated, use CSS instead */ ChattyHostBuilder.prototype.frameBorder = function(attr) {
        this._frameBorder = attr;
        return this;
    };
    /** @deprecated Replaced by [[withSandboxAttribute]] */ ChattyHostBuilder.prototype.sandbox = function(attr) {
        this.withSandboxAttribute(attr);
        return this;
    };
    /**
     * Create the iframe with the given sandbox attribute
     *
     * @param attr The sandbox attribute
     */ ChattyHostBuilder.prototype.withSandboxAttribute = function(attr) {
        this._sandboxAttrs.push(attr);
        return this;
    };
    /**
     * Create the iframe with the given allow attribute
     *
     * @param attr The sandbox attribute
     */ ChattyHostBuilder.prototype.withAllowAttribute = function(attr) {
        this._allowAttrs.push(attr);
        return this;
    };
    /**
     * Use `targetOrigin` as the value for postMessage(). See
     * [Window.postMessage()](https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage)
     * for details.
     *
     * @param targetOrigin
     */ ChattyHostBuilder.prototype.withTargetOrigin = function(targetOrigin) {
        this._targetOrigin = targetOrigin;
        return this;
    };
    /**
     * Builds a [[ChattyHost]] with the provided properties.
     */ ChattyHostBuilder.prototype.build = function() {
        return new $0b0da33dcbc0a299$exports.ChattyHost(this);
    };
    return ChattyHostBuilder;
}();
$910d8f7605aa2b65$exports.ChattyHostBuilder = $910d8f7605aa2b65$var$ChattyHostBuilder;



Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyClientBuilder", {
    enumerable: true,
    get: function() {
        return $43d276b110beee29$exports.ChattyClientBuilder;
    }
});

Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyHostBuilder", {
    enumerable: true,
    get: function() {
        return $910d8f7605aa2b65$exports.ChattyHostBuilder;
    }
});

Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyClient", {
    enumerable: true,
    get: function() {
        return $37ef33cd37f414d4$exports.ChattyClient;
    }
});
Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyClientStates", {
    enumerable: true,
    get: function() {
        return $37ef33cd37f414d4$exports.ChattyClientStates;
    }
});

Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyHost", {
    enumerable: true,
    get: function() {
        return $0b0da33dcbc0a299$exports.ChattyHost;
    }
});
Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyHostStates", {
    enumerable: true,
    get: function() {
        return $0b0da33dcbc0a299$exports.ChattyHostStates;
    }
});

Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyClientMessages", {
    enumerable: true,
    get: function() {
        return $50fbf9176af0e354$exports.ChattyClientMessages;
    }
});

Object.defineProperty($bcb878c6abdbfd50$exports, "ChattyHostMessages", {
    enumerable: true,
    get: function() {
        return $9f6ea473a55b9503$exports.ChattyHostMessages;
    }
});

$bcb878c6abdbfd50$var$__exportStar((parcelRequire("c5tG7")), $bcb878c6abdbfd50$exports);
/**
 * @class Chatty
 *
 * Primary interface for chatty. Provides methods for creating the chatty hosts and clients.
 */ var $bcb878c6abdbfd50$var$Chatty = /** @class */ function() {
    function Chatty() {}
    /**
     * Creates a [[ChattyHostBuilder]] object. The builder presents a set of methods to configure
     * and construct the host object.
     *
     * It is up to the client's webserver to return the correct headers to allow for parent/iframe
     * communication. See
     * [Window.postMessage()](https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage)
     * for details.
     *
     * @param url The URL of the client iframe to create. The hosted iframe should create a chatty
     * client to communicate with the host.
     */ Chatty.createHost = function(url) {
        return new $910d8f7605aa2b65$exports.ChattyHostBuilder(url);
    };
    /**
     * Creates a [[ChattyHostBuilder]] object. The builder presents a set of methods to configure
     * and construct the host object.
     *
     * @param source The source of the client iframe to create. The hosted iframe should create a chatty
     * client to communicate with the host.
     */ Chatty.createHostFromSource = function(source) {
        return new $910d8f7605aa2b65$exports.ChattyHostBuilder(undefined, source);
    };
    /**
     * Creates a [[ChattyClientBuilder]] object. The builder presents a set of methods to configure
     * and construct the client object.
     */ Chatty.createClient = function() {
        return new $43d276b110beee29$exports.ChattyClientBuilder();
    };
    return Chatty;
}();
$bcb878c6abdbfd50$exports.Chatty = $bcb878c6abdbfd50$var$Chatty;


var $b3fbc483e1e2bca9$var$IS_URL = /^https?:\/\//;
/**
 * Wrapper for Looker embedded content. Provides a mechanism for creating the embedded content element,
 * and for establishing two-way communication between the parent window and the embedded content.
 */ var $b3fbc483e1e2bca9$var$EmbedClient = /** @class */ function() {
    /**
     * @hidden
     */ function EmbedClient(_builder) {
        this._builder = _builder;
        this._hostBuilder = null;
        this._host = null;
        this._connection = null;
        this._client = null;
        this._cookielessInitialized = false;
    }
    Object.defineProperty(EmbedClient.prototype, "connection", {
        /**
         * Returns a promise that resolves to a client that can be used to send messages to the
         * embedded content.
         */ get: function() {
            return this._connection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedClient.prototype, "isConnected", {
        /**
         * Indicates whether two way communication has successfully been established with the embedded content.
         */ get: function() {
            return !!this._connection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedClient.prototype, "targetOrigin", {
        get: function() {
            if (this._builder.sandboxedHost) return "*";
            var apiHost = this._builder.apiHost;
            return $b3fbc483e1e2bca9$var$IS_URL.test(apiHost) ? apiHost : "https://".concat(apiHost);
        },
        enumerable: false,
        configurable: true
    });
    EmbedClient.prototype.createIframe = function(url) {
        return $b3fbc483e1e2bca9$var$__awaiter(this, void 0, void 0, function() {
            var eventType, _loop_1, this_1, _i, _a, handler, _b, _c, attr, _d, _e, attr;
            var _f;
            var _this = this;
            return $b3fbc483e1e2bca9$var$__generator(this, function(_g) {
                this._hostBuilder = $bcb878c6abdbfd50$exports.Chatty.createHost(url);
                if (this._builder.dialogScroll) this._builder.handlers["env:client:dialog"] = [
                    function(_a) {
                        var open = _a.open, placement = _a.placement;
                        // Placement of 'cover' means that the dialog top is close
                        // to the top of the IFRAME. The top MAY be scrolled out
                        // of view. The following attempts to scroll the top of the
                        // dialog into view.
                        if (open && placement === "cover") // Timeout is a little ugly. Suspect there might be an issue
                        // with a Looker component where the last row is scrolled
                        // into view. Normally not an issue because outside of embed
                        // as the dialog is limited to the viewport.
                        // Make timeout configurable?
                        window.setTimeout(function() {
                            if (_this._host) _this._host.iframe.scrollIntoView(true);
                        }, 200);
                    }
                ];
                if (this._builder.dynamicIFrameHeight) this._builder.handlers["page:properties:changed"] = [
                    function(_a) {
                        var height = _a.height;
                        if (height && height > 100 && _this._host) _this._host.iframe.style.height = "".concat(height, "px");
                    }
                ];
                if (this._builder.isCookielessEmbed) this._builder.handlers["session:tokens:request"] = [
                    function() {
                        return $b3fbc483e1e2bca9$var$__awaiter(_this, void 0, void 0, function() {
                            var _a, api_token, api_token_ttl, navigation_token, navigation_token_ttl, session_reference_token_ttl, client;
                            return $b3fbc483e1e2bca9$var$__generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        if (!(this._client && this._cookielessApiToken && this._builder.generateTokens)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        if (!this._cookielessInitialized) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.generateTokens()
                                        ];
                                    case 1:
                                        _a = _b.sent(), api_token = _a.api_token, api_token_ttl = _a.api_token_ttl, navigation_token = _a.navigation_token, navigation_token_ttl = _a.navigation_token_ttl, session_reference_token_ttl = _a.session_reference_token_ttl;
                                        this._cookielessApiToken = api_token;
                                        this._cookielessApiTokenTtl = api_token_ttl;
                                        this._cookielessNavigationToken = navigation_token;
                                        this._cookielessNavigationTokenTtl = navigation_token_ttl;
                                        this._cookielessSessionReferenceTokenTtl = session_reference_token_ttl;
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 2:
                                        this._cookielessInitialized = true;
                                        _b.label = 3;
                                    case 3:
                                        client = this._client;
                                        client.send("session:tokens", {
                                            api_token: this._cookielessApiToken,
                                            api_token_ttl: this._cookielessApiTokenTtl,
                                            navigation_token: this._cookielessNavigationToken,
                                            navigation_token_ttl: this._cookielessNavigationTokenTtl,
                                            session_reference_token_ttl: this._cookielessSessionReferenceTokenTtl
                                        });
                                        _b.label = 4;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    }
                ];
                for(eventType in this._builder.handlers){
                    _loop_1 = function(handler) {
                        this_1._hostBuilder.on(eventType, function() {
                            var args = [];
                            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                            return handler.apply(_this._client, args);
                        });
                    };
                    this_1 = this;
                    for(_i = 0, _a = this._builder.handlers[eventType]; _i < _a.length; _i++){
                        handler = _a[_i];
                        _loop_1(handler);
                    }
                }
                for(_b = 0, _c = this._builder.sandboxAttrs; _b < _c.length; _b++){
                    attr = _c[_b];
                    this._hostBuilder.withSandboxAttribute(attr);
                }
                for(_d = 0, _e = this._builder.allowAttrs; _d < _e.length; _d++){
                    attr = _e[_d];
                    this._hostBuilder.withAllowAttribute(attr);
                }
                this._host = this._hostBuilder// tslint:disable-next-line:deprecation
                .frameBorder(this._builder.frameBorder).withTargetOrigin(this.targetOrigin).appendTo(this._builder.el).build();
                // IE doesn't like calling classList.add() with no arguments, so check
                if (this._builder.classNames.length) (_f = this._host.iframe.classList).add.apply(_f, this._builder.classNames);
                if (this._builder.scrollMonitor) this.addIframeMonitor(this._host.iframe);
                return [
                    2 /*return*/ ,
                    this._host.connect().then(function(host) {
                        // eslint-disable-next-line new-cap
                        _this._client = new _this._builder.clientConstructor(host);
                        return _this._client;
                    })
                ];
            });
        });
    };
    EmbedClient.prototype.sendScrollData = function(iframe) {
        var client = this._client;
        client.send("env:host:scroll", {
            offsetLeft: iframe.offsetLeft,
            offsetTop: iframe.offsetTop,
            scrollX: window.scrollX,
            scrollY: window.scrollY
        });
    };
    EmbedClient.prototype.addIframeMonitor = function(iframe) {
        var _this = this;
        document.addEventListener("scroll", function(_event) {
            _this.sendScrollData(iframe);
        });
        window.addEventListener("resize", function(_event) {
            _this.sendScrollData(iframe);
        });
    };
    EmbedClient.prototype.createUrl = function() {
        return $b3fbc483e1e2bca9$var$__awaiter(this, void 0, void 0, function() {
            var src, auth, url, _i, _a, param;
            var _this = this;
            return $b3fbc483e1e2bca9$var$__generator(this, function(_b) {
                src = this._builder.embedUrl;
                auth = this._builder.auth;
                if (!(auth === null || auth === void 0 ? void 0 : auth.url)) return [
                    2 /*return*/ ,
                    "".concat(this._builder.apiHost).concat(src)
                ];
                url = "".concat(auth.url, "?src=").concat(encodeURIComponent(src));
                if (auth.params) for(_i = 0, _a = auth.params; _i < _a.length; _i++){
                    param = _a[_i];
                    url += "&".concat(encodeURIComponent(param.name), "=").concat(encodeURIComponent(param.value));
                }
                // eslint-disable-next-line no-async-promise-executor
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        return $b3fbc483e1e2bca9$var$__awaiter(_this, void 0, void 0, function() {
                            var xhr, _i, _a, header;
                            return $b3fbc483e1e2bca9$var$__generator(this, function(_b) {
                                xhr = new XMLHttpRequest();
                                xhr.open("GET", url);
                                if (auth.withCredentials) xhr.withCredentials = auth.withCredentials;
                                xhr.setRequestHeader("Cache-Control", "no-cache");
                                if (auth.headers) for(_i = 0, _a = auth.headers; _i < _a.length; _i++){
                                    header = _a[_i];
                                    xhr.setRequestHeader(header.name, header.value);
                                }
                                xhr.onload = function() {
                                    if (xhr.status === 200) resolve(JSON.parse(xhr.responseText).url);
                                    else reject(xhr.statusText);
                                };
                                xhr.onerror = function() {
                                    return reject(xhr.statusText);
                                };
                                xhr.send();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    })
                ];
            });
        });
    };
    EmbedClient.prototype.acquireCookielessEmbedSession = function() {
        return $b3fbc483e1e2bca9$var$__awaiter(this, void 0, void 0, function() {
            return $b3fbc483e1e2bca9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (EmbedClient.sessionAcquired) return [
                            2 /*return*/ ,
                            this.acquireCookielessEmbedSessionInternal()
                        ];
                        if (!EmbedClient.acquireSessionPromise) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            EmbedClient.acquireSessionPromise
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this.acquireCookielessEmbedSessionInternal()
                        ];
                    case 2:
                        EmbedClient.acquireSessionPromise = this.acquireCookielessEmbedSessionInternal();
                        return [
                            2 /*return*/ ,
                            EmbedClient.acquireSessionPromise.then(function(url) {
                                EmbedClient.sessionAcquired = true;
                                return url;
                            }).catch(function(error) {
                                EmbedClient.acquireSessionPromise = undefined;
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    EmbedClient.prototype.acquireCookielessEmbedSessionInternal = function() {
        return $b3fbc483e1e2bca9$var$__awaiter(this, void 0, void 0, function() {
            var _a, acquireSession, generateTokens, _b, authentication_token, api_token, api_token_ttl, navigation_token, navigation_token_ttl, session_reference_token_ttl, apiHost, sep, src, embedPath;
            return $b3fbc483e1e2bca9$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this._builder, acquireSession = _a.acquireSession, generateTokens = _a.generateTokens;
                        if (!acquireSession) throw new Error("invalid state: acquireSession not defined");
                        if (!generateTokens) throw new Error("invalid state: generateTokens not defined");
                        return [
                            4 /*yield*/ ,
                            this.acquireSession()
                        ];
                    case 1:
                        _b = _c.sent(), authentication_token = _b.authentication_token, api_token = _b.api_token, api_token_ttl = _b.api_token_ttl, navigation_token = _b.navigation_token, navigation_token_ttl = _b.navigation_token_ttl, session_reference_token_ttl = _b.session_reference_token_ttl;
                        if (!authentication_token || !navigation_token || !api_token) throw new Error("failed to prepare cookieless embed session");
                        this._cookielessApiToken = api_token;
                        this._cookielessApiTokenTtl = api_token_ttl;
                        this._cookielessNavigationToken = navigation_token;
                        this._cookielessNavigationTokenTtl = navigation_token_ttl;
                        this._cookielessSessionReferenceTokenTtl = session_reference_token_ttl;
                        apiHost = "https://".concat(this._builder.apiHost);
                        sep = new URL(this._builder.embedUrl, apiHost).search === "" ? "?" : "&";
                        src = "".concat(this._builder.embedUrl).concat(sep, "embed_navigation_token=").concat(navigation_token);
                        embedPath = "/login/embed/" + encodeURIComponent(src) + "?embed_authentication_token=".concat(authentication_token);
                        return [
                            2 /*return*/ ,
                            "".concat(apiHost).concat(embedPath)
                        ];
                }
            });
        });
    };
    EmbedClient.prototype.acquireSession = function() {
        return $b3fbc483e1e2bca9$var$__awaiter(this, void 0, void 0, function() {
            var acquireSession, _a, url, init, resp, error_1;
            return $b3fbc483e1e2bca9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        acquireSession = this._builder.acquireSession;
                        if (!(typeof acquireSession === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            acquireSession()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 2:
                        _b.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        _a = this.getResource(acquireSession), url = _a.url, init = _a.init;
                        return [
                            4 /*yield*/ ,
                            fetch(url, init)
                        ];
                    case 3:
                        resp = _b.sent();
                        if (!resp.ok) {
                            console.error("acquire embed session failed", {
                                resp: resp
                            });
                            throw new Error("acquire embed session failed");
                        }
                        return [
                            4 /*yield*/ ,
                            resp.json()
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        error_1 = _b.sent();
                        console.error(error_1);
                        throw new Error("acquire embed session failed");
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EmbedClient.prototype.generateTokens = function() {
        return $b3fbc483e1e2bca9$var$__awaiter(this, void 0, void 0, function() {
            var generateTokens, _a, url, defaultInit, init, resp, error_2;
            return $b3fbc483e1e2bca9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        generateTokens = this._builder.generateTokens;
                        if (!(typeof generateTokens === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            generateTokens()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 2:
                        _b.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        _a = this.getResource(generateTokens), url = _a.url, defaultInit = _a.init;
                        init = defaultInit || {
                            body: JSON.stringify({
                                api_token: this._cookielessApiToken,
                                navigation_token: this._cookielessNavigationToken
                            }),
                            headers: {
                                "content-type": "application/json"
                            },
                            method: "PUT"
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(url, init)
                        ];
                    case 3:
                        resp = _b.sent();
                        if (!resp.ok) {
                            if (resp.status === 400) return [
                                2 /*return*/ ,
                                {
                                    session_reference_token_ttl: 0
                                }
                            ];
                            console.error("generate tokens failed", {
                                resp: resp
                            });
                            throw new Error("generate tokens failed");
                        }
                        return [
                            4 /*yield*/ ,
                            resp.json()
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        error_2 = _b.sent();
                        console.error(error_2);
                        throw new Error("generate tokens failed");
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EmbedClient.prototype.getResource = function(resource) {
        var url;
        var init;
        if (typeof resource === "object") {
            var tempUrl = resource.url, rest = $b3fbc483e1e2bca9$var$__rest(resource, [
                "url"
            ]);
            init = rest;
            url = tempUrl;
        } else url = resource;
        return {
            init: init,
            url: url
        };
    };
    /**
     * Establish two way communication with embedded content. Returns a promise that resolves to a
     * client that can be used to send messages to the embedded content.
     */ EmbedClient.prototype.connect = function() {
        return $b3fbc483e1e2bca9$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $b3fbc483e1e2bca9$var$__generator(this, function(_a) {
                if (this._connection) return [
                    2 /*return*/ ,
                    this._connection
                ];
                if (this._builder.url) {
                    if (this._builder.isCookielessEmbed) throw new Error("withUrl not supported by cookieless embed");
                    this._connection = this.createIframe(this._builder.url);
                } else if (this._builder.isCookielessEmbed) this._connection = this.acquireCookielessEmbedSession().then(function(url) {
                    return $b3fbc483e1e2bca9$var$__awaiter(_this, void 0, void 0, function() {
                        return $b3fbc483e1e2bca9$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this.createIframe(url)
                            ];
                        });
                    });
                }).catch(function(_error) {
                    _this._connection = null;
                    throw _error;
                });
                else this._connection = this.createUrl().then(function(url) {
                    return $b3fbc483e1e2bca9$var$__awaiter(_this, void 0, void 0, function() {
                        return $b3fbc483e1e2bca9$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this.createIframe(url)
                            ];
                        });
                    });
                });
                return [
                    2 /*return*/ ,
                    this._connection
                ];
            });
        });
    };
    EmbedClient.sessionAcquired = false;
    return EmbedClient;
}();
$b3fbc483e1e2bca9$exports.EmbedClient = $b3fbc483e1e2bca9$var$EmbedClient;


function $8f410de3e8b48e99$var$stringify(params) {
    var result = [];
    for(var key in params){
        var value = params[key];
        var valueArray = Array.isArray(value) ? value : [
            value
        ];
        for(var _i = 0, valueArray_1 = valueArray; _i < valueArray_1.length; _i++){
            var singleValue = valueArray_1[_i];
            result.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(singleValue)));
        }
    }
    return result.join("&");
}
function $8f410de3e8b48e99$var$escapeFilterParam(param) {
    return param.replace(/,/g, "^,");
}
/**
 * The builder class for [[EmbedClient]]. Contains methods for defining the properties of embedded
 * Looker content.
 */ var $8f410de3e8b48e99$var$EmbedBuilder = /** @class */ function() {
    /**
     * @hidden
     */ function EmbedBuilder(_hostSettings, _type, _endpoint, _clientConstructor) {
        this._hostSettings = _hostSettings;
        this._type = _type;
        this._endpoint = _endpoint;
        this._clientConstructor = _clientConstructor;
        this._handlers = {};
        this._appendTo = null;
        this._sandboxAttrs = [];
        this._allowAttrs = [];
        this._classNames = [];
        this._frameBorder = "0";
        this._suffix = "";
        if (this.sandboxedHost) this._params = {
            embed_domain: this._hostSettings.apiHost,
            sandboxed_host: "true",
            sdk: "2"
        };
        else {
            var embedDomain = window.location.origin;
            this._params = {
                embed_domain: embedDomain,
                sdk: "2"
            };
        }
    }
    /**
     * Value for the `frame-border` attribute of an embedded iframe
     */ EmbedBuilder.prototype.withFrameBorder = function(attr) {
        this._frameBorder = attr;
        return this;
    };
    /**
     * @hidden
     *
     * @param id
     */ EmbedBuilder.prototype.withId = function(id) {
        this._id = id;
        return this;
    };
    /**
     * Allows manual control of URL parameters for the embedded content
     *
     * @param params Additional URL parameters
     * created by ID.
     */ EmbedBuilder.prototype.withParams = function(params) {
        for(var key in params)this._params[key] = params[key];
        return this;
    };
    /**
     * Allows specifying initial filters to apply to the embedded content.
     *
     * @filters Filters to apply
     */ EmbedBuilder.prototype.withFilters = function(filters, escape) {
        if (escape === void 0) escape = false;
        if (this.type === "dashboard") for(var key in filters)this._params[key] = escape ? $8f410de3e8b48e99$var$escapeFilterParam(filters[key]) : filters[key];
        else for(var key in filters)this._params["f[".concat(key, "]")] = escape ? $8f410de3e8b48e99$var$escapeFilterParam(filters[key]) : filters[key];
        return this;
    };
    /**
     * Allows specifying sandbox attributes for an embedded content iframe. Sandbox attributes
     * should include `allow-scripts` or embedded content will not execute.
     * @param attr one or more sandbox attributes for an embedded content iframe.
     */ EmbedBuilder.prototype.withSandboxAttr = function() {
        var attr = [];
        for(var _i = 0; _i < arguments.length; _i++)attr[_i] = arguments[_i];
        this._sandboxAttrs = this._sandboxAttrs.concat(attr);
        return this;
    };
    /**
     * Allows specifying allow attributes (for example fullscreen) for an embedded content iframe.
     * @param attr one or more allow attributes for an embedded content iframe.
     */ EmbedBuilder.prototype.withAllowAttr = function() {
        var attr = [];
        for(var _i = 0; _i < arguments.length; _i++)attr[_i] = arguments[_i];
        this._allowAttrs = this._allowAttrs.concat(attr);
        return this;
    };
    /**
     * Allows specifying classes for an embedded content
     * @param className one or more sandbox attributes for an embedded content.
     */ EmbedBuilder.prototype.withClassName = function() {
        var className = [];
        for(var _i = 0; _i < arguments.length; _i++)className[_i] = arguments[_i];
        this._classNames = this._classNames.concat(className);
        return this;
    };
    /**
     * Allows specifying next generation content
     *
     * @param suffix Next generation suffix. Defaults to '-next'.
     */ EmbedBuilder.prototype.withNext = function(suffix) {
        if (suffix === void 0) suffix = "-next";
        this._suffix = suffix;
        this._endpoint += this._suffix;
        return this;
    };
    /**
     * Allows specifying a theme for the content.
     *
     * @param theme Theme name
     */ EmbedBuilder.prototype.withTheme = function(theme) {
        this._params.theme = theme;
        return this;
    };
    /**
     * Monitors scroll position and informs the embedded Looker IFRAME
     * of the current scroll position and the offset of the containing
     * IFRAME within the window. Looker uses this information to position
     * dialogs within the users viewport.
     *
     * Requires Looker >=23.6.0
     *
     * @param monitor defaults to true
     *
     */ EmbedBuilder.prototype.withScrollMonitor = function(monitor) {
        if (monitor === void 0) monitor = true;
        this._scrollMonitor = monitor;
        return this;
    };
    /**
     * Listens for page changed events from the embedded Looker IFRAME
     * and updates the height of the IFRAME.
     *
     * @param dynamicIFrameHeight defaults to true
     */ EmbedBuilder.prototype.withDynamicIFrameHeight = function(dynamicIFrameHeight) {
        if (dynamicIFrameHeight === void 0) dynamicIFrameHeight = true;
        this._dynamicIFrameHeight = dynamicIFrameHeight;
        return this;
    };
    /**
     * Listens for covering dialogs being opened in the Looker IFRAME
     * and scrolls the top of dialog into view.
     *
     * @param dialogScroll defaults to true
     */ EmbedBuilder.prototype.withDialogScroll = function(dialogScroll) {
        if (dialogScroll === void 0) dialogScroll = true;
        this._dialogScroll = dialogScroll;
        return this;
    };
    /**
     * Allows api host to be specified
     *
     * @param apiHost
     */ EmbedBuilder.prototype.withApiHost = function(apiHost) {
        if (!this._hostSettings.apiHost) {
            this._hostSettings.apiHost = apiHost;
            if (this.sandboxedHost) {
                this._params.embed_domain = apiHost;
                this._params.sandboxed_host = "true";
            }
        } else if (this._hostSettings.apiHost !== apiHost) throw new Error("not allowed to change api host");
        return this;
    };
    /**
     * Allows auth url to be specified
     *
     * @param authUrl URL to endpoint that can sign Looker SSO URLs
     */ EmbedBuilder.prototype.withAuthUrl = function(authUrl) {
        var _a;
        if (!((_a = this._hostSettings.auth) === null || _a === void 0 ? void 0 : _a.url)) this._hostSettings.auth = {
            url: authUrl
        };
        else if (this._hostSettings.auth.url !== authUrl) throw new Error("not allowed to change auth url");
        return this;
    };
    /**
     * Allows auth url to be specified
     *
     * @param auth
     */ EmbedBuilder.prototype.withAuth = function(auth) {
        if (!this._hostSettings.auth) this._hostSettings.auth = auth;
        else if (this._hostSettings.auth !== auth) throw new Error("not allowed to change auth");
        return this;
    };
    /**
     * @hidden
     *
     * @param url
     */ EmbedBuilder.prototype.withUrl = function(url) {
        if (this.isCookielessEmbed) throw new Error("withUrl not supported by cookieless embed");
        this._url = url;
        return this;
    };
    Object.defineProperty(EmbedBuilder.prototype, "sandboxedHost", {
        /**
         * @hidden
         */ get: function() {
            if (this._sandboxedHost === undefined) {
                var embedHostDomain = window.location.origin;
                this._sandboxedHost = embedHostDomain === "null" || !embedHostDomain;
            }
            return this._sandboxedHost;
        },
        /**
         * @hidden
         */ set: function(sandboxedHost) {
            this._sandboxedHost = sandboxedHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "el", {
        /**
         * The element to append the embedded content to.
         */ get: function() {
            return this._appendTo || document.body;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "frameBorder", {
        /**
         * the frame-border attribute to apply to the iframe
         */ get: function() {
            return this._frameBorder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "endpoint", {
        /**
         * The endpoint used to load content
         */ get: function() {
            return this._endpoint;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "type", {
        /**
         * The type of embedded content, dashboard, look, and explore
         */ get: function() {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "apiHost", {
        /**
         * The address of the Looker instance being used
         */ get: function() {
            return this._hostSettings.apiHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "isCookielessEmbed", {
        /**
         * Is cookieless embedding being used
         */ get: function() {
            return !!this._hostSettings.acquireSession;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "acquireSession", {
        /**
         * Cookieless embed acquire session
         */ get: function() {
            return this._hostSettings.acquireSession;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "generateTokens", {
        /**
         * Cookieless embed generate tokens
         */ get: function() {
            return this._hostSettings.generateTokens;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "url", {
        /**
         * The content URL of this embedded content, if provided
         */ get: function() {
            return this._url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "authUrl", {
        /**
         * The auth URL of this embedded content, if provided
         * @deprecated
         */ get: function() {
            var _a;
            return (_a = this._hostSettings.auth) === null || _a === void 0 ? void 0 : _a.url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "auth", {
        /**
         * The auth config of this embedded content, if provided
         */ get: function() {
            return this._hostSettings.auth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "embedUrl", {
        /**
         * @hidden
         */ get: function() {
            var params = $8f410de3e8b48e99$var$stringify(this._params);
            return "".concat(this.endpoint, "/").concat(this.id, "?").concat(params);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "handlers", {
        /**
         * @hidden
         */ get: function() {
            return this._handlers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "sandboxAttrs", {
        /**
         * The sandbox attributes of an embedded content iframe, if provided
         */ get: function() {
            return this._sandboxAttrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "allowAttrs", {
        /**
         * The allowed attributes of an embedded content iframe, if provided
         */ get: function() {
            return this._allowAttrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "classNames", {
        /**
         * The classnames to apply to the embedded content
         */ get: function() {
            return this._classNames;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "suffix", {
        /**
         * The the suffix to append to the content type portion of the url
         */ get: function() {
            return this._suffix;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "id", {
        /**
         * The ID of this embedded content, if provided
         */ get: function() {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "scrollMonitor", {
        /**
         * Whether scrolling is monitored
         */ get: function() {
            return this._scrollMonitor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "dynamicIFrameHeight", {
        /**
         * Whether IFRAME height is to be dynamically updated
         */ get: function() {
            return this._dynamicIFrameHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "dialogScroll", {
        /**
         * Whether cover dialogs tops are to be scrolled into view
         */ get: function() {
            return this._dialogScroll;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilder.prototype, "clientConstructor", {
        /**
         * @hidden
         */ get: function() {
            return this._clientConstructor;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Select an element to append the embedded content to, either a content selector or
     * the DOM element.
     *
     * @param el
     */ EmbedBuilder.prototype.appendTo = function(el) {
        if (typeof el === "string") this._appendTo = document.querySelector(el);
        else this._appendTo = el;
        return this;
    };
    /**
     * Register an event handler.
     *
     * @typeparam K: A Looker embed event name
     * @param name: string Name of the event to respond to.
     * @param handler: Callback A callback method to be invoked when the message is received.
     */ EmbedBuilder.prototype.on = function(name, handler) {
        this._handlers[name] = this._handlers[name] ? this._handlers[name] : [];
        this._handlers[name].push(handler);
        return this;
    };
    /**
     * Constructs the embedded content, including creating the DOM element that contains the content.
     */ EmbedBuilder.prototype.build = function() {
        return new $b3fbc483e1e2bca9$exports.EmbedClient(this);
    };
    return EmbedBuilder;
}();
$8f410de3e8b48e99$exports.EmbedBuilder = $8f410de3e8b48e99$var$EmbedBuilder;


var $2d8a3fb0e11e2bdd$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $2d8a3fb0e11e2bdd$var$__extends = $2d8a3fb0e11e2bdd$exports && $2d8a3fb0e11e2bdd$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2d8a3fb0e11e2bdd$var$__awaiter = $2d8a3fb0e11e2bdd$exports && $2d8a3fb0e11e2bdd$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2d8a3fb0e11e2bdd$var$__generator = $2d8a3fb0e11e2bdd$exports && $2d8a3fb0e11e2bdd$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($2d8a3fb0e11e2bdd$exports, "__esModule", {
    value: true
});
$2d8a3fb0e11e2bdd$exports.LookerEmbedDashboard = void 0;
var $cf91796b37f4895a$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $cf91796b37f4895a$var$__awaiter = $cf91796b37f4895a$exports && $cf91796b37f4895a$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cf91796b37f4895a$var$__generator = $cf91796b37f4895a$exports && $cf91796b37f4895a$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($cf91796b37f4895a$exports, "__esModule", {
    value: true
});
$cf91796b37f4895a$exports.LookerEmbedBase = void 0;
var $cf91796b37f4895a$var$LookerEmbedBase = /** @class */ function() {
    /**
     * @hidden
     *
     * @param _host
     */ function LookerEmbedBase(_host) {
        this._host = _host;
    }
    /**
     * Send a message to the embedded content.
     *
     * @param message String message identifier.
     * @param params Additional parameters to be sent to the client. After transmission ownership
     * of the parameters is transferred to the embedded Explore.
     */ LookerEmbedBase.prototype.send = function(message, params) {
        this._host.send(message, params);
    };
    /**
     * Send a message to the embedded content and resolve with a response
     *
     * @param message String message identifier.
     * @param params Additional parameters to be sent to the client. After transmission ownership
     * of the parameters is transferred to the embedded Explore.
     */ LookerEmbedBase.prototype.sendAndReceive = function(message, params) {
        return $cf91796b37f4895a$var$__awaiter(this, void 0, void 0, function() {
            return $cf91796b37f4895a$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._host.sendAndReceive(message, params)
                ];
            });
        });
    };
    return LookerEmbedBase;
}();
$cf91796b37f4895a$exports.LookerEmbedBase = $cf91796b37f4895a$var$LookerEmbedBase;


/**
 * Client that communicates with an embedded Looker dashboard. Messages are documented
 * [here](https://docs.looker.com/r/sdk/events)
 */ var $2d8a3fb0e11e2bdd$var$LookerEmbedDashboard = /** @class */ function(_super) {
    $2d8a3fb0e11e2bdd$var$__extends(LookerEmbedDashboard, _super);
    function LookerEmbedDashboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Convenience method for sending a run message to the embedded dashboard.
     */ LookerEmbedDashboard.prototype.run = function() {
        this.send("dashboard:run");
    };
    /**
     * Convenience method for sending a stop message to the embedded dashboard.
     *
     * Requires Looker 7.14 and Dashboards Next (see [[EmbedBuilder.withNext]]).
     */ LookerEmbedDashboard.prototype.stop = function() {
        this.send("dashboard:stop");
    };
    /**
     * Convenience method for sending an edit message to the embedded dashboard.
     *
     * Requires Looker 22.20 and Dashboards Next (see [[EmbedBuilder.withNext]]).
     */ LookerEmbedDashboard.prototype.edit = function() {
        this.send("dashboard:edit");
    };
    /**
     * Convenience method for updating the filters of the embedded dashboard.
     *
     * @param filters A set of filter parameters to update
     */ LookerEmbedDashboard.prototype.updateFilters = function(params) {
        this.send("dashboard:filters:update", {
            filters: params
        });
    };
    /**
     * Convenience method for setting options on the embedded dashboard.
     *
     * @param options An options object to be applied
     */ LookerEmbedDashboard.prototype.setOptions = function(options) {
        this.send("dashboard:options:set", options);
    };
    /**
     * Convenience method for opening the dashboard schedule dialog.
     *
     * Requires Looker 7.18 and Dashboards Next (see [[EmbedBuilder.withNext]]).
     */ LookerEmbedDashboard.prototype.openScheduleDialog = function() {
        return $2d8a3fb0e11e2bdd$var$__awaiter(this, void 0, void 0, function() {
            return $2d8a3fb0e11e2bdd$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.sendAndReceive("dashboard:schedule_modal:open")
                ];
            });
        });
    };
    /**
     * Convenience method for loading a new dashboard.
     * Requires Looker 7.12 and Dashboards Next (see [[EmbedBuilder.withNext]]).
     * Throws an error if the dashboard load did not happen, which can happen if the
     * current dashboard is in edit mode.
     *
     * @param id The ID of the dashboard to load
     * @param pushHistory Whether to push the new page onto history. Default is false.
     */ LookerEmbedDashboard.prototype.loadDashboard = function(id, pushHistory) {
        if (pushHistory === void 0) pushHistory = false;
        return $2d8a3fb0e11e2bdd$var$__awaiter(this, void 0, void 0, function() {
            return $2d8a3fb0e11e2bdd$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.sendAndReceive("dashboard:load", {
                        id: id,
                        pushHistory: pushHistory
                    })
                ];
            });
        });
    };
    return LookerEmbedDashboard;
}($cf91796b37f4895a$exports.LookerEmbedBase);
$2d8a3fb0e11e2bdd$exports.LookerEmbedDashboard = $2d8a3fb0e11e2bdd$var$LookerEmbedDashboard;


var $fa521f9662dfc304$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $fa521f9662dfc304$var$__extends = $fa521f9662dfc304$exports && $fa521f9662dfc304$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($fa521f9662dfc304$exports, "__esModule", {
    value: true
});
$fa521f9662dfc304$exports.LookerEmbedExplore = void 0;

/**
 * Client that communicates with an embedded Looker Explore. Messages are documented
 * [here](https://docs.looker.com/r/sdk/events)
 */ var $fa521f9662dfc304$var$LookerEmbedExplore = /** @class */ function(_super) {
    $fa521f9662dfc304$var$__extends(LookerEmbedExplore, _super);
    function LookerEmbedExplore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Convenience method for sending a run message to the embedded Explore.
     */ LookerEmbedExplore.prototype.run = function() {
        this.send("look:run");
    };
    /**
     * Convenience method for updating the filters of the embedded Explore.
     *
     * @param filters A set of filter parameters to update
     */ LookerEmbedExplore.prototype.updateFilters = function(params) {
        this.send("look:filters:update", {
            filters: params
        });
    };
    return LookerEmbedExplore;
}($cf91796b37f4895a$exports.LookerEmbedBase);
$fa521f9662dfc304$exports.LookerEmbedExplore = $fa521f9662dfc304$var$LookerEmbedExplore;


var $5bb62d4682d772b7$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $5bb62d4682d772b7$var$__extends = $5bb62d4682d772b7$exports && $5bb62d4682d772b7$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($5bb62d4682d772b7$exports, "__esModule", {
    value: true
});
$5bb62d4682d772b7$exports.LookerEmbedExtension = void 0;

/**
 * Client that communicates with an embedded Looker dashboard. Messages are documented
 * [here](https://docs.looker.com/r/sdk/events)
 */ var $5bb62d4682d772b7$var$LookerEmbedExtension = /** @class */ function(_super) {
    $5bb62d4682d772b7$var$__extends(LookerEmbedExtension, _super);
    function LookerEmbedExtension() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LookerEmbedExtension;
}($cf91796b37f4895a$exports.LookerEmbedBase);
$5bb62d4682d772b7$exports.LookerEmbedExtension = $5bb62d4682d772b7$var$LookerEmbedExtension;


var $e5d637c2cdd5f2af$exports = {};
"use strict";
/*

 MIT License

 Copyright (c) 2019 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */ var $e5d637c2cdd5f2af$var$__extends = $e5d637c2cdd5f2af$exports && $e5d637c2cdd5f2af$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($e5d637c2cdd5f2af$exports, "__esModule", {
    value: true
});
$e5d637c2cdd5f2af$exports.LookerEmbedLook = void 0;

/**
 * Client that communicates with an embedded Looker Look. Messages are documented
 * [here](https://docs.looker.com/r/sdk/events)
 */ var $e5d637c2cdd5f2af$var$LookerEmbedLook = /** @class */ function(_super) {
    $e5d637c2cdd5f2af$var$__extends(LookerEmbedLook, _super);
    function LookerEmbedLook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Convenience method for sending a run message to the embedded Look.
     */ LookerEmbedLook.prototype.run = function() {
        this.send("look:run");
    };
    /**
     * Convenience method for updating the filters of the embedded Look.
     *
     * @param filters A set of filter parameters to update
     */ LookerEmbedLook.prototype.updateFilters = function(params) {
        this.send("look:filters:update", {
            filters: params
        });
    };
    return LookerEmbedLook;
}($cf91796b37f4895a$exports.LookerEmbedBase);
$e5d637c2cdd5f2af$exports.LookerEmbedLook = $e5d637c2cdd5f2af$var$LookerEmbedLook;



$ef0c9f16e4e520e5$var$__exportStar((parcelRequire("7WlvX")), $ef0c9f16e4e520e5$exports);
var $ef0c9f16e4e520e5$var$LookerEmbedSDK = /** @class */ function() {
    function LookerEmbedSDK() {}
    /**
     * Initialize the Embed SDK.
     *
     * @param apiHost The address or base URL of the Looker host (example.looker.com:9999, https://example.looker.com:9999)
     *                This is required for verification of messages sent from the embedded content.
     * @param authUrl A server endpoint that will sign SSO embed URLs
     */ LookerEmbedSDK.init = function(apiHost, auth) {
        this.apiHost = apiHost;
        this.auth = typeof auth === "string" ? {
            url: auth
        } : auth;
        this.acquireSession = undefined;
        this.generateTokens = undefined;
    };
    /**
     * Initialize the Embed SDK to use a cookieless session.
     *
     * @param apiHost The address or base URL of the host (example.looker.com:9999, https://example.looker.com:9999)
     * @param acquireSession is either a string containing a server endpoint that will acquire the embed session OR
     * a RequestInfo object for a fetch call to the server endpoint that will acquire the embed session OR
     * a callback that will invoke the server endpoint that will acquire the embed session.
     * The server endpoint must ultimately call the Looker endpoint `acquire_embed_cookieless_session`.
     * @param generateTokens is either a string containing a server endpoint that will generate new tokens OR
     * a RequestInfo object for a fetch call to the server endpoint that will generate new tokens OR
     * a callback that will invoke the server endpoint that will generate new tokens.
     * The server endpoint should ultimately call the Looker endpoint `generate_tokens_for_cookieless_session`.
     *
     * Looker 22.20+
     */ LookerEmbedSDK.initCookieless = function(apiHost, acquireSession, generateTokens) {
        this.apiHost = apiHost;
        this.acquireSession = acquireSession;
        this.generateTokens = generateTokens;
        this.auth = undefined;
    };
    /**
     * Create an EmbedBuilder for an embedded Looker dashboard.
     *
     * @param url A signed SSO embed URL or embed URL for an already authenticated Looker user
     */ LookerEmbedSDK.createDashboardWithUrl = function(url) {
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "dashboard", "/embed/dashboards", $2d8a3fb0e11e2bdd$exports.LookerEmbedDashboard).withUrl(url);
    };
    /**
     * Create an EmbedBuilder for an embedded Looker dashboard.
     *
     * @param id The numeric ID of a Looker User Defined Dashboard, or LookML Dashboard ID
     */ LookerEmbedSDK.createDashboardWithId = function(id) {
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "dashboard", "/embed/dashboards", $2d8a3fb0e11e2bdd$exports.LookerEmbedDashboard).withId(id);
    };
    /**
     * Create an EmbedBuilder for an embedded Looker Explore.
     *
     * @param url A signed SSO embed URL or embed URL for an already authenticated Looker user
     */ LookerEmbedSDK.createExploreWithUrl = function(url) {
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "explore", "/embed/explore", $fa521f9662dfc304$exports.LookerEmbedExplore).withUrl(url);
    };
    /**
     * Create an EmbedBuilder for an embedded Looker Explore.
     *
     * @param id The ID of a Looker explore
     */ LookerEmbedSDK.createExploreWithId = function(id) {
        id = id.replace("::", "/"); // Handle old format explore ids.
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "explore", "/embed/explore", $fa521f9662dfc304$exports.LookerEmbedExplore).withId(id);
    };
    /**
     * Create an EmbedBuilder for an embedded Looker Look.
     *
     * @param url A signed SSO embed URL or embed URL for an already authenticated Looker user
     */ LookerEmbedSDK.createLookWithUrl = function(url) {
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "look", "/embed/looks", $e5d637c2cdd5f2af$exports.LookerEmbedLook).withUrl(url);
    };
    /**
     * Create an EmbedBuilder for an embedded Looker dashboard.
     *
     * @param id The ID of a Looker Look
     */ LookerEmbedSDK.createLookWithId = function(id) {
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "look", "/embed/looks", $e5d637c2cdd5f2af$exports.LookerEmbedLook).withId(id);
    };
    /**
     * Create an EmbedBuilder for an embedded Looker extension.
     *
     * @param url A signed SSO embed URL or embed URL for an already authenticated Looker user
     */ LookerEmbedSDK.createExtensionWithUrl = function(url) {
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "extension", "/embed/extensions", $5bb62d4682d772b7$exports.LookerEmbedExtension).withUrl(url);
    };
    /**
     * Create an EmbedBuilder for an embedded Looker extension. Requires Looker 7.12
     *
     * @param id The ID of a Looker Look
     */ LookerEmbedSDK.createExtensionWithId = function(id) {
        return new $8f410de3e8b48e99$exports.EmbedBuilder(this, "extension", "/embed/extensions", $5bb62d4682d772b7$exports.LookerEmbedExtension).withId(id);
    };
    return LookerEmbedSDK;
}();
$ef0c9f16e4e520e5$exports.LookerEmbedSDK = $ef0c9f16e4e520e5$var$LookerEmbedSDK;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $99e18646983cd0f4$export$2e2bcd8739ae039 = ()=>{
    const [session, setSession] = (0, $acw62.useState)();
    const fetchSession = async ()=>{
        const currentSession = await (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentSession();
        setSession(currentSession);
    };
    (0, $acw62.useEffect)(()=>{
        fetchSession(); // initially fetch the session
        const intervalId = setInterval(fetchSession, 60000); // check every minute
        // clean up on component unmount
        return ()=>clearInterval(intervalId);
    }, []);
    return session;
};



const $2b131d1f0fe5ee8b$export$698c3eb1dc011b6a = `https://user${".video.fabrik"}.com/api/v1`;
const $2b131d1f0fe5ee8b$export$2250ae0a1cb92822 = `https://public${""}.kargovideo.com/api/v1`;
const $2b131d1f0fe5ee8b$export$1af019cf144511fc = "looker.kargo.com";
const $2b131d1f0fe5ee8b$export$c2217f38baa6ce77 = 2897;
const $2b131d1f0fe5ee8b$export$a739cd5aac835909 = false;
var $2b131d1f0fe5ee8b$export$2e2bcd8739ae039 = {};


let $e4d97216ecfc8407$var$initialized = false;
async function $e4d97216ecfc8407$export$cbd5e678aed168dc({ height: height }, element) {
    if (height && height > 100) {
        const iframe = element.querySelector("iframe");
        if (iframe) iframe.style.height = `${height}px`;
    }
}
function $e4d97216ecfc8407$export$1c19dd7ec528ba09(sessionToken) {
    if (!$e4d97216ecfc8407$var$initialized) {
        (0, $ef0c9f16e4e520e5$exports.LookerEmbedSDK).initCookieless((0, $2b131d1f0fe5ee8b$export$1af019cf144511fc), {
            url: `${(0, $2b131d1f0fe5ee8b$export$698c3eb1dc011b6a)}/dashboards/looker-acquire-embed-session`,
            headers: {
                Authorization: sessionToken
            }
        }, {
            url: `${(0, $2b131d1f0fe5ee8b$export$698c3eb1dc011b6a)}/dashboards/looker-generate-embed-tokens`,
            headers: {
                Authorization: sessionToken,
                "content-type": "application/json"
            },
            method: "PUT"
        });
        $e4d97216ecfc8407$var$initialized = true;
    }
    return 0, $ef0c9f16e4e520e5$exports.LookerEmbedSDK;
}


const $cbdc99728f907da8$export$a56d684b76fce479 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $cbdc99728f907da8$export$cfaf1613728950e3({ children: children }) {
    const session = (0, $99e18646983cd0f4$export$2e2bcd8739ae039)();
    (0, $acw62.useEffect)(()=>{
        if (!session) return;
        (0, $e4d97216ecfc8407$export$1c19dd7ec528ba09)(session.getAccessToken().getJwtToken());
    }, [
        session
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cbdc99728f907da8$export$a56d684b76fce479.Provider, {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({}), []),
        children: children
    });
}
function $cbdc99728f907da8$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($cbdc99728f907da8$export$a56d684b76fce479);
}





var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $518d598de003888d$export$2e2bcd8739ae039 = ()=>{
    const [userSession, setUserSession] = (0, $acw62.useState)();
    const fetchSession = async ()=>{
        const userAttributes = await (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentUserInfo();
        setUserSession(userAttributes);
    };
    (0, $acw62.useEffect)(()=>{
        fetchSession(); // initially fetch the session
        const intervalId = setInterval(fetchSession, 60000); // check every minute
        // clean up on component unmount
        return ()=>clearInterval(intervalId);
    }, []);
    return userSession;
};




var $679d68edbe7c385a$export$b223542850d71259;
(function(EApiStatusError) {
    EApiStatusError[EApiStatusError["CONFLICTED"] = 409] = "CONFLICTED";
    EApiStatusError[EApiStatusError["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    EApiStatusError[EApiStatusError["NOT_FOUND"] = 404] = "NOT_FOUND";
    EApiStatusError[EApiStatusError["INTERNAL_ERROR"] = 500] = "INTERNAL_ERROR";
    EApiStatusError[EApiStatusError["DUPLICATED"] = 412] = "DUPLICATED";
})($679d68edbe7c385a$export$b223542850d71259 || ($679d68edbe7c385a$export$b223542850d71259 = {}));


var $8d9dab153099bf22$export$a2ccf1848ebec243;
(function(UploadActionEnums) {
    // VIDEO UPLOAD
    UploadActionEnums["UPLOAD_STARTED"] = "UPLOAD_STARTED";
    UploadActionEnums["CLOSE_UPLOAD_INDICATOR_CONTAINER"] = "CLOSE_UPLOAD_INDICATOR_CONTAINER";
    UploadActionEnums["VIDEO_CREATION_STARTED"] = "VIDEO_CREATION_STARTED";
    UploadActionEnums["VIDEO_SIGNED_URL_CREATED"] = "VIDEO_SIGNED_URL_CREATED";
    UploadActionEnums["VIDEO_UPLOAD_PROGRESS"] = "VIDEO_UPLOAD_PROGRESS";
    UploadActionEnums["UPLOAD_ABORTED"] = "UPLOAD_ABORTED";
    UploadActionEnums["VIDEO_UPLOAD_ENDED"] = "VIDEO_UPLOAD_ENDED";
})($8d9dab153099bf22$export$a2ccf1848ebec243 || ($8d9dab153099bf22$export$a2ccf1848ebec243 = {}));


function $927f90cac8c58501$export$5929023aaad979ca(endpoint, accessToken, init = {}) {
    return fetch(`${(0, $2b131d1f0fe5ee8b$export$698c3eb1dc011b6a)}/${endpoint}`, {
        ...init,
        headers: {
            ...init.headers,
            Authorization: accessToken
        }
    });
}
function $927f90cac8c58501$export$c3fb375033326b5e(endpoint, init = {}) {
    return fetch(`${(0, $2b131d1f0fe5ee8b$export$2250ae0a1cb92822)}/${endpoint}`, {
        ...init,
        ...init.headers && {
            headers: {
                ...init.headers
            }
        }
    });
}
const $927f90cac8c58501$var$responseHandler = async (resp, endpoint)=>{
    const { ok: ok, status: status } = resp;
    if (!ok) return resp.json().then((body)=>{
        const errorMessage = body.message || "No error message provided";
        (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track("Error", {
            type: "api",
            endpoint: endpoint,
            status: status,
            errorMessage: errorMessage
        });
        throw new Error(`API returned error ${status}: ${errorMessage}`);
    }).catch((e)=>{
        (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track("Error", {
            type: "api",
            endpoint: endpoint,
            status: status,
            errorMessage: "Error message could not be parsed"
        });
        switch(status){
            case (0, $679d68edbe7c385a$export$b223542850d71259).CONFLICTED:
                {
                    const responseString = e.message.split("409: ")[1];
                    throw new Error(responseString);
                }
            case (0, $679d68edbe7c385a$export$b223542850d71259).DUPLICATED:
                throw new Error(e.message);
            default:
                throw new Error(`API returned error ${status} and the error message could not be parsed.`);
        }
    });
    return resp.json();
};
function $927f90cac8c58501$export$2e2bcd8739ae039(accessToken, username, groups) {
    function fetchAPI(endpoint, init = {}) {
        return $927f90cac8c58501$export$5929023aaad979ca(endpoint, accessToken, init).then((resp)=>$927f90cac8c58501$var$responseHandler(resp, endpoint));
    }
    const fetchPublicAPI = (endpoint, init = {})=>$927f90cac8c58501$export$c3fb375033326b5e(endpoint, init).then((resp)=>$927f90cac8c58501$var$responseHandler(resp, endpoint));
    const deleteAPI = (endpoint, data)=>{
        (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track("API Delete Request", {
            resource: endpoint,
            data: data
        });
        return fetchAPI(endpoint, {
            method: "DELETE",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    const postAPI = (endpoint, data)=>{
        (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track("API Create Request", {
            resource: endpoint,
            data: data
        });
        return fetchAPI(endpoint, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    const putAPI = (endpoint, data)=>{
        (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track("API Update Request", {
            resource: endpoint,
            data: data
        });
        return fetchAPI(endpoint, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    function getMRSSFeedAPI() {
        const resource = "mrss-feeds";
        return {
            createMRSSFeed: (data)=>postAPI(resource, data),
            deleteMRSSFeed: (token)=>deleteAPI(`${resource}/${token}`),
            getMRSSFeeds: (query)=>fetchAPI(`${resource}/${query ? `?${new URLSearchParams(query)}` : ""}`).then((r)=>r?.mrss_feeds),
            getMRSSFeed: (token)=>fetchAPI(`${resource}/${token}`),
            updateMRSSFeed: (token, data)=>putAPI(`${resource}/${token}`, data)
        };
    }
    const api = {
        ...getMRSSFeedAPI(),
        createDomain: (data)=>postAPI("domains", data).then((res)=>({
                    ...data,
                    token: res.data.token
                })),
        getRevisionByConfigToken: (configToken)=>fetchAPI(`domains/revisions/${configToken}`).then((res)=>res),
        saveTargetingUrls: (data, token, configToken)=>postAPI(`domains/targetingurl/${token}/${configToken}`, data).then((res)=>({
                    ...data,
                    ...res.data
                })),
        deleteTargetingUrls: (query, token, configToken)=>deleteAPI(`domains/targetingurl/${token}/${configToken}?${new URLSearchParams(query)}`).then((res)=>({
                    ...res.data
                })),
        bulkUpdateDomainsConfig: (data)=>putAPI(`domains/bulk-update`, data).then((res)=>({
                    ...res.data
                })),
        bulkDeleteDomains: (data)=>deleteAPI(`domains/bulk-delete`, data).then((res)=>({
                    ...res.data
                })),
        bulkUpdateDomains: (data)=>putAPI(`domains/bulk-update-domains`, data).then((res)=>({
                    ...res.data
                })),
        deleteDomain: (token)=>deleteAPI(`domains/${token}`),
        getDomains: (query)=>fetchAPI(`domains${query ? `?${new URLSearchParams(query)}` : ""}`).then((res)=>res.configs),
        getDomain: (token)=>fetchAPI(`domains/${token}`),
        domain: (d)=>({
                createConfig: (data)=>postAPI(`domains/${d}/configs`, data),
                deleteConfig: (token)=>deleteAPI(`domains/${d}/configs/${token}`),
                getConfig: (c)=>fetchAPI(`domains/${d}/configs/${c}`),
                setConfig: (c, config)=>putAPI(`domains/${d}/configs/${c}`, config),
                update: (data)=>putAPI(`domains/${d}`, data)
            }),
        createUser: (user)=>postAPI("users", user).then(({ data: data })=>data),
        inviteUser: (user)=>postAPI("users/invite-user", user).then(({ data: data })=>data),
        readUser: (select_user)=>fetchAPI(`users/${select_user}`),
        deleteUser: (select_user)=>deleteAPI(`users/${select_user}`),
        updateUser: (select_user, data)=>putAPI(`users/${select_user}`, data),
        getUsers: (query)=>fetchAPI(`users${query ? `?${new URLSearchParams(query)}` : ""}`),
        getCategories: (query)=>fetchAPI(`medias/categories${query ? `?${new URLSearchParams(query)}` : ""}`),
        getTags: (query)=>fetchAPI(`medias/tags${query ? `?${new URLSearchParams({
                group: query.slug || query.group || groups?.join(",") || username
            })}` : ""}`),
        getPublishers: (query)=>fetchAPI(`publishers${query ? `?${new URLSearchParams(query)}` : ""}`),
        createPublisher: (data)=>postAPI("publishers", data).then((res)=>({
                    publisher: res,
                    message: null
                })).catch((err)=>({
                    publisher: null,
                    message: err?.message || `Error occurred when tried to onboard publisher`
                })),
        Playlist: {
            create: (d)=>postAPI("playlists", d).then(({ data: data })=>data),
            list: (query)=>fetchAPI(`playlists${query ? `?${new URLSearchParams(query)}` : ""}`),
            medias: (token, query)=>fetchPublicAPI(`playlists/${token}/medias${query ? `?${new URLSearchParams(JSON.stringify(query))}` : ""}`),
            get: (token)=>fetchAPI(`playlists/${token}`),
            delete: (token)=>deleteAPI(`playlists/${token}`),
            update: (token, data)=>putAPI(`playlists/${token}`, data),
            createByTag: (d)=>postAPI("playlists/tags", d).then(({ data: data })=>data),
            createByCategory: (d)=>postAPI("playlists/categories", d).then(({ data: data })=>data)
        },
        Media: {
            get: (token)=>fetchAPI(`medias/${token}`),
            index: (query)=>fetchAPI(`medias?${new URLSearchParams({
                    ...query,
                    group: query.slug || query.group || groups?.join(",") || username
                })}`),
            remove: (token)=>deleteAPI(`medias/${token}`),
            restore: (token)=>postAPI(`medias/${token}/restore`),
            update: (token, data)=>putAPI(`medias/${token}`, data),
            uploadSubtitle: (token, file, progressHandler)=>api.uploadFile(`${(0, $2b131d1f0fe5ee8b$export$698c3eb1dc011b6a)}/medias/${token}/subtitle`, file, null, (ev)=>{
                    if (!progressHandler || typeof progressHandler !== "function") return;
                    progressHandler(ev, token);
                }),
            bulkRemove: (data)=>postAPI(`medias/bulk-delete`, data),
            bulkEditTags: (data)=>postAPI(`medias/bulk-edit-tags`, data),
            bulkEditCategory: (data)=>postAPI(`medias/bulk-edit-category`, data)
        },
        Looker: {
            getUserObjects: ()=>fetchAPI("dashboards/looker-get-objects"),
            acquireEmbed: ()=>fetchAPI("dashboards/looker-acquire-embed-session"),
            // eslint-disable-next-line max-len
            getTokens: (data)=>putAPI("dashboards/looker-generate-embed-tokens", {
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
        },
        createVideo: async ({ data: data, file: file, image: image, index: index, uploadDispatcher: uploadDispatcher, abortController: abortController, publisherUsername: publisherUsername, onCreate: onCreate, onProgress: onProgress })=>{
            if (!data && !file) throw new Error("Needs video data and/or file");
            if (file && !(file instanceof File)) throw new Error("Invalid video file");
            const createResponse = await postAPI("medias", {
                group: publisherUsername || username,
                ...data
            });
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const { token: token, url: url, image_url: image_url } = createResponse.data;
            const dataWithToken = {
                ...data,
                token: token
            };
            if (onCreate) onCreate(dataWithToken, {
                url: url,
                imageURL: image_url
            });
            if (!file) return dataWithToken;
            const response = await Promise.allSettled([
                // url and image_url are AWS pre-signed URLs
                api.uploadFile(url, file, abortController?.signal, (e)=>{
                    if (!onProgress) return;
                    onProgress(token, e);
                }),
                image && api.uploadFile(image_url, image, abortController?.signal)
            ]);
            if (typeof uploadDispatcher === "function") uploadDispatcher((0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_UPLOAD_ENDED, {
                index: index,
                statuses: {
                    video: response[0]?.status,
                    image: response[1]?.status
                }
            });
            if (response[0].status === "rejected") throw new Error(response[0].reason);
            return api.confirmVideo(token, !!image && response[1].status === "fulfilled");
        },
        uploadFile: async (url, file, signal, onprogress)=>new Promise((resolve, reject)=>{
                const xhr = new XMLHttpRequest();
                xhr.open("PUT", url);
                xhr.setRequestHeader("Content-Type", file.type);
                // if URL is not AWS Pre-signed URL
                if (accessToken && url.includes((0, $2b131d1f0fe5ee8b$export$698c3eb1dc011b6a))) xhr.setRequestHeader("Authorization", accessToken);
                xhr.upload.onprogress = onprogress;
                xhr.onreadystatechange = ()=>{
                    if (xhr.readyState !== 4) return;
                    if (xhr.status !== 200) reject();
                    else resolve(xhr.responseText);
                };
                xhr.onabort = ()=>reject();
                if (signal) signal.addEventListener("abort", ()=>xhr.abort());
                xhr.send(file);
            }),
        // eslint-disable-next-line max-len
        confirmVideo: (token, confirm_image)=>postAPI(`medias/${token}/confirm`, {
                confirm_image: confirm_image
            }).then((res)=>res.media)
    };
    return api;
}


const $62c3235118f7fb12$export$a078c61943f9dbbe = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $62c3235118f7fb12$export$e62cf4050ed10e67({ children: children }) {
    const session = (0, $99e18646983cd0f4$export$2e2bcd8739ae039)();
    const userSession = (0, $518d598de003888d$export$2e2bcd8739ae039)();
    const [userProfile, setUserProfile] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(userSession);
    (0, $acw62.useEffect)(()=>{
        setUserProfile(userSession);
    }, [
        userSession
    ]);
    const accessToken = session?.getAccessToken().getJwtToken();
    const api = (0, $927f90cac8c58501$export$2e2bcd8739ae039)(accessToken, session?.getAccessToken().decodePayload().username, session?.getAccessToken().decodePayload()["cognito:groups"]);
    const value = (0, $acw62.useMemo)(()=>({
            api: api,
            didLoad: !!accessToken,
            userProfile: userProfile,
            setUserProfile: setUserProfile
        }), [
        accessToken,
        userProfile
    ]);
    return api && /*#__PURE__*/ (0, $ayMG0.jsx)($62c3235118f7fb12$export$a078c61943f9dbbe.Provider, {
        value: value,
        children: children
    });
}
var $62c3235118f7fb12$export$2e2bcd8739ae039 = $62c3235118f7fb12$export$a078c61943f9dbbe;


function $28c935ff7811b100$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)((0, $62c3235118f7fb12$export$2e2bcd8739ae039));
}


function $7cfd7d2033513804$export$20ed3b85869bd7b2() {
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            "dashboards",
            "looker-get-objects"
        ],
        queryFn: ()=>api && api.Looker.getUserObjects(),
        enabled: !!api && didLoad,
        staleTime: Infinity
    });
    return {
        ...query,
        dashboardId: query.data?.dashboard_id,
        videoPerformanceExploreId: query.data?.events_explore,
        monetizationExploreId: query.data?.ad_events_explore,
        userDomains: query.data?.domains,
        userAdUnits: query.data?.ad_units
    };
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $12f40d6000cba5c7$exports = {};
$12f40d6000cba5c7$exports = new URL("loading_circle.166def27.svg", import.meta.url).toString();


const $d225de012d32d10a$var$src = new URL($12f40d6000cba5c7$exports).toString();
function $d225de012d32d10a$export$2e2bcd8739ae039({ isStatic: isStatic, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: $d225de012d32d10a$var$src,
        alt: "loading indicator",
        className: isStatic ? "" : "spin",
        style: style
    });
}


var $baec2d8ea645d6e9$export$2e2bcd8739ae039 = (0, $d225de012d32d10a$export$2e2bcd8739ae039);


function $24bd3ddf2346b8d7$export$8bebb93084f4055() {
    const { dashboardId: dashboardId } = (0, $7cfd7d2033513804$export$20ed3b85869bd7b2)();
    const dashboardContainerRef = (0, $acw62.useRef)(null);
    const [dashboardLoaded, setDashboardLoaded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!dashboardId) return;
        (0, $ef0c9f16e4e520e5$exports.LookerEmbedSDK).createDashboardWithId(dashboardId)// Allow fullscreen tile visualizations
        .withAllowAttr("fullscreen").appendTo(dashboardContainerRef.current).on("page:properties:changed", (event)=>{
            (0, $e4d97216ecfc8407$export$cbd5e678aed168dc)(event, dashboardContainerRef.current);
        }).on("dashboard:loaded", ()=>{
            setDashboardLoaded(true);
        })// Give the embedded content a class for styling purposes
        .withClassName("looker-embed").withTheme("light")// Finalize the build
        .build()// Connect to Looker
        .connect();
    }, [
        dashboardId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbdc99728f907da8$export$cfaf1613728950e3), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: dashboardContainerRef,
            children: !dashboardLoaded && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: "100%",
                    height: "calc(100vh - 259px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





function $69afb1ae7c880ac4$export$7472995af639359f({ exploreId: exploreId, className: className }) {
    const exploreRef = (0, $acw62.useRef)(null);
    const [exploreReady, setExploreReady] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!exploreId) return;
        (0, $ef0c9f16e4e520e5$exports.LookerEmbedSDK).createExploreWithId(exploreId)// Allow fullscreen tile visualizations
        .withAllowAttr("fullscreen").appendTo(exploreRef.current).on("page:changed", ()=>{
            if (!exploreReady) {
                setExploreReady(true);
                (0, $e4d97216ecfc8407$export$cbd5e678aed168dc)({
                    height: window.screen.height - Math.floor(window.screen.height * 0.20),
                    type: "PagePropertiesChangedEvent"
                }, exploreRef.current);
            }
        })// Give the embedded content a class for styling purposes
        .withClassName("looker-embed").withTheme("light")// Finalize the build
        .build()// Connect to Looker
        .connect();
    }, [
        exploreId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbdc99728f907da8$export$cfaf1613728950e3), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: exploreRef,
            className: className || "",
            children: !exploreReady && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: "100%",
                    height: "calc(100vh - 259px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $468db79851f81a8c$export$b94310965bed44e6() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Home"
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $7Frhn = parcelRequire("7Frhn");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4828cb1f30b841b0$export$47a2da616e55e8e9(slot) {
    return (0, $4Cod0.default)("MuiAppBar", slot);
}
const $4828cb1f30b841b0$var$appBarClasses = (0, $beCSm.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $4828cb1f30b841b0$export$2e2bcd8739ae039 = $4828cb1f30b841b0$var$appBarClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $37a342382669398e$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $37a342382669398e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color)}`,
            `position${(0, $jTnBY.default)(position)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4828cb1f30b841b0$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $37a342382669398e$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $37a342382669398e$var$AppBarRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $8nd05.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $8nd05.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $8nd05.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $8nd05.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        "inherit",
        "transparent"
    ].includes(ownerState.color) && {
        backgroundColor: "var(--AppBar-background)"
    }, {
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $37a342382669398e$var$AppBar = /*#__PURE__*/ $acw62.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $1En50.default)(props, $37a342382669398e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $37a342382669398e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($37a342382669398e$var$AppBarRoot, (0, $8nd05.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $9QePP.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
$37a342382669398e$var$AppBar.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "default",
            "inherit",
            "primary",
            "secondary",
            "transparent",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */ enableColorOnDark: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "absolute",
        "fixed",
        "relative",
        "static",
        "sticky"
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $37a342382669398e$export$2e2bcd8739ae039 = $37a342382669398e$var$AppBar;


var $c9Z8w = parcelRequire("c9Z8w");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");

var $dFNG2 = parcelRequire("dFNG2");

var $0tqaY = parcelRequire("0tqaY");

var $6o2lr = parcelRequire("6o2lr");

var $ayMG0 = parcelRequire("ayMG0");
const $9d2a35bf051ea407$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $9d2a35bf051ea407$var$defaultTheme = (0, $6o2lr.default)();
const $9d2a35bf051ea407$var$defaultCreateStyledComponent = (0, $0tqaY.default)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $gxvzd.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9d2a35bf051ea407$var$useThemePropsDefault = (inProps)=>(0, $dFNG2.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $9d2a35bf051ea407$var$defaultTheme
    });
const $9d2a35bf051ea407$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $4Cod0.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $gxvzd.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $8Indx.default)(slots, getContainerUtilityClass, classes);
};
function $9d2a35bf051ea407$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9d2a35bf051ea407$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9d2a35bf051ea407$var$useThemePropsDefault, componentName: componentName = "MuiContainer" } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = "div", disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = "lg" } = props, other = (0, $1En50.default)(props, $9d2a35bf051ea407$var$_excluded);
        const ownerState = (0, $8nd05.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9d2a35bf051ea407$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    Container.propTypes /* remove-proptypes */  = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        fixed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                "xs",
                "sm",
                "md",
                "lg",
                "xl",
                false
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]),
        sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    };
    return Container;
}



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
"use client";
const $2291beb327d500f8$var$Container = (0, $9d2a35bf051ea407$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: "MuiContainer"
        })
});
$2291beb327d500f8$var$Container.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */ fixed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */ maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "xs",
            "sm",
            "md",
            "lg",
            "xl",
            false
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;


var $kyRsi = parcelRequire("kyRsi");
var $6lXkL = parcelRequire("6lXkL");


var $kfZjc = parcelRequire("kfZjc");
var $8a7e516510f6e4c7$exports = {};
"use strict";
var $8a7e516510f6e4c7$var$__createBinding = $8a7e516510f6e4c7$exports && $8a7e516510f6e4c7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a7e516510f6e4c7$var$__exportStar = $8a7e516510f6e4c7$exports && $8a7e516510f6e4c7$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8a7e516510f6e4c7$var$__createBinding(exports1, m, p);
};
var $8a7e516510f6e4c7$var$__importDefault = $8a7e516510f6e4c7$exports && $8a7e516510f6e4c7$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8a7e516510f6e4c7$exports, "__esModule", {
    value: true
});
$8a7e516510f6e4c7$exports.THEME_ENUM = void 0;

const $8a7e516510f6e4c7$var$krg_header_menu_button_react_1 = $8a7e516510f6e4c7$var$__importDefault((parcelRequire("ataIx")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($8a7e516510f6e4c7$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$8a7e516510f6e4c7$var$__exportStar((parcelRequire("4YKhJ")), $8a7e516510f6e4c7$exports);
$8a7e516510f6e4c7$exports.default = $8a7e516510f6e4c7$var$krg_header_menu_button_react_1.default;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $26QC4 = parcelRequire("26QC4");

function $efb9fb9496b09505$export$2e2bcd8739ae039({ width: width, height: height, text: text, color: color }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            width: width,
            height: height,
            borderRadius: "50%",
            backgroundColor: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                width: width * 0.95,
                height: height * 0.95,
                borderRadius: "50%",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26QC4.default), {
                sx: {
                    width: width * 0.90,
                    height: height * 0.90,
                    bgcolor: color,
                    fontSize: width / 2,
                    textTransform: "uppercase"
                },
                children: text
            })
        })
    });
}


function $12872af000a28022$var$stringToColor(string) {
    let hash = 0;
    let i;
    /* eslint-disable no-bitwise */ for(i = 0; i < string.length; i += 1)hash = string.charCodeAt(i) + ((hash << 5) - hash);
    let color = "#";
    for(i = 0; i < 3; i += 1){
        const value = hash >> i * 8 & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */ return color;
}
function $12872af000a28022$export$59fb969267da6e1f(name) {
    if (!name) return null;
    let splitName = [];
    let shownName = "";
    if (name.includes("-")) splitName = name.split("-");
    else if (name.includes(" ")) splitName = name.split(" ");
    shownName = splitName.length > 1 ? `${splitName[0][0]}${splitName[1][0]}` : name.substring(0, 2);
    return {
        color: $12872af000a28022$var$stringToColor(name),
        text: `${shownName}`
    };
}
const $12872af000a28022$export$2dc49b88faa8e755 = (text, maxLength)=>text?.length > maxLength ? text.slice(0, 30) + String.fromCharCode(0x2026) : text;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $210a69e1eb51b64d$export$2e2bcd8739ae039(props) {
    const { width: width = "72", height: height = "21", color: color = "#FFFF" } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 149.786 45.522",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
            transform: "translate(0)",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                    cx: "4.856",
                    cy: "4.856",
                    rx: "4.856",
                    ry: "4.856",
                    transform: "translate(109.315 2.232) rotate(-13.283)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M526.853,478.586a1.494,1.494,0,0,1-.487.066.853.853,0,0,1-.7-.251.81.81,0,0,1-.153-.411h-.8a1.194,1.194,0,0,0,.451.988,1.946,1.946,0,0,0,1.239.358,1.782,1.782,0,0,0,1.2-.364,1.158,1.158,0,0,0,.424-.916.988.988,0,0,0-.361-.825,1.861,1.861,0,0,0-.689-.29l-.695-.169a2.258,2.258,0,0,1-.525-.164.351.351,0,0,1-.191-.323.419.419,0,0,1,.193-.366.912.912,0,0,1,.517-.131,1.1,1.1,0,0,1,.492.1.58.58,0,0,1,.317.519h.809a1.2,1.2,0,0,0-.473-.982,1.764,1.764,0,0,0-1.085-.336,1.674,1.674,0,0,0-1.159.358,1.166,1.166,0,0,0-.394.9.977.977,0,0,0,.41.869,2.628,2.628,0,0,0,.87.312l.427.093a1.823,1.823,0,0,1,.547.192.343.343,0,0,1,.175.306A.469.469,0,0,1,526.853,478.586Z",
                    transform: "translate(-382.821 -473.972)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M536.967,476.729c0-.08,0-.191,0-.331s0-.249,0-.326l.755,3.38h.82l.76-3.38q0,.115,0,.326c0,.14,0,.251,0,.331v2.723h.788v-4.031h-1.214l-.727,3.172-.733-3.172H536.18v4.031h.787Z",
                    transform: "translate(-390.376 -474.193)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M202.534,520.724h-.124c-1.8-2.977-4.9-4.963-9.554-4.963-7.507,0-13.772,5.459-13.772,15.261s6.266,15.261,13.772,15.261c4.653,0,7.755-1.985,9.554-4.963h.124v4.032H210.1V516.692h-7.568Zm-7.754,18.363c-4.591,0-7.755-3.226-7.755-8.065s3.164-8.065,7.755-8.065,7.754,3.226,7.754,8.065S199.37,539.087,194.78,539.087Z",
                    transform: "translate(-155.185 -500.762)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M297.9,489.07c-4.653,0-7.755,1.985-9.554,4.963h-.124v-18.8h-7.63v43.426h7.63V514.63h.124c1.8,2.977,4.9,4.963,9.554,4.963,7.506,0,13.772-5.459,13.772-15.261S305.4,489.07,297.9,489.07ZM295.975,512.4c-4.591,0-7.755-3.226-7.755-8.065s3.164-8.065,7.755-8.065,7.755,3.226,7.755,8.065S300.566,512.4,295.975,512.4Z",
                    transform: "translate(-222.039 -474.071)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M384.943,522.891h-.124v-6.08h-7.507v28.661h7.568V533.748c0-7.01,2.916-9.616,9-9.616h.868v-8.189h-.31C389.719,515.943,386.432,518.424,384.943,522.891Z",
                    transform: "translate(-285.742 -500.882)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    width: "7.631",
                    height: "28.661",
                    transform: "translate(111.357 15.93)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M117.024,482.648H135.4V475.2H109.075v43.469h7.949V500.656h14.03v-7.328h-14.03Z",
                    transform: "translate(-109.075 -474.044)",
                    fill: color
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M494.748,490.5h-9.486l-10.4,12.258V475.727h-7.631v43.426h7.631V506.687l10.4,12.258,9.486.018-12.073-14.258Z",
                    transform: "translate(-344.962 -474.395)",
                    fill: color
                })
            ]
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
var $4F5tJ = parcelRequire("4F5tJ");
var $6lXkL = parcelRequire("6lXkL");
var $2iAqv = parcelRequire("2iAqv");
var $3bYfT = parcelRequire("3bYfT");

var $1GFtd = parcelRequire("1GFtd");function $b9c362fbce901abe$export$2e2bcd8739ae039(styles) {
    return styles;
}



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $81ed011036a55dbf$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), "ArrowForwardIos");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $795a1c282b21c2c5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2"
}), "Bookmark");



var $acw62 = parcelRequire("acw62");


function $4f86ca3d56f18424$export$a036ba61edb46e4b(inputQuery = {}) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const fetchPublishers = (0, $acw62.useCallback)(()=>api && api.getPublishers(inputQuery), [
        api,
        inputQuery
    ]);
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "publishers",
        inputQuery
    ], ()=>fetchPublishers(), {
        enabled: didLoad,
        staleTime: Infinity
    });
    const createNewPublisherMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>api.createPublisher(data)
    });
    return {
        query: query,
        queryClient: queryClient,
        createNewPublisherMutation: createNewPublisherMutation,
        publishers: query.data?.users || []
    };
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $71ad126b68006e25$exports = {};
"use strict";
var $71ad126b68006e25$var$__createBinding = $71ad126b68006e25$exports && $71ad126b68006e25$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $71ad126b68006e25$var$__exportStar = $71ad126b68006e25$exports && $71ad126b68006e25$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $71ad126b68006e25$var$__createBinding(exports1, m, p);
};
var $71ad126b68006e25$var$__importDefault = $71ad126b68006e25$exports && $71ad126b68006e25$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($71ad126b68006e25$exports, "__esModule", {
    value: true
});
$71ad126b68006e25$exports.BUTTON_VARIANT_ENUM = $71ad126b68006e25$exports.THEME_ENUM = void 0;

const $71ad126b68006e25$var$krg_modal_react_1 = $71ad126b68006e25$var$__importDefault((parcelRequire("0zGhM")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($71ad126b68006e25$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

var $dgtCa = parcelRequire("dgtCa");
Object.defineProperty($71ad126b68006e25$exports, "BUTTON_VARIANT_ENUM", {
    enumerable: true,
    get: function() {
        return $dgtCa.VARIANT_ENUM;
    }
});

$71ad126b68006e25$var$__exportStar((parcelRequire("bcwoj")), $71ad126b68006e25$exports);

$71ad126b68006e25$var$__exportStar((parcelRequire("fE9Ck")), $71ad126b68006e25$exports);
$71ad126b68006e25$exports.default = $71ad126b68006e25$var$krg_modal_react_1.default;



function $525720de80d3c8ea$export$2e2bcd8739ae039({ elementClassName: elementClassName, isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, content: content, title: title, submitButtonText: submitButtonText, cancelButtonText: cancelButtonText, isSubmitButtonEnabled: isSubmitButtonEnabled, isCancelButtonEnabled: isCancelButtonEnabled, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))), {
        className: `content-modal modal${elementClassName ? ` ${elementClassName}` : ""}`,
        isOpen: isOpen,
        onClose: onClose,
        style: style,
        maxWidth: (0, $71ad126b68006e25$exports.SIZE_ENUM).lg,
        onSubmitClick: (ev)=>onSubmit(ev),
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).THEME_ENUM.v2,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).TYPE_ENUM.submit,
        inputContainer: content,
        title: title,
        isCancelButtonEnabled: isCancelButtonEnabled,
        isSubmitButtonEnabled: isSubmitButtonEnabled,
        submitButtonText: submitButtonText,
        cancelButtonText: cancelButtonText
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $lkxXU = parcelRequire("lkxXU");

var $1GFtd = parcelRequire("1GFtd");

var $iDAOR = parcelRequire("iDAOR");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $95f6704f80233608$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)("MuiFormGroup", slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $beCSm.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;



var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5042f159189dda87$var$_excluded = [
    "className",
    "row"
];
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $de580948e3d734b1$export$d72d4cbdc30b331f), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $1En50.default)(props, $5042f159189dda87$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$5042f159189dda87$var$FormGroup.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Display group of elements in a compact row.
   * @default false
   */ row: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c550ce5d3f5617f8$export$c4cff3a43f7cabb6(slot) {
    return (0, $4Cod0.default)("MuiRadioGroup", slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $beCSm.default)("MuiRadioGroup", [
    "root",
    "row",
    "error"
]);
var $c550ce5d3f5617f8$export$2e2bcd8739ae039 = $c550ce5d3f5617f8$var$radioGroupClasses;



var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
$f9f6bb9b992d33b5$var$RadioGroupContext.displayName = "RadioGroupContext";
var $f9f6bb9b992d33b5$export$2e2bcd8739ae039 = $f9f6bb9b992d33b5$var$RadioGroupContext;



var $5A6d3 = parcelRequire("5A6d3");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $659f9ff12b4e3755$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c550ce5d3f5617f8$export$c4cff3a43f7cabb6), classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $1En50.default)(props, $659f9ff12b4e3755$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $9Rgf1.default)(ref, rootRef);
    const name = (0, $5A6d3.default)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), (0, $8nd05.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
$659f9ff12b4e3755$var$RadioGroup.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $659f9ff12b4e3755$export$2e2bcd8739ae039 = $659f9ff12b4e3755$var$RadioGroup;


var $2esSG = parcelRequire("2esSG");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $i582X = parcelRequire("i582X");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $kVqvD = parcelRequire("kVqvD");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $03c2199a765ab5af$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e413843d0810bb75$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $d8seH.default)("span", {
    shouldForwardProp: (0, $8Uq77.default)
})({
    position: "relative",
    display: "flex"
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $d8seH.default)((0, $03c2199a765ab5af$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $d8seH.default)((0, $e413843d0810bb75$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
$6d9735fee3c00fe1$var$RadioButtonIcon.propTypes = {
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */ fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "small",
        "medium"
    ])
};
var $6d9735fee3c00fe1$export$2e2bcd8739ae039 = $6d9735fee3c00fe1$var$RadioButtonIcon;



var $jTnBY = parcelRequire("jTnBY");

var $hPGQj = parcelRequire("hPGQj");
var $3d47321b9fcbcb38$export$2e2bcd8739ae039 = (0, $hPGQj.default);



var $acw62 = parcelRequire("acw62");

"use client";
function $e9140607eee18105$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039));
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d9d692e9561f6352$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)("MuiRadio", slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $beCSm.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $d9d692e9561f6352$export$2e2bcd8739ae039 = $d9d692e9561f6352$var$radioClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $cb3af4fea2cad44e$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color)}`,
            size !== "medium" && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8nd05.default)({}, classes, (0, $8Indx.default)(slots, (0, $d9d692e9561f6352$export$192f7b2363c77155), classes));
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = "primary", icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $1En50.default)(props, $cb3af4fea2cad44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $e9140607eee18105$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $3d47321b9fcbcb38$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$RadioRoot, (0, $8nd05.default)({
        type: "radio",
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $cb3af4fea2cad44e$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $cb3af4fea2cad44e$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
$cb3af4fea2cad44e$var$Radio.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "default",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $i582X.default),
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "medium",
            "small"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $cb3af4fea2cad44e$export$2e2bcd8739ae039 = $cb3af4fea2cad44e$var$Radio;



var $1GFtd = parcelRequire("1GFtd");
const $63bcf117b2b4ed6f$var$useStyles = (0, $1GFtd.default)(()=>(0, $b9c362fbce901abe$export$2e2bcd8739ae039)({
        label: {
            color: "black",
            fontSize: "12px"
        },
        radioButton: {
            "& .MuiSvgIcon-root": {
                height: 20
            }
        },
        radioButtonColor: {
            "& .MuiSvgIcon-root": {
                color: "#0033ff"
            }
        }
    }));
function $63bcf117b2b4ed6f$export$2e2bcd8739ae039({ options: options, onChange: onChange, value: value }) {
    const classes = $63bcf117b2b4ed6f$var$useStyles();
    const handleRadioChange = (event)=>{
        onChange(event.target.value);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $659f9ff12b4e3755$export$2e2bcd8739ae039), {
        value: value,
        onChange: handleRadioChange,
        children: options?.sort()?.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                style: {
                    padding: "8px",
                    margin: "2px 0px",
                    width: "100%",
                    backgroundColor: value === option ? "#e5ebff" : ""
                },
                classes: {
                    label: classes.label
                },
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {
                    className: `${classes.radioButton} ${value === option ? classes.radioButtonColor : ""}`
                }),
                label: option,
                value: option
            }, option))
    });
}


var $f587abb87f41bb66$export$2e2bcd8739ae039 = (0, $63bcf117b2b4ed6f$export$2e2bcd8739ae039);


const $488ce0e0acc4caba$var$useStyles = (0, $1GFtd.default)(()=>(0, $b9c362fbce901abe$export$2e2bcd8739ae039)({
        conatiner: {
            marginTop: "-2px"
        },
        searchInput: {
            width: "50%",
            padding: "0px 10px",
            marginLeft: "-10px"
        },
        label: {
            color: "black",
            fontSize: "12px"
        },
        radioButtonContainer: {
            height: "400px",
            overflowY: "scroll",
            boxSizing: "border-box"
        }
    }));
function $488ce0e0acc4caba$export$2e2bcd8739ae039({ publisherList: publisherList, onChange: onChange, value: value }) {
    const [inputValue, setInputValue] = (0, $acw62.useState)(null);
    const classes = $488ce0e0acc4caba$var$useStyles();
    const filterPublisherList = (publisher)=>{
        if (!publisher) return publisherList;
        return publisherList.filter((publisherslug)=>publisherslug?.toLowerCase().includes(publisher?.toLowerCase()));
    };
    const filterPublisher = filterPublisherList(inputValue);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: classes?.conatiner,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {}),
                className: classes.searchInput,
                placeholder: "Search Publisher",
                onDebounceEnd: (publisher)=>{
                    setInputValue(publisher);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    border: "solid 1px #d1d9de",
                    borderRadius: "7px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        sx: {
                            padding: "10px 43px"
                        },
                        className: classes.label,
                        children: "PUBLISHER"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        sx: {
                            border: "1px solid black"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: `${classes?.radioButtonContainer}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f587abb87f41bb66$export$2e2bcd8739ae039), {
                                options: filterPublisher,
                                value: value,
                                onChange: onChange
                            })
                        })
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cFBau = parcelRequire("cFBau");
var $iAtns = parcelRequire("iAtns");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $3bYfT = parcelRequire("3bYfT");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)("MuiInputAdornment", slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3e589c60baacdec$export$4b135a4b3a6c4550), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1En50.default)(props, $d0c64ff513a9933f$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)() || {};
    let variant = variantProp;
    if (variantProp && muiFormControl.variant) {
        if (variantProp === muiFormControl.variant) console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one.");
    }
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
$d0c64ff513a9933f$var$InputAdornment.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `IconButton` or string.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */ disablePointerEvents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The position this adornment should appear relative to the `Input`.
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "end",
        "start"
    ]).isRequired,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "filled",
        "outlined",
        "standard"
    ])
};
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;



var $1GFtd = parcelRequire("1GFtd");
var $20e4b243ccff587b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($20e4b243ccff587b$exports, "__esModule", {
    value: true
});
$20e4b243ccff587b$exports.default = void 0;

var $20e4b243ccff587b$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $20e4b243ccff587b$var$_default = $20e4b243ccff587b$exports.default = (0, $20e4b243ccff587b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");


const $49b7abbdca87eebe$var$useStyles = (0, $1GFtd.default)(()=>(0, $b9c362fbce901abe$export$2e2bcd8739ae039)({
        textInpute: {
            width: "100%",
            padding: "0px 10px",
            margin: "10px 0px 15px 0px"
        },
        inputRoot: {
            padding: "0px 7px !important",
            height: "40px",
            textAlign: "center"
        },
        noBorderRadius: {
            borderRadius: 0
        },
        placeHolder: {
            fontSize: 12
        },
        clearIndicator: {
            display: "none"
        },
        listbox: {
            fontSize: 12,
            fontWeight: "bold"
        }
    }));
var $49b7abbdca87eebe$var$widthValue;
(function(widthValue /* eslint-disable-line @typescript-eslint/naming-convention */ ) {
    widthValue["minWidth"] = "250px";
    widthValue["fullWidth"] = "100%";
})($49b7abbdca87eebe$var$widthValue || ($49b7abbdca87eebe$var$widthValue = {}));
/* eslint-disable-next-line react/function-component-definition */ const $49b7abbdca87eebe$var$SearchDropdown = ({ searchValue: searchValue, options: options, widthSize: widthSize, placeholder: placeholder, onSearchChange: onSearchChange, onOptionClick: onOptionClick })=>{
    const classes = $49b7abbdca87eebe$var$useStyles();
    const filterOptions = searchValue?.trim() === "" ? [] : options?.filter((option)=>{
        if (option.includes("from")) {
            const targetOption = option.split("(")[0];
            return targetOption?.toLowerCase()?.includes(searchValue?.toLowerCase());
        }
        return option?.toLowerCase()?.includes(searchValue?.toLowerCase());
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            width: $49b7abbdca87eebe$var$widthValue[widthSize]
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
            classes: {
                inputRoot: classes.inputRoot,
                clearIndicator: classes.clearIndicator,
                listbox: classes.listbox
            },
            freeSolo: true,
            options: filterOptions,
            onChange: (e, value)=>onOptionClick(value),
            onInputChange: onSearchChange,
            renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    ...params,
                    className: classes.textInpute,
                    variant: "outlined",
                    placeholder: placeholder,
                    fullWidth: true,
                    autoFocus: true,
                    InputProps: {
                        ...params.InputProps,
                        classes: {
                            notchedOutline: classes.noBorderRadius,
                            input: classes.placeHolder
                        },
                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                            position: "start",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($20e4b243ccff587b$exports))), {})
                        })
                    },
                    InputLabelProps: {
                        shrink: false
                    },
                    onKeyDown: (e)=>{
                        e.stopPropagation();
                    }
                })
        })
    });
};
var $49b7abbdca87eebe$export$2e2bcd8739ae039 = $49b7abbdca87eebe$var$SearchDropdown;


var $053f01ce092d1441$export$2e2bcd8739ae039 = (0, $49b7abbdca87eebe$export$2e2bcd8739ae039);




const $1f83f6922083daa5$var$useStyles = (0, $1GFtd.default)(()=>{
    const fontWeight = 500;
    const fontSize = "13px";
    const width = "100%";
    return (0, $b9c362fbce901abe$export$2e2bcd8739ae039)({
        recentViewList: {
            color: "#e5eaef",
            padding: "2px 8px 1px 0px",
            fontSize: "36px",
            paddingRight: "12px"
        },
        textInputWrapper: {
            padding: "0px 7px"
        },
        textInput: {
            width: width,
            padding: "0px 10px"
        },
        viewAll: {
            borderTop: "1px solid #a7b3bd",
            borderBottom: "1px solid #a7b3bd",
            width: width,
            padding: "12px 18px",
            fontSize: fontSize,
            fontFamily: "Poppins",
            fontWeight: fontWeight,
            lineHeight: "20px"
        },
        recent: {
            width: width,
            padding: "13px 19px",
            color: "#3f4853",
            fontSize: fontSize,
            marginTop: "13px",
            fontWeight: fontWeight
        },
        item: {
            fontSize: fontSize,
            fontFamily: "Poppins",
            fontWeight: fontWeight,
            padding: "8px 18px",
            "&:focus": {
                outline: "none",
                boxShadow: "none"
            }
        },
        svgArrowIcon: {
            fontSize: "23px",
            color: "#fff",
            margin: "0px 18px 0px 11px",
            fontWeight: "lighter",
            transform: "rotate(90deg) "
        },
        currentPublisher: {
            fontSize: "18px",
            color: "#fff",
            textTransform: "none",
            outline: "none",
            boxShadow: "none",
            "&:focus": {
                outline: "none",
                boxShadow: "none"
            }
        }
    });
});
function $1f83f6922083daa5$var$SvgArrowIcon({ className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81ed011036a55dbf$export$2e2bcd8739ae039), {
        className: className
    });
}
const $1f83f6922083daa5$var$StyledMenu = (0, $d8seH.default)((props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        ...props
    }))(()=>({
        "& .MuiPaper-root": {
            borderRadius: 2,
            marginTop: "1em",
            minWidth: 260,
            color: "#000",
            fontSize: "13px"
        }
    }));
function $1f83f6922083daa5$export$2e2bcd8739ae039({ asAdmin: asAdmin }) {
    const { snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const classes = $1f83f6922083daa5$var$useStyles();
    const { publishers: publishers, query: query } = (0, $4f86ca3d56f18424$export$a036ba61edb46e4b)({});
    const recentPublisherList = (0, $14c705ecf5141c7b$export$1aae215f59ea61d5)() ?? [];
    const { switchToPublisherGroup: switchToPublisherGroup, switchToPublisher: switchToPublisher, switchToPublisherUsername: switchToPublisherUsername, publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [searchValue, setSearchValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [publisherModalIsOpen, setPublisherModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [switchPublisher, setSwitchPublisher] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [currentPublisherSlug, setCurrentPublisherSlug] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(recentPublisherList[0] || publisherSlug);
    const handleDropdown = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleIModal = ()=>{
        setPublisherModalIsOpen(true);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
        setPublisherModalIsOpen(false);
    };
    const handleSearchChange = (event, newInput)=>{
        setSearchValue(newInput);
    };
    const findCurrentPublisher = (searchText)=>{
        const publisher = publishers?.find((pl)=>pl?.name?.toLowerCase() === searchText?.toLowerCase() || pl.slug === searchText?.toLowerCase() || pl.domains.includes(searchText.split("(")[0].trim()));
        if (publisher) {
            setCurrentPublisherSlug(publisher.name);
            switchToPublisher(publisher.slug);
            (0, $14c705ecf5141c7b$export$a1bdc0fcf3479e85)(publisher.slug);
            switchToPublisherUsername(publisher.users[0]?.username);
            (0, $636507560a861811$export$6ae5cbbde4bec733)(publisher.users[0]?.username);
            switchToPublisherGroup(publisher.group);
            (0, $636507560a861811$export$c0a147212ba524b4)(publisher.group);
            snackbarSuccess(`Successfully switched to ${publisher.name}`);
            handleClose();
            setSwitchPublisher(null);
            setSearchValue("");
        }
    };
    (0, $acw62.useEffect)(()=>{
        findCurrentPublisher(publisherSlug);
    }, [
        publisherSlug
    ]);
    const getDomainsListFromPublisher = (publisher)=>publisher.domains.map((domain)=>`${domain} ( from: ${publisher.name} )`);
    const optionsPublisherAndDomains = [
        ...publishers.length ? publishers.map((publisher)=>publisher.name) : [],
        ...publishers.length ? publishers.map(getDomainsListFromPublisher) : []
    ].flat();
    return asAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            query.isFetched && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
                title: "Choose Your Publisher",
                elementClassName: "modal-publisher-list",
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $488ce0e0acc4caba$export$2e2bcd8739ae039), {
                    value: switchPublisher,
                    publisherList: publishers.length && publishers.map((publisher)=>publisher.name),
                    onChange: setSwitchPublisher
                }),
                onClose: ()=>{
                    handleClose();
                    setSwitchPublisher(null);
                },
                isOpen: publisherModalIsOpen,
                submitButtonText: "Switch Publisher",
                cancelButtonText: "Cancel",
                isSubmitButtonEnabled: !!switchPublisher,
                onSubmit: ()=>{
                    findCurrentPublisher(switchPublisher);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                disableRipple: true,
                "aria-controls": "publisher-list-menu",
                "aria-haspopup": "true",
                onClick: handleDropdown,
                className: classes.currentPublisher,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: currentPublisherSlug
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1f83f6922083daa5$var$SvgArrowIcon, {
                        className: classes?.svgArrowIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($1f83f6922083daa5$var$StyledMenu, {
                    id: "basic-menu",
                    anchorEl: anchorEl,
                    open: Boolean(anchorEl),
                    onClose: handleClose,
                    MenuListProps: {
                        "aria-labelledby": "basic-button"
                    },
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "right"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "right"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            className: classes.textInputWrapper,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $053f01ce092d1441$export$2e2bcd8739ae039), {
                                searchValue: searchValue,
                                options: optionsPublisherAndDomains,
                                placeholder: "search domain/publisher",
                                onSearchChange: handleSearchChange,
                                onOptionClick: (value)=>findCurrentPublisher(value)
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                            className: classes.viewAll,
                            onClick: ()=>handleIModal(),
                            children: "View All"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            className: classes.recent,
                            variant: "subtitle2",
                            children: "RECENT VIEWS"
                        }),
                        recentPublisherList.map((publisher)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                className: classes.item,
                                onClick: ()=>{
                                    findCurrentPublisher(publisher);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $795a1c282b21c2c5$export$2e2bcd8739ae039), {
                                        className: classes?.recentViewList
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: publisher
                                    })
                                ]
                            }, publisher))
                    ]
                })
            })
        ]
    });
}


function $193714fcc8f30367$export$8b251419efc915eb({ asAdmin: asAdmin }) {
    const [isOpen, setIsOpen] = $acw62.useState(false);
    const { signOut: signOut } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((context)=>[
            context.user
        ]);
    const history = (0, $kfZjc.useHistory)();
    const { userProfile: userProfile } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    if (!userProfile) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: " "
    });
    const profileProps = (0, $12872af000a28022$export$59fb969267da6e1f)(userProfile.attributes?.name || userProfile.username);
    const menuItems = [
        {
            text: "Signout",
            handleClick: ()=>{
                signOut();
                (0, $14c705ecf5141c7b$export$a1bdc0fcf3479e85)("");
                (0, $636507560a861811$export$6ae5cbbde4bec733)("");
                (0, $636507560a861811$export$c0a147212ba524b4)("");
                (0, $db434a401f2c9abc$export$2e2bcd8739ae039).reset();
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37a342382669398e$export$2e2bcd8739ae039), {
        elevation: 0,
        position: "static",
        sx: {
            background: "linear-gradient(90deg, #1035C9 0%, #2550FA 100%)",
            height: "70px",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
            maxWidth: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kyRsi.default), {
                disableGutters: true,
                sx: {
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: ()=>history.push("/"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $210a69e1eb51b64d$export$2e2bcd8739ae039), {})
                    }),
                    profileProps && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            rowGap: "20px"
                        },
                        children: [
                            undefined,
                            asAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1f83f6922083daa5$export$2e2bcd8739ae039), {
                                asAdmin: asAdmin
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8a7e516510f6e4c7$exports))), {
                                isOpen: isOpen,
                                onVisibilityChange: setIsOpen,
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efb9fb9496b09505$export$2e2bcd8739ae039), {
                                    width: 35,
                                    height: 35,
                                    text: profileProps.text,
                                    color: profileProps.color
                                }),
                                menuItems: menuItems
                            })
                        ]
                    })
                ]
            })
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $75ca8ca6191977d3$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Page not found."
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bjZRT = parcelRequire("bjZRT");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3W6ht = parcelRequire("3W6ht");

var $dUgGz = parcelRequire("dUgGz");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $960931686a59e228$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $960931686a59e228$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $960931686a59e228$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $dUgGz.getListItemButtonUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $960931686a59e228$var$ListItemButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver: $960931686a59e228$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $dUgGz.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $dUgGz.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $dUgGz.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $dUgGz.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $dUgGz.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $960931686a59e228$var$ListItemButton = /*#__PURE__*/ $acw62.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, component: component = "div", children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $1En50.default)(props, $960931686a59e228$var$_excluded);
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
            else console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered.");
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $960931686a59e228$var$useUtilityClasses(ownerState);
    const handleRef = (0, $9Rgf1.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($960931686a59e228$var$ListItemButtonRoot, (0, $8nd05.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
$960931686a59e228$var$ListItemButton.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Defines the `align-items` style property.
   * @default 'center'
   */ alignItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "center",
        "flex-start"
    ]),
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Use to apply selected styling.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $960931686a59e228$export$2e2bcd8739ae039 = $960931686a59e228$var$ListItemButton;


var $19ocJ = parcelRequire("19ocJ");
var $8AyZl = parcelRequire("8AyZl");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $c9Z8w = parcelRequire("c9Z8w");

var $1mPeS = parcelRequire("1mPeS");

var $lHOu3 = parcelRequire("lHOu3");

var $5qZhP = parcelRequire("5qZhP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $bmoVh = parcelRequire("bmoVh");

var $hweuE = parcelRequire("hweuE");

var $14H9o = parcelRequire("14H9o");

var $9Rgf1 = parcelRequire("9Rgf1");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $247ae09dccc3464c$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)("MuiCollapse", slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $beCSm.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $247ae09dccc3464c$export$2e2bcd8739ae039 = $247ae09dccc3464c$var$collapseClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $848dc8709a4309c5$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $247ae09dccc3464c$export$5162da8f798e0959), classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $d8seH.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $8nd05.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $d8seH.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $d8seH.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $bmoVh.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default) } = props, other = (0, $1En50.default)(props, $848dc8709a4309c5$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $14H9o.default)();
    const timer = (0, $lHOu3.default)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseRoot, (0, $8nd05.default)({
                as: component,
                className: (0, $9QePP.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $8nd05.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $8nd05.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapper, {
                    ownerState: (0, $8nd05.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapperInner, {
                        ownerState: (0, $8nd05.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$848dc8709a4309c5$var$Collapse.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The content node to be collapsed.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */ collapsedSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $5qZhP.default),
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The transition orientation.
   * @default 'vertical'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "horizontal",
        "vertical"
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        })
    ])
};
$848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$export$2e2bcd8739ae039 = $848dc8709a4309c5$var$Collapse;



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d3eb87d8c876d989$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), "Circle");



var $kfZjc = parcelRequire("kfZjc");parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

const $5dc958303e06c3a5$export$ff05e60509bc6769 = 12;
const $5dc958303e06c3a5$export$9da91b8bed9b77ee = $5dc958303e06c3a5$export$ff05e60509bc6769;
const $5dc958303e06c3a5$export$24cce83894f67e7a = 100;
const $5dc958303e06c3a5$export$f3203d6b16e7184f = 10;
const $5dc958303e06c3a5$export$f7c4fb11c95277ac = 25;
const $5dc958303e06c3a5$export$ef953643a4c1c458 = "#FBC02D";
const $5dc958303e06c3a5$export$145b2db09f422acc = false;
const $5dc958303e06c3a5$export$fe55f658fe3636f4 = false;
const $5dc958303e06c3a5$export$7f95b2bd5443b7af = 3;
const $5dc958303e06c3a5$export$ebaebf2c17821fff = 500;
const $5dc958303e06c3a5$export$dbaa36e254979f6f = 100;
const $5dc958303e06c3a5$export$698668688a6e8f34 = {
    PUBLISHER_HUB: "Publisher Hub",
    MEDIA_GALLERY: "Media Gallery",
    REPORTS: "Reports"
};
const $5dc958303e06c3a5$export$b38547102cc16c9f = [
    {
        path: (0, $29836994947f98a9$export$807b1b70df68fbc6).PUBLISHER_HUB,
        text: $5dc958303e06c3a5$export$698668688a6e8f34.PUBLISHER_HUB
    },
    {
        path: (0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY,
        text: $5dc958303e06c3a5$export$698668688a6e8f34.MEDIA_GALLERY
    },
    {
        path: (0, $29836994947f98a9$export$807b1b70df68fbc6).REPORTING,
        text: $5dc958303e06c3a5$export$698668688a6e8f34.REPORTS
    }
];
const $5dc958303e06c3a5$export$9c47d206252ffa27 = [
    `text/vtt`,
    `text/srt`,
    `text/plain`
];
const $5dc958303e06c3a5$export$1547fe5c62a0c049 = 5;
const $5dc958303e06c3a5$export$58e52dd22dd7fb6a = null;
const $5dc958303e06c3a5$export$9c5f6903d23b4822 = [
    {
        id: 1,
        name: "Category"
    },
    {
        id: 2,
        name: "Tag"
    },
    {
        id: 3,
        name: "Custom"
    }
];
const $5dc958303e06c3a5$export$4bc22197a004b096 = [
    {
        value: `newest`,
        text: `Date added (newest)`
    },
    {
        value: `oldest`,
        text: `Date added (oldest)`
    },
    {
        value: `shuffle`,
        text: `Shuffle`
    },
    {
        value: `manual`,
        text: `Manual`
    }
];
const $5dc958303e06c3a5$export$6e6190295ccf9618 = {
    404: "Video not found",
    403: "You are not authorized to access this video",
    500: "Something went wrong. Please try refreshing the page.",
    400: "Bad request"
};
const $5dc958303e06c3a5$export$4a0190bd87e17e53 = {
    width: "70px",
    height: "40px",
    objectFit: "contain",
    borderRadius: "4px",
    border: "1px solid #e0e0e0"
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $24b11f3a326b0d32$exports = {};
$24b11f3a326b0d32$exports = new URL("arrow_down.1bc8a3e1.svg", import.meta.url).toString();


function $7efadcd1f5507aa3$export$2e2bcd8739ae039({ alt: alt, className: className, style: style }) {
    const src = new URL($24b11f3a326b0d32$exports).toString();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: src,
        className: className,
        style: style,
        alt: alt
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $67925c481a1fb5cd$exports = {};
$67925c481a1fb5cd$exports = new URL("arrow_right.70113965.svg", import.meta.url).toString();


function $f5f963ca7f493b38$export$2e2bcd8739ae039({ alt: alt, className: className, style: style }) {
    const src = new URL($67925c481a1fb5cd$exports).toString();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: src,
        className: className,
        style: style,
        alt: alt
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $c38d95c2c95dd510$exports = {};
$c38d95c2c95dd510$exports = new URL("arrow_up.f4e60999.svg", import.meta.url).toString();


function $b04ad06a50dc5a14$export$2e2bcd8739ae039({ alt: alt, className: className, style: style }) {
    const src = new URL($c38d95c2c95dd510$exports).toString();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: src,
        className: className,
        style: style,
        alt: alt
    });
}








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $c78770f0c89775c7$export$1aef8022e4184007;
(function(SidebarActionEnum) {
    SidebarActionEnum["SET_MAIN_SIDEBAR"] = "SET_MAIN_SIDEBAR";
    SidebarActionEnum["SET_SINGLE_PAGE_SIDEBAR"] = "SET_SINGLE_PAGE_SIDEBAR";
})($c78770f0c89775c7$export$1aef8022e4184007 || ($c78770f0c89775c7$export$1aef8022e4184007 = {}));


var $d425c04d82806399$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case (0, $c78770f0c89775c7$export$1aef8022e4184007).SET_MAIN_SIDEBAR:
            return {
                ...state,
                singlePageSidebar: []
            };
        case (0, $c78770f0c89775c7$export$1aef8022e4184007).SET_SINGLE_PAGE_SIDEBAR:
            return {
                ...state,
                singlePageSidebar: action.payload.singlePageSidebar
            };
        default:
            throw new Error(`Unhandled sidebar action type: ${action.type}`);
    }
};


const $19d54d555e11d5ac$var$initialState = {
    isOpen: true,
    singlePageSidebar: []
};
const $19d54d555e11d5ac$var$CurrentSidebarContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $19d54d555e11d5ac$export$d8355e8edbcacbe8 = ({ children: children })=>{
    const [store, dispatch] = (0, $acw62.useReducer)((0, $d425c04d82806399$export$2e2bcd8739ae039), {
        ...$19d54d555e11d5ac$var$initialState
    });
    const contextMemorizedValue = (0, $acw62.useMemo)(()=>[
            store,
            dispatch
        ], [
        store
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19d54d555e11d5ac$var$CurrentSidebarContext.Provider, {
        value: contextMemorizedValue,
        children: children
    });
};
const $19d54d555e11d5ac$export$861cd542ff836f0d = ()=>{
    const context = (0, $acw62.useContext)($19d54d555e11d5ac$var$CurrentSidebarContext);
    if (!context) throw new Error("useSidebarContext must be used within a SidebarProvider");
    return context;
};




function $1d86e5558f6878d0$var$LeftListItemIcon({ color: color }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
        sx: {
            minWidth: "30px"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3eb87d8c876d989$export$2e2bcd8739ae039), {
            sx: {
                fontSize: "15px"
            },
            color: color
        })
    });
}
function $1d86e5558f6878d0$var$RightListItemIcon({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
        sx: {
            minWidth: 0
        },
        children: children
    });
}
const $1d86e5558f6878d0$var$baseListItemButtonSx = {
    px: "24px",
    height: "46px",
    borderBottom: "solid 1px #c8d0d6"
};
function $1d86e5558f6878d0$var$SidebarListItemButton({ onClick: onClick, selected: selected, text: text, iconElement: iconElement }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $960931686a59e228$export$2e2bcd8739ae039), {
        sx: {
            ...$1d86e5558f6878d0$var$baseListItemButtonSx
        },
        onClick: onClick,
        selected: selected,
        children: [
            iconElement || /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$LeftListItemIcon, {
                color: selected ? "primary" : undefined
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                primary: text,
                primaryTypographyProps: selected ? {
                    sx: {
                        fontWeight: 600
                    }
                } : undefined
            })
        ]
    });
}
function $1d86e5558f6878d0$export$1ba59dacbcbf90fe({ isPublisherAdmin: isPublisherAdmin }) {
    const location = (0, $kfZjc.useLocation)();
    const session = (0, $99e18646983cd0f4$export$2e2bcd8739ae039)();
    const history = (0, $kfZjc.useHistory)();
    const isPathActive = (path)=>!!(0, $kfZjc.matchPath)(location.pathname, {
            path: path,
            exact: false,
            strict: false
        });
    const [open, setOpen] = (0, $acw62.useState)(isPathActive((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN));
    const [bulkEdit, setBulkEditOpen] = (0, $acw62.useState)(location.pathname.includes((0, $29836994947f98a9$export$807b1b70df68fbc6).BULK_EDIT));
    const userGroups = session && session.getAccessToken().payload["cognito:groups"];
    const isSuperAdmin = userGroups && userGroups.includes("admin");
    const userIsAdmin = isSuperAdmin || isPublisherAdmin;
    const [{ singlePageSidebar: singlePageSidebar }] = (0, $19d54d555e11d5ac$export$861cd542ff836f0d)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(userIsAdmin);
    if (singlePageSidebar && singlePageSidebar.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
        className: "sidebar-container",
        disablePadding: true,
        children: singlePageSidebar.map((sb)=>{
            const { path: path, text: text, onClick: onClick, iconElement: iconElement } = sb;
            return /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$SidebarListItemButton, {
                text: text,
                iconElement: iconElement,
                selected: isPathActive(path),
                onClick: onClick || (()=>history.push(path))
            }, `custom-sidebar-item-${text}`);
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
        sx: {
            boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)"
        },
        children: [
            (0, $5dc958303e06c3a5$export$b38547102cc16c9f).map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$SidebarListItemButton, {
                    onClick: ()=>history.push(item.path),
                    selected: isPathActive(item.path),
                    text: item.text
                }, item.path)),
            userIsAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $960931686a59e228$export$2e2bcd8739ae039), {
                        sx: $1d86e5558f6878d0$var$baseListItemButtonSx,
                        onClick: ()=>setOpen(!open),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$LeftListItemIcon, {
                                color: isPathActive((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN) ? "primary" : undefined
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                primary: "Admin",
                                primaryTypographyProps: isPathActive((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN) ? {
                                    sx: {
                                        fontWeight: 600
                                    }
                                } : undefined
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$RightListItemIcon, {
                                children: open ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b04ad06a50dc5a14$export$2e2bcd8739ae039), {
                                    alt: "expand less",
                                    style: {
                                        width: "9px"
                                    }
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7efadcd1f5507aa3$export$2e2bcd8739ae039), {
                                    alt: "expand more",
                                    style: {
                                        width: "9px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $848dc8709a4309c5$export$2e2bcd8739ae039), {
                        in: open,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
                            component: "div",
                            disablePadding: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$SidebarListItemButton, {
                                    onClick: ()=>history.push((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_USERS),
                                    selected: isPathActive((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_USERS),
                                    text: "User management"
                                }),
                                isSuperAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$SidebarListItemButton, {
                                            onClick: ()=>history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN, {
                                                    slug: publisherSlug
                                                })),
                                            selected: location.pathname.includes((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN),
                                            text: "Domain management"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$SidebarListItemButton, {
                                            onClick: ()=>history.push((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PUBLISHER_ONBOARD),
                                            selected: location.pathname.includes((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PUBLISHER_ONBOARD),
                                            text: "Onboard Publishers"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $960931686a59e228$export$2e2bcd8739ae039), {
                                    sx: {
                                        ...$1d86e5558f6878d0$var$baseListItemButtonSx
                                    },
                                    onClick: ()=>setBulkEditOpen(!bulkEdit),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$LeftListItemIcon, {
                                            color: location.pathname.includes((0, $29836994947f98a9$export$807b1b70df68fbc6).BULK_EDIT) ? "primary" : undefined
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                            primary: "Bulk Edit",
                                            primaryTypographyProps: location.pathname.includes((0, $29836994947f98a9$export$807b1b70df68fbc6).BULK_EDIT) ? {
                                                sx: {
                                                    fontWeight: 600
                                                }
                                            } : undefined
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$RightListItemIcon, {
                                            children: bulkEdit ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b04ad06a50dc5a14$export$2e2bcd8739ae039), {
                                                alt: "expand less",
                                                style: {
                                                    width: "9px"
                                                }
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7efadcd1f5507aa3$export$2e2bcd8739ae039), {
                                                alt: "expand more",
                                                style: {
                                                    width: "9px"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $848dc8709a4309c5$export$2e2bcd8739ae039), {
                                    in: bulkEdit,
                                    timeout: "auto",
                                    unmountOnExit: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
                                        component: "div",
                                        disablePadding: true,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$SidebarListItemButton, {
                                                onClick: ()=>history.push((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_BULK_UPDATE),
                                                selected: location.pathname.includes((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_BULK_UPDATE),
                                                text: "Update"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($1d86e5558f6878d0$var$SidebarListItemButton, {
                                                onClick: ()=>history.push((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_BULK_DELETE),
                                                selected: location.pathname.includes((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_BULK_DELETE),
                                                text: "Delete"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8ca75cf684bd0a38$export$7f2e1fd47b352b5f;
(function(MediaState) {
    // Only Frontend states
    MediaState["UPLOADING"] = "uploading";
    MediaState["ABORTED"] = "aborted";
    // API states
    MediaState["EMPTY"] = "empty";
    MediaState["PROCESSING"] = "processing";
    MediaState["READY"] = "ready";
    MediaState["UPLOADED"] = "uploaded";
    MediaState["FAILED"] = "failed";
    MediaState["SOFT_DELETED"] = "soft_deleted";
    MediaState["HARD_DELETED"] = "hard_deleted";
    MediaState["DRAFT"] = "draft";
})($8ca75cf684bd0a38$export$7f2e1fd47b352b5f || ($8ca75cf684bd0a38$export$7f2e1fd47b352b5f = {}));
var $8ca75cf684bd0a38$export$7aa631536f5ac276;
(function(BulkEditType) {
    BulkEditType["TAGS"] = "tags";
    BulkEditType["CATEGORY"] = "category";
})($8ca75cf684bd0a38$export$7aa631536f5ac276 || ($8ca75cf684bd0a38$export$7aa631536f5ac276 = {}));


var $6210bec9c6d47e2f$export$c863cd691bba752;
(function(UploadResultStatesEnums) {
    UploadResultStatesEnums["FULFILLED"] = "fulfilled";
    UploadResultStatesEnums["REJECTED"] = "rejected";
})($6210bec9c6d47e2f$export$c863cd691bba752 || ($6210bec9c6d47e2f$export$c863cd691bba752 = {}));


const $1cd70745a1b59d1c$export$9db6462b07c2e33f = `video-create-mutation`;
const $1cd70745a1b59d1c$export$3a01487f0c19bd29 = {
    uploadingVideos: [],
    abortController: new AbortController(),
    uploadingFilesCount: 0,
    uploadInProgress: false
};


var $9c02a4b9f1079c8c$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case (0, $8d9dab153099bf22$export$a2ccf1848ebec243).UPLOAD_STARTED:
            return {
                ...state,
                uploadInProgress: true,
                uploadingFilesCount: action.payload.uploadingFilesCount
            };
        case (0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_CREATION_STARTED:
            {
                const { uploadingVideos: uploadingVideos } = state;
                const { title: title, index: index, file: file, domain: domain } = action.payload;
                uploadingVideos[index] = {
                    title: title,
                    progress: 0,
                    completed: false,
                    status: (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).EMPTY,
                    file: file,
                    domain: domain
                };
                return {
                    ...state,
                    uploadingVideos: uploadingVideos
                };
            }
        case (0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_SIGNED_URL_CREATED:
            {
                const { uploadingVideos: uploadingVideos } = state;
                const { token: token, index: index, videoURL: videoURL, imageURL: imageURL } = action.payload;
                uploadingVideos[index] = {
                    ...uploadingVideos[index],
                    token: token,
                    isUploading: true,
                    video: {
                        signedURL: videoURL
                    },
                    image: {
                        signedURL: imageURL
                    }
                };
                return {
                    ...state,
                    uploadingVideos: uploadingVideos
                };
            }
        case (0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_UPLOAD_PROGRESS:
            {
                const { uploadingVideos: uploadingVideos } = state;
                const { index: index, progress: progress } = action.payload;
                uploadingVideos[index] = {
                    ...uploadingVideos[index],
                    progress: progress,
                    status: (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).UPLOADING
                };
                return {
                    ...state,
                    uploadingVideos: uploadingVideos
                };
            }
        case (0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_UPLOAD_ENDED:
            {
                const { uploadingVideos: uploadingVideos } = state;
                const { index: index, statuses: statuses } = action.payload;
                uploadingVideos[index] = {
                    ...uploadingVideos[index],
                    isUploading: false,
                    progress: 100,
                    completed: true,
                    status: statuses[0] === (0, $6210bec9c6d47e2f$export$c863cd691bba752).FULFILLED ? (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).PROCESSING : (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).FAILED,
                    video: {
                        state: statuses[0],
                        // Will be usefully if we want to resend/resume after process aborted
                        // we can apply to expire as well based on S3 policy as well
                        ...statuses[0] === (0, $6210bec9c6d47e2f$export$c863cd691bba752).FULFILLED && {
                            signedURL: null
                        }
                    },
                    image: {
                        state: statuses[1],
                        ...statuses[1] === (0, $6210bec9c6d47e2f$export$c863cd691bba752).FULFILLED && {
                            signedURL: null
                        }
                    }
                };
                return {
                    ...state,
                    uploadingVideos: uploadingVideos,
                    uploadInProgress: uploadingVideos.filter((v)=>!!v.isUploading).length > 0
                };
            }
        case (0, $8d9dab153099bf22$export$a2ccf1848ebec243).UPLOAD_ABORTED:
            return {
                ...state,
                uploadingFilesCount: 0,
                uploadInProgress: false,
                uploadingVideos: state.uploadingVideos.map((v)=>({
                        ...v,
                        isUploading: false,
                        progress: 0,
                        status: (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).ABORTED,
                        completed: true
                    }))
            };
        case (0, $8d9dab153099bf22$export$a2ccf1848ebec243).CLOSE_UPLOAD_INDICATOR_CONTAINER:
            return {
                ...state,
                ...(0, $1cd70745a1b59d1c$export$3a01487f0c19bd29)
            };
        default:
            return state;
    }
};



// Initial state, as it's shared will have one point of truth, and avoid linter error
const $aece6033f0ce4c41$var$initialState = (0, $1cd70745a1b59d1c$export$3a01487f0c19bd29);
// IMPROVEMENT: Use sessionStorage to persist state for pre-signed URLS, and apply file load to that URL
// Create context
const $aece6033f0ce4c41$var$CurrentUploadStateContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $aece6033f0ce4c41$var$CurrentUploadStateDispatcher = /*#__PURE__*/ (0, $acw62.createContext)(null);
// Create provider
const $aece6033f0ce4c41$var$AppProvider = ({ children: children })=>{
    const [store, dispatch] = (0, $acw62.useReducer)((0, $9c02a4b9f1079c8c$export$2e2bcd8739ae039), $aece6033f0ce4c41$var$initialState);
    const memorizedValue = (0, $acw62.useMemo)(()=>store, [
        store
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aece6033f0ce4c41$var$CurrentUploadStateContext.Provider, {
        value: memorizedValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($aece6033f0ce4c41$var$CurrentUploadStateDispatcher.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const $aece6033f0ce4c41$export$327c7ed43d894c97 = ()=>{
    const context = (0, $acw62.useContext)($aece6033f0ce4c41$var$CurrentUploadStateContext);
    if (!context) throw new Error("useUploadStateContext must be used within a UploadProvider");
    return context;
};
const $aece6033f0ce4c41$export$8d64f678f60b47f7 = ()=>{
    const context = (0, $acw62.useContext)($aece6033f0ce4c41$var$CurrentUploadStateDispatcher);
    if (!context) throw new Error("useUploadDispatchContext must be used within a UploadProvider");
    return context;
};
var $aece6033f0ce4c41$export$2e2bcd8739ae039 = $aece6033f0ce4c41$var$AppProvider;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1GFtd = parcelRequire("1GFtd");

var $2cPwN = parcelRequire("2cPwN");
var $7Frhn = parcelRequire("7Frhn");
var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $7Frhn = parcelRequire("7Frhn");

var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
$5bbfcb95732dc207$var$AccordionContext.displayName = "AccordionContext";
var $5bbfcb95732dc207$export$2e2bcd8739ae039 = $5bbfcb95732dc207$var$AccordionContext;



var $3yddg = parcelRequire("3yddg");

var $6lpak = parcelRequire("6lpak");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e14e8c767477d992$export$80fb6a2cb3f13b8b(slot) {
    return (0, $4Cod0.default)("MuiAccordion", slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $beCSm.default)("MuiAccordion", [
    "root",
    "rounded",
    "expanded",
    "disabled",
    "gutters",
    "region"
]);
var $e14e8c767477d992$export$2e2bcd8739ae039 = $e14e8c767477d992$var$accordionClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5c228c234852d575$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            !square && "rounded",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        region: [
            "region"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e14e8c767477d992$export$80fb6a2cb3f13b8b), classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiAccordion",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e14e8c767477d992$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: "relative",
        transition: theme.transitions.create([
            "margin"
        ], transition),
        overflowAnchor: "none",
        // Keep the same scrolling position
        "&::before": {
            position: "absolute",
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                "opacity",
                "background-color"
            ], transition)
        },
        "&:first-of-type": {
            "&::before": {
                display: "none"
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
            "&::before": {
                opacity: 0
            },
            "&:first-of-type": {
                marginTop: 0
            },
            "&:last-of-type": {
                marginBottom: 0
            },
            "& + &": {
                "&::before": {
                    display: "none"
                }
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    "&:first-of-type": {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    "&:last-of-type": {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        "@supports (-ms-ime-align: auto)": {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
                        margin: "16px 0"
                    }
                }
            }
        ]
    }));
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAccordion"
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $1En50.default)(props, $5c228c234852d575$var$_excluded);
    const [expanded, setExpandedState] = (0, $3yddg.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: "Accordion",
        state: "expanded"
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $8nd05.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $8nd05.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $6lpak.default)("transition", {
        elementType: (0, $848dc8709a4309c5$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5c228c234852d575$var$AccordionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bbfcb95732dc207$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, (0, $8nd05.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props["aria-controls"],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
$5c228c234852d575$var$Accordion.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired, (props)=>{
        const summary = $acw62.Children.toArray(props.children)[0];
        if ((0, $4jPKB.isFragment)(summary)) return new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.");
        if (!/*#__PURE__*/ $acw62.isValidElement(summary)) return new Error("MUI: Expected the first child of Accordion to be a valid element.");
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, expands the accordion by default.
   * @default false
   */ defaultExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */ expanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $5c228c234852d575$export$2e2bcd8739ae039 = $5c228c234852d575$var$Accordion;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d55ba52db43b55df$export$282216ad123d6580(slot) {
    return (0, $4Cod0.default)("MuiAccordionSummary", slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $beCSm.default)("MuiAccordionSummary", [
    "root",
    "expanded",
    "focusVisible",
    "disabled",
    "gutters",
    "contentGutters",
    "content",
    "expandIconWrapper"
]);
var $d55ba52db43b55df$export$2e2bcd8739ae039 = $d55ba52db43b55df$var$accordionSummaryClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $1a792f5a0c37e2ab$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        focusVisible: [
            "focusVisible"
        ],
        content: [
            "content",
            expanded && "expanded",
            !disableGutters && "contentGutters"
        ],
        expandIconWrapper: [
            "expandIconWrapper",
            expanded && "expanded"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d55ba52db43b55df$export$282216ad123d6580), classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: "MuiAccordionSummary",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: "flex",
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            "min-height",
            "background-color"
        ], transition),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled})`]: {
            cursor: "pointer"
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $d8seH.default)("div", {
    name: "MuiAccordionSummary",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: "flex",
        flexGrow: 1,
        margin: "12px 0",
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        "margin"
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        margin: "20px 0"
                    }
                }
            }
        ]
    }));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $d8seH.default)("div", {
    name: "MuiAccordionSummary",
    slot: "ExpandIconWrapper",
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: "flex",
        color: (theme.vars || theme).palette.action.active,
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
            transform: "rotate(180deg)"
        }
    }));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAccordionSummary"
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $1En50.default)(props, $1a792f5a0c37e2ab$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $5bbfcb95732dc207$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a792f5a0c37e2ab$var$AccordionSummaryRoot, (0, $8nd05.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $9QePP.default)(classes.root, className),
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
$1a792f5a0c37e2ab$var$AccordionSummary.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The icon to display as the expand indicator.
   */ expandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $1a792f5a0c37e2ab$export$2e2bcd8739ae039 = $1a792f5a0c37e2ab$var$AccordionSummary;


var $3bYfT = parcelRequire("3bYfT");
var $lkxXU = parcelRequire("lkxXU");
var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4b72c3145e33d8$export$a6afb527becfac26(slot) {
    return (0, $4Cod0.default)("MuiAccordionDetails", slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $beCSm.default)("MuiAccordionDetails", [
    "root"
]);
var $6e4b72c3145e33d8$export$2e2bcd8739ae039 = $6e4b72c3145e33d8$var$accordionDetailsClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $1b78273c1c27a2e1$var$_excluded = [
    "className"
];
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6e4b72c3145e33d8$export$a6afb527becfac26), classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $d8seH.default)("div", {
    name: "MuiAccordionDetails",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAccordionDetails"
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $1b78273c1c27a2e1$var$_excluded);
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$1b78273c1c27a2e1$var$AccordionDetails.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $1b78273c1c27a2e1$export$2e2bcd8739ae039 = $1b78273c1c27a2e1$var$AccordionDetails;


var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $bjZRT = parcelRequire("bjZRT");
var $19ocJ = parcelRequire("19ocJ");

var $bNGtB = parcelRequire("bNGtB");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3fed6bc25c5eb7cb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");


var $eJaQo = parcelRequire("eJaQo");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bc0da73b61a3d359$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m18 4 2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z"
}), "Movie");






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $1GFtd = parcelRequire("1GFtd");

const $f3846ac6d4b84146$var$useStyles = (0, $1GFtd.default)({
    paper: {
        "& .MuiPaper-root": {
            height: "192px !important",
            padding: "20px",
            margin: 0,
            width: "min(590px, 50%)"
        }
    }
});
function $f3846ac6d4b84146$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, onSubmitClick: onSubmitClick, header: header, body: body, submitButtonText: submitButtonText, cancelButtonText: cancelButtonText, inputContainer: inputContainer, isCloseIconDismissible: isCloseIconDismissible }) {
    const classes = $f3846ac6d4b84146$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))), {
        className: `confirm-modal ${classes.paper}`,
        isOpen: isOpen,
        onClose: onClose,
        onSubmitClick: onSubmitClick,
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).THEME_ENUM.v2,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).TYPE_ENUM.confirmation,
        header: header,
        body: body,
        submitButtonText: submitButtonText || "Save",
        cancelButtonText: cancelButtonText || "Cancel",
        inputContainer: inputContainer,
        isCloseIconDismissible: isCloseIconDismissible || true
    });
}


const $813cd6504fe4ba99$var$useStyles = (0, $1GFtd.default)({
    paper: {
        "& .MuiPaper-root": {
            padding: 0,
            position: "fixed",
            bottom: "10px",
            right: "10px",
            width: "440px",
            maxWidth: "100%",
            "& .MuiCollapse-root .MuiCollapse-wrapperInner > div": {
                padding: 0
            },
            "& .MuiAccordionSummary-content, & .MuiListItem-root": {
                padding: 0,
                margin: "10px 0"
            },
            "& #accordion-panel-header": {
                "&:hover": {
                    cursor: "auto"
                },
                "& .MuiAccordionSummary-content": {
                    padding: 0
                },
                "& .Mui-expanded": {
                    transform: "rotate(0)"
                },
                "& .Mui-expanded .accordion-expander": {
                    transform: "rotate(180deg)"
                }
            },
            "& #accordion-button-summary-container": {
                cursor: "pointer",
                "& > svg": {
                    marginLeft: "10px"
                }
            },
            "& .MuiListItemIcon-root": {
                minWidth: "auto"
            },
            "& .media-title-text": {
                padding: "0 10px"
            },
            "& .title": {
                display: "block",
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "24px"
            },
            "& .subtitle": {
                display: "block",
                color: "#3C61F3",
                fontSize: "14px",
                lineHeight: "20px"
            },
            "& .prefix-icon": {
                color: "#000000"
            }
        }
    }
});
/**
 * UploadProgressModal
 * @constructor
 */ const $813cd6504fe4ba99$var$UploadProgressModal = ()=>{
    const classes = $813cd6504fe4ba99$var$useStyles($813cd6504fe4ba99$var$useStyles);
    const [expanded, setExpanded] = (0, $acw62.useState)(true);
    const [counters, setCounter] = (0, $acw62.useState)({
        completed: 0,
        uploading: 0
    });
    const [showConfirmModal, setShowConfirmModal] = (0, $acw62.useState)(false);
    const uploadState = (0, $aece6033f0ce4c41$export$327c7ed43d894c97)();
    const { uploadingVideos: uploadingVideos, abortController: abortController, uploadingFilesCount: uploadingFilesCount, uploadInProgress: uploadInProgress } = uploadState;
    const uploadDispatcher = (0, $aece6033f0ce4c41$export$8d64f678f60b47f7)();
    (0, $acw62.useEffect)(()=>{
        const completed = uploadingVideos.filter((up)=>up.completed).length;
        setCounter({
            completed: completed,
            uploading: uploadingVideos.filter((up)=>up.isUploading).length
        });
        if (completed === uploadingFilesCount && !uploadInProgress) uploadDispatcher({
            type: (0, $8d9dab153099bf22$export$a2ccf1848ebec243).CLOSE_UPLOAD_INDICATOR_CONTAINER
        });
    }, [
        uploadState
    ]);
    const toggleAccordion = ()=>setExpanded(!expanded);
    const handleCancelledUpload = (ev)=>{
        ev.preventDefault();
        if (uploadInProgress && abortController && !abortController.signal?.aborted) {
            abortController.abort();
            uploadingVideos.forEach((up)=>{
                if (!up.completed) uploadDispatcher({
                    type: (0, $8d9dab153099bf22$export$a2ccf1848ebec243).UPLOAD_ABORTED
                });
            });
        }
    };
    const progressIcon = (upload, fontSize = "24px")=>{
        if (upload.isUploading && upload.progress < 100) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
            variant: "determinate",
            size: fontSize,
            value: upload.progress
        });
        if (upload.completed) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bNGtB.default), {
            sx: {
                color: "#006300",
                fontSize: fontSize
            }
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
            size: fontSize
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7Frhn.default), {
        id: "upload-progress-container",
        className: `${classes.paper}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: showConfirmModal,
                header: "Are you sure you want to abort uploading videos?",
                body: "This will stop uploading videos to the server.",
                submitButtonText: "Cancel Uploads",
                onClose: ()=>setShowConfirmModal(false),
                onSubmitClick: handleCancelledUpload
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                defaultExpanded: true,
                square: true,
                expanded: expanded,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                        expandIcon: counters.uploading === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            id: "accordion-button-summary-container",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fed6bc25c5eb7cb$export$2e2bcd8739ae039), {
                                    className: "accordion-expander",
                                    onClick: ()=>toggleAccordion()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJaQo.default), {
                                    onClick: ()=>setShowConfirmModal(true)
                                })
                            ]
                        }),
                        "aria-controls": "accordion-panel-content",
                        id: "accordion-panel-header",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    className: "title",
                                    variant: "h5",
                                    children: [
                                        "Uploading ",
                                        uploadingFilesCount,
                                        " video(s)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    className: "subtitle",
                                    variant: "subtitle1",
                                    children: [
                                        counters.completed,
                                        " out of ",
                                        uploadingFilesCount
                                    ]
                                })
                            ]
                        })
                    }),
                    uploadingVideos.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
                                    children: uploadingVideos.map((video)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lofVM.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                                                    className: "prefix-icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bc0da73b61a3d359$export$2e2bcd8739ae039), {
                                                        fontSize: "small"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                                    className: "media-title-text",
                                                    children: video.title
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                                                    children: progressIcon(video)
                                                })
                                            ]
                                        }, `uploaded-video-progress-${video.title || video.token}`))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $813cd6504fe4ba99$export$2e2bcd8739ae039 = $813cd6504fe4ba99$var$UploadProgressModal;


function $82815a5f14ae99c4$export$2e2bcd8739ae039({ children: children, asAdmin: asAdmin, isPublisherAdmin: isPublisherAdmin }) {
    const location = (0, $kfZjc.useLocation)();
    const { uploadingFilesCount: uploadingFilesCount } = (0, $aece6033f0ce4c41$export$327c7ed43d894c97)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track_pageview();
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $193714fcc8f30367$export$8b251419efc915eb), {
                asAdmin: asAdmin
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "260px calc(100vw - 260px)",
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d86e5558f6878d0$export$1ba59dacbcbf90fe), {
                        isPublisherAdmin: isPublisherAdmin
                    }),
                    children
                ]
            }),
            uploadingFilesCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $813cd6504fe4ba99$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6bbabf3c01bf9470$var$extendStatics = function(d, b) {
    $6bbabf3c01bf9470$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6bbabf3c01bf9470$var$extendStatics(d, b);
};
function $6bbabf3c01bf9470$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6bbabf3c01bf9470$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6bbabf3c01bf9470$export$18ce0697a983be9b = function() {
    $6bbabf3c01bf9470$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6bbabf3c01bf9470$export$18ce0697a983be9b.apply(this, arguments);
};
function $6bbabf3c01bf9470$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6bbabf3c01bf9470$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6bbabf3c01bf9470$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6bbabf3c01bf9470$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6bbabf3c01bf9470$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6bbabf3c01bf9470$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6bbabf3c01bf9470$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6bbabf3c01bf9470$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6bbabf3c01bf9470$export$45d3717a4c69092e(o, m, p);
}
function $6bbabf3c01bf9470$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6bbabf3c01bf9470$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6bbabf3c01bf9470$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6bbabf3c01bf9470$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6bbabf3c01bf9470$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6bbabf3c01bf9470$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6bbabf3c01bf9470$export$10c90e4f7922046c(v) {
    return this instanceof $6bbabf3c01bf9470$export$10c90e4f7922046c ? (this.v = v, this) : new $6bbabf3c01bf9470$export$10c90e4f7922046c(v);
}
function $6bbabf3c01bf9470$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6bbabf3c01bf9470$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6bbabf3c01bf9470$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6bbabf3c01bf9470$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6bbabf3c01bf9470$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6bbabf3c01bf9470$export$19a8beecd37a4c45 === "function" ? $6bbabf3c01bf9470$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6bbabf3c01bf9470$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6bbabf3c01bf9470$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $6bbabf3c01bf9470$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6bbabf3c01bf9470$export$45d3717a4c69092e(result, mod, k);
    }
    $6bbabf3c01bf9470$var$__setModuleDefault(result, mod);
    return result;
}
function $6bbabf3c01bf9470$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6bbabf3c01bf9470$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6bbabf3c01bf9470$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6bbabf3c01bf9470$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}



var $acw62 = parcelRequire("acw62");
var $60313e3b9e75c852$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $221e6a6efdd9e64e$export$6f3cc5789c9e770e = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


var $f98b5e72da0bdf12$export$8f45430ccf837300 = {
    red: {
        10: {
            value: "hsl(0, 75%, 95%)"
        },
        20: {
            value: "hsl(0, 75%, 85%)"
        },
        40: {
            value: "hsl(0, 75%, 75%)"
        },
        60: {
            value: "hsl(0, 50%, 50%)"
        },
        80: {
            value: "hsl(0, 95%, 30%)"
        },
        90: {
            value: "hsl(0, 100%, 20%)"
        },
        100: {
            value: "hsl(0, 100%, 15%)"
        }
    },
    orange: {
        10: {
            value: "hsl(30, 75%, 95%)"
        },
        20: {
            value: "hsl(30, 75%, 85%)"
        },
        40: {
            value: "hsl(30, 75%, 75%)"
        },
        60: {
            value: "hsl(30, 50%, 50%)"
        },
        80: {
            value: "hsl(30, 95%, 30%)"
        },
        90: {
            value: "hsl(30, 100%, 20%)"
        },
        100: {
            value: "hsl(30, 100%, 15%)"
        }
    },
    yellow: {
        10: {
            value: "hsl(60, 75%, 95%)"
        },
        20: {
            value: "hsl(60, 75%, 85%)"
        },
        40: {
            value: "hsl(60, 75%, 75%)"
        },
        60: {
            value: "hsl(60, 50%, 50%)"
        },
        80: {
            value: "hsl(60, 95%, 30%)"
        },
        90: {
            value: "hsl(60, 100%, 20%)"
        },
        100: {
            value: "hsl(60, 100%, 15%)"
        }
    },
    green: {
        10: {
            value: "hsl(130, 60%, 95%)"
        },
        20: {
            value: "hsl(130, 60%, 90%)"
        },
        40: {
            value: "hsl(130, 44%, 63%)"
        },
        60: {
            value: "hsl(130, 43%, 46%)"
        },
        80: {
            value: "hsl(130, 33%, 37%)"
        },
        90: {
            value: "hsl(130, 27%, 29%)"
        },
        100: {
            value: "hsl(130, 22%, 23%)"
        }
    },
    teal: {
        10: {
            value: "hsl(190, 75%, 95%)"
        },
        20: {
            value: "hsl(190, 75%, 85%)"
        },
        40: {
            value: "hsl(190, 70%, 70%)"
        },
        60: {
            value: "hsl(190, 50%, 50%)"
        },
        80: {
            value: "hsl(190, 95%, 30%)"
        },
        90: {
            value: "hsl(190, 100%, 20%)"
        },
        100: {
            value: "hsl(190, 100%, 15%)"
        }
    },
    blue: {
        10: {
            value: "hsl(220, 95%, 95%)"
        },
        20: {
            value: "hsl(220, 85%, 85%)"
        },
        40: {
            value: "hsl(220, 70%, 70%)"
        },
        60: {
            value: "hsl(220, 50%, 50%)"
        },
        80: {
            value: "hsl(220, 95%, 30%)"
        },
        90: {
            value: "hsl(220, 100%, 20%)"
        },
        100: {
            value: "hsl(220, 100%, 15%)"
        }
    },
    purple: {
        10: {
            value: "hsl(300, 95%, 95%)"
        },
        20: {
            value: "hsl(300, 85%, 85%)"
        },
        40: {
            value: "hsl(300, 70%, 70%)"
        },
        60: {
            value: "hsl(300, 50%, 50%)"
        },
        80: {
            value: "hsl(300, 95%, 30%)"
        },
        90: {
            value: "hsl(300, 100%, 20%)"
        },
        100: {
            value: "hsl(300, 100%, 15%)"
        }
    },
    pink: {
        10: {
            value: "hsl(340, 95%, 95%)"
        },
        20: {
            value: "hsl(340, 90%, 85%)"
        },
        40: {
            value: "hsl(340, 70%, 70%)"
        },
        60: {
            value: "hsl(340, 50%, 50%)"
        },
        80: {
            value: "hsl(340, 95%, 30%)"
        },
        90: {
            value: "hsl(340, 100%, 20%)"
        },
        100: {
            value: "hsl(340, 100%, 15%)"
        }
    },
    neutral: {
        10: {
            value: "hsl(210, 5%, 98%)"
        },
        20: {
            value: "hsl(210, 5%, 94%)"
        },
        40: {
            value: "hsl(210, 5%, 87%)"
        },
        60: {
            value: "hsl(210, 8%, 55%)"
        },
        80: {
            value: "hsl(210, 10%, 40%)"
        },
        90: {
            value: "hsl(210, 25%, 25%)"
        },
        100: {
            value: "hsl(210, 50%, 10%)"
        }
    },
    brand: {
        primary: {
            10: {
                value: "{colors.teal.10.value}"
            },
            20: {
                value: "{colors.teal.20.value}"
            },
            40: {
                value: "{colors.teal.40.value}"
            },
            60: {
                value: "{colors.teal.60.value}"
            },
            80: {
                value: "{colors.teal.80.value}"
            },
            90: {
                value: "{colors.teal.90.value}"
            },
            100: {
                value: "{colors.teal.100.value}"
            }
        },
        secondary: {
            10: {
                value: "{colors.purple.10.value}"
            },
            20: {
                value: "{colors.purple.20.value}"
            },
            40: {
                value: "{colors.purple.40.value}"
            },
            60: {
                value: "{colors.purple.60.value}"
            },
            80: {
                value: "{colors.purple.80.value}"
            },
            90: {
                value: "{colors.purple.90.value}"
            },
            100: {
                value: "{colors.purple.100.value}"
            }
        }
    },
    font: {
        primary: {
            value: "{colors.neutral.100.value}"
        },
        secondary: {
            value: "{colors.neutral.90.value}"
        },
        tertiary: {
            value: "{colors.neutral.80.value}"
        },
        disabled: {
            value: "{colors.neutral.60.value}"
        },
        inverse: {
            value: "{colors.white.value}"
        },
        interactive: {
            value: "{colors.brand.primary.80.value}"
        },
        hover: {
            value: "{colors.brand.primary.90.value}"
        },
        focus: {
            value: "{colors.brand.primary.100.value}"
        },
        active: {
            value: "{colors.brand.primary.100.value}"
        },
        info: {
            value: "{colors.blue.90.value}"
        },
        warning: {
            value: "{colors.orange.90.value}"
        },
        error: {
            value: "{colors.red.90.value}"
        },
        success: {
            value: "{colors.green.90.value}"
        }
    },
    background: {
        primary: {
            value: "{colors.white.value}"
        },
        secondary: {
            value: "{colors.neutral.10.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        quaternary: {
            value: "{colors.neutral.60.value}"
        },
        disabled: {
            value: "{colors.background.tertiary.value}"
        },
        info: {
            value: "{colors.blue.20.value}"
        },
        warning: {
            value: "{colors.orange.20.value}"
        },
        error: {
            value: "{colors.red.20.value}"
        },
        success: {
            value: "{colors.green.20.value}"
        }
    },
    border: {
        primary: {
            value: "{colors.neutral.60.value}"
        },
        secondary: {
            value: "{colors.neutral.40.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        disabled: {
            value: "{colors.border.tertiary.value}"
        },
        pressed: {
            value: "{colors.brand.primary.100.value}"
        },
        focus: {
            value: "{colors.brand.primary.100.value}"
        },
        error: {
            value: "{colors.red.80.value}"
        }
    },
    shadow: {
        primary: {
            value: "hsla(210, 50%, 10%, 0.25)"
        },
        secondary: {
            value: "hsla(210, 50%, 10%, 0.15)"
        },
        tertiary: {
            value: "hsla(210, 50%, 10%, 0.05)"
        }
    },
    overlay: {
        10: {
            value: "hsla(0, 0%, 0%, 0.1)"
        },
        20: {
            value: "hsla(0, 0%, 0%, 0.2)"
        },
        30: {
            value: "hsla(0, 0%, 0%, 0.3)"
        },
        40: {
            value: "hsla(0, 0%, 0%, 0.4)"
        },
        50: {
            value: "hsla(0, 0%, 0%, 0.5)"
        },
        60: {
            value: "hsla(0, 0%, 0%, 0.6)"
        },
        70: {
            value: "hsla(0, 0%, 0%, 0.7)"
        },
        80: {
            value: "hsla(0, 0%, 0%, 0.8)"
        },
        90: {
            value: "hsla(0, 0%, 0%, 0.9)"
        }
    },
    black: {
        value: "hsl(0, 0%, 0%)"
    },
    white: {
        value: "hsl(0, 0%, 100%)"
    },
    transparent: {
        value: "transparent"
    }
};


var $18d36cfff944f130$export$5ea928c9faf85bd3 = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "space-between"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    }
};


var $e6d2b35493f7129a$export$485ded5f26ebe08d = {
    menu: {
        width: {
            value: "100%"
        },
        marginBlockStart: {
            value: "{space.xxxs}"
        },
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        options: {
            display: {
                value: "flex"
            },
            flexDirection: {
                value: "column"
            },
            maxHeight: {
                value: "300px"
            }
        },
        option: {
            backgroundColor: {
                value: "{colors.background.primary}"
            },
            color: {
                value: "currentcolor"
            },
            cursor: {
                value: "pointer"
            },
            transitionDuration: {
                value: "{time.short}"
            },
            transitionProperty: {
                value: "background-color, color"
            },
            transitionTimingFunction: {
                value: "ease"
            },
            _active: {
                backgroundColor: {
                    value: "{colors.brand.primary.80}"
                },
                color: {
                    value: "{colors.white}"
                }
            }
        },
        _empty: {
            display: {
                value: "flex"
            }
        },
        _loading: {
            alignItems: {
                value: "center"
            },
            display: {
                value: "flex"
            },
            gap: {
                value: "{space.xxxs}"
            }
        },
        spaceShared: {
            paddingBlock: {
                value: "{space.xs}"
            },
            paddingInline: {
                value: "{space.small}"
            }
        }
    }
};


var $18c1d8b61f0f2a94$export$d5cb6eef88ffbde2 = {
    maxWidth: {
        value: "60rem"
    },
    modal: {
        width: {
            value: "{space.relative.full}"
        },
        height: {
            value: "{space.relative.full}"
        },
        backgroundColor: {
            value: "{colors.overlay.50.value}"
        },
        top: {
            value: "{space.zero}"
        },
        left: {
            value: "{space.zero}"
        }
    },
    container: {
        widthMax: {
            value: "30rem"
        }
    },
    router: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    },
    footer: {
        paddingBottom: {
            value: "{space.medium.value}"
        }
    },
    form: {
        padding: {
            value: "{space.xl.value}"
        }
    },
    state: {
        inactive: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    orContainer: {
        color: {
            value: "{colors.neutral.80.value}"
        },
        orLine: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    }
};


var $140da4a541f196e0$export$4aebd143f31d0c0d = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: 1
    },
    fontWeight: {
        value: "{fontWeights.semibold.value}"
    },
    fontSize: {
        value: "{fontSizes.small.value}"
    },
    textAlign: {
        value: "center"
    },
    paddingVertical: {
        value: "{space.xs.value}"
    },
    paddingHorizontal: {
        value: "{space.small.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    borderRadius: {
        value: "{radii.xl.value}"
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.xs.value}"
        },
        paddingVertical: {
            value: "{space.xxs.value}"
        },
        paddingHorizontal: {
            value: "{space.xs.value}"
        }
    },
    large: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        }
    }
};


var $1d90eb15cdc8cc61$export$2ba01fb71ed41cb6 = {
    fontWeight: {
        value: "{fontWeights.bold.value}"
    },
    transitionDuration: {
        value: "{components.fieldcontrol.transitionDuration.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    lineHeight: {
        value: "{components.fieldcontrol.lineHeight.value}"
    },
    paddingBlockStart: {
        value: "{components.fieldcontrol.paddingBlockStart.value}"
    },
    paddingBlockEnd: {
        value: "{components.fieldcontrol.paddingBlockEnd.value}"
    },
    paddingInlineStart: {
        value: "{components.fieldcontrol.paddingInlineStart.value}"
    },
    paddingInlineEnd: {
        value: "{components.fieldcontrol.paddingInlineEnd.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    borderWidth: {
        value: "{components.fieldcontrol.borderWidth.value}"
    },
    borderStyle: {
        value: "{components.fieldcontrol.borderStyle.value}"
    },
    borderRadius: {
        value: "{components.fieldcontrol.borderRadius.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.10.value}"
        },
        borderColor: {
            value: "{colors.brand.primary.60.value}"
        }
    },
    _focus: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.10.value}"
        },
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: "{components.fieldcontrol._focus.boxShadow.value}"
        }
    },
    _active: {
        color: {
            value: "{colors.font.active.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.20.value}"
        },
        borderColor: {
            value: "{colors.brand.primary.100.value}"
        }
    },
    _loading: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    primary: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.100.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        }
    },
    menu: {
        borderWidth: {
            value: "{space.zero.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        justifyContent: {
            value: "start"
        },
        _hover: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    link: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{space.zero.value}"
        },
        color: {
            value: "{colors.font.interactive.value}"
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.10.value}"
            },
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.10.value}"
            },
            color: {
                value: "{colors.font.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.20.value}"
            },
            color: {
                value: "{colors.font.active.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    small: {
        fontSize: {
            value: "{components.fieldcontrol.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.small.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.small.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.small.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.small.paddingInlineEnd.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.fieldcontrol.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.large.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.large.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.large.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.large.paddingInlineEnd.value}"
        }
    },
    loaderWrapper: {
        alignItems: {
            value: "center"
        },
        gap: {
            value: "{space.xs.value}"
        }
    }
};


var $ef916d5161fa2b7b$export$aa3e815946b80764 = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    borderWidth: {
        value: "0"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "transparent"
    },
    boxShadow: {
        value: "none"
    },
    padding: {
        value: "{space.medium.value}"
    },
    outlined: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        boxShadow: {
            value: "{components.card.boxShadow.value}"
        }
    },
    elevated: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "0"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "transparent"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    }
};


var $0c0a1340d507d958$export$b07e517d22efa1ca = {
    cursor: {
        value: "pointer"
    },
    alignItems: {
        value: "center"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        position: {
            value: "relative"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        before: {
            width: {
                value: "100%"
            },
            height: {
                value: "100%"
            },
            borderWidth: {
                value: "{borderWidths.medium.value}"
            },
            borderRadius: {
                value: "20%"
            },
            borderStyle: {
                value: "solid"
            },
            borderColor: {
                value: "{colors.border.primary.value}"
            }
        },
        _focus: {
            outlineColor: {
                value: "{colors.transparent.value}"
            },
            outlineStyle: {
                value: "solid"
            },
            outlineWidth: {
                value: "{outlineWidths.medium.value}"
            },
            outlineOffset: {
                value: "{outlineOffsets.medium.value}"
            },
            borderColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                borderColor: {
                    value: "{colors.transparent.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "2px",
                        color: "{colors.border.error.value}"
                    }
                }
            }
        }
    },
    icon: {
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        borderRadius: {
            value: "20%"
        },
        opacity: {
            value: "{opacities.0.value}"
        },
        transform: {
            value: "scale(0)"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.short.value}"
        },
        transitionTimingFunction: {
            value: "ease-in-out"
        },
        _checked: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _indeterminate: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        }
    },
    label: {
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


var $608076cf990c5718$export$282c9e915736aefa = {
    alignItems: {
        value: "flex-start"
    },
    alignContent: {
        value: "center"
    },
    flexDirection: {
        value: "column"
    },
    justifyContent: {
        value: "center"
    }
};


var $a5be6d420d0d8142$export$bf5175b0c24981cd = {
    pagination: {
        current: {
            color: {
                value: "{components.pagination.current.color}"
            },
            backgroundColor: {
                value: "{components.pagination.current.backgroundColor}"
            }
        },
        button: {
            color: {
                value: "{components.pagination.button.color}"
            },
            _hover: {
                backgroundColor: {
                    value: "{components.pagination.button.hover.backgroundColor}"
                },
                color: {
                    value: "{components.pagination.button.hover.color}"
                }
            },
            _disabled: {
                color: {
                    value: "{components.pagination.button.disabled.color}"
                }
            }
        }
    },
    search: {
        input: {
            color: {
                value: "{components.searchfield.color}"
            }
        },
        button: {
            color: {
                value: "{components.searchfield.button.color}"
            },
            _active: {
                backgroundColor: {
                    value: "{components.searchfield.button._active.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._active.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._active.color}"
                }
            },
            _disabled: {
                backgroundColor: {
                    value: "{components.searchfield.button._disabled.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._disabled.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._disabled.color}"
                }
            },
            _focus: {
                backgroundColor: {
                    value: "{components.searchfield.button._focus.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._focus.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._focus.color}"
                }
            },
            _hover: {
                backgroundColor: {
                    value: "{components.searchfield.button._hover.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._hover.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._hover.color}"
                }
            }
        }
    }
};


var $d46f3bf3266ca199$export$784d13d8ee351f07 = {
    fontSize: {
        value: "{fontSizes.xs}"
    },
    gap: {
        value: "{space.relative.medium}"
    },
    svg: {
        path: {
            fill: {
                value: "{colors.font.primary}"
            }
        }
    },
    toolTip: {
        bottom: {
            value: "{space.large}"
        },
        color: {
            value: "{colors.teal.100}"
        },
        fontSize: {
            value: "{fontSizes.xxs}"
        }
    }
};


var $ec2f462d4c2b1ecd$export$5a80fc6ecf647d64 = {
    height: {
        value: "{space.relative.full.value}"
    }
};


var $9c94a8014e3d7a55$export$e8c9778bf415dd08 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    label: {
        color: {
            value: "{colors.font.tertiary.value}"
        },
        paddingInline: {
            value: "{space.medium.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        }
    },
    small: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        }
    },
    large: {
        borderWidth: {
            value: "{borderWidths.large.value}"
        }
    },
    opacity: {
        value: "{opacities.60.value}"
    }
};


var $6512de84b49f890c$export$f194ed9df726ec47 = {
    display: {
        value: "block"
    },
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    width: {
        value: "100%"
    },
    item: {
        marginTop: {
            value: "1px"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderBottomLeftRadius: {
            value: "{radii.medium.value}"
        },
        borderBottomRightRadius: {
            value: "{radii.medium.value}"
        },
        borderTopLeftRadius: {
            value: "{radii.medium.value}"
        },
        borderTopRightRadius: {
            value: "{radii.medium.value}"
        },
        borderStartStartRadius: {
            value: "{radii.medium.value}"
        },
        borderStartEndRadius: {
            value: "{radii.medium.value}"
        },
        borderEndStartRadius: {
            value: "{radii.medium.value}"
        },
        borderEndEndRadius: {
            value: "{radii.medium.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0",
                    offsetY: "0",
                    blurRadius: "0",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        }
    },
    header: {
        boxShadow: {
            value: {
                offsetX: "0",
                offsetY: "1px",
                blurRadius: "0",
                color: "{colors.overlay.20.value}"
            }
        }
    },
    trigger: {
        minHeight: {
            value: "3rem"
        },
        paddingInlineStart: {
            value: "{space.large.value}"
        },
        paddingInlineEnd: {
            value: "{space.large.value}"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "space-between"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            }
        }
    },
    content: {
        paddingInlineStart: {
            value: "{space.large.value}"
        },
        paddingInlineEnd: {
            value: "{space.large.value}"
        },
        text: {
            color: {
                value: "{colors.font.secondary.value}"
            },
            paddingBlockStart: {
                value: "{space.medium.value}"
            },
            paddingBlockEnd: {
                value: "{space.medium.value}"
            }
        },
        _open: {
            animationDuration: {
                value: "{time.medium.value}"
            },
            animationTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        },
        _closed: {
            animationDuration: {
                value: "{time.medium.value}"
            },
            animationTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        }
    },
    icon: {
        transitionDuration: {
            value: "{time.medium.value}"
        },
        transitionTimingFunction: {
            value: "cubic-bezier(0.87, 0, 0.13, 1)"
        }
    }
};


var $3dfeb98daf2a1b8c$export$e0f35d825088c098 = {
    gap: {
        value: "{space.xs.value}"
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    small: {
        gap: {
            value: "{space.xxxs.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    large: {
        gap: {
            value: "{space.small.value}"
        },
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    label: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    }
};


var $78af44c653d20294$export$5ba822cdf6eca6d5 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.small.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    paddingBlockStart: {
        value: "{space.xs.value}"
    },
    paddingBlockEnd: {
        value: "{space.xs.value}"
    },
    paddingInlineStart: {
        value: "{space.medium.value}"
    },
    paddingInlineEnd: {
        value: "{space.medium.value}"
    },
    fontSize: {
        value: "{components.field.fontSize.value}"
    },
    lineHeight: {
        value: "{lineHeights.medium.value}"
    },
    transitionDuration: {
        value: "{time.medium.value}"
    },
    outlineColor: {
        value: "{colors.transparent.value}"
    },
    outlineStyle: {
        value: "solid"
    },
    outlineWidth: {
        value: "{outlineWidths.medium.value}"
    },
    outlineOffset: {
        value: "{outlineOffsets.medium.value}"
    },
    small: {
        fontSize: {
            value: "{components.field.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xxs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xxs.value}"
        },
        paddingInlineStart: {
            value: "{space.small.value}"
        },
        paddingInlineEnd: {
            value: "{space.small.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.field.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xs.value}"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    },
    quiet: {
        borderStyle: {
            value: "none"
        },
        borderBlockEnd: {
            value: "{borderWidths.small.value} solid {colors.border.primary.value}"
        },
        borderInlineStart: {
            value: "none"
        },
        borderInlineEnd: {
            value: "none"
        },
        borderBlockStart: {
            value: "none"
        },
        borderRadius: {
            value: "0"
        },
        _focus: {
            borderBlockEndColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "1px",
                    color: "{colors.border.focus.value}",
                    blurRadius: "0px"
                }
            }
        },
        _error: {
            borderBlockEndColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "1px",
                        color: "{colors.border.error.value}",
                        blurRadius: "0px"
                    }
                }
            }
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "1px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        cursor: {
            value: "not-allowed"
        },
        borderColor: {
            value: "{colors.transparent.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    _error: {
        borderColor: {
            value: "{colors.border.error.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "1px",
                    color: "{colors.border.error.value}"
                }
            }
        }
    }
};


var $d9631c641721a0fe$export$886e4abc352a8403 = {
    gap: {
        value: "{space.zero.value}"
    },
    vertical: {
        alignItems: {
            value: "center"
        }
    },
    outer: {
        alignItems: {
            value: "center"
        }
    }
};


var $39ffdea5589cb07b$export$b29676ca3eb575f7 = {
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    description: {
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontStyle: {
            value: "italic"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    }
};


var $c52704e8b6efe341$export$97691fbb80847c19 = {
    gap: {
        value: "{space.medium.value}"
    },
    justifyContent: {
        value: "normal"
    },
    alignItems: {
        value: "stretch"
    },
    alignContent: {
        value: "normal"
    },
    flexWrap: {
        value: "nowrap"
    }
};


var $9b57ce5256c94186$export$46e4a324ac90507f = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    1: {
        fontSize: {
            value: "{fontSizes.xxxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.light.value}"
        }
    },
    2: {
        fontSize: {
            value: "{fontSizes.xxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        }
    },
    3: {
        fontSize: {
            value: "{fontSizes.xxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.medium.value}"
        }
    },
    4: {
        fontSize: {
            value: "{fontSizes.xl.value}"
        },
        fontWeight: {
            value: "{fontWeights.semibold.value}"
        }
    },
    5: {
        fontSize: {
            value: "{fontSizes.large.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    6: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};


var $6b07188db97b293d$export$5340050496cd0f8f = {
    highlighted: {
        fontWeight: {
            value: "{fontWeights.bold}"
        }
    }
};


var $77bc24cfabe6e5ce$export$1ca1ec8b29a4ce27 = {
    lineHeight: {
        value: 1
    },
    height: {
        value: "1em"
    }
};


var $bcacdc745a54d765$export$5c452ff88e35e47d = {
    maxWidth: {
        value: "100%"
    },
    height: {
        value: "auto"
    },
    objectFit: {
        value: "initial"
    },
    objectPosition: {
        value: "initial"
    }
};


var $a1d3b70eddb2cd40$export$9c30223ca0a664fb = {
    active: {
        color: {
            value: "{colors.font.active.value}"
        }
    },
    color: {
        value: "{colors.font.interactive.value}"
    },
    focus: {
        color: {
            value: "{colors.font.focus.value}"
        }
    },
    hover: {
        color: {
            value: "{colors.font.hover.value}"
        }
    },
    visited: {
        color: {
            value: "{colors.font.interactive.value}"
        }
    }
};


var $c70801c6c0290ee4$export$f4c5de44377d2946 = {
    width: {
        value: "{fontSizes.medium.value}"
    },
    height: {
        value: "{fontSizes.medium.value}"
    },
    fontSize: {
        value: "{fontSizes.xs.value}"
    },
    strokeEmpty: {
        value: "{colors.neutral.20.value}"
    },
    strokeFilled: {
        value: "{colors.brand.primary.80.value}"
    },
    strokeLinecap: {
        value: "round"
    },
    animationDuration: {
        value: "1s"
    },
    small: {
        width: {
            value: "{fontSizes.small.value}"
        },
        height: {
            value: "{fontSizes.small.value}"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.large.value}"
        },
        height: {
            value: "{fontSizes.large.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    linear: {
        width: {
            value: "100%"
        },
        minWidth: {
            value: "5rem"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        strokeWidth: {
            value: "{fontSizes.medium.value}"
        },
        strokeFilled: {
            value: "{colors.brand.primary.80.value}"
        },
        strokeEmpty: {
            value: "{colors.neutral.20.value}"
        },
        strokeLinecap: {
            value: "round"
        },
        animationDuration: {
            value: "1s"
        },
        small: {
            strokeWidth: {
                value: "{fontSizes.small.value}"
            },
            fontSize: {
                value: "{fontSizes.small.value}"
            }
        },
        large: {
            strokeWidth: {
                value: "{fontSizes.large.value}"
            },
            fontSize: {
                value: "{fontSizes.large.value}"
            }
        }
    },
    text: {
        fill: {
            value: "{colors.font.primary.value}"
        }
    }
};


var $51b4320659274502$export$b1e5508a851be14d = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{space.zero.value}"
    },
    maxWidth: {
        value: "30rem"
    },
    minWidth: {
        value: "14rem"
    },
    small: {
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.xxxl.value}"
        },
        height: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    item: {
        minHeight: {
            value: "2.5rem"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    }
};


var $38ba9e987d5b701b$export$22fa394f3ba39578 = {
    current: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.40.value}"
        }
    },
    button: {
        color: {
            value: "{colors.font.primary.value}"
        },
        paddingInlineStart: {
            value: "{space.xxs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xxs.value}"
        },
        transitionProperty: {
            value: "background-color"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    ellipsis: {
        alignItems: {
            value: "baseline"
        },
        justifyContent: {
            value: "center"
        },
        paddingInlineStart: {
            value: "{space.xs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xs.value}"
        }
    },
    itemContainer: {
        marginLeft: {
            value: "{space.xxxs.value}"
        },
        marginRight: {
            value: "{space.xxxs.value}"
        }
    },
    itemShared: {
        height: {
            value: "{fontSizes.xxl.value}"
        },
        minWidth: {
            value: "{fontSizes.xxl.value}"
        },
        borderRadius: {
            value: "{fontSizes.medium.value}"
        }
    }
};


var $cea495b8ae78c89d$export$75dd6c0d8e7c7e6b = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


var $9e5505887201a574$export$2b14d7973e978f83 = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    }
};


var $9cfc71ab4eee210d$export$c7187bbd1a7a9244 = {
    borderRadius: {
        value: "{radii.small.value}"
    },
    transitionDuration: {
        value: "{time.long.value}"
    },
    startColor: {
        value: "{colors.background.secondary.value}"
    },
    endColor: {
        value: "{colors.background.tertiary.value}"
    },
    small: {
        height: {
            value: "{space.small.value}"
        }
    },
    default: {
        height: {
            value: "{space.medium.value}"
        }
    },
    large: {
        height: {
            value: "{space.large.value}"
        }
    }
};


var $28b10a47e0e2599a$export$b56dc0f160585b86 = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    },
    gap: {
        value: "inherit"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        },
        boxSizing: {
            value: "border-box"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "50%"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        color: {
            value: "{colors.background.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        outlineColor: {
            value: "{colors.transparent.value}"
        },
        outlineStyle: {
            value: "solid"
        },
        outlineWidth: {
            value: "{outlineWidths.medium.value}"
        },
        outlineOffset: {
            value: "{outlineOffsets.medium.value}"
        },
        padding: {
            value: "{borderWidths.medium.value}"
        },
        small: {
            width: {
                value: "{fontSizes.small.value}"
            },
            height: {
                value: "{fontSizes.small.value}"
            }
        },
        large: {
            width: {
                value: "{fontSizes.large.value}"
            },
            height: {
                value: "{fontSizes.large.value}"
            }
        },
        _checked: {
            color: {
                value: "{colors.brand.primary.80.value}"
            },
            _disabled: {
                color: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    },
    label: {
        color: {
            value: "{components.text.color.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


var $e933c37f3178f431$export$19d611f01a2bdcee = {
    radio: {
        borderWidth: {
            value: "{components.radio.button.borderWidth}"
        },
        borderColor: {
            value: "{components.radio.button.borderColor}"
        },
        backgroundColor: {
            value: "{components.radio.button.backgroundColor}"
        },
        _checked: {
            color: {
                value: "{components.radio.button._checked.color}"
            }
        },
        label: {
            color: {
                value: "{components.radio.label.color}"
            }
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};


var $752b9ab1bf6362d9$export$8121c87bde23d44 = {
    large: {
        size: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    default: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    small: {
        size: {
            value: "{fontSizes.small.value}"
        }
    },
    filled: {
        color: {
            value: "{colors.brand.secondary.80.value}"
        }
    },
    empty: {
        color: {
            value: "{colors.background.tertiary.value}"
        }
    }
};


var $bbcc747564416c65$export$20f8183d3857720a = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


var $bbfd3733a4d6419c$export$2e6c959c16ff56b8 = {
    paddingInlineEnd: {
        value: "{space.xxl.value}"
    },
    wrapper: {
        flex: {
            value: "1"
        },
        display: {
            value: "block"
        },
        position: {
            value: "relative"
        },
        cursor: {
            value: "pointer"
        }
    },
    iconWrapper: {
        alignItems: {
            value: "center"
        },
        position: {
            value: "absolute"
        },
        top: {
            value: "50%"
        },
        right: {
            value: "{space.medium.value}"
        },
        transform: {
            value: "translateY(-50%)"
        },
        pointerEvents: {
            value: "none"
        }
    },
    option: {
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    whiteSpace: {
        value: "nowrap"
    },
    minWidth: {
        value: "6.5rem"
    },
    small: {
        minWidth: {
            value: "5.5rem"
        }
    },
    large: {
        minWidth: {
            value: "7.5rem"
        }
    }
};


var $a1f33b1f19f69846$export$43b12a9ec74e5c15 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    color: {
        value: "{components.fieldcontrol.color}"
    },
    flexDirection: {
        value: "column"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};


var $5b62b09aa29e3be5$export$91a82c92775294e7 = {
    paddingBlock: {
        value: "{space.xs.value}"
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        height: {
            value: "0.375rem"
        },
        minWidth: {
            value: "10rem"
        }
    },
    range: {
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            }
        }
    },
    thumb: {
        width: {
            value: "1.25rem"
        },
        height: {
            value: "1.25rem"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderRadius: {
            value: "50%"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            borderColor: {
                value: "transparent"
            },
            boxShadow: {
                value: "none"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0",
                    offsetY: "0",
                    blurRadius: "0",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        }
    },
    small: {
        track: {
            height: {
                value: "0.25rem"
            }
        },
        thumb: {
            width: {
                value: "1rem"
            },
            height: {
                value: "1rem"
            }
        }
    },
    large: {
        track: {
            height: {
                value: "0.625rem"
            }
        },
        thumb: {
            width: {
                value: "1.5rem"
            },
            height: {
                value: "1.5rem"
            }
        }
    }
};


var $4b15cb93b56d3fb0$export$2391ed8b13703124 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    flexDirection: {
        value: "column"
    },
    input: {
        color: {
            value: "{components.fieldcontrol.color}"
        },
        fontSize: {
            value: "{components.fieldcontrol.fontSize}"
        },
        textAlign: {
            value: "center"
        }
    },
    button: {
        color: {
            value: "{components.button.color}"
        },
        backgroundColor: {
            value: "{colors.transparent}"
        },
        _active: {
            color: {
                value: "{components.button._active.color}"
            },
            backgroundColor: {
                value: "{components.button._active.backgroundColor}"
            }
        },
        _focus: {
            color: {
                value: "{components.button._focus.color}"
            },
            backgroundColor: {
                value: "{components.button._focus.backgroundColor}"
            }
        },
        _disabled: {
            color: {
                value: "{components.button._disabled.color}"
            },
            backgroundColor: {
                value: "{components.fieldcontrol._disabled.backgroundColor}"
            }
        },
        _hover: {
            color: {
                value: "{components.button._hover.color}"
            },
            backgroundColor: {
                value: "{components.button._hover.backgroundColor}"
            }
        }
    }
};


var $fb6f4451337bed82$export$3df77196ea7dd221 = {
    _disabled: {
        opacity: {
            value: "{opacities.60.value}"
        }
    },
    _focused: {
        shadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "2px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    large: {
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    label: {
        padding: {
            value: "{space.xs.value}"
        }
    },
    thumb: {
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            transform: {
                value: "{transforms.slideX.medium.value}"
            }
        },
        transition: {
            duration: {
                value: "{time.medium.value}"
            }
        },
        width: {
            value: "{space.relative.medium.value}"
        }
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        height: {
            value: "{space.relative.medium.value}"
        },
        padding: {
            value: "{outlineWidths.medium.value}"
        },
        transition: {
            duration: {
                value: "{time.short.value}"
            }
        },
        width: {
            value: "{space.relative.xl.value}"
        },
        _error: {
            backgroundColor: {
                value: "{colors.background.error.value}"
            }
        }
    }
};


var $13b4c75f04cc668b$export$9852986a3ec5f6a0 = {
    borderCollapse: {
        value: "collapse"
    },
    display: {
        value: "table"
    },
    width: {
        value: "100%"
    },
    head: {
        display: {
            value: "table-header-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    body: {
        display: {
            value: "table-row-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    foot: {
        display: {
            value: "table-footer-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    row: {
        display: {
            value: "table-row"
        },
        verticalAlign: {
            value: "middle"
        },
        hover: {
            backgroundColor: {
                value: "{colors.background.tertiary.value}"
            }
        },
        striped: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    header: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    data: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    caption: {
        captionSide: {
            value: "bottom"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-caption"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        wordBreak: {
            value: "break-all"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            }
        }
    }
};


var $3246db6a624cfa5f$export$39f5674517ec0000 = {
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{colors.border.secondary.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    gap: {
        value: "0"
    },
    item: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.secondary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        _hover: {
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.focus.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.interactive.value}"
            },
            borderColor: {
                value: "{colors.font.interactive.value}"
            },
            backgroundColor: {
                value: "transparent"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.tertiary.value}"
            }
        }
    }
};


var $860b53ffa91ff37a$export$6f093cfa640b7166 = {
    color: {
        value: "{colors.font.primary.value}"
    },
    primary: {
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    secondary: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    },
    tertiary: {
        color: {
            value: "{colors.font.tertiary.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        }
    }
};


var $dc48344d3c2120fe$export$a97649e9ae9088d4 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


var $14e60659413622fc$export$a0baff9279ccf6a1 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


var $cff4bafab05e5231$export$72f8a860416016a1 = {
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        backgroundColor: {
            value: "{colors.overlay.10.value}"
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    _active: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderColor: {
            value: "{colors.border.disabled.value}"
        },
        color: {
            value: "{colors.font.disabled.value}"
        }
    },
    _pressed: {
        borderColor: {
            value: "{colors.border.pressed.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.20.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.30.value}"
            }
        }
    },
    primary: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            },
            borderColor: {
                value: "{colors.brand.primary.80.value}"
            },
            color: {
                value: "{colors.background.primary.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.border.focus.value}"
                },
                borderColor: {
                    value: "{colors.border.focus.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            },
            _hover: {
                borderColor: {
                    value: "{colors.brand.primary.60.value}"
                },
                backgroundColor: {
                    value: "{colors.brand.primary.60.value}"
                },
                boxShadow: {
                    value: "{colors.brand.primary.60.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            }
        }
    },
    link: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        color: {
            value: "{colors.overlay.50.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.90.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.transparent.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            },
            _hover: {
                color: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.transparent.value}"
                }
            }
        }
    }
};


var $755a0e33b75a1ccc$export$8f367359b07a0011 = {
    alignItems: {
        value: "center"
    },
    alignContent: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    }
};


var $d3d2d24c63d04e1d$export$9b5ac10f59f76296 = {
    alert: (0, $18d36cfff944f130$export$5ea928c9faf85bd3),
    authenticator: (0, $18c1d8b61f0f2a94$export$d5cb6eef88ffbde2),
    autocomplete: (0, $e6d2b35493f7129a$export$485ded5f26ebe08d),
    badge: (0, $140da4a541f196e0$export$4aebd143f31d0c0d),
    button: (0, $1d90eb15cdc8cc61$export$2ba01fb71ed41cb6),
    card: (0, $ef916d5161fa2b7b$export$aa3e815946b80764),
    checkbox: (0, $0c0a1340d507d958$export$b07e517d22efa1ca),
    checkboxfield: (0, $608076cf990c5718$export$282c9e915736aefa),
    collection: (0, $a5be6d420d0d8142$export$bf5175b0c24981cd),
    copy: (0, $d46f3bf3266ca199$export$784d13d8ee351f07),
    countrycodeselect: (0, $ec2f462d4c2b1ecd$export$5a80fc6ecf647d64),
    divider: (0, $9c94a8014e3d7a55$export$e8c9778bf415dd08),
    expander: (0, $6512de84b49f890c$export$f194ed9df726ec47),
    field: (0, $3dfeb98daf2a1b8c$export$e0f35d825088c098),
    fieldcontrol: (0, $78af44c653d20294$export$5ba822cdf6eca6d5),
    fieldgroup: (0, $d9631c641721a0fe$export$886e4abc352a8403),
    fieldmessages: (0, $39ffdea5589cb07b$export$b29676ca3eb575f7),
    flex: (0, $c52704e8b6efe341$export$97691fbb80847c19),
    heading: (0, $9b57ce5256c94186$export$46e4a324ac90507f),
    icon: (0, $77bc24cfabe6e5ce$export$1ca1ec8b29a4ce27),
    highlightmatch: (0, $6b07188db97b293d$export$5340050496cd0f8f),
    image: (0, $bcacdc745a54d765$export$5c452ff88e35e47d),
    link: (0, $a1d3b70eddb2cd40$export$9c30223ca0a664fb),
    loader: (0, $c70801c6c0290ee4$export$f4c5de44377d2946),
    menu: (0, $51b4320659274502$export$b1e5508a851be14d),
    pagination: (0, $38ba9e987d5b701b$export$22fa394f3ba39578),
    passwordfield: (0, $cea495b8ae78c89d$export$75dd6c0d8e7c7e6b),
    phonenumberfield: (0, $9e5505887201a574$export$2b14d7973e978f83),
    placeholder: (0, $9cfc71ab4eee210d$export$c7187bbd1a7a9244),
    radio: (0, $28b10a47e0e2599a$export$b56dc0f160585b86),
    radiogroup: (0, $e933c37f3178f431$export$19d611f01a2bdcee),
    rating: (0, $752b9ab1bf6362d9$export$8121c87bde23d44),
    searchfield: (0, $bbcc747564416c65$export$20f8183d3857720a),
    select: (0, $bbfd3733a4d6419c$export$2e6c959c16ff56b8),
    selectfield: (0, $a1f33b1f19f69846$export$43b12a9ec74e5c15),
    sliderfield: (0, $5b62b09aa29e3be5$export$91a82c92775294e7),
    stepperfield: (0, $4b15cb93b56d3fb0$export$2391ed8b13703124),
    switchfield: (0, $fb6f4451337bed82$export$3df77196ea7dd221),
    table: (0, $13b4c75f04cc668b$export$9852986a3ec5f6a0),
    tabs: (0, $3246db6a624cfa5f$export$39f5674517ec0000),
    text: (0, $860b53ffa91ff37a$export$6f093cfa640b7166),
    textareafield: (0, $dc48344d3c2120fe$export$a97649e9ae9088d4),
    textfield: (0, $14e60659413622fc$export$a0baff9279ccf6a1),
    togglebutton: (0, $cff4bafab05e5231$export$72f8a860416016a1),
    togglebuttongroup: (0, $755a0e33b75a1ccc$export$8f367359b07a0011)
};


var $149699a83c4a8396$export$f45fbea8fe20ca8a = {
    default: {
        variable: {
            value: "'InterVariable', 'Inter var', 'Inter', -apple-system, BlinkMacSystemFont,\n        'Helvetica Neue', 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',\n        sans-serif"
        },
        static: {
            value: "'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue',\n        'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif"
        }
    }
};


var $47658db7b6a153af$export$67baea80019ff381 = {
    xxxs: {
        value: "0.375rem"
    },
    xxs: {
        value: "0.5rem"
    },
    xs: {
        value: "0.75rem"
    },
    small: {
        value: "0.875rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.25rem"
    },
    xl: {
        value: "1.5rem"
    },
    xxl: {
        value: "2rem"
    },
    xxxl: {
        value: "2.5rem"
    },
    xxxxl: {
        value: "3rem"
    }
};


var $e7326a15647e368d$export$59230918eb9bd861 = {
    hairline: {
        value: 100
    },
    thin: {
        value: 200
    },
    light: {
        value: 300
    },
    normal: {
        value: 400
    },
    medium: {
        value: 500
    },
    semibold: {
        value: 600
    },
    bold: {
        value: 700
    },
    extrabold: {
        value: 800
    },
    black: {
        value: 900
    }
};


var $1d8bd2b04b85e7e7$export$e646ed6b629bf51e = {
    small: {
        value: "1.25"
    },
    medium: {
        value: "1.5"
    },
    large: {
        value: "2"
    }
};


var $3a5d92722051221e$export$da6c1b172b339805 = {
    0: {
        value: "0"
    },
    10: {
        value: "0.1"
    },
    20: {
        value: "0.2"
    },
    30: {
        value: "0.3"
    },
    40: {
        value: "0.4"
    },
    50: {
        value: "0.5"
    },
    60: {
        value: "0.6"
    },
    70: {
        value: "0.7"
    },
    80: {
        value: "0.8"
    },
    90: {
        value: "0.9"
    },
    100: {
        value: "1"
    }
};


var $659bf2a8c058ad33$export$ef75ee03a03b44a8 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


var $4974cfb5642f6cb9$export$d532f76375153c47 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


var $6f68125c1e2b96b2$export$18f838d5aba6962a = {
    xs: {
        value: "0.125rem"
    },
    small: {
        value: "0.25rem"
    },
    medium: {
        value: "0.5rem"
    },
    large: {
        value: "1rem"
    },
    xl: {
        value: "2rem"
    },
    xxl: {
        value: "4rem"
    },
    xxxl: {
        value: "8rem"
    }
};


var $6d9285fa3e2292a2$export$3eb26d38a832ce9a = {
    small: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "4px",
            color: "{colors.shadow.tertiary.value}"
        }
    },
    medium: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "6px",
            color: "{colors.shadow.secondary.value}"
        }
    },
    large: {
        value: {
            offsetX: "0px",
            offsetY: "4px",
            blurRadius: "12px",
            color: "{colors.shadow.primary.value}"
        }
    }
};


var $c637a68f19e0f13b$export$a941ed4b947d12f8 = {
    zero: {
        value: "0"
    },
    xxxs: {
        value: "0.25rem"
    },
    xxs: {
        value: "0.375rem"
    },
    xs: {
        value: "0.5rem"
    },
    small: {
        value: "0.75rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.5rem"
    },
    xl: {
        value: "2.0rem"
    },
    xxl: {
        value: "3.0rem"
    },
    xxxl: {
        value: "4.5rem"
    },
    relative: {
        xxxs: {
            value: "0.25em"
        },
        xxs: {
            value: "0.375em"
        },
        xs: {
            value: "0.5em"
        },
        small: {
            value: "0.75em"
        },
        medium: {
            value: "1em"
        },
        large: {
            value: "1.5em"
        },
        xl: {
            value: "2.0em"
        },
        xxl: {
            value: "3.0em"
        },
        xxxl: {
            value: "4.5em"
        },
        full: {
            value: "100%"
        }
    }
};


var $281dac37e19072d3$export$2da9be4cfdb689b1 = {
    short: {
        value: "100ms"
    },
    medium: {
        value: "250ms"
    },
    long: {
        value: "500ms"
    }
};


var $e1c8749c68cfba75$export$63e4f03d302d3e40 = {
    slideX: {
        small: {
            value: "translateX(0.5em)"
        },
        medium: {
            value: "translateX(1em)"
        },
        large: {
            value: "translateX(2em)"
        }
    }
};


var $5dba11c09dfc5714$export$6ad93df59e712c43 = {
    components: (0, $d3d2d24c63d04e1d$export$9b5ac10f59f76296),
    borderWidths: (0, $221e6a6efdd9e64e$export$6f3cc5789c9e770e),
    colors: (0, $f98b5e72da0bdf12$export$8f45430ccf837300),
    fonts: (0, $149699a83c4a8396$export$f45fbea8fe20ca8a),
    fontSizes: (0, $47658db7b6a153af$export$67baea80019ff381),
    fontWeights: (0, $e7326a15647e368d$export$59230918eb9bd861),
    lineHeights: (0, $1d8bd2b04b85e7e7$export$e646ed6b629bf51e),
    opacities: (0, $3a5d92722051221e$export$da6c1b172b339805),
    outlineOffsets: (0, $659bf2a8c058ad33$export$ef75ee03a03b44a8),
    outlineWidths: (0, $4974cfb5642f6cb9$export$d532f76375153c47),
    radii: (0, $6f68125c1e2b96b2$export$18f838d5aba6962a),
    shadows: (0, $6d9285fa3e2292a2$export$3eb26d38a832ce9a),
    space: (0, $c637a68f19e0f13b$export$a941ed4b947d12f8),
    time: (0, $281dac37e19072d3$export$2da9be4cfdb689b1),
    transforms: (0, $e1c8749c68cfba75$export$63e4f03d302d3e40)
};


var $5929a3181b0c1113$export$d07517a676ce386f = {
    values: {
        base: 0,
        small: 480,
        medium: 768,
        large: 992,
        xl: 1280,
        xxl: 1536
    },
    defaultBreakpoint: "base"
};


var $ed14429abad98907$export$164de7ab8df77ef0 = {
    tokens: (0, $5dba11c09dfc5714$export$6ad93df59e712c43),
    breakpoints: (0, $5929a3181b0c1113$export$d07517a676ce386f),
    name: "default-theme"
};

function $89b176368041d7a8$export$daee9cd42beef6d1(e) {
    return "object" == typeof e && e.hasOwnProperty("value");
}


var $fa74499edcf324c6$exports = {};
var $0b2d21aee1d97729$exports = {};
var $1389b3710f5da9e8$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$1389b3710f5da9e8$exports = $1389b3710f5da9e8$var$arrayReduce;


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;



var $l6E2L = parcelRequire("l6E2L");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = "\\u0300-\\u036f", $ed80fa8833e2b532$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ed80fa8833e2b532$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = "[" + $ed80fa8833e2b532$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $l6E2L(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, "");
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $12f2ccb7e11b3895$exports = {};
var $7e165cbd28a9af51$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
$7e165cbd28a9af51$exports = $7e165cbd28a9af51$var$asciiWords;


var $8688e0b23f5a081b$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
$8688e0b23f5a081b$exports = $8688e0b23f5a081b$var$hasUnicodeWord;



var $l6E2L = parcelRequire("l6E2L");
var $325a565efdffbc96$exports = {};
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = "\ud800-\udfff", $325a565efdffbc96$var$rsComboMarksRange = "\\u0300-\\u036f", $325a565efdffbc96$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $325a565efdffbc96$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = "\\u2700-\\u27bf", $325a565efdffbc96$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $325a565efdffbc96$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $325a565efdffbc96$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $325a565efdffbc96$var$rsPunctuationRange = "\\u2000-\\u206f", $325a565efdffbc96$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $325a565efdffbc96$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $325a565efdffbc96$var$rsVarRange = "\\ufe0e\\ufe0f", $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['\u2019]", $325a565efdffbc96$var$rsBreak = "[" + $325a565efdffbc96$var$rsBreakRange + "]", $325a565efdffbc96$var$rsCombo = "[" + $325a565efdffbc96$var$rsComboRange + "]", $325a565efdffbc96$var$rsDigits = "\\d+", $325a565efdffbc96$var$rsDingbat = "[" + $325a565efdffbc96$var$rsDingbatRange + "]", $325a565efdffbc96$var$rsLower = "[" + $325a565efdffbc96$var$rsLowerRange + "]", $325a565efdffbc96$var$rsMisc = "[^" + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsFitz = "\ud83c[\udffb-\udfff]", $325a565efdffbc96$var$rsModifier = "(?:" + $325a565efdffbc96$var$rsCombo + "|" + $325a565efdffbc96$var$rsFitz + ")", $325a565efdffbc96$var$rsNonAstral = "[^" + $325a565efdffbc96$var$rsAstralRange + "]", $325a565efdffbc96$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $325a565efdffbc96$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $325a565efdffbc96$var$rsUpper = "[" + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = "(?:" + $325a565efdffbc96$var$rsLower + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsMiscUpper = "(?:" + $325a565efdffbc96$var$rsUpper + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsOptContrLower = "(?:" + $325a565efdffbc96$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $325a565efdffbc96$var$rsOptContrUpper = "(?:" + $325a565efdffbc96$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + "?", $325a565efdffbc96$var$rsOptVar = "[" + $325a565efdffbc96$var$rsVarRange + "]?", $325a565efdffbc96$var$rsOptJoin = "(?:" + $325a565efdffbc96$var$rsZWJ + "(?:" + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ")*", $325a565efdffbc96$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $325a565efdffbc96$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = "(?:" + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsLower + "+" + $325a565efdffbc96$var$rsOptContrLower + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsMiscUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsMiscLower + "+" + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
$325a565efdffbc96$exports = $325a565efdffbc96$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $l6E2L(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8688e0b23f5a081b$exports(string) ? $325a565efdffbc96$exports(string) : $7e165cbd28a9af51$exports(string);
    return string.match(pattern) || [];
}
$12f2ccb7e11b3895$exports = $12f2ccb7e11b3895$var$words;


/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1389b3710f5da9e8$exports($12f2ccb7e11b3895$exports($ed80fa8833e2b532$exports(string).replace($0b2d21aee1d97729$var$reApos, "")), callback, "");
    };
}
$0b2d21aee1d97729$exports = $0b2d21aee1d97729$var$createCompounder;


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $fa74499edcf324c6$var$kebabCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    return result + (index ? "-" : "") + word.toLowerCase();
});
$fa74499edcf324c6$exports = $fa74499edcf324c6$var$kebabCase;


var $ff3cc90cb76ac26c$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $283c8f0374cf594f$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $be1adfaa5ce5d8e4$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const $be1adfaa5ce5d8e4$var$defaults = {
    opening_character: "{",
    closing_character: "}",
    separator: "."
};
$be1adfaa5ce5d8e4$exports = $be1adfaa5ce5d8e4$var$defaults;


function $283c8f0374cf594f$var$createReferenceRegex(opts = {}) {
    const options = Object.assign({}, $be1adfaa5ce5d8e4$exports, opts);
    return new RegExp("\\" + options.opening_character + "([^" + options.closing_character + "]+)" + "\\" + options.closing_character, "g");
}
$283c8f0374cf594f$exports = $283c8f0374cf594f$var$createReferenceRegex;


/**
 * Checks if the value uses a value reference.
 * @memberof Dictionary
 * @param {string} value
 * @param {Object|RegExp} regexOrOptions
 * @returns {boolean} - True, if the value uses a value reference
 */ function $ff3cc90cb76ac26c$var$usesReference(value, regexOrOptions = {}) {
    const regex = regexOrOptions instanceof RegExp ? regexOrOptions : $283c8f0374cf594f$exports(regexOrOptions);
    if (typeof value === "string") return regex.test(value);
    if (typeof value === "object") {
        let hasReference = false;
        // iterate over each property in the object,
        // if any element passes the regex test,
        // the whole thing should be true
        for(const key in value)if (value.hasOwnProperty(key)) {
            const element = value[key];
            let reference = $ff3cc90cb76ac26c$var$usesReference(element, regexOrOptions);
            if (reference) {
                hasReference = true;
                break;
            }
        }
        return hasReference;
    }
    return false;
}
$ff3cc90cb76ac26c$exports = $ff3cc90cb76ac26c$var$usesReference;


var $912df85f858b93ae$export$f9ebafeabd662d32 = "amplify";
function $912df85f858b93ae$var$t(r) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ff3cc90cb76ac26c$exports)))(r)) {
        var e = r.replace(/\{|\}/g, "").replace(".value", "").split(".");
        return "var(--".concat($912df85f858b93ae$export$8658ddf1aae625a3({
            path: e
        }), ")");
    }
    return r;
}
function $912df85f858b93ae$export$55101aa37e5c1f8f(r) {
    var e = r.value;
    if ("string" == typeof e) return $912df85f858b93ae$var$t(e);
    if ("object" == typeof e && "offsetX" in e) {
        var o = e.offsetX, i = void 0 === o ? "" : o, a = e.offsetY, f = void 0 === a ? "" : a, n = e.blurRadius, s = void 0 === n ? "" : n, u = e.spreadRadius, c = void 0 === u ? "" : u, l = e.color, p = void 0 === l ? "" : l;
        return [
            $912df85f858b93ae$var$t(i),
            $912df85f858b93ae$var$t(f),
            $912df85f858b93ae$var$t(s),
            $912df85f858b93ae$var$t(c),
            $912df85f858b93ae$var$t(p)
        ].join(" ");
    }
    return e;
}
function $912df85f858b93ae$export$8658ddf1aae625a3(o) {
    var i = o.path;
    return "".concat((0, (/*@__PURE__*/$parcel$interopDefault($fa74499edcf324c6$exports)))((0, $6bbabf3c01bf9470$export$1216008129fb82ed)([
        "amplify"
    ], void 0 === i ? [] : i, !0).join(" ")));
}


var $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6;
!function(e) {
    e.Alert = "amplify-alert", e.AlertIcon = "amplify-alert__icon", e.AlertHeading = "amplify-alert__heading", e.AlertBody = "amplify-alert__body", e.AlertDismiss = "amplify-alert__dismiss", e.Autocomplete = "amplify-autocomplete", e.AutocompleteMenu = "amplify-autocomplete__menu", e.AutocompleteMenuEmpty = "amplify-autocomplete__menu--empty", e.AutocompleteMenuFooter = "amplify-autocomplete__menu__footer", e.AutocompleteMenuHeader = "amplify-autocomplete__menu__header", e.AutocompleteMenuLoading = "amplify-autocomplete__menu--loading", e.AutocompleteMenuOption = "amplify-autocomplete__menu__option", e.AutocompleteMenuOptions = "amplify-autocomplete__menu__options", e.Badge = "amplify-badge", e.Button = "amplify-button", e.ButtonGroup = "amplify-buttongroup", e.ButtonLoaderWrapper = "amplify-button__loader-wrapper", e.Card = "amplify-card", e.Checkbox = "amplify-checkbox", e.CheckboxButton = "amplify-checkbox__button", e.CheckboxIcon = "amplify-checkbox__icon", e.CheckboxInput = "amplify-checkbox__input", e.CheckboxLabel = "amplify-checkbox__label", e.CheckboxField = "amplify-checkboxfield", e.Collection = "amplify-collection", e.CollectionItems = "amplify-collection-items", e.CollectionSearch = "amplify-collection-search", e.CollectionPagination = "amplify-collection-pagination", e.CountryCodeSelect = "amplify-countrycodeselect", e.DialCodeSelect = "amplify-dialcodeselect", e.Divider = "amplify-divider", e.DividerLabel = "amplify-divider--label", e.Expander = "amplify-expander", e.ExpanderContent = "amplify-expander__content", e.ExpanderContentText = "amplify-expander__content__text", e.ExpanderHeader = "amplify-expander__header", e.ExpanderIcon = "amplify-expander__icon", e.ExpanderItem = "amplify-expander__item", e.ExpanderTrigger = "amplify-expander__trigger", e.Field = "amplify-field", e.FieldDescription = "amplify-field__description", e.FieldErrorMessage = "amplify-field__error-message", e.FieldGroup = "amplify-field-group", e.FieldGroupControl = "amplify-field-group__control", e.FieldGroupOuterEnd = "amplify-field-group__outer-end", e.FieldGroupOuterStart = "amplify-field-group__outer-start", e.FieldGroupInnerEnd = "amplify-field-group__inner-end", e.FieldGroupInnerStart = "amplify-field-group__inner-start", e.FieldGroupIcon = "amplify-field-group__icon", e.FieldGroupIconButton = "amplify-field-group__icon-button", e.FieldGroupHasInnerEnd = "amplify-field-group--has-inner-end", e.FieldGroupHasInnerStart = "amplify-field-group--has-inner-start", e.FieldShowPassword = "amplify-field__show-password", e.FieldGroupFieldWrapper = "amplify-field-group__field-wrapper", e.Flex = "amplify-flex", e.Grid = "amplify-grid", e.Heading = "amplify-heading", e.HighlightMatch = "amplify-highlightmatch", e.HighlightMatchHighlighted = "amplify-highlightmatch__highlighted", e.Icon = "amplify-icon", e.Image = "amplify-image", e.Input = "amplify-input", e.Label = "amplify-label", e.Link = "amplify-link", e.Loader = "amplify-loader", e.LoaderDeterminate = "amplify-loader--determinate", e.LoaderPercentageText = "amplify-loader__percentage-text", e.MenuContent = "amplify-menu-content", e.MenuItem = "amplify-menu-content__item", e.MenuTrigger = "amplify-menu-trigger", e.Pagination = "amplify-pagination", e.PaginationItemButton = "amplify-pagination__item-button", e.PaginationItemCurrent = "amplify-pagination__item-current", e.PaginationItemEllipsis = "amplify-pagination__item-ellipsis", e.PasswordField = "amplify-passwordfield", e.PhoneNumberField = "amplify-phonenumberfield", e.Placeholder = "amplify-placeholder", e.Radio = "amplify-radio", e.RadioButton = "amplify-radio__button", e.RadioInput = "amplify-radio__input", e.RadioLabel = "amplify-radio__label", e.RadioGroupField = "amplify-radiogroupfield", e.RadioGroup = "amplify-radiogroup", e.Rating = "amplify-rating", e.ScrollView = "amplify-scrollview", e.SearchField = "amplify-searchfield", e.SearchFieldClear = "amplify-searchfield__clear", e.SearchFieldSearch = "amplify-searchfield__search", e.Select = "amplify-select", e.SelectField = "amplify-selectfield", e.SelectWrapper = "amplify-select__wrapper", e.SelectIconWrapper = "amplify-select__icon-wrapper", e.SliderField = "amplify-sliderfield", e.SliderFieldGroup = "amplify-sliderfield__group", e.SliderFieldLabel = "amplify-sliderfield__label", e.SliderFieldRange = "amplify-sliderfield__range", e.SliderFieldRoot = "amplify-sliderfield__root", e.SliderFieldThumb = "amplify-sliderfield__thumb", e.SliderFieldTrack = "amplify-sliderfield__track", e.StepperField = "amplify-stepperfield", e.StepperFieldButtonDecrease = "amplify-stepperfield__button--decrease", e.StepperFieldButtonIncrease = "amplify-stepperfield__button--increase", e.StepperFieldInput = "amplify-stepperfield__input", e.SwitchField = "amplify-switchfield", e.SwitchLabel = "amplify-switch-label", e.SwitchThumb = "amplify-switch-thumb", e.SwitchTrack = "amplify-switch-track", e.SwitchWrapper = "amplify-switch__wrapper", e.Table = "amplify-table", e.TableCaption = "amplify-table__caption", e.TableBody = "amplify-table__body", e.TableTd = "amplify-table__td", e.TableTh = "amplify-table__th", e.TableFoot = "amplify-table__foot", e.TableHead = "amplify-table__head", e.TableRow = "amplify-table__row", e.Tabs = "amplify-tabs", e.TabItems = "amplify-tabs-item", e.Text = "amplify-text", e.Textarea = "amplify-textarea", e.TextAreaField = "amplify-textareafield", e.TextField = "amplify-textfield", e.ToggleButton = "amplify-togglebutton", e.ToggleButtonGroup = "amplify-togglebuttongroup", e.VisuallyHidden = "amplify-visually-hidden";
}($bb1cd2060d268efe$export$a5e41a4bc3f9b1d6 || ($bb1cd2060d268efe$export$a5e41a4bc3f9b1d6 = {}));


const $eb5f843fca4db3c6$export$d520e33dec8f4319 = {
    Alert: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Alert,
        components: [
            "Alert"
        ],
        description: "Top level element that wraps the Alert primitive"
    },
    AlertIcon: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AlertIcon,
        components: [
            "Alert"
        ],
        description: "Class applied to Icon component within the Alert primitive"
    },
    AlertHeading: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AlertHeading,
        components: [
            "Alert"
        ],
        description: "Class applied to the heading View"
    },
    AlertBody: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AlertBody,
        components: [
            "Alert"
        ],
        description: "Class applied to the body View"
    },
    AlertDismiss: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AlertDismiss,
        components: [
            "Alert"
        ],
        description: "Class applied to the close Button"
    },
    Autocomplete: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Autocomplete,
        components: [
            "Autocomplete"
        ],
        description: "Top level element that wraps the Autocomplete primitive"
    },
    AutocompleteMenu: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AutocompleteMenu,
        components: [
            "Autocomplete"
        ],
        description: "Top level element that wraps the dropdown menu"
    },
    AutocompleteMenuEmpty: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AutocompleteMenuEmpty,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to the no options slot of menu"
    },
    AutocompleteMenuFooter: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AutocompleteMenuFooter,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to menu footer"
    },
    AutocompleteMenuHeader: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AutocompleteMenuHeader,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to menu header"
    },
    AutocompleteMenuLoading: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AutocompleteMenuLoading,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to the loading slot of menu"
    },
    AutocompleteMenuOption: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AutocompleteMenuOption,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to each li option"
    },
    AutocompleteMenuOptions: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).AutocompleteMenuOptions,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to ul container element"
    },
    Badge: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Badge,
        components: [
            "Badge"
        ],
        description: "Top level element that wraps the Badge component"
    },
    Button: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Button,
        components: [
            "Button"
        ],
        description: "Top level element that wraps the Button primitive"
    },
    ButtonGroup: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ButtonGroup
    },
    ButtonLoaderWrapper: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ButtonLoaderWrapper,
        components: [
            "Button"
        ],
        description: "Class applied to the Loader component within the Button Loading state"
    },
    Card: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Card,
        components: [
            "Card"
        ],
        description: "Top level element that wraps the Card primitive"
    },
    Checkbox: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Checkbox,
        components: [
            "Checkbox"
        ],
        description: "Top level element that wraps the Checkbox primitive"
    },
    CheckboxButton: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CheckboxButton,
        components: [
            "Checkbox"
        ],
        description: "Wrapper for the checked icon within the Checkbox primitive"
    },
    CheckboxIcon: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CheckboxIcon,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the checked icon within the Checkbox primitive"
    },
    CheckboxInput: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CheckboxInput,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the visually hidden checkbox input within the Checkbox primitive"
    },
    CheckboxLabel: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CheckboxLabel,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the label within the Checkbox primitive"
    },
    CheckboxField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CheckboxField,
        components: [
            "CheckboxField"
        ],
        description: "Top level element that wraps the CheckboxField primitive"
    },
    Collection: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Collection,
        components: [
            "Collection"
        ],
        description: "Top level element that wraps the Collection primitive"
    },
    CollectionItems: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CollectionItems,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps all the items in a collection"
    },
    CollectionSearch: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CollectionSearch,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps the collection search box"
    },
    CollectionPagination: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CollectionPagination,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps the pagination component in a collection"
    },
    CountryCodeSelect: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).CountryCodeSelect,
        components: [
            "PhoneNumberField"
        ],
        description: "Class applied to the Dial Code Select within the PhoneNumberField primitive"
    },
    DialCodeSelect: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).DialCodeSelect,
        components: [
            "PhoneNumberField"
        ],
        description: "Class applied to the Dial Code Select within the PhoneNumberField primitive"
    },
    Divider: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Divider,
        components: [
            "Divider"
        ],
        description: "Top level element that wraps the Divider primitive"
    },
    DividerLabel: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).DividerLabel,
        components: [
            "Divider"
        ],
        description: "Class applied to the label of the Divider component"
    },
    Expander: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Expander,
        components: [
            "Expander"
        ],
        description: "Top level element that wraps the Expander primitive"
    },
    ExpanderContent: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ExpanderContent,
        components: [
            "Expander"
        ],
        description: "Expander content container"
    },
    ExpanderContentText: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ExpanderContentText,
        components: [
            "Expander"
        ],
        description: "Expander content text"
    },
    ExpanderHeader: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ExpanderHeader,
        components: [
            "Expander"
        ],
        description: "Expander item header"
    },
    ExpanderIcon: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ExpanderIcon,
        components: [
            "Expander"
        ],
        description: "Icon to indicate whether an item is expanded or collapsed"
    },
    ExpanderItem: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ExpanderItem,
        components: [
            "Expander"
        ],
        description: "Expander item(containier for header, trigger, and content)"
    },
    ExpanderTrigger: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ExpanderTrigger,
        components: [
            "Expander"
        ],
        description: "Expander item trigger(button)"
    },
    Field: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Field
    },
    FieldDescription: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldDescription
    },
    FieldErrorMessage: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldErrorMessage
    },
    FieldGroup: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroup
    },
    FieldGroupControl: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupControl
    },
    FieldGroupOuterEnd: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd
    },
    FieldGroupOuterStart: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart
    },
    FieldGroupInnerEnd: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupInnerEnd
    },
    FieldGroupInnerStart: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupInnerStart
    },
    FieldGroupIcon: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupIcon
    },
    FieldGroupIconButton: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupIconButton
    },
    FieldGroupHasInnerEnd: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerEnd
    },
    FieldGroupHasInnerStart: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerStart
    },
    FieldShowPassword: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldShowPassword
    },
    FieldGroupFieldWrapper: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper
    },
    Flex: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Flex,
        components: [
            "Flex"
        ],
        description: "Top level element that wraps the Flex primitive"
    },
    Grid: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Grid,
        components: [
            "Grid"
        ],
        description: "Top level element that wraps the Grid primitive"
    },
    Heading: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Heading,
        components: [
            "Heading"
        ],
        description: "Top level element that wraps the Heading primitive"
    },
    HighlightMatch: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).HighlightMatch,
        components: [
            "HighlightMatch"
        ],
        description: "Top level element that wraps the HighlightMatch primitive"
    },
    HighlightMatchHighlighted: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).HighlightMatchHighlighted,
        components: [
            "HighlightMatch"
        ],
        description: "Class applied to the highlighted text of the HighlightMatch primitive"
    },
    Icon: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Icon,
        components: [
            "Icon"
        ],
        description: "Top level element that wraps the Icon primitive"
    },
    Image: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Image,
        components: [
            "Image"
        ],
        description: "Top level element that wraps the Image primitive"
    },
    Input: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Input
    },
    Label: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Label
    },
    Link: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Link,
        components: [
            "Link"
        ],
        description: "Top level element that wraps the Link primitive"
    },
    Loader: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Loader,
        components: [
            "Loader"
        ],
        description: "Top level element that wraps the Loader primitive"
    },
    LoaderDeterminate: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).LoaderDeterminate,
        components: [
            "Loader"
        ],
        description: "Class applied to a determinate loader"
    },
    LoaderPercentageText: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).LoaderPercentageText,
        components: [
            "Loader"
        ],
        description: "Class applied to the percentage text of loader"
    },
    MenuContent: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).MenuContent,
        components: [
            "Menu"
        ],
        description: "Menu content container (Flex)"
    },
    MenuItem: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).MenuItem,
        components: [
            "Menu"
        ],
        description: "Menu item button (MenuButton, wrapped in amplify-menu-content class)"
    },
    MenuTrigger: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).MenuTrigger,
        components: [
            "Menu"
        ],
        description: "Menu trigger button (MenuButton, not wrapped in amplify-menu-content class)"
    },
    Pagination: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Pagination,
        components: [
            "Pagination"
        ],
        description: "Top level element that wraps the Pagination primitive"
    },
    PaginationItemButton: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).PaginationItemButton,
        components: [
            "Pagination"
        ],
        description: "Class applied to the pagination buttons"
    },
    PaginationItemCurrent: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).PaginationItemCurrent,
        components: [
            "Pagination"
        ],
        description: "Class applied to the currently selected pagination button"
    },
    PaginationItemEllipsis: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).PaginationItemEllipsis,
        components: [
            "Pagination"
        ],
        description: "Class applied to the ellipsis within the Pagination primitive"
    },
    PasswordField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).PasswordField,
        components: [
            "PasswordField"
        ],
        description: "Top level element that wraps the PasswordField primitive"
    },
    PhoneNumberField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).PhoneNumberField,
        components: [
            "PhoneNumberField"
        ],
        description: "Top level element that wraps the PhoneNumberField primitive"
    },
    Placeholder: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Placeholder,
        components: [
            "Placeholder"
        ],
        description: "Top level element that wraps the Placeholder primitive"
    },
    Radio: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Radio,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Top level element that wraps the Radio primitive"
    },
    RadioButton: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).RadioButton,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the displayed radio button"
    },
    RadioInput: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).RadioInput,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the visually hidden radio input"
    },
    RadioLabel: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).RadioLabel,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the radio label"
    },
    RadioGroupField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).RadioGroupField,
        components: [
            "RadioGroupField"
        ],
        description: "Top level element that wraps the RadioGroupField primitive"
    },
    RadioGroup: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).RadioGroup,
        components: [
            "RadioGroupField"
        ],
        description: "Class applied to the radio group wrapper"
    },
    Rating: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Rating,
        components: [
            "Rating"
        ],
        description: "Top level element that wraps the Rating primitive"
    },
    ScrollView: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ScrollView,
        components: [
            "ScrollView"
        ],
        description: "Top level element that wraps the ScrollView primitive"
    },
    SearchField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SearchField,
        components: [
            "SearchField"
        ],
        description: "Top level element that wraps the SearchField primitive"
    },
    SearchFieldClear: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SearchFieldClear,
        components: [
            "SearchField"
        ],
        description: "Class applied to the search field clear button"
    },
    SearchFieldSearch: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SearchFieldSearch,
        components: [
            "SearchField"
        ],
        description: "Class applied to the search button"
    },
    Select: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Select,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select element"
    },
    SelectField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SelectField,
        components: [
            "SelectField"
        ],
        description: "Top level element that wraps the SelectField primitive"
    },
    SelectWrapper: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SelectWrapper,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select wrapper"
    },
    SelectIconWrapper: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SelectIconWrapper,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select icon wrapper"
    },
    SliderField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SliderField,
        components: [
            "SliderField"
        ],
        description: "Top level element that wraps the SliderField primitive"
    },
    SliderFieldGroup: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SliderFieldGroup,
        components: [
            "SliderField"
        ],
        description: "Class applied to the element that wraps the slider root"
    },
    SliderFieldLabel: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SliderFieldLabel,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider label"
    },
    SliderFieldRange: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SliderFieldRange,
        components: [
            "SliderField"
        ],
        description: "Class applied to the filled in portion of the slider track"
    },
    SliderFieldRoot: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SliderFieldRoot,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider root which wraps the track and thumb"
    },
    SliderFieldThumb: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SliderFieldThumb,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider thumb"
    },
    SliderFieldTrack: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SliderFieldTrack,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider track"
    },
    StepperField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).StepperField,
        components: [
            "StepperField"
        ],
        description: "Top level element that wraps the StepperField primitive"
    },
    StepperFieldButtonDecrease: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).StepperFieldButtonDecrease,
        components: [
            "StepperField"
        ],
        description: "Class applied to the decrease button"
    },
    StepperFieldButtonIncrease: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).StepperFieldButtonIncrease,
        components: [
            "StepperField"
        ],
        description: "Class applied to the increase button"
    },
    StepperFieldInput: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).StepperFieldInput,
        components: [
            "StepperField"
        ],
        description: "Class applied to the StepperField input"
    },
    SwitchField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SwitchField,
        components: [
            "SwitchField"
        ],
        description: "Top level element that wraps the SwitchField primitive"
    },
    SwitchLabel: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SwitchLabel,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField label text"
    },
    SwitchThumb: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SwitchThumb,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField thumb"
    },
    SwitchTrack: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SwitchTrack,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField track"
    },
    SwitchWrapper: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).SwitchWrapper,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the label element that wraps the SwitchField label and track"
    },
    Table: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Table,
        components: [
            "Table"
        ],
        description: "Top level element that wraps the Table primitive"
    },
    TableCaption: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TableCaption,
        components: [
            "Table"
        ],
        description: "Class applied to the content provided as the caption prop"
    },
    TableBody: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TableBody,
        components: [
            "Table"
        ],
        description: "Class applied to TableBody component"
    },
    TableTd: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TableTd,
        components: [
            "Table"
        ],
        description: 'Class applied to TableCell component rendered as a <td> element (<TableCell as="td" />)'
    },
    TableTh: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TableTh,
        components: [
            "Table"
        ],
        description: 'Class applied to TableCell comopnent rendered as a <th> element (<TableCell as="th" />)'
    },
    TableFoot: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TableFoot,
        components: [
            "Table"
        ],
        description: "Class applied to TableFoot component"
    },
    TableHead: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TableHead,
        components: [
            "Table"
        ],
        description: "Class applied to TableHead component"
    },
    TableRow: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TableRow,
        components: [
            "Table"
        ],
        description: "Class applied to TableRow component"
    },
    Tabs: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Tabs,
        components: [
            "Tabs"
        ],
        description: "Top level element that wraps the Tabs primitive"
    },
    TabItems: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TabItems,
        components: [
            "Tabs"
        ],
        description: "Top level element that wraps the TabItem primitive"
    },
    Text: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Text,
        components: [
            "Text"
        ],
        description: "Top level element that wraps the Text primitive"
    },
    Textarea: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).Textarea,
        components: [
            "TextAreaField"
        ],
        description: "Class applied to the text area"
    },
    TextAreaField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TextAreaField,
        components: [
            "TextAreaField"
        ],
        description: "Top level element that wraps the TextAreaField primitive"
    },
    TextField: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).TextField,
        components: [
            "TextField"
        ],
        description: "Top level element that wraps the TextField primitive"
    },
    ToggleButton: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ToggleButton,
        components: [
            "ToggleButton"
        ],
        description: "Top level element that wraps the ToggleButton primitive"
    },
    ToggleButtonGroup: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).ToggleButtonGroup,
        components: [
            "ToggleButton",
            "ToggleButtonGroup"
        ],
        description: "Top level element that wraps the ToggleButtonGroup primitive"
    },
    VisuallyHidden: {
        className: (0, $bb1cd2060d268efe$export$a5e41a4bc3f9b1d6).VisuallyHidden,
        components: [
            "VisuallyHidden"
        ],
        description: "Top level element that wraps the VisuallyHidden primitive"
    }
}, $eb5f843fca4db3c6$export$da015ee4e3f15a81 = {
    Alert: $eb5f843fca4db3c6$export$d520e33dec8f4319.Alert.className,
    AlertIcon: $eb5f843fca4db3c6$export$d520e33dec8f4319.AlertIcon.className,
    AlertHeading: $eb5f843fca4db3c6$export$d520e33dec8f4319.AlertHeading.className,
    AlertBody: $eb5f843fca4db3c6$export$d520e33dec8f4319.AlertBody.className,
    AlertDismiss: $eb5f843fca4db3c6$export$d520e33dec8f4319.AlertDismiss.className,
    Autocomplete: $eb5f843fca4db3c6$export$d520e33dec8f4319.Autocomplete.className,
    AutocompleteMenu: $eb5f843fca4db3c6$export$d520e33dec8f4319.AutocompleteMenu.className,
    AutocompleteMenuEmpty: $eb5f843fca4db3c6$export$d520e33dec8f4319.AutocompleteMenuEmpty.className,
    AutocompleteMenuFooter: $eb5f843fca4db3c6$export$d520e33dec8f4319.AutocompleteMenuFooter.className,
    AutocompleteMenuHeader: $eb5f843fca4db3c6$export$d520e33dec8f4319.AutocompleteMenuHeader.className,
    AutocompleteMenuLoading: $eb5f843fca4db3c6$export$d520e33dec8f4319.AutocompleteMenuLoading.className,
    AutocompleteMenuOption: $eb5f843fca4db3c6$export$d520e33dec8f4319.AutocompleteMenuOption.className,
    AutocompleteMenuOptions: $eb5f843fca4db3c6$export$d520e33dec8f4319.AutocompleteMenuOptions.className,
    Badge: $eb5f843fca4db3c6$export$d520e33dec8f4319.Badge.className,
    Button: $eb5f843fca4db3c6$export$d520e33dec8f4319.Button.className,
    ButtonGroup: $eb5f843fca4db3c6$export$d520e33dec8f4319.ButtonGroup.className,
    ButtonLoaderWrapper: $eb5f843fca4db3c6$export$d520e33dec8f4319.ButtonLoaderWrapper.className,
    Card: $eb5f843fca4db3c6$export$d520e33dec8f4319.Card.className,
    Checkbox: $eb5f843fca4db3c6$export$d520e33dec8f4319.Checkbox.className,
    CheckboxButton: $eb5f843fca4db3c6$export$d520e33dec8f4319.CheckboxButton.className,
    CheckboxIcon: $eb5f843fca4db3c6$export$d520e33dec8f4319.CheckboxIcon.className,
    CheckboxInput: $eb5f843fca4db3c6$export$d520e33dec8f4319.CheckboxInput.className,
    CheckboxLabel: $eb5f843fca4db3c6$export$d520e33dec8f4319.CheckboxLabel.className,
    CheckboxField: $eb5f843fca4db3c6$export$d520e33dec8f4319.CheckboxField.className,
    Collection: $eb5f843fca4db3c6$export$d520e33dec8f4319.Collection.className,
    CollectionItems: $eb5f843fca4db3c6$export$d520e33dec8f4319.CollectionItems.className,
    CollectionSearch: $eb5f843fca4db3c6$export$d520e33dec8f4319.CollectionSearch.className,
    CollectionPagination: $eb5f843fca4db3c6$export$d520e33dec8f4319.CollectionPagination.className,
    CountryCodeSelect: $eb5f843fca4db3c6$export$d520e33dec8f4319.CountryCodeSelect.className,
    DialCodeSelect: $eb5f843fca4db3c6$export$d520e33dec8f4319.DialCodeSelect.className,
    Divider: $eb5f843fca4db3c6$export$d520e33dec8f4319.Divider.className,
    DividerLabel: $eb5f843fca4db3c6$export$d520e33dec8f4319.DividerLabel.className,
    Expander: $eb5f843fca4db3c6$export$d520e33dec8f4319.Expander.className,
    ExpanderContent: $eb5f843fca4db3c6$export$d520e33dec8f4319.ExpanderContent.className,
    ExpanderContentText: $eb5f843fca4db3c6$export$d520e33dec8f4319.ExpanderContentText.className,
    ExpanderHeader: $eb5f843fca4db3c6$export$d520e33dec8f4319.ExpanderHeader.className,
    ExpanderIcon: $eb5f843fca4db3c6$export$d520e33dec8f4319.ExpanderIcon.className,
    ExpanderItem: $eb5f843fca4db3c6$export$d520e33dec8f4319.ExpanderItem.className,
    ExpanderTrigger: $eb5f843fca4db3c6$export$d520e33dec8f4319.ExpanderTrigger.className,
    Field: $eb5f843fca4db3c6$export$d520e33dec8f4319.Field.className,
    FieldDescription: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldDescription.className,
    FieldErrorMessage: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldErrorMessage.className,
    FieldGroup: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroup.className,
    FieldGroupControl: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupControl.className,
    FieldGroupOuterEnd: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupOuterEnd.className,
    FieldGroupOuterStart: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupOuterStart.className,
    FieldGroupInnerEnd: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupInnerEnd.className,
    FieldGroupInnerStart: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupInnerStart.className,
    FieldGroupIcon: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupIcon.className,
    FieldGroupIconButton: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupIconButton.className,
    FieldGroupHasInnerEnd: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupHasInnerEnd.className,
    FieldGroupHasInnerStart: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupHasInnerStart.className,
    FieldShowPassword: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldShowPassword.className,
    FieldGroupFieldWrapper: $eb5f843fca4db3c6$export$d520e33dec8f4319.FieldGroupFieldWrapper.className,
    Flex: $eb5f843fca4db3c6$export$d520e33dec8f4319.Flex.className,
    Grid: $eb5f843fca4db3c6$export$d520e33dec8f4319.Grid.className,
    Heading: $eb5f843fca4db3c6$export$d520e33dec8f4319.Heading.className,
    HighlightMatch: $eb5f843fca4db3c6$export$d520e33dec8f4319.HighlightMatch.className,
    HighlightMatchHighlighted: $eb5f843fca4db3c6$export$d520e33dec8f4319.HighlightMatchHighlighted.className,
    Icon: $eb5f843fca4db3c6$export$d520e33dec8f4319.Icon.className,
    Image: $eb5f843fca4db3c6$export$d520e33dec8f4319.Image.className,
    Input: $eb5f843fca4db3c6$export$d520e33dec8f4319.Input.className,
    Label: $eb5f843fca4db3c6$export$d520e33dec8f4319.Label.className,
    Link: $eb5f843fca4db3c6$export$d520e33dec8f4319.Link.className,
    Loader: $eb5f843fca4db3c6$export$d520e33dec8f4319.Loader.className,
    LoaderDeterminate: $eb5f843fca4db3c6$export$d520e33dec8f4319.LoaderDeterminate.className,
    LoaderPercentageText: $eb5f843fca4db3c6$export$d520e33dec8f4319.LoaderPercentageText.className,
    MenuContent: $eb5f843fca4db3c6$export$d520e33dec8f4319.MenuContent.className,
    MenuItem: $eb5f843fca4db3c6$export$d520e33dec8f4319.MenuItem.className,
    MenuTrigger: $eb5f843fca4db3c6$export$d520e33dec8f4319.MenuTrigger.className,
    Pagination: $eb5f843fca4db3c6$export$d520e33dec8f4319.Pagination.className,
    PaginationItemButton: $eb5f843fca4db3c6$export$d520e33dec8f4319.PaginationItemButton.className,
    PaginationItemCurrent: $eb5f843fca4db3c6$export$d520e33dec8f4319.PaginationItemCurrent.className,
    PaginationItemEllipsis: $eb5f843fca4db3c6$export$d520e33dec8f4319.PaginationItemEllipsis.className,
    PasswordField: $eb5f843fca4db3c6$export$d520e33dec8f4319.PasswordField.className,
    PhoneNumberField: $eb5f843fca4db3c6$export$d520e33dec8f4319.PhoneNumberField.className,
    Placeholder: $eb5f843fca4db3c6$export$d520e33dec8f4319.Placeholder.className,
    Radio: $eb5f843fca4db3c6$export$d520e33dec8f4319.Radio.className,
    RadioButton: $eb5f843fca4db3c6$export$d520e33dec8f4319.RadioButton.className,
    RadioInput: $eb5f843fca4db3c6$export$d520e33dec8f4319.RadioInput.className,
    RadioLabel: $eb5f843fca4db3c6$export$d520e33dec8f4319.RadioLabel.className,
    RadioGroupField: $eb5f843fca4db3c6$export$d520e33dec8f4319.RadioGroupField.className,
    RadioGroup: $eb5f843fca4db3c6$export$d520e33dec8f4319.RadioGroup.className,
    Rating: $eb5f843fca4db3c6$export$d520e33dec8f4319.Rating.className,
    ScrollView: $eb5f843fca4db3c6$export$d520e33dec8f4319.ScrollView.className,
    SearchField: $eb5f843fca4db3c6$export$d520e33dec8f4319.SearchField.className,
    SearchFieldClear: $eb5f843fca4db3c6$export$d520e33dec8f4319.SearchFieldClear.className,
    SearchFieldSearch: $eb5f843fca4db3c6$export$d520e33dec8f4319.SearchFieldSearch.className,
    Select: $eb5f843fca4db3c6$export$d520e33dec8f4319.Select.className,
    SelectField: $eb5f843fca4db3c6$export$d520e33dec8f4319.SelectField.className,
    SelectWrapper: $eb5f843fca4db3c6$export$d520e33dec8f4319.SelectWrapper.className,
    SelectIconWrapper: $eb5f843fca4db3c6$export$d520e33dec8f4319.SelectIconWrapper.className,
    SliderField: $eb5f843fca4db3c6$export$d520e33dec8f4319.SliderField.className,
    SliderFieldGroup: $eb5f843fca4db3c6$export$d520e33dec8f4319.SliderFieldGroup.className,
    SliderFieldLabel: $eb5f843fca4db3c6$export$d520e33dec8f4319.SliderFieldLabel.className,
    SliderFieldRange: $eb5f843fca4db3c6$export$d520e33dec8f4319.SliderFieldRange.className,
    SliderFieldRoot: $eb5f843fca4db3c6$export$d520e33dec8f4319.SliderFieldRoot.className,
    SliderFieldThumb: $eb5f843fca4db3c6$export$d520e33dec8f4319.SliderFieldThumb.className,
    SliderFieldTrack: $eb5f843fca4db3c6$export$d520e33dec8f4319.SliderFieldTrack.className,
    StepperField: $eb5f843fca4db3c6$export$d520e33dec8f4319.StepperField.className,
    StepperFieldButtonDecrease: $eb5f843fca4db3c6$export$d520e33dec8f4319.StepperFieldButtonDecrease.className,
    StepperFieldButtonIncrease: $eb5f843fca4db3c6$export$d520e33dec8f4319.StepperFieldButtonIncrease.className,
    StepperFieldInput: $eb5f843fca4db3c6$export$d520e33dec8f4319.StepperFieldInput.className,
    SwitchField: $eb5f843fca4db3c6$export$d520e33dec8f4319.SwitchField.className,
    SwitchLabel: $eb5f843fca4db3c6$export$d520e33dec8f4319.SwitchLabel.className,
    SwitchThumb: $eb5f843fca4db3c6$export$d520e33dec8f4319.SwitchThumb.className,
    SwitchTrack: $eb5f843fca4db3c6$export$d520e33dec8f4319.SwitchTrack.className,
    SwitchWrapper: $eb5f843fca4db3c6$export$d520e33dec8f4319.SwitchWrapper.className,
    Table: $eb5f843fca4db3c6$export$d520e33dec8f4319.Table.className,
    TableCaption: $eb5f843fca4db3c6$export$d520e33dec8f4319.TableCaption.className,
    TableBody: $eb5f843fca4db3c6$export$d520e33dec8f4319.TableBody.className,
    TableTd: $eb5f843fca4db3c6$export$d520e33dec8f4319.TableTd.className,
    TableTh: $eb5f843fca4db3c6$export$d520e33dec8f4319.TableTh.className,
    TableFoot: $eb5f843fca4db3c6$export$d520e33dec8f4319.TableFoot.className,
    TableHead: $eb5f843fca4db3c6$export$d520e33dec8f4319.TableHead.className,
    TableRow: $eb5f843fca4db3c6$export$d520e33dec8f4319.TableRow.className,
    Tabs: $eb5f843fca4db3c6$export$d520e33dec8f4319.Tabs.className,
    TabItems: $eb5f843fca4db3c6$export$d520e33dec8f4319.TabItems.className,
    Text: $eb5f843fca4db3c6$export$d520e33dec8f4319.Text.className,
    Textarea: $eb5f843fca4db3c6$export$d520e33dec8f4319.Textarea.className,
    TextAreaField: $eb5f843fca4db3c6$export$d520e33dec8f4319.TextAreaField.className,
    TextField: $eb5f843fca4db3c6$export$d520e33dec8f4319.TextField.className,
    ToggleButton: $eb5f843fca4db3c6$export$d520e33dec8f4319.ToggleButton.className,
    ToggleButtonGroup: $eb5f843fca4db3c6$export$d520e33dec8f4319.ToggleButtonGroup.className,
    VisuallyHidden: $eb5f843fca4db3c6$export$d520e33dec8f4319.VisuallyHidden.className
}, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c = {
    Alert: {
        dismissButtonLabel: "Dismiss alert"
    },
    Autocomplete: {
        emptyText: "No options found",
        loadingText: "Loading options..."
    },
    Collection: {
        searchButtonLabel: "Search",
        searchNoResultsFound: "No results found"
    },
    Fields: {
        clearButtonLabel: "Clear input"
    },
    PaginationItem: {
        currentPageLabel: "Page",
        nextLabel: "Go to next page",
        pageLabel: "Go to page",
        previousLabel: "Go to previous page"
    },
    PhoneNumberField: {
        countryCodeLabel: "Country code"
    },
    SearchField: {
        searchButtonLabel: "Search"
    },
    PasswordField: {
        passwordIsHidden: "Password is hidden",
        passwordIsShown: "Password is shown",
        showPassword: "Show password"
    },
    StepperField: {
        increaseButtonLabel: "Increase to",
        decreaseButtonLabel: "Decrease to"
    }
}, $eb5f843fca4db3c6$export$f486c23e21d151b2 = {
    backgroundColor: "colors",
    color: "colors",
    borderRadius: "radii",
    fontSize: "fontSizes",
    fontWeight: "fontWeights",
    fontFamily: "fonts",
    lineHeight: "lineHeights",
    opacity: "opacities",
    boxShadow: "shadows",
    transform: "transforms",
    left: "space",
    right: "space",
    top: "space",
    bottom: "space",
    height: "space",
    width: "space",
    letterSpacing: "space",
    margin: "space",
    marginBlock: "space",
    marginBlockEnd: "space",
    marginBlockStart: "space",
    marginInline: "space",
    marginInlineEnd: "space",
    marginInlineStart: "space",
    marginLeft: "space",
    marginRight: "space",
    marginTop: "space",
    marginBottom: "space",
    maxHeight: "space",
    maxWidth: "space",
    minHeight: "space",
    minWidth: "space",
    padding: "space",
    paddingBlock: "space",
    paddingBlockEnd: "space",
    paddingBlockStart: "space",
    paddingInline: "space",
    paddingInlineEnd: "space",
    paddingInlineStart: "space",
    paddingLeft: "space",
    paddingRight: "space",
    paddingTop: "space",
    paddingBottom: "space",
    gap: "space",
    columnGap: "space",
    rowGap: "space"
}, $eb5f843fca4db3c6$export$728705b4513abbb5 = "Escape", $eb5f843fca4db3c6$export$4162dbd8c730437 = "Enter", $eb5f843fca4db3c6$export$8188339dbe6c99c4 = "ArrowUp", $eb5f843fca4db3c6$export$59f214baefff6196 = "ArrowDown";


const $8b520a117f46c559$export$c6251bf2bc4bb464 = (t)=>"string" == typeof t && t.length > 0, $8b520a117f46c559$export$f6e2535fb5126e54 = (t)=>"function" == typeof t, $8b520a117f46c559$export$78d1711480f95c3e = (t)=>"string" == typeof t && 0 === t.length, $8b520a117f46c559$export$68b32c1946a6b59c = (t)=>null == t || $8b520a117f46c559$export$78d1711480f95c3e(t), $8b520a117f46c559$export$12cda49cb4509427 = (t, n)=>{
    const r = n - t + 1;
    return Array.from({
        length: r
    }, (n, r)=>r + t);
}, $8b520a117f46c559$export$1d6fb99b5e148be8 = (t, n)=>n ? `${t}--${n}` : null, $8b520a117f46c559$export$3c152e7b97c7496c = (t, n, r)=>r ? `${t}--${n}` : null, $8b520a117f46c559$export$b0c777ec01738e5b = (e, l)=>{
    if ("string" != typeof l) return l;
    if (l.includes(" ")) return l.split(" ").map((t)=>$8b520a117f46c559$export$b0c777ec01738e5b(e, t)).join(" ");
    const i = l.split("."), s = (0, $eb5f843fca4db3c6$export$f486c23e21d151b2)[e];
    let f = (0, $ed14429abad98907$export$164de7ab8df77ef0).tokens[s];
    for(let t = 0; t < i.length && f; t++)f = f[i[t]];
    return (0, $89b176368041d7a8$export$daee9cd42beef6d1)(f) ? `var(--${(0, $912df85f858b93ae$export$8658ddf1aae625a3)({
        path: [
            (0, $eb5f843fca4db3c6$export$f486c23e21d151b2)[e],
            ...i
        ]
    })})` : l;
};





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $7e2642286866fa4a$export$c69338bc7d797351 = {
    alignContent: "alignContent",
    alignItems: "alignItems",
    alignSelf: "alignSelf",
    area: "gridArea",
    autoColumns: "gridAutoColumns",
    autoFlow: "gridAutoFlow",
    autoRows: "gridAutoRows",
    backgroundColor: "backgroundColor",
    backgroundImage: "backgroundImage",
    basis: "flexBasis",
    border: "border",
    borderRadius: "borderRadius",
    bottom: "bottom",
    boxShadow: "boxShadow",
    color: "color",
    column: "gridColumn",
    columnEnd: "gridColumnEnd",
    columnGap: "columnGap",
    columnSpan: "gridColumn",
    columnStart: "gridColumnStart",
    direction: "flexDirection",
    display: "display",
    flex: "flex",
    fontFamily: "fontFamily",
    fontSize: "fontSize",
    fontStyle: "fontStyle",
    fontWeight: "fontWeight",
    gap: "gap",
    grow: "flexGrow",
    height: "height",
    justifyContent: "justifyContent",
    left: "left",
    letterSpacing: "letterSpacing",
    lineHeight: "lineHeight",
    margin: "margin",
    marginBlock: "marginBlock",
    marginBlockEnd: "marginBlockEnd",
    marginBlockStart: "marginBlockStart",
    marginBottom: "marginBlockEnd",
    marginInline: "marginInline",
    marginInlineEnd: "marginInlineEnd",
    marginInlineStart: "marginInlineStart",
    marginLeft: "marginInlineStart",
    marginRight: "marginInlineEnd",
    marginTop: "marginBlockStart",
    maxHeight: "maxHeight",
    maxWidth: "maxWidth",
    minHeight: "minHeight",
    minWidth: "minWidth",
    objectFit: "objectFit",
    objectPosition: "objectPosition",
    opacity: "opacity",
    order: "order",
    overflow: "overflow",
    padding: "padding",
    paddingBlock: "paddingBlock",
    paddingBlockEnd: "paddingBlockEnd",
    paddingBlockStart: "paddingBlockStart",
    paddingBottom: "paddingBlockEnd",
    paddingInline: "paddingInline",
    paddingInlineEnd: "paddingInlineEnd",
    paddingInlineStart: "paddingInlineStart",
    paddingLeft: "paddingInlineStart",
    paddingRight: "paddingInlineEnd",
    paddingTop: "paddingBlockStart",
    position: "position",
    resize: "resize",
    right: "right",
    row: "gridRow",
    rowEnd: "gridRowEnd",
    rowGap: "rowGap",
    rowSpan: "gridRow",
    rowStart: "gridRowStart",
    shrink: "flexShrink",
    templateAreas: "gridTemplateAreas",
    templateColumns: "gridTemplateColumns",
    templateRows: "gridTemplateRows",
    textAlign: "textAlign",
    textDecoration: "textDecoration",
    textTransform: "textTransform",
    top: "top",
    transform: "transform",
    transformOrigin: "transformOrigin",
    width: "width",
    whiteSpace: "whiteSpace",
    wrap: "flexWrap"
}, $7e2642286866fa4a$export$885e0ebc08cdd9a0 = Object.keys($7e2642286866fa4a$export$c69338bc7d797351);




const $d7677b12b9cf9e0a$export$7791b19c8f6fdbca = ({ breakpoint: o, breakpoints: e, propKey: i, values: n })=>{
    if ((0, $89b176368041d7a8$export$daee9cd42beef6d1)(n)) return n.toString();
    if ("object" != typeof n) return (0, $8b520a117f46c559$export$b0c777ec01738e5b)(i, n);
    let s = {};
    const p = Object.keys(e).sort((r, t)=>e[r] - e[t]);
    return Array.isArray(n) ? n.map((r, t)=>{
        s[p[t]] = r;
    }) : s = n, (({ breakpoint: o, breakpoints: e, propKey: i, values: n })=>{
        if (void 0 !== n[o]) {
            const e = n[o];
            return (0, $89b176368041d7a8$export$daee9cd42beef6d1)(e) ? e.toString() : (0, $8b520a117f46c559$export$b0c777ec01738e5b)(i, e);
        }
        const s = Object.keys(e).sort((r, t)=>e[t] - e[r]), p = s.slice(s.indexOf(o));
        for (const o of p)if (void 0 !== n[o]) {
            const e = n[o];
            return (0, $89b176368041d7a8$export$daee9cd42beef6d1)(e) ? e.toString() : (0, $8b520a117f46c559$export$b0c777ec01738e5b)(i, e);
        }
        return null;
    })({
        breakpoint: o,
        breakpoints: e,
        propKey: i,
        values: s
    });
};



var $acw62 = parcelRequire("acw62");
const $d1337900e01ba20e$export$872f03ff2a363331 = ({ breakpoints: t })=>{
    const n = Object.keys(t).sort((n, e)=>t[e] - t[n]);
    return n.map((e, r)=>{
        let i = "";
        const o = t[e], a = n[r - 1], p = a ? t[a] - 1 : null;
        return o >= 0 && (i = `(min-width: ${o}px)`), null !== p && (i && (i += " and "), i += `(max-width: ${p}px)`), {
            breakpoint: e,
            query: i,
            maxWidth: p,
            minWidth: o
        };
    });
};


const $9d2e8e96809bd95b$var$n = "undefined" == typeof window ? $acw62.useEffect : $acw62.useLayoutEffect, $9d2e8e96809bd95b$export$199d6754bdf4e1e3 = ({ breakpoints: o, defaultBreakpoint: a })=>{
    const r = "undefined" != typeof window && void 0 !== window.matchMedia ? window.matchMedia : null, i = $acw62.useMemo(()=>(0, $d1337900e01ba20e$export$872f03ff2a363331)({
            breakpoints: o
        }), [
        o
    ]), [s, u] = $acw62.useState(a), c = $acw62.useCallback((e, t)=>{
        e && u(t);
    }, [
        u
    ]);
    return $9d2e8e96809bd95b$var$n(()=>{
        if (!r) return;
        const e = i.map(({ query: e, breakpoint: t })=>{
            const n = r(e);
            c(n.matches, t);
            const o = (e)=>{
                e.matches && u(t);
            };
            return n.addEventListener("change", o), ()=>n.removeEventListener("change", o);
        });
        return ()=>{
            e.forEach((e)=>e());
        };
    }, [
        o,
        u,
        r,
        i
    ]), $acw62.useDebugValue(s, (e)=>e), s;
};




var $acw62 = parcelRequire("acw62");

var $864a32aaa8614b1c$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $fa11d244b809f165$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $4caa032c183be831$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $4caa032c183be831$export$206cd6ecad4fcdde(str, locale) {
    var lang = $4caa032c183be831$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $4caa032c183be831$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $4caa032c183be831$export$61d6efbc6547e8eb(str);
}
function $4caa032c183be831$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}


// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $bb839e30d903d5e0$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $bb839e30d903d5e0$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $bb839e30d903d5e0$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $bb839e30d903d5e0$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $bb839e30d903d5e0$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $4caa032c183be831$export$61d6efbc6547e8eb) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $bb839e30d903d5e0$var$replace($bb839e30d903d5e0$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $bb839e30d903d5e0$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}


function $1c101dfc925f9f17$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $1c101dfc925f9f17$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $1c101dfc925f9f17$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $bb839e30d903d5e0$export$a596972587f860c8)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "",
        transform: $1c101dfc925f9f17$export$66a4dfea2695736
    }, options));
}


function $4690c22a3f79a44e$export$1c6885769b2bad6f(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $1c101dfc925f9f17$export$66a4dfea2695736)(input, index);
}
function $4690c22a3f79a44e$export$f3c8e8146a7dbf93(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $1c101dfc925f9f17$export$c27cf446dc44c0b9)(input);
}
function $4690c22a3f79a44e$export$8a7688a96d852767(input, options) {
    if (options === void 0) options = {};
    return (0, $1c101dfc925f9f17$export$26c6f48841fe1a8a)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        transform: $4690c22a3f79a44e$export$1c6885769b2bad6f
    }, options));
}




function $4395beeb50d15822$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $bb839e30d903d5e0$export$a596972587f860c8)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "."
    }, options));
}


function $5be6cdd8e661e6b8$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $4395beeb50d15822$export$e1b697368b9a68f5)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "_"
    }, options));
}



function $3c541ac1dfaf7179$export$c68d52815ae74c39(input, options) {
    if (options === void 0) options = {};
    return (0, $4395beeb50d15822$export$e1b697368b9a68f5)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "-"
    }, options));
}


const $fa11d244b809f165$var$reduce = function(obj, f, accumulator_init) {
    return Object.keys(obj || {}).reduce((accumulator, key)=>{
        let value = obj[key];
        return f(accumulator, value, key, obj);
    }, accumulator_init);
};
const $fa11d244b809f165$var$forEach = function(obj, f) {
    Object.keys(obj || {}).forEach((key)=>{
        let value = obj[key];
        f(value, key);
    });
};
// Note: This is a crappy version to a certain extent... don't use with Strings, for example...
const $fa11d244b809f165$var$clone = function(object) {
    return Object.assign(new object.constructor(), object);
};
const $fa11d244b809f165$var$cloneDeep = function(obj) {
    if (obj === null || obj === undefined || typeof obj !== "object") return obj;
    if (obj instanceof Array) return obj.reduce((arr, item, i)=>{
        arr[i] = $fa11d244b809f165$var$cloneDeep(item);
        return arr;
    }, []);
    if (obj instanceof Object) return Object.keys(obj || {}).reduce((cpObj, key)=>{
        cpObj[key] = $fa11d244b809f165$var$cloneDeep(obj[key]);
        return cpObj;
    }, {});
};
const $fa11d244b809f165$var$isObject = function(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
};
const $fa11d244b809f165$var$isString = function(obj) {
    return typeof obj === "string" || obj instanceof String;
};
const $fa11d244b809f165$var$isArray = function(obj) {
    return Array.isArray(obj);
};
const $fa11d244b809f165$var$isEmpty = function(obj) {
    return [
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
function $fa11d244b809f165$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
const $fa11d244b809f165$var$filter = function(arr, filter) {
    if (typeof filter !== "function") throw "filter is not a function";
    if (typeof arr === "undefined") return [];
    return arr.filter(filter);
};
const $fa11d244b809f165$var$assign = function() {
    let args = Array.prototype.slice.call(arguments);
    args.unshift({});
    return Object.assign(...args);
};
/* global Set */ const $fa11d244b809f165$var$pull = function(arr, ...removeList) {
    var removeSet = new Set(removeList);
    for(let i = arr.length - 1; i >= 0; i--)if (removeSet.has(arr[i])) arr.splice(i, 1);
};
const $fa11d244b809f165$var$unique = function(arr) {
    return [
        ...new Set(arr)
    ];
};
const $fa11d244b809f165$var$upperFirst = function(str) {
    return str ? str[0].toUpperCase() + str.substr(1) : "";
};
const $fa11d244b809f165$var$matchFn = function(inputObj, testObj) {
    if ($fa11d244b809f165$var$isObject(testObj)) return Object.keys(testObj).every((key)=>$fa11d244b809f165$var$matchFn(inputObj[key], testObj[key]));
    else return inputObj == testObj;
};
const $fa11d244b809f165$var$matches = function(matchObj) {
    let cloneObj = $fa11d244b809f165$var$cloneDeep(matchObj);
    let matchesFn = (inputObj)=>$fa11d244b809f165$var$matchFn(inputObj, cloneObj);
    return matchesFn;
};
const $fa11d244b809f165$var$DEFAULT_OPTIONS = {
    transform: $4690c22a3f79a44e$export$f3c8e8146a7dbf93
};
const $fa11d244b809f165$var$changeDefaultCaseTransform = function(caseFunction, default_options) {
    return (caseToChange, options)=>caseFunction(caseToChange, Object.assign({}, $fa11d244b809f165$var$DEFAULT_OPTIONS, default_options, options));
};
$fa11d244b809f165$exports = {
    each: $fa11d244b809f165$var$forEach,
    forEach: $fa11d244b809f165$var$forEach,
    forIn: $fa11d244b809f165$var$forEach,
    keys: Object.keys,
    clone: $fa11d244b809f165$var$clone,
    cloneDeep: $fa11d244b809f165$var$cloneDeep,
    extend: Object.assign,
    isString: $fa11d244b809f165$var$isString,
    isArray: $fa11d244b809f165$var$isArray,
    isObject: $fa11d244b809f165$var$isObject,
    isPlainObject: $fa11d244b809f165$var$isPlainObject,
    isEmpty: $fa11d244b809f165$var$isEmpty,
    filter: $fa11d244b809f165$var$filter,
    reduce: $fa11d244b809f165$var$reduce,
    assign: $fa11d244b809f165$var$assign,
    upperFirst: $fa11d244b809f165$var$upperFirst,
    camelCase: $fa11d244b809f165$var$changeDefaultCaseTransform($4690c22a3f79a44e$export$8a7688a96d852767),
    snakeCase: $5be6cdd8e661e6b8$export$feae9a740c003485,
    kebabCase: $3c541ac1dfaf7179$export$c68d52815ae74c39,
    pull: $fa11d244b809f165$var$pull,
    matches: $fa11d244b809f165$var$matches,
    unique: $fa11d244b809f165$var$unique
};


/**
 * Performs an deep extend on the objects, from right to left.
 * @private
 * @param {Object[]} objects - An array of JS objects
 * @param {Function} collision - A function to be called when a merge collision happens.
 * @param {string[]} path - (for internal use) An array of strings which is the current path down the object when this is called recursively.
 * @returns {Object}
 */ function $864a32aaa8614b1c$var$deepExtend(objects, collision, path) {
    if (objects == null) return {};
    var src, copyIsArray, copy, name, options, clone, target = objects[0] || {}, i = 1, length = objects.length;
    path = path || [];
    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object") target = {};
    for(; i < length; i++){
        // Only deal with non-null/undefined values
        if ((options = objects[i]) != null) // Extend the base object
        for(name in options){
            if (!options.hasOwnProperty(name)) continue;
            if (name === "__proto__") continue;
            src = target[name];
            copy = options[name];
            // Prevent never-ending loop
            if (target === copy) continue;
            // Recurse if we're merging plain objects or arrays
            if (copy && ($fa11d244b809f165$exports.isPlainObject(copy) || (copyIsArray = $fa11d244b809f165$exports.isArray(copy)))) {
                if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && $fa11d244b809f165$exports.isArray(src) ? src : [];
                } else clone = src && $fa11d244b809f165$exports.isPlainObject(src) ? src : {};
                var nextPath = path.slice(0);
                nextPath.push(name);
                // Never move original objects, clone them
                target[name] = $864a32aaa8614b1c$var$deepExtend([
                    clone,
                    copy
                ], collision, nextPath);
            // Don't bring in undefined values
            } else if (copy !== undefined) {
                if (src != null && typeof collision == "function") collision({
                    target: target,
                    copy: options,
                    path: path,
                    key: name
                });
                target[name] = copy;
            }
        }
    }
    return target;
}
$864a32aaa8614b1c$exports = $864a32aaa8614b1c$var$deepExtend;


var $a1c985c713bae1e8$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/**
 * Takes an plain javascript object and will make a flat array of all the leaf nodes.
 * A leaf node in this context has a 'value' property. Potentially refactor this to
 * be more generic.
 * @private
 * @param  {Object} properties - The plain object you want flattened into an array.
 * @param  {Array} [to_ret=[]] - Properties array. This function is recursive therefore this is what gets passed along.
 * @return {Array}
 */ function $a1c985c713bae1e8$var$flattenProperties(properties, to_ret) {
    to_ret = to_ret || [];
    for(var name in properties)if (properties.hasOwnProperty(name)) {
        // TODO: this is a bit fragile and arbitrary to stop when we get to a 'value' property.
        if ($fa11d244b809f165$exports.isPlainObject(properties[name]) && "value" in properties[name]) to_ret.push(properties[name]);
        else if ($fa11d244b809f165$exports.isPlainObject(properties[name])) $a1c985c713bae1e8$var$flattenProperties(properties[name], to_ret);
    }
    return to_ret;
}
$a1c985c713bae1e8$exports = $a1c985c713bae1e8$var$flattenProperties;




function $c7209bc7d1c9de6e$var$r(n, t) {
    void 0 === t && (t = []);
    var o = {};
    if (n.hasOwnProperty("value")) return function(n, t) {
        var o = "--".concat((0, $912df85f858b93ae$export$8658ddf1aae625a3)({
            path: t
        })), e = n.value;
        return {
            name: o,
            path: t,
            value: (0, $912df85f858b93ae$export$55101aa37e5c1f8f)(n),
            original: e,
            toString: function() {
                return "var(".concat(o, ")");
            }
        };
    }(n, t);
    if ("object" == typeof n) for(var e in n)n.hasOwnProperty(e) && ("object" != typeof n[e] ? (console.warn("Non-design token found when creating the theme at path: ".concat(t.join("."), ".").concat(e, "\nDid you forget to add '{value:\"").concat(n[e], "\"}'?")), o[e] = n[e]) : o[e] = $c7209bc7d1c9de6e$var$r(n[e], t.concat(e)));
    return o;
}
function $c7209bc7d1c9de6e$export$25d302a5b900a763(a, c) {
    void 0 === c && (c = (0, $ed14429abad98907$export$164de7ab8df77ef0));
    var i = (0, (/*@__PURE__*/$parcel$interopDefault($864a32aaa8614b1c$exports)))([
        {},
        c,
        a
    ]), m = $c7209bc7d1c9de6e$var$r(i.tokens), l = i.breakpoints, d = i.name, p = '[data-amplify-theme="'.concat(d, '"] {\n') + (0, (/*@__PURE__*/$parcel$interopDefault($a1c985c713bae1e8$exports)))(m).map(function(n) {
        return "".concat(n.name, ": ").concat(n.value, ";");
    }).join("\n") + "\n}\n", s = [];
    return i.overrides && (s = i.overrides.map(function(t) {
        var e = $c7209bc7d1c9de6e$var$r(t.tokens), a = (0, (/*@__PURE__*/$parcel$interopDefault($a1c985c713bae1e8$exports)))(e).map(function(n) {
            return "".concat(n.name, ": ").concat(n.value, ";");
        }).join("\n");
        if ("selector" in t && (p += "\n".concat(t.selector, " {\n").concat(a, "\n}\n")), "mediaQuery" in t && (p += "\n@media (".concat(t.mediaQuery, ') {\n  [data-amplify-theme="').concat(d, '"] {\n    ').concat(a, "\n  }\n}\n")), "breakpoint" in t) {
            var c = i.breakpoints.values[t.breakpoint];
            p += "\n@media (min-width: ".concat(c, 'px) {\n  [data-amplify-theme="').concat(d, '"] {\n    ').concat(a, "\n  }\n}\n");
        }
        return "colorMode" in t && (p += "\n@media (prefers-color-scheme: ".concat(t.colorMode, ') {\n          [data-amplify-theme="').concat(d, '"][data-amplify-color-mode="system"] {\n').concat(a, "\n}\n        }\n"), p += '\n[data-amplify-theme="'.concat(d, '"][data-amplify-color-mode="').concat(t.colorMode, '"] {\n').concat(a, "\n}\n")), (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)((0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, t), {
            tokens: e
        });
    })), {
        tokens: m,
        breakpoints: l,
        name: d,
        cssText: p,
        overrides: s
    };
}



var $acw62 = parcelRequire("acw62");

const $b8381a645f36bb1c$export$1292f175d4b89c7c = $acw62.createContext({
    theme: (0, $c7209bc7d1c9de6e$export$25d302a5b900a763)()
});


const $5c65e7d01e0e6614$export$1a3896b0420de28d = (o)=>void 0 === o || void 0 === o.theme ? (0, $c7209bc7d1c9de6e$export$25d302a5b900a763)() : o.theme, $5c65e7d01e0e6614$export$93d4e7f90805808f = ()=>{
    const t = $acw62.useContext((0, $b8381a645f36bb1c$export$1292f175d4b89c7c));
    return $5c65e7d01e0e6614$export$1a3896b0420de28d(t);
};



const $977c7c783ee37387$export$63d3b2476bc623b7 = (o)=>"auto" === o || "number" == typeof o && !isNaN(o) || "string" == typeof o && !isNaN(parseFloat(o)), $977c7c783ee37387$export$7a05ae144bf7b4de = (o)=>"auto" === o ? "auto" : `span ${o}`, $977c7c783ee37387$export$2289a9e09445ac09 = (o)=>{
    if ($977c7c783ee37387$export$63d3b2476bc623b7(o)) return $977c7c783ee37387$export$7a05ae144bf7b4de(o);
    if (Array.isArray(o)) return o.map((o)=>$977c7c783ee37387$export$7a05ae144bf7b4de(o));
    if ("object" == typeof o && null != o) {
        const n = {};
        return Object.entries(o).forEach(([o, t])=>{
            n[o] = $977c7c783ee37387$export$7a05ae144bf7b4de(t);
        }), n;
    }
    return null;
}, $977c7c783ee37387$export$708ec223603a550 = (t)=>{
    const { rowSpan: r, columnSpan: e, row: i, column: p } = t, s = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "rowSpan",
        "columnSpan",
        "row",
        "column"
    ]), { rowFromSpanValue: l, columnFromSpanValue: c } = $acw62.useMemo(()=>({
            rowFromSpanValue: $977c7c783ee37387$export$2289a9e09445ac09(r),
            columnFromSpanValue: $977c7c783ee37387$export$2289a9e09445ac09(e)
        }), [
        r,
        e
    ]);
    return Object.assign({
        row: (0, $8b520a117f46c559$export$68b32c1946a6b59c)(i) ? l : i,
        column: (0, $8b520a117f46c559$export$68b32c1946a6b59c)(p) ? c : p
    }, s);
}, $977c7c783ee37387$export$2184e8c9a9308f34 = ({ props: o = {}, style: n = {}, breakpoint: e, breakpoints: i })=>{
    const a = {};
    return Object.keys(o).filter((n)=>null != o[n]).forEach((s)=>{
        if (s in (0, $7e2642286866fa4a$export$c69338bc7d797351)) {
            if (!(0, $8b520a117f46c559$export$78d1711480f95c3e)(o[s])) {
                const a = o[s], p = (0, $7e2642286866fa4a$export$c69338bc7d797351)[s];
                n = Object.assign(Object.assign({}, n), {
                    [p]: (0, $d7677b12b9cf9e0a$export$7791b19c8f6fdbca)({
                        values: a,
                        breakpoint: e,
                        breakpoints: i,
                        propKey: s
                    })
                });
            }
        } else a[s] = o[s];
    }), {
        propStyles: n,
        nonStyleProps: a
    };
}, $977c7c783ee37387$export$28e6b9b82ee883c = (o, t)=>{
    const { breakpoints: { values: r, defaultBreakpoint: a } } = (0, $5c65e7d01e0e6614$export$93d4e7f90805808f)(), p = (0, $9d2e8e96809bd95b$export$199d6754bdf4e1e3)({
        breakpoints: r,
        defaultBreakpoint: a
    }), s = $977c7c783ee37387$export$708ec223603a550(o);
    return $acw62.useMemo(()=>$977c7c783ee37387$export$2184e8c9a9308f34({
            props: s,
            style: t,
            breakpoint: p,
            breakpoints: r
        }), [
        s,
        t,
        r,
        p
    ]);
}, $977c7c783ee37387$var$d = {
    alignContent: !0,
    alignItems: !0,
    direction: !0,
    gap: !0,
    justifyContent: !0,
    wrap: !0,
    columnGap: !0,
    rowGap: !0
}, $977c7c783ee37387$var$f = {
    alignSelf: !0,
    area: !0,
    backgroundColor: !0,
    backgroundImage: !0,
    basis: !0,
    border: !0,
    borderRadius: !0,
    bottom: !0,
    boxShadow: !0,
    color: !0,
    column: !0,
    columnEnd: !0,
    columnSpan: !0,
    columnStart: !0,
    display: !0,
    flex: !0,
    fontFamily: !0,
    fontSize: !0,
    fontStyle: !0,
    fontWeight: !0,
    grow: !0,
    height: !0,
    left: !0,
    letterSpacing: !0,
    lineHeight: !0,
    margin: !0,
    marginBlock: !0,
    marginBlockEnd: !0,
    marginBlockStart: !0,
    marginBottom: !0,
    marginInline: !0,
    marginInlineEnd: !0,
    marginInlineStart: !0,
    marginLeft: !0,
    marginRight: !0,
    marginTop: !0,
    maxHeight: !0,
    maxWidth: !0,
    minHeight: !0,
    minWidth: !0,
    opacity: !0,
    order: !0,
    overflow: !0,
    padding: !0,
    paddingBlock: !0,
    paddingBlockEnd: !0,
    paddingBlockStart: !0,
    paddingBottom: !0,
    paddingInline: !0,
    paddingInlineEnd: !0,
    paddingInlineStart: !0,
    paddingLeft: !0,
    paddingRight: !0,
    paddingTop: !0,
    position: !0,
    right: !0,
    row: !0,
    rowEnd: !0,
    rowSpan: !0,
    rowStart: !0,
    shrink: !0,
    textAlign: !0,
    textDecoration: !0,
    textTransform: !0,
    top: !0,
    transform: !0,
    transformOrigin: !0,
    width: !0,
    whiteSpace: !0
}, $977c7c783ee37387$export$584a75f5facb0a5 = (o)=>{
    const n = {
        flexContainerStyleProps: {},
        baseStyleProps: {},
        rest: {}
    };
    return Object.keys(o).forEach((t)=>{
        t in $977c7c783ee37387$var$d ? n.flexContainerStyleProps[t] = o[t] : t in $977c7c783ee37387$var$f ? n.baseStyleProps[t] = o[t] : n.rest[t] = o[t];
    }), n;
};


const $3fb18b5cd10064d6$export$27a5bd065ad55220 = $acw62.forwardRef((a, r)=>{
    var { as: i = "div", children: l, testId: d, ariaLabel: o, isDisabled: n, style: b } = a, m = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(a, [
        "as",
        "children",
        "testId",
        "ariaLabel",
        "isDisabled",
        "style"
    ]);
    const { propStyles: p, nonStyleProps: c } = (0, $977c7c783ee37387$export$28e6b9b82ee883c)(m, b);
    return $acw62.createElement(i, Object.assign({
        "aria-label": o,
        "data-testid": d,
        disabled: n,
        ref: r,
        style: p
    }, c), l);
});
$3fb18b5cd10064d6$export$27a5bd065ad55220.displayName = "View";


const $60f6936f2ef9a054$export$c47c5262afb3a760 = "linear-empty", $60f6936f2ef9a054$export$84e78a619b590ebb = "linear-filled", $60f6936f2ef9a054$export$2dac697651a47d0c = "circular-empty", $60f6936f2ef9a054$export$c6c37ac3a7f79d5a = "circular-filled", $60f6936f2ef9a054$export$a2450a64b7863610 = 8, $60f6936f2ef9a054$export$2d2c9be8b5b863f = 42, $60f6936f2ef9a054$export$d13f13f2833cdb46 = 84 * Math.PI, $60f6936f2ef9a054$export$3b0d6d7590275603 = $acw62.forwardRef((s, n)=>{
    var { className: o, filledColor: c, emptyColor: d, size: m, variation: p, isDeterminate: f = !1, isPercentageTextHidden: x = !1, percentage: g = 0 } = s, u = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(s, [
        "className",
        "filledColor",
        "emptyColor",
        "size",
        "variation",
        "isDeterminate",
        "isPercentageTextHidden",
        "percentage"
    ]);
    g = Math.min(g, 100);
    const v = `${g = Math.max(g, 0)}%`, h = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Loader, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Loader, m), (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Loader, p), f ? (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).LoaderDeterminate : null, o), E = $acw62.createElement("g", null, $acw62.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: String(d)
        },
        "data-testid": "linear-empty"
    }), $acw62.createElement("line", {
        x1: "0",
        x2: f ? v : "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: f && 0 === g ? "none" : c ? String(c) : void 0
        },
        "data-testid": "linear-filled"
    }), f ? $acw62.createElement("text", {
        "aria-live": "polite",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).LoaderPercentageText, x ? (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).VisuallyHidden : null),
        x: `${-1 + g}%`,
        y: "200%"
    }, v) : null), k = $acw62.createElement("g", null, $acw62.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
            stroke: String(d)
        },
        "data-testid": "circular-empty"
    }), $acw62.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
            stroke: String(c),
            strokeDasharray: f ? `${$60f6936f2ef9a054$export$d13f13f2833cdb46}% ${$60f6936f2ef9a054$export$d13f13f2833cdb46}%` : void 0,
            strokeDashoffset: f ? $60f6936f2ef9a054$export$d13f13f2833cdb46 - $60f6936f2ef9a054$export$d13f13f2833cdb46 * g / 100 + "%" : void 0
        },
        "data-testid": "circular-filled"
    }), f ? $acw62.createElement("text", {
        "aria-live": "polite",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).LoaderPercentageText, x ? (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).VisuallyHidden : null),
        x: "130%",
        y: "80%"
    }, v) : null);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "svg",
        className: h,
        "data-size": m,
        "data-variation": p,
        ref: n,
        role: "img"
    }, u), "linear" === p ? E : k);
});
$60f6936f2ef9a054$export$3b0d6d7590275603.displayName = "Loader";




function $0084b72bac862faf$export$2e2bcd8739ae039({ children: children, isPublisherAdmin: isPublisherAdmin, admin: admin }) {
    const session = (0, $99e18646983cd0f4$export$2e2bcd8739ae039)();
    if (!session) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60f6936f2ef9a054$export$3b0d6d7590275603), {
        onPointerEnterCapture: undefined,
        onPointerLeaveCapture: undefined
    });
    if (!session.getAccessToken().payload["cognito:groups"].includes(admin) && !isPublisherAdmin) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75ca8ca6191977d3$export$271f9f08425019c7), {});
    return children;
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $7f14f097c3e15130$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
}), "FileUpload");


var $hAiFn = parcelRequire("hAiFn");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3a5d5a3302e977b8$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14 10H3v2h11zm0-4H3v2h11zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2zM3 16h7v-2H3z"
}), "PlaylistAdd");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $3OJTQ = parcelRequire("3OJTQ");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");
function $239028b4b362607b$export$2e2bcd8739ae039(componentNameInError, Component) {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    const prevPropTypes = Component ? (0, $8nd05.default)({}, Component.propTypes) : null;
    const requireProp = (requiredProp)=>(props, propName, componentName, location, propFullName, ...args)=>{
            const propFullNameSafe = propFullName || propName;
            const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
            if (defaultTypeChecker) {
                const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
                if (typeCheckerResult) return typeCheckerResult;
            }
            if (typeof props[propName] !== "undefined" && !props[requiredProp]) return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
            return null;
        };
    return requireProp;
}


var $2dbb80310490cb08$export$2e2bcd8739ae039 = (0, $239028b4b362607b$export$2e2bcd8739ae039);



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
$e1c9164ec15102c7$var$GridContext.displayName = "GridContext";
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)("MuiGrid", slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $f35b8acab3fc2f62$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $beCSm.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $3OJTQ.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $14H9o.default)();
    const props = (0, $hcz0Q.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $8nd05.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
$9450fbc34cc5b2ea$var$Grid.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The number of columns.
   * @default 12
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ columnSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "column-reverse",
            "column",
            "row-reverse",
            "row"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "column-reverse",
            "column",
            "row-reverse",
            "row"
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ item: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */ lg: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */ md: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ rowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */ sm: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */ wrap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "nowrap",
        "wrap-reverse",
        "wrap"
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */ xl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */ xs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "auto"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */ zeroMinWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
{
    const requireProp = (0, $2dbb80310490cb08$export$2e2bcd8739ae039)("Grid", $9450fbc34cc5b2ea$var$Grid);
    // eslint-disable-next-line no-useless-concat
    $9450fbc34cc5b2ea$var$Grid["propTypes"] = (0, $8nd05.default)({}, $9450fbc34cc5b2ea$var$Grid.propTypes, {
        direction: requireProp("container"),
        lg: requireProp("item"),
        md: requireProp("item"),
        sm: requireProp("item"),
        spacing: requireProp("container"),
        wrap: requireProp("container"),
        xs: requireProp("item"),
        zeroMinWidth: requireProp("item")
    });
}var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;


var $lkxXU = parcelRequire("lkxXU");

var $acw62 = parcelRequire("acw62");




const $d91039711271eba9$var$getQueryParams = (filter = {})=>{
    const { title: title, page: page = 0, limit: limit = (0, $5dc958303e06c3a5$export$dbaa36e254979f6f), skip: skip, type: type = null, sort: sort = {
        created_at: "desc"
    }, date_range: // eslint-disable-next-line @typescript-eslint/naming-convention
    date_range, slug: slug } = filter;
    const query = {
        skip: skip || limit * page,
        limit: limit,
        sort: typeof sort !== "string" ? JSON.stringify(sort) : sort,
        ...type && {
            type: type
        },
        ...title && {
            title: title
        },
        ...slug && {
            slug: slug
        }
    };
    if (date_range) {
        const { from: from, to: to } = date_range;
        query.created_range = JSON.stringify({
            start: from ? from.getTime() : undefined,
            end: to ? new Date(to).setDate(new Date(to).getDate() + 1) : undefined
        });
    }
    return query;
};
function $d91039711271eba9$export$2e2bcd8739ae039(filter) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const fetchPlaylists = (0, $acw62.useCallback)(()=>api && api.Playlist.list($d91039711271eba9$var$getQueryParams(filter || {})), [
        api,
        filter
    ]);
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "playlists",
        filter
    ], ()=>fetchPlaylists(), {
        enabled: didLoad,
        staleTime: Infinity
    });
    const createMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (input)=>api.Playlist.create(input),
        onSuccess: ()=>{
            snackbarSuccess("Playlist Successfully Created");
            queryClient.invalidateQueries({
                queryKey: [
                    "playlists"
                ]
            });
        }
    });
    const createByTagMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (input)=>api.Playlist.createByTag(input),
        onSuccess: ()=>{
            snackbarSuccess("Playlist Successfully Created");
            queryClient.invalidateQueries({
                queryKey: [
                    "playlists"
                ]
            });
        }
    });
    const createByCategoryMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (input)=>api.Playlist.createByCategory(input),
        onSuccess: ()=>{
            snackbarSuccess("Playlist Successfully Created");
            queryClient.invalidateQueries({
                queryKey: [
                    "playlists"
                ]
            });
        }
    });
    const deleteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (token)=>api.Playlist.delete(token),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "playlists"
                ]
            });
        }
    });
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ token: token, data: data })=>api.Playlist.update(token, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "playlists"
                ]
            });
        }
    });
    return {
        query: query,
        playlists: query.data?.playlists || [],
        api: {
            create: createMutation.mutate,
            createByTag: createByTagMutation.mutate,
            createByCategory: createByCategoryMutation.mutate,
            delete: deleteMutation.mutate,
            update: updateMutation.mutate
        },
        mutations: {
            createMutation: createMutation,
            createByCategoryMutation: createByCategoryMutation,
            createByTagMutation: createByTagMutation,
            deleteMutation: deleteMutation,
            updateMutation: updateMutation
        }
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");

var $dqlTG = parcelRequire("dqlTG");

var $1GFtd = parcelRequire("1GFtd");

var $iDAOR = parcelRequire("iDAOR");

var $dgtCa = parcelRequire("dgtCa");

var $AfP12 = parcelRequire("AfP12");

var $kfZjc = parcelRequire("kfZjc");



var $acw62 = parcelRequire("acw62");





function $7f956d50de0acb82$var$getQueryParams({ page: page = 0, limit: limit = (0, $5dc958303e06c3a5$export$9da91b8bed9b77ee), skip: skip, text: text, category: category, group: group, imported_from: imported_from, duration: duration, date_range: date_range, ...params }) {
    const query = {
        count: true,
        ...imported_from && {
            imported_from: imported_from
        },
        ...group && {
            group: group
        },
        skip: skip || limit * page,
        limit: limit,
        ...category && {
            category: category
        },
        sort: JSON.stringify({
            created_at: "desc"
        }),
        ...text && {
            search_text: text
        },
        ...params
    };
    if (duration && typeof duration !== "string") {
        const durationObject = {};
        if (duration.includes(-1)) durationObject.min = 601;
        const maxValue = Math.max(...duration);
        if (maxValue && maxValue !== -1) durationObject.max = maxValue;
        query.duration = Object.keys(durationObject).length !== 0 && durationObject;
    }
    if (date_range) {
        const { from: from, to: to } = date_range;
        query.created_range = JSON.stringify({
            start: from ? from.getTime() : undefined,
            end: to ? new Date(to).setDate(new Date(to).getDate() + 1) : undefined
        });
    }
    return query;
}
function $7f956d50de0acb82$export$2e2bcd8739ae039(query) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const fetchVideos = (0, $acw62.useCallback)((params)=>api.Media.index($7f956d50de0acb82$var$getQueryParams(params)), [
        api
    ]);
    const stableQuery = (0, $acw62.useMemo)(()=>query, [
        JSON.stringify(query)
    ]);
    const videosQuery = (0, $2ae43d8d5d3a2a12$export$bdc59d3c1a6569aa)({
        queryKey: [
            "videos",
            stableQuery
        ],
        queryFn: ({ pageParam: pageParam = 0 })=>fetchVideos({
                page: pageParam,
                ...stableQuery
            }),
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.medias?.length < (stableQuery.limit || (0, $5dc958303e06c3a5$export$9da91b8bed9b77ee))) return undefined;
            return pages.length;
        },
        enabled: didLoad,
        onSuccess: (data)=>{
            data.pages.reduce((videos, page)=>videos.concat(page.medias), []).forEach((video)=>queryClient.setQueryData([
                    "video",
                    video.token
                ], video));
        },
        staleTime: Infinity
    });
    const createMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationKey: `${(0, $1cd70745a1b59d1c$export$9db6462b07c2e33f)}`,
        mutationFn: ({ file: file, data: data, index: index, abortController: abortController, uploadDispatcher: uploadDispatcher, image: image, publisherUsername: publisherUsername, onCreate: onCreate })=>api.createVideo({
                data: {
                    ...data,
                    media_info: {
                        original_file_name: file.name,
                        original_extension: file.name.split(".").pop(),
                        ...data?.media_info
                    },
                    media_type: "video",
                    provider: "cms"
                },
                file: file,
                image: image,
                abortController: abortController,
                publisherUsername: publisherUsername,
                index: index,
                uploadDispatcher: uploadDispatcher,
                onCreate: (d, signedURLs)=>{
                    uploadDispatcher((0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_CREATION_STARTED, {
                        index: index,
                        file: file,
                        title: file.name.split(".")[0]
                    });
                    if (onCreate) onCreate(d, signedURLs);
                },
                onProgress: (token, e)=>{
                    const percentage = e.loaded / e.total * 100;
                    if (typeof uploadDispatcher === "function" && percentage > 0) uploadDispatcher((0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_UPLOAD_PROGRESS, {
                        index: index,
                        progress: percentage
                    });
                }
            }),
        onSuccess: (data)=>{
            queryClient.setQueryData([
                "video",
                data.token
            ], (oldData)=>{
                const videoData = {
                    ...oldData,
                    ...data
                };
                if (!oldData) queryClient.setQueryData([
                    "videos",
                    {}
                ], (videos)=>{
                    if (videos) videos.pages[0].medias.unshift(videoData);
                    return videos;
                });
                return videoData;
            });
        }
    });
    const videos = videosQuery.data?.pages.reduce((arr, page)=>{
        const uniqueTokens = new Set(arr.map((video)=>video.token)); // Set of existing tokens
        page.medias.forEach((newVideo)=>{
            if (!uniqueTokens.has(newVideo.token)) {
                // Add video if token is unique
                uniqueTokens.add(newVideo.token);
                arr.push(newVideo);
            }
        });
        return arr;
    }, []) || [];
    const totalCount = videosQuery.data?.pages[0]?.count || 0;
    return {
        query: videosQuery,
        isFetching: videosQuery.isFetching,
        totalCount: totalCount,
        fetchNextPage: videosQuery.fetchNextPage,
        hasNextPage: videosQuery.hasNextPage,
        videos: videos,
        api: {
            create: createMutation.mutate
        },
        mutations: {
            createMutation: createMutation
        }
    };
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dgtCa = parcelRequire("dgtCa");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5b523f0e341f280c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
}), "GetApp");



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $dac22b55eb23ffcc$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function $dac22b55eb23ffcc$export$8cc09085015f0dc7(file, path) {
    var f = $dac22b55eb23ffcc$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $dac22b55eb23ffcc$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $dac22b55eb23ffcc$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $7ac450b547cb7da9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $7ac450b547cb7da9$export$a36e16046ae8f1bb(evt) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            if ($7ac450b547cb7da9$var$isObject(evt) && $7ac450b547cb7da9$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($7ac450b547cb7da9$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $7ac450b547cb7da9$var$isDataTransfer(value) {
    return $7ac450b547cb7da9$var$isObject(value);
}
function $7ac450b547cb7da9$var$isChangeEvt(value) {
    return $7ac450b547cb7da9$var$isObject(value) && $7ac450b547cb7da9$var$isObject(value.target);
}
function $7ac450b547cb7da9$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $7ac450b547cb7da9$var$getInputFiles(evt) {
    return $7ac450b547cb7da9$var$fromList(evt.target.files).map(function(file) {
        return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $7ac450b547cb7da9$var$getFsHandleFiles(handles) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$getDataTransferFiles(dt, type) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7ac450b547cb7da9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7ac450b547cb7da9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$fromList(dt.files).map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7ac450b547cb7da9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7ac450b547cb7da9$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7ac450b547cb7da9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $7ac450b547cb7da9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7ac450b547cb7da9$var$fromDirEntry(entry);
    return $7ac450b547cb7da9$var$fromDataTransferItem(item);
}
function $7ac450b547cb7da9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(acc), false), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(Array.isArray(files) ? $7ac450b547cb7da9$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $7ac450b547cb7da9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7ac450b547cb7da9$var$fromEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7ac450b547cb7da9$var$fromDirEntry(entry) : $7ac450b547cb7da9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7ac450b547cb7da9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7ac450b547cb7da9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7ac450b547cb7da9$var$fromFileEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
}; // File Errors
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $000a86df99a95c54$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $7ac450b547cb7da9$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $aaac53b849ab07d4$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $aaac53b849ab07d4$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $aaac53b849ab07d4$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}


function $9d1a92e6c90f4f4c$export$2e2bcd8739ae039({ children: children, onDrop: onDrop }) {
    const { getRootProps: getRootProps, getInputProps: getInputProps } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        accept: {
            "video/*": []
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ...getRootProps({
            className: "dropzone"
        }),
        style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "5px",
            height: 130,
            backgroundColor: "#E0E3E7",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                theme: (0, $dgtCa.THEME_ENUM).v2,
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5b523f0e341f280c$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: "10px"
                    }
                }),
                style: {
                    backgroundColor: "transparent"
                },
                text: "Drag & Drop to Upload Video Files",
                type: "file"
            }),
            children
        ]
    });
}


var $72c332637d67474e$export$2e2bcd8739ae039 = (0, $9d1a92e6c90f4f4c$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $216b618b1b33e0d2$exports = {};
!function(t, s) {
    $216b618b1b33e0d2$exports = s();
}($216b618b1b33e0d2$exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});



var $5WoTm = parcelRequire("5WoTm");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8f31d4e5d089305e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], "AccessTime");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8260f72609748c85$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 11H7v2h2zm4 0h-2v2h2zm4 0h-2v2h2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V9h14z"
}), "DateRange");



var $3bYfT = parcelRequire("3bYfT");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $kSnzZ = parcelRequire("kSnzZ");

var $58lXc = parcelRequire("58lXc");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $4Cod0.default)("MuiLinearProgress", slot);
}
const $fd1aab3db3503e90$var$linearProgressClasses = (0, $beCSm.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $fd1aab3db3503e90$export$2e2bcd8739ae039 = $fd1aab3db3503e90$var$linearProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $0fa40ac3f678fedb$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $0fa40ac3f678fedb$var$_ = (t)=>t, $0fa40ac3f678fedb$var$_t, $0fa40ac3f678fedb$var$_t2, $0fa40ac3f678fedb$var$_t3, $0fa40ac3f678fedb$var$_t4, $0fa40ac3f678fedb$var$_t5, $0fa40ac3f678fedb$var$_t6;
const $0fa40ac3f678fedb$var$TRANSITION_DURATION = 4; // seconds
const $0fa40ac3f678fedb$var$indeterminate1Keyframe = (0, $jjlaj.keyframes)($0fa40ac3f678fedb$var$_t || ($0fa40ac3f678fedb$var$_t = $0fa40ac3f678fedb$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $0fa40ac3f678fedb$var$indeterminate2Keyframe = (0, $jjlaj.keyframes)($0fa40ac3f678fedb$var$_t2 || ($0fa40ac3f678fedb$var$_t2 = $0fa40ac3f678fedb$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $0fa40ac3f678fedb$var$bufferKeyframe = (0, $jjlaj.keyframes)($0fa40ac3f678fedb$var$_t3 || ($0fa40ac3f678fedb$var$_t3 = $0fa40ac3f678fedb$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $0fa40ac3f678fedb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $jTnBY.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $jTnBY.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $jTnBY.default)(color)}`,
            variant === "buffer" && `color${(0, $jTnBY.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6), classes);
};
const $0fa40ac3f678fedb$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $kSnzZ.lighten)(theme.palette[color].main, 0.62) : (0, $kSnzZ.darken)(theme.palette[color].main, 0.5);
};
const $0fa40ac3f678fedb$var$LinearProgressRoot = (0, $d8seH.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $0fa40ac3f678fedb$var$LinearProgressDashed = (0, $d8seH.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $0fa40ac3f678fedb$var$getColorShade(theme, ownerState.color);
    return (0, $8nd05.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $jjlaj.css)($0fa40ac3f678fedb$var$_t4 || ($0fa40ac3f678fedb$var$_t4 = $0fa40ac3f678fedb$var$_`
    animation: ${0} 3s infinite linear;
  `), $0fa40ac3f678fedb$var$bufferKeyframe));
const $0fa40ac3f678fedb$var$LinearProgressBar1 = (0, $d8seH.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $jjlaj.css)($0fa40ac3f678fedb$var$_t5 || ($0fa40ac3f678fedb$var$_t5 = $0fa40ac3f678fedb$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $0fa40ac3f678fedb$var$indeterminate1Keyframe));
const $0fa40ac3f678fedb$var$LinearProgressBar2 = (0, $d8seH.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $jjlaj.css)($0fa40ac3f678fedb$var$_t6 || ($0fa40ac3f678fedb$var$_t6 = $0fa40ac3f678fedb$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $0fa40ac3f678fedb$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $0fa40ac3f678fedb$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate" } = props, other = (0, $1En50.default)(props, $0fa40ac3f678fedb$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $0fa40ac3f678fedb$var$useUtilityClasses(ownerState);
    const isRtl = (0, $58lXc.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        } else console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        } else console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0fa40ac3f678fedb$var$LinearProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
$0fa40ac3f678fedb$var$LinearProgress.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "inherit",
            "primary",
            "secondary"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */ valueBuffer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "buffer",
        "determinate",
        "indeterminate",
        "query"
    ])
};
var $0fa40ac3f678fedb$export$2e2bcd8739ae039 = $0fa40ac3f678fedb$var$LinearProgress;



var $1GFtd = parcelRequire("1GFtd");

var $htqGM = parcelRequire("htqGM");



function $d0a01e33b734bdf6$export$2e2bcd8739ae039(video, initialData) {
    const { snackbarError: snackbarError, snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            "video",
            video
        ],
        queryFn: ()=>video && api.Media.get(video).then((data)=>data.media),
        initialData: initialData,
        retry: false,
        staleTime: Infinity,
        keepPreviousData: true,
        enabled: !!video && didLoad,
        onError: (e)=>{
            console.error(e);
            snackbarError("Error while fetching the video");
        }
    });
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>api.Media.update(video, data),
        onSuccess: ({ media: media })=>{
            snackbarSuccess(`Video related information was updated`);
            queryClient.setQueryData([
                "video",
                video
            ], media);
            queryClient.invalidateQueries({
                queryKey: [
                    "videos"
                ]
            });
        },
        onError: (e)=>{
            console.error(e);
            snackbarError("Error while updating the video. Check the console for more information.");
        }
    });
    const deleteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (token)=>api.Media.remove(token),
        onSuccess: ()=>{
            snackbarSuccess(`Video was successfully deleted`);
        },
        onError: (e)=>{
            console.error(e);
            snackbarError("Error while deleting the video. Check the console for more information.");
        }
    });
    const uploadVTT = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data, handleProgress)=>api.Media.uploadSubtitle(video, data, handleProgress),
        onSuccess: ()=>{
            snackbarSuccess("VTT file was successfully uploaded");
        },
        onError: (e)=>{
            console.error(e);
            snackbarError("Error while uploading the VTT file. Check the console for more information.");
        }
    });
    return {
        ...query,
        video: query.data,
        isLoading: query.isLoading || updateMutation.isLoading || deleteMutation.isLoading || uploadVTT.isLoading,
        api: {
            update: updateMutation.mutate,
            delete: deleteMutation.mutate
        },
        mutations: {
            updateMutation: updateMutation,
            deleteMutation: deleteMutation,
            uploadVTT: uploadVTT
        }
    };
}




function $5094343bfed31c54$export$bce5964253ee8249(video) {
    return video && (video.title || video.media_info.original_file_name);
}
function $5094343bfed31c54$export$83796d047265408f(video, videos, isShiftKeyOn, prevSelected) {
    const prevVideo = isShiftKeyOn ? prevSelected || video : video;
    const prevIndex = videos.indexOf(prevVideo);
    const currIndex = videos.indexOf(video);
    const [start, end] = [
        prevIndex,
        currIndex
    ].sort((a, b)=>a - b);
    return videos.filter((item, idx)=>idx >= start && idx <= end).map((i)=>i);
}
const $5094343bfed31c54$export$9960a43c944d4ea4 = (config)=>{
    if (config?.key) return config.key;
    if (config?.type) {
        if (config?.type === "prod" || config?.type === "socan") return "Production Player";
        if (config?.type === "stage" || config?.type === "socan-stage" || config?.type === "socan-staging") return "Staging Player";
    }
    return "Related Content Player";
};
const $5094343bfed31c54$export$bc733b0c5cbb3e8a = (durationInSeconds)=>(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).duration(durationInSeconds, "seconds").format("HH:mm:ss");
const $5094343bfed31c54$export$9667a007680253be = (state)=>state === (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).READY || state === (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).DRAFT;


/* eslint-disable no-promise-executor-return, jsx-a11y/alt-text */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $52988b0bf91e85f8$var$timeoutPromise = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $52988b0bf91e85f8$export$2e2bcd8739ae039({ src: src, retries: retries = 2, delay: delay = 1000, fallbacks: fallbacks, ...props }) {
    const [url, setUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(src);
    const [retryCount, setRetryCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [fallbackIndex, setFallbackIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [fallbackRetryCount, setFallbackRetryCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const handleError = async ()=>{
        await $52988b0bf91e85f8$var$timeoutPromise(delay); // delay of 1 second before retrying
        if (retryCount < retries) {
            setUrl(`${src}?retry=${retryCount}`);
            setRetryCount(retryCount + 1);
        } else if (fallbacks?.length > 0 && fallbackIndex < fallbacks.length) {
            if (typeof fallbacks[fallbackIndex] === "string") {
                setUrl(fallbacks[fallbackIndex]);
                setFallbackIndex(fallbackIndex + 1);
                setFallbackRetryCount(0);
            } else {
                const currFallback = fallbacks[fallbackIndex];
                setUrl(`${currFallback.src}?retry=${fallbackRetryCount}`);
                if (fallbackRetryCount > currFallback.retries) {
                    setFallbackIndex(fallbackIndex + 1);
                    setFallbackRetryCount(0);
                } else setFallbackRetryCount(fallbackRetryCount + 1);
            }
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        ...props,
        src: url,
        onError: handleError,
        draggable: false
    });
}


var $e4354fdf2568cf14$export$2e2bcd8739ae039 = (0, $52988b0bf91e85f8$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $acw62 = parcelRequire("acw62");
const $0fb70c165030e806$export$9ba68b0537e6c120 = /*#__PURE__*/ (0, $acw62.createContext)({
    itemIdKey: "id",
    draggableList: [],
    onDragEnd: (dragIdx, dropIdx)=>{},
    isDraggable: false
});


function $6c8535fa6926b1a4$export$5cc3906c1637d2e({ draggableList: draggableList, children: children, itemIdKey: itemIdKey, onDragEnd: onDragEnd, isDraggable: isDraggable }) {
    /* eslint-disable-next-line react/jsx-no-constructed-context-values */ const value = {
        itemIdKey: itemIdKey,
        draggableList: draggableList.map((i)=>({
                [itemIdKey]: i[itemIdKey]
            })),
        onDragEnd: onDragEnd,
        isDraggable: isDraggable
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fb70c165030e806$export$9ba68b0537e6c120).Provider, {
        value: value,
        children: children
    });
}
const $6c8535fa6926b1a4$export$7941f8aafa4b6021 = ()=>(0, $acw62.useContext)((0, $0fb70c165030e806$export$9ba68b0537e6c120));



function $b1ceb9678267158d$export$de69795869716f53(props) {
    const { id: id, children: children, direction: direction } = props;
    const dragRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const dropRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const [isdropped, setIsDropped] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { draggableList: draggableList, itemIdKey: itemIdKey, onDragEnd: onDragEnd, isDraggable: isDraggable } = (0, $6c8535fa6926b1a4$export$7941f8aafa4b6021)();
    function findDragAndDropIndex(target, dropTarget) {
        const dragIdx = draggableList.findIndex((v)=>v[itemIdKey] === target?.id);
        const dropIdx = draggableList.findIndex((v)=>v[itemIdKey] === dropTarget?.id);
        return {
            dragIdx: dragIdx,
            dropIdx: dropIdx
        };
    }
    function fixDropIndexByMoveDiretion(moveDirection, dropIdx) {
        if (moveDirection) {
            if (dropIdx >= 0) return dropIdx - 1;
            return draggableList.length - 1;
        }
        return dropIdx;
    }
    function moveWithAnimation(target, dropTarget) {
        const moveDirection = !dropTarget || dropTarget.previousElementSibling === target.nextElementSibling;
        let animationTarget;
        if (moveDirection) animationTarget = dropTarget ? dropTarget.previousElementSibling : target.nextElementSibling;
        else animationTarget = target.previousElementSibling;
        if (animationTarget) {
            animationTarget.style.transform = `translate${direction}(${moveDirection ? "-100%" : "100%"})`;
            animationTarget.style.transition = "transform .2s ease-out";
            animationTarget.ontransitionend = ()=>{
                animationTarget.style.transition = "";
                animationTarget.style.transform = "";
                if (target && target.parentNode) {
                    target.parentNode.insertBefore(target, dropTarget);
                    const { dragIdx: dragIdx, dropIdx: dropIdx } = findDragAndDropIndex(target, dropTarget);
                    dragRef.current = dragIdx;
                    dropRef.current = fixDropIndexByMoveDiretion(moveDirection, dropIdx);
                }
            };
        }
    }
    function listItemDragged(e) {
        setIsDropped(false);
        e.target.classList.add("dragging");
        let dropTarget = document.elementFromPoint(e.clientX, e.clientY) === null ? e.target : document.elementFromPoint(e.clientX + 100, e.clientY + 50);
        if (e.target.parentNode === dropTarget.parentNode) {
            dropTarget = dropTarget !== e.target.nextElementSibling ? dropTarget : dropTarget.nextElementSibling;
            if (e.target !== dropTarget) // move target with animation
            moveWithAnimation(e.target, dropTarget);
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (dragRef.current !== dropRef.current && isdropped) {
            onDragEnd(dragRef.current, dropRef.current);
            dragRef.current = 0;
            dropRef.current = 0;
        }
    }, [
        isdropped
    ]);
    function listItemDropped(e) {
        setIsDropped(true);
        e.target.classList.remove("dragging");
        e.preventDefault();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const listItems = document.querySelectorAll(".draggable");
        Array.prototype.map.call(listItems, (option)=>{
            // eslint-disable-next-line @typescript-eslint/no-use-before-define, no-param-reassign
            option.ondrag = listItemDragged;
            // eslint-disable-next-line @typescript-eslint/no-use-before-define, no-param-reassign
            option.ondragend = listItemDropped;
        });
        window.addEventListener("dragover", (e)=>e.preventDefault());
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "draggable",
        id: id,
        draggable: isDraggable,
        children: children
    });
}


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($216b618b1b33e0d2$exports))));
const $c057dee6365134f0$var$useStyles = (0, $1GFtd.default)({
    checkbox: {
        "& .MuiCheckbox-root": {
            padding: 0,
            transform: "translateX(5px)",
            "&:not(.Mui-checked)": {
                color: "#91A0AD"
            }
        },
        "& .MuiCheckbox-root:not(.Mui-checked)": {
            color: "#91A0AD"
        }
    },
    progressbar: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "75%",
        height: "10px",
        borderRadius: "10px",
        backgroundColor: "#E0E3E7",
        "& .MuiLinearProgress-bar": {
            backgroundColor: "#0033FF",
            borderRadius: "10px"
        }
    }
});
function $c057dee6365134f0$var$PlayButton() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB5PSIwcHgiIHg9IjBweCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDQwIDQwIj48Zz48cGF0aCBmaWxsPSJncmF5IiBkPSJtMzcuMyAxMGMtNS41LTkuNi0xNy43LTEyLjgtMjcuMy03LjNzLTEyLjggMTcuNy03LjMgMjcuMyAxNy44IDEyLjggMjcuMyA3LjNjOS42LTUuNSAxMi44LTE3LjcgNy4zLTI3LjN6IiAvPjxwYXRoIGZpbGw9IndoaXRlIiBkPSJtMzcuMyAxMGMtNS41LTkuNi0xNy43LTEyLjgtMjcuMy03LjNzLTEyLjggMTcuNy03LjMgMjcuMyAxNy44IDEyLjggMjcuMyA3LjNjOS42LTUuNSAxMi44LTE3LjcgNy4zLTI3LjN6bS05LjMgMjMuOWMtNy43IDQuNC0xNy40IDEuOC0yMS45LTUuOS00LjQtNy42LTEuNy0xNy40IDUuOS0yMS45IDcuNy00LjQgMTcuNC0xLjggMjEuOSA1LjkgNC40IDcuNyAxLjggMTcuNC01LjkgMjEuOXptLTAuOC0xNC43bC0xMC41LTYuMWMtMS4yLTAuNC0xLjQtMC4yLTEuNyAxbDAuMSAxMi4xYzAuMiAxLjIgMC42IDEuNCAxLjcgMWwxMC40LTZjMC45LTAuNyAwLjktMS4zIDAtMnoiLz48L2c+PC9zdmc+Cg==",
        alt: "overlay",
        style: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "25px",
            height: "25px",
            opacity: 0.7
        }
    });
}
function $c057dee6365134f0$var$StateOverlay({ icon: icon, text: text }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        style: {
            alignItems: "center",
            color: "white",
            gap: "15px",
            display: "flex",
            fontSize: "14px",
            fontWeight: 500,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        },
        children: [
            icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: text
            })
        ]
    });
}
function $c057dee6365134f0$export$b90189b6ff51fe46({ video: videoProp, isChecked: isChecked, isSelectable: isSelectable, onClick: onClick, onToggle: onToggle, isNumbered: isNumbered, index: index }) {
    const classes = $c057dee6365134f0$var$useStyles();
    const { video: video } = (0, $d0a01e33b734bdf6$export$2e2bcd8739ae039)(videoProp.token);
    if (!video) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const { created_at: date, default_stream: defStream, original_stream: origStream, ...videoData } = video;
    const imageUrl = video.local?.image_url || defStream && defStream.image_url || origStream && origStream.image_url;
    const duration = video.local?.duration || video.media_info?.duration || video.default_stream?.media_info?.duration;
    const formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(date).format("MM-DD-YY");
    const formattedDuration = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).duration(duration, "seconds").format((()=>"HH:mm:ss")());
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b1ceb9678267158d$export$de69795869716f53), {
        id: video.token,
        direction: "X",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                width: "150px",
                cursor: "pointer"
            },
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    style: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        isNumbered && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            sx: {
                                fontSize: "14px",
                                fontWeight: 500,
                                textAlign: "right",
                                paddingRight: "5px"
                            },
                            children: index + 1
                        }),
                        isSelectable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                            className: classes.checkbox,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                            isChecked: isChecked,
                            onToggle: onToggle
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        position: "relative",
                        marginBottom: "5px",
                        aspectRatio: "16/9",
                        background: video.state === "ready" || video.state === "processing" && video.local ? "none" : "black"
                    },
                    children: [
                        [
                            "failed"
                        ].includes(video.state) && /*#__PURE__*/ (0, $ayMG0.jsx)($c057dee6365134f0$var$StateOverlay, {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35c8e43691ef923a$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: "24px"
                                },
                                color: "error"
                            }),
                            text: "Failed"
                        }),
                        (video.state === "ready" || video.state === "processing" && video.local) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4354fdf2568cf14$export$2e2bcd8739ae039), {
                            alt: "video thumbnail",
                            width: "100%",
                            style: {
                                aspectRatio: "16/9",
                                background: "black",
                                objectFit: "contain",
                                opacity: video.state === "uploading" ? 0.4 : 1
                            },
                            src: imageUrl,
                            fallbacks: [
                                videoData.hls_stream?.image_url,
                                origStream?.image_url
                            ].filter(Boolean)
                        }),
                        [
                            "empty",
                            "uploaded",
                            "processing"
                        ].includes(video.state) && /*#__PURE__*/ (0, $ayMG0.jsx)($c057dee6365134f0$var$StateOverlay, {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WoTm.default), {
                                color: "warning",
                                style: {
                                    fontSize: "24px"
                                }
                            }),
                            text: "Pending"
                        }),
                        (![
                            "uploading",
                            "empty",
                            "failed"
                        ].includes(video.state) || video.state === "processing") && video.local && /*#__PURE__*/ (0, $ayMG0.jsx)($c057dee6365134f0$var$PlayButton, {}),
                        video.state === "uploading" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fa40ac3f678fedb$export$2e2bcd8739ae039), {
                            variant: "determinate",
                            className: classes.progressbar,
                            value: video.percentage_uploaded
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    style: {
                        fontWeight: 500,
                        fontSize: "12px",
                        paddingLeft: "7px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflowX: "clip"
                    },
                    children: (0, $5094343bfed31c54$export$bce5964253ee8249)(video)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        paddingLeft: "7px",
                        paddingTop: "5px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f31d4e5d089305e$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontSize: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    sx: {
                                        fontSize: "10px"
                                    },
                                    children: formattedDuration
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8260f72609748c85$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontSize: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    sx: {
                                        fontSize: "10px"
                                    },
                                    children: formattedDate
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, video.token);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");

var $1GFtd = parcelRequire("1GFtd");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $fa96d0164203a553$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");


var $hAiFn = parcelRequire("hAiFn");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bae8d0b4be16a32a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), "Download");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $feca65910bf0cf12$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");



var $iDAOR = parcelRequire("iDAOR");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $55ofq = parcelRequire("55ofq");

var $1GFtd = parcelRequire("1GFtd");
const $6606e5f4ea82c065$var$useStyles = (0, $1GFtd.default)({
    menu: {
        zIndex: 1301,
        border: 0,
        color: "black"
    },
    button: {
        color: "black",
        "& svg": {
            fontSize: "20px"
        }
    },
    paper: {
        border: 0
    },
    popper: {
        zIndex: 1301
    }
});
function $6606e5f4ea82c065$export$2e2bcd8739ae039({ menuItems: menuItems }) {
    const classes = $6606e5f4ea82c065$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($55ofq))), {
        classNames: {
            button: classes.button,
            menuList: classes.menu,
            paper: classes.paper,
            popper: classes.popper
        },
        menuItems: menuItems,
        buttonVariant: (0, (/*@__PURE__*/$parcel$interopDefault($55ofq))).BUTTON_VARIANT_ENUM.icon
    });
}


var $32969727be711a87$export$2e2bcd8739ae039 = (0, $6606e5f4ea82c065$export$2e2bcd8739ae039);



/* eslint-disable @typescript-eslint/lines-between-class-members */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


function $c2e19e4137e450c8$export$f503bc85d719e8b0({ aspectratio: aspectratio, width: width, video: video, ...props }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const [player, setPlayer] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const initPlayer = ()=>{
        if (!window.KargoVideo) return;
        const p = new window.KargoVideo.Player({
            element: ref.current,
            attrs: {
                aspectratio: aspectratio || "1270/720",
                width: width || "100%",
                staging: (0, $2b131d1f0fe5ee8b$export$a739cd5aac835909),
                video: video,
                autoplay: false,
                autoplaywhenvisible: false,
                irisplaylist: false,
                showsidebargallery: false,
                ...props
            }
        });
        p.once("playing", ()=>(0, $db434a401f2c9abc$export$2e2bcd8739ae039).track("Video Played", {
                video: video
            }));
        p.activate();
        setPlayer(p);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!player || !video) return;
        if (!player.destroyed()) player.destroy();
        initPlayer();
    }, [
        video
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!window.KargoVideo) {
            const loadScript = new Promise((resolve, reject)=>{
                const script = document.createElement("script");
                script.src = "https://static.kargovideo.com/player/latest/kargo.js";
                script.onload = resolve;
                script.onerror = reject;
                document.getElementsByTagName("head")[0].append(script);
            });
            const loadStyles = new Promise((resolve, reject)=>{
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.type = "text/css";
                link.href = "https://static.kargovideo.com/player/latest/kargo.css";
                link.onload = resolve;
                link.onerror = reject;
                document.getElementsByTagName("head")[0].append(link);
            });
            Promise.all([
                loadScript,
                loadStyles
            ]).then(()=>initPlayer());
        } else initPlayer();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        style: {
            aspectRatio: aspectratio || "1270/720",
            width: width || "100%"
        }
    });
}




/* eslint-disable react/prop-types */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");

/* eslint-disable-next-line arrow-body-style */ const $d3e7c2fde86b1eea$var$useTrackedClick = (id, onClick)=>{
    return (...args)=>{
        (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track_button_click(id);
        if (onClick) onClick(...args);
    };
};
var $d3e7c2fde86b1eea$export$2e2bcd8739ae039 = $d3e7c2fde86b1eea$var$useTrackedClick;


function $3916480840c73ed0$export$2e2bcd8739ae039({ id: id, onClick: onClick, ...props }) {
    const trackedOnClick = (0, $d3e7c2fde86b1eea$export$2e2bcd8739ae039)(id, onClick);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
        id: id,
        ...props,
        onClick: trackedOnClick
    });
}


const $cbe3be3a7f8b144a$var$useStyles = (0, $1GFtd.default)({
    modal: {
        "& .MuiDialog-container .MuiDialog-paper": {
            borderRadius: "10px",
            padding: 0,
            width: "531px",
            "& .MuiDialogActions-root": {
                padding: "10px",
                "& svg": {
                    fontSize: "20px",
                    color: "#303237"
                }
            }
        }
    },
    inner: {
        display: "flex",
        alignItems: "center",
        height: "100% !important"
    },
    title: {
        fontSize: "18px",
        fontWeight: 500,
        lineHeight: "27px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "402px"
    },
    arrow: {
        padding: 0,
        "& svg": {
            color: "black",
            fontSize: "50px"
        }
    }
});
function $cbe3be3a7f8b144a$var$Inner({ video: token, onNavigateNext: onNavigateNext, onNavigatePrev: onNavigatePrev }) {
    const { snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const { video: video, api: api } = (0, $d0a01e33b734bdf6$export$2e2bcd8739ae039)(token);
    const classes = $cbe3be3a7f8b144a$var$useStyles();
    const [isEditingTitle, setIsEditingTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [title, setTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(video?.title);
    const handleEditFinished = ()=>{
        if (title !== video?.title) api.update({
            title: title
        });
        setIsEditingTitle(false);
    };
    const handleEditCanceled = ()=>{
        setTitle(video?.title);
        setIsEditingTitle(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: classes.inner,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3916480840c73ed0$export$2e2bcd8739ae039), {
                id: "navigate-to-prev-video",
                className: classes.arrow,
                onClick: onNavigatePrev,
                disableRipple: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa96d0164203a553$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "100%",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        sx: {
                            padding: "10px 0"
                        },
                        children: [
                            isEditingTitle ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                                style: {
                                    height: "auto"
                                },
                                isFullWidth: true,
                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                                label: "Video Title",
                                text: title,
                                debounceTime: 0,
                                onDebounceEnd: setTitle,
                                onTextChange: setTitle,
                                onBlur: async ()=>handleEditFinished(),
                                onKeyDown: ({ key: key })=>{
                                    if (key === "Enter") handleEditFinished();
                                    else if (key === "Escape") handleEditCanceled();
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                className: classes.title,
                                children: (0, $5094343bfed31c54$export$bce5964253ee8249)(video)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32969727be711a87$export$2e2bcd8739ae039), {
                                menuItems: [
                                    {
                                        name: "Edit",
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {}),
                                        isEnabled: true,
                                        onClick: ()=>{
                                            setTitle(video?.title);
                                            setIsEditingTitle(true);
                                        }
                                    },
                                    {
                                        name: "Download",
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {}),
                                        isEnabled: true,
                                        onClick: ()=>{
                                            if (!video?.default_stream?.url) {
                                                snackbarError("Video not available for download yet.");
                                                return;
                                            }
                                            window.open(`${video.default_stream.url}?download=true`, "_self");
                                        }
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2e19e4137e450c8$export$f503bc85d719e8b0), {
                        video: token
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3916480840c73ed0$export$2e2bcd8739ae039), {
                id: "navigate-to-next-video",
                className: classes.arrow,
                onClick: onNavigateNext,
                disableRipple: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $feca65910bf0cf12$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
function $cbe3be3a7f8b144a$export$2e2bcd8739ae039({ video: video, isOpen: isOpen, onClose: onClose, onNavigateNext: onNavigateNext, onNavigatePrev: onNavigatePrev }) {
    const classes = $cbe3be3a7f8b144a$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))), {
        className: classes.modal,
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).THEME_ENUM.v2,
        isOpen: isOpen,
        onClose: onClose,
        inputContainer: /*#__PURE__*/ (0, $ayMG0.jsx)($cbe3be3a7f8b144a$var$Inner, {
            video: video,
            onNavigateNext: onNavigateNext,
            onNavigatePrev: onNavigatePrev
        })
    });
}


/* eslint-disable react/prop-types */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dgtCa = parcelRequire("dgtCa");

function $28133ee1914bc066$export$2e2bcd8739ae039({ id: id, onClick: onClick, ...props }) {
    const trackedOnClick = (0, $d3e7c2fde86b1eea$export$2e2bcd8739ae039)(id, onClick);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
        id: id,
        theme: (0, $dgtCa.THEME_ENUM).v2,
        ...props,
        onClick: trackedOnClick
    });
}


function $bcdc194fb17ffd2c$export$2e2bcd8739ae039(input) {
    const regex = /\((\d+)\)$/; // regex to extract the number on a string with format "something (2)"
    const match = input.match(regex);
    return match ? input.replace(regex, `(${parseInt(match[1], 10) + 1})`) : `${input} (1)`;
}



const $9e4e4f1e24f1be78$var$useStyles = (0, $1GFtd.default)(()=>({
        textButton: {
            textTransform: "none",
            textDecoration: "underline"
        }
    }));
function $9e4e4f1e24f1be78$export$2e2bcd8739ae039({ onClose: onClose, onSubmit: onSubmit, username: username, publisherGroup: publisherGroup }) {
    const classes = $9e4e4f1e24f1be78$var$useStyles();
    const history = (0, $kfZjc.useHistory)();
    const { snackbarSuccess: snackbarSuccess, snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [title, setTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const { playlists: playlists } = (0, $d91039711271eba9$export$2e2bcd8739ae039)({});
    const [playlist, setPlaylist] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        medias: []
    });
    const [modalVideoIndex, setModalVideoIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(-1);
    const [playlistCreateError, setPlaylistCreateError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const defaultCreateError = "Playlist title can't be empty";
    const modalVideo = playlist.medias[modalVideoIndex];
    const totalVideos = playlist.medias.length;
    const { api: api } = (0, $d91039711271eba9$export$2e2bcd8739ae039)();
    const { api: videosAPI } = (0, $7f956d50de0acb82$export$2e2bcd8739ae039)({});
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const placeholderTitle = $9e4e4f1e24f1be78$var$getPlaceholderTitle(playlists || [], "New Playlist");
    const onDrop = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((acceptedFiles)=>{
        const processedFiles = [];
        const uploadedVideos = [];
        acceptedFiles.forEach((file)=>{
            if (processedFiles.includes(file)) return;
            processedFiles.push(file);
            videosAPI.create({
                file: file,
                ...publisherGroup && {
                    publisherUsername: publisherGroup
                },
                onCreate: ({ token: token })=>{
                    uploadedVideos.push(token);
                    setPlaylist({
                        ...playlist,
                        medias: uploadedVideos
                    });
                }
            }, {
                onSuccess: ()=>{
                    if (processedFiles.length === acceptedFiles.length) snackbarSuccess(`Video${acceptedFiles.length > 1 ? "s" : ""} Added to Playlist`);
                }
            });
        });
    }, [
        publisherGroup
    ]);
    const handleSubmit = ()=>{
        if (!title || title?.trim() === "") {
            setPlaylistCreateError(defaultCreateError);
            snackbarError(defaultCreateError);
            return;
        }
        setPlaylistCreateError("");
        api.create({
            ...playlist,
            username: username,
            title: title
        });
        onSubmit({
            ...playlist,
            title: title
        });
    };
    const handleClose = ()=>{
        setPlaylist({});
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid black",
                    padding: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            justifyContent: "center",
                            padding: "21px 10px 10px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                            style: {
                                height: "auto"
                            },
                            errorMessage: playlistCreateError,
                            label: placeholderTitle,
                            text: title,
                            onDebounceEnd: setTitle,
                            onTextChange: setTitle,
                            debounceTime: 0
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                                id: "save-new-playlist",
                                text: "Save Playlist",
                                variant: (0, $dgtCa.VARIANT_ENUM).contained,
                                size: (0, $dgtCa.SIZE_ENUM).small,
                                onClick: handleSubmit
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                    tooltip: "Cancel playlist creation",
                                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                                        sx: {
                                            color: "#303237",
                                            fontSize: "20px"
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    padding: "13px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe3be3a7f8b144a$export$2e2bcd8739ae039), {
                        video: modalVideo,
                        isOpen: modalVideoIndex > -1,
                        onClose: ()=>setModalVideoIndex(-1),
                        onNavigatePrev: ()=>setModalVideoIndex((modalVideoIndex - 1 + totalVideos) % totalVideos),
                        onNavigateNext: ()=>setModalVideoIndex((modalVideoIndex + 1) % totalVideos)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        children: playlist.medias.map((token, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c057dee6365134f0$export$b90189b6ff51fe46), {
                                    video: {
                                        token: token
                                    },
                                    onClick: ()=>setModalVideoIndex(i)
                                })
                            }, token))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72c332637d67474e$export$2e2bcd8739ae039), {
                        onDrop: onDrop,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                            theme: (0, $dgtCa.THEME_ENUM).v2,
                            variant: (0, $dgtCa.VARIANT_ENUM).text,
                            textContainerClassName: classes.textButton,
                            onClick: (e)=>{
                                e.stopPropagation();
                                if (!title || title?.trim() === "") setTitle(placeholderTitle);
                                api.create({
                                    ...playlist,
                                    title: title || placeholderTitle
                                });
                                onClose();
                                history.push(`${(0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY}?tab=0`);
                            },
                            text: "or browse My Library"
                        })
                    })
                ]
            })
        ]
    });
}
function $9e4e4f1e24f1be78$var$getPlaceholderTitle(list, placeholder) {
    let pTitle = placeholder;
    list.forEach((item)=>{
        if (item.title?.includes(placeholder)) pTitle = item.title;
    });
    return (0, $bcdc194fb17ffd2c$export$2e2bcd8739ae039)(pTitle);
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1GFtd = parcelRequire("1GFtd");


var $iDAOR = parcelRequire("iDAOR");
const $dd7bdcb34095997c$var$useStyles = (0, $1GFtd.default)({
    search: (props)=>({
            ...!props.isFullWidth && {
                width: "360px"
            },
            height: "auto",
            "& .MuiInputBase-root": {
                height: "37px"
            },
            "& input": {
                fontSize: "14px"
            }
        })
});
function $dd7bdcb34095997c$export$2e2bcd8739ae039({ isFullWidth: isFullWidth, onDebounceEnd: onDebounceEnd, onTextChange: onTextChange, debounceTime: debounceTime, placeholder: placeholder, style: style, text: text = "" }) {
    const classes = $dd7bdcb34095997c$var$useStyles({
        isFullWidth: isFullWidth
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
        className: classes.search,
        isFullWidth: isFullWidth,
        text: text,
        onTextChange: onTextChange,
        onDebounceEnd: onDebounceEnd,
        placeholder: placeholder,
        debounceTime: debounceTime,
        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {}),
        style: style,
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2
    });
}


var $db95cc6529792278$export$2e2bcd8739ae039 = (0, $dd7bdcb34095997c$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1GFtd = parcelRequire("1GFtd");
var $0e79d138fe402d8e$exports = {};
"use strict";
var $0e79d138fe402d8e$var$__importDefault = $0e79d138fe402d8e$exports && $0e79d138fe402d8e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0e79d138fe402d8e$exports, "__esModule", {
    value: true
});
$0e79d138fe402d8e$exports.VARIANT_ENUM = void 0;

const $0e79d138fe402d8e$var$krg_date_picker_react_1 = $0e79d138fe402d8e$var$__importDefault((parcelRequire("guTE0")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($0e79d138fe402d8e$exports, "VARIANT_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.INPUT_VARIANT_ENUM;
    }
});
$0e79d138fe402d8e$exports.default = $0e79d138fe402d8e$var$krg_date_picker_react_1.default;


const $2f195e6d38f66fca$var$useStyles = (0, $1GFtd.default)({
    readOnlyDatePicker: {
        "& input": {
            pointerEvents: "none !important",
            cursor: "default !important",
            backgroundColor: "transparent !important",
            caretColor: "transparent !important"
        },
        "& .MuiInputAdornment-root": {
            pointerEvents: "all !important"
        },
        "& .MuiInputBase-root": {
            cursor: "default !important"
        },
        "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.23) !important"
        }
    }
});
function $2f195e6d38f66fca$export$5109c6dd95d8fb00({ isEnabled: isEnabled, value: value, onDateRangeChange: onDateRangeChange, onDateClear: onDateClear, onClick: onClick }) {
    const classes = $2f195e6d38f66fca$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0e79d138fe402d8e$exports))), {
        dateRange: value,
        classNames: {
            input: classes.readOnlyDatePicker
        },
        inputVariant: (0, (/*@__PURE__*/$parcel$interopDefault($0e79d138fe402d8e$exports))).VARIANT_ENUM.outlined,
        placeholder: "Select date range",
        isRange: true,
        isEnabled: isEnabled,
        onDateRangeChange: onDateRangeChange,
        onDateClear: onDateClear,
        onClick: onClick
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/* eslint-disable react/prop-types */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1GFtd = parcelRequire("1GFtd");
var $e9acd06419247d87$exports = {};
"use strict";
var $e9acd06419247d87$var$__importDefault = $e9acd06419247d87$exports && $e9acd06419247d87$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e9acd06419247d87$exports, "__esModule", {
    value: true
});
$e9acd06419247d87$exports.CHIP_TYPE_ENUM = $e9acd06419247d87$exports.VARIANT_ENUM = $e9acd06419247d87$exports.THEME_ENUM = void 0;

const $e9acd06419247d87$var$krg_autocomplete_react_1 = $e9acd06419247d87$var$__importDefault((parcelRequire("8xCb1")));

var $cWFSm = parcelRequire("cWFSm");
Object.defineProperty($e9acd06419247d87$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $cWFSm.THEME_ENUM;
    }
});
Object.defineProperty($e9acd06419247d87$exports, "VARIANT_ENUM", {
    enumerable: true,
    get: function() {
        return $cWFSm.INPUT_VARIANT_ENUM;
    }
});

var $hIemg = parcelRequire("hIemg");
Object.defineProperty($e9acd06419247d87$exports, "CHIP_TYPE_ENUM", {
    enumerable: true,
    get: function() {
        return $hIemg.TYPE_ENUM;
    }
});
$e9acd06419247d87$exports.default = $e9acd06419247d87$var$krg_autocomplete_react_1.default;


const $120fe10e9e623c5d$var$useStyles = (0, $1GFtd.default)({
    autocomplete: {
        minHeight: "37px",
        "& .MuiTextField-root": {
            minWidth: "260px",
            maxWidth: "320px",
            height: "37px"
        },
        "& span.MuiAutocomplete-tag": {
            fontSize: "small"
        }
    }
});
function $120fe10e9e623c5d$export$2e2bcd8739ae039({ isEnabled: isEnabled, className: className, options: options, onChange: onChange, isMultiple: isMultiple = true, value: value, theme: theme, size: size = "small", hasCheckbox: hasCheckbox = true, chipType: chipType, ...props }) {
    const classes = $120fe10e9e623c5d$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9acd06419247d87$exports))), {
        className: className || classes.autocomplete,
        theme: theme || (0, (/*@__PURE__*/$parcel$interopDefault($e9acd06419247d87$exports))).THEME_ENUM.v2,
        isMultiple: isMultiple,
        isEnabled: isEnabled,
        disableCloseOnSelect: true,
        limitTags: 2,
        size: size,
        options: options,
        getOptionLabel: (option)=>option?.name,
        value: value,
        onChange: (e, newValue)=>onChange(newValue),
        getChipData: (option)=>({
                text: option.name,
                id: option.id
            }),
        chipType: chipType || (0, $e9acd06419247d87$exports.CHIP_TYPE_ENUM).gray,
        hasCheckbox: hasCheckbox,
        ...props
    });
}



function $bb471419d711cdd8$export$2e2bcd8739ae039({ isEnabled: isEnabled = true, value: value = [], onChange: onChange }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $120fe10e9e623c5d$export$2e2bcd8739ae039), {
        id: "playlist-type-select",
        isEnabled: isEnabled,
        label: "Type",
        placeholder: "Add",
        value: value,
        onChange: onChange,
        options: (0, $5dc958303e06c3a5$export$9c5f6903d23b4822)
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $d803cf99079fa048$export$2e2bcd8739ae039({ height: height }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: "100%",
            height: height || "calc(100vh - 259px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $kfZjc = parcelRequire("kfZjc");

var $kfZjc = parcelRequire("kfZjc");

var $4353bd6a5a30fa9b$exports = {};
"use strict";
var $4353bd6a5a30fa9b$var$__createBinding = $4353bd6a5a30fa9b$exports && $4353bd6a5a30fa9b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4353bd6a5a30fa9b$var$__exportStar = $4353bd6a5a30fa9b$exports && $4353bd6a5a30fa9b$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4353bd6a5a30fa9b$var$__createBinding(exports1, m, p);
};
var $4353bd6a5a30fa9b$var$__importDefault = $4353bd6a5a30fa9b$exports && $4353bd6a5a30fa9b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4353bd6a5a30fa9b$exports, "__esModule", {
    value: true
});
$4353bd6a5a30fa9b$exports.THEME_ENUM = void 0;

const $4353bd6a5a30fa9b$var$krg_data_table_react_1 = $4353bd6a5a30fa9b$var$__importDefault((parcelRequire("6JYdB")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($4353bd6a5a30fa9b$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$4353bd6a5a30fa9b$var$__exportStar((parcelRequire("4Pqbs")), $4353bd6a5a30fa9b$exports);

$4353bd6a5a30fa9b$var$__exportStar((parcelRequire("e1Hcy")), $4353bd6a5a30fa9b$exports);

$4353bd6a5a30fa9b$var$__exportStar((parcelRequire("bp629")), $4353bd6a5a30fa9b$exports);
$4353bd6a5a30fa9b$exports.default = $4353bd6a5a30fa9b$var$krg_data_table_react_1.default;



var $1GFtd = parcelRequire("1GFtd");


var $htqGM = parcelRequire("htqGM");




function $44b65fd3e61b6901$export$c86a5b4c0781d3(inputString, separator = " ") {
    if (!inputString) return "";
    return inputString.trim() // remove leading or trailing spaces
    .split(separator).filter((str)=>str) // remove empty strings
    .map((str)=>str.charAt(0).toUpperCase() + str.substring(1)).join(" ");
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $hAiFn = parcelRequire("hAiFn");
var $gqvXj = parcelRequire("gqvXj");
var $8YLZH = parcelRequire("8YLZH");

const $a9a3f0ceeef4cf54$var$iconStyle = {
    ml: "10px",
    "&:hover": {
        cursor: "pointer",
        color: "#03f"
    }
};
const $a9a3f0ceeef4cf54$var$disabledStyle = {
    color: "rgba(0, 0, 0, 0.26)",
    cursor: "not-allowed",
    pointerEvents: "none",
    ...$a9a3f0ceeef4cf54$var$iconStyle
};
function $a9a3f0ceeef4cf54$export$2e2bcd8739ae039({ playlist: playlist, onActionClick: onActionClick, onEditActionClick: onEditActionClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {
                sx: {
                    ...$a9a3f0ceeef4cf54$var$iconStyle,
                    ml: "0px"
                },
                onClick: ()=>onEditActionClick(playlist.token)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gqvXj.default), {
                sx: (0, $5dc958303e06c3a5$export$fe55f658fe3636f4) ? $a9a3f0ceeef4cf54$var$iconStyle : $a9a3f0ceeef4cf54$var$disabledStyle,
                onClick: ()=>onActionClick("copy", playlist)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {
                sx: $a9a3f0ceeef4cf54$var$iconStyle,
                onClick: ()=>onActionClick("delete", playlist)
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $48733ae2ee9b2cdf$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, button: button, type: type = (0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).TYPE_ENUM.success, autoHideDuration: autoHideDuration = 6000, message: message }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fbb25d8420b2bfb5$export$2e2bcd8739ae039), {
        autoHideDuration: autoHideDuration,
        type: type,
        isOpen: isOpen,
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($5e01f9464c1d6970$exports))).THEME_ENUM.v2,
        onClose: onClose,
        button: button,
        text: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                fontSize: "14px"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: message
            })
        })
    });
}



// hooks/useSortingWithURL.ts

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
function $887b2da4e8f087cf$export$a0fcfb0562217ff7() {
    const headerRef = (0, $acw62.useRef)(null);
    const location = (0, $kfZjc.useLocation)();
    const history = (0, $kfZjc.useHistory)();
    // Handle sorting changes and update URL
    const handleSortChange = (0, $acw62.useCallback)((order, field)=>{
        const searchParams = new URLSearchParams(location.search);
        if (order && field) {
            searchParams.set("sortOrder", order.toString());
            searchParams.set("sortField", field);
        } else {
            searchParams.delete("sortOrder");
            searchParams.delete("sortField");
        }
        history.push({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    }, [
        history,
        location
    ]);
    // Load sorting from URL on mount and when URL changes
    (0, $acw62.useEffect)(()=>{
        const params = new URLSearchParams(location.search);
        const sortOrder = params.get("sortOrder");
        const sortField = params.get("sortField");
        if (sortOrder && sortField && headerRef.current) headerRef.current.setOrder(sortOrder, sortField);
    }, [
        location.search
    ]);
    return {
        headerRef: headerRef,
        handleSortChange: handleSortChange
    };
}


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($216b618b1b33e0d2$exports))));
const $6cdec3f5ba465419$var$useStyles = (0, $1GFtd.default)({
    table: {
        "& thead th": {
            background: "transparent",
            color: "black",
            fontSize: "11px",
            fontWeight: 600
        },
        "& tbody": {
            borderTop: "2px solid black",
            borderBottom: "2px solid black",
            "& tr:hover": {
                background: "#EEF3F7"
            }
        }
    }
});
function $6cdec3f5ba465419$export$2e2bcd8739ae039({ playlists: playlists, selectedPlaylists: selectedPlaylists = [], onPlaylistToggle: onPlaylistToggle, onToggleAll: onToggleAll }) {
    const history = (0, $kfZjc.useHistory)();
    const classes = $6cdec3f5ba465419$var$useStyles();
    const { api: api } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const { headerRef: headerRef, handleSortChange: handleSortChange } = (0, $887b2da4e8f087cf$export$a0fcfb0562217ff7)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const [actionState, setActionState] = (0, $acw62.useState)({
        isOpen: false,
        type: "delete",
        playlist: null
    });
    const [snackbarState, setSnackbarState] = (0, $acw62.useState)({
        type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
        isOpen: false,
        message: ""
    });
    const isAllChecked = (0, $acw62.useMemo)(()=>{
        const selectedPlaylistsSet = new Set(selectedPlaylists);
        return selectedPlaylistsSet.size > 0 && playlists.every((playlist)=>selectedPlaylistsSet.has(playlist.token));
    }, [
        playlists,
        selectedPlaylists
    ]);
    const handleActionClick = (type, playlist)=>{
        setActionState({
            isOpen: true,
            type: type,
            playlist: playlist
        });
    };
    const handleCloseSnackbar = ()=>{
        setSnackbarState({
            ...snackbarState,
            isOpen: false
        });
    };
    const handleConfirmAction = (0, $acw62.useCallback)(async ()=>{
        if (actionState.playlist) try {
            if (actionState.type === "delete") await api.Playlist.delete(actionState.playlist.token);
            await queryClient.invalidateQueries([
                "playlists"
            ]);
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
                isOpen: true,
                message: `Successfully ${actionState.type === "delete" ? "deleted" : "copied"} playlist`
            });
        } catch (error) {
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
                isOpen: true,
                message: `Failed to ${actionState.type} playlist`
            });
            console.error(`Failed to ${actionState.type} playlist:`, error);
        } finally{
            setActionState({
                isOpen: false,
                type: actionState.type,
                playlist: null
            });
        }
    }, [
        actionState
    ]);
    const navigateToSinglePlaylist = (token)=>history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).SINGLE_PLAYLIST_EDIT_PAGE, {
            token: token
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: actionState.isOpen,
                onClose: ()=>setActionState({
                        ...actionState,
                        isOpen: false
                    }),
                onSubmitClick: handleConfirmAction,
                header: `${(0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(actionState.type)} playlist`,
                body: `Are you sure you want to ${actionState.type} this playlist?`,
                submitButtonText: (0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(actionState.type),
                cancelButtonText: "Cancel"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    border: "1px solid #91A0AD"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).THEME_ENUM.v2,
                    className: classes.table,
                    config: {
                        pagination: {
                            initialPageSize: (0, $5dc958303e06c3a5$export$ff05e60509bc6769)
                        },
                        methods: {
                            onTableOrderChange: handleSortChange
                        },
                        meta: {
                            headerRef: headerRef
                        },
                        data: {
                            columns: [
                                {
                                    type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.checkbox,
                                    headerName: "",
                                    field: "isChecked",
                                    renderHeader: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                            isChecked: isAllChecked,
                                            onToggle: onToggleAll
                                        }),
                                    renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                            isChecked: row.isChecked,
                                            isEnabled: row.state,
                                            onToggle: (isChecked)=>onPlaylistToggle?.(row.token, isChecked)
                                        })
                                },
                                {
                                    headerName: "Playlist Title",
                                    type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.subtitle,
                                    field: "playlist_title",
                                    onClick: (_, row)=>navigateToSinglePlaylist(row.token),
                                    width: "450px"
                                },
                                {
                                    headerName: "Type",
                                    field: "type",
                                    width: "120px",
                                    renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: (0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(row.type, "_")
                                        })
                                },
                                {
                                    headerName: "Date Updated",
                                    field: "updated_at",
                                    textAlignment: "right",
                                    width: "120px"
                                },
                                {
                                    headerName: "Actions",
                                    field: "actions",
                                    width: "120px",
                                    renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a9a3f0ceeef4cf54$export$2e2bcd8739ae039), {
                                            playlist: row,
                                            onEditActionClick: ()=>navigateToSinglePlaylist(row.token),
                                            onActionClick: handleActionClick
                                        })
                                }
                            ],
                            rows: playlists.map((playlist)=>({
                                    ...playlist,
                                    playlist_title: {
                                        title: playlist.title
                                    },
                                    updated_at: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(playlist.updated_at).format("MM/DD/YYYY"),
                                    medias: playlist?.medias?.length,
                                    isChecked: selectedPlaylists.includes(playlist.token)
                                }))
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48733ae2ee9b2cdf$export$2e2bcd8739ae039), {
                type: snackbarState.type,
                isOpen: snackbarState.isOpen,
                onClose: handleCloseSnackbar,
                message: snackbarState.message
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $95fdffd6a39e1be0$export$5336cca884279f84;
(function(FormActionsEnum) {
    FormActionsEnum["ADD_TAG"] = "ADD_TAG";
    FormActionsEnum["REMOVE_TAG"] = "REMOVE_TAG";
    FormActionsEnum["CHANGE_FORM_FIELD"] = "CHANGE_FORM_FIELD";
    FormActionsEnum["VALIDATE_FORM_FIELD"] = "VALIDATE_FORM_FIELD";
    FormActionsEnum["RESET_FORM"] = "RESET_FORM";
    FormActionsEnum["SET_FORM_ERROR"] = "SET_FORM_ERROR";
    FormActionsEnum["CLOSE_FORM_ERROR"] = "CLOSE_FORM_ERROR";
    FormActionsEnum["SET_FORM_SUBMITTING"] = "SET_FORM_SUBMITTING";
    FormActionsEnum["SET_FORM_SUBMITTED"] = "SET_FORM_SUBMITTED";
    FormActionsEnum["SET_FORM_SUBMIT_ERROR"] = "SET_FORM_SUBMIT_ERROR";
    FormActionsEnum["SET_FORM_SUBMIT_SUCCESS"] = "SET_FORM_SUBMIT_SUCCESS";
})($95fdffd6a39e1be0$export$5336cca884279f84 || ($95fdffd6a39e1be0$export$5336cca884279f84 = {}));
var $95fdffd6a39e1be0$export$79fdfd1377fa0a2;
(function(ActionOnFieldEnum) {
    ActionOnFieldEnum["ADD"] = "ADD";
    ActionOnFieldEnum["REMOVE"] = "REMOVE";
})($95fdffd6a39e1be0$export$79fdfd1377fa0a2 || ($95fdffd6a39e1be0$export$79fdfd1377fa0a2 = {}));



function $6bca6f68346a010a$export$c4ea027afed2fe4a(str) {
    const regex = /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+(\/[\w-.~%]*)*(\?[\w-.~%&=]*)?(#[\w-.~%]*)?(\/[\w-.~%]*\*)?\/?$|^(\/[\w-.~%]+)*(\/[\w-.~%]*\*)?(\?[\w-.~%&=]*)?(#[\w-.~%]*)?$/;
    return regex.test(str);
}
function $6bca6f68346a010a$export$6535eb414fa2c8b6(url) {
    return url.replace(/^(https?:\/\/)?(www\.)?[^/?]+/, "").replace(/\/+$/, "").replace(/^\/+/, "");
}
function $6bca6f68346a010a$export$81350727a0ff4e2e(url, domain) {
    // Remove the protocol (http or https) e 'www.' se presente
    const cleanedUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");
    const urlParts = cleanedUrl.split("/");
    const urlDomain = urlParts[0].includes("?") ? "" : urlParts[0];
    const cleanedDomain = domain.replace(/^(https?:\/\/)?(www\.)?/, "");
    return urlDomain.trim() ? urlDomain === cleanedDomain : true;
}
function $6bca6f68346a010a$export$f2888183a34644d4(url) {
    const regex = /^(https?:\/\/)?(www\.)?/;
    return url.replace(regex, "");
}


const $5f45a7f1525fd7fd$export$766520ae5bac8408 = (value)=>!value || typeof value === "undefined" || Array.isArray(value) && value.length === 0 || value.toString().trim().length === 0;
const $5f45a7f1525fd7fd$export$d1d63c033a2d214c = (length, value, name)=>{
    const { min: min, max: max } = length;
    const fieldName = name ? `field ${name}` : "this field";
    if (typeof min !== "undefined" && typeof max !== "undefined") {
        if (typeof value === "string" && value.length < min && value.length > max) return `Field ${name} could be only between ${min} and ${max} characters`;
        if (typeof value === "number" && value < min && value >= max) return `Value for ${fieldName} should be between "${min}" and "${max}"`;
    }
    if (typeof min !== "undefined") {
        if (typeof value === "string" && value.length < min) return `Minimum ${min} characters required for ${fieldName}`;
        if (typeof value === "number" && value < min) return `Value for ${fieldName} should be minimum: "${min}"`;
    }
    if (typeof max !== "undefined") {
        if (typeof value === "string" && value.length > max) return `Maximum ${max} characters allowed for ${fieldName}`;
        if (typeof value === "number" && value > max) return `Value for ${fieldName} should be minimum: "${min}"`;
    }
    return true;
};
const $5f45a7f1525fd7fd$export$3fdd3a337a929aa9 = (count, value, name)=>{
    const { min: min, max: max } = count;
    const fieldName = name ? `field ${name}` : "this field";
    if (Array.isArray(value) && typeof min !== "undefined" && typeof max !== "undefined") {
        if (min && max && value.length < min && value.length > max) return `Only ${max} items selection allowed for ${fieldName}`;
        if (typeof min !== "undefined" && value.length < min) return `Minimum ${min} items selection allowed for ${fieldName}`;
        if (typeof max !== "undefined" && value.length > max) return `Minimum ${max} items selection allowed for ${fieldName}`;
    }
    return true;
};
const $5f45a7f1525fd7fd$export$f87eb48f25c86ad = (email)=>{
    if ($5f45a7f1525fd7fd$export$766520ae5bac8408(email)) return "Email can't be empty";
    // eslint-disable-next-line no-useless-escape
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return email.match(emailPattern) ? true : "Invalid email address";
};
const $5f45a7f1525fd7fd$export$605987bbe4f33f56 = (url)=>{
    if ($5f45a7f1525fd7fd$export$766520ae5bac8408(url)) return "URL can't be empty";
    return (0, $6bca6f68346a010a$export$c4ea027afed2fe4a)(url) ? true : `Invalid URL field`;
};
var /**
 * Will check form inputs for error existence based on provided rule(-s)
 * @param field
 * @param value
 */ $5f45a7f1525fd7fd$export$2e2bcd8739ae039 = (field, value)=>{
    const errors = [];
    // If required field is empty
    if (field.required && $5f45a7f1525fd7fd$export$766520ae5bac8408(value)) errors.push(`${field.label} is required field`);
    if (typeof field.rules === "object") {
        const rules = Object.keys(field.rules);
        if (rules.length === 0) return errors;
        return [
            ...errors,
            ...rules.map((rule)=>{
                switch(rule){
                    case "selectionLength":
                        {
                            const { min: min, max: max } = field.rules[rule];
                            if (typeof value === "string" && (max === 1 || min === 1 || !min && !max)) return "";
                            if (!Array.isArray(value)) return `${field.name} values should be an array`;
                            if (min || max) {
                                const countChecker = $5f45a7f1525fd7fd$export$3fdd3a337a929aa9({
                                    min: min,
                                    max: max
                                }, value, field.label);
                                return typeof countChecker === "string" ? countChecker : "";
                            }
                            break;
                        }
                    case "length":
                        if (typeof value === "string" || typeof value === "number") {
                            const { min: min, max: max } = field.rules[rule];
                            if (min || max) {
                                const lengthChecker = $5f45a7f1525fd7fd$export$d1d63c033a2d214c({
                                    min: min,
                                    max: max
                                }, value, field.label);
                                return typeof lengthChecker === "string" ? lengthChecker : "";
                            }
                        }
                        break;
                    case "pattern":
                        if (typeof value !== "string") return `${field.name} has to be a string value`;
                        return value.match(rule) ? "" : `${field.name} pattern in not correct, please be sure correct value provided`;
                    case "isURL":
                        if (typeof value !== "string") return `${field.name} has to be a string value`;
                        return $5f45a7f1525fd7fd$export$605987bbe4f33f56(value) ? "" : `${field.name} in not url, please be sure correct value provided`;
                    default:
                        break;
                }
                return "";
            }).filter((err)=>typeof err === "string" && err.length > 0)
        ];
    }
    return errors;
};


const $c3742093f02c499e$var$dataTransfer = (value, field, action)=>{
    if (field.type === "chip") {
        if (action === (0, $95fdffd6a39e1be0$export$79fdfd1377fa0a2).ADD) {
            if (typeof value === "object" && value.text) return {
                formValue: [
                    ...field.value,
                    {
                        id: value.text,
                        text: value.text
                    }
                ],
                dataValue: [
                    ...field.value.map((v)=>v.text),
                    value.text
                ]
            };
            if (Array.isArray(value)) {
                const values = value.map((v)=>({
                        text: v,
                        id: v
                    }));
                return {
                    formValue: [
                        ...field.value,
                        ...values.length > 0 && value.map((v)=>({
                                text: v,
                                id: v
                            }))
                    ],
                    dataValue: [
                        ...field.value.map((v)=>v.text),
                        ...values.length > 0 && values.map((v)=>v.text)
                    ]
                };
            }
        }
        if (action === (0, $95fdffd6a39e1be0$export$79fdfd1377fa0a2).REMOVE) return {
            formValue: [
                ...field.value.filter((v)=>v.text !== value.text)
            ],
            dataValue: field.value.filter((v)=>v.text !== value.text).map((v)=>v.text)
        };
    }
    if (field.type === "select") {
        let formValue;
        let dataValue;
        const isMultiple = typeof field.isMultiple !== "undefined" && field.isMultiple;
        if (isMultiple) {
            formValue = Array.isArray(value) ? value : [
                value
            ];
            dataValue = typeof value === "string" ? value.split(",") : value;
        } else {
            formValue = Array.isArray(value) ? value.join(",") : value;
            dataValue = Array.isArray(value) ? value.join(",") : value.toString(); // formValue;
        }
        return {
            formValue: formValue,
            dataValue: dataValue
        };
    }
    return {
        formValue: value,
        dataValue: value
    };
};
var $c3742093f02c499e$export$2e2bcd8739ae039 = (state, payload, action, touched = true)=>{
    let errorMessages = [];
    const { field: field, value: value } = payload;
    const { name: name, errorMessage: errorMessage } = field;
    // reset errors and data. Avoid JSLinter error: "no-param-reassign"
    const data = {
        ...state.data
    };
    if (data[name]) delete data[name];
    const errors = {
        ...state.errors
    };
    if (errors[name]) delete errors[name];
    // check validation
    const validationResults = (0, $5f45a7f1525fd7fd$export$2e2bcd8739ae039)(field, value);
    if (validationResults.length > 0 || errorMessage) errorMessages = errorMessage && errorMessage.length > 0 ? [
        errorMessage
    ] : validationResults;
    const { formValue: formValue, dataValue: dataValue } = $c3742093f02c499e$var$dataTransfer(value, field, action);
    return {
        ...state,
        formInputFields: {
            ...state.formInputFields,
            [name]: {
                ...payload.field,
                touched: touched,
                value: formValue,
                error: errorMessages
            }
        },
        ...validationResults.length > 0 && {
            data: data,
            errors: {
                ...state.errors,
                [name]: errorMessages
            }
        },
        ...validationResults.length === 0 && {
            errors: errors,
            data: {
                ...data,
                [name]: dataValue
            }
        },
        ...touched && {
            touched: touched
        }
    };
};


const $d7e981380978072f$var$GENERIC_FORM_ERROR_KEY = "formError";
var $d7e981380978072f$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).RESET_FORM:
            return {
                ...state,
                formInputFields: action.payload,
                errors: {},
                touched: false
            };
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).CHANGE_FORM_FIELD:
            return (0, $c3742093f02c499e$export$2e2bcd8739ae039)(state, action.payload);
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).VALIDATE_FORM_FIELD:
            return (0, $c3742093f02c499e$export$2e2bcd8739ae039)(state, action.payload, null, false);
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).ADD_TAG:
            return (0, $c3742093f02c499e$export$2e2bcd8739ae039)(state, action.payload, (0, $95fdffd6a39e1be0$export$79fdfd1377fa0a2).ADD);
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).REMOVE_TAG:
            return (0, $c3742093f02c499e$export$2e2bcd8739ae039)(state, action.payload, (0, $95fdffd6a39e1be0$export$79fdfd1377fa0a2).REMOVE);
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMITTING:
            return {
                ...state,
                submitting: true
            };
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMITTED:
            return {
                ...state,
                submitting: false,
                touched: false
            };
        // doing the same but was split to be more clear
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMIT_ERROR:
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_ERROR:
            {
                const errors = {
                    ...state.errors
                };
                if (errors[$d7e981380978072f$var$GENERIC_FORM_ERROR_KEY]) delete errors[$d7e981380978072f$var$GENERIC_FORM_ERROR_KEY];
                return {
                    ...state,
                    showAllErrors: true,
                    submitting: false,
                    errors: {
                        ...action.payload && {
                            [$d7e981380978072f$var$GENERIC_FORM_ERROR_KEY]: [
                                action.payload
                            ]
                        },
                        ...state.errors
                    }
                };
            }
        case (0, $95fdffd6a39e1be0$export$5336cca884279f84).CLOSE_FORM_ERROR:
            {
                const errors = {
                    ...state.errors
                };
                if (errors[$d7e981380978072f$var$GENERIC_FORM_ERROR_KEY]) delete errors[$d7e981380978072f$var$GENERIC_FORM_ERROR_KEY];
                // will show one error for
                return {
                    ...state,
                    showAllErrors: false,
                    errors: errors
                };
            }
        default:
            return state;
    }
};


const $366ccbbe6fb31b36$var$initialFormState = {
    errors: {},
    touched: false,
    formInputFields: {},
    data: null,
    showAllErrors: false,
    submitting: false
};
const $366ccbbe6fb31b36$var$CurrentFormContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $366ccbbe6fb31b36$export$8ce1ff4f94d08846 = ({ children: children, formInputFields: formInputFields })=>{
    const [store, dispatch] = (0, $acw62.useReducer)((0, $d7e981380978072f$export$2e2bcd8739ae039), {
        ...$366ccbbe6fb31b36$var$initialFormState,
        formInputFields: formInputFields
    });
    const contextMemorizedValue = (0, $acw62.useMemo)(()=>[
            store,
            dispatch
        ], [
        store
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($366ccbbe6fb31b36$var$CurrentFormContext.Provider, {
        value: contextMemorizedValue,
        children: children
    });
};
const $366ccbbe6fb31b36$export$4d957a5e1be13b03 = ()=>{
    const context = (0, $acw62.useContext)($366ccbbe6fb31b36$var$CurrentFormContext);
    if (!context) throw new Error("useFormContext must be used within a FormProvider");
    return context;
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iDAOR = parcelRequire("iDAOR");

var $OEVqP = parcelRequire("OEVqP");
var $gd5y7 = parcelRequire("gd5y7");
var $3bYfT = parcelRequire("3bYfT");

var $6vVdw = parcelRequire("6vVdw");
var $6392f5418b4c6f5d$exports = {};
"use strict";
var $6392f5418b4c6f5d$var$__createBinding = $6392f5418b4c6f5d$exports && $6392f5418b4c6f5d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6392f5418b4c6f5d$var$__exportStar = $6392f5418b4c6f5d$exports && $6392f5418b4c6f5d$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6392f5418b4c6f5d$var$__createBinding(exports1, m, p);
};
var $6392f5418b4c6f5d$var$__importDefault = $6392f5418b4c6f5d$exports && $6392f5418b4c6f5d$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($6392f5418b4c6f5d$exports, "__esModule", {
    value: true
});
$6392f5418b4c6f5d$exports.VARIANT_ENUM = $6392f5418b4c6f5d$exports.THEME_ENUM = void 0;

const $6392f5418b4c6f5d$var$krg_select_react_1 = $6392f5418b4c6f5d$var$__importDefault((parcelRequire("1BMiU")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($6392f5418b4c6f5d$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});
Object.defineProperty($6392f5418b4c6f5d$exports, "VARIANT_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.INPUT_VARIANT_ENUM;
    }
});

$6392f5418b4c6f5d$var$__exportStar((parcelRequire("aD0se")), $6392f5418b4c6f5d$exports);

$6392f5418b4c6f5d$var$__exportStar((parcelRequire("bcMh9")), $6392f5418b4c6f5d$exports);
$6392f5418b4c6f5d$exports.default = $6392f5418b4c6f5d$var$krg_select_react_1.default;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
function $0030bffa1359ca92$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $0030bffa1359ca92$export$71594e8a50f746f4 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $0030bffa1359ca92$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
    elementString === "[object global]";
}
function $0030bffa1359ca92$export$8ee0fc9ee280b4ee(node) {
    return "nodeType" in node;
}
function $0030bffa1359ca92$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $0030bffa1359ca92$export$62858bae88b53fd0(node) {
    const { Document: Document } = $0030bffa1359ca92$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $0030bffa1359ca92$export$1b3bfaa9684536aa(node) {
    if ($0030bffa1359ca92$export$5a096129d439f843(node)) return false;
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).HTMLElement;
}
function $0030bffa1359ca92$export$17eda790a720ec57(node) {
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).SVGElement;
}
function $0030bffa1359ca92$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target.document;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return document;
    if ($0030bffa1359ca92$export$62858bae88b53fd0(target)) return target;
    if ($0030bffa1359ca92$export$1b3bfaa9684536aa(target) || $0030bffa1359ca92$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $0030bffa1359ca92$export$700979bc83e7db82 = $0030bffa1359ca92$export$71594e8a50f746f4 ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $0030bffa1359ca92$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $acw62.useRef)(handler);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $0030bffa1359ca92$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $acw62.useRef)(null);
    const set = (0, $acw62.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $acw62.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $0030bffa1359ca92$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $acw62.useRef)(value);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $0030bffa1359ca92$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $acw62.useRef)();
    return (0, $acw62.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $0030bffa1359ca92$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $0030bffa1359ca92$export$90fc3a17d93f704c(onChange);
    const node = (0, $acw62.useRef)(null);
    const setNodeRef = (0, $acw62.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $0030bffa1359ca92$export$5cae361ad82dce8b(value) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $0030bffa1359ca92$var$ids = {};
function $0030bffa1359ca92$export$c485849f2e393253(prefix, value) {
    return (0, $acw62.useMemo)(()=>{
        if (value) return value;
        const id = $0030bffa1359ca92$var$ids[prefix] == null ? 0 : $0030bffa1359ca92$var$ids[prefix] + 1;
        $0030bffa1359ca92$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $0030bffa1359ca92$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $0030bffa1359ca92$export$e16d8520af44a096 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(1);
const $0030bffa1359ca92$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(-1);
function $0030bffa1359ca92$export$d0e71af79cd586c6(event) {
    return "clientX" in event && "clientY" in event;
}
function $0030bffa1359ca92$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $0030bffa1359ca92$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $0030bffa1359ca92$export$36195c8aa1517e04(event) {
    if ($0030bffa1359ca92$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($0030bffa1359ca92$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $0030bffa1359ca92$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $0030bffa1359ca92$export$c4ffa16951855e28.Translate.toString(transform),
                $0030bffa1359ca92$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(" ");
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $0030bffa1359ca92$var$SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function $0030bffa1359ca92$export$44f71d798fd0a62b(element) {
    if (element.matches($0030bffa1359ca92$var$SELECTOR)) return element;
    return element.querySelector($0030bffa1359ca92$var$SELECTOR);
}



var $acw62 = parcelRequire("acw62");
const $768971a59ac63485$var$hiddenStyles = {
    display: "none"
};
function $768971a59ac63485$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: $768971a59ac63485$var$hiddenStyles
    }, value);
}
function $768971a59ac63485$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: "fixed",
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: "hidden",
        clip: "rect(0 0 0 0)",
        clipPath: "inset(100%)",
        whiteSpace: "nowrap"
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $768971a59ac63485$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $acw62.useState)("");
    const announce = (0, $acw62.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $0bb7808e9486acbd$var$DndMonitorContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $0bb7808e9486acbd$export$1182af90218a7b81(listener) {
    const registerListener = (0, $acw62.useContext)($0bb7808e9486acbd$var$DndMonitorContext);
    (0, $acw62.useEffect)(()=>{
        if (!registerListener) throw new Error("useDndMonitor must be used within a children of <DndContext>");
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $0bb7808e9486acbd$var$useDndMonitorProvider() {
    const [listeners] = (0, $acw62.useState)(()=>new Set());
    const registerListener = (0, $acw62.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $acw62.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $0bb7808e9486acbd$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $0bb7808e9486acbd$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $0bb7808e9486acbd$var$Accessibility(_ref) {
    let { announcements: announcements = $0bb7808e9486acbd$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $0bb7808e9486acbd$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $768971a59ac63485$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
    }, []);
    $0bb7808e9486acbd$export$1182af90218a7b81((0, $acw62.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $1u0KT.createPortal)(markup, container) : markup;
}
var $0bb7808e9486acbd$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($0bb7808e9486acbd$var$Action || ($0bb7808e9486acbd$var$Action = {}));
function $0bb7808e9486acbd$var$noop() {}
function $0bb7808e9486acbd$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $acw62.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $0bb7808e9486acbd$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $0bb7808e9486acbd$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $0bb7808e9486acbd$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $0bb7808e9486acbd$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return "0 0";
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $0bb7808e9486acbd$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $0bb7808e9486acbd$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $0bb7808e9486acbd$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $0bb7808e9486acbd$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $0bb7808e9486acbd$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $0bb7808e9486acbd$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $0bb7808e9486acbd$var$distanceBetween($0bb7808e9486acbd$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $0bb7808e9486acbd$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $0bb7808e9486acbd$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $0bb7808e9486acbd$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $0bb7808e9486acbd$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $0bb7808e9486acbd$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $0bb7808e9486acbd$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $0bb7808e9486acbd$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $0bb7808e9486acbd$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
function $0bb7808e9486acbd$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $0bb7808e9486acbd$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $0bb7808e9486acbd$var$getAdjustedRect = /*#__PURE__*/ $0bb7808e9486acbd$var$createRectAdjustmentFn(1);
function $0bb7808e9486acbd$var$parseTransform(transform) {
    if (transform.startsWith("matrix3d(")) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith("matrix(")) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $0bb7808e9486acbd$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $0bb7808e9486acbd$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $0bb7808e9486acbd$var$getTransformAgnosticClientRect(element) {
    return $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $0bb7808e9486acbd$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $0bb7808e9486acbd$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === "fixed";
}
function $0bb7808e9486acbd$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === "string" ? overflowRegex.test(value) : false;
    });
}
function $0bb7808e9486acbd$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(node) || (0, $0030bffa1359ca92$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($0bb7808e9486acbd$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($0bb7808e9486acbd$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $0bb7808e9486acbd$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $0bb7808e9486acbd$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $0bb7808e9486acbd$var$getScrollableElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return null;
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element;
    if (!(0, $0030bffa1359ca92$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(element) || element === (0, $0030bffa1359ca92$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $0bb7808e9486acbd$var$getScrollXCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $0bb7808e9486acbd$var$getScrollYCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $0bb7808e9486acbd$var$getScrollCoordinates(element) {
    return {
        x: $0bb7808e9486acbd$var$getScrollXCoordinate(element),
        y: $0bb7808e9486acbd$var$getScrollYCoordinate(element)
    };
}
var $0bb7808e9486acbd$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($0bb7808e9486acbd$var$Direction || ($0bb7808e9486acbd$var$Direction = {}));
function $0bb7808e9486acbd$var$isDocumentScrollingElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $0bb7808e9486acbd$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $0bb7808e9486acbd$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $0bb7808e9486acbd$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $0bb7808e9486acbd$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $0bb7808e9486acbd$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $0bb7808e9486acbd$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $0bb7808e9486acbd$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $0bb7808e9486acbd$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $0bb7808e9486acbd$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, $0bb7808e9486acbd$var$getScrollCoordinates(node));
    }, $0bb7808e9486acbd$export$597cbd7bbd10deb4);
}
function $0bb7808e9486acbd$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollXCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollYCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: "center",
        inline: "center"
    });
}
const $0bb7808e9486acbd$var$properties = [
    [
        "x",
        [
            "left",
            "right"
        ],
        $0bb7808e9486acbd$var$getScrollXOffset
    ],
    [
        "y",
        [
            "top",
            "bottom"
        ],
        $0bb7808e9486acbd$var$getScrollYOffset
    ]
];
class $0bb7808e9486acbd$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $0bb7808e9486acbd$export$e4864aa91b5ed091(element);
        const scrollOffsets = $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $0bb7808e9486acbd$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, "rect", {
            enumerable: false
        });
    }
}
class $0bb7808e9486acbd$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $0bb7808e9486acbd$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
}
function $0bb7808e9486acbd$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === "number") return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ("x" in measurement && "y" in measurement) return dx > measurement.x && dy > measurement.y;
    if ("x" in measurement) return dx > measurement.x;
    if ("y" in measurement) return dy > measurement.y;
    return false;
}
var $0bb7808e9486acbd$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($0bb7808e9486acbd$var$EventName || ($0bb7808e9486acbd$var$EventName = {}));
function $0bb7808e9486acbd$var$preventDefault(event) {
    event.preventDefault();
}
function $0bb7808e9486acbd$var$stopPropagation(event) {
    event.stopPropagation();
}
var $0bb7808e9486acbd$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($0bb7808e9486acbd$export$a8b1916dba3ae88b || ($0bb7808e9486acbd$export$a8b1916dba3ae88b = {}));
const $0bb7808e9486acbd$var$defaultKeyboardCodes = {
    start: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Tab
    ]
};
const $0bb7808e9486acbd$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $0bb7808e9486acbd$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$b204af158042fbac)(target));
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(node);
        onStart($0bb7808e9486acbd$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $0030bffa1359ca92$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $0bb7808e9486acbd$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = "smooth" } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $0bb7808e9486acbd$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && !isRight || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && !isBottom || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $0030bffa1359ca92$export$e16d8520af44a096)((0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$0bb7808e9486acbd$export$44d67f2a438aeba9.activators = [
    {
        eventName: "onKeyDown",
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $0bb7808e9486acbd$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && "distance" in constraint);
}
function $0bb7808e9486acbd$var$isDelayConstraint(constraint) {
    return Boolean(constraint && "delay" in constraint);
}
class $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $0bb7808e9486acbd$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
        this.documentListeners = new $0bb7808e9486acbd$var$Listeners(this.document);
        this.listeners = new $0bb7808e9486acbd$var$Listeners(listenerTarget);
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.DragStart, $0bb7808e9486acbd$var$preventDefault);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.ContextMenu, $0bb7808e9486acbd$var$preventDefault);
        this.documentListeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.Click, $0bb7808e9486acbd$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        const delta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $0bb7808e9486acbd$var$events = {
    cancel: {
        name: "pointercancel"
    },
    move: {
        name: "pointermove"
    },
    end: {
        name: "pointerup"
    }
};
class $0bb7808e9486acbd$export$b26af955418d6638 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $0030bffa1359ca92$export$b204af158042fbac)(event.target);
        super(props, $0bb7808e9486acbd$var$events, listenerTarget);
    }
}
$0bb7808e9486acbd$export$b26af955418d6638.activators = [
    {
        eventName: "onPointerDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$1 = {
    move: {
        name: "mousemove"
    },
    end: {
        name: "mouseup"
    }
};
var $0bb7808e9486acbd$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($0bb7808e9486acbd$var$MouseButton || ($0bb7808e9486acbd$var$MouseButton = {}));
class $0bb7808e9486acbd$export$b28554b50bf7f273 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$1, (0, $0030bffa1359ca92$export$b204af158042fbac)(props.event.target));
    }
}
$0bb7808e9486acbd$export$b28554b50bf7f273.activators = [
    {
        eventName: "onMouseDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $0bb7808e9486acbd$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$2 = {
    cancel: {
        name: "touchcancel"
    },
    move: {
        name: "touchmove"
    },
    end: {
        name: "touchend"
    }
};
class $0bb7808e9486acbd$export$19b41baf2e1bcdc0 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($0bb7808e9486acbd$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($0bb7808e9486acbd$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$0bb7808e9486acbd$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: "onTouchStart",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $0bb7808e9486acbd$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($0bb7808e9486acbd$export$eefe60e26f04c318 || ($0bb7808e9486acbd$export$eefe60e26f04c318 = {}));
var $0bb7808e9486acbd$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($0bb7808e9486acbd$export$f93aa492a37e1b0e || ($0bb7808e9486acbd$export$f93aa492a37e1b0e = {}));
function $0bb7808e9486acbd$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $0bb7808e9486acbd$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $0030bffa1359ca92$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $acw62.useMemo)(()=>{
        switch(activator){
            case $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $0bb7808e9486acbd$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $acw62.useRef)(null);
    const autoScroll = (0, $acw62.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $acw62.useMemo)(()=>order === $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                "x",
                "y"
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $0bb7808e9486acbd$var$defaultScrollIntent = {
    x: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    },
    y: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    }
};
function $0bb7808e9486acbd$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(delta);
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $0bb7808e9486acbd$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Backward] || direction.x === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Backward] || direction.y === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $0bb7808e9486acbd$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $0bb7808e9486acbd$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $acw62.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $0bb7808e9486acbd$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($0bb7808e9486acbd$export$571c10ffffe014ab || ($0bb7808e9486acbd$export$571c10ffffe014ab = {}));
var $0bb7808e9486acbd$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($0bb7808e9486acbd$export$8e062c3160beefd5 || ($0bb7808e9486acbd$export$8e062c3160beefd5 = {}));
const $0bb7808e9486acbd$var$defaultValue = /*#__PURE__*/ new Map();
function $0bb7808e9486acbd$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $acw62.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $acw62.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $acw62.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $acw62.useRef)(null);
    const droppableRects = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $0bb7808e9486acbd$var$defaultValue;
        if (!previousValue || previousValue === $0bb7808e9486acbd$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $0bb7808e9486acbd$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $acw62.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled || typeof frequency !== "number" || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $0bb7808e9486acbd$export$571c10ffffe014ab.Always:
                return false;
            case $0bb7808e9486acbd$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $0bb7808e9486acbd$var$useInitialValue(value, computeFn) {
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === "function" ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $0bb7808e9486acbd$var$useInitialRect(node, measure) {
    return $0bb7808e9486acbd$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $0bb7808e9486acbd$var$defaultMeasure(element) {
    return new $0bb7808e9486acbd$var$Rect($0bb7808e9486acbd$export$b6aa1f30c53d7454(element), element);
}
function $0bb7808e9486acbd$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $0bb7808e9486acbd$var$defaultMeasure;
    const [rect, setRect] = (0, $acw62.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $0bb7808e9486acbd$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === "childList" && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRect
    });
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $0bb7808e9486acbd$var$useRectDelta(rect) {
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(rect);
    return $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
}
const $0bb7808e9486acbd$var$defaultValue$1 = [];
function $0bb7808e9486acbd$var$useScrollableAncestors(node) {
    const previousNode = (0, $acw62.useRef)(node);
    const ancestors = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $0bb7808e9486acbd$var$defaultValue$1;
        if (previousValue && previousValue !== $0bb7808e9486acbd$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $0bb7808e9486acbd$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $acw62.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $0bb7808e9486acbd$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $acw62.useState)(null);
    const prevElements = (0, $acw62.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $acw62.useCallback)((event)=>{
        const scrollingElement = $0bb7808e9486acbd$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $0bb7808e9486acbd$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener("scroll", handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $0bb7808e9486acbd$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener("scroll", handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $acw62.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, coordinates), $0bb7808e9486acbd$export$597cbd7bbd10deb4) : $0bb7808e9486acbd$var$getScrollOffsets(elements);
        return $0bb7808e9486acbd$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $acw62.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$useSensorSetup(sensors) {
    (0, $acw62.useEffect)(()=>{
        if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $0bb7808e9486acbd$var$useSyntheticListeners(listeners, id) {
    return (0, $acw62.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $0bb7808e9486acbd$var$useWindowRect(element) {
    return (0, $acw62.useMemo)(()=>element ? $0bb7808e9486acbd$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $0bb7808e9486acbd$var$defaultValue$2 = [];
function $0bb7808e9486acbd$var$useRects(elements, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(firstElement ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $acw62.useState)($0bb7808e9486acbd$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $0bb7808e9486acbd$var$defaultValue$2;
            return elements.map((element)=>$0bb7808e9486acbd$var$isDocumentScrollingElement(element) ? windowRect : new $0bb7808e9486acbd$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRects
    });
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $0bb7808e9486acbd$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $0bb7808e9486acbd$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $acw62.useState)(null);
    const handleResize = (0, $acw62.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $acw62.useCallback)((element)=>{
        const node = $0bb7808e9486acbd$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    return (0, $acw62.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $0bb7808e9486acbd$var$defaultSensors = [
    {
        sensor: $0bb7808e9486acbd$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $0bb7808e9486acbd$export$44d67f2a438aeba9,
        options: {}
    }
];
const $0bb7808e9486acbd$var$defaultData = {
    current: {}
};
const $0bb7808e9486acbd$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect,
        strategy: $0bb7808e9486acbd$export$571c10ffffe014ab.WhileDragging,
        frequency: $0bb7808e9486acbd$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $0bb7808e9486acbd$export$b6aa1f30c53d7454
    }
};
class $0bb7808e9486acbd$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $0bb7808e9486acbd$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $0bb7808e9486acbd$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $0bb7808e9486acbd$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $0bb7808e9486acbd$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $0bb7808e9486acbd$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ""
    },
    dispatch: $0bb7808e9486acbd$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop
};
const $0bb7808e9486acbd$var$InternalContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultInternalContext);
const $0bb7808e9486acbd$var$PublicContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultPublicContext);
function $0bb7808e9486acbd$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $0bb7808e9486acbd$var$DroppableContainersMap()
        }
    };
}
function $0bb7808e9486acbd$var$reducer(state, action) {
    switch(action.type){
        case $0bb7808e9486acbd$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $0bb7808e9486acbd$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.DragEnd:
        case $0bb7808e9486acbd$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $0bb7808e9486acbd$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previousActivatorEvent = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $0030bffa1359ca92$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $0030bffa1359ca92$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $0bb7808e9486acbd$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $0bb7808e9486acbd$var$useMeasuringConfiguration(config) {
    return (0, $acw62.useMemo)(()=>({
            draggable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $acw62.useRef)(false);
    const { x: x, y: y } = typeof config === "boolean" ? {
        x: config,
        y: config
    } : config;
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $0bb7808e9486acbd$var$ActiveDraggableContext = /*#__PURE__*/ (0, $acw62.createContext)({
    ...$0bb7808e9486acbd$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $0bb7808e9486acbd$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($0bb7808e9486acbd$var$Status || ($0bb7808e9486acbd$var$Status = {}));
const $0bb7808e9486acbd$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $acw62.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $0bb7808e9486acbd$var$defaultSensors, collisionDetection: collisionDetection = $0bb7808e9486acbd$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $acw62.useReducer)($0bb7808e9486acbd$var$reducer, undefined, $0bb7808e9486acbd$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $0bb7808e9486acbd$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $acw62.useState)($0bb7808e9486acbd$var$Status.Uninitialized);
    const isInitialized = status === $0bb7808e9486acbd$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $acw62.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $acw62.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $0bb7808e9486acbd$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $acw62.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $acw62.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $acw62.useState)(null);
    const latestProps = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $acw62.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $0bb7808e9486acbd$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $0bb7808e9486acbd$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $0bb7808e9486acbd$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $acw62.useMemo)(()=>activatorEvent ? (0, $0030bffa1359ca92$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $0bb7808e9486acbd$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $0bb7808e9486acbd$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $0bb7808e9486acbd$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $acw62.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $0bb7808e9486acbd$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $0bb7808e9486acbd$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(draggingNode ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $0bb7808e9486acbd$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $0bb7808e9486acbd$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $0030bffa1359ca92$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $0bb7808e9486acbd$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $0bb7808e9486acbd$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, "id");
    const [over, setOver] = (0, $acw62.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $0bb7808e9486acbd$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $acw62.useRef)(null);
    const instantiateSensor = (0, $acw62.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: "onDragAbort",
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: "onDragPending",
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $1u0KT.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($0bb7808e9486acbd$var$Status.Initializing);
                    dispatch({
                        type: $0bb7808e9486acbd$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: "onDragStart",
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $0bb7808e9486acbd$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($0bb7808e9486acbd$var$Action.DragEnd),
            onCancel: createHandler($0bb7808e9486acbd$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $0bb7808e9486acbd$var$Action.DragEnd && typeof cancelDrop === "function") {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $0bb7808e9486acbd$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $1u0KT.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($0bb7808e9486acbd$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $0bb7808e9486acbd$var$Action.DragEnd ? "onDragEnd" : "onDragCancel";
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $acw62.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $0bb7808e9486acbd$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $0bb7808e9486acbd$var$useSensorSetup(sensors);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $0bb7808e9486acbd$var$Status.Initializing) setStatus($0bb7808e9486acbd$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $acw62.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $1u0KT.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: "onDragMove",
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $acw62.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $1u0KT.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: "onDragOver",
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $0bb7808e9486acbd$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $acw62.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $acw62.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === "object") return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $0bb7808e9486acbd$var$NullContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $0bb7808e9486acbd$var$defaultRole = "button";
const $0bb7808e9486acbd$var$ID_PREFIX = "Draggable";
function $0bb7808e9486acbd$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const { role: role = $0bb7808e9486acbd$var$defaultRole, roleDescription: roleDescription = "draggable", tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $acw62.useContext)(isDragging ? $0bb7808e9486acbd$var$ActiveDraggableContext : $0bb7808e9486acbd$var$NullContext);
    const [node, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const listeners = $0bb7808e9486acbd$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $acw62.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            "aria-disabled": disabled,
            "aria-pressed": isDragging && role === $0bb7808e9486acbd$var$defaultRole ? true : undefined,
            "aria-roledescription": roleDescription,
            "aria-describedby": ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $0bb7808e9486acbd$export$4930f6bf413be70e() {
    return (0, $acw62.useContext)($0bb7808e9486acbd$var$PublicContext);
}
const $0bb7808e9486acbd$var$ID_PREFIX$1 = "Droppable";
const $0bb7808e9486acbd$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $0bb7808e9486acbd$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previous = (0, $acw62.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $acw62.useRef)(false);
    const rect = (0, $acw62.useRef)(null);
    const callbackId = (0, $acw62.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$0bb7808e9486acbd$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $acw62.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $acw62.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $acw62.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch({
            type: $0bb7808e9486acbd$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $0bb7808e9486acbd$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $0bb7808e9486acbd$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $0bb7808e9486acbd$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $acw62.useState)(null);
    const [element, setElement] = (0, $acw62.useState)(null);
    const previousChildren = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children, clonedChildren ? (0, $acw62.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $0bb7808e9486acbd$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $0bb7808e9486acbd$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultTransform
    }, children));
}
const $0bb7808e9486acbd$var$baseStyles = {
    position: "fixed",
    touchAction: "none"
};
const $0bb7808e9486acbd$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? "transform 250ms ease" : undefined;
};
const $0bb7808e9486acbd$var$PositionedOverlay = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $0bb7808e9486acbd$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$0bb7808e9486acbd$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $0bb7808e9486acbd$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === "function" ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $0bb7808e9486acbd$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $0bb7808e9486acbd$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $0bb7808e9486acbd$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: "ease",
    keyframes: $0bb7808e9486acbd$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $0bb7808e9486acbd$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: "0"
            }
        }
    })
};
function $0bb7808e9486acbd$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $0030bffa1359ca92$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $0bb7808e9486acbd$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === "function" ? config : $0bb7808e9486acbd$var$createDefaultDropAnimation(config);
        $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $0bb7808e9486acbd$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$0bb7808e9486acbd$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: "forwards"
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $0bb7808e9486acbd$var$key = 0;
function $0bb7808e9486acbd$var$useKey(id) {
    return (0, $acw62.useMemo)(()=>{
        if (id == null) return;
        $0bb7808e9486acbd$var$key++;
        return $0bb7808e9486acbd$var$key;
    }, [
        id
    ]);
}
const $0bb7808e9486acbd$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = "div", className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $0bb7808e9486acbd$export$4930f6bf413be70e();
    const transform = (0, $acw62.useContext)($0bb7808e9486acbd$var$ActiveDraggableContext);
    const key = $0bb7808e9486acbd$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(activeNodeRect);
    const dropAnimation = $0bb7808e9486acbd$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $acw62 = parcelRequire("acw62");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $0332ec5baeac6793$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $0332ec5baeac6793$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $0332ec5baeac6793$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $0332ec5baeac6793$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $0332ec5baeac6793$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0332ec5baeac6793$var$normalizeDisabled(disabled) {
    if (typeof disabled === "boolean") return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$0332ec5baeac6793$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
};
function $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $0332ec5baeac6793$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $0332ec5baeac6793$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $0332ec5baeac6793$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$0332ec5baeac6793$var$defaultScale$1
        };
    }
    const itemGap = $0332ec5baeac6793$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
};
function $0332ec5baeac6793$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $0332ec5baeac6793$var$ID_PREFIX = "Sortable";
const $0332ec5baeac6793$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    activeIndex: -1,
    containerId: $0332ec5baeac6793$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $0332ec5baeac6793$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $0332ec5baeac6793$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $0332ec5baeac6793$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $0bb7808e9486acbd$export$4930f6bf413be70e)();
    const containerId = (0, $0030bffa1359ca92$export$c485849f2e393253)($0332ec5baeac6793$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $acw62.useMemo)(()=>userDefinedItems.map((item)=>typeof item === "object" && "id" in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $acw62.useRef)(items);
    const itemsHaveChanged = !$0332ec5baeac6793$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $0332ec5baeac6793$var$normalizeDisabled(disabledProp);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $acw62.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $0332ec5baeac6793$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0332ec5baeac6793$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $0332ec5baeac6793$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $0332ec5baeac6793$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $0332ec5baeac6793$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $0332ec5baeac6793$var$defaultTransition = {
    duration: 200,
    easing: "ease"
};
const $0332ec5baeac6793$var$transitionProperty = "transform";
const $0332ec5baeac6793$var$disabledTransition = /*#__PURE__*/ (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
    property: $0332ec5baeac6793$var$transitionProperty,
    duration: 0,
    easing: "linear"
});
const $0332ec5baeac6793$var$defaultAttributes = {
    roleDescription: "sortable"
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $0332ec5baeac6793$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $acw62.useState)(null);
    const previousIndex = (0, $acw62.useRef)(index);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $0bb7808e9486acbd$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $acw62.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $0332ec5baeac6793$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $0332ec5baeac6793$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $0332ec5baeac6793$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $0332ec5baeac6793$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $acw62.useContext)($0332ec5baeac6793$var$Context);
    const disabled = $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $acw62.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $acw62.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $0bb7808e9486acbd$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $0bb7808e9486acbd$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$0332ec5baeac6793$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $0030bffa1359ca92$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $acw62.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $0332ec5baeac6793$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $acw62.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $acw62.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $0332ec5baeac6793$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $0332ec5baeac6793$var$transitionProperty
        });
        return undefined;
    }
}
function $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === "boolean") return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $0332ec5baeac6793$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && "sortable" in data && typeof data.sortable === "object" && "containerId" in data.sortable && "items" in data.sortable && "index" in data.sortable) return true;
    return false;
}
const $0332ec5baeac6793$var$directions = [
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left
];
const $0332ec5baeac6793$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($0332ec5baeac6793$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $0bb7808e9486acbd$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $0bb7808e9486acbd$export$ef1beab6d7287295)(collisions, "id");
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $0bb7808e9486acbd$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $0332ec5baeac6793$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $0332ec5baeac6793$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $0332ec5baeac6793$var$isSameContainer(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $0332ec5baeac6793$var$isAfter(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    if (!$0332ec5baeac6793$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}




function $d2f556790fac95b8$export$7f11ea1f0ba255b5(gridSize) {
    return (_ref)=>{
        let { transform: transform } = _ref;
        return {
            ...transform,
            x: Math.ceil(transform.x / gridSize) * gridSize,
            y: Math.ceil(transform.y / gridSize) * gridSize
        };
    };
}
const $d2f556790fac95b8$export$29320759dd5f3702 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        y: 0
    };
};
function $d2f556790fac95b8$var$restrictToBoundingRect(transform, rect, boundingRect) {
    const value = {
        ...transform
    };
    if (rect.top + transform.y <= boundingRect.top) value.y = boundingRect.top - rect.top;
    else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) value.y = boundingRect.top + boundingRect.height - rect.bottom;
    if (rect.left + transform.x <= boundingRect.left) value.x = boundingRect.left - rect.left;
    else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) value.x = boundingRect.left + boundingRect.width - rect.right;
    return value;
}
const $d2f556790fac95b8$export$c7685f801ed492b5 = (_ref)=>{
    let { containerNodeRect: containerNodeRect, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (!draggingNodeRect || !containerNodeRect) return transform;
    return $d2f556790fac95b8$var$restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};
const $d2f556790fac95b8$export$85bf625d52c1d097 = (_ref)=>{
    let { draggingNodeRect: draggingNodeRect, transform: transform, scrollableAncestorRects: scrollableAncestorRects } = _ref;
    const firstScrollableAncestorRect = scrollableAncestorRects[0];
    if (!draggingNodeRect || !firstScrollableAncestorRect) return transform;
    return $d2f556790fac95b8$var$restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};
const $d2f556790fac95b8$export$1ed98a87b7c51b89 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        x: 0
    };
};
const $d2f556790fac95b8$export$57196ad89f591aab = (_ref)=>{
    let { transform: transform, draggingNodeRect: draggingNodeRect, windowRect: windowRect } = _ref;
    if (!draggingNodeRect || !windowRect) return transform;
    return $d2f556790fac95b8$var$restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};
const $d2f556790fac95b8$export$70a75ea36ecd3098 = (_ref)=>{
    let { activatorEvent: activatorEvent, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (draggingNodeRect && activatorEvent) {
        const activatorCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(activatorEvent);
        if (!activatorCoordinates) return transform;
        const offsetX = activatorCoordinates.x - draggingNodeRect.left;
        const offsetY = activatorCoordinates.y - draggingNodeRect.top;
        return {
            ...transform,
            x: transform.x + offsetX - draggingNodeRect.width / 2,
            y: transform.y + offsetY - draggingNodeRect.height / 2
        };
    }
    return transform;
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $9Lykx = parcelRequire("9Lykx");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $29775a9ad9a7bded$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), "Remove");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3fb6cdd207b8a1a5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "DragIndicator");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $b33d2f48c57e5fd5$var$ThumbnailImage = ({ src: src, alt: alt, style: style = {}, onError: onError })=>{
    const handleError = (e)=>{
        e.currentTarget.style.display = "none";
        onError?.(e);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: src,
        alt: alt,
        style: {
            ...(0, $5dc958303e06c3a5$export$4a0190bd87e17e53),
            ...style
        },
        onError: handleError
    });
};
var $b33d2f48c57e5fd5$export$2e2bcd8739ae039 = $b33d2f48c57e5fd5$var$ThumbnailImage;


const $bbe0c501dbf686b8$var$VideoItem = ({ video: video, index: index, showRemoveButton: showRemoveButton = false, showDragHandle: showDragHandle = false, onRemove: onRemove, dragProps: dragProps = {}, containerStyle: containerStyle = {} })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, style: dragStyle } = dragProps;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        ref: setNodeRef,
        style: dragStyle,
        sx: {
            display: "flex",
            alignItems: "center",
            padding: "0.5em",
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "white",
            cursor: "default",
            "&:hover": {
                backgroundColor: "#f5f5f5",
                ...showRemoveButton && {
                    "& .remove-button": {
                        opacity: 1
                    },
                    "& .number-text": {
                        opacity: 0
                    }
                }
            },
            ...containerStyle
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    width: 50,
                    textAlign: "center",
                    position: "relative",
                    ...showRemoveButton && {
                        "& .remove-button": {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            opacity: 0,
                            transition: "opacity 0.2s"
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        className: "number-text",
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            transition: "opacity 0.2s"
                        },
                        children: index + 1
                    }),
                    showRemoveButton && onRemove && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        className: "remove-button",
                        size: "small",
                        onClick: ()=>onRemove(video.token),
                        sx: {
                            width: 24,
                            height: 24,
                            backgroundColor: "rgba(0,0,0,0.1)",
                            "&:hover": {
                                backgroundColor: "rgba(0,0,0,0.2)"
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29775a9ad9a7bded$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    width: 100,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b33d2f48c57e5fd5$export$2e2bcd8739ae039), {
                    src: video?.default_stream?.image_url,
                    alt: video.title
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    flex: 1,
                    paddingLeft: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    sx: {
                        fontWeight: "normal",
                        fontSize: "12px"
                    },
                    children: video.title
                })
            }),
            showDragHandle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    width: 50,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    size: "small",
                    ...attributes,
                    ...listeners,
                    sx: {
                        cursor: "grab"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fb6cdd207b8a1a5$export$2e2bcd8739ae039), {
                        fontSize: "small"
                    })
                })
            })
        ]
    });
};
var $bbe0c501dbf686b8$export$2e2bcd8739ae039 = $bbe0c501dbf686b8$var$VideoItem;


const $f3bcae63b9199492$var$SortableVideoItem = ({ video: video, index: index, onRemove: onRemove, showRemoveButton: showRemoveButton = true })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $0332ec5baeac6793$export$4ebcb6201122185a)({
        id: video.token
    });
    const style = {
        transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.5 : 1
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbe0c501dbf686b8$export$2e2bcd8739ae039), {
        video: video,
        index: index,
        showRemoveButton: showRemoveButton,
        showDragHandle: true,
        onRemove: onRemove,
        dragProps: {
            attributes: attributes,
            listeners: listeners,
            setNodeRef: setNodeRef,
            style: style
        }
    });
};
const $f3bcae63b9199492$var$CustomPlaylistList = ({ videos: videos, onReorder: onReorder, onRemove: onRemove, showRemoveButton: showRemoveButton = true, style: style })=>{
    const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        if (active.id !== over?.id) {
            const oldIndex = videos.findIndex((v)=>v.token === active.id);
            const newIndex = videos.findIndex((v)=>v.token === over?.id);
            if (oldIndex !== -1 && newIndex !== -1) onReorder(oldIndex, newIndex);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            paddingTop: "20px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "1px solid #e0e0e0",
                    fontWeight: 500,
                    fontSize: "12px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            width: 50,
                            padding: "1em 0.6em",
                            textAlign: "center"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            width: 100,
                            padding: "1em 0.6em",
                            textAlign: "center"
                        },
                        children: "Thumbnail"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            flex: 1,
                            padding: "1em 0.6em",
                            paddingLeft: 2
                        },
                        children: "Video Title"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            width: 50,
                            padding: "1em 0.6em",
                            textAlign: "center"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    maxHeight: "400px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    ...style
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bb7808e9486acbd$export$2d5c5ceac203fc1e), {
                    collisionDetection: (0, $0bb7808e9486acbd$export$c8e785ae6b74bab8),
                    onDragEnd: handleDragEnd,
                    modifiers: [
                        (0, $d2f556790fac95b8$export$1ed98a87b7c51b89),
                        (0, $d2f556790fac95b8$export$85bf625d52c1d097)
                    ],
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
                        items: videos.map((v)=>v.token),
                        strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e),
                        children: videos.map((video, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f3bcae63b9199492$var$SortableVideoItem, {
                                video: video,
                                index: index,
                                onRemove: onRemove,
                                showRemoveButton: showRemoveButton
                            }, video.token))
                    })
                })
            })
        ]
    });
};
var $f3bcae63b9199492$export$2e2bcd8739ae039 = $f3bcae63b9199492$var$CustomPlaylistList;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");

var $1GFtd = parcelRequire("1GFtd");




const $39154cc66d8e6722$export$28e6b9b82ee883c = (0, $1GFtd.default)({
    container: {
        maxHeight: "400px",
        overflowY: "auto"
    }
});
const $39154cc66d8e6722$var$PlaylistDataTable = ({ videos: videos, onRemove: onRemove, rowSize: rowSize = 6, showRemoveButton: showRemoveButton = true })=>{
    const classes = $39154cc66d8e6722$export$28e6b9b82ee883c();
    const columns = [
        {
            headerName: "",
            field: "number",
            width: "50px",
            renderCell: (row)=>{
                const index = videos.findIndex((v)=>v.token === row.id);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        textAlign: "center",
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        ...showRemoveButton && {
                            "& .remove-button": {
                                position: "absolute",
                                opacity: 0,
                                transition: "opacity 0.2s"
                            }
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "number-text",
                            style: {
                                textAlign: "center",
                                display: "block",
                                transition: "opacity 0.2s"
                            },
                            children: index + 1
                        }),
                        showRemoveButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            className: "remove-button",
                            size: "small",
                            onClick: ()=>onRemove(row.id),
                            sx: {
                                width: 24,
                                height: 24,
                                backgroundColor: "rgba(0,0,0,0.1)",
                                "&:hover": {
                                    backgroundColor: "rgba(0,0,0,0.2)"
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29775a9ad9a7bded$export$2e2bcd8739ae039), {
                                fontSize: "small"
                            })
                        })
                    ]
                });
            }
        },
        {
            headerName: "Thumbnail",
            field: "thumbnail",
            width: "100px",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: row.thumbnail,
                    alt: row.title,
                    style: (0, $5dc958303e06c3a5$export$4a0190bd87e17e53),
                    onError: (e)=>{
                        e.currentTarget.style.display = "none";
                    }
                })
        },
        {
            headerName: "Video Title",
            field: "title",
            minWidth: "300px",
            maxWidth: "400px"
        },
        {
            headerName: "Publish Date",
            field: "publish_date",
            width: "120px",
            textAlignment: "right"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            ...showRemoveButton && {
                "& .MuiDataGrid-row": {
                    "&:hover .remove-button": {
                        opacity: "1 !important"
                    },
                    "&:hover .number-text": {
                        opacity: "0 !important"
                    }
                },
                "& .MuiTableRow-root": {
                    "&:hover .remove-button": {
                        opacity: "1 !important"
                    },
                    "&:hover .number-text": {
                        opacity: "0 !important"
                    }
                }
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))), {
            theme: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).THEME_ENUM.v2,
            containerClassName: classes.container,
            config: {
                data: {
                    columns: columns,
                    rows: videos.map((video)=>({
                            id: video.token,
                            thumbnail: video?.default_stream?.image_url,
                            title: video.title,
                            publish_date: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(video.created_at).format("MM/DD/YYYY")
                        }))
                },
                pagination: {
                    initialPageSize: rowSize,
                    totalRowCount: videos.length,
                    hasStrictRows: false
                }
            }
        })
    });
};
var $39154cc66d8e6722$export$2e2bcd8739ae039 = $39154cc66d8e6722$var$PlaylistDataTable;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ed7b2b659b749647$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");



var $dgtCa = parcelRequire("dgtCa");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
const $a0a7b6fc0014f6ee$var$EmptyPlaylistState = ({ title: title = "No Videos Added", description: description = "Click 'ADD VIDEOS' to select videos, or create an empty playlist and add videos later" })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            textAlign: "center",
            padding: 4,
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            backgroundColor: "#fafafa"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body1",
                color: "text.secondary",
                sx: {
                    marginBottom: 1
                },
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                children: description
            })
        ]
    });
var $a0a7b6fc0014f6ee$export$2e2bcd8739ae039 = $a0a7b6fc0014f6ee$var$EmptyPlaylistState;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");


var $htqGM = parcelRequire("htqGM");

var $1GFtd = parcelRequire("1GFtd");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $e4f44006c888bb84$export$3ee9b4aab65c61a7 = [
    {
        id: "1",
        name: "Attractions"
    },
    {
        id: "2",
        name: "Automotive"
    },
    {
        id: "3",
        name: "Books and Literature"
    },
    {
        id: "4",
        name: "Business and Finance"
    },
    {
        id: "5",
        name: "Careers"
    },
    {
        id: "6",
        name: "Communication"
    },
    {
        id: "7",
        name: "Crime"
    },
    {
        id: "8",
        name: "Disasters"
    },
    {
        id: "9",
        name: "Education"
    },
    {
        id: "10",
        name: "Entertainment"
    },
    {
        id: "11",
        name: "Events"
    },
    {
        id: "12",
        name: "Family and Relationships"
    },
    {
        id: "13",
        name: "Fine Art"
    },
    {
        id: "14",
        name: "Food & Drink"
    },
    {
        id: "15",
        name: "Genres"
    },
    {
        id: "16",
        name: "Healthy Living"
    },
    {
        id: "17",
        name: "Hobbies & Interests"
    },
    {
        id: "18",
        name: "Holidays"
    },
    {
        id: "19",
        name: "Home & Garden"
    },
    {
        id: "20",
        name: "Law"
    },
    {
        id: "21",
        name: "Maps & Navigation"
    },
    {
        id: "22",
        name: "Medical Health"
    },
    {
        id: "23",
        name: "Personal Celebrations & Life Events"
    },
    {
        id: "24",
        name: "Personal Finance"
    },
    {
        id: "25",
        name: "Pets"
    },
    {
        id: "26",
        name: "Politics"
    },
    {
        id: "27",
        name: "Pop Culture"
    },
    {
        id: "28",
        name: "Productivity"
    },
    {
        id: "29",
        name: "Real Estate"
    },
    {
        id: "30",
        name: "Religion & Spirituality"
    },
    {
        id: "31",
        name: "Science"
    },
    {
        id: "32",
        name: "Sensitive Topics"
    },
    {
        id: "33",
        name: "Shopping"
    },
    {
        id: "34",
        name: "Sports"
    },
    {
        id: "35",
        name: "Style & Fashion"
    },
    {
        id: "36",
        name: "Technology & Computing"
    },
    {
        id: "37",
        name: "Travel"
    },
    {
        id: "38",
        name: "Video Gaming"
    },
    {
        id: "39",
        name: "War and Conflicts"
    }
];


function $4b9509b4cff86a85$export$2e2bcd8739ae039({ isEnabled: isEnabled = true, value: value = [], isMultiple: isMultiple = true, onChange: onChange, hasCheckbox: hasCheckbox = true }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $120fe10e9e623c5d$export$2e2bcd8739ae039), {
        id: "categories-select",
        isEnabled: isEnabled,
        label: "Categories",
        placeholder: "Add",
        value: value,
        isMultiple: isMultiple,
        onChange: onChange,
        options: (0, $e4f44006c888bb84$export$3ee9b4aab65c61a7),
        hasCheckbox: hasCheckbox
    });
}





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1GFtd = parcelRequire("1GFtd");



function $4be2481e2af7cc00$export$2e2bcd8739ae039(inputQuery = {}) {
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "tags",
        inputQuery
    ], async ()=>{
        if (!api) throw new Error("API not initialized");
        try {
            const response = await api.getTags(inputQuery);
            return response;
        } catch (error) {
            console.error("Error fetching tags:", error);
            throw new Error("Failed to fetch tags");
        }
    }, {
        enabled: didLoad,
        staleTime: Infinity,
        retry: 3,
        retryDelay: (attemptIndex)=>Math.min(1000 * 2 ** attemptIndex, 30000)
    });
    return {
        query: query,
        tags: query.data?.tags || [],
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch
    };
}



const $6f7ac4fbe33a42d7$var$useStyles = (0, $1GFtd.default)({
    autocomplete: {
        minHeight: "37px",
        "& .MuiTextField-root": {
            minWidth: "260px",
            maxWidth: "320px",
            height: "37px"
        },
        "& span.MuiAutocomplete-tag": {
            fontSize: "small"
        }
    }
});
function $6f7ac4fbe33a42d7$export$2e2bcd8739ae039({ asAdmin: asAdmin, isEnabled: isEnabled = true, value: value = [], onChange: onChange, className: className }) {
    const classes = $6f7ac4fbe33a42d7$var$useStyles();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const query = {
        ...publisherSlug && {
            slug: publisherSlug
        }
    };
    const { tags: tags, isLoading: isLoading } = (0, $4be2481e2af7cc00$export$2e2bcd8739ae039)(query);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $120fe10e9e623c5d$export$2e2bcd8739ae039), {
        id: "tags-select",
        className: `${className} ${classes.autocomplete}`,
        isEnabled: isEnabled,
        label: "Tags",
        placeholder: "Add",
        isLoading: isLoading,
        value: value,
        onChange: onChange,
        options: tags.map((tag, id)=>({
                id: id,
                name: tag
            })),
        isOptionEqualToValue: (option, val)=>option.name === val.name
    });
}






const $dda9709b90af82fe$var$useStyles = (0, $1GFtd.default)({
    table: {
        "& thead th": {
            background: "transparent",
            color: "black",
            fontSize: "11px",
            fontWeight: 600
        },
        "& tbody": {
            borderTop: "2px solid black",
            borderBottom: "2px solid black",
            "& tr:hover": {
                background: "#EEF3F7"
            }
        }
    },
    container: {
        maxHeight: "400px",
        overflowY: "auto"
    }
});
function $dda9709b90af82fe$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, onAddVideos: onAddVideos, publisherSlug: publisherSlug, asAdmin: asAdmin, currentSelectedVideos: currentSelectedVideos = [] }) {
    const classes = $dda9709b90af82fe$var$useStyles();
    const [search, setSearch] = (0, $acw62.useState)("");
    const [selectedCategories, setSelectedCategories] = (0, $acw62.useState)([]);
    const [selectedTags, setSelectedTags] = (0, $acw62.useState)([]);
    const [dateRange, setDateRange] = (0, $acw62.useState)();
    const [selectedVideos, setSelectedVideos] = (0, $acw62.useState)([]);
    const { snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [pageSize, setPageSize] = (0, $acw62.useState)(6);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const query = {
        limit: pageSize,
        ...search.length >= 3 && {
            text: search
        },
        ...selectedCategories.length > 0 && {
            category: selectedCategories.map((category)=>category.name.toLowerCase())
        },
        ...selectedTags.length > 0 && {
            tags: selectedTags.map((tag)=>tag.name.toLowerCase())
        },
        ...publisherSlug && {
            slug: publisherSlug
        },
        ...dateRange && dateRange.to && dateRange.from && {
            date_range: dateRange
        }
    };
    const { videos: videos, query: videosQuery, totalCount: totalCount, hasNextPage: hasNextPage, fetchNextPage: fetchNextPage } = (0, $7f956d50de0acb82$export$2e2bcd8739ae039)(query);
    // Check if all selectable videos are selected
    const isAllChecked = (0, $acw62.useMemo)(()=>{
        const selectedVideosSet = new Set(selectedVideos.map((v)=>v.token));
        const pageVideos = videos.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        return selectedVideosSet.size > 0 && pageVideos.every((video)=>selectedVideosSet.has(video.token) || !(0, $5094343bfed31c54$export$9667a007680253be)(video.state) || currentSelectedVideos.some((selected)=>selected.token === video.token));
    }, [
        videos,
        selectedVideos
    ]);
    // Handle toggling selection for all videos
    const handleToggleAll = (checked)=>{
        const pageVideos = videos.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        if (!checked) {
            const visibleTokens = new Set(pageVideos.map((v)=>v.token));
            setSelectedVideos((prev)=>prev.filter((v)=>!visibleTokens.has(v.token)));
            return;
        }
        if (pageVideos.length === 0) {
            snackbarWarning("The Video Library is empty.");
            return;
        }
        const tempSelectedVideos = pageVideos.filter((video)=>(0, $5094343bfed31c54$export$9667a007680253be)(video.state) && !currentSelectedVideos.find((v)=>v.token === video.token));
        if (tempSelectedVideos.length === 0) {
            snackbarWarning("No videos with an active or draft state.");
            return;
        }
        const updatedSelected = [
            ...selectedVideos,
            ...tempSelectedVideos.filter((v)=>!selectedVideos.some((sv)=>sv.token === v.token))
        ];
        setSelectedVideos(updatedSelected);
    };
    // Handle toggling selection for a single video
    const handleVideoToggle = (selectedVideo, isSelected)=>{
        if (isSelected) setSelectedVideos([
            ...selectedVideos,
            selectedVideo
        ]);
        else setSelectedVideos(selectedVideos.filter((video)=>video.token !== selectedVideo.token));
    };
    const handleSearch = (value)=>{
        setSearch(value);
    };
    const handleCategories = (categories)=>{
        setSelectedCategories(categories);
    };
    const handleTags = (tags)=>{
        setSelectedTags(tags);
    };
    const handleDateChange = (range)=>{
        setDateRange(range);
    };
    const handlePaginationChange = (page, currentPageSize)=>{
        setPageSize(currentPageSize);
        setCurrentPage(page);
        if (page * currentPageSize > videos.length && hasNextPage) fetchNextPage();
    };
    const handleAddVideos = ()=>{
        onAddVideos(selectedVideos);
        setSelectedVideos([]);
        onClose();
    };
    const handleClose = ()=>{
        setSelectedVideos([]);
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
        title: "Add Videos",
        isOpen: isOpen,
        style: {
            height: "auto",
            minHeight: "80vh"
        },
        onClose: handleClose,
        submitButtonText: "ADD",
        cancelButtonText: "CANCEL",
        onSubmit: handleAddVideos,
        isSubmitButtonEnabled: selectedVideos.length > 0,
        content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        marginBottom: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        children: "Browse your available videos and select the ones you'd like to include in your custom playlist."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    justifyContent: "flex-start",
                    sx: {
                        marginBottom: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: "auto",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db95cc6529792278$export$2e2bcd8739ae039), {
                                placeholder: "Search",
                                text: search,
                                onTextChange: handleSearch
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: "auto",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b9509b4cff86a85$export$2e2bcd8739ae039), {
                                value: selectedCategories,
                                onChange: handleCategories
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: "auto",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f7ac4fbe33a42d7$export$2e2bcd8739ae039), {
                                asAdmin: asAdmin,
                                value: selectedTags,
                                onChange: handleTags
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: "auto",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f195e6d38f66fca$export$5109c6dd95d8fb00), {
                                onDateRangeChange: handleDateChange,
                                value: dateRange
                            })
                        })
                    ]
                }),
                videosQuery.isFetched ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        border: "1px solid #91A0AD"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))), {
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).THEME_ENUM.v2,
                        containerClassName: classes.container,
                        className: classes.table,
                        config: {
                            data: {
                                columns: [
                                    {
                                        headerName: "",
                                        type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.checkbox,
                                        field: "isChecked",
                                        renderHeader: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                                isChecked: isAllChecked,
                                                onToggle: handleToggleAll
                                            }),
                                        renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                                isChecked: row.isChecked,
                                                isEnabled: (0, $5094343bfed31c54$export$9667a007680253be)(row.status) && row.isEnabled,
                                                onToggle: (isChecked)=>{
                                                    const video = videos.find((v)=>v.token === row.id);
                                                    if (video) handleVideoToggle(video, isChecked);
                                                }
                                            }),
                                        width: "50px"
                                    },
                                    {
                                        headerName: "Thumbnail",
                                        type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.thumbnail,
                                        field: "thumbnail",
                                        width: "100px",
                                        renderCell: (row)=>{
                                            const thumbnailUrl = typeof row.thumbnail === "string" ? row.thumbnail : "";
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: thumbnailUrl,
                                                alt: "Video thumbnail",
                                                style: (0, $5dc958303e06c3a5$export$4a0190bd87e17e53),
                                                onError: (e)=>{
                                                    e.currentTarget.style.display = "none";
                                                }
                                            });
                                        }
                                    },
                                    {
                                        headerName: "Title",
                                        field: "title",
                                        width: "200px"
                                    },
                                    {
                                        headerName: "Status",
                                        field: "status",
                                        width: "100px"
                                    },
                                    {
                                        headerName: "Category",
                                        field: "category",
                                        width: "120px"
                                    },
                                    {
                                        headerName: "Tags",
                                        field: "tags",
                                        width: "200px"
                                    },
                                    {
                                        headerName: "Date Uploaded",
                                        field: "dateUploaded",
                                        width: "120px"
                                    }
                                ],
                                rows: videos.map((video)=>{
                                    const videoChecked = selectedVideos.some((selected)=>selected.token === video.token);
                                    const existingVideo = currentSelectedVideos.some((selected)=>selected.token === video.token);
                                    return {
                                        id: video.token,
                                        isChecked: videoChecked || existingVideo,
                                        isEnabled: !existingVideo,
                                        thumbnail: video?.default_stream?.image_url,
                                        title: video.title,
                                        status: video.state,
                                        category: video.category,
                                        tags: video.tags?.join(", "),
                                        dateUploaded: new Date(video.created_at).toLocaleDateString("en-US", {
                                            month: "2-digit",
                                            day: "2-digit",
                                            year: "numeric"
                                        })
                                    };
                                })
                            },
                            pagination: {
                                initialPageSize: pageSize,
                                totalRowCount: totalCount,
                                hasStrictRows: false
                            },
                            methods: {
                                onPaginationChange: handlePaginationChange
                            }
                        }
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d803cf99079fa048$export$2e2bcd8739ae039), {
                    height: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 2,
                        paddingTop: 2,
                        borderTop: "1px solid #e0e0e0"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        children: [
                            "Selected Videos: ",
                            selectedVideos.length
                        ]
                    })
                })
            ]
        })
    });
}


const $2a238fca44ed85c3$export$2830befb6f558677 = (list, type)=>{
    if (type === "newest") return [
        ...list
    ].sort((a, b)=>new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    if (type === "oldest") return [
        ...list
    ].sort((a, b)=>new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
    if (type === "shuffle") return [
        ...list
    ].sort(()=>Math.random() - 0.5);
    return list;
};


const $fece7a82ef7bf50b$var$VideoManagement = ({ selectedVideos: selectedVideos, setSelectedVideos: setSelectedVideos, sortValue: sortValue, publisherSlug: publisherSlug, asAdmin: asAdmin, isAddVideosModalOpen: isAddVideosModalOpen, setIsAddVideosModalOpen: setIsAddVideosModalOpen, onSortedVideosChange: onSortedVideosChange })=>{
    // Sort videos based on selected sort type
    const sortedVideos = (0, $acw62.useMemo)(()=>{
        if (!sortValue || sortValue === "manual") return selectedVideos;
        return (0, $2a238fca44ed85c3$export$2830befb6f558677)(selectedVideos, sortValue);
    }, [
        selectedVideos,
        sortValue
    ]);
    // Notify parent component of sorted videos for API calls
    (0, $acw62.useEffect)(()=>{
        if (onSortedVideosChange) onSortedVideosChange(sortedVideos);
    }, [
        sortedVideos,
        onSortedVideosChange
    ]);
    // Handle reordering videos (only for manual sort)
    const handleReorder = (oldIndex, newIndex)=>{
        const newVideos = [
            ...selectedVideos
        ];
        const [movedVideo] = newVideos.splice(oldIndex, 1);
        newVideos.splice(newIndex, 0, movedVideo);
        setSelectedVideos(newVideos);
    };
    // Handle removing a video
    const handleRemoveVideo = (videoToken)=>{
        setSelectedVideos(selectedVideos.filter((v)=>v.token !== videoToken));
    };
    const handleAddVideos = (videos)=>{
        const newSelectedVideos = [
            ...selectedVideos,
            ...videos
        ];
        setSelectedVideos(newSelectedVideos);
        setIsAddVideosModalOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    marginBottom: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "text.secondary",
                    children: "Choose existing videos from your library to add to your playlist."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    marginBottom: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                    theme: (0, $dgtCa.THEME_ENUM).v2,
                    variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {}),
                    style: {
                        borderColor: (0, $dgtCa.BACKGROUND_ENUM).blue,
                        color: (0, $dgtCa.BACKGROUND_ENUM).blue
                    },
                    text: "ADD VIDEOS",
                    onClick: ()=>setIsAddVideosModalOpen(true)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    marginTop: 2,
                    width: "852px"
                },
                children: (()=>{
                    if (sortedVideos.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0a7b6fc0014f6ee$export$2e2bcd8739ae039), {});
                    if (sortValue === "manual") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3bcae63b9199492$export$2e2bcd8739ae039), {
                        videos: sortedVideos,
                        onReorder: handleReorder,
                        onRemove: handleRemoveVideo
                    });
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39154cc66d8e6722$export$2e2bcd8739ae039), {
                        videos: sortedVideos,
                        onRemove: handleRemoveVideo
                    });
                })()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    position: "absolute",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 2,
                    paddingTop: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "text.secondary",
                    children: [
                        "Total Videos: ",
                        sortedVideos.length
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dda9709b90af82fe$export$2e2bcd8739ae039), {
                isOpen: isAddVideosModalOpen,
                onClose: ()=>setIsAddVideosModalOpen(false),
                onAddVideos: handleAddVideos,
                publisherSlug: publisherSlug,
                asAdmin: asAdmin,
                currentSelectedVideos: selectedVideos
            })
        ]
    });
};
var $fece7a82ef7bf50b$export$2e2bcd8739ae039 = $fece7a82ef7bf50b$var$VideoManagement;







const $3f43b861fb5eed68$export$cd01a3bec503042 = (dispatch, inp)=>Object.keys(inp).forEach((key)=>inp[key]?.required && dispatch({
            type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).VALIDATE_FORM_FIELD,
            payload: {
                field: inp[key],
                value: inp[key].value
            }
        }));
const $3f43b861fb5eed68$export$e02251cfbe407ee6 = (dispatch, errors, data, action)=>{
    let isPromise = false;
    dispatch({
        type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMITTING
    });
    if (Object.keys(errors).length === 0 && Object.keys(data).length > 0) try {
        const res = action.call(undefined, data);
        isPromise = res instanceof Promise;
        if (isPromise) {
            res.then(()=>{
                dispatch({
                    type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMITTED
                });
            });
            res.catch((err)=>{
                console.error(err);
                dispatch({
                    type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMIT_ERROR,
                    payload: `Error when tried to submit changes, please try later.`
                });
            });
        }
    } catch (err) {
        console.error(err);
        dispatch({
            type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMIT_ERROR,
            payload: "Error when tried to submit changes, please try later"
        });
    } finally{
        if (!isPromise) {
            console.warn(`Action is not a promise, so global isLoaded will be useless`);
            dispatch({
                type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMITTED
            });
        }
    }
    else dispatch({
        type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMIT_ERROR,
        payload: "Please recheck all fields and be sure all are filled correctly"
    });
};
const $3f43b861fb5eed68$export$3a465d426c5d6d9b = (dispatch, field, value)=>dispatch({
        type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).CHANGE_FORM_FIELD,
        payload: {
            field: field,
            value: value
        }
    });
const $3f43b861fb5eed68$export$fca196045f4c24a3 = (dispatch, ev, field, ref)=>{
    // keyCode, charCode are deprecated
    const { code: code, key: key } = ev;
    if (code === "Enter" || key === "Enter" && ref.current) {
        if (!ref.current.value) return;
        const prevValues = field.value.map((v)=>v.text);
        const values = ref.current.value.split(/[,|;]/g).map((val)=>val.trim()).filter((val)=>val.length > 0 && !prevValues.includes(val));
        if (values.length > 0) dispatch({
            type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).ADD_TAG,
            payload: {
                field: field,
                value: values
            }
        });
        // eslint-disable-next-line no-param-reassign
        ref.current.value = "";
    }
};
const $3f43b861fb5eed68$export$ad5fc744e8547a15 = (dispatch, tag, field)=>dispatch({
        type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).REMOVE_TAG,
        payload: {
            field: field,
            value: tag
        }
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $i32L9 = parcelRequire("i32L9");
var $OEVqP = parcelRequire("OEVqP");
var $gd5y7 = parcelRequire("gd5y7");
var $3a4c397b48b889d5$exports = {};
"use strict";
var $3a4c397b48b889d5$var$__createBinding = $3a4c397b48b889d5$exports && $3a4c397b48b889d5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3a4c397b48b889d5$var$__exportStar = $3a4c397b48b889d5$exports && $3a4c397b48b889d5$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3a4c397b48b889d5$var$__createBinding(exports1, m, p);
};
var $3a4c397b48b889d5$var$__importDefault = $3a4c397b48b889d5$exports && $3a4c397b48b889d5$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($3a4c397b48b889d5$exports, "__esModule", {
    value: true
});
$3a4c397b48b889d5$exports.VARIANT_ENUM = $3a4c397b48b889d5$exports.THEME_ENUM = void 0;

const $3a4c397b48b889d5$var$krg_text_area_react_1 = $3a4c397b48b889d5$var$__importDefault((parcelRequire("6yJwi")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($3a4c397b48b889d5$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});
Object.defineProperty($3a4c397b48b889d5$exports, "VARIANT_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.INPUT_VARIANT_ENUM;
    }
});

$3a4c397b48b889d5$var$__exportStar((parcelRequire("dUvwV")), $3a4c397b48b889d5$exports);

$3a4c397b48b889d5$var$__exportStar((parcelRequire("j6RuV")), $3a4c397b48b889d5$exports);
$3a4c397b48b889d5$exports.default = $3a4c397b48b889d5$var$krg_text_area_react_1.default;



var $ayMG0 = parcelRequire("ayMG0");

var $9Lykx = parcelRequire("9Lykx");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $cf6866e33a4a25da$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "InfoOutlined");



var $AfP12 = parcelRequire("AfP12");
const $dfe88cc496d1e86b$var$InfoPopover = ({ text: text, size: size = "small", color: color = "black" })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
        tooltip: text,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
            sx: {
                padding: "0 4px"
            },
            size: size,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                fill: color,
                fontSize: size
            })
        })
    });
var $dfe88cc496d1e86b$export$2e2bcd8739ae039 = $dfe88cc496d1e86b$var$InfoPopover;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $gd5y7 = parcelRequire("gd5y7");
var $6lXkL = parcelRequire("6lXkL");
var $ab7Se = parcelRequire("ab7Se");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $c6e8aaa394c7c23b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 1h6v2H9zm10.03 6.39 1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61M13 14h-2V8h2z"
}), "Timer");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $29f855caffb40343$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6z"
}), "AttachFile");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $e64b66a0287a27e1$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($e64b66a0287a27e1$exports, "__esModule", {
    value: true
});
$e64b66a0287a27e1$exports.default = void 0;

var $e64b66a0287a27e1$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e64b66a0287a27e1$var$_default = $e64b66a0287a27e1$exports.default = (0, $e64b66a0287a27e1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy");



var $OEVqP = parcelRequire("OEVqP");
var $gd5y7 = parcelRequire("gd5y7");

var $iDAOR = parcelRequire("iDAOR");


/**
 * @constructor
 */ const $e93b3917ab2b84b0$var$CopyToClipboard = ({ data: data, title: title, infoPopover: infoPopover = true, customMessageOnCopy: customMessageOnCopy })=>{
    const { snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const inputRef = (0, $acw62.useRef)(null);
    const handleCopied = async (target, postAction)=>{
        const copiedValue = target.value;
        await navigator.clipboard.writeText(copiedValue);
        if (postAction && typeof postAction === "function") postAction();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
        className: "form-group-container media-url-container",
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                children: [
                    title,
                    infoPopover && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                        text: typeof infoPopover === "string" ? infoPopover : "Click to copy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                    name: "media-url",
                    variant: (0, $iDAOR.VARIANT_ENUM).outlined,
                    text: data,
                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e64b66a0287a27e1$exports))), {
                        style: {
                            cursor: "pointer",
                            color: "#91A0AD"
                        },
                        onClick: ()=>inputRef.current && handleCopied(inputRef.current, ()=>snackbarSuccess(customMessageOnCopy || `URL ${data} was copied!`))
                    }),
                    style: {
                        height: "auto"
                    },
                    inputRef: inputRef
                })
            })
        ]
    });
};
var $e93b3917ab2b84b0$export$2e2bcd8739ae039 = $e93b3917ab2b84b0$var$CopyToClipboard;


const $be9ce15777946433$var$UploadVTTInput = ({ token: token })=>{
    const { snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [fileURL, setFileURL] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const { mutations: { uploadVTT: { mutate: mutate, isLoading: isLoading, data: data } } } = (0, $d0a01e33b734bdf6$export$2e2bcd8739ae039)(token);
    (0, $acw62.useEffect)(()=>{
        if (typeof data === "string") try {
            const resp = JSON.parse(data);
            if (resp?.data?.fileURL) setFileURL(resp?.data?.fileURL);
        } catch (e) {
            console.error(`Error parsing data`, e);
        }
    }, [
        data
    ]);
    const handleUploadVTT = (ev)=>{
        const file = ev.target?.files[0];
        if (!file || !(0, $5dc958303e06c3a5$export$9c47d206252ffa27).includes(file?.type)) {
            snackbarWarning(`Invalid file type selected as VTT file only "${(0, $5dc958303e06c3a5$export$9c47d206252ffa27).map((f)=>f.split("/")[1]).join(", ")}" types are allowed!`);
            return;
        }
        mutate(file);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                className: "form-group-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    className: "file-input-controller",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                        component: "label",
                        disabled: isLoading,
                        startIcon: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6e8aaa394c7c23b$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29f855caffb40343$export$2e2bcd8739ae039), {
                            style: {
                                cursor: "pointer",
                                color: "#91A0AD"
                            }
                        }),
                        variant: "outlined",
                        children: [
                            "Click to attach or update VTT file",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab7Se.default), {
                                name: "file",
                                type: "file",
                                onChange: handleUploadVTT,
                                inputProps: {
                                    accept: ".vtt",
                                    title: "Click to attach or update VTT file"
                                },
                                hidden: true
                            })
                        ]
                    })
                })
            }),
            fileURL && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e93b3917ab2b84b0$export$2e2bcd8739ae039), {
                data: fileURL,
                title: "Copy VTT File URL"
            })
        ]
    });
};
var $be9ce15777946433$export$2e2bcd8739ae039 = $be9ce15777946433$var$UploadVTTInput;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $OEVqP = parcelRequire("OEVqP");
var $gd5y7 = parcelRequire("gd5y7");

var $6vVdw = parcelRequire("6vVdw");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6lpak = parcelRequire("6lpak");

var $jTnBY = parcelRequire("jTnBY");

var $7Frhn = parcelRequire("7Frhn");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)("MuiAlert", slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $beCSm.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "colorSuccess",
    "colorInfo",
    "colorWarning",
    "colorError",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;



var $9Lykx = parcelRequire("9Lykx");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");



var $ldBGF = parcelRequire("ldBGF");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $d7b9f0ef25189a24$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color || severity)}`,
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1da0e229d53b4459$export$69aecd24bc2cf7e3), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === "light" ? (0, $kSnzZ.darken) : (0, $kSnzZ.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $kSnzZ.lighten) : (0, $kSnzZ.darken);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px",
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "standard"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "outlined"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "filled"
                    },
                    style: (0, $8nd05.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eec239707c48bf2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $611e456547a52fc7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7987087272cca1$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76204164d2201318$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $1En50.default)(props, $d7b9f0ef25189a24$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $8nd05.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $8nd05.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $6lpak.default)("closeButton", {
        elementType: (0, $9Lykx.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $6lpak.default)("closeIcon", {
        elementType: (0, $ldBGF.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d7b9f0ef25189a24$var$AlertRoot, (0, $8nd05.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, (0, $8nd05.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, (0, $8nd05.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
$d7b9f0ef25189a24$var$Alert.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the alert.
   */ action: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */ closeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        CloseButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        CloseIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        closeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */ iconMapping: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        success: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        warning: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    }),
    /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */ severity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "error",
            "info",
            "success",
            "warning"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ]),
        closeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        closeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   * @default 'standard'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "filled",
            "outlined",
            "standard"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;


const $35f5cb900290ac99$var$WrongFieldComponent = ({ fieldKey: fieldKey, message: message = `Wrong condition was applied for field "${fieldKey}"` })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
            severity: "warning",
            children: message
        })
    });
var $35f5cb900290ac99$export$2e2bcd8739ae039 = $35f5cb900290ac99$var$WrongFieldComponent;


const $af92efe3ba553e0f$var$TagFieldComponent = ({ fieldKey: fieldKey })=>{
    const [{ errors: errors, formInputFields: formInputFields }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const tags = formInputFields[fieldKey];
    const inputRef = (0, $acw62.useRef)(null);
    const fieldError = errors[fieldKey];
    if (!tags) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35f5cb900290ac99$export$2e2bcd8739ae039), {
        fieldKey: fieldKey
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
        className: `form-group-container ${fieldError ? "error-field-group" : ""}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                children: [
                    tags.label && tags.label,
                    tags.popoverText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                        text: tags.popoverText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                error: !!fieldError,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "chip-container",
                    onClick: ()=>{
                        inputRef.current?.focus();
                    },
                    children: [
                        tags.value && tags.value.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))), {
                                className: "tags-chip",
                                theme: (0, $6vVdw.THEME_ENUM).v2,
                                type: (0, $6vVdw.TYPE_ENUM).gray,
                                data: {
                                    text: t.text,
                                    id: t.id
                                },
                                onDelete: ()=>(0, $3f43b861fb5eed68$export$ad5fc744e8547a15)(dispatch, t, tags)
                            }, `chip-${t.id}`)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "text",
                            onKeyDown: (ev)=>(0, $3f43b861fb5eed68$export$fca196045f4c24a3)(dispatch, ev, tags, inputRef),
                            placeholder: "Add a tag",
                            ref: inputRef
                        })
                    ]
                })
            })
        ]
    });
};
var $af92efe3ba553e0f$export$2e2bcd8739ae039 = $af92efe3ba553e0f$var$TagFieldComponent;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $OEVqP = parcelRequire("OEVqP");
var $gd5y7 = parcelRequire("gd5y7");





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $i32L9 = parcelRequire("i32L9");
const $c1bd0ce53b58c1c0$var$FieldHinterText = ({ text: text, errors: errors })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            text && typeof errors === "undefined" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                children: text
            }),
            errors?.length > 0 && errors.map((err)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                    error: true,
                    color: "error",
                    children: err
                }, err))
        ]
    });
var $c1bd0ce53b58c1c0$export$2e2bcd8739ae039 = $c1bd0ce53b58c1c0$var$FieldHinterText;



const $04071252e2237c5d$var$SelectFieldComponent = ({ fieldKey: fieldKey })=>{
    const [{ errors: errors, formInputFields: formInputFields }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const selectField = formInputFields[fieldKey];
    const fieldErrors = errors[fieldKey];
    // options should contain at least one item which value is not empty
    const optionsCondition = Array.isArray(selectField?.options) && selectField.options?.filter((v)=>!!v).length > 0;
    const valueTypeCondition = selectField.isMultiple && !Array.isArray(selectField.value);
    if (!selectField || !optionsCondition || valueTypeCondition) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35f5cb900290ac99$export$2e2bcd8739ae039), {
        fieldKey: fieldKey,
        message: `Wrong field name: "${fieldKey}" was provided as select field or options does not exist!`
    });
    const defaultSelectValue = selectField.value || "";
    if (defaultSelectValue === "" && selectField.defaultValue && selectField.options?.filter((v)=>v.value === "").length === 0) selectField.options.unshift(selectField.defaultValue);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
        className: `form-group-container ${fieldErrors ? "error-field-group" : ""}`,
        children: [
            (selectField.label || selectField.popoverText) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                children: [
                    selectField.label && selectField.label,
                    selectField.popoverText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                        text: selectField.popoverText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                error: !!fieldErrors,
                sx: {
                    maxWidth: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))), {
                        value: selectField.value,
                        items: selectField.options,
                        multipleType: (0, $6392f5418b4c6f5d$exports.MULTIPLE_TYPE_ENUM).checkmark,
                        onChange: (value)=>(0, $3f43b861fb5eed68$export$3a465d426c5d6d9b)(dispatch, selectField, value),
                        isMultiple: !!selectField.isMultiple,
                        renderValue: true,
                        isFullWidth: true
                    }),
                    selectField.hinterText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1bd0ce53b58c1c0$export$2e2bcd8739ae039), {
                        text: selectField.hinterText,
                        errors: fieldErrors
                    })
                ]
            })
        ]
    });
};
var $04071252e2237c5d$export$2e2bcd8739ae039 = $04071252e2237c5d$var$SelectFieldComponent;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $OEVqP = parcelRequire("OEVqP");
var $gd5y7 = parcelRequire("gd5y7");

var $iDAOR = parcelRequire("iDAOR");




const $e2af5e0efbed2d61$var$TextInputFieldComponent = ({ fieldKey: fieldKey })=>{
    const [{ errors: errors, formInputFields: formInputFields }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const textField = formInputFields[fieldKey];
    const fieldErrors = errors[fieldKey];
    if (!textField) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35f5cb900290ac99$export$2e2bcd8739ae039), {
        fieldKey: fieldKey
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
        className: `form-group-container ${fieldErrors ? "error-field-group" : ""}`,
        children: [
            textField && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                children: textField?.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                error: !!fieldErrors,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                        id: "media-title",
                        name: textField.name,
                        variant: (0, $iDAOR.VARIANT_ENUM).outlined,
                        text: (textField.value || textField?.defaultValue)?.toString() || "",
                        style: {
                            height: "auto"
                        },
                        onTextChange: (text)=>(0, $3f43b861fb5eed68$export$3a465d426c5d6d9b)(dispatch, textField, text)
                    }),
                    textField.hinterText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1bd0ce53b58c1c0$export$2e2bcd8739ae039), {
                        text: textField.hinterText,
                        errors: fieldErrors
                    })
                ]
            })
        ]
    });
};
var $e2af5e0efbed2d61$export$2e2bcd8739ae039 = $e2af5e0efbed2d61$var$TextInputFieldComponent;


const $66c147be7aae7bee$export$28cbd05bc0fa924e = ({ text: text, errors: errors })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            text && typeof errors === "undefined" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                children: text
            }),
            errors?.length > 0 && errors.map((err)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                    error: true,
                    color: "error",
                    children: err
                }, err))
        ]
    });
/**
 * SingleVideoEditor
 * @param useFormSate
 * @constructor
 */ const $66c147be7aae7bee$var$SingleMediaEditor = ({ video: video })=>{
    const [{ formInputFields: formInputFields, errors: errors }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const { title: title, description: description, tags: tags, category: category, domain: domain } = formInputFields;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        id: "media-editor-form-container",
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2af5e0efbed2d61$export$2e2bcd8739ae039), {
                fieldKey: title.name
            }),
            description && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                className: `form-group-container ${errors?.description && "error-field-group"}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                        children: [
                            description.label,
                            description.popoverText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                                text: description.popoverText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                        error: !!errors?.description,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a4c397b48b889d5$exports))), {
                                name: description.name || "description",
                                rows: 6,
                                placeholder: "Add a description",
                                text: description.value?.toString() || "",
                                hasError: !!errors.description,
                                onTextChange: (value)=>(0, $3f43b861fb5eed68$export$3a465d426c5d6d9b)(dispatch, description, value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($66c147be7aae7bee$export$28cbd05bc0fa924e, {
                                text: description.hinterText,
                                errors: errors?.description
                            })
                        ]
                    })
                ]
            }),
            category && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04071252e2237c5d$export$2e2bcd8739ae039), {
                fieldKey: category.name
            }),
            domain && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04071252e2237c5d$export$2e2bcd8739ae039), {
                fieldKey: domain.name
            }),
            tags && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af92efe3ba553e0f$export$2e2bcd8739ae039), {
                fieldKey: tags.name
            }),
            video.default_stream?.url && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e93b3917ab2b84b0$export$2e2bcd8739ae039), {
                data: video.default_stream?.url,
                title: "Media Link"
            }),
            video.token && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be9ce15777946433$export$2e2bcd8739ae039), {
                token: video.token
            })
        ]
    });
};
var $66c147be7aae7bee$export$2e2bcd8739ae039 = $66c147be7aae7bee$var$SingleMediaEditor;











const $8a5583bf677b99f2$export$1f64eb0cdf956878 = ({ type: type, isOpen: isOpen, onClose: onClose, asAdmin: asAdmin })=>{
    const [{ formInputFields: formInputFields, errors: errors }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const excludedTagInputRef = (0, $acw62.useRef)();
    const tagInputRef = (0, $acw62.useRef)();
    const { title: title, tags: tags, categories: categories, excludedTags: excludedTags, sort: sort } = formInputFields;
    const { api: api } = (0, $d91039711271eba9$export$2e2bcd8739ae039)();
    const { snackbarError: snackbarError, snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [selectedCategories, setSelectedCategories] = (0, $acw62.useState)([]);
    const [selectedVideos, setSelectedVideos] = (0, $acw62.useState)([]);
    const [sortedVideos, setSortedVideos] = (0, $acw62.useState)([]);
    const [isAddVideosModalOpen, setIsAddVideosModalOpen] = (0, $acw62.useState)(false);
    // Set default sort type when modal opens
    (0, $acw62.useEffect)(()=>{
        if (type === "custom" && !sort.value) (0, $3f43b861fb5eed68$export$3a465d426c5d6d9b)(dispatch, sort, "newest");
    }, [
        type,
        sort.value,
        dispatch,
        sort
    ]);
    const parseFormToRequestData = ()=>{
        const data = {
            title: title.value,
            key: title.value.trim().replace(/ /g, "-"),
            sortType: sort.value,
            categories: categories.value,
            tags: tags.value.map((tag)=>tag.text),
            excludedTags: excludedTags.value.map((tag)=>tag.text),
            ...publisherSlug && {
                slug: publisherSlug
            }
        };
        if (type === "category") {
            delete data.excludedTags;
            delete data.tags;
        } else if (type === "custom") {
            delete data.excludedTags;
            delete data.tags;
            delete data.categories;
            // Send videos in the sorted order
            data.medias = sortedVideos.map((video)=>video.token);
        } else delete data.categories;
        return data;
    };
    const cleanAndCloseForm = ()=>{
        dispatch({
            type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).RESET_FORM,
            payload: {
                ...formInputFields,
                sort: {
                    ...sort,
                    value: ""
                },
                categories: {
                    ...categories,
                    value: []
                },
                tags: {
                    ...tags,
                    value: []
                },
                excludedTags: {
                    ...excludedTags,
                    value: []
                },
                title: {
                    ...title,
                    value: ""
                }
            }
        });
        onClose();
    };
    const handleSelect = (value)=>{
        setSelectedCategories(value);
        (0, $3f43b861fb5eed68$export$3a465d426c5d6d9b)(dispatch, categories, value);
    };
    const handleRequestByType = (data)=>{
        setIsLoading(true);
        const onSuccess = ()=>{
            dispatch({
                type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).SET_FORM_SUBMITTED
            });
            snackbarSuccess(`Playlist ${data.title} created`);
            cleanAndCloseForm();
        };
        const onError = (error)=>{
            const errorMessage = error?.message || "Something went wrong, try again later";
            snackbarError(errorMessage);
        };
        if (type === "category") api.createByCategory(data, {
            onSuccess: onSuccess,
            onError: onError,
            onSettled: ()=>setIsLoading(false)
        });
        else if (type === "custom") api.create(data, {
            onSuccess: onSuccess,
            onError: onError,
            onSettled: ()=>setIsLoading(false)
        });
        else api.createByTag(data, {
            onSuccess: onSuccess,
            onError: onError,
            onSettled: ()=>setIsLoading(false)
        });
    };
    const submitHandler = async (ev)=>{
        ev.preventDefault();
        const data = parseFormToRequestData();
        (0, $3f43b861fb5eed68$export$e02251cfbe407ee6)(dispatch, errors, data, handleRequestByType);
    };
    const allRequiredIsFilled = ()=>{
        const formFieldsValid = !Object.keys(formInputFields).some((k)=>formInputFields[k].required && !formInputFields[k].value);
        return formFieldsValid;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
            title: `${type === "custom" ? "Create a new custom playlist" : `Generate Playlist by ${(0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(type)}`}`,
            content: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {
                    style: {
                        height: 50,
                        width: 50,
                        margin: 50
                    }
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "content-box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    id: "media-editor-form-container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-around",
                            gap: 2,
                            children: [
                                title && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                    className: `form-group-container ${errors?.title && "error-field-group"}`,
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                                            children: title.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                                            error: !!errors?.title,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                                                    id: "media-title",
                                                    name: title.name || "title",
                                                    variant: (0, $iDAOR.VARIANT_ENUM).outlined,
                                                    text: title.value?.toString() || "",
                                                    style: {
                                                        height: "auto",
                                                        width: "100%"
                                                    },
                                                    onTextChange: (text)=>(0, $3f43b861fb5eed68$export$3a465d426c5d6d9b)(dispatch, title, text)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66c147be7aae7bee$export$28cbd05bc0fa924e), {
                                                    text: title.hinterText,
                                                    errors: errors?.title
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                sort && sort.options && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                    className: `form-group-container ${errors?.sort && "error-field-group"}`,
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                                            style: {
                                                marginLeft: 16
                                            },
                                            children: [
                                                sort.label,
                                                sort.popoverText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                                                    text: sort.popoverText
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                                            error: !!errors?.sort,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))), {
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    value: sort.value,
                                                    items: type === "custom" ? sort.options : sort.options.filter((option)=>option.value !== "manual"),
                                                    onChange: (value)=>(0, $3f43b861fb5eed68$export$3a465d426c5d6d9b)(dispatch, sort, value)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66c147be7aae7bee$export$28cbd05bc0fa924e), {
                                                    text: sort.hinterText,
                                                    errors: errors?.sort
                                                })
                                            ]
                                        }),
                                        sort.value === "shuffle" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                marginTop: 1,
                                                fontStyle: "italic",
                                                fontSize: "12px"
                                            },
                                            children: "Preview won't reflect the shuffled playback sequence."
                                        })
                                    ]
                                })
                            ]
                        }),
                        type === "category" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: categories && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                className: `form-group-container ${errors?.categories && "error-field-group"}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                                        children: [
                                            categories.label,
                                            categories.popoverText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                                                text: categories.popoverText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                                        error: !!errors?.categories,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))), {
                                            value: selectedCategories,
                                            items: (0, $e4f44006c888bb84$export$3ee9b4aab65c61a7).map((cat)=>({
                                                    text: cat.name,
                                                    value: cat.name?.toLowerCase()
                                                })),
                                            multipleType: (0, $6392f5418b4c6f5d$exports.MULTIPLE_TYPE_ENUM).checkmark,
                                            size: (0, $6392f5418b4c6f5d$exports.SIZE_ENUM).small,
                                            onChange: (value)=>handleSelect(value),
                                            isMultiple: true
                                        })
                                    })
                                ]
                            })
                        }),
                        type === "custom" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fece7a82ef7bf50b$export$2e2bcd8739ae039), {
                                selectedVideos: selectedVideos,
                                setSelectedVideos: setSelectedVideos,
                                sortValue: sort.value,
                                publisherSlug: publisherSlug,
                                asAdmin: asAdmin,
                                isAddVideosModalOpen: isAddVideosModalOpen,
                                setIsAddVideosModalOpen: setIsAddVideosModalOpen,
                                onSortedVideosChange: setSortedVideos
                            })
                        }),
                        type === "tag" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                tags && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                    className: `form-group-container ${errors?.tags && "error-field-group"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                                            children: [
                                                tags.label,
                                                tags.popoverText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                                                    text: tags.popoverText
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                                            error: !!errors?.tags,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                className: "chip-container-tag",
                                                onClick: ()=>{
                                                    tagInputRef.current?.focus();
                                                },
                                                children: [
                                                    tags.value && tags.value.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))), {
                                                            theme: (0, $iDAOR.THEME_ENUM).v2,
                                                            type: (0, $6vVdw.TYPE_ENUM).gray,
                                                            data: {
                                                                text: t.text,
                                                                id: t.id
                                                            },
                                                            onDelete: ()=>(0, $3f43b861fb5eed68$export$ad5fc744e8547a15)(dispatch, t, tags)
                                                        }, `chip-${t.id}`)),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "tag",
                                                        type: "text",
                                                        onKeyDown: (ev)=>(0, $3f43b861fb5eed68$export$fca196045f4c24a3)(dispatch, ev, tags, tagInputRef),
                                                        placeholder: "Add a tag",
                                                        ref: tagInputRef
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                excludedTags && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                    className: `form-group-container ${errors?.excludedTags && "error-field-group"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $OEVqP.default), {
                                            children: [
                                                excludedTags.label,
                                                excludedTags.popoverText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfe88cc496d1e86b$export$2e2bcd8739ae039), {
                                                    text: excludedTags.popoverText
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                                            error: !!errors?.excludedTags,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                className: "chip-container-tag",
                                                onClick: ()=>{
                                                    excludedTagInputRef.current?.focus();
                                                },
                                                children: [
                                                    excludedTags.value && excludedTags.value.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))), {
                                                            className: "excluded-chip",
                                                            theme: (0, $iDAOR.THEME_ENUM).v2,
                                                            type: (0, $6vVdw.TYPE_ENUM).gray,
                                                            data: {
                                                                text: t.text,
                                                                id: t.id
                                                            },
                                                            onDelete: ()=>(0, $3f43b861fb5eed68$export$ad5fc744e8547a15)(dispatch, t, excludedTags)
                                                        }, `chip-${t.id}`)),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "exclued-tag",
                                                        type: "text",
                                                        onKeyDown: (ev)=>(0, $3f43b861fb5eed68$export$fca196045f4c24a3)(dispatch, ev, excludedTags, excludedTagInputRef),
                                                        placeholder: "Add a tag",
                                                        ref: excludedTagInputRef
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            isOpen: isOpen,
            onClose: onClose,
            submitButtonText: "Generate",
            cancelButtonText: "cancel",
            onSubmit: submitHandler,
            isSubmitButtonEnabled: allRequiredIsFilled()
        })
    });
};



function $658198d280171c3b$export$2e2bcd8739ae039({ type: type, isOpen: isOpen, onClose: onClose, asAdmin: asAdmin }) {
    const formInitialState = {
        title: {
            name: "title",
            label: "Playlist Title",
            type: "text",
            required: true,
            rules: {
                length: {
                    min: 5
                }
            },
            value: "",
            popoverText: "Title of the playlist",
            hinterText: "*required"
        },
        sort: {
            name: "sort",
            label: "Video Sort",
            type: "select",
            required: true,
            value: "",
            options: (0, $5dc958303e06c3a5$export$4bc22197a004b096),
            popoverText: "Please select a sort type"
        },
        tags: {
            name: "tags",
            label: "Tags",
            type: "chip",
            value: [],
            popoverText: "Commas or semicolon will separate the tags"
        },
        excludedTags: {
            name: "excludedTags",
            label: "Excluded Tags",
            type: "chip",
            value: [],
            popoverText: "Commas or semicolon will separate the tags"
        },
        categories: {
            name: "categories",
            label: "Categories",
            type: "chip",
            value: [],
            popoverText: "Commas or semicolon will separate the Categories"
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $366ccbbe6fb31b36$export$8ce1ff4f94d08846), {
        formInputFields: formInitialState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a5583bf677b99f2$export$1f64eb0cdf956878), {
            isOpen: isOpen,
            onClose: onClose,
            type: type,
            asAdmin: asAdmin
        })
    });
}



// useURLParams.ts

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $f1q41 = parcelRequire("f1q41");
function $fa18b1697d991a50$export$560024ff4d816068() {
    const history = (0, $kfZjc.useHistory)();
    const location = (0, $kfZjc.useLocation)();
    // Base function to update any URL param
    const updateParam = (0, $acw62.useCallback)((paramName, value)=>{
        const searchParams = new URLSearchParams(location.search);
        if (value === null || Array.isArray(value) && value.length === 0) searchParams.delete(paramName);
        else if (Array.isArray(value)) searchParams.set(paramName, value.join(","));
        else searchParams.set(paramName, value);
        history.push({
            search: searchParams.toString()
        });
    }, [
        history,
        location.search
    ]);
    // Debounced search param update
    const debouncedUpdateSearch = (0, $acw62.useCallback)((0, $f1q41.debounce)((search)=>{
        updateParam("search", search || null);
    }, 300), [
        updateParam
    ]);
    // Handle autocomplete selections (categories, tags, types, etc.)
    const updateAutocompleteParam = (0, $acw62.useCallback)((paramName, items, propName = "id")=>{
        if (items.length > 0) updateParam(paramName, items.map((item)=>String(item[propName])));
        else updateParam(paramName, null);
    }, [
        updateParam
    ]);
    // Handle date range
    const updateDateRangeParams = (0, $acw62.useCallback)((range)=>{
        const searchParams = new URLSearchParams(location.search);
        if (range?.from) searchParams.set("fromDate", range.from.toISOString());
        else searchParams.delete("fromDate");
        if (range?.to) searchParams.set("toDate", range.to.toISOString());
        else searchParams.delete("toDate");
        history.push({
            search: searchParams.toString()
        });
    }, [
        history,
        location.search
    ]);
    // Parse params from URL
    const getParamAsArray = (0, $acw62.useCallback)((paramName)=>{
        const searchParams = new URLSearchParams(location.search);
        const param = searchParams.get(paramName);
        return param ? decodeURIComponent(param).split(",") : [];
    }, [
        location.search
    ]);
    const getParamAsString = (0, $acw62.useCallback)((paramName)=>{
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get(paramName) || "";
    }, [
        location.search
    ]);
    const getParamAsDateRange = (0, $acw62.useCallback)(()=>{
        const searchParams = new URLSearchParams(location.search);
        const fromDateStr = searchParams.get("fromDate");
        const toDateStr = searchParams.get("toDate");
        if (!fromDateStr && !toDateStr) return undefined;
        return {
            from: fromDateStr ? new Date(fromDateStr) : undefined,
            to: toDateStr ? new Date(toDateStr) : undefined
        };
    }, [
        location.search
    ]);
    return {
        debouncedUpdateSearch: debouncedUpdateSearch,
        updateAutocompleteParam: updateAutocompleteParam,
        updateDateRangeParams: updateDateRangeParams,
        getParamAsArray: getParamAsArray,
        getParamAsString: getParamAsString,
        getParamAsDateRange: getParamAsDateRange
    };
}


function $aa205eac0ff8b9e3$export$2e2bcd8739ae039({ asAdmin: asAdmin, publisherSlug: publisherSlug, publisherGroup: publisherGroup, publisherUsername: publisherUsername, onChangeSelected: onChangeSelected, createOptions: copt, selectedPlaylists: selectedPlaylists, generateFormType: generateFormType, closeGenerateForm: closeGenerateForm }) {
    const [search, setSearch] = (0, $acw62.useState)("");
    const [query, setQuery] = (0, $acw62.useState)({});
    const [showPlaylist, setShowPlaylist] = (0, $acw62.useState)(false);
    const { snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [playlistType, setPlaylistType] = (0, $acw62.useState)([]);
    const [dateRange, setDateRange] = (0, $acw62.useState)();
    const { debouncedUpdateSearch: debouncedUpdateSearch, updateAutocompleteParam: updateAutocompleteParam, updateDateRangeParams: updateDateRangeParams, getParamAsArray: getParamAsArray, getParamAsString: getParamAsString, getParamAsDateRange: getParamAsDateRange } = (0, $fa18b1697d991a50$export$560024ff4d816068)();
    const { playlists: playlists, query: { isFetching: isFetching, isFetched: isFetched } } = (0, $d91039711271eba9$export$2e2bcd8739ae039)(query);
    // Handle toggling selection for all Playlists
    const handleToggleAll = (checked)=>{
        if (!checked) {
            onChangeSelected([]);
            return;
        }
        if (playlists.length === 0) {
            snackbarWarning("The Playlist Library is empty.");
            return;
        }
        const selectedTokens = playlists.map((playlist)=>playlist.token);
        onChangeSelected(selectedTokens);
    };
    // Handle toggling selection for a single Playlist
    const handlePlaylistToggle = (playlistToken, isSelected)=>{
        if (isSelected) onChangeSelected([
            ...selectedPlaylists,
            playlistToken
        ]);
        else onChangeSelected(selectedPlaylists.filter((token)=>token !== playlistToken));
    };
    const handleSearch = (value)=>{
        setSearch(value);
        debouncedUpdateSearch(value);
    };
    const handleType = (types)=>{
        setPlaylistType(types);
        updateAutocompleteParam("playlistType", types, "name");
    };
    const handleDateChange = (range)=>{
        setDateRange(range);
        updateDateRangeParams(range);
    };
    (0, $acw62.useEffect)(()=>{
        const searchParam = getParamAsString("search");
        const typeParam = getParamAsArray("playlistType");
        const range = getParamAsDateRange();
        setSearch(searchParam);
        setPlaylistType((0, $5dc958303e06c3a5$export$9c5f6903d23b4822).filter((type)=>typeParam.includes(type.name)));
        setDateRange(range);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const playlistQuery = {
            ...asAdmin && {
                asAdmin: asAdmin
            },
            ...search.length >= (0, $5dc958303e06c3a5$export$7f95b2bd5443b7af) && {
                title: search || ""
            },
            ...publisherSlug && {
                slug: publisherSlug
            },
            ...playlistType.length > 0 && {
                type: playlistType.map((type)=>type.name?.toLowerCase())
            },
            ...dateRange && dateRange.to && dateRange.from && {
                date_range: dateRange
            }
        };
        setQuery(playlistQuery);
    }, [
        search,
        playlistType,
        dateRange,
        publisherSlug,
        asAdmin
    ]);
    (0, $acw62.useEffect)(()=>{
        setShowPlaylist(asAdmin && Boolean(publisherSlug) || !asAdmin);
    }, [
        asAdmin,
        publisherSlug
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                item: true,
                xs: 12,
                md: 12,
                spacing: 2,
                justifyContent: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: "auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db95cc6529792278$export$2e2bcd8739ae039), {
                            placeholder: "Search",
                            text: search,
                            onTextChange: handleSearch
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: "auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb471419d711cdd8$export$2e2bcd8739ae039), {
                            value: playlistType,
                            onChange: handleType
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: "auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f195e6d38f66fca$export$5109c6dd95d8fb00), {
                            value: dateRange,
                            onDateRangeChange: (selectedDate)=>handleDateChange(selectedDate)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                variant: "fullWidth",
                sx: {
                    mt: "21px",
                    borderColor: "transparent"
                }
            }),
            !isFetched && isFetching ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d803cf99079fa048$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    copt?.isVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9e4e4f1e24f1be78$export$2e2bcd8739ae039), {
                        publisherGroup: publisherGroup,
                        username: publisherUsername,
                        onClose: copt.onClose,
                        onSubmit: copt.onSubmit
                    }),
                    generateFormType && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $658198d280171c3b$export$2e2bcd8739ae039), {
                        asAdmin: asAdmin,
                        type: generateFormType,
                        isOpen: !!generateFormType,
                        onClose: closeGenerateForm
                    }),
                    showPlaylist && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdec3f5ba465419$export$2e2bcd8739ae039), {
                        playlists: playlists,
                        selectedPlaylists: selectedPlaylists,
                        onToggleAll: handleToggleAll,
                        onPlaylistToggle: handlePlaylistToggle
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lkxXU = parcelRequire("lkxXU");

var $dgtCa = parcelRequire("dgtCa");

var $1GFtd = parcelRequire("1GFtd");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $a16d4fe828609408$exports = {};
"use strict";
var $a16d4fe828609408$var$__createBinding = $a16d4fe828609408$exports && $a16d4fe828609408$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a16d4fe828609408$var$__exportStar = $a16d4fe828609408$exports && $a16d4fe828609408$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a16d4fe828609408$var$__createBinding(exports1, m, p);
};
var $a16d4fe828609408$var$__importDefault = $a16d4fe828609408$exports && $a16d4fe828609408$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a16d4fe828609408$exports, "__esModule", {
    value: true
});
$a16d4fe828609408$exports.THEME_ENUM = $a16d4fe828609408$exports.BACKGROUND_ENUM = void 0;

const $a16d4fe828609408$var$krg_tabs_react_1 = $a16d4fe828609408$var$__importDefault((parcelRequire("qZSsd")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($a16d4fe828609408$exports, "BACKGROUND_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.BACKGROUND_ENUM;
    }
});
Object.defineProperty($a16d4fe828609408$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$a16d4fe828609408$var$__exportStar((parcelRequire("4eFsB")), $a16d4fe828609408$exports);

$a16d4fe828609408$var$__exportStar((parcelRequire("i0PuK")), $a16d4fe828609408$exports);
$a16d4fe828609408$exports.default = $a16d4fe828609408$var$krg_tabs_react_1.default;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $iuSDM = parcelRequire("iuSDM");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e1ec0b0c4e143dec$export$427f1c1e2e839f85(slot) {
    return (0, $4Cod0.default)("MuiPagination", slot);
}
const $e1ec0b0c4e143dec$var$paginationClasses = (0, $beCSm.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
var $e1ec0b0c4e143dec$export$2e2bcd8739ae039 = $e1ec0b0c4e143dec$var$paginationClasses;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $agZ85 = parcelRequire("agZ85");
"use client";
const $fcf3350ab6dcf91e$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $fcf3350ab6dcf91e$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = "usePagination", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $1En50.default)(props, $fcf3350ab6dcf91e$var$_excluded);
    const [page, setPageState] = (0, $agZ85.default)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled: disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, $8nd05.default)({
        items: items
    }, other);
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $58lXc = parcelRequire("58lXc");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6a3264dc4d579370$export$e4ce0a775adf2f74(slot) {
    return (0, $4Cod0.default)("MuiPaginationItem", slot);
}
const $6a3264dc4d579370$var$paginationItemClasses = (0, $beCSm.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon",
    "colorPrimary",
    "colorSecondary"
]);
var $6a3264dc4d579370$export$2e2bcd8739ae039 = $6a3264dc4d579370$var$paginationItemClasses;



var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $21SL6 = parcelRequire("21SL6");

var $5izos = parcelRequire("5izos");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $26ce82c6cc8a75d9$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5ef22e36056d1791$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $6a273894865f8b08$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $6a273894865f8b08$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const $6a273894865f8b08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, $jTnBY.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `color${(0, $jTnBY.default)(color)}`,
            color !== "standard" && `${variant}${(0, $jTnBY.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6a3264dc4d579370$export$e4ce0a775adf2f74), classes);
};
const $6a273894865f8b08$var$PaginationItemEllipsis = (0, $d8seH.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const $6a273894865f8b08$var$PaginationItemPage = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === "text" && {
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: (0, $8nd05.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: (0, $8nd05.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $6a273894865f8b08$var$PaginationItemPageIcon = (0, $d8seH.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $6a273894865f8b08$var$PaginationItem = /*#__PURE__*/ $acw62.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className: className, color: color = "standard", component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = "circular", size: size = "medium", slots: slots = {}, type: type = "page", variant: variant = "text" } = props, other = (0, $1En50.default)(props, $6a273894865f8b08$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const isRtl = (0, $58lXc.useRtl)();
    const classes = $6a273894865f8b08$var$useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, $5ef22e36056d1791$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $26ce82c6cc8a75d9$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $21SL6.default),
        first: slots.last || components.last || (0, $5izos.default)
    } : {
        previous: slots.previous || components.previous || (0, $26ce82c6cc8a75d9$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $5ef22e36056d1791$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $21SL6.default),
        last: slots.last || components.last || (0, $5izos.default)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($6a273894865f8b08$var$PaginationItemPage, (0, $8nd05.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
$6a273894865f8b08$var$PaginationItem.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary",
            "standard"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        first: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        last: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        next: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        previous: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The current page number.
   */ page: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true` the pagination item is selected.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The shape of the pagination item.
   * @default 'circular'
   */ shape: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "circular",
        "rounded"
    ]),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "small",
            "medium",
            "large"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        first: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        last: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        next: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        previous: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The type of pagination item.
   * @default 'page'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "end-ellipsis",
        "first",
        "last",
        "next",
        "page",
        "previous",
        "start-ellipsis"
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "outlined",
            "text"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $6a273894865f8b08$export$2e2bcd8739ae039 = $6a273894865f8b08$var$PaginationItem;



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $081224c8d3cb055f$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $081224c8d3cb055f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e1ec0b0c4e143dec$export$427f1c1e2e839f85), classes);
};
const $081224c8d3cb055f$var$PaginationRoot = (0, $d8seH.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $081224c8d3cb055f$var$PaginationUl = (0, $d8seH.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function $081224c8d3cb055f$var$defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const $081224c8d3cb055f$var$Pagination = /*#__PURE__*/ $acw62.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = "standard", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $081224c8d3cb055f$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a273894865f8b08$export$2e2bcd8739ae039), (0, $8nd05.default)({}, item)), shape: shape = "circular", showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = "medium", variant: variant = "text" } = props, other = (0, $1En50.default)(props, $081224c8d3cb055f$var$_excluded);
    const { items: items } = (0, $fcf3350ab6dcf91e$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, $8nd05.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $081224c8d3cb055f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationRoot, (0, $8nd05.default)({
        "aria-label": "pagination navigation",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: renderItem((0, $8nd05.default)({}, item, {
                        color: color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
// @default tags synced with default values from usePagination
$081224c8d3cb055f$var$Pagination.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */ boundaryCount: (0, $iuSDM.default),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "primary",
            "secondary",
            "standard"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The total number of pages.
   * @default 1
   */ count: (0, $iuSDM.default),
    /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */ defaultPage: (0, $iuSDM.default),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */ getItemAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, hide the next-page button.
   * @default false
   */ hideNextButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, hide the previous-page button.
   * @default false
   */ hidePrevButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */ page: (0, $iuSDM.default),
    /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */ renderItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The shape of the pagination items.
   * @default 'circular'
   */ shape: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "circular",
        "rounded"
    ]),
    /**
   * If `true`, show the first-page button.
   * @default false
   */ showFirstButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, show the last-page button.
   * @default false
   */ showLastButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */ siblingCount: (0, $iuSDM.default),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "small",
            "medium",
            "large"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "outlined",
            "text"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $081224c8d3cb055f$export$2e2bcd8739ae039 = $081224c8d3cb055f$var$Pagination;



var $1GFtd = parcelRequire("1GFtd");
const $517324d2bcac817e$var$useStyles = (0, $1GFtd.default)({
    pagination: {
        "& .MuiPaginationItem-page.Mui-selected": {
            backgroundColor: "black",
            color: "white"
        },
        "& .MuiPaginationItem-page": {
            margin: "0 4px"
        },
        "& .MuiPaginationItem-previousNext": {
            margin: 0
        },
        "& .MuiPaginationItem-page.MuiPaginationItem-sizeSmall": {
            fontSize: "12px",
            minWidth: "20px",
            height: "20px"
        }
    }
});
function $517324d2bcac817e$export$2e2bcd8739ae039(props) {
    const classes = $517324d2bcac817e$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $081224c8d3cb055f$export$2e2bcd8739ae039), {
        className: classes.pagination,
        ...props
    });
}


var $cec2c2b565215e8d$export$2e2bcd8739ae039 = (0, $517324d2bcac817e$export$2e2bcd8739ae039);


function $8643838914e5dcec$export$2e2bcd8739ae039({ tabsConfig: tabsConfig }) {
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const itemsPerPage = 4;
    const totalPages = Math.ceil(tabsConfig.tabs.length / itemsPerPage);
    const tabs = tabsConfig.tabs.slice((page - 1) * itemsPerPage, page * itemsPerPage);
    const handlePageChange = (e, value)=>{
        setPage(value);
        const newSelTab = (value - 1) * itemsPerPage + tabsConfig.selectedTab > tabs.length ? 0 : tabsConfig.selectedTab;
        tabsConfig.onChange(null, (value - 1) * itemsPerPage + newSelTab);
    };
    const handleTabSelection = (e, value)=>{
        tabsConfig.onChange(e, (page - 1) * itemsPerPage + value);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        sx: {
            "& .MuiTabs-root .MuiTab-root": {
                borderBottom: 0
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a16d4fe828609408$exports))), {
                variant: (0, (/*@__PURE__*/$parcel$interopDefault($a16d4fe828609408$exports))).VARIANT_ENUM.fullWidth,
                theme: (0, (/*@__PURE__*/$parcel$interopDefault($a16d4fe828609408$exports))).THEME_ENUM.v2,
                ...tabsConfig,
                tabs: tabs,
                onChange: handleTabSelection
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cec2c2b565215e8d$export$2e2bcd8739ae039), {
                count: totalPages,
                page: page,
                onChange: handlePageChange,
                boundaryCount: 1,
                siblingCount: 0,
                size: "small"
            })
        ]
    });
}


var $789836e85fc60e05$export$2e2bcd8739ae039 = (0, $8643838914e5dcec$export$2e2bcd8739ae039);



const $655489ed9310a128$var$useStyles = (0, $1GFtd.default)({
    button: {
        "&.Mui-disabled": {
            "&>div>div": {
                color: "#91A0AD"
            }
        },
        "&>div>div": {
            textTransform: "initial",
            padding: "0"
        }
    }
});
function $655489ed9310a128$export$2e2bcd8739ae039({ buttonsConfig: buttonsConfig, tabsConfig: tabsConfig, sx: sx, children: children }) {
    const classes = $655489ed9310a128$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    ...sx
                },
                className: "SectionNavBar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $789836e85fc60e05$export$2e2bcd8739ae039), {
                        tabsConfig: tabsConfig
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexWrap: "nowrap",
                        position: "relative",
                        children: [
                            buttonsConfig.map((config)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $acw62.createElement)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                                            id: config.id,
                                            style: {
                                                padding: "7px 28px",
                                                minWidth: "120px",
                                                marginLeft: "15px",
                                                whiteSpace: "nowrap"
                                            },
                                            size: (0, $dgtCa.SIZE_ENUM).small,
                                            variant: config.isEnabled ? (0, $dgtCa.VARIANT_ENUM).contained : (0, $dgtCa.VARIANT_ENUM).outlined,
                                            ...config,
                                            key: config.id,
                                            className: `${classes.button} ${config.className}`
                                        }),
                                        config.children && config.children
                                    ]
                                }, config.id)),
                            children
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                variant: "fullWidth",
                sx: {
                    mt: "-1px",
                    mb: "32px",
                    borderBottomWidth: "1px",
                    borderColor: "transparent"
                }
            })
        ]
    });
}




var $dgtCa = parcelRequire("dgtCa");
var $3bf093269ed94b0d$export$2e2bcd8739ae039 = (0, $655489ed9310a128$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
function $9433e1e113201c89$export$2e2bcd8739ae039() {
    const { search: search } = (0, $kfZjc.useLocation)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new URLSearchParams(search), [
        search
    ]);
}


function $80f3bd128133629b$export$2e2bcd8739ae039(parameter, transformer) {
    const queryParams = (0, $9433e1e113201c89$export$2e2bcd8739ae039)();
    const queryParam = queryParams.get(parameter);
    return transformer ? transformer(queryParam) : queryParam;
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $6el2W = parcelRequire("6el2W");
var $3bYfT = parcelRequire("3bYfT");
var $lkxXU = parcelRequire("lkxXU");
var $cVXaD = parcelRequire("cVXaD");

var $1GFtd = parcelRequire("1GFtd");


var $dgtCa = parcelRequire("dgtCa");

var $htqGM = parcelRequire("htqGM");





var $c75a4671c7c1827b$export$32c2c14de5aa8aa1;
(function(PlaylistCreationEnum) {
    PlaylistCreationEnum["TAG"] = "tag";
    PlaylistCreationEnum["CUSTOM"] = "custom";
    PlaylistCreationEnum["CATEGORY"] = "category";
})($c75a4671c7c1827b$export$32c2c14de5aa8aa1 || ($c75a4671c7c1827b$export$32c2c14de5aa8aa1 = {}));


const $b1452a02e8a9e7a9$var$useStyles = (0, $1GFtd.default)({
    paper: {
        display: "flex",
        flexDirection: "column",
        padding: 20,
        borderRadius: 10,
        width: 280
    },
    button: {
        alignSelf: "end",
        marginTop: 17
    },
    checkbox: {
        marginLeft: 11,
        "& .MuiCheckbox-root:not(.Mui-checked)": {
            color: "#91A0AD"
        }
    }
});
function $b1452a02e8a9e7a9$export$2e2bcd8739ae039({ videos: videos, onClose: onClose, onSubmit: onSubmit, anchorEl: anchorEl, asAdmin: asAdmin, publisherSlug: publisherSlug }) {
    const classes = $b1452a02e8a9e7a9$var$useStyles();
    const { snackbarSuccess: snackbarSuccess, snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [search, setSearch] = (0, $acw62.useState)("");
    const [debouncedSearch, setDebouncedSearch] = (0, $acw62.useState)(search);
    const [selectedPlaylists, setSelectedPlaylists] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const timeout = setTimeout(()=>setDebouncedSearch(search), 300);
        return ()=>clearTimeout(timeout);
    }, [
        search
    ]);
    const query = {
        ...asAdmin && {
            asAdmin: asAdmin,
            slug: publisherSlug
        },
        type: [
            (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CUSTOM
        ],
        ...debouncedSearch && {
            title: debouncedSearch
        }
    };
    const { playlists: playlists, api: api, query: { isFetching: isFetching } } = (0, $d91039711271eba9$export$2e2bcd8739ae039)(query);
    const handleCheckboxToggle = (token, checked)=>{
        const updated = checked ? [
            ...selectedPlaylists,
            token
        ] : selectedPlaylists.filter((t)=>t !== token);
        setSelectedPlaylists(updated);
    };
    const handleSave = ()=>{
        const requests = selectedPlaylists.map((token)=>{
            const target = playlists.find((p)=>p.token === token);
            const updatedMedias = target?.medias.concat(videos) ?? videos;
            return new Promise((resolve)=>{
                api.update({
                    token: token,
                    data: {
                        medias: updatedMedias
                    }
                }, {
                    onSuccess: resolve
                });
            });
        });
        return Promise.all(requests).then(()=>{
            const videoText = videos.length > 1 ? "Videos" : "Video";
            const playlistText = selectedPlaylists.length > 1 ? "Playlists" : "Playlist";
            snackbarSuccess(`${videoText} Added to ${playlistText}`);
            onSubmit(selectedPlaylists);
            setSelectedPlaylists([]);
            onClose();
        }).catch((err)=>{
            console.error(err);
            snackbarError("Error while updating playlists. Check the console for more information.");
        });
    };
    const handleClose = ()=>{
        setSelectedPlaylists([]);
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6el2W.default), {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: -5,
            horizontal: "center"
        },
        anchorEl: anchorEl,
        open: !!anchorEl,
        onClose: handleClose,
        classes: {
            paper: classes.paper
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                sx: {
                    marginBottom: "21px",
                    fontWeigth: "500",
                    fontSize: "18px"
                },
                children: "Add to Playlist"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db95cc6529792278$export$2e2bcd8739ae039), {
                placeholder: "Search",
                text: search,
                onTextChange: setSearch,
                isFullWidth: true
            }),
            isFetching && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {
                style: {
                    width: "60px",
                    margin: "20px 20px 3px 20px",
                    alignSelf: "center"
                }
            }),
            playlists?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        sx: {
                            borderColor: "#91A0AD"
                        }
                    }),
                    playlists.map((playlist)=>{
                        const title = playlist.title || playlist.key || playlist.token;
                        const shouldTruncate = title.length > 20;
                        const displayText = shouldTruncate ? `${title.slice(0, 16)}...` : title;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            sx: {
                                height: "40px",
                                alignItems: "center",
                                justifyContent: "space-between"
                            },
                            children: [
                                shouldTruncate ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: title,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontSize: 11
                                        },
                                        children: displayText
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontSize: 11
                                    },
                                    children: displayText
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    sx: {
                                        color: "#91A0AD",
                                        fontSize: 10,
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8260f72609748c85$export$2e2bcd8739ae039), {
                                            sx: {
                                                fontSize: 10,
                                                marginRight: 1
                                            }
                                        }),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(playlist.creation_date).format("MM-DD-YY"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                            className: classes.checkbox,
                                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                            isChecked: selectedPlaylists.includes(playlist.token),
                                            onToggle: (v)=>handleCheckboxToggle(playlist.token, v)
                                        })
                                    ]
                                })
                            ]
                        }, playlist.token);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                style: {
                    paddingTop: 10,
                    paddingBottom: 10
                },
                id: "confirm-add-to-playlist",
                variant: (0, $dgtCa.VARIANT_ENUM).contained,
                className: classes.button,
                text: "Save",
                isEnabled: videos.length > 0 && selectedPlaylists.length > 0,
                onClick: handleSave
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






const $a405ab673e6a7301$var$UploadVideoFilesComponent = ({ showUploadPopup: showUploadPopup, publisherGroup: publisherGroup, query: query, selectedDomain: selectedDomain })=>{
    const inputFileRef = (0, $acw62.useRef)(null);
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api } = (0, $7f956d50de0acb82$export$2e2bcd8739ae039)({});
    const { snackbarSuccess: snackbarSuccess, snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const uploadState = (0, $aece6033f0ce4c41$export$327c7ed43d894c97)();
    const dispatch = (0, $aece6033f0ce4c41$export$8d64f678f60b47f7)();
    const { uploadingVideos: uploadingVideos, abortController: abortController } = uploadState;
    (0, $acw62.useEffect)(()=>{
        if (showUploadPopup === true) inputFileRef.current.click();
    }, [
        showUploadPopup
    ]);
    const uploadDispatcher = (type, payload)=>{
        if (type === (0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_UPLOAD_PROGRESS && payload.progress) {
            if (!uploadingVideos[payload?.index]) return;
            const prevProgress = uploadingVideos[payload.index].progress;
            if (payload.progress - prevProgress >= (0, $5dc958303e06c3a5$export$f7c4fb11c95277ac)) dispatch({
                type: type,
                payload: payload
            });
            return;
        }
        dispatch({
            type: type,
            payload: payload || undefined
        });
    };
    const onFileSelected = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((acceptedFiles)=>{
        const files = Array.from(acceptedFiles.target.files);
        if (files && files?.length > (0, $5dc958303e06c3a5$export$f3203d6b16e7184f)) {
            snackbarWarning(`You can only upload ${(0, $5dc958303e06c3a5$export$f3203d6b16e7184f)} video(s) at a time`);
            return;
        }
        uploadDispatcher((0, $8d9dab153099bf22$export$a2ccf1848ebec243).UPLOAD_STARTED, {
            uploadingFilesCount: files.length
        });
        files.forEach((file, index)=>{
            api.create({
                file: file,
                index: index,
                abortController: abortController,
                uploadDispatcher: uploadDispatcher,
                ...publisherGroup && {
                    publisherUsername: publisherGroup
                },
                data: selectedDomain ? {
                    domain: selectedDomain.domain
                } : undefined,
                onCreate: ({ token: token }, signedURLs)=>uploadDispatcher((0, $8d9dab153099bf22$export$a2ccf1848ebec243).VIDEO_SIGNED_URL_CREATED, {
                        token: token,
                        index: index,
                        videoURL: signedURLs.url,
                        imageURL: signedURLs.imageURL
                    })
            }, {
                onSuccess: ()=>{
                    queryClient.invalidateQueries([
                        "videos",
                        query
                    ]);
                    snackbarSuccess(`Video Added to Library`);
                }
            });
        });
    }, [
        publisherGroup,
        selectedDomain
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
            type: "file",
            multiple: true,
            accept: "video/*",
            ref: inputFileRef,
            style: {
                display: "none"
            },
            onChange: onFileSelected
        })
    });
};
var $a405ab673e6a7301$export$2e2bcd8739ae039 = $a405ab673e6a7301$var$UploadVideoFilesComponent;



/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");




function $55a90792c19f66c6$export$2e2bcd8739ae039(inputQuery) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { snackbarError: snackbarError, snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            "mrss-feeds",
            inputQuery
        ],
        queryFn: ()=>api.getMRSSFeeds(inputQuery),
        enabled: didLoad,
        staleTime: Infinity
    });
    const createMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: api.createMRSSFeed,
        onSuccess: ()=>{
            snackbarSuccess("MRSS Feed Successfully Created");
            queryClient.invalidateQueries([
                "mrss-feeds"
            ]);
        },
        onError: ()=>snackbarError("Error While Creating MRSS Feed")
    });
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ token: token, data: data })=>api.updateMRSSFeed(token, data),
        onSuccess: ()=>{
            snackbarSuccess("MRSS Feed Successfully Updated");
            queryClient.invalidateQueries([
                "mrss-feeds"
            ]);
        },
        onError: ()=>snackbarError("Error While Updating MRSS Feed")
    });
    const deleteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ token: token })=>api.deleteMRSSFeed(token),
        onSuccess: ()=>{
            snackbarSuccess("MRSS Feed Successfully Deleted");
            queryClient.invalidateQueries([
                "mrss-feeds"
            ]);
        },
        onError: ()=>snackbarError("Error While Deleting MRSS Feed")
    });
    return {
        query: query,
        data: query?.data,
        MRSSFeeds: query?.data || [],
        api: {
            create: createMutation.mutate,
            update: updateMutation.mutate,
            delete: deleteMutation.mutate
        },
        mutations: {
            createMutation: createMutation
        }
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e484133473dd7fbd$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33m-7.14-.94 2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64z"
}), "SyncDisabled");


var $5WoTm = parcelRequire("5WoTm");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5283f343a5d9590e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
}), "Pending");


var $bNGtB = parcelRequire("bNGtB");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b145ac0bd9a8004e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), "Sync");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bd249ba0cb5270d6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h6v-2H3zM3 6v2h18V6zm0 7h12v-2H3z"
}), "Sort");


var $8YLZH = parcelRequire("8YLZH");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");

var $f1q41 = parcelRequire("f1q41");

var $1GFtd = parcelRequire("1GFtd");

var $htqGM = parcelRequire("htqGM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d9f195cb3938646c$exports = {};

var $lsJ54 = parcelRequire("lsJ54");
var $6d38303b9c8735ba$exports = {};

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
$6d38303b9c8735ba$exports = $6d38303b9c8735ba$var$now;



/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $dc614d828223dea6$exports(wait) || 0;
    if ($lsJ54(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($dc614d828223dea6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d38303b9c8735ba$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d38303b9c8735ba$exports());
    }
    function debounced() {
        var time = $6d38303b9c8735ba$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d9f195cb3938646c$exports = $d9f195cb3938646c$var$debounce;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



const $1700ac1232394245$export$f51f4c4ede09e011 = $acw62.forwardRef((t, o)=>{
    var { className: i, children: c } = t, l = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "className",
        "children"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Flex, i),
        ref: o
    }, l), c);
});
$1700ac1232394245$export$f51f4c4ede09e011.displayName = "Flex";




var $acw62 = parcelRequire("acw62");



const $dce4e86d40174a31$export$ef2184bd89960b14 = $acw62.forwardRef((t, i)=>{
    var { className: o, children: c } = t, l = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "className",
        "children"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Grid, o),
        ref: i
    }, l), c);
});
$dce4e86d40174a31$export$ef2184bd89960b14.displayName = "Grid";




var $acw62 = parcelRequire("acw62");




const $f1eea10f2f5922b0$export$5f1af8db9871e1d6 = $acw62.forwardRef((m, n)=>{
    var { as: c = "p", className: d, children: l, isTruncated: f, variation: p } = m, u = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "as",
        "className",
        "children",
        "isTruncated",
        "variation"
    ]);
    const T = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Text, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Text, p), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Text, "truncated", f), d);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: c,
        className: T,
        "data-truncate": f,
        "data-variation": p,
        ref: n
    }, u), l);
});
$f1eea10f2f5922b0$export$5f1af8db9871e1d6.displayName = "Text";




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $73e2b32273d2efb3$export$dc26c440c68f2c2a = "...", $73e2b32273d2efb3$export$7f6d8a9c788c158e = (a, m, e = 1)=>$acw62.useMemo(()=>{
        const t = Math.max(a, 1), o = Math.max(e, 1), n = Math.max(t, m), s = n;
        if (n < 5 + 2 * o) return (0, $8b520a117f46c559$export$12cda49cb4509427)(1, n);
        const i = Math.max(t - o, 1), h = Math.min(t + o, s), u = i > 2, M = h < s - 1;
        if (u && !M) return [
            1,
            "...",
            ...(0, $8b520a117f46c559$export$12cda49cb4509427)(s - (3 + 2 * o) + 1, s)
        ];
        if (!u && M) return [
            ...(0, $8b520a117f46c559$export$12cda49cb4509427)(1, 3 + 2 * o),
            "...",
            s
        ];
        return [
            1,
            "...",
            ...(0, $8b520a117f46c559$export$12cda49cb4509427)(i, h),
            "...",
            s
        ];
    }, [
        a,
        m,
        e
    ]);




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





const $4896d31ad1e4b703$export$353f5b6fc5456de1 = $acw62.forwardRef((d, m)=>{
    var { className: p, children: u, isFullWidth: c = !1, isDisabled: f, isLoading: b, loadingText: h = "", size: B, type: g = "button", variation: j } = d, w = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "className",
        "children",
        "isFullWidth",
        "isDisabled",
        "isLoading",
        "loadingText",
        "size",
        "type",
        "variation"
    ]);
    const x = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Button, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupControl, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Button, j), (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Button, B), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Button, "disabled", f || b || w.disabled), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Button, "loading", b), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Button, "fullwidth", c), p);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        ref: m,
        as: "button",
        className: x,
        "data-fullwidth": c,
        "data-loading": b,
        "data-size": B,
        "data-variation": j,
        isDisabled: f || b,
        type: g
    }, w), b && h ? $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "span",
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).ButtonLoaderWrapper
    }, $acw62.createElement((0, $60f6936f2ef9a054$export$3b0d6d7590275603), {
        size: B
    }), h) : u);
});
$4896d31ad1e4b703$export$353f5b6fc5456de1.displayName = "Button";








var $acw62 = parcelRequire("acw62");


const $63b7aac9ef7d46aa$export$c13ba04fa7e7e8e = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $c78f4da700e318d7$export$3f284407ead563ae = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z",
        fill: "currentColor"
    })));
};




var $acw62 = parcelRequire("acw62");



const $7fe1470fea4c3ff2$export$439d29a4e110a164 = $acw62.forwardRef((m, t)=>{
    var { as: o = "span", children: l, className: n } = m, c = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "as",
        "children",
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).VisuallyHidden, n),
        ref: t
    }, c), l);
});
$7fe1470fea4c3ff2$export$439d29a4e110a164.displayName = "VisuallyHidden";



const $3b6b36ec64379eac$export$c055754b41d961d4 = "current", $3b6b36ec64379eac$export$465924c6a64f8c07 = "ellipsis", $3b6b36ec64379eac$export$c82a077939f0464b = (p)=>{
    var { type: b, page: I, currentPage: d, currentPageLabel: P = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PaginationItem.currentPageLabel, isDisabled: k, onClick: E, ariaLabel: j } = p, f = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(p, [
        "type",
        "page",
        "currentPage",
        "currentPageLabel",
        "isDisabled",
        "onClick",
        "ariaLabel"
    ]);
    const C = $acw62.useCallback(()=>{
        E(I, d);
    }, [
        I,
        d,
        E
    ]), B = $acw62.useCallback(()=>{
        E();
    }, [
        E
    ]), L = $acw62.useCallback(()=>{
        E();
    }, [
        E
    ]), v = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, "link"), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, "disabled", k)), h = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, "link"), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, "disabled", k));
    switch(b){
        case "page":
            return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
                as: "li"
            }, I === d ? $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
                "aria-current": "page",
                as: "button",
                className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemCurrent,
                testId: "current"
            }, f), $acw62.createElement((0, $7fe1470fea4c3ff2$export$439d29a4e110a164), null, P, ":"), I) : $acw62.createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), Object.assign({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemButton, "link")),
                size: "small",
                variation: "link",
                onClick: C,
                ariaLabel: j
            }, f), I));
        case "next":
            return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
                as: "li"
            }, $acw62.createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), Object.assign({
                className: v,
                size: "small",
                variation: "link",
                isDisabled: k,
                onClick: L,
                ariaLabel: j
            }, f), $acw62.createElement((0, $c78f4da700e318d7$export$3f284407ead563ae), {
                size: "large"
            })));
        case "previous":
            return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
                as: "li"
            }, $acw62.createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), Object.assign({
                className: h,
                size: "small",
                variation: "link",
                isDisabled: k,
                onClick: B,
                ariaLabel: j
            }, f), $acw62.createElement((0, $63b7aac9ef7d46aa$export$c13ba04fa7e7e8e), {
                size: "large"
            })));
        case "ellipsis":
            return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
                as: "li"
            }, $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
                as: "span",
                className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PaginationItemEllipsis,
                testId: "ellipsis"
            }, f), "\u2026"));
    }
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        as: "li"
    });
};
$3b6b36ec64379eac$export$c82a077939f0464b.displayName = "PaginationItem";



const $1c5707578c6f3ba6$export$c49e70681966c63e = (n, s, o, l, m = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PaginationItem.currentPageLabel, p = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PaginationItem.pageLabel, c = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PaginationItem.previousLabel, g = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PaginationItem.nextLabel, u, b, P)=>{
    const y = $acw62.createElement((0, $3b6b36ec64379eac$export$c82a077939f0464b), {
        type: "previous",
        key: "previous",
        currentPage: n,
        onClick: b,
        isDisabled: n <= 1,
        ariaLabel: c
    }), L = $acw62.createElement((0, $3b6b36ec64379eac$export$c82a077939f0464b), {
        type: "next",
        key: "next",
        currentPage: n,
        onClick: u,
        isDisabled: n >= s && !o,
        ariaLabel: g
    }), k = (0, $73e2b32273d2efb3$export$7f6d8a9c788c158e)(n, s, l);
    return [
        y,
        ...$acw62.useMemo(()=>k.map((a, i)=>a === (0, $73e2b32273d2efb3$export$dc26c440c68f2c2a) ? $acw62.createElement((0, $3b6b36ec64379eac$export$c82a077939f0464b), {
                    type: "ellipsis",
                    key: 1 === i ? "start-ellipsis" : "end-ellipsis"
                }) : $acw62.createElement((0, $3b6b36ec64379eac$export$c82a077939f0464b), {
                    key: a,
                    type: "page",
                    page: a,
                    currentPage: n,
                    currentPageLabel: m,
                    onClick: P,
                    ariaLabel: `${p} ${a}`
                })), [
            k,
            n,
            m,
            p,
            P
        ]),
        L
    ];
};



const $527f3b097186e82f$export$68f5e1453c188a82 = $acw62.forwardRef((i, l)=>{
    var { className: m, currentPage: g = 1, totalPages: c, hasMorePages: p = !1, siblingCount: u, currentPageLabel: P, pageLabel: b, previousLabel: f, nextLabel: L, onNext: x, onPrevious: h, onChange: j } = i, v = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "className",
        "currentPage",
        "totalPages",
        "hasMorePages",
        "siblingCount",
        "currentPageLabel",
        "pageLabel",
        "previousLabel",
        "nextLabel",
        "onNext",
        "onPrevious",
        "onChange"
    ]);
    const N = (0, $1c5707578c6f3ba6$export$c49e70681966c63e)(g, c, p, u, P, b, f, L, x, h, j);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "nav",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Pagination, m),
        ref: l
    }, v), $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "ol",
        justifyContent: "center",
        alignItems: "center",
        gap: "inherit"
    }, N));
});
$527f3b097186e82f$export$68f5e1453c188a82.displayName = "Pagination";



var $acw62 = parcelRequire("acw62");
const $7124f26f01e643bd$export$f80c710216eae131 = (e)=>{
    let { currentPage: t = 1, totalPages: s, hasMorePages: o, siblingCount: n = 1 } = e;
    t = Math.max(t, 1), n = Math.max(n, 1), s = Math.max(t, s);
    const [r, l] = $acw62.useState(t);
    $acw62.useEffect(()=>l(t), [
        t,
        s
    ]);
    const u = $acw62.useCallback(()=>{
        r < s && l(r + 1);
    }, [
        r,
        s
    ]), c = $acw62.useCallback(()=>{
        r > 1 && l(r - 1);
    }, [
        r
    ]), g = $acw62.useCallback((a, e)=>{
        l(a);
    }, []);
    return {
        currentPage: r,
        totalPages: s,
        hasMorePages: o,
        siblingCount: n,
        onNext: u,
        onPrevious: c,
        onChange: g
    };
};





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



const $df0a8e4f1f09059f$export$139dce681cbb565 = $acw62.forwardRef((o, m)=>{
    var { className: l, children: t, isVisible: c = !0, excludeFromTabOrder: d = !1 } = o, n = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className",
        "children",
        "isVisible",
        "excludeFromTabOrder"
    ]);
    return c ? $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupIcon, l),
        ref: m,
        tabIndex: d ? -1 : void 0
    }, n), t) : null;
});
$df0a8e4f1f09059f$export$139dce681cbb565.displayName = "FieldGroupIcon";


const $3ca40eaefc08cd56$export$232a4d370dde0272 = $acw62.forwardRef((m, n)=>{
    var { children: c, className: i } = m, l = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "children",
        "className"
    ]);
    return $acw62.createElement((0, $df0a8e4f1f09059f$export$139dce681cbb565), Object.assign({
        as: (0, $4896d31ad1e4b703$export$353f5b6fc5456de1),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupIconButton, i),
        ref: n
    }, l), c);
});
$3ca40eaefc08cd56$export$232a4d370dde0272.displayName = "FieldGroupIconButton";








var $acw62 = parcelRequire("acw62");


const $e9c1137b37a4e89f$export$e04bcc6127e699bf = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
    })));
};


const $36c6d0b4cdf5caec$var$a = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).Fields.clearButtonLabel, $36c6d0b4cdf5caec$export$ef4e5fdc4928e08b = $acw62.forwardRef((i, s)=>{
    var { ariaLabel: l = $36c6d0b4cdf5caec$var$a, size: n } = i, m = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "ariaLabel",
        "size"
    ]);
    return $acw62.createElement((0, $3ca40eaefc08cd56$export$232a4d370dde0272), Object.assign({
        ariaLabel: l,
        ref: s
    }, m), $acw62.createElement((0, $e9c1137b37a4e89f$export$e04bcc6127e699bf), {
        size: n
    }));
});
$36c6d0b4cdf5caec$export$ef4e5fdc4928e08b.displayName = "FieldClearButton";











var $acw62 = parcelRequire("acw62");


const $3aea0c423f973043$export$2be804e19c04baed = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z",
        fill: "currentColor"
    })));
};



var $acw62 = parcelRequire("acw62");







const $1451fdb8587207c1$var$a = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).SearchField.searchButtonLabel, $1451fdb8587207c1$export$40d419902b7a459d = $acw62.forwardRef((o, s)=>$acw62.createElement((0, $3ca40eaefc08cd56$export$232a4d370dde0272), Object.assign({
        ariaLabel: $1451fdb8587207c1$var$a,
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).SearchFieldSearch,
        ref: s,
        type: "submit"
    }, o), $acw62.createElement((0, $3aea0c423f973043$export$2be804e19c04baed), {
        size: o.size
    })));
$1451fdb8587207c1$export$40d419902b7a459d.displayName = "SearchFieldButton";




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");



const $696539b8ac1b8264$export$806e181b7f4dca8a = "qa-field-description", $696539b8ac1b8264$export$873ced4623a3149c = (a)=>{
    var { descriptiveText: d, labelHidden: l } = a, o = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(a, [
        "descriptiveText",
        "labelHidden"
    ]);
    return d ? $acw62.createElement((0, $f1eea10f2f5922b0$export$5f1af8db9871e1d6), Object.assign({
        "data-testid": "qa-field-description",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldDescription, {
            [(0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).VisuallyHidden]: l
        })
    }, o), d) : null;
};
$696539b8ac1b8264$export$873ced4623a3149c.displayName = "FieldDescription";




var $acw62 = parcelRequire("acw62");


const $7c590db08e2c3ed8$export$1c081951d49ad6f6 = (o)=>{
    var { errorMessage: t, hasError: m } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "errorMessage",
        "hasError"
    ]);
    return m && t ? $acw62.createElement((0, $f1eea10f2f5922b0$export$5f1af8db9871e1d6), Object.assign({
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldErrorMessage
    }, i), t) : null;
};
$7c590db08e2c3ed8$export$1c081951d49ad6f6.displayName = "FieldErrorMessage";




var $acw62 = parcelRequire("acw62");





const $12aa7727c9bd1307$export$f0fe469072bc6950 = $acw62.forwardRef((l, m)=>{
    var { children: s, className: p, innerEndComponent: d, innerStartComponent: u, orientation: c = "horizontal", outerEndComponent: F, outerStartComponent: E, variation: G } = l, f = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(l, [
        "children",
        "className",
        "innerEndComponent",
        "innerStartComponent",
        "orientation",
        "outerEndComponent",
        "outerStartComponent",
        "variation"
    ]);
    const N = null != d, C = null != u ? (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupHasInnerStart : null, S = N ? (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupHasInnerEnd : null, h = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroup, C, S, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroup, c), p);
    return $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
        className: h,
        "data-orientation": c,
        ref: m
    }, f), E && $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupOuterStart, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupOuterStart, G))
    }, E), $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupFieldWrapper, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupFieldWrapper, c)),
        "data-orientation": c
    }, u && $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupInnerStart
    }, u), s, d && $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupInnerEnd
    }, d)), F && $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupOuterEnd, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupOuterEnd, G))
    }, F));
});
$12aa7727c9bd1307$export$f0fe469072bc6950.displayName = "FieldGroup";





var $acw62 = parcelRequire("acw62");




const $bfebae8636cadf20$export$f5b8910cec6cf069 = $acw62.forwardRef((i, l)=>{
    var { autoComplete: u, checked: d, className: p, defaultChecked: c, defaultValue: m, id: h, isDisabled: C, isReadOnly: f, isRequired: y, size: v, type: I = "text", hasError: k = !1, value: b, variation: R, onBlur: V, onChange: g, onCopy: j, onCut: F, onFocus: N, onInput: O, onPaste: q, onSelect: w, onWheel: z } = i, B = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "autoComplete",
        "checked",
        "className",
        "defaultChecked",
        "defaultValue",
        "id",
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "size",
        "type",
        "hasError",
        "value",
        "variation",
        "onBlur",
        "onChange",
        "onCopy",
        "onCut",
        "onFocus",
        "onInput",
        "onPaste",
        "onSelect",
        "onWheel"
    ]);
    const D = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Input, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupControl, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Input, R), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Input, "error", k), (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Input, v), p);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        "aria-invalid": k,
        as: "input",
        autoComplete: u,
        checked: d,
        className: D,
        "data-size": v,
        "data-variation": R,
        defaultChecked: c,
        defaultValue: m,
        isDisabled: C,
        id: h,
        onBlur: V,
        onChange: g,
        onCopy: j,
        onCut: F,
        onFocus: N,
        onInput: O,
        onPaste: q,
        onSelect: w,
        onWheel: z,
        readOnly: f,
        ref: l,
        required: y,
        type: I,
        value: b
    }, B));
});
$bfebae8636cadf20$export$f5b8910cec6cf069.displayName = "Input";




var $acw62 = parcelRequire("acw62");



const $0c39af73c6023b8b$export$b04be29aa201d4f5 = $acw62.forwardRef((i, m)=>{
    var { children: t, className: o, visuallyHidden: n } = i, c = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "children",
        "className",
        "visuallyHidden"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "label",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Label, o, {
            [(0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).VisuallyHidden]: n
        }),
        ref: m
    }, c), t);
});
$0c39af73c6023b8b$export$b04be29aa201d4f5.displayName = "Label";


const $2ba03255af6c173c$export$b13482c6703e2987 = (i)=>i.isMultiline, $2ba03255af6c173c$export$efdbddb928a8673f = (i)=>!i.isMultiline, $2ba03255af6c173c$export$f133e3eacf56ea22 = (i, l)=>!i.isMultiline, $2ba03255af6c173c$export$b1811dc1d486ce = (i, l)=>i.isMultiline;




var $acw62 = parcelRequire("acw62");




const $b3ff26fdbb34cc65$export$f5c9f3c2c4054eec = $acw62.forwardRef((m, n)=>{
    var { className: d, isReadOnly: l, isRequired: c, size: f, hasError: p = !1, variation: x } = m, u = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "className",
        "isReadOnly",
        "isRequired",
        "size",
        "hasError",
        "variation"
    ]);
    const v = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Textarea, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupControl, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Textarea, x), (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Textarea, f), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Textarea, "error", p), d);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        "aria-invalid": p,
        as: "textarea",
        className: v,
        "data-size": f,
        "data-variation": x,
        readOnly: l,
        ref: n,
        required: c
    }, u));
});
$b3ff26fdbb34cc65$export$f5c9f3c2c4054eec.displayName = "TextArea";



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $60364573ac7ce533$export$e5c5a5f917a5871c = (null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? $acw62.useLayoutEffect : ()=>{};


const $af44a26693d6395d$export$766b2b49c9d08de4 = "amplify-id", $af44a26693d6395d$var$e = $acw62["useId".toString()] || (()=>{});
let $af44a26693d6395d$var$i = 0;
const $af44a26693d6395d$export$5c0b1cf3fea224ac = (r)=>{
    const [s, n] = $acw62.useState($af44a26693d6395d$var$e());
    return (0, $60364573ac7ce533$export$e5c5a5f917a5871c)(()=>{
        r || n((t)=>null != t ? t : String($af44a26693d6395d$var$i++));
    }, [
        r
    ]), r || (s ? `amplify-id-${s}` : "");
};



var $acw62 = parcelRequire("acw62");

var $hPtJY = parcelRequire("hPtJY");
const $d8062de64a9f01e8$export$406e4c8585b97b03 = ({ shouldWarn: o, message: s })=>{
    $acw62.useEffect(()=>{
        o && ("undefined" == typeof $hPtJY || $hPtJY && true) && console.warn(s);
    }, [
        o,
        s
    ]);
};


const $4dd4eb3a13974ce8$export$a53151f0e13c6fff = 3, $4dd4eb3a13974ce8$var$F = (j, F)=>{
    const { className: x, descriptiveText: C, errorMessage: v, hasError: y = !1, id: S, label: T, labelHidden: w = !1, outerEndComponent: M, outerStartComponent: I, innerStartComponent: z, innerEndComponent: H, isMultiline: N, type: A, size: L, testId: O, variation: P, alignSelf: D, bottom: G, height: W, left: k, padding: B, position: R, right: U, top: q, width: J } = j, K = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(j, [
        "className",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "label",
        "labelHidden",
        "outerEndComponent",
        "outerStartComponent",
        "innerStartComponent",
        "innerEndComponent",
        "isMultiline",
        "type",
        "size",
        "testId",
        "variation",
        "alignSelf",
        "bottom",
        "height",
        "left",
        "padding",
        "position",
        "right",
        "top",
        "width"
    ]), Q = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(S), V = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(), X = C ? V : void 0, { flexContainerStyleProps: Y, baseStyleProps: Z, rest: $ } = (0, $977c7c783ee37387$export$584a75f5facb0a5)(K);
    (0, $d8062de64a9f01e8$export$406e4c8585b97b03)({
        shouldWarn: j.isMultiline,
        message: "TextField isMultiLine prop will be deprecated in next major release of @aws-amplify/ui-react. Please use TextAreaField component instead."
    });
    let _ = null;
    if ((0, $2ba03255af6c173c$export$b13482c6703e2987)(j)) {
        const { rows: e } = j;
        _ = $acw62.createElement((0, $b3ff26fdbb34cc65$export$f5c9f3c2c4054eec), Object.assign({
            "aria-describedby": X,
            hasError: y,
            id: Q,
            ref: (0, $2ba03255af6c173c$export$b1811dc1d486ce)(j) ? F : void 0,
            rows: null != e ? e : 3,
            size: L,
            variation: P
        }, Z, $));
    } else if ((0, $2ba03255af6c173c$export$efdbddb928a8673f)(j)) {
        const { type: e = "text" } = j;
        _ = $acw62.createElement((0, $bfebae8636cadf20$export$f5b8910cec6cf069), Object.assign({
            "aria-describedby": X,
            hasError: y,
            id: Q,
            ref: (0, $2ba03255af6c173c$export$f133e3eacf56ea22)(j) ? F : void 0,
            size: L,
            type: e,
            variation: P
        }, Z, $));
    }
    return $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
        alignSelf: D,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Field, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Field, L), (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).TextField, x),
        bottom: G,
        "data-size": L,
        height: W,
        left: k,
        padding: B,
        position: R,
        right: U,
        testId: O,
        top: q,
        width: J
    }, Y), $acw62.createElement((0, $0c39af73c6023b8b$export$b04be29aa201d4f5), {
        htmlFor: Q,
        visuallyHidden: w
    }, T), $acw62.createElement((0, $696539b8ac1b8264$export$873ced4623a3149c), {
        id: V,
        labelHidden: w,
        descriptiveText: C
    }), $acw62.createElement((0, $12aa7727c9bd1307$export$f0fe469072bc6950), {
        outerStartComponent: I,
        outerEndComponent: M,
        innerStartComponent: z,
        innerEndComponent: H,
        variation: P
    }, _), $acw62.createElement((0, $7c590db08e2c3ed8$export$1c081951d49ad6f6), {
        hasError: y,
        errorMessage: v
    }));
}, $4dd4eb3a13974ce8$export$2c73285ae9390cec = $acw62.forwardRef($4dd4eb3a13974ce8$var$F);
$4dd4eb3a13974ce8$var$F.displayName = "TextField";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $303520a7b115ac8f$export$fd83412bb73805d4({ externalRef: r, internalRef: n }) {
    return $acw62.useCallback((e)=>{
        "function" == typeof r ? r(e) : null !== r && (r.current = e), n.current = e;
    }, [
        r,
        n
    ]);
}


const $64ee1e8553b61bb3$var$s = new Set([
    (0, $eb5f843fca4db3c6$export$728705b4513abbb5),
    (0, $eb5f843fca4db3c6$export$4162dbd8c730437)
]), $64ee1e8553b61bb3$export$9bb30bbe003b82e0 = ({ defaultValue: t = "", value: r, onChange: u, onClear: c, onSubmit: f, externalRef: m })=>{
    const C = void 0 !== r, [i, d] = $acw62.useState(t), k = C ? r : i, p = $acw62.useRef(null), b = (0, $303520a7b115ac8f$export$fd83412bb73805d4)({
        externalRef: m,
        internalRef: p
    }), h = $acw62.useCallback(()=>{
        var e;
        C || d(""), null === (e = null == p ? void 0 : p.current) || void 0 === e || e.focus(), (0, $8b520a117f46c559$export$f6e2535fb5126e54)(c) && c();
    }, [
        C,
        d,
        c
    ]), v = $acw62.useCallback((e)=>{
        (0, $8b520a117f46c559$export$f6e2535fb5126e54)(f) && f(e);
    }, [
        f
    ]), R = $acw62.useCallback((e)=>{
        const { key: o } = e;
        $64ee1e8553b61bb3$var$s.has(o) && (e.preventDefault(), o === (0, $eb5f843fca4db3c6$export$728705b4513abbb5) ? h() : o === (0, $eb5f843fca4db3c6$export$4162dbd8c730437) && v(k));
    }, [
        k,
        h,
        v
    ]), g = $acw62.useCallback((e)=>{
        C || d(e.target.value), (0, $8b520a117f46c559$export$f6e2535fb5126e54)(u) && u(e);
    }, [
        C,
        u,
        d
    ]), j = $acw62.useCallback(()=>{
        v(k);
    }, [
        v,
        k
    ]);
    return {
        composedValue: k,
        onClearHandler: h,
        onKeyDown: R,
        onClick: j,
        handleOnChange: g,
        composedRefs: b
    };
};



const $4209a8fa431f3bba$export$b94867ecbd698f21 = $acw62.forwardRef((d, u)=>{
    var { autoComplete: p = "off", className: f, isDisabled: h, clearButtonLabel: C, labelHidden: b = !0, name: F = "q", hasSearchButton: j = !0, hasSearchIcon: S = !1, onChange: B, onClear: v, onSubmit: E, searchButtonRef: I, size: g, defaultValue: D, value: V } = d, w = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "autoComplete",
        "className",
        "isDisabled",
        "clearButtonLabel",
        "labelHidden",
        "name",
        "hasSearchButton",
        "hasSearchIcon",
        "onChange",
        "onClear",
        "onSubmit",
        "searchButtonRef",
        "size",
        "defaultValue",
        "value"
    ]);
    const { composedValue: x, onClearHandler: z, onKeyDown: R, onClick: k, handleOnChange: G, composedRefs: H } = (0, $64ee1e8553b61bb3$export$9bb30bbe003b82e0)({
        defaultValue: D,
        value: V,
        onChange: B,
        onClear: v,
        onSubmit: E,
        externalRef: u
    }), N = j ? $acw62.createElement((0, $1451fdb8587207c1$export$40d419902b7a459d), {
        isDisabled: h,
        onClick: k,
        ref: I,
        size: g
    }) : void 0, y = S ? $acw62.createElement((0, $df0a8e4f1f09059f$export$139dce681cbb565), null, $acw62.createElement((0, $3aea0c423f973043$export$2be804e19c04baed), null)) : void 0;
    return $acw62.createElement((0, $4dd4eb3a13974ce8$export$2c73285ae9390cec), Object.assign({
        autoComplete: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).SearchField, f),
        labelHidden: b,
        innerStartComponent: y,
        innerEndComponent: $acw62.createElement((0, $36c6d0b4cdf5caec$export$ef4e5fdc4928e08b), {
            ariaLabel: C,
            excludeFromTabOrder: !0,
            isVisible: (0, $8b520a117f46c559$export$c6251bf2bc4bb464)(x),
            onClick: z,
            size: g,
            variation: "link"
        }),
        isDisabled: h,
        isMultiline: !1,
        name: F,
        onChange: G,
        onKeyDown: R,
        outerEndComponent: N,
        ref: H,
        size: g,
        value: x
    }, w));
});
$4209a8fa431f3bba$export$b94867ecbd698f21.displayName = "SearchField";





const $2461fb166c9207aa$export$6dab95b2d809a42c = (e, t, o)=>{
    if (t < 1 || o < 1) return [];
    const s = (t - 1) * o;
    return e.slice(s, s + o);
}, $2461fb166c9207aa$export$158171b6c6bb2ba4 = (t, s)=>(0, $8b520a117f46c559$export$c6251bf2bc4bb464)(t) ? t.toLowerCase().includes(s.toLowerCase()) : "object" == typeof t && null !== t && Object.values(t).some((e)=>$2461fb166c9207aa$export$158171b6c6bb2ba4(e, s)), $2461fb166c9207aa$export$b287f0ca5dbff6af = (e, t)=>Math.ceil(e / t);


const $847b4561e4f4f352$var$f = 10, $847b4561e4f4f352$var$j = (t)=>{
    var { children: a, direction: l = "column", items: i } = t, n = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "children",
        "direction",
        "items"
    ]);
    return $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
        direction: l
    }, n), Array.isArray(i) ? i.map(a) : null);
}, $847b4561e4f4f352$var$P = (t)=>{
    var { children: a, items: s } = t, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "children",
        "items"
    ]);
    return $acw62.createElement((0, $dce4e86d40174a31$export$ef2184bd89960b14), Object.assign({}, i), Array.isArray(s) ? s.map(a) : null);
}, $847b4561e4f4f352$export$fb8073518f34e6ec = (l)=>{
    var { className: b, isSearchable: C, isPaginated: E, items: N, itemsPerPage: y = $847b4561e4f4f352$var$f, searchFilter: F = (0, $2461fb166c9207aa$export$158171b6c6bb2ba4), searchLabel: A = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).Collection.searchButtonLabel, searchNoResultsFound: S, searchPlaceholder: x, type: I = "list", testId: O } = l, v = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(l, [
        "className",
        "isSearchable",
        "isPaginated",
        "items",
        "itemsPerPage",
        "searchFilter",
        "searchLabel",
        "searchNoResultsFound",
        "searchPlaceholder",
        "type",
        "testId"
    ]);
    const [L, R] = $acw62.useState(), G = $acw62.useCallback((0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(R, 300), [
        R
    ]);
    N = Array.isArray(N) ? N : [], C && (0, $8b520a117f46c559$export$c6251bf2bc4bb464)(L) && (N = N.filter((e)=>F(e, L)));
    const T = (0, $7124f26f01e643bd$export$f80c710216eae131)({
        totalPages: (0, $2461fb166c9207aa$export$b287f0ca5dbff6af)(N.length, y)
    });
    E && (N = (0, $2461fb166c9207aa$export$6dab95b2d809a42c)(N, T.currentPage, y));
    const k = "list" === I ? $acw62.createElement($847b4561e4f4f352$var$j, Object.assign({
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).CollectionItems,
        items: N
    }, v)) : "grid" === I ? $acw62.createElement($847b4561e4f4f352$var$P, Object.assign({
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).CollectionItems,
        items: N
    }, v)) : null;
    return $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        testId: O,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Collection, b)
    }, C ? $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).CollectionSearch
    }, $acw62.createElement((0, $4209a8fa431f3bba$export$b94867ecbd698f21), {
        label: A,
        placeholder: x,
        onChange: (e)=>G(e.target.value),
        onClear: ()=>R("")
    })) : null, ((e, t, a)=>t.length ? e : a || $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
            justifyContent: "center"
        }, $acw62.createElement((0, $f1eea10f2f5922b0$export$5f1af8db9871e1d6), null, (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).Collection.searchNoResultsFound)))(k, N, S), E ? $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).CollectionPagination
    }, $acw62.createElement((0, $527f3b097186e82f$export$68f5e1453c188a82), Object.assign({}, T))) : null);
};
$847b4561e4f4f352$export$fb8073518f34e6ec.displayName = "Collection";





function $10fe11384c3682d1$export$b152b8aa9757e899({ videos: videos, onMove: onMove, onVideoClick: onVideoClick, onVideoToggle: onVideoToggle, isNumbered: isNumbered, isSelectable: isSelectable, isDraggable: isDraggable, selected: selected }) {
    const [modalVideoIndex, setModalVideoIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(-1);
    const modalVideo = videos[modalVideoIndex];
    const totalVideos = videos.length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe3be3a7f8b144a$export$2e2bcd8739ae039), {
                video: modalVideo?.token,
                isOpen: modalVideoIndex > -1,
                onClose: ()=>setModalVideoIndex(-1),
                onNavigatePrev: ()=>setModalVideoIndex((modalVideoIndex - 1 + totalVideos) % totalVideos),
                onNavigateNext: ()=>setModalVideoIndex((modalVideoIndex + 1) % totalVideos)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c8535fa6926b1a4$export$5cc3906c1637d2e), {
                draggableList: videos,
                itemIdKey: "token",
                onDragEnd: (drop, drag)=>onMove && onMove(drop, drag),
                isDraggable: isDraggable,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847b4561e4f4f352$export$fb8073518f34e6ec), {
                    items: videos,
                    type: "list",
                    direction: "row",
                    wrap: "wrap",
                    gap: "20px 30px",
                    children: (video, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c057dee6365134f0$export$b90189b6ff51fe46), {
                                index: index,
                                maxIndex: videos.length - 1,
                                video: video,
                                isNumbered: isNumbered,
                                isSelectable: isSelectable,
                                isChecked: selected?.includes(video.token),
                                onClick: (e)=>{
                                    setModalVideoIndex(index);
                                    if (onVideoClick) onVideoClick(video.token, e);
                                },
                                onToggle: (value)=>onVideoToggle(video.token, value)
                            })
                        }, index)
                })
            })
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");

var $eOIWT = parcelRequire("eOIWT");
function $0809e2665cadfb12$export$2e2bcd8739ae039({ disabled: disabled, items: items }) {
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                sx: {
                    padding: 0,
                    color: "#303237",
                    fontSize: "20px"
                },
                disableRipple: true,
                disabled: disabled,
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eOIWT.default), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                sx: {
                    borderRadius: 0,
                    "& .MuiPaper-root": {
                        minWidth: "180px",
                        borderRadius: 0
                    },
                    "& .MuiMenuItem-root": {
                        fontSize: "11px",
                        "& .MuiSvgIcon-root": {
                            fontSize: "20px",
                            marginRight: "18px"
                        }
                    }
                },
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                onClick: handleClose,
                transformOrigin: {
                    horizontal: "right",
                    vertical: "top"
                },
                anchorOrigin: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                children: items?.map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                        onClick: (e)=>{
                            e.stopPropagation();
                            handleClose();
                            i.onClick();
                        },
                        children: i.inner
                    }, i.key))
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $kfZjc = parcelRequire("kfZjc");

var $kfZjc = parcelRequire("kfZjc");



var $6vVdw = parcelRequire("6vVdw");

var $1GFtd = parcelRequire("1GFtd");

var $2cPwN = parcelRequire("2cPwN");
var $3bYfT = parcelRequire("3bYfT");

var $htqGM = parcelRequire("htqGM");

var $AfP12 = parcelRequire("AfP12");










var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $hAiFn = parcelRequire("hAiFn");
var $8YLZH = parcelRequire("8YLZH");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $c256b9ea02976c07$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), "Restore");




const $6516280f07af1ec3$var$iconStyle = {
    ml: "10px",
    "&:hover": {
        cursor: "pointer",
        color: "#03f"
    }
};
const $6516280f07af1ec3$var$disabledStyle = {
    color: "rgba(0, 0, 0, 0.26)",
    cursor: "not-allowed",
    pointerEvents: "none",
    ...$6516280f07af1ec3$var$iconStyle
};
function $6516280f07af1ec3$export$2e2bcd8739ae039({ video: video, onActionClick: onActionClick, onEditActionClick: onEditActionClick }) {
    const state = video?.state?.toLowerCase();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {
                sx: (0, $5094343bfed31c54$export$9667a007680253be)(state) ? {
                    ...$6516280f07af1ec3$var$iconStyle,
                    ml: "0px"
                } : {
                    ...$6516280f07af1ec3$var$disabledStyle,
                    ml: "0px"
                },
                onClick: ()=>onEditActionClick(video?.token)
            }),
            state !== (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).SOFT_DELETED && state !== (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).HARD_DELETED && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {
                sx: (0, $5094343bfed31c54$export$9667a007680253be)(state) || state === (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).EMPTY ? $6516280f07af1ec3$var$iconStyle : $6516280f07af1ec3$var$disabledStyle,
                onClick: ()=>onActionClick("delete", video)
            }),
            state === (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).SOFT_DELETED && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c256b9ea02976c07$export$2e2bcd8739ae039), {
                sx: $6516280f07af1ec3$var$iconStyle,
                onClick: ()=>onActionClick("restore", video)
            })
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ce9a444a000d9838$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82"
}), "PlayArrowRounded");


const $e8f70d25c97fe2c5$var$ThumbnailPlaceholder = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            width: "70px",
            height: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#E5EAEF",
            borderRadius: "5px"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce9a444a000d9838$export$2e2bcd8739ae039), {
            sx: {
                color: "#FFFFFF",
                fontSize: "24px"
            }
        })
    });
var $e8f70d25c97fe2c5$export$2e2bcd8739ae039 = $e8f70d25c97fe2c5$var$ThumbnailPlaceholder;



(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($216b618b1b33e0d2$exports))));
const $7fe6dc14a14eebbb$export$28e6b9b82ee883c = (0, $1GFtd.default)({
    table: {
        "& thead th": {
            background: "transparent",
            color: "black",
            fontSize: "11px",
            fontWeight: 600
        },
        "& tbody": {
            borderTop: "2px solid black",
            borderBottom: "2px solid black",
            "& tr:hover": {
                background: "#EEF3F7"
            }
        }
    }
});
const $7fe6dc14a14eebbb$export$d97d0946c568efa5 = {
    margin: "2px",
    backgroundColor: "#e5eaef",
    padding: "7px 11px",
    border: "none"
};
const $7fe6dc14a14eebbb$var$videoTagChips = (tags)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: tags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))), {
                style: $7fe6dc14a14eebbb$export$d97d0946c568efa5,
                theme: (0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))).THEME_ENUM.v2,
                type: (0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))).TYPE_ENUM.transparent,
                data: {
                    text: tag,
                    id: tag
                }
            }, tag))
    });
function $7fe6dc14a14eebbb$export$2e2bcd8739ae039({ videos: videos, selectedVideosToken: selectedVideosToken = [], onVideoToggle: onVideoToggle, onToggleAll: onToggleAll, query: query, totalCount: totalCount }) {
    const history = (0, $kfZjc.useHistory)();
    const classes = $7fe6dc14a14eebbb$export$28e6b9b82ee883c();
    const { headerRef: headerRef, handleSortChange: handleSortChange } = (0, $887b2da4e8f087cf$export$a0fcfb0562217ff7)();
    const { hasNextPage: hasNextPage, fetchNextPage: fetchNextPage } = (0, $7f956d50de0acb82$export$2e2bcd8739ae039)(query);
    const [modalVideoIndex, setModalVideoIndex] = (0, $acw62.useState)(-1);
    const [actionState, setActionState] = (0, $acw62.useState)({
        isOpen: false,
        type: "delete",
        video: null
    });
    const [snackbarState, setSnackbarState] = (0, $acw62.useState)({
        type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
        isOpen: false,
        message: ""
    });
    const { api: api } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const isAllChecked = (0, $acw62.useMemo)(()=>{
        const selectedVideosSet = new Set(selectedVideosToken);
        return selectedVideosSet.size > 0 && videos.every((video)=>selectedVideosSet.has(video.token) || !(0, $5094343bfed31c54$export$9667a007680253be)(video.state));
    }, [
        videos,
        selectedVideosToken
    ]);
    const modalVideo = videos[modalVideoIndex];
    const totalVideos = videos.length;
    const handleActionClick = (type, video)=>{
        setActionState({
            isOpen: true,
            type: type,
            video: video
        });
    };
    const handlePaginationChange = (page, pageSize)=>{
        if (page * pageSize > videos.length && hasNextPage) fetchNextPage();
    };
    const handleConfirmAction = (0, $acw62.useCallback)(async ()=>{
        if (actionState.video) try {
            if (actionState.type === "delete") await api.Media.remove(actionState.video.token);
            else if (actionState.type === "restore") await api.Media.restore(actionState.video.token);
            queryClient.invalidateQueries([
                "videos",
                query
            ]);
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
                isOpen: true,
                message: `Successfully ${actionState.type}d video(s)`
            });
        } catch (error) {
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
                isOpen: true,
                message: `Failed to ${actionState.type} video(s)`
            });
            console.error(`Failed to ${actionState.type} video:`, error);
        } finally{
            setActionState({
                isOpen: false,
                type: actionState.type,
                video: null
            });
        }
    }, [
        actionState,
        api.Media,
        queryClient,
        query
    ]);
    const handleCloseSnackbar = ()=>{
        setSnackbarState({
            ...snackbarState,
            isOpen: false
        });
    };
    const navigateToSingleVideo = (token)=>history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).SINGLE_MEDIA_EDIT_PAGE, {
            token: token
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe3be3a7f8b144a$export$2e2bcd8739ae039), {
                video: modalVideo?.token,
                isOpen: modalVideoIndex > -1,
                onClose: ()=>setModalVideoIndex(-1),
                onNavigatePrev: ()=>setModalVideoIndex((modalVideoIndex - 1 + totalVideos) % totalVideos),
                onNavigateNext: ()=>setModalVideoIndex((modalVideoIndex + 1) % totalVideos)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: actionState.isOpen,
                onClose: ()=>setActionState({
                        ...actionState,
                        isOpen: false
                    }),
                onSubmitClick: handleConfirmAction,
                header: `${(0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(actionState.type)} Video(s)`,
                body: `Are you sure you want to ${actionState.type} this video?`,
                submitButtonText: (0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(actionState.type),
                cancelButtonText: "Cancel"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    border: "1px solid #91A0AD"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).THEME_ENUM.v2,
                    className: classes.table,
                    config: {
                        pagination: {
                            initialPageSize: (0, $5dc958303e06c3a5$export$ff05e60509bc6769),
                            totalRowCount: totalCount,
                            hasStrictRows: false
                        },
                        methods: {
                            onTableOrderChange: handleSortChange,
                            onPaginationChange: handlePaginationChange
                        },
                        meta: {
                            headerRef: headerRef
                        },
                        data: {
                            columns: [
                                {
                                    type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.checkbox,
                                    headerName: "",
                                    field: "isChecked",
                                    renderHeader: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                            isChecked: isAllChecked,
                                            onToggle: onToggleAll
                                        }),
                                    renderCell: (row)=>row.state === (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).PROCESSING ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            sx: {
                                                position: "relative",
                                                margin: "auto"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                size: "16px"
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                            isChecked: row.isChecked,
                                            isEnabled: (0, $5094343bfed31c54$export$9667a007680253be)(row.state),
                                            onToggle: (isChecked)=>onVideoToggle?.(row, isChecked)
                                        })
                                },
                                {
                                    headerName: "Thumbnail",
                                    type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.thumbnail,
                                    field: "thumbnail",
                                    renderCell: (row)=>row.state === (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).PROCESSING || !row.thumbnail ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8f70d25c97fe2c5$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: row.thumbnail,
                                            alt: row.title,
                                            style: (0, $5dc958303e06c3a5$export$4a0190bd87e17e53)
                                        }),
                                    onClick: (_, row)=>setModalVideoIndex(row.index),
                                    width: "130px"
                                },
                                {
                                    headerName: "Status",
                                    field: "state",
                                    width: "120px",
                                    onClick: (_, row)=>navigateToSingleVideo(row.token),
                                    renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            sx: {
                                                fontSize: "11px",
                                                lineHeight: "16px",
                                                color: row.state === (0, $8ca75cf684bd0a38$export$7f2e1fd47b352b5f).PROCESSING ? (0, $5dc958303e06c3a5$export$ef953643a4c1c458) : "inherit"
                                            },
                                            children: (0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(row.state, "_")
                                        })
                                },
                                {
                                    headerName: "Video Title",
                                    type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.subtitle,
                                    field: "video_title",
                                    onClick: (_, row)=>navigateToSingleVideo(row.token),
                                    width: "450px"
                                },
                                {
                                    headerName: "Category",
                                    field: "category",
                                    width: "130px",
                                    onClick: (_, row)=>navigateToSingleVideo(row.token),
                                    renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: (0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(row.category, " ")
                                        })
                                },
                                {
                                    headerName: "Tags",
                                    field: "tags",
                                    width: "300px",
                                    onClick: (_, row)=>navigateToSingleVideo(row.token),
                                    renderCell: (row)=>{
                                        const tags = row.tags.filter((tag)=>tag.trim() !== "");
                                        const [visibleTags, extraTags] = [
                                            tags?.slice(0, 2),
                                            tags?.slice(2)
                                        ];
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                $7fe6dc14a14eebbb$var$videoTagChips(visibleTags),
                                                extraTags.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                    tooltip: $7fe6dc14a14eebbb$var$videoTagChips(extraTags),
                                                    placement: "top",
                                                    arrow: true,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))), {
                                                        style: $7fe6dc14a14eebbb$export$d97d0946c568efa5,
                                                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))).THEME_ENUM.v2,
                                                        type: (0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))).TYPE_ENUM.transparent,
                                                        data: {
                                                            text: `+${extraTags.length}`,
                                                            id: "extra"
                                                        }
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                },
                                {
                                    headerName: "Publish Date",
                                    field: "publish_date",
                                    width: "120px",
                                    textAlignment: "right",
                                    onClick: (_, row)=>navigateToSingleVideo(row.token)
                                },
                                {
                                    headerName: "Duration",
                                    field: "duration",
                                    width: "120px",
                                    textAlignment: "right"
                                },
                                {
                                    headerName: "Actions",
                                    field: "actions",
                                    width: "120px",
                                    renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6516280f07af1ec3$export$2e2bcd8739ae039), {
                                            video: row,
                                            onActionClick: handleActionClick,
                                            onEditActionClick: ()=>navigateToSingleVideo(row.token)
                                        })
                                }
                            ],
                            rows: videos.map((video, index)=>({
                                    ...video,
                                    category: video.category,
                                    state: video.state,
                                    thumbnail: video.default_stream?.image_url,
                                    video_title: {
                                        title: video.title || video.media_info?.original_file_name
                                    },
                                    publish_date: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(video.created_at).format("MM/DD/YYYY"),
                                    duration: (0, $5094343bfed31c54$export$bc733b0c5cbb3e8a)(video.local?.duration || video.media_info?.duration || video.default_stream?.media_info?.duration || 0),
                                    isChecked: selectedVideosToken.includes(video.token),
                                    index: index
                                }))
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48733ae2ee9b2cdf$export$2e2bcd8739ae039), {
                type: snackbarState.type,
                isOpen: snackbarState.isOpen,
                onClose: handleCloseSnackbar,
                message: snackbarState.message
            })
        ]
    });
}


var $f02c4b2cdb768b74$export$2e2bcd8739ae039 = (0, $7fe6dc14a14eebbb$export$2e2bcd8739ae039);




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $db36f493660c6a2d$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "Menu");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1c874531aaf27cee$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 8h4V4H4zm6 12h4v-4h-4zm-6 0h4v-4H4zm0-6h4v-4H4zm6 0h4v-4h-4zm6-10v4h4V4zm-6 4h4V4h-4zm6 6h4v-4h-4zm0 6h4v-4h-4z"
}), "Apps");



var $AfP12 = parcelRequire("AfP12");
function $b050cbbc95334a82$export$2e2bcd8739ae039({ onViewChange: onViewChange, viewType: viewType }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "view-selector",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                disableRipple: true,
                onClick: (e)=>{
                    e.stopPropagation();
                    onViewChange("table");
                },
                style: {
                    padding: "2.5px"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                    tooltip: "Switch to List View",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db36f493660c6a2d$export$2e2bcd8739ae039), {
                        style: {
                            fontSize: "20px",
                            color: viewType === "table" ? "#0033FF" : "black"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                disableRipple: true,
                onClick: (e)=>{
                    e.stopPropagation();
                    onViewChange("card");
                },
                style: {
                    padding: "2.5px "
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                    tooltip: "Switch to Card View",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c874531aaf27cee$export$2e2bcd8739ae039), {
                        style: {
                            fontSize: "20px",
                            color: viewType === "card" ? "#0033FF" : "black"
                        }
                    })
                })
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
function $135d028a9038fa3a$var$useShiftKeyListener(set, dependency) {
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        window.addEventListener("keydown", (e)=>{
            if (e.shiftKey) {
                set(true);
                window.addEventListener("keyup", (ev)=>{
                    if (ev.key.toLocaleLowerCase().includes("shift")) set(false);
                });
            }
        });
    }, dependency);
}
var $135d028a9038fa3a$export$2e2bcd8739ae039 = $135d028a9038fa3a$var$useShiftKeyListener;




const $276a3353e67d6fac$var$useStyles = (0, $1GFtd.default)({
    summary: {
        padding: 0,
        borderBottom: "1px solid black",
        minHeight: "47px",
        "& .MuiAccordionSummary-content": {
            transform: "translate(10px)",
            justifyContent: "space-between",
            margin: 0
        },
        "&.Mui-expanded": {
            minHeight: "47px",
            "& $arrow": {
                transform: "rotate(180deg)"
            }
        }
    },
    arrow: {
        transition: "transform .3s ease-in-out",
        width: "10px",
        marginLeft: "5px",
        filter: "brightness(0)"
    },
    details: {
        maxHeight: "520px",
        overflowY: "scroll",
        padding: "24px 0"
    },
    input: {
        height: "37px"
    }
});
let $276a3353e67d6fac$var$prevSelected;
function $276a3353e67d6fac$export$2e2bcd8739ae039({ menuButtonProps: menuButtonProps, onChangeSelected: onChangeSelected, query: query, selected: selected, title: title, subtitle: subtitle, state: state }) {
    const [viewType, setViewType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("card");
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [selectedAll, setSelectedAll] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [shiftSelectionState, setShiftSelectionState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    (0, $135d028a9038fa3a$export$2e2bcd8739ae039)(setShiftSelectionState, [
        selected
    ]);
    const classes = $276a3353e67d6fac$var$useStyles();
    const { videos: videos, query: { fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isFetching: isFetching, isFetchingNextPage: isFetchingNextPage } } = (0, $7f956d50de0acb82$export$2e2bcd8739ae039)(query);
    const handleToggleAll = (checked)=>{
        if (videos.length === 0) {
            setSelectedAll(checked);
            if (checked) snackbarWarning("MRSS Feed selected is Empty");
            return;
        }
        if (!checked) onChangeSelected(selected.filter((s)=>videos.find((v)=>v.token === s) === undefined));
        else onChangeSelected((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).union(selected, videos.map((v)=>v.token)));
    };
    const handleVideoToggle = (video, isSelected)=>{
        const index = selected.indexOf(video);
        const videosToken = videos.map((v)=>v.token);
        const selections = (0, $5094343bfed31c54$export$83796d047265408f)(video, videosToken, shiftSelectionState, $276a3353e67d6fac$var$prevSelected);
        let newSelected;
        if (isSelected && index === -1) newSelected = [
            ...selected,
            ...selections
        ];
        else if (!isSelected && index > -1) newSelected = selected.filter((i)=>!selections.includes(i));
        $276a3353e67d6fac$var$prevSelected = shiftSelectionState ? undefined : video;
        onChangeSelected(newSelected);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const handleScroll = ()=>{
            if (isFetchingNextPage || !hasNextPage) return;
            const { scrollTop: scrollTop, offsetHeight: documentHeight } = document.documentElement;
            const windowHeight = window.innerHeight;
            if (documentHeight - scrollTop <= 10 * windowHeight) fetchNextPage();
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, [
        isFetchingNextPage,
        hasNextPage
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
        elevation: 0,
        expanded: expanded,
        onChange: ()=>setExpanded((oldValue)=>!oldValue),
        sx: {
            "&:before": {
                display: "none"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                className: classes.summary,
                sx: {
                    marginLeft: "8px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "black",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                isChecked: videos.length > 0 ? videos.every((v)=>selected.includes(v.token)) : selectedAll,
                                onToggle: handleToggleAll
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: "14px",
                                            fontWeight: 500
                                        },
                                        children: title
                                    }),
                                    subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: "10px"
                                        },
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7efadcd1f5507aa3$export$2e2bcd8739ae039), {
                                className: classes.arrow,
                                alt: "expand icon"
                            }),
                            state
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b050cbbc95334a82$export$2e2bcd8739ae039), {
                                onViewChange: setViewType,
                                viewType: viewType
                            }),
                            menuButtonProps && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0809e2665cadfb12$export$2e2bcd8739ae039), {
                                ...menuButtonProps
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                className: classes.details,
                children: [
                    videos.length > 0 && (viewType === "card" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10fe11384c3682d1$export$b152b8aa9757e899), {
                        videos: videos,
                        selected: selected,
                        isSelectable: true,
                        onVideoToggle: handleVideoToggle
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f02c4b2cdb768b74$export$2e2bcd8739ae039), {
                        videos: videos,
                        selectedVideosToken: selected,
                        onToggleAll: handleToggleAll,
                        // TODO: need to fix ts error, setting single type for onVideoToggle arguments, some cases it's video array, in other cases it's tokens array
                        onVideoToggle: handleVideoToggle
                    })),
                    isFetching && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            padding: "20px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {
                            style: {
                                width: "50px"
                            }
                        })
                    })
                ]
            })
        ]
    });
}




/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $dgtCa = parcelRequire("dgtCa");

/* eslint-disable react/prop-types */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $1GFtd = parcelRequire("1GFtd");
const $df4f9efe1d4f1c80$var$useStyles = (0, $1GFtd.default)({
    select: {
        "& fieldset.MuiOutlinedInput-notchedOutline": {
            backgroundColor: "transparent",
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0
        }
    }
});
function $df4f9efe1d4f1c80$export$2e2bcd8739ae039({ className: className, classNames: classNames, theme: theme, ...props }) {
    const classes = $df4f9efe1d4f1c80$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))), {
        className: className || classes.select,
        classNames: classNames || {
            selectContainer: classes.select
        },
        theme: theme || (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).THEME_ENUM.v2,
        ...props
    });
}


var $ddf0617b838f18a6$export$2e2bcd8739ae039 = (0, $df4f9efe1d4f1c80$export$2e2bcd8739ae039);



function $becefbda4bb15a13$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit }) {
    const [sort, setSort] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("default");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))), {
        className: "modal",
        title: "Sort Videos",
        isOpen: isOpen,
        onClose: onClose,
        inputContainer: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                    label: "Sort Videos",
                    value: sort,
                    onChange: setSort,
                    style: {
                        width: "200px"
                    },
                    items: [
                        {
                            text: "Newest Videos By Date",
                            value: "default"
                        },
                        {
                            text: "Stop Videos Older than 30 Days",
                            value: "only_recent"
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    gap: "20px",
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                            id: "cancel-update-video-order",
                            variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                            id: "confirm-update-video-order",
                            variant: (0, $dgtCa.VARIANT_ENUM).contained,
                            text: "Update Video Order"
                        })
                    ]
                })
            ]
        }),
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).THEME_ENUM.v2
    });
}


function $fb78ad6f378ef71d$export$9b467e964d61e7fb({ feed: feed }) {
    return !feed.active ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e484133473dd7fbd$export$2e2bcd8739ae039), {
                fontSize: "small"
            }),
            " Disconnected"
        ]
    }) : !feed.healthy ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WoTm.default), {
                fontSize: "small",
                color: "warning"
            }),
            " Unhealthy"
        ]
    }) : feed.running ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5283f343a5d9590e$export$2e2bcd8739ae039), {
                fontSize: "small",
                color: "primary"
            }),
            " Running"
        ]
    }) : Date.now() - new Date(feed.updated_at).getTime() < 86400000 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bNGtB.default), {
                fontSize: "small",
                color: "success"
            }),
            " Updated"
        ]
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
}
function $fb78ad6f378ef71d$export$2e2bcd8739ae039({ feed: feed, onChangeSelected: onChangeSelected, query: query, selected: selected }) {
    const [sortQuery, setSortQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [showSortingModal, setShowSortingModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showDeleteModal, setShowDeleteModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [shouldConfirmDisconnect, setShouldConfirmDisconnect] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { api: api } = (0, $55a90792c19f66c6$export$2e2bcd8739ae039)({});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $becefbda4bb15a13$export$2e2bcd8739ae039), {
                isOpen: showSortingModal,
                onClose: ()=>setShowSortingModal(false),
                onSubmit: (s)=>{
                    if (s === "only_recent") setSortQuery({
                        created_at: {
                            $gt: Date.now() - 2592000000
                        }
                    });
                    else setSortQuery({});
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: shouldConfirmDisconnect,
                header: "Are you sure you want to disconnect the MRSS Feed Link?",
                body: "This will stop new videos from being uploaded into the Library.",
                submitButtonText: "Disconnect",
                onClose: ()=>setShouldConfirmDisconnect(false),
                onSubmitClick: ()=>{
                    api.update({
                        token: feed.token,
                        data: {
                            ...feed,
                            active: false
                        }
                    });
                    setShouldConfirmDisconnect(false);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: showDeleteModal,
                header: "Are you sure you want to delete the MRSS Feed?",
                submitButtonText: "Delete MRSS Feed",
                onClose: ()=>setShowDeleteModal(false),
                onSubmitClick: ()=>{
                    api.delete({
                        token: feed.token
                    });
                    setShowDeleteModal(false);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $276a3353e67d6fac$export$2e2bcd8739ae039), {
                menuButtonProps: {
                    items: [
                        {
                            key: "sync",
                            inner: feed.active ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e484133473dd7fbd$export$2e2bcd8739ae039), {}),
                                    "Disconnect MRSS Feed Link"
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b145ac0bd9a8004e$export$2e2bcd8739ae039), {}),
                                    "Connect MRSS Feed Link"
                                ]
                            }),
                            onClick: ()=>{
                                if (feed.active) setShouldConfirmDisconnect(true);
                                else api.update({
                                    token: feed.token,
                                    data: {
                                        ...feed,
                                        active: false
                                    }
                                });
                            }
                        },
                        {
                            key: "sorting",
                            inner: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd249ba0cb5270d6$export$2e2bcd8739ae039), {}),
                                    "Change Sort Videos"
                                ]
                            }),
                            onClick: ()=>{
                                setShowSortingModal(true);
                            }
                        },
                        {
                            key: "deleting",
                            inner: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {}),
                                    "Delete MRSS Feed Link"
                                ]
                            }),
                            onClick: ()=>{
                                setShowDeleteModal(true);
                            }
                        }
                    ]
                },
                title: `MRSS Feed: ${feed.feed_url}`,
                subtitle: feed.token ? `Feed Token: ${feed.token}` : "",
                query: {
                    ...query,
                    ...sortQuery,
                    imported_from: feed.token
                },
                state: /*#__PURE__*/ (0, $ayMG0.jsx)($fb78ad6f378ef71d$export$9b467e964d61e7fb, {
                    feed: feed
                }),
                selected: selected,
                onChangeSelected: onChangeSelected
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $a720e39beaad5850$export$82ca86ed83c7174c;
(function(MULTIPLE_TYPE_ENUM) {
    MULTIPLE_TYPE_ENUM["default"] = "default";
    MULTIPLE_TYPE_ENUM["checkmark"] = "checkmark";
    MULTIPLE_TYPE_ENUM["chip"] = "chip";
})($a720e39beaad5850$export$82ca86ed83c7174c || ($a720e39beaad5850$export$82ca86ed83c7174c = {}));
var $a720e39beaad5850$export$c446d1d1cc068bad;
(function(SIZE_ENUM) {
    SIZE_ENUM["small"] = "small";
    SIZE_ENUM["medium"] = "medium";
})($a720e39beaad5850$export$c446d1d1cc068bad || ($a720e39beaad5850$export$c446d1d1cc068bad = {}));



function $f822a1fa4e956c2d$export$2e2bcd8739ae039({ asAdmin: asAdmin, isEnabled: isEnabled, value: value, onChange: onChange }) {
    let query;
    /* if (asAdmin) query = { asAdmin }; */ /* const { categories } = useCategories(query); */ /* eslint-enable @typescript-eslint/no-unused-vars */ const durations = [
        {
            text: "< 30 seconds",
            value: 30
        },
        {
            text: "< 1 minute",
            value: 60
        },
        {
            text: "< 5 minutes",
            value: 300
        },
        {
            text: "< 10 minutes",
            value: 600
        },
        {
            text: "> 10 minutes",
            value: -1
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
        label: "Content Length",
        isEnabled: isEnabled,
        value: value,
        items: durations.map((d)=>({
                text: d.text,
                value: d.value
            })),
        isMultiple: true,
        multipleType: (0, $a720e39beaad5850$export$82ca86ed83c7174c).checkmark,
        onChange: onChange
    });
}





function $2ae0082acbe2bc98$export$2e2bcd8739ae039({ asAdmin: asAdmin, publisherSlug: publisherSlug, selected: selected, onChangeSelected: onChangeSelected, createOptions: copt }) {
    const [search, setSearch] = (0, $acw62.useState)("");
    const { data: feeds, query: feedsQuery } = (0, $55a90792c19f66c6$export$2e2bcd8739ae039)({
        ...publisherSlug && {
            slug: publisherSlug
        }
    });
    const [selectedCategories, setSelectedCategories] = (0, $acw62.useState)([]);
    const [selectedDurations, setSelectedDurations] = (0, $acw62.useState)([]);
    const [dateRange, setDateRange] = (0, $acw62.useState)();
    const query = {
        ...search && {
            text: search
        },
        ...selectedCategories.length > 0 && {
            category: selectedCategories
        },
        ...selectedDurations.length > 0 && {
            duration: selectedDurations
        },
        ...dateRange && dateRange.to && dateRange.from && {
            date_range: dateRange
        },
        ...publisherSlug && {
            slug: publisherSlug
        }
    };
    const debouncedTrack = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $f1q41.debounce)((event, data)=>{
            (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track(event, data);
        }, 3000), []);
    (0, $acw62.useEffect)(()=>{
        if (search || selectedCategories?.length > 0 || selectedDurations?.length > 0 || dateRange) debouncedTrack("Search", {
            resource: "video",
            text: search,
            categories: selectedCategories,
            durations: selectedDurations,
            date: dateRange
        });
    }, [
        search,
        selectedCategories,
        selectedDurations,
        dateRange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    item: true,
                    xs: 12,
                    md: 12,
                    gap: 3,
                    justifyContent: "flex-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db95cc6529792278$export$2e2bcd8739ae039), {
                            placeholder: "Search",
                            onDebounceEnd: setSearch
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 3,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b9509b4cff86a85$export$2e2bcd8739ae039), {
                                asAdmin: asAdmin,
                                // TODO: need to fix the type of selectedCategories, as it's not a string[]
                                value: selectedCategories,
                                onChange: (cat)=>{
                                    setSelectedCategories([
                                        ...selectedCategories,
                                        cat
                                    ]);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 3,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f822a1fa4e956c2d$export$2e2bcd8739ae039), {
                                asAdmin: asAdmin,
                                value: selectedDurations,
                                onChange: (duration)=>{
                                    setSelectedDurations([
                                        ...selectedDurations,
                                        duration
                                    ]);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 3,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f195e6d38f66fca$export$5109c6dd95d8fb00), {
                                onDateRangeChange: (selectedDate)=>{
                                    setDateRange(selectedDate);
                                },
                                value: dateRange
                            })
                        })
                    ]
                })
            }),
            feedsQuery.isFetched ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: feeds?.length > 0 && feeds.map((f)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb78ad6f378ef71d$export$2e2bcd8739ae039), {
                        feed: f,
                        query: query,
                        selected: selected,
                        onChangeSelected: onChangeSelected
                    }, f.token))
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: "100%",
                    height: "calc(100vh - 259px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lkxXU = parcelRequire("lkxXU");

















function $81993be2bdff5cbf$export$2e2bcd8739ae039({ asAdmin: asAdmin, selectedVideos: selectedVideos, onChangeSelected: onChangeSelected, isBulkDeleteOpen: isBulkDeleteOpen, setIsBulkDeleteOpen: setIsBulkDeleteOpen, query: query, setQuery: setQuery, publisherSlug: publisherSlug }) {
    const [search, setSearch] = (0, $acw62.useState)("");
    const [selectedCategories, setSelectedCategories] = (0, $acw62.useState)([]);
    const [selectedTags, setSelectedTags] = (0, $acw62.useState)([]);
    const [dateRange, setDateRange] = (0, $acw62.useState)();
    const { snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const { api: api } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const [snackbarState, setSnackbarState] = (0, $acw62.useState)({
        type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
        isOpen: false,
        message: ""
    });
    const { videos: videos, query: videosQuery, totalCount: totalCount } = (0, $7f956d50de0acb82$export$2e2bcd8739ae039)(query);
    const { tags: initialTags } = (0, $4be2481e2af7cc00$export$2e2bcd8739ae039)({
        ...publisherSlug && {
            slug: publisherSlug
        }
    });
    const { debouncedUpdateSearch: debouncedUpdateSearch, updateAutocompleteParam: updateAutocompleteParam, updateDateRangeParams: updateDateRangeParams, getParamAsArray: getParamAsArray, getParamAsString: getParamAsString, getParamAsDateRange: getParamAsDateRange } = (0, $fa18b1697d991a50$export$560024ff4d816068)();
    const handleCloseSnackbar = ()=>{
        setSnackbarState({
            ...snackbarState,
            isOpen: false
        });
    };
    const handleConfirmBulkDelete = (0, $acw62.useCallback)(async ()=>{
        try {
            await api.Media.bulkRemove({
                tokens: selectedVideos.map((video)=>video.token),
                group: publisherSlug
            });
            queryClient.invalidateQueries([
                "videos",
                query
            ]);
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
                isOpen: true,
                message: `Successfully deleted video(s)`
            });
            onChangeSelected([]);
        } catch (error) {
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).error,
                isOpen: true,
                message: `Failed to deleted videos`
            });
        } finally{
            setIsBulkDeleteOpen(false);
        }
    }, [
        isBulkDeleteOpen,
        api.Media,
        queryClient,
        query
    ]);
    const handleToggleAll = (checked)=>{
        if (!checked) {
            onChangeSelected([]);
            return;
        }
        if (videos.length === 0) {
            snackbarWarning("The Video Library is empty.");
            return;
        }
        const tempSelectedVideos = videos.filter((video)=>(0, $5094343bfed31c54$export$9667a007680253be)(video.state));
        if (tempSelectedVideos.length === 0) {
            snackbarWarning("No videos with an active or draft state.");
            return;
        }
        onChangeSelected(tempSelectedVideos);
    };
    // Handle toggling selection for a single video
    const handleVideoToggle = (selectedVideo, isSelected)=>{
        if (isSelected) onChangeSelected([
            ...selectedVideos,
            selectedVideo
        ]);
        else onChangeSelected(selectedVideos.filter((video)=>video.token !== selectedVideo.token));
    };
    const handleSearch = (value)=>{
        setSearch(value);
        debouncedUpdateSearch(value);
    };
    const handleCategories = (categories)=>{
        setSelectedCategories(categories);
        updateAutocompleteParam("categories", categories);
    };
    const handleTags = (tags)=>{
        setSelectedTags(tags);
        updateAutocompleteParam("tags", tags, "name");
    };
    const handleDateChange = (range)=>{
        setDateRange(range);
        updateDateRangeParams(range);
    };
    (0, $acw62.useEffect)(()=>{
        const searchParam = getParamAsString("search");
        const categoryIds = getParamAsArray("categories");
        const range = getParamAsDateRange();
        setSearch(searchParam);
        setSelectedCategories((0, $e4f44006c888bb84$export$3ee9b4aab65c61a7).filter((category)=>categoryIds.includes(String(category.id))));
        setDateRange(range);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const tagNames = getParamAsArray("tags");
        setSelectedTags(initialTags.map((tag, id)=>({
                id: id,
                name: tag
            })).filter((tag)=>tagNames.includes(String(tag.name))));
    }, [
        initialTags
    ]);
    (0, $acw62.useEffect)(()=>{
        const newQuery = {
            ...search.length >= 3 && {
                text: search
            },
            ...selectedCategories.length > 0 && {
                category: selectedCategories.map((category)=>category.name.toLowerCase())
            },
            ...selectedTags.length > 0 && {
                tags: selectedTags.map((tag)=>tag.name)
            },
            ...publisherSlug && {
                slug: publisherSlug
            },
            ...dateRange && dateRange.to && dateRange.from && {
                date_range: dateRange
            }
        };
        setQuery(newQuery);
    }, [
        search,
        selectedCategories,
        selectedTags,
        dateRange,
        publisherSlug
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                container: true,
                xs: 12,
                md: 12,
                spacing: 2,
                justifyContent: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: "auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db95cc6529792278$export$2e2bcd8739ae039), {
                            placeholder: "Search",
                            text: search,
                            onTextChange: handleSearch
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: "auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b9509b4cff86a85$export$2e2bcd8739ae039), {
                            value: selectedCategories,
                            onChange: handleCategories
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: "auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f7ac4fbe33a42d7$export$2e2bcd8739ae039), {
                            asAdmin: asAdmin,
                            value: selectedTags,
                            onChange: handleTags
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: "auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f195e6d38f66fca$export$5109c6dd95d8fb00), {
                            onDateRangeChange: handleDateChange,
                            value: dateRange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                variant: "fullWidth",
                sx: {
                    mt: "21px",
                    borderColor: "transparent"
                }
            }),
            videosQuery.isFetched ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f02c4b2cdb768b74$export$2e2bcd8739ae039), {
                videos: videos,
                selectedVideosToken: selectedVideos.map((video)=>video.token),
                onToggleAll: handleToggleAll,
                onVideoToggle: handleVideoToggle,
                query: query,
                totalCount: totalCount
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d803cf99079fa048$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: isBulkDeleteOpen,
                onClose: ()=>setIsBulkDeleteOpen(false),
                onSubmitClick: handleConfirmBulkDelete,
                header: "Delete Video(s)",
                body: "Deleting these video(s) will permanently remove them from your library and any existing playlists. Are you sure you want to proceed?",
                submitButtonText: "Delete",
                cancelButtonText: "Cancel"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48733ae2ee9b2cdf$export$2e2bcd8739ae039), {
                type: snackbarState.type,
                isOpen: snackbarState.isOpen,
                onClose: handleCloseSnackbar,
                message: snackbarState.message
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");

var $1GFtd = parcelRequire("1GFtd");
const $0e5d371a44cc2550$var$useStyles = (0, $1GFtd.default)({
    menuPaper: {
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        marginTop: "-10px",
        minWidth: "160px"
    },
    menuItem: {
        fontSize: "11px",
        padding: "8px 16px",
        color: "#000000",
        "&:hover": {
            backgroundColor: "#f5f5f5"
        }
    },
    menuList: {
        padding: 0
    }
});
const $0e5d371a44cc2550$var$AnchorMenu = ({ anchorEl: anchorEl, open: open, onClose: onClose, menuItems: menuItems })=>{
    const classes = $0e5d371a44cc2550$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
        anchorEl: anchorEl,
        open: open,
        onClose: onClose,
        classes: {
            paper: classes.menuPaper
        },
        MenuListProps: {
            "aria-labelledby": "edit-videos",
            className: classes.menuList
        },
        children: menuItems.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                className: classes.menuItem,
                onClick: ()=>{
                    item.onClick();
                    onClose();
                },
                children: item.label
            }, item.label))
    });
};
var $0e5d371a44cc2550$export$2e2bcd8739ae039 = $0e5d371a44cc2550$var$AnchorMenu;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");


var $htqGM = parcelRequire("htqGM");

var $6vVdw = parcelRequire("6vVdw");


var $1GFtd = parcelRequire("1GFtd");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b8d976dd8c0b005c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), "Cancel");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $70f5a6bcfc957e17$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "AddCircleOutline");













const $fe4dfc5ed1fd5320$var$useStyles = (0, $1GFtd.default)({
    dialogPaper: (props)=>({
            "& .MuiDialog-paper": {
                minWidth: props.bulkEditType === (0, $8ca75cf684bd0a38$export$7aa631536f5ac276).TAGS ? "1152px" : "620px",
                height: "auto !important",
                padding: "20px",
                margin: 0
            },
            "& .MuiDialog-paper > div:nth-of-type(3), & .MuiDialog-paper > div:nth-of-type(4)": {
                marginTop: "30px"
            }
        }),
    dataTableContainer: {
        border: "1px solid #91A0AD",
        marginTop: "30px"
    }
});
const $fe4dfc5ed1fd5320$var$BulkEditMediaModal = ({ asAdmin: asAdmin, isOpen: isOpen, onClose: onClose, videos: videos, bulkEditType: bulkEditType, query: query })=>{
    const classes = $fe4dfc5ed1fd5320$var$useStyles({
        bulkEditType: bulkEditType
    });
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const { api: api } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const [isAllChecked, setIsAllChecked] = (0, $acw62.useState)(false);
    const [selectedTags, setSelectedTags] = (0, $acw62.useState)([]);
    const [selectedCategories, setSelectedCategories] = (0, $acw62.useState)(null);
    const [selectedVideos, setSelectedVideos] = (0, $acw62.useState)([]);
    const [isSubmitEnabled, setISubmitEnabled] = (0, $acw62.useState)(true);
    const [allVideos, setAllVideos] = (0, $acw62.useState)([]);
    const [snackbarState, setSnackbarState] = (0, $acw62.useState)({
        type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
        isOpen: false,
        message: ""
    });
    const tagsQuery = {
        ...publisherSlug && {
            slug: publisherSlug
        }
    };
    const { refetch: refetchTags } = (0, $4be2481e2af7cc00$export$2e2bcd8739ae039)(tagsQuery);
    const handleToggleAll = (checked)=>{
        setIsAllChecked(!isAllChecked);
        setSelectedVideos(checked ? allVideos : []);
    };
    const removeVideoTags = (existingVideos, token, removedTag)=>existingVideos.map((video)=>video.token === token ? {
                ...video,
                tags: video.tags.filter((tag)=>tag !== removedTag)
            } : video);
    const handleCloseSnackbar = ()=>setSnackbarState({
            ...snackbarState,
            isOpen: false
        });
    const handleRemoveTags = (row, removedTag)=>{
        setAllVideos((prevAllVideos)=>removeVideoTags(prevAllVideos, row.token, removedTag));
        setSelectedVideos((prevSelectedVideos)=>removeVideoTags(prevSelectedVideos, row.token, removedTag));
    };
    const handleAddTags = ()=>{
        const tagsToAdd = selectedTags.map((tag)=>tag.name);
        setAllVideos((prevAllVideos)=>prevAllVideos.map((video)=>selectedVideos.some((selectedVideo)=>selectedVideo.token === video.token) ? {
                    ...video,
                    tags: Array.from(new Set([
                        ...video.tags,
                        ...tagsToAdd
                    ]))
                } : video));
        setSelectedVideos((prevSelectedVideos)=>prevSelectedVideos.map((video)=>({
                    ...video,
                    tags: Array.from(new Set([
                        ...video.tags,
                        ...tagsToAdd
                    ]))
                })));
        setSelectedTags([]);
    };
    const handleSubmit = async ()=>{
        try {
            if (selectedVideos.length > (0, $5dc958303e06c3a5$export$24cce83894f67e7a)) {
                setSnackbarState({
                    type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).error,
                    isOpen: true,
                    message: `Maximum videos count for bulk edit is ${(0, $5dc958303e06c3a5$export$24cce83894f67e7a)}`
                });
                return;
            }
            setISubmitEnabled(false);
            if (bulkEditType === (0, $8ca75cf684bd0a38$export$7aa631536f5ac276).CATEGORY) await api.Media.bulkEditCategory({
                tokens: allVideos.map((video)=>video.token),
                category: selectedCategories.name.toLowerCase(),
                group: publisherSlug
            });
            else if (bulkEditType === (0, $8ca75cf684bd0a38$export$7aa631536f5ac276).TAGS) await api.Media.bulkEditTags({
                medias: selectedVideos,
                group: publisherSlug
            });
            else return;
            queryClient.invalidateQueries([
                "videos",
                query
            ]);
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).success,
                isOpen: true,
                message: `Successfully updated ${bulkEditType}`
            });
        } catch (error) {
            setSnackbarState({
                type: (0, $5e01f9464c1d6970$exports.TYPE_ENUM).error,
                isOpen: true,
                message: `Failed to edit ${bulkEditType}`
            });
        } finally{
            setISubmitEnabled(true);
        }
    };
    const handleRowToggle = (selectedVideo, isChecked)=>{
        if (isChecked) setSelectedVideos([
            ...selectedVideos,
            selectedVideo
        ]);
        else setSelectedVideos(selectedVideos.filter((video)=>video.token !== selectedVideo.token));
    };
    const videoTagChips = (row, tags)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: tags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))), {
                    style: (0, $7fe6dc14a14eebbb$export$d97d0946c568efa5),
                    ...row.isChecked && {
                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
                            sx: {
                                color: "#91A0AD !important"
                            },
                            onClick: ()=>handleRemoveTags(row, tag)
                        })
                    },
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))).THEME_ENUM.v2,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($6vVdw))).TYPE_ENUM.transparent,
                    data: {
                        text: tag,
                        id: tag
                    }
                }, tag))
        });
    const tagsBulkEdit = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f7ac4fbe33a42d7$export$2e2bcd8739ae039), {
                            value: selectedTags,
                            onChange: setSelectedTags,
                            asAdmin: asAdmin
                        }),
                        selectedTags.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "h6",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            style: {
                                fontSize: "11px",
                                marginLeft: "5px",
                                padding: "8px 8px 8px 12px",
                                cursor: "pointer"
                            },
                            onClick: ()=>handleAddTags(),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70f5a6bcfc957e17$export$2e2bcd8739ae039), {
                                    sx: {
                                        marginRight: "4px"
                                    }
                                }),
                                " Add"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        border: "1px solid #91A0AD",
                        marginTop: "30px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))), {
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).THEME_ENUM.v2,
                        config: {
                            pagination: {
                                initialPageSize: 5
                            },
                            data: {
                                columns: [
                                    {
                                        type: (0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))).CELL_TYPE_ENUM.checkbox,
                                        headerName: "",
                                        field: "isChecked",
                                        renderHeader: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                                isChecked: isAllChecked,
                                                onToggle: handleToggleAll
                                            }),
                                        renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                                                isChecked: row.isChecked,
                                                onToggle: (isChecked)=>handleRowToggle(row, isChecked)
                                            })
                                    },
                                    {
                                        headerName: "Video Title",
                                        field: "video_title",
                                        width: "300px"
                                    },
                                    {
                                        headerName: "Tags",
                                        field: "tags",
                                        renderCell: (row)=>videoTagChips(row, row.tags || [])
                                    }
                                ],
                                rows: allVideos.map((video)=>({
                                        ...video,
                                        video_title: video.title,
                                        isChecked: selectedVideos.some((selectedVideo)=>selectedVideo.token === video.token)
                                    }))
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        fontSize: "12px",
                        marginTop: "12px"
                    },
                    children: [
                        "Selected Videos ",
                        selectedVideos.length
                    ]
                })
            ]
        });
    (0, $acw62.useEffect)(()=>{
        if (videos.length > 0 && isOpen) {
            refetchTags();
            setAllVideos(videos);
            if (bulkEditType === (0, $8ca75cf684bd0a38$export$7aa631536f5ac276).TAGS) {
                setIsAllChecked(true);
                setSelectedVideos(videos);
            }
        }
        if (!isOpen) {
            setIsAllChecked(false);
            setSelectedVideos([]);
        }
    }, [
        videos,
        isOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))), {
        className: `confirm-modal ${classes.dialogPaper}`,
        isOpen: isOpen,
        onClose: onClose,
        header: `Bulk Edit ${(0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(bulkEditType)}`,
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).THEME_ENUM.v2,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).TYPE_ENUM.confirmation,
        inputContainer: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                bulkEditType === (0, $8ca75cf684bd0a38$export$7aa631536f5ac276).TAGS ? tagsBulkEdit() : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b9509b4cff86a85$export$2e2bcd8739ae039), {
                            value: selectedCategories,
                            onChange: setSelectedCategories,
                            isMultiple: false,
                            hasCheckbox: false
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                position: "absolute",
                                bottom: "20px",
                                left: "20px",
                                fontSize: "12px"
                            },
                            children: [
                                "Selected Videos ",
                                videos.length
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48733ae2ee9b2cdf$export$2e2bcd8739ae039), {
                    type: snackbarState.type,
                    isOpen: snackbarState.isOpen,
                    onClose: handleCloseSnackbar,
                    message: snackbarState.message
                })
            ]
        }),
        submitButtonText: "Save",
        cancelButtonText: "Cancel",
        isSubmitButtonEnabled: isSubmitEnabled && (selectedCategories !== null || selectedVideos.length > 0),
        onSubmitClick: ()=>handleSubmit()
    });
};
var $fe4dfc5ed1fd5320$export$2e2bcd8739ae039 = $fe4dfc5ed1fd5320$var$BulkEditMediaModal;







function $e8f3c29d364c2853$export$bec5ce498e1ba61e({ enabled: enabled, query: query } = {
    enabled: false
}) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const fetchDomains = async (q)=>{
        let domains = await api.getDomains(q);
        domains = domains.map((domain)=>{
            domain.configs.sort((c1, c2)=>new Date(c2.created_at).getTime() - new Date(c1.created_at).getTime());
            return domain;
        });
        return domains.sort((d1, d2)=>new Date(d1.created_at).getTime() - new Date(d2.created_at).getTime());
    };
    // eslint-disable-next-line max-len
    const domainsQuery = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "domain-configs",
        query || {}
    ], ()=>fetchDomains(query), {
        staleTime: Infinity,
        keepPreviousData: true,
        enabled: enabled && didLoad
    });
    const createMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ domain: domain, username: username, slug: slug, createAdUnits: createAdUnits })=>api.createDomain({
                domain: domain,
                slug: slug,
                username: username,
                createAdUnits: createAdUnits
            }),
        onSuccess: (response)=>{
            const previousData = queryClient.getQueryData([
                "domain-configs",
                query
            ]);
            const domainData = {
                configs: [],
                created_at: new Date().toISOString(),
                created_by: "TODO",
                updated_at: new Date().toISOString(),
                updated_by: "TODO",
                ...response
            };
            queryClient.setQueryData([
                "domain-configs",
                query
            ], previousData ? [
                ...previousData,
                domainData
            ] : [
                domainData
            ]);
            queryClient.setQueryData([
                "domain",
                {
                    token: response.token
                }
            ], domainData);
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const deleteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (token)=>api.deleteDomain(token),
        onSuccess: (_, token)=>{
            queryClient.setQueryData([
                "domain",
                {
                    token: token
                }
            ], undefined);
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const updateConfigMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ config: config, domain: domain })=>api.domain(domain).setConfig(config.token, config),
        onSuccess: (response)=>{
            queryClient.setQueryData([
                "domain",
                {
                    token: response.domain.token
                }
            ], response.domain);
            response.domain.configs.forEach((c)=>queryClient.setQueryData([
                    "domain-config",
                    {
                        token: c.token
                    }
                ], c));
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const updateDomain = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ data: data, domain: domain })=>api.domain(domain).update({
                ...data
            }),
        onSuccess: (response)=>{
            queryClient.setQueryData([
                "domain",
                {
                    token: response.domain.token
                }
            ], response.domain);
            response.domain.configs.forEach((c)=>queryClient.setQueryData([
                    "domain-config",
                    {
                        token: c.token
                    }
                ], c));
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const saveTargetingUrls = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ targeting_urls: targeting_urls, domain: domain, token: token, configToken: configToken })=>api.saveTargetingUrls({
                targeting_urls: targeting_urls,
                domain: domain
            }, token, configToken),
        onSuccess: (response)=>{
            queryClient.setQueryData([
                "targetingUrls",
                {
                    targeting_urls: response.body[0]
                }
            ], response.body[0]);
        }
    });
    const deleteTargetingUrl = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ url: url, token: token, configToken: configToken })=>api.deleteTargetingUrls({
                url: url
            }, token, configToken),
        onSuccess: (response)=>{
            queryClient.setQueryData([
                "url-deleted-message",
                {
                    url: response.body.message
                }
            ], response.body.message);
        }
    });
    const bulkUpdateConfig = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ publishers: publishers, changes: changes, notes: notes })=>api.bulkUpdateDomainsConfig({
                publishers: publishers,
                changes: changes,
                notes: notes
            }),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const bulkDeleteDomain = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ publishers: publishers, changes: changes, notes: notes })=>api.bulkDeleteDomains({
                publishers: publishers,
                changes: changes,
                notes: notes
            }),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    return {
        domains: domainsQuery.data,
        query: domainsQuery,
        create: createMutation.mutate,
        delete: deleteMutation.mutate,
        updateConfig: updateConfigMutation.mutate,
        updateDomain: updateDomain.mutate,
        saveTargetingUrls: saveTargetingUrls.mutate,
        deleteTargetingUrl: deleteTargetingUrl.mutate,
        bulkUpdateDomainsConfig: bulkUpdateConfig.mutate,
        bulkDeleteDomain: bulkDeleteDomain.mutate
    };
}


function $27250de26c0e8d8e$export$2e2bcd8739ae039({ asAdmin: asAdmin, publisherGroup: groupName } = {
    asAdmin: false,
    publisherGroup: ""
}) {
    const { publisherSlug: publisherSlug, publisherGroup: publisherGroup, publisherUsername: publisherUsername } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const [isCreateFormVisible, setIsCreateFormVisible] = (0, $acw62.useState)(false);
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const [anchorElMenu, setAnchorElMenu] = (0, $acw62.useState)(null);
    const [anchorElDomain, setAnchorElDomain] = (0, $acw62.useState)(null);
    const [selectedDomain, setSelectedDomain] = (0, $acw62.useState)(null);
    const [isDomainMenuOpen, setIsDomainMenuOpen] = (0, $acw62.useState)(false);
    const tab = (0, $80f3bd128133629b$export$2e2bcd8739ae039)("tab", (t)=>parseInt(t, 10) || 0);
    const [selectedTab, setSelectedTab] = (0, $acw62.useState)(tab);
    const [selectedVideos, setSelectedVideos] = (0, $acw62.useState)([]);
    const [bulkEditType, setBulkEditType] = (0, $acw62.useState)((0, $8ca75cf684bd0a38$export$7aa631536f5ac276).TAGS);
    const [selectedPlaylists, setSelectedPlaylists] = (0, $acw62.useState)([]);
    const [showUploadPopup, setShowUploadPopup] = (0, $acw62.useState)(false);
    const [isBulkDeleteOpen, setIsBulkDeleteOpen] = (0, $acw62.useState)(false);
    const [generatePlaylistType, setGeneratePlaylistType] = (0, $acw62.useState)();
    const [isEditMenuOpen, setIsEditMenuOpen] = (0, $acw62.useState)(false);
    const [isPlaylistMenuOpen, setIsPlaylistMenuOpen] = (0, $acw62.useState)(false);
    const [isBulkEditOpen, setIsBulkEditOpen] = (0, $acw62.useState)(false);
    const [videoQuery, setVideoQuery] = (0, $acw62.useState)({});
    const { uploadInProgress: uploadInProgress } = (0, $aece6033f0ce4c41$export$327c7ed43d894c97)();
    const query = asAdmin && {
        slug: publisherSlug
    };
    const { domains: domains } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        enabled: true,
        query: query
    });
    const handleUploadClick = (e)=>{
        if (domains && domains.length > 0) {
            setAnchorElDomain(e.currentTarget);
            setIsDomainMenuOpen(true);
        } else {
            setSelectedDomain(null);
            setShowUploadPopup(true);
        }
    };
    const handleDomainSelect = (domain)=>{
        setSelectedDomain(domain);
        setIsDomainMenuOpen(false);
        setShowUploadPopup(true);
    };
    const domainMenuItems = domains?.map((domain)=>({
            label: domain.domain,
            onClick: ()=>handleDomainSelect(domain)
        })) || [];
    const createOptions = {
        isVisible: isCreateFormVisible,
        onClose: ()=>setIsCreateFormVisible(false),
        onSubmit: ()=>{
            setIsCreateFormVisible(false);
        }
    };
    const tabs = [
        {
            label: "Video Library"
        },
        {
            label: "Playlists"
        },
        {
            label: "MRSS Feed"
        }
    ];
    const history = (0, $kfZjc.useHistory)();
    const buttonsConfig = {
        0: [
            {
                id: "upload-videos",
                key: "upload-videos",
                text: uploadInProgress ? "Uploading..." : "Upload Videos",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f14f097c3e15130$export$2e2bcd8739ae039), {}),
                isEnabled: !uploadInProgress,
                onClick: handleUploadClick
            },
            {
                id: "edit-videos",
                key: "edit-videos",
                text: "Edit",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {
                    sx: {
                        color: selectedVideos.length > 0 ? "#ffffff" : "#d1d9de"
                    }
                }),
                isEnabled: selectedVideos.length > 0,
                onClick: (e)=>{
                    setAnchorElMenu(e.currentTarget);
                    setIsEditMenuOpen(true);
                }
            },
            {
                id: "add-to-playlist",
                key: "add-to-playlist",
                text: "Add to Playlist",
                isEnabled: ((0, $5dc958303e06c3a5$export$145b2db09f422acc) || asAdmin) && selectedVideos.length > 0,
                onClick: (e)=>{
                    setAnchorEl(e.currentTarget);
                }
            }
        ],
        1: [
            {
                id: "generate-playlist",
                key: "generate-playlist",
                text: "Generate Playlist",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a5d5a3302e977b8$export$2e2bcd8739ae039), {
                    sx: {
                        marginRight: "4px"
                    }
                }),
                onClick: (e)=>{
                    setAnchorElMenu(e.currentTarget);
                    setIsPlaylistMenuOpen(true);
                },
                isEnabled: !isCreateFormVisible
            }
        ],
        2: [
            {
                id: "edit-mrss",
                key: "edit-mrss",
                text: "Edit",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {}),
                isEnabled: false,
                onClick: (e)=>{
                    setAnchorElMenu(e.currentTarget);
                }
            }
        ]
    };
    const editMenuItems = [
        {
            label: "Categories",
            onClick: ()=>{
                setBulkEditType((0, $8ca75cf684bd0a38$export$7aa631536f5ac276).CATEGORY);
                setIsBulkEditOpen(true);
            }
        },
        {
            label: "Tags",
            onClick: ()=>{
                setBulkEditType((0, $8ca75cf684bd0a38$export$7aa631536f5ac276).TAGS);
                setIsBulkEditOpen(true);
            }
        },
        {
            label: "Delete Selected",
            onClick: ()=>setIsBulkDeleteOpen(true)
        }
    ];
    const generatePlaylistMenu = [
        {
            label: "Generate by categories",
            // TODO: Add function for edit by categories
            onClick: ()=>setGeneratePlaylistType("category")
        },
        {
            label: "Generate by tags",
            // TODO: Add function for edit by tags
            onClick: ()=>setGeneratePlaylistType("tag")
        },
        {
            label: "Custom Playlist",
            onClick: ()=>setGeneratePlaylistType("custom")
        }
    ];
    const handleSelectedTab = (tabValue)=>{
        if (isCreateFormVisible) setIsCreateFormVisible(false);
        setSelectedTab(tabValue);
        history.push(`${window.location.pathname}?tab=${tabValue}`);
    };
    const renderTabContent = ()=>{
        switch(tab){
            case 0:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81993be2bdff5cbf$export$2e2bcd8739ae039), {
                    asAdmin: asAdmin,
                    publisherSlug: publisherSlug,
                    createOptions: createOptions,
                    selectedVideos: selectedVideos,
                    onChangeSelected: setSelectedVideos,
                    isBulkDeleteOpen: isBulkDeleteOpen,
                    setIsBulkDeleteOpen: setIsBulkDeleteOpen,
                    query: videoQuery,
                    setQuery: setVideoQuery
                });
            case 1:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa205eac0ff8b9e3$export$2e2bcd8739ae039), {
                    asAdmin: asAdmin,
                    publisherSlug: publisherSlug,
                    publisherGroup: groupName || publisherGroup,
                    publisherUsername: publisherUsername,
                    createOptions: createOptions,
                    selectedPlaylists: selectedPlaylists,
                    onChangeSelected: setSelectedPlaylists,
                    generateFormType: generatePlaylistType,
                    closeGenerateForm: ()=>setGeneratePlaylistType(undefined)
                });
            case 2:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ae0082acbe2bc98$export$2e2bcd8739ae039), {
                    asAdmin: asAdmin,
                    publisherSlug: publisherSlug,
                    createOptions: createOptions,
                    selected: selectedVideos,
                    onChangeSelected: setSelectedVideos
                });
            default:
                return null;
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (showUploadPopup) setShowUploadPopup(false);
    }, [
        showUploadPopup
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "20px",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        fontSize: "24px",
                        marginY: "12px"
                    },
                    children: "Media Gallery"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e5d371a44cc2550$export$2e2bcd8739ae039), {
                    anchorEl: anchorElDomain,
                    open: isDomainMenuOpen,
                    onClose: ()=>setIsDomainMenuOpen(false),
                    menuItems: domainMenuItems
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e5d371a44cc2550$export$2e2bcd8739ae039), {
                    anchorEl: anchorElMenu,
                    open: isEditMenuOpen,
                    onClose: ()=>setIsEditMenuOpen(false),
                    menuItems: editMenuItems
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e5d371a44cc2550$export$2e2bcd8739ae039), {
                    anchorEl: anchorElMenu,
                    open: isPlaylistMenuOpen,
                    onClose: ()=>setIsPlaylistMenuOpen(false),
                    menuItems: generatePlaylistMenu
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe4dfc5ed1fd5320$export$2e2bcd8739ae039), {
                    isOpen: isBulkEditOpen,
                    onClose: ()=>setIsBulkEditOpen(false),
                    videos: selectedVideos,
                    bulkEditType: bulkEditType,
                    asAdmin: asAdmin,
                    query: videoQuery
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a405ab673e6a7301$export$2e2bcd8739ae039), {
                    showUploadPopup: showUploadPopup && !uploadInProgress,
                    publisherGroup: groupName || publisherGroup,
                    query: videoQuery,
                    selectedDomain: selectedDomain
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b1452a02e8a9e7a9$export$2e2bcd8739ae039), {
                    asAdmin: asAdmin,
                    anchorEl: anchorEl,
                    publisherSlug: publisherSlug,
                    onClose: ()=>setAnchorEl(null),
                    onSubmit: ()=>setSelectedVideos([]),
                    videos: selectedVideos.map((video)=>video.token)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bf093269ed94b0d$export$2e2bcd8739ae039), {
                    buttonsConfig: buttonsConfig[selectedTab],
                    tabsConfig: {
                        onChange: (e, value)=>handleSelectedTab(value),
                        selectedTab: selectedTab,
                        tabs: tabs
                    }
                }),
                renderTabContent()
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");

var $dgtCa = parcelRequire("dgtCa");



var $i4KPV = parcelRequire("i4KPV");


var $AfP12 = parcelRequire("AfP12");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");


var $dgtCa = parcelRequire("dgtCa");

var $AfP12 = parcelRequire("AfP12");


function $44f1e43d99683336$export$2e2bcd8739ae039({ user: user, style: style, username: username, groups: groups, show_edit: show_edit = false, setSelectedUser: setSelectedUser, setUserFormModalIsOpen: setUserFormModalIsOpen }) {
    let userObj;
    if (!user) userObj = {
        username: username,
        groups: groups,
        AdministrativeRole: groups?.includes("admin") ? "Administrator" : "Publisher"
    };
    else userObj = {
        ...user,
        AdministrativeRole: user.groups?.includes("admin") ? "Administrator" : "Publisher"
    };
    const profileProps = (0, $12872af000a28022$export$59fb969267da6e1f)(userObj.name || userObj.username);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: style,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flexFlow: "column",
                    marginTop: "-10px"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efb9fb9496b09505$export$2e2bcd8739ae039), {
                    text: profileProps?.text,
                    color: profileProps?.color,
                    width: 130,
                    height: 130
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    ml: 2,
                    marginLeft: "30px",
                    marginTop: "15px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        color: "text.primary",
                        sx: {
                            marginBottom: "10px"
                        },
                        children: userObj.name || userObj.username
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        color: "text.primary",
                        sx: {
                            marginBottom: "7px",
                            fontWeight: "bold"
                        },
                        children: userObj.AdministrativeRole
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.primary",
                        sx: {
                            marginBottom: "10px",
                            fontWeight: "medium",
                            fontSize: "12px"
                        },
                        children: userObj.email || userObj.username
                    }),
                    show_edit && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                        tooltip: "Edit profile email",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                            theme: (0, $dgtCa.THEME_ENUM).v2,
                            variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                            className: "button-height-35",
                            text: "Edit Profile",
                            onClick: ()=>{
                                setSelectedUser(user);
                                setUserFormModalIsOpen(true);
                            }
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


function $d7d1dfba842fa9e3$export$2e2bcd8739ae039(inputQuery = {}) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api, didLoad: didLoad, userProfile: userProfile, setUserProfile: setUserProfile } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const fetchUsers = (0, $acw62.useCallback)(()=>api && api.getUsers(inputQuery), [
        api,
        inputQuery
    ]);
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "users",
        inputQuery
    ], ()=>fetchUsers(), {
        enabled: didLoad,
        staleTime: Infinity
    });
    const createMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (input)=>api.createUser(input),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "users"
                ]
            });
        }
    });
    const deleteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (username)=>api.deleteUser(username),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "users"
                ]
            });
        }
    });
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ username: username, data: data })=>api.updateUser(username, data),
        onSuccess: (resp)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "users"
                ]
            });
            if (userProfile.username === resp.username) setUserProfile({
                username: resp.username,
                attributes: resp,
                groups: resp.groups
            });
        }
    });
    const inviteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (input)=>api.inviteUser(input),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "users"
                ]
            });
        }
    });
    return {
        query: query,
        users: query.data?.users || [],
        api: {
            create: createMutation.mutate,
            delete: deleteMutation.mutate,
            update: updateMutation.mutate,
            invite: inviteMutation.mutate
        },
        mutations: {
            createMutation: createMutation,
            deleteMutation: deleteMutation,
            updateMutation: updateMutation
        }
    };
}


function $3272e54d3f0ae632$export$2e2bcd8739ae039({ setSelectedUser: setSelectedUser, setUserFormModalIsOpen: setUserFormModalIsOpen, users: users }) {
    const [deleteModalIsOpen, setDeleteModalIsOpen] = $acw62.useState(false);
    const [deletingUser, setDeletingUser] = $acw62.useState({
        username: ""
    });
    const [deleteModalButtonsFlag, setDeleteModalButtonsFlag] = $acw62.useState(true);
    const { api: api } = (0, $d7d1dfba842fa9e3$export$2e2bcd8739ae039)();
    const { snackbarError: snackbarError, snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "row",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
                isOpen: deleteModalIsOpen,
                title: `Are you sure you want to delete ${deletingUser.name || deletingUser.username}`,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f1e43d99683336$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: "25px",
                        marginBottom: "25px"
                    },
                    username: deletingUser.username,
                    groups: deletingUser.groups
                }),
                submitButtonText: "Delete Account",
                isSubmitButtonEnabled: deleteModalButtonsFlag,
                isCancelButtonEnabled: deleteModalButtonsFlag,
                onClose: ()=>setDeleteModalIsOpen(false),
                onSubmit: async ()=>{
                    setDeleteModalButtonsFlag(false);
                    api.delete(deletingUser.username, {
                        onSuccess: ()=>{
                            snackbarSuccess("User Deleted");
                            setDeleteModalIsOpen(false);
                            setDeleteModalButtonsFlag(true);
                        },
                        onError: (e)=>{
                            console.error(e);
                            snackbarError("Error while deleting user. Check the console for more information");
                            setDeleteModalButtonsFlag(true);
                        }
                    });
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    overflowX: "hidden",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                            theme: (0, $dgtCa.THEME_ENUM).v2,
                            variant: (0, $dgtCa.VARIANT_ENUM).contained,
                            className: "button-height-35",
                            text: "Invite User",
                            onClick: ()=>{
                                setSelectedUser({
                                    username: ""
                                });
                                setUserFormModalIsOpen(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "h6",
                            color: "text.primary",
                            sx: {
                                marginLeft: "20px"
                            },
                            children: "Account Users"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))), {
                        theme: (0, $i4KPV.THEME_ENUM).v2,
                        style: {
                            fontFamily: (0, $i4KPV.FONT_FAMILY_ENUM).poppins
                        },
                        className: "data-table",
                        config: {
                            pagination: {
                                initialPageSize: 15
                            },
                            actionMenu: {
                                display: (0, $4353bd6a5a30fa9b$exports.DISPLAY_ENUM).separate,
                                actions: [
                                    {
                                        type: (0, $4353bd6a5a30fa9b$exports.ACTION_TYPE_ENUM).edit,
                                        isHidden: (row)=>row.id === 1,
                                        onClick: (row)=>{
                                            setSelectedUser(row);
                                            setUserFormModalIsOpen(true);
                                        }
                                    },
                                    {
                                        type: (0, $4353bd6a5a30fa9b$exports.ACTION_TYPE_ENUM).archive,
                                        label: "Delete Account",
                                        isHidden: (row)=>row.id === 1,
                                        onClick: (row)=>{
                                            setDeletingUser(row);
                                            setDeleteModalIsOpen(true);
                                        }
                                    }
                                ]
                            },
                            data: {
                                columns: [
                                    {
                                        headerName: "User Name",
                                        field: "name"
                                    },
                                    {
                                        headerName: "Email",
                                        field: "email_or_user"
                                    },
                                    {
                                        headerName: "User Role",
                                        field: "role",
                                        width: "100px"
                                    },
                                    {
                                        headerName: "Properties",
                                        field: "domains",
                                        renderCell: (r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    textTransform: "uppercase",
                                                    paddingLeft: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                        tooltip: r.properties_row_tooltip,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                color: "#91a0ad",
                                                                fontSize: "20px"
                                                            }
                                                        })
                                                    }),
                                                    ` ${r.domains.join(",")}`
                                                ]
                                            })
                                    }
                                ],
                                rows: users.map((u, i)=>{
                                    let role = u?.publisher.users?.find(({ username: username })=>username === u?.username)?.role;
                                    role = role?.charAt(0)?.toUpperCase()?.concat(role?.substring(1));
                                    return {
                                        ...u,
                                        id: u.username,
                                        key: u.username,
                                        name: u.name || u.username,
                                        email_or_user: u.email || u.username,
                                        role: role,
                                        index: i,
                                        properties_row_tooltip: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                className: "circle-list",
                                                children: u.domains.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: item
                                                    }, item))
                                            })
                                        })
                                    };
                                })
                            }
                        }
                    })
                ]
            })
        ]
    });
}




/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $iDAOR = parcelRequire("iDAOR");


var $dgtCa = parcelRequire("dgtCa");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5727d380b42de352$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), "HelpOutline");



var $AfP12 = parcelRequire("AfP12");

function $b9f26d63283413e0$export$2e2bcd8739ae039({ style: style, user: user, domains: domains = [], submit: submit, close: close, cancelButtonEnabled: cancelButtonEnabled = true, submitButtonEnabled: submitButtonEnabled = true, changeCancelButtonState: changeCancelButtonState, changeSubmitButtonState: changeSubmitButtonState }) {
    const [userObj, setUserObj] = (0, $acw62.useState)({
        ...user,
        role: user.role?.toLowerCase()
    });
    const [buttonEnabled, setButtonEnabled] = (0, $acw62.useState)(submitButtonEnabled && userObj.username.length > 1);
    const handleNameChange = (name)=>{
        setUserObj({
            ...userObj,
            name: name
        });
    };
    const handleEmailChange = (email)=>{
        setUserObj({
            ...userObj,
            email: email
        });
        if (email.length && email.indexOf("@") > -1 && userObj.role) setButtonEnabled(true);
    };
    const handlePropertiesChange = (newDomains)=>{
        /* Faking the properties select label */ if (newDomains.length > 1 && newDomains.includes("empty")) newDomains.splice(newDomains.indexOf("empty"), 1);
        if (newDomains.length === 0) newDomains.push("empty");
        setUserObj({
            ...userObj,
            domains: newDomains
        });
    };
    const handleRoleChange = (role)=>{
        setUserObj({
            ...userObj,
            role: role
        });
        if (role && userObj.email.indexOf("@") > -1) setButtonEnabled(true);
    };
    const handleSubmit = ()=>{
        changeSubmitButtonState(false);
        if (userObj.domains?.length > 0 && userObj.domains?.includes("empty")) userObj.domains.splice(userObj.domains.indexOf("empty"), 1);
        submit(userObj);
    };
    const roleTooltip = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            "Admin:",
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: "User management controls over all properties. Controls player creation, player functionality, video content management, and playlist creation for each property. Can access reporting for all properties."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            "Publisher:",
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: "Video content management, playlist creation, and editing permissions on assigned properties."
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "47%"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            text: userObj.name,
                            name: "name",
                            isFullWidth: true,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                            label: "Name",
                            onTextChange: handleNameChange,
                            debounceTime: 0,
                            onDebounceEnd: handleNameChange
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "47%",
                            marginLeft: "50px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            text: userObj.email,
                            name: "email",
                            isFullWidth: true,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                            label: "Email",
                            onTextChange: handleEmailChange,
                            debounceTime: 0,
                            onDebounceEnd: handleEmailChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    marginTop: "25px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "30%"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                            name: "domains",
                            className: "select-no-padding",
                            value: userObj.domains || [
                                "empty"
                            ],
                            items: [
                                {
                                    text: "Properties",
                                    value: "empty",
                                    isHidden: userObj.domains && userObj.domains.length > 0
                                }
                            ].concat(typeof domains?.length !== "undefined" ? domains.map((d)=>({
                                    text: d,
                                    value: d,
                                    isHidden: false
                                })) : []),
                            isMultiple: true,
                            multipleType: (0, $a720e39beaad5850$export$82ca86ed83c7174c).checkmark,
                            onChange: handlePropertiesChange
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "22%",
                            marginLeft: "25px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                            name: "role",
                            value: userObj.role || "empty",
                            items: [
                                {
                                    text: "User Role",
                                    value: "empty",
                                    isHidden: userObj.role && userObj.role.length > 0
                                },
                                {
                                    text: "Admin",
                                    value: "admin",
                                    isHidden: false
                                },
                                {
                                    text: "Analyst",
                                    value: "analyst",
                                    isHidden: false
                                },
                                {
                                    text: "Editor",
                                    value: "editor",
                                    isHidden: false
                                }
                            ],
                            isFullWidth: true,
                            onChange: handleRoleChange
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "5%",
                            marginLeft: "10px",
                            marginTop: "10px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                            tooltip: roleTooltip,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5727d380b42de352$export$2e2bcd8739ae039), {
                                sx: {
                                    color: "#91a0ad",
                                    fontSize: "25px"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "15%",
                            marginLeft: "70px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                            theme: (0, $dgtCa.THEME_ENUM).v2,
                            variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                            className: "button-height-35",
                            sx: {
                                fontSize: "16px"
                            },
                            text: "Cancel",
                            onClick: close,
                            isEnabled: cancelButtonEnabled
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "15%",
                            marginLeft: "20px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                            theme: (0, $dgtCa.THEME_ENUM).v2,
                            variant: (0, $dgtCa.VARIANT_ENUM).contained,
                            className: "button-height-35",
                            sx: {
                                fontSize: "16px"
                            },
                            text: `${user.username.length ? "Save" : "Invite"}`,
                            onClick: handleSubmit,
                            isEnabled: submitButtonEnabled && buttonEnabled
                        })
                    })
                ]
            })
        ]
    });
}









function $d24dbc81e15b91f3$export$2e2bcd8739ae039({ slug: slug, isAdmin: isAdmin, user: userList }) {
    const padding = "20px";
    const session = (0, $99e18646983cd0f4$export$2e2bcd8739ae039)();
    const username = session?.getAccessToken().decodePayload().username;
    const groups = session?.getAccessToken().decodePayload()["cognito:groups"];
    const { userProfile: userProfile } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(isAdmin);
    const publisherQuery = {
        ...isAdmin && {
            slug: publisherSlug || slug
        }
    };
    const { users: users, query: query, api: api } = (0, $d7d1dfba842fa9e3$export$2e2bcd8739ae039)({
        ...publisherQuery
    });
    const [userFormModalIsOpen, setUserFormModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selectedUser, setSelectedUser] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        username: ""
    });
    const [userFormSubmitButtonEnabled, setUserFormSubmitButtonEnabled] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [userFormCancelButtonEnabled, setUserFormCancelButtonEnabled] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const { domains: domains, query: domainsQuery } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        query: {
            ...publisherQuery
        }
    });
    const { snackbarError: snackbarError, snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const handleErrorMessages = (e, message)=>{
        console.error(e);
        snackbarError(typeof e === "string" ? e : e?.message || message);
    };
    if (!query.isFetched || !userProfile) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: "100%",
            height: "calc(100vh - var(--header-height)))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    const userRole = userList?.find((user)=>user?.username === username)?.role;
    const user = {
        username: username,
        role: userRole,
        ...userProfile.attributes,
        groups: groups
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: padding,
        children: [
            domainsQuery.isFetched && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
                isOpen: userFormModalIsOpen,
                title: `${selectedUser.username.length ? "Edit Account Profile" : "Invite User"}`,
                elementClassName: "modal-edit-user",
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b9f26d63283413e0$export$2e2bcd8739ae039), {
                    user: selectedUser,
                    domains: domains?.length && domains?.map((d)=>d.domain),
                    submit: async (newUser)=>{
                        setUserFormSubmitButtonEnabled(false);
                        setUserFormCancelButtonEnabled(false);
                        if (newUser.username.length) {
                            const update = {
                                name: newUser.name,
                                username: newUser.username,
                                email: newUser.email,
                                domains: newUser.domains,
                                role: newUser.role,
                                verify_email: newUser.email !== selectedUser.email,
                                groups: selectedUser.groups || []
                            };
                            api.update({
                                username: selectedUser.username,
                                data: update
                            }, {
                                onSuccess: ()=>{
                                    /* Maybe add a loader or something while the table updates?
                        We can use the mutation states to see if it's still loading */ snackbarSuccess("User Updated");
                                    setUserFormModalIsOpen(false);
                                    setUserFormSubmitButtonEnabled(true);
                                    setUserFormCancelButtonEnabled(true);
                                },
                                onError: (e)=>{
                                    const defaultMessage = "Error while updating user. Check the console for more information";
                                    handleErrorMessages(e, defaultMessage);
                                    setUserFormSubmitButtonEnabled(true);
                                    setUserFormCancelButtonEnabled(true);
                                }
                            });
                        } else {
                            const userInvite = {
                                ...newUser,
                                username: newUser.email,
                                slug: publisherSlug
                            };
                            api.invite(userInvite, {
                                onSuccess: ()=>{
                                    /* Maybe add a loader or something while the table updates?
                      We can use the mutation states to see if it's still loading */ snackbarSuccess("User Invited");
                                    setUserFormModalIsOpen(false);
                                    setUserFormSubmitButtonEnabled(true);
                                    setUserFormCancelButtonEnabled(true);
                                },
                                onError: (e)=>{
                                    const defaultMessage = "Error while inviting user. Check the console for more information";
                                    handleErrorMessages(e, defaultMessage);
                                    setUserFormSubmitButtonEnabled(true);
                                    setUserFormCancelButtonEnabled(true);
                                }
                            });
                        }
                    },
                    cancelButtonEnabled: userFormCancelButtonEnabled,
                    changeCancelButtonState: setUserFormCancelButtonEnabled,
                    submitButtonEnabled: userFormSubmitButtonEnabled,
                    changeSubmitButtonState: setUserFormSubmitButtonEnabled,
                    close: ()=>setUserFormModalIsOpen(false)
                }),
                onClose: ()=>setUserFormModalIsOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginLeft: "15px",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f1e43d99683336$export$2e2bcd8739ae039), {
                    user: user,
                    show_edit: true,
                    setSelectedUser: setSelectedUser,
                    setUserFormModalIsOpen: setUserFormModalIsOpen
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3272e54d3f0ae632$export$2e2bcd8739ae039), {
                    users: users,
                    setSelectedUser: setSelectedUser,
                    setUserFormModalIsOpen: setUserFormModalIsOpen
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dgtCa = parcelRequire("dgtCa");


var $f1q41 = parcelRequire("f1q41");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $30hyv = parcelRequire("30hyv");

var $QpuKB = parcelRequire("QpuKB");

var $elyLx = parcelRequire("elyLx");

var $81yMd = parcelRequire("81yMd");

var $hjXJ8 = parcelRequire("hjXJ8");

var $2XjE0 = parcelRequire("2XjE0");


var $AfP12 = parcelRequire("AfP12");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2XjE0 = parcelRequire("2XjE0");
var $elyLx = parcelRequire("elyLx");
var $9Lykx = parcelRequire("9Lykx");

var $AfP12 = parcelRequire("AfP12");

var $eJaQo = parcelRequire("eJaQo");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1eff010ab2549a67$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Create");


var $8YLZH = parcelRequire("8YLZH");

var $ba07f1d509c74af4$exports = {};
"use strict";
var $ba07f1d509c74af4$var$__createBinding = $ba07f1d509c74af4$exports && $ba07f1d509c74af4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba07f1d509c74af4$var$__exportStar = $ba07f1d509c74af4$exports && $ba07f1d509c74af4$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba07f1d509c74af4$var$__createBinding(exports1, m, p);
};
var $ba07f1d509c74af4$var$__importDefault = $ba07f1d509c74af4$exports && $ba07f1d509c74af4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ba07f1d509c74af4$exports, "__esModule", {
    value: true
});
$ba07f1d509c74af4$exports.THEME_ENUM = void 0;

const $ba07f1d509c74af4$var$krg_switch_react_1 = $ba07f1d509c74af4$var$__importDefault((parcelRequire("56GVS")));

var $i4KPV = parcelRequire("i4KPV");
Object.defineProperty($ba07f1d509c74af4$exports, "THEME_ENUM", {
    enumerable: true,
    get: function() {
        return $i4KPV.THEME_ENUM;
    }
});

$ba07f1d509c74af4$var$__exportStar((parcelRequire("fsTIa")), $ba07f1d509c74af4$exports);
$ba07f1d509c74af4$exports.default = $ba07f1d509c74af4$var$krg_switch_react_1.default;



var $1GFtd = parcelRequire("1GFtd");

var $iDAOR = parcelRequire("iDAOR");

var $dgtCa = parcelRequire("dgtCa");
var $20b8e6b0b51e9b4a$export$2e2bcd8739ae039 = {
    business: "business",
    celebrity: "celebrity",
    education: "education",
    entertainment: "entertainment",
    fashion: "fashion",
    finance: "finance",
    lifestyle: "lifestyle",
    news: "news",
    pets: "pets",
    politics: "law, govt and politics",
    science: "science",
    shareable: "shareable",
    shopping: "shopping",
    society: "society",
    sports: "sports",
    technology: "technology and computing",
    travel: "travel",
    "art and entertainment": "art and entertainment",
    "automotive and vehicles": "automotive and vehicles",
    "Business and Industrial": "business and industrial",
    "family and parenting": "family and parenting",
    "food and drink": "Food and Drink",
    "health and fitness": "health and fitness",
    "hobbies & leisure": "hobbies & leisure",
    "home & garden": "home and garden",
    "style and fashion": "style and fashion"
};


/* eslint-disable @typescript-eslint/no-shadow */ 

function $b5dd5d6a03e10096$export$a13e2cd9aac3d29e(token, domainToken, initialData) {
    const { api: api } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    let queryParams = {
        queryKey: [
            "domain-config",
            {
                token: token
            }
        ],
        queryFn: ()=>api && api.domain(domainToken).getConfig(token).then((res)=>res.config),
        enabled: !!(api && token),
        staleTime: Infinity
    };
    if (initialData) queryParams = {
        ...queryParams,
        initialData: initialData
    };
    const { data: data } = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)(queryParams);
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>api.domain(domainToken).setConfig(token, data),
        onSuccess: (response)=>{
            queryClient.setQueryData([
                "domain",
                {
                    token: token
                }
            ], response.domain);
            response.domain.configs.forEach((c)=>queryClient.setQueryData([
                    "domain-config",
                    {
                        token: c.token
                    }
                ], c));
            queryClient.invalidateQueries({
                queryKey: [
                    "domain"
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const deleteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ()=>api.domain(domainToken).deleteConfig(token),
        onSuccess: ()=>{
            queryClient.setQueryData([
                "domain-config",
                {
                    token: token
                }
            ], undefined);
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const getRevisions = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (configToken)=>api.getRevisionByConfigToken(configToken)
    });
    return {
        data: data,
        getRevisions: getRevisions.mutate,
        update: updateMutation.mutate,
        deleteConfig: (mutateOptions)=>deleteMutation.mutate(undefined, mutateOptions)
    };
}


/* eslint-disable @typescript-eslint/no-unused-vars, no-template-curly-in-string */ function $fceccdce3d74d463$export$2e2bcd8739ae039({ config: config, id: id }) {
    function script(attrs, i) {
        window.top.kso_disablevp = true;
        function init() {
            const p = new window.KargoVideo.Player({
                element: document.getElementById(i),
                attrs: attrs
            });
            p.activate();
        }
        const uri = "https://static.kargovideo.com/player/latest/kargo";
        if (window.KargoVideo) init();
        else {
            const ls = new Promise((resolve, reject)=>{
                const s = document.createElement("script");
                s.src = `${uri}.js`;
                s.onload = resolve;
                s.onerror = reject;
                document.getElementsByTagName("head")[0].append(s);
            });
            const ll = new Promise((resolve, reject)=>{
                const l = document.createElement("link");
                l.rel = "stylesheet";
                l.type = "text/css";
                l.href = `${uri}.css`;
                l.onload = resolve;
                l.onerror = reject;
                document.getElementsByTagName("head")[0].append(l);
            });
            Promise.all([
                ls,
                ll
            ]).then(()=>init());
        }
    }
    const minified = '!function(e,t){function o(){new window.KargoVideo.Player({element:document.getElementById(t),attrs:e}).activate()}window.top.kso_disablevp=!0;const n="https://static.kargovideo.com/player/latest/kargo";if(window.KargoVideo)o();else{const e=new Promise(((e,t)=>{const o=document.createElement("script");o.src=`${n}.js`,o.onload=e,o.onerror=t,document.getElementsByTagName("head")[0].append(o)})),t=new Promise(((e,t)=>{const o=document.createElement("link");o.rel="stylesheet",o.type="text/css",o.href=`${n}.css`,o.onload=e,o.onerror=t,document.getElementsByTagName("head")[0].append(o)}));Promise.all([e,t]).then((()=>o()))}}';
    return `<div id="${id}"></div><script>${minified}(window["${id}-config"] || ${JSON.stringify(config.config || {})}, "${id}")</script>`;
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");


var $iDAOR = parcelRequire("iDAOR");


var $htqGM = parcelRequire("htqGM");
function $1e59a353a8d3e241$export$2e2bcd8739ae039({ id: id, elementClassName: elementClassName, isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, label: label, text: text, title: title, submitButtonText: submitButtonText, cancelButtonText: cancelButtonText, showCheckbox: showCheckbox = false, checkboxLabel: checkboxLabel, error: error = "", setError: setError }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleSubmit = ()=>{
        if (showCheckbox) {
            onSubmit(value || text, isChecked);
            setIsChecked(false);
        } else onSubmit(value || text);
    };
    const handleChange = (v)=>{
        if (error?.length && setError) setError("");
        setValue(v.trim());
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))), {
        className: `modal${elementClassName ? ` ${elementClassName}` : ""}`,
        isOpen: isOpen,
        onClose: onClose,
        onSubmitClick: handleSubmit,
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).THEME_ENUM.v2,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($71ad126b68006e25$exports))).TYPE_ENUM.submit,
        inputContainer: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                    text: text,
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                    onDebounceEnd: handleChange,
                    debounceTime: 0,
                    isFullWidth: true,
                    label: label,
                    errorMessage: error,
                    hasErrorIcon: !!error
                }),
                showCheckbox && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                    isChecked: isChecked,
                    onToggle: ()=>setIsChecked(!isChecked),
                    label: checkboxLabel
                }),
                id && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    className: "id",
                    color: "#91A0AD",
                    fontSize: "10px",
                    children: [
                        "ID: ",
                        id
                    ]
                })
            ]
        }),
        title: title,
        submitButtonText: submitButtonText || "Save",
        cancelButtonText: cancelButtonText || "Cancel"
    });
}





function $a9fd19d627d10772$export$d9dcc325f8df9b84(token, initialData) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    let queryParams = {
        queryKey: [
            "domain",
            {
                token: token
            }
        ],
        queryFn: ()=>api && token && api.getDomain(token).then((res)=>res.domain),
        enabled: !!api,
        staleTime: Infinity,
        onSuccess: (response)=>{
            response?.configs?.forEach((c)=>queryClient.setQueryData([
                    "domain-config",
                    {
                        token: c.token
                    }
                ], c));
        }
    };
    if (initialData) queryParams = {
        ...queryParams,
        initialData: initialData
    };
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)(queryParams);
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>api.domain(token).update(data),
        onSuccess: (response)=>{
            queryClient.setQueryData([
                "domain",
                {
                    token: token
                }
            ], response.domain);
            response.domain.configs.forEach((config)=>queryClient.setQueryData([
                    "domain-config",
                    {
                        token: config.token
                    }
                ], config));
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    const createConfigMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>api.domain(token).createConfig(data),
        onSuccess: (response)=>{
            queryClient.setQueryData([
                "domain",
                {
                    token: token
                }
            ], response.domain);
            response.domain.configs.forEach((config)=>queryClient.setQueryData([
                    "domain-config",
                    {
                        token: config.token
                    }
                ], config));
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
        }
    });
    return {
        ...query,
        update: updateMutation.mutate,
        createConfig: createConfigMutation.mutate
    };
}


/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $8a25b6bdfe002341$export$2e2bcd8739ae039({ asAdmin: asAdmin, isEnabled: isEnabled, value: value, onChange: onChange, query: query }) {
    const { playlists: playlists } = (0, $d91039711271eba9$export$2e2bcd8739ae039)(query);
    if (value && value !== "None" && !playlists.find((p)=>p.token === value)) playlists.push({
        token: value
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
        isEnabled: isEnabled,
        value: value,
        items: [
            {
                text: "None",
                value: "None"
            }
        ].concat(playlists.map((p)=>({
                text: p.title || p.key || p.token,
                value: p.token
            }))),
        onChange: onChange
    });
}


var $ba525c68f348c623$export$2e2bcd8739ae039 = (0, $8a25b6bdfe002341$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $5de35605ce8839db$export$2e2bcd8739ae039({ query: query, isEnabled: isEnabled, value: value, onChange: onChange }) {
    const { MRSSFeeds: MRSSFeeds } = (0, $55a90792c19f66c6$export$2e2bcd8739ae039)(query);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
        isEnabled: isEnabled,
        value: value,
        items: [
            {
                text: "None",
                value: "None"
            }
        ].concat(MRSSFeeds.map((m)=>({
                text: m.name || m.feed_url || m.token,
                value: `${m.token}#${m.user}`
            }))),
        onChange: onChange
    });
}


var $773213f79e406e82$export$2e2bcd8739ae039 = (0, $5de35605ce8839db$export$2e2bcd8739ae039);








var $0d5b949ca1fc17c8$exports = {};
$0d5b949ca1fc17c8$exports = new URL("code.e6d7117e.svg", import.meta.url).toString();


function $c442071f2abf6328$var$Code() {
    const code = new URL($0d5b949ca1fc17c8$exports);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: code,
        style: {
            fontSize: "20px"
        },
        alt: "code"
    });
}
const $c442071f2abf6328$var$useStyles = (0, $1GFtd.default)({
    actionCell: {
        whiteSpace: "nowrap"
    },
    editableCell: {
        "& .MuiInputBase-root": {
            width: "160px"
        },
        "& .MuiIconButton-root": {
            visibility: "hidden"
        },
        "&:hover .MuiIconButton-root": {
            visibility: "visible"
        }
    },
    selectCell: {
        "& .MuiInputBase-root": {
            width: "120px"
        }
    }
});
function $c442071f2abf6328$export$2e2bcd8739ae039({ asAdmin: asAdmin, search: search, config: config, index: index, domain: domain, isCreating: isCreating, query: query, setConfigUpdatingStatus: setConfigUpdatingStatus, onCreateFinished: onCreateFinished, isEditing: isEditing, onUpdate: onUpdate }) {
    // STATES
    const [confirmModalIsOpen, setConfirmModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [isUrlTargetModalOpen, setIsUrlTargetModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [invalidUrlMessage, setInvalidUrlMessage] = (0, $acw62.useState)("");
    const [urlInputState, setUrlInputState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [deletedUrls, setDeletedUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [targetingUrls, setTargetingUrls] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(config?.config?.targeting_urls || []);
    const [exportTagID] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(`krg-${config?.token}-${Date.now()}`);
    const [exportTagModalIsOpen, setExportTagModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showNext, setShowNext] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [noEngageNext, setNoEngageNext] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [selectedCategories, setSelectedCategories] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([
        "auto"
    ]);
    const [key, setKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(config?.key);
    if (!key && key?.trim() !== "" && config?.key) setKey(config?.key);
    const [isEditingTitle, setIsEditingTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isCreating || false);
    // HOOKS
    const classes = $c442071f2abf6328$var$useStyles();
    const { snackbarSuccess: snackbarSuccess, snackbarError: snackbarError, snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const { createConfig: createConfig } = (0, $a9fd19d627d10772$export$d9dcc325f8df9b84)(domain.token, domain);
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ const { update: update, deleteConfig: deleteConfig } = (0, $b5dd5d6a03e10096$export$a13e2cd9aac3d29e)(config?.token, domain.token, config);
    // CONSTANTS
    const targetUrls = config?.config?.targeting_urls || [];
    const outstream = config?.config?.outstream || false;
    const floating = config?.config?.sticky || false;
    const isConfigDeletable = !!config?.is_config_deletable;
    const relatedContent = !!config?.config?.irisplaylist || false;
    const autoplay = config?.config?.autoplaywhenvisible !== false && config?.config?.autoplay !== false;
    const muted = config?.config?.muted !== false;
    // METHODS
    const editingSnackBarWarning = ()=>snackbarWarning("Click Edit Video Player button on the right");
    /* eslint-disable-next-line consistent-return */ const handleUpdate = (updater)=>{
        if (!isEditing) return editingSnackBarWarning();
        if (onUpdate) onUpdate({
            ...domain,
            configs: domain.configs.map((cfg)=>{
                if (cfg.token !== config?.token) return cfg;
                return updater(cfg);
            })
        });
    };
    const handleConfigUpdate = (configUpdater)=>handleUpdate((cfg)=>({
                ...cfg,
                config: {
                    ...cfg.config,
                    ...configUpdater(cfg)
                }
            }));
    const handleEditFinished = async ()=>{
        setIsEditingTitle(false);
        if (isCreating) {
            if (!key) {
                onCreateFinished();
                return;
            }
            setConfigUpdatingStatus(true);
            createConfig({
                key: key
            }, {
                onSuccess: (response)=>{
                    snackbarSuccess("Player Created");
                    onCreateFinished(response.domain);
                    setConfigUpdatingStatus(false);
                },
                onError: (e)=>{
                    console.error(e);
                    snackbarError("Error while creating player. Check the console for more information");
                    onCreateFinished();
                }
            });
        } else if (key && key !== config?.key) handleUpdate(()=>({
                ...config,
                key: key
            }));
    };
    const renderPlayerName = ()=>{
        let displayPlayername = (0, $5094343bfed31c54$export$9960a43c944d4ea4)(config);
        displayPlayername = (0, $12872af000a28022$export$2dc49b88faa8e755)(displayPlayername, 29);
        if (displayPlayername.length > 29) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
            theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
            tooltip: config?.key,
            children: displayPlayername
        });
        return displayPlayername;
    };
    const renderAddUrlButton = (onClick)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                style: {
                    marginRight: -15,
                    color: "inherit"
                }
            }),
            id: config?.key,
            text: "add URL",
            onClick: onClick,
            size: (0, $dgtCa.SIZE_ENUM).small,
            variant: (0, $dgtCa.VARIANT_ENUM).outlined,
            style: {
                width: 100,
                padding: "0 12px 0 10px"
            }
        });
    const handleErrorMessageUrl = (text)=>{
        if (text === "") return text;
        if (!(0, $6bca6f68346a010a$export$c4ea027afed2fe4a)(text)) return "Invalid Url";
        if (!(0, $6bca6f68346a010a$export$81350727a0ff4e2e)(text, domain.domain)) return "Invalid Domain";
        return "";
    };
    const renderUrlModalContent = ()=>{
        const onTextChange = (text)=>{
            setUrlInputState(text);
            setInvalidUrlMessage(handleErrorMessageUrl(text));
        };
        const saveAndCleanInput = ()=>{
            if (targetingUrls.some((url)=>(0, $6bca6f68346a010a$export$6535eb414fa2c8b6)(url) === (0, $6bca6f68346a010a$export$6535eb414fa2c8b6)(urlInputState))) {
                setInvalidUrlMessage("URL already added, try a diferent one");
                return;
            }
            if ((0, $6bca6f68346a010a$export$c4ea027afed2fe4a)(urlInputState)) {
                setUrlInputState("");
                setTargetingUrls([
                    urlInputState,
                    ...targetingUrls
                ]);
            }
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrapper-modal-content",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "center-div",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            variant: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).VARIANT_ENUM.outlined,
                            text: urlInputState,
                            placeholder: "URL Target",
                            isAutoHeight: true,
                            isFullWidth: true,
                            errorMessage: invalidUrlMessage,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                            onClick: (e)=>e.stopPropagation(),
                            onTextChange: onTextChange,
                            debounceTime: 0,
                            onDebounceEnd: setUrlInputState
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: renderAddUrlButton(saveAndCleanInput)
                        })
                    ]
                }),
                targetingUrls.length ? targetingUrls.map((url)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "left-div",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "outline-div",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                    tooltip: url,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "text-overflow",
                                        children: url
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                /* eslint-disable-line jsx-a11y/control-has-associated-label */ className: "button-close",
                                type: "button",
                                onClick: ()=>{
                                    const urlIndex = targetingUrls.indexOf(url);
                                    if (targetUrls.includes(targetingUrls[urlIndex])) setDeletedUrl([
                                        ...deletedUrls,
                                        targetingUrls[urlIndex]
                                    ]);
                                    const newList = [
                                        ...targetingUrls
                                    ];
                                    newList.splice(urlIndex, 1);
                                    setTargetingUrls(newList);
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJaQo.default), {})
                            })
                        ]
                    }, url)) : null
            ]
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowNext(config?.config?.shownext || 30);
        setNoEngageNext(config?.config?.noengagenext || 10);
        if (config?.config?.targeting_urls) setTargetingUrls(config.config.targeting_urls);
    }, [
        config
    ]);
    const handleOpenModalTargetingURL = ()=>{
        if (!isEditing) return editingSnackBarWarning();
        return setIsUrlTargetModalOpen(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
        sx: {
            "& td": {
                border: 0
            },
            height: "60px",
            backgroundColor: index % 2 === 0 ? "white" : "#EEF3F7",
            ...search?.length > 0 && config?.token.includes(search) ? {
                backgroundColor: "#EEF3F7"
            } : {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                sx: {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                    backgroundColor: index % 2 === 0 ? "white" : "#EEF3F7"
                },
                className: classes.editableCell,
                children: isEditingTitle ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                    label: "Player Name",
                    variant: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).VARIANT_ENUM.outlined,
                    text: key,
                    hasAutoFocus: true,
                    isAutoHeight: true,
                    isFullWidth: true,
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                    onClick: (e)=>e.stopPropagation(),
                    onTextChange: setKey,
                    debounceTime: 0,
                    onDebounceEnd: setKey,
                    onBlur: async ()=>handleEditFinished(),
                    /* eslint-disable-next-line @typescript-eslint/no-shadow */ onKeyDown: async ({ key: key })=>{
                        if (key === "Enter") await handleEditFinished();
                        else if (key === "Escape") {
                            if (isCreating) onCreateFinished();
                            setIsEditingTitle(false);
                            setKey(config?.config?.key);
                        }
                    }
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "div-with-hint",
                            style: {
                                width: 230,
                                overflow: "hidden",
                                whiteSpace: "nowrap"
                            },
                            children: [
                                renderPlayerName(),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>{
                                        if (!isEditing) return editingSnackBarWarning();
                                        return setIsEditingTitle(true);
                                    },
                                    disableRipple: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1eff010ab2549a67$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontSize: "18px"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "hint",
                            children: (0, $12872af000a28022$export$2dc49b88faa8e755)(config?.token, 12)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                width: 120,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "left-div",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: renderAddUrlButton(handleOpenModalTargetingURL)
                            }),
                            targetingUrls?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "urls-counter",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                    tooltip: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: targetingUrls.map((s, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    marginTop: idx === 0 ? idx : 8
                                                },
                                                children: s
                                            }, s))
                                    }),
                                    children: targetingUrls.length
                                })
                            }) : null
                        ]
                    }),
                    isUrlTargetModalOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
                        isOpen: isUrlTargetModalOpen,
                        title: `Add URL to ${config?.key} Player`,
                        submitButtonText: "Save",
                        cancelButtonText: "Cancel",
                        content: renderUrlModalContent(),
                        isCancelButtonEnabled: true,
                        isSubmitButtonEnabled: targetUrls.length !== targetingUrls.length,
                        onClose: ()=>{
                            setTargetingUrls(targetUrls);
                            setUrlInputState("");
                            setIsUrlTargetModalOpen(false);
                        },
                        onSubmit: ()=>{
                            if (!isEditing) setTargetingUrls(targetUrls);
                            handleConfigUpdate(()=>({
                                    targeting_urls: targetingUrls,
                                    deletedUrls: deletedUrls
                                }));
                            setIsUrlTargetModalOpen(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))).THEME_ENUM.v2,
                    hasTrackIcon: true,
                    isChecked: outstream,
                    onToggle: ()=>handleConfigUpdate(()=>({
                                outstream: !outstream
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: !isCreating && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ba525c68f348c623$export$2e2bcd8739ae039), {
                    asAdmin: asAdmin,
                    query: query,
                    isEnabled: !outstream,
                    value: config?.config?.playlisttoken || "None",
                    onChange: (pl)=>handleConfigUpdate(()=>({
                                playlisttoken: pl === "None" ? undefined : pl
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $773213f79e406e82$export$2e2bcd8739ae039), {
                    asAdmin: asAdmin,
                    query: query,
                    isEnabled: !outstream,
                    value: `${config?.config?.query?.imported_from}#${config?.config?.query?.group}` || "None",
                    onChange: (mf)=>handleConfigUpdate(()=>({
                                query: {
                                    imported_from: mf === "None" ? undefined : mf.split("#")[0],
                                    group: mf.split("#")[1],
                                    limit: 10
                                }
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                className: "related-content-cell",
                children: !isCreating && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))).THEME_ENUM.v2,
                    hasTrackIcon: true,
                    isChecked: relatedContent && !outstream,
                    isEnabled: !outstream,
                    onToggle: ()=>handleConfigUpdate(()=>({
                                irisplaylist: !relatedContent
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: !isCreating && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                    // TODO: Look into why there are two `style` attributes and determine which one to use.
                    // style={{ width: 250 }}
                    value: config?.config?.query?.categories || selectedCategories,
                    items: [
                        "Auto Selecting"
                    ].concat(Object.keys((0, $20b8e6b0b51e9b4a$export$2e2bcd8739ae039))).map((cat)=>({
                            text: cat,
                            value: cat === "Auto Selecting" ? "auto" : (0, $20b8e6b0b51e9b4a$export$2e2bcd8739ae039)[cat],
                            isHidden: cat === "Auto Selecting"
                        })),
                    style: {
                        width: 235
                    },
                    isMultiple: true,
                    isEnabled: relatedContent && !outstream,
                    multipleType: (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).MULTIPLE_TYPE_ENUM.checkmark,
                    variant: (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).VARIANT_ENUM.outlined,
                    size: (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).SIZE_ENUM.small,
                    onChange: (value)=>{
                        let cat;
                        if (value.length > 0) {
                            if (value[0] === "auto") cat = value.slice(1);
                            else cat = value;
                        } else cat = [
                            "auto"
                        ];
                        if (isEditing) setSelectedCategories(cat);
                        handleConfigUpdate((cfg)=>({
                                query: {
                                    ...cfg.config?.query,
                                    categories: cat?.sort()
                                }
                            }));
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                    items: [
                        {
                            text: "Click to play",
                            value: 0
                        },
                        {
                            text: "Autoplay",
                            value: 1
                        }
                    ],
                    value: autoplay ? 1 : 0,
                    onChange: (value)=>handleConfigUpdate(()=>({
                                autoplay: !!value,
                                autoplaywhenvisible: !!value
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))).THEME_ENUM.v2,
                    hasTrackIcon: true,
                    isChecked: !muted,
                    onToggle: ()=>handleConfigUpdate(()=>({
                                muted: !muted
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))).THEME_ENUM.v2,
                    hasTrackIcon: true,
                    isChecked: floating,
                    onToggle: ()=>handleConfigUpdate((cfg)=>({
                                sticky: !floating && cfg.config?.stickyCondition ? cfg.config.stickyCondition : !floating
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                className: classes.selectCell,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                    value: config?.config?.floatingoptions?.mobile?.height !== undefined ? config?.config?.floatingoptions?.mobile?.height : 175,
                    items: [
                        {
                            text: "Exclude Device",
                            value: 0
                        },
                        {
                            text: "120px",
                            value: 120
                        },
                        {
                            text: "175px",
                            value: 175
                        },
                        {
                            text: "200px",
                            value: 200
                        }
                    ],
                    isEnabled: floating,
                    variant: (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).VARIANT_ENUM.outlined,
                    size: (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).SIZE_ENUM.small,
                    onChange: (value)=>handleConfigUpdate((cfg)=>({
                                floatingoptions: {
                                    ...cfg.config?.floatingoptions,
                                    noFloatOnMobile: value === 0,
                                    sidebar: value === 120,
                                    mobile: {
                                        ...cfg.config?.floatingoptions?.mobile,
                                        height: value
                                    }
                                }
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                className: classes.selectCell,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                    value: config?.config?.floatingoptions?.desktop?.height === 0 ? "exclude" : config?.config?.floatingoptions?.desktop?.position || "bottom-right",
                    items: [
                        {
                            text: "Exclude Device",
                            value: "exclude"
                        },
                        {
                            text: "Bottom Right",
                            value: "bottom-right"
                        },
                        {
                            text: "Bottom Left",
                            value: "bottom-left"
                        },
                        {
                            text: "Top Right",
                            value: "top-right"
                        },
                        {
                            text: "Top Left",
                            value: "top-left"
                        }
                    ],
                    isEnabled: floating,
                    variant: (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).VARIANT_ENUM.outlined,
                    size: (0, (/*@__PURE__*/$parcel$interopDefault($6392f5418b4c6f5d$exports))).SIZE_ENUM.small,
                    onChange: (value)=>handleConfigUpdate((cfg)=>({
                                floatingoptions: {
                                    ...cfg.config?.floatingoptions,
                                    noFloatOnDesktop: value === "exclude",
                                    desktop: {
                                        ...cfg.config?.floatingoptions?.desktop,
                                        height: value === "exclude" ? 0 : undefined,
                                        position: value !== "exclude" ? value : undefined
                                    }
                                }
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))).THEME_ENUM.v2,
                    hasTrackIcon: true,
                    isChecked: !// TODO: Look into the naming of the `config` attribute...
                    (Object.hasOwn(config?.config, "presetkey") && config.config.presetkey !== "responsive"),
                    onToggle: (checked)=>handleConfigUpdate(()=>({
                                presetkey: checked ? "responsive" : null
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($ba07f1d509c74af4$exports))).THEME_ENUM.v2,
                    hasTrackIcon: true,
                    isChecked: config?.config?.nextwidget !== false,
                    onToggle: (checked)=>handleConfigUpdate(()=>({
                                nextwidget: checked
                            }))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                style: {
                    textAlign: "center"
                },
                children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                    text: showNext,
                    isAutoHeight: true,
                    isFullWidth: true,
                    onTextChange: setShowNext,
                    debounceTime: 0,
                    onDebounceEnd: setShowNext,
                    onBlur: ()=>handleConfigUpdate(()=>({
                                shownext: Number(showNext) || 30
                            }))
                }) : config?.config?.shownext || 30
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                style: {
                    textAlign: "center"
                },
                children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                    text: noEngageNext,
                    isAutoHeight: true,
                    isFullWidth: true,
                    onTextChange: setNoEngageNext,
                    debounceTime: 0,
                    onDebounceEnd: setNoEngageNext,
                    onBlur: ()=>handleConfigUpdate(()=>({
                                noengagenext: Number(noEngageNext) || 10
                            }))
                }) : config?.config?.noengagenext || 10
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                className: classes.actionCell,
                children: !isCreating && config && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e59a353a8d3e241$export$2e2bcd8739ae039), {
                            elementClassName: "export-tag-modal",
                            title: config?.key || config?.token,
                            isOpen: exportTagModalIsOpen,
                            submitButtonText: "Copy",
                            onClose: ()=>setExportTagModalIsOpen(false),
                            onSubmit: (exportTag)=>{
                                navigator.clipboard.writeText(exportTag);
                                snackbarSuccess("Copied to Clipboard");
                            },
                            label: "Export Tag",
                            text: (0, $fceccdce3d74d463$export$2e2bcd8739ae039)({
                                config: config,
                                id: exportTagID
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                            tooltip: "Embed the video player on a specific page.",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                disableRipple: true,
                                sx: {
                                    padding: "5px"
                                },
                                onClick: ()=>setExportTagModalIsOpen(true),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c442071f2abf6328$var$Code, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                            isOpen: confirmModalIsOpen,
                            header: `Delete ${key} - ID ${config?.token.substring(0, 6)}`,
                            body: `Are you sure you want to delete the player "${key} - ID ${config?.token.substring(0, 6)}"? This action can't be undone.`,
                            submitButtonText: "Confirm",
                            onClose: ()=>setConfirmModalIsOpen(false),
                            onSubmitClick: ()=>{
                                deleteConfig({
                                    onSuccess: ()=>{
                                        snackbarSuccess("Player Deleted");
                                    },
                                    onError: (error)=>{
                                        console.error(error);
                                        snackbarError("Error while deleting Player, check the console for more information.");
                                    }
                                });
                                setConfirmModalIsOpen(false);
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                            tooltip: "Deletes this video player from the property. Please note that if there are no players associated with a property, no player will load on site.",
                            children: isConfigDeletable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                disableRipple: true,
                                sx: {
                                    padding: "5px"
                                },
                                onClick: ()=>setConfirmModalIsOpen(true),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {
                                    sx: {
                                        fontSize: "20px"
                                    }
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }, config?.token);
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");

var $1GFtd = parcelRequire("1GFtd");

function $2b3892566527ada7$export$2e2bcd8739ae039({ buttonText: buttonText, disabled: disabled, onClick: onClick }) {
    const buttonRotation = buttonText === "left" ? "180deg" : "0deg";
    const useStyles = (0, $1GFtd.default)({
        arrow: {
            width: "10.1px",
            height: "16.67px",
            transform: /* eslint-disable-next-line prefer-template */ "rotate(" + buttonRotation + ")",
            filter: "invert(91%) sepia(18%) saturate(81%) hue-rotate(160deg) brightness(90%) contrast(97%)"
        },
        paddle: {
            width: "30px",
            minWidth: "30px",
            height: "100%",
            color: "#000000",
            border: "1px solid #000000",
            padding: "0px",
            "&:hover": {
                color: "#0033FF",
                border: "1px solid #0033FF",
                "& img": {
                    filter: "invert(10%) sepia(100%) saturate(7051%) hue-rotate(235deg) brightness(99%) contrast(112%)"
                }
            },
            "&:disabled": {
                color: "#D1D9DE",
                border: "1px solid #D1D9DE",
                "& img": {
                    filter: "invert(0%) sepia(100%) saturate(8%) hue-rotate(161deg) brightness(96%) contrast(102%)"
                }
            }
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        variant: "outlined",
        className: classes.paddle,
        disabled: disabled,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5f963ca7f493b38$export$2e2bcd8739ae039), {
            alt: buttonText,
            className: classes.arrow
        })
    });
}



const $37a6dbda26a524a1$var$colWidths = [
    98.37,
    150,
    155.56,
    150,
    150,
    115.95,
    90,
    152,
    152,
    114,
    150,
    140,
    152,
    92
];
const $37a6dbda26a524a1$var$breakpoints = [
    0,
    ...$37a6dbda26a524a1$var$colWidths.reduce((prev, curr)=>{
        prev.push(curr + (prev[prev.length - 1] || 0));
        return prev;
    }, [])
];
function $37a6dbda26a524a1$export$2e2bcd8739ae039({ asAdmin: asAdmin, domain: domain, search: search, isCreating: isCreating, isEditing: isEditing, query: query, onUpdate: onUpdate, setConfigUpdatingStatus: setConfigUpdatingStatus, onCreateFinished: onCreateFinished }) {
    if (!domain) return null;
    const [leftArrowDisable, setLeftArrowDisable] = $acw62.useState(true);
    const [rightArrowDisable, setRightArrowDisable] = $acw62.useState(false);
    const elementRef = $acw62.useRef(null);
    const [showPaddles, setShowPaddles] = $acw62.useState(true);
    const floatingDesktopTooltip = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Configure the player float position on desktop to the bottom right, bottom left, top right, top left of the screen."
    });
    // TODO: Look into moving this method into a utils file?
    function handleHorizontalScroll(element, direction) {
        let distance = element.clientWidth;
        if (direction > 0) for(let i = 0; i < $37a6dbda26a524a1$var$breakpoints.length; i++){
            if ($37a6dbda26a524a1$var$breakpoints[i] > element.scrollLeft + element.clientWidth - 190) break;
            else distance = $37a6dbda26a524a1$var$breakpoints[i];
        }
        else for(let i = $37a6dbda26a524a1$var$breakpoints.length - 1; i >= 0; i--){
            if ($37a6dbda26a524a1$var$breakpoints[i] < element.scrollLeft - element.clientWidth + 190) break;
            else distance = $37a6dbda26a524a1$var$breakpoints[i];
        }
        element.scroll({
            left: distance,
            behavior: "smooth"
        });
        setLeftArrowDisable(distance === 0);
        setRightArrowDisable(distance + element.clientWidth > element.scrollWidth);
    }
    $acw62.useEffect(()=>{
        window.addEventListener("resize", ()=>{
            if (elementRef?.current?.scrollWidth <= elementRef?.current?.clientWidth) setShowPaddles(false);
            else setShowPaddles(true);
        });
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "row",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "30px",
                marginRight: "10px",
                display: showPaddles ? "block" : "none",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b3892566527ada7$export$2e2bcd8739ae039), {
                    buttonText: "left",
                    disabled: leftArrowDisable,
                    onClick: ()=>{
                        handleHorizontalScroll(elementRef.current, -1);
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    overflowX: "hidden",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                    className: "domain-card-players-table",
                    sx: {
                        overflowX: "hidden"
                    },
                    ref: elementRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                        sx: {
                            minWidth: 650,
                            marginBottom: "10px",
                            overflowX: "hidden"
                        },
                        "aria-label": "simple table",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                sx: {
                                    borderBottom: "2px solid black",
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            sx: {
                                                position: "sticky",
                                                left: 0,
                                                backgroundColor: "white"
                                            },
                                            children: "Video Player Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: "URL target"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Disables video content. Enables player floating on desktop and mobile. Changes ad request structure to outstream.",
                                                children: "Outstream"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Assign a playlist. This content supersedes videos from Fabrik\u2019s syndicated content library.",
                                                children: "Playlist"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Assign a mrss feed. This content supersedes videos from Fabrik\u2019s syndicated content library and the playlist.",
                                                children: "MRSS Feed"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Access videos from Fabrik\u2019s syndicated content library.",
                                                children: "Syndicated Content"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Categories of syndicated content that can serve in the video player.",
                                                children: "Video Category"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: "Video Playback"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: "Sound On/Off"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Video player floats when scrolled out of view",
                                                children: "Floating"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Set the height of the floating player on mobile, or hide it completely",
                                                children: "Mobile (Height)"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: floatingDesktopTooltip,
                                                children: "Desktop (Location)"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Loads video gallery when player is on desktop",
                                                children: "Video Gallery"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Enables next video to play automatically if no user interaction with the player.",
                                                children: "Next Video Settings"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Seconds into video before initiating countdown timer.",
                                                children: "Next Video Length"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                                                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                                                tooltip: "Countdown length before going to next video.",
                                                children: "Countdown Length"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $QpuKB.default), {
                                children: [
                                    isCreating && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c442071f2abf6328$export$2e2bcd8739ae039), {
                                        index: -1,
                                        asAdmin: asAdmin,
                                        domain: domain,
                                        setConfigUpdatingStatus: setConfigUpdatingStatus,
                                        onCreateFinished: (updatedDomain)=>{
                                            onCreateFinished(updatedDomain);
                                        },
                                        isCreating: true
                                    }),
                                    domain.configs.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $c442071f2abf6328$export$2e2bcd8739ae039), {
                                            asAdmin: asAdmin,
                                            query: query,
                                            index: i,
                                            search: search,
                                            domain: domain,
                                            config: c,
                                            isEditing: isEditing,
                                            onUpdate: onUpdate
                                        }, c.token))
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "30px",
                marginLeft: "10px",
                display: showPaddles ? "block" : "none",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b3892566527ada7$export$2e2bcd8739ae039), {
                    buttonText: "right",
                    disabled: rightArrowDisable,
                    onClick: ()=>{
                        handleHorizontalScroll(elementRef.current, 1);
                    }
                })
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $63f21e5cf8cde4d8$export$533de6bd8cd3faae = (history, fallbackPath)=>{
    if (history.action === "POP") // If the user directly landed on the page (no history), redirect to fallback
    history.push(fallbackPath);
    else // If there's history, go back
    history.goBack();
};
const $63f21e5cf8cde4d8$export$be4fe2f67b55b8c1 = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/)?$/;
const $63f21e5cf8cde4d8$export$2678fb74a7f238e9 = (domain)=>$63f21e5cf8cde4d8$export$be4fe2f67b55b8c1.test(domain);
const $63f21e5cf8cde4d8$export$45d83df3bf045126 = (error)=>{
    if (!error) return null;
    if (error?.response?.status) return error.response.status;
    if (error?.status) return error.status;
    const statusMatch = error.message.match(/API returned error (\d{3})/i);
    return statusMatch ? parseInt(statusMatch[1], 10) : null;
};



function $e6d298d2808c038e$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, title: title, label: label, createOptions: createOptions, showCheckbox: showCheckbox, asAdmin: asAdmin }) {
    const { create: create } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        enabled: false
    });
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const { publisherUsername: username, publisherSlug: slug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e59a353a8d3e241$export$2e2bcd8739ae039), {
        elementClassName: "create-property-modal",
        title: title || "Create Property",
        label: label || "Property Name",
        submitButtonText: "Save",
        cancelButtonText: "Cancel",
        showCheckbox: showCheckbox,
        checkboxLabel: "Create Google Ad Manager Adunits with domain",
        isOpen: isOpen,
        onClose: onClose,
        error: error,
        setError: setError,
        onSubmit: (domain, createAdUnits = false)=>{
            if (!(0, $63f21e5cf8cde4d8$export$2678fb74a7f238e9)(domain)) {
                setError("Please enter a valid domain");
                return;
            }
            create({
                domain: domain,
                username: username,
                slug: slug,
                createAdUnits: createAdUnits
            }, createOptions || {});
            onSubmit(domain);
        }
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1GFtd = parcelRequire("1GFtd");

var $dgtCa = parcelRequire("dgtCa");

var $9Lykx = parcelRequire("9Lykx");

var $hAiFn = parcelRequire("hAiFn");
var $8YLZH = parcelRequire("8YLZH");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $33ee49c509baa50e$export$2e2bcd8739ae039({ token: token, isOpen: isOpen, onClose: onClose, onSubmit: onSubmit }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e59a353a8d3e241$export$2e2bcd8739ae039), {
        id: token,
        title: "Edit Property",
        label: "Property Name",
        submitButtonText: "Save",
        cancelButtonText: "Cancel",
        isOpen: isOpen,
        onClose: onClose,
        onSubmit: onSubmit
    });
}





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1GFtd = parcelRequire("1GFtd");

const $a1bfd01510116977$var$useStyles = (0, $1GFtd.default)({
    table: {
        overflow: "auto",
        height: "auto",
        "& th, & td": {
            paddingLeft: "10px"
        },
        "& thead": {
            boxShadow: "0 1px black",
            position: "sticky",
            top: 0,
            zIndex: 1,
            "& th": {
                background: "transparent",
                color: "black",
                fontSize: "11px",
                fontWeight: 600
            },
            background: "white"
        },
        "& tbody": {
            "& tr": {
                height: "50px",
                "&:nth-of-type(even)": {
                    "&:hover": {
                        background: "#EEF3F7"
                    },
                    background: "#EEF3F7"
                },
                "&:hover": {
                    background: "white"
                }
            },
            "& td": {
                border: 0,
                "& div": {
                    fontSize: "13px",
                    textTransform: "uppercase",
                    fontWeight: 500
                }
            }
        }
    },
    selected: {
        color: "#0033FF"
    }
});
function $a1bfd01510116977$export$2e2bcd8739ae039(props) {
    const { columns: columns, rows: rows, size: size = 10 } = props;
    const classes = $a1bfd01510116977$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4353bd6a5a30fa9b$exports))), {
        containerClassName: classes.table,
        config: {
            data: {
                columns: columns,
                rows: rows
            },
            pagination: {
                initialPageSize: size,
                isHidden: false
            }
        }
    });
}


const $83e064d13b8e0ab7$var$useStyles = (0, $1GFtd.default)({
    selected: {
        color: "#0033FF"
    }
});
function $83e064d13b8e0ab7$var$ButtonsCell({ domain: domain }) {
    const { snackbarSuccess: snackbarSuccess, snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const { update: update } = (0, $a9fd19d627d10772$export$d9dcc325f8df9b84)(domain?.token, domain);
    const api = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)();
    const [confirmModalIsOpen, setConfirmModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [userFormModalIsOpen, setUserFormModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleEdit = ()=>setUserFormModalIsOpen(true);
    const handleDelete = ()=>setConfirmModalIsOpen(true);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            float: "right"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: confirmModalIsOpen,
                header: `Delete ${domain?.domain}`,
                body: `Are you sure you want to delete the property ${domain?.domain}? This action can't be undone.`,
                submitButtonText: "Confirm",
                onClose: ()=>setConfirmModalIsOpen(false),
                onSubmitClick: ()=>{
                    api.delete(domain?.token, {
                        onSuccess: ()=>snackbarSuccess("Deleted Property"),
                        onError: (error)=>{
                            console.error(error);
                            snackbarError(`Error deleting property ${domain?.domain}, check the console for more information.`);
                        }
                    });
                    setConfirmModalIsOpen(false);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33ee49c509baa50e$export$2e2bcd8739ae039), {
                token: domain?.token,
                isOpen: userFormModalIsOpen,
                onClose: ()=>setUserFormModalIsOpen(false),
                onSubmit: (value)=>{
                    setUserFormModalIsOpen(false);
                    update({
                        domain: value
                    }, {
                        onSuccess: ()=>snackbarSuccess("Edit Saved"),
                        onError: (error)=>{
                            console.error(error);
                            snackbarError(`Error while editing property ${domain?.token}, check the console for more information.`);
                        }
                    });
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                style: {
                    color: "black"
                },
                onClick: handleEdit,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {
                    style: {
                        fontSize: "20px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                style: {
                    color: "black"
                },
                onClick: handleDelete,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {
                    style: {
                        fontSize: "20px"
                    }
                })
            })
        ]
    });
}
function $83e064d13b8e0ab7$export$2e2bcd8739ae039({ properties: properties, selected: selected, onSelected: onSelected, onCreateButtonClick: onCreateButtonClick, asAdmin: asAdmin }) {
    const classes = $83e064d13b8e0ab7$var$useStyles();
    const columns = [
        {
            field: "domain",
            headerName: "Properties",
            onClick: (_, row)=>{
                onSelected(row.ogdomain);
            },
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: row.token === selected.token ? classes.selected : undefined,
                    children: row.domain
                })
        },
        {
            field: "playerscount",
            headerName: "No. of Video Players",
            onClick: (_, row)=>onSelected(row.ogdomain),
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: row.token === selected.token ? classes.selected : undefined,
                    style: {
                        textAlign: "end",
                        width: "122px"
                    },
                    children: row.playerscount
                })
        },
        {
            field: "",
            headerName: "",
            onClick: (_, row)=>onSelected(row.ogdomain),
            renderHeader: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                    id: "create-property",
                    text: "Create Property",
                    onClick: onCreateButtonClick,
                    variant: (0, $dgtCa.VARIANT_ENUM).contained,
                    size: (0, $dgtCa.SIZE_ENUM).small,
                    style: {
                        float: "right"
                    }
                }),
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)($83e064d13b8e0ab7$var$ButtonsCell, {
                    domain: row.ogdomain
                })
        }
    ];
    const rows = properties?.map((d)=>({
            ...d,
            ogdomain: d,
            playerscount: d.configs.length,
            id: d.token
        })) || [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1bfd01510116977$export$2e2bcd8739ae039), {
        size: asAdmin ? 6 : 12,
        columns: columns,
        rows: rows
    });
}


var $b09cd104a1ce5bdf$export$2e2bcd8739ae039 = (0, $83e064d13b8e0ab7$export$2e2bcd8739ae039);








function $c1f1a59392dfe959$export$2e2bcd8739ae039({ asAdmin: asAdmin, slug: slug } = {
    asAdmin: false,
    slug: ""
}) {
    const { snackbarSuccess: snackbarSuccess, snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const padding = "20px";
    const [modalIsOpen, setModalIsOpen] = (0, $acw62.useState)(false);
    const query = asAdmin && {
        slug: publisherSlug || slug
    };
    const { domains: domains, query: domainsQuery, ...domainsAPI } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        enabled: true,
        query: query
    });
    const [selectedDomain, setSelectedDomain] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    if (!selectedDomain && domains && domains.length > 0) setSelectedDomain(domains[0]);
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [isDomainSelected, setIsDomainSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [isCreatingConfig, setIsCreatingConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [isEditingConfig, setIsEditingConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [updatedSelectedDomain, setUpdatedSelectedDomain] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [isDomainLoading, setIsDomainLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (domains) setIsDomainLoading(false);
    }, [
        domains
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (domains?.length) {
            const selectedDomainData = domains.find((d)=>d.token === selectedDomain.token);
            if (selectedDomainData) setUpdatedSelectedDomain((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(selectedDomainData));
            else setSelectedDomain(domains[0]);
        }
    }, [
        domains,
        selectedDomain
    ]);
    const debouncedTrack = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $f1q41.debounce)((event, data)=>{
            (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track(event, data);
        }, 3000), []);
    function targetingUrlManager(newConfig, oldConfig) {
        if (newConfig.config.targeting_urls) {
            const oldUrls = oldConfig.config.targeting_urls || [];
            const targetingUrls = newConfig.config.targeting_urls.filter((url)=>{
                if (!oldUrls.includes(url)) return url;
                return false;
            }).map((url)=>(0, $6bca6f68346a010a$export$6535eb414fa2c8b6)(url));
            const deletedUrls = newConfig.config.deletedUrls || [];
            if (deletedUrls.length) deletedUrls.forEach((url)=>{
                domainsAPI.deleteTargetingUrl({
                    url: url,
                    token: selectedDomain.token,
                    configToken: newConfig.token
                }, {
                    onSettled: ()=>{
                        snackbarSuccess(`URL(s) deleted to ${newConfig.key} Player`);
                    }
                });
            });
            if (targetingUrls.length) domainsAPI.saveTargetingUrls({
                targeting_urls: targetingUrls,
                domain: selectedDomain.domain,
                token: selectedDomain.token,
                configToken: newConfig.token
            }, {
                onSettled: ()=>{
                    snackbarSuccess(`URL(s) added to ${newConfig.key} Player`);
                }
            });
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (search) debouncedTrack("Search", {
            resource: "property",
            text: search
        });
        else setIsDomainSelected(false);
    }, [
        search
    ]);
    /* eslint-disable-next-line @typescript-eslint/no-shadow */ const filterDomainList = (selectedDomain)=>{
        if (!isDomainSelected) return domains;
        return domains.filter((domain)=>domain?.domain.toLowerCase().startsWith(selectedDomain?.domain?.toLowerCase()));
    };
    const handleSearchChange = (event, newInput)=>setSearch(newInput);
    if (!domains && !domainsQuery.isFetched) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: "100%",
            height: "calc(100vh - 70px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: padding,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $053f01ce092d1441$export$2e2bcd8739ae039), {
                searchValue: search,
                widthSize: "minWidth",
                placeholder: "search property",
                options: domains?.map((d)=>d.domain),
                onSearchChange: handleSearchChange,
                onOptionClick: (value)=>{
                    setSelectedDomain(domains?.find((d)=>d?.domain?.toLowerCase() === value?.toLowerCase()));
                    setIsDomainSelected(true);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6d298d2808c038e$export$2e2bcd8739ae039), {
                asAdmin: asAdmin,
                isOpen: modalIsOpen,
                onClose: ()=>setModalIsOpen(false),
                onSubmit: ()=>setModalIsOpen(false),
                createOptions: {
                    onSuccess: ()=>{
                        snackbarSuccess("Created New Property");
                    },
                    onError: (error)=>{
                        console.error(error);
                        snackbarError("Error creating property, check the console for more information.");
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            fontSize: "10px",
                            fontWeight: 500
                        },
                        children: "Select a property from the list to see the Video Player details below"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        style: {
                            fontSize: "18px",
                            fontWeight: 500,
                            marginTop: "30px",
                            marginBottom: "12px"
                        },
                        children: "Property Field"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b09cd104a1ce5bdf$export$2e2bcd8739ae039), {
                        asAdmin: !asAdmin,
                        properties: filterDomainList(selectedDomain),
                        selected: selectedDomain,
                        onSelected: setSelectedDomain,
                        onCreateButtonClick: ()=>setModalIsOpen(true)
                    }),
                    domains?.length > 0 && !asAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginTop: "40px",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "24px",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        style: {
                                            fontSize: "18px",
                                            fontWeight: 500
                                        },
                                        children: "Video Players"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        gap: "16px",
                                        children: [
                                            isDomainLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {
                                                style: {
                                                    width: "28px",
                                                    height: "28px"
                                                }
                                            }),
                                            !asAdmin && isEditingConfig ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                                                        id: "cancel-edit-players",
                                                        text: "Cancel",
                                                        size: (0, $dgtCa.SIZE_ENUM).small,
                                                        variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                                                        onClick: ()=>{
                                                            // @ts-ignore
                                                            setUpdatedSelectedDomain();
                                                            setIsEditingConfig(false);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                                                        id: "confirm-edit-players",
                                                        isEnabled: !isDomainLoading,
                                                        text: "Save Changes",
                                                        size: (0, $dgtCa.SIZE_ENUM).small,
                                                        variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                                                        onClick: ()=>{
                                                            setIsDomainLoading(true);
                                                            updatedSelectedDomain.configs.forEach((newConfig)=>{
                                                                const oldConfig = selectedDomain.configs.find((c)=>c.token === newConfig.token);
                                                                if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEqual(oldConfig, newConfig)) return;
                                                                targetingUrlManager(newConfig, oldConfig);
                                                                const config = {
                                                                    ...newConfig
                                                                };
                                                                delete config.config.targeting_urls;
                                                                delete config.config.deletedUrls;
                                                                domainsAPI.updateConfig({
                                                                    domain: selectedDomain.token,
                                                                    config: config
                                                                });
                                                            });
                                                            selectedDomain.configs = updatedSelectedDomain.configs;
                                                            setIsEditingConfig(false);
                                                        }
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                                                id: "edit-players",
                                                text: "Edit Video Player",
                                                isEnabled: !isDomainLoading,
                                                onClick: ()=>{
                                                    setIsEditingConfig(true);
                                                },
                                                size: (0, $dgtCa.SIZE_ENUM).small,
                                                variant: (0, $dgtCa.VARIANT_ENUM).outlined
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                                                id: "add-player",
                                                text: "Add Video Player",
                                                isEnabled: !isEditingConfig && !isDomainLoading,
                                                onClick: ()=>setIsCreatingConfig(true),
                                                size: (0, $dgtCa.SIZE_ENUM).small,
                                                variant: (0, $dgtCa.VARIANT_ENUM).contained
                                            })
                                        ]
                                    })
                                ]
                            }),
                            selectedDomain && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    opacity: isDomainLoading ? 0.7 : 1
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37a6dbda26a524a1$export$2e2bcd8739ae039), {
                                    asAdmin: asAdmin,
                                    query: query,
                                    domain: updatedSelectedDomain || domains.find((d)=>d.token === selectedDomain.token),
                                    search: search,
                                    isEditing: isEditingConfig,
                                    isCreating: isCreatingConfig,
                                    onUpdate: setUpdatedSelectedDomain,
                                    setConfigUpdatingStatus: setIsDomainLoading,
                                    onCreateFinished: (newDomain)=>{
                                        if (newDomain) {
                                            newDomain.configs.reverse();
                                            selectedDomain.configs = newDomain.configs;
                                        }
                                        setIsCreatingConfig(false);
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $lkxXU = parcelRequire("lkxXU");





function $3937af9b081053f5$export$2e2bcd8739ae039({ asAdmin: asAdmin } = {
    asAdmin: false
}) {
    const { videoPerformanceExploreId: videoPerformanceExploreId, monetizationExploreId: monetizationExploreId } = (0, $7cfd7d2033513804$export$20ed3b85869bd7b2)();
    const padding = "20px";
    const tabs = [
        {
            label: "Video Performance"
        },
        {
            label: "Monetization"
        }
    ];
    const tab = (0, $80f3bd128133629b$export$2e2bcd8739ae039)("tab", (t)=>parseInt(t, 10) || 0);
    const history = (0, $kfZjc.useHistory)();
    const [selectedTab, setSelectedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(tab);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (selectedTab === tab) return;
        history.push(`${window.location.pathname}?tab=${selectedTab}`);
    }, [
        selectedTab
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (selectedTab !== tab) setSelectedTab(tab);
    }, [
        tab
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: padding,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $789836e85fc60e05$export$2e2bcd8739ae039), {
                    tabsConfig: {
                        onChange: (e, value)=>setSelectedTab(value),
                        selectedTab: selectedTab,
                        tabs: tabs
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    variant: "fullWidth",
                    sx: {
                        mt: "-1px",
                        borderBottomWidth: "1px",
                        borderColor: "rgb(209, 217, 222)"
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "video-explore-container",
                    className: tab === 0 ? "" : "hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69afb1ae7c880ac4$export$7472995af639359f), {
                        asAdmin: asAdmin,
                        exploreId: videoPerformanceExploreId
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "monetization-explore-container",
                    className: tab === 1 ? "" : "hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69afb1ae7c880ac4$export$7472995af639359f), {
                        asAdmin: asAdmin,
                        exploreId: monetizationExploreId
                    })
                })
            ]
        })
    });
}






function $91a3a273935dc930$export$2e2bcd8739ae039(username, initialData) {
    const { snackbarError: snackbarError, snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            "users",
            username
        ],
        queryFn: ()=>username && api.readUser(username).then((data)=>data.publisher),
        initialData: initialData,
        staleTime: Infinity,
        keepPreviousData: true,
        enabled: username && didLoad
    });
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>api.Media.update(username, data),
        onSuccess: ({ user: user })=>{
            snackbarSuccess("Updated User");
            queryClient.setQueryData([
                "users",
                username
            ], user);
            queryClient.invalidateQueries({
                queryKey: [
                    "users"
                ]
            });
        },
        onError: (e)=>{
            console.error(e);
            snackbarError("Error while updating the user. Check the console for more information.");
        }
    });
    return {
        ...query,
        slug: query?.data?.slug,
        group: query?.data?.group,
        user: query?.data?.users,
        api: {
            update: updateMutation.mutate
        },
        mutations: {
            updateMutation: updateMutation
        }
    };
}


function $2eaa67bfb8774117$export$f14b11bc64234d25(userList, isAdmin, admin, username, group) {
    if (isAdmin) return {
        isPublisherAdmin: false,
        publisherGroup: null,
        publisherUsername: null
    };
    const publisherUser = userList && userList?.find((user)=>user.role === admin && user.username === username);
    return {
        isPublisherAdmin: publisherUser?.role === admin,
        publisherUsername: publisherUser?.username,
        publisherGroup: group
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $iuSDM = parcelRequire("iuSDM");

var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3bYfT = parcelRequire("3bYfT");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e8aa9eabd3007a18$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");



var $6n0Ko = parcelRequire("6n0Ko");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $ad5c6c214f96507f$var$_excluded = [
    "slots",
    "slotProps"
];
const $ad5c6c214f96507f$var$BreadcrumbCollapsedButton = (0, $d8seH.default)((0, $6n0Ko.default))(({ theme: theme })=>(0, $8nd05.default)({
        display: "flex",
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === "light" ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        "&:hover, &:focus": (0, $8nd05.default)({}, theme.palette.mode === "light" ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        "&:active": (0, $8nd05.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === "light" ? {
            backgroundColor: (0, $kSnzZ.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $kSnzZ.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $ad5c6c214f96507f$var$BreadcrumbCollapsedIcon = (0, $d8seH.default)((0, $e8aa9eabd3007a18$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $ad5c6c214f96507f$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $1En50.default)(props, $ad5c6c214f96507f$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedButton, (0, $8nd05.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedIcon, (0, $8nd05.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
$ad5c6c214f96507f$var$BreadcrumbCollapsed.propTypes = {
    /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        collapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        CollapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $ad5c6c214f96507f$export$2e2bcd8739ae039 = $ad5c6c214f96507f$var$BreadcrumbCollapsed;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3109febd55ba98e0$export$17261110b18c8084(slot) {
    return (0, $4Cod0.default)("MuiBreadcrumbs", slot);
}
const $3109febd55ba98e0$var$breadcrumbsClasses = (0, $beCSm.default)("MuiBreadcrumbs", [
    "root",
    "ol",
    "li",
    "separator"
]);
var $3109febd55ba98e0$export$2e2bcd8739ae039 = $3109febd55ba98e0$var$breadcrumbsClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $3beee71e1808c2fa$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $3beee71e1808c2fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        li: [
            "li"
        ],
        ol: [
            "ol"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3109febd55ba98e0$export$17261110b18c8084), classes);
};
const $3beee71e1808c2fa$var$BreadcrumbsRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $3109febd55ba98e0$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $3beee71e1808c2fa$var$BreadcrumbsOl = (0, $d8seH.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles)=>styles.ol
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
const $3beee71e1808c2fa$var$BreadcrumbsSeparator = (0, $d8seH.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
});
function $3beee71e1808c2fa$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $3beee71e1808c2fa$var$Breadcrumbs = /*#__PURE__*/ $acw62.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiBreadcrumbs"
    });
    const { children: children, className: className, component: component = "nav", slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = "Show path", itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = "/" } = props, other = (0, $1En50.default)(props, $3beee71e1808c2fa$var$_excluded);
    const [expanded, setExpanded] = $acw62.useState(false);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $3beee71e1808c2fa$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $eD6Co.default)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $acw62.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
            console.error([
                "MUI: You have provided an invalid combination of props to the Breadcrumbs.",
                `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`
            ].join("\n"));
            return allItems;
        }
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ad5c6c214f96507f$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $acw62.Children.toArray(children).filter((child)=>{
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Breadcrumbs component doesn't accept a Fragment as a child.",
            "Consider providing an array instead."
        ].join("\n"));
        return /*#__PURE__*/ $acw62.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsRoot, (0, $8nd05.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $3beee71e1808c2fa$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
$3beee71e1808c2fa$var$Breadcrumbs.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Show path'
   */ expandText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */ itemsAfterCollapse: (0, $iuSDM.default),
    /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */ itemsBeforeCollapse: (0, $iuSDM.default),
    /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */ maxItems: (0, $iuSDM.default),
    /**
   * Custom separator node.
   * @default '/'
   */ separator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        collapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    }),
    /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        CollapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $3beee71e1808c2fa$export$2e2bcd8739ae039 = $3beee71e1808c2fa$var$Breadcrumbs;


var $3bYfT = parcelRequire("3bYfT");


var $4fGPb = parcelRequire("4fGPb");
function $50f06ca8e5498c82$export$96038c7a387b6b24({ paths: paths, updatePaths: updatePaths }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3beee71e1808c2fa$export$2e2bcd8739ae039), {
        className: "krg-breadcrumbs",
        "aria-label": "breadcrumb",
        children: paths.map((item, idx, arr)=>{
            if (idx === arr.length - 1) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                color: "inherit",
                children: item.pathName
            }, item.path);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
                onClick: ()=>updatePaths(idx),
                to: item.path,
                children: item.pathName
            }, item.path);
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dgtCa = parcelRequire("dgtCa");



function $1f8abd7fea68f5ba$export$2e2bcd8739ae039(props) {
    const { show: show, save: save, cancel: cancel, savingLoading: savingLoading } = props;
    if (show) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "krg-float-buttons",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                id: `krg-float-cancel-${Math.random()}`,
                text: "Cancel",
                onClick: cancel,
                size: (0, $dgtCa.SIZE_ENUM).small,
                variant: (0, $dgtCa.VARIANT_ENUM).outlined
            }),
            savingLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {
                style: {
                    width: 28,
                    height: 28
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                id: `krg-float-cancel-${Math.random()}`,
                text: "Save changes",
                onClick: save,
                size: (0, $dgtCa.SIZE_ENUM).small,
                variant: (0, $dgtCa.VARIANT_ENUM).contained
            })
        ]
    });
    return null;
}











const $04813b9f064173e2$var$SuperAdminContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $04813b9f064173e2$export$e9e2792ac12de339({ isAdmin: isAdmin, children: children, slug: slug }) {
    // Auth validation
    if (!isAdmin) return null;
    // States
    const [showEditButtons, setShowEditButtons] = (0, $acw62.useState)(false);
    const [editConfig, setEditConfig] = (0, $acw62.useState)({});
    const [editDomainConfig, setEditDomainConfig] = (0, $acw62.useState)({});
    const [advancedEditMode, setAdvancedEditMode] = (0, $acw62.useState)(false);
    const [forceSaveSchema, setForceSaveSchema] = (0, $acw62.useState)(false);
    const [conflictedData, setConflictedData] = (0, $acw62.useState)(null);
    const [initialData, setInitialData] = (0, $acw62.useState)({});
    const [hasValidationErrors, setHasValidationErrors] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [httpMethod, setHttpMethod] = (0, $acw62.useState)();
    const { snackbarWarning: snackbarWarning, snackbarSuccess: snackbarSuccess, snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const history = (0, $kfZjc.useHistory)();
    const location = (0, $kfZjc.useLocation)();
    const [params, setParams] = (0, $acw62.useState)({
        playerToken: "",
        domainToken: ""
    });
    const { update: update } = (0, $b5dd5d6a03e10096$export$a13e2cd9aac3d29e)(params.playerToken, params.domainToken, initialData);
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(isAdmin);
    const query = isAdmin && {
        slug: publisherSlug || slug
    };
    const { domains: domains, query: domainsQuery, ...domainsAPI } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        enabled: true,
        query: query
    });
    const [paths, setPaths] = (0, $acw62.useState)([
        {
            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN,
            pathName: "Domains"
        }
    ]);
    const [selectedDomainToken, setSelectedDomainToken] = (0, $acw62.useState)(paths[1]?.path.split("/")[3]);
    const { createConfig: createConfig } = (0, $a9fd19d627d10772$export$d9dcc325f8df9b84)(selectedDomainToken);
    const handleBackToConfigs = ()=>{
        history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
            slug: publisherSlug || slug,
            domainToken: params.domainToken
        }));
    };
    // Methods
    // Urls targeting has a dedicated service to update its changes.
    function targetingUrlManager(newConfig, oldConfig, domainName, domainToken, playerToken) {
        const urlsAlreadyOnServer = oldConfig?.config?.targeting_urls || [];
        // compare each url inside the updated config with the old urls
        const urlsToBeSaved = newConfig?.config?.targeting_urls?.filter((url)=>{
            // if old urls do not includes the url, means it a new one to be added.
            if (!urlsAlreadyOnServer?.includes(url)) return url;
            return false;
        })?.map((url)=>(0, $6bca6f68346a010a$export$6535eb414fa2c8b6)(url));
        // delete urls will be the ones that is on the server but not anymore in the updated config
        const deletedUrls = urlsAlreadyOnServer?.filter((url)=>{
            if (!newConfig.config.targeting_urls?.includes(url)) return url;
            return false;
        });
        // if any to be deleted call the server to delete
        if (deletedUrls?.length) deletedUrls.forEach((url)=>{
            domainsAPI.deleteTargetingUrl({
                url: url,
                token: domainToken,
                configToken: params.playerToken
            });
        });
        // if any to be saved call the server to save it
        if (urlsToBeSaved?.length) domainsAPI.saveTargetingUrls({
            targeting_urls: urlsToBeSaved,
            token: domainToken,
            configToken: playerToken,
            domain: domainName
        });
    }
    const removePathFromBreadcrumbs = (idx)=>{
        const slicedPaths = paths.slice(0, idx + 1);
        setPaths(slicedPaths);
    };
    const addPathToBreadCrumb = (ctxPaths)=>{
        const tempArr = [
            ...paths
        ];
        ctxPaths.forEach((p)=>{
            if (!paths.some((item)=>item.path === p.path)) {
                if (!paths.some((item)=>item.path === p.path)) tempArr.push(p);
            }
        });
        setPaths(tempArr);
    };
    const saveEditChanges = ()=>{
        const toBeSavedConfig = {
            ...conflictedData || editConfig
        };
        setConflictedData(null);
        setIsLoading(true);
        let newConfig = {
            ...initialData,
            notes: editDomainConfig.notes,
            type: editDomainConfig.type,
            is_config_deletable: editDomainConfig.is_config_deletable,
            config: {
                ...toBeSavedConfig
            }
        };
        if (advancedEditMode) newConfig = editDomainConfig;
        const domainName = paths.length > 0 && paths[1]?.pathName;
        /* eslint-disable-next-line @typescript-eslint/naming-convention */ const targeting_urls = newConfig.config?.targeting_urls;
        targetingUrlManager(newConfig, initialData, domainName, params.domainToken, params.playerToken);
        delete newConfig.config?.targeting_urls;
        update(newConfig, {
            onSuccess: ()=>{
                snackbarSuccess("Player Updated!");
                setIsLoading(false);
                handleBackToConfigs();
            },
            onError: (e)=>{
                const error = {
                    e: e
                };
                if (error.e.message) {
                    const data = JSON.parse(error.e.message);
                    setAdvancedEditMode(false);
                    setConflictedData({
                        ...data.domain.conflicted.config,
                        targeting_urls: targeting_urls
                    });
                    setEditConfig({
                        ...data.domain.current.config,
                        targeting_urls: editConfig.targeting_urls
                    });
                    setInitialData(data.domain.current);
                    setIsLoading(false);
                }
            }
        });
    };
    const saveCloneChanges = ()=>{
        const newConfig = {
            key: editDomainConfig?.key || "",
            notes: editDomainConfig.notes,
            type: editDomainConfig.type,
            config: {
                ...editConfig
            }
        };
        createConfig(newConfig, {
            onSuccess: (response)=>{
                const { domain: domain } = response;
                const { token: domainToken, domain: domainName } = domain;
                const config = {
                    ...newConfig,
                    created_at: domain.created_at,
                    updated_at: domain.updated_at,
                    updated_by: domain.updated_by,
                    created_by: domain.created_by,
                    token: domainToken
                };
                const playerToken = response.domain.configs.find((c)=>c.key === editDomainConfig.key).token;
                targetingUrlManager(config, initialData, domainName, domainToken, playerToken);
                delete newConfig.config?.targeting_urls;
                snackbarSuccess("Player Clone Created");
                history.goBack();
            },
            onError: (e)=>{
                if (e.message.includes("412")) snackbarError(`Error duplicated player name: ${newConfig.key} already exist at the domain destination`);
                else snackbarError("Something went wrong!");
            }
        });
    };
    const handleCloneOrEditChanges = ()=>{
        if (hasValidationErrors && !forceSaveSchema) {
            snackbarWarning("Fix syntax errors before saving it!");
            return;
        }
        if (!editDomainConfig.notes.trim() || editDomainConfig.notes.length > 56) {
            snackbarWarning("Please leave a note for this changes of maximum 56 characters.");
            return;
        }
        if (httpMethod === "create") saveCloneChanges();
        else saveEditChanges();
    };
    const cancelEditChanges = ()=>{
        removePathFromBreadcrumbs(paths.length - 2);
        snackbarWarning("Undone changes!");
        setEditConfig(initialData?.config);
        handleBackToConfigs();
    };
    const handlePublisherSwitch = (current_slug)=>{
        const LS_PUBLISHER_SLUG = "publisherSlug";
        const lsSlug = localStorage.getItem(LS_PUBLISHER_SLUG);
        const recentPublisherList = (0, $14c705ecf5141c7b$export$1aae215f59ea61d5)();
        if (lsSlug && lsSlug !== current_slug) {
            localStorage.setItem(LS_PUBLISHER_SLUG, current_slug);
            // only redirect to domains page user directly switch to a different publisher
            if (recentPublisherList.length > 0) {
                removePathFromBreadcrumbs(0);
                history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN, {
                    slug: current_slug
                }));
            }
        } else localStorage.setItem(LS_PUBLISHER_SLUG, current_slug);
    };
    // LifeCycles
    (0, $acw62.useEffect)(()=>{
        const handlePopState = ()=>{
            setPaths((prev)=>prev.length > 1 ? prev.slice(0, -1) : prev);
        };
        window.addEventListener("popstate", handlePopState);
        // cleanup on unmount
        return ()=>window.removeEventListener("popstate", handlePopState);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const { pathname: pathname } = location;
        setParams({
            playerToken: pathname.split("/").at(5),
            domainToken: pathname.split("/").at(4)
        });
        if (pathname === (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PUBLISHER_ONBOARD) setPaths([
            {
                path: pathname,
                pathName: "Onboard publisher"
            }
        ]);
        if (pathname.includes("bulk")) {
            const splitedPathname = pathname.split("/")[2];
            setPaths([
                {
                    path: pathname,
                    pathName: `${(0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(splitedPathname, "-")} Domains`
                }
            ]);
        }
        if (pathname === (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN) setPaths([
            {
                path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN, {
                    slug: publisherSlug || slug
                }),
                pathName: "Domains"
            }
        ]);
    }, [
        location.pathname
    ]);
    // redirect to domains page when switching publisher
    (0, $acw62.useEffect)(()=>{
        handlePublisherSwitch(publisherSlug);
    }, [
        publisherSlug
    ]);
    // reset bread crumbs path to domains page when navigating back to domain
    (0, $acw62.useEffect)(()=>{
        removePathFromBreadcrumbs(0);
    }, [
        paths.length > 1 && location.pathname.split("/").length === 3
    ]);
    // Context
    const contextValues = (0, $acw62.useMemo)(()=>({
            removePathFromBreadcrumbs: removePathFromBreadcrumbs,
            addPathToBreadCrumb: addPathToBreadCrumb,
            setShowEditButtons: setShowEditButtons,
            handleCloneOrEditChanges: handleCloneOrEditChanges,
            editConfig: editConfig,
            setEditConfig: setEditConfig,
            setHttpMethod: setHttpMethod,
            initialData: initialData,
            setInitialData: setInitialData,
            setHasValidationErrors: setHasValidationErrors,
            slug: slug,
            paths: paths,
            setSelectedDomainToken: setSelectedDomainToken,
            selectedDomainToken: selectedDomainToken,
            conflictedData: conflictedData,
            setConflictedData: setConflictedData,
            isLoading: isLoading,
            editDomainConfig: editDomainConfig,
            setEditDomainConfig: setEditDomainConfig,
            advancedEditMode: advancedEditMode,
            setAdvancedEditMode: setAdvancedEditMode,
            forceSaveSchema: forceSaveSchema,
            setForceSaveSchema: setForceSaveSchema,
            domains: domains,
            domainsQuery: domainsQuery
        }), [
        addPathToBreadCrumb,
        removePathFromBreadcrumbs,
        setShowEditButtons,
        handleCloneOrEditChanges,
        editConfig,
        setEditConfig,
        setHttpMethod,
        initialData,
        setInitialData,
        setHasValidationErrors,
        paths,
        setSelectedDomainToken,
        selectedDomainToken,
        conflictedData,
        setConflictedData,
        isLoading,
        editDomainConfig,
        setEditDomainConfig,
        advancedEditMode,
        setAdvancedEditMode,
        forceSaveSchema,
        setForceSaveSchema,
        domains,
        domainsQuery
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($04813b9f064173e2$var$SuperAdminContext.Provider, {
        value: contextValues,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50f06ca8e5498c82$export$96038c7a387b6b24), {
                    paths: paths,
                    updatePaths: removePathFromBreadcrumbs
                }),
                children,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1f8abd7fea68f5ba$export$2e2bcd8739ae039), {
                    show: showEditButtons,
                    cancel: cancelEditChanges,
                    save: handleCloneOrEditChanges
                })
            ]
        })
    });
}
const $04813b9f064173e2$export$e3a1c6815b077e4a = ()=>(0, $acw62.useContext)($04813b9f064173e2$var$SuperAdminContext);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
var $4fGPb = parcelRequire("4fGPb");



var $gd5y7 = parcelRequire("gd5y7");
var $cX7V2 = parcelRequire("cX7V2");
var $2iAqv = parcelRequire("2iAqv");
var $ad2b0c1d97366d24$exports = {};
"use strict";
var $ad2b0c1d97366d24$var$__createBinding = $ad2b0c1d97366d24$exports && $ad2b0c1d97366d24$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ad2b0c1d97366d24$var$__exportStar = $ad2b0c1d97366d24$exports && $ad2b0c1d97366d24$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ad2b0c1d97366d24$var$__createBinding(exports1, m, p);
};
var $ad2b0c1d97366d24$var$__importDefault = $ad2b0c1d97366d24$exports && $ad2b0c1d97366d24$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ad2b0c1d97366d24$exports, "__esModule", {
    value: true
});

const $ad2b0c1d97366d24$var$krg_toggle_button_react_1 = $ad2b0c1d97366d24$var$__importDefault((parcelRequire("fcvb5")));

$ad2b0c1d97366d24$var$__exportStar((parcelRequire("cftMu")), $ad2b0c1d97366d24$exports);

$ad2b0c1d97366d24$var$__exportStar((parcelRequire("lPPDP")), $ad2b0c1d97366d24$exports);
$ad2b0c1d97366d24$exports.default = $ad2b0c1d97366d24$var$krg_toggle_button_react_1.default;



var $dgtCa = parcelRequire("dgtCa");










function $c124fe04d5edc6ee$export$2e2bcd8739ae039(props) {
    const { addPathToBreadCrumb: addPathToBreadCrumb, domains: domains, domainsQuery: domainsQuery } = (0, $04813b9f064173e2$export$e3a1c6815b077e4a)();
    const { asAdmin: asAdmin = false } = props;
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const { snackbarSuccess: snackbarSuccess, snackbarError: snackbarError } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [modalIsOpen, setModalIsOpen] = (0, $acw62.useState)(false);
    const [userDomains, setUserDomains] = (0, $acw62.useState)([]);
    const [hasUnsavedChanges, setHasUnsavedChanges] = (0, $acw62.useState)(false);
    const history = (0, $kfZjc.useHistory)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    // Add breadcrumb
    (0, $acw62.useEffect)(()=>{
        if (!asAdmin) history.push((0, $29836994947f98a9$export$807b1b70df68fbc6).PUBLISHER_HUB);
        addPathToBreadCrumb([
            {
                path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN, {
                    slug: publisherSlug
                }),
                pathName: "Domains"
            }
        ]);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (domains) {
            const tempDomains = domains.map((domain)=>({
                    ...domain,
                    id: domain.domain
                }));
            setUserDomains(tempDomains);
        }
    }, [
        domains
    ]);
    if (domainsQuery.isFetching) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "krg-loading-wrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    const handleRecommenderToggle = (domainToken, enabled)=>{
        const index = userDomains.findIndex((domain)=>domain.token === domainToken);
        if (index === -1) return;
        const target = userDomains[index];
        if (target.recommender_enabled === enabled) return;
        const updatedDomains = [
            ...userDomains
        ];
        updatedDomains[index] = {
            ...target,
            recommender_enabled: enabled,
            ...!target.recommender_source && {
                recommender_source: "1PC"
            }
        };
        setUserDomains(updatedDomains);
        setHasUnsavedChanges(true);
    };
    const handleSourceChange = (domainToken, source)=>{
        const index = userDomains.findIndex((domain)=>domain.token === domainToken);
        if (index === -1) return;
        const target = userDomains[index];
        if (target.recommender_source === source) return;
        const updatedDomains = [
            ...userDomains
        ];
        updatedDomains[index] = {
            ...target,
            recommender_source: source
        };
        setUserDomains(updatedDomains);
        setHasUnsavedChanges(true);
    };
    const handleSaveChanges = async ()=>{
        const domainMap = new Map(domains.map((d)=>[
                d.token,
                d
            ]));
        try {
            const updatedDomains = userDomains.filter((userDomain)=>{
                const originalDomain = domainMap.get(userDomain.token);
                return originalDomain?.recommender_enabled !== userDomain.recommender_enabled || originalDomain?.recommender_source !== userDomain.recommender_source;
            }).map((domain)=>({
                    token: domain.token,
                    recommender_enabled: domain.recommender_enabled,
                    recommender_source: domain.recommender_source
                }));
            if (updatedDomains.length === 0) {
                snackbarSuccess("No changes to save");
                setHasUnsavedChanges(false);
                return;
            }
            await api.bulkUpdateDomains({
                domains: updatedDomains
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "domain-configs"
                ]
            });
            snackbarSuccess(`Domain(s) updated successfully`);
            setHasUnsavedChanges(false);
        } catch (error) {
            snackbarError("Error updating domain(s)");
            console.error(error);
        }
    };
    const columns = [
        {
            field: "domain",
            headerName: "Domains",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
                    to: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                        slug: publisherSlug,
                        domainToken: row.token
                    }),
                    className: "krg-ellipses-text",
                    children: row.domain
                })
        },
        {
            field: "updated_at",
            headerName: "Last update",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(row.updated_at).format("DD/MMM/YY "),
                        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(row.updated_at).format(" HH:mm:ss")
                    ]
                })
        },
        {
            field: "recommender_enabled",
            headerName: "Recommender Enabled",
            renderCell: (row)=>{
                const domain = userDomains.find((d)=>d.token === row.token);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ad2b0c1d97366d24$exports))), {
                    buttons: [
                        {
                            label: "Yes",
                            value: "true"
                        },
                        {
                            label: "No",
                            value: "false"
                        }
                    ],
                    size: (0, (/*@__PURE__*/$parcel$interopDefault($ad2b0c1d97366d24$exports))).SIZE_ENUM.small,
                    color: domain?.recommender_enabled ? (0, (/*@__PURE__*/$parcel$interopDefault($ad2b0c1d97366d24$exports))).COLOR_ENUM.success : (0, (/*@__PURE__*/$parcel$interopDefault($ad2b0c1d97366d24$exports))).COLOR_ENUM.error,
                    onChange: (value)=>{
                        if (asAdmin) handleRecommenderToggle(row.token, value[0] === "true");
                    },
                    isSingleSelection: true,
                    selectedButtons: [
                        domain?.recommender_enabled ? "true" : "false"
                    ],
                    disabled: !asAdmin
                });
            }
        },
        {
            field: "recommender_source",
            headerName: "Recommender Source",
            renderCell: (row)=>{
                const domain = userDomains.find((d)=>d.token === row.token);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    size: "small",
                    sx: {
                        minWidth: 120
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: domain?.recommender_source || "1PC",
                        onChange: (e)=>handleSourceChange(row.token, e.target.value),
                        disabled: !asAdmin || !domain?.recommender_enabled,
                        sx: {
                            height: "32px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "1PC",
                                children: "1PC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "VE",
                                children: "VE"
                            })
                        ]
                    })
                });
            }
        },
        {
            field: "",
            headerName: "No. of Players Configs",
            onClick: (__, row)=>{
                addPathToBreadCrumb([
                    {
                        path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                            slug: publisherSlug,
                            domainToken: row.token
                        }),
                        pathName: row.domain
                    }
                ]);
                history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                    slug: publisherSlug,
                    domainToken: row.token
                }), {
                    config: row.configs
                });
            },
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    style: {
                        textAlign: "end",
                        width: "122px"
                    },
                    children: row.configs.length
                })
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "20px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                padding: "0 30px 0 0",
                display: "flex",
                justifyContent: "end",
                gap: 2,
                children: [
                    asAdmin && hasUnsavedChanges && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                        id: "save-domain-settings",
                        text: "Save Changes",
                        onClick: handleSaveChanges,
                        variant: (0, $dgtCa.VARIANT_ENUM).contained,
                        size: (0, $dgtCa.SIZE_ENUM).small,
                        color: "primary"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                        id: "add-domain",
                        text: "Add domain",
                        onClick: ()=>setModalIsOpen(true),
                        variant: (0, $dgtCa.VARIANT_ENUM).contained,
                        size: (0, $dgtCa.SIZE_ENUM).small
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6d298d2808c038e$export$2e2bcd8739ae039), {
                asAdmin: asAdmin,
                title: "Add New Domain",
                label: "Domain",
                isOpen: modalIsOpen,
                showCheckbox: true,
                onClose: ()=>setModalIsOpen(false),
                onSubmit: ()=>setModalIsOpen(false),
                createOptions: {
                    onSuccess: ()=>{
                        snackbarSuccess("Created New Domain");
                    },
                    onError: ()=>{
                        snackbarError("Error creating domain, check the console for more information.");
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1bfd01510116977$export$2e2bcd8739ae039), {
                    columns: columns,
                    rows: userDomains,
                    size: 12
                })
            })
        ]
    });
}


/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-shadow */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
var $4fGPb = parcelRequire("4fGPb");


var $e1f981a4b419bccc$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($e1f981a4b419bccc$exports, "__esModule", {
    value: true
});
$e1f981a4b419bccc$exports.default = void 0;

var $e1f981a4b419bccc$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e1f981a4b419bccc$var$_default = $e1f981a4b419bccc$exports.default = (0, $e1f981a4b419bccc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2zm-1 7h5.5L14 6.5z"
}), "FileCopy");


var $8c6ad197f63b3f3e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8c6ad197f63b3f3e$exports, "__esModule", {
    value: true
});
$8c6ad197f63b3f3e$exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = $8c6ad197f63b3f3e$exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");



var $f1q41 = parcelRequire("f1q41");

var $dgtCa = parcelRequire("dgtCa");










function $16165861a72427f6$export$2e2bcd8739ae039() {
    const { addPathToBreadCrumb: addPathToBreadCrumb } = (0, $04813b9f064173e2$export$e3a1c6815b077e4a)();
    const history = (0, $kfZjc.useHistory)();
    const params = (0, $kfZjc.useParams)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(true);
    const { data: data, isFetched: isFetched, isError: isError } = (0, $a9fd19d627d10772$export$d9dcc325f8df9b84)(params.domainToken || "");
    const configs = data?.configs || [];
    const [selectedDomain, setSelectedDomain] = (0, $acw62.useState)();
    const [updatedSelectedDomain, setUpdatedSelectedDomain] = (0, $acw62.useState)();
    const [search, setSearch] = (0, $acw62.useState)("");
    const [isDomainSelected, setIsDomainSelected] = (0, $acw62.useState)(false);
    const debouncedTrack = (0, $acw62.useMemo)(()=>(0, $f1q41.debounce)((event, data)=>{
            (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track(event, data);
        }, 3000), []);
    (0, $acw62.useEffect)(()=>{
        if (configs?.length) {
            const selectedDomainData = configs.find((d)=>d.token === selectedDomain?.token);
            if (selectedDomainData) setUpdatedSelectedDomain((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(selectedDomainData));
            else setSelectedDomain(configs[0]);
        }
    }, [
        configs,
        selectedDomain,
        isError
    ]);
    (0, $acw62.useEffect)(()=>{
        if (search) debouncedTrack("Search", {
            resource: "property",
            text: search
        });
        else setIsDomainSelected(false);
    }, [
        search
    ]);
    const filterDomainList = (ctxSelectedDomain)=>{
        if (!isDomainSelected) return configs;
        return configs.filter((config)=>config?.key.toLowerCase().startsWith(ctxSelectedDomain?.key?.toLowerCase()));
    };
    const handleSearchChange = (event, text)=>setSearch(text);
    if (!configs && !isFetched) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "krg-loading-wrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    (0, $acw62.useEffect)(()=>{
        if (data) addPathToBreadCrumb([
            {
                path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                    slug: publisherSlug,
                    domainToken: params.domainToken
                }),
                pathName: data.domain
            }
        ]);
    }, [
        data
    ]);
    const columns = [
        {
            field: "key",
            headerName: "Player Config",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
                    to: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_EDIT, {
                        domainToken: params.domainToken,
                        playerToken: row.token,
                        slug: publisherSlug
                    }),
                    className: "krg-ellipses-text",
                    children: row.key
                })
        },
        {
            field: "notes",
            headerName: "Notes",
            renderCell: (row)=>row.notes ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: row.notes
                }) : null
        },
        {
            field: "revision",
            headerName: "Revision",
            onClick: (_, row)=>{
                history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CONFIG, {
                    slug: publisherSlug,
                    domainToken: params.domainToken,
                    playerToken: row.token
                }));
            },
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: row.revision
                })
        },
        {
            field: "updated_at",
            headerName: "Last update",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(row.updated_at).format("DD/MMM/YY "),
                        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(row.updated_at).format(" HH:mm:ss")
                    ]
                })
        },
        {
            field: "created_by_user",
            headerName: "Updated by",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: row.created_by_user
                })
        },
        {
            field: "clone",
            headerName: "Clone",
            onClick: (_, row)=>{
                history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CLONE, {
                    slug: publisherSlug,
                    domainToken: params.domainToken,
                    playerToken: row.token
                }), {
                    config: row
                });
            },
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e1f981a4b419bccc$exports))), {
                    color: "secondary"
                })
        },
        {
            field: "edit",
            headerName: "Edit",
            onClick: (_, row)=>{
                history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_EDIT, {
                    slug: publisherSlug,
                    domainToken: params.domainToken,
                    playerToken: row.token
                }), {
                    config: row
                });
            },
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {
                    color: "primary"
                })
        }
    ];
    const rows = filterDomainList(updatedSelectedDomain)?.map((d)=>({
            ...d,
            id: d.key
        })) || [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "20px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                padding: "0 30px 0 0",
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $053f01ce092d1441$export$2e2bcd8739ae039), {
                        searchValue: search,
                        widthSize: "minWidth",
                        placeholder: "search player config",
                        options: configs?.map((d)=>d.key),
                        onSearchChange: handleSearchChange,
                        onOptionClick: (value)=>{
                            setSelectedDomain(configs?.find((d)=>d?.key?.toLowerCase() === value?.toLowerCase()));
                            setIsDomainSelected(true);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                        id: "add-player",
                        text: "Add config",
                        onClick: ()=>{
                            history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_CONFIG_EDIT, {
                                slug: publisherSlug,
                                domainToken: params.domainToken
                            }), {
                                config: {}
                            });
                        },
                        variant: (0, $dgtCa.VARIANT_ENUM).contained,
                        size: (0, $dgtCa.SIZE_ENUM).small
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1bfd01510116977$export$2e2bcd8739ae039), {
                    columns: columns,
                    rows: rows,
                    size: 20
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $iDAOR = parcelRequire("iDAOR");



var $htqGM = parcelRequire("htqGM");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
function $bee55e9bb705b0f2$export$93cc12bcce4c2e3c(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $bee55e9bb705b0f2$export$993bf82df8051d40(r) {
    if (Array.isArray(r)) return r;
}
function $bee55e9bb705b0f2$export$fdab3c20aae16ddf(e, r, t) {
    return (r = $bee55e9bb705b0f2$export$615c81bad063d605(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $bee55e9bb705b0f2$export$861af887bcb88094(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $bee55e9bb705b0f2$export$37ce4bd7a39fe25f() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bee55e9bb705b0f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bee55e9bb705b0f2$export$df72099fd95ee399(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bee55e9bb705b0f2$var$ownKeys(Object(t), true).forEach(function(r) {
            $bee55e9bb705b0f2$export$fdab3c20aae16ddf(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bee55e9bb705b0f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bee55e9bb705b0f2$export$d8a2083381e8fcb(e, t) {
    if (null == e) return {};
    var o, r, i = $bee55e9bb705b0f2$export$81942a8f34b531c4(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bee55e9bb705b0f2$export$81942a8f34b531c4(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $bee55e9bb705b0f2$export$12b6a547ec390b98(r, e) {
    return $bee55e9bb705b0f2$export$993bf82df8051d40(r) || $bee55e9bb705b0f2$export$861af887bcb88094(r, e) || $bee55e9bb705b0f2$export$b471fbbbe6d7806(r, e) || $bee55e9bb705b0f2$export$37ce4bd7a39fe25f();
}
function $bee55e9bb705b0f2$export$df1528eb86e943d6(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $bee55e9bb705b0f2$export$615c81bad063d605(t) {
    var i = $bee55e9bb705b0f2$export$df1528eb86e943d6(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $bee55e9bb705b0f2$export$b471fbbbe6d7806(r, a) {
    if (r) {
        if ("string" == typeof r) return $bee55e9bb705b0f2$export$93cc12bcce4c2e3c(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bee55e9bb705b0f2$export$93cc12bcce4c2e3c(r, a) : void 0;
    }
}


function $9060348473dc28ea$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9060348473dc28ea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9060348473dc28ea$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9060348473dc28ea$var$ownKeys(Object(source), true).forEach(function(key) {
            $9060348473dc28ea$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9060348473dc28ea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9060348473dc28ea$var$compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
}
function $9060348473dc28ea$var$curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nextArgs[_key3] = arguments[_key3];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
function $9060348473dc28ea$var$isObject(value) {
    return ({}).toString.call(value).includes("Object");
}
function $9060348473dc28ea$var$isEmpty(obj) {
    return !Object.keys(obj).length;
}
function $9060348473dc28ea$var$isFunction(value) {
    return typeof value === "function";
}
function $9060348473dc28ea$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
function $9060348473dc28ea$var$validateChanges(initial, changes) {
    if (!$9060348473dc28ea$var$isObject(changes)) $9060348473dc28ea$var$errorHandler("changeType");
    if (Object.keys(changes).some(function(field) {
        return !$9060348473dc28ea$var$hasOwnProperty(initial, field);
    })) $9060348473dc28ea$var$errorHandler("changeField");
    return changes;
}
function $9060348473dc28ea$var$validateSelector(selector) {
    if (!$9060348473dc28ea$var$isFunction(selector)) $9060348473dc28ea$var$errorHandler("selectorType");
}
function $9060348473dc28ea$var$validateHandler(handler) {
    if (!($9060348473dc28ea$var$isFunction(handler) || $9060348473dc28ea$var$isObject(handler))) $9060348473dc28ea$var$errorHandler("handlerType");
    if ($9060348473dc28ea$var$isObject(handler) && Object.values(handler).some(function(_handler) {
        return !$9060348473dc28ea$var$isFunction(_handler);
    })) $9060348473dc28ea$var$errorHandler("handlersType");
}
function $9060348473dc28ea$var$validateInitial(initial) {
    if (!initial) $9060348473dc28ea$var$errorHandler("initialIsRequired");
    if (!$9060348473dc28ea$var$isObject(initial)) $9060348473dc28ea$var$errorHandler("initialType");
    if ($9060348473dc28ea$var$isEmpty(initial)) $9060348473dc28ea$var$errorHandler("initialContent");
}
function $9060348473dc28ea$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $9060348473dc28ea$var$errorMessages = {
    initialIsRequired: "initial state is required",
    initialType: "initial state should be an object",
    initialContent: "initial state shouldn't be an empty object",
    handlerType: "handler should be an object or a function",
    handlersType: "all handlers should be a functions",
    selectorType: "selector should be a function",
    changeType: "provided value of changes should be an object",
    changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
    "default": "an unknown error accured in `state-local` package"
};
var $9060348473dc28ea$var$errorHandler = $9060348473dc28ea$var$curry($9060348473dc28ea$var$throwError)($9060348473dc28ea$var$errorMessages);
var $9060348473dc28ea$var$validators = {
    changes: $9060348473dc28ea$var$validateChanges,
    selector: $9060348473dc28ea$var$validateSelector,
    handler: $9060348473dc28ea$var$validateHandler,
    initial: $9060348473dc28ea$var$validateInitial
};
function $9060348473dc28ea$var$create(initial) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $9060348473dc28ea$var$validators.initial(initial);
    $9060348473dc28ea$var$validators.handler(handler);
    var state = {
        current: initial
    };
    var didUpdate = $9060348473dc28ea$var$curry($9060348473dc28ea$var$didStateUpdate)(state, handler);
    var update = $9060348473dc28ea$var$curry($9060348473dc28ea$var$updateState)(state);
    var validate = $9060348473dc28ea$var$curry($9060348473dc28ea$var$validators.changes)(initial);
    var getChanges = $9060348473dc28ea$var$curry($9060348473dc28ea$var$extractChanges)(state);
    function getState() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(state) {
            return state;
        };
        $9060348473dc28ea$var$validators.selector(selector);
        return selector(state.current);
    }
    function setState(causedChanges) {
        $9060348473dc28ea$var$compose(didUpdate, update, validate, getChanges)(causedChanges);
    }
    return [
        getState,
        setState
    ];
}
function $9060348473dc28ea$var$extractChanges(state, causedChanges) {
    return $9060348473dc28ea$var$isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function $9060348473dc28ea$var$updateState(state, changes) {
    state.current = $9060348473dc28ea$var$_objectSpread2($9060348473dc28ea$var$_objectSpread2({}, state.current), changes);
    return changes;
}
function $9060348473dc28ea$var$didStateUpdate(state, handler, changes) {
    $9060348473dc28ea$var$isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
        var _handler$field;
        return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
    });
    return changes;
}
var $9060348473dc28ea$var$index = {
    create: $9060348473dc28ea$var$create
};
var $9060348473dc28ea$export$2e2bcd8739ae039 = $9060348473dc28ea$var$index;


var $c482d67a3b2162b4$export$2e2bcd8739ae039 = {
    paths: {
        vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.55.1/min/vs"
    }
};


function $32601aa89bd9af55$export$2e2bcd8739ae039(fn) {
    return function curried() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nextArgs[_key2] = arguments[_key2];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}


function $92c97a4a229f3a23$export$2e2bcd8739ae039(value) {
    return ({}).toString.call(value).includes("Object");
}


/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */ function $cf5f38a3a625a9e0$var$validateConfig(config) {
    if (!config) $cf5f38a3a625a9e0$export$cc3fdd528b56c4a9("configIsRequired");
    if (!(0, $92c97a4a229f3a23$export$2e2bcd8739ae039)(config)) $cf5f38a3a625a9e0$export$cc3fdd528b56c4a9("configType");
    if (config.urls) {
        $cf5f38a3a625a9e0$var$informAboutDeprecation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
/**
 * logs deprecation message
 */ function $cf5f38a3a625a9e0$var$informAboutDeprecation() {
    console.warn($cf5f38a3a625a9e0$export$d8bd0967cb58683.deprecation);
}
function $cf5f38a3a625a9e0$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $cf5f38a3a625a9e0$export$d8bd0967cb58683 = {
    configIsRequired: "the configuration object is required",
    configType: "the configuration object should be an object",
    "default": "an unknown error accured in `@monaco-editor/loader` package",
    deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var $cf5f38a3a625a9e0$export$cc3fdd528b56c4a9 = (0, $32601aa89bd9af55$export$2e2bcd8739ae039)($cf5f38a3a625a9e0$var$throwError)($cf5f38a3a625a9e0$export$d8bd0967cb58683);
var $cf5f38a3a625a9e0$export$2e2bcd8739ae039 = {
    config: $cf5f38a3a625a9e0$var$validateConfig
};


var $cdea1942f0eebb85$export$2e2bcd8739ae039 = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};



function $2587816bf76728ed$export$2e2bcd8739ae039(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) {
            if (target[key]) Object.assign(source[key], $2587816bf76728ed$export$2e2bcd8739ae039(target[key], source[key]));
        }
    });
    return (0, $bee55e9bb705b0f2$export$df72099fd95ee399)((0, $bee55e9bb705b0f2$export$df72099fd95ee399)({}, target), source);
}


// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var $cbf26bd161834ccb$export$ef4ebf120f9f6749 = {
    type: "cancelation",
    msg: "operation is manually canceled"
};
function $cbf26bd161834ccb$export$2e2bcd8739ae039(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject($cbf26bd161834ccb$export$ef4ebf120f9f6749) : resolve(val);
        });
        promise["catch"](reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
}


var $0840e892d82f5480$var$_excluded = [
    "monaco"
];
/** the local state of the module */ var $0840e892d82f5480$var$_state$create = (0, $9060348473dc28ea$export$2e2bcd8739ae039).create({
    config: (0, $c482d67a3b2162b4$export$2e2bcd8739ae039),
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
}), $0840e892d82f5480$var$_state$create2 = (0, $bee55e9bb705b0f2$export$12b6a547ec390b98)($0840e892d82f5480$var$_state$create, 2), $0840e892d82f5480$var$getState = $0840e892d82f5480$var$_state$create2[0], $0840e892d82f5480$var$setState = $0840e892d82f5480$var$_state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */ function $0840e892d82f5480$var$config(globalConfig) {
    var _validators$config = (0, $cf5f38a3a625a9e0$export$2e2bcd8739ae039).config(globalConfig), monaco = _validators$config.monaco, config = (0, $bee55e9bb705b0f2$export$d8a2083381e8fcb)(_validators$config, $0840e892d82f5480$var$_excluded);
    $0840e892d82f5480$var$setState(function(state) {
        return {
            config: (0, $2587816bf76728ed$export$2e2bcd8739ae039)(state.config, config),
            monaco: monaco
        };
    });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */ function $0840e892d82f5480$var$init() {
    var state = $0840e892d82f5480$var$getState(function(_ref) {
        var monaco = _ref.monaco, isInitialized = _ref.isInitialized, resolve = _ref.resolve;
        return {
            monaco: monaco,
            isInitialized: isInitialized,
            resolve: resolve
        };
    });
    if (!state.isInitialized) {
        $0840e892d82f5480$var$setState({
            isInitialized: true
        });
        if (state.monaco) {
            state.resolve(state.monaco);
            return (0, $cbf26bd161834ccb$export$2e2bcd8739ae039)($0840e892d82f5480$var$wrapperPromise);
        }
        if (window.monaco && window.monaco.editor) {
            $0840e892d82f5480$var$storeMonacoInstance(window.monaco);
            state.resolve(window.monaco);
            return (0, $cbf26bd161834ccb$export$2e2bcd8739ae039)($0840e892d82f5480$var$wrapperPromise);
        }
        (0, $cdea1942f0eebb85$export$2e2bcd8739ae039)($0840e892d82f5480$var$injectScripts, $0840e892d82f5480$var$getMonacoLoaderScript)($0840e892d82f5480$var$configureLoader);
    }
    return (0, $cbf26bd161834ccb$export$2e2bcd8739ae039)($0840e892d82f5480$var$wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */ function $0840e892d82f5480$var$injectScripts(script) {
    return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */ function $0840e892d82f5480$var$createScript(src) {
    var script = document.createElement("script");
    return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */ function $0840e892d82f5480$var$getMonacoLoaderScript(configureLoader) {
    var state = $0840e892d82f5480$var$getState(function(_ref2) {
        var config = _ref2.config, reject = _ref2.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = $0840e892d82f5480$var$createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return configureLoader();
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
/**
 * configures the monaco loader
 */ function $0840e892d82f5480$var$configureLoader() {
    var state = $0840e892d82f5480$var$getState(function(_ref3) {
        var config = _ref3.config, resolve = _ref3.resolve, reject = _ref3.reject;
        return {
            config: config,
            resolve: resolve,
            reject: reject
        };
    });
    var require = window.require;
    require.config(state.config);
    require([
        "vs/editor/editor.main"
    ], function(loaded) {
        var monaco = loaded.m /* for 0.53 & 0.54 */  || loaded /* for other versions */ ;
        $0840e892d82f5480$var$storeMonacoInstance(monaco);
        state.resolve(monaco);
    }, function(error) {
        state.reject(error);
    });
}
/**
 * store monaco instance in local state
 */ function $0840e892d82f5480$var$storeMonacoInstance(monaco) {
    if (!$0840e892d82f5480$var$getState().monaco) $0840e892d82f5480$var$setState({
        monaco: monaco
    });
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */ function $0840e892d82f5480$var$__getMonacoInstance() {
    return $0840e892d82f5480$var$getState(function(_ref4) {
        var monaco = _ref4.monaco;
        return monaco;
    });
}
var $0840e892d82f5480$var$wrapperPromise = new Promise(function(resolve, reject) {
    return $0840e892d82f5480$var$setState({
        resolve: resolve,
        reject: reject
    });
});
var $0840e892d82f5480$export$2e2bcd8739ae039 = {
    config: $0840e892d82f5480$var$config,
    init: $0840e892d82f5480$var$init,
    __getMonacoInstance: $0840e892d82f5480$var$__getMonacoInstance
};





var $acw62 = parcelRequire("acw62");
var $e964c7ac951d5673$var$le = {
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial"
    },
    fullWidth: {
        width: "100%"
    },
    hide: {
        display: "none"
    }
}, $e964c7ac951d5673$var$v = $e964c7ac951d5673$var$le;
var $e964c7ac951d5673$var$ae = {
    container: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    }
}, $e964c7ac951d5673$var$Y = $e964c7ac951d5673$var$ae;
function $e964c7ac951d5673$var$Me({ children: e }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $e964c7ac951d5673$var$Y.container
    }, e);
}
var $e964c7ac951d5673$var$Z = $e964c7ac951d5673$var$Me;
var $e964c7ac951d5673$var$$ = $e964c7ac951d5673$var$Z;
function $e964c7ac951d5673$var$Ee({ width: e, height: r, isEditorReady: n, loading: t, _ref: a, className: m, wrapperProps: E }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        style: {
            ...$e964c7ac951d5673$var$v.wrapper,
            width: e,
            height: r
        },
        ...E
    }, !n && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e964c7ac951d5673$var$$, null, t), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: a,
        style: {
            ...$e964c7ac951d5673$var$v.fullWidth,
            ...!n && $e964c7ac951d5673$var$v.hide
        },
        className: m
    }));
}
var $e964c7ac951d5673$var$ee = $e964c7ac951d5673$var$Ee;
var $e964c7ac951d5673$var$H = (0, $acw62.memo)($e964c7ac951d5673$var$ee);
function $e964c7ac951d5673$var$Ce(e) {
    (0, $acw62.useEffect)(e, []);
}
var $e964c7ac951d5673$var$k = $e964c7ac951d5673$var$Ce;
function $e964c7ac951d5673$var$he(e, r, n = !0) {
    let t = (0, $acw62.useRef)(!0);
    (0, $acw62.useEffect)(t.current || !n ? ()=>{
        t.current = !1;
    } : e, r);
}
var $e964c7ac951d5673$var$l = $e964c7ac951d5673$var$he;
function $e964c7ac951d5673$var$D() {}
function $e964c7ac951d5673$var$h(e, r, n, t) {
    return $e964c7ac951d5673$var$De(e, t) || $e964c7ac951d5673$var$be(e, r, n, t);
}
function $e964c7ac951d5673$var$De(e, r) {
    return e.editor.getModel($e964c7ac951d5673$var$te(e, r));
}
function $e964c7ac951d5673$var$be(e, r, n, t) {
    return e.editor.createModel(r, n, t ? $e964c7ac951d5673$var$te(e, t) : void 0);
}
function $e964c7ac951d5673$var$te(e, r) {
    return e.Uri.parse(r);
}
function $e964c7ac951d5673$var$Oe({ original: e, modified: r, language: n, originalLanguage: t, modifiedLanguage: a, originalModelPath: m, modifiedModelPath: E, keepCurrentOriginalModel: g = !1, keepCurrentModifiedModel: N = !1, theme: x = "light", loading: P = "Loading...", options: y = {}, height: V = "100%", width: z = "100%", className: F, wrapperProps: j = {}, beforeMount: A = $e964c7ac951d5673$var$D, onMount: q = $e964c7ac951d5673$var$D }) {
    let [M, O] = (0, $acw62.useState)(!1), [T, s] = (0, $acw62.useState)(!0), u = (0, $acw62.useRef)(null), c = (0, $acw62.useRef)(null), w = (0, $acw62.useRef)(null), d = (0, $acw62.useRef)(q), o = (0, $acw62.useRef)(A), b = (0, $acw62.useRef)(!1);
    $e964c7ac951d5673$var$k(()=>{
        let i = (0, $0840e892d82f5480$export$2e2bcd8739ae039).init();
        return i.then((f)=>(c.current = f) && s(!1)).catch((f)=>f?.type !== "cancelation" && console.error("Monaco initialization: error:", f)), ()=>u.current ? I() : i.cancel();
    }), $e964c7ac951d5673$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getOriginalEditor(), f = $e964c7ac951d5673$var$h(c.current, e || "", t || n || "text", m || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        m
    ], M), $e964c7ac951d5673$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getModifiedEditor(), f = $e964c7ac951d5673$var$h(c.current, r || "", a || n || "text", E || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        E
    ], M), $e964c7ac951d5673$var$l(()=>{
        let i = u.current.getModifiedEditor();
        i.getOption(c.current.editor.EditorOption.readOnly) ? i.setValue(r || "") : r !== i.getValue() && (i.executeEdits("", [
            {
                range: i.getModel().getFullModelRange(),
                text: r || "",
                forceMoveMarkers: !0
            }
        ]), i.pushUndoStop());
    }, [
        r
    ], M), $e964c7ac951d5673$var$l(()=>{
        u.current?.getModel()?.original.setValue(e || "");
    }, [
        e
    ], M), $e964c7ac951d5673$var$l(()=>{
        let { original: i, modified: f } = u.current.getModel();
        c.current.editor.setModelLanguage(i, t || n || "text"), c.current.editor.setModelLanguage(f, a || n || "text");
    }, [
        n,
        t,
        a
    ], M), $e964c7ac951d5673$var$l(()=>{
        c.current?.editor.setTheme(x);
    }, [
        x
    ], M), $e964c7ac951d5673$var$l(()=>{
        u.current?.updateOptions(y);
    }, [
        y
    ], M);
    let L = (0, $acw62.useCallback)(()=>{
        if (!c.current) return;
        o.current(c.current);
        let i = $e964c7ac951d5673$var$h(c.current, e || "", t || n || "text", m || ""), f = $e964c7ac951d5673$var$h(c.current, r || "", a || n || "text", E || "");
        u.current?.setModel({
            original: i,
            modified: f
        });
    }, [
        n,
        r,
        a,
        e,
        t,
        m,
        E
    ]), U = (0, $acw62.useCallback)(()=>{
        !b.current && w.current && (u.current = c.current.editor.createDiffEditor(w.current, {
            automaticLayout: !0,
            ...y
        }), L(), c.current?.editor.setTheme(x), O(!0), b.current = !0);
    }, [
        y,
        x,
        L
    ]);
    (0, $acw62.useEffect)(()=>{
        M && d.current(u.current, c.current);
    }, [
        M
    ]), (0, $acw62.useEffect)(()=>{
        !T && !M && U();
    }, [
        T,
        M,
        U
    ]);
    function I() {
        let i = u.current?.getModel();
        g || i?.original?.dispose(), N || i?.modified?.dispose(), u.current?.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e964c7ac951d5673$var$H, {
        width: z,
        height: V,
        isEditorReady: M,
        loading: P,
        _ref: w,
        className: F,
        wrapperProps: j
    });
}
var $e964c7ac951d5673$var$ie = $e964c7ac951d5673$var$Oe;
var $e964c7ac951d5673$export$f95cfa31b5a0bc91 = (0, $acw62.memo)($e964c7ac951d5673$var$ie);
function $e964c7ac951d5673$var$Pe() {
    let [e, r] = (0, $acw62.useState)((0, $0840e892d82f5480$export$2e2bcd8739ae039).__getMonacoInstance());
    return $e964c7ac951d5673$var$k(()=>{
        let n;
        return e || (n = (0, $0840e892d82f5480$export$2e2bcd8739ae039).init(), n.then((t)=>{
            r(t);
        })), ()=>n?.cancel();
    }), e;
}
var $e964c7ac951d5673$export$7c29dcfb1e21cfdd = $e964c7ac951d5673$var$Pe;
function $e964c7ac951d5673$var$He(e) {
    let r = (0, $acw62.useRef)();
    return (0, $acw62.useEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r.current;
}
var $e964c7ac951d5673$var$se = $e964c7ac951d5673$var$He;
var $e964c7ac951d5673$var$_ = new Map;
function $e964c7ac951d5673$var$Ve({ defaultValue: e, defaultLanguage: r, defaultPath: n, value: t, language: a, path: m, theme: E = "light", line: g, loading: N = "Loading...", options: x = {}, overrideServices: P = {}, saveViewState: y = !0, keepCurrentModel: V = !1, width: z = "100%", height: F = "100%", className: j, wrapperProps: A = {}, beforeMount: q = $e964c7ac951d5673$var$D, onMount: M = $e964c7ac951d5673$var$D, onChange: O, onValidate: T = $e964c7ac951d5673$var$D }) {
    let [s, u] = (0, $acw62.useState)(!1), [c, w] = (0, $acw62.useState)(!0), d = (0, $acw62.useRef)(null), o = (0, $acw62.useRef)(null), b = (0, $acw62.useRef)(null), L = (0, $acw62.useRef)(M), U = (0, $acw62.useRef)(q), I = (0, $acw62.useRef)(), i = (0, $acw62.useRef)(t), f = $e964c7ac951d5673$var$se(m), Q = (0, $acw62.useRef)(!1), B = (0, $acw62.useRef)(!1);
    $e964c7ac951d5673$var$k(()=>{
        let p = (0, $0840e892d82f5480$export$2e2bcd8739ae039).init();
        return p.then((R)=>(d.current = R) && w(!1)).catch((R)=>R?.type !== "cancelation" && console.error("Monaco initialization: error:", R)), ()=>o.current ? pe() : p.cancel();
    }), $e964c7ac951d5673$var$l(()=>{
        let p = $e964c7ac951d5673$var$h(d.current, e || t || "", r || a || "", m || n || "");
        p !== o.current?.getModel() && (y && $e964c7ac951d5673$var$_.set(f, o.current?.saveViewState()), o.current?.setModel(p), y && o.current?.restoreViewState($e964c7ac951d5673$var$_.get(m)));
    }, [
        m
    ], s), $e964c7ac951d5673$var$l(()=>{
        o.current?.updateOptions(x);
    }, [
        x
    ], s), $e964c7ac951d5673$var$l(()=>{
        !o.current || t === void 0 || (o.current.getOption(d.current.editor.EditorOption.readOnly) ? o.current.setValue(t) : t !== o.current.getValue() && (B.current = !0, o.current.executeEdits("", [
            {
                range: o.current.getModel().getFullModelRange(),
                text: t,
                forceMoveMarkers: !0
            }
        ]), o.current.pushUndoStop(), B.current = !1));
    }, [
        t
    ], s), $e964c7ac951d5673$var$l(()=>{
        let p = o.current?.getModel();
        p && a && d.current?.editor.setModelLanguage(p, a);
    }, [
        a
    ], s), $e964c7ac951d5673$var$l(()=>{
        g !== void 0 && o.current?.revealLine(g);
    }, [
        g
    ], s), $e964c7ac951d5673$var$l(()=>{
        d.current?.editor.setTheme(E);
    }, [
        E
    ], s);
    let X = (0, $acw62.useCallback)(()=>{
        if (!(!b.current || !d.current) && !Q.current) {
            U.current(d.current);
            let p = m || n, R = $e964c7ac951d5673$var$h(d.current, t || e || "", r || a || "", p || "");
            o.current = d.current?.editor.create(b.current, {
                model: R,
                automaticLayout: !0,
                ...x
            }, P), y && o.current.restoreViewState($e964c7ac951d5673$var$_.get(p)), d.current.editor.setTheme(E), g !== void 0 && o.current.revealLine(g), u(!0), Q.current = !0;
        }
    }, [
        e,
        r,
        n,
        t,
        a,
        m,
        x,
        P,
        y,
        E,
        g
    ]);
    (0, $acw62.useEffect)(()=>{
        s && L.current(o.current, d.current);
    }, [
        s
    ]), (0, $acw62.useEffect)(()=>{
        !c && !s && X();
    }, [
        c,
        s,
        X
    ]), i.current = t, (0, $acw62.useEffect)(()=>{
        s && O && (I.current?.dispose(), I.current = o.current?.onDidChangeModelContent((p)=>{
            B.current || O(o.current.getValue(), p);
        }));
    }, [
        s,
        O
    ]), (0, $acw62.useEffect)(()=>{
        if (s) {
            let p = d.current.editor.onDidChangeMarkers((R)=>{
                let G = o.current.getModel()?.uri;
                if (G && R.find((J)=>J.path === G.path)) {
                    let J = d.current.editor.getModelMarkers({
                        resource: G
                    });
                    T?.(J);
                }
            });
            return ()=>{
                p?.dispose();
            };
        }
        return ()=>{};
    }, [
        s,
        T
    ]);
    function pe() {
        I.current?.dispose(), V ? y && $e964c7ac951d5673$var$_.set(m, o.current.saveViewState()) : o.current.getModel()?.dispose(), o.current.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e964c7ac951d5673$var$H, {
        width: z,
        height: F,
        isEditorReady: s,
        loading: N,
        _ref: b,
        className: j,
        wrapperProps: A
    });
}
var $e964c7ac951d5673$var$fe = $e964c7ac951d5673$var$Ve;
var $e964c7ac951d5673$export$7cda8d932e2f33c0 = (0, $acw62.memo)($e964c7ac951d5673$var$fe);
var $e964c7ac951d5673$export$2e2bcd8739ae039 = $e964c7ac951d5673$export$7cda8d932e2f33c0;



var $acw62 = parcelRequire("acw62");

function $4eccf30e27ce8e0f$export$2e2bcd8739ae039(onChange, onValidate) {
    const editorRef = (0, $acw62.useRef)(null);
    const monaco = (0, $e964c7ac951d5673$export$7c29dcfb1e21cfdd)();
    return {
        onMount (editor) {
            const modified = editor.getModifiedEditor();
            editorRef.current = modified;
            modified.onDidChangeModelContent(()=>{
                onChange(modified.getValue());
            });
            monaco.editor.onDidChangeMarkers(()=>{
                onValidate(monaco.editor.getModelMarkers({}));
            });
        }
    };
}


function $f1103ba73659fa46$export$2e2bcd8739ae039(props) {
    const { schemaValidation: schemaValidation, onChange: onChange, onValidate: onValidate, editValue: editValue, diffValue: diffValue, renderSideBySide: renderSideBySide } = props;
    const monaco = (0, $e964c7ac951d5673$export$7c29dcfb1e21cfdd)();
    const { onMount: onMount } = (0, $4eccf30e27ce8e0f$export$2e2bcd8739ae039)(onChange, onValidate);
    (0, $acw62.useEffect)(()=>{
        if (monaco) monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
            validate: true,
            schemas: [
                {
                    uri: "schemas.json",
                    fileMatch: [
                        "*"
                    ],
                    schema: schemaValidation
                }
            ]
        });
    }, [
        monaco
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e964c7ac951d5673$export$f95cfa31b5a0bc91), {
        height: "100%",
        language: "json",
        modified: diffValue,
        original: editValue,
        onMount: onMount,
        options: {
            renderSideBySide: renderSideBySide
        }
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

function $e20a0aa6fe0c173b$export$2e2bcd8739ae039(props) {
    const { schemaValidation: schemaValidation, onChange: onChange, onValidate: onValidate, editValue: editValue, autoFoldBrackets: autoFoldBrackets, severity: // Schema will be tested against both severity 4: warning, 8: error
    severity = [
        4,
        8
    ] } = props;
    const editorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const monaco = (0, $e964c7ac951d5673$export$7c29dcfb1e21cfdd)();
    (0, $acw62.useEffect)(()=>{
        if (monaco) monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
            validate: true,
            schemas: [
                {
                    uri: "schemas.json",
                    fileMatch: [
                        "*"
                    ],
                    schema: schemaValidation
                }
            ]
        });
    }, [
        monaco,
        editorRef.current,
        schemaValidation
    ]);
    function handleEditorDidMount(editor) {
        if (autoFoldBrackets) editor.getAction("editor.foldLevel2").run();
        editorRef.current = editor;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e964c7ac951d5673$export$2e2bcd8739ae039), {
        height: "100%",
        language: "json",
        value: editValue,
        onChange: onChange,
        onMount: (editor)=>handleEditorDidMount(editor),
        onValidate: (values)=>{
            onValidate(values.filter((v)=>severity.includes(v.severity)));
        },
        options: {
            foldingStrategy: "indentation"
        }
    });
}



function $b66f688e095ad2ff$export$2e2bcd8739ae039(props) {
    const { diffMode: diffMode, diffValue: diffValue, editValue: editValue, onChange: onChange, onValidate: onValidate, schemaValidation: schemaValidation, autoFoldBrackets: autoFoldBrackets, renderSideBySide: renderSideBySide } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "krg-json-editor-shell",
        children: diffMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f1103ba73659fa46$export$2e2bcd8739ae039), {
            diffValue: diffValue,
            editValue: editValue,
            onChange: onChange,
            onValidate: onValidate,
            schemaValidation: schemaValidation,
            renderSideBySide: renderSideBySide
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e20a0aa6fe0c173b$export$2e2bcd8739ae039), {
            editValue: editValue,
            onChange: onChange,
            onValidate: onValidate,
            schemaValidation: schemaValidation,
            autoFoldBrackets: autoFoldBrackets
        })
    });
}





// TODO: Clean up devices list once we migrate to the new schema. At the moment, v3 only supports `mobile` and `desktop`
const $4c0789ca822a7305$export$710d38705d3511ed = (type)=>{
    const devices = [
        "&mobile",
        "&desktop",
        "&windows",
        "&mac",
        "&ios",
        "&android",
        "&safari",
        "&chrome",
        "&firefox",
        "&ie",
        "mobile",
        "desktop"
    ];
    const schema = {};
    devices.forEach((key)=>{
        schema[key] = {
            type: type
        };
    });
    return schema;
};
const $4c0789ca822a7305$export$cee6104b1ed093ab = (type, defaultValue, options)=>{
    const schema = {
        type: [
            ...typeof type === "string" ? [
                type
            ] : type,
            "object"
        ],
        default: type === "boolean" ? true : defaultValue,
        properties: $4c0789ca822a7305$export$710d38705d3511ed([
            type
        ]),
        ...options && options
    };
    if (type !== "boolean" && !defaultValue) delete schema.default;
    return schema;
};
const $4c0789ca822a7305$export$df4b2e5da68f8066 = (itemType, oneOf, options)=>{
    if (oneOf?.length) return {
        type: [
            "array",
            "object"
        ],
        items: {
            oneOf: oneOf
        }
    };
    return {
        type: [
            "array",
            "object",
            itemType
        ],
        items: {
            type: itemType,
            ...options
        },
        properties: $4c0789ca822a7305$export$710d38705d3511ed([
            "array"
        ])
    };
};
const $4c0789ca822a7305$export$86a468a7b1ac6c06 = (domain)=>`^(https?:\\/\\/)?(www\\.)?${domain.toLowerCase()}(\\/[\\w-.~%]*)*(\\?[\\w-.~%&=]*)?(#[\\w-.~%]*)?(\\/[\\w-.~%]*\\*)?\\/?$|^(\\/[\\w-.~%]+)*(\\/[\\w-.~%]*\\*)?(\\?[\\w-.~%&=]*)?(#[\\w-.~%]*)?$`;



const $5c7c2470ccc60b08$export$df807a8215902104 = {
    type: "object",
    properties: {
        "starts-paused": (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true),
        position: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", undefined),
        threshold: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 0.3),
        static: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true),
        sidebar: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        floatingonly: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        closeable: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true),
        hideplayeronclose: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        showcompanionad: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        noFloatOnDesktop: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        noFloatOnMobile: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        noFloatIfAbove: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        noFloatIfBelow: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
        mobile: {
            type: "object",
            properties: {
                position: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "top"),
                height: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 175),
                sidebar: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true),
                companionad: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true),
                bottom: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                size: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
                availablesizes: {
                    type: "object",
                    properties: {
                        x: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        s: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        m: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        l: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        xl: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number")
                    }
                }
            }
        },
        desktop: {
            type: "object",
            properties: {
                position: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "bottom-right"),
                sidebar: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                height: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                companionad: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                bottom: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 30),
                size: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "m"),
                availablesizes: {
                    type: "object",
                    properties: {
                        x: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 169),
                        s: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 183),
                        m: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 197),
                        l: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 211),
                        xl: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 225)
                    }
                }
            }
        }
    },
    additionalProperties: {
        type: [
            "number",
            "string",
            "boolean",
            "array",
            "object",
            "null"
        ],
        description: "no type declaration on this property, you are adding a new one"
    }
};




const $78d82f6155aa340c$var$IBucket = {
    type: "object",
    properties: {
        max: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
        increment: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 0.05)
    }
};
const $78d82f6155aa340c$export$bb38ab300c4906f7 = {
    type: "object",
    properties: {
        buckets: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
            $78d82f6155aa340c$var$IBucket
        ])
    }
};



const $69a0260b61ee371f$var$INode = {
    type: "object",
    properties: {
        asi: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        hp: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 1),
        sid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
    }
};
const $69a0260b61ee371f$export$16a3a5429b638f83 = {
    type: "object",
    properties: {
        config: {
            type: "object",
            properties: {
                complete: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 1),
                ver: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
                nodes: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                    $69a0260b61ee371f$var$INode
                ])
            }
        }
    }
};


const $e815ed4d2cddc947$export$3aaed4564292677d = {
    type: "object",
    properties: {
        schain: (0, $69a0260b61ee371f$export$16a3a5429b638f83),
        priceGranularity: (0, $78d82f6155aa340c$export$bb38ab300c4906f7)
    }
};
const $e815ed4d2cddc947$export$7d080943536b0472 = {
    type: "object",
    properties: {
        methods: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        args: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
            {
                type: [
                    "object",
                    "boolean"
                ],
                additionalProperties: {
                    type: [
                        "number",
                        "string",
                        "boolean",
                        "array",
                        "object",
                        "null"
                    ],
                    description: "no type declaration on this property, you are adding a new one"
                }
            }
        ])
    }
};




const $2334d437a65aa03b$export$4705ccef1d6e47d1 = {
    type: "object",
    properties: {
        name: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "", {
            enum: [
                "id5Id",
                "33acrossId",
                "sharedId",
                "pbjs-unifiedid",
                "pbjs_li_nonid"
            ]
        }),
        type: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "html5"),
        expires: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 90),
        refreshInSeconds: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 28800)
    }
};


const $fae0d015f886b590$export$d0ea890dbc47093d = {
    type: "object",
    properties: {
        name: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "", {
            enum: [
                "33acrossId"
            ]
        }),
        params: {
            type: "object",
            properties: {
                pid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "0010b00002EFnxPAAT")
            },
            required: [
                "pid"
            ]
        },
        storage: (0, $2334d437a65aa03b$export$4705ccef1d6e47d1)
    }
};




const $978ae710e3ca106f$export$4be55556ae74ad44 = {
    type: "object",
    properties: {
        name: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "", {
            enum: [
                "id5Id"
            ]
        }),
        params: {
            type: "object",
            properties: {
                partner: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 562)
            },
            required: [
                "partner"
            ],
            storage: (0, $2334d437a65aa03b$export$4705ccef1d6e47d1)
        }
    }
};




const $c562b630c74d04df$export$a93a0dc346583ac8 = {
    type: "object",
    properties: {
        name: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "", {
            enum: [
                "sharedId"
            ]
        }),
        storage: (0, $2334d437a65aa03b$export$4705ccef1d6e47d1)
    }
};




const $2a710407e6506a8f$export$37104e2bbcc90320 = {
    type: "object",
    properties: {
        name: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "", {
            enum: [
                "unifiedId"
            ]
        }),
        params: {
            type: "object",
            properties: {
                partner: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "vu6qg20")
            },
            required: [
                "partner"
            ],
            storage: (0, $2334d437a65aa03b$export$4705ccef1d6e47d1)
        }
    }
};




const $938208bb86469854$export$2329881008edeb6c = {
    type: "object",
    properties: {
        name: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "", {
            enum: [
                "liveIntentId"
            ]
        }),
        params: {
            type: "object",
            properties: {
                publisherId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "78242")
            },
            required: [
                "publisherId"
            ],
            storage: (0, $2334d437a65aa03b$export$4705ccef1d6e47d1)
        }
    }
};






const $e11d0402f52d73bf$export$f1d2bdb650b13313 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "adagio"
            ]
        },
        params: {
            type: "object",
            properties: {
                organizationId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                }),
                site: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                placement: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                adUnitElementId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            adUnitName: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                additionalProperties: false
            }),
            required: [
                "adUnitName",
                "organizationId",
                "site",
                "placement",
                "adUnitElementId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $c88179f79a8fedba$export$91cc44ae071b2125 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "appnexus"
            ]
        },
        params: {
            type: "object",
            properties: {
                placementId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                })
            },
            required: [
                "placementId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $d445afec19e792ce$export$75a829ddc2bd9f59 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "criteo"
            ]
        },
        params: {
            type: "object",
            properties: {
                networkId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                }),
                pubid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                zoneId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                })
            },
            required: [
                "networkId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $3e4eeb74e5354780$export$f903ba993ba790ba = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "ix"
            ]
        },
        params: {
            type: "object",
            properties: {
                siteId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            required: [
                "siteId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $51f9dce00ecb33cb$export$5d2d4c0327c93b76 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "medianet"
            ]
        },
        params: {
            type: "object",
            properties: {
                cid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                crid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                bidfloor: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                })
            },
            required: [
                "cid",
                "crid"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $7dbc7afcd0f531e8$export$a5ff5b3e7aa87575 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "pubmatic"
            ]
        },
        params: {
            type: "object",
            properties: {
                publisherId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                adSlot: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            required: [
                "publisherId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $1d5faa9ae87216fb$export$99af56f8d241aad2 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "rubicon"
            ]
        },
        params: {
            type: "object",
            properties: {
                accountId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                }),
                siteId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                }),
                zoneId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                })
            },
            required: [
                "accountId",
                "siteId",
                "zoneId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $42e677ab560fdb34$export$b88a8e27287202c1 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "sharethrough"
            ]
        },
        params: {
            type: "object",
            properties: {
                pkey: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            required: [
                "pkey"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $90309c6736683c0d$export$793022abfdd61a7 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "triplelift"
            ]
        },
        params: {
            type: "object",
            properties: {
                inventoryCode: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                floor: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                })
            },
            required: [
                "inventoryCode"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $c779915015a5a984$export$a5186d8aded7c377 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "kargo"
            ]
        },
        params: {
            type: "object",
            properties: {
                placementId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            required: [
                "placementId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};


const $717bee25a3804008$var$IRollConfig = {
    type: "object",
    properties: {
        repositoryId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        prebidbids: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
            (0, $e11d0402f52d73bf$export$f1d2bdb650b13313),
            (0, $c779915015a5a984$export$a5186d8aded7c377),
            (0, $7dbc7afcd0f531e8$export$a5ff5b3e7aa87575),
            (0, $1d5faa9ae87216fb$export$99af56f8d241aad2),
            (0, $c88179f79a8fedba$export$91cc44ae071b2125),
            (0, $3e4eeb74e5354780$export$f903ba993ba790ba),
            (0, $90309c6736683c0d$export$793022abfdd61a7),
            (0, $d445afec19e792ce$export$75a829ddc2bd9f59),
            (0, $42e677ab560fdb34$export$b88a8e27287202c1),
            (0, $51f9dce00ecb33cb$export$5d2d4c0327c93b76)
        ]),
        prebiddfpad: {
            type: "object",
            properties: {
                cust_params: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string"),
                ui: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
            }
        },
        htlkey: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        longitude: {
            type: "object",
            description: "LongitudeAds configuration. Defining this overrides all other auction types (htl/prebid/tam)",
            properties: {
                unitId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "videotest")
            }
        },
        adtagurl: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
    },
    additionalProperties: {
        type: [
            "number",
            "string",
            "boolean",
            "array",
            "object",
            "null"
        ],
        description: "no type declaration on this property, you are adding a new one"
    }
};
var $717bee25a3804008$export$2e2bcd8739ae039 = $717bee25a3804008$var$IRollConfig;




const $cd0b238fbe0b1dbd$export$4215aa57422a231f = {
    type: "object",
    properties: {
        cust_params: {
            type: "object",
            properties: {
                kv_test: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
            }
        }
    }
};



const $a4f155bf44a61f18$export$19b8b9436eaad681 = {
    type: "object",
    properties: {
        provider: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)([
            "string"
        ], "", {
            enum: [
                "asteriobid"
            ]
        }),
        options: {
            type: "object",
            properties: {
                url: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
                bundleId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
            },
            required: [
                "url",
                "bundleId"
            ]
        }
    }
};




const $09d6618b6926eda2$export$6d382fc2bd2af1ff = {
    type: "object",
    properties: {
        gamChildNetworkCode: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        googleAdTagDefaults: (0, $cd0b238fbe0b1dbd$export$4215aa57422a231f)
    },
    additionalProperties: false
};




const $c208906e310de915$export$50e7980be3dedd30 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "1accord"
            ]
        },
        params: {
            type: "object",
            properties: {
                tagId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            required: [
                "tagId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};




const $eed74ff6837c33a8$export$8d0c5a019106f285 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "amx"
            ]
        },
        params: {
            type: "object",
            properties: {
                tagId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                adUnitId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            required: [
                "tagId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};





const $f9eda1c3014b4932$export$c3e58b7ce073b8a7 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "gumgum"
            ]
        },
        params: {
            type: "object",
            properties: {
                zone: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                pubId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                })
            },
            required: [
                "zone",
                "pubId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};









const $99c1f44cad169e38$export$7f29fb38fa8bf604 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "smartadserver"
            ]
        },
        params: {
            type: "object",
            properties: {
                networkId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                }),
                siteId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                }),
                pageId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                }),
                formatId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", null, {
                    additionalProperties: false
                })
            },
            required: [
                "networkId",
                "siteId",
                "pageId",
                "formatId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $1d0a52798fdef287$export$4d254f37f85ed7bd = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "sovrn"
            ]
        },
        params: {
            type: "object",
            properties: {
                tagid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                video: {
                    type: "object",
                    properties: {
                        api: {
                            type: "array",
                            items: {
                                type: "number"
                            }
                        }
                    },
                    required: [
                        "api"
                    ]
                }
            },
            required: [
                "tagid"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $47517f2f0b8869ce$export$d0ae8c6b47b7dec2 = {
    type: "object",
    properties: {
        bidder: {
            type: "string",
            enum: [
                "ttd"
            ]
        },
        params: {
            type: "object",
            properties: {
                supplySourceId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                publisherId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                }),
                placementId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    additionalProperties: false
                })
            },
            required: [
                "supplySourceId",
                "publisherId"
            ]
        }
    },
    additionalProperties: false,
    required: [
        "bidder",
        "params"
    ]
};



const $a4369e339a8738c1$export$735c2d00f8791d62 = [
    (0, $e11d0402f52d73bf$export$f1d2bdb650b13313),
    (0, $eed74ff6837c33a8$export$8d0c5a019106f285),
    (0, $c88179f79a8fedba$export$91cc44ae071b2125),
    (0, $d445afec19e792ce$export$75a829ddc2bd9f59),
    (0, $f9eda1c3014b4932$export$c3e58b7ce073b8a7),
    (0, $3e4eeb74e5354780$export$f903ba993ba790ba),
    (0, $c779915015a5a984$export$a5186d8aded7c377),
    (0, $51f9dce00ecb33cb$export$5d2d4c0327c93b76),
    (0, $c208906e310de915$export$50e7980be3dedd30),
    (0, $7dbc7afcd0f531e8$export$a5ff5b3e7aa87575),
    (0, $1d5faa9ae87216fb$export$99af56f8d241aad2),
    (0, $42e677ab560fdb34$export$b88a8e27287202c1),
    (0, $99c1f44cad169e38$export$7f29fb38fa8bf604),
    (0, $1d0a52798fdef287$export$4d254f37f85ed7bd),
    (0, $47517f2f0b8869ce$export$d0ae8c6b47b7dec2),
    (0, $90309c6736683c0d$export$793022abfdd61a7)
];


const $d3d746768398b5ba$export$3edc0a6d652685 = {
    type: "object",
    properties: {
        nonUniversalServerBidders: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
            {
                type: "object",
                properties: {
                    adapter: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
                    gvlid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                    prebidParams: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, (0, $a4369e339a8738c1$export$735c2d00f8791d62))
                }
            }
        ]),
        nonUniversalBidders: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, (0, $a4369e339a8738c1$export$735c2d00f8791d62)),
        enabledBidders: {
            type: "object",
            properties: {
                "1accord": (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                adagio: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                amx: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                appnexus: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                criteo: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                gumgum: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                ix: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                medianet: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                openx: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                pubmatic: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                rubicon: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                sharethrough: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                smartadserver: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                sovrn: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                triplelift: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                ttd: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                unruly: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean")
            },
            required: [
                "1accord",
                "adagio",
                "amx",
                "appnexus",
                "criteo",
                "gumgum",
                "ix",
                "medianet",
                "openx",
                "pubmatic",
                "rubicon",
                "sharethrough",
                "smartadserver",
                "sovrn",
                "triplelift",
                "ttd",
                "unruly"
            ]
        },
        schainOverrides: {
            type: "object",
            properties: {
                publisher: {
                    type: "object",
                    properties: {
                        bidders: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string", [
                            {
                                type: "string",
                                enum: [
                                    "1accord",
                                    "adagio",
                                    "amx",
                                    "appnexus",
                                    "criteo",
                                    "gumgum",
                                    "ix",
                                    "kargo",
                                    "medianet",
                                    "openx",
                                    "pubmatic",
                                    "rubicon",
                                    "sharethrough",
                                    "smartadserver",
                                    "sovrn",
                                    "triplelift",
                                    "unruly"
                                ]
                            }
                        ]),
                        sid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
                        asi: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
                    }
                },
                fabrik: {
                    type: "object",
                    properties: {
                        sid: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
                    }
                }
            }
        }
    },
    additionalProperties: false
};



const $639bf250d3d65cf0$export$e47c71ffd6385262 = {
    type: "object",
    properties: {
        type: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "outstream"),
        width: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
        height: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
        waitForScroll: {
            description: "Waits for window scroll event before initializing the player. Set as boolean to enable for all devices, or set as object to enable for specific devices [desktop, mobile]. Defaults to false.",
            anyOf: [
                {
                    type: "object",
                    properties: {
                        desktop: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                        mobile: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean")
                    }
                },
                {
                    type: "boolean"
                }
            ]
        },
        placement: {
            type: "object",
            properties: {
                desktop: {
                    type: "object",
                    properties: {
                        bottom: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        left: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        right: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        top: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number")
                    }
                },
                mobile: {
                    type: "object",
                    properties: {
                        bottom: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        left: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        right: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                        top: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number")
                    }
                }
            }
        }
    },
    additionalProperties: false
};



const $de028aec7b3bad15$export$984887d41ee50f19 = {
    type: "object",
    properties: {
        type: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "accompanyingContent"),
        playerSelector: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        playerId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        width: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        height: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        aspectRatio: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        mediaIds: {
            oneOf: [
                (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
                {
                    type: "array",
                    items: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
                }
            ]
        },
        playlistId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        mute: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true),
        volume: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 0.5, {
            minimum: 0,
            maximum: 1
        }),
        byRecommender: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", false),
        autoplay: {
            type: [
                "string",
                "boolean"
            ],
            oneOf: [
                {
                    type: "string",
                    enum: [
                        "viewable"
                    ]
                },
                {
                    type: "boolean",
                    enum: [
                        true,
                        false
                    ]
                }
            ],
            description: "Controls autoplay behavior. Can be true, false, or 'viewable' for viewability-based autoplay.",
            default: false
        },
        autopause: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true),
        waitForScroll: {
            description: "Waits for window scroll event before initializing the player. Set as boolean to enable for all devices, or set as object to enable for specific devices [desktop, mobile]. Defaults to false.",
            anyOf: [
                {
                    type: "object",
                    properties: {
                        desktop: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
                        mobile: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean")
                    }
                },
                {
                    type: "boolean"
                }
            ]
        }
    },
    additionalProperties: false
};



const $b87abe66ef69fc66$export$56c097bda34e8df6 = {
    type: "object",
    properties: {
        sellerId: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
    }
};



const $11a04b594f50abd1$var$PlacementPositions = {
    type: "object",
    properties: {
        top: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
        right: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
        bottom: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
        left: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number")
    }
};
const $11a04b594f50abd1$export$3b0872bbd7e675a2 = {
    type: "object",
    properties: {
        navbarSelector: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
            pattern: "^(\\.|#).+",
            description: "Query selector for the navbar element. Used to dynamically change the position of the player when it hits this navbar element."
        }),
        customDomainStyles: {
            type: "object",
            description: "Used to override default fvp player styles. Available properties [articleElSelector, backgroundColor, backgroundColorRefElSelector, positionOverrides, cssOverrides]",
            properties: {
                articleElSelector: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    description: "Query selector id for the article element. Used to dynamically change bg color of player when it hits this article element."
                }),
                backgroundColor: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    description: "Background color for the player. Used to override the default styles."
                }),
                backgroundColorRefElSelector: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    description: "Query selector for the background color reference element. Used to override the default styles based on the background color of the reference element."
                }),
                positionOverrides: {
                    type: "object",
                    description: "Used to override the default position of the player. Available properties [desktop, mobile]",
                    properties: {
                        desktop: {
                            type: "object",
                            description: "Available position overrides [top, bottom, left, right]",
                            properties: {
                                top: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                                bottom: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                                left: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                                right: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number")
                            }
                        },
                        mobile: {
                            type: "object",
                            description: "Available position overrides [top, bottom]",
                            properties: {
                                top: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
                                bottom: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number")
                            }
                        }
                    }
                },
                cssOverrides: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                    description: "Used to override the default class names."
                }),
                playerPlacementPadding: {
                    type: "object",
                    description: "Used to add padding to the player based on its placement. Available properties [desktop, mobile]",
                    properties: {
                        desktop: {
                            type: "object",
                            description: "Add padding specific to desktop player placements. Available properties [topLeft, topRight, bottomLeft, bottomRight]",
                            properties: {
                                topLeft: $11a04b594f50abd1$var$PlacementPositions,
                                topRight: $11a04b594f50abd1$var$PlacementPositions,
                                bottomLeft: $11a04b594f50abd1$var$PlacementPositions,
                                bottomRight: $11a04b594f50abd1$var$PlacementPositions
                            }
                        },
                        mobile: {
                            type: "object",
                            description: "Add padding specific to mobile player placements. Available properties [top, bottom]",
                            properties: {
                                top: $11a04b594f50abd1$var$PlacementPositions,
                                bottom: $11a04b594f50abd1$var$PlacementPositions
                            }
                        }
                    }
                }
            },
            additionalProperties: false
        },
        publisherName: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string")
    },
    additionalProperties: false
};


const $342cc1dc450464ed$var$IPrerollConfig = (0, $717bee25a3804008$export$2e2bcd8739ae039);
const $342cc1dc450464ed$var$IMidrollConfig = (0, $717bee25a3804008$export$2e2bcd8739ae039);
const $342cc1dc450464ed$var$IPosrollConfig = (0, $717bee25a3804008$export$2e2bcd8739ae039);
const $342cc1dc450464ed$var$IQuery = {
    type: "object",
    properties: {
        group: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        importted_from: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
        limit: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
        categories: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string")
    }
};
const $342cc1dc450464ed$export$a9256acc112e24be = (domain, withTopLevel, schemaVersion = "2.0")=>{
    const cleanDomain = (0, $6bca6f68346a010a$export$f2888183a34644d4)(domain);
    const escapedDomain = cleanDomain.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regexPattern = (0, $4c0789ca822a7305$export$86a468a7b1ac6c06)(escapedDomain);
    let playerConfig;
    // TODO: Update this function once we fully migrate to the new schema
    if (schemaVersion === "2.0") playerConfig = {
        type: "object",
        properties: {
            ads_source_init_timeout: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
            adsposition: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            adtagurl: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            adtagurlfallbacks: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            airplay: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            allowpip: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            aspectratio: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)([
                "string",
                "number"
            ]),
            autoplay: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            autoplaywhenvisible: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            broadcasting: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            bypagecontent: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            cdnhost: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            chromecast: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            companionad: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            contenturl: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            continuousplayback: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            currentstream: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            customnonlinear: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            description: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            disablepause: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            disableseeking: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            fitonheight: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            fitonwidth: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            floating: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            floatingoptions: (0, $5c7c2470ccc60b08$export$df807a8215902104),
            floatstyle: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "", {
                enum: [
                    "v2",
                    "v3-1",
                    "v3-2"
                ]
            }),
            fullscreenmandatory: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            google_ad_tag_defaults: (0, $cd0b238fbe0b1dbd$export$4215aa57422a231f),
            globalStyles: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            hasnext: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            hidebarafter: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 5000),
            hidebeforeadstarts: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            hidebrandinfo: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            hideoninactivity: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            imatagurl: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            initialseek: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            inlinevastxml: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            irisconfig: $342cc1dc450464ed$var$IQuery,
            irisplaylist: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            linearadplayer: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            loop: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            loopall: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            minadintervals: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 5),
            muted: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            next_active: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            nextadtagurls: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            nextwidget: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            noengagenext: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)([
                "number",
                "string"
            ], 10),
            nofullscreen: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            outstream: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            pauseonclick: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            playfullscreenonmobile: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            playlist: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string"),
            playlisttoken: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            playonclick: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            playwhenvisible: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            popup: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            poster: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            preferredextensions: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string"),
            preload: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            preload_ads: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            preroll: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            presetkey: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            preventinteraction: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            query: $342cc1dc450464ed$var$IQuery,
            recentvideoshourstimeout: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
            reloadonplay: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            rerecordable: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            rotated: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            showcaption: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            shownext: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 30),
            showplayercontentafter: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
            skipinitial: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            skipseconds: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 5),
            source: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            sources: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string"),
            state: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            stayengaged: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            streams: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string"),
            submittable: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            targeting_urls: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string", undefined, {
                pattern: regexPattern
            }),
            theme: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "kargo"),
            thumbnailurl: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            title: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            topmessage: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            totalduration: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number"),
            tracktextvisible: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            type: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            unmuteonclick: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            uploaddate: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            video: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string"),
            visibilityfraction: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 0.5),
            vmapads: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            volume: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("number", 1.0),
            vpaidhidecontrolbar: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            enable_bid_cache: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean"),
            ad_player_size_override: {
                type: "object",
                properties: {
                    small: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("number"),
                    medium: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("number"),
                    large: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("number")
                }
            },
            sticky: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", true, {
                description: "sticky is deprecated, use `floating` instead",
                deprecated: true
            }),
            prebidconfig: (0, $e815ed4d2cddc947$export$3aaed4564292677d),
            prebiduserids: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                (0, $fae0d015f886b590$export$d0ea890dbc47093d),
                (0, $978ae710e3ca106f$export$4be55556ae74ad44),
                (0, $2a710407e6506a8f$export$37104e2bbcc90320),
                (0, $c562b630c74d04df$export$a93a0dc346583ac8),
                (0, $938208bb86469854$export$2329881008edeb6c)
            ]),
            prebid_analytics: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                (0, $a4f155bf44a61f18$export$19b8b9436eaad681)
            ]),
            prebidglobals: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                (0, $e815ed4d2cddc947$export$7d080943536b0472)
            ]),
            prerollconfig: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                $342cc1dc450464ed$var$IPrerollConfig
            ]),
            midrollconfig: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                $342cc1dc450464ed$var$IMidrollConfig
            ]),
            posrollconfig: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                $342cc1dc450464ed$var$IPosrollConfig
            ])
        },
        additionalProperties: {
            type: [
                "number",
                "string",
                "boolean",
                "array",
                "object",
                "null"
            ],
            description: "no type declaration on this property, you are adding a new one"
        }
    };
    else playerConfig = {
        type: "object",
        properties: {
            original_site_id: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", null, {
                description: "Used for migrating publishers to v3 if we created a new domain for them in the CMS. IE: `www.greenmatter.com` -> `greenmatters.com`"
            }),
            gam: (0, $09d6618b6926eda2$export$6d382fc2bd2af1ff),
            prebid: (0, $d3d746768398b5ba$export$3edc0a6d652685),
            video: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)(undefined, [
                (0, $639bf250d3d65cf0$export$e47c71ffd6385262),
                (0, $de028aec7b3bad15$export$984887d41ee50f19)
            ]),
            amazon: {
                type: "object",
                properties: {
                    enabled: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("boolean", false)
                }
            },
            longitude: (0, $b87abe66ef69fc66$export$56c097bda34e8df6),
            publisher: (0, $11a04b594f50abd1$export$3b0872bbd7e675a2),
            schemaVersion: (0, $4c0789ca822a7305$export$cee6104b1ed093ab)("string", "3.0", {
                description: "The schema version of the domain config. Defaults to 3.0"
            }),
            // TODO: Investigate if `targeting_urls` is needed in the schema
            targeting_urls: (0, $4c0789ca822a7305$export$df4b2e5da68f8066)("string", undefined, {
                pattern: regexPattern
            })
        },
        additionalProperties: false
    };
    const domainConfig = {
        type: "object",
        properties: {
            config: playerConfig
        },
        additionalProperties: {
            type: [
                "number",
                "string",
                "boolean",
                "array",
                "object",
                "null"
            ],
            description: "no type declaration on this property, you are adding a new one"
        }
    };
    if (withTopLevel) return domainConfig;
    return playerConfig;
};






function $602ce273b30edb39$export$2e2bcd8739ae039() {
    const { setShowEditButtons: setShowEditButtons, editConfig: editConfig, setEditConfig: setEditConfig, setInitialData: setInitialData, setHasValidationErrors: setHasValidationErrors, addPathToBreadCrumb: addPathToBreadCrumb, conflictedData: conflictedData, setConflictedData: setConflictedData, isLoading: isLoading, advancedEditMode: advancedEditMode, setAdvancedEditMode: setAdvancedEditMode, editDomainConfig: editDomainConfig, setEditDomainConfig: setEditDomainConfig, setHttpMethod: setHttpMethod, setSelectedDomainToken: setSelectedDomainToken, forceSaveSchema: forceSaveSchema, setForceSaveSchema: setForceSaveSchema } = (0, $04813b9f064173e2$export$e3a1c6815b077e4a)();
    const { domainToken: domainToken, playerToken: playerToken, revision: revision, slug: slug } = (0, $kfZjc.useParams)();
    const tabs = [
        {
            label: "JSON Editor"
        }
    ];
    const [selectedTab, setSelectedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [playerSchema, setPlayerSchema] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [sideByside, setSideBySide] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selectedDomain, setSelectedDomain] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    // TODO: Remove prettier-ignore once we copy the `.prettierrc` file from `fvp-ad-manager`
    // prettier-ignore
    const [selectedSchemaVersion, setSelectedSchemaVersion] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([
        "3.0"
    ]);
    const { publisherSlug: publisherSlug, switchToPublisher: switchToPublisher } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(true);
    const { data: domain } = (0, $a9fd19d627d10772$export$d9dcc325f8df9b84)(domainToken || "");
    const { getRevisions: getRevisions } = (0, $b5dd5d6a03e10096$export$a13e2cd9aac3d29e)(playerToken, domainToken || "");
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowEditButtons(true);
        switchToPublisher(slug);
        if (domain) {
            const config = domain?.configs?.filter((c)=>c?.token === playerToken).shift();
            if (revision) getRevisions(playerToken, {
                onSuccess: (res)=>{
                    const domainConfig = res.filter((c)=>c.revision === Number(revision)).shift();
                    setEditConfig(domainConfig.config);
                    setEditDomainConfig(domainConfig);
                }
            });
            else {
                setEditConfig(config?.config || {});
                setInitialData(config || {});
                setEditDomainConfig({
                    ...config,
                    notes: ""
                });
            }
            addPathToBreadCrumb([
                {
                    path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                        slug: slug || publisherSlug,
                        domainToken: domainToken
                    }),
                    pathName: domain?.domain
                },
                {
                    path: playerToken === "add-config" ? (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                        slug: slug || publisherSlug,
                        domainToken: domainToken
                    }) : (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CONFIG, {
                        slug: slug || publisherSlug,
                        domainToken: domainToken,
                        playerToken: playerToken
                    }),
                    pathName: config?.key
                },
                {
                    path: window.location.pathname,
                    pathName: revision || (playerToken === "add-config" ? "new config" : "edit")
                }
            ]);
            setSelectedDomain(domain?.domain);
        }
        return ()=>setShowEditButtons(false);
    }, [
        domain,
        revision,
        slug
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPlayerSchema((0, $342cc1dc450464ed$export$a9256acc112e24be)(selectedDomain, advancedEditMode, selectedSchemaVersion[0]));
    }, [
        advancedEditMode,
        selectedDomain,
        selectedSchemaVersion
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (playerToken === "add-config") {
            // Sets default schema version when new config is being created
            setEditConfig({
                schemaVersion: selectedSchemaVersion[0]
            });
            setHttpMethod("create");
            setSelectedDomainToken(domainToken || "");
        }
    }, [
        playerToken
    ]);
    const handleOnChanges = (value)=>{
        if (conflictedData) setConflictedData(JSON.parse(value));
        else if (advancedEditMode) {
            setEditDomainConfig(JSON.parse(value));
            setEditConfig(JSON.parse(value).config);
        } else {
            setEditConfig(JSON.parse(value));
            setEditDomainConfig({
                ...editDomainConfig,
                config: JSON.parse(value)
            });
        }
    };
    const configJson = editConfig ? JSON.stringify(editConfig, null, 2) : "";
    const domainConfigJson = editDomainConfig ? JSON.stringify(editDomainConfig, null, 2) : "";
    const editJsonValue = advancedEditMode ? domainConfigJson : configJson;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: "90%",
            paddingTop: 10
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bf093269ed94b0d$export$2e2bcd8739ae039), {
                buttonsConfig: [],
                tabsConfig: {
                    onChange: (e, value)=>setSelectedTab(value),
                    selectedTab: selectedTab,
                    tabs: tabs
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flexFlow: "row wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "30%",
                            marginLeft: 3
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            text: editDomainConfig.key,
                            name: "key",
                            isFullWidth: true,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                            label: "Player name",
                            onTextChange: (key)=>{
                                setEditDomainConfig({
                                    ...editDomainConfig,
                                    key: key
                                });
                            },
                            debounceTime: 0,
                            onDebounceEnd: (key)=>{
                                setEditDomainConfig({
                                    ...editDomainConfig,
                                    key: key
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "30%",
                            marginLeft: 3
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            text: editDomainConfig.type,
                            name: "type",
                            isFullWidth: true,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                            label: "Config Type",
                            onTextChange: (type)=>{
                                setEditDomainConfig({
                                    ...editDomainConfig,
                                    type: type
                                });
                            },
                            debounceTime: 0,
                            onDebounceEnd: (type)=>{
                                setEditDomainConfig({
                                    ...editDomainConfig,
                                    type: type
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "30%",
                            marginLeft: 3
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ad2b0c1d97366d24$exports))), {
                            buttons: [
                                {
                                    label: "v3 Schema",
                                    value: "3.0"
                                },
                                {
                                    label: "v2 Schema",
                                    value: "2.0"
                                }
                            ],
                            size: (0, (/*@__PURE__*/$parcel$interopDefault($ad2b0c1d97366d24$exports))).SIZE_ENUM.small,
                            onChange: (newSelectedSchemaVersion)=>{
                                setSelectedSchemaVersion(newSelectedSchemaVersion);
                            },
                            isSingleSelection: true,
                            selectedButtons: selectedSchemaVersion
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            width: "90%",
                            marginLeft: 3
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            text: editDomainConfig.notes,
                            name: "notes",
                            isFullWidth: true,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                            label: "Notes",
                            onTextChange: (text)=>{
                                setEditDomainConfig({
                                    ...editDomainConfig,
                                    notes: text
                                });
                            },
                            debounceTime: 0,
                            maxCharacter: 250,
                            onDebounceEnd: (text)=>{
                                setEditDomainConfig({
                                    ...editDomainConfig,
                                    notes: text
                                });
                            }
                        })
                    })
                ]
            }),
            conflictedData ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                isChecked: sideByside,
                onToggle: setSideBySide,
                label: "Side by side view",
                theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flexFlow: "row",
                    width: "50%",
                    marginLeft: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                        isChecked: advancedEditMode,
                        onToggle: (v)=>setAdvancedEditMode(v),
                        label: "Advanced Edit Mode",
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                        isChecked: forceSaveSchema,
                        onToggle: (v)=>setForceSaveSchema(v),
                        label: "Force Save Schema",
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2
                    })
                ]
            }),
            domain && selectedDomain && !isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b66f688e095ad2ff$export$2e2bcd8739ae039), {
                editValue: editJsonValue,
                onChange: handleOnChanges,
                onValidate: (values)=>{
                    setHasValidationErrors(values.length > 0);
                },
                schemaValidation: playerSchema,
                diffMode: !!conflictedData,
                diffValue: conflictedData && JSON.stringify(conflictedData, null, 2),
                renderSideBySide: sideByside
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "krg-loading-shell",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");


var $iDAOR = parcelRequire("iDAOR");












let $42cdd4db883087ee$var$previousPublisher = "";
function $42cdd4db883087ee$export$2e2bcd8739ae039() {
    const { setShowEditButtons: setShowEditButtons, editConfig: editConfig, setEditConfig: setEditConfig, setInitialData: setInitialData, setHasValidationErrors: setHasValidationErrors, slug: slug, setHttpMethod: setHttpMethod, addPathToBreadCrumb: addPathToBreadCrumb, selectedDomainToken: selectedDomainToken, setSelectedDomainToken: setSelectedDomainToken, editDomainConfig: editDomainConfig, setEditDomainConfig: setEditDomainConfig } = (0, $04813b9f064173e2$export$e3a1c6815b077e4a)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(true);
    const { publishers: publishers } = (0, $4f86ca3d56f18424$export$a036ba61edb46e4b)({});
    const { domainToken: domainToken, playerToken: playerToken } = (0, $kfZjc.useParams)();
    const [playerSchema, setPlayerSchema] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const { snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [selectedPublisher, setSelectedPublisher] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(publisherSlug || slug);
    const [isEdit, setIsEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const query = {
        slug: selectedPublisher
    };
    const { domains: domains } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        enabled: !!selectedPublisher,
        query: query
    });
    const [selectedTab, setSelectedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const selectedDomainList = domains?.map((d)=>({
            name: d.domain,
            token: d.token
        }));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowEditButtons(true);
        return ()=>setShowEditButtons(false);
    }, [
        setShowEditButtons
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (domains && !isEdit) {
            const domain = domains?.find((d)=>d.token === domainToken);
            const config = domain?.configs.find((c)=>c.token === playerToken);
            setHttpMethod("create");
            setSelectedDomainToken(domain?.token || "");
            setEditConfig(config?.config || {});
            setInitialData(config || {});
            setEditDomainConfig({
                ...config,
                notes: ""
            });
            addPathToBreadCrumb([
                {
                    path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                        domainToken: domainToken
                    }),
                    pathName: domain?.domain || ""
                },
                {
                    path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CONFIG, {
                        domainToken: domainToken,
                        playerToken: playerToken
                    }),
                    pathName: config?.key || ""
                },
                {
                    path: window.location.pathname,
                    pathName: "clone"
                }
            ]);
            setPlayerSchema((0, $342cc1dc450464ed$export$a9256acc112e24be)(domain?.domain || ""));
            $42cdd4db883087ee$var$previousPublisher = selectedPublisher;
        } else {
            snackbarWarning(`${selectedPublisher} has no domain yet, please create a domain there first!`);
            setTimeout(()=>{
                setSelectedPublisher($42cdd4db883087ee$var$previousPublisher);
            }, 3000);
        }
    }, [
        domains,
        isEdit,
        editDomainConfig.key
    ]);
    const handleOnChanges = (value)=>setEditConfig(JSON.parse(value));
    const handleNameChange = (name)=>{
        setIsEditing(true);
        setEditDomainConfig({
            ...editDomainConfig,
            key: name
        });
    };
    const handleDomainChange = (newDomainToken)=>setSelectedDomainToken(newDomainToken);
    const handlePublisherChange = (newPublisher)=>{
        setIsEditing(true);
        setSelectedPublisher(newPublisher);
    };
    const renderInputs = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                marginLeft: 3
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexFlow: "column",
                        width: "30%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                        text: editDomainConfig.key,
                        name: "name",
                        isFullWidth: true,
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                        label: "Player Name",
                        onTextChange: handleNameChange,
                        debounceTime: 0,
                        onDebounceEnd: handleNameChange
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexFlow: "column",
                        width: "30%",
                        marginLeft: "25px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                        name: "publishers",
                        value: selectedPublisher || "empty",
                        label: "Publisher destination:",
                        items: [
                            {
                                text: "Publishers",
                                value: "empty",
                                isHidden: publishers && publishers.length > 0
                            },
                            /* eslint-disable-next-line no-unsafe-optional-chaining */ ...publishers?.map((p)=>({
                                    text: p.name,
                                    value: p.slug,
                                    isHidden: false
                                }))
                        ],
                        onChange: handlePublisherChange
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexFlow: "column",
                        width: "30%",
                        marginLeft: "25px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
                        name: "domains",
                        className: "select-no-padding",
                        value: selectedDomainToken || "empty",
                        label: "Domain destination:",
                        items: [
                            {
                                text: "Domains",
                                value: "empty",
                                isHidden: !!selectedDomainToken
                            },
                            ...selectedDomainList.map((d)=>({
                                    text: d.name,
                                    value: d.token,
                                    isHidden: false
                                }))
                        ],
                        onChange: handleDomainChange
                    })
                })
            ]
        });
    const renderEditor = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                flexFlow: "column",
                height: "90%"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b66f688e095ad2ff$export$2e2bcd8739ae039), {
                editValue: editConfig ? JSON.stringify(editConfig, null, 2) : "",
                onChange: handleOnChanges,
                onValidate: (values)=>setHasValidationErrors(values.length > 0),
                schemaValidation: playerSchema
            })
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: "90%",
            paddingTop: 10
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bf093269ed94b0d$export$2e2bcd8739ae039), {
                buttonsConfig: [],
                tabsConfig: {
                    onChange: (_e, value)=>setSelectedTab(value),
                    selectedTab: selectedTab,
                    tabs: [
                        {
                            label: "Clone Editor"
                        }
                    ]
                }
            }),
            domains?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    renderInputs(),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    display: "flex",
                                    flexFlow: "column",
                                    width: "30%",
                                    marginLeft: 3
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                                    text: editDomainConfig.type,
                                    name: "type",
                                    isFullWidth: true,
                                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                                    label: "Config Type",
                                    onTextChange: (type)=>setEditDomainConfig({
                                            ...editDomainConfig,
                                            type: type
                                        }),
                                    debounceTime: 0,
                                    onDebounceEnd: (type)=>setEditDomainConfig({
                                            ...editDomainConfig,
                                            type: type
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    display: "flex",
                                    flexFlow: "column",
                                    width: "30%",
                                    marginLeft: 3
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                                    text: editDomainConfig.notes,
                                    name: "notes",
                                    isFullWidth: true,
                                    theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                                    label: "Notes",
                                    onTextChange: (notes)=>setEditDomainConfig({
                                            ...editDomainConfig,
                                            notes: notes
                                        }),
                                    debounceTime: 0,
                                    maxCharacter: 250,
                                    onDebounceEnd: (notes)=>setEditDomainConfig({
                                            ...editDomainConfig,
                                            notes: notes
                                        })
                                })
                            })
                        ]
                    }),
                    renderEditor()
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "krg-loading-shell",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");

var $iDAOR = parcelRequire("iDAOR");





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



function $76525783db335904$export$2e2bcd8739ae039({ isEnabled: isEnabled = true, value: value, onChange: onChange }) {
    const { publishers: publishers } = (0, $4f86ca3d56f18424$export$a036ba61edb46e4b)({});
    const sortedPublisher = publishers.map(({ name: name, slug: slug })=>({
            name: name,
            slug: slug
        }))?.sort((name, slug)=>{
        if (name.name > slug.name) return 1;
        if (name.name < slug.name) return -1;
        return 0;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddf0617b838f18a6$export$2e2bcd8739ae039), {
        label: "Select Publishers",
        isEnabled: isEnabled && sortedPublisher.length > 0,
        value: value,
        items: sortedPublisher.map((c)=>({
                text: c.name,
                value: c.slug
            })),
        isMultiple: true,
        multipleType: (0, $a720e39beaad5850$export$82ca86ed83c7174c).checkmark,
        onChange: onChange
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");

var $dgtCa = parcelRequire("dgtCa");
function $5448779ae698aab3$export$2e2bcd8739ae039({ isEnabled: isEnabled = true, discriptions: discriptions, onSave: onSave, onCancel: onCancel, actions: actions }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "h6",
                        component: "h1",
                        fontWeight: "bold",
                        sx: {
                            color: "#333",
                            marginBottom: "16px"
                        },
                        children: [
                            "Confirm Bulk ",
                            actions
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body1",
                        color: "textPrimary",
                        sx: {
                            marginBottom: "16px"
                        },
                        children: [
                            "You are about to perform a bulk ",
                            actions,
                            " on the following publishers:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "textSecondary",
                        sx: {
                            marginBottom: "24px"
                        },
                        children: discriptions
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "textSecondary",
                        sx: {
                            fontStyle: "italic"
                        },
                        children: [
                            "Please click ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "Confirm"
                            }),
                            " to proceed or",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "Cancel"
                            }),
                            " to abort the operation."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "flex-end",
                mt: 4,
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                        theme: (0, $dgtCa.THEME_ENUM).v2,
                        variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                        sx: {
                            fontSize: "14px",
                            padding: "8px 20px",
                            borderColor: "#b0bec5",
                            color: "#b0bec5",
                            "&:hover": {
                                borderColor: "#90a4ae",
                                color: "#90a4ae"
                            }
                        },
                        text: "Cancel",
                        onClick: onCancel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                        theme: (0, $dgtCa.THEME_ENUM).v2,
                        variant: (0, $dgtCa.VARIANT_ENUM).contained,
                        sx: {
                            fontSize: "14px",
                            padding: "8px 20px",
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#1565c0"
                            }
                        },
                        text: "Confirm",
                        onClick: onSave,
                        isEnabled: isEnabled
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $6lXkL = parcelRequire("6lXkL");
function $0899ee3baf1fc6c1$export$2e2bcd8739ae039({ title: title, publishers: publishers, domains: domains, totalChange: totalChange, actions: actions, onOk: onOk }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            bgcolor: "background.paper",
            boxShadow: 3,
            p: 5,
            m: 2,
            borderRadius: 2,
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                component: "h2",
                gutterBottom: true,
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body1",
                color: "textPrimary",
                sx: {
                    mt: 2
                },
                children: [
                    "Successfully ",
                    actions,
                    " the following publishers:"
                ]
            }),
            publishers?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                gutterBottom: true,
                color: "textSecondary",
                children: publishers?.join(" ")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body1",
                color: "textPrimary",
                sx: {
                    mt: 2
                },
                children: [
                    "Successfully ",
                    actions,
                    " the following domains:"
                ]
            }),
            domains?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                gutterBottom: true,
                color: "textSecondary",
                children: domains?.join(" ")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body1",
                color: "textPrimary",
                sx: {
                    mt: 2
                },
                children: "Total number of configuration change:"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                gutterBottom: true,
                color: "textSecondary",
                children: totalChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                variant: "contained",
                color: "primary",
                onClick: onOk,
                sx: {
                    mt: 2
                },
                children: "OK"
            })
        ]
    });
}







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
function $23760b2b95362ec5$export$2e2bcd8739ae039(actions) {
    const displayText = {
        Update: `
      {
        // to update an value:
        "outstream": false,
      
        // to update an object propertie value
        "floatingoptions": {
      
          // noFloatOnMobile will be update or added inside floatingoptions 
          // if floatingoptions is not present on the config, it will be added too.
          "noFloatOnMobile": false,
      
          // same will happen to mobile and height
          "mobile": {
            "height": 120
          }
        },
        "query": {
           // array it will push the values passed here 
          // to the existing array on the config
          "categories": [
            "style and fashion"
          ]
        }
      }`,
        Delete: `
    {
      // to delete an propertie just pass a true value to it:
      "outstream": true,

      // to delete the whole object, just passed the value of the object as true
      "prerollconfig": true,
      
      // to delete an object propertie just do the same thing
      "floatingoptions": {

        // noFloatOnMobile will be deleted inside floatingoptions 
        // if floatingoptions is not present it will be ignored.
        "noFloatOnMobile": true,

        // same will happen to mobile and height
        "mobile": {
          "height": true
        }
      },
      "query": {
        // array it will remove the values passed here 
        // on the existing array on the config
        "categories": [
          "style and fashion"
        ]
      }
    }`
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexFlow: "column",
            height: "90%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "h6",
                component: "h1",
                fontWeight: "bold",
                sx: {
                    color: "#333",
                    marginBottom: "16px",
                    marginLeft: "14px"
                },
                children: [
                    "Example Of ",
                    actions,
                    " Properties"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    color: "green",
                    marginLeft: "14px"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                        children: displayText[actions]
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3bYfT = parcelRequire("3bYfT");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $938b1427b9e9a19f$export$5269a5bce2c2f987(slot) {
    return (0, $4Cod0.default)("MuiAlertTitle", slot);
}
const $938b1427b9e9a19f$var$alertTitleClasses = (0, $beCSm.default)("MuiAlertTitle", [
    "root"
]);
var $938b1427b9e9a19f$export$2e2bcd8739ae039 = $938b1427b9e9a19f$var$alertTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $cbe9496169f0560d$var$_excluded = [
    "className"
];
const $cbe9496169f0560d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $938b1427b9e9a19f$export$5269a5bce2c2f987), classes);
};
const $cbe9496169f0560d$var$AlertTitleRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $cbe9496169f0560d$var$AlertTitle = /*#__PURE__*/ $acw62.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $cbe9496169f0560d$var$_excluded);
    const ownerState = props;
    const classes = $cbe9496169f0560d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cbe9496169f0560d$var$AlertTitleRoot, (0, $8nd05.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
$cbe9496169f0560d$var$AlertTitle.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $cbe9496169f0560d$export$2e2bcd8739ae039 = $cbe9496169f0560d$var$AlertTitle;


function $8be00a71a8f424c9$export$2e2bcd8739ae039({ message: message, severity: severity, title: title, hideButton: hideButton = true, extraMessages: extraMessages, onClose: onClose, buttonTitle: buttonTitle }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            width: "90%",
            marginBottom: "19px",
            marginLeft: "14px"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
            severity: severity,
            onClose: onClose,
            action: !hideButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                color: "inherit",
                size: "small",
                onClick: onClose,
                children: buttonTitle
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: message
                }),
                extraMessages?.length > 0 && extraMessages?.map((msg)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: msg
                    }, msg))
            ]
        })
    });
}



function $aa54eeacaf756c37$export$2e2bcd8739ae039({ actions: actions }) {
    const capitalizeActions = (0, $44b65fd3e61b6901$export$c86a5b4c0781d3)(actions, "-");
    const { addPathToBreadCrumb: addPathToBreadCrumb } = (0, $04813b9f064173e2$export$e3a1c6815b077e4a)();
    const { snackbarError: snackbarError, snackbarWarning: snackbarWarning } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const [modalIsOpen, setModalIsOpen] = (0, $acw62.useState)(false);
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [response, setIsResponse] = (0, $acw62.useState)({
        domains: [],
        publishers: [],
        totalConfigsChanged: 0
    });
    const [selectedPublishers, setSelectedPublishers] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [notes, setNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [editConfig, setEditConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [hasValidationErrors, setHasValidationErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [playerSchema, setPlayerSchema] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const { domains: domains, query: domainsQuery, bulkUpdateDomainsConfig: bulkUpdateDomainsConfig, bulkDeleteDomain: bulkDeleteDomain } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        enabled: true
    });
    (0, $acw62.useEffect)(()=>{
        addPathToBreadCrumb([
            {
                path: "/admin/bulk-edit",
                pathName: "Bulk Edit"
            }
        ]);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (domains) setPlayerSchema((0, $342cc1dc450464ed$export$a9256acc112e24be)(domains[0]?.domain));
    }, [
        domains
    ]);
    if (domainsQuery.isFetching) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "krg-loading-wrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    const handleBulkDeleteDomain = ()=>{
        bulkDeleteDomain({
            publishers: selectedPublishers,
            notes: notes,
            changes: editConfig
        }, {
            onSuccess: (res)=>{
                setIsResponse(res);
                setIsOpen(true);
            },
            onError: ()=>{
                snackbarError(`Error occur while ${actions} bulk domains`);
            }
        });
    };
    const handleBulkUpdateDomain = ()=>{
        bulkUpdateDomainsConfig({
            publishers: selectedPublishers,
            notes: notes,
            changes: editConfig
        }, {
            onSuccess: (res)=>{
                setIsResponse(res);
                setIsOpen(true);
            },
            onError: ()=>{
                snackbarError(`Error occur while ${actions} bulk domains`);
            }
        });
    };
    const handleConfirm = ()=>{
        if (actions === "update") handleBulkUpdateDomain();
        else handleBulkDeleteDomain();
        setModalIsOpen(false);
        setSelectedPublishers([]);
        setNotes("");
        setEditConfig({});
    };
    const handleOnChanges = (value)=>setEditConfig(JSON.parse(value));
    const renderInputs = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                marginLeft: 3
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5448779ae698aab3$export$2e2bcd8739ae039), {
                        isEnabled: selectedPublishers.length > 0,
                        actions: capitalizeActions,
                        discriptions: selectedPublishers.join(", "),
                        show: modalIsOpen,
                        onSave: handleConfirm,
                        onCancel: ()=>{
                            setModalIsOpen(false);
                        }
                    }),
                    onClose: ()=>setModalIsOpen(false),
                    isOpen: modalIsOpen
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexFlow: "column",
                        width: "40%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                        text: notes,
                        name: "notes",
                        isFullWidth: true,
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2,
                        label: "Notes",
                        onTextChange: setNotes,
                        debounceTime: 0,
                        maxCharacter: 250,
                        onDebounceEnd: setNotes
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexFlow: "column",
                        width: "40%",
                        marginLeft: "25px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76525783db335904$export$2e2bcd8739ae039), {
                        value: selectedPublishers,
                        onChange: (cat)=>{
                            setSelectedPublishers(cat);
                        }
                    })
                })
            ]
        });
    const renderEditor = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                flexFlow: "column",
                height: "90%"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b66f688e095ad2ff$export$2e2bcd8739ae039), {
                editValue: editConfig ? JSON.stringify(editConfig, null, 2) : "",
                onChange: handleOnChanges,
                onValidate: (values)=>setHasValidationErrors(values.length > 0),
                schemaValidation: playerSchema
            })
        });
    const renderSnackBar = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $525720de80d3c8ea$export$2e2bcd8739ae039), {
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0899ee3baf1fc6c1$export$2e2bcd8739ae039), {
                actions: `${actions}ed`,
                title: `${capitalizeActions} Successful`,
                domains: response?.domains,
                publishers: response?.publishers,
                totalChange: response.totalConfigsChanged,
                onOk: ()=>{
                    setIsOpen(false);
                }
            }),
            onClose: ()=>{
                setIsOpen(false);
                setIsResponse({
                    domains: [],
                    publishers: [],
                    totalConfigsChanged: 0
                });
            },
            isOpen: isOpen
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "20px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8be00a71a8f424c9$export$2e2bcd8739ae039), {
                hideButton: true,
                severity: "warning",
                title: `Bulk ${capitalizeActions} mode`,
                message: "Each action performed here will be applied in ALL domain's player configs in a selected publishers"
            }),
            renderInputs(),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 5,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: (0, $23760b2b95362ec5$export$2e2bcd8739ae039)(capitalizeActions)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "h6",
                                component: "h1",
                                fontWeight: "bold",
                                sx: {
                                    color: "#333",
                                    marginBottom: "3px",
                                    marginLeft: "14px"
                                },
                                children: [
                                    "Bulk ",
                                    capitalizeActions,
                                    " Editor"
                                ]
                            }),
                            renderEditor()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1f8abd7fea68f5ba$export$2e2bcd8739ae039), {
                show: true,
                save: ()=>{
                    if (hasValidationErrors) {
                        snackbarWarning("Fix syntax errors before saving it!");
                        return;
                    }
                    if (!notes) {
                        snackbarWarning("Please leave a note for this changes of maximum 56 characters.");
                        return;
                    }
                    setModalIsOpen(true);
                },
                cancel: ()=>{
                    setEditConfig({});
                }
            }),
            isOpen && renderSnackBar()
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");











function $3186cada89682f8e$export$2e2bcd8739ae039() {
    const { addPathToBreadCrumb: addPathToBreadCrumb } = (0, $04813b9f064173e2$export$e3a1c6815b077e4a)();
    const history = (0, $kfZjc.useHistory)();
    const params = (0, $kfZjc.useParams)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(true);
    const [revisions, setRevisions] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const { getRevisions: getRevisions } = (0, $b5dd5d6a03e10096$export$a13e2cd9aac3d29e)(params.playerToken, params.domainToken || "");
    const { data: data } = (0, $a9fd19d627d10772$export$d9dcc325f8df9b84)(params.domainToken || "");
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (data?.domain) addPathToBreadCrumb([
            {
                path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                    slug: publisherSlug,
                    domainToken: params.domainToken
                }),
                pathName: data?.domain
            },
            {
                path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CONFIG, {
                    slug: publisherSlug,
                    domainToken: params.domainToken,
                    playerToken: params.playerToken
                }),
                pathName: "No revision yet"
            }
        ]);
    }, [
        data
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (data) {
            const latestConfig = data.configs.filter((c)=>c.token === params.playerToken).shift();
            getRevisions(params.playerToken, {
                onSuccess: (res)=>{
                    res.push({
                        ...latestConfig,
                        isLatest: true
                    });
                    setRevisions(res.sort((a, b)=>Number(a.revision) - Number(b.revision)));
                },
                onError: ()=>{
                    setRevisions([
                        {
                            ...latestConfig,
                            isLatest: true
                        }
                    ]);
                },
                onSettled: ()=>{
                    addPathToBreadCrumb([
                        {
                            path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG, {
                                slug: publisherSlug,
                                domainToken: params.domainToken
                            }),
                            pathName: data?.domain
                        },
                        {
                            path: (0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CONFIG, {
                                slug: publisherSlug,
                                domainToken: params.domainToken,
                                playerToken: params.playerToken
                            }),
                            pathName: latestConfig.key
                        }
                    ]);
                    setIsLoading(false);
                }
            });
        }
    }, [
        params.playerToken,
        data
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "krg-loading-wrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    const columns = [
        {
            field: "revision",
            headerName: "Revision number",
            onClick: (e, row)=>{
                if (row.isLatest) {
                    history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_EDIT, {
                        slug: publisherSlug,
                        domainToken: params.domainToken,
                        playerToken: params.playerToken
                    }));
                    return;
                }
                history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_REVISION_EDIT, {
                    slug: publisherSlug,
                    domainToken: params.domainToken,
                    playerToken: params.playerToken,
                    revision: row.revision
                }));
            },
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: row.revision
                })
        },
        {
            field: "notes",
            headerName: "Notes",
            renderCell: (row)=>row.notes ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: row.notes
                }) : null
        },
        {
            field: "updated_at",
            headerName: "Last update",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(row.updated_at).format("DD/MMM/YY "),
                        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(row.updated_at).format(" HH:mm:ss")
                    ]
                })
        },
        {
            field: "created_by_user",
            headerName: "Updated by",
            renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: row.created_by_user
                })
        },
        {
            field: "edit",
            headerName: "Edit",
            onClick: (_, row)=>{
                if (row.isLatest) {
                    history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_EDIT, {
                        slug: publisherSlug,
                        domainToken: params.domainToken,
                        playerToken: params.playerToken
                    }));
                    return;
                }
                history.push((0, $kfZjc.generatePath)((0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_REVISION_EDIT, {
                    slug: publisherSlug,
                    domainToken: params.domainToken,
                    playerToken: row.token,
                    revision: row.revision
                }), {
                    config: row
                });
            },
            /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ renderCell: (row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {
                    color: "primary"
                })
        }
    ];
    const rows = revisions?.map((d)=>d).reverse() || [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "20px",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1bfd01510116977$export$2e2bcd8739ae039), {
                columns: columns,
                rows: rows,
                size: 14
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $19ocJ = parcelRequire("19ocJ");
var $lkxXU = parcelRequire("lkxXU");


var $iDAOR = parcelRequire("iDAOR");

var $htqGM = parcelRequire("htqGM");

var $55ofq = parcelRequire("55ofq");






const $576e88cd2f553856$export$77edea3e896928b1 = {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "start",
    width: "100%"
};
const $576e88cd2f553856$export$aa6223da92b253dd = {
    display: "flex",
    flexFlow: "column",
    width: 500,
    margin: "40px 0 24px 0"
};
const $576e88cd2f553856$export$248a47518f3a0001 = {
    display: "flex",
    flexFlow: "column",
    width: 500
};
const $576e88cd2f553856$export$1b9b24bdbcc25a11 = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper"
};




function $ef8cbb1b18cfd4d4$export$2e2bcd8739ae039() {
    const [inputs, setInput] = (0, $acw62.useState)({
        name: "",
        slug: "",
        domains: [],
        create_user: false,
        username: ""
    });
    const [errors, setError] = (0, $acw62.useState)([]);
    const [publisher, setPublisher] = (0, $acw62.useState)(null);
    const { createNewPublisherMutation: createNewPublisherMutation, query: query } = (0, $4f86ca3d56f18424$export$a036ba61edb46e4b)();
    const { switchToPublisherGroup: switchToPublisherGroup, switchToPublisher: switchToPublisher, switchToPublisherUsername: switchToPublisherUsername } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(true);
    const { addPathToBreadCrumb: addPathToBreadCrumb } = (0, $04813b9f064173e2$export$e3a1c6815b077e4a)();
    const { mutate: mutate, isLoading: isLoading, data: data, error: error } = createNewPublisherMutation;
    const resetErrors = (keys)=>{
        setError(typeof keys === "undefined" ? [] : errors.filter((err)=>!keys.includes(err?.key)));
    };
    (0, $acw62.useEffect)(()=>{
        addPathToBreadCrumb([
            {
                path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PUBLISHER_ONBOARD,
                pathName: "Publishers Onboard"
            }
        ]);
    }, []);
    (0, $acw62.useEffect)(()=>{
        resetErrors([
            "api"
        ]);
        if (data) {
            if (data?.publisher) setPublisher(data.publisher);
            else if (error || data.message) setError([
                ...errors,
                {
                    key: "api",
                    message: data?.message || JSON.stringify(error)
                }
            ]);
            else setError([
                ...errors,
                {
                    key: "api",
                    message: `Unexpected error occurred during publisher creation`
                }
            ]);
        }
    }, [
        data,
        error
    ]);
    const handleSubmit = (ev)=>{
        ev.preventDefault();
        resetErrors([
            "api"
        ]);
        if (errors.length <= 0) mutate(inputs);
    };
    const handleOnChange = (id, text, required)=>{
        let slugOrName = text;
        if (required && text.length === 0) {
            setError([
                ...errors,
                {
                    key: id,
                    message: `Publisher ${id} is required`
                }
            ]);
            return;
        }
        if (id === "slug") slugOrName = text.trim().split(" ").join("-").toLocaleLowerCase();
        setInput({
            ...inputs,
            [id]: slugOrName.replace(/^(http(s)?:\/\/)?(www\.)?/, "")
        });
    };
    const handleSwitchUser = (pl)=>{
        query.refetch().then(()=>{
            switchToPublisher(pl.slug);
            switchToPublisherUsername(pl.name);
            switchToPublisherGroup(pl.group);
            (0, $636507560a861811$export$c0a147212ba524b4)(pl.group);
        });
    };
    const showNewCreatedPublisher = (pl)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                paddingTop: "20px"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h3",
                    marginBottom: "10px",
                    children: "Publisher Details:"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
                    sx: $576e88cd2f553856$export$1b9b24bdbcc25a11,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                primary: `Name: ${pl.name}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            component: "li"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                primary: `Slug: ${pl.slug}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            component: "li"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                primary: `Group: ${pl.group}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            component: "li"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                primary: `Created At: ${pl.created_at}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            component: "li"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                primary: `Created By: ${pl.created_by}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            component: "li"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                                id: "switch-publisher",
                                text: `Switch to "${publisher.name}"`,
                                onClick: ()=>handleSwitchUser(publisher),
                                size: (0, $55ofq.BUTTON_SIZE_ENUM).large,
                                variant: "contained",
                                isFullWidth: true
                            })
                        })
                    ]
                })
            ]
        });
    const createPublisherForm = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: $576e88cd2f553856$export$77edea3e896928b1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $576e88cd2f553856$export$aa6223da92b253dd,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            marginBottom: 2,
                            variant: "h4",
                            children: "Create a new Publisher"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "subtitle1",
                            children: `The Publisher's name is only necessary to create a publisher.
            But we can also can set specific slug
            (if not, one will be generated for the publisher based on the name). 
            Publisher\u{2019}s group will be equal to its slug.`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $576e88cd2f553856$export$248a47518f3a0001,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                        id: "create_user",
                        label: "create user",
                        inputType: "text",
                        isChecked: inputs.create_user,
                        onToggle: (check)=>setInput({
                                ...inputs,
                                create_user: check
                            }),
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $576e88cd2f553856$export$248a47518f3a0001,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            id: "name",
                            label: "Publisher Name",
                            inputType: "text",
                            hasAutoFocus: true,
                            required: true,
                            onDebounceEnd: (text)=>handleOnChange("name", text, true),
                            hasErrorIcon: errors.filter((err)=>err.key === "name").length > 0,
                            errorMessage: errors?.length > 0 ? errors.filter((err)=>err.key === "name")[0]?.message || `` : ``,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2
                        }),
                        inputs.name && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            isEnabled: false,
                            text: `Will submit: "${inputs.name}"`,
                            style: {
                                width: `50%`
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $576e88cd2f553856$export$248a47518f3a0001,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            id: "slug",
                            label: "Slug Name (Optional)",
                            inputType: "text",
                            hasAutoFocus: true,
                            onDebounceEnd: (text)=>handleOnChange("slug", text, false),
                            hasErrorIcon: errors.filter((err)=>err.key === "slug").length > 0,
                            helperText: inputs.slug?.length > 0 && `Slug will be: ${inputs.slug}`,
                            theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2
                        }),
                        inputs.slug && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                            isEnabled: false,
                            text: `Will submit: "${inputs.slug}"`,
                            style: {
                                width: `50%`
                            }
                        })
                    ]
                }),
                inputs.create_user && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $576e88cd2f553856$export$248a47518f3a0001,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))), {
                        id: "username",
                        label: "Username",
                        inputType: "text",
                        hasAutoFocus: true,
                        required: inputs.create_user,
                        onDebounceEnd: (text)=>handleOnChange("username", text, inputs.create_user),
                        hasErrorIcon: errors.filter((err)=>err.key === "username").length > 0,
                        errorMessage: errors?.length > 0 ? errors.filter((err)=>err.key === "username")[0]?.message || `` : ``,
                        theme: (0, (/*@__PURE__*/$parcel$interopDefault($iDAOR))).THEME_ENUM.v2
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $576e88cd2f553856$export$248a47518f3a0001,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28133ee1914bc066$export$2e2bcd8739ae039), {
                        id: "onboard-publisher",
                        text: "Onboard Publisher",
                        isEnabled: errors.length <= 0 && inputs?.name?.length > 0,
                        onClick: handleSubmit,
                        size: (0, $55ofq.BUTTON_SIZE_ENUM).medium,
                        variant: (0, $55ofq.BUTTON_VARIANT_ENUM).contained
                    })
                })
            ]
        });
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "center-div",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "10px 20px",
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: errors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: errors.map((err, i)=>err.key === `api` && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                            severity: "error",
                            children: `Error Details: ${err.message}`
                        }, `local-err-${err.key || i}`))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: publisher && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                    severity: "success",
                    children: `Publisher: "${publisher.name}" was successfully created!`
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                children: publisher ? showNewCreatedPublisher(publisher) : createPublisherForm()
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $3bYfT = parcelRequire("3bYfT");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $30UGG = parcelRequire("30UGG");
var $5WjaY = parcelRequire("5WjaY");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $fEVav = parcelRequire("fEVav");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $72f090ff2322b6ae$export$5f5333fe417019a7(slot) {
    return (0, $4Cod0.default)("MuiCardMedia", slot);
}
const $72f090ff2322b6ae$var$cardMediaClasses = (0, $beCSm.default)("MuiCardMedia", [
    "root",
    "media",
    "img"
]);
var $72f090ff2322b6ae$export$2e2bcd8739ae039 = $72f090ff2322b6ae$var$cardMediaClasses;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $891b59d4b36435bb$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $891b59d4b36435bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            "root",
            isMediaComponent && "media",
            isImageComponent && "img"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $72f090ff2322b6ae$export$5f5333fe417019a7), classes);
};
const $891b59d4b36435bb$var$CardMediaRoot = (0, $d8seH.default)("div", {
    name: "MuiCardMedia",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "block",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }, ownerState.isMediaComponent && {
        width: "100%"
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: "cover"
    }));
const $891b59d4b36435bb$var$MEDIA_COMPONENTS = [
    "video",
    "audio",
    "picture",
    "iframe",
    "img"
];
const $891b59d4b36435bb$var$IMAGE_COMPONENTS = [
    "picture",
    "img"
];
const $891b59d4b36435bb$var$CardMedia = /*#__PURE__*/ $acw62.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiCardMedia"
    });
    const { children: children, className: className, component: component = "div", image: image, src: src, style: style } = props, other = (0, $1En50.default)(props, $891b59d4b36435bb$var$_excluded);
    const isMediaComponent = $891b59d4b36435bb$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $8nd05.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $891b59d4b36435bb$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $891b59d4b36435bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($891b59d4b36435bb$var$CardMediaRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? "img" : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
$891b59d4b36435bb$var$CardMedia.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node, (props)=>{
        if (!props.children && !props.image && !props.src && !props.component) return new Error("MUI: Either `children`, `image`, `src` or `component` prop must be specified.");
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */ image: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */ src: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
var $891b59d4b36435bb$export$2e2bcd8739ae039 = $891b59d4b36435bb$var$CardMedia;




var $kfZjc = parcelRequire("kfZjc");

var $iDAOR = parcelRequire("iDAOR");
var $14b4fcb0e549e7b0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($14b4fcb0e549e7b0$exports, "__esModule", {
    value: true
});
$14b4fcb0e549e7b0$exports.default = void 0;

var $14b4fcb0e549e7b0$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$var$_default = $14b4fcb0e549e7b0$exports.default = (0, $14b4fcb0e549e7b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");



var $dgtCa = parcelRequire("dgtCa");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $3bYfT = parcelRequire("3bYfT");
var $30UGG = parcelRequire("30UGG");

var $dgtCa = parcelRequire("dgtCa");

var $i4KPV = parcelRequire("i4KPV");




const $982db486951befe7$var$SingleMediaActionButtons = ({ initialFormState: initialFormState, submitHandler: submitHandler })=>{
    const { push: push } = (0, $kfZjc.useHistory)();
    const [{ errors: errors, touched: touched }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const cancelAction = (0, $acw62.useCallback)(()=>{
        if (touched) setShowModal(true);
        else push((0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY);
    }, [
        touched
    ]);
    const handleConfirmReset = ()=>{
        dispatch({
            type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).RESET_FORM,
            payload: initialFormState
        });
        setShowModal(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            marginBottom: "45px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                onSubmitClick: ()=>handleConfirmReset(),
                header: "Reset Applied Chages",
                body: "Are you sure you want to reset changes you applied for this media?",
                submitButtonText: "Reset Form Fields",
                cancelButtonText: "Cancel"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                columnGap: 3,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            className: "page-subtitle",
                            children: "Media Details"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: true,
                        textAlign: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            justifyContent: "end",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                                    id: "cancel",
                                    className: "form-button",
                                    text: "Cancel",
                                    onClick: cancelAction,
                                    variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                                    size: (0, $dgtCa.SIZE_ENUM).small,
                                    isSquaredBorder: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                                    id: "submit-update",
                                    className: "form-button",
                                    text: "Save Changes",
                                    onClick: submitHandler,
                                    variant: (0, $dgtCa.VARIANT_ENUM).contained,
                                    size: (0, $dgtCa.SIZE_ENUM).small,
                                    isSquaredBorder: true,
                                    isEnabled: Object.keys(errors).length === 0 && touched,
                                    background: (0, $i4KPV.BACKGROUND_ENUM).black
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $982db486951befe7$export$2e2bcd8739ae039 = $982db486951befe7$var$SingleMediaActionButtons;







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $81yMd = parcelRequire("81yMd");
var $7Frhn = parcelRequire("7Frhn");
var $30hyv = parcelRequire("30hyv");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $elyLx = parcelRequire("elyLx");
var $QpuKB = parcelRequire("QpuKB");
var $6ami2 = parcelRequire("6ami2");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QePP = parcelRequire("9QePP");

var $5qZhP = parcelRequire("5qZhP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $cllwi = parcelRequire("cllwi");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3bYfT = parcelRequire("3bYfT");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd904517f2a78af6$export$d6efab9620b78fec(slot) {
    return (0, $4Cod0.default)("MuiLink", slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $beCSm.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $fd904517f2a78af6$export$2e2bcd8739ae039 = $fd904517f2a78af6$var$linkClasses;



var $k0igC = parcelRequire("k0igC");

var $kSnzZ = parcelRequire("kSnzZ");
const $204cbcbead979fad$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $204cbcbead979fad$var$transformDeprecatedColors = (color)=>{
    return $204cbcbead979fad$export$c4e140d5d351182b[color] || color;
};
const $204cbcbead979fad$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $204cbcbead979fad$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $k0igC.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $k0igC.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $kSnzZ.alpha)(color, 0.4);
};
var $204cbcbead979fad$export$2e2bcd8739ae039 = $204cbcbead979fad$var$getTextDecoration;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $731ce78e0c47d0a7$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $jTnBY.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd904517f2a78af6$export$d6efab9620b78fec), classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $jTnBY.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $8nd05.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $8nd05.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $204cbcbead979fad$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $fd904517f2a78af6$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $1En50.default)(props, $731ce78e0c47d0a7$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $cllwi.default)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handlerRef = (0, $9Rgf1.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, (0, $8nd05.default)({
        color: color,
        className: (0, $9QePP.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $204cbcbead979fad$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
$731ce78e0c47d0a7$var$Link.propTypes /* remove-proptypes */  = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The color of the link.
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).any,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $5qZhP.default),
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */ TypographyClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Controls when the link should have an underline.
   * @default 'always'
   */ underline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "always",
        "hover",
        "none"
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "body1",
            "body2",
            "button",
            "caption",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "inherit",
            "overline",
            "subtitle1",
            "subtitle2"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $731ce78e0c47d0a7$export$2e2bcd8739ae039 = $731ce78e0c47d0a7$var$Link;



var $bNGtB = parcelRequire("bNGtB");
var $5WoTm = parcelRequire("5WoTm");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bb2065511871d060$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2zm10 14.5V20H8v-3.5l4-4zm-4-5-4-4V4h8v3.5z"
}), "HourglassEmpty");


/**
 * Determines the stream type based on stream properties
 * - If stream has explicit type property, use it
 * - If URL contains .m3u8, it's HLS
 * - Otherwise, it's MP4 (default)
 */ const $bd1355e829bfa874$var$getStreamType = (stream)=>{
    if (stream.type) return stream.type === "hls" ? "HLS" : "MP4";
    // Infer from URL
    if (stream.url?.includes(".m3u8")) return "HLS";
    return "MP4";
};
/**
 * Determines the stream state based on media_info and media_jobs
 * - If media_info exists, transcoding succeeded
 * - Otherwise, check the media_job at the same index for state
 */ const $bd1355e829bfa874$var$getStreamState = (stream, index, mediaJobs)=>{
    // If media_info is present, it's a success
    if (stream.media_info) return {
        status: "success",
        label: "Success"
    };
    // Check media_job at the same index
    if (mediaJobs && mediaJobs[index]) {
        const jobState = mediaJobs[index].state.toLowerCase();
        if (jobState === "failure" || jobState === "failed") return {
            status: "failure",
            label: mediaJobs[index].state
        };
        // Any other state (processing, pending, queued, etc.) shows in yellow
        return {
            status: "pending",
            label: mediaJobs[index].state
        };
    }
    // No media_info and no corresponding job - assume failure
    return {
        status: "failure",
        label: "Failed"
    };
};
/**
 * Returns the color for a given stream status
 */ const $bd1355e829bfa874$var$getStateColor = (status)=>{
    switch(status){
        case "success":
            return "#4caf50"; // Green
        case "failure":
            return "#f44336"; // Red
        case "pending":
            return "#f9a825"; // Yellow/amber
        default:
            return "#9e9e9e"; // Grey
    }
};
/**
 * Returns the icon component for a given stream status
 */ const $bd1355e829bfa874$var$getStateIcon = (status)=>{
    const color = $bd1355e829bfa874$var$getStateColor(status);
    switch(status){
        case "success":
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bNGtB.default), {
                sx: {
                    fontSize: "16px",
                    color: color
                }
            });
        case "failure":
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WoTm.default), {
                sx: {
                    fontSize: "16px",
                    color: color
                }
            });
        case "pending":
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb2065511871d060$export$2e2bcd8739ae039), {
                sx: {
                    fontSize: "16px",
                    color: color
                }
            });
        default:
            return null;
    }
};
const $bd1355e829bfa874$var$StreamsList = ({ streams: streams, mediaJobs: mediaJobs })=>{
    if (!streams || streams.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            mt: 2
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: "body2",
            color: "text.secondary",
            children: "No transcoded streams available."
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            mt: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                sx: {
                    fontSize: "14px",
                    fontWeight: 600,
                    mb: 1,
                    color: "#333"
                },
                children: "Transcoded Streams"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                component: (0, $7Frhn.default),
                sx: {
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    borderRadius: "8px"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                sx: {
                                    backgroundColor: "#f5f5f5"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            fontWeight: 600,
                                            fontSize: "12px"
                                        },
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            fontWeight: 600,
                                            fontSize: "12px"
                                        },
                                        children: "URL"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            fontWeight: 600,
                                            fontSize: "12px"
                                        },
                                        children: "State"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                            children: streams.map((stream, index)=>{
                                const streamType = $bd1355e829bfa874$var$getStreamType(stream);
                                const streamState = $bd1355e829bfa874$var$getStreamState(stream, index, mediaJobs);
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    sx: {
                                        "&:last-child td, &:last-child th": {
                                            border: 0
                                        },
                                        "&:hover": {
                                            backgroundColor: "#fafafa"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                label: streamType,
                                                size: "small",
                                                sx: {
                                                    backgroundColor: streamType === "HLS" ? "#e3f2fd" : "#f3e5f5",
                                                    color: streamType === "HLS" ? "#1565c0" : "#7b1fa2",
                                                    fontWeight: 500,
                                                    fontSize: "11px"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                                                href: stream.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                sx: {
                                                    fontSize: "12px",
                                                    color: "#1976d2",
                                                    textDecoration: "none",
                                                    wordBreak: "break-all",
                                                    "&:hover": {
                                                        textDecoration: "underline"
                                                    }
                                                },
                                                children: stream.url
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1
                                                },
                                                children: [
                                                    $bd1355e829bfa874$var$getStateIcon(streamState.status),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        sx: {
                                                            fontSize: "12px",
                                                            color: $bd1355e829bfa874$var$getStateColor(streamState.status),
                                                            textTransform: "capitalize"
                                                        },
                                                        children: streamState.label
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, stream.token || stream.id || index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $bd1355e829bfa874$export$2e2bcd8739ae039 = $bd1355e829bfa874$var$StreamsList;


const $81800c43d7dda911$var$SingleMediaPageContainer = ({ video: video, token: token, initialFormState: initialFormState })=>{
    const { push: push } = (0, $kfZjc.useHistory)();
    const [{ formInputFields: formInputFields, errors: errors, data: data, showAllErrors: showAllErrors, submitting: submitting, touched: touched }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { mutations: { updateMutation: updateMutation, deleteMutation: deleteMutation } } = (0, $d0a01e33b734bdf6$export$2e2bcd8739ae039)(token);
    const { mutateAsync: mutateAsync } = updateMutation;
    (0, $acw62.useEffect)(()=>{
        if (deleteMutation.isSuccess) queryClient.resetQueries([
            "videos"
        ]).then(()=>push((0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY));
    }, [
        deleteMutation.isSuccess
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!touched && formInputFields) (0, $3f43b861fb5eed68$export$cd01a3bec503042)(dispatch, formInputFields);
    }, []);
    const submitHandler = async (ev)=>{
        ev.preventDefault();
        (0, $3f43b861fb5eed68$export$e02251cfbe407ee6)(dispatch, errors, data, mutateAsync);
    };
    if (!video) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        className: "page-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                onSubmitClick: ()=>deleteMutation.mutate(token),
                header: "Deleting Video",
                body: "Are you sure you want to delete this video?",
                submitButtonText: "Delete",
                cancelButtonText: "Cancel"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "page-title-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h1",
                    className: "page-title",
                    children: formInputFields.title?.value?.toString()
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $982db486951befe7$export$2e2bcd8739ae039), {
                initialFormState: initialFormState,
                submitHandler: submitHandler
            }),
            Object.keys(errors).length > 0 && showAllErrors && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                severity: "error",
                sx: {
                    marginBottom: "20px"
                },
                onClose: ()=>dispatch({
                        type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).CLOSE_FORM_ERROR
                    }),
                children: Object.keys(errors).map((errKey)=>errors[errKey].map((err)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: err
                        }, `alert-${err}`)))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: 6,
                            order: {
                                xs: 2,
                                md: 1
                            },
                            sx: {
                                paddingLeft: 0
                            },
                            children: submitting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                                onSubmit: submitHandler,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66c147be7aae7bee$export$2e2bcd8739ae039), {
                                    video: video
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: 6,
                            order: {
                                xs: 1,
                                md: 2
                            },
                            sx: {
                                marginBottom: "25px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $891b59d4b36435bb$export$2e2bcd8739ae039), {
                                        component: "div",
                                        sx: {
                                            padding: "0.5em",
                                            backgroundColor: "#f1f1f1"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2e19e4137e450c8$export$f503bc85d719e8b0), {
                                            video: token
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd1355e829bfa874$export$2e2bcd8739ae039), {
                                    streams: video?.transcoded_streams || [],
                                    mediaJobs: video?.media_jobs
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                    id: "delete-video",
                    className: "form-delete-button",
                    text: "Delete Video",
                    onClick: ()=>setShowModal(true),
                    variant: (0, $iDAOR.VARIANT_ENUM).outlined,
                    isSquaredBorder: true,
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {}),
                    style: {
                        marginTop: "17px",
                        border: "none",
                        paddingLeft: 0
                    }
                })
            })
        ]
    });
};
var $81800c43d7dda911$export$2e2bcd8739ae039 = $81800c43d7dda911$var$SingleMediaPageContainer;




var $acw62 = parcelRequire("acw62");


const $3a5a012e4b2c58ae$var$useSinglePageSidebar = (navItems)=>{
    const [sidebarState, sidebarDispatch] = (0, $19d54d555e11d5ac$export$861cd542ff836f0d)();
    (0, $acw62.useEffect)(()=>{
        sidebarDispatch({
            type: (0, $c78770f0c89775c7$export$1aef8022e4184007).SET_SINGLE_PAGE_SIDEBAR,
            payload: {
                ...sidebarState,
                singlePageSidebar: navItems
            }
        });
        return ()=>{
            sidebarDispatch({
                type: (0, $c78770f0c89775c7$export$1aef8022e4184007).SET_MAIN_SIDEBAR
            });
        };
    }, [
        navItems
    ]);
};
var $3a5a012e4b2c58ae$export$2e2bcd8739ae039 = $3a5a012e4b2c58ae$var$useSinglePageSidebar;



var $ayMG0 = parcelRequire("ayMG0");

var $bjZRT = parcelRequire("bjZRT");
var $700ab4d8ec4f5cb0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($700ab4d8ec4f5cb0$exports, "__esModule", {
    value: true
});
$700ab4d8ec4f5cb0$exports.default = void 0;

var $700ab4d8ec4f5cb0$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $700ab4d8ec4f5cb0$var$_default = $700ab4d8ec4f5cb0$exports.default = (0, $700ab4d8ec4f5cb0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), "ArrowBackIos");


const $239e48635335fb04$var$SidebarBackIconItem = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
        sx: {
            minWidth: "30px"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($700ab4d8ec4f5cb0$exports))), {
            sx: {
                fontSize: "15px"
            },
            color: "primary"
        })
    });
var $239e48635335fb04$export$2e2bcd8739ae039 = $239e48635335fb04$var$SidebarBackIconItem;







const $f5c92669879fdfbe$var$SingleMediaPage = ({ asAdmin: asAdmin })=>{
    const history = (0, $kfZjc.useHistory)();
    const { publisherSlug: publisherSlug } = (0, $556b5b2da5bfbb21$export$dc4ef782e1b5fd70)(asAdmin);
    const query = asAdmin && {
        slug: publisherSlug
    };
    const { domains: domains, query: domainsQuery } = (0, $e8f3c29d364c2853$export$bec5ce498e1ba61e)({
        enabled: true,
        query: query
    });
    // Show single page sidebar
    const sidebarItem = {
        selected: false,
        text: "Media Gallery",
        onClick: ()=>(0, $63f21e5cf8cde4d8$export$533de6bd8cd3faae)(history, (0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY),
        iconElement: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $239e48635335fb04$export$2e2bcd8739ae039), {})
    };
    (0, $3a5a012e4b2c58ae$export$2e2bcd8739ae039)([
        sidebarItem
    ]);
    const { token: token } = (0, $kfZjc.useParams)();
    if (!token) throw new Error("No ID found in media data");
    const { video: video, isLoading: isVideoLoading, error: videoError } = (0, $d0a01e33b734bdf6$export$2e2bcd8739ae039)(token);
    // Show loading state while either video or domains are loading
    if (isVideoLoading || domainsQuery.isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    if (!video || videoError) {
        const statusCode = (0, $63f21e5cf8cde4d8$export$45d83df3bf045126)(videoError);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            children: (0, $5dc958303e06c3a5$export$6e6190295ccf9618)[statusCode]
        });
    }
    const { title: title, description: description, category: category, tags: tags, domain: domainName, media_info: { original_file_name: // eslint-disable-next-line @typescript-eslint/naming-convention
    original_file_name } } = video;
    const formInitialState = {
        title: {
            name: "title",
            label: "Video Title",
            type: "text",
            required: true,
            rules: {
                length: {
                    min: 5
                }
            },
            // errorMessage: "Video Title is required and should me min 5 characters length",
            value: title || original_file_name,
            popoverText: "Title of the video",
            hinterText: "*required"
        },
        description: {
            name: "description",
            label: "Video Description",
            type: "text",
            required: true,
            rules: {
                length: {
                    min: 20
                }
            },
            errorMessage: "Video Description is required and has to be min 20 characters length",
            value: description,
            popoverText: "Please add more information about your video",
            hinterText: "*required"
        },
        tags: {
            name: "tags",
            label: "Tags",
            type: "chip",
            value: tags?.map((tag)=>({
                    id: tag,
                    text: tag
                })) || [],
            popoverText: "Commas or semicolon will separate the tags"
        },
        category: {
            name: "category",
            label: "Category",
            type: "select",
            value: category,
            errorMessage: "Only one category selection allowed",
            options: (0, $e4f44006c888bb84$export$3ee9b4aab65c61a7).map(({ name: name })=>({
                    value: name.toLowerCase(),
                    text: name
                })) || [],
            popoverText: "Please select a category for your video"
        },
        domain: {
            name: "domain",
            label: "Domain",
            type: "select",
            value: domainName || "",
            options: domains?.map((domain)=>({
                    value: domain.domain,
                    text: domain.domain
                })) || [],
            popoverText: "Please select a domain for your video",
            errorMessage: "Only one domain selection allowed"
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $366ccbbe6fb31b36$export$8ce1ff4f94d08846), {
        formInputFields: formInitialState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81800c43d7dda911$export$2e2bcd8739ae039), {
            initialFormState: formInitialState,
            video: video,
            token: token
        })
    });
};
var $f5c92669879fdfbe$export$2e2bcd8739ae039 = $f5c92669879fdfbe$var$SingleMediaPage;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $30UGG = parcelRequire("30UGG");


var $kfZjc = parcelRequire("kfZjc");

var $iDAOR = parcelRequire("iDAOR");


var $dgtCa = parcelRequire("dgtCa");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");


var $dgtCa = parcelRequire("dgtCa");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $8c4b30ac94754196$var$FormFieldRenderer = ({ name: name, type: type })=>{
    switch(type){
        case `text`:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2af5e0efbed2d61$export$2e2bcd8739ae039), {
                fieldKey: name
            });
        case `select`:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04071252e2237c5d$export$2e2bcd8739ae039), {
                fieldKey: name
            });
        case `chip`:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af92efe3ba553e0f$export$2e2bcd8739ae039), {
                fieldKey: name
            });
        default:
            // As there could be some inputs which is with predefined component, default will be empty for them
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    }
};
var $8c4b30ac94754196$export$2e2bcd8739ae039 = $8c4b30ac94754196$var$FormFieldRenderer;





/**
 * SinglePlaylistEditor
 * @constructor
 */ const $6ab349d58bbeb709$var$SinglePlaylistEditor = ({ creationType: creationType, onVideosAdded: onVideosAdded, mediaList: mediaList })=>{
    const [{ formInputFields: formInputFields }] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const [isAddVideosModalOpen, setIsAddVideosModalOpen] = (0, $acw62.useState)(false);
    const handleAddVideos = (selectedVideos)=>{
        if (onVideosAdded) onVideosAdded(selectedVideos);
        setIsAddVideosModalOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        id: "media-editor-form-container",
        children: [
            Object.keys(formInputFields).map((key)=>{
                const { [key]: { ...field } } = formInputFields;
                if (!field.name || key !== field.name) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        severity: "warning",
                        children: `Field: "${key}" don't match with name key: "${field.name}"`
                    })
                }, key);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8c4b30ac94754196$export$2e2bcd8739ae039), {
                    name: key,
                    type: field.type
                }, key);
            }),
            creationType === (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CUSTOM && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        marginY: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body2",
                            color: "text.secondary",
                            sx: {
                                marginBottom: 1
                            },
                            children: "Choose existing videos from your library to add to your playlist."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                            theme: (0, $dgtCa.THEME_ENUM).v2,
                            variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                            style: {
                                borderColor: (0, $dgtCa.BACKGROUND_ENUM).blue,
                                color: (0, $dgtCa.BACKGROUND_ENUM).blue
                            },
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {}),
                            text: "ADD VIDEOS",
                            onClick: ()=>setIsAddVideosModalOpen(true)
                        })
                    ]
                })
            }),
            creationType === (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CUSTOM && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dda9709b90af82fe$export$2e2bcd8739ae039), {
                isOpen: isAddVideosModalOpen,
                onClose: ()=>setIsAddVideosModalOpen(false),
                onAddVideos: handleAddVideos,
                currentSelectedVideos: mediaList
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    marginTop: "1px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        md: 4,
                        xl: 3,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                sx: {
                                    fontSize: "11px"
                                },
                                children: "Total Duration:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                sx: {
                                    fontSize: "16px"
                                },
                                children: (0, $5094343bfed31c54$export$bc733b0c5cbb3e8a)(mediaList.reduce((acc, media)=>acc + (media?.default_stream?.media_info?.duration || 0), 0))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        md: 4,
                        xl: 3,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                sx: {
                                    fontSize: "11px"
                                },
                                children: "No of Videos:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                sx: {
                                    fontSize: "16px"
                                },
                                children: mediaList.length
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6ab349d58bbeb709$export$2e2bcd8739ae039 = $6ab349d58bbeb709$var$SinglePlaylistEditor;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $3bYfT = parcelRequire("3bYfT");
var $30UGG = parcelRequire("30UGG");

var $dgtCa = parcelRequire("dgtCa");

var $i4KPV = parcelRequire("i4KPV");




const $4c1584fac8fc2e20$var$SinglePlaylistActionButtons = ({ initialFormState: initialFormState, submitHandler: submitHandler, creationType: creationType, hasMediaChanges: hasMediaChanges, resetMediaList: resetMediaList })=>{
    const { push: push } = (0, $kfZjc.useHistory)();
    const [{ errors: errors, touched: touched }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const cancelAction = (0, $acw62.useCallback)(()=>{
        if (touched || hasMediaChanges) setShowModal(true);
        else push((0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY_PLAYLISTS);
    }, [
        touched,
        hasMediaChanges
    ]);
    const handleConfirmReset = ()=>{
        dispatch({
            type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).RESET_FORM,
            payload: initialFormState
        });
        resetMediaList();
        setShowModal(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            marginBottom: "45px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                onSubmitClick: ()=>handleConfirmReset(),
                header: "Reset Applied Playlist Changes",
                body: "Are you sure you want to reset changes you applied for this playlist?",
                submitButtonText: "Reset Form Fields",
                cancelButtonText: "Cancel"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                columnGap: 3,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            className: "page-subtitle",
                            children: [
                                "Playlist Details: ",
                                creationType
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: true,
                        textAlign: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            justifyContent: "end",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                                    id: "cancel",
                                    className: "form-button",
                                    text: touched || hasMediaChanges ? "Reset Changes" : "Cancel",
                                    onClick: cancelAction,
                                    variant: (0, $dgtCa.VARIANT_ENUM).outlined,
                                    size: (0, $dgtCa.SIZE_ENUM).small,
                                    isSquaredBorder: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                                    id: "submit-update",
                                    className: "form-button",
                                    text: "Save Changes",
                                    onClick: submitHandler,
                                    variant: (0, $dgtCa.VARIANT_ENUM).contained,
                                    size: (0, $dgtCa.SIZE_ENUM).small,
                                    isSquaredBorder: true,
                                    isEnabled: Object.keys(errors).length === 0 && (touched || hasMediaChanges),
                                    background: (0, $i4KPV.BACKGROUND_ENUM).black
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $4c1584fac8fc2e20$export$2e2bcd8739ae039 = $4c1584fac8fc2e20$var$SinglePlaylistActionButtons;










function $cf18fa6cb0ece6bc$export$2e2bcd8739ae039(token, initialData) {
    const { snackbarError: snackbarError, snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { api: api, didLoad: didLoad } = (0, $28c935ff7811b100$export$2e2bcd8739ae039)();
    const query = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            "playlist",
            token
        ],
        queryFn: ()=>token && api.Playlist.get(token).then((data)=>data.playlist),
        initialData: initialData,
        staleTime: Infinity,
        keepPreviousData: true,
        enabled: !!token && didLoad
    });
    const getPlaylistMedias = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            "playlist-medias",
            token
        ],
        queryFn: ()=>token && api.Playlist.medias(token).then((data)=>data.medias),
        initialData: initialData,
        staleTime: Infinity,
        keepPreviousData: true,
        enabled: !!token && didLoad
    });
    const updateMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>api.Playlist.update(token, data),
        onSuccess: ({ playlist: playlist })=>{
            snackbarSuccess(`Playlist related information was updated`);
            queryClient.setQueryData([
                "playlist",
                token
            ], playlist);
            queryClient.invalidateQueries({
                queryKey: [
                    "playlist",
                    token
                ]
            });
        },
        onError: (e)=>{
            console.error(e);
            snackbarError("Error while updating the video. Check the console for more information.");
        }
    });
    const deleteMutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (tkn)=>api.Playlist.delete(tkn),
        onSuccess: ()=>{
            snackbarSuccess(`Video was successfully deleted`);
        },
        onError: (e)=>{
            console.error(e);
            snackbarError("Error while deleting the video. Check the console for more information.");
        }
    });
    return {
        ...query,
        getPlaylistMedias: getPlaylistMedias,
        isMediasLoading: getPlaylistMedias.isFetching,
        playlist: query.data,
        medias: getPlaylistMedias.data,
        api: {
            update: updateMutation.mutate,
            delete: deleteMutation.mutate
        },
        mutations: {
            updateMutation: updateMutation,
            deleteMutation: deleteMutation
        }
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $5WjaY = parcelRequire("5WjaY");
var $3bYfT = parcelRequire("3bYfT");





const $38618f8374b19d55$var$SinglePlaylistMediaList = ({ mediaList: mediaList, creationType: creationType, sortType: sortType, onRemoveVideo: onRemoveVideo, onReorderVideos: onReorderVideos })=>{
    const isCustomPlaylist = creationType === (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CUSTOM;
    const isManualSort = isCustomPlaylist && sortType === "manual";
    const sortedMediaList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (sortType !== "manual") return (0, $2a238fca44ed85c3$export$2830befb6f558677)(mediaList, sortType);
        return mediaList;
    }, [
        mediaList,
        sortType
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                sx: {
                    borderColor: "#000"
                },
                children: isCustomPlaylist && mediaList.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0a7b6fc0014f6ee$export$2e2bcd8739ae039), {
                    description: "Click 'ADD VIDEOS' to select and add videos to your playlist."
                }) : isManualSort ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3bcae63b9199492$export$2e2bcd8739ae039), {
                    videos: sortedMediaList,
                    onReorder: onReorderVideos,
                    onRemove: onRemoveVideo,
                    showRemoveButton: isCustomPlaylist,
                    style: {
                        maxHeight: "600px"
                    }
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39154cc66d8e6722$export$2e2bcd8739ae039), {
                    videos: sortedMediaList,
                    onRemove: onRemoveVideo,
                    rowSize: 10,
                    showRemoveButton: isCustomPlaylist
                })
            }),
            mediaList.length > 0 && (sortType === "shuffle" || isManualSort) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    marginTop: "1px"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    md: 12,
                    xl: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        sx: {
                            fontSize: "11px"
                        },
                        children: sortType === "shuffle" ? "Note: Shuffle is enabled, and the video order will be randomized." : "Note: Manual sort is enabled. You can drag and drop videos to reorder them."
                    })
                })
            })
        ]
    });
};
var $38618f8374b19d55$export$2e2bcd8739ae039 = $38618f8374b19d55$var$SinglePlaylistMediaList;






const $91e34ba468ebd1ce$var$SinglePlaylistPageContainer = ({ token: token, initialFormState: initialFormState, creationType: creationType })=>{
    const history = (0, $kfZjc.useHistory)();
    const [{ formInputFields: formInputFields, errors: errors, data: data, showAllErrors: showAllErrors, submitting: submitting, touched: touched }, dispatch] = (0, $366ccbbe6fb31b36$export$4d957a5e1be13b03)();
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const [showBackModal, setShowBackModal] = (0, $acw62.useState)(false);
    const [hasMediaChanges, setHasMediaChanges] = (0, $acw62.useState)(false);
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { getPlaylistMedias: getPlaylistMedias, isMediasLoading: isMediasLoading, mutations: { updateMutation: updateMutation, deleteMutation: deleteMutation } } = (0, $cf18fa6cb0ece6bc$export$2e2bcd8739ae039)(token);
    const { mutateAsync: mutateAsync } = updateMutation;
    const [mediaList, setMediaList] = (0, $acw62.useState)([]);
    const [initialMediaList, setInitialMediaList] = (0, $acw62.useState)([]);
    const { snackbarSuccess: snackbarSuccess } = (0, $9d761cac11c11d44$export$2e2bcd8739ae039)();
    const resetMediaList = ()=>{
        setMediaList(initialMediaList);
        setHasMediaChanges(false);
    };
    const handleBackClick = (0, $acw62.useCallback)(()=>{
        if (touched || hasMediaChanges) setShowBackModal(true);
        else (0, $63f21e5cf8cde4d8$export$533de6bd8cd3faae)(history, (0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY_PLAYLISTS);
    }, [
        touched,
        hasMediaChanges,
        history
    ]);
    // Show single page sidebar
    const sidebarItem = {
        selected: false,
        text: "Media Gallery",
        onClick: handleBackClick,
        iconElement: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $239e48635335fb04$export$2e2bcd8739ae039), {})
    };
    (0, $3a5a012e4b2c58ae$export$2e2bcd8739ae039)([
        sidebarItem
    ]);
    const handleAddVideos = (videos)=>{
        const newMediaList = [
            ...mediaList,
            ...videos
        ];
        setMediaList(newMediaList);
        setHasMediaChanges(true);
        snackbarSuccess("Videos added successfully. Please save the playlist to update the media list.");
    };
    const handleRemoveVideo = (mediaToken)=>{
        setMediaList(mediaList.filter((media)=>media.token !== mediaToken));
        setHasMediaChanges(true);
    };
    const handleReorderVideos = (oldIndex, newIndex)=>{
        const reorderedMediaList = [
            ...mediaList
        ];
        const [removed] = reorderedMediaList.splice(oldIndex, 1);
        reorderedMediaList.splice(newIndex, 0, removed);
        setMediaList(reorderedMediaList);
        setHasMediaChanges(true);
    };
    const submitHandler = async (ev)=>{
        ev.preventDefault();
        const formData = {
            ...data,
            ...creationType === (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CUSTOM && {
                medias: mediaList.map((media)=>media.token)
            }
        };
        (0, $3f43b861fb5eed68$export$e02251cfbe407ee6)(dispatch, errors, formData, mutateAsync);
    };
    (0, $acw62.useEffect)(()=>{
        getPlaylistMedias.refetch().then((resp)=>{
            if (resp.isSuccess) {
                setMediaList(resp.data || []);
                setInitialMediaList(resp.data || []);
            }
        });
    }, []);
    // ✅ Reset mutation states to prevent stale success states
    (0, $acw62.useEffect)(()=>{
        updateMutation.reset();
        deleteMutation.reset();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (deleteMutation.isSuccess) {
            queryClient.invalidateQueries([
                "playlists"
            ]);
            queryClient.resetQueries([
                "playlist"
            ]).then(()=>history.push((0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY_PLAYLISTS));
        }
    }, [
        deleteMutation.isSuccess
    ]);
    (0, $acw62.useEffect)(()=>{
        if (updateMutation.isSuccess) {
            setInitialMediaList([
                ...mediaList
            ]);
            queryClient.invalidateQueries({
                queryKey: [
                    "playlist",
                    token
                ]
            });
        }
    }, [
        updateMutation.isSuccess,
        token,
        queryClient
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!touched && formInputFields) (0, $3f43b861fb5eed68$export$cd01a3bec503042)(dispatch, formInputFields);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!submitting && !Object.keys(errors).length && hasMediaChanges) setHasMediaChanges(false);
    }, [
        submitting,
        errors
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        className: "page-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                onSubmitClick: ()=>deleteMutation.mutate(token),
                header: "Deleting Playlist",
                body: "Are you sure you want to delete this playlist?",
                submitButtonText: "Delete",
                cancelButtonText: "Cancel"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3846ac6d4b84146$export$2e2bcd8739ae039), {
                isOpen: showBackModal,
                onClose: ()=>{
                    setShowBackModal(false);
                    (0, $63f21e5cf8cde4d8$export$533de6bd8cd3faae)(history, (0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY_PLAYLISTS);
                },
                onSubmitClick: ()=>setShowBackModal(false),
                header: "Unsaved Changes",
                body: "You have unsaved changes to this playlist. If you leave now, your changes will be lost. Would you like to continue editing or leave without saving?",
                submitButtonText: "Continue Editing",
                cancelButtonText: "Leave Page",
                isCloseIconDismissible: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "page-title-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h1",
                    className: "page-title",
                    children: formInputFields.title?.value?.toString()
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c1584fac8fc2e20$export$2e2bcd8739ae039), {
                initialFormState: initialFormState,
                submitHandler: submitHandler,
                creationType: creationType,
                hasMediaChanges: hasMediaChanges,
                resetMediaList: resetMediaList
            }),
            Object.keys(errors).length > 0 && showAllErrors && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                severity: "error",
                sx: {
                    marginBottom: "20px"
                },
                onClose: ()=>dispatch({
                        type: (0, $95fdffd6a39e1be0$export$5336cca884279f84).CLOSE_FORM_ERROR
                    }),
                children: Object.keys(errors).map((errKey)=>errors[errKey].map((err)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: err
                        }, `alert-${err}`)))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: 5,
                            order: {
                                xs: 2,
                                md: 1
                            },
                            sx: {
                                paddingLeft: 0
                            },
                            children: submitting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                                onSubmit: submitHandler,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ab349d58bbeb709$export$2e2bcd8739ae039), {
                                    creationType: creationType,
                                    onVideosAdded: handleAddVideos,
                                    mediaList: mediaList
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: 7,
                            order: {
                                xs: 1,
                                md: 2
                            },
                            sx: {
                                marginBottom: "25px"
                            },
                            children: submitting || isMediasLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    height: "100%",
                                    justifyContent: "center",
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38618f8374b19d55$export$2e2bcd8739ae039), {
                                mediaList: mediaList,
                                creationType: creationType,
                                sortType: formInputFields.sortType?.value,
                                onRemoveVideo: handleRemoveVideo,
                                onReorderVideos: handleReorderVideos
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgtCa))), {
                    id: "delete-playlist",
                    className: "form-delete-button",
                    text: "Delete Playlist",
                    onClick: ()=>setShowModal(true),
                    variant: (0, $iDAOR.VARIANT_ENUM).outlined,
                    isSquaredBorder: true,
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {}),
                    style: {
                        marginTop: "17px",
                        border: "none",
                        paddingLeft: 0
                    }
                })
            })
        ]
    });
};
var $91e34ba468ebd1ce$export$2e2bcd8739ae039 = $91e34ba468ebd1ce$var$SinglePlaylistPageContainer;






const $b61345dfd9b919e5$var$SinglePlaylistPage = ()=>{
    const { token: token } = (0, $kfZjc.useParams)();
    if (!token) throw new Error("No ID found in media data");
    const { playlist: playlist } = (0, $cf18fa6cb0ece6bc$export$2e2bcd8739ae039)(token);
    if (!playlist) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $baec2d8ea645d6e9$export$2e2bcd8739ae039), {})
    });
    const { title: title, tags: tags, sortType: sortType, categories: categories, excludedTags: excludedTags, type: type = (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CUSTOM } = playlist;
    const categoryOptions = (0, $e4f44006c888bb84$export$3ee9b4aab65c61a7).map(({ name: name })=>({
            value: name.toLowerCase(),
            text: name
        }));
    const categoryDefaultValue = categories?.length ? categories.map((val)=>val.trim().toLowerCase()) : [];
    const formInitialState = {
        title: {
            name: "title",
            label: "Playlist Title",
            type: "text",
            required: true,
            rules: {
                length: {
                    min: (0, $5dc958303e06c3a5$export$1547fe5c62a0c049),
                    ...(0, $5dc958303e06c3a5$export$58e52dd22dd7fb6a) && {
                        max: (0, $5dc958303e06c3a5$export$58e52dd22dd7fb6a)
                    }
                }
            },
            errorMessage: `Video Title is required and should be min ${(0, $5dc958303e06c3a5$export$58e52dd22dd7fb6a)} characters length`,
            value: title || "",
            hinterText: "*required"
        },
        sortType: {
            name: "sortType",
            label: "Video Sort",
            type: "select",
            required: true,
            value: (0, $5dc958303e06c3a5$export$4bc22197a004b096).find(({ value: value })=>value === sortType)?.value || (0, $5dc958303e06c3a5$export$4bc22197a004b096)[0].value,
            errorMessage: "At least one sort type is required",
            options: type === (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CUSTOM ? (0, $5dc958303e06c3a5$export$4bc22197a004b096) : (0, $5dc958303e06c3a5$export$4bc22197a004b096).filter((option)=>option.value !== "manual"),
            popoverText: "Please choose videos sort"
        },
        ...type === (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).CATEGORY && {
            categories: {
                name: "categories",
                label: "Categories",
                type: "select",
                required: true,
                value: categoryDefaultValue,
                errorMessage: "Only one category selection allowed",
                options: categoryOptions,
                popoverText: "Please select a category for your video",
                isMultiple: true
            }
        },
        ...type === (0, $c75a4671c7c1827b$export$32c2c14de5aa8aa1).TAG && {
            tags: {
                name: "tags",
                label: "Tags",
                type: "chip",
                required: true,
                value: tags?.map((tag)=>({
                        id: tag,
                        text: tag
                    })) || [],
                popoverText: "Commas or semicolon will separate the tags"
            },
            excludedTags: {
                name: "excludedTags",
                label: "Exclude Tags",
                type: "chip",
                value: excludedTags?.map((tag)=>({
                        id: tag,
                        text: tag
                    })) || [],
                popoverText: "Commas or semicolon will separate the excluded tags"
            }
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $366ccbbe6fb31b36$export$8ce1ff4f94d08846), {
        formInputFields: formInitialState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91e34ba468ebd1ce$export$2e2bcd8739ae039), {
            token: token,
            playlist: playlist,
            initialFormState: formInitialState,
            creationType: type
        })
    });
};
var $b61345dfd9b919e5$export$2e2bcd8739ae039 = $b61345dfd9b919e5$var$SinglePlaylistPage;


(0, $db434a401f2c9abc$export$2e2bcd8739ae039).init({
    debug: true,
    persistence: "localStorage"
});
function $7943b7043191bb43$export$2e2bcd8739ae039() {
    const admin = "admin";
    const { authStatus: authStatus } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((context)=>[
            context.authStatus
        ]);
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const session = (0, $99e18646983cd0f4$export$2e2bcd8739ae039)();
    const userAccessPayload = session && session.getAccessToken().payload;
    const userName = userAccessPayload && userAccessPayload.username;
    const userGroups = userAccessPayload && userAccessPayload["cognito:groups"];
    const isAdmin = userGroups && userGroups.includes(admin);
    const { user: user, group: group, slug: slug } = (0, $91a3a273935dc930$export$2e2bcd8739ae039)(userName);
    const { isPublisherAdmin: isPublisherAdmin, publisherGroup: publisherGroup } = (0, $2eaa67bfb8774117$export$f14b11bc64234d25)(user, isAdmin, admin, userName, group);
    (0, $acw62.useEffect)(()=>{
        if (authStatus === "unauthenticated") queryClient.removeQueries();
    }, [
        authStatus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.BrowserRouter), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
            FallbackComponent: (0, $51a692b93140ffe5$export$2e2bcd8739ae039),
            onError: (e)=>{
                (0, $db434a401f2c9abc$export$2e2bcd8739ae039).track("Error", {
                    type: "runtime",
                    errorName: e.name,
                    errorMessage: e.message
                });
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19d54d555e11d5ac$export$d8355e8edbcacbe8), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aece6033f0ce4c41$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82815a5f14ae99c4$export$2e2bcd8739ae039), {
                        asAdmin: isAdmin,
                        isPublisherAdmin: isPublisherAdmin,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Switch), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ROOT,
                                    exact: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Redirect), {
                                        to: (0, $29836994947f98a9$export$807b1b70df68fbc6).PUBLISHER_HUB
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).PUBLISHER_HUB,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1f1a59392dfe959$export$2e2bcd8739ae039), {
                                        asAdmin: isAdmin,
                                        slug: slug
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).MEDIA_GALLERY,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $27250de26c0e8d8e$export$2e2bcd8739ae039), {
                                        asAdmin: isAdmin,
                                        publisherGroup: publisherGroup
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).SINGLE_MEDIA_EDIT_PAGE,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5c92669879fdfbe$export$2e2bcd8739ae039), {
                                        asAdmin: isAdmin
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).SINGLE_PLAYLIST_EDIT_PAGE,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b61345dfd9b919e5$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).REPORTING,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3937af9b081053f5$export$2e2bcd8739ae039), {
                                        asAdmin: isAdmin
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0084b72bac862faf$export$2e2bcd8739ae039), {
                                        admin: admin,
                                        isPublisherAdmin: isPublisherAdmin,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Switch), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_USERS,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d24dbc81e15b91f3$export$2e2bcd8739ae039), {
                                                        slug: slug,
                                                        isAdmin: isAdmin,
                                                        user: user
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $04813b9f064173e2$export$e9e2792ac12de339), {
                                                    isAdmin: isAdmin,
                                                    slug: slug,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN,
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c124fe04d5edc6ee$export$2e2bcd8739ae039), {
                                                                asAdmin: isAdmin
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_DOMAIN_CONFIG,
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16165861a72427f6$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CONFIG,
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3186cada89682f8e$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: [
                                                                (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_EDIT,
                                                                (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_REVISION_EDIT
                                                            ],
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $602ce273b30edb39$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PUBLISHER_ONBOARD,
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef8cbb1b18cfd4d4$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_PLAYER_CLONE,
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42cdd4db883087ee$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_BULK_UPDATE,
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa54eeacaf756c37$export$2e2bcd8739ae039), {
                                                                actions: "update"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                            path: (0, $29836994947f98a9$export$807b1b70df68fbc6).ADMIN_BULK_DELETE,
                                                            exact: true,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa54eeacaf756c37$export$2e2bcd8739ae039), {
                                                                actions: "delete"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                    path: (0, $29836994947f98a9$export$807b1b70df68fbc6).NOT_FOUND,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75ca8ca6191977d3$export$271f9f08425019c7), {})
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $a8970915757c176b$export$cca4a41bdb910c51 = {
    "Account recovery requires verified contact information": "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
    "Back to Sign In": "Zur\xfcck zur Anmeldung",
    "Change Password": "Passwort \xe4ndern",
    Changing: "\xc4ndern von",
    Code: "Code",
    "Confirm Password": "Passwort best\xe4tigen",
    "Confirm Sign Up": "Registrierung best\xe4tigen",
    "Confirm SMS Code": "SMS-Code best\xe4tigen",
    "Confirm TOTP Code": "TOTP-Code best\xe4tigen",
    Confirm: "Best\xe4tigen",
    "Confirmation Code": "Best\xe4tigungs-Code",
    Confirming: "Wird best\xe4tigt",
    "Create a new account": "Einen neuen Account erstellen",
    "Create Account": "Account erstellen",
    "Creating Account": "Account wird erstellt",
    "Dismiss alert": "Warnung verwerfen",
    Email: "Email",
    "Enter your code": "Geben Sie Ihren Code ein",
    "Enter your email": "Geben Sie Ihre Email ein",
    "Enter your phone number": "Geben Sie Ihre Telefonnummer ein",
    "Enter your username": "Geben Sie Ihren Benutzernamen ein",
    "Forgot your password?": "Passwort vergessen? ",
    "Hide password": "Passwort verbergen",
    Loading: "Wird geladen",
    "New password": "Neues Passwort",
    Password: "Passwort",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Code erneut senden",
    "Reset your Password": "Zur\xfccksetzen des Passwort",
    "Reset your password": "Zur\xfccksetzen des passwort",
    "Send code": "Code senden",
    "Send Code": "Code senden",
    Sending: "Wird gesendet",
    "Setup TOTP": "TOTP einrichten",
    "Show password": "Passwort anzeigen",
    "Sign in to your account": "Melden Sie sich mit Ihrem Account an",
    "Sign In with Amazon": "Mit Amazon anmelden",
    "Sign In with Apple": "Mit Apple anmelden",
    "Sign In with Facebook": "Mit Facebook anmelden",
    "Sign In with Google": "Mit Google anmelden",
    "Sign in": "Anmelden",
    "Sign In": "Anmelden",
    "Signing in": "Wird angemeldet",
    Skip: "\xdcberspringen",
    Submit: "Abschicken",
    Submitting: "Wird gesendet",
    Username: "Benutzername",
    "Verify Contact": "Kontakt verifizieren",
    Verify: "Verifizieren",
    "An account with the given email already exists.": "Ein Account mit dieser Email existiert bereits.",
    "Confirm a Code": "Code best\xe4tigen",
    "Confirm Sign In": "Anmeldung best\xe4tigen",
    "Create account": "Hier registrieren",
    "Enter your password": "Geben Sie Ihr Passwort ein",
    "Forgot Password": "Passwort vergessen",
    "Have an account? ": "Schon registriert? ",
    "Incorrect username or password": "Falscher Benutzername oder falsches Passwort",
    "Invalid password format": "Ung\xfcltiges Passwort-Format",
    "Invalid phone number format": "Ung\xfcltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900",
    "It may take a minute to arrive.": "Es k\xf6nnte eine Minute dauern, bis der Code eintrifft.",
    "Lost your code? ": "Code verloren? ",
    "New Password": "Neues Passwort",
    "No account? ": "Kein Account? ",
    or: "oder",
    "Password attempts exceeded": "Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht",
    "Reset password": "Passwort zur\xfccksetzen",
    "Sign Out": "Abmelden",
    "Sign Up": "Registrieren",
    "User already exists": "Dieser Benutzer existiert bereits",
    "User does not exist": "Dieser Benutzer existiert nicht",
    "Username cannot be empty": "Benutzername darf nicht leer sein",
    "We Emailed You": "Email wurde versendet",
    "Your code is on the way. To log in, enter the code we emailed to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an",
    "Your code is on the way. To log in, enter the code we texted to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an"
};


var $c3b0f98bf3b332cf$export$eb91f595f110d703 = {
    "Account recovery requires verified contact information": "Account recovery requires verified contact information",
    "Back to Sign In": "Back to Sign In",
    "Change Password": "Change Password",
    Changing: "Changing",
    Code: "Code",
    "Confirm Password": "Confirm Password",
    "Confirm Sign Up": "Confirm Sign Up",
    "Confirm SMS Code": "Confirm SMS Code",
    "Confirm TOTP Code": "Confirm TOTP Code",
    Confirm: "Confirm",
    "Confirmation Code": "Confirmation Code",
    Confirming: "Confirming",
    "Create a new account": "Create a new account",
    "Create Account": "Create Account",
    "Creating Account": "Creating Account",
    "Dismiss alert": "Dismiss alert",
    Email: "Email",
    "Enter your code": "Enter your code",
    "Enter your email": "Enter your email",
    "Enter your phone number": "Enter your phone number",
    "Enter your username": "Enter your username",
    "Forgot your password?": "Forgot your password?",
    "Hide password": "Hide password",
    Loading: "Loading",
    "New password": "New password",
    Password: "Password",
    "Phone Number": "Phone Number",
    "Resend Code": "Resend Code",
    "Reset your password": "Reset your password",
    "Reset your Password": "Reset your Password",
    "Send code": "Send code",
    "Send Code": "Send Code",
    Sending: "Sending",
    "Setup TOTP": "Setup TOTP",
    "Show password": "Show password",
    "Sign in to your account": "Sign in to your account",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "Sign in",
    "Sign In": "Sign In",
    "Signing in": "Signing in",
    Skip: "Skip",
    Submit: "Submit",
    Submitting: "Submitting",
    Username: "Username",
    "Verify Contact": "Verify Contact",
    Verify: "Verify"
};


var $baeb34dab8ae3620$export$1d204a99f5862ba9 = {
    "Account recovery requires verified contact information": "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
    "Back to Sign In": "Volver a inicio de sesi\xf3n",
    "Change Password": "Cambiar contrase\xf1a",
    Changing: "Cambiando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirmar contrase\xf1a",
    "Confirm Sign Up": "Confirmar registro",
    "Confirm SMS Code": "Confirmar el c\xf3digo de SMS",
    "Confirm TOTP Code": "Confirmar c\xf3digo TOTP",
    Confirm: "Confirmar",
    "Confirmation Code": "C\xf3digo de confirmaci\xf3n",
    Confirming: "Confirmando",
    "Create a new account": "Crear una cuenta nueva",
    "Create Account": "Crear cuenta",
    "Creating Account": "Creando cuenta",
    "Dismiss alert": "Descartar alerta",
    Email: "Email",
    "Enter your code": "Ingrese el c\xf3digo",
    "Enter your email": "Escriba su Email",
    "Enter your phone number": "Ingrese el n\xfamero de tel\xe9fono",
    "Enter your username": "Ingrese el nombre de usuario",
    "Forgot your password?": "\xbfOlvid\xf3 su contrase\xf1a?",
    "Hide password": "Ocultar contrase\xf1a",
    Loading: "Cargando",
    "New password": "Nueva contrase\xf1a",
    Password: "Contrase\xf1a",
    "Phone Number": "N\xfamero de tel\xe9fono",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Restablecer su contrase\xf1a",
    "Reset your Password": "Restablecer su Contrase\xf1a",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar contrase\xf1a",
    "Sign in to your account": "Iniciar sesi\xf3n en tu cuenta",
    "Sign In with Amazon": "Iniciar Sesi\xf3n con Amazon",
    "Sign In with Apple": "Iniciar Sesi\xf3n con Apple",
    "Sign In with Facebook": "Iniciar Sesi\xf3n con Facebook",
    "Sign In with Google": "Iniciar Sesi\xf3n con Google",
    "Sign in": "Iniciar sesi\xf3n",
    "Sign In": "Iniciar Sesi\xf3n",
    "Signing in": "Iniciando sesi\xf3n",
    Skip: "Omitir",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nombre de usuario",
    "Verify Contact": "Verificar contacto",
    Verify: "Verificar",
    "An account with the given email already exists.": "Ya existe una cuenta con el correo ingresado.",
    "Confirm a Code": "Confirmar un c\xf3digo",
    "Confirm Sign In": "Confirmar inicio de sesi\xf3n",
    "Forgot Password": "Olvid\xe9 mi contrase\xf1a",
    "Incorrect username or password.": "Nombre de usuario o contrase\xf1a incorrecta",
    "Invalid password format": "Formato de contrase\xf1a inv\xe1lido",
    "Invalid phone number format": "Formato de n\xfamero de tel\xe9fono inv\xe1lido",
    "Loading...": "Cargando...",
    "New Password": "Nueva contrase\xf1a",
    or: "o",
    "Resend a Code": "Reenviar un c\xf3digo",
    "Sign Out": "Cerrar sesi\xf3n",
    "Sign Up with Amazon": "Crear cuenta con Amazon",
    "Sign Up with Apple": "Crear cuenta con Apple",
    "Sign Up with Facebook": "Crear cuenta con Facebook",
    "Sign Up with Google": "Crear cuenta con Google",
    "Sign Up": "Crear cuenta",
    "User already exists": "El usuario ya existe",
    "User does not exist": "El usuario no existe",
    "Username cannot be empty": "El nombre de usuario no puede estar vac\xedo",
    "Your passwords must match": "Las contrase\xf1as deben coincidir"
};


var $ddc24953b2c79e64$export$8cfa91bfcf8d11c8 = {
    "Account recovery requires verified contact information": "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
    "Back to Sign In": "Retour \xe0 la connexion",
    "Change Password": "Modifier le mot de passe",
    Changing: "Modification en cours",
    Code: "Code",
    "Confirm Password": "Confirmez le mot de passe",
    "Confirm Sign Up": "Confirmer l'inscription",
    "Confirm SMS Code": "Confirmer le code SMS",
    "Confirm TOTP Code": "Confirmer le code TOTP",
    Confirm: "Confirmer",
    "Confirmation Code": "Code de confirmation",
    Confirming: "Confirmation",
    "Create a new account": "Cr\xe9er un nouveau compte",
    "Create Account": "Cr\xe9er un compte",
    "Creating Account": "Cr\xe9ation d'un compte",
    "Dismiss alert": "Supprimer l'alerte",
    Email: "Email",
    "Enter your code": "Saisissez cotre code de confirmation",
    "Enter your email": "Saisissez votre adresse email",
    "Enter your phone number": "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    "Enter your username": "Saisissez votre nom d'utilisateur",
    "Forgot your password?": "Mot de passe oubli\xe9 ? ",
    "Hide password": "Masquer le mot de passe",
    Loading: "Chargement en cours",
    "New password": "Nouveau mot de passe",
    Password: "Mot de passe",
    "Phone Number": "Num\xe9ro de t\xe9l\xe9phone",
    "Resend Code": "Renvoyer le code",
    "Reset your Password": "R\xe9initialiser votre mot de passe",
    "Reset your password": "R\xe9initialisez votre mot de passe",
    "Send code": "Envoyer le code",
    "Send Code": "M'envoyer un code",
    Sending: "Envoi en cours",
    "Setup TOTP": "Configuration de TOTP",
    "Show password": "Afficher le mot de passe",
    "Sign in to your account": "Connexion \xe0 votre compte",
    "Sign In with Amazon": "Se connecter avec Amazon",
    "Sign In with Apple": "Se connecter avec Apple",
    "Sign In with Facebook": "Se connecter avec Facebook",
    "Sign In with Google": "Se connecter avec Google",
    "Sign in": "Se connecter",
    "Sign In": "Se connecter",
    "Signing in": "Connexion en cours",
    Skip: "Passer",
    Submit: "Soumettre",
    Submitting: "Envoi en cours",
    Username: "Nom d'utilisateur",
    "Verify Contact": "V\xe9rifier le contact",
    Verify: "V\xe9rifier",
    "An account with the given email already exists.": "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
    Change: "Modifier",
    "Confirm a Code": "Confirmer un code",
    "Confirm Sign In": "Confirmer la connexion",
    "Create account": "Cr\xe9er un compte",
    "Enter your password": "Saisissez votre mot de passe",
    "Forgot Password": "Mot de passe oubli\xe9",
    "Have an account? ": "D\xe9j\xe0 un compte ? ",
    Hello: "Bonjour",
    "Incorrect username or password": "Identifiant ou mot de passe incorrect",
    "Invalid password format": "Format de mot de passe invalide",
    "Invalid phone number format": "Format de num\xe9ro de t\xe9l\xe9phone invalide. Veuillez utiliser un format +12345678900",
    "Loading...": "Chargement...",
    "Lost your code? ": "Vous avez perdu votre code ? ",
    "Network error": "Erreur r\xe9seau",
    "New Password": "Nouveau mot de passe",
    "No account? ": "Pas de compte ? ",
    or: "ou",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "R\xe9initialisez votre mot de passe",
    Send: "Envoyer",
    "Sign In with AWS": "Se connecter avec AWS",
    "Sign Out": "D\xe9connexion",
    "Sign Up": "S'inscrire",
    SMS: "SMS",
    "User already exists": "L'utilisateur existe d\xe9j\xe0",
    "User does not exist": "L'utilisateur n'existe pas",
    "Username cannot be empty": "Le nom d'utilisateur doit \xeatre renseign\xe9",
    "Username/client id combination not found.": "L'utilisateur n'existe pas"
};


var $3aec870541e38948$export$5c8da73de176fccc = {
    "Account recovery requires verified contact information": "Il ripristino dell'account richiede informazioni di contatto verificate",
    "Back to Sign In": "Torna alla schermata di accesso",
    "Change Password": "Cambia la password",
    Changing: "Modifica in corso",
    Code: "Codice",
    "Confirm Password": "Conferma la password",
    "Confirm Sign Up": "Conferma registrazione",
    "Confirm SMS Code": "Conferma codice SMS",
    "Confirm TOTP Code": "Conferma codice TOTP",
    Confirm: "Conferma",
    "Confirmation Code": "Codice di verifica",
    Confirming: "Conferma in corso",
    "Create a new account": "Crea un nuovo account",
    "Create Account": "Crea Account",
    "Creating Account": "Creazione account in corso",
    "Dismiss alert": "Ignora l'avviso",
    Email: "Email",
    "Enter your code": "Inserisci il tuo codice",
    "Enter your email": "Inserisci la tua e-mail",
    "Enter your phone number": 'Inserisci il tuo numero di telefono"',
    "Enter your username": "Inserisci il tuo nome utente",
    "Forgot your password?": "Password dimenticata?",
    "Hide password": "Nascondi password",
    Loading: "Caricamento in corso",
    "New password": "Nuova password",
    Password: "Password",
    "Phone Number": "Numero di telefono",
    "Resend Code": "Invia nuovamente il codice",
    "Reset your Password": "Reimposta la tua Password",
    "Reset your password": "Reimposta la tua password",
    "Send code": "Invia codice",
    "Send Code": "Invia codice",
    Sending: "Invio in corso",
    "Setup TOTP": "Configura TOTP",
    "Show password": "Mostra password",
    "Sign in to your account": "Accedi al tuo account",
    "Sign In with Amazon": "Accedi con Amazon",
    "Sign In with Apple": "Accedi con Apple",
    "Sign In with Facebook": "Accedi con Facebook",
    "Sign In with Google": "Accedi con Google",
    "Sign in": "Accedi",
    "Sign In": "Accedi",
    "Signing in": "Accesso in corso",
    Skip: "Salta",
    Submit: "Invia",
    Submitting: "Invio in corso",
    Username: "Nome utente",
    "Verify Contact": "Verifica contatto",
    Verify: "Verifica",
    "An account with the given email already exists.": "Questa email \xe8 gi\xe0 utilizzata da un altro account.",
    "Confirm a Code": "Conferma un codice",
    "Confirm Sign In": "Conferma l'accesso",
    "Create account": "Crea account",
    "Enter your password": "Inserisci la tua password",
    "Forgot Password": "Password dimenticata",
    "Have an account? ": "Gi\xe0 registrato?",
    "Incorrect username or password": "Nome utente o password errati",
    "Invalid password format": "Formato della password non valido",
    "Invalid phone number format": "Formato del numero di telefono non valido",
    "Lost your code?": "Codice smarrito?",
    "New Password": "Nuova password",
    "No account? ": "Non hai un account?",
    or: "o",
    "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
    "Reset password": "Reimposta password",
    "Sign Out": "Esci",
    "Sign Up": "Registrati",
    "User already exists": "Utente gi\xe0 esistente",
    "User does not exist": "Utente inesistente",
    "Username cannot be empty": "Il nome utente non pu\xf2 essere vuoto"
};


var $c8f7199ac82f3699$export$c416809cd76fbf21 = {
    "Account recovery requires verified contact information": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
    "Back to Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
    "Change Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
    Changing: "\u5909\u66F4\u4E2D",
    Code: "\u30B3\u30FC\u30C9",
    "Confirm Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
    "Confirm Sign Up": "\u767B\u9332\u3059\u308B",
    "Confirm SMS Code": "SMS \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm TOTP Code": "TOTP \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    Confirm: "\u78BA\u5B9A",
    "Confirmation Code": "\u78BA\u8A8D\u30B3\u30FC\u30C9",
    Confirming: "\u78BA\u8A8D\u4E2D",
    "Create a new account": "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Create Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Creating Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u4E2D",
    "Dismiss alert": "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308B",
    Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    "Enter your code": "\u30B3\u30FC\u30C9\u3092\u5165\u529B",
    "Enter your email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
    "Enter your phone number": "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B",
    "Enter your username": "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
    "Forgot your password?": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
    "Hide password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u975E\u8868\u793A",
    Loading: "\u30ED\u30FC\u30C9\u4E2D",
    "New password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
    "Phone Number": "\u96FB\u8A71\u756A\u53F7",
    "Resend Code": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
    "Reset your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Reset your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
    "Send code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    "Send Code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    Sending: "\u9001\u4FE1\u4E2D",
    "Setup TOTP": "TOTP \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    "Show password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A",
    "Sign in to your account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign In with Amazon": "Amazon\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Apple": "Apple \u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Facebook": "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Google": "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign in": "\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Signing in": "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D",
    Skip: "\u30B9\u30AD\u30C3\u30D7",
    Submit: "\u9001\u4FE1",
    Submitting: "\u9001\u4FE1\u4E2D",
    Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
    "Verify Contact": "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
    Verify: "\u78BA\u8A8D",
    "An account with the given email already exists.": "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
    "Confirm a Code": "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
    "Create account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
    "Enter your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
    "Forgot Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
    "Have an account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
    "Incorrect username or password": "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
    "Invalid password format": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
    "Invalid phone number format": "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    "It may take a minute to arrive.": "\u30B3\u30FC\u30C9\u3092\u53D7\u4FE1\u3059\u308B\u307E\u3067\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    "Lost your code? ": "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
    "New Password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    "No account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
    or: "\u53C8\u306F",
    "Password attempts exceeded": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
    "Reset password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
    "Sign Out": "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
    "Sign Up": "\u767B\u9332 ",
    "User already exists": "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
    "User does not exist": "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
    "Username cannot be empty": "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
    "We Emailed You": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:",
    "Your code is on the way. To log in, enter the code we texted to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:"
};


var $7e48350d7a995c9f$export$fb1930c2b96707b2 = {
    "Account recovery requires verified contact information": "\uACC4\uC815 \uBCF5\uAD6C\uB97C \uC704\uD574 \uC5F0\uB77D\uCC98 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
    "Back to Sign In": "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
    "Change Password": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30",
    Changing: "\uBCC0\uACBD\uC911",
    Code: "\uCF54\uB4DC",
    "Confirm Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778",
    "Confirm Sign Up": "\uD68C\uC6D0\uAC00\uC785 \uD655\uC778",
    "Confirm SMS Code": "\uD734\uB300\uD3F0 \uBCF8\uC778 \uD655\uC778",
    "Confirm TOTP Code": "TOTP \uC778\uC99D\uBC88\uD638 \uD655\uC778",
    Confirm: "\uD655\uC778",
    "Confirmation Code": "\uC778\uC99D\uBC88\uD638",
    Confirming: "\uD655\uC778\uC911",
    "Create a new account": "\uD68C\uC6D0\uAC00\uC785",
    "Create Account": "\uD68C\uC6D0\uAC00\uC785",
    "Creating Account": "\uD68C\uC6D0\uAC00\uC785\uC911",
    "Dismiss alert": "\uC54C\uB9BC \uBB34\uC2DC",
    Email: "\uC774\uBA54\uC77C",
    "Enter your code": "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Enter your email": "\uC774\uBA54\uC77C \uC785\uB825",
    "Enter your phone number": "\uC804\uD654\uBC88\uD638 \uC785\uB825",
    "Enter your username": "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Hide password": "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
    Loading: "\uB85C\uB529\uC911",
    "New password": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
    Password: "\uBE44\uBC00\uBC88\uD638",
    "Phone Number": "\uC804\uD654\uBC88\uD638",
    "Resend Code": "\uC778\uC99D\uBC88\uD638 \uC7AC\uC804\uC1A1",
    "Reset your password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Reset your Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Send code": "\uC778\uC99D\uCF54\uB4DC \uBCF4\uB0B4\uAE30",
    "Send Code": "\uCF54\uB4DC \uC804\uC1A1",
    Sending: "\uC804\uC1A1\uC911",
    "Setup TOTP": "TOTP \uC124\uC815\uD558\uAE30",
    "Show password": "\uBE44\uBC00\uBC88\uD638 \uBCF4\uC774\uAE30",
    "Sign in to your account": "\uB85C\uADF8\uC778",
    "Sign In with Amazon": "Amazon \uB85C\uADF8\uC778",
    "Sign In with Apple": "Apple \uB85C\uADF8\uC778",
    "Sign In with Facebook": "Facebook \uB85C\uADF8\uC778",
    "Sign In with Google": "Google \uB85C\uADF8\uC778",
    "Sign in": "\uB85C\uADF8\uC778",
    "Sign In": "\uB85C\uADF8\uC778",
    "Signing in": "\uB85C\uADF8\uC778\uC911",
    Skip: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
    Submit: "\uD655\uC778",
    Submitting: "\uD655\uC778\uC911",
    Username: "\uC544\uC774\uB514",
    "Verify Contact": "\uC5F0\uB77D\uCC98 \uD655\uC778",
    Verify: "\uC778\uC99D",
    Birthdate: "\uC0DD\uB144\uC6D4\uC77C",
    "Family Name": "\uC131",
    "Forgot your password?": "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
    "Given Name": "\uC774\uB984",
    Name: "\uC131\uD568",
    Nickname: "\uB2C9\uB124\uC784",
    "Preferred Username": "\uB2C9\uB124\uC784",
    Profile: "\uD504\uB85C\uD544",
    "Reset Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    Website: "\uC6F9\uC0AC\uC774\uD2B8"
};


var $c1f0817968ebbd13$export$8569df33fbaae243 = {
    "Account recovery requires verified contact information": "Accountherstel vereist geverifieerde contactgegevens",
    "Back to Sign In": "Terug naar inloggen",
    "Change Password": "Wachtwoord wijzigen",
    Changing: "Wordt aangepast",
    Code: "Code",
    "Confirm Password": "Bevestig Wachtwoord",
    "Confirm Sign Up": "Bevestig inschrijving",
    "Confirm SMS Code": "Bevestig SMS Code",
    "Confirm TOTP Code": "Bevestig TOTP Code",
    Confirm: "Bevestig",
    "Confirmation Code": "Bevestigingscode",
    Confirming: "Bevestigen",
    "Create a new account": "Nieuw account aanmaken",
    "Create Account": "Account aanmaken",
    "Creating Account": "Account wordt aangemaakt",
    "Dismiss alert": "Waarschuwing sluiten",
    Email: "E-mail",
    "Enter your code": "Vul je code in",
    "Enter your email": "Vul je e-mail in",
    "Enter your phone number": "Vul je telefoonnummer in",
    "Enter your username": "Vul je gebruikersnaam in",
    "Forgot your password?": "Wachtwoord vergeten? ",
    "Hide password": "Verberg wachtwoord",
    Loading: "Laden",
    "New password": "Nieuw wachtwoord",
    Password: "Wachtwoord",
    "Phone Number": "Telefoonnummer",
    "Resend Code": "Verstuur code nogmaals",
    "Reset your password": "Reset je wachtwoord",
    "Reset your Password": "Wachtwoord resetten",
    "Send code": "Verstuur code",
    "Send Code": "Verstuur Code",
    Sending: "Versturen",
    "Setup TOTP": "TOTP Instellingen",
    "Show password": "Toon wachtwoord",
    "Sign in to your account": "Inloggen op je account",
    "Sign In with Amazon": "Inloggen met Amazon",
    "Sign In with Apple": "Inloggen met Apple",
    "Sign In with Facebook": "Inloggen met Facebook",
    "Sign In with Google": "Inloggen met Google",
    "Sign in": "Inloggen",
    "Sign In": "Inloggen",
    "Signing in": "Inloggen",
    Skip: "Overslaan",
    Submit: "Versturen",
    Submitting: "Wordt verstuurd",
    Username: "Gebruikersnaam",
    "Verify Contact": "Verifieer Contact",
    Verify: "Verifieer"
};


var $922470b85f36d842$export$6fb0e8139f7ef98d = {
    "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
    "Back to Sign In": "Powr\xf3t do logowania",
    "Change Password": "Zmie\u0144 has\u0142o",
    Changing: "Zmienianie",
    Code: "Kod",
    "Confirm Password": "Potwierd\u017A Has\u0142o",
    "Confirm Sign Up": "Potwierd\u017A rejestracj\u0119",
    "Confirm SMS Code": "Potwierd\u017A kod SMS",
    "Confirm TOTP Code": "Potwierd\u017A has\u0142o jednorazowe",
    Confirm: "Potwierd\u017A",
    "Confirmation Code": "Kod potwierdzenia",
    Confirming: "Potwierdzanie",
    "Create a new account": "Utw\xf3rz nowe konto",
    "Create Account": "Utw\xf3rz konto",
    "Creating Account": "Tworzenie konta",
    "Dismiss alert": "Odrzu\u0107 alert",
    Email: "E-mail",
    "Enter your code": "Wprowad\u017A sw\xf3j kod",
    "Enter your email": "Wpisz sw\xf3j adres e-mail",
    "Enter your phone number": "Wpisz sw\xf3j numer telefonu",
    "Enter your username": "Wprowad\u017A swoj\u0105 nazw\u0119 u\u017Cytkownika",
    "Forgot your password?": "Zapomnia\u0142e\u015B has\u0142a? ",
    "Hide password": "Ukryj has\u0142o",
    Loading: "\u0141adowanie",
    "New password": "Nowe has\u0142o",
    Password: "Has\u0142o",
    "Phone Number": "Numer telefonu",
    "Resend Code": "Wy\u015Blij kod ponownie",
    "Reset your password": "Zresetuj swoje has\u0142o",
    "Reset your Password": "Zresetuj swoje has\u0142o",
    "Send code": "Wy\u015Blij kod",
    "Send Code": "Zresetuj has\u0142o",
    Sending: "Wysy\u0142anie",
    "Setup TOTP": "Konfiguruj TOTP",
    "Show password": "Poka\u017C has\u0142o",
    "Sign in to your account": "Zaloguj si\u0119 na swoje konto",
    "Sign In with Amazon": "Zaloguj z Amazon",
    "Sign In with Apple": "Zaloguj z Apple",
    "Sign In with Facebook": "Zaloguj z Facebook",
    "Sign In with Google": "Zaloguj z Google",
    "Sign In": "Logowanie",
    "Sign in": "Zaloguj",
    "Signing in": "Logowanie",
    Skip: "Pomi\u0144",
    Submit: "Wy\u015Blij",
    Submitting: "Wysy\u0142anie",
    Username: "Nazwa u\u017Cytkownika",
    "Verify Contact": "Weryfikacja danych kontaktowych",
    Verify: "Zweryfikuj",
    Birthdate: "Data urodzenia",
    "Family Name": "Nazwisko",
    "Given Name": "Pierwsze imi\u0119",
    "Middle Name": "Drugie imi\u0119",
    Name: "Imi\u0119 i nazwisko",
    Nickname: "Pseudonim",
    "Preferred Username": "Preferowana nazwa u\u017Cytkownika",
    Profile: "Profil",
    Website: "Strona internetowa"
};


var $24f1642b0a936605$export$c7dddbf179b434d1 = {
    "Account recovery requires verified contact information": "A recupera\xe7\xe3o da conta requer informa\xe7\xf5es de contato verificadas",
    "Back to Sign In": "Voltar para Entrar",
    "Change Password": "Mudar senha",
    Changing: "Mudando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirme a Senha",
    "Confirm Sign Up": "Confirmar inscri\xe7\xe3o",
    "Confirm SMS Code": "Confirme o c\xf3digo SMS",
    "Confirm TOTP Code": "Confirme o c\xf3digo TOTP",
    Confirm: "confirme",
    "Confirmation Code": "C\xf3digo de confirma\xe7\xe3o",
    Confirming: "Confirmando",
    "Create a new account": "Criar uma nova conta",
    "Create Account": "Criar Conta",
    "Creating Account": "Criando conta",
    "Dismiss alert": "Descartar alerta",
    Email: "O email",
    "Enter your code": "Insira seu c\xf3digo",
    "Enter your email": "Digite seu e-mail",
    "Enter your phone number": "Digite seu n\xfamero de telefone",
    "Enter your username": "entre com seu nome de usu\xe1rio",
    "Forgot your password?": "Esqueceu sua senha? ",
    "Hide password": "Esconder a senha",
    Loading: "Carregando",
    "New password": "Nova Senha",
    Password: "Senha",
    "Phone Number": "N\xfamero de telefone",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Redefina sua senha",
    "Reset your Password": "Redefina sua senha",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar senha",
    "Sign in to your account": "Fa\xe7a login em sua conta",
    "Sign In with Amazon": "Entrar com a Amazon",
    "Sign In with Apple": "Entrar com a Apple",
    "Sign In with Facebook": "Entrar com o Facebook",
    "Sign In with Google": "Fa\xe7a login no Google",
    "Sign in": "Entrar",
    "Sign In": "Entrar",
    "Signing in": "Entrando",
    Skip: "Pular",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nome do usu\xe1rio",
    "Verify Contact": "Verificar contato",
    Verify: "Verificar"
};


var $b5f229cd9c4dc153$export$2a86dc37ee9734c = {
    "Account recovery requires verified contact information": "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
    "Back to Sign In": "\u56DE\u5230\u767B\u5F55",
    "Change Password": "\u66F4\u6539\u5BC6\u7801",
    Changing: "\u6B63\u5728\u4FEE\u6539",
    Code: "\u786E\u8BA4\u7801",
    "Confirm Password": "\u786E\u8BA4\u5BC6\u7801",
    "Confirm Sign Up": "\u786E\u8BA4\u6CE8\u518C",
    "Confirm SMS Code": "\u786E\u8BA4\u77ED\u4FE1\u9A8C\u8BC1\u7801",
    "Confirm TOTP Code": "\u786E\u8BA4 TOTP \u4EE3\u7801",
    Confirm: "\u786E\u8BA4",
    "Confirmation Code": "\u786E\u8BA4\u7801",
    Confirming: "\u6B63\u5728\u786E\u8BA4",
    "Create a new account": "\u521B\u5EFA\u65B0\u8D26\u6237",
    "Create Account": "\u521B\u5EFA\u8D26\u6237",
    "Creating Account": "\u6B63\u5728\u521B\u5EFA\u8D26\u6237",
    "Dismiss alert": "\u5173\u95ED\u8B66\u62A5",
    Email: "\u90AE\u7BB1",
    "Enter your code": "\u8F93\u5165\u9A8C\u8BC1\u7801",
    "Enter your email": "\u8F93\u5165\u7535\u5B50\u90AE\u4EF6",
    "Enter your phone number": "\u8F93\u5165\u7535\u8BDD\u53F7\u7801",
    "Enter your username": "\u8F93\u5165\u7528\u6237\u540D",
    "Forgot your password?": "\u5FD8\u8BB0\u5BC6\u7801\u4E86\uFF1F",
    "Hide password": "\u9690\u85CF\u5BC6\u7801",
    Loading: "\u6B63\u5728\u52A0\u8F7D",
    "New password": "\u65B0\u5BC6\u7801",
    Password: "\u5BC6\u7801",
    "Phone Number": "\u7535\u8BDD",
    "Resend Code": "\u91CD\u53D1\u9A8C\u8BC1\u7801",
    "Reset your password": "\u91CD\u7F6E\u5BC6\u7801",
    "Reset your Password": "\u91CD\u7F6E\u5BC6\u7801",
    "Send Code": "\u53D1\u9001\u786E\u8BA4\u7801",
    "Send code": "\u53D1\u9001\u9A8C\u8BC1\u7801",
    Sending: "\u6B63\u5728\u53D1\u9001",
    "Setup TOTP": "\u8BBE\u7F6E TOTP",
    "Show password": "\u663E\u793A\u5BC6\u7801",
    "Sign in to your account": "\u767B\u5F55\u8D26\u6237",
    "Sign In with Amazon": "\u901A\u8FC7 Amazon \u767B\u5F55",
    "Sign In with Apple": "\u901A\u8FC7 Apple \u767B\u5F55",
    "Sign In with Facebook": "\u901A\u8FC7 Facebook \u767B\u5F55",
    "Sign In with Google": "\u901A\u8FC7 Google \u767B\u5F55",
    "Sign in": "\u767B\u5F55",
    "Sign In": "\u767B\u5F55",
    "Signing in": "\u6B63\u5728\u767B\u5F55",
    Skip: "\u8DF3\u8FC7",
    Submit: "\u63D0\u4EA4",
    Submitting: "\u6B63\u5728\u63D0\u4EA4",
    Username: "\u7528\u6237\u540D",
    "Verify Contact": "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
    Verify: "\u9A8C\u8BC1",
    "Confirm a Code": "\u786E\u8BA4\u7801",
    "Confirm Sign In": "\u786E\u8BA4\u767B\u5F55",
    "Forgot Password": "\u5FD8\u8BB0\u5BC6\u7801",
    "Incorrect username or password": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
    "Invalid password format": "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
    "Invalid phone number format": "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900",
    "New Password": "\u65B0\u5BC6\u7801",
    or: "\u6216\u8005",
    "Resend a Code": "\u91CD\u53D1\u786E\u8BA4\u7801",
    "Sign Out": "\u9000\u51FA",
    "Sign Up": "\u6CE8\u518C",
    "User already exists": "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
    "User does not exist": "\u7528\u6237\u4E0D\u5B58\u5728"
};


var $e77e3731bb4362c2$export$9f1a61f9baaa2d2e = {
    "Account recovery requires verified contact information": "F\xf6r att \xe5terst\xe4lla kontot beh\xf6ver du ett verifierat konto",
    "Back to Sign In": "Tillbaka till inloggningen",
    "Change Password": "Byt l\xf6senord",
    Changing: "\xc4ndra",
    Code: "Kod",
    "Confirm Password": "Bekr\xe4fta l\xf6senord",
    "Confirm Sign Up": "Bekr\xe4fta registrering",
    "Confirm SMS Code": "Bekr\xe4fta SMS-kod",
    "Confirm TOTP Code": "Bekr\xe4fta TOTP-kod",
    Confirm: "Bekr\xe4fta",
    "Confirmation Code": "Verifikationskod",
    Confirming: "Bekr\xe4ftar",
    "Create a new account": "Skapa ett nytt konto",
    "Create Account": "Skapa konto",
    "Creating Account": "Skapar konto",
    "Dismiss alert": "Avvisa varning",
    Email: "E-post",
    "Enter your code": "Skriv din kod",
    "Enter your email": "Fyll i din e-post",
    "Enter your phone number": "Ange ditt telefonnummer",
    "Enter your username": "Ange ditt anv\xe4ndarnamn",
    "Forgot your password?": "Gl\xf6mt ditt l\xf6senord? ",
    "Hide password": "D\xf6lj l\xf6senord",
    Loading: "Laddar",
    "New password": "Nytt l\xf6senord",
    Password: "L\xf6senord",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Skicka koden igen",
    "Reset your password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Reset your Password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Send code": "Skicka kod",
    "Send Code": "Skicka kod",
    Sending: "Skickar",
    "Setup TOTP": "Konfigurera TOTP",
    "Show password": "Visa l\xf6senord",
    "Sign in to your account": "Logga in till ditt konto",
    "Sign In with Amazon": "Logga in med Amazon",
    "Sign In with Apple": "Logga in med Apple",
    "Sign In with Facebook": "Logga in med Facebook",
    "Sign In with Google": "Logga in med Google",
    "Sign in": "Logga in",
    "Sign In": "Logga in",
    "Signing in": "Loggar in",
    Skip: "Hoppa \xf6ver",
    Submit: "Skicka",
    Submitting: "Skickar in",
    Username: "Anv\xe4ndarnamn",
    "Verify Contact": "Verifiera kontakt",
    Verify: "Verifiera",
    "An account with the given email already exists.": "Det finns redan ett konto med denna e-postadress",
    "Confirm a Code": "Bekr\xe4fta koden",
    "Confirm Sign In": "Bekr\xe4fta inloggning",
    "Create account": "Skapa konto",
    "Enter your password": "Ange ditt l\xf6senord",
    "Forgot Password": "Gl\xf6mt l\xf6senordet",
    "Have an account? ": "Redan registrerad? ",
    "Incorrect username or password": "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    "Invalid password format": "Ogiltigt l\xf6senordsformat",
    "Invalid phone number format": "Ogiltigt format f\xf6r telefonnummer",
    "Lost your code? ": "F\xf6rlorat koden? ",
    "New Password": "Nytt l\xf6senord",
    "No account? ": "Inget konto? ",
    or: "eller",
    "Password attempts exceeded": "Maximalt antal felaktiga inloggningsf\xf6rs\xf6k har uppn\xe5tts",
    "Reset password": "\xc5terst\xe4ll l\xf6senord",
    "Sign Out": "Logga ut",
    "Sign Up": "Registrering",
    "User already exists": "Anv\xe4ndaren finns redan",
    "User does not exist": "Anv\xe4ndaren finns inte",
    "Username cannot be empty": "Anv\xe4ndarnamnet kan inte vara tomt",
    "We Emailed You": "Vi har skickat e-post till dig"
};


var $d48a27e3c5cfc2eb$export$710642024bfcbd8f = {
    "Account recovery requires verified contact information": "Pemulihan akun memerlukan informasi kontak terverifikasi",
    "Back to Sign In": "Kembali ke Masuk",
    "Change Password": "Ubah kata sandi",
    Changing: "Mengubah",
    Code: "Kode",
    "Confirm Password": "Konfirmasi kata sandi",
    "Confirm Sign Up": "Konfirmasi Pendaftaran",
    "Confirm SMS Code": "Konfirmasi Kode SMS",
    "Confirm TOTP Code": "Konfirmasi Kode TOTP",
    Confirm: "Konfirmasi",
    "Confirmation Code": "Kode Konfirmasi",
    Confirming: "Mengkonfirmasi",
    "Create a new account": "Buat akun baru",
    "Create Account": "Buat Akun",
    "Creating Account": "Membuat Akun",
    "Dismiss alert": "Hentikan pemberitahuan",
    Email: "Email",
    "Enter your code": "Masukkan kode anda",
    "Enter your email": "Masukkan email anda",
    "Enter your phone number": "Masukkan nomor telepon anda",
    "Enter your username": "Masukkan nama akun anda",
    "Forgot your password?": "Lupa kata sandi? ",
    "Hide password": "Sembunyikan kata sandi",
    Loading: "Memuat",
    "New password": "Kata sandi baru",
    Password: "Kata sandi",
    "Phone Number": "Nomor telepon",
    "Resend Code": "Kirim ulang kodenya",
    "Reset your Password": "Reset Kata Sandi",
    "Reset your password": "Ubah kata sandi anda",
    "Send code": "Kirim kode",
    "Send Code": "Kirim Kode",
    Sending: "Mengirim",
    "Setup TOTP": "Siapkan TOTP",
    "Show password": "Tampilkan kata sandi",
    "Sign in to your account": "Masuk akun anda",
    "Sign In with Amazon": "Masuk dengan Amazon",
    "Sign In with Apple": "Masuk dengan Apple",
    "Sign In with Facebook": "Masuk dengan Facebook",
    "Sign In with Google": "Masuk dengan Google",
    "Sign in": "Masuk",
    "Sign In": "Masuk",
    "Signing in": "Memasuki",
    Skip: "Lewati",
    Submit: "Ajukan",
    Submitting: "Mengajukan",
    Username: "Nama akun",
    "Verify Contact": "Verifikasi Kontak",
    Verify: "Verifikasi",
    "An account with the given email already exists.": "Akun dengan email tersebut sudah terdaftar.",
    "Attempt limit exceeded, please try after some time.": "Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.",
    "Cannot reset password for the user as there is no registered/verified email or phone_number": "Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon",
    Change: "Ubah",
    "Confirm a Code": "Konfirmasi kode",
    "Create account": "Buat akun",
    "Enter your password": "Masukkan kata sandi anda",
    "Forgot Password": "Lupa kata sandi",
    "Have an account? ": "Sudah punya akun? ",
    Hello: "Halo",
    "Incorrect username or password.": "Nama akun atau kata sandi salah.",
    "Invalid phone number format": "Nomor telepon tidak sesuai dengan format.",
    "Invalid verification code provided, please try again.": "Kode verifikasi tidak sesuai, mohon coba lagi.",
    "It may take a minute to arrive.": "Mungkin perlu beberapa waktu untuk tiba.",
    "Lost your code? ": "Kode anda hilang?",
    Name: "Nama",
    "Network error": "Galat jaringan",
    "No account? ": "Tidak ada akun?",
    or: "atau",
    "Password did not conform with policy: Password not long enough": "Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "Ubah kata sandi anda",
    Send: "Kirim",
    "Sign In with AWS": "Masuk dengan AWS",
    "Sign Up with Amazon": "Daftar dengan Amazon",
    "Sign Up with AWS": "Daftar dengan AWS",
    "Sign Up with Facebook": "Daftar dengan Facebook",
    "Sign Up with Google": "Daftar dengan Google",
    SMS: "SMS",
    "User already exists": "Akun sudah terdaftar",
    "User does not exist.": "Akun tidak terdaftar.",
    "User is disabled.": "Akun dinonaktifkan.",
    "Username cannot be empty": "Nama akun tidak boleh kosong",
    "Username/client id combination not found.": "Nama akun atau id tidak ditemukan.",
    "We Emailed You": "Kami mengirimkanmu email",
    "Your code is on the way. To log in, enter the code we emailed to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke",
    "Your code is on the way. To log in, enter the code we texted to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke",
    "Your passwords must match": "Kata sandi harus sama"
};


var $82ddd26d3ab2beb8$export$6961fa2059aeacf0 = {
    "Account recovery requires verified contact information": "Hesap kurtarma, do\u011Frulanm\u0131\u015F ileti\u015Fim bilgilerini gerektirir",
    "Back to Sign In": "Oturum A\xe7maya Geri D\xf6n",
    "Change Password": "\u015Eifreyi De\u011Fi\u015Ftir",
    Changing: "De\u011Fi\u015Ftiriliyor",
    Code: "Kod",
    "Confirm Password": "\u015Eifreyi Do\u011Frula",
    "Confirm Sign Up": "Kay\u0131t \u0130\u015Flemini Do\u011Frula",
    "Confirm SMS Code": "SMS Kodunu Do\u011Frula",
    "Confirm TOTP Code": "Tek Kullan\u0131ml\u0131k \u015Eifreyi Do\u011Frula",
    Confirm: "Do\u011Frula",
    "Confirmation Code": "Do\u011Frulama Kodu",
    Confirming: "Do\u011Frulan\u0131yor",
    "Create a new account": "Yeni bir hesap olu\u015Ftur",
    "Create Account": "Hesap Olu\u015Ftur",
    "Creating Account": "Hesap Olu\u015Fturuluyor",
    "Dismiss alert": "Uyar\u0131y\u0131 reddet",
    Email: "E-posta",
    "Enter your code": "Kodu girin",
    "Enter your email": "E-posta adresinizi girin",
    "Enter your phone number": "Telefon numaran\u0131z\u0131 girin",
    "Enter your username": "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
    "Forgot your password?": "\u015Eifrenizi mi unuttunuz?",
    "Hide password": "\u015Eifreyi gizle",
    Loading: "Y\xfckleniyor",
    "New password": "Yeni \u015Fifre",
    Password: "\u015Eifre",
    "Phone Number": "Telefon Numaras\u0131",
    "Resend Code": "Kodu Yeniden G\xf6nder",
    "Reset your password": "\u015Eifrenizi s\u0131f\u0131rlay\u0131n",
    "Reset your Password": "\u015Eifrenizi S\u0131f\u0131rlay\u0131n",
    "Send code": "Kod g\xf6nder",
    "Send Code": "Kod G\xf6nder",
    Sending: "G\xf6nderiliyor",
    "Setup TOTP": "Tek kullan\u0131ml\u0131k \u015Fifre kurulumu yap",
    "Show password": "\u015Eifreyi g\xf6ster",
    "Sign in to your account": "Hesab\u0131n\u0131zda oturum a\xe7\u0131n",
    "Sign In with Amazon": "Amazon ile Oturum A\xe7",
    "Sign In with Apple": "Apple ile Oturum A\xe7",
    "Sign In with Facebook": "Facebook ile Oturum A\xe7",
    "Sign In with Google": "Google ile Oturum A\xe7",
    "Sign in": "Oturum a\xe7",
    "Sign In": "Oturum A\xe7",
    "Signing in": "Oturum a\xe7\u0131l\u0131yor",
    Skip: "Atla",
    Submit: "G\xf6nder",
    Submitting: "G\xf6nderiliyor",
    Username: "Kullan\u0131c\u0131 ad\u0131",
    "Verify Contact": "Ki\u015Fiyi Do\u011Frula",
    Verify: "Do\u011Frula",
    "An account with the given email already exists.": "Bu e-postaya ait zaten bir hesap var.",
    "Confirm Sign In": "Oturum A\xe7may\u0131 Do\u011Frula",
    "Have an account? ": "Hesab\u0131n\u0131z var m\u0131? ",
    "Incorrect username or password": "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre",
    "Invalid password format": "Ge\xe7ersiz parola format\u0131",
    "Invalid phone number format": "Ge\xe7ersiz telefon numaras\u0131 format\u0131",
    "Lost your code? ": "Kodu mu kaybettiniz? ",
    "No account? ": "Hesab\u0131n\u0131z yok mu? ",
    or: "veya",
    "Password attempts exceeded": "Maksimum oturum a\xe7ma giri\u015Fimi a\u015F\u0131ld\u0131",
    "Sign Out": "\xc7\u0131k\u0131\u015F yap",
    "Sign Up": "Kay\u0131t Ol",
    "User already exists": "Bu kullan\u0131c\u0131 zaten var",
    "User does not exist": "B\xf6yle bir kullan\u0131c\u0131 mevcut de\u011Fil",
    "Username cannot be empty": "Kullan\u0131c\u0131 ad\u0131 bo\u015F olamaz"
};


var $8baf0792046649b2$export$6240aeddf7c74bb8 = {
    "Account recovery requires verified contact information": "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434, \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438",
    "Change Password": "\u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
    "Confirm Sign Up": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    "Confirm SMS Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 CMC-\u041A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 TOTP-\u041A\u043E\u0434",
    Confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044C",
    "Confirmation Code": "\u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
    Confirming: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
    "Create a new account": "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Create Account": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Creating Account": "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
    "Dismiss alert": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
    Email: "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your code": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u041A\u043E\u0434",
    "Enter your email": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your phone number": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Enter your username": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Forgot your password?": "\u0417\u0430\u0431\u044B\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    "New password": "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Resend Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u044C \u0435\u0449\u0435 \u0440\u0430\u0437 \u041A\u043E\u0434",
    "Reset your password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u041F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    "Send Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    Sending: "\u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430",
    "Setup TOTP": "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0437\u043D\u0430\u043A \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    "Sign In with Amazon": "\u0437\u043D\u0430\u043A \u0432 \u0441 Amazon",
    "Sign In with Apple": "\u0437\u043D\u0430\u043A \u0432 \u0441 Apple",
    "Sign In with Facebook": "\u0437\u043D\u0430\u043A \u0432 \u0441 Facebook",
    "Sign In with Google": "\u0437\u043D\u0430\u043A \u0432 \u0441 Google",
    "Sign in": "\u0437\u043D\u0430\u043A \u0432",
    "Sign In": "\u0437\u043D\u0430\u043A \u0432",
    "Signing in": "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0442\u044C",
    Submit: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435",
    Submitting: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0432",
    Username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Verify Contact": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C"
};


var $4bf027fbf863856e$export$320d289eca4cc695 = {
    BACK_SIGN_IN: "Back to Sign In",
    BIRTHDATE: "Birthdate",
    CHANGE_PASSWORD: "Change Password",
    CHANGING_PASSWORD: "Changing",
    CODE: "Code",
    CONFIRM_PASSWORD: "Confirm Password",
    CONFIRM_RESET_PASSWORD_HEADING: "Reset your Password",
    CONFIRM_SIGNUP_HEADING: "Confirm Sign Up",
    CONFIRM_SMS: "Confirm SMS Code",
    CONFIRM_TOTP: "Confirm TOTP Code",
    CONFIRM: "Confirm",
    CONFIRMATION_CODE: "Confirmation Code",
    CONFIRMING: "Confirming",
    CREATE_ACCOUNT: "Create Account",
    CREATING_ACCOUNT: "Creating Account",
    EMAIL_ADDRESS: "Email",
    ENTER_CODE: "Enter your code",
    ENTER_USERNAME: "Enter your username",
    FAMILY_NAME: "Family Name",
    GIVEN_NAME: "Given Name",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    FORGOT_YOUR_PASSWORD_LEGACY: "Forgot your password? ",
    HIDE_PASSWORD: "Hide password",
    LOADING: "Loading",
    LOGIN_NAME: "Username",
    MIDDLE_NAME: "Middle Name",
    NAME: "Name",
    NICKNAME: "Nickname",
    NEW_PASSWORD: "New password",
    PASSWORD: "Password",
    PHONE_NUMBER: "Phone Number",
    PREFERRED_USERNAME: "Preferred Username",
    PROFILE: "Profile",
    RESEND_CODE: "Resend Code",
    RESET_PASSWORD_HEADING: "Reset your password",
    RESET_PASSWORD: "Reset Password",
    SEND_CODE: "Send code",
    SENDING: "Sending",
    SETUP_TOTP: "Setup TOTP",
    SHOW_PASSWORD: "Show password",
    SIGN_IN_BUTTON: "Sign in",
    SIGN_IN_TAB: "Sign In",
    SIGN_IN_WITH_AMAZON: "Sign In with Amazon",
    SIGN_IN_WITH_APPLE: "Sign In with Apple",
    SIGN_IN_WITH_FACEBOOK: "Sign In with Facebook",
    SIGN_IN_WITH_GOOGLE: "Sign In with Google",
    SIGN_IN: "Sign in to your account",
    SIGN_UP_BUTTON: "Create a new account",
    SIGNING_IN_BUTTON: "Signing in",
    SKIP: "Skip",
    SUBMIT: "Submit",
    SUBMITTING: "Submitting",
    VERIFY_CONTACT: "Verify Contact",
    VERIFY_HEADING: "Account recovery requires verified contact information",
    VERIFY: "Verify",
    WEBSITE: "Website"
};


var $d4e415c2bc764a95$export$cca4a41bdb910c51 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $a8970915757c176b$export$cca4a41bdb910c51)), $d4e415c2bc764a95$export$eb91f595f110d703 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $c3b0f98bf3b332cf$export$eb91f595f110d703)), $d4e415c2bc764a95$export$1d204a99f5862ba9 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $baeb34dab8ae3620$export$1d204a99f5862ba9)), $d4e415c2bc764a95$export$8cfa91bfcf8d11c8 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $ddc24953b2c79e64$export$8cfa91bfcf8d11c8)), $d4e415c2bc764a95$export$5c8da73de176fccc = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $3aec870541e38948$export$5c8da73de176fccc)), $d4e415c2bc764a95$export$c416809cd76fbf21 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $c8f7199ac82f3699$export$c416809cd76fbf21)), $d4e415c2bc764a95$export$fb1930c2b96707b2 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $7e48350d7a995c9f$export$fb1930c2b96707b2)), $d4e415c2bc764a95$export$8569df33fbaae243 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $c1f0817968ebbd13$export$8569df33fbaae243)), $d4e415c2bc764a95$export$6fb0e8139f7ef98d = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $922470b85f36d842$export$6fb0e8139f7ef98d)), $d4e415c2bc764a95$export$c7dddbf179b434d1 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $24f1642b0a936605$export$c7dddbf179b434d1)), $d4e415c2bc764a95$export$2a86dc37ee9734c = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $b5f229cd9c4dc153$export$2a86dc37ee9734c)), $d4e415c2bc764a95$export$9f1a61f9baaa2d2e = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $e77e3731bb4362c2$export$9f1a61f9baaa2d2e)), $d4e415c2bc764a95$export$710642024bfcbd8f = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $d48a27e3c5cfc2eb$export$710642024bfcbd8f)), $d4e415c2bc764a95$export$6961fa2059aeacf0 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $82ddd26d3ab2beb8$export$6961fa2059aeacf0)), $d4e415c2bc764a95$export$6240aeddf7c74bb8 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $8baf0792046649b2$export$6240aeddf7c74bb8)), $d4e415c2bc764a95$export$320d289eca4cc695 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $4bf027fbf863856e$export$320d289eca4cc695));


var $a8222690d8473c9c$export$6ba37fd455cdd594 = (0, $6bbabf3c01bf9470$export$18ce0697a983be9b)({}, (0, $d4e415c2bc764a95$export$320d289eca4cc695));
function $a8222690d8473c9c$export$d73ee8ef04f5226a(r) {
    return (0, $a204f73577cd8409$export$dbe3113d60765c1a).get(r);
}
function $a8222690d8473c9c$export$8a4bbd9646545970(r) {
    return (0, $a204f73577cd8409$export$dbe3113d60765c1a).get(r) !== r;
}
var $a8222690d8473c9c$export$150b732325d14d04 = {
    de: (0, $d4e415c2bc764a95$export$cca4a41bdb910c51),
    en: (0, $d4e415c2bc764a95$export$eb91f595f110d703),
    es: (0, $d4e415c2bc764a95$export$1d204a99f5862ba9),
    fr: (0, $d4e415c2bc764a95$export$8cfa91bfcf8d11c8),
    id: (0, $d4e415c2bc764a95$export$710642024bfcbd8f),
    it: (0, $d4e415c2bc764a95$export$5c8da73de176fccc),
    ja: (0, $d4e415c2bc764a95$export$c416809cd76fbf21),
    kr: (0, $d4e415c2bc764a95$export$fb1930c2b96707b2),
    nl: (0, $d4e415c2bc764a95$export$8569df33fbaae243),
    pl: (0, $d4e415c2bc764a95$export$6fb0e8139f7ef98d),
    pt: (0, $d4e415c2bc764a95$export$c7dddbf179b434d1),
    zh: (0, $d4e415c2bc764a95$export$2a86dc37ee9734c),
    sv: (0, $d4e415c2bc764a95$export$9f1a61f9baaa2d2e),
    tr: (0, $d4e415c2bc764a95$export$6961fa2059aeacf0),
    ru: (0, $d4e415c2bc764a95$export$6240aeddf7c74bb8)
};


var $acw62 = parcelRequire("acw62");


var $6fe1d0f9db543746$export$a51e8cda1526c737 = [
    "+1",
    "+7",
    "+20",
    "+27",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+36",
    "+39",
    "+40",
    "+41",
    "+43",
    "+44",
    "+45",
    "+46",
    "+47",
    "+48",
    "+49",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+81",
    "+82",
    "+84",
    "+86",
    "+90",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+98",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+223",
    "+224",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+230",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+242",
    "+243",
    "+244",
    "+245",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+345",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+356",
    "+357",
    "+358",
    "+359",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+385",
    "+386",
    "+387",
    "+389",
    "+420",
    "+421",
    "+423",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+537",
    "+590",
    "+591",
    "+593",
    "+594",
    "+595",
    "+596",
    "+597",
    "+598",
    "+599",
    "+670",
    "+672",
    "+673",
    "+674",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+687",
    "+688",
    "+689",
    "+690",
    "+691",
    "+692",
    "+850",
    "+852",
    "+853",
    "+855",
    "+856",
    "+872",
    "+880",
    "+886",
    "+960",
    "+961",
    "+962",
    "+963",
    "+964",
    "+965",
    "+966",
    "+967",
    "+968",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998"
];



var $14a27b5008d5fd79$export$1222d357a3c2c47f = {
    birthdate: {
        label: "Birthdate",
        labelHidden: !0,
        placeholder: "Birthdate",
        type: "date",
        autocomplete: "bday",
        isRequired: !0
    },
    confirmation_code: {
        label: "Confirmation Code",
        labelHidden: !0,
        placeholder: "Code",
        type: "number",
        autocomplete: "one-time-code",
        isRequired: !0
    },
    confirm_password: {
        label: "Confirm Password",
        labelHidden: !0,
        placeholder: "Confirm Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    email: {
        label: "Email",
        labelHidden: !0,
        placeholder: "Email",
        type: "email",
        autocomplete: "username",
        isRequired: !0
    },
    family_name: {
        label: "Family Name",
        labelHidden: !0,
        placeholder: "Family Name",
        type: "text",
        autocomplete: "family-name",
        isRequired: !0
    },
    given_name: {
        label: "Given Name",
        labelHidden: !0,
        placeholder: "Given Name",
        type: "text",
        autocomplete: "given-name",
        isRequired: !0
    },
    middle_name: {
        label: "Middle Name",
        labelHidden: !0,
        placeholder: "Middle Name",
        type: "text",
        autocomplete: "additional-name",
        isRequired: !0
    },
    name: {
        label: "Name",
        labelHidden: !0,
        placeholder: "Name",
        type: "text",
        autocomplete: "name",
        isRequired: !0
    },
    nickname: {
        label: "Nickname",
        labelHidden: !0,
        placeholder: "Nickname",
        type: "text",
        autocomplete: "tel",
        isRequired: !0
    },
    password: {
        label: "Password",
        labelHidden: !0,
        placeholder: "Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    phone_number: {
        label: "Phone Number",
        labelHidden: !0,
        placeholder: "Phone",
        type: "tel",
        autocomplete: "tel",
        dialCode: "+1",
        dialCodeList: (0, $6fe1d0f9db543746$export$a51e8cda1526c737),
        isRequired: !0
    },
    preferred_username: {
        label: "Preferred Username",
        labelHidden: !0,
        placeholder: "Preferred Username",
        type: "text",
        isRequired: !0
    },
    profile: {
        label: "Profile",
        labelHidden: !0,
        placeholder: "Profile",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    website: {
        label: "Website",
        labelHidden: !0,
        placeholder: "Website",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    username: {
        label: "Username",
        labelHidden: !0,
        placeholder: "Username",
        type: "text",
        autocomplete: "username",
        isRequired: !0
    }
}, $14a27b5008d5fd79$export$4223938282102ea7 = [
    "^",
    "$",
    "*",
    ".",
    "[",
    "]",
    "{",
    "}",
    "(",
    ")",
    "?",
    '"',
    "!",
    "@",
    "#",
    "%",
    "&",
    "/",
    "\\",
    ",",
    ">",
    "<",
    "'",
    ":",
    ";",
    "|",
    "_",
    "~",
    "`",
    "=",
    "+",
    "-",
    " "
];


var $5c16c933f208f780$export$3c7f711f5942602f = function(t) {
    var e = t.packageName, a = t.version;
    (0, $68caf4bd6c7da8b9$export$ad34c5a3baecdb02)("".concat(e, "/").concat(a));
}, $5c16c933f208f780$export$655775443891f2b8 = function(t) {
    for(var n = t.trim().split(""), e = 0; e < n.length; e++)e > 0 && e < n.length - 1 && (n[e] = "*");
    return n.join("");
}, $5c16c933f208f780$export$72b2b64445441bf7 = function(t) {
    if (t.length < 4) return t;
    for(var n = t.split(""), e = 0; e < n.length - 4; e++)n[e] = "*";
    return n.join("");
}, $5c16c933f208f780$export$f726708373635d8a = function(t, n) {
    var e = n.send, a = n.getSnapshot();
    switch(t.payload.event){
        case "tokenRefresh":
            a.matches("authenticated.idle") && e("TOKEN_REFRESH");
            break;
        case "signOut":
        case "tokenRefresh_failure":
            a.matches("authenticated.idle") && e("SIGN_OUT");
    }
}, $5c16c933f208f780$export$4776c363cae9362c = function(n, e) {
    return void 0 === e && (e = $5c16c933f208f780$export$f726708373635d8a), (0, $1a908fb961b3fa6b$export$8c41bb232f1008b1).listen("auth", function(t) {
        e(t, n);
    }, "authenticator-hub-handler");
}, $5c16c933f208f780$export$1ec93875315f071d = function(t) {
    return (0, $14a27b5008d5fd79$export$4223938282102ea7).some(function(n) {
        return t.includes(n);
    });
}, $5c16c933f208f780$export$f1f323074be5cac0 = function(t, n, e) {
    return encodeURI("otpauth://totp/".concat(t, ":").concat(n, "?secret=").concat(e, "&issuer=").concat(t));
};




var $acw62 = parcelRequire("acw62");
const $a3f1af57078aa690$export$da5ac45a736a5880 = $acw62.createContext(null), $a3f1af57078aa690$export$b0e9d19f717d0a5c = ()=>{
    const e = $acw62.useContext($a3f1af57078aa690$export$da5ac45a736a5880);
    if (!e) throw new Error("`useCustomComponents` cannot be used outside of a `CustomComponentsContext.Provider`");
    return e;
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




const $cdee2f99629198c8$var$n = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
}, $cdee2f99629198c8$export$a8a3e93435678ff9 = $acw62.forwardRef((o, c)=>{
    var { className: l, children: d, isTruncated: h, level: f = 6 } = o, p = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className",
        "children",
        "isTruncated",
        "level"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: $cdee2f99629198c8$var$n[f],
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Heading, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Heading, f), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Heading, "truncated", h), l),
        ref: c
    }, p), d);
});
$cdee2f99629198c8$export$a8a3e93435678ff9.displayName = "Heading";






var $acw62 = parcelRequire("acw62");
const $2acbce06560f1e5e$export$896ffc81198e4315 = (r)=>"object" == typeof r && null !== r && "message" in r && "string" == typeof r.message, $2acbce06560f1e5e$export$b41f3ff9bba7a33e = (e)=>{
    if ($2acbce06560f1e5e$export$896ffc81198e4315(e)) return e;
    try {
        return new Error(JSON.stringify(e));
    } catch (r) {
        return new Error(String(e));
    }
}, $2acbce06560f1e5e$export$82f46aa4e6535a45 = (r)=>$2acbce06560f1e5e$export$b41f3ff9bba7a33e(r).message, $2acbce06560f1e5e$export$e29bbbec84471f66 = (r)=>{
    const e = new FormData(r.target);
    return Object.fromEntries(e);
};



function $074a34efe153cfb4$export$df6a82844cee724c() {
    const { submitForm: a, updateBlur: m, updateForm: u } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.submitForm,
            e.updateBlur,
            e.updateForm
        ]);
    return {
        handleBlur: (0, $acw62.useCallback)(({ target: { name: e } })=>{
            m({
                name: e
            });
        }, [
            m
        ]),
        handleChange: (0, $acw62.useCallback)(({ target: { checked: e, name: t, type: r, value: a } })=>{
            u({
                name: t,
                value: "checkbox" === r && !e ? void 0 : a
            });
        }, [
            u
        ]),
        handleSubmit: (0, $acw62.useCallback)((e)=>{
            e.preventDefault(), a((0, $2acbce06560f1e5e$export$e29bbbec84471f66)(e));
        }, [
            a
        ])
    };
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


const $f7e7ecf5ec708aa8$export$8fb9587943155ce3 = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $ba13fb0f3580930d$export$66493327321323ad = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $e922a6ea34703fd3$export$340bfce9b4df026b = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $0f19969c9520fc8b$export$5be70e40251e6f9b = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
        fill: "currentColor"
    })));
};


const $900202dfa1b87786$export$4a143c8822a09fb4 = ({ variation: s, ariaHidden: t })=>{
    switch(s){
        case "info":
            return $acw62.createElement((0, $e922a6ea34703fd3$export$340bfce9b4df026b), {
                "aria-hidden": t,
                className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).AlertIcon
            });
        case "error":
            return $acw62.createElement((0, $ba13fb0f3580930d$export$66493327321323ad), {
                "aria-hidden": t,
                className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).AlertIcon
            });
        case "warning":
            return $acw62.createElement((0, $0f19969c9520fc8b$export$5be70e40251e6f9b), {
                "aria-hidden": t,
                className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).AlertIcon
            });
        case "success":
            return $acw62.createElement((0, $f7e7ecf5ec708aa8$export$8fb9587943155ce3), {
                "aria-hidden": t,
                className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).AlertIcon
            });
        default:
            return null;
    }
};
$900202dfa1b87786$export$4a143c8822a09fb4.displayName = "AlertIcon";



const $d8d3b3c99706f583$export$caec2af78bcc877f = $acw62.forwardRef((f, p)=>{
    var { buttonRef: u, children: b, className: h, dismissButtonLabel: j = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).Alert.dismissButtonLabel, hasIcon: A = !0, heading: E, isDismissible: N = !1, onDismiss: v, variation: B } = f, D = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(f, [
        "buttonRef",
        "children",
        "className",
        "dismissButtonLabel",
        "hasIcon",
        "heading",
        "isDismissible",
        "onDismiss",
        "variation"
    ]);
    const [I, g] = $acw62.useState(!1), x = $acw62.useCallback(()=>{
        g(!I), (0, $8b520a117f46c559$export$f6e2535fb5126e54)(v) && v();
    }, [
        g,
        v,
        I
    ]);
    return !I && $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Alert, h, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Alert, B)),
        "data-variation": B,
        ref: p,
        role: "alert"
    }, D), A && $acw62.createElement((0, $900202dfa1b87786$export$4a143c8822a09fb4), {
        variation: B,
        ariaHidden: !0
    }), $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        flex: "1"
    }, E && $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).AlertHeading
    }, E), $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).AlertBody
    }, b)), N && $acw62.createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        ariaLabel: j,
        variation: "link",
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).AlertDismiss,
        onClick: x,
        ref: u
    }, $acw62.createElement((0, $e9c1137b37a4e89f$export$e04bcc6127e699bf), {
        "aria-hidden": "true"
    })));
});
$d8d3b3c99706f583$export$caec2af78bcc877f.displayName = "Alert";


const $9425ed193731c948$export$3caa4b6a8cb6c61a = ()=>{
    const { error: o } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((r)=>[
            r.error
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, o ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8d3b3c99706f583$export$caec2af78bcc877f), {
        variation: "error",
        isDismissible: !0
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(o)) : null);
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $cb1c3cdbc10c77c4$export$43a753047a354e27 = [
    "birthdate",
    "email",
    "family_name",
    "given_name",
    "middle_name",
    "name",
    "nickname",
    "phone_number",
    "preferred_username",
    "profile",
    "website"
], $cb1c3cdbc10c77c4$export$a263a0ca54f86170 = [
    "address",
    "gender",
    "locale",
    "picture",
    "updated_at",
    "zoneinfo"
], $cb1c3cdbc10c77c4$export$c3f13f1789f7946b = [
    "username",
    "email",
    "phone_number"
], $cb1c3cdbc10c77c4$export$ee5f111526f572af = (0, $6bbabf3c01bf9470$export$1216008129fb82ed)((0, $6bbabf3c01bf9470$export$1216008129fb82ed)((0, $6bbabf3c01bf9470$export$1216008129fb82ed)([], $cb1c3cdbc10c77c4$export$c3f13f1789f7946b, !0), $cb1c3cdbc10c77c4$export$43a753047a354e27, !0), [
    "confirmation_code",
    "password",
    "confirm_password"
], !1);



var $14016dd608f30925$export$e29bbbec84471f66 = function(r) {
    var t = new FormData(r.target);
    return Object.fromEntries(t);
}, $14016dd608f30925$export$b5859dd113079414 = function(t, n) {
    var e = [];
    return t && (e = Object.keys(t).reduce(function(r, n) {
        var e;
        return r.push([
            n,
            null === (e = t[n]) || void 0 === e ? void 0 : e.order
        ]), r;
    }, []).sort(function(r, t) {
        return r[1] - t[1];
    }).filter(function(r) {
        return void 0 !== r[1];
    }).map(function(r) {
        return r[0];
    })), Array.from(new Set((0, $6bbabf3c01bf9470$export$1216008129fb82ed)((0, $6bbabf3c01bf9470$export$1216008129fb82ed)([], e, !0), n, !0)));
}, $14016dd608f30925$export$3237178b1c616b9f = function(r) {
    return (0, $cb1c3cdbc10c77c4$export$ee5f111526f572af).includes(r);
}, $14016dd608f30925$export$501239432719417d = function(r) {
    var t;
    return r ? (t = r, Array.isArray(t) ? r : [
        r
    ]) : null;
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


const $3c9dccef80effa3d$export$9ef36bcf05bb63d9 = (m)=>{
    const { className: o } = m, a = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, o)
    }, a), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 6.0002C15.79 6.0002 19.17 8.1302 20.82 11.5002C20.23 12.7202 19.4 13.7702 18.41 14.6202L19.82 16.0302C21.21 14.8002 22.31 13.2602 23 11.5002C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.01 6.2202C10.66 6.0902 11.32 6.0002 12 6.0002ZM10.93 7.14019L13 9.2102C13.57 9.4602 14.03 9.9202 14.28 10.4902L16.35 12.5602C16.43 12.2202 16.49 11.8602 16.49 11.4902C16.5 9.0102 14.48 7.0002 12 7.0002C11.63 7.0002 11.28 7.05019 10.93 7.14019ZM2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.98 18.7102 16.32 18.1802L19.74 21.6002L21.15 20.1902L3.42 2.4502L2.01 3.8702ZM9.51 11.3702L12.12 13.9802C12.08 13.9902 12.04 14.0002 12 14.0002C10.62 14.0002 9.5 12.8802 9.5 11.5002C9.5 11.4502 9.51 11.4202 9.51 11.3702V11.3702ZM6.11 7.97019L7.86 9.7202C7.63 10.2702 7.5 10.8702 7.5 11.5002C7.5 13.9802 9.52 16.0002 12 16.0002C12.63 16.0002 13.23 15.8702 13.77 15.6402L14.75 16.6202C13.87 16.8602 12.95 17.0002 12 17.0002C8.21 17.0002 4.83 14.8702 3.18 11.5002C3.88 10.0702 4.9 8.89019 6.11 7.97019Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $5ad54cfafd9b92ee$export$e8b904c5d6d728c0 = (o)=>{
    const { className: a } = o, C = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, C), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
        fill: "currentColor"
    })));
};


const { passwordIsHidden: $d7e51178e736f4c9$var$n, passwordIsShown: $d7e51178e736f4c9$var$l, showPassword: $d7e51178e736f4c9$var$w } = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PasswordField, $d7e51178e736f4c9$export$c42f83a0ca8c8188 = $acw62.forwardRef((i, m)=>{
    var { fieldType: p, passwordIsHiddenLabel: c = $d7e51178e736f4c9$var$n, passwordIsShownLabel: f = $d7e51178e736f4c9$var$l, showPasswordButtonLabel: b = $d7e51178e736f4c9$var$w, size: h } = i, I = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "fieldType",
        "passwordIsHiddenLabel",
        "passwordIsShownLabel",
        "showPasswordButtonLabel",
        "size"
    ]);
    return $acw62.createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), Object.assign({
        "aria-checked": "password" !== p,
        ariaLabel: b,
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldShowPassword,
        ref: m,
        role: "switch",
        size: h
    }, I), $acw62.createElement((0, $7fe1470fea4c3ff2$export$439d29a4e110a164), {
        "aria-live": "polite"
    }, "password" === p ? c : f), "password" === p ? $acw62.createElement((0, $5ad54cfafd9b92ee$export$e8b904c5d6d728c0), {
        size: h
    }) : $acw62.createElement((0, $3c9dccef80effa3d$export$9ef36bcf05bb63d9), {
        size: h
    }));
});
$d7e51178e736f4c9$export$c42f83a0ca8c8188.displayName = "ShowPasswordButton";



const $3e8af8b64d5d58ec$export$65ed9482db2257fa = $acw62.forwardRef((l, d)=>{
    var { autoComplete: w = "current-password", label: n, className: i, hideShowPassword: p = !1, passwordIsHiddenLabel: m, passwordIsShownLabel: u, showPasswordButtonLabel: b, showPasswordButtonRef: c, size: h } = l, f = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(l, [
        "autoComplete",
        "label",
        "className",
        "hideShowPassword",
        "passwordIsHiddenLabel",
        "passwordIsShownLabel",
        "showPasswordButtonLabel",
        "showPasswordButtonRef",
        "size"
    ]);
    const [P, L] = $acw62.useState("password"), S = $acw62.useCallback(()=>{
        L("password" === P ? "text" : "password");
    }, [
        L,
        P
    ]);
    return $acw62.createElement((0, $4dd4eb3a13974ce8$export$2c73285ae9390cec), Object.assign({
        autoComplete: w,
        isMultiline: !1,
        outerEndComponent: p ? null : $acw62.createElement((0, $d7e51178e736f4c9$export$c42f83a0ca8c8188), {
            fieldType: P,
            onClick: S,
            passwordIsHiddenLabel: m,
            passwordIsShownLabel: u,
            ref: c,
            size: h,
            showPasswordButtonLabel: b
        }),
        size: h,
        type: P,
        label: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PasswordField, i),
        ref: d
    }, f));
});
$3e8af8b64d5d58ec$export$65ed9482db2257fa.displayName = "PasswordField";




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


const $d1ebe27a2c7f2f3c$export$e0c00b3c5102a294 = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
        fill: "currentColor"
    })));
};


const $33fbfe8dfe5f46ed$export$ef9b1a59e592288f = $acw62.forwardRef((m, n)=>{
    var { autoComplete: d, className: p, size: u, variation: f, value: v, defaultValue: h, hasError: E, icon: S = $acw62.createElement((0, $d1ebe27a2c7f2f3c$export$e0c00b3c5102a294), null), iconColor: j, children: C, placeholder: N, isDisabled: b, isRequired: V } = m, x = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "autoComplete",
        "className",
        "size",
        "variation",
        "value",
        "defaultValue",
        "hasError",
        "icon",
        "iconColor",
        "children",
        "placeholder",
        "isDisabled",
        "isRequired"
    ]);
    const q = void 0 === v && void 0 === h && N, w = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Select, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).FieldGroupControl, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Select, u), (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Select, f), (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Select, "error", E), p);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).SelectWrapper
    }, $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        "aria-invalid": E,
        as: "select",
        autoComplete: d,
        value: v,
        defaultValue: q ? "" : h,
        isDisabled: b,
        required: V,
        "data-size": u,
        "data-variation": f,
        className: w,
        ref: n
    }, x), N && $acw62.createElement("option", {
        value: ""
    }, N), C), $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).SelectIconWrapper,
        color: j
    }, S));
});
$33fbfe8dfe5f46ed$export$ef9b1a59e592288f.displayName = "Select";




const $ba712d0ccb44a817$export$d55b50a564d0b931 = $acw62.forwardRef((c, p)=>{
    const { children: f, className: h, descriptiveText: b, errorMessage: F, hasError: j = !1, id: E, label: u, labelHidden: g = !1, options: v, size: y, testId: S } = c, x = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(c, [
        "children",
        "className",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "label",
        "labelHidden",
        "options",
        "size",
        "testId"
    ]), I = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(E), z = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(), H = b ? z : void 0, { flexContainerStyleProps: M, baseStyleProps: N, rest: T } = (0, $977c7c783ee37387$export$584a75f5facb0a5)(x);
    return $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Field, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).SelectField, h),
        "data-size": y,
        testId: S
    }, N, M), $acw62.createElement((0, $0c39af73c6023b8b$export$b04be29aa201d4f5), {
        htmlFor: I,
        visuallyHidden: g
    }, u), $acw62.createElement((0, $696539b8ac1b8264$export$873ced4623a3149c), {
        id: z,
        labelHidden: g,
        descriptiveText: b
    }), $acw62.createElement((0, $33fbfe8dfe5f46ed$export$ef9b1a59e592288f), Object.assign({
        "aria-describedby": H,
        hasError: j,
        id: I,
        ref: p,
        size: y
    }, T), (({ children: e, options: t })=>e ? ((null == t ? void 0 : t.length) && console.warn("Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children."), e) : null == t ? void 0 : t.map((e, t)=>$acw62.createElement("option", {
                label: e,
                value: e,
                key: `${e}-${t}`
            }, e)))({
        children: f,
        options: v
    })), $acw62.createElement((0, $7c590db08e2c3ed8$export$1c081951d49ad6f6), {
        hasError: j,
        errorMessage: F
    }));
});
$ba712d0ccb44a817$export$d55b50a564d0b931.displayName = "SelectField";


const $54370cc7c5e464e7$export$3978650a8f87744f = $acw62.forwardRef((r, i)=>{
    var { className: m, dialCodeList: d, isReadOnly: c } = r, n = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(r, [
        "className",
        "dialCodeList",
        "isReadOnly"
    ]);
    const p = null != d ? d : (0, $6fe1d0f9db543746$export$a51e8cda1526c737), f = $acw62.useMemo(()=>p.map((e)=>$acw62.createElement("option", {
                key: e,
                value: e,
                disabled: c
            }, e)), [
        p,
        c
    ]);
    return $acw62.createElement((0, $ba712d0ccb44a817$export$d55b50a564d0b931), Object.assign({
        "aria-disabled": c,
        autoComplete: "tel-country-code",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).CountryCodeSelect, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).DialCodeSelect, m),
        labelHidden: !0,
        ref: i
    }, n), f);
});
$54370cc7c5e464e7$export$3978650a8f87744f.displayName = "CountryCodeSelect";



const $78a8b0923523d237$export$522a16be7a55e553 = $acw62.forwardRef((d, n)=>{
    var { autoComplete: s = "tel-national", className: C, countryCodeName: m, countryCodeLabel: u = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PhoneNumberField.countryCodeLabel, countryCodeRef: c, defaultCountryCode: y, defaultDialCode: f, dialCodeLabel: p = (0, $eb5f843fca4db3c6$export$529e7eefcb1e2a4c).PhoneNumberField.countryCodeLabel, dialCodeList: b, dialCodeName: h, dialCodeRef: N, hasError: L, isDisabled: R, isReadOnly: D, onCountryCodeChange: g, onDialCodeChange: E, onInput: F, size: v, type: O, variation: j } = d, z = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "autoComplete",
        "className",
        "countryCodeName",
        "countryCodeLabel",
        "countryCodeRef",
        "defaultCountryCode",
        "defaultDialCode",
        "dialCodeLabel",
        "dialCodeList",
        "dialCodeName",
        "dialCodeRef",
        "hasError",
        "isDisabled",
        "isReadOnly",
        "onCountryCodeChange",
        "onDialCodeChange",
        "onInput",
        "size",
        "type",
        "variation"
    ]);
    const P = h || m, x = p || u, I = f || y, S = E || g, T = N || c;
    return $acw62.createElement((0, $4dd4eb3a13974ce8$export$2c73285ae9390cec), Object.assign({
        outerStartComponent: $acw62.createElement((0, $54370cc7c5e464e7$export$3978650a8f87744f), {
            defaultValue: I,
            dialCodeList: b,
            className: C,
            hasError: L,
            isDisabled: R,
            isReadOnly: D,
            label: x,
            name: P,
            onChange: S,
            ref: T,
            size: v,
            variation: j
        }),
        autoComplete: s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).PhoneNumberField, C),
        hasError: L,
        isDisabled: R,
        isReadOnly: D,
        isMultiline: !1,
        onInput: F,
        ref: n,
        size: v,
        type: "tel",
        variation: j
    }, z));
});
$78a8b0923523d237$export$522a16be7a55e553.displayName = "PhoneNumberField";





var $acw62 = parcelRequire("acw62");



const $7cdd4ab3d2268ab5$export$db10347ccaf03b65 = ({ errors: o, id: m })=>(null == o ? void 0 : o.length) > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        "data-amplify-sign-up-errors": !0,
        id: m
    }, o.map((i)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1eea10f2f5922b0$export$5f1af8db9871e1d6), {
            key: i,
            role: "alert",
            variation: "error"
        }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(i)))) : null;



function $dbc403e9c4523b2e$export$56e87bf42978147a(n) {
    var { autocomplete: d, dialCode: p, name: c, type: u } = n, E = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(n, [
        "autocomplete",
        "dialCode",
        "name",
        "type"
    ]);
    const { validationErrors: b } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ validationErrors: e })=>[
            e
        ]), f = $acw62.useMemo(()=>(0, $14016dd608f30925$export$501239432719417d)(b[c]), [
        c,
        b
    ]), v = (null == f ? void 0 : f.length) > 0, y = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(), F = v ? y : void 0;
    return "tel" === u ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $78a8b0923523d237$export$522a16be7a55e553), Object.assign({}, E, {
        name: c,
        defaultDialCode: p,
        dialCodeName: "country_code",
        autoComplete: d,
        hasError: v,
        "aria-describedby": F
    })), $acw62.createElement((0, $7cdd4ab3d2268ab5$export$db10347ccaf03b65), {
        errors: f,
        id: y
    })) : "password" === u ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $3e8af8b64d5d58ec$export$65ed9482db2257fa), Object.assign({}, E, {
        name: c,
        autoComplete: d,
        hasError: v,
        "aria-describedby": F
    })), $acw62.createElement((0, $7cdd4ab3d2268ab5$export$db10347ccaf03b65), {
        errors: f,
        id: y
    })) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $4dd4eb3a13974ce8$export$2c73285ae9390cec), Object.assign({}, E, {
        name: c,
        autoComplete: d,
        hasError: v,
        type: u,
        "aria-describedby": F
    })), $acw62.createElement((0, $7cdd4ab3d2268ab5$export$db10347ccaf03b65), {
        errors: f,
        id: y
    }));
}



function $9cb74c5239410bb9$export$125d0b248abd3e88() {
    const { fields: m } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ route: e })=>[
            e
        ]), o = $acw62.useRef(m.map((t, m)=>$acw62.createElement((0, $dbc403e9c4523b2e$export$56e87bf42978147a), Object.assign({
            key: m
        }, t)))).current;
    return $acw62.createElement($acw62.Fragment, null, o);
}



var $acw62 = parcelRequire("acw62");



const $4cabc09ab136a152$var$o = (e)=>"signIn" === e || "signUp";
function $4cabc09ab136a152$export$253df7dc30f737bc({ children: n, className: i, variation: m = "default" }) {
    const { route: c } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ route: e })=>[
            e
        ]), { components: { Header: l, Footer: s } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        className: i,
        "data-amplify-authenticator": "",
        "data-variation": m
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        "data-amplify-container": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(l, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        "data-amplify-router": "",
        "data-amplify-router-content": $4cabc09ab136a152$var$o(c) ? void 0 : ""
    }, n), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(s, null)));
}


function $255f4d214cd0afff$export$649c708157e61c64({ className: r, variation: p }) {
    const { isPending: f, resendCode: y, codeDeliveryDetails: { DeliveryMedium: h, Destination: g } = {} } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending,
            e.resendCode,
            e.codeDeliveryDetails
        ]), { handleChange: v, handleSubmit: E } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { ConfirmSignUp: { Header: C = $255f4d214cd0afff$export$649c708157e61c64.Header, Footer: D = $255f4d214cd0afff$export$649c708157e61c64.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)(), j = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Your code is on the way. To log in, enter the code we emailed to"), x = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Your code is on the way. To log in, enter the code we texted to"), F = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Your code is on the way. To log in, enter the code we sent you. It may take a minute to arrive."), w = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("It may take a minute to arrive."), S = "EMAIL" === h ? `${j} ${g}. ${w}` : "SMS" === h ? `${x} ${g}. ${w}` : (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(`${F}`);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: r,
        variation: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignup": "",
        method: "post",
        onChange: v,
        onSubmit: E
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1eea10f2f5922b0$export$5f1af8db9871e1d6), {
        className: "amplify-authenticator__subtitle"
    }, S), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        variation: "primary",
        isDisabled: f,
        type: "submit",
        loadingText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Confirming"),
        isLoading: f,
        fontWeight: "normal"
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Confirm")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        onClick: y,
        type: "button",
        fontWeight: "normal"
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Resend Code"))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(D, null))));
}
$255f4d214cd0afff$export$649c708157e61c64.Header = ()=>{
    const { codeDeliveryDetails: { DeliveryMedium: o } = {} } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.codeDeliveryDetails
        ]), i = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("EMAIL" === o ? "We Emailed You" : "SMS" === o ? "We Texted You" : "We Sent A Code");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 4
    }, i);
}, $255f4d214cd0afff$export$649c708157e61c64.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const $e2e890da969fd34e$export$b3aae0a112274a60 = ({ className: l, variation: c })=>{
    const { isPending: u, toSignIn: f } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending,
            e.toSignIn
        ]), { handleBlur: g, handleChange: h, handleSubmit: F } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { ForceNewPassword: { FormFields: C = $e2e890da969fd34e$export$b3aae0a112274a60.FormFields } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: l,
        variation: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forcenewpassword": "",
        method: "post",
        onChange: h,
        onSubmit: F,
        onBlur: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 3
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Change Password")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        isDisabled: u,
        type: "submit",
        variation: "primary",
        isLoading: u,
        loadingText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Changing"),
        fontWeight: "normal"
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Change Password")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        onClick: f,
        type: "button",
        fontWeight: "normal",
        variation: "link",
        size: "small"
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Back to Sign In")))));
};
$e2e890da969fd34e$export$b3aae0a112274a60.FormFields = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null);
};



var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};
var $b5acdf7c8123a019$exports = {};
"use strict";
$b5acdf7c8123a019$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    this.data = new Uint8Array($b5acdf7c8123a019$exports(data));
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $7969b47dc9b762ca$export$76e9c0cec6811ff4 = ()=>{
    const { isPending: r, toSignIn: m } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((i)=>[
            i.isPending,
            i.toSignIn
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        isDisabled: r,
        type: "submit",
        variation: "primary",
        fontWeight: "normal",
        isLoading: r,
        loadingText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Confirming")
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Confirm")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        onClick: m,
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Back to Sign In")));
};





const $cb0f0c66fca12f0c$var$g = new (0, $22e905ae30d82ab4$export$ba6a9c7ac8291f7f)("SetupTOTP-logger"), $cb0f0c66fca12f0c$export$1cb4d977b4f6b776 = ({ className: r, variation: l })=>{
    var h;
    const { fields: v, getTotpSecretCode: C, isPending: y, user: H } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: w, handleSubmit: S } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { SetupTOTP: { Header: F = $cb0f0c66fca12f0c$export$1cb4d977b4f6b776.Header, Footer: j = $cb0f0c66fca12f0c$export$1cb4d977b4f6b776.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)(), [T, x] = $acw62.useState(!0), [P, V] = $acw62.useState(), [b, O] = $acw62.useState("COPY"), [R, k] = $acw62.useState(""), { totpIssuer: L = "AWSCognito", totpUsername: M = null == H ? void 0 : H.username } = null !== (h = null == v ? void 0 : v.QR) && void 0 !== h ? h : {}, q = $acw62.useCallback(()=>(0, $6bbabf3c01bf9470$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
            try {
                const e = yield C();
                k(e);
                const o = (0, $5c16c933f208f780$export$f1f323074be5cac0)(L, M, e), r = yield (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toDataURL(o);
                V(r);
            } catch (e) {
                $cb0f0c66fca12f0c$var$g.error(e);
            } finally{
                x(!1);
            }
        }), [
        C,
        L,
        M
    ]);
    $acw62.useEffect(()=>{
        P || q();
    }, [
        q,
        P
    ]);
    return $acw62.createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: r,
        variation: l
    }, $acw62.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-setup-totp": "",
        method: "post",
        onChange: w,
        onSubmit: S
    }, $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: y
    }, $acw62.createElement(F, null), $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, T ? $acw62.createElement("p", null, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Loading"), "\u2026") : $acw62.createElement("img", {
        "data-amplify-qrcode": !0,
        src: P,
        alt: "qr code",
        width: "228",
        height: "228"
    }), $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        "data-amplify-copy": !0
    }, $acw62.createElement("div", null, R), $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        "data-amplify-copy-svg": !0,
        onClick: ()=>{
            navigator.clipboard.writeText(R), O((0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("COPIED"));
        }
    }, $acw62.createElement("div", {
        "data-amplify-copy-tooltip": !0
    }, b), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
    })))), $acw62.createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null), $acw62.createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null)), $acw62.createElement((0, $7969b47dc9b762ca$export$76e9c0cec6811ff4), null), $acw62.createElement(j, null))));
};
$cb0f0c66fca12f0c$export$1cb4d977b4f6b776.Header = function() {
    return $acw62.createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 3
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Setup TOTP"));
}, $cb0f0c66fca12f0c$export$1cb4d977b4f6b776.Footer = function() {
    return null;
};








var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $b37fe3d39d956993$export$e5c5a5f917a5871c = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? $acw62.useLayoutEffect : ()=>{};



var $acw62 = parcelRequire("acw62");
const $f3afa084f31a11ef$var$r = $acw62["useId".toString()] || (()=>{});
let $f3afa084f31a11ef$var$n = 0;
function $f3afa084f31a11ef$export$f680877a34711e37(o) {
    const [u, i] = $acw62.useState($f3afa084f31a11ef$var$r());
    return (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        o || i((t)=>null != t ? t : String($f3afa084f31a11ef$var$n++));
    }, [
        o
    ]), o || (u ? `radix-${u}` : "");
}
function $f3afa084f31a11ef$export$6be90bcb437e928f({ children: t }) {
    return $acw62.useEffect(()=>{}, []), /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, t);
}



var $acw62 = parcelRequire("acw62");
function $6421c5b6e6501f6d$export$25bec8c6f54ee79a(r) {
    const t = $acw62.useRef(r);
    return $acw62.useEffect(()=>{
        t.current = r;
    }), $acw62.useMemo(()=>(...e)=>{
            var r;
            return null === (r = t.current) || void 0 === r ? void 0 : r.call(t, ...e);
        }, []);
}



var $acw62 = parcelRequire("acw62");
function $206b7034d5d190d4$export$6f32135080cb4c3({ prop: o, defaultProp: r, onChange: n = ()=>{} }) {
    const [a, u] = function({ defaultProp: o, onChange: r }) {
        const n = $acw62.useState(o), [a] = n, u = $acw62.useRef(a), c = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(r);
        return $acw62.useEffect(()=>{
            u.current !== a && (c(a), u.current = a);
        }, [
            a,
            u,
            c
        ]), n;
    }({
        defaultProp: r,
        onChange: n
    }), c = void 0 !== o, f = c ? o : a, l = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(n);
    return [
        f,
        $acw62.useCallback((e)=>{
            if (c) {
                const t = e, r = "function" == typeof e ? t(o) : e;
                r !== o && l(r);
            } else u(e);
        }, [
            c,
            o,
            u,
            l
        ])
    ];
}




var $acw62 = parcelRequire("acw62");
function $06dbdeafb212d82f$export$43e446d32b3d21af(...o) {
    return (e)=>o.forEach((o)=>(function(o, e) {
                "function" == typeof o ? o(e) : null != o && (o.current = e);
            })(o, e));
}
function $06dbdeafb212d82f$export$c7b2cbe3552a0d05(...e) {
    return $acw62.useCallback($06dbdeafb212d82f$export$43e446d32b3d21af(...e), e);
}



var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");
const $2fad294522b5ed20$export$8c6ed5c666ac1360 = /*#__PURE__*/ $acw62.forwardRef((e, o)=>{
    const { children: a, ...s } = e;
    return $acw62.Children.toArray(a).some($2fad294522b5ed20$var$l) ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, $acw62.Children.map(a, (e)=>$2fad294522b5ed20$var$l(e) ? /*#__PURE__*/ $acw62.createElement($2fad294522b5ed20$var$n, (0, $8nd05.default)({}, s, {
            ref: o
        }), e.props.children) : e)) : /*#__PURE__*/ $acw62.createElement($2fad294522b5ed20$var$n, (0, $8nd05.default)({}, s, {
        ref: o
    }), a);
});
$2fad294522b5ed20$export$8c6ed5c666ac1360.displayName = "Slot";
const $2fad294522b5ed20$var$n = /*#__PURE__*/ $acw62.forwardRef((r, n)=>{
    const { children: l, ...a } = r; /*#__PURE__*/ 
    return $acw62.isValidElement(l) ? /*#__PURE__*/ $acw62.cloneElement(l, {
        ...$2fad294522b5ed20$var$o(a, l.props),
        ref: (0, $06dbdeafb212d82f$export$43e446d32b3d21af)(n, l.ref)
    }) : $acw62.Children.count(l) > 1 ? $acw62.Children.only(null) : null;
});
$2fad294522b5ed20$var$n.displayName = "SlotClone";
const $2fad294522b5ed20$export$d9f1ccf0bdb05d45 = ({ children: e })=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, e);
function $2fad294522b5ed20$var$l(e) {
    return $acw62.isValidElement(e) && e.type === $2fad294522b5ed20$export$d9f1ccf0bdb05d45;
}
function $2fad294522b5ed20$var$o(e, t) {
    const r = {
        ...t
    };
    for(const n in t){
        const l = e[n], o = t[n];
        /^on[A-Z]/.test(n) ? r[n] = (...e)=>{
            null == o || o(...e), null == l || l(...e);
        } : "style" === n ? r[n] = {
            ...l,
            ...o
        } : "className" === n && (r[n] = [
            l,
            o
        ].filter(Boolean).join(" "));
    }
    return {
        ...e,
        ...r
    };
}
const $2fad294522b5ed20$export$be92b6f5f03c0fe9 = $2fad294522b5ed20$export$8c6ed5c666ac1360;



var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");
const $ffa305e20fe06c82$export$250ffa63cdc0d034 = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
].reduce((o, i)=>({
        ...o,
        [i]: /*#__PURE__*/ $acw62.forwardRef((o, m)=>{
            const { asChild: a, ...s } = o, n = a ? (0, $2fad294522b5ed20$export$8c6ed5c666ac1360) : i;
            return $acw62.useEffect(()=>{
                window[Symbol.for("radix-ui")] = !0;
            }, []), /*#__PURE__*/ $acw62.createElement(n, (0, $8nd05.default)({}, s, {
                ref: m
            }));
        })
    }), {});
const $ffa305e20fe06c82$export$be92b6f5f03c0fe9 = $ffa305e20fe06c82$export$250ffa63cdc0d034;




var $acw62 = parcelRequire("acw62");
function $a27e3b74a1e4b413$export$fd42f52fd3ae1109(t, n) {
    const o = /*#__PURE__*/ $acw62.createContext(n);
    function r(t) {
        const { children: n, ...r } = t, c = $acw62.useMemo(()=>r, Object.values(r)); /*#__PURE__*/ 
        return $acw62.createElement(o.Provider, {
            value: c
        }, n);
    }
    return r.displayName = t + "Provider", [
        r,
        function(r) {
            const c = $acw62.useContext(o);
            if (c) return c;
            if (void 0 !== n) return n;
            throw new Error(`\`${r}\` must be used within \`${t}\``);
        }
    ];
}
function $a27e3b74a1e4b413$export$50c7b4e9d9f19c1(n, o = []) {
    let r = [];
    const c = ()=>{
        const t = r.map((t)=>/*#__PURE__*/ $acw62.createContext(t));
        return function(o) {
            const r = (null == o ? void 0 : o[n]) || t;
            return $acw62.useMemo(()=>({
                    [`__scope${n}`]: {
                        ...o,
                        [n]: r
                    }
                }), [
                o,
                r
            ]);
        };
    };
    return c.scopeName = n, [
        function(t, o) {
            const c = /*#__PURE__*/ $acw62.createContext(o), u = r.length;
            function s(t) {
                const { scope: o, children: r, ...s } = t, i = (null == o ? void 0 : o[n][u]) || c, a = $acw62.useMemo(()=>s, Object.values(s)); /*#__PURE__*/ 
                return $acw62.createElement(i.Provider, {
                    value: a
                }, r);
            }
            return r = [
                ...r,
                o
            ], s.displayName = t + "Provider", [
                s,
                function(r, s) {
                    const i = (null == s ? void 0 : s[n][u]) || c, a = $acw62.useContext(i);
                    if (a) return a;
                    if (void 0 !== o) return o;
                    throw new Error(`\`${r}\` must be used within \`${t}\``);
                }
            ];
        },
        $a27e3b74a1e4b413$var$t(c, ...o)
    ];
}
function $a27e3b74a1e4b413$var$t(...t1) {
    const n = t1[0];
    if (1 === t1.length) return n;
    const o = ()=>{
        const o = t1.map((e)=>({
                useScope: e(),
                scopeName: e.scopeName
            }));
        return function(t) {
            const r = o.reduce((e, { useScope: n, scopeName: o })=>({
                    ...e,
                    ...n(t)[`__scope${o}`]
                }), {});
            return $acw62.useMemo(()=>({
                    [`__scope${n.scopeName}`]: r
                }), [
                r
            ]);
        };
    };
    return o.scopeName = n.scopeName, o;
}







var $acw62 = parcelRequire("acw62");
function $435c9fb8798de9ba$export$c74125a8e3af6bb2(c) {
    const n = c + "CollectionProvider", [l, i] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)(n), [f, a] = l(n, {
        collectionRef: {
            current: null
        },
        itemMap: new Map
    }), u = (e)=>{
        const { scope: r, children: t } = e, c = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map).current; /*#__PURE__*/ 
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(f, {
            scope: r,
            itemMap: n,
            collectionRef: c
        }, t);
    }, m = c + "CollectionSlot", s = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((t, c)=>{
        const { scope: n, children: l } = t, i = a(m, n), f = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(c, i.collectionRef); /*#__PURE__*/ 
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fad294522b5ed20$export$8c6ed5c666ac1360), {
            ref: f
        }, l);
    }), p = c + "CollectionItemSlot", d = "data-radix-collection-item", R = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((t, c)=>{
        const { scope: n, children: l, ...i } = t, f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), u = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(c, f), m = a(p, n);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(m.itemMap.set(f, {
                ref: f,
                ...i
            }), ()=>{
                m.itemMap.delete(f);
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fad294522b5ed20$export$8c6ed5c666ac1360), {
            [d]: "",
            ref: u
        }, l);
    });
    return [
        {
            Provider: u,
            Slot: s,
            ItemSlot: R
        },
        function(e) {
            const r = a(c + "CollectionConsumer", e);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
                const e = r.collectionRef.current;
                if (!e) return [];
                const t = Array.from(e.querySelectorAll(`[${d}]`));
                return Array.from(r.itemMap.values()).sort((e, r)=>t.indexOf(e.ref.current) - t.indexOf(r.ref.current));
            }, [
                r.collectionRef,
                r.itemMap
            ]);
        },
        i
    ];
}


function $e0f75533c8da79e2$export$b9ecd428b558ff10(e, n, { checkForDefaultPrevented: t = !0 } = {}) {
    return function(r) {
        if (null == e || e(r), !1 === t || !r.defaultPrevented) return null == n ? void 0 : n(r);
    };
}



var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");
const $31e40192e19ff522$var$f = {
    bubbles: !1,
    cancelable: !0
}, [$31e40192e19ff522$var$p, $31e40192e19ff522$var$l, $31e40192e19ff522$var$m] = (0, $435c9fb8798de9ba$export$c74125a8e3af6bb2)("RovingFocusGroup"), [$31e40192e19ff522$var$d, $31e40192e19ff522$export$c7109489551a4f4] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)("RovingFocusGroup", [
    $31e40192e19ff522$var$m
]);
const [$31e40192e19ff522$var$g, $31e40192e19ff522$var$F] = $31e40192e19ff522$var$d("RovingFocusGroup");
const $31e40192e19ff522$export$8699f7c8af148338 = /*#__PURE__*/ $acw62.forwardRef((e, o)=>/*#__PURE__*/ $acw62.createElement($31e40192e19ff522$var$p.Provider, {
        scope: e.__scopeRovingFocusGroup
    }, /*#__PURE__*/ $acw62.createElement($31e40192e19ff522$var$p.Slot, {
        scope: e.__scopeRovingFocusGroup
    }, /*#__PURE__*/ $acw62.createElement($31e40192e19ff522$var$w, (0, $8nd05.default)({}, e, {
        ref: o
    }))))); /*#__PURE__*/ 
const $31e40192e19ff522$var$w = /*#__PURE__*/ $acw62.forwardRef((t, n)=>{
    const { __scopeRovingFocusGroup: c, orientation: p, dir: m = "ltr", loop: d = !1, currentTabStopId: v, defaultCurrentTabStopId: F, onCurrentTabStopIdChange: w, onEntryFocus: b, ...x } = t, E = $acw62.useRef(null), I = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(n, E), [G = null, h] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: v,
        defaultProp: F,
        onChange: w
    }), [T, A] = $acw62.useState(!1), y = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(b), D = $31e40192e19ff522$var$l(c), S = $acw62.useRef(!1);
    return $acw62.useEffect(()=>{
        const e = E.current;
        if (e) return e.addEventListener("rovingFocusGroup.onEntryFocus", y), ()=>e.removeEventListener("rovingFocusGroup.onEntryFocus", y);
    }, [
        y
    ]), /*#__PURE__*/ $acw62.createElement($31e40192e19ff522$var$g, {
        scope: c,
        orientation: p,
        dir: m,
        loop: d,
        currentTabStopId: G,
        onItemFocus: $acw62.useCallback((e)=>h(e), [
            h
        ]),
        onItemShiftTab: $acw62.useCallback(()=>A(!0), [])
    }, /*#__PURE__*/ $acw62.createElement((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $8nd05.default)({
        tabIndex: T ? -1 : 0,
        "data-orientation": p
    }, x, {
        ref: I,
        style: {
            outline: "none",
            ...t.style
        },
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(t.onMouseDown, ()=>{
            S.current = !0;
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(t.onFocus, (e)=>{
            const o = !S.current;
            if (e.target === e.currentTarget && o && !T) {
                const o = new Event("rovingFocusGroup.onEntryFocus", $31e40192e19ff522$var$f);
                if (e.currentTarget.dispatchEvent(o), !o.defaultPrevented) {
                    const e = D().filter((e)=>e.focusable);
                    $31e40192e19ff522$var$R([
                        e.find((e)=>e.active),
                        e.find((e)=>e.id === G),
                        ...e
                    ].filter(Boolean).map((e)=>e.ref.current));
                }
            }
            S.current = !1;
        }),
        onBlur: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(t.onBlur, ()=>A(!1))
    })));
});
const $31e40192e19ff522$export$ab9df7c53fe8454 = /*#__PURE__*/ $acw62.forwardRef((e, o)=>{
    const { __scopeRovingFocusGroup: n, focusable: i = !0, active: c = !1, ...f } = e, m = (0, $f3afa084f31a11ef$export$f680877a34711e37)(), d = $31e40192e19ff522$var$F("RovingFocusGroupItem", n), v = d.currentTabStopId === m, g = $31e40192e19ff522$var$l(n); /*#__PURE__*/ 
    return $acw62.createElement($31e40192e19ff522$var$p.ItemSlot, {
        scope: n,
        id: m,
        focusable: i,
        active: c
    }, /*#__PURE__*/ $acw62.createElement((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).span, (0, $8nd05.default)({
        tabIndex: v ? 0 : -1,
        "data-orientation": d.orientation
    }, f, {
        ref: o,
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(e.onMouseDown, (e)=>{
            i ? d.onItemFocus(m) : e.preventDefault();
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(e.onFocus, ()=>d.onItemFocus(m)),
        onKeyDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(e.onKeyDown, (e)=>{
            if ("Tab" === e.key && e.shiftKey) return void d.onItemShiftTab();
            if (e.target !== e.currentTarget) return;
            const o = function(e, o, r) {
                const t = function(e, o) {
                    return "rtl" !== o ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
                }(e.key, r);
                return "vertical" === o && [
                    "ArrowLeft",
                    "ArrowRight"
                ].includes(t) || "horizontal" === o && [
                    "ArrowUp",
                    "ArrowDown"
                ].includes(t) ? void 0 : $31e40192e19ff522$var$b[t];
            }(e, d.orientation, d.dir);
            if (void 0 !== o) {
                e.preventDefault();
                let n = g().filter((e)=>e.focusable).map((e)=>e.ref.current);
                if ("last" === o) n.reverse();
                else if ("prev" === o || "next" === o) {
                    "prev" === o && n.reverse();
                    const i = n.indexOf(e.currentTarget);
                    n = d.loop ? (t = i + 1, (r = n).map((e, o)=>r[(t + o) % r.length])) : n.slice(i + 1);
                }
                setTimeout(()=>$31e40192e19ff522$var$R(n));
            }
            var r, t;
        })
    })));
}); /*#__PURE__*/ 
const $31e40192e19ff522$var$b = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $31e40192e19ff522$var$R(e) {
    const o = document.activeElement;
    for (const r of e){
        if (r === o) return;
        if (r.focus(), document.activeElement !== o) return;
    }
}
const $31e40192e19ff522$export$be92b6f5f03c0fe9 = $31e40192e19ff522$export$8699f7c8af148338;
const $31e40192e19ff522$export$6d08773d2e66f8f2 = $31e40192e19ff522$export$ab9df7c53fe8454;







var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");
const [$1e222a1434bedc9c$var$d, $1e222a1434bedc9c$export$355f5bd209d7b13a] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)("Tabs", [
    (0, $31e40192e19ff522$export$c7109489551a4f4)
]);
const $1e222a1434bedc9c$var$u = (0, $31e40192e19ff522$export$c7109489551a4f4)(), [$1e222a1434bedc9c$var$b, $1e222a1434bedc9c$var$p] = $1e222a1434bedc9c$var$d("Tabs");
const $1e222a1434bedc9c$export$b2539bed5023c21c = /*#__PURE__*/ $acw62.forwardRef((t, o)=>{
    const { __scopeTabs: n, value: i, onValueChange: d, defaultValue: l, orientation: u = "horizontal", dir: p = "ltr", activationMode: m = "automatic", ...f } = t, [v, T] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: i,
        onChange: d,
        defaultProp: l
    }); /*#__PURE__*/ 
    return $acw62.createElement($1e222a1434bedc9c$var$b, {
        scope: n,
        baseId: (0, $f3afa084f31a11ef$export$f680877a34711e37)(),
        value: v,
        onValueChange: T,
        orientation: u,
        dir: p,
        activationMode: m
    }, /*#__PURE__*/ $acw62.createElement((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $8nd05.default)({
        "data-orientation": u
    }, f, {
        ref: o
    })));
}); /*#__PURE__*/ 
const $1e222a1434bedc9c$export$9712d22edc0d78c1 = /*#__PURE__*/ $acw62.forwardRef((e, o)=>{
    const { __scopeTabs: r, loop: n = !0, ...i } = e, d = $1e222a1434bedc9c$var$p("TabsList", r), l = $1e222a1434bedc9c$var$u(r); /*#__PURE__*/ 
    return $acw62.createElement($31e40192e19ff522$export$be92b6f5f03c0fe9, (0, $8nd05.default)({
        asChild: !0
    }, l, {
        orientation: d.orientation,
        dir: d.dir,
        loop: n
    }), /*#__PURE__*/ $acw62.createElement((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $8nd05.default)({
        role: "tablist",
        "aria-orientation": d.orientation,
        dir: d.dir
    }, i, {
        ref: o
    })));
}); /*#__PURE__*/ 
const $1e222a1434bedc9c$export$8114b9fdfdf9f3ba = /*#__PURE__*/ $acw62.forwardRef((e, o)=>{
    const { __scopeTabs: r, value: n, disabled: d = !1, ...l } = e, b = $1e222a1434bedc9c$var$p("TabsTrigger", r), v = $1e222a1434bedc9c$var$u(r), T = $1e222a1434bedc9c$var$m(b.baseId, n), x = $1e222a1434bedc9c$var$f(b.baseId, n), g = n === b.value; /*#__PURE__*/ 
    return $acw62.createElement($31e40192e19ff522$export$6d08773d2e66f8f2, (0, $8nd05.default)({
        asChild: !0
    }, v, {
        focusable: !d,
        active: g
    }), /*#__PURE__*/ $acw62.createElement((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).button, (0, $8nd05.default)({
        type: "button",
        role: "tab",
        "aria-selected": g,
        "aria-controls": x,
        "data-state": g ? "active" : "inactive",
        "data-disabled": d ? "" : void 0,
        disabled: d,
        id: T
    }, l, {
        ref: o,
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(e.onMouseDown, (e)=>{
            d || 0 !== e.button || !1 !== e.ctrlKey ? e.preventDefault() : b.onValueChange(n);
        }),
        onKeyDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(e.onKeyDown, (e)=>{
            [
                " ",
                "Enter"
            ].includes(e.key) && b.onValueChange(n);
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(e.onFocus, ()=>{
            const e = "manual" !== b.activationMode;
            g || d || !e || b.onValueChange(n);
        })
    })));
}); /*#__PURE__*/ 
const $1e222a1434bedc9c$export$bd905d70e8fd2ebb = /*#__PURE__*/ $acw62.forwardRef((e, t)=>{
    const { __scopeTabs: o, value: r, children: n, ...i } = e, d = $1e222a1434bedc9c$var$p("TabsContent", o), l = $1e222a1434bedc9c$var$m(d.baseId, r), u = $1e222a1434bedc9c$var$f(d.baseId, r), b = r === d.value; /*#__PURE__*/ 
    return $acw62.createElement((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $8nd05.default)({
        "data-state": b ? "active" : "inactive",
        "data-orientation": d.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !b,
        id: u,
        tabIndex: 0
    }, i, {
        ref: t
    }), b && n);
}); /*#__PURE__*/ 
function $1e222a1434bedc9c$var$m(e, t) {
    return `${e}-trigger-${t}`;
}
function $1e222a1434bedc9c$var$f(e, t) {
    return `${e}-content-${t}`;
}
const $1e222a1434bedc9c$export$be92b6f5f03c0fe9 = $1e222a1434bedc9c$export$b2539bed5023c21c;
const $1e222a1434bedc9c$export$54c2e3dc7acea9f5 = $1e222a1434bedc9c$export$9712d22edc0d78c1;
const $1e222a1434bedc9c$export$41fb9f06171c75f4 = $1e222a1434bedc9c$export$8114b9fdfdf9f3ba;
const $1e222a1434bedc9c$export$7c6e2c02157bb7d2 = $1e222a1434bedc9c$export$bd905d70e8fd2ebb;



var $acw62 = parcelRequire("acw62");



const $bea7e155134ecd35$var$m = (e)=>null !== e && "object" == typeof e && e.hasOwnProperty("props") && null != e.props.title, $bea7e155134ecd35$export$b2539bed5023c21c = $acw62.forwardRef((s, c)=>{
    var { ariaLabel: p, children: d, className: f, defaultIndex: u = 0, currentIndex: b, onChange: g, indicatorPosition: h, spacing: y } = s, x = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(s, [
        "ariaLabel",
        "children",
        "className",
        "defaultIndex",
        "currentIndex",
        "onChange",
        "indicatorPosition",
        "spacing"
    ]);
    const I = $acw62.Children.map(d, (e)=>null === e || "string" == typeof e && /\s/.test(e) ? {} : $bea7e155134ecd35$var$m(e) ? e.props : (console.warn("Amplify UI: <Tabs> component only accepts <TabItem> as children."), {})), N = {
        defaultValue: u.toString(),
        value: null != b ? b.toString() : void 0,
        onValueChange: g
    };
    return $acw62.createElement((0, $1e222a1434bedc9c$export$be92b6f5f03c0fe9), Object.assign({}, N), $acw62.createElement((0, $1e222a1434bedc9c$export$54c2e3dc7acea9f5), {
        "aria-label": p
    }, $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Tabs, f),
        "data-indicator-position": h,
        ref: c
    }, x), $acw62.Children.map(d, (e, a)=>$bea7e155134ecd35$var$m(e) ? $acw62.cloneElement(e, {
            "data-spacing": y,
            key: a,
            value: `${a}`
        }) : null))), I.map((e, a)=>$acw62.createElement((0, $1e222a1434bedc9c$export$7c6e2c02157bb7d2), {
            key: a,
            value: `${a}`
        }, e.children)));
}), $bea7e155134ecd35$export$17043b9d35150718 = $acw62.forwardRef((t, r)=>{
    var { className: n, title: o } = t, m = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "className",
        "title"
    ]);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: (0, $1e222a1434bedc9c$export$41fb9f06171c75f4),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).TabItems, n),
        ref: r
    }, m), o);
});
$bea7e155134ecd35$export$b2539bed5023c21c.displayName = "Tabs", $bea7e155134ecd35$export$17043b9d35150718.displayName = "TabItem";




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
var $818ebffbaf2f8521$export$4d240f091c25e146;
!function(o) {
    o.Apple = "SignInWithApple", o.Amazon = "LoginWithAmazon", o.Facebook = "Facebook", o.Google = "Google";
}($818ebffbaf2f8521$export$4d240f091c25e146 || ($818ebffbaf2f8521$export$4d240f091c25e146 = {}));





var $acw62 = parcelRequire("acw62");



const $82e54503510fd442$export$2e0a83ec2e27ecbb = $acw62.forwardRef((o, l)=>{
    var { className: m, orientation: n = "horizontal", size: d, label: c } = o, f = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className",
        "orientation",
        "size",
        "label"
    ]);
    const p = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Divider, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Divider, n), (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Divider, d), c ? (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).DividerLabel : null, m);
    return $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        "aria-orientation": n,
        as: "hr",
        className: p,
        "data-size": d,
        "data-label": c,
        ref: l
    }, f));
});
$82e54503510fd442$export$2e0a83ec2e27ecbb.displayName = "Divider";





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



const $1c856409467d4f86$var$m = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24
}, $1c856409467d4f86$export$f04a61298a47a40f = $acw62.forwardRef((r, n)=>{
    var { className: o, as: h = "svg", fill: l = "currentColor", pathData: c, viewBox: p = $1c856409467d4f86$var$m, children: f, paths: d } = r, w = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(r, [
        "className",
        "as",
        "fill",
        "pathData",
        "viewBox",
        "children",
        "paths"
    ]);
    const g = p.minX ? p.minX : $1c856409467d4f86$var$m.minX, v = p.minY ? p.minY : $1c856409467d4f86$var$m.minY, j = p.width ? p.width : $1c856409467d4f86$var$m.width, x = p.height ? p.height : $1c856409467d4f86$var$m.height;
    let N;
    return f && (N = f), d && (N = d.map((e, a)=>$acw62.createElement("path", Object.assign({}, e, {
            key: a
        })))), c && (N = $acw62.createElement("path", {
        d: c,
        fill: l
    })), $acw62.createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), Object.assign({
        as: h,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Icon, o),
        ref: n,
        viewBox: `${g} ${v} ${j} ${x}`
    }, w), N);
});
$1c856409467d4f86$export$f04a61298a47a40f.displayName = "Icon";



const $08c35cd8d61ed1fa$var$n = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-label": "Apple icon",
        className: "amplify-icon federated-sign-in-icon",
        fill: "#000",
        preserveAspectRatio: "xMidYMid",
        stroke: "#000",
        strokeWidth: "0",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
    })), $08c35cd8d61ed1fa$var$r = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-label": "Google icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 256 262",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
        fill: "#4285F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
        fill: "#34A853"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
        fill: "#FBBC05"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
        fill: "#EB4335"
    })), $08c35cd8d61ed1fa$var$o = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1c856409467d4f86$export$f04a61298a47a40f), {
        className: "federated-sign-in-icon",
        ariaLabel: "Facebook icon",
        viewBox: {
            minX: 0,
            minY: 0,
            width: 279,
            height: 538
        },
        pathData: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
        fill: "#1877F2"
    }), $08c35cd8d61ed1fa$var$c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-label": "Amazon icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 243 264",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M230.826 208.039C227.468 203.683 208.551 205.982 200.056 206.998C197.471 207.321 197.076 205.042 199.407 203.405C214.475 192.665 239.201 195.766 242.082 199.364C244.966 202.982 241.337 228.071 227.173 240.049C225.001 241.888 222.93 240.904 223.898 238.468C227.077 230.431 234.205 212.419 230.826 208.039ZM123.769 264C71.0234 264 39.0764 241.955 14.7853 217.542C9.97339 212.706 3.71799 206.296 0.311513 200.691C-1.09773 198.372 2.59096 195.022 5.04421 196.844C35.239 219.268 79.1012 239.538 122.53 239.538C151.82 239.538 188.046 227.47 217.669 214.868C222.147 212.966 222.147 219.18 221.512 221.061C221.183 222.032 206.515 236.221 186.247 247.047C167.304 257.166 143.397 264 123.769 264Z",
        fill: "#F2541B"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M142.943 111.185C142.943 124.756 143.268 136.054 136.406 148.123C130.856 157.913 122.027 163.95 112.222 163.95C98.8288 163.95 90.9806 153.772 90.9806 138.693C90.9806 109.036 117.677 103.647 142.943 103.647V111.185ZM178.166 196.081C175.858 198.15 171.635 198.22 169.914 196.894C157.974 187.684 149.89 173.688 149.89 173.688C130.706 193.156 117.127 199 92.2879 199C62.8772 199 40 180.905 40 144.729C40 116.461 55.3552 97.2408 77.2563 87.823C96.2094 79.5256 122.684 78.0173 142.943 75.7517C142.943 75.7517 144.633 53.933 138.699 45.9806C134.098 39.8163 126.272 36.9329 119.089 36.9329C106.127 36.8829 93.61 43.9051 91.1262 57.4188C90.4136 61.2829 87.5533 64.5261 84.54 64.206L51.0823 60.5922C48.5156 60.2951 45.0381 57.6639 45.8636 53.3081C53.644 12.3684 90.7373 0 123.989 0C140.983 0 163.21 4.51651 176.608 17.3349C193.597 33.1648 191.969 54.2755 191.969 77.2722V131.51C191.969 147.835 198.768 154.987 205.151 163.775C207.376 166.953 207.886 170.714 205.04 173.032C197.902 178.999 178.166 196.081 178.166 196.081Z",
        fill: "#F2541B"
    })), $08c35cd8d61ed1fa$export$66f93ed48923765d = (i)=>{
    const { icon: m, provider: s, text: C } = i, { toFederatedSignIn: p } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)();
    let d;
    return "facebook" === m ? d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($08c35cd8d61ed1fa$var$o, null) : "google" === m ? d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($08c35cd8d61ed1fa$var$r, null) : "amazon" === m ? d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($08c35cd8d61ed1fa$var$c, null) : "apple" === m && (d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($08c35cd8d61ed1fa$var$n, null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        onClick: (e)=>{
            e.preventDefault(), p({
                provider: s
            });
        },
        className: "federated-sign-in-button",
        fontWeight: "normal",
        gap: "1rem"
    }, d, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1eea10f2f5922b0$export$5f1af8db9871e1d6), {
        as: "span"
    }, C));
};


function $83f4fe2f57ccd22a$export$558443b7244c6aa() {
    const { route: s, socialProviders: c } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ route: e, socialProviders: o })=>[
            e,
            o
        ]);
    if (0 === c.length) return null;
    const l = "signUp" === s ? "Up" : "In";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column",
        padding: "0 0 1rem 0",
        className: "federated-sign-in-container"
    }, c.map((r)=>{
        switch(r){
            case "amazon":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08c35cd8d61ed1fa$export$66f93ed48923765d), {
                    icon: "amazon",
                    key: r,
                    provider: (0, $818ebffbaf2f8521$export$4d240f091c25e146).Amazon,
                    text: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(`Sign ${l} with Amazon`)
                });
            case "apple":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08c35cd8d61ed1fa$export$66f93ed48923765d), {
                    icon: "apple",
                    key: r,
                    provider: (0, $818ebffbaf2f8521$export$4d240f091c25e146).Apple,
                    text: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(`Sign ${l} with Apple`)
                });
            case "facebook":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08c35cd8d61ed1fa$export$66f93ed48923765d), {
                    icon: "facebook",
                    key: r,
                    provider: (0, $818ebffbaf2f8521$export$4d240f091c25e146).Facebook,
                    text: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(`Sign ${l} with Facebook`)
                });
            case "google":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08c35cd8d61ed1fa$export$66f93ed48923765d), {
                    icon: "google",
                    key: r,
                    provider: (0, $818ebffbaf2f8521$export$4d240f091c25e146).Google,
                    text: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(`Sign ${l} with Google`)
                });
            default:
                console.error(`Authenticator does not support ${r}. Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose`);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82e54503510fd442$export$2e0a83ec2e27ecbb), {
        size: "small",
        label: "or"
    }));
}







function $641078993bc200d6$export$b64708c6f1b3ed96() {
    const { isPending: r } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: f, handleSubmit: g } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { SignIn: { Header: E = $641078993bc200d6$export$b64708c6f1b3ed96.Header, Footer: F = $641078993bc200d6$export$b64708c6f1b3ed96.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signin": "",
        method: "post",
        onSubmit: g,
        onChange: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $83f4fe2f57ccd22a$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fe1470fea4c3ff2$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("legend", null, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Sign in"))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        isDisabled: r,
        isFullWidth: !0,
        type: "submit",
        variation: "primary",
        isLoading: r,
        loadingText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Signing in")
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Sign in")))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(F, null));
}
$641078993bc200d6$export$b64708c6f1b3ed96.Footer = ()=>{
    const { toResetPassword: i } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.toResetPassword
        ]), m = (0, $a8222690d8473c9c$export$8a4bbd9646545970)("Forgot your password? ") ? (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Forgot your password? ") : (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Forgot your password?");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        "data-amplify-footer": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        onClick: i,
        size: "small",
        variation: "link"
    }, m));
}, $641078993bc200d6$export$b64708c6f1b3ed96.Header = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










function $5518fddb6e8785ac$export$4ee457d816cea81a() {
    const { hasValidationErrors: u, isPending: c } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.hasValidationErrors,
            e.isPending
        ]), { handleChange: p, handleBlur: f, handleSubmit: F } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { SignUp: { Header: h = $5518fddb6e8785ac$export$4ee457d816cea81a.Header, FormFields: E = $5518fddb6e8785ac$export$4ee457d816cea81a.FormFields, Footer: g = $5518fddb6e8785ac$export$4ee457d816cea81a.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signup": "",
        method: "post",
        onChange: p,
        onSubmit: F,
        onBlur: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $83f4fe2f57ccd22a$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        isDisabled: u || c,
        isFullWidth: !0,
        type: "submit",
        variation: "primary",
        isLoading: c,
        loadingText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Creating Account")
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Create Account")))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, null));
}
$5518fddb6e8785ac$export$4ee457d816cea81a.Header = function() {
    return null;
}, $5518fddb6e8785ac$export$4ee457d816cea81a.FormFields = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null);
}, $5518fddb6e8785ac$export$4ee457d816cea81a.Footer = function() {
    return null;
};



const $a1e695b81e2802da$export$6815ad73b98d75ed = ({ className: l, hideSignUp: s, variation: p })=>{
    const { route: g, toSignIn: u, toSignUp: f } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.route,
            e.toSignIn,
            e.toSignUp
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: l,
        variation: p
    }, s ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, "signIn" === g && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $641078993bc200d6$export$b64708c6f1b3ed96), null)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bea7e155134ecd35$export$b2539bed5023c21c), {
        indicatorPosition: "top",
        currentIndex: "signIn" === g ? 0 : 1,
        spacing: "equal",
        justifyContent: "center",
        onChange: ()=>"signIn" === g ? f() : u()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bea7e155134ecd35$export$17043b9d35150718), {
        title: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Sign In")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, "signIn" === g && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $641078993bc200d6$export$b64708c6f1b3ed96), null))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bea7e155134ecd35$export$17043b9d35150718), {
        title: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Create Account")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fb18b5cd10064d6$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, "signUp" === g && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5518fddb6e8785ac$export$4ee457d816cea81a), null)))));
};



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $b2aab3cfef0b5c38$export$8311b872375357fe = (a)=>{
    const { cancelButtonSendType: o, cancelButtonText: m, submitButtonText: l } = a, { isPending: c, resendCode: s, skipVerification: u, toSignIn: p } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), f = c ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Submitting"), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Submit")), b = l || f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        variation: "primary",
        isDisabled: c,
        type: "submit"
    }, b), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4896d31ad1e4b703$export$353f5b6fc5456de1), {
        onClick: ()=>{
            switch(o){
                case "SKIP":
                    u();
                    break;
                case "RESEND":
                    s();
                    break;
                case "SIGN_IN":
                    p();
                    break;
                default:
                    return;
            }
        },
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, m));
};




const $38ffdaed146eb63f$export$79a17bba512ce899 = ({ className: o, variation: f })=>{
    const { isPending: d } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: p, handleSubmit: h } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { ConfirmVerifyUser: { Header: E = $38ffdaed146eb63f$export$79a17bba512ce899.Header, Footer: F = $38ffdaed146eb63f$export$79a17bba512ce899.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: o,
        variation: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmverifyuser": "",
        method: "post",
        onChange: p,
        onSubmit: h
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2aab3cfef0b5c38$export$8311b872375357fe), {
        cancelButtonText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Skip"),
        cancelButtonSendType: "SKIP"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(F, null))));
};
$38ffdaed146eb63f$export$79a17bba512ce899.Header = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 3
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Account recovery requires verified contact information"));
}, $38ffdaed146eb63f$export$79a17bba512ce899.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
const $f52798eef0be9b92$export$a79eda4ff50e30b6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    name: "default"
}), $f52798eef0be9b92$export$7bea016dc7ad2ddf = ()=>(0, $acw62.useContext)($f52798eef0be9b92$export$a79eda4ff50e30b6);


const $bdf42ea6f3cf8e50$export$d493a8d66e90d1ca = (m, p)=>{
    var { children: c, className: h, id: u, isDisabled: b, testId: f, value: R, labelPosition: g, height: v, width: j, bottom: N, left: x, position: E, padding: I, right: y, top: w } = m, D = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "children",
        "className",
        "id",
        "isDisabled",
        "testId",
        "value",
        "labelPosition",
        "height",
        "width",
        "bottom",
        "left",
        "position",
        "padding",
        "right",
        "top"
    ]);
    const { currentValue: C, defaultValue: F, name: O, hasError: P, isGroupDisabled: V, isRequired: k, isReadOnly: q, onChange: z, size: B, labelPosition: G } = (0, $f52798eef0be9b92$export$7bea016dc7ad2ddf)(), T = V || b || q && F !== R, H = void 0 !== C ? R === C : void 0, L = void 0 !== F ? R === F : void 0, A = g || G;
    return $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "label",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Radio, (0, $8b520a117f46c559$export$3c152e7b97c7496c)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Radio, "disabled", T), h),
        "data-disabled": T,
        "data-label-position": A,
        width: j,
        bottom: N,
        top: w,
        right: y,
        left: x,
        position: E,
        padding: I
    }, c && $acw62.createElement((0, $f1eea10f2f5922b0$export$5f1af8db9871e1d6), {
        as: "span",
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).RadioLabel,
        "data-disabled": T
    }, c), $acw62.createElement((0, $bfebae8636cadf20$export$f5b8910cec6cf069), Object.assign({
        checked: H,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).VisuallyHidden, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).RadioInput),
        defaultChecked: L,
        hasError: P,
        id: u,
        isDisabled: T,
        isReadOnly: q,
        isRequired: k,
        onChange: z,
        ref: p,
        type: "radio",
        name: O,
        value: R
    }, D)), $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        "aria-hidden": "true",
        as: "span",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).RadioButton, (0, $8b520a117f46c559$export$1d6fb99b5e148be8)((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).RadioButton, B)),
        "data-size": B,
        testId: f
    }));
}, $bdf42ea6f3cf8e50$export$d7b12c4107be0d61 = $acw62.forwardRef($bdf42ea6f3cf8e50$export$d493a8d66e90d1ca);
$bdf42ea6f3cf8e50$export$d7b12c4107be0d61.displayName = "Radio";




var $acw62 = parcelRequire("acw62");









const $4a6c69c6fa0fa225$export$a314277471067e8a = $acw62.forwardRef((m, c)=>{
    var { children: u, className: p, defaultValue: b, descriptiveText: f, errorMessage: E, hasError: F = !1, id: h, isDisabled: v, isRequired: R, isReadOnly: g, label: j, labelHidden: x = !1, labelPosition: y, onChange: M, name: N, size: z, value: C } = m, D = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(m, [
        "children",
        "className",
        "defaultValue",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "isDisabled",
        "isRequired",
        "isReadOnly",
        "label",
        "labelHidden",
        "labelPosition",
        "onChange",
        "name",
        "size",
        "value"
    ]);
    const G = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(h), H = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(), O = (0, $af44a26693d6395d$export$5c0b1cf3fea224ac)(), P = f ? O : void 0, V = $acw62.useMemo(()=>({
            currentValue: C,
            defaultValue: b,
            hasError: F,
            isRequired: R,
            isReadOnly: g,
            isGroupDisabled: v,
            onChange: M,
            size: z,
            name: N,
            labelPosition: y
        }), [
        b,
        F,
        v,
        R,
        g,
        M,
        z,
        N,
        C,
        y
    ]);
    return $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).Field, (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).RadioGroupField, p),
        "data-size": z,
        ref: c
    }, D), $acw62.createElement((0, $0c39af73c6023b8b$export$b04be29aa201d4f5), {
        id: H,
        visuallyHidden: x
    }, j), $acw62.createElement((0, $696539b8ac1b8264$export$873ced4623a3149c), {
        id: O,
        labelHidden: x,
        descriptiveText: f
    }), $acw62.createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        "aria-describedby": P,
        "aria-labelledby": H,
        className: (0, $eb5f843fca4db3c6$export$da015ee4e3f15a81).RadioGroup,
        id: G,
        role: "radiogroup"
    }, $acw62.createElement((0, $f52798eef0be9b92$export$a79eda4ff50e30b6).Provider, {
        value: V
    }, u)), $acw62.createElement((0, $7c590db08e2c3ed8$export$1c081951d49ad6f6), {
        hasError: F,
        errorMessage: E
    }));
});
$4a6c69c6fa0fa225$export$a314277471067e8a.displayName = "RadioGroupField";








const $345fb334ecec28c6$var$v = (n)=>Object.entries(n).map(([n, a])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bdf42ea6f3cf8e50$export$d7b12c4107be0d61), {
            name: "unverifiedAttr",
            value: n,
            key: n
        }, ((e, r)=>{
            const n = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)(e);
            let a = r;
            if ("Phone Number" === e) a = (0, $5c16c933f208f780$export$72b2b64445441bf7)(r);
            else if ("Email" === e) {
                const e = r.split("@");
                a = `${(0, $5c16c933f208f780$export$655775443891f2b8)(e[0])}@${e[1]}`;
            }
            return `${n}: ${a}`;
        })((0, $14a27b5008d5fd79$export$1222d357a3c2c47f)[n].label, a))), $345fb334ecec28c6$export$da61eb776d8ee98b = ({ className: r, variation: o })=>{
    const { components: { VerifyUser: { Header: i = $345fb334ecec28c6$export$da61eb776d8ee98b.Header, Footer: a = $345fb334ecec28c6$export$da61eb776d8ee98b.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)(), { isPending: m, unverifiedContactMethods: h } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ isPending: e, unverifiedContactMethods: t })=>[
            e,
            t
        ]), { handleChange: y, handleSubmit: F } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), b = m ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, "Verifying\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Verify")), g = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a6c69c6fa0fa225$export$a314277471067e8a), {
        label: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Verify Contact"),
        labelHidden: !0,
        name: "verify_context",
        isDisabled: m
    }, $345fb334ecec28c6$var$v(h));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: r,
        variation: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-verifyuser": "",
        method: "post",
        onChange: y,
        onSubmit: F
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: m
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(i, null), g, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2aab3cfef0b5c38$export$8311b872375357fe), {
        cancelButtonText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Skip"),
        cancelButtonSendType: "SKIP",
        submitButtonText: b
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(a, null))));
};
$345fb334ecec28c6$export$da61eb776d8ee98b.Header = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 3
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Account recovery requires verified contact information"));
}, $345fb334ecec28c6$export$da61eb776d8ee98b.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const $69dbc7dbdea95a64$export$b8b09b30a5bdd893 = ({ className: r, variation: n })=>{
    const { isPending: f } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: u, handleSubmit: p } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { ConfirmSignIn: { Header: h = $69dbc7dbdea95a64$export$b8b09b30a5bdd893.Header, Footer: E = $69dbc7dbdea95a64$export$b8b09b30a5bdd893.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: r,
        variation: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignin": "",
        method: "post",
        onChange: u,
        onSubmit: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7969b47dc9b762ca$export$76e9c0cec6811ff4), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, null))));
};
$69dbc7dbdea95a64$export$b8b09b30a5bdd893.Header = function() {
    const { user: o } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(), { challengeName: i } = o;
    let m;
    switch(i){
        case "SMS_MFA":
            m = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Confirm SMS Code");
            break;
        case "SOFTWARE_TOKEN_MFA":
            m = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Confirm TOTP Code");
            break;
        default:
            throw new Error(`${(0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Unexpected challengeName encountered in ConfirmSignIn:")} ${i}`);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 3
    }, m);
}, $69dbc7dbdea95a64$export$b8b09b30a5bdd893.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const $fac0c36292ed1037$export$fb3a0d1a16180c0d = ({ className: r, variation: u })=>{
    const { isPending: p } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleBlur: f, handleChange: E, handleSubmit: h } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { ConfirmResetPassword: { Header: F = $fac0c36292ed1037$export$fb3a0d1a16180c0d.Header, Footer: j = $fac0c36292ed1037$export$fb3a0d1a16180c0d.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: r,
        variation: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmresetpassword": "",
        method: "post",
        onSubmit: h,
        onChange: E,
        onBlur: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(F, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2aab3cfef0b5c38$export$8311b872375357fe), {
        cancelButtonSendType: "RESEND",
        cancelButtonText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Resend Code")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(j, null))));
};
$fac0c36292ed1037$export$fb3a0d1a16180c0d.Header = function() {
    const o = (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Reset your password");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 3
    }, o);
}, $fac0c36292ed1037$export$fb3a0d1a16180c0d.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const $d146706206971a7d$export$a4c3d56613a57187 = ({ className: o, variation: d })=>{
    const { isPending: p } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: f, handleSubmit: E } = (0, $074a34efe153cfb4$export$df6a82844cee724c)(), { components: { ResetPassword: { Header: F = $d146706206971a7d$export$a4c3d56613a57187.Header, Footer: g = $d146706206971a7d$export$a4c3d56613a57187.Footer } } } = (0, $a3f1af57078aa690$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4cabc09ab136a152$export$253df7dc30f737bc), {
        className: o,
        variation: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-resetpassword": "",
        method: "post",
        onChange: f,
        onSubmit: E
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(F, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1700ac1232394245$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cb74c5239410bb9$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9425ed193731c948$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2aab3cfef0b5c38$export$8311b872375357fe), {
        cancelButtonText: (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Back to Sign In"),
        cancelButtonSendType: "SIGN_IN",
        submitButtonText: p ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Sending"), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Send code"))
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, null))));
};
$d146706206971a7d$export$a4c3d56613a57187.Header = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdee2f99629198c8$export$a8a3e93435678ff9), {
        level: 3
    }, (0, $a8222690d8473c9c$export$d73ee8ef04f5226a)("Reset your password"));
}, $d146706206971a7d$export$a4c3d56613a57187.Footer = function() {
    return null;
};


const $1392da38259830ac$export$c92b4b399eea902a = (n)=>"signIn" === n || "signUp" === n;


function $571cbad6c968d1df$var$d() {
    return null;
}
function $571cbad6c968d1df$export$55185c17a0fcbe46({ className: l, hideSignUp: w, variation: j }) {
    const { route: U } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ route: r })=>[
            r
        ]), g = (0, $acw62.useMemo)(()=>((r)=>{
            switch(r){
                case "authenticated":
                case "idle":
                case "setup":
                case "autoSignIn":
                    return $571cbad6c968d1df$var$d;
                case "confirmSignUp":
                    return 0, $255f4d214cd0afff$export$649c708157e61c64;
                case "confirmSignIn":
                    return 0, $69dbc7dbdea95a64$export$b8b09b30a5bdd893;
                case "setupTOTP":
                    return 0, $cb0f0c66fca12f0c$export$1cb4d977b4f6b776;
                case "signIn":
                case "signUp":
                    return 0, $a1e695b81e2802da$export$6815ad73b98d75ed;
                case "forceNewPassword":
                    return 0, $e2e890da969fd34e$export$b3aae0a112274a60;
                case "resetPassword":
                    return 0, $d146706206971a7d$export$a4c3d56613a57187;
                case "confirmResetPassword":
                    return 0, $fac0c36292ed1037$export$fb3a0d1a16180c0d;
                case "verifyUser":
                    return 0, $345fb334ecec28c6$export$da61eb776d8ee98b;
                case "confirmVerifyUser":
                    return 0, $38ffdaed146eb63f$export$79a17bba512ce899;
                default:
                    return console.warn(`Unhandled Authenticator route - please open an issue: ${r}`), $571cbad6c968d1df$var$d;
            }
        })(U), [
        U
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, {
        className: l,
        hideSignUp: (0, $1392da38259830ac$export$c92b4b399eea902a)(U) ? w : void 0,
        variation: j
    });
}


















const $bd9b41bde83f41f6$export$71abc632aa29e6fe = {
    Header: ()=>null,
    SignIn: {
        Header: (0, $641078993bc200d6$export$b64708c6f1b3ed96).Header,
        Footer: (0, $641078993bc200d6$export$b64708c6f1b3ed96).Footer
    },
    SignUp: {
        Header: (0, $5518fddb6e8785ac$export$4ee457d816cea81a).Header,
        FormFields: (0, $5518fddb6e8785ac$export$4ee457d816cea81a).FormFields,
        Footer: (0, $5518fddb6e8785ac$export$4ee457d816cea81a).Footer
    },
    ConfirmSignUp: {
        Header: (0, $255f4d214cd0afff$export$649c708157e61c64).Header,
        Footer: (0, $255f4d214cd0afff$export$649c708157e61c64).Footer
    },
    SetupTOTP: {
        Header: (0, $cb0f0c66fca12f0c$export$1cb4d977b4f6b776).Header,
        Footer: (0, $cb0f0c66fca12f0c$export$1cb4d977b4f6b776).Footer
    },
    ConfirmResetPassword: {
        Header: (0, $fac0c36292ed1037$export$fb3a0d1a16180c0d).Header,
        Footer: (0, $fac0c36292ed1037$export$fb3a0d1a16180c0d).Footer
    },
    ConfirmSignIn: {
        Header: (0, $69dbc7dbdea95a64$export$b8b09b30a5bdd893).Header,
        Footer: (0, $69dbc7dbdea95a64$export$b8b09b30a5bdd893).Footer
    },
    VerifyUser: {
        Header: (0, $345fb334ecec28c6$export$da61eb776d8ee98b).Header,
        Footer: (0, $345fb334ecec28c6$export$da61eb776d8ee98b).Footer
    },
    ConfirmVerifyUser: {
        Header: (0, $38ffdaed146eb63f$export$79a17bba512ce899).Header,
        Footer: (0, $38ffdaed146eb63f$export$79a17bba512ce899).Footer
    },
    ForceNewPassword: {
        FormFields: (0, $e2e890da969fd34e$export$b3aae0a112274a60).FormFields
    },
    ResetPassword: {
        Header: (0, $d146706206971a7d$export$a4c3d56613a57187).Header,
        Footer: (0, $d146706206971a7d$export$a4c3d56613a57187).Footer
    },
    Footer: ()=>null
};


const $11c6361434fe71de$export$a4ad2735b021c132 = "3.6.1";


function $553aa295e34952c1$export$213d252991da224({ children: s, className: t, components: n, formFields: a, hideSignUp: m, initialState: u, loginMechanisms: c, signUpAttributes: f, services: l, socialProviders: g, variation: d }) {
    const { route: w, signOut: P, user: j } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ route: e, signOut: s, user: t })=>[
            e,
            s,
            t
        ]);
    !function(s) {
        const { route: t, initializeMachine: i } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)(({ route: e })=>[
                e
            ]), o = $acw62.useRef(!1);
        $acw62.useEffect(()=>{
            o.current || "setup" !== t || (i(s), o.current = !0);
        }, [
            i,
            t,
            s
        ]);
    }({
        initialState: u,
        loginMechanisms: c,
        services: l,
        signUpAttributes: f,
        socialProviders: g,
        formFields: a
    });
    const S = $acw62.useMemo(()=>({
            components: Object.assign(Object.assign({}, (0, $bd9b41bde83f41f6$export$71abc632aa29e6fe)), n)
        }), [
        n
    ]);
    return "authenticated" === w || "signOut" === w ? s ? $acw62.createElement($acw62.Fragment, null, "function" == typeof s ? s({
        signOut: P,
        user: j
    }) : s) : null : $acw62.createElement((0, $a3f1af57078aa690$export$da5ac45a736a5880).Provider, {
        value: S
    }, $acw62.createElement((0, $571cbad6c968d1df$export$55185c17a0fcbe46), {
        className: t,
        hideSignUp: m,
        variation: d
    }));
}
function $553aa295e34952c1$export$3d7a1e8452f884f3(r) {
    return $acw62.useEffect(()=>{
        (0, $5c16c933f208f780$export$3c7f711f5942602f)({
            packageName: "@aws-amplify/ui-react",
            version: (0, $11c6361434fe71de$export$a4ad2735b021c132)
        });
    }, []), $acw62.createElement((0, $870bcf77de627b81$export$2e2bcd8739ae039), null, $acw62.createElement($553aa295e34952c1$export$213d252991da224, Object.assign({}, r)));
}
$553aa295e34952c1$export$3d7a1e8452f884f3.Provider = (0, $870bcf77de627b81$export$2e2bcd8739ae039), $553aa295e34952c1$export$3d7a1e8452f884f3.ResetPassword = (0, $d146706206971a7d$export$a4c3d56613a57187), $553aa295e34952c1$export$3d7a1e8452f884f3.SetupTOTP = (0, $cb0f0c66fca12f0c$export$1cb4d977b4f6b776), $553aa295e34952c1$export$3d7a1e8452f884f3.SignIn = (0, $641078993bc200d6$export$b64708c6f1b3ed96), $553aa295e34952c1$export$3d7a1e8452f884f3.SignUp = (0, $5518fddb6e8785ac$export$4ee457d816cea81a), $553aa295e34952c1$export$3d7a1e8452f884f3.ForceNewPassword = (0, $e2e890da969fd34e$export$b3aae0a112274a60);




var $htqGM = parcelRequire("htqGM");

var $AfP12 = parcelRequire("AfP12");




(0, $a204f73577cd8409$export$dbe3113d60765c1a).putVocabularies((0, $a8222690d8473c9c$export$150b732325d14d04));
(0, $a204f73577cd8409$export$dbe3113d60765c1a).putVocabularies({
    en: {
        // username cannot have whitespace
        "2 validation errors detected: Value at 'userAlias' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+; Value at 'userName' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+": "Username cannot have whitespace."
    }
});
function $37f6576e290dd33b$var$Header() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        style: {
            width: "464px",
            height: "90px",
            background: "linear-gradient(90deg, #1035C9 0%, #2550FA 100%)",
            color: "white",
            textTransform: "uppercase",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            gap: "12px",
            fontSize: "28px",
            fontWeight: 700
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $210a69e1eb51b64d$export$2e2bcd8739ae039), {
                height: "25",
                width: "82.26"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 4
                },
                children: "Video Player"
            })
        ]
    });
}
function $37f6576e290dd33b$var$Footer() {
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(localStorage.getItem("remember_user") !== "no");
    const { toResetPassword: toResetPassword } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)();
    if (isChecked) {
        (0, $cc420cb14b670b2a$export$334c29725a78c21d).configure({
            ...(0, $1d959da113fdf5c0$export$2e2bcd8739ae039),
            storage: localStorage
        });
        localStorage.setItem("remember_user", "yes");
    } else {
        (0, $cc420cb14b670b2a$export$334c29725a78c21d).configure({
            ...(0, $1d959da113fdf5c0$export$2e2bcd8739ae039),
            storage: sessionStorage
        });
        localStorage.setItem("remember_user", "no");
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "data-amplify-footer",
        style: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            height: "60px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($AfP12))), {
                style: {
                    position: "absolute",
                    left: "max(380px, calc(50vw + 143px))"
                },
                classNames: {
                    popper: "passwordtooltip"
                },
                position: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).POSITION_ENUM.topEnd,
                theme: (0, (/*@__PURE__*/$parcel$interopDefault($AfP12))).THEME_ENUM.v2,
                tooltip: "Your password contains at least: 8 characters, 1 number, 1 special character, 1 uppercase letter and 1 lowercase letter",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5727d380b42de352$export$2e2bcd8739ae039), {
                    style: {
                        position: "absolute",
                        top: "max(calc(50vh + 14px), 260px)",
                        left: "max(410px, calc(50vw + 170px))",
                        color: "#91A0AD",
                        fontSize: "20px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($htqGM))), {
                isChecked: isChecked,
                onToggle: setIsChecked,
                label: "Remember Me",
                className: "login-checkbox",
                theme: (0, (/*@__PURE__*/$parcel$interopDefault($htqGM))).THEME_ENUM.v2,
                style: {
                    marginTop: "-132px",
                    alignSelf: "flex-start",
                    marginLeft: "52px",
                    color: "#91A0AD"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                className: "amplify-button--link amplify-button--small",
                style: {
                    marginTop: "106px"
                },
                onClick: toResetPassword,
                children: "Forgot your Password?"
            })
        ]
    });
}
function $37f6576e290dd33b$var$AuthenticatorInner({ children: children }) {
    /* eslint-disable-next-line @typescript-eslint/naming-convention */ const { _state: _state, error: error, user: user } = (0, $ac0a16ef242d249b$export$2e2bcd8739ae039)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (user?.username) (0, $db434a401f2c9abc$export$2e2bcd8739ae039).identify(user.username);
        (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentSession().then((session)=>{
            const userGroups = session.getAccessToken().payload["cognito:groups"];
            userGroups?.forEach((group)=>(0, $db434a401f2c9abc$export$2e2bcd8739ae039).add_group("Publisher", group));
            const userIsAdmin = userGroups?.includes("admin");
            (0, $db434a401f2c9abc$export$2e2bcd8739ae039).people.set({
                Role: userIsAdmin ? "Administrator" : "Publisher"
            });
        });
    }, [
        user
    ]);
    const [username, setUsername] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [password, setPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    if (_state.event && _state.event.type === "CHANGE") {
        if (_state.event.data.name === "username" && _state.event.data.value !== username) setUsername(_state.event.data.value);
        if (_state.event.data.name === "password" && _state.event.data.value !== password) setPassword(_state.event.data.value);
    }
    const services = {
        async handleSignIn (formData) {
            /* eslint-disable @typescript-eslint/no-shadow */ const { password: password } = formData;
            const username = formData?.username.toLowerCase().trim();
            try {
                return await (0, $cc420cb14b670b2a$export$334c29725a78c21d).signIn({
                    username: username,
                    password: password
                }, null, {
                    referrer: window.location.href
                });
            } catch (e) {
                const error = String(e);
                if (/NotAuthorizedException/.test(error)) throw new Error("Incorrect username or password.");
                if (/InvalidParameterException/.test(error)) throw new Error("Username and password can only contain alphanumeric and symbol.");
                if (/AuthError/.test(error)) throw new Error("Username and password can not be empty.");
                throw new Error("Unknown error");
            }
        /* eslint-enable @typescript-eslint/no-shadow */ }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $553aa295e34952c1$export$3d7a1e8452f884f3), {
        className: `${!username ? "" : "small-username-label"} ${!password ? "" : "small-password-label"} ${error ? "has-error" : ""} sign-in`,
        hideSignUp: true,
        services: services,
        components: {
            Header: $37f6576e290dd33b$var$Header,
            SignIn: {
                Footer: $37f6576e290dd33b$var$Footer
            }
        },
        formFields: {
            signIn: {
                username: {
                    placeholder: "",
                    label: "User Name",
                    labelHidden: false
                },
                password: {
                    placeholder: "",
                    label: "Password",
                    labelHidden: false
                }
            }
        },
        children: children
    });
}
function $37f6576e290dd33b$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $553aa295e34952c1$export$3d7a1e8452f884f3).Provider, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($37f6576e290dd33b$var$AuthenticatorInner, {
            children: children
        })
    });
}


var $92a479b839eb2ffe$export$2e2bcd8739ae039 = (0, $37f6576e290dd33b$export$2e2bcd8739ae039);


let $cd93687958c8007e$var$loadedConfig = (0, $1d959da113fdf5c0$export$2e2bcd8739ae039);
$cd93687958c8007e$var$loadedConfig = {
    Auth: {
        userPoolId: "us-east-1_lF3YQlAEq",
        userPoolWebClientId: "6q72tcr0og7l8qjkin187ic3am"
    }
};
(0, $36606c730099e1c8$export$a3858a9a153cffc7).configure($cd93687958c8007e$var$loadedConfig);
const $cd93687958c8007e$var$queryClient = new (0, $13e074efb1ecf7c6$export$405d0624ed55a03f)();
function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i4KPV.KrgProvider), {
        theme: (0, $227f11a6809b1d6b$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92a479b839eb2ffe$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62c3235118f7fb12$export$e62cf4050ed10e67), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccb8f828cefd6075$export$45604f0cc8ae667b), {
                    client: $cd93687958c8007e$var$queryClient,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d761cac11c11d44$export$d1e619fddc3508ce), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $556b5b2da5bfbb21$export$f2ee90d31ef8a5d8), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7943b7043191bb43$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        })
    });
}


(0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root")).render(// KrgButton is throwing the following error with StrictMode: https://github.com/mui/material-ui/issues/20182
// <StrictMode>
/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.600011b8.js.map
